/* tslint:disable */
/* eslint-disable */
/**
 * eCareHealth API documentation.
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 * 
 * @export
 * @interface AccessToken
 */
export interface AccessToken {
    /**
     * 
     * @type {string}
     * @memberof AccessToken
     */
    'refreshToken': string;
    /**
     * 
     * @type {boolean}
     * @memberof AccessToken
     */
    'expireSession'?: boolean;
}
/**
 * 
 * @export
 * @interface Address
 */
export interface Address {
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    'line1': string;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    'line2'?: string;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    'city': string;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    'state': string;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    'country': string;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    'zipcode': string;
}
/**
 * 
 * @export
 * @interface AddressEntity
 */
export interface AddressEntity {
    /**
     * 
     * @type {number}
     * @memberof AddressEntity
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof AddressEntity
     */
    'line1'?: string;
    /**
     * 
     * @type {string}
     * @memberof AddressEntity
     */
    'line2'?: string;
    /**
     * 
     * @type {string}
     * @memberof AddressEntity
     */
    'city'?: string;
    /**
     * 
     * @type {string}
     * @memberof AddressEntity
     */
    'state'?: string;
    /**
     * 
     * @type {string}
     * @memberof AddressEntity
     */
    'country'?: string;
    /**
     * 
     * @type {string}
     * @memberof AddressEntity
     */
    'zipcode'?: string;
}
/**
 * 
 * @export
 * @interface AiChatRequest
 */
export interface AiChatRequest {
    /**
     * 
     * @type {string}
     * @memberof AiChatRequest
     */
    'message'?: string;
    /**
     * 
     * @type {string}
     * @memberof AiChatRequest
     */
    'userId'?: string;
    /**
     * 
     * @type {string}
     * @memberof AiChatRequest
     */
    'patientContext'?: string;
    /**
     * 
     * @type {string}
     * @memberof AiChatRequest
     */
    'currentModule'?: string;
}
/**
 * 
 * @export
 * @interface AllergiesIntakeForm
 */
export interface AllergiesIntakeForm {
    /**
     * 
     * @type {boolean}
     * @memberof AllergiesIntakeForm
     */
    'none'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AllergiesIntakeForm
     */
    'adhesiveTape'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AllergiesIntakeForm
     */
    'anesthesia'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AllergiesIntakeForm
     */
    'aspirin'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AllergiesIntakeForm
     */
    'codeine'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AllergiesIntakeForm
     */
    'dairyProducts'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AllergiesIntakeForm
     */
    'iodine'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AllergiesIntakeForm
     */
    'latex'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AllergiesIntakeForm
     */
    'morphine'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AllergiesIntakeForm
     */
    'penicillin'?: boolean;
}
/**
 * 
 * @export
 * @interface Answer
 */
export interface Answer {
    /**
     * 
     * @type {string}
     * @memberof Answer
     */
    'uuid'?: string;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof Answer
     */
    'question': { [key: string]: string; };
    /**
     * 
     * @type {string}
     * @memberof Answer
     */
    'answer'?: string;
}
/**
 * 
 * @export
 * @interface Appointment
 */
export interface Appointment {
    /**
     * 
     * @type {string}
     * @memberof Appointment
     */
    'uuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof Appointment
     */
    'patientId': string;
    /**
     * 
     * @type {string}
     * @memberof Appointment
     */
    'patientName'?: string;
    /**
     * 
     * @type {string}
     * @memberof Appointment
     */
    'patientDob'?: string;
    /**
     * 
     * @type {string}
     * @memberof Appointment
     */
    'patientMrn'?: string;
    /**
     * 
     * @type {string}
     * @memberof Appointment
     */
    'patientEmail'?: string;
    /**
     * 
     * @type {string}
     * @memberof Appointment
     */
    'patientPhone'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Appointment
     */
    'emailConsent'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Appointment
     */
    'messageConsent'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Appointment
     */
    'callConsent'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof Appointment
     */
    'patientGender'?: AppointmentPatientGenderEnum;
    /**
     * 
     * @type {string}
     * @memberof Appointment
     */
    'ecarehealthPatientId'?: string;
    /**
     * 
     * @type {string}
     * @memberof Appointment
     */
    'avatar'?: string;
    /**
     * 
     * @type {string}
     * @memberof Appointment
     */
    'providerId': string;
    /**
     * 
     * @type {string}
     * @memberof Appointment
     */
    'providerName'?: string;
    /**
     * 
     * @type {string}
     * @memberof Appointment
     */
    'providerRole'?: string;
    /**
     * 
     * @type {string}
     * @memberof Appointment
     */
    'providerAvatar'?: string;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof Appointment
     */
    'providerSpecialities'?: { [key: string]: string; };
    /**
     * 
     * @type {string}
     * @memberof Appointment
     */
    'locationId'?: string;
    /**
     * 
     * @type {string}
     * @memberof Appointment
     */
    'locationName'?: string;
    /**
     * 
     * @type {string}
     * @memberof Appointment
     */
    'mode'?: AppointmentModeEnum;
    /**
     * 
     * @type {string}
     * @memberof Appointment
     */
    'type'?: string;
    /**
     * 
     * @type {string}
     * @memberof Appointment
     */
    'chiefComplaint'?: string;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof Appointment
     */
    'appointmentSpecialities'?: { [key: string]: string; };
    /**
     * 
     * @type {string}
     * @memberof Appointment
     */
    'startTime': string;
    /**
     * 
     * @type {string}
     * @memberof Appointment
     */
    'endTime': string;
    /**
     * 
     * @type {string}
     * @memberof Appointment
     */
    'room'?: string;
    /**
     * 
     * @type {string}
     * @memberof Appointment
     */
    'paymentType'?: AppointmentPaymentTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof Appointment
     */
    'note'?: string;
    /**
     * 
     * @type {string}
     * @memberof Appointment
     */
    'emailForms'?: string;
    /**
     * 
     * @type {string}
     * @memberof Appointment
     */
    'source'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Appointment
     */
    'paid'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof Appointment
     */
    'estimateAmount'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof Appointment
     */
    'emailedFormsStatus'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof Appointment
     */
    'duration'?: number;
    /**
     * 
     * @type {string}
     * @memberof Appointment
     */
    'status'?: AppointmentStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof Appointment
     */
    'timezone'?: AppointmentTimezoneEnum;
    /**
     * 
     * @type {string}
     * @memberof Appointment
     */
    'reminderStatus'?: AppointmentReminderStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof Appointment
     */
    'rescheduledAppointmentId'?: string;
    /**
     * 
     * @type {string}
     * @memberof Appointment
     */
    'rescheduleReason'?: string;
    /**
     * 
     * @type {string}
     * @memberof Appointment
     */
    'cancelReason'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Appointment
     */
    'slotOpen'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Appointment
     */
    'chargeable'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof Appointment
     */
    'created'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Appointment
     */
    'archive'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof Appointment
     */
    'customForms'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Appointment
     */
    'intakeComplete'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof Appointment
     */
    'pgName'?: string;
    /**
     * 
     * @type {string}
     * @memberof Appointment
     */
    'providerColourCode'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Appointment
     */
    'notForBilling'?: boolean;
    /**
     * 
     * @type {Set<PatientInsurance>}
     * @memberof Appointment
     */
    'patientInsurances'?: Set<PatientInsurance>;
    /**
     * 
     * @type {boolean}
     * @memberof Appointment
     */
    'isRecurring'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof Appointment
     */
    'recurringType'?: AppointmentRecurringTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof Appointment
     */
    'recurringFrequency'?: string;
    /**
     * 
     * @type {string}
     * @memberof Appointment
     */
    'endDate'?: string;
    /**
     * 
     * @type {number}
     * @memberof Appointment
     */
    'endAfter'?: number;
    /**
     * 
     * @type {PatientInsurance}
     * @memberof Appointment
     */
    'patientPrimaryInsurance'?: PatientInsurance;
    /**
     * 
     * @type {PatientInsurance}
     * @memberof Appointment
     */
    'patientSecondaryInsurance'?: PatientInsurance;
    /**
     * 
     * @type {string}
     * @memberof Appointment
     */
    'assessments'?: string;
    /**
     * 
     * @type {string}
     * @memberof Appointment
     */
    'intakeForms'?: string;
    /**
     * 
     * @type {string}
     * @memberof Appointment
     */
    'encounterDate'?: string;
    /**
     * 
     * @type {Reminder}
     * @memberof Appointment
     */
    'reminders'?: Reminder;
    /**
     * 
     * @type {boolean}
     * @memberof Appointment
     */
    'sendForms'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof Appointment
     */
    'customFrequency'?: string;
    /**
     * 
     * @type {string}
     * @memberof Appointment
     */
    'customFrequencyUnit'?: string;
    /**
     * 
     * @type {string}
     * @memberof Appointment
     */
    'visitNote'?: string;
    /**
     * 
     * @type {string}
     * @memberof Appointment
     */
    'modified'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Appointment
     */
    'appointmentRequest'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof Appointment
     */
    'appStatusForPatient'?: string;
    /**
     * 
     * @type {string}
     * @memberof Appointment
     */
    'appointmentTypeId'?: string;
    /**
     * 
     * @type {string}
     * @memberof Appointment
     */
    'scheduledSource'?: string;
    /**
     * 
     * @type {string}
     * @memberof Appointment
     */
    'networkStatus'?: AppointmentNetworkStatusEnum;
    /**
     * 
     * @type {number}
     * @memberof Appointment
     */
    'copayAmount'?: number;
    /**
     * 
     * @type {number}
     * @memberof Appointment
     */
    'coInsuranceAmount'?: number;
    /**
     * 
     * @type {number}
     * @memberof Appointment
     */
    'deductible'?: number;
    /**
     * 
     * @type {string}
     * @memberof Appointment
     */
    'coverageLevel'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Appointment
     */
    'priorAuthorization'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof Appointment
     */
    'verificationStatus'?: AppointmentVerificationStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof Appointment
     */
    'paymentLinkId'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Appointment
     */
    'paymentLinkSent'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof Appointment
     */
    'paymentLinkAmount'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof Appointment
     */
    'paymentLinkPaid'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Appointment
     */
    'superBillGenerated'?: boolean;
}

export const AppointmentPatientGenderEnum = {
    Male: 'MALE',
    Female: 'FEMALE',
    Unknown: 'UNKNOWN',
    Other: 'OTHER'
} as const;

export type AppointmentPatientGenderEnum = typeof AppointmentPatientGenderEnum[keyof typeof AppointmentPatientGenderEnum];
export const AppointmentModeEnum = {
    InPerson: 'IN_PERSON',
    Virtual: 'VIRTUAL'
} as const;

export type AppointmentModeEnum = typeof AppointmentModeEnum[keyof typeof AppointmentModeEnum];
export const AppointmentPaymentTypeEnum = {
    Cash: 'CASH',
    Card: 'CARD',
    Bank: 'BANK',
    Insurance: 'INSURANCE',
    Online: 'ONLINE'
} as const;

export type AppointmentPaymentTypeEnum = typeof AppointmentPaymentTypeEnum[keyof typeof AppointmentPaymentTypeEnum];
export const AppointmentStatusEnum = {
    Pending: 'PENDING',
    Confirmed: 'CONFIRMED',
    Cancelled: 'CANCELLED',
    NoShow: 'NO_SHOW',
    CheckedIn: 'CHECKED_IN',
    InExam: 'IN_EXAM',
    Scheduled: 'SCHEDULED',
    IntakeCompleted: 'INTAKE_COMPLETED',
    Completed: 'COMPLETED',
    Instant: 'INSTANT',
    CancellationRequested: 'CANCELLATION_REQUESTED'
} as const;

export type AppointmentStatusEnum = typeof AppointmentStatusEnum[keyof typeof AppointmentStatusEnum];
export const AppointmentTimezoneEnum = {
    Pst: 'PST',
    Est: 'EST',
    Cst: 'CST',
    Mst: 'MST',
    Ast: 'AST',
    Hst: 'HST',
    Edt: 'EDT',
    Pdt: 'PDT',
    Cdt: 'CDT',
    Adt: 'ADT',
    Mdt: 'MDT',
    Ist: 'IST',
    Akdt: 'AKDT',
    Akst: 'AKST',
    Gmt: 'GMT',
    Utc: 'UTC',
    Wet: 'WET',
    West: 'WEST',
    Cet: 'CET',
    Cest: 'CEST',
    Eet: 'EET',
    Eest: 'EEST',
    Msk: 'MSK',
    Msd: 'MSD',
    Aest: 'AEST',
    Aedt: 'AEDT',
    Acst: 'ACST',
    Acdt: 'ACDT',
    Awst: 'AWST',
    Nzst: 'NZST',
    Nzdt: 'NZDT',
    Sgt: 'SGT',
    Hkt: 'HKT',
    Jst: 'JST',
    Kst: 'KST',
    CstChina: 'CST_CHINA',
    Bdt: 'BDT',
    Pkt: 'PKT',
    IstIran: 'IST_IRAN',
    Trt: 'TRT',
    Idt: 'IDT',
    Wat: 'WAT',
    Cat: 'CAT',
    Eat: 'EAT',
    Art: 'ART',
    Bot: 'BOT',
    Clt: 'CLT',
    Clst: 'CLST',
    Srt: 'SRT',
    Gft: 'GFT',
    Uyt: 'UYT',
    Uyst: 'UYST',
    Vet: 'VET',
    Samt: 'SAMT',
    Yekt: 'YEKT',
    Irkt: 'IRKT',
    Krat: 'KRAT',
    Magt: 'MAGT',
    Pett: 'PETT',
    Vlat: 'VLAT',
    Chot: 'CHOT',
    Ulat: 'ULAT',
    Tmt: 'TMT',
    Orat: 'ORAT',
    Almt: 'ALMT',
    Azt: 'AZT',
    Get: 'GET',
    Mut: 'MUT',
    Sct: 'SCT',
    Ret: 'RET',
    Mvt: 'MVT',
    Cct: 'CCT',
    Sast: 'SAST',
    Nst: 'NST',
    Ndt: 'NDT'
} as const;

export type AppointmentTimezoneEnum = typeof AppointmentTimezoneEnum[keyof typeof AppointmentTimezoneEnum];
export const AppointmentReminderStatusEnum = {
    Pending: 'PENDING',
    Hours48: 'HOURS_48',
    Hours24: 'HOURS_24',
    Hours2: 'HOURS_2',
    Minutes15: 'MINUTES_15',
    Discard: 'DISCARD'
} as const;

export type AppointmentReminderStatusEnum = typeof AppointmentReminderStatusEnum[keyof typeof AppointmentReminderStatusEnum];
export const AppointmentRecurringTypeEnum = {
    Daily: 'DAILY',
    Weekly: 'WEEKLY',
    Custom: 'CUSTOM',
    Monthly: 'MONTHLY'
} as const;

export type AppointmentRecurringTypeEnum = typeof AppointmentRecurringTypeEnum[keyof typeof AppointmentRecurringTypeEnum];
export const AppointmentNetworkStatusEnum = {
    InNetwork: 'IN_NETWORK',
    OutOfNetwork: 'OUT_OF_NETWORK'
} as const;

export type AppointmentNetworkStatusEnum = typeof AppointmentNetworkStatusEnum[keyof typeof AppointmentNetworkStatusEnum];
export const AppointmentVerificationStatusEnum = {
    Done: 'DONE',
    Pending: 'PENDING',
    InProgress: 'IN_PROGRESS'
} as const;

export type AppointmentVerificationStatusEnum = typeof AppointmentVerificationStatusEnum[keyof typeof AppointmentVerificationStatusEnum];

/**
 * 
 * @export
 * @interface AppointmentConfigurationDto
 */
export interface AppointmentConfigurationDto {
    /**
     * 
     * @type {string}
     * @memberof AppointmentConfigurationDto
     */
    'uuid'?: string;
    /**
     * 
     * @type {number}
     * @memberof AppointmentConfigurationDto
     */
    'cancelAppointmentTime'?: number;
    /**
     * 
     * @type {string}
     * @memberof AppointmentConfigurationDto
     */
    'cancelAppointmentUnit'?: string;
    /**
     * 
     * @type {number}
     * @memberof AppointmentConfigurationDto
     */
    'rescheduleAppointmentTime'?: number;
    /**
     * 
     * @type {string}
     * @memberof AppointmentConfigurationDto
     */
    'rescheduleAppointmentUnit'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof AppointmentConfigurationDto
     */
    'archive'?: boolean;
}
/**
 * 
 * @export
 * @interface AppointmentStatusChange
 */
export interface AppointmentStatusChange {
    /**
     * 
     * @type {string}
     * @memberof AppointmentStatusChange
     */
    'appointmentId': string;
    /**
     * 
     * @type {string}
     * @memberof AppointmentStatusChange
     */
    'status'?: AppointmentStatusChangeStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof AppointmentStatusChange
     */
    'reason'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof AppointmentStatusChange
     */
    'chargable'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AppointmentStatusChange
     */
    'appointmentRequest'?: boolean;
}

export const AppointmentStatusChangeStatusEnum = {
    Pending: 'PENDING',
    Confirmed: 'CONFIRMED',
    Cancelled: 'CANCELLED',
    NoShow: 'NO_SHOW',
    CheckedIn: 'CHECKED_IN',
    InExam: 'IN_EXAM',
    Scheduled: 'SCHEDULED',
    IntakeCompleted: 'INTAKE_COMPLETED',
    Completed: 'COMPLETED',
    Instant: 'INSTANT',
    CancellationRequested: 'CANCELLATION_REQUESTED'
} as const;

export type AppointmentStatusChangeStatusEnum = typeof AppointmentStatusChangeStatusEnum[keyof typeof AppointmentStatusChangeStatusEnum];

/**
 * 
 * @export
 * @interface AppointmentTypeList
 */
export interface AppointmentTypeList {
    /**
     * 
     * @type {string}
     * @memberof AppointmentTypeList
     */
    'uuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof AppointmentTypeList
     */
    'typeName'?: string;
    /**
     * 
     * @type {string}
     * @memberof AppointmentTypeList
     */
    'nameString'?: string;
    /**
     * 
     * @type {string}
     * @memberof AppointmentTypeList
     */
    'duration'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof AppointmentTypeList
     */
    'active'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AppointmentTypeList
     */
    'archive'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof AppointmentTypeList
     */
    'intakeForms'?: string;
    /**
     * 
     * @type {string}
     * @memberof AppointmentTypeList
     */
    'dueDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof AppointmentTypeList
     */
    'sla'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof AppointmentTypeList
     */
    'autoConfirmOnSchedule'?: boolean;
}
/**
 * 
 * @export
 * @interface AssessmentCode
 */
export interface AssessmentCode {
    /**
     * 
     * @type {string}
     * @memberof AssessmentCode
     */
    'uuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof AssessmentCode
     */
    'code'?: string;
    /**
     * 
     * @type {string}
     * @memberof AssessmentCode
     */
    'description'?: string;
}
/**
 * 
 * @export
 * @interface AssessmentDTO
 */
export interface AssessmentDTO {
    /**
     * 
     * @type {string}
     * @memberof AssessmentDTO
     */
    'title'?: string;
    /**
     * 
     * @type {Content}
     * @memberof AssessmentDTO
     */
    'content'?: Content;
}
/**
 * 
 * @export
 * @interface AssessmentData
 */
export interface AssessmentData {
    /**
     * 
     * @type {string}
     * @memberof AssessmentData
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof AssessmentData
     */
    'assessment_id'?: string;
    /**
     * 
     * @type {number}
     * @memberof AssessmentData
     */
    'total_score'?: number;
    /**
     * 
     * @type {Array<AssessmentSection>}
     * @memberof AssessmentData
     */
    'sectionsAsList'?: Array<AssessmentSection>;
    /**
     * 
     * @type {string}
     * @memberof AssessmentData
     */
    'AssessmentName'?: string;
    /**
     * 
     * @type {AssessmentSection}
     * @memberof AssessmentData
     */
    'section'?: AssessmentSection;
    /**
     * 
     * @type {Array<AssessmentSection>}
     * @memberof AssessmentData
     */
    'sections'?: Array<AssessmentSection>;
}
/**
 * 
 * @export
 * @interface AssessmentPDFRequest
 */
export interface AssessmentPDFRequest {
    /**
     * 
     * @type {string}
     * @memberof AssessmentPDFRequest
     */
    'patientId'?: string;
    /**
     * 
     * @type {string}
     * @memberof AssessmentPDFRequest
     */
    'dateOfBirth'?: string;
    /**
     * 
     * @type {string}
     * @memberof AssessmentPDFRequest
     */
    'screeningAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof AssessmentPDFRequest
     */
    'screeningBy'?: string;
    /**
     * 
     * @type {{ [key: string]: AssessmentData; }}
     * @memberof AssessmentPDFRequest
     */
    'assessments'?: { [key: string]: AssessmentData; };
}
/**
 * 
 * @export
 * @interface AssessmentQuestion
 */
export interface AssessmentQuestion {
    /**
     * 
     * @type {string}
     * @memberof AssessmentQuestion
     */
    'uuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof AssessmentQuestion
     */
    'title'?: string;
    /**
     * 
     * @type {string}
     * @memberof AssessmentQuestion
     */
    'selectedAns'?: string;
}
/**
 * 
 * @export
 * @interface AssessmentSection
 */
export interface AssessmentSection {
    /**
     * 
     * @type {string}
     * @memberof AssessmentSection
     */
    'type'?: string;
    /**
     * 
     * @type {string}
     * @memberof AssessmentSection
     */
    'title'?: string;
    /**
     * 
     * @type {string}
     * @memberof AssessmentSection
     */
    'interpretation'?: string;
    /**
     * 
     * @type {{ [key: string]: number; }}
     * @memberof AssessmentSection
     */
    'answersOptions'?: { [key: string]: number; };
    /**
     * 
     * @type {Array<AssessmentQuestion>}
     * @memberof AssessmentSection
     */
    'questions'?: Array<AssessmentQuestion>;
}
/**
 * 
 * @export
 * @interface AssessmentsEntity
 */
export interface AssessmentsEntity {
    /**
     * 
     * @type {string}
     * @memberof AssessmentsEntity
     */
    'createdBy'?: string;
    /**
     * 
     * @type {string}
     * @memberof AssessmentsEntity
     */
    'modifiedBy'?: string;
    /**
     * 
     * @type {string}
     * @memberof AssessmentsEntity
     */
    'created'?: string;
    /**
     * 
     * @type {string}
     * @memberof AssessmentsEntity
     */
    'modified'?: string;
    /**
     * 
     * @type {number}
     * @memberof AssessmentsEntity
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof AssessmentsEntity
     */
    'uuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof AssessmentsEntity
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof AssessmentsEntity
     */
    'status'?: AssessmentsEntityStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof AssessmentsEntity
     */
    'submittedOn'?: string;
    /**
     * 
     * @type {string}
     * @memberof AssessmentsEntity
     */
    'submittedBy'?: string;
    /**
     * 
     * @type {string}
     * @memberof AssessmentsEntity
     */
    'sendOn'?: string;
    /**
     * 
     * @type {string}
     * @memberof AssessmentsEntity
     */
    'sendBy'?: string;
    /**
     * 
     * @type {string}
     * @memberof AssessmentsEntity
     */
    'patientId'?: string;
    /**
     * 
     * @type {string}
     * @memberof AssessmentsEntity
     */
    'appointmentId'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof AssessmentsEntity
     */
    'scheduled'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AssessmentsEntity
     */
    'archive'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof AssessmentsEntity
     */
    'patientName'?: string;
    /**
     * 
     * @type {string}
     * @memberof AssessmentsEntity
     */
    'patientMrn'?: string;
    /**
     * 
     * @type {string}
     * @memberof AssessmentsEntity
     */
    'schedulerName'?: string;
    /**
     * 
     * @type {string}
     * @memberof AssessmentsEntity
     */
    'providerRole'?: string;
    /**
     * 
     * @type {string}
     * @memberof AssessmentsEntity
     */
    'content'?: string;
    /**
     * 
     * @type {string}
     * @memberof AssessmentsEntity
     */
    'modifiedAt'?: string;
}

export const AssessmentsEntityStatusEnum = {
    Pending: 'PENDING',
    Completed: 'COMPLETED',
    Scheduled: 'SCHEDULED'
} as const;

export type AssessmentsEntityStatusEnum = typeof AssessmentsEntityStatusEnum[keyof typeof AssessmentsEntityStatusEnum];

/**
 * 
 * @export
 * @interface AvailabilitySetting
 */
export interface AvailabilitySetting {
    /**
     * 
     * @type {string}
     * @memberof AvailabilitySetting
     */
    'providerId': string;
    /**
     * 
     * @type {string}
     * @memberof AvailabilitySetting
     */
    'bookingWindow': string;
    /**
     * 
     * @type {string}
     * @memberof AvailabilitySetting
     */
    'timezone': AvailabilitySettingTimezoneEnum;
    /**
     * 
     * @type {number}
     * @memberof AvailabilitySetting
     */
    'initialConsultTime': number;
    /**
     * 
     * @type {number}
     * @memberof AvailabilitySetting
     */
    'followupConsultTime': number;
    /**
     * 
     * @type {number}
     * @memberof AvailabilitySetting
     */
    'administrativeConsultTime'?: number;
    /**
     * 
     * @type {number}
     * @memberof AvailabilitySetting
     */
    'careCoordinationConsultTime'?: number;
    /**
     * 
     * @type {number}
     * @memberof AvailabilitySetting
     */
    'medicationBriefConsultTime'?: number;
    /**
     * 
     * @type {number}
     * @memberof AvailabilitySetting
     */
    'nursingOnlyConsultTime'?: number;
    /**
     * 
     * @type {number}
     * @memberof AvailabilitySetting
     */
    'telephoneCallConsultTime'?: number;
    /**
     * 
     * @type {number}
     * @memberof AvailabilitySetting
     */
    'urgentVisitConsultTime'?: number;
    /**
     * 
     * @type {number}
     * @memberof AvailabilitySetting
     */
    'videoVisitConsultTime'?: number;
    /**
     * 
     * @type {number}
     * @memberof AvailabilitySetting
     */
    'wellnessExamConsultTime'?: number;
    /**
     * 
     * @type {number}
     * @memberof AvailabilitySetting
     */
    'bufferTime'?: number;
    /**
     * 
     * @type {Set<AvailabilityTimeSetting>}
     * @memberof AvailabilitySetting
     */
    'settings'?: Set<AvailabilityTimeSetting>;
    /**
     * 
     * @type {string}
     * @memberof AvailabilitySetting
     */
    'bookBefore'?: string;
    /**
     * 
     * @type {Set<BlockDay>}
     * @memberof AvailabilitySetting
     */
    'blockDays'?: Set<BlockDay>;
    /**
     * 
     * @type {Set<DaySlot>}
     * @memberof AvailabilitySetting
     */
    'daySlots'?: Set<DaySlot>;
    /**
     * 
     * @type {string}
     * @memberof AvailabilitySetting
     */
    'startTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof AvailabilitySetting
     */
    'endTime'?: string;
}

export const AvailabilitySettingTimezoneEnum = {
    Pst: 'PST',
    Est: 'EST',
    Cst: 'CST',
    Mst: 'MST',
    Ast: 'AST',
    Hst: 'HST',
    Edt: 'EDT',
    Pdt: 'PDT',
    Cdt: 'CDT',
    Adt: 'ADT',
    Mdt: 'MDT',
    Ist: 'IST',
    Akdt: 'AKDT',
    Akst: 'AKST',
    Gmt: 'GMT',
    Utc: 'UTC',
    Wet: 'WET',
    West: 'WEST',
    Cet: 'CET',
    Cest: 'CEST',
    Eet: 'EET',
    Eest: 'EEST',
    Msk: 'MSK',
    Msd: 'MSD',
    Aest: 'AEST',
    Aedt: 'AEDT',
    Acst: 'ACST',
    Acdt: 'ACDT',
    Awst: 'AWST',
    Nzst: 'NZST',
    Nzdt: 'NZDT',
    Sgt: 'SGT',
    Hkt: 'HKT',
    Jst: 'JST',
    Kst: 'KST',
    CstChina: 'CST_CHINA',
    Bdt: 'BDT',
    Pkt: 'PKT',
    IstIran: 'IST_IRAN',
    Trt: 'TRT',
    Idt: 'IDT',
    Wat: 'WAT',
    Cat: 'CAT',
    Eat: 'EAT',
    Art: 'ART',
    Bot: 'BOT',
    Clt: 'CLT',
    Clst: 'CLST',
    Srt: 'SRT',
    Gft: 'GFT',
    Uyt: 'UYT',
    Uyst: 'UYST',
    Vet: 'VET',
    Samt: 'SAMT',
    Yekt: 'YEKT',
    Irkt: 'IRKT',
    Krat: 'KRAT',
    Magt: 'MAGT',
    Pett: 'PETT',
    Vlat: 'VLAT',
    Chot: 'CHOT',
    Ulat: 'ULAT',
    Tmt: 'TMT',
    Orat: 'ORAT',
    Almt: 'ALMT',
    Azt: 'AZT',
    Get: 'GET',
    Mut: 'MUT',
    Sct: 'SCT',
    Ret: 'RET',
    Mvt: 'MVT',
    Cct: 'CCT',
    Sast: 'SAST',
    Nst: 'NST',
    Ndt: 'NDT'
} as const;

export type AvailabilitySettingTimezoneEnum = typeof AvailabilitySettingTimezoneEnum[keyof typeof AvailabilitySettingTimezoneEnum];

/**
 * 
 * @export
 * @interface AvailabilityTimeSetting
 */
export interface AvailabilityTimeSetting {
    /**
     * 
     * @type {string}
     * @memberof AvailabilityTimeSetting
     */
    'appointmentTypeUuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof AvailabilityTimeSetting
     */
    'appointmentTypeName'?: string;
    /**
     * 
     * @type {string}
     * @memberof AvailabilityTimeSetting
     */
    'appointmentTypeNameFormatted'?: string;
    /**
     * 
     * @type {number}
     * @memberof AvailabilityTimeSetting
     */
    'slotTime'?: number;
    /**
     * 
     * @type {string}
     * @memberof AvailabilityTimeSetting
     */
    'minNoticeUnit'?: string;
}
/**
 * 
 * @export
 * @interface BlockDay
 */
export interface BlockDay {
    /**
     * 
     * @type {string}
     * @memberof BlockDay
     */
    'startTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof BlockDay
     */
    'endTime'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof BlockDay
     */
    'fullDay'?: boolean;
}
/**
 * 
 * @export
 * @interface BulkCancel
 */
export interface BulkCancel {
    /**
     * 
     * @type {Array<string>}
     * @memberof BulkCancel
     */
    'taskId'?: Array<string>;
}
/**
 * 
 * @export
 * @interface BulkReassigned
 */
export interface BulkReassigned {
    /**
     * 
     * @type {Array<string>}
     * @memberof BulkReassigned
     */
    'taskId'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof BulkReassigned
     */
    'dueDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof BulkReassigned
     */
    'description'?: string;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof BulkReassigned
     */
    'assignTo'?: { [key: string]: string; };
    /**
     * 
     * @type {string}
     * @memberof BulkReassigned
     */
    'resolvedDate'?: string;
}
/**
 * 
 * @export
 * @interface BulkScrubRequest
 */
export interface BulkScrubRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof BulkScrubRequest
     */
    'claimUuids': Array<string>;
}
/**
 * 
 * @export
 * @interface CarePlan
 */
export interface CarePlan {
    /**
     * 
     * @type {string}
     * @memberof CarePlan
     */
    'uuid'?: string;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof CarePlan
     */
    'patient': { [key: string]: string; };
    /**
     * 
     * @type {string}
     * @memberof CarePlan
     */
    'assignedBy'?: string;
    /**
     * 
     * @type {string}
     * @memberof CarePlan
     */
    'startDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof CarePlan
     */
    'endDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof CarePlan
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof CarePlan
     */
    'condition'?: string;
    /**
     * 
     * @type {string}
     * @memberof CarePlan
     */
    'deception'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CarePlan
     */
    'active'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CarePlan
     */
    'archive'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CarePlan
     */
    'appointment_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CarePlan
     */
    'providerStatus'?: CarePlanProviderStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof CarePlan
     */
    'assignDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof CarePlan
     */
    'goals'?: string;
    /**
     * 
     * @type {string}
     * @memberof CarePlan
     */
    'intervention'?: string;
    /**
     * 
     * @type {string}
     * @memberof CarePlan
     */
    'preventive_schedule'?: string;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof CarePlan
     */
    'icdCodes'?: { [key: string]: string; };
}

export const CarePlanProviderStatusEnum = {
    Pending: 'PENDING',
    Confirmed: 'CONFIRMED'
} as const;

export type CarePlanProviderStatusEnum = typeof CarePlanProviderStatusEnum[keyof typeof CarePlanProviderStatusEnum];

/**
 * 
 * @export
 * @interface ChangeAvatarRequest
 */
export interface ChangeAvatarRequest {
    /**
     * 
     * @type {string}
     * @memberof ChangeAvatarRequest
     */
    'newAvatar'?: string;
    /**
     * 
     * @type {string}
     * @memberof ChangeAvatarRequest
     */
    'userId'?: string;
}
/**
 * 
 * @export
 * @interface ChangePasswordRequest
 */
export interface ChangePasswordRequest {
    /**
     * 
     * @type {string}
     * @memberof ChangePasswordRequest
     */
    'currentPassword': string;
    /**
     * 
     * @type {string}
     * @memberof ChangePasswordRequest
     */
    'newPassword': string;
}
/**
 * 
 * @export
 * @interface Claim
 */
export interface Claim {
    /**
     * 
     * @type {string}
     * @memberof Claim
     */
    'uuid'?: string;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof Claim
     */
    'patient'?: { [key: string]: string; };
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof Claim
     */
    'provider'?: { [key: string]: string; };
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof Claim
     */
    'referringProvider'?: { [key: string]: string; };
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof Claim
     */
    'orderingProvider'?: { [key: string]: string; };
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof Claim
     */
    'serviceLocation'?: { [key: string]: string; };
    /**
     * 
     * @type {Address}
     * @memberof Claim
     */
    'serviceLocationAddress'?: Address;
    /**
     * 
     * @type {Address}
     * @memberof Claim
     */
    'serviceLocationBillingAddress'?: Address;
    /**
     * 
     * @type {string}
     * @memberof Claim
     */
    'encounterType'?: string;
    /**
     * 
     * @type {string}
     * @memberof Claim
     */
    'patientName'?: string;
    /**
     * 
     * @type {string}
     * @memberof Claim
     */
    'patientId'?: string;
    /**
     * 
     * @type {string}
     * @memberof Claim
     */
    'patientGender'?: string;
    /**
     * 
     * @type {string}
     * @memberof Claim
     */
    'patientDOB'?: string;
    /**
     * 
     * @type {string}
     * @memberof Claim
     */
    'patientPhone'?: string;
    /**
     * 
     * @type {Address}
     * @memberof Claim
     */
    'patientAddress'?: Address;
    /**
     * 
     * @type {PatientInsuranceClaims}
     * @memberof Claim
     */
    'patientInsurance'?: PatientInsuranceClaims;
    /**
     * 
     * @type {string}
     * @memberof Claim
     */
    'dateOfService'?: string;
    /**
     * 
     * @type {string}
     * @memberof Claim
     */
    'placeOfService'?: ClaimPlaceOfServiceEnum;
    /**
     * 
     * @type {string}
     * @memberof Claim
     */
    'reasonForVisit'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Claim
     */
    'active'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Claim
     */
    'archive'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof Claim
     */
    'providerName'?: string;
    /**
     * 
     * @type {string}
     * @memberof Claim
     */
    'providerSignatureDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof Claim
     */
    'referringProviderName'?: string;
    /**
     * 
     * @type {number}
     * @memberof Claim
     */
    'referringProviderNPI'?: number;
    /**
     * 
     * @type {string}
     * @memberof Claim
     */
    'insuranceId'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Claim
     */
    'conditionRelatedToEmployment'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Claim
     */
    'conditionRelatedToAutoAccident'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Claim
     */
    'conditionRelatedToOtherAccident'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof Claim
     */
    'dateOfCurrentIllness'?: string;
    /**
     * 
     * @type {string}
     * @memberof Claim
     */
    'otherDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof Claim
     */
    'unableToWorkFrom'?: string;
    /**
     * 
     * @type {string}
     * @memberof Claim
     */
    'unableToWorkTo'?: string;
    /**
     * 
     * @type {string}
     * @memberof Claim
     */
    'hospitalizationFrom'?: string;
    /**
     * 
     * @type {string}
     * @memberof Claim
     */
    'hospitalizationTo'?: string;
    /**
     * 
     * @type {string}
     * @memberof Claim
     */
    'state'?: string;
    /**
     * 
     * @type {string}
     * @memberof Claim
     */
    'claimCodes'?: string;
    /**
     * 
     * @type {string}
     * @memberof Claim
     */
    'acceptAssignment'?: string;
    /**
     * 
     * @type {string}
     * @memberof Claim
     */
    'otherClaimId'?: string;
    /**
     * 
     * @type {string}
     * @memberof Claim
     */
    'resubmissionCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof Claim
     */
    'originalReferenceNumber'?: string;
    /**
     * 
     * @type {Array<PatientProcedureCode>}
     * @memberof Claim
     */
    'patientProcedureCodes'?: Array<PatientProcedureCode>;
    /**
     * 
     * @type {ProviderAccountDetails}
     * @memberof Claim
     */
    'providerAccountDetails'?: ProviderAccountDetails;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof Claim
     */
    'diagnosisCodes'?: { [key: string]: string; };
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof Claim
     */
    'encounter'?: { [key: string]: string; };
    /**
     * 
     * @type {string}
     * @memberof Claim
     */
    'claimStatus'?: ClaimClaimStatusEnum;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof Claim
     */
    'superBill'?: { [key: string]: string; };
    /**
     * 
     * @type {number}
     * @memberof Claim
     */
    'total'?: number;
    /**
     * 
     * @type {string}
     * @memberof Claim
     */
    'updatedDate'?: string;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof Claim
     */
    'renderingProviderSpecialities'?: { [key: string]: string; };
    /**
     * 
     * @type {string}
     * @memberof Claim
     */
    'insuredRelationshipWithPatient'?: ClaimInsuredRelationshipWithPatientEnum;
    /**
     * 
     * @type {string}
     * @memberof Claim
     */
    'subscriberFirstName'?: string;
    /**
     * 
     * @type {string}
     * @memberof Claim
     */
    'subscriberLastName'?: string;
    /**
     * 
     * @type {string}
     * @memberof Claim
     */
    'subscriberMiddleName'?: string;
    /**
     * 
     * @type {string}
     * @memberof Claim
     */
    'subscriberSsn'?: string;
    /**
     * 
     * @type {string}
     * @memberof Claim
     */
    'subscriberGender'?: ClaimSubscriberGenderEnum;
    /**
     * 
     * @type {string}
     * @memberof Claim
     */
    'subscriberBirthDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof Claim
     */
    'subscriberMobileNumber'?: string;
    /**
     * 
     * @type {Address}
     * @memberof Claim
     */
    'subscriberAddress'?: Address;
    /**
     * 
     * @type {string}
     * @memberof Claim
     */
    'billingProviderPhone'?: string;
    /**
     * 
     * @type {string}
     * @memberof Claim
     */
    'billingProviderName'?: string;
    /**
     * 
     * @type {Address}
     * @memberof Claim
     */
    'billingProviderAddress'?: Address;
    /**
     * 
     * @type {number}
     * @memberof Claim
     */
    'billingProviderNPI'?: number;
    /**
     * 
     * @type {string}
     * @memberof Claim
     */
    'renderingProviderPhone'?: string;
    /**
     * 
     * @type {string}
     * @memberof Claim
     */
    'renderingProviderName'?: string;
    /**
     * 
     * @type {Address}
     * @memberof Claim
     */
    'renderingProviderAddress'?: Address;
    /**
     * 
     * @type {number}
     * @memberof Claim
     */
    'renderingProviderNPI'?: number;
    /**
     * 
     * @type {number}
     * @memberof Claim
     */
    'orderingProviderNPI'?: number;
    /**
     * 
     * @type {string}
     * @memberof Claim
     */
    'renderingProviderNPINumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof Claim
     */
    'referringProviderNPINumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof Claim
     */
    'orderingProviderNPINumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof Claim
     */
    'taxId'?: string;
    /**
     * 
     * @type {string}
     * @memberof Claim
     */
    'accountNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof Claim
     */
    'providerGroupName'?: string;
    /**
     * 
     * @type {string}
     * @memberof Claim
     */
    'providerGroupPhone'?: string;
    /**
     * 
     * @type {string}
     * @memberof Claim
     */
    'providerGroupNpi'?: string;
    /**
     * 
     * @type {string}
     * @memberof Claim
     */
    'providerGroupEmail'?: string;
    /**
     * 
     * @type {Address}
     * @memberof Claim
     */
    'providerGroupAddress'?: Address;
    /**
     * 
     * @type {Address}
     * @memberof Claim
     */
    'providerGroupBillingAddress'?: Address;
    /**
     * 
     * @type {boolean}
     * @memberof Claim
     */
    'partialSave'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof Claim
     */
    'ackFile'?: string;
    /**
     * 
     * @type {string}
     * @memberof Claim
     */
    'comment'?: string;
    /**
     * 
     * @type {string}
     * @memberof Claim
     */
    'error'?: string;
    /**
     * 
     * @type {string}
     * @memberof Claim
     */
    'priorAuthorization'?: string;
    /**
     * 
     * @type {string}
     * @memberof Claim
     */
    'posCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof Claim
     */
    'claimType'?: string;
    /**
     * 
     * @type {string}
     * @memberof Claim
     */
    'insuranceType'?: ClaimInsuranceTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof Claim
     */
    'scrubStatus'?: ClaimScrubStatusEnum;
    /**
     * 
     * @type {number}
     * @memberof Claim
     */
    'paidAmount'?: number;
    /**
     * 
     * @type {number}
     * @memberof Claim
     */
    'adjustment'?: number;
    /**
     * 
     * @type {number}
     * @memberof Claim
     */
    'patientResponsibility'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof Claim
     */
    'paymentPosted'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof Claim
     */
    'practiceName'?: string;
    /**
     * 
     * @type {string}
     * @memberof Claim
     */
    'practiceNpi'?: string;
    /**
     * 
     * @type {string}
     * @memberof Claim
     */
    'practiceContact'?: string;
    /**
     * 
     * @type {Address}
     * @memberof Claim
     */
    'practiceBillingAddress'?: Address;
}

export const ClaimPlaceOfServiceEnum = {
    Pharmacy: 'PHARMACY',
    TelehealthOutsidePatientHome: 'TELEHEALTH_OUTSIDE_PATIENT_HOME',
    School: 'SCHOOL',
    HomelessShelter: 'HOMELESS_SHELTER',
    IndianHealthServiceFreeStandingFacility: 'INDIAN_HEALTH_SERVICE_FREE_STANDING_FACILITY',
    IndianHealthServiceProviderBasedFacility: 'INDIAN_HEALTH_SERVICE_PROVIDER_BASED_FACILITY',
    Tribal638FreeStandingFacility: 'TRIBAL_638_FREE_STANDING_FACILITY',
    Tribal638ProviderBasedFacility: 'TRIBAL_638_PROVIDER_BASED_FACILITY',
    PrisonCorrectionalFacility: 'PRISON_CORRECTIONAL_FACILITY',
    TelehealthInsidePatientHome: 'TELEHEALTH_INSIDE_PATIENT_HOME',
    Office: 'OFFICE',
    Home: 'HOME',
    AssistedLivingFacility: 'ASSISTED_LIVING_FACILITY',
    GroupHome: 'GROUP_HOME',
    MobileUnit: 'MOBILE_UNIT',
    TemporaryLodging: 'TEMPORARY_LODGING',
    WalkInRetailHealthClinic: 'WALK_IN_RETAIL_HEALTH_CLINIC',
    PlaceOfEmploymentWorksite: 'PLACE_OF_EMPLOYMENT_WORKSITE',
    OffCampusOutpatientHospital: 'OFF_CAMPUS_OUTPATIENT_HOSPITAL',
    UrgentCareFacility: 'URGENT_CARE_FACILITY',
    InpatientHospital: 'INPATIENT_HOSPITAL',
    OutpatientHospital: 'OUTPATIENT_HOSPITAL',
    EmergencyRoomHospital: 'EMERGENCY_ROOM_HOSPITAL',
    AmbulatorySurgicalCenter: 'AMBULATORY_SURGICAL_CENTER',
    BirthingCenter: 'BIRTHING_CENTER',
    MilitaryTreatmentFacility: 'MILITARY_TREATMENT_FACILITY',
    SkilledNursingFacility: 'SKILLED_NURSING_FACILITY',
    NursingFacility: 'NURSING_FACILITY',
    CustodialCareFacility: 'CUSTODIAL_CARE_FACILITY',
    Hospice: 'HOSPICE',
    AmbulanceLand: 'AMBULANCE_LAND',
    AmbulanceAirOrWater: 'AMBULANCE_AIR_OR_WATER',
    IndependentClinic: 'INDEPENDENT_CLINIC',
    FederallyQualifiedHealthCenter: 'FEDERALLY_QUALIFIED_HEALTH_CENTER',
    InpatientPsychiatricFacility: 'INPATIENT_PSYCHIATRIC_FACILITY',
    PsychiatricFacilityPartialHospitalization: 'PSYCHIATRIC_FACILITY_PARTIAL_HOSPITALIZATION',
    CommunityMentalHealthCenter: 'COMMUNITY_MENTAL_HEALTH_CENTER',
    IntermediateCareFacilityIntellectualDisabilities: 'INTERMEDIATE_CARE_FACILITY_INTELLECTUAL_DISABILITIES',
    ResidentialSubstanceAbuseTreatmentFacility: 'RESIDENTIAL_SUBSTANCE_ABUSE_TREATMENT_FACILITY',
    PsychiatricResidentialTreatmentCenter: 'PSYCHIATRIC_RESIDENTIAL_TREATMENT_CENTER',
    NonResidentialSubstanceAbuseTreatmentFacility: 'NON_RESIDENTIAL_SUBSTANCE_ABUSE_TREATMENT_FACILITY',
    NonResidentialOpioidTreatmentFacility: 'NON_RESIDENTIAL_OPIOID_TREATMENT_FACILITY',
    MassImmunizationCenter: 'MASS_IMMUNIZATION_CENTER',
    ComprehensiveInpatientRehabilitationFacility: 'COMPREHENSIVE_INPATIENT_REHABILITATION_FACILITY',
    ComprehensiveOutpatientRehabilitationFacility: 'COMPREHENSIVE_OUTPATIENT_REHABILITATION_FACILITY',
    EndStageRenalDiseaseTreatmentFacility: 'END_STAGE_RENAL_DISEASE_TREATMENT_FACILITY',
    PublicHealthClinic: 'PUBLIC_HEALTH_CLINIC',
    RuralHealthClinic: 'RURAL_HEALTH_CLINIC',
    IndependentLaboratory: 'INDEPENDENT_LABORATORY',
    OtherPlaceOfService: 'OTHER_PLACE_OF_SERVICE'
} as const;

export type ClaimPlaceOfServiceEnum = typeof ClaimPlaceOfServiceEnum[keyof typeof ClaimPlaceOfServiceEnum];
export const ClaimClaimStatusEnum = {
    Draft: 'DRAFT',
    Submitted: 'SUBMITTED',
    Denied: 'DENIED',
    Accepted: 'ACCEPTED',
    AcceptedByWaystar: 'ACCEPTED_BY_WAYSTAR',
    AcceptedByClaimmd: 'ACCEPTED_BY_CLAIMMD',
    Rejected: 'REJECTED',
    Resubmitted: 'RESUBMITTED',
    Pending: 'PENDING',
    Paid: 'PAID',
    PendingSubmission: 'PENDING_SUBMISSION',
    ReadyForSubmit: 'READY_FOR_SUBMIT'
} as const;

export type ClaimClaimStatusEnum = typeof ClaimClaimStatusEnum[keyof typeof ClaimClaimStatusEnum];
export const ClaimInsuredRelationshipWithPatientEnum = {
    Self: 'SELF',
    Associate: 'ASSOCIATE',
    CareGiver: 'CARE_GIVER',
    Child: 'CHILD',
    EmergencyContact: 'EMERGENCY_CONTACT',
    Employee: 'EMPLOYEE',
    Employer: 'EMPLOYER',
    ExtendedFamily: 'EXTENDED_FAMILY',
    Father: 'FATHER',
    FosterChild: 'FOSTER_CHILD',
    Friend: 'FRIEND',
    Grandchild: 'GRANDCHILD',
    Grandparent: 'GRANDPARENT',
    Guardian: 'GUARDIAN',
    HandicappedDependent: 'HANDICAPPED_DEPENDENT',
    LifePartner: 'LIFE_PARTNER',
    Manager: 'MANAGER',
    Mother: 'MOTHER',
    NaturalChild: 'NATURAL_CHILD',
    None: 'NONE',
    Other: 'OTHER',
    OtherAdult: 'OTHER_ADULT',
    Owner: 'OWNER',
    Parent: 'PARENT',
    Sibling: 'SIBLING',
    Sister: 'SISTER',
    Spouse: 'SPOUSE',
    Stepchild: 'STEPCHILD',
    Trainer: 'TRAINER',
    Unknown: 'UNKNOWN',
    WardOfCourt: 'WARD_OF_COURT'
} as const;

export type ClaimInsuredRelationshipWithPatientEnum = typeof ClaimInsuredRelationshipWithPatientEnum[keyof typeof ClaimInsuredRelationshipWithPatientEnum];
export const ClaimSubscriberGenderEnum = {
    Male: 'MALE',
    Female: 'FEMALE',
    Unknown: 'UNKNOWN',
    Other: 'OTHER'
} as const;

export type ClaimSubscriberGenderEnum = typeof ClaimSubscriberGenderEnum[keyof typeof ClaimSubscriberGenderEnum];
export const ClaimInsuranceTypeEnum = {
    Primary: 'PRIMARY',
    Secondary: 'SECONDARY',
    Tertiary: 'TERTIARY',
    Other: 'OTHER'
} as const;

export type ClaimInsuranceTypeEnum = typeof ClaimInsuranceTypeEnum[keyof typeof ClaimInsuranceTypeEnum];
export const ClaimScrubStatusEnum = {
    Passed: 'PASSED',
    Pending: 'PENDING',
    Failed: 'FAILED'
} as const;

export type ClaimScrubStatusEnum = typeof ClaimScrubStatusEnum[keyof typeof ClaimScrubStatusEnum];

/**
 * 
 * @export
 * @interface ClaimIntegrationDto
 */
export interface ClaimIntegrationDto {
    /**
     * 
     * @type {number}
     * @memberof ClaimIntegrationDto
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof ClaimIntegrationDto
     */
    'uuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof ClaimIntegrationDto
     */
    'vendor'?: ClaimIntegrationDtoVendorEnum;
    /**
     * 
     * @type {string}
     * @memberof ClaimIntegrationDto
     */
    'userId'?: string;
    /**
     * 
     * @type {string}
     * @memberof ClaimIntegrationDto
     */
    'password'?: string;
    /**
     * 
     * @type {string}
     * @memberof ClaimIntegrationDto
     */
    'sftpHost'?: string;
    /**
     * 
     * @type {string}
     * @memberof ClaimIntegrationDto
     */
    'sftpUsername'?: string;
    /**
     * 
     * @type {string}
     * @memberof ClaimIntegrationDto
     */
    'sftpPassword'?: string;
    /**
     * 
     * @type {string}
     * @memberof ClaimIntegrationDto
     */
    'accountKey'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ClaimIntegrationDto
     */
    'archive'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ClaimIntegrationDto
     */
    'tenantId'?: string;
}

export const ClaimIntegrationDtoVendorEnum = {
    Waystar: 'WAYSTAR',
    ClaimMd: 'CLAIM_MD',
    Stedi: 'STEDI'
} as const;

export type ClaimIntegrationDtoVendorEnum = typeof ClaimIntegrationDtoVendorEnum[keyof typeof ClaimIntegrationDtoVendorEnum];

/**
 * 
 * @export
 * @interface ClaimRequest
 */
export interface ClaimRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof ClaimRequest
     */
    'claimUuids'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof ClaimRequest
     */
    'relationship'?: ClaimRequestRelationshipEnum;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof ClaimRequest
     */
    'claimedProcedures'?: { [key: string]: string; };
    /**
     * 
     * @type {boolean}
     * @memberof ClaimRequest
     */
    'relatedToOtherAccident'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ClaimRequest
     */
    'relatedToEmployment'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ClaimRequest
     */
    'relatedToAccident'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ClaimRequest
     */
    'additionalClaimInfo'?: string;
    /**
     * 
     * @type {string}
     * @memberof ClaimRequest
     */
    'outsideLabCharge'?: string;
    /**
     * 
     * @type {string}
     * @memberof ClaimRequest
     */
    'vendorType'?: ClaimRequestVendorTypeEnum;
}

export const ClaimRequestRelationshipEnum = {
    Self: 'SELF',
    Spouse: 'SPOUSE',
    Child: 'CHILD',
    Other: 'OTHER'
} as const;

export type ClaimRequestRelationshipEnum = typeof ClaimRequestRelationshipEnum[keyof typeof ClaimRequestRelationshipEnum];
export const ClaimRequestVendorTypeEnum = {
    Waystar: 'WAYSTAR',
    ClaimMd: 'CLAIM_MD',
    Stedi: 'STEDI'
} as const;

export type ClaimRequestVendorTypeEnum = typeof ClaimRequestVendorTypeEnum[keyof typeof ClaimRequestVendorTypeEnum];

/**
 * 
 * @export
 * @interface ClinicalNotesDTO
 */
export interface ClinicalNotesDTO {
    /**
     * 
     * @type {SubjectiveDTO}
     * @memberof ClinicalNotesDTO
     */
    'subjective'?: SubjectiveDTO;
    /**
     * 
     * @type {ObjectiveDTO}
     * @memberof ClinicalNotesDTO
     */
    'objective'?: ObjectiveDTO;
    /**
     * 
     * @type {AssessmentDTO}
     * @memberof ClinicalNotesDTO
     */
    'assessment'?: AssessmentDTO;
    /**
     * 
     * @type {PlanDTO}
     * @memberof ClinicalNotesDTO
     */
    'plan'?: PlanDTO;
    /**
     * 
     * @type {FollowUpNoteDTO}
     * @memberof ClinicalNotesDTO
     */
    'followUpNote'?: FollowUpNoteDTO;
    /**
     * 
     * @type {Array<TranscriptionSegmentDTO>}
     * @memberof ClinicalNotesDTO
     */
    'transcriptionSegments'?: Array<TranscriptionSegmentDTO>;
    /**
     * 
     * @type {string}
     * @memberof ClinicalNotesDTO
     */
    'patientId'?: string;
    /**
     * 
     * @type {string}
     * @memberof ClinicalNotesDTO
     */
    'appointmentId'?: string;
    /**
     * 
     * @type {PsychiatricNoteDTO}
     * @memberof ClinicalNotesDTO
     */
    'psychiatric'?: PsychiatricNoteDTO;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof ClinicalNotesDTO
     */
    'sections'?: { [key: string]: string; };
    /**
     * 
     * @type {string}
     * @memberof ClinicalNotesDTO
     */
    'noteType'?: ClinicalNotesDTONoteTypeEnum;
}

export const ClinicalNotesDTONoteTypeEnum = {
    SimpleSoapNote: 'SIMPLE_SOAP_NOTE',
    PsychiatricNote: 'PSYCHIATRIC_NOTE',
    PrimaryCareSoapNote: 'PRIMARY_CARE_SOAP_NOTE',
    FreeSoapNote: 'FREE_SOAP_NOTE',
    TreatmentPlan: 'TREATMENT_PLAN',
    PsychiatricProgress: 'PSYCHIATRIC_PROGRESS',
    InitialPsychotherapy: 'INITIAL_PSYCHOTHERAPY',
    PsychiatricInitialVisitNote: 'PSYCHIATRIC_INITIAL_VISIT_NOTE',
    PreoperativeNote: 'PREOPERATIVE_NOTE',
    PsychodynamicTherapyNote: 'PSYCHODYNAMIC_THERAPY_NOTE',
    PsychotherapyNote: 'PSYCHOTHERAPY_NOTE',
    CollaborativeCareModel: 'COLLABORATIVE_CARE_MODEL',
    PsychoeducationTherapy: 'PSYCHOEDUCATION_THERAPY',
    DapNote: 'DAP_NOTE',
    BirpNote: 'BIRP_NOTE',
    ProgressNote: 'PROGRESS_NOTE',
    PremierMdInitialF2F: 'PREMIER_MD_INITIAL_F2F',
    PremierMdReadmissionF2F: 'PREMIER_MD_READMISSION_F2F',
    PremierMdRecertificationF2F: 'PREMIER_MD_RECERTIFICATION_F2F',
    PremierMdRocF2F: 'PREMIER_MD_ROC_F2F',
    PremierMdFollowUpF2F: 'PREMIER_MD_FOLLOW_UP_F2F',
    PremierMd30DayF2F: 'PREMIER_MD_30_DAY_F2F',
    PremierMdInitialTelehealth: 'PREMIER_MD_INITIAL_TELEHEALTH',
    PremierMdReadmissionTelehealth: 'PREMIER_MD_READMISSION_TELEHEALTH',
    PremierMdRecertificationTelehealth: 'PREMIER_MD_RECERTIFICATION_TELEHEALTH',
    PremierMdRocTelehealth: 'PREMIER_MD_ROC_TELEHEALTH',
    PremierMd30DayTelehealth: 'PREMIER_MD_30_DAY_TELEHEALTH',
    PremierMdCognitiveVisit: 'PREMIER_MD_COGNITIVE_VISIT',
    PremierMdLabsCommNote: 'PREMIER_MD_LABS_COMM_NOTE'
} as const;

export type ClinicalNotesDTONoteTypeEnum = typeof ClinicalNotesDTONoteTypeEnum[keyof typeof ClinicalNotesDTONoteTypeEnum];

/**
 * 
 * @export
 * @interface ClinicalNotesSaveRequest
 */
export interface ClinicalNotesSaveRequest {
    /**
     * 
     * @type {ClinicalNotesDTO}
     * @memberof ClinicalNotesSaveRequest
     */
    'data'?: ClinicalNotesDTO;
    /**
     * 
     * @type {string}
     * @memberof ClinicalNotesSaveRequest
     */
    'patientId'?: string;
    /**
     * 
     * @type {string}
     * @memberof ClinicalNotesSaveRequest
     */
    'appointmentId'?: string;
    /**
     * 
     * @type {string}
     * @memberof ClinicalNotesSaveRequest
     */
    'noteType'?: ClinicalNotesSaveRequestNoteTypeEnum;
}

export const ClinicalNotesSaveRequestNoteTypeEnum = {
    SimpleSoapNote: 'SIMPLE_SOAP_NOTE',
    PsychiatricNote: 'PSYCHIATRIC_NOTE',
    PrimaryCareSoapNote: 'PRIMARY_CARE_SOAP_NOTE',
    FreeSoapNote: 'FREE_SOAP_NOTE',
    TreatmentPlan: 'TREATMENT_PLAN',
    PsychiatricProgress: 'PSYCHIATRIC_PROGRESS',
    InitialPsychotherapy: 'INITIAL_PSYCHOTHERAPY',
    PsychiatricInitialVisitNote: 'PSYCHIATRIC_INITIAL_VISIT_NOTE',
    PreoperativeNote: 'PREOPERATIVE_NOTE',
    PsychodynamicTherapyNote: 'PSYCHODYNAMIC_THERAPY_NOTE',
    PsychotherapyNote: 'PSYCHOTHERAPY_NOTE',
    CollaborativeCareModel: 'COLLABORATIVE_CARE_MODEL',
    PsychoeducationTherapy: 'PSYCHOEDUCATION_THERAPY',
    DapNote: 'DAP_NOTE',
    BirpNote: 'BIRP_NOTE',
    ProgressNote: 'PROGRESS_NOTE',
    PremierMdInitialF2F: 'PREMIER_MD_INITIAL_F2F',
    PremierMdReadmissionF2F: 'PREMIER_MD_READMISSION_F2F',
    PremierMdRecertificationF2F: 'PREMIER_MD_RECERTIFICATION_F2F',
    PremierMdRocF2F: 'PREMIER_MD_ROC_F2F',
    PremierMdFollowUpF2F: 'PREMIER_MD_FOLLOW_UP_F2F',
    PremierMd30DayF2F: 'PREMIER_MD_30_DAY_F2F',
    PremierMdInitialTelehealth: 'PREMIER_MD_INITIAL_TELEHEALTH',
    PremierMdReadmissionTelehealth: 'PREMIER_MD_READMISSION_TELEHEALTH',
    PremierMdRecertificationTelehealth: 'PREMIER_MD_RECERTIFICATION_TELEHEALTH',
    PremierMdRocTelehealth: 'PREMIER_MD_ROC_TELEHEALTH',
    PremierMd30DayTelehealth: 'PREMIER_MD_30_DAY_TELEHEALTH',
    PremierMdCognitiveVisit: 'PREMIER_MD_COGNITIVE_VISIT',
    PremierMdLabsCommNote: 'PREMIER_MD_LABS_COMM_NOTE'
} as const;

export type ClinicalNotesSaveRequestNoteTypeEnum = typeof ClinicalNotesSaveRequestNoteTypeEnum[keyof typeof ClinicalNotesSaveRequestNoteTypeEnum];

/**
 * 
 * @export
 * @interface ClinicalSummaryLinkRequest
 */
export interface ClinicalSummaryLinkRequest {
    /**
     * 
     * @type {string}
     * @memberof ClinicalSummaryLinkRequest
     */
    'clinicalSummaryType': ClinicalSummaryLinkRequestClinicalSummaryTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof ClinicalSummaryLinkRequest
     */
    'recordId': string;
    /**
     * 
     * @type {string}
     * @memberof ClinicalSummaryLinkRequest
     */
    'appointmentId': string;
    /**
     * 
     * @type {string}
     * @memberof ClinicalSummaryLinkRequest
     */
    'historyType'?: ClinicalSummaryLinkRequestHistoryTypeEnum;
}

export const ClinicalSummaryLinkRequestClinicalSummaryTypeEnum = {
    Allergies: 'ALLERGIES',
    Medication: 'MEDICATION',
    Vaccine: 'VACCINE',
    Careplan: 'CAREPLAN',
    History: 'HISTORY',
    Vitals: 'VITALS'
} as const;

export type ClinicalSummaryLinkRequestClinicalSummaryTypeEnum = typeof ClinicalSummaryLinkRequestClinicalSummaryTypeEnum[keyof typeof ClinicalSummaryLinkRequestClinicalSummaryTypeEnum];
export const ClinicalSummaryLinkRequestHistoryTypeEnum = {
    MedicalHistory: 'MEDICAL_HISTORY',
    SurgicalHistory: 'SURGICAL_HISTORY',
    FamilyHistory: 'FAMILY_HISTORY'
} as const;

export type ClinicalSummaryLinkRequestHistoryTypeEnum = typeof ClinicalSummaryLinkRequestHistoryTypeEnum[keyof typeof ClinicalSummaryLinkRequestHistoryTypeEnum];

/**
 * 
 * @export
 * @interface ContactDictionary
 */
export interface ContactDictionary {
    /**
     * 
     * @type {string}
     * @memberof ContactDictionary
     */
    'uuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof ContactDictionary
     */
    'firstName': string;
    /**
     * 
     * @type {string}
     * @memberof ContactDictionary
     */
    'lastName': string;
    /**
     * 
     * @type {string}
     * @memberof ContactDictionary
     */
    'fullName'?: string;
    /**
     * 
     * @type {string}
     * @memberof ContactDictionary
     */
    'contactNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof ContactDictionary
     */
    'faxNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof ContactDictionary
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof ContactDictionary
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof ContactDictionary
     */
    'contactType'?: ContactDictionaryContactTypeEnum;
    /**
     * 
     * @type {boolean}
     * @memberof ContactDictionary
     */
    'active'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ContactDictionary
     */
    'archive'?: boolean;
    /**
     * 
     * @type {Address}
     * @memberof ContactDictionary
     */
    'address'?: Address;
    /**
     * 
     * @type {string}
     * @memberof ContactDictionary
     */
    'userUuid'?: string;
}

export const ContactDictionaryContactTypeEnum = {
    Lab: 'LAB',
    Clinic: 'CLINIC',
    Vendor: 'VENDOR',
    Pharmacy: 'PHARMACY',
    Provider: 'PROVIDER',
    Staff: 'STAFF',
    Patient: 'PATIENT',
    Other: 'OTHER',
    InsurancePayer: 'INSURANCE_PAYER'
} as const;

export type ContactDictionaryContactTypeEnum = typeof ContactDictionaryContactTypeEnum[keyof typeof ContactDictionaryContactTypeEnum];

/**
 * 
 * @export
 * @interface Content
 */
export interface Content {
    /**
     * 
     * @type {string}
     * @memberof Content
     */
    'patientInstructions'?: string;
    /**
     * 
     * @type {string}
     * @memberof Content
     */
    'recommendations'?: string;
}
/**
 * 
 * @export
 * @interface Conversation
 */
export interface Conversation {
    /**
     * 
     * @type {string}
     * @memberof Conversation
     */
    'uuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof Conversation
     */
    'participant1'?: string;
    /**
     * 
     * @type {string}
     * @memberof Conversation
     */
    'senderName'?: string;
    /**
     * 
     * @type {string}
     * @memberof Conversation
     */
    'participant2'?: string;
    /**
     * 
     * @type {string}
     * @memberof Conversation
     */
    'receiverName'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Conversation
     */
    'archive'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Conversation
     */
    'participant2Provider'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Conversation
     */
    'participant1Provider'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof Conversation
     */
    'unReadSmsCount'?: number;
    /**
     * 
     * @type {string}
     * @memberof Conversation
     */
    'lastSms'?: string;
    /**
     * 
     * @type {string}
     * @memberof Conversation
     */
    'lastSmsTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof Conversation
     */
    'patientDob'?: string;
    /**
     * 
     * @type {string}
     * @memberof Conversation
     */
    'patientGender'?: ConversationPatientGenderEnum;
    /**
     * 
     * @type {boolean}
     * @memberof Conversation
     */
    'receiverActive'?: boolean;
}

export const ConversationPatientGenderEnum = {
    Male: 'MALE',
    Female: 'FEMALE',
    Unknown: 'UNKNOWN',
    Other: 'OTHER'
} as const;

export type ConversationPatientGenderEnum = typeof ConversationPatientGenderEnum[keyof typeof ConversationPatientGenderEnum];

/**
 * 
 * @export
 * @interface CreatePatientDto
 */
export interface CreatePatientDto {
    /**
     * 
     * @type {string}
     * @memberof CreatePatientDto
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreatePatientDto
     */
    'first_name': string;
    /**
     * 
     * @type {string}
     * @memberof CreatePatientDto
     */
    'last_name': string;
    /**
     * 
     * @type {string}
     * @memberof CreatePatientDto
     */
    'date_of_birth'?: string;
}
/**
 * 
 * @export
 * @interface CreateTranscriptionRequest
 */
export interface CreateTranscriptionRequest {
    /**
     * 
     * @type {File}
     * @memberof CreateTranscriptionRequest
     */
    'file': File;
}
/**
 * 
 * @export
 * @interface CustomForm
 */
export interface CustomForm {
    /**
     * 
     * @type {string}
     * @memberof CustomForm
     */
    'uuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomForm
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof CustomForm
     */
    'content': string;
    /**
     * 
     * @type {boolean}
     * @memberof CustomForm
     */
    'active'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CustomForm
     */
    'formType'?: CustomFormFormTypeEnum;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof CustomForm
     */
    'specialities'?: { [key: string]: string; };
    /**
     * 
     * @type {boolean}
     * @memberof CustomForm
     */
    'archive'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CustomForm
     */
    'modifiedDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomForm
     */
    'createdBy'?: string;
    /**
     * 
     * @type {number}
     * @memberof CustomForm
     */
    'version'?: number;
}

export const CustomFormFormTypeEnum = {
    CustomQuestionnaire: 'CUSTOM_QUESTIONNAIRE',
    VisitNotes: 'VISIT_NOTES',
    ReviewOfSystem: 'REVIEW_OF_SYSTEM',
    PhysicalExam: 'PHYSICAL_EXAM',
    Micros: 'MICROS',
    AnnotableImage: 'ANNOTABLE_IMAGE',
    Email: 'EMAIL',
    Sms: 'SMS',
    OrderSet: 'ORDER_SET',
    IntakeForm: 'INTAKE_FORM',
    ConsentForm: 'CONSENT_FORM'
} as const;

export type CustomFormFormTypeEnum = typeof CustomFormFormTypeEnum[keyof typeof CustomFormFormTypeEnum];

/**
 * 
 * @export
 * @interface CustomFormTemplate
 */
export interface CustomFormTemplate {
    /**
     * 
     * @type {string}
     * @memberof CustomFormTemplate
     */
    'uuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomFormTemplate
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof CustomFormTemplate
     */
    'content'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CustomFormTemplate
     */
    'active'?: boolean;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof CustomFormTemplate
     */
    'specialities'?: { [key: string]: string; };
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof CustomFormTemplate
     */
    'customForm'?: { [key: string]: string; };
    /**
     * 
     * @type {boolean}
     * @memberof CustomFormTemplate
     */
    'archive'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CustomFormTemplate
     */
    'modifiedDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomFormTemplate
     */
    'createdBy'?: string;
    /**
     * 
     * @type {number}
     * @memberof CustomFormTemplate
     */
    'version'?: number;
    /**
     * 
     * @type {string}
     * @memberof CustomFormTemplate
     */
    'formType'?: CustomFormTemplateFormTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof CustomFormTemplate
     */
    'emailSmsTemplateId'?: string;
}

export const CustomFormTemplateFormTypeEnum = {
    CustomQuestionnaire: 'CUSTOM_QUESTIONNAIRE',
    VisitNotes: 'VISIT_NOTES',
    ReviewOfSystem: 'REVIEW_OF_SYSTEM',
    PhysicalExam: 'PHYSICAL_EXAM',
    Micros: 'MICROS',
    AnnotableImage: 'ANNOTABLE_IMAGE',
    Email: 'EMAIL',
    Sms: 'SMS',
    OrderSet: 'ORDER_SET',
    IntakeForm: 'INTAKE_FORM',
    ConsentForm: 'CONSENT_FORM'
} as const;

export type CustomFormTemplateFormTypeEnum = typeof CustomFormTemplateFormTypeEnum[keyof typeof CustomFormTemplateFormTypeEnum];

/**
 * 
 * @export
 * @interface DEAInformation
 */
export interface DEAInformation {
    /**
     * 
     * @type {string}
     * @memberof DEAInformation
     */
    'uuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof DEAInformation
     */
    'deaState'?: string;
    /**
     * 
     * @type {string}
     * @memberof DEAInformation
     */
    'deaNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof DEAInformation
     */
    'deaTermDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof DEAInformation
     */
    'deaActiveDate'?: string;
}
/**
 * 
 * @export
 * @interface DaySlot
 */
export interface DaySlot {
    /**
     * 
     * @type {string}
     * @memberof DaySlot
     */
    'day'?: DaySlotDayEnum;
    /**
     * 
     * @type {LocalTime}
     * @memberof DaySlot
     */
    'startTime'?: LocalTime;
    /**
     * 
     * @type {LocalTime}
     * @memberof DaySlot
     */
    'endTime'?: LocalTime;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof DaySlot
     */
    'location'?: { [key: string]: string; };
    /**
     * 
     * @type {string}
     * @memberof DaySlot
     */
    'availabilityMode'?: DaySlotAvailabilityModeEnum;
}

export const DaySlotDayEnum = {
    Monday: 'MONDAY',
    Tuesday: 'TUESDAY',
    Wednesday: 'WEDNESDAY',
    Thursday: 'THURSDAY',
    Friday: 'FRIDAY',
    Saturday: 'SATURDAY',
    Sunday: 'SUNDAY'
} as const;

export type DaySlotDayEnum = typeof DaySlotDayEnum[keyof typeof DaySlotDayEnum];
export const DaySlotAvailabilityModeEnum = {
    InPerson: 'IN_PERSON',
    Virtual: 'VIRTUAL'
} as const;

export type DaySlotAvailabilityModeEnum = typeof DaySlotAvailabilityModeEnum[keyof typeof DaySlotAvailabilityModeEnum];

/**
 * 
 * @export
 * @interface DefaultAssessment
 */
export interface DefaultAssessment {
    /**
     * 
     * @type {string}
     * @memberof DefaultAssessment
     */
    'uuid'?: string;
    /**
     * 
     * @type {object}
     * @memberof DefaultAssessment
     */
    'assessments'?: object;
}
/**
 * 
 * @export
 * @interface Department
 */
export interface Department {
    /**
     * 
     * @type {string}
     * @memberof Department
     */
    'uuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof Department
     */
    'deptId'?: string;
    /**
     * 
     * @type {string}
     * @memberof Department
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof Department
     */
    'adminName'?: string;
    /**
     * 
     * @type {string}
     * @memberof Department
     */
    'adminId'?: string;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof Department
     */
    'workLocations'?: { [key: string]: string; };
    /**
     * 
     * @type {string}
     * @memberof Department
     */
    'contact'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Department
     */
    'active'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Department
     */
    'archive'?: boolean;
}
/**
 * 
 * @export
 * @interface DocumentTag
 */
export interface DocumentTag {
    /**
     * 
     * @type {string}
     * @memberof DocumentTag
     */
    'uuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof DocumentTag
     */
    'tag': string;
    /**
     * 
     * @type {boolean}
     * @memberof DocumentTag
     */
    'active'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DocumentTag
     */
    'archive'?: boolean;
}
/**
 * 
 * @export
 * @interface EmailSmsTemplate
 */
export interface EmailSmsTemplate {
    /**
     * 
     * @type {string}
     * @memberof EmailSmsTemplate
     */
    'uuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof EmailSmsTemplate
     */
    'templateName'?: string;
    /**
     * 
     * @type {string}
     * @memberof EmailSmsTemplate
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof EmailSmsTemplate
     */
    'subject'?: string;
    /**
     * 
     * @type {string}
     * @memberof EmailSmsTemplate
     */
    'templateTypes'?: EmailSmsTemplateTemplateTypesEnum;
    /**
     * 
     * @type {boolean}
     * @memberof EmailSmsTemplate
     */
    'active'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof EmailSmsTemplate
     */
    'archive'?: boolean;
}

export const EmailSmsTemplateTemplateTypesEnum = {
    Email: 'EMAIL',
    Sms: 'SMS',
    Ros: 'ROS',
    Physical: 'PHYSICAL',
    Macros: 'MACROS',
    CarePlan: 'CARE_PLAN',
    HomeCareRos: 'HOME_CARE_ROS',
    HomeCarePe: 'HOME_CARE_PE'
} as const;

export type EmailSmsTemplateTemplateTypesEnum = typeof EmailSmsTemplateTemplateTypesEnum[keyof typeof EmailSmsTemplateTemplateTypesEnum];

/**
 * 
 * @export
 * @interface EmailToPatient
 */
export interface EmailToPatient {
    /**
     * 
     * @type {Array<string>}
     * @memberof EmailToPatient
     */
    'patientUuids'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof EmailToPatient
     */
    'subject'?: string;
    /**
     * 
     * @type {string}
     * @memberof EmailToPatient
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof EmailToPatient
     */
    'claimUuid'?: string;
}
/**
 * 
 * @export
 * @interface EmailVerificationRequest
 */
export interface EmailVerificationRequest {
    /**
     * 
     * @type {string}
     * @memberof EmailVerificationRequest
     */
    'email'?: string;
}
/**
 * 
 * @export
 * @interface EmergencyContact
 */
export interface EmergencyContact {
    /**
     * 
     * @type {string}
     * @memberof EmergencyContact
     */
    'uuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof EmergencyContact
     */
    'firstName'?: string;
    /**
     * 
     * @type {string}
     * @memberof EmergencyContact
     */
    'lastName'?: string;
    /**
     * 
     * @type {string}
     * @memberof EmergencyContact
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof EmergencyContact
     */
    'mobile'?: string;
    /**
     * 
     * @type {string}
     * @memberof EmergencyContact
     */
    'relationshipWithPatient'?: EmergencyContactRelationshipWithPatientEnum;
}

export const EmergencyContactRelationshipWithPatientEnum = {
    Self: 'SELF',
    Associate: 'ASSOCIATE',
    Brother: 'BROTHER',
    CareGiver: 'CARE_GIVER',
    Child: 'CHILD',
    EmergencyContact: 'EMERGENCY_CONTACT',
    Employee: 'EMPLOYEE',
    Employer: 'EMPLOYER',
    ExtendedFamily: 'EXTENDED_FAMILY',
    Father: 'FATHER',
    FosterChild: 'FOSTER_CHILD',
    Friend: 'FRIEND',
    Grandchild: 'GRANDCHILD',
    Grandparent: 'GRANDPARENT',
    Guardian: 'GUARDIAN',
    HandicappedDependent: 'HANDICAPPED_DEPENDENT',
    LifePartner: 'LIFE_PARTNER',
    Manager: 'MANAGER',
    Mother: 'MOTHER',
    NaturalChild: 'NATURAL_CHILD',
    None: 'NONE',
    Other: 'OTHER',
    OtherAdult: 'OTHER_ADULT',
    Owner: 'OWNER',
    Parent: 'PARENT',
    Sibling: 'SIBLING',
    Sister: 'SISTER',
    Spouse: 'SPOUSE',
    Stepchild: 'STEPCHILD',
    Trainer: 'TRAINER',
    Unknown: 'UNKNOWN',
    WardOfCourt: 'WARD_OF_COURT'
} as const;

export type EmergencyContactRelationshipWithPatientEnum = typeof EmergencyContactRelationshipWithPatientEnum[keyof typeof EmergencyContactRelationshipWithPatientEnum];

/**
 * 
 * @export
 * @interface EncounterAddendum
 */
export interface EncounterAddendum {
    /**
     * 
     * @type {string}
     * @memberof EncounterAddendum
     */
    'addendumText': string;
    /**
     * 
     * @type {string}
     * @memberof EncounterAddendum
     */
    'providerSignature': string;
}
/**
 * 
 * @export
 * @interface EncounterSignOff
 */
export interface EncounterSignOff {
    /**
     * 
     * @type {string}
     * @memberof EncounterSignOff
     */
    'providerId'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSignOff
     */
    'provider'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSignOff
     */
    'providerNote'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSignOff
     */
    'providerSignature'?: string;
}
/**
 * 
 * @export
 * @interface EncounterSumary
 */
export interface EncounterSumary {
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'uuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'appointmentId'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'followUp'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'instruction'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'hpi'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'chiefComplaint'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'problems'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'habits'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'carePlan'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof EncounterSumary
     */
    'archive'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'encounterStatus'?: EncounterSumaryEncounterStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'formType'?: EncounterSumaryFormTypeEnum;
    /**
     * 
     * @type {{ [key: string]: object; }}
     * @memberof EncounterSumary
     */
    'noteContent'?: { [key: string]: object; };
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'clockDrawingUrl'?: string;
    /**
     * 
     * @type {Set<Patientallergy>}
     * @memberof EncounterSumary
     */
    'patientAllergies'?: Set<Patientallergy>;
    /**
     * 
     * @type {Set<TherapyNote>}
     * @memberof EncounterSumary
     */
    'therapyNotes'?: Set<TherapyNote>;
    /**
     * 
     * @type {Set<CarePlan>}
     * @memberof EncounterSumary
     */
    'carePlans'?: Set<CarePlan>;
    /**
     * 
     * @type {Set<FamilyHistory>}
     * @memberof EncounterSumary
     */
    'familyHistories'?: Set<FamilyHistory>;
    /**
     * 
     * @type {Set<MedicalHistory>}
     * @memberof EncounterSumary
     */
    'medicalHistories'?: Set<MedicalHistory>;
    /**
     * 
     * @type {Set<SurgicalHistory>}
     * @memberof EncounterSumary
     */
    'surgicalHistory'?: Set<SurgicalHistory>;
    /**
     * 
     * @type {Set<PatientVital>}
     * @memberof EncounterSumary
     */
    'patientVitals'?: Set<PatientVital>;
    /**
     * 
     * @type {Set<PatientMedication>}
     * @memberof EncounterSumary
     */
    'patientMedications'?: Set<PatientMedication>;
    /**
     * 
     * @type {{ [key: string]: ScreenerQuestionAnswerScoreResponse; }}
     * @memberof EncounterSumary
     */
    'patientQuestionAnswers'?: { [key: string]: ScreenerQuestionAnswerScoreResponse; };
    /**
     * 
     * @type {Array<PhysicalROSTemplate>}
     * @memberof EncounterSumary
     */
    'rosTemplates'?: Array<PhysicalROSTemplate>;
    /**
     * 
     * @type {Array<PhysicalROSTemplate>}
     * @memberof EncounterSumary
     */
    'physicalTemplates'?: Array<PhysicalROSTemplate>;
    /**
     * 
     * @type {Set<RosTemplate>}
     * @memberof EncounterSumary
     */
    'carePlanTemplates'?: Set<RosTemplate>;
    /**
     * 
     * @type {Set<ProcedureCode>}
     * @memberof EncounterSumary
     */
    'procedureCodes'?: Set<ProcedureCode>;
    /**
     * 
     * @type {Set<AssessmentCode>}
     * @memberof EncounterSumary
     */
    'assessmentCodes'?: Set<AssessmentCode>;
    /**
     * 
     * @type {Set<PatientVaccine>}
     * @memberof EncounterSumary
     */
    'patientVaccines'?: Set<PatientVaccine>;
    /**
     * 
     * @type {Set<PatientOrder>}
     * @memberof EncounterSumary
     */
    'patientOrders'?: Set<PatientOrder>;
    /**
     * 
     * @type {{ [key: string]: Array<PatientQuestionAnswer>; }}
     * @memberof EncounterSumary
     */
    'patientSocialHistory'?: { [key: string]: Array<PatientQuestionAnswer>; };
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'patientId'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'providerId'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'providerName'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'providerSignature'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'providerNote'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'tx'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'subjectiveFreeNote'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'subjectiveChiefComplaint'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'overallMseNote'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'objectiveFreeNote'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'note'?: string;
    /**
     * 
     * @type {Set<PrescriptionForm>}
     * @memberof EncounterSumary
     */
    'patientPrescriptionForms'?: Set<PrescriptionForm>;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'providerGroupName'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'providerGroupPhone'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'providerGroupNpi'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'providerGroupEmail'?: string;
    /**
     * 
     * @type {Address}
     * @memberof EncounterSumary
     */
    'providerGroupAddress'?: Address;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'patientName'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'encounterDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'appointmentDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'patientDob'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'encounterType'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'relationshipToInsured'?: EncounterSumaryRelationshipToInsuredEnum;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'insuranceName'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'visitNote'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'assessmentFreeNote'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'planFreeNote'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'allergyFreeText'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'presentingProblem'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'treatmentGoal'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'treatmentStrategy'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'estimateCompletionOfTreatmentGoal'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'frequencyOfTreatment'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'estimateCompletionOfTreatmentStrategy'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'dateOfProcedure'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'nameOfConsultant'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'attendingPhysician'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'historyOfPresentIllness'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'pastPsychodynamicHistory'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'pastPsychodynamicHistoryNote'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'psychMedicalHistory'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'psychMedicalHistoryNote'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'substanceUseHistory'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'substanceUseHistoryNote'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'familyPsychiatricHistory'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'familyPsychiatricHistoryNote'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'socialHistory'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'socialHistoryNote'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'appearanceNote'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'behaviorNote'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'speechNote'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'cooperativeness'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'cooperativenessNote'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'moodAffectNote'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'thoughtProcessNote'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'intellectualFunctioning'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'intellectualFunctioningNote'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'thoughtContentNote'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'perceptionNote'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'cognitionNote'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'insightNote'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'judgment'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'judgmentNote'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'riskLevel'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'riskLevelNote'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof EncounterSumary
     */
    'agreedToTreatmentPlan'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'treatment'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'futureConsiderations'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'labStudy'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'referrals'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'collateral'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'safety'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'appearance'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'behavior'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'speech'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'mood'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'affect'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'affectCongruence'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'thoughtProcess'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'perceptions'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'cognition'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'therapy'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'insightJudgment'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'patientIdVerificationMethod'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'safetyAssessmentSuicideRisk'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'studiesScansLabworkReview'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'psychiatricEvolutionPlanReview'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'clinicalInstructionsReview'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'noteForSendPatientForms'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'otherFormsProvided'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'otherRequestsNote'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'mentalHealthScreeningDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'interimDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'updateWeightDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'individualTreatmentTherapyRequirements'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'patientGoals'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'weightLossTherapiesOption'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'weightLossTherapiesDescription'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'weightLossTherapiesDuration'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'weightLossTherapiesDurationDescription'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof EncounterSumary
     */
    'agreedToPsychiatricEvolutionplanOne'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof EncounterSumary
     */
    'agreedToPsychiatricEvolutionplanTwo'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof EncounterSumary
     */
    'agreedToPsychiatricEvolutionplanThree'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof EncounterSumary
     */
    'agreedToPsychiatricEvolutionplanFour'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof EncounterSumary
     */
    'agreedToClinicalInstructionsplanOne'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof EncounterSumary
     */
    'agreedToClinicalInstructionsplanTwo'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof EncounterSumary
     */
    'agreedToClinicalInstructionsplanThree'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof EncounterSumary
     */
    'agreedToClinicalInstructionsplanFour'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof EncounterSumary
     */
    'agreedToClinicalInstructionsplanFive'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof EncounterSumary
     */
    'agreedToAdjunctTherapyRecommendationsOne'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof EncounterSumary
     */
    'agreedToAdjunctTherapyRecommendationsTwo'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof EncounterSumary
     */
    'agreedToAdjunctTherapyRecommendationsThree'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof EncounterSumary
     */
    'agreedToAdjunctTherapyRecommendationsFour'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof EncounterSumary
     */
    'agreedToAdjunctTherapyRecommendationsFive'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof EncounterSumary
     */
    'agreedToAdjunctTherapyRecommendationsSix'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof EncounterSumary
     */
    'agreedToAdjunctTherapyRecommendationsSeven'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof EncounterSumary
     */
    'agreedToAdjunctTherapyRecommendationsEight'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof EncounterSumary
     */
    'parentCars2Screening'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof EncounterSumary
     */
    'medAgreementPeds'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof EncounterSumary
     */
    'controlledSubstanceConsent'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof EncounterSumary
     */
    'stimulantAgreement'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof EncounterSumary
     */
    'schoolMedAuth'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof EncounterSumary
     */
    'loaForm'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof EncounterSumary
     */
    'esa'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof EncounterSumary
     */
    'labOrder'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof EncounterSumary
     */
    'insuranceUpdate'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof EncounterSumary
     */
    'weightLossContract'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof EncounterSumary
     */
    'naFormProvided'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof EncounterSumary
     */
    'accommodationsAtWork'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof EncounterSumary
     */
    'accommodationsAtSchool'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof EncounterSumary
     */
    'other'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof EncounterSumary
     */
    'form504Iep'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'sessionDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'duration'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'materialBroughtToSession'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'sessionFocus'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'primaryModality'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'thoughtContent'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'insight'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'freeAssociations'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'dreamContent'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'dreamAnalysis'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'transferenceObservations'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'counterTransferenceReflections'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'unconsciousConflictsExplored'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'earlyChildhoodExperiences'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'relationalPatterns'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'interpretationsOffered'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'clientResponseToInterpretations'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'walkingThroughProcess'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'insightsDeveloped'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'therapeuticRelationship'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'progressTowardTreatmentGoal'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'clinicalImpression'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'planForNextSession'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'riskAssessment'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'suicideRisk'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'homicideRisk'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'timeSpend'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'documentationTime'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof EncounterSumary
     */
    'billable'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'defenseMechanismObserved'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'presentingConcerns'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'acceptanceWork'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'cognitiveDefusion'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'presentMomentAwareness'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'selfAsContext'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'valueClarification'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'commitedAction'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'interventionsUsed'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'clientReponseToInterventins'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'homeworkAssigned'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'automaticThoughtsIdentified'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'cognitiveDistortionsIdentified'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'behavioralExperimentsExposureWork'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'dialecticalStrategiesUsed'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'mindfulnessExercises'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'distressToleranceSkills'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'emotionRegulationSkills'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'interpersonalEffectivenessSkills'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'presentingConcernsToday'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'sessionType'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'patientEngagement'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'guardianParentName'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'relationship'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'mobileNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'selectedInterventions'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'sessionFocusContent'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'patientResponseToTreatment'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'nextAppointmentDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'sessionFrequency'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'coordinationNeeded'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'clinicalImpressions'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'treatmentGoalsProgress'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'primaryTopic'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'learningObjectives'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'contentDelivered'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'skillsCategoriesCovered'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'skillsDescription'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'materialsDistributed'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'materialDetails'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'engagementLevel'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'comprehensionLevel'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'questionsDiscussion'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'participantFeedback'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'inSessionPractice'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'homePracticeAssignments'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'realLifeApplicationPlan'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'followUpTopics'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'additionalResourcesNeeded'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'nextSessionPlan'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'psychoeducationProviderNote'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'primaryDiagnosis'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'secondaryDiagnoses'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'targetSymptom'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'measurementTool'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'currentProgress'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'currentPsychiatricMedications'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'medicationChangesThisVisit'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'sideEffectsReported'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'adherenceIssuesOrBarriers'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'behavioralActivation'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'psychoeducationProvided'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'problemSolving'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'relapsePrevention'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'pcpCommunication'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'specialtyReferrals'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'communityResources'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'familyCaregiverInvolvement'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'suicidalIdeation'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'homicidalIdeation'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'overallRiskLevel'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'safetyPlanStatus'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'treatmentPlanChanges'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'barriersToTreatment'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'nextStepsAndActionItems'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof EncounterSumary
     */
    'psychiatricConsultationNeeded'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'reasonForConsultation'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'urgencyLevel'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'preferredFutureGoals'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'miracleQuestionResponse'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'exceptionsIdentified'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'copingQuestions'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'whatsAlreadyWorking'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'scalingQuestionUsed'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'currentRating'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'previousSessionRating'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'indicatorsOfProgress'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'clientStrengthsAndResources'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'complimentsOffered'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'smallChangesNoticed'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'betweenSessionTasks'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'goalsSetForThisSession'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'progressTowardSessionGoals'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'clientResponseToSession'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'nextStepsActions'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'triggersIdentified'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'dissociativeAssessment'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'groundingTechniquesUsed'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'windowOfToleranceAssessment'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'emdrPhase'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'targetMemoryImage'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'negativeCognitionNc'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'positiveCognitionPc'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'vocValidityOfCognition'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'emotions'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'sudScale'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'bodySensationsLocations'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'desensitizationSetsProcessing'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'installationProcess'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'bodyScanResults'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'closure'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'traumaNarrativeWork'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'cognitiveProcessingOfTrauma'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'somaticBodyBasedInterventions'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'resourceInstallation'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'copingSkillsPracticed'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'stabilizationWork'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'safetyPlanning'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'progressTowardTraumaTreatmentGoals'?: string;
    /**
     * 
     * @type {PsychotherapyCbtVisitNote}
     * @memberof EncounterSumary
     */
    'psychotherapyCbtVisitNote'?: PsychotherapyCbtVisitNote;
    /**
     * 
     * @type {PsychotherapyDbtVisitNote}
     * @memberof EncounterSumary
     */
    'psychotherapyDbtVisitNote'?: PsychotherapyDbtVisitNote;
    /**
     * 
     * @type {PsychotherapyActVisitNote}
     * @memberof EncounterSumary
     */
    'psychotherapyActVisitNote'?: PsychotherapyActVisitNote;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'interventionFreeNote'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'responseFreeNote'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'behaviorFreeNote'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'therapeuticInterventions'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'therapeuticInterventionsNote'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'topicsAddressed'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'topicsAddressedNote'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'patientParticipation'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'patientParticipationNote'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'responseToIntervention'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'responseToInterventionNote'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'progress'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'dataFreeNote'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'interventionsProvided'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'interventionsProvidedNote'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'otherTherapeuticInterventionsNote'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'patientResponse'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'patientResponseNote'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'diagnosisJustification'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'mseOrientation'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'mseGeneralAppearance'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'mseDress'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'mseMotorActivity'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'mseInterviewBehavior'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'mseSpeech'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'mseMood'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'mseAffect'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'mseInsight'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'mseJudgmentImpulseControl'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'mseMemory'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'mseAttentionConcentration'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'mseThoughtProcess'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'mseThoughtContent'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'msePerception'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'mseFunctionalStatus'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'mseOverallNote'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof EncounterSumary
     */
    'riskDeniesAllAreas'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'riskLevelOfRisk'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'riskNeedToAct'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'riskPlanToAct'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'riskMeansToAct'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'riskFactors'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'riskProtectiveFactors'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'riskAdditionalDetails'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof EncounterSumary
     */
    'noCurrentMedications'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'medicationComments'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'interventionsUsedNote'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'otherInterventionsNote'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'assessmentAdditionalNotes'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'recommendation'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncounterSumary
     */
    'prescribedTreatmentFrequency'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof EncounterSumary
     */
    'psychoeducationSessionRequired'?: boolean;
}

export const EncounterSumaryEncounterStatusEnum = {
    Intake: 'INTAKE',
    Exam: 'EXAM',
    Checkout: 'CHECKOUT',
    Completed: 'COMPLETED'
} as const;

export type EncounterSumaryEncounterStatusEnum = typeof EncounterSumaryEncounterStatusEnum[keyof typeof EncounterSumaryEncounterStatusEnum];
export const EncounterSumaryFormTypeEnum = {
    SimpleSoapNote: 'SIMPLE_SOAP_NOTE',
    PsychiatricNote: 'PSYCHIATRIC_NOTE',
    PrimaryCareSoapNote: 'PRIMARY_CARE_SOAP_NOTE',
    FreeSoapNote: 'FREE_SOAP_NOTE',
    TreatmentPlan: 'TREATMENT_PLAN',
    PsychiatricProgress: 'PSYCHIATRIC_PROGRESS',
    InitialPsychotherapy: 'INITIAL_PSYCHOTHERAPY',
    PsychiatricInitialVisitNote: 'PSYCHIATRIC_INITIAL_VISIT_NOTE',
    PreoperativeNote: 'PREOPERATIVE_NOTE',
    PsychodynamicTherapyNote: 'PSYCHODYNAMIC_THERAPY_NOTE',
    PsychotherapyNote: 'PSYCHOTHERAPY_NOTE',
    CollaborativeCareModel: 'COLLABORATIVE_CARE_MODEL',
    PsychoeducationTherapy: 'PSYCHOEDUCATION_THERAPY',
    DapNote: 'DAP_NOTE',
    BirpNote: 'BIRP_NOTE',
    ProgressNote: 'PROGRESS_NOTE',
    PremierMdInitialF2F: 'PREMIER_MD_INITIAL_F2F',
    PremierMdReadmissionF2F: 'PREMIER_MD_READMISSION_F2F',
    PremierMdRecertificationF2F: 'PREMIER_MD_RECERTIFICATION_F2F',
    PremierMdRocF2F: 'PREMIER_MD_ROC_F2F',
    PremierMdFollowUpF2F: 'PREMIER_MD_FOLLOW_UP_F2F',
    PremierMd30DayF2F: 'PREMIER_MD_30_DAY_F2F',
    PremierMdInitialTelehealth: 'PREMIER_MD_INITIAL_TELEHEALTH',
    PremierMdReadmissionTelehealth: 'PREMIER_MD_READMISSION_TELEHEALTH',
    PremierMdRecertificationTelehealth: 'PREMIER_MD_RECERTIFICATION_TELEHEALTH',
    PremierMdRocTelehealth: 'PREMIER_MD_ROC_TELEHEALTH',
    PremierMd30DayTelehealth: 'PREMIER_MD_30_DAY_TELEHEALTH',
    PremierMdCognitiveVisit: 'PREMIER_MD_COGNITIVE_VISIT',
    PremierMdLabsCommNote: 'PREMIER_MD_LABS_COMM_NOTE'
} as const;

export type EncounterSumaryFormTypeEnum = typeof EncounterSumaryFormTypeEnum[keyof typeof EncounterSumaryFormTypeEnum];
export const EncounterSumaryRelationshipToInsuredEnum = {
    Self: 'SELF',
    Associate: 'ASSOCIATE',
    CareGiver: 'CARE_GIVER',
    Child: 'CHILD',
    EmergencyContact: 'EMERGENCY_CONTACT',
    Employee: 'EMPLOYEE',
    Employer: 'EMPLOYER',
    ExtendedFamily: 'EXTENDED_FAMILY',
    Father: 'FATHER',
    FosterChild: 'FOSTER_CHILD',
    Friend: 'FRIEND',
    Grandchild: 'GRANDCHILD',
    Grandparent: 'GRANDPARENT',
    Guardian: 'GUARDIAN',
    HandicappedDependent: 'HANDICAPPED_DEPENDENT',
    LifePartner: 'LIFE_PARTNER',
    Manager: 'MANAGER',
    Mother: 'MOTHER',
    NaturalChild: 'NATURAL_CHILD',
    None: 'NONE',
    Other: 'OTHER',
    OtherAdult: 'OTHER_ADULT',
    Owner: 'OWNER',
    Parent: 'PARENT',
    Sibling: 'SIBLING',
    Sister: 'SISTER',
    Spouse: 'SPOUSE',
    Stepchild: 'STEPCHILD',
    Trainer: 'TRAINER',
    Unknown: 'UNKNOWN',
    WardOfCourt: 'WARD_OF_COURT'
} as const;

export type EncounterSumaryRelationshipToInsuredEnum = typeof EncounterSumaryRelationshipToInsuredEnum[keyof typeof EncounterSumaryRelationshipToInsuredEnum];

/**
 * 
 * @export
 * @interface EobClaimPayment
 */
export interface EobClaimPayment {
    /**
     * 
     * @type {string}
     * @memberof EobClaimPayment
     */
    'claimUuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof EobClaimPayment
     */
    'paidAs'?: EobClaimPaymentPaidAsEnum;
    /**
     * 
     * @type {string}
     * @memberof EobClaimPayment
     */
    'dateOfService'?: string;
    /**
     * 
     * @type {string}
     * @memberof EobClaimPayment
     */
    'providerName'?: string;
    /**
     * 
     * @type {string}
     * @memberof EobClaimPayment
     */
    'payerName'?: string;
    /**
     * 
     * @type {number}
     * @memberof EobClaimPayment
     */
    'totalCharge'?: number;
    /**
     * 
     * @type {string}
     * @memberof EobClaimPayment
     */
    'status'?: string;
    /**
     * 
     * @type {Array<EobCptPayment>}
     * @memberof EobClaimPayment
     */
    'patientProcedureCodes'?: Array<EobCptPayment>;
}

export const EobClaimPaymentPaidAsEnum = {
    Primary: 'PRIMARY',
    Secondary: 'SECONDARY',
    Tertiary: 'TERTIARY',
    Other: 'OTHER'
} as const;

export type EobClaimPaymentPaidAsEnum = typeof EobClaimPaymentPaidAsEnum[keyof typeof EobClaimPaymentPaidAsEnum];

/**
 * 
 * @export
 * @interface EobCptPayment
 */
export interface EobCptPayment {
    /**
     * 
     * @type {string}
     * @memberof EobCptPayment
     */
    'uuid'?: string;
    /**
     * 
     * @type {number}
     * @memberof EobCptPayment
     */
    'insurancePaid'?: number;
    /**
     * 
     * @type {number}
     * @memberof EobCptPayment
     */
    'writeOff'?: number;
    /**
     * 
     * @type {number}
     * @memberof EobCptPayment
     */
    'adjustment'?: number;
    /**
     * 
     * @type {number}
     * @memberof EobCptPayment
     */
    'copay'?: number;
    /**
     * 
     * @type {number}
     * @memberof EobCptPayment
     */
    'coInsurance'?: number;
    /**
     * 
     * @type {number}
     * @memberof EobCptPayment
     */
    'deductible'?: number;
    /**
     * 
     * @type {number}
     * @memberof EobCptPayment
     */
    'patientResponsibility'?: number;
    /**
     * 
     * @type {number}
     * @memberof EobCptPayment
     */
    'allowedAmount'?: number;
    /**
     * 
     * @type {number}
     * @memberof EobCptPayment
     */
    'contractAdjustment'?: number;
    /**
     * 
     * @type {number}
     * @memberof EobCptPayment
     */
    'otherAdjustment'?: number;
    /**
     * 
     * @type {number}
     * @memberof EobCptPayment
     */
    'remainingBalance'?: number;
    /**
     * 
     * @type {string}
     * @memberof EobCptPayment
     */
    'writeOffType'?: string;
    /**
     * 
     * @type {string}
     * @memberof EobCptPayment
     */
    'adjustmentType'?: string;
    /**
     * 
     * @type {string}
     * @memberof EobCptPayment
     */
    'comments'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof EobCptPayment
     */
    'denied'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof EobCptPayment
     */
    'denialCode'?: string;
}
/**
 * 
 * @export
 * @interface EobPaymentPostingRequest
 */
export interface EobPaymentPostingRequest {
    /**
     * 
     * @type {string}
     * @memberof EobPaymentPostingRequest
     */
    'eobUuid'?: string;
    /**
     * 
     * @type {Array<EobClaimPayment>}
     * @memberof EobPaymentPostingRequest
     */
    'claims'?: Array<EobClaimPayment>;
}
/**
 * 
 * @export
 * @interface EraClaimRequest
 */
export interface EraClaimRequest {
    /**
     * 
     * @type {string}
     * @memberof EraClaimRequest
     */
    'claimId'?: string;
    /**
     * 
     * @type {string}
     * @memberof EraClaimRequest
     */
    'dateOfService'?: string;
    /**
     * 
     * @type {string}
     * @memberof EraClaimRequest
     */
    'patientName'?: string;
    /**
     * 
     * @type {string}
     * @memberof EraClaimRequest
     */
    'paidAs'?: EraClaimRequestPaidAsEnum;
    /**
     * 
     * @type {string}
     * @memberof EraClaimRequest
     */
    'claimType'?: string;
    /**
     * 
     * @type {string}
     * @memberof EraClaimRequest
     */
    'providerName'?: string;
    /**
     * 
     * @type {string}
     * @memberof EraClaimRequest
     */
    'payerName'?: string;
    /**
     * 
     * @type {string}
     * @memberof EraClaimRequest
     */
    'payersClaimId': string;
    /**
     * 
     * @type {number}
     * @memberof EraClaimRequest
     */
    'chargeAmount': number;
    /**
     * 
     * @type {number}
     * @memberof EraClaimRequest
     */
    'insurancePaid': number;
    /**
     * 
     * @type {number}
     * @memberof EraClaimRequest
     */
    'insuranceAdjustment': number;
    /**
     * 
     * @type {number}
     * @memberof EraClaimRequest
     */
    'patientResponsibility': number;
    /**
     * 
     * @type {number}
     * @memberof EraClaimRequest
     */
    'allowedAmount': number;
    /**
     * 
     * @type {string}
     * @memberof EraClaimRequest
     */
    'adjudicationDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof EraClaimRequest
     */
    'paymentDate': string;
    /**
     * 
     * @type {string}
     * @memberof EraClaimRequest
     */
    'statementDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof EraClaimRequest
     */
    'claimStatus': EraClaimRequestClaimStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof EraClaimRequest
     */
    'denialRejectionCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof EraClaimRequest
     */
    'statusCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof EraClaimRequest
     */
    'groupCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof EraClaimRequest
     */
    'reasonCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof EraClaimRequest
     */
    'adjustmentType'?: EraClaimRequestAdjustmentTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof EraClaimRequest
     */
    'copay'?: number;
    /**
     * 
     * @type {number}
     * @memberof EraClaimRequest
     */
    'coInsurance'?: number;
    /**
     * 
     * @type {number}
     * @memberof EraClaimRequest
     */
    'deductible'?: number;
    /**
     * 
     * @type {Array<PatientProcedureCode>}
     * @memberof EraClaimRequest
     */
    'patientProcedureCodes'?: Array<PatientProcedureCode>;
    /**
     * 
     * @type {boolean}
     * @memberof EraClaimRequest
     */
    'posted'?: boolean;
    /**
     * 
     * @type {{ [key: string]: object; }}
     * @memberof EraClaimRequest
     */
    'claim'?: { [key: string]: object; };
}

export const EraClaimRequestPaidAsEnum = {
    Primary: 'PRIMARY',
    Secondary: 'SECONDARY',
    Tertiary: 'TERTIARY',
    Other: 'OTHER'
} as const;

export type EraClaimRequestPaidAsEnum = typeof EraClaimRequestPaidAsEnum[keyof typeof EraClaimRequestPaidAsEnum];
export const EraClaimRequestClaimStatusEnum = {
    Draft: 'DRAFT',
    Submitted: 'SUBMITTED',
    Denied: 'DENIED',
    Accepted: 'ACCEPTED',
    AcceptedByWaystar: 'ACCEPTED_BY_WAYSTAR',
    AcceptedByClaimmd: 'ACCEPTED_BY_CLAIMMD',
    Rejected: 'REJECTED',
    Resubmitted: 'RESUBMITTED',
    Pending: 'PENDING',
    Paid: 'PAID',
    PendingSubmission: 'PENDING_SUBMISSION',
    ReadyForSubmit: 'READY_FOR_SUBMIT'
} as const;

export type EraClaimRequestClaimStatusEnum = typeof EraClaimRequestClaimStatusEnum[keyof typeof EraClaimRequestClaimStatusEnum];
export const EraClaimRequestAdjustmentTypeEnum = {
    Contract: 'CONTRACT',
    NonCovered: 'NON_COVERED'
} as const;

export type EraClaimRequestAdjustmentTypeEnum = typeof EraClaimRequestAdjustmentTypeEnum[keyof typeof EraClaimRequestAdjustmentTypeEnum];

/**
 * 
 * @export
 * @interface EraPostRequest
 */
export interface EraPostRequest {
    /**
     * 
     * @type {number}
     * @memberof EraPostRequest
     */
    'amount'?: number;
    /**
     * 
     * @type {string}
     * @memberof EraPostRequest
     */
    'checkEftNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof EraPostRequest
     */
    'paymentMethod'?: string;
    /**
     * 
     * @type {string}
     * @memberof EraPostRequest
     */
    'eraDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof EraPostRequest
     */
    'batchNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof EraPostRequest
     */
    'instrumentNumber'?: string;
    /**
     * 
     * @type {Array<EraClaimRequest>}
     * @memberof EraPostRequest
     */
    'claims'?: Array<EraClaimRequest>;
}
/**
 * 
 * @export
 * @interface EraRequest
 */
export interface EraRequest {
    /**
     * 
     * @type {string}
     * @memberof EraRequest
     */
    'uuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof EraRequest
     */
    'eraDocNumber': string;
    /**
     * 
     * @type {string}
     * @memberof EraRequest
     */
    'eraDate': string;
    /**
     * 
     * @type {string}
     * @memberof EraRequest
     */
    'checkEftNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof EraRequest
     */
    'paymentMethod'?: string;
    /**
     * 
     * @type {number}
     * @memberof EraRequest
     */
    'amount'?: number;
    /**
     * 
     * @type {string}
     * @memberof EraRequest
     */
    'batchNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof EraRequest
     */
    'instrumentNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof EraRequest
     */
    'billingProviderUuid': string;
    /**
     * 
     * @type {string}
     * @memberof EraRequest
     */
    'payerId': string;
    /**
     * 
     * @type {string}
     * @memberof EraRequest
     */
    'fileName'?: string;
    /**
     * 
     * @type {Array<EraClaimRequest>}
     * @memberof EraRequest
     */
    'claims': Array<EraClaimRequest>;
}
/**
 * 
 * @export
 * @interface EventBridgeEvent
 */
export interface EventBridgeEvent {
    /**
     * 
     * @type {string}
     * @memberof EventBridgeEvent
     */
    'version'?: string;
    /**
     * 
     * @type {string}
     * @memberof EventBridgeEvent
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof EventBridgeEvent
     */
    'source'?: string;
    /**
     * 
     * @type {string}
     * @memberof EventBridgeEvent
     */
    'account'?: string;
    /**
     * 
     * @type {string}
     * @memberof EventBridgeEvent
     */
    'time'?: string;
    /**
     * 
     * @type {string}
     * @memberof EventBridgeEvent
     */
    'region'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof EventBridgeEvent
     */
    'resources'?: Array<string>;
    /**
     * 
     * @type {{ [key: string]: object; }}
     * @memberof EventBridgeEvent
     */
    'detail'?: { [key: string]: object; };
    /**
     * 
     * @type {string}
     * @memberof EventBridgeEvent
     */
    'detail-type'?: string;
}
/**
 * 
 * @export
 * @interface FamilyHistory
 */
export interface FamilyHistory {
    /**
     * 
     * @type {string}
     * @memberof FamilyHistory
     */
    'uuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof FamilyHistory
     */
    'conditionName'?: string;
    /**
     * 
     * @type {string}
     * @memberof FamilyHistory
     */
    'note'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof FamilyHistory
     */
    'active'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FamilyHistory
     */
    'archive'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof FamilyHistory
     */
    'onSetAge'?: string;
    /**
     * 
     * @type {string}
     * @memberof FamilyHistory
     */
    'relative'?: FamilyHistoryRelativeEnum;
    /**
     * 
     * @type {boolean}
     * @memberof FamilyHistory
     */
    'died'?: boolean;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof FamilyHistory
     */
    'patient'?: { [key: string]: string; };
    /**
     * 
     * @type {string}
     * @memberof FamilyHistory
     */
    'recordedDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof FamilyHistory
     */
    'appointmentId'?: string;
    /**
     * 
     * @type {string}
     * @memberof FamilyHistory
     */
    'providerStatus'?: FamilyHistoryProviderStatusEnum;
}

export const FamilyHistoryRelativeEnum = {
    Self: 'SELF',
    Associate: 'ASSOCIATE',
    CareGiver: 'CARE_GIVER',
    Child: 'CHILD',
    EmergencyContact: 'EMERGENCY_CONTACT',
    Employee: 'EMPLOYEE',
    Employer: 'EMPLOYER',
    ExtendedFamily: 'EXTENDED_FAMILY',
    Father: 'FATHER',
    FosterChild: 'FOSTER_CHILD',
    Friend: 'FRIEND',
    Grandchild: 'GRANDCHILD',
    Grandparent: 'GRANDPARENT',
    Guardian: 'GUARDIAN',
    HandicappedDependent: 'HANDICAPPED_DEPENDENT',
    LifePartner: 'LIFE_PARTNER',
    Manager: 'MANAGER',
    Mother: 'MOTHER',
    NaturalChild: 'NATURAL_CHILD',
    None: 'NONE',
    Other: 'OTHER',
    OtherAdult: 'OTHER_ADULT',
    Owner: 'OWNER',
    Parent: 'PARENT',
    Sibling: 'SIBLING',
    Sister: 'SISTER',
    Spouse: 'SPOUSE',
    Stepchild: 'STEPCHILD',
    Trainer: 'TRAINER',
    Unknown: 'UNKNOWN',
    WardOfCourt: 'WARD_OF_COURT'
} as const;

export type FamilyHistoryRelativeEnum = typeof FamilyHistoryRelativeEnum[keyof typeof FamilyHistoryRelativeEnum];
export const FamilyHistoryProviderStatusEnum = {
    Pending: 'PENDING',
    Confirmed: 'CONFIRMED'
} as const;

export type FamilyHistoryProviderStatusEnum = typeof FamilyHistoryProviderStatusEnum[keyof typeof FamilyHistoryProviderStatusEnum];

/**
 * 
 * @export
 * @interface FamilyHistoryIntakeForm
 */
export interface FamilyHistoryIntakeForm {
    /**
     * 
     * @type {string}
     * @memberof FamilyHistoryIntakeForm
     */
    'problem'?: string;
    /**
     * 
     * @type {string}
     * @memberof FamilyHistoryIntakeForm
     */
    'relative'?: string;
    /**
     * 
     * @type {string}
     * @memberof FamilyHistoryIntakeForm
     */
    'age'?: string;
}
/**
 * 
 * @export
 * @interface FaxConfiguration
 */
export interface FaxConfiguration {
    /**
     * 
     * @type {string}
     * @memberof FaxConfiguration
     */
    'uuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof FaxConfiguration
     */
    'vendor'?: FaxConfigurationVendorEnum;
    /**
     * 
     * @type {string}
     * @memberof FaxConfiguration
     */
    'userName'?: string;
    /**
     * 
     * @type {string}
     * @memberof FaxConfiguration
     */
    'password'?: string;
    /**
     * 
     * @type {string}
     * @memberof FaxConfiguration
     */
    'senderEmail'?: string;
    /**
     * 
     * @type {string}
     * @memberof FaxConfiguration
     */
    'faxNumber'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof FaxConfiguration
     */
    'archive'?: boolean;
}

export const FaxConfigurationVendorEnum = {
    Srfax: 'SRFAX'
} as const;

export type FaxConfigurationVendorEnum = typeof FaxConfigurationVendorEnum[keyof typeof FaxConfigurationVendorEnum];

/**
 * 
 * @export
 * @interface FcmToken
 */
export interface FcmToken {
    /**
     * 
     * @type {string}
     * @memberof FcmToken
     */
    'uuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof FcmToken
     */
    'registrationId'?: string;
    /**
     * 
     * @type {string}
     * @memberof FcmToken
     */
    'userId'?: string;
}
/**
 * 
 * @export
 * @interface FeeSchedule
 */
export interface FeeSchedule {
    /**
     * 
     * @type {string}
     * @memberof FeeSchedule
     */
    'uuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof FeeSchedule
     */
    'amount'?: string;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof FeeSchedule
     */
    'medicalCodes': { [key: string]: string; };
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof FeeSchedule
     */
    'providers': { [key: string]: string; };
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof FeeSchedule
     */
    'payers'?: { [key: string]: string; };
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof FeeSchedule
     */
    'modifier'?: { [key: string]: string; };
    /**
     * 
     * @type {string}
     * @memberof FeeSchedule
     */
    'rate'?: string;
    /**
     * 
     * @type {string}
     * @memberof FeeSchedule
     */
    'allowedAmount'?: string;
    /**
     * 
     * @type {string}
     * @memberof FeeSchedule
     */
    'fromDate': string;
    /**
     * 
     * @type {string}
     * @memberof FeeSchedule
     */
    'endDate': string;
    /**
     * 
     * @type {boolean}
     * @memberof FeeSchedule
     */
    'active'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FeeSchedule
     */
    'archive'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof FeeSchedule
     */
    'feeScheduleType'?: FeeScheduleFeeScheduleTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof FeeSchedule
     */
    'codeType'?: FeeScheduleCodeTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof FeeSchedule
     */
    'createdDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof FeeSchedule
     */
    'updatedDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof FeeSchedule
     */
    'createdBy'?: string;
    /**
     * 
     * @type {string}
     * @memberof FeeSchedule
     */
    'updatedBy'?: string;
}

export const FeeScheduleFeeScheduleTypeEnum = {
    PayerSpecific: 'PAYER_SPECIFIC',
    ProviderSpecific: 'PROVIDER_SPECIFIC'
} as const;

export type FeeScheduleFeeScheduleTypeEnum = typeof FeeScheduleFeeScheduleTypeEnum[keyof typeof FeeScheduleFeeScheduleTypeEnum];
export const FeeScheduleCodeTypeEnum = {
    Cpt: 'CPT',
    Icd: 'ICD',
    Hcpcs: 'HCPCS',
    Loinc: 'LOINC',
    PayerCatalog: 'PAYER_CATALOG',
    Patient: 'PATIENT',
    Provider: 'PROVIDER',
    LabTest: 'LAB_TEST',
    ImagingStudy: 'IMAGING_STUDY',
    DrugCatalog: 'DRUG_CATALOG'
} as const;

export type FeeScheduleCodeTypeEnum = typeof FeeScheduleCodeTypeEnum[keyof typeof FeeScheduleCodeTypeEnum];

/**
 * 
 * @export
 * @interface Flags
 */
export interface Flags {
    /**
     * 
     * @type {string}
     * @memberof Flags
     */
    'uuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof Flags
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof Flags
     */
    'color'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Flags
     */
    'active'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Flags
     */
    'archive'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof Flags
     */
    'createdAt'?: string;
}
/**
 * 
 * @export
 * @interface FollowUpNoteDTO
 */
export interface FollowUpNoteDTO {
    /**
     * 
     * @type {string}
     * @memberof FollowUpNoteDTO
     */
    'title'?: string;
    /**
     * 
     * @type {Content}
     * @memberof FollowUpNoteDTO
     */
    'content'?: Content;
}
/**
 * 
 * @export
 * @interface InstantAppointment
 */
export interface InstantAppointment {
    /**
     * 
     * @type {string}
     * @memberof InstantAppointment
     */
    'uuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof InstantAppointment
     */
    'patientId': string;
    /**
     * 
     * @type {string}
     * @memberof InstantAppointment
     */
    'patientName'?: string;
    /**
     * 
     * @type {string}
     * @memberof InstantAppointment
     */
    'patientDob'?: string;
    /**
     * 
     * @type {string}
     * @memberof InstantAppointment
     */
    'patientMrn'?: string;
    /**
     * 
     * @type {string}
     * @memberof InstantAppointment
     */
    'patientEmail'?: string;
    /**
     * 
     * @type {string}
     * @memberof InstantAppointment
     */
    'patientPhone'?: string;
    /**
     * 
     * @type {string}
     * @memberof InstantAppointment
     */
    'avatar'?: string;
    /**
     * 
     * @type {string}
     * @memberof InstantAppointment
     */
    'providerId': string;
    /**
     * 
     * @type {string}
     * @memberof InstantAppointment
     */
    'providerName'?: string;
    /**
     * 
     * @type {string}
     * @memberof InstantAppointment
     */
    'providerRole'?: string;
    /**
     * 
     * @type {string}
     * @memberof InstantAppointment
     */
    'mode'?: InstantAppointmentModeEnum;
    /**
     * 
     * @type {string}
     * @memberof InstantAppointment
     */
    'type'?: InstantAppointmentTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof InstantAppointment
     */
    'paymentType'?: InstantAppointmentPaymentTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof InstantAppointment
     */
    'note'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof InstantAppointment
     */
    'paid'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof InstantAppointment
     */
    'estimateAmount'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof InstantAppointment
     */
    'emailedFormsStatus'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof InstantAppointment
     */
    'duration'?: number;
    /**
     * 
     * @type {string}
     * @memberof InstantAppointment
     */
    'status'?: InstantAppointmentStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof InstantAppointment
     */
    'reminderStatus'?: InstantAppointmentReminderStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof InstantAppointment
     */
    'rescheduleReason'?: string;
    /**
     * 
     * @type {string}
     * @memberof InstantAppointment
     */
    'created'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof InstantAppointment
     */
    'archive'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof InstantAppointment
     */
    'intakeComplete'?: boolean;
}

export const InstantAppointmentModeEnum = {
    InPerson: 'IN_PERSON',
    Virtual: 'VIRTUAL'
} as const;

export type InstantAppointmentModeEnum = typeof InstantAppointmentModeEnum[keyof typeof InstantAppointmentModeEnum];
export const InstantAppointmentTypeEnum = {
    New: 'NEW',
    Followup: 'FOLLOWUP',
    Instant: 'INSTANT',
    Administrative: 'ADMINISTRATIVE',
    CareCoordination: 'CARE_COORDINATION',
    MedicationBrief: 'MEDICATION_BRIEF',
    NewPatientVisit: 'NEW_PATIENT_VISIT',
    NursingOnly: 'NURSING_ONLY',
    TelephoneCall: 'TELEPHONE_CALL',
    UrgentVisit: 'URGENT_VISIT',
    VideoVisit: 'VIDEO_VISIT',
    WellnessExam: 'WELLNESS_EXAM'
} as const;

export type InstantAppointmentTypeEnum = typeof InstantAppointmentTypeEnum[keyof typeof InstantAppointmentTypeEnum];
export const InstantAppointmentPaymentTypeEnum = {
    Cash: 'CASH',
    Card: 'CARD',
    Bank: 'BANK',
    Insurance: 'INSURANCE',
    Online: 'ONLINE'
} as const;

export type InstantAppointmentPaymentTypeEnum = typeof InstantAppointmentPaymentTypeEnum[keyof typeof InstantAppointmentPaymentTypeEnum];
export const InstantAppointmentStatusEnum = {
    Pending: 'PENDING',
    Confirmed: 'CONFIRMED',
    Cancelled: 'CANCELLED',
    NoShow: 'NO_SHOW',
    CheckedIn: 'CHECKED_IN',
    InExam: 'IN_EXAM',
    Scheduled: 'SCHEDULED',
    IntakeCompleted: 'INTAKE_COMPLETED',
    Completed: 'COMPLETED',
    Instant: 'INSTANT',
    CancellationRequested: 'CANCELLATION_REQUESTED'
} as const;

export type InstantAppointmentStatusEnum = typeof InstantAppointmentStatusEnum[keyof typeof InstantAppointmentStatusEnum];
export const InstantAppointmentReminderStatusEnum = {
    Pending: 'PENDING',
    Hours48: 'HOURS_48',
    Hours24: 'HOURS_24',
    Hours2: 'HOURS_2',
    Minutes15: 'MINUTES_15',
    Discard: 'DISCARD'
} as const;

export type InstantAppointmentReminderStatusEnum = typeof InstantAppointmentReminderStatusEnum[keyof typeof InstantAppointmentReminderStatusEnum];

/**
 * 
 * @export
 * @interface InsuranceIntakeForm
 */
export interface InsuranceIntakeForm {
    /**
     * 
     * @type {string}
     * @memberof InsuranceIntakeForm
     */
    'insuranceProvider'?: string;
    /**
     * 
     * @type {string}
     * @memberof InsuranceIntakeForm
     */
    'policyNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof InsuranceIntakeForm
     */
    'groupNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof InsuranceIntakeForm
     */
    'subscriberName'?: string;
    /**
     * 
     * @type {string}
     * @memberof InsuranceIntakeForm
     */
    'subscriberDOB'?: string;
    /**
     * 
     * @type {string}
     * @memberof InsuranceIntakeForm
     */
    'subscriberSSN'?: string;
    /**
     * 
     * @type {string}
     * @memberof InsuranceIntakeForm
     */
    'relationshipToPatient'?: string;
}
/**
 * 
 * @export
 * @interface InsurancePayer
 */
export interface InsurancePayer {
    /**
     * 
     * @type {string}
     * @memberof InsurancePayer
     */
    'payerId': string;
    /**
     * 
     * @type {string}
     * @memberof InsurancePayer
     */
    'payerName': string;
    /**
     * 
     * @type {string}
     * @memberof InsurancePayer
     */
    'payerType': InsurancePayerPayerTypeEnum;
    /**
     * 
     * @type {Address}
     * @memberof InsurancePayer
     */
    'address'?: Address;
    /**
     * 
     * @type {boolean}
     * @memberof InsurancePayer
     */
    'active'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof InsurancePayer
     */
    'archive'?: boolean;
}

export const InsurancePayerPayerTypeEnum = {
    Commercial: 'COMMERCIAL',
    Medicare: 'MEDICARE',
    Medicaid: 'MEDICAID',
    MedicaidManagedCare: 'MEDICAID_MANAGED_CARE',
    MedicareAdvantage: 'MEDICARE_ADVANTAGE',
    WorkersComp: 'WORKERS_COMP',
    AutoPip: 'AUTO_PIP',
    TricareVa: 'TRICARE_VA',
    SelfPay: 'SELF_PAY',
    Other: 'OTHER'
} as const;

export type InsurancePayerPayerTypeEnum = typeof InsurancePayerPayerTypeEnum[keyof typeof InsurancePayerPayerTypeEnum];

/**
 * 
 * @export
 * @interface InsurancePlan
 */
export interface InsurancePlan {
    /**
     * 
     * @type {string}
     * @memberof InsurancePlan
     */
    'uuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof InsurancePlan
     */
    'planName'?: string;
    /**
     * 
     * @type {InsurancePayer}
     * @memberof InsurancePlan
     */
    'insurancePayer'?: InsurancePayer;
    /**
     * 
     * @type {string}
     * @memberof InsurancePlan
     */
    'planType'?: InsurancePlanPlanTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof InsurancePlan
     */
    'coverageType'?: string;
}

export const InsurancePlanPlanTypeEnum = {
    Ppo: 'PPO',
    Hmo: 'HMO',
    Medicare: 'MEDICARE',
    Dental: 'DENTAL',
    Vision: 'VISION',
    Hsa: 'HSA',
    Private: 'PRIVATE',
    Epo: 'EPO',
    Pos: 'POS',
    Other: 'OTHER',
    Medicaid: 'MEDICAID',
    WorkersCompensation: 'WORKERS_COMPENSATION',
    BehavioralHealth: 'BEHAVIORAL_HEALTH',
    MotorVehicle: 'MOTOR_VEHICLE',
    Uninsured: 'UNINSURED'
} as const;

export type InsurancePlanPlanTypeEnum = typeof InsurancePlanPlanTypeEnum[keyof typeof InsurancePlanPlanTypeEnum];

/**
 * 
 * @export
 * @interface IntakeForm
 */
export interface IntakeForm {
    /**
     * 
     * @type {string}
     * @memberof IntakeForm
     */
    'uuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof IntakeForm
     */
    'content'?: string;
    /**
     * 
     * @type {string}
     * @memberof IntakeForm
     */
    'appointment'?: string;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof IntakeForm
     */
    'patient'?: { [key: string]: string; };
    /**
     * 
     * @type {boolean}
     * @memberof IntakeForm
     */
    'archive'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IntakeForm
     */
    'active'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof IntakeForm
     */
    'actionId'?: string;
}
/**
 * 
 * @export
 * @interface InvitePatient
 */
export interface InvitePatient {
    /**
     * 
     * @type {string}
     * @memberof InvitePatient
     */
    'appointmentId': string;
    /**
     * 
     * @type {string}
     * @memberof InvitePatient
     */
    'patientId': string;
    /**
     * 
     * @type {string}
     * @memberof InvitePatient
     */
    'appointmentUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof InvitePatient
     */
    'providerId': string;
}
/**
 * 
 * @export
 * @interface InvoiceReminderRequest
 */
export interface InvoiceReminderRequest {
    /**
     * 
     * @type {string}
     * @memberof InvoiceReminderRequest
     */
    'uuid'?: string;
    /**
     * 
     * @type {Set<string>}
     * @memberof InvoiceReminderRequest
     */
    'reminderMedium': Set<InvoiceReminderRequestReminderMediumEnum>;
    /**
     * 
     * @type {string}
     * @memberof InvoiceReminderRequest
     */
    'reminderBeforeNumber': string;
    /**
     * 
     * @type {string}
     * @memberof InvoiceReminderRequest
     */
    'reminderBeforeUnit': InvoiceReminderRequestReminderBeforeUnitEnum;
}

export const InvoiceReminderRequestReminderMediumEnum = {
    Email: 'EMAIL',
    PushNotification: 'PUSH_NOTIFICATION',
    Sms: 'SMS'
} as const;

export type InvoiceReminderRequestReminderMediumEnum = typeof InvoiceReminderRequestReminderMediumEnum[keyof typeof InvoiceReminderRequestReminderMediumEnum];
export const InvoiceReminderRequestReminderBeforeUnitEnum = {
    Minutes: 'MINUTES',
    Hours: 'HOURS',
    Days: 'DAYS'
} as const;

export type InvoiceReminderRequestReminderBeforeUnitEnum = typeof InvoiceReminderRequestReminderBeforeUnitEnum[keyof typeof InvoiceReminderRequestReminderBeforeUnitEnum];

/**
 * 
 * @export
 * @interface Lab
 */
export interface Lab {
    /**
     * 
     * @type {string}
     * @memberof Lab
     */
    'uuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof Lab
     */
    'labName'?: string;
    /**
     * 
     * @type {string}
     * @memberof Lab
     */
    'contactNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof Lab
     */
    'faxNumber'?: string;
    /**
     * 
     * @type {Address}
     * @memberof Lab
     */
    'address'?: Address;
}
/**
 * 
 * @export
 * @interface LanguageConversionRequest
 */
export interface LanguageConversionRequest {
    /**
     * 
     * @type {string}
     * @memberof LanguageConversionRequest
     */
    'language'?: string;
    /**
     * 
     * @type {Array<TranscriptionSegmentDTO>}
     * @memberof LanguageConversionRequest
     */
    'transcriptionSegments'?: Array<TranscriptionSegmentDTO>;
}
/**
 * 
 * @export
 * @interface LicenseInformation
 */
export interface LicenseInformation {
    /**
     * 
     * @type {string}
     * @memberof LicenseInformation
     */
    'uuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof LicenseInformation
     */
    'licenseState'?: string;
    /**
     * 
     * @type {string}
     * @memberof LicenseInformation
     */
    'licenseNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof LicenseInformation
     */
    'expiryDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof LicenseInformation
     */
    'licenseActiveDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof LicenseInformation
     */
    'licenseDocument'?: string;
    /**
     * 
     * @type {string}
     * @memberof LicenseInformation
     */
    'licenseName'?: string;
    /**
     * 
     * @type {string}
     * @memberof LicenseInformation
     */
    'licenseDocumentFormat'?: string;
}
/**
 * 
 * @export
 * @interface LocalTime
 */
export interface LocalTime {
    /**
     * 
     * @type {number}
     * @memberof LocalTime
     */
    'hour'?: number;
    /**
     * 
     * @type {number}
     * @memberof LocalTime
     */
    'minute'?: number;
    /**
     * 
     * @type {number}
     * @memberof LocalTime
     */
    'second'?: number;
    /**
     * 
     * @type {number}
     * @memberof LocalTime
     */
    'nano'?: number;
}
/**
 * 
 * @export
 * @interface Location
 */
export interface Location {
    /**
     * 
     * @type {string}
     * @memberof Location
     */
    'uuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof Location
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof Location
     */
    'locationId'?: string;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof Location
     */
    'specialities'?: { [key: string]: string; };
    /**
     * 
     * @type {string}
     * @memberof Location
     */
    'contact'?: string;
    /**
     * 
     * @type {string}
     * @memberof Location
     */
    'npi'?: string;
    /**
     * 
     * @type {string}
     * @memberof Location
     */
    'timezone': string;
    /**
     * 
     * @type {string}
     * @memberof Location
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof Location
     */
    'fax'?: string;
    /**
     * 
     * @type {string}
     * @memberof Location
     */
    'note'?: string;
    /**
     * 
     * @type {Address}
     * @memberof Location
     */
    'physicalAddress'?: Address;
    /**
     * 
     * @type {Address}
     * @memberof Location
     */
    'billingAddress'?: Address;
    /**
     * 
     * @type {Set<LocationHour>}
     * @memberof Location
     */
    'officeHours'?: Set<LocationHour>;
    /**
     * 
     * @type {boolean}
     * @memberof Location
     */
    'active'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Location
     */
    'archive'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Location
     */
    'addressCheckBox'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof Location
     */
    'avatar'?: string;
}
/**
 * 
 * @export
 * @interface LocationHour
 */
export interface LocationHour {
    /**
     * 
     * @type {string}
     * @memberof LocationHour
     */
    'dayOfWeek'?: LocationHourDayOfWeekEnum;
    /**
     * 
     * @type {string}
     * @memberof LocationHour
     */
    'openingTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof LocationHour
     */
    'closingTime'?: string;
}

export const LocationHourDayOfWeekEnum = {
    Monday: 'MONDAY',
    Tuesday: 'TUESDAY',
    Wednesday: 'WEDNESDAY',
    Thursday: 'THURSDAY',
    Friday: 'FRIDAY',
    Saturday: 'SATURDAY',
    Sunday: 'SUNDAY'
} as const;

export type LocationHourDayOfWeekEnum = typeof LocationHourDayOfWeekEnum[keyof typeof LocationHourDayOfWeekEnum];

/**
 * 
 * @export
 * @interface LoginRequest
 */
export interface LoginRequest {
    /**
     * 
     * @type {string}
     * @memberof LoginRequest
     */
    'username': string;
    /**
     * 
     * @type {string}
     * @memberof LoginRequest
     */
    'password': string;
    /**
     * 
     * @type {string}
     * @memberof LoginRequest
     */
    'portal'?: string;
}
/**
 * 
 * @export
 * @interface MacrosTemplate
 */
export interface MacrosTemplate {
    /**
     * 
     * @type {string}
     * @memberof MacrosTemplate
     */
    'uuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof MacrosTemplate
     */
    'templateName'?: string;
    /**
     * 
     * @type {string}
     * @memberof MacrosTemplate
     */
    'description'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof MacrosTemplate
     */
    'archive'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MacrosTemplate
     */
    'active'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof MacrosTemplate
     */
    'modifiedDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof MacrosTemplate
     */
    'createdBy'?: string;
}
/**
 * 
 * @export
 * @interface MedicalCode
 */
export interface MedicalCode {
    /**
     * 
     * @type {string}
     * @memberof MedicalCode
     */
    'uuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof MedicalCode
     */
    'codeVersion'?: MedicalCodeCodeVersionEnum;
    /**
     * 
     * @type {string}
     * @memberof MedicalCode
     */
    'type': MedicalCodeTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof MedicalCode
     */
    'code'?: string;
    /**
     * 
     * @type {string}
     * @memberof MedicalCode
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof MedicalCode
     */
    'source'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof MedicalCode
     */
    'active'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MedicalCode
     */
    'archive'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof MedicalCode
     */
    'errorMessage'?: string;
    /**
     * 
     * @type {string}
     * @memberof MedicalCode
     */
    'drugId'?: string;
    /**
     * 
     * @type {string}
     * @memberof MedicalCode
     */
    'formType'?: MedicalCodeFormTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof MedicalCode
     */
    'drugName'?: string;
    /**
     * 
     * @type {string}
     * @memberof MedicalCode
     */
    'strength'?: string;
}

export const MedicalCodeCodeVersionEnum = {
    _09: 'ICD 09',
    _10: 'ICD 10',
    _11: 'ICD 11'
} as const;

export type MedicalCodeCodeVersionEnum = typeof MedicalCodeCodeVersionEnum[keyof typeof MedicalCodeCodeVersionEnum];
export const MedicalCodeTypeEnum = {
    Cpt: 'CPT',
    Icd: 'ICD',
    Hcpcs: 'HCPCS',
    Loinc: 'LOINC',
    PayerCatalog: 'PAYER_CATALOG',
    Patient: 'PATIENT',
    Provider: 'PROVIDER',
    LabTest: 'LAB_TEST',
    ImagingStudy: 'IMAGING_STUDY',
    DrugCatalog: 'DRUG_CATALOG'
} as const;

export type MedicalCodeTypeEnum = typeof MedicalCodeTypeEnum[keyof typeof MedicalCodeTypeEnum];
export const MedicalCodeFormTypeEnum = {
    Aerosol: 'AEROSOL',
    AerosolFoam: 'AEROSOL_FOAM',
    AerosolMetered: 'AEROSOL_METERED',
    BarChewable: 'BAR_CHEWABLE',
    Capsule: 'CAPSULE',
    CapsuleCoatedPellets: 'CAPSULE_COATED_PELLETS',
    CapsuleDelayedRelPellets: 'CAPSULE_DELAYED_REL_PELLETS',
    CapsuleDelayedRelease: 'CAPSULE_DELAYED_RELEASE',
    CapsuleExtendedRelease: 'CAPSULE_EXTENDED_RELEASE',
    CapsulePellet: 'CAPSULE_PELLET',
    CapsulePellets: 'CAPSULE_PELLETS',
    CapsuleTablet: 'CAPSULE_TABLET',
    CapsuleTabletCapsuleDelayedRelPellets: 'CAPSULE_TABLET_CAPSULE_DELAYED_REL_PELLETS',
    CapsuleTabletCapsuleDelayedRelease: 'CAPSULE_TABLET_CAPSULE_DELAYED_RELEASE',
    CapsuleTabletTablet: 'CAPSULE_TABLET_TABLET',
    Cloth: 'CLOTH',
    Concentrate: 'CONCENTRATE',
    Cream: 'CREAM',
    CreamAugmented: 'CREAM_AUGMENTED',
    CreamInsert: 'CREAM_INSERT',
    CreamSuppository: 'CREAM_SUPPOSITORY',
    CreamTablet: 'CREAM_TABLET',
    Disc: 'DISC',
    Dressing: 'DRESSING',
    DrugElutingContactLens: 'DRUG_ELUTING_CONTACT_LENS',
    Elixir: 'ELIXIR',
    Emulsion: 'EMULSION',
    Enema: 'ENEMA',
    FiberExtendedRelease: 'FIBER_EXTENDED_RELEASE',
    Film: 'FILM',
    FilmExtendedRelease: 'FILM_EXTENDED_RELEASE',
    Foam: 'FOAM',
    ForSolution: 'FOR_SOLUTION',
    ForSolutionTabletDelayedRelease: 'FOR_SOLUTION_TABLET_DELAYED_RELEASE',
    ForSolutionTabletForSolution: 'FOR_SOLUTION_TABLET_FOR_SOLUTION',
    ForSuspension: 'FOR_SUSPENSION',
    ForSuspensionDelayedRelease: 'FOR_SUSPENSION_DELAYED_RELEASE',
    ForSuspensionExtendedRelease: 'FOR_SUSPENSION_EXTENDED_RELEASE',
    ForSuspensionTablet: 'FOR_SUSPENSION_TABLET',
    Gas: 'GAS',
    Gel: 'GEL',
    GelAugmented: 'GEL_AUGMENTED',
    GelMetered: 'GEL_METERED',
    Granule: 'GRANULE',
    GranuleDelayedRelease: 'GRANULE_DELAYED_RELEASE',
    GranuleEffervescent: 'GRANULE_EFFERVESCENT',
    Granules: 'GRANULES',
    GranulesExtendedRelease: 'GRANULES_EXTENDED_RELEASE',
    GumChewing: 'GUM_CHEWING',
    Implant: 'IMPLANT',
    Inhalant: 'INHALANT',
    Injectable: 'INJECTABLE',
    InjectableLipidComplex: 'INJECTABLE_LIPID_COMPLEX',
    InjectableLiposomal: 'INJECTABLE_LIPOSOMAL',
    InjectableSuspension: 'INJECTABLE_SUSPENSION',
    InjectableTablet: 'INJECTABLE_TABLET',
    Injection: 'INJECTION',
    InjectionExtendedRelease: 'INJECTION_EXTENDED_RELEASE',
    Insert: 'INSERT',
    InsertExtendedRelease: 'INSERT_EXTENDED_RELEASE',
    IntrauterineDevice: 'INTRAUTERINE_DEVICE',
    Jelly: 'JELLY',
    Liquid: 'LIQUID',
    Lotion: 'LOTION',
    LotionAugmented: 'LOTION_AUGMENTED',
    LotionShampoo: 'LOTION_SHAMPOO',
    Na: 'NA',
    Oil: 'OIL',
    OilDrops: 'OIL_DROPS',
    Ointment: 'OINTMENT',
    OintmentAugmented: 'OINTMENT_AUGMENTED',
    Paste: 'PASTE',
    Pastille: 'PASTILLE',
    Patch: 'PATCH',
    Pellet: 'PELLET',
    Pellets: 'PELLETS',
    Powder: 'POWDER',
    PowderExtendedRelease: 'POWDER_EXTENDED_RELEASE',
    PowderForInjectionSolution: 'POWDER_FOR_INJECTION_SOLUTION',
    PowderForInjectionSolutionLyophilizedPowder: 'POWDER_FOR_INJECTION_SOLUTION_LYOPHILIZED_POWDER',
    PowderMetered: 'POWDER_METERED',
    Ring: 'RING',
    Shampoo: 'SHAMPOO',
    Soap: 'SOAP',
    Solution: 'SOLUTION',
    SolutionForSlush: 'SOLUTION_FOR_SLUSH',
    SolutionElixir: 'SOLUTION_ELIXIR',
    SolutionExtendedRelease: 'SOLUTION_EXTENDED_RELEASE',
    SolutionGelFormingDrops: 'SOLUTION_GEL_FORMING_DROPS',
    SolutionMetered: 'SOLUTION_METERED',
    SolutionSolution: 'SOLUTION_SOLUTION',
    SolutionDrops: 'SOLUTION_DROPS',
    Sponge: 'SPONGE',
    Spray: 'SPRAY',
    SprayMetered: 'SPRAY_METERED',
    Suppository: 'SUPPOSITORY',
    Suspension: 'SUSPENSION',
    SuspensionDelayedRelease: 'SUSPENSION_DELAYED_RELEASE',
    SuspensionExtendedRelease: 'SUSPENSION_EXTENDED_RELEASE',
    SuspensionLiposomal: 'SUSPENSION_LIPOSOMAL',
    SuspensionDrops: 'SUSPENSION_DROPS',
    Swab: 'SWAB',
    Syringe: 'SYRINGE',
    Syrup: 'SYRUP',
    System: 'SYSTEM',
    SystemExtendedRelease: 'SYSTEM_EXTENDED_RELEASE',
    Tablet: 'TABLET',
    TabletChewable: 'TABLET_CHEWABLE',
    TabletChewableTablet: 'TABLET_CHEWABLE_TABLET',
    TabletChewableTabletCapsule: 'TABLET_CHEWABLE_TABLET_CAPSULE',
    TabletCoatedParticles: 'TABLET_COATED_PARTICLES',
    TabletDelayedRelease: 'TABLET_DELAYED_RELEASE',
    TabletDispersible: 'TABLET_DISPERSIBLE',
    TabletEffervescent: 'TABLET_EFFERVESCENT',
    TabletExtendedRelease: 'TABLET_EXTENDED_RELEASE',
    TabletExtendedReleaseChewable: 'TABLET_EXTENDED_RELEASE_CHEWABLE',
    TabletForSuspension: 'TABLET_FOR_SUSPENSION',
    TabletOrallyDisintegrating: 'TABLET_ORALLY_DISINTEGRATING',
    TabletOrallyDisintegratingDelayedRelease: 'TABLET_ORALLY_DISINTEGRATING_DELAYED_RELEASE',
    TabletOrallyDisintegratingExtendedRelease: 'TABLET_ORALLY_DISINTEGRATING_EXTENDED_RELEASE',
    Tampon: 'TAMPON',
    Tape: 'TAPE',
    TrocheLozenge: 'TROCHE_LOZENGE',
    Unknown: 'UNKNOWN',
    Vial: 'VIAL'
} as const;

export type MedicalCodeFormTypeEnum = typeof MedicalCodeFormTypeEnum[keyof typeof MedicalCodeFormTypeEnum];

/**
 * 
 * @export
 * @interface MedicalHistory
 */
export interface MedicalHistory {
    /**
     * 
     * @type {string}
     * @memberof MedicalHistory
     */
    'uuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof MedicalHistory
     */
    'conditionName'?: string;
    /**
     * 
     * @type {string}
     * @memberof MedicalHistory
     */
    'note'?: string;
    /**
     * 
     * @type {string}
     * @memberof MedicalHistory
     */
    'medicalHistoryDate'?: string;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof MedicalHistory
     */
    'patient': { [key: string]: string; };
    /**
     * 
     * @type {boolean}
     * @memberof MedicalHistory
     */
    'active'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MedicalHistory
     */
    'archive'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof MedicalHistory
     */
    'recordedDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof MedicalHistory
     */
    'appointmentId'?: string;
    /**
     * 
     * @type {string}
     * @memberof MedicalHistory
     */
    'providerStatus'?: MedicalHistoryProviderStatusEnum;
}

export const MedicalHistoryProviderStatusEnum = {
    Pending: 'PENDING',
    Confirmed: 'CONFIRMED'
} as const;

export type MedicalHistoryProviderStatusEnum = typeof MedicalHistoryProviderStatusEnum[keyof typeof MedicalHistoryProviderStatusEnum];

/**
 * 
 * @export
 * @interface MedicalHistoryIntakeForm
 */
export interface MedicalHistoryIntakeForm {
    /**
     * 
     * @type {boolean}
     * @memberof MedicalHistoryIntakeForm
     */
    'noneOfTheProblemsListed'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MedicalHistoryIntakeForm
     */
    'allergies'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MedicalHistoryIntakeForm
     */
    'anemia'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MedicalHistoryIntakeForm
     */
    'arthritisConditions'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MedicalHistoryIntakeForm
     */
    'asthma'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MedicalHistoryIntakeForm
     */
    'arterialFibrillation'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MedicalHistoryIntakeForm
     */
    'bleedingProblems'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MedicalHistoryIntakeForm
     */
    'bph'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MedicalHistoryIntakeForm
     */
    'cadCoronaryArteryDisease'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MedicalHistoryIntakeForm
     */
    'cancer'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MedicalHistoryIntakeForm
     */
    'cardiacArrest'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MedicalHistoryIntakeForm
     */
    'celiacDisease'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MedicalHistoryIntakeForm
     */
    'chestPain'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MedicalHistoryIntakeForm
     */
    'congestiveHeartFailure'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MedicalHistoryIntakeForm
     */
    'chronicFatigueSyndrome'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MedicalHistoryIntakeForm
     */
    'depression'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MedicalHistoryIntakeForm
     */
    'diabetes'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MedicalHistoryIntakeForm
     */
    'drugAlcoholAbuse'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MedicalHistoryIntakeForm
     */
    'erectileDysfunction'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MedicalHistoryIntakeForm
     */
    'fibromyalgia'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MedicalHistoryIntakeForm
     */
    'gerd'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MedicalHistoryIntakeForm
     */
    'heartDisease'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MedicalHistoryIntakeForm
     */
    'hyperinsulinemia'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MedicalHistoryIntakeForm
     */
    'hyperlipidemia'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MedicalHistoryIntakeForm
     */
    'hypertension'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MedicalHistoryIntakeForm
     */
    'hypogonadismMale'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MedicalHistoryIntakeForm
     */
    'hypothyroidism'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MedicalHistoryIntakeForm
     */
    'infectionProblems'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MedicalHistoryIntakeForm
     */
    'insomnia'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MedicalHistoryIntakeForm
     */
    'irritableBowelSyndrome'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MedicalHistoryIntakeForm
     */
    'kidneyProblems'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MedicalHistoryIntakeForm
     */
    'menopause'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MedicalHistoryIntakeForm
     */
    'migrainesHeadaches'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MedicalHistoryIntakeForm
     */
    'neuropathy'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MedicalHistoryIntakeForm
     */
    'onychomycosis'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MedicalHistoryIntakeForm
     */
    'organInjury'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MedicalHistoryIntakeForm
     */
    'osteoporosis'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MedicalHistoryIntakeForm
     */
    'pulmonaryEmbolism'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MedicalHistoryIntakeForm
     */
    'seizureDisorder'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MedicalHistoryIntakeForm
     */
    'shortnessOfBreath'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MedicalHistoryIntakeForm
     */
    'sinusConditions'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MedicalHistoryIntakeForm
     */
    'stroke'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MedicalHistoryIntakeForm
     */
    'syndromeX'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MedicalHistoryIntakeForm
     */
    'tremors'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MedicalHistoryIntakeForm
     */
    'wheatAllergy'?: boolean;
}
/**
 * 
 * @export
 * @interface Medication
 */
export interface Medication {
    /**
     * 
     * @type {string}
     * @memberof Medication
     */
    'uuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof Medication
     */
    'name'?: string;
}
/**
 * 
 * @export
 * @interface MedicationIntakeForm
 */
export interface MedicationIntakeForm {
    /**
     * 
     * @type {string}
     * @memberof MedicationIntakeForm
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof MedicationIntakeForm
     */
    'dosage'?: string;
    /**
     * 
     * @type {string}
     * @memberof MedicationIntakeForm
     */
    'frequency'?: string;
    /**
     * 
     * @type {string}
     * @memberof MedicationIntakeForm
     */
    'prescribedBy'?: string;
}
/**
 * 
 * @export
 * @interface NoteGenerationRequest
 */
export interface NoteGenerationRequest {
    /**
     * 
     * @type {Array<TranscriptionSegmentRequest>}
     * @memberof NoteGenerationRequest
     */
    'segments'?: Array<TranscriptionSegmentRequest>;
    /**
     * 
     * @type {string}
     * @memberof NoteGenerationRequest
     */
    'noteType'?: NoteGenerationRequestNoteTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof NoteGenerationRequest
     */
    'appointmentId'?: string;
    /**
     * 
     * @type {string}
     * @memberof NoteGenerationRequest
     */
    'patientId'?: string;
    /**
     * 
     * @type {string}
     * @memberof NoteGenerationRequest
     */
    'instructions'?: string;
}

export const NoteGenerationRequestNoteTypeEnum = {
    SimpleSoapNote: 'SIMPLE_SOAP_NOTE',
    PsychiatricNote: 'PSYCHIATRIC_NOTE',
    PrimaryCareSoapNote: 'PRIMARY_CARE_SOAP_NOTE',
    FreeSoapNote: 'FREE_SOAP_NOTE',
    TreatmentPlan: 'TREATMENT_PLAN',
    PsychiatricProgress: 'PSYCHIATRIC_PROGRESS',
    InitialPsychotherapy: 'INITIAL_PSYCHOTHERAPY',
    PsychiatricInitialVisitNote: 'PSYCHIATRIC_INITIAL_VISIT_NOTE',
    PreoperativeNote: 'PREOPERATIVE_NOTE',
    PsychodynamicTherapyNote: 'PSYCHODYNAMIC_THERAPY_NOTE',
    PsychotherapyNote: 'PSYCHOTHERAPY_NOTE',
    CollaborativeCareModel: 'COLLABORATIVE_CARE_MODEL',
    PsychoeducationTherapy: 'PSYCHOEDUCATION_THERAPY',
    DapNote: 'DAP_NOTE',
    BirpNote: 'BIRP_NOTE',
    ProgressNote: 'PROGRESS_NOTE',
    PremierMdInitialF2F: 'PREMIER_MD_INITIAL_F2F',
    PremierMdReadmissionF2F: 'PREMIER_MD_READMISSION_F2F',
    PremierMdRecertificationF2F: 'PREMIER_MD_RECERTIFICATION_F2F',
    PremierMdRocF2F: 'PREMIER_MD_ROC_F2F',
    PremierMdFollowUpF2F: 'PREMIER_MD_FOLLOW_UP_F2F',
    PremierMd30DayF2F: 'PREMIER_MD_30_DAY_F2F',
    PremierMdInitialTelehealth: 'PREMIER_MD_INITIAL_TELEHEALTH',
    PremierMdReadmissionTelehealth: 'PREMIER_MD_READMISSION_TELEHEALTH',
    PremierMdRecertificationTelehealth: 'PREMIER_MD_RECERTIFICATION_TELEHEALTH',
    PremierMdRocTelehealth: 'PREMIER_MD_ROC_TELEHEALTH',
    PremierMd30DayTelehealth: 'PREMIER_MD_30_DAY_TELEHEALTH',
    PremierMdCognitiveVisit: 'PREMIER_MD_COGNITIVE_VISIT',
    PremierMdLabsCommNote: 'PREMIER_MD_LABS_COMM_NOTE'
} as const;

export type NoteGenerationRequestNoteTypeEnum = typeof NoteGenerationRequestNoteTypeEnum[keyof typeof NoteGenerationRequestNoteTypeEnum];

/**
 * 
 * @export
 * @interface ObjectiveDTO
 */
export interface ObjectiveDTO {
    /**
     * 
     * @type {string}
     * @memberof ObjectiveDTO
     */
    'title'?: string;
    /**
     * 
     * @type {Content}
     * @memberof ObjectiveDTO
     */
    'content'?: Content;
}
/**
 * 
 * @export
 * @interface PageMetadata
 */
export interface PageMetadata {
    /**
     * 
     * @type {number}
     * @memberof PageMetadata
     */
    'size'?: number;
    /**
     * 
     * @type {number}
     * @memberof PageMetadata
     */
    'number'?: number;
    /**
     * 
     * @type {number}
     * @memberof PageMetadata
     */
    'totalElements'?: number;
    /**
     * 
     * @type {number}
     * @memberof PageMetadata
     */
    'totalPages'?: number;
}
/**
 * 
 * @export
 * @interface PagedModelAssessmentsEntity
 */
export interface PagedModelAssessmentsEntity {
    /**
     * 
     * @type {Array<AssessmentsEntity>}
     * @memberof PagedModelAssessmentsEntity
     */
    'content'?: Array<AssessmentsEntity>;
    /**
     * 
     * @type {PageMetadata}
     * @memberof PagedModelAssessmentsEntity
     */
    'page'?: PageMetadata;
}
/**
 * 
 * @export
 * @interface PagedModelPatientFormEntity
 */
export interface PagedModelPatientFormEntity {
    /**
     * 
     * @type {Array<PatientFormEntity>}
     * @memberof PagedModelPatientFormEntity
     */
    'content'?: Array<PatientFormEntity>;
    /**
     * 
     * @type {PageMetadata}
     * @memberof PagedModelPatientFormEntity
     */
    'page'?: PageMetadata;
}
/**
 * 
 * @export
 * @interface Patient
 */
export interface Patient {
    /**
     * 
     * @type {string}
     * @memberof Patient
     */
    'uuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof Patient
     */
    'firstName': string;
    /**
     * 
     * @type {string}
     * @memberof Patient
     */
    'lastName': string;
    /**
     * 
     * @type {string}
     * @memberof Patient
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof Patient
     */
    'gender': PatientGenderEnum;
    /**
     * 
     * @type {string}
     * @memberof Patient
     */
    'mobileNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof Patient
     */
    'avatar'?: string;
    /**
     * 
     * @type {string}
     * @memberof Patient
     */
    'timezone': PatientTimezoneEnum;
    /**
     * 
     * @type {string}
     * @memberof Patient
     */
    'race'?: PatientRaceEnum;
    /**
     * 
     * @type {string}
     * @memberof Patient
     */
    'middleName'?: string;
    /**
     * 
     * @type {string}
     * @memberof Patient
     */
    'ethnicity'?: PatientEthnicityEnum;
    /**
     * 
     * @type {string}
     * @memberof Patient
     */
    'ssn'?: string;
    /**
     * 
     * @type {string}
     * @memberof Patient
     */
    'mrn'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Patient
     */
    'emailConsent'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Patient
     */
    'messageConsent'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Patient
     */
    'callConsent'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof Patient
     */
    'registrationDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof Patient
     */
    'birthDate': string;
    /**
     * 
     * @type {Set<EmergencyContact>}
     * @memberof Patient
     */
    'emergencyContacts'?: Set<EmergencyContact>;
    /**
     * 
     * @type {Set<PharmacyStore>}
     * @memberof Patient
     */
    'pharmacyStores'?: Set<PharmacyStore>;
    /**
     * 
     * @type {Set<ReferringAgency>}
     * @memberof Patient
     */
    'referringAgencies'?: Set<ReferringAgency>;
    /**
     * 
     * @type {Set<Lab>}
     * @memberof Patient
     */
    'labs'?: Set<Lab>;
    /**
     * 
     * @type {Set<Radiology>}
     * @memberof Patient
     */
    'radiologies'?: Set<Radiology>;
    /**
     * 
     * @type {Set<PatientInsurance>}
     * @memberof Patient
     */
    'patientInsurances'?: Set<PatientInsurance>;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof Patient
     */
    'providerId'?: { [key: string]: string; };
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof Patient
     */
    'locationId'?: { [key: string]: string; };
    /**
     * 
     * @type {Address}
     * @memberof Patient
     */
    'address'?: Address;
    /**
     * 
     * @type {string}
     * @memberof Patient
     */
    'maritalStatus'?: PatientMaritalStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof Patient
     */
    'faxNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof Patient
     */
    'source'?: string;
    /**
     * 
     * @type {string}
     * @memberof Patient
     */
    'homePhone'?: string;
    /**
     * 
     * @type {string}
     * @memberof Patient
     */
    'errorMessage'?: string;
    /**
     * 
     * @type {string}
     * @memberof Patient
     */
    'lastAppointment'?: string;
    /**
     * 
     * @type {string}
     * @memberof Patient
     */
    'nextAppointment'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Patient
     */
    'active'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Patient
     */
    'archive'?: boolean;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof Patient
     */
    'languages'?: { [key: string]: string; };
    /**
     * 
     * @type {string}
     * @memberof Patient
     */
    'lastLogin'?: string;
    /**
     * 
     * @type {string}
     * @memberof Patient
     */
    'customerId'?: string;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof Patient
     */
    'pharmacyLabRadiology'?: { [key: string]: string; };
    /**
     * 
     * @type {number}
     * @memberof Patient
     */
    'providerNPInumber'?: number;
    /**
     * 
     * @type {string}
     * @memberof Patient
     */
    'providerContactNo'?: string;
    /**
     * 
     * @type {string}
     * @memberof Patient
     */
    'providerEmail'?: string;
    /**
     * 
     * @type {Set<PharmacyLabRadiologyEntity>}
     * @memberof Patient
     */
    'pharmacyLabRadiologyMap'?: Set<PharmacyLabRadiologyEntity>;
    /**
     * 
     * @type {string}
     * @memberof Patient
     */
    'category'?: string;
    /**
     * 
     * @type {number}
     * @memberof Patient
     */
    'val'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof Patient
     */
    'phoneNotAvailable'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Patient
     */
    'emailNotAvailable'?: boolean;
    /**
     * 
     * @type {Set<PatientDocument>}
     * @memberof Patient
     */
    'patientConsentEntities'?: Set<PatientDocument>;
    /**
     * 
     * @type {string}
     * @memberof Patient
     */
    'defaultCommunicationChannel'?: PatientDefaultCommunicationChannelEnum;
    /**
     * 
     * @type {boolean}
     * @memberof Patient
     */
    'isReferral'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof Patient
     */
    'patientScriptsureId'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Patient
     */
    'isScriptSure'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof Patient
     */
    'ecarehealthPatientId'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Patient
     */
    'patientPortalAccess'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Patient
     */
    'credentialGenerated'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Patient
     */
    'eligibilityVerified'?: boolean;
    /**
     * 
     * @type {PatientAssessments}
     * @memberof Patient
     */
    'assessments'?: PatientAssessments;
    /**
     * 
     * @type {boolean}
     * @memberof Patient
     */
    'emailVerified'?: boolean;
}

export const PatientGenderEnum = {
    Male: 'MALE',
    Female: 'FEMALE',
    Unknown: 'UNKNOWN',
    Other: 'OTHER'
} as const;

export type PatientGenderEnum = typeof PatientGenderEnum[keyof typeof PatientGenderEnum];
export const PatientTimezoneEnum = {
    Pst: 'PST',
    Est: 'EST',
    Cst: 'CST',
    Mst: 'MST',
    Ast: 'AST',
    Hst: 'HST',
    Edt: 'EDT',
    Pdt: 'PDT',
    Cdt: 'CDT',
    Adt: 'ADT',
    Mdt: 'MDT',
    Ist: 'IST',
    Akdt: 'AKDT',
    Akst: 'AKST',
    Gmt: 'GMT',
    Utc: 'UTC',
    Wet: 'WET',
    West: 'WEST',
    Cet: 'CET',
    Cest: 'CEST',
    Eet: 'EET',
    Eest: 'EEST',
    Msk: 'MSK',
    Msd: 'MSD',
    Aest: 'AEST',
    Aedt: 'AEDT',
    Acst: 'ACST',
    Acdt: 'ACDT',
    Awst: 'AWST',
    Nzst: 'NZST',
    Nzdt: 'NZDT',
    Sgt: 'SGT',
    Hkt: 'HKT',
    Jst: 'JST',
    Kst: 'KST',
    CstChina: 'CST_CHINA',
    Bdt: 'BDT',
    Pkt: 'PKT',
    IstIran: 'IST_IRAN',
    Trt: 'TRT',
    Idt: 'IDT',
    Wat: 'WAT',
    Cat: 'CAT',
    Eat: 'EAT',
    Art: 'ART',
    Bot: 'BOT',
    Clt: 'CLT',
    Clst: 'CLST',
    Srt: 'SRT',
    Gft: 'GFT',
    Uyt: 'UYT',
    Uyst: 'UYST',
    Vet: 'VET',
    Samt: 'SAMT',
    Yekt: 'YEKT',
    Irkt: 'IRKT',
    Krat: 'KRAT',
    Magt: 'MAGT',
    Pett: 'PETT',
    Vlat: 'VLAT',
    Chot: 'CHOT',
    Ulat: 'ULAT',
    Tmt: 'TMT',
    Orat: 'ORAT',
    Almt: 'ALMT',
    Azt: 'AZT',
    Get: 'GET',
    Mut: 'MUT',
    Sct: 'SCT',
    Ret: 'RET',
    Mvt: 'MVT',
    Cct: 'CCT',
    Sast: 'SAST',
    Nst: 'NST',
    Ndt: 'NDT'
} as const;

export type PatientTimezoneEnum = typeof PatientTimezoneEnum[keyof typeof PatientTimezoneEnum];
export const PatientRaceEnum = {
    AfricanAmerican: 'AFRICAN_AMERICAN',
    AmericanIndian: 'AMERICAN_INDIAN',
    Asian: 'ASIAN',
    AsianIndian: 'ASIAN_INDIAN',
    OtherRace: 'OTHER_RACE',
    AmericanIndianOrAlaskaNative: 'AMERICAN_INDIAN_OR_ALASKA_NATIVE',
    BlackOrAfricanAmerican: 'BLACK_OR_AFRICAN_AMERICAN',
    White: 'WHITE',
    HispanicOrLatino: 'HISPANIC_OR_LATINO',
    NativeHawaiianOrOtherPacificIslander: 'NATIVE_HAWAIIAN_OR_OTHER_PACIFIC_ISLANDER',
    Unknown: 'UNKNOWN'
} as const;

export type PatientRaceEnum = typeof PatientRaceEnum[keyof typeof PatientRaceEnum];
export const PatientEthnicityEnum = {
    CentralAmerican: 'CENTRAL_AMERICAN',
    Cuban: 'CUBAN',
    Dominican: 'DOMINICAN',
    Mexican: 'MEXICAN',
    SouthAmerican: 'SOUTH_AMERICAN',
    HispanicOrLatino: 'HISPANIC_OR_LATINO',
    NotHispanicOrLatino: 'NOT_HISPANIC_OR_LATINO',
    DeclinedToSpecify: 'DECLINED_TO_SPECIFY'
} as const;

export type PatientEthnicityEnum = typeof PatientEthnicityEnum[keyof typeof PatientEthnicityEnum];
export const PatientMaritalStatusEnum = {
    Single: 'SINGLE',
    Married: 'MARRIED',
    Divorced: 'DIVORCED',
    Widowed: 'WIDOWED',
    Separated: 'SEPARATED',
    Unknown: 'UNKNOWN',
    Other: 'OTHER',
    PreferNotToAnswer: 'PREFER_NOT_TO_ANSWER'
} as const;

export type PatientMaritalStatusEnum = typeof PatientMaritalStatusEnum[keyof typeof PatientMaritalStatusEnum];
export const PatientDefaultCommunicationChannelEnum = {
    Sms: 'SMS',
    Email: 'EMAIL',
    EmailAndSms: 'EMAIL_AND_SMS'
} as const;

export type PatientDefaultCommunicationChannelEnum = typeof PatientDefaultCommunicationChannelEnum[keyof typeof PatientDefaultCommunicationChannelEnum];

/**
 * 
 * @export
 * @interface PatientAssessment
 */
export interface PatientAssessment {
    /**
     * 
     * @type {string}
     * @memberof PatientAssessment
     */
    'uuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientAssessment
     */
    'patientId'?: string;
    /**
     * 
     * @type {object}
     * @memberof PatientAssessment
     */
    'responses'?: object;
    /**
     * 
     * @type {string}
     * @memberof PatientAssessment
     */
    'screeningAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientAssessment
     */
    'updateDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientAssessment
     */
    'screeningBy'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientAssessment
     */
    'assessmentName'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientAssessment
     */
    'assessmentStatus'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientAssessment
     */
    'responsiblePerson'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientAssessment
     */
    'submittedBy'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientAssessment
     */
    'providerName'?: string;
}
/**
 * 
 * @export
 * @interface PatientAssessments
 */
export interface PatientAssessments {
    /**
     * 
     * @type {string}
     * @memberof PatientAssessments
     */
    'scheduleTime'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof PatientAssessments
     */
    'assessment'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof PatientAssessments
     */
    'patientIds'?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof PatientAssessments
     */
    'isScheduled'?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof PatientAssessments
     */
    'reminderMedium'?: Array<PatientAssessmentsReminderMediumEnum>;
    /**
     * 
     * @type {Reminder}
     * @memberof PatientAssessments
     */
    'reminders'?: Reminder;
    /**
     * 
     * @type {boolean}
     * @memberof PatientAssessments
     */
    'isRecurring'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PatientAssessments
     */
    'recurringType'?: PatientAssessmentsRecurringTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof PatientAssessments
     */
    'recurringFrequency'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientAssessments
     */
    'endDate'?: string;
    /**
     * 
     * @type {number}
     * @memberof PatientAssessments
     */
    'endAfter'?: number;
    /**
     * 
     * @type {string}
     * @memberof PatientAssessments
     */
    'customFrequency'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientAssessments
     */
    'customFrequencyUnit'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientAssessments
     */
    'providerName'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientAssessments
     */
    'providerRole'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PatientAssessments
     */
    'resend'?: boolean;
}

export const PatientAssessmentsReminderMediumEnum = {
    Email: 'EMAIL',
    PushNotification: 'PUSH_NOTIFICATION',
    Sms: 'SMS'
} as const;

export type PatientAssessmentsReminderMediumEnum = typeof PatientAssessmentsReminderMediumEnum[keyof typeof PatientAssessmentsReminderMediumEnum];
export const PatientAssessmentsRecurringTypeEnum = {
    Daily: 'DAILY',
    Weekly: 'WEEKLY',
    Custom: 'CUSTOM',
    Monthly: 'MONTHLY'
} as const;

export type PatientAssessmentsRecurringTypeEnum = typeof PatientAssessmentsRecurringTypeEnum[keyof typeof PatientAssessmentsRecurringTypeEnum];

/**
 * 
 * @export
 * @interface PatientBalanceCalculation
 */
export interface PatientBalanceCalculation {
    /**
     * 
     * @type {string}
     * @memberof PatientBalanceCalculation
     */
    'superBillId'?: string;
    /**
     * 
     * @type {number}
     * @memberof PatientBalanceCalculation
     */
    'currentPaid'?: number;
}
/**
 * 
 * @export
 * @interface PatientCard
 */
export interface PatientCard {
    /**
     * 
     * @type {string}
     * @memberof PatientCard
     */
    'uuid'?: string;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof PatientCard
     */
    'patient': { [key: string]: string; };
    /**
     * 
     * @type {Address}
     * @memberof PatientCard
     */
    'address'?: Address;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof PatientCard
     */
    'billingProvider'?: { [key: string]: string; };
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof PatientCard
     */
    'billingProviderSpecialities'?: { [key: string]: string; };
    /**
     * 
     * @type {InsurancePayer}
     * @memberof PatientCard
     */
    'insurancePayer'?: InsurancePayer;
    /**
     * 
     * @type {string}
     * @memberof PatientCard
     */
    'paymentMethodId'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientCard
     */
    'cardHolderName'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientCard
     */
    'postalCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientCard
     */
    'country'?: string;
    /**
     * 
     * @type {number}
     * @memberof PatientCard
     */
    'expMonth'?: number;
    /**
     * 
     * @type {number}
     * @memberof PatientCard
     */
    'expYear'?: number;
    /**
     * 
     * @type {string}
     * @memberof PatientCard
     */
    'last4'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientCard
     */
    'displayBrand'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientCard
     */
    'paymentMode'?: PatientCardPaymentModeEnum;
    /**
     * 
     * @type {string}
     * @memberof PatientCard
     */
    'paymentCategory'?: PatientCardPaymentCategoryEnum;
    /**
     * 
     * @type {string}
     * @memberof PatientCard
     */
    'note'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientCard
     */
    'fingerprint'?: string;
    /**
     * 
     * @type {number}
     * @memberof PatientCard
     */
    'amount'?: number;
    /**
     * 
     * @type {number}
     * @memberof PatientCard
     */
    'appliedAmount'?: number;
    /**
     * 
     * @type {number}
     * @memberof PatientCard
     */
    'unappliedAmount'?: number;
    /**
     * 
     * @type {string}
     * @memberof PatientCard
     */
    'transactionId'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientCard
     */
    'chequeId'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientCard
     */
    'bankPaymentMode'?: PatientCardBankPaymentModeEnum;
    /**
     * 
     * @type {string}
     * @memberof PatientCard
     */
    'paymentDate'?: string;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof PatientCard
     */
    'billIds'?: { [key: string]: string; };
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof PatientCard
     */
    'claimIds'?: { [key: string]: string; };
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof PatientCard
     */
    'visitIds'?: { [key: string]: string; };
    /**
     * 
     * @type {string}
     * @memberof PatientCard
     */
    'patientDOB'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientCard
     */
    'patientGender'?: PatientCardPatientGenderEnum;
    /**
     * 
     * @type {string}
     * @memberof PatientCard
     */
    'typeOfPayment'?: PatientCardTypeOfPaymentEnum;
    /**
     * 
     * @type {boolean}
     * @memberof PatientCard
     */
    'primary'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PatientCard
     */
    'active'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PatientCard
     */
    'archive'?: boolean;
}

export const PatientCardPaymentModeEnum = {
    Cash: 'CASH',
    Online: 'ONLINE',
    Bank: 'BANK',
    Check: 'CHECK',
    ApplyCreditBalance: 'APPLY_CREDIT_BALANCE',
    Ach: 'ACH'
} as const;

export type PatientCardPaymentModeEnum = typeof PatientCardPaymentModeEnum[keyof typeof PatientCardPaymentModeEnum];
export const PatientCardPaymentCategoryEnum = {
    Copay: 'COPAY',
    Deductible: 'DEDUCTIBLE',
    Coinsurance: 'COINSURANCE',
    SelfPay: 'SELF_PAY',
    Advance: 'ADVANCE',
    Pr: 'PR',
    OutOfNetwork: 'OUT_OF_NETWORK',
    Invoice: 'INVOICE'
} as const;

export type PatientCardPaymentCategoryEnum = typeof PatientCardPaymentCategoryEnum[keyof typeof PatientCardPaymentCategoryEnum];
export const PatientCardBankPaymentModeEnum = {
    Cheque: 'CHEQUE',
    Rtgs: 'RTGS',
    Neft: 'NEFT'
} as const;

export type PatientCardBankPaymentModeEnum = typeof PatientCardBankPaymentModeEnum[keyof typeof PatientCardBankPaymentModeEnum];
export const PatientCardPatientGenderEnum = {
    Male: 'MALE',
    Female: 'FEMALE',
    Unknown: 'UNKNOWN',
    Other: 'OTHER'
} as const;

export type PatientCardPatientGenderEnum = typeof PatientCardPatientGenderEnum[keyof typeof PatientCardPatientGenderEnum];
export const PatientCardTypeOfPaymentEnum = {
    Patient: 'PATIENT',
    Insurance: 'INSURANCE'
} as const;

export type PatientCardTypeOfPaymentEnum = typeof PatientCardTypeOfPaymentEnum[keyof typeof PatientCardTypeOfPaymentEnum];

/**
 * 
 * @export
 * @interface PatientDiagnosis
 */
export interface PatientDiagnosis {
    /**
     * 
     * @type {string}
     * @memberof PatientDiagnosis
     */
    'uuid'?: string;
    /**
     * 
     * @type {MedicalCode}
     * @memberof PatientDiagnosis
     */
    'medicalCode': MedicalCode;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof PatientDiagnosis
     */
    'patient': { [key: string]: string; };
    /**
     * 
     * @type {string}
     * @memberof PatientDiagnosis
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientDiagnosis
     */
    'diagnosisStatus'?: PatientDiagnosisDiagnosisStatusEnum;
    /**
     * 
     * @type {boolean}
     * @memberof PatientDiagnosis
     */
    'active'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PatientDiagnosis
     */
    'type'?: PatientDiagnosisTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof PatientDiagnosis
     */
    'diagnosedDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientDiagnosis
     */
    'note'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PatientDiagnosis
     */
    'archive'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PatientDiagnosis
     */
    'recordedDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientDiagnosis
     */
    'modifiedDate'?: string;
}

export const PatientDiagnosisDiagnosisStatusEnum = {
    Active: 'ACTIVE',
    Inactive: 'INACTIVE'
} as const;

export type PatientDiagnosisDiagnosisStatusEnum = typeof PatientDiagnosisDiagnosisStatusEnum[keyof typeof PatientDiagnosisDiagnosisStatusEnum];
export const PatientDiagnosisTypeEnum = {
    Chronic: 'CHRONIC',
    Acute: 'ACUTE'
} as const;

export type PatientDiagnosisTypeEnum = typeof PatientDiagnosisTypeEnum[keyof typeof PatientDiagnosisTypeEnum];

/**
 * 
 * @export
 * @interface PatientDocument
 */
export interface PatientDocument {
    /**
     * 
     * @type {string}
     * @memberof PatientDocument
     */
    'uuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientDocument
     */
    'document'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientDocument
     */
    'patient'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientDocument
     */
    'name'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PatientDocument
     */
    'active'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PatientDocument
     */
    'documentType'?: PatientDocumentDocumentTypeEnum;
    /**
     * 
     * @type {boolean}
     * @memberof PatientDocument
     */
    'archive'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PatientDocument
     */
    'assigned'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PatientDocument
     */
    'documentFormat'?: PatientDocumentDocumentFormatEnum;
    /**
     * 
     * @type {string}
     * @memberof PatientDocument
     */
    'patientDocumentTags'?: PatientDocumentPatientDocumentTagsEnum;
    /**
     * 
     * @type {string}
     * @memberof PatientDocument
     */
    'uploadedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientDocument
     */
    'uploadedBy'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientDocument
     */
    'documentDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientDocument
     */
    'documentDescription'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientDocument
     */
    'appointmentId'?: string;
}

export const PatientDocumentDocumentTypeEnum = {
    Avatar: 'AVATAR',
    CustomForm: 'CUSTOM_FORM',
    Insurance: 'INSURANCE',
    IdProof: 'ID_PROOF',
    DrivingLicense: 'DRIVING_LICENSE',
    StateId: 'STATE_ID',
    Passport: 'PASSPORT',
    GreenCardPhoto: 'GREEN_CARD_PHOTO',
    Documents: 'DOCUMENTS',
    LabReport: 'LAB_REPORT',
    LabOrder: 'LAB_ORDER',
    InsuranceCardFront: 'INSURANCE_CARD_FRONT',
    InsuranceCardBack: 'INSURANCE_CARD_BACK',
    InsuranceEligibility: 'INSURANCE_ELIGIBILITY',
    ConsentForm: 'CONSENT_FORM',
    EducationMaterial: 'EDUCATION_MATERIAL',
    LicenseInformation: 'LICENSE_INFORMATION',
    FailDataImportDocuments: 'FAIL_DATA_IMPORT_DOCUMENTS',
    Roi: 'ROI',
    ReferralDocuments: 'REFERRAL_DOCUMENTS',
    PatientConsent: 'PATIENT_CONSENT',
    PriorAuthorization: 'PRIOR_AUTHORIZATION',
    ChatAttachment: 'CHAT_ATTACHMENT',
    MiniCogClock: 'MINI_COG_CLOCK',
    Eob: 'EOB'
} as const;

export type PatientDocumentDocumentTypeEnum = typeof PatientDocumentDocumentTypeEnum[keyof typeof PatientDocumentDocumentTypeEnum];
export const PatientDocumentDocumentFormatEnum = {
    Pdf: 'PDF',
    MsWord: 'MS_WORD',
    Zip: 'ZIP',
    XGzip: 'X_GZIP',
    XCompressed: 'X_COMPRESSED',
    Docx: 'DOCX',
    Rtf: 'RTF',
    Plain: 'PLAIN',
    Xlsx: 'XLSX',
    JpegImage: 'JPEG_IMAGE',
    Mp4: 'MP4',
    PngImage: 'PNG_IMAGE',
    GifImage: 'GIF_IMAGE',
    BmpImage: 'BMP_IMAGE',
    WebpImage: 'WEBP_IMAGE',
    SvgImage: 'SVG_IMAGE',
    MpegAudio: 'MPEG_AUDIO',
    Other: 'OTHER',
    Csv: 'CSV'
} as const;

export type PatientDocumentDocumentFormatEnum = typeof PatientDocumentDocumentFormatEnum[keyof typeof PatientDocumentDocumentFormatEnum];
export const PatientDocumentPatientDocumentTagsEnum = {
    PatientRegistrationForm: 'PATIENT_REGISTRATION_FORM',
    InsuranceInformation: 'INSURANCE_INFORMATION',
    ConsentForm: 'CONSENT_FORM',
    IdAndProofOfAddress: 'ID_AND_PROOF_OF_ADDRESS',
    ProgressNote: 'PROGRESS_NOTE',
    LabReport: 'LAB_REPORT',
    ImagingReport: 'IMAGING_REPORT',
    ConsultationNote: 'CONSULTATION_NOTE',
    SurgeryReport: 'SURGERY_REPORT',
    DischargeSummaries: 'DISCHARGE_SUMMARIES',
    MedicationList: 'MEDICATION_LIST',
    ReferralLetter: 'REFERRAL_LETTER',
    AuthorizationLetter: 'AUTHORIZATION_LETTER',
    Fax: 'FAX',
    EncounterSummary: 'ENCOUNTER_SUMMARY'
} as const;

export type PatientDocumentPatientDocumentTagsEnum = typeof PatientDocumentPatientDocumentTagsEnum[keyof typeof PatientDocumentPatientDocumentTagsEnum];

/**
 * 
 * @export
 * @interface PatientEducationMaterial
 */
export interface PatientEducationMaterial {
    /**
     * 
     * @type {string}
     * @memberof PatientEducationMaterial
     */
    'uuid'?: string;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof PatientEducationMaterial
     */
    'patients'?: { [key: string]: string; };
}
/**
 * 
 * @export
 * @interface PatientEmitEventDTO
 */
export interface PatientEmitEventDTO {
    /**
     * 
     * @type {string}
     * @memberof PatientEmitEventDTO
     */
    'eventKey': string;
    /**
     * 
     * @type {boolean}
     * @memberof PatientEmitEventDTO
     */
    'videoStatus'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PatientEmitEventDTO
     */
    'audioStatus'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof PatientEmitEventDTO
     */
    'network'?: number;
    /**
     * 
     * @type {number}
     * @memberof PatientEmitEventDTO
     */
    'mbps'?: number;
    /**
     * 
     * @type {string}
     * @memberof PatientEmitEventDTO
     */
    'appointmentUuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientEmitEventDTO
     */
    'name'?: string;
}
/**
 * 
 * @export
 * @interface PatientFlags
 */
export interface PatientFlags {
    /**
     * 
     * @type {string}
     * @memberof PatientFlags
     */
    'uuid'?: string;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof PatientFlags
     */
    'flags'?: { [key: string]: string; };
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof PatientFlags
     */
    'patient'?: { [key: string]: string; };
    /**
     * 
     * @type {boolean}
     * @memberof PatientFlags
     */
    'active'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PatientFlags
     */
    'archive'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PatientFlags
     */
    'created'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientFlags
     */
    'modified'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientFlags
     */
    'flagColour'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientFlags
     */
    'userName'?: string;
}
/**
 * 
 * @export
 * @interface PatientFormEntity
 */
export interface PatientFormEntity {
    /**
     * 
     * @type {string}
     * @memberof PatientFormEntity
     */
    'createdBy'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientFormEntity
     */
    'modifiedBy'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientFormEntity
     */
    'created'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientFormEntity
     */
    'modified'?: string;
    /**
     * 
     * @type {number}
     * @memberof PatientFormEntity
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof PatientFormEntity
     */
    'uuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientFormEntity
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientFormEntity
     */
    'status'?: PatientFormEntityStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof PatientFormEntity
     */
    'submittedOn'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientFormEntity
     */
    'submittedBy'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientFormEntity
     */
    'sendOn'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientFormEntity
     */
    'sendBy'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientFormEntity
     */
    'patientId'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientFormEntity
     */
    'appointmentId'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientFormEntity
     */
    'content'?: string;
}

export const PatientFormEntityStatusEnum = {
    Pending: 'PENDING',
    Completed: 'COMPLETED',
    Scheduled: 'SCHEDULED'
} as const;

export type PatientFormEntityStatusEnum = typeof PatientFormEntityStatusEnum[keyof typeof PatientFormEntityStatusEnum];

/**
 * 
 * @export
 * @interface PatientInquiryStatusUpdate
 */
export interface PatientInquiryStatusUpdate {
    /**
     * 
     * @type {string}
     * @memberof PatientInquiryStatusUpdate
     */
    'status'?: PatientInquiryStatusUpdateStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof PatientInquiryStatusUpdate
     */
    'rejectReason'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PatientInquiryStatusUpdate
     */
    'isWidgetApproved'?: boolean;
}

export const PatientInquiryStatusUpdateStatusEnum = {
    Pending: 'PENDING',
    Confirmed: 'CONFIRMED',
    Rejected: 'REJECTED'
} as const;

export type PatientInquiryStatusUpdateStatusEnum = typeof PatientInquiryStatusUpdateStatusEnum[keyof typeof PatientInquiryStatusUpdateStatusEnum];

/**
 * 
 * @export
 * @interface PatientInsurance
 */
export interface PatientInsurance {
    /**
     * 
     * @type {string}
     * @memberof PatientInsurance
     */
    'uuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientInsurance
     */
    'planName'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientInsurance
     */
    'groupId'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientInsurance
     */
    'groupName'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientInsurance
     */
    'frontPhoto'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientInsurance
     */
    'backPhoto'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientInsurance
     */
    'memberId'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientInsurance
     */
    'faxNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientInsurance
     */
    'phoneNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientInsurance
     */
    'insuredRelationshipWithPatient'?: PatientInsuranceInsuredRelationshipWithPatientEnum;
    /**
     * 
     * @type {string}
     * @memberof PatientInsurance
     */
    'insuredRelationshipWithPatientLabel'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientInsurance
     */
    'insuranceType'?: PatientInsuranceInsuranceTypeEnum;
    /**
     * 
     * @type {Address}
     * @memberof PatientInsurance
     */
    'address'?: Address;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof PatientInsurance
     */
    'patient'?: { [key: string]: string; };
    /**
     * 
     * @type {InsurancePayer}
     * @memberof PatientInsurance
     */
    'insurancePayer'?: InsurancePayer;
    /**
     * 
     * @type {string}
     * @memberof PatientInsurance
     */
    'insuredFirstName'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientInsurance
     */
    'insuredLastName'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientInsurance
     */
    'planId'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientInsurance
     */
    'insuredGender'?: PatientInsuranceInsuredGenderEnum;
    /**
     * 
     * @type {string}
     * @memberof PatientInsurance
     */
    'insuredBirthDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientInsurance
     */
    'effectiveStartDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientInsurance
     */
    'effectiveEndDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientInsurance
     */
    'coPay'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientInsurance
     */
    'orderOfBenefits'?: PatientInsuranceOrderOfBenefitsEnum;
    /**
     * 
     * @type {string}
     * @memberof PatientInsurance
     */
    'insuranceId'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientInsurance
     */
    'copayType'?: PatientInsuranceCopayTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof PatientInsurance
     */
    'coInsurance'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientInsurance
     */
    'authorizations'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientInsurance
     */
    'coverageLevel'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientInsurance
     */
    'claimNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientInsurance
     */
    'note'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientInsurance
     */
    'employerName'?: string;
    /**
     * 
     * @type {Address}
     * @memberof PatientInsurance
     */
    'employerAddress'?: Address;
    /**
     * 
     * @type {string}
     * @memberof PatientInsurance
     */
    'subscriberFirstName'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientInsurance
     */
    'subscriberLastName'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientInsurance
     */
    'subscriberMiddleName'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientInsurance
     */
    'subscriberSsn'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientInsurance
     */
    'subscriberGender'?: PatientInsuranceSubscriberGenderEnum;
    /**
     * 
     * @type {string}
     * @memberof PatientInsurance
     */
    'subscriberBirthDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientInsurance
     */
    'subscriberMobileNumber'?: string;
    /**
     * 
     * @type {Address}
     * @memberof PatientInsurance
     */
    'subscriberAddress'?: Address;
    /**
     * 
     * @type {boolean}
     * @memberof PatientInsurance
     */
    'active'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PatientInsurance
     */
    'planType'?: PatientInsurancePlanTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof PatientInsurance
     */
    'coverageType'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientInsurance
     */
    'deductibleAmount'?: string;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof PatientInsurance
     */
    'provider'?: { [key: string]: string; };
    /**
     * 
     * @type {Set<InsurancePlan>}
     * @memberof PatientInsurance
     */
    'insurancePlans'?: Set<InsurancePlan>;
    /**
     * 
     * @type {string}
     * @memberof PatientInsurance
     */
    'networkStatus'?: PatientInsuranceNetworkStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof PatientInsurance
     */
    'verificationStatus'?: PatientInsuranceVerificationStatusEnum;
    /**
     * 
     * @type {number}
     * @memberof PatientInsurance
     */
    'copayAmount'?: number;
    /**
     * 
     * @type {number}
     * @memberof PatientInsurance
     */
    'coInsuranceAmount'?: number;
    /**
     * 
     * @type {number}
     * @memberof PatientInsurance
     */
    'deductible'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof PatientInsurance
     */
    'priorAuthorization'?: boolean;
}

export const PatientInsuranceInsuredRelationshipWithPatientEnum = {
    Self: 'SELF',
    Associate: 'ASSOCIATE',
    CareGiver: 'CARE_GIVER',
    Child: 'CHILD',
    EmergencyContact: 'EMERGENCY_CONTACT',
    Employee: 'EMPLOYEE',
    Employer: 'EMPLOYER',
    ExtendedFamily: 'EXTENDED_FAMILY',
    Father: 'FATHER',
    FosterChild: 'FOSTER_CHILD',
    Friend: 'FRIEND',
    Grandchild: 'GRANDCHILD',
    Grandparent: 'GRANDPARENT',
    Guardian: 'GUARDIAN',
    HandicappedDependent: 'HANDICAPPED_DEPENDENT',
    LifePartner: 'LIFE_PARTNER',
    Manager: 'MANAGER',
    Mother: 'MOTHER',
    NaturalChild: 'NATURAL_CHILD',
    None: 'NONE',
    Other: 'OTHER',
    OtherAdult: 'OTHER_ADULT',
    Owner: 'OWNER',
    Parent: 'PARENT',
    Sibling: 'SIBLING',
    Sister: 'SISTER',
    Spouse: 'SPOUSE',
    Stepchild: 'STEPCHILD',
    Trainer: 'TRAINER',
    Unknown: 'UNKNOWN',
    WardOfCourt: 'WARD_OF_COURT'
} as const;

export type PatientInsuranceInsuredRelationshipWithPatientEnum = typeof PatientInsuranceInsuredRelationshipWithPatientEnum[keyof typeof PatientInsuranceInsuredRelationshipWithPatientEnum];
export const PatientInsuranceInsuranceTypeEnum = {
    Primary: 'PRIMARY',
    Secondary: 'SECONDARY',
    Tertiary: 'TERTIARY',
    Other: 'OTHER'
} as const;

export type PatientInsuranceInsuranceTypeEnum = typeof PatientInsuranceInsuranceTypeEnum[keyof typeof PatientInsuranceInsuranceTypeEnum];
export const PatientInsuranceInsuredGenderEnum = {
    Male: 'MALE',
    Female: 'FEMALE',
    Unknown: 'UNKNOWN',
    Other: 'OTHER'
} as const;

export type PatientInsuranceInsuredGenderEnum = typeof PatientInsuranceInsuredGenderEnum[keyof typeof PatientInsuranceInsuredGenderEnum];
export const PatientInsuranceOrderOfBenefitsEnum = {
    Primary: 'PRIMARY',
    Secondary: 'SECONDARY',
    Ternary: 'TERNARY',
    Other: 'OTHER'
} as const;

export type PatientInsuranceOrderOfBenefitsEnum = typeof PatientInsuranceOrderOfBenefitsEnum[keyof typeof PatientInsuranceOrderOfBenefitsEnum];
export const PatientInsuranceCopayTypeEnum = {
    Fixed: 'FIXED',
    Percentage: 'PERCENTAGE'
} as const;

export type PatientInsuranceCopayTypeEnum = typeof PatientInsuranceCopayTypeEnum[keyof typeof PatientInsuranceCopayTypeEnum];
export const PatientInsuranceSubscriberGenderEnum = {
    Male: 'MALE',
    Female: 'FEMALE',
    Unknown: 'UNKNOWN',
    Other: 'OTHER'
} as const;

export type PatientInsuranceSubscriberGenderEnum = typeof PatientInsuranceSubscriberGenderEnum[keyof typeof PatientInsuranceSubscriberGenderEnum];
export const PatientInsurancePlanTypeEnum = {
    Ppo: 'PPO',
    Hmo: 'HMO',
    Medicare: 'MEDICARE',
    Dental: 'DENTAL',
    Vision: 'VISION',
    Hsa: 'HSA',
    Private: 'PRIVATE',
    Epo: 'EPO',
    Pos: 'POS',
    Other: 'OTHER',
    Medicaid: 'MEDICAID',
    WorkersCompensation: 'WORKERS_COMPENSATION',
    BehavioralHealth: 'BEHAVIORAL_HEALTH',
    MotorVehicle: 'MOTOR_VEHICLE',
    Uninsured: 'UNINSURED'
} as const;

export type PatientInsurancePlanTypeEnum = typeof PatientInsurancePlanTypeEnum[keyof typeof PatientInsurancePlanTypeEnum];
export const PatientInsuranceNetworkStatusEnum = {
    InNetwork: 'IN_NETWORK',
    OutOfNetwork: 'OUT_OF_NETWORK'
} as const;

export type PatientInsuranceNetworkStatusEnum = typeof PatientInsuranceNetworkStatusEnum[keyof typeof PatientInsuranceNetworkStatusEnum];
export const PatientInsuranceVerificationStatusEnum = {
    Done: 'DONE',
    Pending: 'PENDING',
    InProgress: 'IN_PROGRESS'
} as const;

export type PatientInsuranceVerificationStatusEnum = typeof PatientInsuranceVerificationStatusEnum[keyof typeof PatientInsuranceVerificationStatusEnum];

/**
 * 
 * @export
 * @interface PatientInsuranceClaims
 */
export interface PatientInsuranceClaims {
    /**
     * 
     * @type {string}
     * @memberof PatientInsuranceClaims
     */
    'uuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientInsuranceClaims
     */
    'planName'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientInsuranceClaims
     */
    'groupId'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientInsuranceClaims
     */
    'groupName'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientInsuranceClaims
     */
    'memberId'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientInsuranceClaims
     */
    'faxNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientInsuranceClaims
     */
    'phoneNumber'?: string;
    /**
     * 
     * @type {InsurancePayer}
     * @memberof PatientInsuranceClaims
     */
    'insurancePayer'?: InsurancePayer;
    /**
     * 
     * @type {string}
     * @memberof PatientInsuranceClaims
     */
    'insuredFirstName'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientInsuranceClaims
     */
    'insuredLastName'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientInsuranceClaims
     */
    'planId'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientInsuranceClaims
     */
    'insuredGender'?: PatientInsuranceClaimsInsuredGenderEnum;
    /**
     * 
     * @type {string}
     * @memberof PatientInsuranceClaims
     */
    'coPay'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientInsuranceClaims
     */
    'insuranceId'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientInsuranceClaims
     */
    'claimNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientInsuranceClaims
     */
    'planType'?: PatientInsuranceClaimsPlanTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof PatientInsuranceClaims
     */
    'networkStatus'?: PatientInsuranceClaimsNetworkStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof PatientInsuranceClaims
     */
    'verificationStatus'?: PatientInsuranceClaimsVerificationStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof PatientInsuranceClaims
     */
    'effectiveEndDate'?: string;
}

export const PatientInsuranceClaimsInsuredGenderEnum = {
    Male: 'MALE',
    Female: 'FEMALE',
    Unknown: 'UNKNOWN',
    Other: 'OTHER'
} as const;

export type PatientInsuranceClaimsInsuredGenderEnum = typeof PatientInsuranceClaimsInsuredGenderEnum[keyof typeof PatientInsuranceClaimsInsuredGenderEnum];
export const PatientInsuranceClaimsPlanTypeEnum = {
    Ppo: 'PPO',
    Hmo: 'HMO',
    Medicare: 'MEDICARE',
    Dental: 'DENTAL',
    Vision: 'VISION',
    Hsa: 'HSA',
    Private: 'PRIVATE',
    Epo: 'EPO',
    Pos: 'POS',
    Other: 'OTHER',
    Medicaid: 'MEDICAID',
    WorkersCompensation: 'WORKERS_COMPENSATION',
    BehavioralHealth: 'BEHAVIORAL_HEALTH',
    MotorVehicle: 'MOTOR_VEHICLE',
    Uninsured: 'UNINSURED'
} as const;

export type PatientInsuranceClaimsPlanTypeEnum = typeof PatientInsuranceClaimsPlanTypeEnum[keyof typeof PatientInsuranceClaimsPlanTypeEnum];
export const PatientInsuranceClaimsNetworkStatusEnum = {
    InNetwork: 'IN_NETWORK',
    OutOfNetwork: 'OUT_OF_NETWORK'
} as const;

export type PatientInsuranceClaimsNetworkStatusEnum = typeof PatientInsuranceClaimsNetworkStatusEnum[keyof typeof PatientInsuranceClaimsNetworkStatusEnum];
export const PatientInsuranceClaimsVerificationStatusEnum = {
    Done: 'DONE',
    Pending: 'PENDING',
    InProgress: 'IN_PROGRESS'
} as const;

export type PatientInsuranceClaimsVerificationStatusEnum = typeof PatientInsuranceClaimsVerificationStatusEnum[keyof typeof PatientInsuranceClaimsVerificationStatusEnum];

/**
 * 
 * @export
 * @interface PatientIntakeForm
 */
export interface PatientIntakeForm {
    /**
     * 
     * @type {string}
     * @memberof PatientIntakeForm
     */
    'uuid'?: string;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof PatientIntakeForm
     */
    'patient'?: { [key: string]: string; };
    /**
     * 
     * @type {string}
     * @memberof PatientIntakeForm
     */
    'content'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientIntakeForm
     */
    'appointment'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientIntakeForm
     */
    'formId'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PatientIntakeForm
     */
    'active'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PatientIntakeForm
     */
    'archive'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PatientIntakeForm
     */
    'formName'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientIntakeForm
     */
    'sendBy'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientIntakeForm
     */
    'sendOn'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientIntakeForm
     */
    'submittedOn'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientIntakeForm
     */
    'activeSections'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientIntakeForm
     */
    'filledForms'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientIntakeForm
     */
    'submissionMethod'?: string;
}
/**
 * 
 * @export
 * @interface PatientIntakeFormRequest
 */
export interface PatientIntakeFormRequest {
    /**
     * 
     * @type {string}
     * @memberof PatientIntakeFormRequest
     */
    'firstName'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientIntakeFormRequest
     */
    'lastName'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientIntakeFormRequest
     */
    'gender'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientIntakeFormRequest
     */
    'phoneNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientIntakeFormRequest
     */
    'email'?: string;
    /**
     * 
     * @type {Address}
     * @memberof PatientIntakeFormRequest
     */
    'address'?: Address;
    /**
     * 
     * @type {string}
     * @memberof PatientIntakeFormRequest
     */
    'city'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientIntakeFormRequest
     */
    'state'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientIntakeFormRequest
     */
    'zipCode'?: string;
    /**
     * 
     * @type {InsuranceIntakeForm}
     * @memberof PatientIntakeFormRequest
     */
    'primary'?: InsuranceIntakeForm;
    /**
     * 
     * @type {InsuranceIntakeForm}
     * @memberof PatientIntakeFormRequest
     */
    'secondary'?: InsuranceIntakeForm;
    /**
     * 
     * @type {AllergiesIntakeForm}
     * @memberof PatientIntakeFormRequest
     */
    'allergies'?: AllergiesIntakeForm;
    /**
     * 
     * @type {string}
     * @memberof PatientIntakeFormRequest
     */
    'allergiesNote'?: string;
    /**
     * 
     * @type {Array<FamilyHistoryIntakeForm>}
     * @memberof PatientIntakeFormRequest
     */
    'familyHistory'?: Array<FamilyHistoryIntakeForm>;
    /**
     * 
     * @type {SocialHistoryIntakeForm}
     * @memberof PatientIntakeFormRequest
     */
    'socialHistory'?: SocialHistoryIntakeForm;
    /**
     * 
     * @type {string}
     * @memberof PatientIntakeFormRequest
     */
    'socialHistoryNote'?: string;
    /**
     * 
     * @type {Array<SurgicalHistoryIntakeForm>}
     * @memberof PatientIntakeFormRequest
     */
    'surgicalHistory'?: Array<SurgicalHistoryIntakeForm>;
    /**
     * 
     * @type {MedicalHistoryIntakeForm}
     * @memberof PatientIntakeFormRequest
     */
    'medicalHistory'?: MedicalHistoryIntakeForm;
    /**
     * 
     * @type {string}
     * @memberof PatientIntakeFormRequest
     */
    'medicalHistoryNote'?: string;
    /**
     * 
     * @type {Array<MedicationIntakeForm>}
     * @memberof PatientIntakeFormRequest
     */
    'medications'?: Array<MedicationIntakeForm>;
    /**
     * 
     * @type {string}
     * @memberof PatientIntakeFormRequest
     */
    'hippaConsentSign'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientIntakeFormRequest
     */
    'physicianPatientArbitrationAgreementSign'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientIntakeFormRequest
     */
    'medicalServicesAgreementSign'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PatientIntakeFormRequest
     */
    'hippaConsent'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PatientIntakeFormRequest
     */
    'medicalServicesAgreement'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PatientIntakeFormRequest
     */
    'medicalServicesAgreementDate'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PatientIntakeFormRequest
     */
    'physicianPatientArbitrationAgreement'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PatientIntakeFormRequest
     */
    'consent'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PatientIntakeFormRequest
     */
    'birthDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientIntakeFormRequest
     */
    'sex'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientIntakeFormRequest
     */
    'socialSecurity'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientIntakeFormRequest
     */
    'mobileNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientIntakeFormRequest
     */
    'maritalStatus'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientIntakeFormRequest
     */
    'otherSocialHistory'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientIntakeFormRequest
     */
    'leaveMessage'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientIntakeFormRequest
     */
    'discussWithFamily'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PatientIntakeFormRequest
     */
    'primaryInsurance'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PatientIntakeFormRequest
     */
    'secondaryInsurance'?: boolean;
}
/**
 * 
 * @export
 * @interface PatientLabResult
 */
export interface PatientLabResult {
    /**
     * 
     * @type {string}
     * @memberof PatientLabResult
     */
    'uuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientLabResult
     */
    'note'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientLabResult
     */
    'abnormalFlag'?: PatientLabResultAbnormalFlagEnum;
    /**
     * 
     * @type {string}
     * @memberof PatientLabResult
     */
    'resultValue'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PatientLabResult
     */
    'active'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PatientLabResult
     */
    'archive'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PatientLabResult
     */
    'labDocument'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientLabResult
     */
    'uploadedAt'?: string;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof PatientLabResult
     */
    'patient'?: { [key: string]: string; };
    /**
     * 
     * @type {string}
     * @memberof PatientLabResult
     */
    'labDescription'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientLabResult
     */
    'recordedDate'?: string;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof PatientLabResult
     */
    'patientOrder'?: { [key: string]: string; };
    /**
     * 
     * @type {string}
     * @memberof PatientLabResult
     */
    'fileName'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientLabResult
     */
    'orderType'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientLabResult
     */
    'createdByName'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientLabResult
     */
    'reviewer'?: string;
}

export const PatientLabResultAbnormalFlagEnum = {
    BelowLowNormal: 'BELOW_LOW_NORMAL',
    BelowLowerPanicLimits: 'BELOW_LOWER_PANIC_LIMITS',
    AboveUpperPanicLimits: 'ABOVE_UPPER_PANIC_LIMITS'
} as const;

export type PatientLabResultAbnormalFlagEnum = typeof PatientLabResultAbnormalFlagEnum[keyof typeof PatientLabResultAbnormalFlagEnum];

/**
 * 
 * @export
 * @interface PatientMedication
 */
export interface PatientMedication {
    /**
     * 
     * @type {string}
     * @memberof PatientMedication
     */
    'uuid'?: string;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof PatientMedication
     */
    'patient': { [key: string]: string; };
    /**
     * 
     * @type {Medication}
     * @memberof PatientMedication
     */
    'medication'?: Medication;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof PatientMedication
     */
    'medicationId'?: { [key: string]: string; };
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof PatientMedication
     */
    'medicalCodes'?: { [key: string]: string; };
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof PatientMedication
     */
    'prescribedBy'?: { [key: string]: string; };
    /**
     * 
     * @type {string}
     * @memberof PatientMedication
     */
    'note'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PatientMedication
     */
    'active'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PatientMedication
     */
    'archive'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PatientMedication
     */
    'medicationStartDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientMedication
     */
    'medicationLastDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientMedication
     */
    'quantity'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientMedication
     */
    'direction'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientMedication
     */
    'unit'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientMedication
     */
    'dosage'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientMedication
     */
    'dosageWhen'?: PatientMedicationDosageWhenEnum;
    /**
     * 
     * @type {string}
     * @memberof PatientMedication
     */
    'duration'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientMedication
     */
    'refills'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientMedication
     */
    'startDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientMedication
     */
    'frequency'?: PatientMedicationFrequencyEnum;
    /**
     * 
     * @type {string}
     * @memberof PatientMedication
     */
    'modifiedDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientMedication
     */
    'appointmentId'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientMedication
     */
    'providerStatus'?: PatientMedicationProviderStatusEnum;
    /**
     * 
     * @type {boolean}
     * @memberof PatientMedication
     */
    'lifeTime'?: boolean;
}

export const PatientMedicationDosageWhenEnum = {
    BeforeMeal: 'BEFORE_MEAL',
    WithMeal: 'WITH_MEAL',
    AfterMeal: 'AFTER_MEAL',
    InTheMorning: 'IN_THE_MORNING',
    AfternoonMeal: 'AFTERNOON_MEAL',
    Bedtime: 'BEDTIME',
    Prn: 'PRN'
} as const;

export type PatientMedicationDosageWhenEnum = typeof PatientMedicationDosageWhenEnum[keyof typeof PatientMedicationDosageWhenEnum];
export const PatientMedicationFrequencyEnum = {
    EveryTwoHours: 'EVERY_TWO_HOURS',
    EveryFourHours: 'EVERY_FOUR_HOURS',
    EverySixHours: 'EVERY_SIX_HOURS',
    EveryEightHours: 'EVERY_EIGHT_HOURS',
    EveryTenHours: 'EVERY_TEN_HOURS',
    EveryDay: 'EVERY_DAY',
    TwiceADay: 'TWICE_A_DAY',
    ThriceADay: 'THRICE_A_DAY',
    Weekly: 'WEEKLY',
    EveryOtherDay: 'EVERY_OTHER_DAY',
    ThreeTimeWeekly: 'THREE_TIME_WEEKLY',
    FourTimeWeekly: 'FOUR_TIME_WEEKLY'
} as const;

export type PatientMedicationFrequencyEnum = typeof PatientMedicationFrequencyEnum[keyof typeof PatientMedicationFrequencyEnum];
export const PatientMedicationProviderStatusEnum = {
    Pending: 'PENDING',
    Confirmed: 'CONFIRMED'
} as const;

export type PatientMedicationProviderStatusEnum = typeof PatientMedicationProviderStatusEnum[keyof typeof PatientMedicationProviderStatusEnum];

/**
 * 
 * @export
 * @interface PatientMultipleFlagsRequest
 */
export interface PatientMultipleFlagsRequest {
    /**
     * 
     * @type {string}
     * @memberof PatientMultipleFlagsRequest
     */
    'patientUuid'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof PatientMultipleFlagsRequest
     */
    'flagUuids'?: Array<string>;
}
/**
 * 
 * @export
 * @interface PatientNotificationPreference
 */
export interface PatientNotificationPreference {
    /**
     * 
     * @type {string}
     * @memberof PatientNotificationPreference
     */
    'uuid'?: string;
    /**
     * 
     * @type {number}
     * @memberof PatientNotificationPreference
     */
    'notificationTypeId'?: number;
    /**
     * 
     * @type {string}
     * @memberof PatientNotificationPreference
     */
    'notificationTypeName'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientNotificationPreference
     */
    'category'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PatientNotificationPreference
     */
    'push'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PatientNotificationPreference
     */
    'text'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PatientNotificationPreference
     */
    'email'?: boolean;
}
/**
 * 
 * @export
 * @interface PatientOrder
 */
export interface PatientOrder {
    /**
     * 
     * @type {string}
     * @memberof PatientOrder
     */
    'uuid'?: string;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof PatientOrder
     */
    'patient'?: { [key: string]: string; };
    /**
     * 
     * @type {string}
     * @memberof PatientOrder
     */
    'lab'?: string;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof PatientOrder
     */
    'medicalCodes'?: { [key: string]: string; };
    /**
     * 
     * @type {string}
     * @memberof PatientOrder
     */
    'created'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PatientOrder
     */
    'archive'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PatientOrder
     */
    'active'?: boolean;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof PatientOrder
     */
    'tests'?: { [key: string]: string; };
    /**
     * 
     * @type {string}
     * @memberof PatientOrder
     */
    'patientInstruction'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientOrder
     */
    'labInstruction'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientOrder
     */
    'collectionDateTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientOrder
     */
    'reminderTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientOrder
     */
    'billType'?: PatientOrderBillTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof PatientOrder
     */
    'orderType'?: PatientOrderOrderTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof PatientOrder
     */
    'appointmentId'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientOrder
     */
    'providerStatus'?: PatientOrderProviderStatusEnum;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof PatientOrder
     */
    'provider'?: { [key: string]: string; };
    /**
     * 
     * @type {string}
     * @memberof PatientOrder
     */
    'providerName'?: string;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof PatientOrder
     */
    'orderingProvider'?: { [key: string]: string; };
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof PatientOrder
     */
    'primaryProvider'?: { [key: string]: string; };
    /**
     * 
     * @type {Array<PatientLabResult>}
     * @memberof PatientOrder
     */
    'labResults'?: Array<PatientLabResult>;
    /**
     * 
     * @type {string}
     * @memberof PatientOrder
     */
    'imagingCenter'?: string;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof PatientOrder
     */
    'labs'?: { [key: string]: string; };
    /**
     * 
     * @type {string}
     * @memberof PatientOrder
     */
    'appointmentDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientOrder
     */
    'orderStatus'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientOrder
     */
    'orderTitle'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientOrder
     */
    'orderFormType'?: PatientOrderOrderFormTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof PatientOrder
     */
    'orderFormTypeLabel'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientOrder
     */
    'imagingLabName'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientOrder
     */
    'userName'?: string;
    /**
     * 
     * @type {Address}
     * @memberof PatientOrder
     */
    'labAddress'?: Address;
    /**
     * 
     * @type {string}
     * @memberof PatientOrder
     */
    'providerGroupName'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientOrder
     */
    'practiceNpi'?: string;
    /**
     * 
     * @type {Address}
     * @memberof PatientOrder
     */
    'patientAddress'?: Address;
    /**
     * 
     * @type {string}
     * @memberof PatientOrder
     */
    'ssn'?: string;
    /**
     * 
     * @type {number}
     * @memberof PatientOrder
     */
    'providerNpi'?: number;
    /**
     * 
     * @type {string}
     * @memberof PatientOrder
     */
    'insuranceName'?: string;
}

export const PatientOrderBillTypeEnum = {
    Patient: 'PATIENT',
    Provider: 'PROVIDER',
    Insurance: 'INSURANCE'
} as const;

export type PatientOrderBillTypeEnum = typeof PatientOrderBillTypeEnum[keyof typeof PatientOrderBillTypeEnum];
export const PatientOrderOrderTypeEnum = {
    Lab: 'LAB',
    Imaging: 'IMAGING',
    Prescription: 'PRESCRIPTION'
} as const;

export type PatientOrderOrderTypeEnum = typeof PatientOrderOrderTypeEnum[keyof typeof PatientOrderOrderTypeEnum];
export const PatientOrderProviderStatusEnum = {
    Pending: 'PENDING',
    Confirmed: 'CONFIRMED'
} as const;

export type PatientOrderProviderStatusEnum = typeof PatientOrderProviderStatusEnum[keyof typeof PatientOrderProviderStatusEnum];
export const PatientOrderOrderFormTypeEnum = {
    Electronic: 'ELECTRONIC',
    Paper: 'PAPER'
} as const;

export type PatientOrderOrderFormTypeEnum = typeof PatientOrderOrderFormTypeEnum[keyof typeof PatientOrderOrderFormTypeEnum];

/**
 * 
 * @export
 * @interface PatientProcedureCode
 */
export interface PatientProcedureCode {
    /**
     * 
     * @type {string}
     * @memberof PatientProcedureCode
     */
    'uuid'?: string;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof PatientProcedureCode
     */
    'procedureCode'?: { [key: string]: string; };
    /**
     * 
     * @type {string}
     * @memberof PatientProcedureCode
     */
    'type'?: PatientProcedureCodeTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof PatientProcedureCode
     */
    'diagnosisFirstPointers'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientProcedureCode
     */
    'diagnosisSecondPointers'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientProcedureCode
     */
    'diagnosisThirdPointers'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientProcedureCode
     */
    'diagnosisFourthPointers'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientProcedureCode
     */
    'medicalCodeModifiers'?: string;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof PatientProcedureCode
     */
    'modifiers'?: { [key: string]: string; };
    /**
     * 
     * @type {number}
     * @memberof PatientProcedureCode
     */
    'quantity'?: number;
    /**
     * 
     * @type {number}
     * @memberof PatientProcedureCode
     */
    'total'?: number;
    /**
     * 
     * @type {number}
     * @memberof PatientProcedureCode
     */
    'charges'?: number;
    /**
     * 
     * @type {number}
     * @memberof PatientProcedureCode
     */
    'discount'?: number;
    /**
     * 
     * @type {string}
     * @memberof PatientProcedureCode
     */
    'discountType'?: PatientProcedureCodeDiscountTypeEnum;
    /**
     * 
     * @type {boolean}
     * @memberof PatientProcedureCode
     */
    'active'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PatientProcedureCode
     */
    'archive'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PatientProcedureCode
     */
    'patientProcedureCodeType'?: PatientProcedureCodePatientProcedureCodeTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof PatientProcedureCode
     */
    'insurancePaid'?: number;
    /**
     * 
     * @type {number}
     * @memberof PatientProcedureCode
     */
    'writeOff'?: number;
    /**
     * 
     * @type {number}
     * @memberof PatientProcedureCode
     */
    'patientResponsibility'?: number;
    /**
     * 
     * @type {number}
     * @memberof PatientProcedureCode
     */
    'copay'?: number;
    /**
     * 
     * @type {number}
     * @memberof PatientProcedureCode
     */
    'coInsurance'?: number;
    /**
     * 
     * @type {number}
     * @memberof PatientProcedureCode
     */
    'deductible'?: number;
    /**
     * 
     * @type {number}
     * @memberof PatientProcedureCode
     */
    'adjustment'?: number;
    /**
     * 
     * @type {string}
     * @memberof PatientProcedureCode
     */
    'writeOffType'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientProcedureCode
     */
    'adjustmentType'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientProcedureCode
     */
    'comments'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PatientProcedureCode
     */
    'denied'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PatientProcedureCode
     */
    'denialCode'?: string;
    /**
     * 
     * @type {number}
     * @memberof PatientProcedureCode
     */
    'allowedAmount'?: number;
    /**
     * 
     * @type {number}
     * @memberof PatientProcedureCode
     */
    'contractAdjustment'?: number;
    /**
     * 
     * @type {number}
     * @memberof PatientProcedureCode
     */
    'otherAdjustment'?: number;
    /**
     * 
     * @type {number}
     * @memberof PatientProcedureCode
     */
    'remainingBalance'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof PatientProcedureCode
     */
    'posted'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PatientProcedureCode
     */
    'postingStatus'?: PatientProcedureCodePostingStatusEnum;
}

export const PatientProcedureCodeTypeEnum = {
    Cpt: 'CPT',
    Icd: 'ICD',
    Hcpcs: 'HCPCS',
    Loinc: 'LOINC',
    PayerCatalog: 'PAYER_CATALOG',
    Patient: 'PATIENT',
    Provider: 'PROVIDER',
    LabTest: 'LAB_TEST',
    ImagingStudy: 'IMAGING_STUDY',
    DrugCatalog: 'DRUG_CATALOG'
} as const;

export type PatientProcedureCodeTypeEnum = typeof PatientProcedureCodeTypeEnum[keyof typeof PatientProcedureCodeTypeEnum];
export const PatientProcedureCodeDiscountTypeEnum = {
    Percentage: 'PERCENTAGE',
    Amount: 'AMOUNT'
} as const;

export type PatientProcedureCodeDiscountTypeEnum = typeof PatientProcedureCodeDiscountTypeEnum[keyof typeof PatientProcedureCodeDiscountTypeEnum];
export const PatientProcedureCodePatientProcedureCodeTypeEnum = {
    Claim: 'CLAIM',
    SuperBill: 'SUPER_BILL'
} as const;

export type PatientProcedureCodePatientProcedureCodeTypeEnum = typeof PatientProcedureCodePatientProcedureCodeTypeEnum[keyof typeof PatientProcedureCodePatientProcedureCodeTypeEnum];
export const PatientProcedureCodePostingStatusEnum = {
    Unpaid: 'UNPAID',
    Paid: 'PAID',
    Denied: 'DENIED'
} as const;

export type PatientProcedureCodePostingStatusEnum = typeof PatientProcedureCodePostingStatusEnum[keyof typeof PatientProcedureCodePostingStatusEnum];

/**
 * 
 * @export
 * @interface PatientQuestionAnswer
 */
export interface PatientQuestionAnswer {
    /**
     * 
     * @type {string}
     * @memberof PatientQuestionAnswer
     */
    'uuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientQuestionAnswer
     */
    'answer'?: string;
    /**
     * 
     * @type {Question}
     * @memberof PatientQuestionAnswer
     */
    'question': Question;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof PatientQuestionAnswer
     */
    'patient': { [key: string]: string; };
    /**
     * 
     * @type {boolean}
     * @memberof PatientQuestionAnswer
     */
    'active'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PatientQuestionAnswer
     */
    'archive'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PatientQuestionAnswer
     */
    'notes'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientQuestionAnswer
     */
    'appointmentId'?: string;
}
/**
 * 
 * @export
 * @interface PatientQuestionAnswerRequest
 */
export interface PatientQuestionAnswerRequest {
    /**
     * 
     * @type {Array<PatientQuestionAnswer>}
     * @memberof PatientQuestionAnswerRequest
     */
    'patientQuestionAnswers'?: Array<PatientQuestionAnswer>;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof PatientQuestionAnswerRequest
     */
    'patient': { [key: string]: string; };
    /**
     * 
     * @type {string}
     * @memberof PatientQuestionAnswerRequest
     */
    'socialHistoryType'?: PatientQuestionAnswerRequestSocialHistoryTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof PatientQuestionAnswerRequest
     */
    'appointmentId'?: string;
}

export const PatientQuestionAnswerRequestSocialHistoryTypeEnum = {
    HomeAndEnvironment: 'HOME_AND_ENVIRONMENT',
    SubstanceUse: 'SUBSTANCE_USE',
    EducationAndOccupation: 'EDUCATION_AND_OCCUPATION',
    Lifestyle: 'LIFESTYLE',
    MarriageAndSexuality: 'MARRIAGE_AND_SEXUALITY',
    AdvanceDirective: 'ADVANCE_DIRECTIVE',
    DietAndExercise: 'DIET_AND_EXERCISE',
    PublicHealthAndTravel: 'PUBLIC_HEALTH_AND_TRAVEL',
    ActivitiesOfDailyLiving: 'ACTIVITIES_OF_DAILY_LIVING',
    Covid19VaccineScreening: 'COVID_19_VACCINE_SCREENING',
    MigrationFrom123121: 'MIGRATION_FROM_123121',
    Psychiatry: 'PSYCHIATRY',
    HomeCareSubstanceUse: 'HOME_CARE_SUBSTANCE_USE'
} as const;

export type PatientQuestionAnswerRequestSocialHistoryTypeEnum = typeof PatientQuestionAnswerRequestSocialHistoryTypeEnum[keyof typeof PatientQuestionAnswerRequestSocialHistoryTypeEnum];

/**
 * 
 * @export
 * @interface PatientQuestionnaireExportRequest
 */
export interface PatientQuestionnaireExportRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof PatientQuestionnaireExportRequest
     */
    'questionnaireIds'?: Array<string>;
}
/**
 * 
 * @export
 * @interface PatientRunningNote
 */
export interface PatientRunningNote {
    /**
     * 
     * @type {string}
     * @memberof PatientRunningNote
     */
    'uuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientRunningNote
     */
    'providerName'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientRunningNote
     */
    'noteDateTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientRunningNote
     */
    'providerId'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientRunningNote
     */
    'noteDescription'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientRunningNote
     */
    'patientId'?: string;
}
/**
 * 
 * @export
 * @interface PatientScreener
 */
export interface PatientScreener {
    /**
     * 
     * @type {string}
     * @memberof PatientScreener
     */
    'uuid'?: string;
    /**
     * 
     * @type {Array<ScreenerQuestionAnwer>}
     * @memberof PatientScreener
     */
    'screenerQuestion': Array<ScreenerQuestionAnwer>;
    /**
     * 
     * @type {string}
     * @memberof PatientScreener
     */
    'appointmentId': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof PatientScreener
     */
    'answer'?: Array<PatientScreenerAnswerEnum>;
    /**
     * 
     * @type {string}
     * @memberof PatientScreener
     */
    'screenerType'?: PatientScreenerScreenerTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof PatientScreener
     */
    'screenerTypeString'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientScreener
     */
    'submittedBy'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientScreener
     */
    'providerName'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientScreener
     */
    'providerRole'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientScreener
     */
    'patientDob'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientScreener
     */
    'actionId'?: string;
}

export const PatientScreenerAnswerEnum = {
    NotAtAll: 'Not at all',
    Never: 'Never',
    AlmostNever: 'Almost never',
    ALittle: 'A little',
    ALittleBit: 'A little bit',
    Rarely: 'Rarely',
    Occasionally: 'Occasionally',
    Sometimes: 'Sometimes',
    SeveralDays: 'Several days',
    SomeOfTheTime: 'Some of the time',
    HalfTheTime: 'Half the time',
    MoreThanHalfTheTime: 'More than half the time',
    MoreThanHalfTheDays: 'More than half the days',
    Often: 'Often',
    QuiteOften: 'Quite often',
    QuiteABit: 'Quite a bit',
    FairlyOften: 'Fairly often',
    Frequently: 'Frequently',
    MostOfTheTime: 'Most of the time',
    VeryOften: 'Very often',
    AlmostAlways: 'Almost always',
    NearlyEveryDay: 'Nearly every day',
    AlmostEveryDay: 'Almost every day',
    ALot: 'A lot',
    ALotOfTheTime: 'A lot of the time',
    AllTheTime: 'All the time',
    AllOfTheTime: 'All of the time',
    AlmostAllOfTheTime: 'Almost all of the time',
    ALittleOfTheTime: 'A little of the time',
    HardlyEver: 'Hardly ever',
    Always: 'Always',
    EveryDay: 'Every day',
    NoDays: 'NO DAYS',
    _15Days: '1-5 DAYS',
    _612Days: '6-12 DAYS',
    _1315Days: '13-15 DAYS',
    _1622Days: '16-22 DAYS',
    _2327Days: '23-27 DAYS',
    EveryDay2: 'EVERY DAY',
    VeryRarely: 'Very Rarely',
    VeryFrequently: 'Very Frequently',
    Extremely: 'Extremely',
    Excellent: 'Excellent',
    VeryGood: 'Very Good',
    Good: 'Good',
    Poor: 'Poor',
    Fair: 'Fair',
    SomewhatAgree: 'Somewhat Agree',
    SomewhatDisagree: 'Somewhat Disagree',
    FeelsCompletelyUntrue: 'Feels Completely Untrue',
    FeelsMostlyUntrue: 'Feels Mostly Untrue',
    FeelsSlightlyUntrue: 'Feels Slightly Untrue',
    FeelsCompletelyTrue: 'Feels Completely True',
    FeelsSlightlyTrue: 'Feels Slightly True',
    NeitherTrueNorUntrue: 'Neither True Nor Untrue',
    Yes: 'Yes',
    No: 'No',
    DefinitelyDisagree: 'Definitely Disagree',
    StronglyDisagree: 'Strongly Disagree',
    StronglyDisagree2: 'Strongly disagree',
    Disagree: 'Disagree',
    SlightlyDisagree: 'Slightly disagree',
    SlightlyDisagree2: 'Slightly Disagree',
    NeitherAgreeNorDisagree: 'Neither agree nor disagree',
    Neutral: 'Neutral',
    SlightlyAgree: 'Slightly agree',
    SlightlyAgree2: 'Slightly Agree',
    Agree: 'Agree',
    StronglyAgree: 'Strongly Agree',
    StronglyAgree2: 'Strongly agree',
    DefinitelyAgree: 'Definitely Agree',
    DefinitelyFalse: 'Definitely False',
    ProbablyFalse: 'Probably False',
    MostlyFalse: 'Mostly False',
    SomewhatFalse: 'Somewhat False',
    SlightlyFalse: 'Slightly False',
    SlightlyTrue: 'Slightly True',
    SomewhatTrue: 'Somewhat True',
    MostlyTrue: 'Mostly True',
    ProbablyTrue: 'Probably True',
    DefinitelyTrue: 'Definitely True',
    _1: '1',
    _2: '2',
    _3: '3',
    _4: '4',
    _5: '5',
    _6: '6',
    _7: '7',
    _8: '8',
    _9: '9',
    _10: '10',
    OnceOrTwice: 'Once or twice',
    ThreeToSixTimes: 'Three to six times',
    SevenToTenTimes: 'Seven to ten times',
    DailyOrAlmostDaily: 'Daily or almost daily',
    Moderately: 'Moderately',
    Somewhat: 'Somewhat',
    VeryMuch: 'Very much',
    Completely: 'Completely',
    NeverTrue: 'Never true',
    NotTrue: 'Not True',
    VerySeldomTrue: 'Very seldom true',
    SeldomTrue: 'Seldom true',
    SometimesTrue: 'Sometimes true',
    FrequentlyTrue: 'Frequently true',
    AlmostAlwaysTrue: 'Almost always true',
    AlwaysTrue: 'Always true',
    VeryTrue: 'Very True',
    NotAtAllLikeMe: 'Not at all like me',
    SlightlyLikeMe: 'Slightly like me',
    SomewhatLikeMe: 'Somewhat like me',
    ModeratelyLikeMe: 'Moderately like me',
    VeryMuchLikeMe: 'Very much like me',
    NoPain: 'No pain',
    MildPain: 'Mild pain',
    ModeratePain: 'Moderate pain',
    SeverePain: 'Severe pain',
    WorstPossiblePain: 'Worst possible pain',
    MonthlyOrLess: 'Monthly or less',
    TwoToFourTimesAMonth: 'Two to four times a month',
    TwoToThreeTimesAWeek: 'Two to three times a week',
    FourOrMoreTimesAWeek: 'Four or more times a week',
    LessThanOnceAWeek: 'less than once a week',
    OnceAWeekOrMore: 'once a week or more',
    Usually: 'Usually',
    YesAlways: 'Yes, always',
    LessThanADayOrTwo: 'Less than a day or two',
    NearlyAlways: 'Nearly Always',
    DoesNotMatchMyExperienceAtAll: 'Does not match my experience at all',
    ProbablyDoesNotMatchMyExperience: 'Probably does not match my experience',
    ProbablyMatchesMyExperience: 'Probably matches my experience',
    DefinitelyMatchesMyExperience: 'Definitely matches my experience',
    WasOnMedication: 'was on medication',
    WasNotOnMedication: 'was not on medication',
    NotSure: 'not sure?',
    TomabaMedicamentos: 'tomaba medicamentos',
    NoTomabaMedicamentos: 'no tomaba medicamentos',
    NoLoRecuerda: 'no lo recuerda',
    NotPresent: 'Not present',
    Equivocal: 'Equivocal',
    PresentButMild: 'Present, but mild',
    PresentAndModerate: 'Present and moderate',
    PresentAndSevere: 'Present and severe',
    NoneSlight: 'None/slight',
    Mild: 'Mild',
    Moderate: 'Moderate',
    Severe: 'Severe',
    Extreme: 'Extreme',
    VerySevere: 'Very severe',
    Mildly: 'Mildly',
    VerySlightly: 'Very slightly',
    NoAnxietyInThePastWeek: 'No anxiety in the past week.',
    InfrequentAnxietyFeltAnxiousAFewTimes: 'Infrequent anxiety. Felt anxious a few times.',
    OccasionalAnxietyFeltAnxiousAsMuchOfTheTimeAsNotItWasHardToRelax: 'Occasional anxiety. Felt anxious as much of the time as not. It was hard to relax.',
    FrequentAnxietyFeltAnxiousMostOfTheTimeItWasVeryDifficultToRelax: 'Frequent anxiety. Felt anxious most of the time. It was very difficult to relax.',
    ConstantAnxietyFeltAnxiousAllOfTheTimeAndNeverReallyRelaxed: 'Constant anxiety. Felt anxious all of the time and never really relaxed.',
    NoDepressionInThePastWeek: 'No depression in the past week.',
    InfrequentDepressionFeltDepressedAFewTimes: 'Infrequent depression. Felt depressed a few times.',
    OccasionalDepressionFeltDepressedAsMuchOfTheTimeAsNot: 'Occasional depression. Felt depressed as much of the time as not',
    FrequentDepressionFeltDepressedMostOfTheTime: 'Frequent depression. Felt depressed most of the time.',
    ConstantDepressionFeltDepressedAllOfTheTime: 'Constant depression. Felt depressed all of the time.',
    CertainlyTrue: 'Certainly true',
    Never0Times: 'Never (0 times)',
    Sometimes510TimesOr12TimesPerDay: 'Sometimes (5-10 times or 1-2 times per day)',
    Often1120TimesOr23TimesPerDay: 'Often (11-20 times or 2-3 times per day)',
    ThereIsNoEvidenceOfPhysicalOrMedicalProblems: 'There is no evidence of physical or medical problems.',
    MildOrWellManagedPhysicalOrMedicalProblemsAreIndicatedAPersonInNeedOfAPhysicalMedicalExaminationWouldBeRatedHere: 'Mild or well-managed physical or medical problems are indicated. A person in need of a physical/medical examination would be rated here.',
    ChronicPhysicalOrModerateMedicalProblemsArePresent: 'Chronic physical or moderate medical problems are present.',
    SevereLifeThreateningPhysicalOrMedicalConditionExists: 'Severe, life threatening physical or medical condition exists.',
    IDoNotFeelHappierOrMoreCheerfulThanUsual: 'I do not feel happier or more cheerful than usual.',
    IOccasionallyFeelHappierOrMoreCheerfulThanUsual: 'I occasionally feel happier or more cheerful than usual.',
    IOftenFeelHappierOrMoreCheerfulThanUsual: 'I often feel happier or more cheerful than usual.',
    IFeelHappierOrMoreCheerfulThanUsualMostOfTheTime: 'I feel happier or more cheerful than usual most of the time.',
    IFeelHappierOrMoreCheerfulThanUsualAllOfTheTime: 'I feel happier or more cheerful than usual all of the time.',
    _0Nil: '0 - Nil',
    _1MildBriefOrTransientPeriodsOfDepressionOrMildlyDepressedMood: '1 - Mild [brief or transient periods of depression, or mildly depressed mood]',
    _2ModerateDepressedMoodIsClearlyButNotConsistentlyPresentAndOtherEmotionsAreExpressedOrDepressionIsOfModerateIntensity: '2 - Moderate [depressed mood is clearly but not consistently present and other emotions are expressed, or depression is of moderate intensity]',
    _3SeverePervasiveOrContinuousDepressedMoodOfMarkedIntensity: '3 - Severe [pervasive or continuous depressed mood of marked intensity]',
    IDontFeelSelfConsciousAboutMyWeightOrBodySizeWhenImWithOthers: 'I don\'t feel self-conscious about my weight or body size when I\'m with others.',
    IFeelConcernedAboutHowILookToOthersButItNormallyDoesNotMakeMeFeelDisappointedWithMyself: 'I feel concerned about how I look to others, but it normally does not make me feel disappointed with myself.',
    IDoGetSelfConsciousAboutMyAppearanceAndWeightWhichMakesMeFeelDisappointedInMyself: 'I do get self-conscious about my appearance and weight which makes me feel disappointed in myself.',
    IFeelVerySelfConsciousAboutMyWeightAndFrequentlyIFeelIntenseShameAndDisgustForMyselfITryToAvoidSocialContactsBecauseOfMySelfConsciousness: 'I feel very self-conscious about my weight and frequently, I feel intense shame and disgust for myself. I try to avoid social contacts because of my self-consciousness.',
    MostTimesTrue: 'Most times true',
    BarelyTrue: 'Barely true',
    ExactlyTrue: 'Exactly true',
    NotAtAllCharacteristicOfMe: 'Not at all characteristic of me',
    ALittleCharacteristicOfMe: 'A little characteristic of me',
    SomewhatCharacteristicOfMe: 'Somewhat characteristic of me',
    VeryCharacteristicOfMe: 'Very characteristic of me',
    EntirelyCharacteristicOfMe: 'Entirely characteristic of me',
    SlightlyCharacteristicOrTrueOfMe: 'Slightly characteristic or true of me',
    VeryCharacteristicOrTrueOfMe: 'Very characteristic or true of me',
    SlightlyTypicalOfMe: 'Slightly typical of me',
    VeryTypicalOfMe: 'Very typical of me',
    FeelsMostlyTrue: 'Feels mostly true',
    HalfOfTheTime: 'Half of the time',
    Daily: 'Daily',
    True: 'True',
    False: 'False',
    FairlyTrue: 'FAIRLY TRUE',
    DidNotApplyToMeAtAll: 'Did not apply to me at all',
    AppliedToMeToAConsiderableDegreeOrAGoodPartOfTheTime: 'Applied to me to a considerable degree, or a good part of the time',
    NeverDidNotApplyToMeAtAll: 'Never- Did not apply to me at all',
    OftenAppliedToMeAConsiderableDegreeOrAGoodPartOfTheTime: 'Often- Applied to me a considerable degree, or a good part of the time',
    AsMuchAsIAlwaysCould: 'As much as I always could',
    NotQuiteSoMuchNow: 'Not quite so much now',
    DefinitelyNotSoMuchNow: 'Definitely not so much now',
    Slight: 'Slight',
    Slightly: 'Slightly',
    Very: 'Very',
    RareLessThanADayOrTwo: 'Rare, less than a day or two',
    SlightRareLessThanADayOrTwo: 'Slight - Rare, less than a day or two',
    NoneNotAtAll: 'None - Not at all',
    MildSeveralDays: 'Mild - Several days',
    ModerateMoreThanHalfTheDays: 'Moderate - More than half the days',
    SevereNearlyEveryDay: 'Severe - Nearly every day',
    MoreThanHalfTheDays2: 'More than half the days',
    Nunca: 'Nunca',
    Siempre: 'Siempre',
    AVeces: 'A veces',
    MuchasVeces: 'Muchas veces',
    CasiNunca: 'Casi nunca',
    CasiSiempreOSiempreEsCierto: 'Casi siempre o siempre es cierto',
    CasiNuncaONuncaEsCierto: 'Casi nunca o nunca es cierto',
    AlgunasVecesEsCierto: 'Algunas veces es cierto',
    BastantesVeces: 'Bastantes veces',
    NotTrueAtAll: 'Not true at all',
    OnceAMonth: 'Once a month',
    VeryLittle: 'Very little',
    None: 'None',
    Totally: 'Totally',
    AlmostNeverOrNever: 'Almost never or never',
    AlmostAlwaysOrAlways: 'Almost always or always',
    ExtremeDifficultyOrCannotDo: 'Extreme Difficulty or Cannot Do',
    OnceDuringTheMonth: 'Once during the month',
    SeveralTimesDuringTheMonth: 'Several times during the month',
    SeveralTimesAWeek: 'Several times a week',
    NeverUsed: 'Never used',
    SometimesUsed: 'Sometimes used',
    RegularlyUsed: 'Regularly used',
    LessThanMonthly: 'Less than monthly',
    AboutOnceAWeek: 'About once a week',
    AboutOnceADay: 'About once a day',
    About2Or3TimesAWeek: 'About 2 or 3 times a week',
    AboutHalfOfTheTime: 'About half of the time',
    LessThan1Month: 'Less than 1 month',
    LessThan6MonthsAgo: 'Less than 6 months ago',
    _1To5YearsAgo: '1 to 5 years ago',
    _5To10YearsAgo: '5 to 10 years ago',
    _10To20YearsAgo: '10 to 20 years ago',
    _10Years: '10+ years',
    LessThanOnceAMonth: 'Less than once a month',
    OnceAWeekOrLess: 'Once a week or less',
    OnceAWeekOrLessOnceInAWhile: 'Once a week or less / once in a while',
    SometimesButNotFrequently: 'Sometimes but not frequently',
    ACurrentProblem: 'A current problem',
    AMajorProblem: 'A major problem',
    AModerateAmount: 'A moderate amount',
    AGreatDeal: 'A great deal',
    MostMuch: 'Most/Much',
    AlmostAllComplete: 'Almost all/Complete',
    IDoNotWorryAboutMyHealth: 'I do not worry about my health.',
    ISpendMuchOfMyTimeWorryingAboutMyHealth: 'I spend much of my time worrying about my health.',
    ISpendMostOfMyTimeWorryingAboutMyHealth: 'I spend most of my time worrying about my health.',
    ICanBeEitherCheerfulOrSadDependingOnTheCircumstances: 'I can be either cheerful or sad, depending on the circumstances.',
    IFeelThoroughlyLowAndGloomyEvenThingsThatNormallyCheerMeUpGiveMeNoPleasure: 'I feel thoroughly low and gloomy. Even things that normally cheer me up give me no pleasure.',
    IFeelSoUtterlyLowAndMiserableThatICanImagineNothingWorse: 'I feel so utterly low and miserable, that I can imagine nothing worse.',
    NeutralMixed: 'Neutral / Mixed',
    TrueOnlyWhenIWasYoungerThan16: 'True only when I was younger than 16',
    TrueOnlyNow: 'True only now',
    TrueNowWhenIWasYoung: 'True now & when I was young',
    _0Nil2: '0 - Nil',
    _1MildBriefOrTransientPeriodsOfDepressionOrMildlyDepressedMood2: '1 - Mild [brief or transient periods of depression, or mildly depressed mood]',
    _2ModerateDepressedMoodIsClearlyButNotConsistentlyPresentAndOtherEmotionsAreExpressedOrDepressionIsOfModerateIntensity2: '2 - Moderate [depressed mood is clearly but not consistently present and other emotions are expressed, or depression is of moderate intensity]',
    _3SeverePervasiveOrContinuousDepressedMoodOfMarkedIntensity2: '3 - Severe [pervasive or continuous depressed mood of marked intensity]',
    Vomiting: 'vomiting',
    SourBelching: 'sour belching',
    Heartburn: 'heartburn',
    Nausea: 'nausea',
    Diarrhea: 'diarrhea',
    FlatulenceGassing: 'flatulence (gassing)',
    FoulOdorFeces: 'foul-odor feces',
    BladderProblemsUrinaryIncontinence: 'bladder problems / urinary incontinence',
    HairLoss: 'hair loss',
    GallstonesOrGallbladderRemoved: 'gallstones (or gallbladder removed)',
    Diabetes: 'diabetes',
    HighBloodPressureHypertensionAlsoIfTreated: 'high blood pressure / hypertension (also if treated)',
    AsthmaSleepApnea: 'asthma / sleep apnea',
    ArthrosisJointPain: 'arthrosis / joint pain',
    Gout: 'gout',
    Other: 'other',
    DoesNotDescribeMeAtAll: 'Does not describe me at all',
    DoesNotDescribeMe: 'Does not describe me ',
    DescribesMe: 'Describes me',
    DescribesMeVeryWell: 'Describes me very well',
    NoMeDescribeEnAbsoluto: 'No me describe en absoluto',
    MeDescribePoco: 'Me describe poco',
    NiPocoNiMucho: 'Ni poco ni mucho',
    MeDescribeBastante: 'Me describe bastante',
    MeDescribeMuyBien: 'Me describe muy bien',
    ALot2: 'A lot ',
    _0NoPain: '0 (No Pain)',
    _10WorstPainImaginable: '10 (Worst Pain Imaginable)',
    ToASlightDegree: 'To a slight degree',
    ToAModerateDegree: 'To a moderate degree',
    ToAGreatDegree: 'To a great degree',
    Spouse: 'Spouse',
    PartnerCompanion: 'Partner/Companion',
    HousemateRoomate: 'Housemate/Roomate',
    Friend: 'Friend',
    Neighbor: 'Neighbor',
    ParentChildOtherRelative: 'Parent/Child/Other relative',
    VeryRarelyTrue: 'Very rarely true',
    OftenTrue: 'Often true',
    NotAtAllNever: 'Not at All/Never',
    AllOfTheTime2: 'All of the time ',
    IStronglyAgree: 'I strongly agree',
    ISomewhatAgree: 'I somewhat agree',
    ISomewhatDisagree: 'I somewhat disagree',
    DisagreeCompletely: 'Disagree completely',
    DisagreeStrongly: 'Disagree strongly ',
    DisagreeSomewhat: 'Disagree somewhat',
    AgreeSomewhat: 'Agree somewhat',
    AgreeStrongly: 'Agree strongly',
    AgreeCompletely: 'Agree completely',
    Rather: 'Rather',
    Much: 'Much',
    VeryStrong: 'Very strong',
    _0: '0%',
    _0Days: '0 days',
    _0Never: '0 (Never)',
    _0NotAtAllHappy: '0 (Not at all happy)',
    _0NoSatisfactionAtAll: '0 (No satisfaction at all) ',
    _0OfTheTime: '0% of the time',
    _102: '10%',
    _100: '100%',
    _100150Lbs: '100-150 lbs',
    _100Lbs: '<100 lbs',
    _100OfTheTime: '100% of the time',
    _10Always: '10 (Always)',
    _10CompletelySatisfied: '10 (Completely Satisfied) ',
    _10OfTheTime: '10% of the time',
    _10VeryVeryHappy: '10 (Very, very happy)',
    _150200Lbs: '150-200 lbs',
    _12Days: '1-2 days',
    _12Months: '1-2 months',
    _12TimesAWeek: '1-2 times a week',
    _12Years: '1-2 years',
    _13TimesAMonth: '1-3 times a month',
    _20: '20%',
    _200250Lbs: '200-250 lbs',
    _20OfTheTime: '20% of the time',
    _250300Lbs: '250-300 lbs',
    _23Months: '2-3 months',
    _23TimesAWeek: '2-3 times a week',
    _24TimesAMonth: '2-4 times a month',
    _25Years: '2-5 years',
    _2To4TimesAWeekHalfTheTime: '2 to 4 times a week / half the time',
    _30: '30%',
    _300350Lbs: '300-350 lbs',
    _30OfTheTime: '30% of the time',
    _350400Lbs: '350-400 lbs',
    _34Days: '3-4 days',
    _35Days: '3-5 days',
    _36Months: '3-6 months',
    _36TimesAWeek: '3-6 times a week',
    _40: '40%',
    _400450Lbs: '400-450 lbs',
    _40OfTheTime: '40% of the time',
    _450500Lbs: '450-500 lbs',
    _4OrMoreTimesOrDaily: '4 or more times or daily',
    _50: '50%',
    _500550Lbs: '500-550 lbs',
    _50OfTheTime: '50% of the time',
    _550600Lbs: '550-600 lbs',
    _510Years: '5-10 years',
    _56Days: '5-6 days',
    _5OrMoreTimesAWeekAlmostAlways: '5 or more times a week / almost always',
    _60: '60%',
    _600Lbs: '>600 lbs',
    _60OfTheTime: '60% of the time',
    _612Months: '6-12 months',
    _67Days: '6-7 days',
    _6Month: '6-month',
    _6To12MonthsAgo: '6 to 12 months ago',
    _70: '70%',
    _70OfTheTime: '70% of the time',
    _80: '80%',
    _80OfTheTime: '80% of the time',
    _90: '90%',
    _90OfTheTime: '90% of the time',
    AboutHalfTheTime: 'About half the time',
    AboutHalfTheTime3665: 'About half the time (36-65%)',
    AdminImmediateDischarge: 'Admin/immediate discharge',
    Admission: 'Admission',
    AgreeAndDisagreeEqually: 'Agree and Disagree Equally',
    AlmostAllTheTime: 'Almost all the time',
    AlmostAlways91100: 'Almost always (91-100%)',
    AlmostAlwaysAgree: 'Almost Always Agree',
    AlmostAlwaysDisagree: 'Almost Always Disagree',
    AlmostNever010: 'Almost never (0-10%)',
    AlmostNeverLessThanOnceAMonth: 'Almost never (less than once a month)',
    AlwaysAgree: 'Always Agree',
    AlwaysDisagree: 'Always Disagree',
    AppliedToMeToSomeDegreeOrSomeOfTheTime: 'Applied to me to some degree, or some of the time',
    AppliedToMeVeryMuchOrMostOfTheTime: 'Applied to me very much, or most of the time',
    AtLeastEveryDay: 'At least every day',
    ABit: 'A bit',
    AFewTimesLessThanHalfTheTime: 'A few times (less than half the time)',
    ALittleTrue: 'A LITTLE TRUE',
    ALittleTypicalOfMe: 'A little typical of me',
    ALittleUnhappy: 'A little unhappy',
    BangedOrPunchedObjectsToThePointOfBruisingOrBleeding: 'Banged or punched objects to the point of bruising or bleeding',
    BittenYourselfToThePointThatBleedingOccursOrMarksRemainOnTheSkin: 'Bitten yourself to the point that bleeding occurs or marks remain on the skin',
    BotheredALittle: 'Bothered a little',
    BotheredALot: 'Bothered a lot',
    BurnedWristsHandsArmsLegsTorsoOrOtherAreasOfTheBody: 'Burned wrists, hands, arms, legs, torso or other areas of the body',
    CarvedWordsOrSymbolsIntoTheSkin: 'Carved words or symbols into the skin',
    CompletelyTrue: 'Completely true',
    CutWristsArmsLegsTorsoOrOtherAreasOfTheBody: 'Cut wrists, arms, legs, torso or other areas of the body',
    DisagreeStrongly2: 'Disagree Strongly',
    Dislike: 'Dislike',
    DrippedAcidOnToSkin: 'Dripped acid on to skin',
    EngagedInFightingOrOtherAggressiveActivitiesWithTheIntentionOfGettingHurt: 'Engaged in fighting or other aggressive activities with the intention of getting hurt',
    Enjoy: 'Enjoy',
    Everyday: 'Everyday',
    ExtremelyCharacteristicOrTrueOfMe: 'Extremely characteristic or true of me',
    ExtremelyHappy: 'Extremely happy',
    ExtremelyImportant: 'Extremely Important ',
    ExtremelyUnhappy: 'Extremely unhappy',
    ExtremeRiskOfHarmExampleCurrentSuicidalOrHomicidalBehaviorOrSuchIntentionsWithAPlanAndAvailableMeansToCarryOutThisBehavior: 'Extreme risk of harm (example: current suicidal or homicidal behavior or such intentions with a plan and available means to carry out this behavior)',
    FairlyUnhappy: 'Fairly unhappy',
    FrequentlyDisagree: 'Frequently Disagree',
    HaceDosSemanas: 'Hace dos semanas',
    HaceSeisMeses: 'Hace seis meses',
    HaceTresMeses: 'Hace tres meses',
    HaceUnAo: 'Hace un año',
    HaceUnMes: 'Hace un mes',
    Happy: 'Happy',
    IngestedACausticSubstanceSOrSharpObjectSDranoOtherCleaningSubstancesPinsEtc: 'Ingested a caustic substance(s) or sharp object(s) (Drano, other cleaning substances, pins, etc)',
    IntentionallyPreventedWoundsFromHealing: 'Intentionally prevented wounds from healing',
    IDontKnow: 'I don\'t know',
    IDoThisOkSometimes: 'I do this ok; sometimes',
    IDoThisPoorlyRarelyOrNotAtAll: 'I do this poorly; rarely, or not at all',
    IDoThisWellOften: 'I do this well; often',
    IFeelABitLowForTheMostPartThoughSometimesItEasesUpALittle: 'I feel a bit low for the most part, though sometimes it eases up a little.',
    IHaveMissedTakingMyMedicationSFiveOrMoreDays: 'I have missed taking my medication(s) five or more days.',
    IHaveMissedTakingMyMedicationSOneDay: 'I have missed taking my medication(s) one day.',
    IHaveMissedTakingMyMedicationSThreeOrFourDays: 'I have missed taking my medication(s) three or four days.',
    IHaveMissedTakingMyMedicationSTwoDays: 'I have missed taking my medication(s) two days.',
    IHaveStoppedTakingMyMedicationS: 'I have stopped taking my medication(s).',
    IHaveTakenMyMedicationSEveryDayWithoutMissingADay: 'I have taken my medication(s) every day without missing a day.',
    IOccasionallyWorryAboutMyHealth: 'I occasionally worry about my health.',
    IStronglyDisagree: 'I strongly disagree',
    IWouldLikeToWorkOnThisIncreaseTheFrequencyOfThis: 'I would like to work on this, increase the frequency of this',
    LaSemanaPasada: 'La semana pasada',
    LessThanHalfOfTheTime: 'Less than half of the time',
    LessThanHalfTheTime: 'Less than half the time',
    LowRiskOfHarmExampleNoCurrentSuicidalOrHomicidalIdeationPlanIntentionsOrSevereDistressButMayHaveHadTransientOrPassiveThoughtsRecentlyOrInThePast: 'Low risk of harm (example: no current suicidal or homicidal ideation, plan, intentions or severe distress, but may have had transient or passive thoughts recently or in the past)',
    MildlyAgree: 'Mildly Agree',
    MildlyDisagree: 'Mildly Disagree',
    MinimalRiskOfHarmExampleNoIndicationOfSuicidalOrHomicidalThoughtsOrImpulsesAndNoHistoryOfSuicidalOrHomicidalIdeationAndNoIndicationOfSignificantDistress: 'Minimal risk of harm (example: no indication of suicidal or homicidal thoughts or impulses, and no history of suicidal or homicidal ideation, and no indication of significant distress)',
    ModeratelyAgree: 'Moderately Agree',
    ModeratelyCharacteristicOrTrueOfMe: 'Moderately characteristic or true of me',
    ModeratelyDisagree: 'Moderately Disagree',
    ModeratelySatisfied: 'Moderately satisfied',
    ModeratelyTrue: 'Moderately true',
    ModeratelyTypicalOfMe: 'Moderately typical of me',
    ModerateRiskOfHarmExampleSignificantCurrentSuicidalOrHomicidalIdeationWithoutIntentOrConsciousPlanAndWithoutPastHistory: 'Moderate risk of harm (example: significant current suicidal or homicidal ideation without intent or conscious plan and without past history)',
    MoreThan20YearsAgo: 'More than 20 years ago',
    MoreThanOnce: 'More than once',
    MoreThanOnceADay: 'More than once a day',
    MostlyLikeMe: 'Mostly like me',
    MostOfTheTime2040TimesOr36TimesPerDay: 'Most of the time (20-40 times or 3-6 times per day)',
    MostOfTheTime6690: 'Most of the time (66-90%)',
    MostOrAllOfTheTime: 'Most or all of the time',
    MostTimesMoreThanHalfTheTime: 'Most times (more than half the time)',
    NearlyAllTheTime40OrMoreThan6TimesPerDay: 'Nearly all the time (40+ or more than 6 times per day)',
    NeitherAgreeOrDisagree: 'Neither Agree or Disagree',
    NeitherDisagreeNorAgree: 'Neither Disagree nor Agree',
    NeverOrVeryRarelyTrue: 'Never or very rarely true',
    NoneOfTheTime: 'None of the time',
    NoneOfTheTimeCouldNotEjaculate: 'None of the time/could not ejaculate',
    NotApplicable: 'Not applicable',
    NotApplicableEGHaventHadAppointmentYet: 'Not applicable (e.g. haven\'t had appointment yet)',
    NotAtAllCharacteristicOrTrueOfMe: 'Not at all characteristic or true of me',
    NotAtAllImportant: 'Not At All Important ',
    NotAtAllSatisfied: 'Not at all satisfied',
    NotAtAllTrue: 'Not at all true',
    NotAtAllTrueForMe: 'Not at all true for me',
    NotAtAllTypicalOfMe: 'Not at all typical of me',
    NotAProblem: 'Not a problem',
    NotBotheredAtAll: 'Not bothered at all',
    NotLikeMeAtAll: 'Not like me at all',
    NotMuchLikeMe: 'Not much like me',
    NotTrueOrHardlyEverTrue: 'Not true or hardly ever true',
    NotVeryOften: 'Not very often',
    NoSexualActivity: 'No sexual activity',
    NoTengoUnaTerepeuta: 'No tengo una terepeuta',
    Occasionally3Or4Times: 'Occasionally (3 or 4 times)',
    OccasionallyDisagree: 'Occasionally Disagree',
    OccasionallyOrAModerateAmountOfTheTime: 'Occasionally or a moderate amount of the time',
    OccasionallyTrue: 'Occasionally TRUE',
    Often1120TimesOr23TimesPerDay2: 'Often (11-20 times or 2-3 times per day)',
    OftenTrueForMe: 'Often true for me',
    Once: 'Once',
    OnceInAWhile: 'Once in a while',
    OnlyALittleOrNotAtAll: 'Only a little or not at all',
    Perfect: 'Perfect',
    PlannedDischarge: 'Planned discharge',
    PossiblyAProblem: 'Possibly a problem',
    PunchedOrBangedOneselfToThePointOfBruisingOrBleeding: 'Punched or banged oneself to the point of bruising or bleeding',
    QuiteALot: 'Quite a lot',
    QuiteImportant: 'Quite Important ',
    QuiteOftenTrue: 'Quite often true',
    QuiteUnimportant: 'Quite Unimportant ',
    Rarely1Or2Times: 'Rarely (1 or 2 times)',
    Rarely26TimesMonth: 'Rarely (2-6 times/month)',
    RarelyOrNoneOfTheTime: 'Rarely or none of the time',
    RarelyTrue: 'Rarely TRUE',
    RarelyUsed: 'Rarely used',
    RippedOrTornSkin: 'Ripped or torn skin',
    RubbedGlassIntoSkinOrStuckSharpObjectsSuchAsNeedlesPinsAndStaplesIntoOrUnderneathTheSkinNotIncludingTattooingBodyPiercingOrNeedlesUsedForMedicationUse: 'Rubbed glass into skin or stuck sharp objects such as needles, pins, and staples into or underneath the skin (not including tattooing, body piercing, or needles used for medication use)',
    Satisfied: 'Satisfied',
    Seguido: 'Seguido',
    Seldom: 'Seldom',
    SeriousRiskOfHarmExampleCurrentSuicidalOrHomicidalIdeationWithExpressedIntentionsAndOrPastHistoryOfCarryingOutSuchBehaviorButWithoutMeansForCarryingOutTheBehavior: 'Serious risk of harm (example: current suicidal or homicidal ideation with expressed intentions and/or past history of carrying out such behavior but without means for carrying out the behavior)',
    SeveralTimesEveryDay: 'Several times every day',
    SeverelyScratchedOrPinchedWithFingernailsOrOtherObjectsToThePointThatBleedingOccursOrMarksRemainOnTheSkin: 'Severely scratched or pinched with fingernails or other objects to the point that bleeding occurs or marks remain on the skin',
    SlightlyDislike: 'Slightly dislike',
    SlightlyEnjoy: 'Slightly enjoy',
    SlightlySatisfied: 'Slightly satisfied',
    SlightlyTrueForMe: 'Slightly true for me',
    Sometimes1135: 'Sometimes (11-35%)',
    Sometimes510TimesOr12TimesPerDay2: 'Sometimes (5-10 times or 1-2 times per day)',
    SometimesAboutHalfTheTime: 'Sometimes (about half the time)',
    SometimesMoreThan7TimesMonthButNotEveryDay: 'Sometimes (more than 7 times/month, but not every day)',
    SomewhatImportant: 'Somewhat Important ',
    SomewhatOrSometimesTrue: 'Somewhat or sometimes true',
    SomewhatTrueForMe: 'Somewhat true for me',
    SomewhatTrueOrSometimesTrue: 'Somewhat true or sometimes true',
    SomewhatUnimportant: 'Somewhat Unimportant ',
    SomeOrALittleOfTheTime: 'Some or a little of the time',
    S: 'Sí',
    TriedToBreakYourOwnBoneS: 'Tried to break your own bone(s)',
    UndecidedDontKnowDoesNotApply: 'Undecided / Don\'t Know / Does Not Apply',
    Unhappy: 'Unhappy',
    Unsatisfied: 'Unsatisfied',
    UsedViagraOrSimilarDrugWithEverySexualEncounter: 'Used Viagra or similar drug with every sexual encounter',
    VeryHappy: 'Very happy',
    VeryMuchSo: 'Very much so',
    VeryOftenOrAlwaysTrue: 'Very often or always true',
    VeryOftenTrue: 'Very often true',
    VeryPoor: 'Very poor',
    VerySatisfied: 'Very satisfied',
    VerySlightlyOrNotAtAll: 'Very slightly or not at all',
    NotAtAllVerySlightly: 'Not at all / very slightly',
    VeryTrueForMe: 'Very true for me',
    VeryTrueOrOftenTrue: 'Very true or often true',
    VeryUnsatisfied: 'Very Unsatisfied',
    VeryWell: 'Very well',
    SixMonth: 'Six Month',
    Under18: 'Under 18',
    OlderOrEqualTo65: 'Older Or Equal To 65',
    Between18And64: 'Between 18 And 64',
    ZeroPercent: 'Zero Percent',
    TenPercent: 'Ten Percent',
    TwentyPercent: 'Twenty Percent',
    ThirtyPercent: 'Thirty Percent',
    FortyPercent: 'Forty Percent',
    FiftyPercent: 'Fifty Percent',
    SixtyPercent: 'Sixty Percent',
    SeventyPercent: 'Seventy Percent',
    EightyPercent: 'Eighty Percent',
    NinetyPercent: 'Ninety Percent',
    HundredPercent: 'Hundred Percent',
    NoChanceOfDozing: 'No chance of dozing',
    SlightChanceOfDozing: 'Slight chance of dozing',
    ModerateChanceOfDozing: 'Moderate chance of dozing',
    HighChanceOfDozing: 'High chance of dozing',
    HappenedToMe: 'Happened to me',
    WitnessedIt: 'Witnessed it',
    LearnedAboutIt: 'Learned about it',
    PartOfMyJob: 'Part of my job',
    DoesNotApply: 'Does not apply',
    LessThan1Year: 'Less than 1 year',
    _15Years: '1-5 years',
    _510Years2: '5-10 years',
    MoreThan10Years: 'More than 10 years',
    FastFood: 'Fast food',
    FriedFoods: 'Fried foods',
    SugaryDrinks: 'Sugary drinks',
    SweetsOrDesserts: 'Sweets or desserts',
    LateNightEating: 'Late-night eating',
    DailyFruitsOrVegetables: 'Daily fruits or vegetables',
    MostlyHomeCooked: 'Mostly home cooked',
    MostlyTakeOutRestaurant: 'Mostly take-out/restaurant',
    Mixed: 'Mixed',
    LackOfTime: 'Lack of time',
    CostOfHealthyFood: 'Cost of healthy food',
    StressEmotionalEating: 'Stress/emotional eating',
    PainLimitedMobility: 'Pain/limited mobility',
    Fatigue: 'Fatigue',
    LackOfMotivation: 'Lack of motivation',
    FamilySocialHabits: 'Family/social habits',
    Cigarettes: 'Cigarettes',
    Cigars: 'Cigars',
    SmokelessTobacco: 'Smokeless tobacco',
    VapingECigaretteNicotine: 'Vaping/e-cigarette nicotine',
    NotReady: 'Not ready',
    ConsideringQuitting: 'Considering quitting',
    ReadyToQuit: 'Ready to quit',
    ActivelyQuitting: 'Actively quitting',
    SetQuitDate: 'Set quit date',
    TriggerAvoidance: 'Trigger avoidance',
    StressCoping: 'Stress coping',
    SupportSystem: 'Support system',
    RelapsePrevention: 'Relapse prevention',
    NicotineReplacementTherapy: 'Nicotine replacement therapy',
    Bupropion: 'Bupropion',
    Varenicline: 'Varenicline',
    Quitline: 'Quitline',
    PrintedHandout: 'Printed handout',
    BehavioralHealth: 'Behavioral health',
    GroupCounseling: 'Group counseling',
    _99406MoreThan3AndUpTo10Minutes: '99406: more than 3 and up to 10 minutes',
    _99407MoreThan10Minutes: '99407: more than 10 minutes',
    Type1: 'Type 1',
    Type2: 'Type 2',
    Gestational: 'Gestational',
    PreDiabetes: 'Pre-Diabetes',
    Insulin: 'Insulin',
    OralHypoglycemic: 'Oral hypoglycemic',
    DietControl: 'Diet Control',
    LowRiskPatient: 'Low risk patient',
    HighRiskPatient: 'High risk patient',
    Current: 'Current',
    Former: 'Former',
    WelcomeG0402: 'Welcome (G0402)',
    InitialG0438: 'Initial (G0438)',
    SubsequentG0439: 'Subsequent (G0439)',
    TrippedOverSomething: 'Tripped over something',
    Injured: 'Injured',
    LightheadednessOrPalpitationsPriorTo: 'Lightheadedness or palpitations prior to',
    LossOfConsciousness: 'Loss of consciousness',
    NeededToSeeADoctor: 'Needed to see a doctor',
    AbleToGetUpOnOwn: 'Able to get up on own',
    ApartmentCondo: 'Apartment/Condo',
    AssistedLiving: 'Assisted living',
    House: 'House',
    OilHeat: 'Oil heat',
    GasHeat: 'Gas heat',
    ElectricHeatAc: 'Electric heat/AC',
    Fireplace: 'Fireplace',
    Fans: 'Fans',
    OpenWindows: 'Open windows',
    GasOvenStove: 'Gas oven/stove',
    ElectricOvenStove: 'Electric oven/stove',
    Microwave: 'Microwave',
    Toaster: 'Toaster',
    Crockpot: 'Crockpot',
    NoMethodUsed: 'No method used',
    MedicinesLinedUp: 'Medicines lined up',
    PrePouredOrPreplacedPillsInAPillbox: 'Pre-poured or preplaced pills in a pillbox',
    BubblePacksOfMeds: 'Bubble packs of meds',
    Self: 'Self',
    FamilyMember: 'Family member',
    CareGiver: 'Care giver',
    ComfortHeightToilet: 'Comfort-height toilet',
    PortableCommode: 'Portable commode',
    StairLift: 'Stair lift',
    HoyerLift: 'Hoyer lift',
    HospitalBed: 'Hospital bed',
    ChairLift: 'Chair lift',
    RemotePatientMonitoring: 'Remote patient monitoring',
    GrabBars: 'Grab bars',
    O2: 'O2',
    OtherSuppliers: 'Other / Suppliers',
    FreeText: 'Free text',
    Unknown: 'Unknown'
} as const;

export type PatientScreenerAnswerEnum = typeof PatientScreenerAnswerEnum[keyof typeof PatientScreenerAnswerEnum];
export const PatientScreenerScreenerTypeEnum = {
    Aai: 'AAI',
    AaqIi: 'AAQ_II',
    Aas: 'AAS',
    Aces: 'ACES',
    Acsi: 'ACSI',
    ActAdv: 'ACT_ADV',
    AcOk: 'AC_OK',
    AdhdSs: 'ADHD_SS',
    AdlFa: 'ADL_FA',
    Adnm8: 'ADNM_8',
    Adnm8Stressors: 'ADNM_8_STRESSORS',
    AhcHealthRelatedSocialNeedsScreenerAdults: 'AHC_HEALTH_RELATED_SOCIAL_NEEDS_SCREENER_ADULTS',
    Ahs: 'AHS',
    Alss: 'ALSS',
    Amps: 'AMPS',
    Ansa: 'ANSA',
    Apq: 'APQ',
    Aq: 'AQ',
    Ari: 'ARI',
    Arm5New: 'ARM_5_NEW',
    Arm5T: 'ARM_5_T',
    AsbiP: 'ASBI_P',
    Aseq: 'ASEQ',
    Asq: 'ASQ',
    AsqAr: 'ASQ_AR',
    Asrm: 'ASRM',
    Asrs11: 'ASRS_1_1',
    AsrsV11PartA: 'ASRS_V1_1_PART_A',
    Assist: 'ASSIST',
    Audit: 'AUDIT',
    AuditC: 'AUDIT_C',
    Aware30: 'AWARE_3_0',
    Aws: 'AWS',
    Ayr: 'AYR',
    ADes: 'A_DES',
    BamNew: 'BAM_NEW',
    Barc10: 'BARC_10',
    BatNew: 'BAT_NEW',
    Bbq: 'BBQ',
    Bdrs: 'BDRS',
    Bdss: 'BDSS',
    Bes: 'BES',
    Best: 'BEST',
    BfneIi: 'BFNE_II',
    BmsEvaluationOfSession: 'BMS_EVALUATION_OF_SESSION',
    Bpds: 'BPDS',
    Bql: 'BQL',
    Brcs: 'BRCS',
    BrcsSpanish: 'BRCS_SPANISH',
    BriefmoodAfter: 'BRIEFMOOD_AFTER',
    BriefmoodBefore: 'BRIEFMOOD_BEFORE',
    Bsl23: 'BSL_23',
    Bsl23Full: 'BSL_23_FULL',
    Bsps: 'BSPS',
    Bsps4: 'BSPS_4',
    Bts: 'BTS',
    BvsNew: 'BVS_NEW',
    Cage: 'CAGE',
    CalpasPatientSf: 'CALPAS_PATIENT_SF',
    CansEi: 'CANS_EI',
    Care: 'CARE',
    CareF: 'CARE_F',
    Cast: 'CAST',
    CatsChildSpanish: 'CATS_CHILD_SPANISH',
    CatsParent: 'CATS_PARENT',
    CatsParent36: 'CATS_PARENT_3_6',
    CatsParent36Spanish: 'CATS_PARENT_3_6_SPANISH',
    CatsParent717Spanish: 'CATS_PARENT_7_17_SPANISH',
    CatsProgressYouth: 'CATS_PROGRESS_YOUTH',
    CatsSelfReport717: 'CATS_SELF_REPORT_7_17',
    CatsYouth: 'CATS_YOUTH',
    Cdc: 'CDC',
    CesD: 'CES_D',
    CesDc: 'CES_DC',
    Cfars: 'CFARS',
    Cfq: 'CFQ',
    Cga: 'CGA',
    ChildBehaviorRatingScaleCbrs: 'CHILD_BEHAVIOR_RATING_SCALE_CBRS',
    Chs: 'CHS',
    Cias: 'CIAS',
    Cia30: 'CIA_3_0',
    Ciraa: 'CIRAA',
    Compact: 'COMPACT',
    CompactMod: 'COMPACT_MOD',
    Covid19Screener: 'COVID_19_SCREENER',
    CpaqR: 'CPAQ_R',
    Cppss: 'CPPSS',
    CpssVNew: 'CPSS_V_NEW',
    Cries13: 'CRIES_13',
    Cries131: 'CRIES_13_1',
    Cries132: 'CRIES_13_2',
    Cs: 'CS',
    Csaq: 'CSAQ',
    CsasSpanish: 'CSAS_SPANISH',
    Csi: 'CSI',
    Csi16: 'CSI_16',
    Csi4: 'CSI_4',
    CFoci: 'C_FOCI',
    CSsrs: 'C_SSRS',
    CSsrsB: 'C_SSRS_B',
    CSsrsNew: 'C_SSRS_NEW',
    CSsrsSl: 'C_SSRS_SL',
    Das: 'DAS',
    Dass: 'DASS',
    Dass10: 'DASS_10',
    Dass21: 'DASS_21',
    DassY: 'DASS_Y',
    Dbas16Neww: 'DBAS_16_NEWW',
    DbtWccl: 'DBT_WCCL',
    Ders: 'DERS',
    Ders18: 'DERS_18',
    Des: 'DES',
    DesBNew: 'DES_B_NEW',
    Dgsr: 'DGSR',
    Dla20SelfReport: 'DLA_20_SELF_REPORT',
    DpdQ: 'DPD_Q',
    DpssClinicianRated: 'DPSS_CLINICIAN_RATED',
    Drs: 'DRS',
    DrsCa: 'DRS_CA',
    Dsm5Ccsm: 'DSM5_CCSM',
    Dsm5SuChild: 'DSM5_SU_CHILD',
    Dsm5Agoraphobia: 'DSM_5_AGORAPHOBIA',
    Dsm5AnxC: 'DSM_5_ANX_C',
    Dsm5GadC: 'DSM_5_GAD_C',
    Dsm5IiAngP: 'DSM_5_II_ANG_P',
    Dsm5IiAnxP: 'DSM_5_II_ANX_P',
    Dsm5IiAnxPGn: 'DSM_5_II_ANX_P_GN',
    Dsm5IiDepP: 'DSM_5_II_DEP_P',
    Dsm5IiIrrP: 'DSM_5_II_IRR_P',
    Dsm5IiSomPNew: 'DSM_5_II_SOM_P_NEW',
    Dsm5IiSubUse: 'DSM_5_II_SUB_USE',
    Dsm5Level1Child: 'DSM_5_LEVEL_1_CHILD',
    Dsm5Level1Parent: 'DSM_5_LEVEL_1_PARENT',
    Dsm5SadChild: 'DSM_5_SAD_CHILD',
    Dsm5SadNew: 'DSM_5_SAD_NEW',
    Dsm5SmasC: 'DSM_5_SMAS_C',
    Dsm5SmdC: 'DSM_5_SMD_C',
    Dsm5SmptsdC: 'DSM_5_SMPTSD_C',
    Dsrs: 'DSRS',
    Dss: 'DSS',
    DssB: 'DSS_B',
    Dts: 'DTS',
    Eat26PartB: 'EAT_26_PART_B',
    EcrR: 'ECR_R',
    EdeQs: 'EDE_QS',
    EdeQ60Modified: 'EDE_Q_6_0_MODIFIED',
    Edqol: 'EDQOL',
    Epds: 'EPDS',
    Eq: 'EQ',
    Erq: 'ERQ',
    EssNew: 'ESS_NEW',
    Expass: 'EXPASS',
    FaasNew: 'FAAS_NEW',
    Fad: 'FAD',
    Fasa: 'FASA',
    FasN: 'FAS_N',
    FasP: 'FAS_P',
    FasS: 'FAS_S',
    Fbs: 'FBS',
    FbsN: 'FBS_N',
    FbsP: 'FBS_P',
    Ffmq: 'FFMQ',
    FibserScaleNew: 'FIBSER_SCALE_NEW',
    Flbs: 'FLBS',
    Fm5: 'FM5',
    FreiburgMindfulnessInventoryFmi: 'FREIBURG_MINDFULNESS_INVENTORY_FMI',
    Fsas: 'FSAS',
    Fsfi: 'FSFI',
    Fwbs: 'FWBS',
    Gad7: 'GAD7',
    Gad2: 'GAD_2',
    Gad7Spanish: 'GAD_7_SPANISH',
    Gad7Impairment: 'GAD_7___IMPAIRMENT',
    GasNew: 'GAS_NEW',
    GclsPsy: 'GCLS_PSY',
    Giq: 'GIQ',
    Gis: 'GIS',
    GqiNew: 'GQI_NEW',
    Gs: 'GS',
    Gse: 'GSE',
    Hai: 'HAI',
    HamA: 'HAM_A',
    Icg: 'ICG',
    IcuaFi: 'ICUA_FI',
    IcuaFiC: 'ICUA_FI_C',
    IcuaFiF: 'ICUA_FI_F',
    IcuaFiI: 'ICUA_FI_I',
    Ies1: 'IES_1',
    Ies2: 'IES_2',
    Ies3: 'IES_3',
    IesR: 'IES_R',
    Iief: 'IIEF',
    Is: 'IS',
    Isel12: 'ISEL_12',
    Isi: 'ISI',
    Itq: 'ITQ',
    ItrCs: 'ITR_CS',
    Kims: 'KIMS',
    Lasa: 'LASA',
    LdqNew: 'LDQ_NEW',
    Lec5: 'LEC_5',
    Locus: 'LOCUS',
    Lovemap: 'LOVEMAP',
    LscR: 'LSC_R',
    MadrsS: 'MADRS_S',
    Maia2: 'MAIA_2',
    Mast: 'MAST',
    Maysi: 'MAYSI',
    Mcsi: 'MCSI',
    Mdq: 'MDQ',
    MeasuringAdverseEvents: 'MEASURING_ADVERSE_EVENTS',
    Mfpi: 'MFPI',
    MfpiS: 'MFPI_S',
    MfqParentLong: 'MFQ_PARENT_LONG',
    MfqParentShort: 'MFQ_PARENT_SHORT',
    MghHairPulling: 'MGH_HAIR_PULLING',
    Mgma: 'MGMA',
    MhcSf: 'MHC_SF',
    MhlcC: 'MHLC_C',
    MindfuliWaiSr: 'MINDFULI_WAI_SR',
    MoasNew: 'MOAS_NEW',
    MqgChildLong: 'MQG_CHILD_LONG',
    Mshq: 'MSHQ',
    MshqEjd: 'MSHQ_EJD',
    Msi: 'MSI',
    MsiBpd: 'MSI_BPD',
    NihHeals: 'NIH_HEALS',
    NmrqA: 'NMRQ_A',
    Npi13: 'NPI_13',
    Npi16: 'NPI_16',
    Nq: 'NQ',
    Nssi: 'NSSI',
    Oa: 'OA',
    Oasis: 'OASIS',
    ObesityScreening: 'OBESITY_SCREENING',
    TobaccoScreening: 'TOBACCO_SCREENING',
    DiabetesAssessment: 'DIABETES_ASSESSMENT',
    AnnualWellness: 'ANNUAL_WELLNESS',
    Obq44: 'OBQ_44',
    Oci: 'OCI',
    Oci12: 'OCI_12',
    Oci4: 'OCI_4',
    OciCvR: 'OCI_CV_R',
    OciR: 'OCI_R',
    OcTrs: 'OC_TRS',
    Odsis: 'ODSIS',
    OhqNew: 'OHQ_NEW',
    Olbi: 'OLBI',
    PanasSf: 'PANAS_SF',
    PanasX: 'PANAS_X',
    Paqr: 'PAQR',
    Pass: 'PASS',
    PasP: 'PAS_P',
    Pcl5: 'PCL_5',
    Pcl5Lec: 'PCL_5_LEC',
    Pcl5Spanish: 'PCL_5_SPANISH',
    PcPtsd5: 'PC_PTSD_5',
    Phq9: 'PHQ9',
    Phq15Child: 'PHQ_15_CHILD',
    Phq2: 'PHQ_2',
    Phq4: 'PHQ_4',
    Phq8: 'PHQ_8',
    Phq9Spanish: 'PHQ_9_SPANISH',
    Phq9Impairment: 'PHQ_9___IMPAIRMENT',
    PhqA: 'PHQ_A',
    Pnrs: 'PNRS',
    Pnss: 'PNSS',
    Pops: 'POPS',
    PpcsS: 'PPCS_S',
    PqB: 'PQ_B',
    PqLesQ: 'PQ_LES_Q',
    Prea: 'PREA',
    PromisAng: 'PROMIS_ANG',
    PromisAngChild: 'PROMIS_ANG_CHILD',
    PromisDepressiveSymptomsParentReport: 'PROMIS_DEPRESSIVE_SYMPTOMS_PARENT_REPORT',
    PromisPediatricAnxietySf: 'PROMIS_PEDIATRIC_ANXIETY_SF',
    PromisSle: 'PROMIS_SLE',
    PromisSleepChild: 'PROMIS_SLEEP_CHILD',
    PromisSom: 'PROMIS_SOM',
    Proqol: 'PROQOL',
    PsccPS: 'PSCC_P_S',
    Psc17: 'PSC_17',
    Psc17ParentNew: 'PSC_17_PARENT_NEW',
    Psc17Spanish: 'PSC_17_SPANISH',
    Psc35: 'PSC_35',
    PscPA: 'PSC_P_A',
    PscYA: 'PSC_Y_A',
    Psi: 'PSI',
    Pss: 'PSS',
    Pstq: 'PSTQ',
    PstqA: 'PSTQ_A',
    Pswq: 'PSWQ',
    PswqC: 'PSWQ_C',
    PtgiNew: 'PTGI_NEW',
    Ptsst: 'PTSST',
    PtsstP: 'PTSST_P',
    PwiA: 'PWI_A',
    PwiSc: 'PWI_SC',
    PAces: 'P_ACES',
    QewpR: 'QEWP_R',
    QLesQ: 'Q_LES_Q',
    QLesQS: 'Q_LES_Q_S',
    QLesQSf: 'Q_LES_Q_SF',
    Raads14: 'RAADS_14',
    Ras: 'RAS',
    Rcads: 'RCADS',
    RcadsP: 'RCADS_P',
    Rfls: 'RFLS',
    Riasec: 'RIASEC',
    Rses: 'RSES',
    Saam: 'SAAM',
    SaiPatient: 'SAI_PATIENT',
    Sapas: 'SAPAS',
    Sast: 'SAST',
    SatisfactionWithCare: 'SATISFACTION_WITH_CARE',
    Sbc: 'SBC',
    ScaredChild: 'SCARED_CHILD',
    ScaredChildSpanish: 'SCARED_CHILD_SPANISH',
    ScaredParent: 'SCARED_PARENT',
    ScaredParentSpanish: 'SCARED_PARENT_SPANISH',
    ScasChildSpanish: 'SCAS_CHILD_SPANISH',
    ScasParentSpanish: 'SCAS_PARENT_SPANISH',
    ScasPreschoolSpanish: 'SCAS_PRESCHOOL_SPANISH',
    Scd: 'SCD',
    Scoff: 'SCOFF',
    Score15: 'SCORE_15',
    Score15Kids: 'SCORE_15_KIDS',
    ScsSfNew: 'SCS_SF_NEW',
    ScsY: 'SCS_Y',
    Sdoh: 'SDOH',
    Sdq: 'SDQ',
    SdsCl25New: 'SDS_CL_25_NEW',
    SfCds: 'SF_CDS',
    Sias: 'SIAS',
    Sir: 'SIR',
    Smfq: 'SMFQ',
    Smhat1: 'SMHAT_1',
    Smhat2: 'SMHAT_2',
    Smhat3: 'SMHAT_3',
    Smpd: 'SMPD',
    Smsp: 'SMSP',
    Sogs: 'SOGS',
    Sps: 'SPS',
    SpsNew: 'SPS_NEW',
    Srs2: 'SRS_2',
    SscsL: 'SSCS_L',
    SscsSNew: 'SSCS_S_NEW',
    Ssps: 'SSPS',
    Sss8: 'SSS_8',
    Stai: 'STAI',
    SticChildRel: 'STIC_CHILD_REL',
    SticCouples: 'STIC_COUPLES',
    SticFamily: 'STIC_FAMILY',
    SticInd: 'STIC_IND',
    Stim: 'STIM',
    SubstanceAbuse: 'SUBSTANCE_ABUSE',
    Taps1: 'TAPS_1',
    Taps2New: 'TAPS_2_NEW',
    Tas: 'TAS',
    TcsNew: 'TCS_NEW',
    TgiSr: 'TGI_SR_',
    ThePainCatastrophizingScale: 'THE_PAIN_CATASTROPHIZING_SCALE',
    Thq: 'THQ',
    Ths: 'THS',
    TlcPtsdCaq: 'TLC_PTSD_CAQ',
    Trs: 'TRS',
    TrsCa: 'TRS_CA',
    Ucla3New: 'UCLA_3_NEW',
    Uus: 'UUS',
    VasParent: 'VAS_PARENT',
    VasParentFollowUp: 'VAS_PARENT_FOLLOW_UP',
    VasParentFollowUpSpanish: 'VAS_PARENT_FOLLOW_UP_SPANISH',
    VasTeacher: 'VAS_TEACHER',
    VqNew: 'VQ_NEW',
    Wai: 'WAI',
    WaiBest: 'WAI_BEST',
    WaA: 'WA_A',
    WaY: 'WA_Y',
    WeeklyParticipationSurvey: 'WEEKLY_PARTICIPATION_SURVEY',
    Wemwbs: 'WEMWBS',
    Whodas20New: 'WHODAS_2_0_NEW',
    Who5: 'WHO_5',
    Whympi: 'WHYMPI',
    Wss: 'WSS',
    Wurs25: 'WURS_25',
    YalePrime: 'YALE_PRIME',
    Ycpc: 'YCPC',
    Yfas: 'YFAS',
    Yfas20: 'YFAS_2_0'
} as const;

export type PatientScreenerScreenerTypeEnum = typeof PatientScreenerScreenerTypeEnum[keyof typeof PatientScreenerScreenerTypeEnum];

/**
 * 
 * @export
 * @interface PatientVaccine
 */
export interface PatientVaccine {
    /**
     * 
     * @type {string}
     * @memberof PatientVaccine
     */
    'uuid'?: string;
    /**
     * 
     * @type {Vaccine}
     * @memberof PatientVaccine
     */
    'vaccine': Vaccine;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof PatientVaccine
     */
    'patient': { [key: string]: string; };
    /**
     * 
     * @type {string}
     * @memberof PatientVaccine
     */
    'administerDate'?: string;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof PatientVaccine
     */
    'administeredBy': { [key: string]: string; };
    /**
     * 
     * @type {string}
     * @memberof PatientVaccine
     */
    'manufacturer'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientVaccine
     */
    'lot'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientVaccine
     */
    'dose'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientVaccine
     */
    'units'?: PatientVaccineUnitsEnum;
    /**
     * 
     * @type {string}
     * @memberof PatientVaccine
     */
    'route'?: PatientVaccineRouteEnum;
    /**
     * 
     * @type {string}
     * @memberof PatientVaccine
     */
    'site'?: PatientVaccineSiteEnum;
    /**
     * 
     * @type {string}
     * @memberof PatientVaccine
     */
    'expiryDate'?: string;
    /**
     * 
     * @type {number}
     * @memberof PatientVaccine
     */
    'doseDuration'?: number;
    /**
     * 
     * @type {string}
     * @memberof PatientVaccine
     */
    'note'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PatientVaccine
     */
    'active'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PatientVaccine
     */
    'archive'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PatientVaccine
     */
    'recordedDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientVaccine
     */
    'appointmentId'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientVaccine
     */
    'providerStatus'?: PatientVaccineProviderStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof PatientVaccine
     */
    'vaccineType'?: PatientVaccineVaccineTypeEnum;
}

export const PatientVaccineUnitsEnum = {
    Percent: 'PERCENT',
    Capsule: 'CAPSULE',
    Drops: 'DROPS',
    G: 'G',
    Iu: 'IU',
    Mcg: 'MCG',
    Meq: 'MEQ',
    Mg: 'MG',
    MgPerKg: 'MG_PER_KG',
    MgPerMl: 'MG_PER_ML',
    Ml: 'ML',
    MlPerHour: 'ML_PER_HOUR',
    Puffs: 'PUFFS',
    Sprays: 'SPRAYS',
    Tablespoon: 'TABLESPOON',
    Tablets: 'TABLETS',
    Teaspoon: 'TEASPOON',
    Unit: 'UNIT'
} as const;

export type PatientVaccineUnitsEnum = typeof PatientVaccineUnitsEnum[keyof typeof PatientVaccineUnitsEnum];
export const PatientVaccineRouteEnum = {
    Buccel: 'BUCCEL',
    Dental: 'DENTAL',
    Epidural: 'EPIDURAL',
    Injection: 'INJECTION'
} as const;

export type PatientVaccineRouteEnum = typeof PatientVaccineRouteEnum[keyof typeof PatientVaccineRouteEnum];
export const PatientVaccineSiteEnum = {
    AnkleLeft: 'ANKLE_LEFT',
    AnkleRight: 'ANKLE_RIGHT',
    Bladder: 'BLADDER',
    ArmLeftUpper: 'ARM_LEFT_UPPER'
} as const;

export type PatientVaccineSiteEnum = typeof PatientVaccineSiteEnum[keyof typeof PatientVaccineSiteEnum];
export const PatientVaccineProviderStatusEnum = {
    Pending: 'PENDING',
    Confirmed: 'CONFIRMED'
} as const;

export type PatientVaccineProviderStatusEnum = typeof PatientVaccineProviderStatusEnum[keyof typeof PatientVaccineProviderStatusEnum];
export const PatientVaccineVaccineTypeEnum = {
    Historical: 'HISTORICAL',
    Administered: 'ADMINISTERED'
} as const;

export type PatientVaccineVaccineTypeEnum = typeof PatientVaccineVaccineTypeEnum[keyof typeof PatientVaccineVaccineTypeEnum];

/**
 * 
 * @export
 * @interface PatientVital
 */
export interface PatientVital {
    /**
     * 
     * @type {string}
     * @memberof PatientVital
     */
    'uuid'?: string;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof PatientVital
     */
    'patient'?: { [key: string]: string; };
    /**
     * 
     * @type {string}
     * @memberof PatientVital
     */
    'value'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientVital
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientVital
     */
    'unit'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientVital
     */
    'patientFlag'?: PatientVitalPatientFlagEnum;
    /**
     * 
     * @type {string}
     * @memberof PatientVital
     */
    'height'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientVital
     */
    'heightUnit'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientVital
     */
    'heartRate'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientVital
     */
    'heartRateUnit'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientVital
     */
    'weight'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientVital
     */
    'weightUnit'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientVital
     */
    'bodyTemperature'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientVital
     */
    'bodyTemperatureUnit'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientVital
     */
    'bloodPressureUnit'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientVital
     */
    'bloodGlucose'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientVital
     */
    'bloodGlucoseUnit'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientVital
     */
    'respirationRate'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientVital
     */
    'respirationRateUnit'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientVital
     */
    'o2Saturation'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientVital
     */
    'o2SaturationUnit'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientVital
     */
    'bmi'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientVital
     */
    'bmiUnit'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientVital
     */
    'peakExpiratoryFlow'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientVital
     */
    'peakExpiratoryFlowUnit'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientVital
     */
    'forceExpiratoryVolume'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientVital
     */
    'forceExpiratoryVolumeUnit'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientVital
     */
    'perfusionIndex'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientVital
     */
    'perfusionIndexUnit'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientVital
     */
    'respiratoryVolume'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientVital
     */
    'respiratoryVolumeUnit'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientVital
     */
    'method'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientVital
     */
    'type'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientVital
     */
    'note'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientVital
     */
    'flag'?: PatientVitalFlagEnum;
    /**
     * 
     * @type {string}
     * @memberof PatientVital
     */
    'systolic'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientVital
     */
    'diastolic'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientVital
     */
    'pulse'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientVital
     */
    'pulseUnit'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientVital
     */
    'recordedDate'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PatientVital
     */
    'active'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PatientVital
     */
    'archive'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PatientVital
     */
    'appointmentId'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientVital
     */
    'providerStatus'?: PatientVitalProviderStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof PatientVital
     */
    'createdBy'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PatientVital
     */
    'selected'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PatientVital
     */
    'takenAtLocation'?: PatientVitalTakenAtLocationEnum;
}

export const PatientVitalPatientFlagEnum = {
    Normal: 'NORMAL',
    Medium: 'MEDIUM',
    High: 'HIGH'
} as const;

export type PatientVitalPatientFlagEnum = typeof PatientVitalPatientFlagEnum[keyof typeof PatientVitalPatientFlagEnum];
export const PatientVitalFlagEnum = {
    Normal: 'NORMAL',
    Medium: 'MEDIUM',
    High: 'HIGH'
} as const;

export type PatientVitalFlagEnum = typeof PatientVitalFlagEnum[keyof typeof PatientVitalFlagEnum];
export const PatientVitalProviderStatusEnum = {
    Pending: 'PENDING',
    Confirmed: 'CONFIRMED'
} as const;

export type PatientVitalProviderStatusEnum = typeof PatientVitalProviderStatusEnum[keyof typeof PatientVitalProviderStatusEnum];
export const PatientVitalTakenAtLocationEnum = {
    Home: 'HOME',
    AtHome: 'AT_HOME',
    Clinic: 'CLINIC'
} as const;

export type PatientVitalTakenAtLocationEnum = typeof PatientVitalTakenAtLocationEnum[keyof typeof PatientVitalTakenAtLocationEnum];

/**
 * 
 * @export
 * @interface PatientVitalRequest
 */
export interface PatientVitalRequest {
    /**
     * 
     * @type {Array<PatientVital>}
     * @memberof PatientVitalRequest
     */
    'patientVitals'?: Array<PatientVital>;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof PatientVitalRequest
     */
    'patient': { [key: string]: string; };
    /**
     * 
     * @type {string}
     * @memberof PatientVitalRequest
     */
    'note'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientVitalRequest
     */
    'recordedDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientVitalRequest
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientVitalRequest
     */
    'systolic'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientVitalRequest
     */
    'diastolic'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientVitalRequest
     */
    'pulse'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientVitalRequest
     */
    'flag'?: PatientVitalRequestFlagEnum;
    /**
     * 
     * @type {string}
     * @memberof PatientVitalRequest
     */
    'value'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientVitalRequest
     */
    'unit'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientVitalRequest
     */
    'method'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientVitalRequest
     */
    'type'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PatientVitalRequest
     */
    'active'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PatientVitalRequest
     */
    'archive'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PatientVitalRequest
     */
    'selected'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PatientVitalRequest
     */
    'appointmentId'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientVitalRequest
     */
    'providerStatus'?: PatientVitalRequestProviderStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof PatientVitalRequest
     */
    'takenAt'?: PatientVitalRequestTakenAtEnum;
}

export const PatientVitalRequestFlagEnum = {
    Normal: 'NORMAL',
    Medium: 'MEDIUM',
    High: 'HIGH'
} as const;

export type PatientVitalRequestFlagEnum = typeof PatientVitalRequestFlagEnum[keyof typeof PatientVitalRequestFlagEnum];
export const PatientVitalRequestProviderStatusEnum = {
    Pending: 'PENDING',
    Confirmed: 'CONFIRMED'
} as const;

export type PatientVitalRequestProviderStatusEnum = typeof PatientVitalRequestProviderStatusEnum[keyof typeof PatientVitalRequestProviderStatusEnum];
export const PatientVitalRequestTakenAtEnum = {
    Home: 'HOME',
    AtHome: 'AT_HOME',
    Clinic: 'CLINIC'
} as const;

export type PatientVitalRequestTakenAtEnum = typeof PatientVitalRequestTakenAtEnum[keyof typeof PatientVitalRequestTakenAtEnum];

/**
 * 
 * @export
 * @interface Patientallergy
 */
export interface Patientallergy {
    /**
     * 
     * @type {string}
     * @memberof Patientallergy
     */
    'uuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof Patientallergy
     */
    'allergyType'?: PatientallergyAllergyTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof Patientallergy
     */
    'allergy': string;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof Patientallergy
     */
    'patient': { [key: string]: string; };
    /**
     * 
     * @type {string}
     * @memberof Patientallergy
     */
    'reaction'?: string;
    /**
     * 
     * @type {string}
     * @memberof Patientallergy
     */
    'severity'?: PatientallergySeverityEnum;
    /**
     * 
     * @type {string}
     * @memberof Patientallergy
     */
    'onSetDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof Patientallergy
     */
    'note'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Patientallergy
     */
    'active'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Patientallergy
     */
    'archive'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof Patientallergy
     */
    'recordedDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof Patientallergy
     */
    'modifiedDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof Patientallergy
     */
    'appointmentId'?: string;
    /**
     * 
     * @type {string}
     * @memberof Patientallergy
     */
    'providerStatus'?: PatientallergyProviderStatusEnum;
}

export const PatientallergyAllergyTypeEnum = {
    Drug: 'DRUG',
    Food: 'FOOD',
    Environment: 'ENVIRONMENT',
    Other: 'OTHER'
} as const;

export type PatientallergyAllergyTypeEnum = typeof PatientallergyAllergyTypeEnum[keyof typeof PatientallergyAllergyTypeEnum];
export const PatientallergySeverityEnum = {
    NoneMinimal: 'NONE_MINIMAL',
    Mild: 'MILD',
    Moderate: 'MODERATE',
    ModeratelySevere: 'MODERATELY_SEVERE',
    Severe: 'SEVERE'
} as const;

export type PatientallergySeverityEnum = typeof PatientallergySeverityEnum[keyof typeof PatientallergySeverityEnum];
export const PatientallergyProviderStatusEnum = {
    Pending: 'PENDING',
    Confirmed: 'CONFIRMED'
} as const;

export type PatientallergyProviderStatusEnum = typeof PatientallergyProviderStatusEnum[keyof typeof PatientallergyProviderStatusEnum];

/**
 * 
 * @export
 * @interface PaymentRequest
 */
export interface PaymentRequest {
    /**
     * 
     * @type {number}
     * @memberof PaymentRequest
     */
    'amount'?: number;
    /**
     * 
     * @type {number}
     * @memberof PaymentRequest
     */
    'subtotal'?: number;
    /**
     * 
     * @type {string}
     * @memberof PaymentRequest
     */
    'cardId'?: string;
    /**
     * 
     * @type {string}
     * @memberof PaymentRequest
     */
    'currency'?: string;
    /**
     * 
     * @type {string}
     * @memberof PaymentRequest
     */
    'paymentMode'?: PaymentRequestPaymentModeEnum;
    /**
     * 
     * @type {string}
     * @memberof PaymentRequest
     */
    'paymentCategory'?: PaymentRequestPaymentCategoryEnum;
    /**
     * 
     * @type {string}
     * @memberof PaymentRequest
     */
    'note'?: string;
    /**
     * 
     * @type {string}
     * @memberof PaymentRequest
     */
    'bankPaymentMode'?: PaymentRequestBankPaymentModeEnum;
    /**
     * 
     * @type {string}
     * @memberof PaymentRequest
     */
    'transactionId'?: string;
    /**
     * 
     * @type {string}
     * @memberof PaymentRequest
     */
    'paymentDate'?: string;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof PaymentRequest
     */
    'providerId'?: { [key: string]: string; };
    /**
     * 
     * @type {string}
     * @memberof PaymentRequest
     */
    'billId'?: string;
    /**
     * 
     * @type {string}
     * @memberof PaymentRequest
     */
    'visitId'?: string;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof PaymentRequest
     */
    'patient'?: { [key: string]: string; };
    /**
     * 
     * @type {string}
     * @memberof PaymentRequest
     */
    'superBill'?: string;
}

export const PaymentRequestPaymentModeEnum = {
    Cash: 'CASH',
    Online: 'ONLINE',
    Bank: 'BANK',
    Check: 'CHECK',
    ApplyCreditBalance: 'APPLY_CREDIT_BALANCE',
    Ach: 'ACH'
} as const;

export type PaymentRequestPaymentModeEnum = typeof PaymentRequestPaymentModeEnum[keyof typeof PaymentRequestPaymentModeEnum];
export const PaymentRequestPaymentCategoryEnum = {
    Copay: 'COPAY',
    Deductible: 'DEDUCTIBLE',
    Coinsurance: 'COINSURANCE',
    SelfPay: 'SELF_PAY',
    Advance: 'ADVANCE',
    Pr: 'PR',
    OutOfNetwork: 'OUT_OF_NETWORK',
    Invoice: 'INVOICE'
} as const;

export type PaymentRequestPaymentCategoryEnum = typeof PaymentRequestPaymentCategoryEnum[keyof typeof PaymentRequestPaymentCategoryEnum];
export const PaymentRequestBankPaymentModeEnum = {
    Cheque: 'CHEQUE',
    Rtgs: 'RTGS',
    Neft: 'NEFT'
} as const;

export type PaymentRequestBankPaymentModeEnum = typeof PaymentRequestBankPaymentModeEnum[keyof typeof PaymentRequestBankPaymentModeEnum];

/**
 * 
 * @export
 * @interface PharmacyLabRadiology
 */
export interface PharmacyLabRadiology {
    /**
     * 
     * @type {string}
     * @memberof PharmacyLabRadiology
     */
    'uuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof PharmacyLabRadiology
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof PharmacyLabRadiology
     */
    'preferenceType'?: PharmacyLabRadiologyPreferenceTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof PharmacyLabRadiology
     */
    'contactNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof PharmacyLabRadiology
     */
    'faxNumber'?: string;
    /**
     * 
     * @type {Address}
     * @memberof PharmacyLabRadiology
     */
    'address'?: Address;
}

export const PharmacyLabRadiologyPreferenceTypeEnum = {
    Lab: 'LAB',
    Pharmacy: 'PHARMACY',
    Radiology: 'RADIOLOGY'
} as const;

export type PharmacyLabRadiologyPreferenceTypeEnum = typeof PharmacyLabRadiologyPreferenceTypeEnum[keyof typeof PharmacyLabRadiologyPreferenceTypeEnum];

/**
 * 
 * @export
 * @interface PharmacyLabRadiologyEntity
 */
export interface PharmacyLabRadiologyEntity {
    /**
     * 
     * @type {number}
     * @memberof PharmacyLabRadiologyEntity
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof PharmacyLabRadiologyEntity
     */
    'uuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof PharmacyLabRadiologyEntity
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof PharmacyLabRadiologyEntity
     */
    'preferenceType'?: PharmacyLabRadiologyEntityPreferenceTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof PharmacyLabRadiologyEntity
     */
    'contactNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof PharmacyLabRadiologyEntity
     */
    'faxNumber'?: string;
    /**
     * 
     * @type {AddressEntity}
     * @memberof PharmacyLabRadiologyEntity
     */
    'address'?: AddressEntity;
}

export const PharmacyLabRadiologyEntityPreferenceTypeEnum = {
    Lab: 'LAB',
    Pharmacy: 'PHARMACY',
    Radiology: 'RADIOLOGY'
} as const;

export type PharmacyLabRadiologyEntityPreferenceTypeEnum = typeof PharmacyLabRadiologyEntityPreferenceTypeEnum[keyof typeof PharmacyLabRadiologyEntityPreferenceTypeEnum];

/**
 * 
 * @export
 * @interface PharmacyStore
 */
export interface PharmacyStore {
    /**
     * 
     * @type {string}
     * @memberof PharmacyStore
     */
    'uuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof PharmacyStore
     */
    'pharmacyName'?: string;
    /**
     * 
     * @type {string}
     * @memberof PharmacyStore
     */
    'contactNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof PharmacyStore
     */
    'faxNumber'?: string;
    /**
     * 
     * @type {Address}
     * @memberof PharmacyStore
     */
    'address'?: Address;
}
/**
 * 
 * @export
 * @interface PhysicalROSTemplate
 */
export interface PhysicalROSTemplate {
    /**
     * 
     * @type {string}
     * @memberof PhysicalROSTemplate
     */
    'uuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof PhysicalROSTemplate
     */
    'templateNameType'?: string;
    /**
     * 
     * @type {string}
     * @memberof PhysicalROSTemplate
     */
    'templateType'?: PhysicalROSTemplateTemplateTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof PhysicalROSTemplate
     */
    'description'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PhysicalROSTemplate
     */
    'active'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PhysicalROSTemplate
     */
    'archive'?: boolean;
}

export const PhysicalROSTemplateTemplateTypeEnum = {
    PhysicalExam: 'PHYSICAL_EXAM',
    Ros: 'ROS'
} as const;

export type PhysicalROSTemplateTemplateTypeEnum = typeof PhysicalROSTemplateTemplateTypeEnum[keyof typeof PhysicalROSTemplateTemplateTypeEnum];

/**
 * 
 * @export
 * @interface PhysicalROSTemplateRequest
 */
export interface PhysicalROSTemplateRequest {
    /**
     * 
     * @type {string}
     * @memberof PhysicalROSTemplateRequest
     */
    'appointmentId'?: string;
    /**
     * 
     * @type {Array<PhysicalROSTemplate>}
     * @memberof PhysicalROSTemplateRequest
     */
    'physicalROSTemplateList'?: Array<PhysicalROSTemplate>;
}
/**
 * 
 * @export
 * @interface PhysicalTemplate
 */
export interface PhysicalTemplate {
    /**
     * 
     * @type {string}
     * @memberof PhysicalTemplate
     */
    'uuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof PhysicalTemplate
     */
    'templateName'?: string;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof PhysicalTemplate
     */
    'speciality'?: { [key: string]: string; };
    /**
     * 
     * @type {string}
     * @memberof PhysicalTemplate
     */
    'templateTypes'?: PhysicalTemplateTemplateTypesEnum;
    /**
     * 
     * @type {boolean}
     * @memberof PhysicalTemplate
     */
    'active'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PhysicalTemplate
     */
    'archive'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PhysicalTemplate
     */
    'updateDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof PhysicalTemplate
     */
    'createdBy'?: string;
    /**
     * 
     * @type {Set<PhysicalTemplateType>}
     * @memberof PhysicalTemplate
     */
    'physicalTemplateTypeSet'?: Set<PhysicalTemplateType>;
}

export const PhysicalTemplateTemplateTypesEnum = {
    Email: 'EMAIL',
    Sms: 'SMS',
    Ros: 'ROS',
    Physical: 'PHYSICAL',
    Macros: 'MACROS',
    CarePlan: 'CARE_PLAN',
    HomeCareRos: 'HOME_CARE_ROS',
    HomeCarePe: 'HOME_CARE_PE'
} as const;

export type PhysicalTemplateTemplateTypesEnum = typeof PhysicalTemplateTemplateTypesEnum[keyof typeof PhysicalTemplateTemplateTypesEnum];

/**
 * 
 * @export
 * @interface PhysicalTemplateType
 */
export interface PhysicalTemplateType {
    /**
     * 
     * @type {string}
     * @memberof PhysicalTemplateType
     */
    'uuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof PhysicalTemplateType
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof PhysicalTemplateType
     */
    'value'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PhysicalTemplateType
     */
    'isSelected'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PhysicalTemplateType
     */
    'isBaseType'?: boolean;
}
/**
 * 
 * @export
 * @interface PlanDTO
 */
export interface PlanDTO {
    /**
     * 
     * @type {string}
     * @memberof PlanDTO
     */
    'title'?: string;
    /**
     * 
     * @type {Content}
     * @memberof PlanDTO
     */
    'content'?: Content;
}
/**
 * 
 * @export
 * @interface PrescriptionForm
 */
export interface PrescriptionForm {
    /**
     * 
     * @type {string}
     * @memberof PrescriptionForm
     */
    'uuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof PrescriptionForm
     */
    'prescriptionFormType'?: PrescriptionFormPrescriptionFormTypeEnum;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof PrescriptionForm
     */
    'medication'?: { [key: string]: string; };
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof PrescriptionForm
     */
    'medicationId'?: { [key: string]: string; };
    /**
     * 
     * @type {string}
     * @memberof PrescriptionForm
     */
    'prescriptionDate'?: string;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof PrescriptionForm
     */
    'provider'?: { [key: string]: string; };
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof PrescriptionForm
     */
    'location'?: { [key: string]: string; };
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof PrescriptionForm
     */
    'patient'?: { [key: string]: string; };
    /**
     * 
     * @type {string}
     * @memberof PrescriptionForm
     */
    'directionToPatient'?: string;
    /**
     * 
     * @type {string}
     * @memberof PrescriptionForm
     */
    'duration'?: string;
    /**
     * 
     * @type {string}
     * @memberof PrescriptionForm
     */
    'quantity'?: string;
    /**
     * 
     * @type {string}
     * @memberof PrescriptionForm
     */
    'unit'?: PrescriptionFormUnitEnum;
    /**
     * 
     * @type {string}
     * @memberof PrescriptionForm
     */
    'refills'?: string;
    /**
     * 
     * @type {string}
     * @memberof PrescriptionForm
     */
    'startDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof PrescriptionForm
     */
    'endDate'?: string;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof PrescriptionForm
     */
    'preferences'?: { [key: string]: string; };
    /**
     * 
     * @type {PharmacyLabRadiology}
     * @memberof PrescriptionForm
     */
    'pharmacyDetails'?: PharmacyLabRadiology;
    /**
     * 
     * @type {string}
     * @memberof PrescriptionForm
     */
    'notFillBefore'?: string;
    /**
     * 
     * @type {string}
     * @memberof PrescriptionForm
     */
    'preferredDelivery'?: PrescriptionFormPreferredDeliveryEnum;
    /**
     * 
     * @type {string}
     * @memberof PrescriptionForm
     */
    'priorAuthorization'?: string;
    /**
     * 
     * @type {string}
     * @memberof PrescriptionForm
     */
    'directionToPharmacist'?: string;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof PrescriptionForm
     */
    'medicalCodes'?: { [key: string]: string; };
    /**
     * 
     * @type {boolean}
     * @memberof PrescriptionForm
     */
    'active'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PrescriptionForm
     */
    'archive'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PrescriptionForm
     */
    'appointmentId'?: string;
    /**
     * 
     * @type {string}
     * @memberof PrescriptionForm
     */
    'providerStatus'?: PrescriptionFormProviderStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof PrescriptionForm
     */
    'facility'?: PrescriptionFormFacilityEnum;
    /**
     * 
     * @type {Set<Patientallergy>}
     * @memberof PrescriptionForm
     */
    'patientAllergies'?: Set<Patientallergy>;
    /**
     * 
     * @type {Set<PrescriptionMedicationSummary>}
     * @memberof PrescriptionForm
     */
    'patientMedications'?: Set<PrescriptionMedicationSummary>;
    /**
     * 
     * @type {string}
     * @memberof PrescriptionForm
     */
    'prescriptionStatus'?: PrescriptionFormPrescriptionStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof PrescriptionForm
     */
    'substitutionsOrDispense'?: PrescriptionFormSubstitutionsOrDispenseEnum;
    /**
     * 
     * @type {string}
     * @memberof PrescriptionForm
     */
    'reason'?: string;
    /**
     * 
     * @type {Set<PrescriptionMedicationData>}
     * @memberof PrescriptionForm
     */
    'medicationData'?: Set<PrescriptionMedicationData>;
    /**
     * 
     * @type {string}
     * @memberof PrescriptionForm
     */
    'providerNpi'?: string;
    /**
     * 
     * @type {string}
     * @memberof PrescriptionForm
     */
    'providerDea'?: string;
    /**
     * 
     * @type {string}
     * @memberof PrescriptionForm
     */
    'providerLicenseNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof PrescriptionForm
     */
    'providerSignature'?: string;
}

export const PrescriptionFormPrescriptionFormTypeEnum = {
    NewRx: 'NEW_RX',
    ChangeRx: 'CHANGE_RX',
    Refile: 'REFILE'
} as const;

export type PrescriptionFormPrescriptionFormTypeEnum = typeof PrescriptionFormPrescriptionFormTypeEnum[keyof typeof PrescriptionFormPrescriptionFormTypeEnum];
export const PrescriptionFormUnitEnum = {
    Percent: 'PERCENT',
    Capsule: 'CAPSULE',
    Drops: 'DROPS',
    G: 'G',
    Iu: 'IU',
    Mcg: 'MCG',
    Meq: 'MEQ',
    Mg: 'MG',
    MgPerKg: 'MG_PER_KG',
    MgPerMl: 'MG_PER_ML',
    Ml: 'ML',
    MlPerHour: 'ML_PER_HOUR',
    Puffs: 'PUFFS',
    Sprays: 'SPRAYS',
    Tablespoon: 'TABLESPOON',
    Tablets: 'TABLETS',
    Teaspoon: 'TEASPOON',
    Unit: 'UNIT'
} as const;

export type PrescriptionFormUnitEnum = typeof PrescriptionFormUnitEnum[keyof typeof PrescriptionFormUnitEnum];
export const PrescriptionFormPreferredDeliveryEnum = {
    Print: 'PRINT'
} as const;

export type PrescriptionFormPreferredDeliveryEnum = typeof PrescriptionFormPreferredDeliveryEnum[keyof typeof PrescriptionFormPreferredDeliveryEnum];
export const PrescriptionFormProviderStatusEnum = {
    Pending: 'PENDING',
    Confirmed: 'CONFIRMED'
} as const;

export type PrescriptionFormProviderStatusEnum = typeof PrescriptionFormProviderStatusEnum[keyof typeof PrescriptionFormProviderStatusEnum];
export const PrescriptionFormFacilityEnum = {
    Silverside: 'SILVERSIDE',
    Brandywine: 'BRANDYWINE',
    Newark: 'NEWARK',
    Milford: 'MILFORD',
    Exton: 'EXTON',
    Reading: 'READING'
} as const;

export type PrescriptionFormFacilityEnum = typeof PrescriptionFormFacilityEnum[keyof typeof PrescriptionFormFacilityEnum];
export const PrescriptionFormPrescriptionStatusEnum = {
    Draft: 'DRAFT',
    Sent: 'SENT',
    Ordered: 'ORDERED',
    Canceled: 'CANCELED',
    Dispensed: 'DISPENSED',
    Delivered: 'DELIVERED',
    Received: 'RECEIVED',
    InProgress: 'IN_PROGRESS',
    ReadyForPickup: 'READY_FOR_PICKUP',
    PartiallyFilled: 'PARTIALLY_FILLED',
    Filled: 'FILLED',
    PickedUp: 'PICKED_UP',
    Rejected: 'REJECTED',
    Cancelled: 'CANCELLED',
    Expired: 'EXPIRED',
    OnHold: 'ON_HOLD',
    Returned: 'RETURNED',
    PriorAuthRequired: 'PRIOR_AUTH_REQUIRED',
    InsuranceRejected: 'INSURANCE_REJECTED',
    Transferred: 'TRANSFERRED',
    Discontinued: 'DISCONTINUED'
} as const;

export type PrescriptionFormPrescriptionStatusEnum = typeof PrescriptionFormPrescriptionStatusEnum[keyof typeof PrescriptionFormPrescriptionStatusEnum];
export const PrescriptionFormSubstitutionsOrDispenseEnum = {
    SubstitutionsPermitted: 'SUBSTITUTIONS_PERMITTED',
    DispenseAsWritten: 'DISPENSE_AS_WRITTEN'
} as const;

export type PrescriptionFormSubstitutionsOrDispenseEnum = typeof PrescriptionFormSubstitutionsOrDispenseEnum[keyof typeof PrescriptionFormSubstitutionsOrDispenseEnum];

/**
 * 
 * @export
 * @interface PrescriptionMedicationData
 */
export interface PrescriptionMedicationData {
    /**
     * 
     * @type {string}
     * @memberof PrescriptionMedicationData
     */
    'uuid'?: string;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof PrescriptionMedicationData
     */
    'medicationId'?: { [key: string]: string; };
    /**
     * 
     * @type {string}
     * @memberof PrescriptionMedicationData
     */
    'prescriptionFormType'?: string;
    /**
     * 
     * @type {string}
     * @memberof PrescriptionMedicationData
     */
    'quantity'?: string;
    /**
     * 
     * @type {string}
     * @memberof PrescriptionMedicationData
     */
    'directionToPatient'?: string;
    /**
     * 
     * @type {string}
     * @memberof PrescriptionMedicationData
     */
    'unit'?: PrescriptionMedicationDataUnitEnum;
    /**
     * 
     * @type {string}
     * @memberof PrescriptionMedicationData
     */
    'refills'?: string;
    /**
     * 
     * @type {string}
     * @memberof PrescriptionMedicationData
     */
    'startDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof PrescriptionMedicationData
     */
    'endDate'?: string;
}

export const PrescriptionMedicationDataUnitEnum = {
    Percent: 'PERCENT',
    Capsule: 'CAPSULE',
    Drops: 'DROPS',
    G: 'G',
    Iu: 'IU',
    Mcg: 'MCG',
    Meq: 'MEQ',
    Mg: 'MG',
    MgPerKg: 'MG_PER_KG',
    MgPerMl: 'MG_PER_ML',
    Ml: 'ML',
    MlPerHour: 'ML_PER_HOUR',
    Puffs: 'PUFFS',
    Sprays: 'SPRAYS',
    Tablespoon: 'TABLESPOON',
    Tablets: 'TABLETS',
    Teaspoon: 'TEASPOON',
    Unit: 'UNIT'
} as const;

export type PrescriptionMedicationDataUnitEnum = typeof PrescriptionMedicationDataUnitEnum[keyof typeof PrescriptionMedicationDataUnitEnum];

/**
 * 
 * @export
 * @interface PrescriptionMedicationSummary
 */
export interface PrescriptionMedicationSummary {
    /**
     * 
     * @type {string}
     * @memberof PrescriptionMedicationSummary
     */
    'uuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof PrescriptionMedicationSummary
     */
    'prescriptionFormType'?: PrescriptionMedicationSummaryPrescriptionFormTypeEnum;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof PrescriptionMedicationSummary
     */
    'medicationId'?: { [key: string]: string; };
    /**
     * 
     * @type {string}
     * @memberof PrescriptionMedicationSummary
     */
    'prescriptionDate'?: string;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof PrescriptionMedicationSummary
     */
    'provider'?: { [key: string]: string; };
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof PrescriptionMedicationSummary
     */
    'patient'?: { [key: string]: string; };
    /**
     * 
     * @type {string}
     * @memberof PrescriptionMedicationSummary
     */
    'directionToPatient'?: string;
    /**
     * 
     * @type {string}
     * @memberof PrescriptionMedicationSummary
     */
    'duration'?: string;
    /**
     * 
     * @type {string}
     * @memberof PrescriptionMedicationSummary
     */
    'quantity'?: string;
    /**
     * 
     * @type {string}
     * @memberof PrescriptionMedicationSummary
     */
    'unit'?: PrescriptionMedicationSummaryUnitEnum;
    /**
     * 
     * @type {string}
     * @memberof PrescriptionMedicationSummary
     */
    'refills'?: string;
    /**
     * 
     * @type {string}
     * @memberof PrescriptionMedicationSummary
     */
    'startDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof PrescriptionMedicationSummary
     */
    'endDate'?: string;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof PrescriptionMedicationSummary
     */
    'preferences'?: { [key: string]: string; };
    /**
     * 
     * @type {string}
     * @memberof PrescriptionMedicationSummary
     */
    'notFillBefore'?: string;
    /**
     * 
     * @type {string}
     * @memberof PrescriptionMedicationSummary
     */
    'preferredDelivery'?: PrescriptionMedicationSummaryPreferredDeliveryEnum;
    /**
     * 
     * @type {string}
     * @memberof PrescriptionMedicationSummary
     */
    'priorAuthorization'?: string;
    /**
     * 
     * @type {string}
     * @memberof PrescriptionMedicationSummary
     */
    'directionToPharmacist'?: string;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof PrescriptionMedicationSummary
     */
    'medicalCodes'?: { [key: string]: string; };
}

export const PrescriptionMedicationSummaryPrescriptionFormTypeEnum = {
    NewRx: 'NEW_RX',
    ChangeRx: 'CHANGE_RX',
    Refile: 'REFILE'
} as const;

export type PrescriptionMedicationSummaryPrescriptionFormTypeEnum = typeof PrescriptionMedicationSummaryPrescriptionFormTypeEnum[keyof typeof PrescriptionMedicationSummaryPrescriptionFormTypeEnum];
export const PrescriptionMedicationSummaryUnitEnum = {
    Percent: 'PERCENT',
    Capsule: 'CAPSULE',
    Drops: 'DROPS',
    G: 'G',
    Iu: 'IU',
    Mcg: 'MCG',
    Meq: 'MEQ',
    Mg: 'MG',
    MgPerKg: 'MG_PER_KG',
    MgPerMl: 'MG_PER_ML',
    Ml: 'ML',
    MlPerHour: 'ML_PER_HOUR',
    Puffs: 'PUFFS',
    Sprays: 'SPRAYS',
    Tablespoon: 'TABLESPOON',
    Tablets: 'TABLETS',
    Teaspoon: 'TEASPOON',
    Unit: 'UNIT'
} as const;

export type PrescriptionMedicationSummaryUnitEnum = typeof PrescriptionMedicationSummaryUnitEnum[keyof typeof PrescriptionMedicationSummaryUnitEnum];
export const PrescriptionMedicationSummaryPreferredDeliveryEnum = {
    Print: 'PRINT'
} as const;

export type PrescriptionMedicationSummaryPreferredDeliveryEnum = typeof PrescriptionMedicationSummaryPreferredDeliveryEnum[keyof typeof PrescriptionMedicationSummaryPreferredDeliveryEnum];

/**
 * 
 * @export
 * @interface PrintConfiguration
 */
export interface PrintConfiguration {
    /**
     * 
     * @type {string}
     * @memberof PrintConfiguration
     */
    'uuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof PrintConfiguration
     */
    'headerName'?: string;
    /**
     * 
     * @type {string}
     * @memberof PrintConfiguration
     */
    'headerContent'?: string;
    /**
     * 
     * @type {string}
     * @memberof PrintConfiguration
     */
    'headerImage'?: string;
    /**
     * 
     * @type {string}
     * @memberof PrintConfiguration
     */
    'headerAlign'?: PrintConfigurationHeaderAlignEnum;
    /**
     * 
     * @type {boolean}
     * @memberof PrintConfiguration
     */
    'archive'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PrintConfiguration
     */
    'active'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PrintConfiguration
     */
    'default'?: boolean;
}

export const PrintConfigurationHeaderAlignEnum = {
    Left: 'LEFT',
    Right: 'RIGHT',
    Fit: 'FIT'
} as const;

export type PrintConfigurationHeaderAlignEnum = typeof PrintConfigurationHeaderAlignEnum[keyof typeof PrintConfigurationHeaderAlignEnum];

/**
 * 
 * @export
 * @interface Privilege
 */
export interface Privilege {
    /**
     * 
     * @type {number}
     * @memberof Privilege
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof Privilege
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof Privilege
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof Privilege
     */
    'module'?: PrivilegeModuleEnum;
    /**
     * 
     * @type {string}
     * @memberof Privilege
     */
    'access'?: string;
}

export const PrivilegeModuleEnum = {
    PatientManagement: 'PATIENT_MANAGEMENT',
    PatientChart: 'PATIENT_CHART',
    Scheduling: 'SCHEDULING',
    Encounter: 'ENCOUNTER',
    PatientEngagement: 'PATIENT_ENGAGEMENT',
    Library: 'LIBRARY',
    AiScriber: 'AI_SCRIBER',
    Settings: 'SETTINGS',
    Billing: 'BILLING',
    TaskManagement: 'TASK_MANAGEMENT',
    EducationMaterialManagement: 'EDUCATION_MATERIAL_MANAGEMENT'
} as const;

export type PrivilegeModuleEnum = typeof PrivilegeModuleEnum[keyof typeof PrivilegeModuleEnum];

/**
 * 
 * @export
 * @interface ProcedureCode
 */
export interface ProcedureCode {
    /**
     * 
     * @type {string}
     * @memberof ProcedureCode
     */
    'uuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProcedureCode
     */
    'code'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProcedureCode
     */
    'description'?: string;
}
/**
 * 
 * @export
 * @interface Provider
 */
export interface Provider {
    /**
     * 
     * @type {string}
     * @memberof Provider
     */
    'uuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof Provider
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof Provider
     */
    'firstName': string;
    /**
     * 
     * @type {string}
     * @memberof Provider
     */
    'lastName': string;
    /**
     * 
     * @type {string}
     * @memberof Provider
     */
    'phone'?: string;
    /**
     * 
     * @type {string}
     * @memberof Provider
     */
    'birthDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof Provider
     */
    'avatar'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Provider
     */
    'active'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof Provider
     */
    'source'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Provider
     */
    'archive'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof Provider
     */
    'timezone'?: ProviderTimezoneEnum;
    /**
     * 
     * @type {string}
     * @memberof Provider
     */
    'providerType'?: ProviderProviderTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof Provider
     */
    'gender': ProviderGenderEnum;
    /**
     * 
     * @type {number}
     * @memberof Provider
     */
    'npi'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof Provider
     */
    'npiNotAvailable'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof Provider
     */
    'federalTaxIdNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof Provider
     */
    'role'?: string;
    /**
     * 
     * @type {string}
     * @memberof Provider
     */
    'roleType'?: ProviderRoleTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof Provider
     */
    'officeFaxNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof Provider
     */
    'licenseNumber'?: string;
    /**
     * 
     * @type {number}
     * @memberof Provider
     */
    'groupNpiNumber'?: number;
    /**
     * 
     * @type {string}
     * @memberof Provider
     */
    'taxonomyNumber'?: string;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof Provider
     */
    'workLocations'?: { [key: string]: string; };
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof Provider
     */
    'acceptedInsurances'?: { [key: string]: string; };
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof Provider
     */
    'specialities'?: { [key: string]: string; };
    /**
     * 
     * @type {Set<LicenseInformation>}
     * @memberof Provider
     */
    'licenceInformation'?: Set<LicenseInformation>;
    /**
     * 
     * @type {Set<DEAInformation>}
     * @memberof Provider
     */
    'deaInformation'?: Set<DEAInformation>;
    /**
     * 
     * @type {string}
     * @memberof Provider
     */
    'experience'?: string;
    /**
     * 
     * @type {string}
     * @memberof Provider
     */
    'bio'?: string;
    /**
     * 
     * @type {string}
     * @memberof Provider
     */
    'errorMessage'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Provider
     */
    'acceptNewPatient'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof Provider
     */
    'referralNumber'?: string;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof Provider
     */
    'spokenLanguages'?: { [key: string]: string; };
    /**
     * 
     * @type {string}
     * @memberof Provider
     */
    'lastLogin'?: string;
    /**
     * 
     * @type {string}
     * @memberof Provider
     */
    'colorCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof Provider
     */
    'loginUrl'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Provider
     */
    'isReferral'?: boolean;
    /**
     * 
     * @type {Address}
     * @memberof Provider
     */
    'address'?: Address;
    /**
     * 
     * @type {string}
     * @memberof Provider
     */
    'practiceName'?: string;
    /**
     * 
     * @type {string}
     * @memberof Provider
     */
    'temporaryEmail'?: string;
    /**
     * 
     * @type {string}
     * @memberof Provider
     */
    'scriptsurePracticeId'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Provider
     */
    'twoFAEnabled'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof Provider
     */
    'twoFAType'?: string;
    /**
     * 
     * @type {string}
     * @memberof Provider
     */
    'referralType'?: string;
    /**
     * 
     * @type {Set<ProviderAccountDetail>}
     * @memberof Provider
     */
    'accountDetails'?: Set<ProviderAccountDetail>;
    /**
     * 
     * @type {number}
     * @memberof Provider
     */
    'id'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof Provider
     */
    'emailVerified'?: boolean;
}

export const ProviderTimezoneEnum = {
    Pst: 'PST',
    Est: 'EST',
    Cst: 'CST',
    Mst: 'MST',
    Ast: 'AST',
    Hst: 'HST',
    Edt: 'EDT',
    Pdt: 'PDT',
    Cdt: 'CDT',
    Adt: 'ADT',
    Mdt: 'MDT',
    Ist: 'IST',
    Akdt: 'AKDT',
    Akst: 'AKST',
    Gmt: 'GMT',
    Utc: 'UTC',
    Wet: 'WET',
    West: 'WEST',
    Cet: 'CET',
    Cest: 'CEST',
    Eet: 'EET',
    Eest: 'EEST',
    Msk: 'MSK',
    Msd: 'MSD',
    Aest: 'AEST',
    Aedt: 'AEDT',
    Acst: 'ACST',
    Acdt: 'ACDT',
    Awst: 'AWST',
    Nzst: 'NZST',
    Nzdt: 'NZDT',
    Sgt: 'SGT',
    Hkt: 'HKT',
    Jst: 'JST',
    Kst: 'KST',
    CstChina: 'CST_CHINA',
    Bdt: 'BDT',
    Pkt: 'PKT',
    IstIran: 'IST_IRAN',
    Trt: 'TRT',
    Idt: 'IDT',
    Wat: 'WAT',
    Cat: 'CAT',
    Eat: 'EAT',
    Art: 'ART',
    Bot: 'BOT',
    Clt: 'CLT',
    Clst: 'CLST',
    Srt: 'SRT',
    Gft: 'GFT',
    Uyt: 'UYT',
    Uyst: 'UYST',
    Vet: 'VET',
    Samt: 'SAMT',
    Yekt: 'YEKT',
    Irkt: 'IRKT',
    Krat: 'KRAT',
    Magt: 'MAGT',
    Pett: 'PETT',
    Vlat: 'VLAT',
    Chot: 'CHOT',
    Ulat: 'ULAT',
    Tmt: 'TMT',
    Orat: 'ORAT',
    Almt: 'ALMT',
    Azt: 'AZT',
    Get: 'GET',
    Mut: 'MUT',
    Sct: 'SCT',
    Ret: 'RET',
    Mvt: 'MVT',
    Cct: 'CCT',
    Sast: 'SAST',
    Nst: 'NST',
    Ndt: 'NDT'
} as const;

export type ProviderTimezoneEnum = typeof ProviderTimezoneEnum[keyof typeof ProviderTimezoneEnum];
export const ProviderProviderTypeEnum = {
    Md: 'MD',
    Do: 'DO',
    Np: 'NP',
    Pa: 'PA',
    Rn: 'RN',
    Lpn: 'LPN',
    Cns: 'CNS',
    Cnm: 'CNM',
    Crna: 'CRNA',
    Dds: 'DDS',
    Dmd: 'DMD',
    Dpm: 'DPM',
    Dc: 'DC',
    Psyd: 'PSYD',
    Phd: 'PHD',
    Lcsw: 'LCSW',
    Lpc: 'LPC',
    Ot: 'OT',
    Pt: 'PT',
    Slp: 'SLP',
    Bhs: 'BHS',
    Ma: 'MA',
    Cm: 'CM'
} as const;

export type ProviderProviderTypeEnum = typeof ProviderProviderTypeEnum[keyof typeof ProviderProviderTypeEnum];
export const ProviderGenderEnum = {
    Male: 'MALE',
    Female: 'FEMALE',
    Unknown: 'UNKNOWN',
    Other: 'OTHER'
} as const;

export type ProviderGenderEnum = typeof ProviderGenderEnum[keyof typeof ProviderGenderEnum];
export const ProviderRoleTypeEnum = {
    Provider: 'PROVIDER',
    Staff: 'STAFF',
    Patient: 'PATIENT',
    Admin: 'ADMIN',
    Physician: 'PHYSICIAN',
    BillingAdmin: 'BILLING_ADMIN',
    Biller: 'BILLER',
    FrontDeskStaff: 'FRONT_DESK_STAFF',
    SalesCoordinator: 'SALES_COORDINATOR',
    Support: 'SUPPORT',
    PracticeAdmin: 'PRACTICE_ADMIN',
    CareManager: 'CARE_MANAGER'
} as const;

export type ProviderRoleTypeEnum = typeof ProviderRoleTypeEnum[keyof typeof ProviderRoleTypeEnum];

/**
 * 
 * @export
 * @interface ProviderAccountDetail
 */
export interface ProviderAccountDetail {
    /**
     * 
     * @type {string}
     * @memberof ProviderAccountDetail
     */
    'uuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProviderAccountDetail
     */
    'routingNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProviderAccountDetail
     */
    'bankName'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProviderAccountDetail
     */
    'branchCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProviderAccountDetail
     */
    'bankAddress'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProviderAccountDetail
     */
    'accountType'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProviderAccountDetail
     */
    'accountNumber'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ProviderAccountDetail
     */
    'primary'?: boolean;
}
/**
 * 
 * @export
 * @interface ProviderAccountDetails
 */
export interface ProviderAccountDetails {
    /**
     * 
     * @type {string}
     * @memberof ProviderAccountDetails
     */
    'uuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProviderAccountDetails
     */
    'routingNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProviderAccountDetails
     */
    'bankName'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProviderAccountDetails
     */
    'branchCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProviderAccountDetails
     */
    'bankAddress'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProviderAccountDetails
     */
    'accountType'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProviderAccountDetails
     */
    'accountNumber'?: string;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof ProviderAccountDetails
     */
    'provider'?: { [key: string]: string; };
    /**
     * 
     * @type {boolean}
     * @memberof ProviderAccountDetails
     */
    'active'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ProviderAccountDetails
     */
    'archive'?: boolean;
}
/**
 * 
 * @export
 * @interface ProviderGroup
 */
export interface ProviderGroup {
    /**
     * 
     * @type {string}
     * @memberof ProviderGroup
     */
    'uuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProviderGroup
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof ProviderGroup
     */
    'schema'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProviderGroup
     */
    'subdomain'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProviderGroup
     */
    'phone'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProviderGroup
     */
    'npi'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProviderGroup
     */
    'federalTaxId'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProviderGroup
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProviderGroup
     */
    'website'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProviderGroup
     */
    'fax'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProviderGroup
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProviderGroup
     */
    'timezone': ProviderGroupTimezoneEnum;
    /**
     * 
     * @type {Address}
     * @memberof ProviderGroup
     */
    'physicalAddress'?: Address;
    /**
     * 
     * @type {Set<LocationHour>}
     * @memberof ProviderGroup
     */
    'officeHours'?: Set<LocationHour>;
    /**
     * 
     * @type {Address}
     * @memberof ProviderGroup
     */
    'billingAddress'?: Address;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof ProviderGroup
     */
    'specialities'?: { [key: string]: string; };
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof ProviderGroup
     */
    'acceptedInsurances'?: { [key: string]: string; };
    /**
     * 
     * @type {boolean}
     * @memberof ProviderGroup
     */
    'active'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ProviderGroup
     */
    'archive'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ProviderGroup
     */
    'avatar'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProviderGroup
     */
    'caller_id'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ProviderGroup
     */
    'caller_id_verified'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ProviderGroup
     */
    'loginUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProviderGroup
     */
    'scriptsureOrganizationId'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProviderGroup
     */
    'scriptsureBusinessId'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProviderGroup
     */
    'scriptsurePracticeId'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProviderGroup
     */
    'ecarehealthPatientId'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProviderGroup
     */
    'emailId'?: string;
}

export const ProviderGroupTimezoneEnum = {
    Pst: 'PST',
    Est: 'EST',
    Cst: 'CST',
    Mst: 'MST',
    Ast: 'AST',
    Hst: 'HST',
    Edt: 'EDT',
    Pdt: 'PDT',
    Cdt: 'CDT',
    Adt: 'ADT',
    Mdt: 'MDT',
    Ist: 'IST',
    Akdt: 'AKDT',
    Akst: 'AKST',
    Gmt: 'GMT',
    Utc: 'UTC',
    Wet: 'WET',
    West: 'WEST',
    Cet: 'CET',
    Cest: 'CEST',
    Eet: 'EET',
    Eest: 'EEST',
    Msk: 'MSK',
    Msd: 'MSD',
    Aest: 'AEST',
    Aedt: 'AEDT',
    Acst: 'ACST',
    Acdt: 'ACDT',
    Awst: 'AWST',
    Nzst: 'NZST',
    Nzdt: 'NZDT',
    Sgt: 'SGT',
    Hkt: 'HKT',
    Jst: 'JST',
    Kst: 'KST',
    CstChina: 'CST_CHINA',
    Bdt: 'BDT',
    Pkt: 'PKT',
    IstIran: 'IST_IRAN',
    Trt: 'TRT',
    Idt: 'IDT',
    Wat: 'WAT',
    Cat: 'CAT',
    Eat: 'EAT',
    Art: 'ART',
    Bot: 'BOT',
    Clt: 'CLT',
    Clst: 'CLST',
    Srt: 'SRT',
    Gft: 'GFT',
    Uyt: 'UYT',
    Uyst: 'UYST',
    Vet: 'VET',
    Samt: 'SAMT',
    Yekt: 'YEKT',
    Irkt: 'IRKT',
    Krat: 'KRAT',
    Magt: 'MAGT',
    Pett: 'PETT',
    Vlat: 'VLAT',
    Chot: 'CHOT',
    Ulat: 'ULAT',
    Tmt: 'TMT',
    Orat: 'ORAT',
    Almt: 'ALMT',
    Azt: 'AZT',
    Get: 'GET',
    Mut: 'MUT',
    Sct: 'SCT',
    Ret: 'RET',
    Mvt: 'MVT',
    Cct: 'CCT',
    Sast: 'SAST',
    Nst: 'NST',
    Ndt: 'NDT'
} as const;

export type ProviderGroupTimezoneEnum = typeof ProviderGroupTimezoneEnum[keyof typeof ProviderGroupTimezoneEnum];

/**
 * 
 * @export
 * @interface ProviderSignature
 */
export interface ProviderSignature {
    /**
     * 
     * @type {string}
     * @memberof ProviderSignature
     */
    'uuid'?: string;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof ProviderSignature
     */
    'provider'?: { [key: string]: string; };
    /**
     * 
     * @type {string}
     * @memberof ProviderSignature
     */
    'providerSignature'?: string;
}
/**
 * 
 * @export
 * @interface PsychiatricNoteDTO
 */
export interface PsychiatricNoteDTO {
    /**
     * 
     * @type {string}
     * @memberof PsychiatricNoteDTO
     */
    'presentingProblem'?: string;
    /**
     * 
     * @type {string}
     * @memberof PsychiatricNoteDTO
     */
    'currentMentalStatusExamination'?: string;
    /**
     * 
     * @type {string}
     * @memberof PsychiatricNoteDTO
     */
    'safetyIssues'?: string;
    /**
     * 
     * @type {string}
     * @memberof PsychiatricNoteDTO
     */
    'historyOfPresentIllness'?: string;
    /**
     * 
     * @type {string}
     * @memberof PsychiatricNoteDTO
     */
    'pastPsychiatricHistory'?: string;
    /**
     * 
     * @type {string}
     * @memberof PsychiatricNoteDTO
     */
    'substanceUseHistory'?: string;
    /**
     * 
     * @type {string}
     * @memberof PsychiatricNoteDTO
     */
    'medicalHistory'?: string;
    /**
     * 
     * @type {string}
     * @memberof PsychiatricNoteDTO
     */
    'familyPsychiatricHistory'?: string;
    /**
     * 
     * @type {string}
     * @memberof PsychiatricNoteDTO
     */
    'socialHistory'?: string;
    /**
     * 
     * @type {string}
     * @memberof PsychiatricNoteDTO
     */
    'developmentalHistory'?: string;
    /**
     * 
     * @type {string}
     * @memberof PsychiatricNoteDTO
     */
    'educationOccupationalHistory'?: string;
    /**
     * 
     * @type {string}
     * @memberof PsychiatricNoteDTO
     */
    'legalHistory'?: string;
    /**
     * 
     * @type {string}
     * @memberof PsychiatricNoteDTO
     */
    'strengthsLimitations'?: string;
    /**
     * 
     * @type {string}
     * @memberof PsychiatricNoteDTO
     */
    'otherInformation'?: string;
    /**
     * 
     * @type {string}
     * @memberof PsychiatricNoteDTO
     */
    'diagnosisCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof PsychiatricNoteDTO
     */
    'plan'?: string;
    /**
     * 
     * @type {string}
     * @memberof PsychiatricNoteDTO
     */
    'allergies'?: string;
    /**
     * 
     * @type {string}
     * @memberof PsychiatricNoteDTO
     */
    'currentMedications'?: string;
    /**
     * 
     * @type {string}
     * @memberof PsychiatricNoteDTO
     */
    'pastSurgicalHistory'?: string;
    /**
     * 
     * @type {string}
     * @memberof PsychiatricNoteDTO
     */
    'testsOrdered'?: string;
    /**
     * 
     * @type {string}
     * @memberof PsychiatricNoteDTO
     */
    'followUpInstructions'?: string;
}
/**
 * 
 * @export
 * @interface PsychotherapyActVisitNote
 */
export interface PsychotherapyActVisitNote {
    /**
     * 
     * @type {boolean}
     * @memberof PsychotherapyActVisitNote
     */
    'psychoeducationRegardingModel'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PsychotherapyActVisitNote
     */
    'psychoeducationRegardingModelNote'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PsychotherapyActVisitNote
     */
    'mindfulnessPresentMomentAwareness'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PsychotherapyActVisitNote
     */
    'mindfulnessPresentMomentAwarenessNote'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PsychotherapyActVisitNote
     */
    'cognitiveDefusionTechniques'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PsychotherapyActVisitNote
     */
    'cognitiveDefusionTechniquesNote'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PsychotherapyActVisitNote
     */
    'acceptanceOfDifficultThoughts'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PsychotherapyActVisitNote
     */
    'acceptanceOfDifficultThoughtsNote'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PsychotherapyActVisitNote
     */
    'selfAsContextExercises'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PsychotherapyActVisitNote
     */
    'selfAsContextExercisesNote'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PsychotherapyActVisitNote
     */
    'valuesClarification'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PsychotherapyActVisitNote
     */
    'valuesClarificationNote'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PsychotherapyActVisitNote
     */
    'committedActionPlanning'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PsychotherapyActVisitNote
     */
    'committedActionPlanningNote'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PsychotherapyActVisitNote
     */
    'experientialExercises'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PsychotherapyActVisitNote
     */
    'experientialExercisesNote'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PsychotherapyActVisitNote
     */
    'metaphors'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PsychotherapyActVisitNote
     */
    'metaphorsNote'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PsychotherapyActVisitNote
     */
    'behavioralCommitmentStrategies'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PsychotherapyActVisitNote
     */
    'behavioralCommitmentStrategiesNote'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PsychotherapyActVisitNote
     */
    'relapsePrevention'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PsychotherapyActVisitNote
     */
    'relapsePreventionNote'?: string;
    /**
     * 
     * @type {string}
     * @memberof PsychotherapyActVisitNote
     */
    'initialProgress'?: PsychotherapyActVisitNoteInitialProgressEnum;
    /**
     * 
     * @type {string}
     * @memberof PsychotherapyActVisitNote
     */
    'initialProgressEvidence'?: string;
    /**
     * 
     * @type {string}
     * @memberof PsychotherapyActVisitNote
     */
    'homework'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PsychotherapyActVisitNote
     */
    'educationalMaterialAssigned'?: boolean;
}

export const PsychotherapyActVisitNoteInitialProgressEnum = {
    MinimalProgress: 'MINIMAL_PROGRESS',
    ModerateProgress: 'MODERATE_PROGRESS',
    SignificantProgress: 'SIGNIFICANT_PROGRESS'
} as const;

export type PsychotherapyActVisitNoteInitialProgressEnum = typeof PsychotherapyActVisitNoteInitialProgressEnum[keyof typeof PsychotherapyActVisitNoteInitialProgressEnum];

/**
 * 
 * @export
 * @interface PsychotherapyCbtVisitNote
 */
export interface PsychotherapyCbtVisitNote {
    /**
     * 
     * @type {string}
     * @memberof PsychotherapyCbtVisitNote
     */
    'cbtSpecificComponents'?: string;
    /**
     * 
     * @type {string}
     * @memberof PsychotherapyCbtVisitNote
     */
    'homeworkSection'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PsychotherapyCbtVisitNote
     */
    'psychoeducationRegardingCbtModel'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PsychotherapyCbtVisitNote
     */
    'psychoeducationRegardingCbtModelNote'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PsychotherapyCbtVisitNote
     */
    'identificationOfAutomaticThoughts'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PsychotherapyCbtVisitNote
     */
    'identificationOfAutomaticThoughtsNote'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PsychotherapyCbtVisitNote
     */
    'identificationOfCognitiveDistortions'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PsychotherapyCbtVisitNote
     */
    'identificationOfCognitiveDistortionsNote'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PsychotherapyCbtVisitNote
     */
    'cognitiveRestructuring'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PsychotherapyCbtVisitNote
     */
    'cognitiveRestructuringNote'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PsychotherapyCbtVisitNote
     */
    'examinationOfEvidence'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PsychotherapyCbtVisitNote
     */
    'examinationOfEvidenceNote'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PsychotherapyCbtVisitNote
     */
    'developmentOfAlternativeBalancedThoughts'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PsychotherapyCbtVisitNote
     */
    'developmentOfAlternativeBalancedThoughtsNote'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PsychotherapyCbtVisitNote
     */
    'behavioralActivation'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PsychotherapyCbtVisitNote
     */
    'behavioralActivationNote'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PsychotherapyCbtVisitNote
     */
    'problemSolvingSkillsTraining'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PsychotherapyCbtVisitNote
     */
    'problemSolvingSkillsTrainingNote'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PsychotherapyCbtVisitNote
     */
    'copingSkillsDevelopment'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PsychotherapyCbtVisitNote
     */
    'copingSkillsDevelopmentNote'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PsychotherapyCbtVisitNote
     */
    'stressManagementTechniques'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PsychotherapyCbtVisitNote
     */
    'stressManagementTechniquesNote'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PsychotherapyCbtVisitNote
     */
    'relaxationAndGroundingExercises'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PsychotherapyCbtVisitNote
     */
    'relaxationAndGroundingExercisesNote'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PsychotherapyCbtVisitNote
     */
    'goalSettingAndBehavioralExperiments'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PsychotherapyCbtVisitNote
     */
    'goalSettingAndBehavioralExperimentsNote'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PsychotherapyCbtVisitNote
     */
    'relapsePreventionPlanning'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PsychotherapyCbtVisitNote
     */
    'relapsePreventionPlanningNote'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PsychotherapyCbtVisitNote
     */
    'cognitiveDistortionsIdentified'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PsychotherapyCbtVisitNote
     */
    'cognitiveDistortionsIdentifiedNote'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PsychotherapyCbtVisitNote
     */
    'allOrNothingThinking'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PsychotherapyCbtVisitNote
     */
    'allOrNothingThinkingNote'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PsychotherapyCbtVisitNote
     */
    'catastrophizing'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PsychotherapyCbtVisitNote
     */
    'catastrophizingNote'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PsychotherapyCbtVisitNote
     */
    'overgeneralization'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PsychotherapyCbtVisitNote
     */
    'overgeneralizationNote'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PsychotherapyCbtVisitNote
     */
    'mentalFiltering'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PsychotherapyCbtVisitNote
     */
    'mentalFilteringNote'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PsychotherapyCbtVisitNote
     */
    'personalization'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PsychotherapyCbtVisitNote
     */
    'personalizationNote'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PsychotherapyCbtVisitNote
     */
    'mindReading'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PsychotherapyCbtVisitNote
     */
    'mindReadingNote'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PsychotherapyCbtVisitNote
     */
    'fortuneTelling'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PsychotherapyCbtVisitNote
     */
    'fortuneTellingNote'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PsychotherapyCbtVisitNote
     */
    'emotionalReasoning'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PsychotherapyCbtVisitNote
     */
    'emotionalReasoningNote'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PsychotherapyCbtVisitNote
     */
    'labeling'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PsychotherapyCbtVisitNote
     */
    'labelingNote'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PsychotherapyCbtVisitNote
     */
    'shouldStatements'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PsychotherapyCbtVisitNote
     */
    'shouldStatementsNote'?: string;
}
/**
 * 
 * @export
 * @interface PsychotherapyDbtVisitNote
 */
export interface PsychotherapyDbtVisitNote {
    /**
     * 
     * @type {string}
     * @memberof PsychotherapyDbtVisitNote
     */
    'mindfulnessComponent'?: string;
    /**
     * 
     * @type {string}
     * @memberof PsychotherapyDbtVisitNote
     */
    'mindfulnessComponentNote'?: string;
    /**
     * 
     * @type {string}
     * @memberof PsychotherapyDbtVisitNote
     */
    'emotionRegulation'?: string;
    /**
     * 
     * @type {string}
     * @memberof PsychotherapyDbtVisitNote
     */
    'emotionRegulationNote'?: string;
    /**
     * 
     * @type {string}
     * @memberof PsychotherapyDbtVisitNote
     */
    'distressTolerance'?: string;
    /**
     * 
     * @type {string}
     * @memberof PsychotherapyDbtVisitNote
     */
    'distressToleranceNote'?: string;
    /**
     * 
     * @type {string}
     * @memberof PsychotherapyDbtVisitNote
     */
    'interpersonalEffectiveness'?: string;
    /**
     * 
     * @type {string}
     * @memberof PsychotherapyDbtVisitNote
     */
    'interpersonalEffectivenessNote'?: string;
    /**
     * 
     * @type {string}
     * @memberof PsychotherapyDbtVisitNote
     */
    'behavioralAnalysis'?: string;
    /**
     * 
     * @type {string}
     * @memberof PsychotherapyDbtVisitNote
     */
    'behavioralAnalysisNote'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PsychotherapyDbtVisitNote
     */
    'mindfulnessObserve'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PsychotherapyDbtVisitNote
     */
    'mindfulnessDescribe'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PsychotherapyDbtVisitNote
     */
    'mindfulnessParticipate'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PsychotherapyDbtVisitNote
     */
    'mindfulnessNonJudgmentally'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PsychotherapyDbtVisitNote
     */
    'mindfulnessOneMindfully'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PsychotherapyDbtVisitNote
     */
    'mindfulnessEffectiveness'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PsychotherapyDbtVisitNote
     */
    'emotionRegulationEmotionIdentification'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PsychotherapyDbtVisitNote
     */
    'emotionRegulationIdentifyingVulnerabilityFactors'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PsychotherapyDbtVisitNote
     */
    'emotionRegulationCheckTheFacts'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PsychotherapyDbtVisitNote
     */
    'emotionRegulationOppositeAction'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PsychotherapyDbtVisitNote
     */
    'emotionRegulationPleaseSkills'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PsychotherapyDbtVisitNote
     */
    'emotionRegulationBuildingPositiveExperiences'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PsychotherapyDbtVisitNote
     */
    'emotionRegulationReducingEmotionalVulnerability'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PsychotherapyDbtVisitNote
     */
    'emotionRegulationManagingEmotionalIntensity'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PsychotherapyDbtVisitNote
     */
    'distressToleranceStopSkill'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PsychotherapyDbtVisitNote
     */
    'distressToleranceTippSkills'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PsychotherapyDbtVisitNote
     */
    'distressToleranceAcceptsSkills'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PsychotherapyDbtVisitNote
     */
    'distressToleranceSelfSoothing'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PsychotherapyDbtVisitNote
     */
    'distressToleranceImproveTheMoment'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PsychotherapyDbtVisitNote
     */
    'distressToleranceProsAndCons'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PsychotherapyDbtVisitNote
     */
    'distressToleranceRadicalAcceptance'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PsychotherapyDbtVisitNote
     */
    'distressToleranceWillingnessVsWillfulness'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PsychotherapyDbtVisitNote
     */
    'interpersonalEffectivenessDearMan'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PsychotherapyDbtVisitNote
     */
    'interpersonalEffectivenessGive'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PsychotherapyDbtVisitNote
     */
    'interpersonalEffectivenessFast'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PsychotherapyDbtVisitNote
     */
    'interpersonalEffectivenessBoundarySetting'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PsychotherapyDbtVisitNote
     */
    'interpersonalEffectivenessAssertivenessTraining'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PsychotherapyDbtVisitNote
     */
    'interpersonalEffectivenessValidationStrategies'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PsychotherapyDbtVisitNote
     */
    'interpersonalEffectivenessConflictResolution'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PsychotherapyDbtVisitNote
     */
    'interpersonalEffectivenessRelationshipEffectiveness'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PsychotherapyDbtVisitNote
     */
    'behavioralAnalysisChainAnalysis'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PsychotherapyDbtVisitNote
     */
    'behavioralAnalysisSolutionAnalysis'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PsychotherapyDbtVisitNote
     */
    'behavioralAnalysisDiaryCardReview'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PsychotherapyDbtVisitNote
     */
    'behavioralAnalysisTargetBehaviorReview'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PsychotherapyDbtVisitNote
     */
    'behavioralAnalysisBehavioralRehearsal'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PsychotherapyDbtVisitNote
     */
    'behavioralAnalysisSkillsCoaching'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PsychotherapyDbtVisitNote
     */
    'targetBehaviors'?: PsychotherapyDbtVisitNoteTargetBehaviorsEnum;
    /**
     * 
     * @type {string}
     * @memberof PsychotherapyDbtVisitNote
     */
    'initialProgress'?: PsychotherapyDbtVisitNoteInitialProgressEnum;
}

export const PsychotherapyDbtVisitNoteTargetBehaviorsEnum = {
    LifeThreateningBehaviors: 'LIFE_THREATENING_BEHAVIORS',
    TherapyInterferingBehaviors: 'THERAPY_INTERFERING_BEHAVIORS',
    QualityOfLifeInterferingBehaviors: 'QUALITY_OF_LIFE_INTERFERING_BEHAVIORS',
    SkillsAcquisitionGoals: 'SKILLS_ACQUISITION_GOALS'
} as const;

export type PsychotherapyDbtVisitNoteTargetBehaviorsEnum = typeof PsychotherapyDbtVisitNoteTargetBehaviorsEnum[keyof typeof PsychotherapyDbtVisitNoteTargetBehaviorsEnum];
export const PsychotherapyDbtVisitNoteInitialProgressEnum = {
    MinimalProgress: 'MINIMAL_PROGRESS',
    ModerateProgress: 'MODERATE_PROGRESS',
    SignificantProgress: 'SIGNIFICANT_PROGRESS'
} as const;

export type PsychotherapyDbtVisitNoteInitialProgressEnum = typeof PsychotherapyDbtVisitNoteInitialProgressEnum[keyof typeof PsychotherapyDbtVisitNoteInitialProgressEnum];

/**
 * 
 * @export
 * @interface Question
 */
export interface Question {
    /**
     * 
     * @type {Set<Answer>}
     * @memberof Question
     */
    'answersOptions'?: Set<Answer>;
    /**
     * 
     * @type {string}
     * @memberof Question
     */
    'uuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof Question
     */
    'type'?: QuestionTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof Question
     */
    'question'?: string;
    /**
     * 
     * @type {number}
     * @memberof Question
     */
    'sequenceId'?: number;
    /**
     * 
     * @type {string}
     * @memberof Question
     */
    'answerType'?: QuestionAnswerTypeEnum;
}

export const QuestionTypeEnum = {
    HomeAndEnvironment: 'HOME_AND_ENVIRONMENT',
    SubstanceUse: 'SUBSTANCE_USE',
    EducationAndOccupation: 'EDUCATION_AND_OCCUPATION',
    Lifestyle: 'LIFESTYLE',
    MarriageAndSexuality: 'MARRIAGE_AND_SEXUALITY',
    AdvanceDirective: 'ADVANCE_DIRECTIVE',
    DietAndExercise: 'DIET_AND_EXERCISE',
    PublicHealthAndTravel: 'PUBLIC_HEALTH_AND_TRAVEL',
    ActivitiesOfDailyLiving: 'ACTIVITIES_OF_DAILY_LIVING',
    Covid19VaccineScreening: 'COVID_19_VACCINE_SCREENING',
    MigrationFrom123121: 'MIGRATION_FROM_123121',
    Psychiatry: 'PSYCHIATRY',
    HomeCareSubstanceUse: 'HOME_CARE_SUBSTANCE_USE'
} as const;

export type QuestionTypeEnum = typeof QuestionTypeEnum[keyof typeof QuestionTypeEnum];
export const QuestionAnswerTypeEnum = {
    Boolean: 'BOOLEAN',
    String: 'STRING',
    Text: 'TEXT'
} as const;

export type QuestionAnswerTypeEnum = typeof QuestionAnswerTypeEnum[keyof typeof QuestionAnswerTypeEnum];

/**
 * 
 * @export
 * @interface Radiology
 */
export interface Radiology {
    /**
     * 
     * @type {string}
     * @memberof Radiology
     */
    'uuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof Radiology
     */
    'radiologyName'?: string;
    /**
     * 
     * @type {string}
     * @memberof Radiology
     */
    'contactNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof Radiology
     */
    'faxNumber'?: string;
    /**
     * 
     * @type {Address}
     * @memberof Radiology
     */
    'address'?: Address;
}
/**
 * 
 * @export
 * @interface Referral
 */
export interface Referral {
    /**
     * 
     * @type {string}
     * @memberof Referral
     */
    'uuid'?: string;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof Referral
     */
    'patient'?: { [key: string]: string; };
    /**
     * 
     * @type {string}
     * @memberof Referral
     */
    'patientName'?: string;
    /**
     * 
     * @type {string}
     * @memberof Referral
     */
    'patientDob'?: string;
    /**
     * 
     * @type {string}
     * @memberof Referral
     */
    'patientGender'?: ReferralPatientGenderEnum;
    /**
     * 
     * @type {string}
     * @memberof Referral
     */
    'patientEmail'?: string;
    /**
     * 
     * @type {string}
     * @memberof Referral
     */
    'patientContact'?: string;
    /**
     * 
     * @type {string}
     * @memberof Referral
     */
    'patientUuid'?: string;
    /**
     * 
     * @type {Address}
     * @memberof Referral
     */
    'patientAddress'?: Address;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof Referral
     */
    'referralFrom'?: { [key: string]: string; };
    /**
     * 
     * @type {string}
     * @memberof Referral
     */
    'referralFromName'?: string;
    /**
     * 
     * @type {string}
     * @memberof Referral
     */
    'referralFromPhone'?: string;
    /**
     * 
     * @type {string}
     * @memberof Referral
     */
    'referralFromFax'?: string;
    /**
     * 
     * @type {Address}
     * @memberof Referral
     */
    'referralFromAddress'?: Address;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof Referral
     */
    'referralFromSpecialities'?: { [key: string]: string; };
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof Referral
     */
    'referralTo'?: { [key: string]: string; };
    /**
     * 
     * @type {string}
     * @memberof Referral
     */
    'referralToName'?: string;
    /**
     * 
     * @type {string}
     * @memberof Referral
     */
    'referralToPhone'?: string;
    /**
     * 
     * @type {string}
     * @memberof Referral
     */
    'referralToFax'?: string;
    /**
     * 
     * @type {Address}
     * @memberof Referral
     */
    'referralToAddress'?: Address;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof Referral
     */
    'referralToSpecialities'?: { [key: string]: string; };
    /**
     * 
     * @type {string}
     * @memberof Referral
     */
    'referralPriority'?: ReferralReferralPriorityEnum;
    /**
     * 
     * @type {string}
     * @memberof Referral
     */
    'referralReason'?: string;
    /**
     * 
     * @type {string}
     * @memberof Referral
     */
    'referralNote'?: string;
    /**
     * 
     * @type {string}
     * @memberof Referral
     */
    'referralDate'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Referral
     */
    'active'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Referral
     */
    'archive'?: boolean;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof Referral
     */
    'referralSpecialities'?: { [key: string]: string; };
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof Referral
     */
    'referralInsurance'?: { [key: string]: string; };
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof Referral
     */
    'referralDiagnosisCode'?: { [key: string]: string; };
    /**
     * 
     * @type {string}
     * @memberof Referral
     */
    'referralDocumentName'?: string;
    /**
     * 
     * @type {string}
     * @memberof Referral
     */
    'referralDocument'?: string;
    /**
     * 
     * @type {PatientInsurance}
     * @memberof Referral
     */
    'patientInsurance'?: PatientInsurance;
    /**
     * 
     * @type {boolean}
     * @memberof Referral
     */
    'referralIn'?: boolean;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof Referral
     */
    'referralAppointment'?: { [key: string]: string; };
    /**
     * 
     * @type {string}
     * @memberof Referral
     */
    'referralStatus'?: ReferralReferralStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof Referral
     */
    'referralType'?: string;
    /**
     * 
     * @type {string}
     * @memberof Referral
     */
    'description'?: string;
}

export const ReferralPatientGenderEnum = {
    Male: 'MALE',
    Female: 'FEMALE',
    Unknown: 'UNKNOWN',
    Other: 'OTHER'
} as const;

export type ReferralPatientGenderEnum = typeof ReferralPatientGenderEnum[keyof typeof ReferralPatientGenderEnum];
export const ReferralReferralPriorityEnum = {
    High: 'HIGH',
    Low: 'LOW',
    Medium: 'MEDIUM'
} as const;

export type ReferralReferralPriorityEnum = typeof ReferralReferralPriorityEnum[keyof typeof ReferralReferralPriorityEnum];
export const ReferralReferralStatusEnum = {
    Pending: 'PENDING',
    Closed: 'CLOSED',
    Sent: 'SENT',
    Accepted: 'ACCEPTED',
    Completed: 'COMPLETED',
    Scheduled: 'SCHEDULED',
    Rejected: 'REJECTED'
} as const;

export type ReferralReferralStatusEnum = typeof ReferralReferralStatusEnum[keyof typeof ReferralReferralStatusEnum];

/**
 * 
 * @export
 * @interface ReferringAgency
 */
export interface ReferringAgency {
    /**
     * 
     * @type {string}
     * @memberof ReferringAgency
     */
    'uuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof ReferringAgency
     */
    'agencyId': string;
    /**
     * 
     * @type {string}
     * @memberof ReferringAgency
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof ReferringAgency
     */
    'agencyType': string;
    /**
     * 
     * @type {string}
     * @memberof ReferringAgency
     */
    'contactPerson': string;
    /**
     * 
     * @type {string}
     * @memberof ReferringAgency
     */
    'contactRole': string;
    /**
     * 
     * @type {string}
     * @memberof ReferringAgency
     */
    'phone': string;
    /**
     * 
     * @type {string}
     * @memberof ReferringAgency
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof ReferringAgency
     */
    'fax'?: string;
    /**
     * 
     * @type {string}
     * @memberof ReferringAgency
     */
    'npi'?: string;
    /**
     * 
     * @type {Address}
     * @memberof ReferringAgency
     */
    'address'?: Address;
    /**
     * 
     * @type {boolean}
     * @memberof ReferringAgency
     */
    'archive'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ReferringAgency
     */
    'active'?: boolean;
}
/**
 * 
 * @export
 * @interface Reminder
 */
export interface Reminder {
    /**
     * 
     * @type {string}
     * @memberof Reminder
     */
    'uuid'?: string;
    /**
     * 
     * @type {Set<string>}
     * @memberof Reminder
     */
    'reminderMedium'?: Set<ReminderReminderMediumEnum>;
    /**
     * 
     * @type {string}
     * @memberof Reminder
     */
    'reminderBeforeNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof Reminder
     */
    'reminderBeforeUnit'?: ReminderReminderBeforeUnitEnum;
}

export const ReminderReminderMediumEnum = {
    Email: 'EMAIL',
    PushNotification: 'PUSH_NOTIFICATION',
    Sms: 'SMS'
} as const;

export type ReminderReminderMediumEnum = typeof ReminderReminderMediumEnum[keyof typeof ReminderReminderMediumEnum];
export const ReminderReminderBeforeUnitEnum = {
    Minutes: 'MINUTES',
    Hours: 'HOURS',
    Days: 'DAYS'
} as const;

export type ReminderReminderBeforeUnitEnum = typeof ReminderReminderBeforeUnitEnum[keyof typeof ReminderReminderBeforeUnitEnum];

/**
 * 
 * @export
 * @interface RescheduleAppointment
 */
export interface RescheduleAppointment {
    /**
     * 
     * @type {string}
     * @memberof RescheduleAppointment
     */
    'uuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof RescheduleAppointment
     */
    'locationId'?: string;
    /**
     * 
     * @type {string}
     * @memberof RescheduleAppointment
     */
    'startTime': string;
    /**
     * 
     * @type {string}
     * @memberof RescheduleAppointment
     */
    'endTime': string;
    /**
     * 
     * @type {string}
     * @memberof RescheduleAppointment
     */
    'room'?: string;
    /**
     * 
     * @type {string}
     * @memberof RescheduleAppointment
     */
    'chiefComplaint'?: string;
    /**
     * 
     * @type {string}
     * @memberof RescheduleAppointment
     */
    'note'?: string;
    /**
     * 
     * @type {string}
     * @memberof RescheduleAppointment
     */
    'emailForms'?: string;
    /**
     * 
     * @type {string}
     * @memberof RescheduleAppointment
     */
    'source'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof RescheduleAppointment
     */
    'emailedFormsStatus'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof RescheduleAppointment
     */
    'duration'?: number;
    /**
     * 
     * @type {string}
     * @memberof RescheduleAppointment
     */
    'mode'?: RescheduleAppointmentModeEnum;
    /**
     * 
     * @type {string}
     * @memberof RescheduleAppointment
     */
    'customForms'?: string;
    /**
     * 
     * @type {string}
     * @memberof RescheduleAppointment
     */
    'assessments'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof RescheduleAppointment
     */
    'sendForms'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof RescheduleAppointment
     */
    'visitNote'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof RescheduleAppointment
     */
    'appointmentRequest'?: boolean;
}

export const RescheduleAppointmentModeEnum = {
    InPerson: 'IN_PERSON',
    Virtual: 'VIRTUAL'
} as const;

export type RescheduleAppointmentModeEnum = typeof RescheduleAppointmentModeEnum[keyof typeof RescheduleAppointmentModeEnum];

/**
 * 
 * @export
 * @interface RescheduleAssessmentRequest
 */
export interface RescheduleAssessmentRequest {
    /**
     * 
     * @type {string}
     * @memberof RescheduleAssessmentRequest
     */
    'patientId'?: string;
    /**
     * 
     * @type {string}
     * @memberof RescheduleAssessmentRequest
     */
    'appointmentId'?: string;
    /**
     * 
     * @type {string}
     * @memberof RescheduleAssessmentRequest
     */
    'screenerType'?: string;
    /**
     * 
     * @type {string}
     * @memberof RescheduleAssessmentRequest
     */
    'scheduleTime'?: string;
}
/**
 * 
 * @export
 * @interface ResetPasswordRequest
 */
export interface ResetPasswordRequest {
    /**
     * 
     * @type {string}
     * @memberof ResetPasswordRequest
     */
    'newPassword': string;
    /**
     * 
     * @type {string}
     * @memberof ResetPasswordRequest
     */
    'expiryCode'?: string;
}
/**
 * 
 * @export
 * @interface Response
 */
export interface Response {
    /**
     * 
     * @type {string}
     * @memberof Response
     */
    'date'?: string;
    /**
     * 
     * @type {string}
     * @memberof Response
     */
    'code'?: ResponseCodeEnum;
    /**
     * 
     * @type {object}
     * @memberof Response
     */
    'message'?: object;
    /**
     * 
     * @type {object}
     * @memberof Response
     */
    'data'?: object;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof Response
     */
    'errors'?: { [key: string]: string; };
    /**
     * 
     * @type {string}
     * @memberof Response
     */
    'debugMessage'?: string;
    /**
     * 
     * @type {string}
     * @memberof Response
     */
    'userMessage'?: string;
    /**
     * 
     * @type {string}
     * @memberof Response
     */
    'path'?: string;
    /**
     * 
     * @type {string}
     * @memberof Response
     */
    'requestId'?: string;
    /**
     * 
     * @type {string}
     * @memberof Response
     */
    'version'?: string;
}

export const ResponseCodeEnum = {
    InternalError: 'INTERNAL_ERROR',
    AccessDenied: 'ACCESS_DENIED',
    BadRequest: 'BAD_REQUEST',
    NotFound: 'NOT_FOUND',
    Created: 'CREATED',
    UnsupportedMediaType: 'UNSUPPORTED_MEDIA_TYPE',
    Ok: 'OK',
    ServiceUnavailable: 'SERVICE_UNAVAILABLE',
    Entity: 'ENTITY',
    DbError: 'DB_ERROR',
    IamError: 'IAM_ERROR',
    AwsError: 'AWS_ERROR',
    UserArchived: 'USER_ARCHIVED',
    UserUnarchived: 'USER_UNARCHIVED',
    UserNotExist: 'USER_NOT_EXIST',
    BillingInvoiceStatement: 'BILLING_INVOICE_STATEMENT',
    InvalidCredentials: 'INVALID_CREDENTIALS',
    LoginFailed: 'LOGIN_FAILED',
    AccountLocked: 'ACCOUNT_LOCKED',
    InvalidRefreshToken: 'INVALID_REFRESH_TOKEN',
    LogoutResponse: 'LOGOUT_RESPONSE',
    LogoutFailed: 'LOGOUT_FAILED',
    SessionExpired: 'SESSION_EXPIRED',
    SetPasswordResponse: 'SET_PASSWORD_RESPONSE',
    InvalidPasswordLink: 'INVALID_PASSWORD_LINK',
    InvalidPassword: 'INVALID_PASSWORD',
    ResetPasswordFailed: 'RESET_PASSWORD_FAILED',
    ChangePasswordResponse: 'CHANGE_PASSWORD_RESPONSE',
    VerifyPasswordLinkResponse: 'VERIFY_PASSWORD_LINK_RESPONSE',
    ForgotPasswordResponse: 'FORGOT_PASSWORD_RESPONSE',
    ResendInviteEmailResponse: 'RESEND_INVITE_EMAIL_RESPONSE',
    UserCreated: 'USER_CREATED',
    UserNotFound: 'USER_NOT_FOUND',
    UserEmailNotFound: 'USER_EMAIL_NOT_FOUND',
    UpdateUserProfileResponse: 'UPDATE_USER_PROFILE_RESPONSE',
    LinkUserToLocation: 'LINK_USER_TO_LOCATION',
    LinkDepartmentToLocation: 'LINK_DEPARTMENT_TO_LOCATION',
    LinkProviderToLocation: 'LINK_PROVIDER_TO_LOCATION',
    UserEnabled: 'USER_ENABLED',
    UserDisabled: 'USER_DISABLED',
    DuplicateEmailError: 'DUPLICATE_EMAIL_ERROR',
    ChangeAvatarResponse: 'CHANGE_AVATAR_RESPONSE',
    ChangeAvatarResponseProviderGroup: 'CHANGE_AVATAR_RESPONSE_PROVIDER_GROUP',
    ProviderGroupCallerId: 'PROVIDER_GROUP_CALLER_ID',
    ChangeAvatarResponseUser: 'CHANGE_AVATAR_RESPONSE_USER',
    ChangeAvatarResponsePatient: 'CHANGE_AVATAR_RESPONSE_PATIENT',
    ChangeAvatarResponseLocation: 'CHANGE_AVATAR_RESPONSE_LOCATION',
    RemoveAvatarResponseUser: 'REMOVE_AVATAR_RESPONSE_USER',
    UserEmailRequired: 'USER_EMAIL_REQUIRED',
    UserEmailUpdateError: 'USER_EMAIL_UPDATE_ERROR',
    InvalidUserRole: 'INVALID_USER_ROLE',
    UserEmailVerified: 'USER_EMAIL_VERIFIED',
    SignedUp: 'SIGNED_UP',
    UserInactive: 'USER_INACTIVE',
    EmptyEmail: 'EMPTY_EMAIL',
    MailSentSuccessfully: 'MAIL_SENT_SUCCESSFULLY',
    RemoveProviderGroupAvatar: 'REMOVE_PROVIDER_GROUP_AVATAR',
    RemoveProviderAvatar: 'REMOVE_PROVIDER_AVATAR',
    RemovePatientAvatar: 'REMOVE_PATIENT_AVATAR',
    ProviderGroupCallerIdRemoved: 'PROVIDER_GROUP_CALLER_ID_REMOVED',
    ProviderGroupEmailIdRemoved: 'PROVIDER_GROUP_EMAIL_ID_REMOVED',
    ProviderGroupCreated: 'PROVIDER_GROUP_CREATED',
    ProviderGroupUpdated: 'PROVIDER_GROUP_UPDATED',
    VerifyEmail: 'VERIFY_EMAIL',
    FailedUpdateProviderGroup: 'FAILED_UPDATE_PROVIDER_GROUP',
    ProviderGroupEnabled: 'PROVIDER_GROUP_ENABLED',
    ProviderGroupDisabled: 'PROVIDER_GROUP_DISABLED',
    ProviderGroupArchived: 'PROVIDER_GROUP_ARCHIVED',
    ProviderGroupUnarchived: 'PROVIDER_GROUP_UNARCHIVED',
    ProviderGroupTwilioNumber: 'PROVIDER_GROUP_TWILIO_NUMBER',
    PatientPaymentCreated: 'PATIENT_PAYMENT_CREATED',
    LocationCreated: 'LOCATION_CREATED',
    LocationUpdated: 'LOCATION_UPDATED',
    LocationNotFound: 'LOCATION_NOT_FOUND',
    LocationEnabled: 'LOCATION_ENABLED',
    LocationDisabled: 'LOCATION_DISABLED',
    LocationArchived: 'LOCATION_ARCHIVED',
    LocationUnarchived: 'LOCATION_UNARCHIVED',
    DepartmentCreated: 'DEPARTMENT_CREATED',
    DepartmentUpdated: 'DEPARTMENT_UPDATED',
    DepartmentEnabled: 'DEPARTMENT_ENABLED',
    DepartmentDisabled: 'DEPARTMENT_DISABLED',
    DepartmentArchived: 'DEPARTMENT_ARCHIVED',
    DepartmentUnarchived: 'DEPARTMENT_UNARCHIVED',
    ReferringAgencyCreated: 'REFERRING_AGENCY_CREATED',
    ReferringAgencyUpdated: 'REFERRING_AGENCY_UPDATED',
    ReferringAgencyArchived: 'REFERRING_AGENCY_ARCHIVED',
    ReferringAgencyUnarchived: 'REFERRING_AGENCY_UNARCHIVED',
    ProviderCreated: 'PROVIDER_CREATED',
    ProviderUpdated: 'PROVIDER_UPDATED',
    ProviderEnabled: 'PROVIDER_ENABLED',
    ProviderDisabled: 'PROVIDER_DISABLED',
    ProviderArchived: 'PROVIDER_ARCHIVED',
    ProviderUnarchived: 'PROVIDER_UNARCHIVED',
    NpiAlreadyExist: 'NPI_ALREADY_EXIST',
    PatientCreated: 'PATIENT_CREATED',
    PatientUpdate: 'PATIENT_UPDATE',
    PatientStatusUpdated: 'PATIENT_STATUS_UPDATED',
    PatientArchiveStatusUpdated: 'PATIENT_ARCHIVE_STATUS_UPDATED',
    PatientUnarchiveStatusUpdated: 'PATIENT_UNARCHIVE_STATUS_UPDATED',
    PatientEnableDisableResponse: 'PATIENT_ENABLE_DISABLE_RESPONSE',
    FailedPatientUpdate: 'FAILED_PATIENT_UPDATE',
    PatientNotFound: 'PATIENT_NOT_FOUND',
    UserMrnUpdateError: 'USER_MRN_UPDATE_ERROR',
    PatientDataFetched: 'PATIENT_DATA_FETCHED',
    PatientDocumentRemoved: 'PATIENT_DOCUMENT_REMOVED',
    UploadDocInvalidError: 'UPLOAD_DOC_INVALID_ERROR',
    FailedPatientStatusUpdate: 'FAILED_PATIENT_STATUS_UPDATE',
    PatientArchive: 'PATIENT_ARCHIVE',
    FailedPatientArchive: 'FAILED_PATIENT_ARCHIVE',
    InvalidBirthdate: 'INVALID_BIRTHDATE',
    FailedUpdatePatientInsurance: 'FAILED_UPDATE_PATIENT_INSURANCE',
    AddedToWaitingList: 'ADDED_TO_WAITING_LIST',
    TenantConfigurationCreated: 'TENANT_CONFIGURATION_CREATED',
    TenantConfigurationUpdated: 'TENANT_CONFIGURATION_UPDATED',
    FeeAmountAdded: 'FEE_AMOUNT_ADDED',
    FeeAmountUpdated: 'FEE_AMOUNT_UPDATED',
    FeeAmountStatusChanged: 'FEE_AMOUNT_STATUS_CHANGED',
    FeeAmountAlreadyExists: 'FEE_AMOUNT_ALREADY_EXISTS',
    FeeAmountNotFound: 'FEE_AMOUNT_NOT_FOUND',
    FeeDeleted: 'FEE_DELETED',
    InvalidMedicalCode: 'INVALID_MEDICAL_CODE',
    PatientAdded: 'PATIENT_ADDED',
    PatientArchived: 'PATIENT_ARCHIVED',
    PatientUnarchived: 'PATIENT_UNARCHIVED',
    PatientEnabled: 'PATIENT_ENABLED',
    PatientDisabled: 'PATIENT_DISABLED',
    IntakeFormsSent: 'INTAKE_FORMS_SENT',
    InsurancepayerNotFound: 'INSURANCEPAYER_NOT_FOUND',
    InsurancePolicyNotFound: 'INSURANCE_POLICY_NOT_FOUND',
    TooManyInsurances: 'TOO_MANY_INSURANCES',
    InsuranceNotFound: 'INSURANCE_NOT_FOUND',
    SecondaryInsuranceNotFound: 'SECONDARY_INSURANCE_NOT_FOUND',
    InsurancetypeUpdated: 'INSURANCETYPE_UPDATED',
    CannotUpdateInsurancetype: 'CANNOT_UPDATE_INSURANCETYPE',
    PatientInsuranceUpdate: 'PATIENT_INSURANCE_UPDATE',
    SecondaryInsuranceRemoved: 'SECONDARY_INSURANCE_REMOVED',
    DuplicateInsuranceError: 'DUPLICATE_INSURANCE_ERROR',
    InsurancePayerCreated: 'INSURANCE_PAYER_CREATED',
    InsurancePayerUpdated: 'INSURANCE_PAYER_UPDATED',
    InsurancePayerNameExists: 'INSURANCE_PAYER_NAME_EXISTS',
    InsurancePayerEnabled: 'INSURANCE_PAYER_ENABLED',
    InsurancePayerDisabled: 'INSURANCE_PAYER_DISABLED',
    InsurancePayerArchived: 'INSURANCE_PAYER_ARCHIVED',
    InsurancePayerUnarchived: 'INSURANCE_PAYER_UNARCHIVED',
    EligibilityNotAllowed: 'ELIGIBILITY_NOT_ALLOWED',
    EligibilityPayerInactive: 'ELIGIBILITY_PAYER_INACTIVE',
    EligibilityCheckedSuccessfully: 'ELIGIBILITY_CHECKED_SUCCESSFULLY',
    IntakeFormAdded: 'INTAKE_FORM_ADDED',
    IntakeFormUpdated: 'INTAKE_FORM_UPDATED',
    IntakeFormReset: 'INTAKE_FORM_RESET',
    EncounterNoteImport: 'ENCOUNTER_NOTE_IMPORT',
    PatientDocumentUploaded: 'PATIENT_DOCUMENT_UPLOADED',
    ReasonIsMandatory: 'REASON_IS_MANDATORY',
    ChargeableIsMandatory: 'CHARGEABLE_IS_MANDATORY',
    IntakeNeeded: 'INTAKE_NEEDED',
    ConsentFormFound: 'CONSENT_FORM_FOUND',
    AddedAvailability: 'ADDED_AVAILABILITY',
    ConsultTimeConflict: 'CONSULT_TIME_CONFLICT',
    BookedAppointmentSlot: 'BOOKED_APPOINTMENT_SLOT',
    AvailabilityNotFound: 'AVAILABILITY_NOT_FOUND',
    DaySlotNotFound: 'DAY_SLOT_NOT_FOUND',
    SlotNotFound: 'SLOT_NOT_FOUND',
    InvalidTimeDuration: 'INVALID_TIME_DURATION',
    PastStartTime: 'PAST_START_TIME',
    SlotAlreadyBooked: 'SLOT_ALREADY_BOOKED',
    AppointmentCreated: 'APPOINTMENT_CREATED',
    AppointmentRequested: 'APPOINTMENT_REQUESTED',
    AppointmentCancelRequested: 'APPOINTMENT_CANCEL_REQUESTED',
    AppointmentDataFetched: 'APPOINTMENT_DATA_FETCHED',
    AppointmentNotFound: 'APPOINTMENT_NOT_FOUND',
    AppointmentCancelled: 'APPOINTMENT_CANCELLED',
    AppointmentUpdated: 'APPOINTMENT_UPDATED',
    AppointmentReschedule: 'APPOINTMENT_RESCHEDULE',
    AppointmentConfirmed: 'APPOINTMENT_CONFIRMED',
    GetFutureAppointment: 'GET_FUTURE_APPOINTMENT',
    InvitedPatientForAppointment: 'INVITED_PATIENT_FOR_APPOINTMENT',
    AppointmentArchived: 'APPOINTMENT_ARCHIVED',
    AppointmentUnarchived: 'APPOINTMENT_UNARCHIVED',
    NewApptAlreadyExist: 'NEW_APPT_ALREADY_EXIST',
    NewApptNotExist: 'NEW_APPT_NOT_EXIST',
    ExistingAppointmentNotFound: 'EXISTING_APPOINTMENT_NOT_FOUND',
    RescheduleNotAllowed: 'RESCHEDULE_NOT_ALLOWED',
    AppointmentRescheduleRequested: 'APPOINTMENT_RESCHEDULE_REQUESTED',
    AppointmentRescheduled: 'APPOINTMENT_RESCHEDULED',
    AppointmentRescheduledWithCharge: 'APPOINTMENT_RESCHEDULED_WITH_CHARGE',
    CheckedInNotEnabled: 'CHECKED_IN_NOT_ENABLED',
    FollowUpApptError: 'FOLLOW_UP_APPT_ERROR',
    ApptNotCompleteError: 'APPT_NOT_COMPLETE_ERROR',
    ExistingApptStatusError: 'EXISTING_APPT_STATUS_ERROR',
    AppointmentFeeSet: 'APPOINTMENT_FEE_SET',
    AppointmentFeeAlreadyPaid: 'APPOINTMENT_FEE_ALREADY_PAID',
    NoShowNotAllowed: 'NO_SHOW_NOT_ALLOWED',
    BillAmount: 'BILL_AMOUNT',
    AppointementNotRequiredForBilling: 'APPOINTEMENT_NOT_REQUIRED_FOR_BILLING',
    AppointementRequiredForBilling: 'APPOINTEMENT_REQUIRED_FOR_BILLING',
    SendMessageResponse: 'SEND_MESSAGE_RESPONSE',
    EmailSubjectMandatory: 'EMAIL_SUBJECT_MANDATORY',
    PatientPhoneNotPresent: 'PATIENT_PHONE_NOT_PRESENT',
    EncounterAlreadyExist: 'ENCOUNTER_ALREADY_EXIST',
    EncounterArchived: 'ENCOUNTER_ARCHIVED',
    EncounterUpdated: 'ENCOUNTER_UPDATED',
    PatientScreenerAdded: 'PATIENT_SCREENER_ADDED',
    PatientscreenerNotFound: 'PATIENTSCREENER_NOT_FOUND',
    PatientScoreAdded: 'PATIENT_SCORE_ADDED',
    PatientScreenerAnswerUpdated: 'PATIENT_SCREENER_ANSWER_UPDATED',
    InvalidScreenerType: 'INVALID_SCREENER_TYPE',
    InvalidAnswerOption: 'INVALID_ANSWER_OPTION',
    IncompleteScreenerAnswers: 'INCOMPLETE_SCREENER_ANSWERS',
    PatientScreenerScoreUpdated: 'PATIENT_SCREENER_SCORE_UPDATED',
    PatientScreenerDataFetched: 'PATIENT_SCREENER_DATA_FETCHED',
    AppointmentFormsAndAssessmentsFetched: 'APPOINTMENT_FORMS_AND_ASSESSMENTS_FETCHED',
    PaymentCardAdded: 'PAYMENT_CARD_ADDED',
    PaymentCardAlreadyExists: 'PAYMENT_CARD_ALREADY_EXISTS',
    PaymentCharged: 'PAYMENT_CHARGED',
    FineCharged: 'FINE_CHARGED',
    PaymentCardNotFound: 'PAYMENT_CARD_NOT_FOUND',
    PaymentAlreadyDone: 'PAYMENT_ALREADY_DONE',
    PaymentCardNotExists: 'PAYMENT_CARD_NOT_EXISTS',
    PaymentAmountNotSet: 'PAYMENT_AMOUNT_NOT_SET',
    PaymentBillStatusError: 'PAYMENT_BILL_STATUS_ERROR',
    InvalidCardExpiration: 'INVALID_CARD_EXPIRATION',
    PaymentLinkCreated: 'PAYMENT_LINK_CREATED',
    PaymentLinkResent: 'PAYMENT_LINK_RESENT',
    InvoiceEmailSentWithoutPaymentLink: 'INVOICE_EMAIL_SENT_WITHOUT_PAYMENT_LINK',
    InvoiceEmailSentWithPaymentLink: 'INVOICE_EMAIL_SENT_WITH_PAYMENT_LINK',
    InvoiceEmailResentWithPaymentLink: 'INVOICE_EMAIL_RESENT_WITH_PAYMENT_LINK',
    InvoiceEmailResentWithoutPaymentLink: 'INVOICE_EMAIL_RESENT_WITHOUT_PAYMENT_LINK',
    TherapyNoteSaved: 'THERAPY_NOTE_SAVED',
    TherapyNoteArchived: 'THERAPY_NOTE_ARCHIVED',
    NoNotifications: 'NO_NOTIFICATIONS',
    NotificationMarkedAsSeen: 'NOTIFICATION_MARKED_AS_SEEN',
    NotificationsCount: 'NOTIFICATIONS_COUNT',
    PatientConsentFormsAdded: 'PATIENT_CONSENT_FORMS_ADDED',
    TextmacroShortcutExists: 'TEXTMACRO_SHORTCUT_EXISTS',
    TextmacroAdded: 'TEXTMACRO_ADDED',
    TextmacroDataFetched: 'TEXTMACRO_DATA_FETCHED',
    TextmacroUpdated: 'TEXTMACRO_UPDATED',
    FailedUpdateTextMacro: 'FAILED_UPDATE_TEXT_MACRO',
    FailedTextmacroArchive: 'FAILED_TEXTMACRO_ARCHIVE',
    TextmacroArchive: 'TEXTMACRO_ARCHIVE',
    TextmacroRestored: 'TEXTMACRO_RESTORED',
    FailedTextmacroRestore: 'FAILED_TEXTMACRO_RESTORE',
    TextmacroNotExist: 'TEXTMACRO_NOT_EXIST',
    TaskTypeAdded: 'TASK_TYPE_ADDED',
    TaskAdded: 'TASK_ADDED',
    TaskDataFetched: 'TASK_DATA_FETCHED',
    TaskUpdated: 'TASK_UPDATED',
    TaskResolved: 'TASK_RESOLVED',
    TaskReviewed: 'TASK_REVIEWED',
    TaskReassigned: 'TASK_REASSIGNED',
    TasKEnabled: 'TasK_ENABLED',
    TasKDisabled: 'TasK_DISABLED',
    TasKArchived: 'TasK_ARCHIVED',
    TasKUnarchived: 'TasK_UNARCHIVED',
    TaskAssigned: 'TASK_ASSIGNED',
    TaskCancel: 'TASK_CANCEL',
    InvalidTaskStatus: 'INVALID_TASK_STATUS',
    InvalidDuedate: 'INVALID_DUEDATE',
    FineChargedAppointment: 'FINE_CHARGED_APPOINTMENT',
    AppointmentFine: 'APPOINTMENT_FINE',
    CannotChargeFine: 'CANNOT_CHARGE_FINE',
    PaymentSuccessful: 'PAYMENT_SUCCESSFUL',
    NotificationMarkAsRead: 'NOTIFICATION_MARK_AS_READ',
    VitalAdded: 'VITAL_ADDED',
    VitalUpdated: 'VITAL_UPDATED',
    VitalDataFetched: 'VITAL_DATA_FETCHED',
    VitalNotFound: 'VITAL_NOT_FOUND',
    FailedVitalUpdated: 'FAILED_VITAL_UPDATED',
    EmittedSuccessfully: 'EMITTED_SUCCESSFULLY',
    WebhookSuccessful: 'WEBHOOK_SUCCESSFUL',
    PatientAllergySync: 'PATIENT_ALLERGY_SYNC',
    BillUpdated: 'BILL_UPDATED',
    ClaimAdded: 'CLAIM_ADDED',
    ClaimIntegrationCreated: 'CLAIM_INTEGRATION_CREATED',
    ClaimIntegrationUpdated: 'CLAIM_INTEGRATION_UPDATED',
    ClaimIntegrationDeleted: 'CLAIM_INTEGRATION_DELETED',
    ClaimIntegrationNotFound: 'CLAIM_INTEGRATION_NOT_FOUND',
    ClaimIntegrationArchived: 'CLAIM_INTEGRATION_ARCHIVED',
    ClaimIntegrationUnarchived: 'CLAIM_INTEGRATION_UNARCHIVED',
    AppointmentConfigurationCreated: 'APPOINTMENT_CONFIGURATION_CREATED',
    AppointmentConfigurationUpdated: 'APPOINTMENT_CONFIGURATION_UPDATED',
    AppointmentConfigurationArchived: 'APPOINTMENT_CONFIGURATION_ARCHIVED',
    AppointmentConfigurationUnarchived: 'APPOINTMENT_CONFIGURATION_UNARCHIVED',
    AppointmentConfigurationNotFound: 'APPOINTMENT_CONFIGURATION_NOT_FOUND',
    BookAppointmentError: 'BOOK_APPOINTMENT_ERROR',
    CancelAppointmentError: 'CANCEL_APPOINTMENT_ERROR',
    NotImplemented: 'NOT_IMPLEMENTED',
    CommentAddedSuccessfully: 'COMMENT_ADDED_SUCCESSFULLY',
    CommentUpdatedSuccessfully: 'COMMENT_UPDATED_SUCCESSFULLY',
    CommentDeletedSuccessfully: 'COMMENT_DELETED_SUCCESSFULLY',
    MedicalCodeAddedSuccessfully: 'MEDICAL_CODE_ADDED_SUCCESSFULLY',
    MedicalCodeUpdatedSuccessfully: 'MEDICAL_CODE_UPDATED_SUCCESSFULLY',
    ProviderReviewAddedSuccessfully: 'PROVIDER_REVIEW_ADDED_SUCCESSFULLY',
    ProviderReviewStatusUpdatedSuccessfully: 'PROVIDER_REVIEW_STATUS_UPDATED_SUCCESSFULLY',
    CheckInStatus: 'CHECK_IN_STATUS',
    RefillRxAdded: 'REFILL_RX_ADDED',
    RefillRxUpdated: 'REFILL_RX_UPDATED',
    RoiAdded: 'ROI_ADDED',
    RoiUpdated: 'ROI_UPDATED',
    RoiEnabled: 'ROI_ENABLED',
    RoiDisabled: 'ROI_DISABLED',
    RoiArchived: 'ROI_ARCHIVED',
    RoiUnarchived: 'ROI_UNARCHIVED',
    RoiStatusUpdated: 'ROI_STATUS_UPDATED',
    RoiNotFound: 'ROI_NOT_FOUND',
    ConsentFormTemplateAdded: 'CONSENT_FORM_TEMPLATE_ADDED',
    ConsentFormTemplateUpdated: 'CONSENT_FORM_TEMPLATE_UPDATED',
    ConsentFormTemplateStatus: 'CONSENT_FORM_TEMPLATE_STATUS',
    InternalServerError: 'INTERNAL_SERVER_ERROR',
    FileUploaded: 'FILE_UPLOADED',
    EmptyFile: 'EMPTY_FILE',
    MedicalCodesCreated: 'MEDICAL_CODES_CREATED',
    MedicalCodesUpdated: 'MEDICAL_CODES_UPDATED',
    MedicalCodeEnabled: 'MEDICAL_CODE_ENABLED',
    MedicalCodeDisabled: 'MEDICAL_CODE_DISABLED',
    InitialImport: 'INITIAL_IMPORT',
    MedicalCodeRemove: 'MEDICAL_CODE_REMOVE',
    MedicalCodeArchived: 'MEDICAL_CODE_ARCHIVED',
    MedicalCodeUnarchived: 'MEDICAL_CODE_UNARCHIVED',
    PatientDiagnosisCreated: 'PATIENT_DIAGNOSIS_CREATED',
    PatientDiagnosisUpdated: 'PATIENT_DIAGNOSIS_UPDATED',
    PatientDiagnosisEnabled: 'PATIENT_DIAGNOSIS_ENABLED',
    PatientDiagnosisDisabled: 'PATIENT_DIAGNOSIS_DISABLED',
    PatientDiagnosisArchived: 'PATIENT_DIAGNOSIS_ARCHIVED',
    PatientDiagnosisUnarchived: 'PATIENT_DIAGNOSIS_UNARCHIVED',
    PatientAllergyCreated: 'PATIENT_ALLERGY_CREATED',
    PatientAllergyUpdated: 'PATIENT_ALLERGY_UPDATED',
    PatientAllergyEnabled: 'PATIENT_ALLERGY_ENABLED',
    PatientAllergyDisabled: 'PATIENT_ALLERGY_DISABLED',
    PatientAllergyArchived: 'PATIENT_ALLERGY_ARCHIVED',
    PatientAllergyUnarchived: 'PATIENT_ALLERGY_UNARCHIVED',
    ContactDictionaryEnabled: 'CONTACT_DICTIONARY_ENABLED',
    ContactDictionaryDisabled: 'CONTACT_DICTIONARY_DISABLED',
    ContactDictionaryArchived: 'CONTACT_DICTIONARY_ARCHIVED',
    ContactDictionaryUnarchived: 'CONTACT_DICTIONARY_UNARCHIVED',
    FeeScheduleCreated: 'FEE_SCHEDULE_CREATED',
    FeeScheduleUpdated: 'FEE_SCHEDULE_UPDATED',
    FeeScheduleEnabled: 'FEE_SCHEDULE_ENABLED',
    FeeScheduleDisabled: 'FEE_SCHEDULE_DISABLED',
    FeeScheduleArchived: 'FEE_SCHEDULE_ARCHIVED',
    FeeScheduleUnarchived: 'FEE_SCHEDULE_UNARCHIVED',
    PatientDocumentEnabled: 'PATIENT_DOCUMENT_ENABLED',
    PatientDocumentDisabled: 'PATIENT_DOCUMENT_DISABLED',
    PatientDocumentArchived: 'PATIENT_DOCUMENT_ARCHIVED',
    PatientDocumentAssigned: 'PATIENT_DOCUMENT_ASSIGNED',
    PatientDocumentUnarchived: 'PATIENT_DOCUMENT_UNARCHIVED',
    PatientDocumentUpdated: 'PATIENT_DOCUMENT_UPDATED',
    PatientInsuranceAdded: 'PATIENT_INSURANCE_ADDED',
    PatientInsuranceUpdated: 'PATIENT_INSURANCE_UPDATED',
    PatientInsuranceEnabled: 'PATIENT_INSURANCE_ENABLED',
    PatientInsuranceDisabled: 'PATIENT_INSURANCE_DISABLED',
    PatientInsuranceArchived: 'PATIENT_INSURANCE_ARCHIVED',
    PatientInsuranceUnarchived: 'PATIENT_INSURANCE_UNARCHIVED',
    PatientInsurancePlanAdded: 'PATIENT_INSURANCE_PLAN_ADDED',
    PatientInsurancePlanUpdated: 'PATIENT_INSURANCE_PLAN_UPDATED',
    PatientInsurancePlanEnabled: 'PATIENT_INSURANCE_PLAN_ENABLED',
    PatientInsurancePlanDisabled: 'PATIENT_INSURANCE_PLAN_DISABLED',
    PatientInsurancePlanArchived: 'PATIENT_INSURANCE__PLAN_ARCHIVED',
    PatientInsurancePlanUnarchived: 'PATIENT_INSURANCE_PLAN_UNARCHIVED',
    PatientLabResultUploaded: 'PATIENT_LAB_RESULT_UPLOADED',
    PatientLabResultUpdated: 'PATIENT_LAB_RESULT_UPDATED',
    PatientLabResultEnabled: 'PATIENT_LAB_RESULT_ENABLED',
    PatientLabResultDisabled: 'PATIENT_LAB_RESULT_DISABLED',
    PatientLabResultArchived: 'PATIENT_LAB_RESULT_ARCHIVED',
    PatientLabResultUnarchived: 'PATIENT_LAB_RESULT_UNARCHIVED',
    PatientOrderCreated: 'PATIENT_ORDER_CREATED',
    PatientOrderUpdated: 'PATIENT_ORDER_UPDATED',
    PatientOrderEnabled: 'PATIENT_ORDER_ENABLED',
    PatientOrderDisabled: 'PATIENT_ORDER_DISABLED',
    PatientOrderArchived: 'PATIENT_ORDER_ARCHIVED',
    PatientOrderUnarchived: 'PATIENT_ORDER_UNARCHIVED',
    PatientOrderCancelled: 'PATIENT_ORDER_CANCELLED',
    EducationMaterialUploaded: 'EDUCATION_MATERIAL_UPLOADED',
    EducationMaterialUpdated: 'EDUCATION_MATERIAL_UPDATED',
    EducationMaterialEnabled: 'EDUCATION_MATERIAL_ENABLED',
    EducationMaterialDisabled: 'EDUCATION_MATERIAL_DISABLED',
    EducationMaterialArchived: 'EDUCATION_MATERIAL_ARCHIVED',
    EducationMaterialUnarchived: 'EDUCATION_MATERIAL_UNARCHIVED',
    EducationMaterialShared: 'EDUCATION_MATERIAL_SHARED',
    PatientVaccineCreated: 'PATIENT_VACCINE_CREATED',
    PatientVaccineUpdated: 'PATIENT_VACCINE_UPDATED',
    PatientVaccineEnabled: 'PATIENT_VACCINE_ENABLED',
    PatientVaccineDisabled: 'PATIENT_VACCINE_DISABLED',
    PatientVaccineArchived: 'PATIENT_VACCINE_ARCHIVED',
    PatientVaccineUnarchived: 'PATIENT_VACCINE_UNARCHIVED',
    PatientCardEnabled: 'PATIENT_CARD_ENABLED',
    PatientCardDisabled: 'PATIENT_CARD_DISABLED',
    PatientCardUpdated: 'PATIENT_CARD_UPDATED',
    PatientCardArchived: 'PATIENT_CARD_ARCHIVED',
    PatientCardUnarchived: 'PATIENT_CARD_UNARCHIVED',
    PatientVitalCreated: 'PATIENT_VITAL_CREATED',
    PatientVitalUpdated: 'PATIENT_VITAL_UPDATED',
    PatientVitalArchived: 'PATIENT_VITAL_ARCHIVED',
    PatientVitalUnarchived: 'PATIENT_VITAL_UNARCHIVED',
    StickyNoteCreated: 'STICKY_NOTE_CREATED',
    StickyNoteUpdated: 'STICKY_NOTE_UPDATED',
    StickyNoteEnabled: 'STICKY_NOTE_ENABLED',
    StickyNoteDisabled: 'STICKY_NOTE_DISABLED',
    StickyNoteArchived: 'STICKY_NOTE_ARCHIVED',
    StickyNoteUnarchived: 'STICKY_NOTE_UNARCHIVED',
    CarePlanCreated: 'CARE_PLAN_CREATED',
    CarePlanUpdated: 'CARE_PLAN_UPDATED',
    CarePlanEnabled: 'CARE_PLAN_ENABLED',
    CarePlanDisabled: 'CARE_PLAN_DISABLED',
    CarePlanArchived: 'CARE_PLAN_ARCHIVED',
    CarePlanUnarchived: 'CARE_PLAN_UNARCHIVED',
    MedicationCreated: 'MEDICATION_CREATED',
    PatientMedicationCreated: 'PATIENT_MEDICATION_CREATED',
    PatientMedicationUpdated: 'PATIENT_MEDICATION_UPDATED',
    PatientMedicationEnabled: 'PATIENT_MEDICATION_ENABLED',
    PatientMedicationDisabled: 'PATIENT_MEDICATION_DISABLED',
    PatientMedicationArchived: 'PATIENT_MEDICATION_ARCHIVED',
    PatientMedicationUnarchived: 'PATIENT_MEDICATION_UNARCHIVED',
    PatientMedicalHistoryCreated: 'PATIENT_MEDICAL_HISTORY_CREATED',
    PatientMedicalHistoryUpdated: 'PATIENT_MEDICAL_HISTORY_UPDATED',
    PatientMedicalHistoryEnabled: 'PATIENT_MEDICAL_HISTORY_ENABLED',
    PatientMedicalHistoryDisabled: 'PATIENT_MEDICAL_HISTORY_DISABLED',
    PatientMedicalHistoryArchived: 'PATIENT_MEDICAL_HISTORY_ARCHIVED',
    PatientMedicalHistoryUnarchived: 'PATIENT_MEDICAL_HISTORY_UNARCHIVED',
    PatientSurgicalHistoryCreated: 'PATIENT_SURGICAL_HISTORY_CREATED',
    PatientSurgicalHistoryUpdated: 'PATIENT_SURGICAL_HISTORY_UPDATED',
    PatientSurgicalHistoryEnabled: 'PATIENT_SURGICAL_HISTORY_ENABLED',
    PatientSurgicalHistoryDisabled: 'PATIENT_SURGICAL_HISTORY_DISABLED',
    PatientSurgicalHistoryArchived: 'PATIENT_SURGICAL_HISTORY_ARCHIVED',
    PatientSurgicalHistoryUnarchived: 'PATIENT_SURGICAL_HISTORY_UNARCHIVED',
    PatientFamilyHistoryCreated: 'PATIENT_FAMILY_HISTORY_CREATED',
    PatientFamilyHistoryUpdated: 'PATIENT_FAMILY_HISTORY_UPDATED',
    PatientFamilyHistoryEnabled: 'PATIENT_FAMILY_HISTORY_ENABLED',
    PatientFamilyHistoryDisabled: 'PATIENT_FAMILY_HISTORY_DISABLED',
    PatientFamilyHistoryArchived: 'PATIENT_FAMILY_HISTORY_ARCHIVED',
    PatientFamilyHistoryUnarchived: 'PATIENT_FAMILY_HISTORY_UNARCHIVED',
    PatientSocialHistoryCreated: 'PATIENT_SOCIAL_HISTORY_CREATED',
    PatientSocialHistoryUpdated: 'PATIENT_SOCIAL_HISTORY_UPDATED',
    PatientSocialHistoryEnabled: 'PATIENT_SOCIAL_HISTORY_ENABLED',
    PatientSocialHistoryDisabled: 'PATIENT_SOCIAL_HISTORY_DISABLED',
    PatientSocialHistoryArchived: 'PATIENT_SOCIAL_HISTORY_ARCHIVED',
    PatientSocialHistoryUnarchived: 'PATIENT_SOCIAL_HISTORY_UNARCHIVED',
    DocumentTagCreated: 'DOCUMENT_TAG_CREATED',
    DocumentTagUpdated: 'DOCUMENT_TAG_UPDATED',
    DocumentTagEnabled: 'DOCUMENT_TAG_ENABLED',
    DocumentTagDisabled: 'DOCUMENT_TAG_DISABLED',
    DocumentTagArchived: 'DOCUMENT_TAG_ARCHIVED',
    DocumentTagUnarchived: 'DOCUMENT_TAG_UNARCHIVED',
    PatientLabOrderCreated: 'PATIENT_LAB_ORDER_CREATED',
    PatientLabOrderUpdated: 'PATIENT_LAB_ORDER_UPDATED',
    PatientLabOrderNotFound: 'PATIENT_LAB_ORDER_NOT_FOUND',
    PatientLabOrderEnabled: 'PATIENT_LAB_ORDER_ENABLED',
    PatientLabOrderDisabled: 'PATIENT_LAB_ORDER_DISABLED',
    PatientLabOrderArchived: 'PATIENT_LAB_ORDER_ARCHIVED',
    PatientLabOrderUnarchived: 'PATIENT_LAB_ORDER_UNARCHIVED',
    PrescriptionFormCreated: 'PRESCRIPTION_FORM_CREATED',
    PrescriptionFormUpdated: 'PRESCRIPTION_FORM_UPDATED',
    PrescriptionFormEnabled: 'PRESCRIPTION_FORM_ENABLED',
    PrescriptionFormDisabled: 'PRESCRIPTION_FORM_DISABLED',
    PrescriptionFormArchived: 'PRESCRIPTION_FORM_ARCHIVED',
    PrescriptionFormUnarchived: 'PRESCRIPTION_FORM_UNARCHIVED',
    ClinicalNoteCreated: 'CLINICAL_NOTE_CREATED',
    ClinicalNoteUpdated: 'CLINICAL_NOTE_UPDATED',
    ClinicalNoteNotFound: 'CLINICAL_NOTE_NOT_FOUND',
    ClinicalNoteEnabled: 'CLINICAL_NOTE_ENABLED',
    ClinicalNoteDisabled: 'CLINICAL_NOTE_DISABLED',
    ClinicalNoteArchived: 'CLINICAL_NOTE_ARCHIVED',
    ClinicalNoteUnarchived: 'CLINICAL_NOTE_UNARCHIVED',
    ClinicalNotesAdded: 'CLINICAL_NOTES_ADDED',
    UserDocumentUpload: 'USER_DOCUMENT_UPLOAD',
    RoleAdded: 'ROLE_ADDED',
    PrivilegeNotFound: 'PRIVILEGE_NOT_FOUND',
    RoleUpdated: 'ROLE_UPDATED',
    RoleNotFound: 'ROLE_NOT_FOUND',
    CustomFormCreated: 'CUSTOM_FORM_CREATED',
    CustomFormStatusUpdated: 'CUSTOM_FORM_STATUS_UPDATED',
    CustomFormUpdated: 'CUSTOM_FORM_UPDATED',
    CustomFormEnabled: 'CUSTOM_FORM_ENABLED',
    CustomFormDisabled: 'CUSTOM_FORM_DISABLED',
    CustomFormArchived: 'CUSTOM_FORM_ARCHIVED',
    CustomFormImport: 'CUSTOM_FORM_IMPORT',
    CustomFormUnarchived: 'CUSTOM_FORM_UNARCHIVED',
    CustomFormRestored: 'CUSTOM_FORM_RESTORED',
    CustomFormCopy: 'CUSTOM_FORM_COPY',
    CustomFormTemplateCreated: 'CUSTOM_FORM_TEMPLATE_CREATED',
    CustomTemplateImport: 'CUSTOM_TEMPLATE_IMPORT',
    CustomFormTemplateStatusUpdated: 'CUSTOM_FORM_TEMPLATE_STATUS_UPDATED',
    CustomFormTemplateUpdated: 'CUSTOM_FORM_TEMPLATE_UPDATED',
    CustomFormTemplateEnabled: 'CUSTOM_FORM_TEMPLATE_ENABLED',
    CustomFormTemplateDisabled: 'CUSTOM_FORM_TEMPLATE_DISABLED',
    CustomFormTemplateArchived: 'CUSTOM_FORM_TEMPLATE_ARCHIVED',
    CustomFormTemplateRestored: 'CUSTOM_FORM_TEMPLATE_RESTORED',
    MicrosFormCreated: 'MICROS_FORM_CREATED',
    MicrosFormUpdated: 'MICROS_FORM_UPDATED',
    MicrosFormStatusUpdated: 'MICROS_FORM_STATUS_UPDATED',
    MicrosFormArchiveStatusUpdated: 'MICROS_FORM_ARCHIVE_STATUS_UPDATED',
    VisitNoteFormCreated: 'VISIT_NOTE_FORM_CREATED',
    VisitNoteFormUpdated: 'VISIT_NOTE_FORM_UPDATED',
    VisitNoteFormStatusUpdated: 'VISIT_NOTE_FORM_STATUS_UPDATED',
    VisitNoteFormArchiveStatusUpdated: 'VISIT_NOTE_FORM_ARCHIVE_STATUS_UPDATED',
    ReviewOfSystemFormCreated: 'REVIEW_OF_SYSTEM_FORM_CREATED',
    ReviewOfSystemFormUpdated: 'REVIEW_OF_SYSTEM_FORM_UPDATED',
    ReviewOfSystemFormStatusUpdated: 'REVIEW_OF_SYSTEM_FORM_STATUS_UPDATED',
    ReviewOfSystemFormArchiveStatusUpdated: 'REVIEW_OF_SYSTEM_FORM_ARCHIVE_STATUS_UPDATED',
    CustomQuestionnaireFormCreated: 'CUSTOM_QUESTIONNAIRE_FORM_CREATED',
    CustomQuestionnaireFormUpdated: 'CUSTOM_QUESTIONNAIRE_FORM_UPDATED',
    CustomQuestionnaireFormStatusUpdated: 'CUSTOM_QUESTIONNAIRE_FORM_STATUS_UPDATED',
    CustomQuestionnaireFormArchiveStatusUpdated: 'CUSTOM_QUESTIONNAIRE_FORM_ARCHIVE_STATUS_UPDATED',
    CareplanFormCreated: 'CAREPLAN_FORM_CREATED',
    CareplanFormUpdated: 'CAREPLAN_FORM_UPDATED',
    CareplanFormStatusUpdated: 'CAREPLAN_FORM_STATUS_UPDATED',
    CareplanFormArchiveStatusUpdated: 'CAREPLAN_FORM_ARCHIVE_STATUS_UPDATED',
    AnnotableImageFormCreated: 'ANNOTABLE_IMAGE_FORM_CREATED',
    AnnotableImageFormUpdated: 'ANNOTABLE_IMAGE_FORM_UPDATED',
    AnnotableImageFormStatusUpdated: 'ANNOTABLE_IMAGE_FORM_STATUS_UPDATED',
    AnnotableImageFormArchiveStatusUpdated: 'ANNOTABLE_IMAGE_FORM_ARCHIVE_STATUS_UPDATED',
    OrderSetFormCreated: 'ORDER_SET_FORM_CREATED',
    OrderSetFormUpdated: 'ORDER_SET_FORM_UPDATED',
    OrderSetFormStatusUpdated: 'ORDER_SET_FORM_STATUS_UPDATED',
    OrderSetFormArchiveStatusUpdated: 'ORDER_SET_FORM_ARCHIVE_STATUS_UPDATED',
    PhysicalExamFormCreated: 'PHYSICAL_EXAM_FORM_CREATED',
    PhysicalExamFormUpdated: 'PHYSICAL_EXAM_FORM_UPDATED',
    PhysicalExamFormStatusUpdated: 'PHYSICAL_EXAM_FORM_STATUS_UPDATED',
    PhysicalExamFormArchiveStatusUpdated: 'PHYSICAL_EXAM_FORM_ARCHIVE_STATUS_UPDATED',
    CheckConsultTime: 'CHECK_CONSULT_TIME',
    CheckDayInCustomWindow: 'CHECK_DAY_IN_CUSTOM_WINDOW',
    IcdCodeAdded: 'ICD_CODE_ADDED',
    CptCodeAdded: 'CPT_CODE_ADDED',
    HcpcsCodeAdded: 'HCPCS_CODE_ADDED',
    LoincCodeAdded: 'LOINC_CODE_ADDED',
    DrugCatalogAdded: 'DRUG_CATALOG_ADDED',
    IcdCodeUpdated: 'ICD_CODE_UPDATED',
    CptCodeUpdated: 'CPT_CODE_UPDATED',
    HcpcsCodeUpdated: 'HCPCS_CODE_UPDATED',
    LoincCodeUpdated: 'LOINC_CODE_UPDATED',
    DrugCatalogUpdated: 'DRUG_CATALOG_UPDATED',
    IcdCodeUpdateEnabled: 'ICD_CODE_UPDATE_ENABLED',
    CptCodeUpdateEnabled: 'CPT_CODE_UPDATE_ENABLED',
    HcpcsCodeUpdateEnabled: 'HCPCS_CODE_UPDATE_ENABLED',
    LoincCodeUpdateEnabled: 'LOINC_CODE_UPDATE_ENABLED',
    DrugCatalogUpdateEnabled: 'DRUG_CATALOG_UPDATE_ENABLED',
    IcdCodeUpdateDisabled: 'ICD_CODE_UPDATE_DISABLED',
    CptCodeUpdateDisabled: 'CPT_CODE_UPDATE_DISABLED',
    HcpcsCodeUpdateDisabled: 'HCPCS_CODE_UPDATE_DISABLED',
    LoincCodeUpdateDisabled: 'LOINC_CODE_UPDATE_DISABLED',
    DrugCatalogUpdateDisabled: 'DRUG_CATALOG_UPDATE_DISABLED',
    IcdCodeArchived: 'ICD_CODE_ARCHIVED',
    CptCodeArchived: 'CPT_CODE_ARCHIVED',
    HcpcsCodeArchived: 'HCPCS_CODE_ARCHIVED',
    LoincCodeArchived: 'LOINC_CODE_ARCHIVED',
    DrugCatalogArchived: 'DRUG_CATALOG_ARCHIVED',
    IcdCodeUnarchived: 'ICD_CODE_UNARCHIVED',
    CptCodeUnarchived: 'CPT_CODE_UNARCHIVED',
    HcpcsCodeUnarchived: 'HCPCS_CODE_UNARCHIVED',
    LoincCodeUnarchived: 'LOINC_CODE_UNARCHIVED',
    DrugCatalogUnarchived: 'DRUG_CATALOG_UNARCHIVED',
    PatientFlagsCreated: 'PATIENT_FLAGS_CREATED',
    PatientFlagsUpdated: 'PATIENT_FLAGS_UPDATED',
    PatientFlagsArchived: 'PATIENT_FLAGS_ARCHIVED',
    PatientFlagsUnarchived: 'PATIENT_FLAGS_UNARCHIVED',
    FlagsCreated: 'FLAGS_CREATED',
    FlagsUpdated: 'FLAGS_UPDATED',
    FlagsArchived: 'FLAGS_ARCHIVED',
    FlagsUnarchived: 'FLAGS_UNARCHIVED',
    IntakeFormCreated: 'INTAKE_FORM_CREATED',
    CreatePrintConfiguration: 'CREATE_PRINT_CONFIGURATION',
    UpdatePrintConfiguration: 'UPDATE_PRINT_CONFIGURATION',
    DeletePrintConfiguration: 'DELETE_PRINT_CONFIGURATION',
    PrintConfigurationEnabled: 'PRINT_CONFIGURATION_ENABLED',
    PrintConfigurationDisabled: 'PRINT_CONFIGURATION_DISABLED',
    PrintConfigurationArchived: 'PRINT_CONFIGURATION_ARCHIVED',
    SetDefaultPrintConfiguration: 'SET_DEFAULT_PRINT_CONFIGURATION',
    PrintConfigurationUnarchived: 'PRINT_CONFIGURATION_UNARCHIVED',
    ScreenersData: 'SCREENERS_DATA',
    NoScreenerFound: 'NO_SCREENER_FOUND',
    EncounterSummaryAdded: 'ENCOUNTER_SUMMARY_ADDED',
    EncounterSummaryUpdated: 'ENCOUNTER_SUMMARY_UPDATED',
    EncounterSummaryArchived: 'ENCOUNTER_SUMMARY_ARCHIVED',
    EncounterSummaryUnarchived: 'ENCOUNTER_SUMMARY_UNARCHIVED',
    EncounterSignOff: 'ENCOUNTER_SIGN_OFF',
    AddendumSigned: 'ADDENDUM_SIGNED',
    EncounterAssigned: 'ENCOUNTER_ASSIGNED',
    HistoryExportedToEncounter: 'HISTORY_EXPORTED_TO_ENCOUNTER',
    PatientImagingCreated: 'PATIENT_IMAGING_CREATED',
    PatientImagingUpdated: 'PATIENT_IMAGING_UPDATED',
    PatientImagingEnabled: 'PATIENT_IMAGING_ENABLED',
    PatientImagingDisabled: 'PATIENT_IMAGING_DISABLED',
    PatientImagingArchived: 'PATIENT_IMAGING_ARCHIVED',
    PatientImagingUnarchived: 'PATIENT_IMAGING_UNARCHIVED',
    EncounterTemplateCreated: 'ENCOUNTER_TEMPLATE_CREATED',
    EncounterTemplateUpdated: 'ENCOUNTER_TEMPLATE_UPDATED',
    EncounterTemplateEnabled: 'ENCOUNTER_TEMPLATE_ENABLED',
    EncounterTemplateDisabled: 'ENCOUNTER_TEMPLATE_DISABLED',
    EncounterTemplateArchived: 'ENCOUNTER_TEMPLATE_ARCHIVED',
    EncounterTemplateUnarchived: 'ENCOUNTER_TEMPLATE_UNARCHIVED',
    EmailTemplateCreated: 'EMAIL_TEMPLATE_CREATED',
    EmailTemplateUpdated: 'EMAIL_TEMPLATE_UPDATED',
    EmailTemplateEnabled: 'EMAIL_TEMPLATE_ENABLED',
    EmailTemplateDisabled: 'EMAIL_TEMPLATE_DISABLED',
    EmailTemplateArchived: 'EMAIL_TEMPLATE_ARCHIVED',
    EmailTemplateUnarchived: 'EMAIL_TEMPLATE_UNARCHIVED',
    SmsTemplateCreated: 'SMS_TEMPLATE_CREATED',
    SmsTemplateUpdated: 'SMS_TEMPLATE_UPDATED',
    SmsTemplateEnabled: 'SMS_TEMPLATE_ENABLED',
    SmsTemplateDisabled: 'SMS_TEMPLATE_DISABLED',
    SmsTemplateArchived: 'SMS_TEMPLATE_ARCHIVED',
    SmsTemplateUnarchived: 'SMS_TEMPLATE_UNARCHIVED',
    EmailSmsTemplateCreated: 'EMAIL_SMS_TEMPLATE_CREATED',
    EmailSmsTemplateUpdated: 'EMAIL_SMS_TEMPLATE_UPDATED',
    EmailReadSuccessfully: 'EMAIL_READ_SUCCESSFULLY',
    SendEmailToPatient: 'SEND_EMAIL_TO_PATIENT',
    SendSmsToPatient: 'SEND_SMS_TO_PATIENT',
    RecievedSmsFromPatient: 'RECIEVED_SMS_FROM_PATIENT',
    SuperBillCreated: 'SUPER_BILL_CREATED',
    SuperBillUpdated: 'SUPER_BILL_UPDATED',
    SuperBillEnabled: 'SUPER_BILL_ENABLED',
    SuperBillDisabled: 'SUPER_BILL_DISABLED',
    SuperBillArchived: 'SUPER_BILL_ARCHIVED',
    SuperBillUnarchived: 'SUPER_BILL_UNARCHIVED',
    SuperBillBulkUpload: 'SUPER_BILL_BULK_UPLOAD',
    SuperBillCancelled: 'SUPER_BILL_CANCELLED',
    InvoiceReminderConfigured: 'INVOICE_REMINDER_CONFIGURED',
    PatientCreatedStripe: 'PATIENT_CREATED_STRIPE',
    PaymentDoneCash: 'PAYMENT_DONE_CASH',
    PaymentDoneBank: 'PAYMENT_DONE_BANK',
    MakeCharge: 'MAKE_CHARGE',
    LabCreated: 'LAB_CREATED',
    PharmacyCreated: 'PHARMACY_CREATED',
    RadiologyCreated: 'RADIOLOGY_CREATED',
    PreferenceCreated: 'PREFERENCE_CREATED',
    LabUpdated: 'LAB_UPDATED',
    PharmacyUpdated: 'PHARMACY_UPDATED',
    RadiologyUpdated: 'RADIOLOGY_UPDATED',
    PreferenceUpdated: 'PREFERENCE_UPDATED',
    ClaimCreated: 'CLAIM_CREATED',
    ClaimUpdated: 'CLAIM_UPDATED',
    ClaimEnabled: 'CLAIM_ENABLED',
    ClaimDisabled: 'CLAIM_DISABLED',
    ClaimArchived: 'CLAIM_ARCHIVED',
    ClaimUnarchived: 'CLAIM_UNARCHIVED',
    ClaimStatusUpdated: 'CLAIM_STATUS_UPDATED',
    ReferralCreated: 'REFERRAL_CREATED',
    ReferralUpdated: 'REFERRAL_UPDATED',
    ReferralEnabled: 'REFERRAL_ENABLED',
    ReferralDisabled: 'REFERRAL_DISABLED',
    ReferralArchived: 'REFERRAL_ARCHIVED',
    ReferralUnarchived: 'REFERRAL_UNARCHIVED',
    RunningNote: 'RUNNING_NOTE',
    RoleEnabled: 'ROLE_ENABLED',
    RoleDisabled: 'ROLE_DISABLED',
    RoleArchived: 'ROLE_ARCHIVED',
    RoleUnarchived: 'ROLE_UNARCHIVED',
    MacrosTemplateCreated: 'MACROS_TEMPLATE_CREATED',
    ClinicalDataLinked: 'CLINICAL_DATA_LINKED',
    MacrosTemplateUpdated: 'MACROS_TEMPLATE_UPDATED',
    MacrosTemplateEnabled: 'MACROS_TEMPLATE_ENABLED',
    MacrosTemplateDisabled: 'MACROS_TEMPLATE_DISABLED',
    MacrosTemplateArchived: 'MACROS_TEMPLATE_ARCHIVED',
    MacrosTemplateUnarchived: 'MACROS_TEMPLATE_UNARCHIVED',
    AppointemntReminder: 'APPOINTEMNT_REMINDER',
    ElectronicClaimCreated: 'ELECTRONIC_CLAIM_CREATED',
    InternalScrubbingDone: 'INTERNAL_SCRUBBING_DONE',
    ContactDictionaryCreated: 'CONTACT_DICTIONARY_CREATED',
    ContactDictionaryUpdated: 'CONTACT_DICTIONARY_UPDATED',
    ContactDictionaryDeleted: 'CONTACT_DICTIONARY_DELETED',
    ProviderSignatureCreated: 'PROVIDER_SIGNATURE_CREATED',
    ProviderSignatureUpdated: 'PROVIDER_SIGNATURE_UPDATED',
    ProviderSignatureEnabled: 'PROVIDER_SIGNATURE_ENABLED',
    ProviderSignatureDisabled: 'PROVIDER_SIGNATURE_DISABLED',
    ProviderSignatureArchived: 'PROVIDER_SIGNATURE_ARCHIVED',
    ProviderSignatureUnarchived: 'PROVIDER_SIGNATURE_UNARCHIVED',
    TwoFactorAuthDisabled: 'TWO_FACTOR_AUTH_DISABLED',
    TwoFactorAuthEmailOtpSent: 'TWO_FACTOR_AUTH_EMAIL_OTP_SENT',
    TwoFactorAuthEmailOtpVerified: 'TWO_FACTOR_AUTH_EMAIL_OTP_VERIFIED',
    TwoFactorAuthEmailOtpExpired: 'TWO_FACTOR_AUTH_EMAIL_OTP_EXPIRED',
    TwoFactorAuthEmailOtpInvalid: 'TWO_FACTOR_AUTH_EMAIL_OTP_INVALID',
    TwoFactorAuthGoogleVerified: 'TWO_FACTOR_AUTH_GOOGLE_VERIFIED',
    TwoFactorAuthGoogleInvalid: 'TWO_FACTOR_AUTH_GOOGLE_INVALID',
    PrescriptionRecieved: 'PRESCRIPTION_RECIEVED',
    ScriptsurePatientCreated: 'SCRIPTSURE_PATIENT_CREATED',
    InProgress: 'IN_PROGRESS',
    AccountDeactivated: 'ACCOUNT_DEACTIVATED',
    EmailHistoryArchived: 'EMAIL_HISTORY_ARCHIVED',
    EmailHistoryUnarchived: 'EMAIL_HISTORY_UNARCHIVED',
    AllergyRecieved: 'ALLERGY_RECIEVED',
    SmtpConfigurationCreated: 'SMTP_CONFIGURATION_CREATED',
    SmtpConfigurationUpdated: 'SMTP_CONFIGURATION_UPDATED',
    SmtpConfigurationEnabled: 'SMTP_CONFIGURATION_ENABLED',
    SmtpConfigurationDisabled: 'SMTP_CONFIGURATION_DISABLED',
    SmtpConfigurationArchived: 'SMTP_CONFIGURATION_ARCHIVED',
    SmtpConfigurationUnarchived: 'SMTP_CONFIGURATION_UNARCHIVED',
    PatientAssessmentCreated: 'PATIENT_ASSESSMENT_CREATED',
    PatientAssessment: 'PATIENT_ASSESSMENT',
    DefaultAssessmentCreated: 'DEFAULT_ASSESSMENT_CREATED',
    VisitNoteTemplateCreated: 'VISIT_NOTE_TEMPLATE_CREATED',
    VisitNoteTemplateUpdated: 'VISIT_NOTE_TEMPLATE_UPDATED',
    VisitNoteTemplateEnabled: 'VISIT_NOTE_TEMPLATE_ENABLED',
    VisitNoteTemplateDisabled: 'VISIT_NOTE_TEMPLATE_DISABLED',
    VisitNoteTemplateArchived: 'VISIT_NOTE_TEMPLATE_ARCHIVED',
    VisitNoteTemplateUnarchived: 'VISIT_NOTE_TEMPLATE_UNARCHIVED',
    RequiringActionCompleted: 'REQUIRING_ACTION_COMPLETED',
    PatientRequiringActionCompleted: 'PATIENT_REQUIRING_ACTION_COMPLETED',
    PatientInquiryStatusUpdated: 'PATIENT_INQUIRY_STATUS_UPDATED',
    InquiryCancelApproved: 'INQUIRY_CANCEL_APPROVED',
    InquiryCancelDenied: 'INQUIRY_CANCEL_DENIED',
    InquiryRescheduleApproved: 'INQUIRY_RESCHEDULE_APPROVED',
    InquiryRescheduleDenied: 'INQUIRY_RESCHEDULE_DENIED',
    InquiryBookingApproved: 'INQUIRY_BOOKING_APPROVED',
    InquiryBookingDenied: 'INQUIRY_BOOKING_DENIED',
    PatientInquiryNotFound: 'PATIENT_INQUIRY_NOT_FOUND',
    StripeCardRequired: 'STRIPE_CARD_REQUIRED',
    PatientPortalAccessDisabled: 'PATIENT_PORTAL_ACCESS_DISABLED',
    PatientPortalAccessUpdated: 'PATIENT_PORTAL_ACCESS_UPDATED',
    PriorAuthorizationCreated: 'PRIOR_AUTHORIZATION_CREATED',
    PriorAuthorizationUpdated: 'PRIOR_AUTHORIZATION_UPDATED',
    PriorAuthorizationEnabled: 'PRIOR_AUTHORIZATION_ENABLED',
    PriorAuthorizationDisabled: 'PRIOR_AUTHORIZATION_DISABLED',
    PriorAuthorizationArchived: 'PRIOR_AUTHORIZATION_ARCHIVED',
    PriorAuthorizationUnarchived: 'PRIOR_AUTHORIZATION_UNARCHIVED',
    AppointmentTypeCreated: 'APPOINTMENT_TYPE_CREATED',
    AppointmentTypeUpdated: 'APPOINTMENT_TYPE_UPDATED',
    AppointmentTypeEnabled: 'APPOINTMENT_TYPE_ENABLED',
    AppointmentTypeDisabled: 'APPOINTMENT_TYPE_DISABLED',
    AppointmentTypeArchived: 'APPOINTMENT_TYPE_ARCHIVED',
    AppointmentTypeUnarchived: 'APPOINTMENT_TYPE_UNARCHIVED',
    PatientFormSend: 'PATIENT_FORM_SEND',
    FcmTokenAdded: 'FCM_TOKEN_ADDED',
    PatientQuestionnaireCreated: 'PATIENT_QUESTIONNAIRE_CREATED',
    PatientQuestionnaireUpdated: 'PATIENT_QUESTIONNAIRE_UPDATED',
    PatientQuestionnaireEnabled: 'PATIENT_QUESTIONNAIRE_ENABLED',
    PatientQuestionnaireDisabled: 'PATIENT_QUESTIONNAIRE_DISABLED',
    PatientQuestionnaireArchived: 'PATIENT_QUESTIONNAIRE_ARCHIVED',
    PatientQuestionnaireUnarchived: 'PATIENT_QUESTIONNAIRE_UNARCHIVED',
    PatientAssessmentArchived: 'PATIENT_ASSESSMENT_ARCHIVED',
    PatientAssessmentUnarchived: 'PATIENT_ASSESSMENT_UNARCHIVED',
    PatientAssessmentScheduled: 'PATIENT_ASSESSMENT_SCHEDULED',
    TaskTitleCreated: 'TASK_TITLE_CREATED',
    TaskTitleUpdated: 'TASK_TITLE_UPDATED',
    TaskTitleEnabled: 'TASK_TITLE_ENABLED',
    TaskTitleDisabled: 'TASK_TITLE_DISABLED',
    TaskTitleArchived: 'TASK_TITLE_ARCHIVED',
    TaskTitleUnarchived: 'TASK_TITLE_UNARCHIVED',
    TicketRaise: 'TICKET_RAISE',
    ConversationCreated: 'CONVERSATION_CREATED',
    ConversationArchived: 'CONVERSATION_ARCHIVED',
    ConversationUnarchived: 'CONVERSATION_UNARCHIVED',
    FaxConfigurationCreated: 'FAX_CONFIGURATION_CREATED',
    FaxConfigurationUpdated: 'FAX_CONFIGURATION_UPDATED',
    FaxConfigurationDeleted: 'FAX_CONFIGURATION_DELETED',
    FaxConfigurationNotFound: 'FAX_CONFIGURATION_NOT_FOUND',
    FaxConfigurationArchived: 'FAX_CONFIGURATION_ARCHIVED',
    FaxConfigurationUnarchived: 'FAX_CONFIGURATION_UNARCHIVED',
    FaxReadSuccessfully: 'FAX_READ_SUCCESSFULLY',
    PatientCredentialGenerated: 'PATIENT_CREDENTIAL_GENERATED',
    PatientCredentialAlreadyExists: 'PATIENT_CREDENTIAL_ALREADY_EXISTS',
    PatientCredentialNotFound: 'PATIENT_CREDENTIAL_NOT_FOUND',
    PatientCredentialEmailSent: 'PATIENT_CREDENTIAL_EMAIL_SENT',
    PatientCredentialPasswordChanged: 'PATIENT_CREDENTIAL_PASSWORD_CHANGED',
    PatientNotificationPreferenceUpdated: 'PATIENT_NOTIFICATION_PREFERENCE_UPDATED',
    EraCreated: 'ERA_CREATED',
    EraUploaded: 'ERA_UPLOADED',
    EraUpdated: 'ERA_UPDATED',
    EraReconciliationUpdated: 'ERA_RECONCILIATION_UPDATED',
    EraClaimsPosted: 'ERA_CLAIMS_POSTED',
    NotificationMarkedAsRead: 'NOTIFICATION_MARKED_AS_READ',
    AllNotificationsMarkedAsRead: 'ALL_NOTIFICATIONS_MARKED_AS_READ',
    ReferralAccepted: 'REFERRAL_ACCEPTED',
    ReferralRejected: 'REFERRAL_REJECTED',
    EobUploaded: 'EOB_UPLOADED',
    EobUpdated: 'EOB_UPDATED',
    EobArchived: 'EOB_ARCHIVED',
    EobUnarchived: 'EOB_UNARCHIVED',
    EobPaymentPosted: 'EOB_PAYMENT_POSTED',
    ResponseCode: 'ResponseCode'
} as const;

export type ResponseCodeEnum = typeof ResponseCodeEnum[keyof typeof ResponseCodeEnum];

/**
 * 
 * @export
 * @interface Role
 */
export interface Role {
    /**
     * 
     * @type {number}
     * @memberof Role
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof Role
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof Role
     */
    'type': RoleTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof Role
     */
    'description'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Role
     */
    'active'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Role
     */
    'archive'?: boolean;
    /**
     * 
     * @type {Set<Privilege>}
     * @memberof Role
     */
    'privileges'?: Set<Privilege>;
}

export const RoleTypeEnum = {
    Admin: 'ADMIN',
    Staff: 'STAFF',
    Patient: 'PATIENT',
    Provider: 'PROVIDER',
    Physician: 'PHYSICIAN',
    BillingAdmin: 'BILLING_ADMIN',
    Biller: 'BILLER',
    FrontDeskStaff: 'FRONT_DESK_STAFF',
    SalesCoordinator: 'SALES_COORDINATOR',
    PracticeAdmin: 'PRACTICE_ADMIN',
    CareManager: 'CARE_MANAGER',
    Support: 'SUPPORT'
} as const;

export type RoleTypeEnum = typeof RoleTypeEnum[keyof typeof RoleTypeEnum];

/**
 * 
 * @export
 * @interface RolePrivilegeMapping
 */
export interface RolePrivilegeMapping {
    /**
     * 
     * @type {number}
     * @memberof RolePrivilegeMapping
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof RolePrivilegeMapping
     */
    'roleId'?: number;
    /**
     * 
     * @type {string}
     * @memberof RolePrivilegeMapping
     */
    'roleName'?: string;
    /**
     * 
     * @type {string}
     * @memberof RolePrivilegeMapping
     */
    'roleType'?: RolePrivilegeMappingRoleTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof RolePrivilegeMapping
     */
    'roleDescription'?: string;
    /**
     * 
     * @type {number}
     * @memberof RolePrivilegeMapping
     */
    'privilegeId'?: number;
    /**
     * 
     * @type {string}
     * @memberof RolePrivilegeMapping
     */
    'privilegeName'?: string;
    /**
     * 
     * @type {string}
     * @memberof RolePrivilegeMapping
     */
    'privilegeDescription'?: string;
    /**
     * 
     * @type {string}
     * @memberof RolePrivilegeMapping
     */
    'privilegeModule'?: RolePrivilegeMappingPrivilegeModuleEnum;
    /**
     * 
     * @type {string}
     * @memberof RolePrivilegeMapping
     */
    'privilegeAccess'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof RolePrivilegeMapping
     */
    'access'?: boolean;
}

export const RolePrivilegeMappingRoleTypeEnum = {
    Admin: 'ADMIN',
    Staff: 'STAFF',
    Patient: 'PATIENT',
    Provider: 'PROVIDER',
    Physician: 'PHYSICIAN',
    BillingAdmin: 'BILLING_ADMIN',
    Biller: 'BILLER',
    FrontDeskStaff: 'FRONT_DESK_STAFF',
    SalesCoordinator: 'SALES_COORDINATOR',
    PracticeAdmin: 'PRACTICE_ADMIN',
    CareManager: 'CARE_MANAGER',
    Support: 'SUPPORT'
} as const;

export type RolePrivilegeMappingRoleTypeEnum = typeof RolePrivilegeMappingRoleTypeEnum[keyof typeof RolePrivilegeMappingRoleTypeEnum];
export const RolePrivilegeMappingPrivilegeModuleEnum = {
    PatientManagement: 'PATIENT_MANAGEMENT',
    PatientChart: 'PATIENT_CHART',
    Scheduling: 'SCHEDULING',
    Encounter: 'ENCOUNTER',
    PatientEngagement: 'PATIENT_ENGAGEMENT',
    Library: 'LIBRARY',
    AiScriber: 'AI_SCRIBER',
    Settings: 'SETTINGS',
    Billing: 'BILLING',
    TaskManagement: 'TASK_MANAGEMENT',
    EducationMaterialManagement: 'EDUCATION_MATERIAL_MANAGEMENT'
} as const;

export type RolePrivilegeMappingPrivilegeModuleEnum = typeof RolePrivilegeMappingPrivilegeModuleEnum[keyof typeof RolePrivilegeMappingPrivilegeModuleEnum];

/**
 * 
 * @export
 * @interface RosTemplate
 */
export interface RosTemplate {
    /**
     * 
     * @type {string}
     * @memberof RosTemplate
     */
    'uuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof RosTemplate
     */
    'templateName': string;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof RosTemplate
     */
    'speciality'?: { [key: string]: string; };
    /**
     * 
     * @type {string}
     * @memberof RosTemplate
     */
    'templateTypes': RosTemplateTemplateTypesEnum;
    /**
     * 
     * @type {boolean}
     * @memberof RosTemplate
     */
    'active'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RosTemplate
     */
    'archive'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof RosTemplate
     */
    'appointmentId'?: string;
    /**
     * 
     * @type {string}
     * @memberof RosTemplate
     */
    'updateDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof RosTemplate
     */
    'createdBy'?: string;
    /**
     * 
     * @type {Array<RosTemplateType>}
     * @memberof RosTemplate
     */
    'rosTemplateTypeSet'?: Array<RosTemplateType>;
    /**
     * 
     * @type {string}
     * @memberof RosTemplate
     */
    'subject'?: string;
    /**
     * 
     * @type {string}
     * @memberof RosTemplate
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof RosTemplate
     */
    'goals'?: string;
    /**
     * 
     * @type {string}
     * @memberof RosTemplate
     */
    'intervention'?: string;
    /**
     * 
     * @type {string}
     * @memberof RosTemplate
     */
    'preventive_schedule'?: string;
    /**
     * 
     * @type {string}
     * @memberof RosTemplate
     */
    'care_plan_start'?: string;
    /**
     * 
     * @type {string}
     * @memberof RosTemplate
     */
    'care_plan_end'?: string;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof RosTemplate
     */
    'icdCodes'?: { [key: string]: string; };
    /**
     * 
     * @type {string}
     * @memberof RosTemplate
     */
    'patientId'?: string;
}

export const RosTemplateTemplateTypesEnum = {
    Email: 'EMAIL',
    Sms: 'SMS',
    Ros: 'ROS',
    Physical: 'PHYSICAL',
    Macros: 'MACROS',
    CarePlan: 'CARE_PLAN',
    HomeCareRos: 'HOME_CARE_ROS',
    HomeCarePe: 'HOME_CARE_PE'
} as const;

export type RosTemplateTemplateTypesEnum = typeof RosTemplateTemplateTypesEnum[keyof typeof RosTemplateTemplateTypesEnum];

/**
 * 
 * @export
 * @interface RosTemplateType
 */
export interface RosTemplateType {
    /**
     * 
     * @type {string}
     * @memberof RosTemplateType
     */
    'uuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof RosTemplateType
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof RosTemplateType
     */
    'value'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof RosTemplateType
     */
    'isSelected'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RosTemplateType
     */
    'isBaseType'?: boolean;
}
/**
 * 
 * @export
 * @interface SchedulerCreateRequest
 */
export interface SchedulerCreateRequest {
    /**
     * 
     * @type {string}
     * @memberof SchedulerCreateRequest
     */
    'scheduleName': string;
    /**
     * 
     * @type {string}
     * @memberof SchedulerCreateRequest
     */
    'scheduleExpression': string;
    /**
     * 
     * @type {string}
     * @memberof SchedulerCreateRequest
     */
    'payload': string;
    /**
     * 
     * @type {string}
     * @memberof SchedulerCreateRequest
     */
    'eventBridgeTargetSource': string;
    /**
     * 
     * @type {string}
     * @memberof SchedulerCreateRequest
     */
    'eventBridgeTargetDetailType'?: string;
    /**
     * 
     * @type {string}
     * @memberof SchedulerCreateRequest
     */
    'schedulerState'?: SchedulerCreateRequestSchedulerStateEnum;
    /**
     * 
     * @type {string}
     * @memberof SchedulerCreateRequest
     */
    'actionAfterCompletion'?: SchedulerCreateRequestActionAfterCompletionEnum;
}

export const SchedulerCreateRequestSchedulerStateEnum = {
    Enabled: 'ENABLED',
    Disabled: 'DISABLED',
    Null: 'null'
} as const;

export type SchedulerCreateRequestSchedulerStateEnum = typeof SchedulerCreateRequestSchedulerStateEnum[keyof typeof SchedulerCreateRequestSchedulerStateEnum];
export const SchedulerCreateRequestActionAfterCompletionEnum = {
    None: 'NONE',
    Delete: 'DELETE',
    Null: 'null'
} as const;

export type SchedulerCreateRequestActionAfterCompletionEnum = typeof SchedulerCreateRequestActionAfterCompletionEnum[keyof typeof SchedulerCreateRequestActionAfterCompletionEnum];

/**
 * 
 * @export
 * @interface ScreenerQuestionAnswerScoreResponse
 */
export interface ScreenerQuestionAnswerScoreResponse {
    /**
     * 
     * @type {number}
     * @memberof ScreenerQuestionAnswerScoreResponse
     */
    'score'?: number;
    /**
     * 
     * @type {string}
     * @memberof ScreenerQuestionAnswerScoreResponse
     */
    'createdAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof ScreenerQuestionAnswerScoreResponse
     */
    'severity'?: ScreenerQuestionAnswerScoreResponseSeverityEnum;
    /**
     * 
     * @type {string}
     * @memberof ScreenerQuestionAnswerScoreResponse
     */
    'patientName'?: string;
    /**
     * 
     * @type {string}
     * @memberof ScreenerQuestionAnswerScoreResponse
     */
    'dob'?: string;
    /**
     * 
     * @type {string}
     * @memberof ScreenerQuestionAnswerScoreResponse
     */
    'assessedBy'?: string;
    /**
     * 
     * @type {Set<ScreenerQuestionAnwerResponse>}
     * @memberof ScreenerQuestionAnswerScoreResponse
     */
    'screenerQuestionAnwerResponseSet'?: Set<ScreenerQuestionAnwerResponse>;
}

export const ScreenerQuestionAnswerScoreResponseSeverityEnum = {
    NoneMinimal: 'NONE_MINIMAL',
    Mild: 'MILD',
    Moderate: 'MODERATE',
    ModeratelySevere: 'MODERATELY_SEVERE',
    Severe: 'SEVERE'
} as const;

export type ScreenerQuestionAnswerScoreResponseSeverityEnum = typeof ScreenerQuestionAnswerScoreResponseSeverityEnum[keyof typeof ScreenerQuestionAnswerScoreResponseSeverityEnum];

/**
 * 
 * @export
 * @interface ScreenerQuestionAnwer
 */
export interface ScreenerQuestionAnwer {
    /**
     * 
     * @type {string}
     * @memberof ScreenerQuestionAnwer
     */
    'uuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof ScreenerQuestionAnwer
     */
    'question'?: string;
    /**
     * 
     * @type {string}
     * @memberof ScreenerQuestionAnwer
     */
    'answer'?: string;
    /**
     * 
     * @type {string}
     * @memberof ScreenerQuestionAnwer
     */
    'answerString'?: string;
}
/**
 * 
 * @export
 * @interface ScreenerQuestionAnwerResponse
 */
export interface ScreenerQuestionAnwerResponse {
    /**
     * 
     * @type {string}
     * @memberof ScreenerQuestionAnwerResponse
     */
    'uuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof ScreenerQuestionAnwerResponse
     */
    'question'?: string;
    /**
     * 
     * @type {string}
     * @memberof ScreenerQuestionAnwerResponse
     */
    'answer'?: ScreenerQuestionAnwerResponseAnswerEnum;
    /**
     * 
     * @type {string}
     * @memberof ScreenerQuestionAnwerResponse
     */
    'answerString'?: string;
    /**
     * 
     * @type {number}
     * @memberof ScreenerQuestionAnwerResponse
     */
    'individualScore'?: number;
    /**
     * 
     * @type {string}
     * @memberof ScreenerQuestionAnwerResponse
     */
    'appointmentId'?: string;
    /**
     * 
     * @type {string}
     * @memberof ScreenerQuestionAnwerResponse
     */
    'screenerType'?: string;
    /**
     * 
     * @type {string}
     * @memberof ScreenerQuestionAnwerResponse
     */
    'submissionId'?: string;
}

export const ScreenerQuestionAnwerResponseAnswerEnum = {
    NotAtAll: 'Not at all',
    Never: 'Never',
    AlmostNever: 'Almost never',
    ALittle: 'A little',
    ALittleBit: 'A little bit',
    Rarely: 'Rarely',
    Occasionally: 'Occasionally',
    Sometimes: 'Sometimes',
    SeveralDays: 'Several days',
    SomeOfTheTime: 'Some of the time',
    HalfTheTime: 'Half the time',
    MoreThanHalfTheTime: 'More than half the time',
    MoreThanHalfTheDays: 'More than half the days',
    Often: 'Often',
    QuiteOften: 'Quite often',
    QuiteABit: 'Quite a bit',
    FairlyOften: 'Fairly often',
    Frequently: 'Frequently',
    MostOfTheTime: 'Most of the time',
    VeryOften: 'Very often',
    AlmostAlways: 'Almost always',
    NearlyEveryDay: 'Nearly every day',
    AlmostEveryDay: 'Almost every day',
    ALot: 'A lot',
    ALotOfTheTime: 'A lot of the time',
    AllTheTime: 'All the time',
    AllOfTheTime: 'All of the time',
    AlmostAllOfTheTime: 'Almost all of the time',
    ALittleOfTheTime: 'A little of the time',
    HardlyEver: 'Hardly ever',
    Always: 'Always',
    EveryDay: 'Every day',
    NoDays: 'NO DAYS',
    _15Days: '1-5 DAYS',
    _612Days: '6-12 DAYS',
    _1315Days: '13-15 DAYS',
    _1622Days: '16-22 DAYS',
    _2327Days: '23-27 DAYS',
    EveryDay2: 'EVERY DAY',
    VeryRarely: 'Very Rarely',
    VeryFrequently: 'Very Frequently',
    Extremely: 'Extremely',
    Excellent: 'Excellent',
    VeryGood: 'Very Good',
    Good: 'Good',
    Poor: 'Poor',
    Fair: 'Fair',
    SomewhatAgree: 'Somewhat Agree',
    SomewhatDisagree: 'Somewhat Disagree',
    FeelsCompletelyUntrue: 'Feels Completely Untrue',
    FeelsMostlyUntrue: 'Feels Mostly Untrue',
    FeelsSlightlyUntrue: 'Feels Slightly Untrue',
    FeelsCompletelyTrue: 'Feels Completely True',
    FeelsSlightlyTrue: 'Feels Slightly True',
    NeitherTrueNorUntrue: 'Neither True Nor Untrue',
    Yes: 'Yes',
    No: 'No',
    DefinitelyDisagree: 'Definitely Disagree',
    StronglyDisagree: 'Strongly Disagree',
    StronglyDisagree2: 'Strongly disagree',
    Disagree: 'Disagree',
    SlightlyDisagree: 'Slightly disagree',
    SlightlyDisagree2: 'Slightly Disagree',
    NeitherAgreeNorDisagree: 'Neither agree nor disagree',
    Neutral: 'Neutral',
    SlightlyAgree: 'Slightly agree',
    SlightlyAgree2: 'Slightly Agree',
    Agree: 'Agree',
    StronglyAgree: 'Strongly Agree',
    StronglyAgree2: 'Strongly agree',
    DefinitelyAgree: 'Definitely Agree',
    DefinitelyFalse: 'Definitely False',
    ProbablyFalse: 'Probably False',
    MostlyFalse: 'Mostly False',
    SomewhatFalse: 'Somewhat False',
    SlightlyFalse: 'Slightly False',
    SlightlyTrue: 'Slightly True',
    SomewhatTrue: 'Somewhat True',
    MostlyTrue: 'Mostly True',
    ProbablyTrue: 'Probably True',
    DefinitelyTrue: 'Definitely True',
    _1: '1',
    _2: '2',
    _3: '3',
    _4: '4',
    _5: '5',
    _6: '6',
    _7: '7',
    _8: '8',
    _9: '9',
    _10: '10',
    OnceOrTwice: 'Once or twice',
    ThreeToSixTimes: 'Three to six times',
    SevenToTenTimes: 'Seven to ten times',
    DailyOrAlmostDaily: 'Daily or almost daily',
    Moderately: 'Moderately',
    Somewhat: 'Somewhat',
    VeryMuch: 'Very much',
    Completely: 'Completely',
    NeverTrue: 'Never true',
    NotTrue: 'Not True',
    VerySeldomTrue: 'Very seldom true',
    SeldomTrue: 'Seldom true',
    SometimesTrue: 'Sometimes true',
    FrequentlyTrue: 'Frequently true',
    AlmostAlwaysTrue: 'Almost always true',
    AlwaysTrue: 'Always true',
    VeryTrue: 'Very True',
    NotAtAllLikeMe: 'Not at all like me',
    SlightlyLikeMe: 'Slightly like me',
    SomewhatLikeMe: 'Somewhat like me',
    ModeratelyLikeMe: 'Moderately like me',
    VeryMuchLikeMe: 'Very much like me',
    NoPain: 'No pain',
    MildPain: 'Mild pain',
    ModeratePain: 'Moderate pain',
    SeverePain: 'Severe pain',
    WorstPossiblePain: 'Worst possible pain',
    MonthlyOrLess: 'Monthly or less',
    TwoToFourTimesAMonth: 'Two to four times a month',
    TwoToThreeTimesAWeek: 'Two to three times a week',
    FourOrMoreTimesAWeek: 'Four or more times a week',
    LessThanOnceAWeek: 'less than once a week',
    OnceAWeekOrMore: 'once a week or more',
    Usually: 'Usually',
    YesAlways: 'Yes, always',
    LessThanADayOrTwo: 'Less than a day or two',
    NearlyAlways: 'Nearly Always',
    DoesNotMatchMyExperienceAtAll: 'Does not match my experience at all',
    ProbablyDoesNotMatchMyExperience: 'Probably does not match my experience',
    ProbablyMatchesMyExperience: 'Probably matches my experience',
    DefinitelyMatchesMyExperience: 'Definitely matches my experience',
    WasOnMedication: 'was on medication',
    WasNotOnMedication: 'was not on medication',
    NotSure: 'not sure?',
    TomabaMedicamentos: 'tomaba medicamentos',
    NoTomabaMedicamentos: 'no tomaba medicamentos',
    NoLoRecuerda: 'no lo recuerda',
    NotPresent: 'Not present',
    Equivocal: 'Equivocal',
    PresentButMild: 'Present, but mild',
    PresentAndModerate: 'Present and moderate',
    PresentAndSevere: 'Present and severe',
    NoneSlight: 'None/slight',
    Mild: 'Mild',
    Moderate: 'Moderate',
    Severe: 'Severe',
    Extreme: 'Extreme',
    VerySevere: 'Very severe',
    Mildly: 'Mildly',
    VerySlightly: 'Very slightly',
    NoAnxietyInThePastWeek: 'No anxiety in the past week.',
    InfrequentAnxietyFeltAnxiousAFewTimes: 'Infrequent anxiety. Felt anxious a few times.',
    OccasionalAnxietyFeltAnxiousAsMuchOfTheTimeAsNotItWasHardToRelax: 'Occasional anxiety. Felt anxious as much of the time as not. It was hard to relax.',
    FrequentAnxietyFeltAnxiousMostOfTheTimeItWasVeryDifficultToRelax: 'Frequent anxiety. Felt anxious most of the time. It was very difficult to relax.',
    ConstantAnxietyFeltAnxiousAllOfTheTimeAndNeverReallyRelaxed: 'Constant anxiety. Felt anxious all of the time and never really relaxed.',
    NoDepressionInThePastWeek: 'No depression in the past week.',
    InfrequentDepressionFeltDepressedAFewTimes: 'Infrequent depression. Felt depressed a few times.',
    OccasionalDepressionFeltDepressedAsMuchOfTheTimeAsNot: 'Occasional depression. Felt depressed as much of the time as not',
    FrequentDepressionFeltDepressedMostOfTheTime: 'Frequent depression. Felt depressed most of the time.',
    ConstantDepressionFeltDepressedAllOfTheTime: 'Constant depression. Felt depressed all of the time.',
    CertainlyTrue: 'Certainly true',
    Never0Times: 'Never (0 times)',
    Sometimes510TimesOr12TimesPerDay: 'Sometimes (5-10 times or 1-2 times per day)',
    Often1120TimesOr23TimesPerDay: 'Often (11-20 times or 2-3 times per day)',
    ThereIsNoEvidenceOfPhysicalOrMedicalProblems: 'There is no evidence of physical or medical problems.',
    MildOrWellManagedPhysicalOrMedicalProblemsAreIndicatedAPersonInNeedOfAPhysicalMedicalExaminationWouldBeRatedHere: 'Mild or well-managed physical or medical problems are indicated. A person in need of a physical/medical examination would be rated here.',
    ChronicPhysicalOrModerateMedicalProblemsArePresent: 'Chronic physical or moderate medical problems are present.',
    SevereLifeThreateningPhysicalOrMedicalConditionExists: 'Severe, life threatening physical or medical condition exists.',
    IDoNotFeelHappierOrMoreCheerfulThanUsual: 'I do not feel happier or more cheerful than usual.',
    IOccasionallyFeelHappierOrMoreCheerfulThanUsual: 'I occasionally feel happier or more cheerful than usual.',
    IOftenFeelHappierOrMoreCheerfulThanUsual: 'I often feel happier or more cheerful than usual.',
    IFeelHappierOrMoreCheerfulThanUsualMostOfTheTime: 'I feel happier or more cheerful than usual most of the time.',
    IFeelHappierOrMoreCheerfulThanUsualAllOfTheTime: 'I feel happier or more cheerful than usual all of the time.',
    _0Nil: '0 - Nil',
    _1MildBriefOrTransientPeriodsOfDepressionOrMildlyDepressedMood: '1 - Mild [brief or transient periods of depression, or mildly depressed mood]',
    _2ModerateDepressedMoodIsClearlyButNotConsistentlyPresentAndOtherEmotionsAreExpressedOrDepressionIsOfModerateIntensity: '2 - Moderate [depressed mood is clearly but not consistently present and other emotions are expressed, or depression is of moderate intensity]',
    _3SeverePervasiveOrContinuousDepressedMoodOfMarkedIntensity: '3 - Severe [pervasive or continuous depressed mood of marked intensity]',
    IDontFeelSelfConsciousAboutMyWeightOrBodySizeWhenImWithOthers: 'I don\'t feel self-conscious about my weight or body size when I\'m with others.',
    IFeelConcernedAboutHowILookToOthersButItNormallyDoesNotMakeMeFeelDisappointedWithMyself: 'I feel concerned about how I look to others, but it normally does not make me feel disappointed with myself.',
    IDoGetSelfConsciousAboutMyAppearanceAndWeightWhichMakesMeFeelDisappointedInMyself: 'I do get self-conscious about my appearance and weight which makes me feel disappointed in myself.',
    IFeelVerySelfConsciousAboutMyWeightAndFrequentlyIFeelIntenseShameAndDisgustForMyselfITryToAvoidSocialContactsBecauseOfMySelfConsciousness: 'I feel very self-conscious about my weight and frequently, I feel intense shame and disgust for myself. I try to avoid social contacts because of my self-consciousness.',
    MostTimesTrue: 'Most times true',
    BarelyTrue: 'Barely true',
    ExactlyTrue: 'Exactly true',
    NotAtAllCharacteristicOfMe: 'Not at all characteristic of me',
    ALittleCharacteristicOfMe: 'A little characteristic of me',
    SomewhatCharacteristicOfMe: 'Somewhat characteristic of me',
    VeryCharacteristicOfMe: 'Very characteristic of me',
    EntirelyCharacteristicOfMe: 'Entirely characteristic of me',
    SlightlyCharacteristicOrTrueOfMe: 'Slightly characteristic or true of me',
    VeryCharacteristicOrTrueOfMe: 'Very characteristic or true of me',
    SlightlyTypicalOfMe: 'Slightly typical of me',
    VeryTypicalOfMe: 'Very typical of me',
    FeelsMostlyTrue: 'Feels mostly true',
    HalfOfTheTime: 'Half of the time',
    Daily: 'Daily',
    True: 'True',
    False: 'False',
    FairlyTrue: 'FAIRLY TRUE',
    DidNotApplyToMeAtAll: 'Did not apply to me at all',
    AppliedToMeToAConsiderableDegreeOrAGoodPartOfTheTime: 'Applied to me to a considerable degree, or a good part of the time',
    NeverDidNotApplyToMeAtAll: 'Never- Did not apply to me at all',
    OftenAppliedToMeAConsiderableDegreeOrAGoodPartOfTheTime: 'Often- Applied to me a considerable degree, or a good part of the time',
    AsMuchAsIAlwaysCould: 'As much as I always could',
    NotQuiteSoMuchNow: 'Not quite so much now',
    DefinitelyNotSoMuchNow: 'Definitely not so much now',
    Slight: 'Slight',
    Slightly: 'Slightly',
    Very: 'Very',
    RareLessThanADayOrTwo: 'Rare, less than a day or two',
    SlightRareLessThanADayOrTwo: 'Slight - Rare, less than a day or two',
    NoneNotAtAll: 'None - Not at all',
    MildSeveralDays: 'Mild - Several days',
    ModerateMoreThanHalfTheDays: 'Moderate - More than half the days',
    SevereNearlyEveryDay: 'Severe - Nearly every day',
    MoreThanHalfTheDays2: 'More than half the days',
    Nunca: 'Nunca',
    Siempre: 'Siempre',
    AVeces: 'A veces',
    MuchasVeces: 'Muchas veces',
    CasiNunca: 'Casi nunca',
    CasiSiempreOSiempreEsCierto: 'Casi siempre o siempre es cierto',
    CasiNuncaONuncaEsCierto: 'Casi nunca o nunca es cierto',
    AlgunasVecesEsCierto: 'Algunas veces es cierto',
    BastantesVeces: 'Bastantes veces',
    NotTrueAtAll: 'Not true at all',
    OnceAMonth: 'Once a month',
    VeryLittle: 'Very little',
    None: 'None',
    Totally: 'Totally',
    AlmostNeverOrNever: 'Almost never or never',
    AlmostAlwaysOrAlways: 'Almost always or always',
    ExtremeDifficultyOrCannotDo: 'Extreme Difficulty or Cannot Do',
    OnceDuringTheMonth: 'Once during the month',
    SeveralTimesDuringTheMonth: 'Several times during the month',
    SeveralTimesAWeek: 'Several times a week',
    NeverUsed: 'Never used',
    SometimesUsed: 'Sometimes used',
    RegularlyUsed: 'Regularly used',
    LessThanMonthly: 'Less than monthly',
    AboutOnceAWeek: 'About once a week',
    AboutOnceADay: 'About once a day',
    About2Or3TimesAWeek: 'About 2 or 3 times a week',
    AboutHalfOfTheTime: 'About half of the time',
    LessThan1Month: 'Less than 1 month',
    LessThan6MonthsAgo: 'Less than 6 months ago',
    _1To5YearsAgo: '1 to 5 years ago',
    _5To10YearsAgo: '5 to 10 years ago',
    _10To20YearsAgo: '10 to 20 years ago',
    _10Years: '10+ years',
    LessThanOnceAMonth: 'Less than once a month',
    OnceAWeekOrLess: 'Once a week or less',
    OnceAWeekOrLessOnceInAWhile: 'Once a week or less / once in a while',
    SometimesButNotFrequently: 'Sometimes but not frequently',
    ACurrentProblem: 'A current problem',
    AMajorProblem: 'A major problem',
    AModerateAmount: 'A moderate amount',
    AGreatDeal: 'A great deal',
    MostMuch: 'Most/Much',
    AlmostAllComplete: 'Almost all/Complete',
    IDoNotWorryAboutMyHealth: 'I do not worry about my health.',
    ISpendMuchOfMyTimeWorryingAboutMyHealth: 'I spend much of my time worrying about my health.',
    ISpendMostOfMyTimeWorryingAboutMyHealth: 'I spend most of my time worrying about my health.',
    ICanBeEitherCheerfulOrSadDependingOnTheCircumstances: 'I can be either cheerful or sad, depending on the circumstances.',
    IFeelThoroughlyLowAndGloomyEvenThingsThatNormallyCheerMeUpGiveMeNoPleasure: 'I feel thoroughly low and gloomy. Even things that normally cheer me up give me no pleasure.',
    IFeelSoUtterlyLowAndMiserableThatICanImagineNothingWorse: 'I feel so utterly low and miserable, that I can imagine nothing worse.',
    NeutralMixed: 'Neutral / Mixed',
    TrueOnlyWhenIWasYoungerThan16: 'True only when I was younger than 16',
    TrueOnlyNow: 'True only now',
    TrueNowWhenIWasYoung: 'True now & when I was young',
    _0Nil2: '0 - Nil',
    _1MildBriefOrTransientPeriodsOfDepressionOrMildlyDepressedMood2: '1 - Mild [brief or transient periods of depression, or mildly depressed mood]',
    _2ModerateDepressedMoodIsClearlyButNotConsistentlyPresentAndOtherEmotionsAreExpressedOrDepressionIsOfModerateIntensity2: '2 - Moderate [depressed mood is clearly but not consistently present and other emotions are expressed, or depression is of moderate intensity]',
    _3SeverePervasiveOrContinuousDepressedMoodOfMarkedIntensity2: '3 - Severe [pervasive or continuous depressed mood of marked intensity]',
    Vomiting: 'vomiting',
    SourBelching: 'sour belching',
    Heartburn: 'heartburn',
    Nausea: 'nausea',
    Diarrhea: 'diarrhea',
    FlatulenceGassing: 'flatulence (gassing)',
    FoulOdorFeces: 'foul-odor feces',
    BladderProblemsUrinaryIncontinence: 'bladder problems / urinary incontinence',
    HairLoss: 'hair loss',
    GallstonesOrGallbladderRemoved: 'gallstones (or gallbladder removed)',
    Diabetes: 'diabetes',
    HighBloodPressureHypertensionAlsoIfTreated: 'high blood pressure / hypertension (also if treated)',
    AsthmaSleepApnea: 'asthma / sleep apnea',
    ArthrosisJointPain: 'arthrosis / joint pain',
    Gout: 'gout',
    Other: 'other',
    DoesNotDescribeMeAtAll: 'Does not describe me at all',
    DoesNotDescribeMe: 'Does not describe me ',
    DescribesMe: 'Describes me',
    DescribesMeVeryWell: 'Describes me very well',
    NoMeDescribeEnAbsoluto: 'No me describe en absoluto',
    MeDescribePoco: 'Me describe poco',
    NiPocoNiMucho: 'Ni poco ni mucho',
    MeDescribeBastante: 'Me describe bastante',
    MeDescribeMuyBien: 'Me describe muy bien',
    ALot2: 'A lot ',
    _0NoPain: '0 (No Pain)',
    _10WorstPainImaginable: '10 (Worst Pain Imaginable)',
    ToASlightDegree: 'To a slight degree',
    ToAModerateDegree: 'To a moderate degree',
    ToAGreatDegree: 'To a great degree',
    Spouse: 'Spouse',
    PartnerCompanion: 'Partner/Companion',
    HousemateRoomate: 'Housemate/Roomate',
    Friend: 'Friend',
    Neighbor: 'Neighbor',
    ParentChildOtherRelative: 'Parent/Child/Other relative',
    VeryRarelyTrue: 'Very rarely true',
    OftenTrue: 'Often true',
    NotAtAllNever: 'Not at All/Never',
    AllOfTheTime2: 'All of the time ',
    IStronglyAgree: 'I strongly agree',
    ISomewhatAgree: 'I somewhat agree',
    ISomewhatDisagree: 'I somewhat disagree',
    DisagreeCompletely: 'Disagree completely',
    DisagreeStrongly: 'Disagree strongly ',
    DisagreeSomewhat: 'Disagree somewhat',
    AgreeSomewhat: 'Agree somewhat',
    AgreeStrongly: 'Agree strongly',
    AgreeCompletely: 'Agree completely',
    Rather: 'Rather',
    Much: 'Much',
    VeryStrong: 'Very strong',
    _0: '0%',
    _0Days: '0 days',
    _0Never: '0 (Never)',
    _0NotAtAllHappy: '0 (Not at all happy)',
    _0NoSatisfactionAtAll: '0 (No satisfaction at all) ',
    _0OfTheTime: '0% of the time',
    _102: '10%',
    _100: '100%',
    _100150Lbs: '100-150 lbs',
    _100Lbs: '<100 lbs',
    _100OfTheTime: '100% of the time',
    _10Always: '10 (Always)',
    _10CompletelySatisfied: '10 (Completely Satisfied) ',
    _10OfTheTime: '10% of the time',
    _10VeryVeryHappy: '10 (Very, very happy)',
    _150200Lbs: '150-200 lbs',
    _12Days: '1-2 days',
    _12Months: '1-2 months',
    _12TimesAWeek: '1-2 times a week',
    _12Years: '1-2 years',
    _13TimesAMonth: '1-3 times a month',
    _20: '20%',
    _200250Lbs: '200-250 lbs',
    _20OfTheTime: '20% of the time',
    _250300Lbs: '250-300 lbs',
    _23Months: '2-3 months',
    _23TimesAWeek: '2-3 times a week',
    _24TimesAMonth: '2-4 times a month',
    _25Years: '2-5 years',
    _2To4TimesAWeekHalfTheTime: '2 to 4 times a week / half the time',
    _30: '30%',
    _300350Lbs: '300-350 lbs',
    _30OfTheTime: '30% of the time',
    _350400Lbs: '350-400 lbs',
    _34Days: '3-4 days',
    _35Days: '3-5 days',
    _36Months: '3-6 months',
    _36TimesAWeek: '3-6 times a week',
    _40: '40%',
    _400450Lbs: '400-450 lbs',
    _40OfTheTime: '40% of the time',
    _450500Lbs: '450-500 lbs',
    _4OrMoreTimesOrDaily: '4 or more times or daily',
    _50: '50%',
    _500550Lbs: '500-550 lbs',
    _50OfTheTime: '50% of the time',
    _550600Lbs: '550-600 lbs',
    _510Years: '5-10 years',
    _56Days: '5-6 days',
    _5OrMoreTimesAWeekAlmostAlways: '5 or more times a week / almost always',
    _60: '60%',
    _600Lbs: '>600 lbs',
    _60OfTheTime: '60% of the time',
    _612Months: '6-12 months',
    _67Days: '6-7 days',
    _6Month: '6-month',
    _6To12MonthsAgo: '6 to 12 months ago',
    _70: '70%',
    _70OfTheTime: '70% of the time',
    _80: '80%',
    _80OfTheTime: '80% of the time',
    _90: '90%',
    _90OfTheTime: '90% of the time',
    AboutHalfTheTime: 'About half the time',
    AboutHalfTheTime3665: 'About half the time (36-65%)',
    AdminImmediateDischarge: 'Admin/immediate discharge',
    Admission: 'Admission',
    AgreeAndDisagreeEqually: 'Agree and Disagree Equally',
    AlmostAllTheTime: 'Almost all the time',
    AlmostAlways91100: 'Almost always (91-100%)',
    AlmostAlwaysAgree: 'Almost Always Agree',
    AlmostAlwaysDisagree: 'Almost Always Disagree',
    AlmostNever010: 'Almost never (0-10%)',
    AlmostNeverLessThanOnceAMonth: 'Almost never (less than once a month)',
    AlwaysAgree: 'Always Agree',
    AlwaysDisagree: 'Always Disagree',
    AppliedToMeToSomeDegreeOrSomeOfTheTime: 'Applied to me to some degree, or some of the time',
    AppliedToMeVeryMuchOrMostOfTheTime: 'Applied to me very much, or most of the time',
    AtLeastEveryDay: 'At least every day',
    ABit: 'A bit',
    AFewTimesLessThanHalfTheTime: 'A few times (less than half the time)',
    ALittleTrue: 'A LITTLE TRUE',
    ALittleTypicalOfMe: 'A little typical of me',
    ALittleUnhappy: 'A little unhappy',
    BangedOrPunchedObjectsToThePointOfBruisingOrBleeding: 'Banged or punched objects to the point of bruising or bleeding',
    BittenYourselfToThePointThatBleedingOccursOrMarksRemainOnTheSkin: 'Bitten yourself to the point that bleeding occurs or marks remain on the skin',
    BotheredALittle: 'Bothered a little',
    BotheredALot: 'Bothered a lot',
    BurnedWristsHandsArmsLegsTorsoOrOtherAreasOfTheBody: 'Burned wrists, hands, arms, legs, torso or other areas of the body',
    CarvedWordsOrSymbolsIntoTheSkin: 'Carved words or symbols into the skin',
    CompletelyTrue: 'Completely true',
    CutWristsArmsLegsTorsoOrOtherAreasOfTheBody: 'Cut wrists, arms, legs, torso or other areas of the body',
    DisagreeStrongly2: 'Disagree Strongly',
    Dislike: 'Dislike',
    DrippedAcidOnToSkin: 'Dripped acid on to skin',
    EngagedInFightingOrOtherAggressiveActivitiesWithTheIntentionOfGettingHurt: 'Engaged in fighting or other aggressive activities with the intention of getting hurt',
    Enjoy: 'Enjoy',
    Everyday: 'Everyday',
    ExtremelyCharacteristicOrTrueOfMe: 'Extremely characteristic or true of me',
    ExtremelyHappy: 'Extremely happy',
    ExtremelyImportant: 'Extremely Important ',
    ExtremelyUnhappy: 'Extremely unhappy',
    ExtremeRiskOfHarmExampleCurrentSuicidalOrHomicidalBehaviorOrSuchIntentionsWithAPlanAndAvailableMeansToCarryOutThisBehavior: 'Extreme risk of harm (example: current suicidal or homicidal behavior or such intentions with a plan and available means to carry out this behavior)',
    FairlyUnhappy: 'Fairly unhappy',
    FrequentlyDisagree: 'Frequently Disagree',
    HaceDosSemanas: 'Hace dos semanas',
    HaceSeisMeses: 'Hace seis meses',
    HaceTresMeses: 'Hace tres meses',
    HaceUnAo: 'Hace un año',
    HaceUnMes: 'Hace un mes',
    Happy: 'Happy',
    IngestedACausticSubstanceSOrSharpObjectSDranoOtherCleaningSubstancesPinsEtc: 'Ingested a caustic substance(s) or sharp object(s) (Drano, other cleaning substances, pins, etc)',
    IntentionallyPreventedWoundsFromHealing: 'Intentionally prevented wounds from healing',
    IDontKnow: 'I don\'t know',
    IDoThisOkSometimes: 'I do this ok; sometimes',
    IDoThisPoorlyRarelyOrNotAtAll: 'I do this poorly; rarely, or not at all',
    IDoThisWellOften: 'I do this well; often',
    IFeelABitLowForTheMostPartThoughSometimesItEasesUpALittle: 'I feel a bit low for the most part, though sometimes it eases up a little.',
    IHaveMissedTakingMyMedicationSFiveOrMoreDays: 'I have missed taking my medication(s) five or more days.',
    IHaveMissedTakingMyMedicationSOneDay: 'I have missed taking my medication(s) one day.',
    IHaveMissedTakingMyMedicationSThreeOrFourDays: 'I have missed taking my medication(s) three or four days.',
    IHaveMissedTakingMyMedicationSTwoDays: 'I have missed taking my medication(s) two days.',
    IHaveStoppedTakingMyMedicationS: 'I have stopped taking my medication(s).',
    IHaveTakenMyMedicationSEveryDayWithoutMissingADay: 'I have taken my medication(s) every day without missing a day.',
    IOccasionallyWorryAboutMyHealth: 'I occasionally worry about my health.',
    IStronglyDisagree: 'I strongly disagree',
    IWouldLikeToWorkOnThisIncreaseTheFrequencyOfThis: 'I would like to work on this, increase the frequency of this',
    LaSemanaPasada: 'La semana pasada',
    LessThanHalfOfTheTime: 'Less than half of the time',
    LessThanHalfTheTime: 'Less than half the time',
    LowRiskOfHarmExampleNoCurrentSuicidalOrHomicidalIdeationPlanIntentionsOrSevereDistressButMayHaveHadTransientOrPassiveThoughtsRecentlyOrInThePast: 'Low risk of harm (example: no current suicidal or homicidal ideation, plan, intentions or severe distress, but may have had transient or passive thoughts recently or in the past)',
    MildlyAgree: 'Mildly Agree',
    MildlyDisagree: 'Mildly Disagree',
    MinimalRiskOfHarmExampleNoIndicationOfSuicidalOrHomicidalThoughtsOrImpulsesAndNoHistoryOfSuicidalOrHomicidalIdeationAndNoIndicationOfSignificantDistress: 'Minimal risk of harm (example: no indication of suicidal or homicidal thoughts or impulses, and no history of suicidal or homicidal ideation, and no indication of significant distress)',
    ModeratelyAgree: 'Moderately Agree',
    ModeratelyCharacteristicOrTrueOfMe: 'Moderately characteristic or true of me',
    ModeratelyDisagree: 'Moderately Disagree',
    ModeratelySatisfied: 'Moderately satisfied',
    ModeratelyTrue: 'Moderately true',
    ModeratelyTypicalOfMe: 'Moderately typical of me',
    ModerateRiskOfHarmExampleSignificantCurrentSuicidalOrHomicidalIdeationWithoutIntentOrConsciousPlanAndWithoutPastHistory: 'Moderate risk of harm (example: significant current suicidal or homicidal ideation without intent or conscious plan and without past history)',
    MoreThan20YearsAgo: 'More than 20 years ago',
    MoreThanOnce: 'More than once',
    MoreThanOnceADay: 'More than once a day',
    MostlyLikeMe: 'Mostly like me',
    MostOfTheTime2040TimesOr36TimesPerDay: 'Most of the time (20-40 times or 3-6 times per day)',
    MostOfTheTime6690: 'Most of the time (66-90%)',
    MostOrAllOfTheTime: 'Most or all of the time',
    MostTimesMoreThanHalfTheTime: 'Most times (more than half the time)',
    NearlyAllTheTime40OrMoreThan6TimesPerDay: 'Nearly all the time (40+ or more than 6 times per day)',
    NeitherAgreeOrDisagree: 'Neither Agree or Disagree',
    NeitherDisagreeNorAgree: 'Neither Disagree nor Agree',
    NeverOrVeryRarelyTrue: 'Never or very rarely true',
    NoneOfTheTime: 'None of the time',
    NoneOfTheTimeCouldNotEjaculate: 'None of the time/could not ejaculate',
    NotApplicable: 'Not applicable',
    NotApplicableEGHaventHadAppointmentYet: 'Not applicable (e.g. haven\'t had appointment yet)',
    NotAtAllCharacteristicOrTrueOfMe: 'Not at all characteristic or true of me',
    NotAtAllImportant: 'Not At All Important ',
    NotAtAllSatisfied: 'Not at all satisfied',
    NotAtAllTrue: 'Not at all true',
    NotAtAllTrueForMe: 'Not at all true for me',
    NotAtAllTypicalOfMe: 'Not at all typical of me',
    NotAProblem: 'Not a problem',
    NotBotheredAtAll: 'Not bothered at all',
    NotLikeMeAtAll: 'Not like me at all',
    NotMuchLikeMe: 'Not much like me',
    NotTrueOrHardlyEverTrue: 'Not true or hardly ever true',
    NotVeryOften: 'Not very often',
    NoSexualActivity: 'No sexual activity',
    NoTengoUnaTerepeuta: 'No tengo una terepeuta',
    Occasionally3Or4Times: 'Occasionally (3 or 4 times)',
    OccasionallyDisagree: 'Occasionally Disagree',
    OccasionallyOrAModerateAmountOfTheTime: 'Occasionally or a moderate amount of the time',
    OccasionallyTrue: 'Occasionally TRUE',
    Often1120TimesOr23TimesPerDay2: 'Often (11-20 times or 2-3 times per day)',
    OftenTrueForMe: 'Often true for me',
    Once: 'Once',
    OnceInAWhile: 'Once in a while',
    OnlyALittleOrNotAtAll: 'Only a little or not at all',
    Perfect: 'Perfect',
    PlannedDischarge: 'Planned discharge',
    PossiblyAProblem: 'Possibly a problem',
    PunchedOrBangedOneselfToThePointOfBruisingOrBleeding: 'Punched or banged oneself to the point of bruising or bleeding',
    QuiteALot: 'Quite a lot',
    QuiteImportant: 'Quite Important ',
    QuiteOftenTrue: 'Quite often true',
    QuiteUnimportant: 'Quite Unimportant ',
    Rarely1Or2Times: 'Rarely (1 or 2 times)',
    Rarely26TimesMonth: 'Rarely (2-6 times/month)',
    RarelyOrNoneOfTheTime: 'Rarely or none of the time',
    RarelyTrue: 'Rarely TRUE',
    RarelyUsed: 'Rarely used',
    RippedOrTornSkin: 'Ripped or torn skin',
    RubbedGlassIntoSkinOrStuckSharpObjectsSuchAsNeedlesPinsAndStaplesIntoOrUnderneathTheSkinNotIncludingTattooingBodyPiercingOrNeedlesUsedForMedicationUse: 'Rubbed glass into skin or stuck sharp objects such as needles, pins, and staples into or underneath the skin (not including tattooing, body piercing, or needles used for medication use)',
    Satisfied: 'Satisfied',
    Seguido: 'Seguido',
    Seldom: 'Seldom',
    SeriousRiskOfHarmExampleCurrentSuicidalOrHomicidalIdeationWithExpressedIntentionsAndOrPastHistoryOfCarryingOutSuchBehaviorButWithoutMeansForCarryingOutTheBehavior: 'Serious risk of harm (example: current suicidal or homicidal ideation with expressed intentions and/or past history of carrying out such behavior but without means for carrying out the behavior)',
    SeveralTimesEveryDay: 'Several times every day',
    SeverelyScratchedOrPinchedWithFingernailsOrOtherObjectsToThePointThatBleedingOccursOrMarksRemainOnTheSkin: 'Severely scratched or pinched with fingernails or other objects to the point that bleeding occurs or marks remain on the skin',
    SlightlyDislike: 'Slightly dislike',
    SlightlyEnjoy: 'Slightly enjoy',
    SlightlySatisfied: 'Slightly satisfied',
    SlightlyTrueForMe: 'Slightly true for me',
    Sometimes1135: 'Sometimes (11-35%)',
    Sometimes510TimesOr12TimesPerDay2: 'Sometimes (5-10 times or 1-2 times per day)',
    SometimesAboutHalfTheTime: 'Sometimes (about half the time)',
    SometimesMoreThan7TimesMonthButNotEveryDay: 'Sometimes (more than 7 times/month, but not every day)',
    SomewhatImportant: 'Somewhat Important ',
    SomewhatOrSometimesTrue: 'Somewhat or sometimes true',
    SomewhatTrueForMe: 'Somewhat true for me',
    SomewhatTrueOrSometimesTrue: 'Somewhat true or sometimes true',
    SomewhatUnimportant: 'Somewhat Unimportant ',
    SomeOrALittleOfTheTime: 'Some or a little of the time',
    S: 'Sí',
    TriedToBreakYourOwnBoneS: 'Tried to break your own bone(s)',
    UndecidedDontKnowDoesNotApply: 'Undecided / Don\'t Know / Does Not Apply',
    Unhappy: 'Unhappy',
    Unsatisfied: 'Unsatisfied',
    UsedViagraOrSimilarDrugWithEverySexualEncounter: 'Used Viagra or similar drug with every sexual encounter',
    VeryHappy: 'Very happy',
    VeryMuchSo: 'Very much so',
    VeryOftenOrAlwaysTrue: 'Very often or always true',
    VeryOftenTrue: 'Very often true',
    VeryPoor: 'Very poor',
    VerySatisfied: 'Very satisfied',
    VerySlightlyOrNotAtAll: 'Very slightly or not at all',
    NotAtAllVerySlightly: 'Not at all / very slightly',
    VeryTrueForMe: 'Very true for me',
    VeryTrueOrOftenTrue: 'Very true or often true',
    VeryUnsatisfied: 'Very Unsatisfied',
    VeryWell: 'Very well',
    SixMonth: 'Six Month',
    Under18: 'Under 18',
    OlderOrEqualTo65: 'Older Or Equal To 65',
    Between18And64: 'Between 18 And 64',
    ZeroPercent: 'Zero Percent',
    TenPercent: 'Ten Percent',
    TwentyPercent: 'Twenty Percent',
    ThirtyPercent: 'Thirty Percent',
    FortyPercent: 'Forty Percent',
    FiftyPercent: 'Fifty Percent',
    SixtyPercent: 'Sixty Percent',
    SeventyPercent: 'Seventy Percent',
    EightyPercent: 'Eighty Percent',
    NinetyPercent: 'Ninety Percent',
    HundredPercent: 'Hundred Percent',
    NoChanceOfDozing: 'No chance of dozing',
    SlightChanceOfDozing: 'Slight chance of dozing',
    ModerateChanceOfDozing: 'Moderate chance of dozing',
    HighChanceOfDozing: 'High chance of dozing',
    HappenedToMe: 'Happened to me',
    WitnessedIt: 'Witnessed it',
    LearnedAboutIt: 'Learned about it',
    PartOfMyJob: 'Part of my job',
    DoesNotApply: 'Does not apply',
    LessThan1Year: 'Less than 1 year',
    _15Years: '1-5 years',
    _510Years2: '5-10 years',
    MoreThan10Years: 'More than 10 years',
    FastFood: 'Fast food',
    FriedFoods: 'Fried foods',
    SugaryDrinks: 'Sugary drinks',
    SweetsOrDesserts: 'Sweets or desserts',
    LateNightEating: 'Late-night eating',
    DailyFruitsOrVegetables: 'Daily fruits or vegetables',
    MostlyHomeCooked: 'Mostly home cooked',
    MostlyTakeOutRestaurant: 'Mostly take-out/restaurant',
    Mixed: 'Mixed',
    LackOfTime: 'Lack of time',
    CostOfHealthyFood: 'Cost of healthy food',
    StressEmotionalEating: 'Stress/emotional eating',
    PainLimitedMobility: 'Pain/limited mobility',
    Fatigue: 'Fatigue',
    LackOfMotivation: 'Lack of motivation',
    FamilySocialHabits: 'Family/social habits',
    Cigarettes: 'Cigarettes',
    Cigars: 'Cigars',
    SmokelessTobacco: 'Smokeless tobacco',
    VapingECigaretteNicotine: 'Vaping/e-cigarette nicotine',
    NotReady: 'Not ready',
    ConsideringQuitting: 'Considering quitting',
    ReadyToQuit: 'Ready to quit',
    ActivelyQuitting: 'Actively quitting',
    SetQuitDate: 'Set quit date',
    TriggerAvoidance: 'Trigger avoidance',
    StressCoping: 'Stress coping',
    SupportSystem: 'Support system',
    RelapsePrevention: 'Relapse prevention',
    NicotineReplacementTherapy: 'Nicotine replacement therapy',
    Bupropion: 'Bupropion',
    Varenicline: 'Varenicline',
    Quitline: 'Quitline',
    PrintedHandout: 'Printed handout',
    BehavioralHealth: 'Behavioral health',
    GroupCounseling: 'Group counseling',
    _99406MoreThan3AndUpTo10Minutes: '99406: more than 3 and up to 10 minutes',
    _99407MoreThan10Minutes: '99407: more than 10 minutes',
    Type1: 'Type 1',
    Type2: 'Type 2',
    Gestational: 'Gestational',
    PreDiabetes: 'Pre-Diabetes',
    Insulin: 'Insulin',
    OralHypoglycemic: 'Oral hypoglycemic',
    DietControl: 'Diet Control',
    LowRiskPatient: 'Low risk patient',
    HighRiskPatient: 'High risk patient',
    Current: 'Current',
    Former: 'Former',
    WelcomeG0402: 'Welcome (G0402)',
    InitialG0438: 'Initial (G0438)',
    SubsequentG0439: 'Subsequent (G0439)',
    TrippedOverSomething: 'Tripped over something',
    Injured: 'Injured',
    LightheadednessOrPalpitationsPriorTo: 'Lightheadedness or palpitations prior to',
    LossOfConsciousness: 'Loss of consciousness',
    NeededToSeeADoctor: 'Needed to see a doctor',
    AbleToGetUpOnOwn: 'Able to get up on own',
    ApartmentCondo: 'Apartment/Condo',
    AssistedLiving: 'Assisted living',
    House: 'House',
    OilHeat: 'Oil heat',
    GasHeat: 'Gas heat',
    ElectricHeatAc: 'Electric heat/AC',
    Fireplace: 'Fireplace',
    Fans: 'Fans',
    OpenWindows: 'Open windows',
    GasOvenStove: 'Gas oven/stove',
    ElectricOvenStove: 'Electric oven/stove',
    Microwave: 'Microwave',
    Toaster: 'Toaster',
    Crockpot: 'Crockpot',
    NoMethodUsed: 'No method used',
    MedicinesLinedUp: 'Medicines lined up',
    PrePouredOrPreplacedPillsInAPillbox: 'Pre-poured or preplaced pills in a pillbox',
    BubblePacksOfMeds: 'Bubble packs of meds',
    Self: 'Self',
    FamilyMember: 'Family member',
    CareGiver: 'Care giver',
    ComfortHeightToilet: 'Comfort-height toilet',
    PortableCommode: 'Portable commode',
    StairLift: 'Stair lift',
    HoyerLift: 'Hoyer lift',
    HospitalBed: 'Hospital bed',
    ChairLift: 'Chair lift',
    RemotePatientMonitoring: 'Remote patient monitoring',
    GrabBars: 'Grab bars',
    O2: 'O2',
    OtherSuppliers: 'Other / Suppliers',
    FreeText: 'Free text',
    Unknown: 'Unknown'
} as const;

export type ScreenerQuestionAnwerResponseAnswerEnum = typeof ScreenerQuestionAnwerResponseAnswerEnum[keyof typeof ScreenerQuestionAnwerResponseAnswerEnum];

/**
 * 
 * @export
 * @interface SendEmailOtpRequest
 */
export interface SendEmailOtpRequest {
    /**
     * 
     * @type {string}
     * @memberof SendEmailOtpRequest
     */
    'email': string;
}
/**
 * 
 * @export
 * @interface SetPasswordRequest
 */
export interface SetPasswordRequest {
    /**
     * 
     * @type {string}
     * @memberof SetPasswordRequest
     */
    'email': string;
}
/**
 * 
 * @export
 * @interface Setup2FARequest
 */
export interface Setup2FARequest {
    /**
     * 
     * @type {string}
     * @memberof Setup2FARequest
     */
    'providerId': string;
    /**
     * 
     * @type {string}
     * @memberof Setup2FARequest
     */
    'password': string;
    /**
     * 
     * @type {string}
     * @memberof Setup2FARequest
     */
    'authType': Setup2FARequestAuthTypeEnum;
}

export const Setup2FARequestAuthTypeEnum = {
    Email: 'EMAIL',
    GoogleAuthenticator: 'GOOGLE_AUTHENTICATOR'
} as const;

export type Setup2FARequestAuthTypeEnum = typeof Setup2FARequestAuthTypeEnum[keyof typeof Setup2FARequestAuthTypeEnum];

/**
 * 
 * @export
 * @interface SmtpConfiguration
 */
export interface SmtpConfiguration {
    /**
     * 
     * @type {string}
     * @memberof SmtpConfiguration
     */
    'uuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof SmtpConfiguration
     */
    'hostName'?: string;
    /**
     * 
     * @type {string}
     * @memberof SmtpConfiguration
     */
    'userName'?: string;
    /**
     * 
     * @type {string}
     * @memberof SmtpConfiguration
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof SmtpConfiguration
     */
    'verificationEmail'?: string;
    /**
     * 
     * @type {string}
     * @memberof SmtpConfiguration
     */
    'password'?: string;
    /**
     * 
     * @type {string}
     * @memberof SmtpConfiguration
     */
    'port'?: string;
    /**
     * 
     * @type {string}
     * @memberof SmtpConfiguration
     */
    'protocol'?: string;
    /**
     * 
     * @type {string}
     * @memberof SmtpConfiguration
     */
    'providerGroupId'?: string;
}
/**
 * 
 * @export
 * @interface SocialHistoryIntakeForm
 */
export interface SocialHistoryIntakeForm {
    /**
     * 
     * @type {boolean}
     * @memberof SocialHistoryIntakeForm
     */
    'alcohol'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SocialHistoryIntakeForm
     */
    'smoke'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SocialHistoryIntakeForm
     */
    'caffeine'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SocialHistoryIntakeForm
     */
    'sexuallyActive'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SocialHistoryIntakeForm
     */
    'stdCheck'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof SocialHistoryIntakeForm
     */
    'details'?: string;
}
/**
 * 
 * @export
 * @interface SpeakerLabelRequest
 */
export interface SpeakerLabelRequest {
    /**
     * 
     * @type {Array<TranscriptionSegmentRequest>}
     * @memberof SpeakerLabelRequest
     */
    'segments'?: Array<TranscriptionSegmentRequest>;
}
/**
 * 
 * @export
 * @interface SrfaxQueueFaxRequest
 */
export interface SrfaxQueueFaxRequest {
    /**
     * 
     * @type {string}
     * @memberof SrfaxQueueFaxRequest
     */
    'action'?: string;
    /**
     * 
     * @type {string}
     * @memberof SrfaxQueueFaxRequest
     */
    'access_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof SrfaxQueueFaxRequest
     */
    'access_pwd'?: string;
    /**
     * 
     * @type {number}
     * @memberof SrfaxQueueFaxRequest
     */
    'sCallerID'?: number;
    /**
     * 
     * @type {string}
     * @memberof SrfaxQueueFaxRequest
     */
    'sSenderEmail'?: string;
    /**
     * 
     * @type {string}
     * @memberof SrfaxQueueFaxRequest
     */
    'sFaxType'?: string;
    /**
     * 
     * @type {string}
     * @memberof SrfaxQueueFaxRequest
     */
    'sToFaxNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof SrfaxQueueFaxRequest
     */
    'sResponseFormat'?: string;
    /**
     * 
     * @type {string}
     * @memberof SrfaxQueueFaxRequest
     */
    'sAccountCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof SrfaxQueueFaxRequest
     */
    'sRetries'?: string;
    /**
     * 
     * @type {string}
     * @memberof SrfaxQueueFaxRequest
     */
    'sCoverPage'?: string;
    /**
     * 
     * @type {string}
     * @memberof SrfaxQueueFaxRequest
     */
    'sFaxFromHeader'?: string;
    /**
     * 
     * @type {string}
     * @memberof SrfaxQueueFaxRequest
     */
    'sCPFromName'?: string;
    /**
     * 
     * @type {string}
     * @memberof SrfaxQueueFaxRequest
     */
    'sCPToName'?: string;
    /**
     * 
     * @type {string}
     * @memberof SrfaxQueueFaxRequest
     */
    'sCPOrganization'?: string;
    /**
     * 
     * @type {string}
     * @memberof SrfaxQueueFaxRequest
     */
    'sCPSubject'?: string;
    /**
     * 
     * @type {string}
     * @memberof SrfaxQueueFaxRequest
     */
    'sCPComments'?: string;
    /**
     * 
     * @type {string}
     * @memberof SrfaxQueueFaxRequest
     */
    'sFileName_1'?: string;
    /**
     * 
     * @type {string}
     * @memberof SrfaxQueueFaxRequest
     */
    'sFileContent_1'?: string;
    /**
     * 
     * @type {string}
     * @memberof SrfaxQueueFaxRequest
     */
    'sFileName_2'?: string;
    /**
     * 
     * @type {string}
     * @memberof SrfaxQueueFaxRequest
     */
    'sFileContent_2'?: string;
    /**
     * 
     * @type {string}
     * @memberof SrfaxQueueFaxRequest
     */
    'sNotifyURL'?: string;
    /**
     * 
     * @type {string}
     * @memberof SrfaxQueueFaxRequest
     */
    'sQueueFaxDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof SrfaxQueueFaxRequest
     */
    'sQueueFaxTime'?: string;
}
/**
 * 
 * @export
 * @interface SseEmitter
 */
export interface SseEmitter {
    /**
     * 
     * @type {number}
     * @memberof SseEmitter
     */
    'timeout'?: number;
}
/**
 * 
 * @export
 * @interface StickyNotes
 */
export interface StickyNotes {
    /**
     * 
     * @type {string}
     * @memberof StickyNotes
     */
    'uuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof StickyNotes
     */
    'description': string;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof StickyNotes
     */
    'patient': { [key: string]: string; };
    /**
     * 
     * @type {boolean}
     * @memberof StickyNotes
     */
    'active'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof StickyNotes
     */
    'archive'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof StickyNotes
     */
    'createdInfo'?: string;
    /**
     * 
     * @type {string}
     * @memberof StickyNotes
     */
    'createdDate'?: string;
}
/**
 * 
 * @export
 * @interface SubjectiveDTO
 */
export interface SubjectiveDTO {
    /**
     * 
     * @type {string}
     * @memberof SubjectiveDTO
     */
    'title'?: string;
    /**
     * 
     * @type {Content}
     * @memberof SubjectiveDTO
     */
    'content'?: Content;
}
/**
 * 
 * @export
 * @interface SuperBill
 */
export interface SuperBill {
    /**
     * 
     * @type {string}
     * @memberof SuperBill
     */
    'uuid'?: string;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof SuperBill
     */
    'patient'?: { [key: string]: string; };
    /**
     * 
     * @type {string}
     * @memberof SuperBill
     */
    'patientName'?: string;
    /**
     * 
     * @type {string}
     * @memberof SuperBill
     */
    'patientGender'?: string;
    /**
     * 
     * @type {string}
     * @memberof SuperBill
     */
    'patientDOB'?: string;
    /**
     * 
     * @type {string}
     * @memberof SuperBill
     */
    'patientPhone'?: string;
    /**
     * 
     * @type {string}
     * @memberof SuperBill
     */
    'ecarehealthPatientId'?: string;
    /**
     * 
     * @type {Address}
     * @memberof SuperBill
     */
    'patientAddress'?: Address;
    /**
     * 
     * @type {Set<PatientInsurance>}
     * @memberof SuperBill
     */
    'patientInsurance'?: Set<PatientInsurance>;
    /**
     * 
     * @type {string}
     * @memberof SuperBill
     */
    'dateOfService'?: string;
    /**
     * 
     * @type {string}
     * @memberof SuperBill
     */
    'placeOfService'?: SuperBillPlaceOfServiceEnum;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof SuperBill
     */
    'location'?: { [key: string]: string; };
    /**
     * 
     * @type {string}
     * @memberof SuperBill
     */
    'serviceState'?: string;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof SuperBill
     */
    'renderingProvider'?: { [key: string]: string; };
    /**
     * 
     * @type {string}
     * @memberof SuperBill
     */
    'renderingProviderNpi'?: string;
    /**
     * 
     * @type {string}
     * @memberof SuperBill
     */
    'renderingProviderLicenseNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof SuperBill
     */
    'priorAuthorization'?: string;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof SuperBill
     */
    'billingProvider'?: { [key: string]: string; };
    /**
     * 
     * @type {string}
     * @memberof SuperBill
     */
    'billingProviderNpi'?: string;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof SuperBill
     */
    'referringProvider'?: { [key: string]: string; };
    /**
     * 
     * @type {string}
     * @memberof SuperBill
     */
    'referringProviderNpi'?: string;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof SuperBill
     */
    'orderingProvider'?: { [key: string]: string; };
    /**
     * 
     * @type {string}
     * @memberof SuperBill
     */
    'orderingProviderNpi'?: string;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof SuperBill
     */
    'diagnosisCodes'?: { [key: string]: string; };
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof SuperBill
     */
    'procedureCodes'?: { [key: string]: string; };
    /**
     * 
     * @type {string}
     * @memberof SuperBill
     */
    'diagnosisPointers'?: string;
    /**
     * 
     * @type {string}
     * @memberof SuperBill
     */
    'medicalCodeModifiers'?: string;
    /**
     * 
     * @type {number}
     * @memberof SuperBill
     */
    'quantity'?: number;
    /**
     * 
     * @type {number}
     * @memberof SuperBill
     */
    'charges'?: number;
    /**
     * 
     * @type {number}
     * @memberof SuperBill
     */
    'subTotal'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof SuperBill
     */
    'active'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SuperBill
     */
    'archive'?: boolean;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof SuperBill
     */
    'encounter'?: { [key: string]: string; };
    /**
     * 
     * @type {string}
     * @memberof SuperBill
     */
    'encounter_date'?: string;
    /**
     * 
     * @type {string}
     * @memberof SuperBill
     */
    'claimUuid'?: string;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof SuperBill
     */
    'renderingProviderSpecialities'?: { [key: string]: string; };
    /**
     * 
     * @type {number}
     * @memberof SuperBill
     */
    'discount'?: number;
    /**
     * 
     * @type {string}
     * @memberof SuperBill
     */
    'discountType'?: SuperBillDiscountTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof SuperBill
     */
    'billDate'?: string;
    /**
     * 
     * @type {Set<PatientProcedureCode>}
     * @memberof SuperBill
     */
    'patientProcedureCodes'?: Set<PatientProcedureCode>;
    /**
     * 
     * @type {number}
     * @memberof SuperBill
     */
    'claimedAmount'?: number;
    /**
     * 
     * @type {number}
     * @memberof SuperBill
     */
    'copayAmount'?: number;
    /**
     * 
     * @type {number}
     * @memberof SuperBill
     */
    'paidFromPayer'?: number;
    /**
     * 
     * @type {number}
     * @memberof SuperBill
     */
    'writeoffFromPayer'?: number;
    /**
     * 
     * @type {number}
     * @memberof SuperBill
     */
    'writeoffFromPatient'?: number;
    /**
     * 
     * @type {number}
     * @memberof SuperBill
     */
    'patientBalance'?: number;
    /**
     * 
     * @type {number}
     * @memberof SuperBill
     */
    'prevPaid'?: number;
    /**
     * 
     * @type {string}
     * @memberof SuperBill
     */
    'superBillStatus'?: SuperBillSuperBillStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof SuperBill
     */
    'cancelReason'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof SuperBill
     */
    'patientResponsibilityInvoice'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof SuperBill
     */
    'sourceType'?: SuperBillSourceTypeEnum;
    /**
     * 
     * @type {boolean}
     * @memberof SuperBill
     */
    'invoiceSentToPatient'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof SuperBill
     */
    'paymentMode'?: string;
    /**
     * 
     * @type {string}
     * @memberof SuperBill
     */
    'invoiceType'?: string;
    /**
     * 
     * @type {string}
     * @memberof SuperBill
     */
    'dueDate'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof SuperBill
     */
    'selfPay'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof SuperBill
     */
    'total'?: number;
    /**
     * 
     * @type {number}
     * @memberof SuperBill
     */
    'advancedPaid'?: number;
    /**
     * 
     * @type {number}
     * @memberof SuperBill
     */
    'insuranceAmount'?: number;
    /**
     * 
     * @type {number}
     * @memberof SuperBill
     */
    'previousBalance'?: number;
}

export const SuperBillPlaceOfServiceEnum = {
    Pharmacy: 'PHARMACY',
    TelehealthOutsidePatientHome: 'TELEHEALTH_OUTSIDE_PATIENT_HOME',
    School: 'SCHOOL',
    HomelessShelter: 'HOMELESS_SHELTER',
    IndianHealthServiceFreeStandingFacility: 'INDIAN_HEALTH_SERVICE_FREE_STANDING_FACILITY',
    IndianHealthServiceProviderBasedFacility: 'INDIAN_HEALTH_SERVICE_PROVIDER_BASED_FACILITY',
    Tribal638FreeStandingFacility: 'TRIBAL_638_FREE_STANDING_FACILITY',
    Tribal638ProviderBasedFacility: 'TRIBAL_638_PROVIDER_BASED_FACILITY',
    PrisonCorrectionalFacility: 'PRISON_CORRECTIONAL_FACILITY',
    TelehealthInsidePatientHome: 'TELEHEALTH_INSIDE_PATIENT_HOME',
    Office: 'OFFICE',
    Home: 'HOME',
    AssistedLivingFacility: 'ASSISTED_LIVING_FACILITY',
    GroupHome: 'GROUP_HOME',
    MobileUnit: 'MOBILE_UNIT',
    TemporaryLodging: 'TEMPORARY_LODGING',
    WalkInRetailHealthClinic: 'WALK_IN_RETAIL_HEALTH_CLINIC',
    PlaceOfEmploymentWorksite: 'PLACE_OF_EMPLOYMENT_WORKSITE',
    OffCampusOutpatientHospital: 'OFF_CAMPUS_OUTPATIENT_HOSPITAL',
    UrgentCareFacility: 'URGENT_CARE_FACILITY',
    InpatientHospital: 'INPATIENT_HOSPITAL',
    OutpatientHospital: 'OUTPATIENT_HOSPITAL',
    EmergencyRoomHospital: 'EMERGENCY_ROOM_HOSPITAL',
    AmbulatorySurgicalCenter: 'AMBULATORY_SURGICAL_CENTER',
    BirthingCenter: 'BIRTHING_CENTER',
    MilitaryTreatmentFacility: 'MILITARY_TREATMENT_FACILITY',
    SkilledNursingFacility: 'SKILLED_NURSING_FACILITY',
    NursingFacility: 'NURSING_FACILITY',
    CustodialCareFacility: 'CUSTODIAL_CARE_FACILITY',
    Hospice: 'HOSPICE',
    AmbulanceLand: 'AMBULANCE_LAND',
    AmbulanceAirOrWater: 'AMBULANCE_AIR_OR_WATER',
    IndependentClinic: 'INDEPENDENT_CLINIC',
    FederallyQualifiedHealthCenter: 'FEDERALLY_QUALIFIED_HEALTH_CENTER',
    InpatientPsychiatricFacility: 'INPATIENT_PSYCHIATRIC_FACILITY',
    PsychiatricFacilityPartialHospitalization: 'PSYCHIATRIC_FACILITY_PARTIAL_HOSPITALIZATION',
    CommunityMentalHealthCenter: 'COMMUNITY_MENTAL_HEALTH_CENTER',
    IntermediateCareFacilityIntellectualDisabilities: 'INTERMEDIATE_CARE_FACILITY_INTELLECTUAL_DISABILITIES',
    ResidentialSubstanceAbuseTreatmentFacility: 'RESIDENTIAL_SUBSTANCE_ABUSE_TREATMENT_FACILITY',
    PsychiatricResidentialTreatmentCenter: 'PSYCHIATRIC_RESIDENTIAL_TREATMENT_CENTER',
    NonResidentialSubstanceAbuseTreatmentFacility: 'NON_RESIDENTIAL_SUBSTANCE_ABUSE_TREATMENT_FACILITY',
    NonResidentialOpioidTreatmentFacility: 'NON_RESIDENTIAL_OPIOID_TREATMENT_FACILITY',
    MassImmunizationCenter: 'MASS_IMMUNIZATION_CENTER',
    ComprehensiveInpatientRehabilitationFacility: 'COMPREHENSIVE_INPATIENT_REHABILITATION_FACILITY',
    ComprehensiveOutpatientRehabilitationFacility: 'COMPREHENSIVE_OUTPATIENT_REHABILITATION_FACILITY',
    EndStageRenalDiseaseTreatmentFacility: 'END_STAGE_RENAL_DISEASE_TREATMENT_FACILITY',
    PublicHealthClinic: 'PUBLIC_HEALTH_CLINIC',
    RuralHealthClinic: 'RURAL_HEALTH_CLINIC',
    IndependentLaboratory: 'INDEPENDENT_LABORATORY',
    OtherPlaceOfService: 'OTHER_PLACE_OF_SERVICE'
} as const;

export type SuperBillPlaceOfServiceEnum = typeof SuperBillPlaceOfServiceEnum[keyof typeof SuperBillPlaceOfServiceEnum];
export const SuperBillDiscountTypeEnum = {
    Percentage: 'PERCENTAGE',
    Amount: 'AMOUNT'
} as const;

export type SuperBillDiscountTypeEnum = typeof SuperBillDiscountTypeEnum[keyof typeof SuperBillDiscountTypeEnum];
export const SuperBillSuperBillStatusEnum = {
    ReadyForClaim: 'READY_FOR_CLAIM',
    Draft: 'DRAFT',
    Pending: 'PENDING',
    PartiallyPaid: 'PARTIALLY_PAID',
    Paid: 'PAID',
    Cancelled: 'CANCELLED',
    Overdue: 'OVERDUE'
} as const;

export type SuperBillSuperBillStatusEnum = typeof SuperBillSuperBillStatusEnum[keyof typeof SuperBillSuperBillStatusEnum];
export const SuperBillSourceTypeEnum = {
    Visit: 'VISIT',
    EraEob: 'ERA_EOB'
} as const;

export type SuperBillSourceTypeEnum = typeof SuperBillSourceTypeEnum[keyof typeof SuperBillSourceTypeEnum];

/**
 * 
 * @export
 * @interface SuperBillBulk
 */
export interface SuperBillBulk {
    /**
     * 
     * @type {string}
     * @memberof SuperBillBulk
     */
    'superBillId'?: string;
    /**
     * 
     * @type {number}
     * @memberof SuperBillBulk
     */
    'prevPaid'?: number;
    /**
     * 
     * @type {number}
     * @memberof SuperBillBulk
     */
    'patientBalance'?: number;
    /**
     * 
     * @type {number}
     * @memberof SuperBillBulk
     */
    'total'?: number;
    /**
     * 
     * @type {string}
     * @memberof SuperBillBulk
     */
    'superBillStatus'?: SuperBillBulkSuperBillStatusEnum;
}

export const SuperBillBulkSuperBillStatusEnum = {
    ReadyForClaim: 'READY_FOR_CLAIM',
    Draft: 'DRAFT',
    Pending: 'PENDING',
    PartiallyPaid: 'PARTIALLY_PAID',
    Paid: 'PAID',
    Cancelled: 'CANCELLED',
    Overdue: 'OVERDUE'
} as const;

export type SuperBillBulkSuperBillStatusEnum = typeof SuperBillBulkSuperBillStatusEnum[keyof typeof SuperBillBulkSuperBillStatusEnum];

/**
 * 
 * @export
 * @interface SurgicalHistory
 */
export interface SurgicalHistory {
    /**
     * 
     * @type {string}
     * @memberof SurgicalHistory
     */
    'uuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof SurgicalHistory
     */
    'surgeryName'?: string;
    /**
     * 
     * @type {string}
     * @memberof SurgicalHistory
     */
    'note'?: string;
    /**
     * 
     * @type {string}
     * @memberof SurgicalHistory
     */
    'surgeryDate'?: string;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof SurgicalHistory
     */
    'patient': { [key: string]: string; };
    /**
     * 
     * @type {boolean}
     * @memberof SurgicalHistory
     */
    'active'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SurgicalHistory
     */
    'archive'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof SurgicalHistory
     */
    'recordedDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof SurgicalHistory
     */
    'appointmentId'?: string;
    /**
     * 
     * @type {string}
     * @memberof SurgicalHistory
     */
    'providerStatus'?: SurgicalHistoryProviderStatusEnum;
}

export const SurgicalHistoryProviderStatusEnum = {
    Pending: 'PENDING',
    Confirmed: 'CONFIRMED'
} as const;

export type SurgicalHistoryProviderStatusEnum = typeof SurgicalHistoryProviderStatusEnum[keyof typeof SurgicalHistoryProviderStatusEnum];

/**
 * 
 * @export
 * @interface SurgicalHistoryIntakeForm
 */
export interface SurgicalHistoryIntakeForm {
    /**
     * 
     * @type {string}
     * @memberof SurgicalHistoryIntakeForm
     */
    'type'?: string;
    /**
     * 
     * @type {string}
     * @memberof SurgicalHistoryIntakeForm
     */
    'date'?: string;
    /**
     * 
     * @type {string}
     * @memberof SurgicalHistoryIntakeForm
     */
    'doctor'?: string;
    /**
     * 
     * @type {string}
     * @memberof SurgicalHistoryIntakeForm
     */
    'location'?: string;
}
/**
 * 
 * @export
 * @interface Task
 */
export interface Task {
    /**
     * 
     * @type {string}
     * @memberof Task
     */
    'uuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof Task
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof Task
     */
    'description'?: string;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof Task
     */
    'patient'?: { [key: string]: string; };
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof Task
     */
    'actions'?: { [key: string]: string; };
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof Task
     */
    'assignTo'?: { [key: string]: string; };
    /**
     * 
     * @type {string}
     * @memberof Task
     */
    'dueDate': string;
    /**
     * 
     * @type {string}
     * @memberof Task
     */
    'flag'?: TaskFlagEnum;
    /**
     * 
     * @type {string}
     * @memberof Task
     */
    'priority': TaskPriorityEnum;
    /**
     * 
     * @type {boolean}
     * @memberof Task
     */
    'archive'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Task
     */
    'active'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Task
     */
    'resolved'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof Task
     */
    'createdDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof Task
     */
    'createdBy'?: string;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof Task
     */
    'assignBy'?: { [key: string]: string; };
    /**
     * 
     * @type {boolean}
     * @memberof Task
     */
    'providerTask'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Task
     */
    'myTask'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Task
     */
    'toDoTask'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Task
     */
    'isRecurring'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof Task
     */
    'recurringType'?: TaskRecurringTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof Task
     */
    'recurringFrequency'?: string;
    /**
     * 
     * @type {string}
     * @memberof Task
     */
    'endDate'?: string;
    /**
     * 
     * @type {number}
     * @memberof Task
     */
    'endAfter'?: number;
    /**
     * 
     * @type {string}
     * @memberof Task
     */
    'taskStatus'?: TaskTaskStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof Task
     */
    'repeatEvery'?: string;
    /**
     * 
     * @type {string}
     * @memberof Task
     */
    'repeatOn'?: TaskRepeatOnEnum;
    /**
     * 
     * @type {string}
     * @memberof Task
     */
    'resolvedDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof Task
     */
    'resolvedBy'?: string;
    /**
     * 
     * @type {string}
     * @memberof Task
     */
    'scheduleTime'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Task
     */
    'isScheduled'?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof Task
     */
    'reminderMedium'?: Array<TaskReminderMediumEnum>;
    /**
     * 
     * @type {Reminder}
     * @memberof Task
     */
    'reminders'?: Reminder;
    /**
     * 
     * @type {string}
     * @memberof Task
     */
    'customFrequency'?: string;
    /**
     * 
     * @type {string}
     * @memberof Task
     */
    'customFrequencyUnit'?: string;
    /**
     * 
     * @type {string}
     * @memberof Task
     */
    'flagStatus'?: TaskFlagStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof Task
     */
    'reviewedStatus'?: TaskReviewedStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof Task
     */
    'reviewedNote'?: string;
    /**
     * 
     * @type {string}
     * @memberof Task
     */
    'reviewedDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof Task
     */
    'attachment'?: string;
    /**
     * 
     * @type {string}
     * @memberof Task
     */
    'appointmentId'?: string;
    /**
     * 
     * @type {string}
     * @memberof Task
     */
    'assessmentId'?: string;
}

export const TaskFlagEnum = {
    Pending: 'PENDING',
    Completed: 'COMPLETED',
    Overdue: 'OVERDUE',
    Acknowledged: 'ACKNOWLEDGED'
} as const;

export type TaskFlagEnum = typeof TaskFlagEnum[keyof typeof TaskFlagEnum];
export const TaskPriorityEnum = {
    High: 'HIGH',
    Low: 'LOW',
    Medium: 'MEDIUM'
} as const;

export type TaskPriorityEnum = typeof TaskPriorityEnum[keyof typeof TaskPriorityEnum];
export const TaskRecurringTypeEnum = {
    Daily: 'DAILY',
    Weekly: 'WEEKLY',
    Custom: 'CUSTOM',
    Monthly: 'MONTHLY'
} as const;

export type TaskRecurringTypeEnum = typeof TaskRecurringTypeEnum[keyof typeof TaskRecurringTypeEnum];
export const TaskTaskStatusEnum = {
    Resolved: 'RESOLVED',
    ToDo: 'TO_DO',
    Overdue: 'OVERDUE'
} as const;

export type TaskTaskStatusEnum = typeof TaskTaskStatusEnum[keyof typeof TaskTaskStatusEnum];
export const TaskRepeatOnEnum = {
    Weekly: 'WEEKLY',
    Daily: 'DAILY',
    Monthly: 'MONTHLY'
} as const;

export type TaskRepeatOnEnum = typeof TaskRepeatOnEnum[keyof typeof TaskRepeatOnEnum];
export const TaskReminderMediumEnum = {
    Email: 'EMAIL',
    PushNotification: 'PUSH_NOTIFICATION',
    Sms: 'SMS'
} as const;

export type TaskReminderMediumEnum = typeof TaskReminderMediumEnum[keyof typeof TaskReminderMediumEnum];
export const TaskFlagStatusEnum = {
    None: 'NONE',
    Red: 'RED',
    Green: 'GREEN',
    Orange: 'ORANGE'
} as const;

export type TaskFlagStatusEnum = typeof TaskFlagStatusEnum[keyof typeof TaskFlagStatusEnum];
export const TaskReviewedStatusEnum = {
    Pending: 'PENDING',
    Reviewed: 'REVIEWED'
} as const;

export type TaskReviewedStatusEnum = typeof TaskReviewedStatusEnum[keyof typeof TaskReviewedStatusEnum];

/**
 * 
 * @export
 * @interface TaskReviewed
 */
export interface TaskReviewed {
    /**
     * 
     * @type {string}
     * @memberof TaskReviewed
     */
    'taskUuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof TaskReviewed
     */
    'reviewedStatus'?: TaskReviewedReviewedStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof TaskReviewed
     */
    'reviewedNote'?: string;
    /**
     * 
     * @type {string}
     * @memberof TaskReviewed
     */
    'reviewedDate'?: string;
}

export const TaskReviewedReviewedStatusEnum = {
    Pending: 'PENDING',
    Reviewed: 'REVIEWED'
} as const;

export type TaskReviewedReviewedStatusEnum = typeof TaskReviewedReviewedStatusEnum[keyof typeof TaskReviewedReviewedStatusEnum];

/**
 * 
 * @export
 * @interface TaskTitle
 */
export interface TaskTitle {
    /**
     * 
     * @type {string}
     * @memberof TaskTitle
     */
    'uuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof TaskTitle
     */
    'name'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof TaskTitle
     */
    'active'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TaskTitle
     */
    'archive'?: boolean;
}
/**
 * 
 * @export
 * @interface TaskType
 */
export interface TaskType {
    /**
     * 
     * @type {string}
     * @memberof TaskType
     */
    'uuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof TaskType
     */
    'title': string;
    /**
     * 
     * @type {boolean}
     * @memberof TaskType
     */
    'active'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TaskType
     */
    'archive'?: boolean;
}
/**
 * 
 * @export
 * @interface TenantConfiguration
 */
export interface TenantConfiguration {
    /**
     * 
     * @type {string}
     * @memberof TenantConfiguration
     */
    'uuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof TenantConfiguration
     */
    'timeZone'?: TenantConfigurationTimeZoneEnum;
    /**
     * 
     * @type {string}
     * @memberof TenantConfiguration
     */
    'senderEmail'?: string;
    /**
     * 
     * @type {string}
     * @memberof TenantConfiguration
     */
    'callerId'?: string;
    /**
     * 
     * @type {string}
     * @memberof TenantConfiguration
     */
    'hostName'?: string;
    /**
     * 
     * @type {string}
     * @memberof TenantConfiguration
     */
    'userName'?: string;
    /**
     * 
     * @type {string}
     * @memberof TenantConfiguration
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof TenantConfiguration
     */
    'verificationEmail'?: string;
    /**
     * 
     * @type {string}
     * @memberof TenantConfiguration
     */
    'password'?: string;
    /**
     * 
     * @type {string}
     * @memberof TenantConfiguration
     */
    'port'?: string;
    /**
     * 
     * @type {string}
     * @memberof TenantConfiguration
     */
    'protocol'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof TenantConfiguration
     */
    'providerEmailCommunication'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TenantConfiguration
     */
    'patientEmailCommunication'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TenantConfiguration
     */
    'providerSmsCommunication'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TenantConfiguration
     */
    'patientSmsCommunication'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TenantConfiguration
     */
    'providerPushNotificationCommunication'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TenantConfiguration
     */
    'patientPushNotificationCommunication'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof TenantConfiguration
     */
    'invoiceReminderDuration'?: TenantConfigurationInvoiceReminderDurationEnum;
    /**
     * 
     * @type {boolean}
     * @memberof TenantConfiguration
     */
    'archive'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TenantConfiguration
     */
    'active'?: boolean;
}

export const TenantConfigurationTimeZoneEnum = {
    Pst: 'PST',
    Est: 'EST',
    Cst: 'CST',
    Mst: 'MST',
    Ast: 'AST',
    Hst: 'HST',
    Edt: 'EDT',
    Pdt: 'PDT',
    Cdt: 'CDT',
    Adt: 'ADT',
    Mdt: 'MDT',
    Ist: 'IST',
    Akdt: 'AKDT',
    Akst: 'AKST',
    Gmt: 'GMT',
    Utc: 'UTC',
    Wet: 'WET',
    West: 'WEST',
    Cet: 'CET',
    Cest: 'CEST',
    Eet: 'EET',
    Eest: 'EEST',
    Msk: 'MSK',
    Msd: 'MSD',
    Aest: 'AEST',
    Aedt: 'AEDT',
    Acst: 'ACST',
    Acdt: 'ACDT',
    Awst: 'AWST',
    Nzst: 'NZST',
    Nzdt: 'NZDT',
    Sgt: 'SGT',
    Hkt: 'HKT',
    Jst: 'JST',
    Kst: 'KST',
    CstChina: 'CST_CHINA',
    Bdt: 'BDT',
    Pkt: 'PKT',
    IstIran: 'IST_IRAN',
    Trt: 'TRT',
    Idt: 'IDT',
    Wat: 'WAT',
    Cat: 'CAT',
    Eat: 'EAT',
    Art: 'ART',
    Bot: 'BOT',
    Clt: 'CLT',
    Clst: 'CLST',
    Srt: 'SRT',
    Gft: 'GFT',
    Uyt: 'UYT',
    Uyst: 'UYST',
    Vet: 'VET',
    Samt: 'SAMT',
    Yekt: 'YEKT',
    Irkt: 'IRKT',
    Krat: 'KRAT',
    Magt: 'MAGT',
    Pett: 'PETT',
    Vlat: 'VLAT',
    Chot: 'CHOT',
    Ulat: 'ULAT',
    Tmt: 'TMT',
    Orat: 'ORAT',
    Almt: 'ALMT',
    Azt: 'AZT',
    Get: 'GET',
    Mut: 'MUT',
    Sct: 'SCT',
    Ret: 'RET',
    Mvt: 'MVT',
    Cct: 'CCT',
    Sast: 'SAST',
    Nst: 'NST',
    Ndt: 'NDT'
} as const;

export type TenantConfigurationTimeZoneEnum = typeof TenantConfigurationTimeZoneEnum[keyof typeof TenantConfigurationTimeZoneEnum];
export const TenantConfigurationInvoiceReminderDurationEnum = {
    Days7: 'DAYS_7',
    Days15: 'DAYS_15',
    Months1: 'MONTHS_1',
    Months2: 'MONTHS_2',
    Months3: 'MONTHS_3'
} as const;

export type TenantConfigurationInvoiceReminderDurationEnum = typeof TenantConfigurationInvoiceReminderDurationEnum[keyof typeof TenantConfigurationInvoiceReminderDurationEnum];

/**
 * 
 * @export
 * @interface TherapyNote
 */
export interface TherapyNote {
    /**
     * 
     * @type {string}
     * @memberof TherapyNote
     */
    'uuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof TherapyNote
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof TherapyNote
     */
    'description'?: string;
}
/**
 * 
 * @export
 * @interface TicketAttachmentRequest
 */
export interface TicketAttachmentRequest {
    /**
     * 
     * @type {string}
     * @memberof TicketAttachmentRequest
     */
    'extension'?: string;
    /**
     * 
     * @type {string}
     * @memberof TicketAttachmentRequest
     */
    'attachment'?: string;
}
/**
 * 
 * @export
 * @interface TicketCreateRequest
 */
export interface TicketCreateRequest {
    /**
     * 
     * @type {string}
     * @memberof TicketCreateRequest
     */
    'ticketType'?: TicketCreateRequestTicketTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof TicketCreateRequest
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof TicketCreateRequest
     */
    'phone'?: string;
    /**
     * 
     * @type {string}
     * @memberof TicketCreateRequest
     */
    'question'?: string;
    /**
     * 
     * @type {string}
     * @memberof TicketCreateRequest
     */
    'questionDetails'?: string;
    /**
     * 
     * @type {string}
     * @memberof TicketCreateRequest
     */
    'status'?: TicketCreateRequestStatusEnum;
    /**
     * 
     * @type {Array<TicketAttachmentRequest>}
     * @memberof TicketCreateRequest
     */
    'attachments'?: Array<TicketAttachmentRequest>;
}

export const TicketCreateRequestTicketTypeEnum = {
    Ticket: 'TICKET',
    Email: 'EMAIL',
    CallRequest: 'CALL_REQUEST',
    TechnicalSupport: 'TECHNICAL_SUPPORT',
    CustomerSupport: 'CUSTOMER_SUPPORT'
} as const;

export type TicketCreateRequestTicketTypeEnum = typeof TicketCreateRequestTicketTypeEnum[keyof typeof TicketCreateRequestTicketTypeEnum];
export const TicketCreateRequestStatusEnum = {
    New: 'NEW',
    InProgress: 'IN_PROGRESS',
    Resolved: 'RESOLVED',
    Invalid: 'INVALID',
    Hold: 'HOLD'
} as const;

export type TicketCreateRequestStatusEnum = typeof TicketCreateRequestStatusEnum[keyof typeof TicketCreateRequestStatusEnum];

/**
 * 
 * @export
 * @interface TranscriptionSegmentDTO
 */
export interface TranscriptionSegmentDTO {
    /**
     * 
     * @type {number}
     * @memberof TranscriptionSegmentDTO
     */
    'start'?: number;
    /**
     * 
     * @type {number}
     * @memberof TranscriptionSegmentDTO
     */
    'end'?: number;
    /**
     * 
     * @type {string}
     * @memberof TranscriptionSegmentDTO
     */
    'text'?: string;
}
/**
 * 
 * @export
 * @interface TranscriptionSegmentRequest
 */
export interface TranscriptionSegmentRequest {
    /**
     * 
     * @type {string}
     * @memberof TranscriptionSegmentRequest
     */
    'transcription'?: string;
    /**
     * 
     * @type {string}
     * @memberof TranscriptionSegmentRequest
     */
    'start'?: string;
}
/**
 * 
 * @export
 * @interface TwilioCallerId
 */
export interface TwilioCallerId {
    /**
     * 
     * @type {string}
     * @memberof TwilioCallerId
     */
    'caller_id'?: string;
}
/**
 * 
 * @export
 * @interface UpdateClaimWithAckRequest
 */
export interface UpdateClaimWithAckRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateClaimWithAckRequest
     */
    'claimUuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateClaimWithAckRequest
     */
    'fileName'?: string;
    /**
     * 
     * @type {Set<string>}
     * @memberof UpdateClaimWithAckRequest
     */
    'successMessageSet'?: Set<string>;
    /**
     * 
     * @type {Set<string>}
     * @memberof UpdateClaimWithAckRequest
     */
    'errorMessageSet'?: Set<string>;
}
/**
 * 
 * @export
 * @interface UpdatePatientDto
 */
export interface UpdatePatientDto {
    /**
     * 
     * @type {string}
     * @memberof UpdatePatientDto
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdatePatientDto
     */
    'first_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdatePatientDto
     */
    'last_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdatePatientDto
     */
    'date_of_birth'?: string;
}
/**
 * 
 * @export
 * @interface UpdateReferral
 */
export interface UpdateReferral {
    /**
     * 
     * @type {string}
     * @memberof UpdateReferral
     */
    'referralId'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateReferral
     */
    'referralStatus'?: UpdateReferralReferralStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof UpdateReferral
     */
    'description'?: string;
}

export const UpdateReferralReferralStatusEnum = {
    Pending: 'PENDING',
    Closed: 'CLOSED',
    Sent: 'SENT',
    Accepted: 'ACCEPTED',
    Completed: 'COMPLETED',
    Scheduled: 'SCHEDULED',
    Rejected: 'REJECTED'
} as const;

export type UpdateReferralReferralStatusEnum = typeof UpdateReferralReferralStatusEnum[keyof typeof UpdateReferralReferralStatusEnum];

/**
 * 
 * @export
 * @interface UploadDocumentPatientRequest
 */
export interface UploadDocumentPatientRequest {
    /**
     * 
     * @type {File}
     * @memberof UploadDocumentPatientRequest
     */
    'fileFrontSide': File;
    /**
     * 
     * @type {File}
     * @memberof UploadDocumentPatientRequest
     */
    'fileBackSide': File;
}
/**
 * 
 * @export
 * @interface UploadDocumentProviderRequest
 */
export interface UploadDocumentProviderRequest {
    /**
     * 
     * @type {File}
     * @memberof UploadDocumentProviderRequest
     */
    'fileFrontSide': File;
    /**
     * 
     * @type {File}
     * @memberof UploadDocumentProviderRequest
     */
    'fileBackSide'?: File;
}
/**
 * 
 * @export
 * @interface User
 */
export interface User {
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'uuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'iamId'?: string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'firstName': string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'lastName': string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'phone'?: string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'avatar'?: string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'roleType'?: UserRoleTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'roleTypeSting'?: string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'role': string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'birthDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'lastLogin'?: string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'gender': UserGenderEnum;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof User
     */
    'workLocations'?: { [key: string]: string; };
    /**
     * 
     * @type {boolean}
     * @memberof User
     */
    'active'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof User
     */
    'archive'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof User
     */
    'emailVerified'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof User
     */
    'phoneVerified'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'password'?: string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'tenantKey'?: string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'middleName'?: string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'loginUrl'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof User
     */
    'phoneNotAvailable'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof User
     */
    'emailNotAvailable'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'temporaryEmail'?: string;
}

export const UserRoleTypeEnum = {
    Provider: 'PROVIDER',
    Staff: 'STAFF',
    Patient: 'PATIENT',
    Admin: 'ADMIN',
    Physician: 'PHYSICIAN',
    BillingAdmin: 'BILLING_ADMIN',
    Biller: 'BILLER',
    FrontDeskStaff: 'FRONT_DESK_STAFF',
    SalesCoordinator: 'SALES_COORDINATOR',
    Support: 'SUPPORT',
    PracticeAdmin: 'PRACTICE_ADMIN',
    CareManager: 'CARE_MANAGER'
} as const;

export type UserRoleTypeEnum = typeof UserRoleTypeEnum[keyof typeof UserRoleTypeEnum];
export const UserGenderEnum = {
    Male: 'MALE',
    Female: 'FEMALE',
    Unknown: 'UNKNOWN',
    Other: 'OTHER'
} as const;

export type UserGenderEnum = typeof UserGenderEnum[keyof typeof UserGenderEnum];

/**
 * 
 * @export
 * @interface Vaccine
 */
export interface Vaccine {
    /**
     * 
     * @type {string}
     * @memberof Vaccine
     */
    'uuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof Vaccine
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof Vaccine
     */
    'number'?: string;
}
/**
 * 
 * @export
 * @interface Verify2FARequest
 */
export interface Verify2FARequest {
    /**
     * 
     * @type {string}
     * @memberof Verify2FARequest
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof Verify2FARequest
     */
    'code': string;
    /**
     * 
     * @type {boolean}
     * @memberof Verify2FARequest
     */
    'login'?: boolean;
}
/**
 * 
 * @export
 * @interface VisitNoteTemplate
 */
export interface VisitNoteTemplate {
    /**
     * 
     * @type {string}
     * @memberof VisitNoteTemplate
     */
    'uuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof VisitNoteTemplate
     */
    'templateName'?: string;
    /**
     * 
     * @type {string}
     * @memberof VisitNoteTemplate
     */
    'followUp'?: string;
    /**
     * 
     * @type {string}
     * @memberof VisitNoteTemplate
     */
    'instruction'?: string;
    /**
     * 
     * @type {string}
     * @memberof VisitNoteTemplate
     */
    'hpi'?: string;
    /**
     * 
     * @type {string}
     * @memberof VisitNoteTemplate
     */
    'problems'?: string;
    /**
     * 
     * @type {string}
     * @memberof VisitNoteTemplate
     */
    'habits'?: string;
    /**
     * 
     * @type {string}
     * @memberof VisitNoteTemplate
     */
    'assessmentFreeNote'?: string;
    /**
     * 
     * @type {string}
     * @memberof VisitNoteTemplate
     */
    'planFreeNote'?: string;
    /**
     * 
     * @type {string}
     * @memberof VisitNoteTemplate
     */
    'subjectiveFreeNote'?: string;
    /**
     * 
     * @type {string}
     * @memberof VisitNoteTemplate
     */
    'objectiveFreeNote'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof VisitNoteTemplate
     */
    'archive'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof VisitNoteTemplate
     */
    'templateType'?: VisitNoteTemplateTemplateTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof VisitNoteTemplate
     */
    'allergyFreeText'?: string;
    /**
     * 
     * @type {string}
     * @memberof VisitNoteTemplate
     */
    'createdAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof VisitNoteTemplate
     */
    'userName'?: string;
    /**
     * 
     * @type {string}
     * @memberof VisitNoteTemplate
     */
    'historyOfPresentIllness'?: string;
    /**
     * 
     * @type {string}
     * @memberof VisitNoteTemplate
     */
    'presentingProblem'?: string;
    /**
     * 
     * @type {string}
     * @memberof VisitNoteTemplate
     */
    'treatmentStrategy'?: string;
    /**
     * 
     * @type {string}
     * @memberof VisitNoteTemplate
     */
    'estimateCompletionOfTreatmentGoal'?: string;
    /**
     * 
     * @type {string}
     * @memberof VisitNoteTemplate
     */
    'frequencyOfTreatment'?: string;
    /**
     * 
     * @type {string}
     * @memberof VisitNoteTemplate
     */
    'estimateCompletionOfTreatmentStrategy'?: string;
}

export const VisitNoteTemplateTemplateTypeEnum = {
    SimpleSoapNote: 'SIMPLE_SOAP_NOTE',
    PsychiatricNote: 'PSYCHIATRIC_NOTE',
    PrimaryCareSoapNote: 'PRIMARY_CARE_SOAP_NOTE',
    FreeSoapNote: 'FREE_SOAP_NOTE',
    TreatmentPlan: 'TREATMENT_PLAN',
    PsychiatricProgress: 'PSYCHIATRIC_PROGRESS',
    InitialPsychotherapy: 'INITIAL_PSYCHOTHERAPY',
    PsychiatricInitialVisitNote: 'PSYCHIATRIC_INITIAL_VISIT_NOTE',
    PreoperativeNote: 'PREOPERATIVE_NOTE',
    CollaborativeCareModel: 'COLLABORATIVE_CARE_MODEL'
} as const;

export type VisitNoteTemplateTemplateTypeEnum = typeof VisitNoteTemplateTemplateTypeEnum[keyof typeof VisitNoteTemplateTemplateTypeEnum];

/**
 * 
 * @export
 * @interface WidgetAppointment
 */
export interface WidgetAppointment {
    /**
     * 
     * @type {string}
     * @memberof WidgetAppointment
     */
    'patientId': string;
    /**
     * 
     * @type {string}
     * @memberof WidgetAppointment
     */
    'providerId': string;
    /**
     * 
     * @type {string}
     * @memberof WidgetAppointment
     */
    'chiefComplaint': string;
    /**
     * 
     * @type {string}
     * @memberof WidgetAppointment
     */
    'startTime': string;
    /**
     * 
     * @type {string}
     * @memberof WidgetAppointment
     */
    'endTime': string;
    /**
     * 
     * @type {string}
     * @memberof WidgetAppointment
     */
    'paymentType'?: WidgetAppointmentPaymentTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof WidgetAppointment
     */
    'appointmentTypeId'?: string;
    /**
     * 
     * @type {string}
     * @memberof WidgetAppointment
     */
    'mode'?: WidgetAppointmentModeEnum;
    /**
     * 
     * @type {string}
     * @memberof WidgetAppointment
     */
    'locationId'?: string;
    /**
     * 
     * @type {string}
     * @memberof WidgetAppointment
     */
    'timezone'?: WidgetAppointmentTimezoneEnum;
    /**
     * 
     * @type {string}
     * @memberof WidgetAppointment
     */
    'customForms'?: string;
}

export const WidgetAppointmentPaymentTypeEnum = {
    Cash: 'CASH',
    Card: 'CARD',
    Bank: 'BANK',
    Insurance: 'INSURANCE',
    Online: 'ONLINE'
} as const;

export type WidgetAppointmentPaymentTypeEnum = typeof WidgetAppointmentPaymentTypeEnum[keyof typeof WidgetAppointmentPaymentTypeEnum];
export const WidgetAppointmentModeEnum = {
    InPerson: 'IN_PERSON',
    Virtual: 'VIRTUAL'
} as const;

export type WidgetAppointmentModeEnum = typeof WidgetAppointmentModeEnum[keyof typeof WidgetAppointmentModeEnum];
export const WidgetAppointmentTimezoneEnum = {
    Pst: 'PST',
    Est: 'EST',
    Cst: 'CST',
    Mst: 'MST',
    Ast: 'AST',
    Hst: 'HST',
    Edt: 'EDT',
    Pdt: 'PDT',
    Cdt: 'CDT',
    Adt: 'ADT',
    Mdt: 'MDT',
    Ist: 'IST',
    Akdt: 'AKDT',
    Akst: 'AKST',
    Gmt: 'GMT',
    Utc: 'UTC',
    Wet: 'WET',
    West: 'WEST',
    Cet: 'CET',
    Cest: 'CEST',
    Eet: 'EET',
    Eest: 'EEST',
    Msk: 'MSK',
    Msd: 'MSD',
    Aest: 'AEST',
    Aedt: 'AEDT',
    Acst: 'ACST',
    Acdt: 'ACDT',
    Awst: 'AWST',
    Nzst: 'NZST',
    Nzdt: 'NZDT',
    Sgt: 'SGT',
    Hkt: 'HKT',
    Jst: 'JST',
    Kst: 'KST',
    CstChina: 'CST_CHINA',
    Bdt: 'BDT',
    Pkt: 'PKT',
    IstIran: 'IST_IRAN',
    Trt: 'TRT',
    Idt: 'IDT',
    Wat: 'WAT',
    Cat: 'CAT',
    Eat: 'EAT',
    Art: 'ART',
    Bot: 'BOT',
    Clt: 'CLT',
    Clst: 'CLST',
    Srt: 'SRT',
    Gft: 'GFT',
    Uyt: 'UYT',
    Uyst: 'UYST',
    Vet: 'VET',
    Samt: 'SAMT',
    Yekt: 'YEKT',
    Irkt: 'IRKT',
    Krat: 'KRAT',
    Magt: 'MAGT',
    Pett: 'PETT',
    Vlat: 'VLAT',
    Chot: 'CHOT',
    Ulat: 'ULAT',
    Tmt: 'TMT',
    Orat: 'ORAT',
    Almt: 'ALMT',
    Azt: 'AZT',
    Get: 'GET',
    Mut: 'MUT',
    Sct: 'SCT',
    Ret: 'RET',
    Mvt: 'MVT',
    Cct: 'CCT',
    Sast: 'SAST',
    Nst: 'NST',
    Ndt: 'NDT'
} as const;

export type WidgetAppointmentTimezoneEnum = typeof WidgetAppointmentTimezoneEnum[keyof typeof WidgetAppointmentTimezoneEnum];

/**
 * 
 * @export
 * @interface WidgetPatient
 */
export interface WidgetPatient {
    /**
     * 
     * @type {string}
     * @memberof WidgetPatient
     */
    'firstName': string;
    /**
     * 
     * @type {string}
     * @memberof WidgetPatient
     */
    'lastName': string;
    /**
     * 
     * @type {string}
     * @memberof WidgetPatient
     */
    'birthDate': string;
    /**
     * 
     * @type {string}
     * @memberof WidgetPatient
     */
    'gender': WidgetPatientGenderEnum;
    /**
     * 
     * @type {string}
     * @memberof WidgetPatient
     */
    'mobileNumber'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof WidgetPatient
     */
    'phoneNotAvailable'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof WidgetPatient
     */
    'email'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof WidgetPatient
     */
    'emailNotAvailable'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof WidgetPatient
     */
    'timezone'?: WidgetPatientTimezoneEnum;
}

export const WidgetPatientGenderEnum = {
    Male: 'MALE',
    Female: 'FEMALE',
    Unknown: 'UNKNOWN',
    Other: 'OTHER'
} as const;

export type WidgetPatientGenderEnum = typeof WidgetPatientGenderEnum[keyof typeof WidgetPatientGenderEnum];
export const WidgetPatientTimezoneEnum = {
    Pst: 'PST',
    Est: 'EST',
    Cst: 'CST',
    Mst: 'MST',
    Ast: 'AST',
    Hst: 'HST',
    Edt: 'EDT',
    Pdt: 'PDT',
    Cdt: 'CDT',
    Adt: 'ADT',
    Mdt: 'MDT',
    Ist: 'IST',
    Akdt: 'AKDT',
    Akst: 'AKST',
    Gmt: 'GMT',
    Utc: 'UTC',
    Wet: 'WET',
    West: 'WEST',
    Cet: 'CET',
    Cest: 'CEST',
    Eet: 'EET',
    Eest: 'EEST',
    Msk: 'MSK',
    Msd: 'MSD',
    Aest: 'AEST',
    Aedt: 'AEDT',
    Acst: 'ACST',
    Acdt: 'ACDT',
    Awst: 'AWST',
    Nzst: 'NZST',
    Nzdt: 'NZDT',
    Sgt: 'SGT',
    Hkt: 'HKT',
    Jst: 'JST',
    Kst: 'KST',
    CstChina: 'CST_CHINA',
    Bdt: 'BDT',
    Pkt: 'PKT',
    IstIran: 'IST_IRAN',
    Trt: 'TRT',
    Idt: 'IDT',
    Wat: 'WAT',
    Cat: 'CAT',
    Eat: 'EAT',
    Art: 'ART',
    Bot: 'BOT',
    Clt: 'CLT',
    Clst: 'CLST',
    Srt: 'SRT',
    Gft: 'GFT',
    Uyt: 'UYT',
    Uyst: 'UYST',
    Vet: 'VET',
    Samt: 'SAMT',
    Yekt: 'YEKT',
    Irkt: 'IRKT',
    Krat: 'KRAT',
    Magt: 'MAGT',
    Pett: 'PETT',
    Vlat: 'VLAT',
    Chot: 'CHOT',
    Ulat: 'ULAT',
    Tmt: 'TMT',
    Orat: 'ORAT',
    Almt: 'ALMT',
    Azt: 'AZT',
    Get: 'GET',
    Mut: 'MUT',
    Sct: 'SCT',
    Ret: 'RET',
    Mvt: 'MVT',
    Cct: 'CCT',
    Sast: 'SAST',
    Nst: 'NST',
    Ndt: 'NDT'
} as const;

export type WidgetPatientTimezoneEnum = typeof WidgetPatientTimezoneEnum[keyof typeof WidgetPatientTimezoneEnum];


/**
 * AccountReceivableControllerApi - axios parameter creator
 * @export
 */
export const AccountReceivableControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Aggregated A/R totals bucketed by aging period (0-30, 31-60, 61-90, 91-120, 121+ days) plus a final total row. Each bucket returns patient, insurance, and combined total amounts.
         * @summary Account Receivable Summary
         * @param {GetAccountReceivableSummaryDateRangeEnum} [dateRange] 
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccountReceivableSummary: async (dateRange?: GetAccountReceivableSummaryDateRangeEnum, startDate?: string, endDate?: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/master/account-receivable/summary`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (dateRange !== undefined) {
                localVarQueryParameter['dateRange'] = dateRange;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString() :
                    startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString() :
                    endDate;
            }

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Aged insurance A/R report: per-payer outstanding claim balances bucketed into 0-30, 31-60, 61-90, 91-120, 120+ days, grouped by payer with payer ID and payer name.
         * @summary Insurance Account Receivable
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {string} [searchString] 
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInsuranceAccountReceivable: async (page?: number, size?: number, sortBy?: string, sortDirection?: string, searchString?: string, startDate?: string, endDate?: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/master/account-receivable/insurance`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }

            if (searchString !== undefined) {
                localVarQueryParameter['searchString'] = searchString;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString() :
                    startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString() :
                    endDate;
            }

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Aged patient A/R report: per-patient outstanding invoice balances bucketed into 0-30, 31-60, 61-90, 91-120, 120+ days.
         * @summary Patient Account Receivable
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {string} [payerType] 
         * @param {string} [searchString] 
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatientAccountReceivable: async (page?: number, size?: number, sortBy?: string, sortDirection?: string, payerType?: string, searchString?: string, startDate?: string, endDate?: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/master/account-receivable/patient`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }

            if (payerType !== undefined) {
                localVarQueryParameter['payerType'] = payerType;
            }

            if (searchString !== undefined) {
                localVarQueryParameter['searchString'] = searchString;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString() :
                    startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString() :
                    endDate;
            }

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Aged A/R totals (aggregated across all patients) bucketed into 0-30, 31-60, 61-90, 91-120, 120+ days plus a grand total, filtered by the same search/date range as the content endpoint.
         * @summary Patient Account Receivable Totals
         * @param {string} [searchString] 
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {string} [payerType] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatientAccountReceivableTotals: async (searchString?: string, startDate?: string, endDate?: string, payerType?: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/master/account-receivable/totals`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (searchString !== undefined) {
                localVarQueryParameter['searchString'] = searchString;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString() :
                    startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString() :
                    endDate;
            }

            if (payerType !== undefined) {
                localVarQueryParameter['payerType'] = payerType;
            }

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AccountReceivableControllerApi - functional programming interface
 * @export
 */
export const AccountReceivableControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AccountReceivableControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * Aggregated A/R totals bucketed by aging period (0-30, 31-60, 61-90, 91-120, 121+ days) plus a final total row. Each bucket returns patient, insurance, and combined total amounts.
         * @summary Account Receivable Summary
         * @param {GetAccountReceivableSummaryDateRangeEnum} [dateRange] 
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAccountReceivableSummary(dateRange?: GetAccountReceivableSummaryDateRangeEnum, startDate?: string, endDate?: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAccountReceivableSummary(dateRange, startDate, endDate, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccountReceivableControllerApi.getAccountReceivableSummary']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Aged insurance A/R report: per-payer outstanding claim balances bucketed into 0-30, 31-60, 61-90, 91-120, 120+ days, grouped by payer with payer ID and payer name.
         * @summary Insurance Account Receivable
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {string} [searchString] 
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getInsuranceAccountReceivable(page?: number, size?: number, sortBy?: string, sortDirection?: string, searchString?: string, startDate?: string, endDate?: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getInsuranceAccountReceivable(page, size, sortBy, sortDirection, searchString, startDate, endDate, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccountReceivableControllerApi.getInsuranceAccountReceivable']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Aged patient A/R report: per-patient outstanding invoice balances bucketed into 0-30, 31-60, 61-90, 91-120, 120+ days.
         * @summary Patient Account Receivable
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {string} [payerType] 
         * @param {string} [searchString] 
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPatientAccountReceivable(page?: number, size?: number, sortBy?: string, sortDirection?: string, payerType?: string, searchString?: string, startDate?: string, endDate?: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPatientAccountReceivable(page, size, sortBy, sortDirection, payerType, searchString, startDate, endDate, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccountReceivableControllerApi.getPatientAccountReceivable']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Aged A/R totals (aggregated across all patients) bucketed into 0-30, 31-60, 61-90, 91-120, 120+ days plus a grand total, filtered by the same search/date range as the content endpoint.
         * @summary Patient Account Receivable Totals
         * @param {string} [searchString] 
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {string} [payerType] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPatientAccountReceivableTotals(searchString?: string, startDate?: string, endDate?: string, payerType?: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPatientAccountReceivableTotals(searchString, startDate, endDate, payerType, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccountReceivableControllerApi.getPatientAccountReceivableTotals']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AccountReceivableControllerApi - factory interface
 * @export
 */
export const AccountReceivableControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AccountReceivableControllerApiFp(configuration)
    return {
        /**
         * Aggregated A/R totals bucketed by aging period (0-30, 31-60, 61-90, 91-120, 121+ days) plus a final total row. Each bucket returns patient, insurance, and combined total amounts.
         * @summary Account Receivable Summary
         * @param {GetAccountReceivableSummaryDateRangeEnum} [dateRange] 
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccountReceivableSummary(dateRange?: GetAccountReceivableSummaryDateRangeEnum, startDate?: string, endDate?: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getAccountReceivableSummary(dateRange, startDate, endDate, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Aged insurance A/R report: per-payer outstanding claim balances bucketed into 0-30, 31-60, 61-90, 91-120, 120+ days, grouped by payer with payer ID and payer name.
         * @summary Insurance Account Receivable
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {string} [searchString] 
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInsuranceAccountReceivable(page?: number, size?: number, sortBy?: string, sortDirection?: string, searchString?: string, startDate?: string, endDate?: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getInsuranceAccountReceivable(page, size, sortBy, sortDirection, searchString, startDate, endDate, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Aged patient A/R report: per-patient outstanding invoice balances bucketed into 0-30, 31-60, 61-90, 91-120, 120+ days.
         * @summary Patient Account Receivable
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {string} [payerType] 
         * @param {string} [searchString] 
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatientAccountReceivable(page?: number, size?: number, sortBy?: string, sortDirection?: string, payerType?: string, searchString?: string, startDate?: string, endDate?: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getPatientAccountReceivable(page, size, sortBy, sortDirection, payerType, searchString, startDate, endDate, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Aged A/R totals (aggregated across all patients) bucketed into 0-30, 31-60, 61-90, 91-120, 120+ days plus a grand total, filtered by the same search/date range as the content endpoint.
         * @summary Patient Account Receivable Totals
         * @param {string} [searchString] 
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {string} [payerType] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatientAccountReceivableTotals(searchString?: string, startDate?: string, endDate?: string, payerType?: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getPatientAccountReceivableTotals(searchString, startDate, endDate, payerType, xTENANTID, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AccountReceivableControllerApi - object-oriented interface
 * @export
 * @class AccountReceivableControllerApi
 * @extends {BaseAPI}
 */
export class AccountReceivableControllerApi extends BaseAPI {
    /**
     * Aggregated A/R totals bucketed by aging period (0-30, 31-60, 61-90, 91-120, 121+ days) plus a final total row. Each bucket returns patient, insurance, and combined total amounts.
     * @summary Account Receivable Summary
     * @param {GetAccountReceivableSummaryDateRangeEnum} [dateRange] 
     * @param {string} [startDate] 
     * @param {string} [endDate] 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountReceivableControllerApi
     */
    public getAccountReceivableSummary(dateRange?: GetAccountReceivableSummaryDateRangeEnum, startDate?: string, endDate?: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return AccountReceivableControllerApiFp(this.configuration).getAccountReceivableSummary(dateRange, startDate, endDate, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Aged insurance A/R report: per-payer outstanding claim balances bucketed into 0-30, 31-60, 61-90, 91-120, 120+ days, grouped by payer with payer ID and payer name.
     * @summary Insurance Account Receivable
     * @param {number} [page] 
     * @param {number} [size] 
     * @param {string} [sortBy] 
     * @param {string} [sortDirection] 
     * @param {string} [searchString] 
     * @param {string} [startDate] 
     * @param {string} [endDate] 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountReceivableControllerApi
     */
    public getInsuranceAccountReceivable(page?: number, size?: number, sortBy?: string, sortDirection?: string, searchString?: string, startDate?: string, endDate?: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return AccountReceivableControllerApiFp(this.configuration).getInsuranceAccountReceivable(page, size, sortBy, sortDirection, searchString, startDate, endDate, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Aged patient A/R report: per-patient outstanding invoice balances bucketed into 0-30, 31-60, 61-90, 91-120, 120+ days.
     * @summary Patient Account Receivable
     * @param {number} [page] 
     * @param {number} [size] 
     * @param {string} [sortBy] 
     * @param {string} [sortDirection] 
     * @param {string} [payerType] 
     * @param {string} [searchString] 
     * @param {string} [startDate] 
     * @param {string} [endDate] 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountReceivableControllerApi
     */
    public getPatientAccountReceivable(page?: number, size?: number, sortBy?: string, sortDirection?: string, payerType?: string, searchString?: string, startDate?: string, endDate?: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return AccountReceivableControllerApiFp(this.configuration).getPatientAccountReceivable(page, size, sortBy, sortDirection, payerType, searchString, startDate, endDate, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Aged A/R totals (aggregated across all patients) bucketed into 0-30, 31-60, 61-90, 91-120, 120+ days plus a grand total, filtered by the same search/date range as the content endpoint.
     * @summary Patient Account Receivable Totals
     * @param {string} [searchString] 
     * @param {string} [startDate] 
     * @param {string} [endDate] 
     * @param {string} [payerType] 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountReceivableControllerApi
     */
    public getPatientAccountReceivableTotals(searchString?: string, startDate?: string, endDate?: string, payerType?: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return AccountReceivableControllerApiFp(this.configuration).getPatientAccountReceivableTotals(searchString, startDate, endDate, payerType, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const GetAccountReceivableSummaryDateRangeEnum = {
    Last30Days: 'LAST_30_DAYS',
    Quarterly: 'QUARTERLY',
    Yearly: 'YEARLY'
} as const;
export type GetAccountReceivableSummaryDateRangeEnum = typeof GetAccountReceivableSummaryDateRangeEnum[keyof typeof GetAccountReceivableSummaryDateRangeEnum];


/**
 * AiAssistantControllerApi - axios parameter creator
 * @export
 */
export const AiAssistantControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Send a message with userId. Backend auto-saves user request and AI response with timestamps.
         * @summary AI Assistant Chat
         * @param {AiChatRequest} aiChatRequest 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        chat: async (aiChatRequest: AiChatRequest, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'aiChatRequest' is not null or undefined
            assertParamExists('chat', 'aiChatRequest', aiChatRequest)
            const localVarPath = `/api/master/ai-assistant/chat`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(aiChatRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all chat history for a user with pagination. Returns userMessage, aiResponse, requestTime, responseTime.
         * @summary Get Chat History
         * @param {string} userId 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getChatHistory: async (userId: string, page?: number, size?: number, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getChatHistory', 'userId', userId)
            const localVarPath = `/api/master/ai-assistant/history`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AiAssistantControllerApi - functional programming interface
 * @export
 */
export const AiAssistantControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AiAssistantControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * Send a message with userId. Backend auto-saves user request and AI response with timestamps.
         * @summary AI Assistant Chat
         * @param {AiChatRequest} aiChatRequest 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async chat(aiChatRequest: AiChatRequest, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.chat(aiChatRequest, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AiAssistantControllerApi.chat']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get all chat history for a user with pagination. Returns userMessage, aiResponse, requestTime, responseTime.
         * @summary Get Chat History
         * @param {string} userId 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getChatHistory(userId: string, page?: number, size?: number, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getChatHistory(userId, page, size, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AiAssistantControllerApi.getChatHistory']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AiAssistantControllerApi - factory interface
 * @export
 */
export const AiAssistantControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AiAssistantControllerApiFp(configuration)
    return {
        /**
         * Send a message with userId. Backend auto-saves user request and AI response with timestamps.
         * @summary AI Assistant Chat
         * @param {AiChatRequest} aiChatRequest 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        chat(aiChatRequest: AiChatRequest, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.chat(aiChatRequest, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all chat history for a user with pagination. Returns userMessage, aiResponse, requestTime, responseTime.
         * @summary Get Chat History
         * @param {string} userId 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getChatHistory(userId: string, page?: number, size?: number, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getChatHistory(userId, page, size, xTENANTID, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AiAssistantControllerApi - object-oriented interface
 * @export
 * @class AiAssistantControllerApi
 * @extends {BaseAPI}
 */
export class AiAssistantControllerApi extends BaseAPI {
    /**
     * Send a message with userId. Backend auto-saves user request and AI response with timestamps.
     * @summary AI Assistant Chat
     * @param {AiChatRequest} aiChatRequest 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AiAssistantControllerApi
     */
    public chat(aiChatRequest: AiChatRequest, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return AiAssistantControllerApiFp(this.configuration).chat(aiChatRequest, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all chat history for a user with pagination. Returns userMessage, aiResponse, requestTime, responseTime.
     * @summary Get Chat History
     * @param {string} userId 
     * @param {number} [page] 
     * @param {number} [size] 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AiAssistantControllerApi
     */
    public getChatHistory(userId: string, page?: number, size?: number, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return AiAssistantControllerApiFp(this.configuration).getChatHistory(userId, page, size, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AllergyControllerApi - axios parameter creator
 * @export
 */
export const AllergyControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get all  Allergy list.
         * @summary Get all  Allergy.
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sort] 
         * @param {string} [searchString] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllAllergies: async (page?: number, size?: number, sortBy?: string, sort?: string, searchString?: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/master/allergy`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (searchString !== undefined) {
                localVarQueryParameter['searchString'] = searchString;
            }

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AllergyControllerApi - functional programming interface
 * @export
 */
export const AllergyControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AllergyControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * Get all  Allergy list.
         * @summary Get all  Allergy.
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sort] 
         * @param {string} [searchString] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllAllergies(page?: number, size?: number, sortBy?: string, sort?: string, searchString?: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllAllergies(page, size, sortBy, sort, searchString, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AllergyControllerApi.getAllAllergies']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AllergyControllerApi - factory interface
 * @export
 */
export const AllergyControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AllergyControllerApiFp(configuration)
    return {
        /**
         * Get all  Allergy list.
         * @summary Get all  Allergy.
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sort] 
         * @param {string} [searchString] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllAllergies(page?: number, size?: number, sortBy?: string, sort?: string, searchString?: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getAllAllergies(page, size, sortBy, sort, searchString, xTENANTID, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AllergyControllerApi - object-oriented interface
 * @export
 * @class AllergyControllerApi
 * @extends {BaseAPI}
 */
export class AllergyControllerApi extends BaseAPI {
    /**
     * Get all  Allergy list.
     * @summary Get all  Allergy.
     * @param {number} [page] 
     * @param {number} [size] 
     * @param {string} [sortBy] 
     * @param {string} [sort] 
     * @param {string} [searchString] 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AllergyControllerApi
     */
    public getAllAllergies(page?: number, size?: number, sortBy?: string, sort?: string, searchString?: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return AllergyControllerApiFp(this.configuration).getAllAllergies(page, size, sortBy, sort, searchString, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AnswerControllerApi - axios parameter creator
 * @export
 */
export const AnswerControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Add a new Answer for Questions
         * @summary Add Answer for Question
         * @param {Answer} answer 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addAnswerForQuestion: async (answer: Answer, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'answer' is not null or undefined
            assertParamExists('addAnswerForQuestion', 'answer', answer)
            const localVarPath = `/api/master/answer`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(answer, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AnswerControllerApi - functional programming interface
 * @export
 */
export const AnswerControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AnswerControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * Add a new Answer for Questions
         * @summary Add Answer for Question
         * @param {Answer} answer 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addAnswerForQuestion(answer: Answer, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addAnswerForQuestion(answer, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AnswerControllerApi.addAnswerForQuestion']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AnswerControllerApi - factory interface
 * @export
 */
export const AnswerControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AnswerControllerApiFp(configuration)
    return {
        /**
         * Add a new Answer for Questions
         * @summary Add Answer for Question
         * @param {Answer} answer 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addAnswerForQuestion(answer: Answer, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.addAnswerForQuestion(answer, xTENANTID, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AnswerControllerApi - object-oriented interface
 * @export
 * @class AnswerControllerApi
 * @extends {BaseAPI}
 */
export class AnswerControllerApi extends BaseAPI {
    /**
     * Add a new Answer for Questions
     * @summary Add Answer for Question
     * @param {Answer} answer 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AnswerControllerApi
     */
    public addAnswerForQuestion(answer: Answer, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return AnswerControllerApiFp(this.configuration).addAnswerForQuestion(answer, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AppointmentConfigurationControllerApi - axios parameter creator
 * @export
 */
export const AppointmentConfigurationControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Create a new appointment cancellation and reschedule configuration
         * @summary Create Appointment Configuration
         * @param {AppointmentConfigurationDto} appointmentConfigurationDto 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addConfiguration2: async (appointmentConfigurationDto: AppointmentConfigurationDto, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'appointmentConfigurationDto' is not null or undefined
            assertParamExists('addConfiguration2', 'appointmentConfigurationDto', appointmentConfigurationDto)
            const localVarPath = `/api/master/appointment-configuration`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(appointmentConfigurationDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all appointment configurations with pagination and archive filter
         * @summary Get All Appointment Configurations
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {boolean} [archive] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllConfigurations: async (page?: number, size?: number, sortBy?: string, sortDirection?: string, archive?: boolean, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/master/appointment-configuration`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }

            if (archive !== undefined) {
                localVarQueryParameter['archive'] = archive;
            }

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Archive or unarchive an appointment configuration
         * @summary Update Appointment Configuration Archive Status
         * @param {string} uuid 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateArchiveStatus4: async (uuid: string, status: boolean, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('updateArchiveStatus4', 'uuid', uuid)
            // verify required parameter 'status' is not null or undefined
            assertParamExists('updateArchiveStatus4', 'status', status)
            const localVarPath = `/api/master/appointment-configuration/{uuid}/archive-status/{status}`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)))
                .replace(`{${"status"}}`, encodeURIComponent(String(status)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update an existing appointment configuration
         * @summary Update Appointment Configuration
         * @param {AppointmentConfigurationDto} appointmentConfigurationDto 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateConfiguration2: async (appointmentConfigurationDto: AppointmentConfigurationDto, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'appointmentConfigurationDto' is not null or undefined
            assertParamExists('updateConfiguration2', 'appointmentConfigurationDto', appointmentConfigurationDto)
            const localVarPath = `/api/master/appointment-configuration`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(appointmentConfigurationDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AppointmentConfigurationControllerApi - functional programming interface
 * @export
 */
export const AppointmentConfigurationControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AppointmentConfigurationControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * Create a new appointment cancellation and reschedule configuration
         * @summary Create Appointment Configuration
         * @param {AppointmentConfigurationDto} appointmentConfigurationDto 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addConfiguration2(appointmentConfigurationDto: AppointmentConfigurationDto, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addConfiguration2(appointmentConfigurationDto, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AppointmentConfigurationControllerApi.addConfiguration2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get all appointment configurations with pagination and archive filter
         * @summary Get All Appointment Configurations
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {boolean} [archive] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllConfigurations(page?: number, size?: number, sortBy?: string, sortDirection?: string, archive?: boolean, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllConfigurations(page, size, sortBy, sortDirection, archive, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AppointmentConfigurationControllerApi.getAllConfigurations']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Archive or unarchive an appointment configuration
         * @summary Update Appointment Configuration Archive Status
         * @param {string} uuid 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateArchiveStatus4(uuid: string, status: boolean, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateArchiveStatus4(uuid, status, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AppointmentConfigurationControllerApi.updateArchiveStatus4']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update an existing appointment configuration
         * @summary Update Appointment Configuration
         * @param {AppointmentConfigurationDto} appointmentConfigurationDto 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateConfiguration2(appointmentConfigurationDto: AppointmentConfigurationDto, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateConfiguration2(appointmentConfigurationDto, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AppointmentConfigurationControllerApi.updateConfiguration2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AppointmentConfigurationControllerApi - factory interface
 * @export
 */
export const AppointmentConfigurationControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AppointmentConfigurationControllerApiFp(configuration)
    return {
        /**
         * Create a new appointment cancellation and reschedule configuration
         * @summary Create Appointment Configuration
         * @param {AppointmentConfigurationDto} appointmentConfigurationDto 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addConfiguration2(appointmentConfigurationDto: AppointmentConfigurationDto, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.addConfiguration2(appointmentConfigurationDto, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all appointment configurations with pagination and archive filter
         * @summary Get All Appointment Configurations
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {boolean} [archive] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllConfigurations(page?: number, size?: number, sortBy?: string, sortDirection?: string, archive?: boolean, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getAllConfigurations(page, size, sortBy, sortDirection, archive, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Archive or unarchive an appointment configuration
         * @summary Update Appointment Configuration Archive Status
         * @param {string} uuid 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateArchiveStatus4(uuid: string, status: boolean, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.updateArchiveStatus4(uuid, status, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Update an existing appointment configuration
         * @summary Update Appointment Configuration
         * @param {AppointmentConfigurationDto} appointmentConfigurationDto 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateConfiguration2(appointmentConfigurationDto: AppointmentConfigurationDto, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.updateConfiguration2(appointmentConfigurationDto, xTENANTID, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AppointmentConfigurationControllerApi - object-oriented interface
 * @export
 * @class AppointmentConfigurationControllerApi
 * @extends {BaseAPI}
 */
export class AppointmentConfigurationControllerApi extends BaseAPI {
    /**
     * Create a new appointment cancellation and reschedule configuration
     * @summary Create Appointment Configuration
     * @param {AppointmentConfigurationDto} appointmentConfigurationDto 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppointmentConfigurationControllerApi
     */
    public addConfiguration2(appointmentConfigurationDto: AppointmentConfigurationDto, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return AppointmentConfigurationControllerApiFp(this.configuration).addConfiguration2(appointmentConfigurationDto, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all appointment configurations with pagination and archive filter
     * @summary Get All Appointment Configurations
     * @param {number} [page] 
     * @param {number} [size] 
     * @param {string} [sortBy] 
     * @param {string} [sortDirection] 
     * @param {boolean} [archive] 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppointmentConfigurationControllerApi
     */
    public getAllConfigurations(page?: number, size?: number, sortBy?: string, sortDirection?: string, archive?: boolean, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return AppointmentConfigurationControllerApiFp(this.configuration).getAllConfigurations(page, size, sortBy, sortDirection, archive, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Archive or unarchive an appointment configuration
     * @summary Update Appointment Configuration Archive Status
     * @param {string} uuid 
     * @param {boolean} status 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppointmentConfigurationControllerApi
     */
    public updateArchiveStatus4(uuid: string, status: boolean, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return AppointmentConfigurationControllerApiFp(this.configuration).updateArchiveStatus4(uuid, status, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update an existing appointment configuration
     * @summary Update Appointment Configuration
     * @param {AppointmentConfigurationDto} appointmentConfigurationDto 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppointmentConfigurationControllerApi
     */
    public updateConfiguration2(appointmentConfigurationDto: AppointmentConfigurationDto, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return AppointmentConfigurationControllerApiFp(this.configuration).updateConfiguration2(appointmentConfigurationDto, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AppointmentControllerApi - axios parameter creator
 * @export
 */
export const AppointmentControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Public website-widget endpoint to book an appointment as a request. Records a PENDING appointment + PatientInquiry with source \"Website (Widget)\".
         * @summary Widget book appointment
         * @param {WidgetAppointment} widgetAppointment 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bookWidgetAppointment: async (widgetAppointment: WidgetAppointment, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'widgetAppointment' is not null or undefined
            assertParamExists('bookWidgetAppointment', 'widgetAppointment', widgetAppointment)
            const localVarPath = `/api/master/appointment/widget-appointment-book`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(widgetAppointment, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Book a appointment of patient with particular provider at particular location. When appointmentRequest is true (patient portal), returns APPOINTMENT_REQUESTEDD.
         * @summary Book appointment
         * @param {Appointment} appointment 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAppointment: async (appointment: Appointment, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'appointment' is not null or undefined
            assertParamExists('createAppointment', 'appointment', appointment)
            const localVarPath = `/api/master/appointment`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(appointment, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create instant appointment.
         * @summary Create Instant appointment
         * @param {InstantAppointment} instantAppointment 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createInstantAppointment: async (instantAppointment: InstantAppointment, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'instantAppointment' is not null or undefined
            assertParamExists('createInstantAppointment', 'instantAppointment', instantAppointment)
            const localVarPath = `/api/master/appointment/instant-appointment`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(instantAppointment, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Export selected appointments as CSV file.
         * @summary Export appointments to CSV
         * @param {Array<string>} requestBody 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportAppointmentsCsv: async (requestBody: Array<string>, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'requestBody' is not null or undefined
            assertParamExists('exportAppointmentsCsv', 'requestBody', requestBody)
            const localVarPath = `/api/master/appointment/export-csv`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get future appointment.
         * @summary Get future Appointment
         * @param {string} providerId 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        futureAppointment: async (providerId: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'providerId' is not null or undefined
            assertParamExists('futureAppointment', 'providerId', providerId)
            const localVarPath = `/api/master/appointment/future-appointment/{providerId}`
                .replace(`{${"providerId"}}`, encodeURIComponent(String(providerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all appointments with filter options on patient, provider, location.
         * @summary Get all appointments.
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {string} [patientUuid] 
         * @param {Array<string>} [providerUuid] 
         * @param {Array<string>} [locationUuid] 
         * @param {GetAllAppointmentsFilterEnum} [filter] 
         * @param {string} [appointmentType] 
         * @param {string} [appointmentMode] 
         * @param {string} [appointmentStatus] 
         * @param {string} [appStatusForPatient] 
         * @param {string} [startDate] 
         * @param {boolean} [notForBilling] 
         * @param {boolean} [superBillGenerated] 
         * @param {boolean} [archive] 
         * @param {string} [endDate] 
         * @param {string} [searchString] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllAppointments: async (page?: number, size?: number, sortBy?: string, sortDirection?: string, patientUuid?: string, providerUuid?: Array<string>, locationUuid?: Array<string>, filter?: GetAllAppointmentsFilterEnum, appointmentType?: string, appointmentMode?: string, appointmentStatus?: string, appStatusForPatient?: string, startDate?: string, notForBilling?: boolean, superBillGenerated?: boolean, archive?: boolean, endDate?: string, searchString?: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/master/appointment`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }

            if (patientUuid !== undefined) {
                localVarQueryParameter['patientUuid'] = patientUuid;
            }

            if (providerUuid) {
                localVarQueryParameter['providerUuid'] = providerUuid;
            }

            if (locationUuid) {
                localVarQueryParameter['locationUuid'] = locationUuid;
            }

            if (filter !== undefined) {
                localVarQueryParameter['filter'] = filter;
            }

            if (appointmentType !== undefined) {
                localVarQueryParameter['appointmentType'] = appointmentType;
            }

            if (appointmentMode !== undefined) {
                localVarQueryParameter['appointmentMode'] = appointmentMode;
            }

            if (appointmentStatus !== undefined) {
                localVarQueryParameter['appointmentStatus'] = appointmentStatus;
            }

            if (appStatusForPatient !== undefined) {
                localVarQueryParameter['appStatusForPatient'] = appStatusForPatient;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString() :
                    startDate;
            }

            if (notForBilling !== undefined) {
                localVarQueryParameter['notForBilling'] = notForBilling;
            }

            if (superBillGenerated !== undefined) {
                localVarQueryParameter['superBillGenerated'] = superBillGenerated;
            }

            if (archive !== undefined) {
                localVarQueryParameter['archive'] = archive;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString() :
                    endDate;
            }

            if (searchString !== undefined) {
                localVarQueryParameter['searchString'] = searchString;
            }

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all encounter with filter options on patient, provider, location
         * @summary Get all encounter.
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {Array<string>} [patientUuid] 
         * @param {Array<string>} [providerUuid] 
         * @param {string} [appointmentType] 
         * @param {string} [encounterDate] 
         * @param {string} [searchString] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllAppointments1: async (page?: number, size?: number, sortBy?: string, sortDirection?: string, patientUuid?: Array<string>, providerUuid?: Array<string>, appointmentType?: string, encounterDate?: string, searchString?: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/master/appointment/billing-encounter`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }

            if (patientUuid) {
                localVarQueryParameter['patientUuid'] = patientUuid;
            }

            if (providerUuid) {
                localVarQueryParameter['providerUuid'] = providerUuid;
            }

            if (appointmentType !== undefined) {
                localVarQueryParameter['appointmentType'] = appointmentType;
            }

            if (encounterDate !== undefined) {
                localVarQueryParameter['encounterDate'] = (encounterDate as any instanceof Date) ?
                    (encounterDate as any).toISOString() :
                    encounterDate;
            }

            if (searchString !== undefined) {
                localVarQueryParameter['searchString'] = searchString;
            }

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all appointments with filter options on patient, provider, location
         * @summary Get all appointments For Billing Encounter.
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {string} [patientUuid] 
         * @param {Array<string>} [providerUuid] 
         * @param {Array<string>} [locationUuid] 
         * @param {string} [appointmentType] 
         * @param {string} [startDate] 
         * @param {boolean} [archive] 
         * @param {string} [invoiceType] 
         * @param {string} [endDate] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllAppointmentsForBillingEncounter: async (page?: number, size?: number, sortBy?: string, sortDirection?: string, patientUuid?: string, providerUuid?: Array<string>, locationUuid?: Array<string>, appointmentType?: string, startDate?: string, archive?: boolean, invoiceType?: string, endDate?: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/master/appointment/new-billing-encounter`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }

            if (patientUuid !== undefined) {
                localVarQueryParameter['patientUuid'] = patientUuid;
            }

            if (providerUuid) {
                localVarQueryParameter['providerUuid'] = providerUuid;
            }

            if (locationUuid) {
                localVarQueryParameter['locationUuid'] = locationUuid;
            }

            if (appointmentType !== undefined) {
                localVarQueryParameter['appointmentType'] = appointmentType;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString() :
                    startDate;
            }

            if (archive !== undefined) {
                localVarQueryParameter['archive'] = archive;
            }

            if (invoiceType !== undefined) {
                localVarQueryParameter['invoiceType'] = invoiceType;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString() :
                    endDate;
            }

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Gat appointment by UUID.
         * @summary Get appointment by ID
         * @param {string} appointmentId 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAppointmentById: async (appointmentId: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'appointmentId' is not null or undefined
            assertParamExists('getAppointmentById', 'appointmentId', appointmentId)
            const localVarPath = `/api/master/appointment/{appointmentId}`
                .replace(`{${"appointmentId"}}`, encodeURIComponent(String(appointmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Gat appointment by UUID lightweight.
         * @summary Get appointment by ID lightweight
         * @param {string} appointmentId 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAppointmentByIdLightWeight: async (appointmentId: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'appointmentId' is not null or undefined
            assertParamExists('getAppointmentByIdLightWeight', 'appointmentId', appointmentId)
            const localVarPath = `/api/master/appointment/lightweight/{appointmentId}`
                .replace(`{${"appointmentId"}}`, encodeURIComponent(String(appointmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Total appointments, completion rate, no show rate, cancellation rate with % change vs previous period.
         * @summary Appointment dashboard stats
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {Array<string>} [providerUuid] 
         * @param {Array<string>} [statuses] 
         * @param {Array<string>} [modes] 
         * @param {Array<string>} [scheduledSources] 
         * @param {Array<string>} [locationUuid] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAppointmentDashboardStats: async (startDate?: string, endDate?: string, providerUuid?: Array<string>, statuses?: Array<string>, modes?: Array<string>, scheduledSources?: Array<string>, locationUuid?: Array<string>, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/master/appointment/dashboard-stats`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString() :
                    startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString() :
                    endDate;
            }

            if (providerUuid) {
                localVarQueryParameter['providerUuid'] = providerUuid;
            }

            if (statuses) {
                localVarQueryParameter['statuses'] = statuses;
            }

            if (modes) {
                localVarQueryParameter['modes'] = modes;
            }

            if (scheduledSources) {
                localVarQueryParameter['scheduledSources'] = scheduledSources;
            }

            if (locationUuid) {
                localVarQueryParameter['locationUuid'] = locationUuid;
            }

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get appointment by UUID with limited fields.
         * @summary Get appointment detail light
         * @param {string} appointmentId 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAppointmentDetailLight: async (appointmentId: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'appointmentId' is not null or undefined
            assertParamExists('getAppointmentDetailLight', 'appointmentId', appointmentId)
            const localVarPath = `/api/master/appointment/detail-light/{appointmentId}`
                .replace(`{${"appointmentId"}}`, encodeURIComponent(String(appointmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns only uuid, appointment type, status, appointment time, patient name. Filters: pageable, startDate, endDate, appointmentStatus (multiple), appointmentMode (multiple), appStatusForPatient (multiple), appointmentType (multiple), providerUuid (multiple), patientUuid (multiple), locationUuid (multiple).
         * @summary Get lightweight appointment list
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {string} [searchKey] 
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {Array<string>} [appointmentStatus] 
         * @param {Array<string>} [appointmentMode] 
         * @param {Array<string>} [appStatusForPatient] 
         * @param {Array<string>} [appointmentType] 
         * @param {Array<string>} [providerUuid] 
         * @param {Array<string>} [patientUuid] 
         * @param {Array<string>} [locationUuid] 
         * @param {Array<string>} [paymentMode] 
         * @param {Array<string>} [billedStatus] 
         * @param {GetAppointmentLightListDateRangeTypeEnum} [dateRangeType] 
         * @param {string} [invoiceType] 
         * @param {boolean} [claimEligible] 
         * @param {boolean} [isAddendumSigned] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAppointmentLightList: async (page?: number, size?: number, sortBy?: string, sortDirection?: string, searchKey?: string, startDate?: string, endDate?: string, appointmentStatus?: Array<string>, appointmentMode?: Array<string>, appStatusForPatient?: Array<string>, appointmentType?: Array<string>, providerUuid?: Array<string>, patientUuid?: Array<string>, locationUuid?: Array<string>, paymentMode?: Array<string>, billedStatus?: Array<string>, dateRangeType?: GetAppointmentLightListDateRangeTypeEnum, invoiceType?: string, claimEligible?: boolean, isAddendumSigned?: boolean, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/master/appointment/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }

            if (searchKey !== undefined) {
                localVarQueryParameter['searchKey'] = searchKey;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString() :
                    startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString() :
                    endDate;
            }

            if (appointmentStatus) {
                localVarQueryParameter['appointmentStatus'] = appointmentStatus;
            }

            if (appointmentMode) {
                localVarQueryParameter['appointmentMode'] = appointmentMode;
            }

            if (appStatusForPatient) {
                localVarQueryParameter['appStatusForPatient'] = appStatusForPatient;
            }

            if (appointmentType) {
                localVarQueryParameter['appointmentType'] = appointmentType;
            }

            if (providerUuid) {
                localVarQueryParameter['providerUuid'] = providerUuid;
            }

            if (patientUuid) {
                localVarQueryParameter['patientUuid'] = patientUuid;
            }

            if (locationUuid) {
                localVarQueryParameter['locationUuid'] = locationUuid;
            }

            if (paymentMode) {
                localVarQueryParameter['paymentMode'] = paymentMode;
            }

            if (billedStatus) {
                localVarQueryParameter['billedStatus'] = billedStatus;
            }

            if (dateRangeType !== undefined) {
                localVarQueryParameter['dateRangeType'] = dateRangeType;
            }

            if (invoiceType !== undefined) {
                localVarQueryParameter['invoiceType'] = invoiceType;
            }

            if (claimEligible !== undefined) {
                localVarQueryParameter['claimEligible'] = claimEligible;
            }

            if (isAddendumSigned !== undefined) {
                localVarQueryParameter['isAddendumSigned'] = isAddendumSigned;
            }

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Pageable appointment list with sort, filter support. Columns: uuid, startTime, patientName, patientId, provider, mode, location, scheduledOn, status, insurance.
         * @summary Get appointment list view
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {string} [searchKey] 
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {Array<string>} [statuses] 
         * @param {Array<string>} [modes] 
         * @param {Array<string>} [providerUuid] 
         * @param {Array<string>} [patientUuid] 
         * @param {Array<string>} [locationUuid] 
         * @param {Array<string>} [scheduledSources] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAppointmentList: async (page?: number, size?: number, sortBy?: string, sortDirection?: string, searchKey?: string, startDate?: string, endDate?: string, statuses?: Array<string>, modes?: Array<string>, providerUuid?: Array<string>, patientUuid?: Array<string>, locationUuid?: Array<string>, scheduledSources?: Array<string>, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/master/appointment/v2-list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }

            if (searchKey !== undefined) {
                localVarQueryParameter['searchKey'] = searchKey;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString() :
                    startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString() :
                    endDate;
            }

            if (statuses) {
                localVarQueryParameter['statuses'] = statuses;
            }

            if (modes) {
                localVarQueryParameter['modes'] = modes;
            }

            if (providerUuid) {
                localVarQueryParameter['providerUuid'] = providerUuid;
            }

            if (patientUuid) {
                localVarQueryParameter['patientUuid'] = patientUuid;
            }

            if (locationUuid) {
                localVarQueryParameter['locationUuid'] = locationUuid;
            }

            if (scheduledSources) {
                localVarQueryParameter['scheduledSources'] = scheduledSources;
            }

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get appointment counts grouped by status
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAppointmentStatusCount: async (xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/master/appointment/status-count`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns formatted short names of assessments sent to the patient for this appointment.
         * @summary Get assessments sent to patient
         * @param {string} appointmentId 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAssessmentsSentToPatient: async (appointmentId: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'appointmentId' is not null or undefined
            assertParamExists('getAssessmentsSentToPatient', 'appointmentId', appointmentId)
            const localVarPath = `/api/master/appointment/{appointmentId}/assessments-sent`
                .replace(`{${"appointmentId"}}`, encodeURIComponent(String(appointmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get today’s appointments and count
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTodayAppointments: async (xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/master/appointment/today-appointment`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Lean appointment list (uuid, time, provider, mode, status, location). Same filters as the full list endpoint. Used by Patient Portal Visit History card.
         * @summary Get visit history.
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {string} [patientUuid] 
         * @param {Array<string>} [providerUuid] 
         * @param {Array<string>} [locationUuid] 
         * @param {GetVisitHistoryFilterEnum} [filter] 
         * @param {string} [appointmentType] 
         * @param {string} [appointmentMode] 
         * @param {string} [appointmentStatus] 
         * @param {string} [appStatusForPatient] 
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {boolean} [archive] 
         * @param {boolean} [notForBilling] 
         * @param {boolean} [superBillGenerated] 
         * @param {string} [searchString] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVisitHistory: async (page?: number, size?: number, sortBy?: string, sortDirection?: string, patientUuid?: string, providerUuid?: Array<string>, locationUuid?: Array<string>, filter?: GetVisitHistoryFilterEnum, appointmentType?: string, appointmentMode?: string, appointmentStatus?: string, appStatusForPatient?: string, startDate?: string, endDate?: string, archive?: boolean, notForBilling?: boolean, superBillGenerated?: boolean, searchString?: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/master/appointment/visit-history`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }

            if (patientUuid !== undefined) {
                localVarQueryParameter['patientUuid'] = patientUuid;
            }

            if (providerUuid) {
                localVarQueryParameter['providerUuid'] = providerUuid;
            }

            if (locationUuid) {
                localVarQueryParameter['locationUuid'] = locationUuid;
            }

            if (filter !== undefined) {
                localVarQueryParameter['filter'] = filter;
            }

            if (appointmentType !== undefined) {
                localVarQueryParameter['appointmentType'] = appointmentType;
            }

            if (appointmentMode !== undefined) {
                localVarQueryParameter['appointmentMode'] = appointmentMode;
            }

            if (appointmentStatus !== undefined) {
                localVarQueryParameter['appointmentStatus'] = appointmentStatus;
            }

            if (appStatusForPatient !== undefined) {
                localVarQueryParameter['appStatusForPatient'] = appStatusForPatient;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString() :
                    startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString() :
                    endDate;
            }

            if (archive !== undefined) {
                localVarQueryParameter['archive'] = archive;
            }

            if (notForBilling !== undefined) {
                localVarQueryParameter['notForBilling'] = notForBilling;
            }

            if (superBillGenerated !== undefined) {
                localVarQueryParameter['superBillGenerated'] = superBillGenerated;
            }

            if (searchString !== undefined) {
                localVarQueryParameter['searchString'] = searchString;
            }

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Invite patient for instant appointment.
         * @summary Invite patient for instant appointment
         * @param {InvitePatient} invitePatient 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invitePatientForInstantAppointment: async (invitePatient: InvitePatient, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'invitePatient' is not null or undefined
            assertParamExists('invitePatientForInstantAppointment', 'invitePatient', invitePatient)
            const localVarPath = `/api/master/appointment/invite-patient-instant-appointment`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(invitePatient, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Reschedule the a appointment of patient with particular provider at particular location.
         * @summary Reschedule the  appointment
         * @param {RescheduleAppointment} rescheduleAppointment 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reschduleAppointment: async (rescheduleAppointment: RescheduleAppointment, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'rescheduleAppointment' is not null or undefined
            assertParamExists('reschduleAppointment', 'rescheduleAppointment', rescheduleAppointment)
            const localVarPath = `/api/master/appointment`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(rescheduleAppointment, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Resend intake forms for an appointment
         * @summary Resend intake forms
         * @param {string} appointmentId 
         * @param {string} [customForms] 
         * @param {string} [assessments] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resendIntakeForms: async (appointmentId: string, customForms?: string, assessments?: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'appointmentId' is not null or undefined
            assertParamExists('resendIntakeForms', 'appointmentId', appointmentId)
            const localVarPath = `/api/master/appointment/{appointmentId}/resend-intake-forms`
                .replace(`{${"appointmentId"}}`, encodeURIComponent(String(appointmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (customForms !== undefined) {
                localVarQueryParameter['customForms'] = customForms;
            }

            if (assessments !== undefined) {
                localVarQueryParameter['assessments'] = assessments;
            }

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Generate payment link for appointment
         * @summary Create payment link
         * @param {string} appointmentId 
         * @param {number} amount 
         * @param {string} [currency] 
         * @param {SendPaymentLinkPaymentCategoryEnum} [paymentCategory] 
         * @param {boolean} [resend] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendPaymentLink: async (appointmentId: string, amount: number, currency?: string, paymentCategory?: SendPaymentLinkPaymentCategoryEnum, resend?: boolean, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'appointmentId' is not null or undefined
            assertParamExists('sendPaymentLink', 'appointmentId', appointmentId)
            // verify required parameter 'amount' is not null or undefined
            assertParamExists('sendPaymentLink', 'amount', amount)
            const localVarPath = `/api/master/appointment/{appointmentId}/send-payment-link`
                .replace(`{${"appointmentId"}}`, encodeURIComponent(String(appointmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (amount !== undefined) {
                localVarQueryParameter['amount'] = amount;
            }

            if (currency !== undefined) {
                localVarQueryParameter['currency'] = currency;
            }

            if (paymentCategory !== undefined) {
                localVarQueryParameter['paymentCategory'] = paymentCategory;
            }

            if (resend !== undefined) {
                localVarQueryParameter['resend'] = resend;
            }

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Change Appointment archive status to either archived or unarchived.
         * @summary Archive/Unarchive Appointment
         * @param {string} appointmentId 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAppointmentArchiveStatus: async (appointmentId: string, status: boolean, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'appointmentId' is not null or undefined
            assertParamExists('updateAppointmentArchiveStatus', 'appointmentId', appointmentId)
            // verify required parameter 'status' is not null or undefined
            assertParamExists('updateAppointmentArchiveStatus', 'status', status)
            const localVarPath = `/api/master/appointment/{appointmentId}/archive-status/{status}`
                .replace(`{${"appointmentId"}}`, encodeURIComponent(String(appointmentId)))
                .replace(`{${"status"}}`, encodeURIComponent(String(status)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update Appointment status for billing.
         * @summary Update Appointment status for billing
         * @param {string} appointmentId 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAppointmentBillingStatus: async (appointmentId: string, status: boolean, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'appointmentId' is not null or undefined
            assertParamExists('updateAppointmentBillingStatus', 'appointmentId', appointmentId)
            // verify required parameter 'status' is not null or undefined
            assertParamExists('updateAppointmentBillingStatus', 'status', status)
            const localVarPath = `/api/master/appointment/{appointmentId}/billing/{status}`
                .replace(`{${"appointmentId"}}`, encodeURIComponent(String(appointmentId)))
                .replace(`{${"status"}}`, encodeURIComponent(String(status)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update appointment status for reschedule or cancel.
         * @summary Update appointment status.
         * @param {AppointmentStatusChange} appointmentStatusChange 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAppointmentStatus: async (appointmentStatusChange: AppointmentStatusChange, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'appointmentStatusChange' is not null or undefined
            assertParamExists('updateAppointmentStatus', 'appointmentStatusChange', appointmentStatusChange)
            const localVarPath = `/api/master/appointment/update-status`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(appointmentStatusChange, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AppointmentControllerApi - functional programming interface
 * @export
 */
export const AppointmentControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AppointmentControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * Public website-widget endpoint to book an appointment as a request. Records a PENDING appointment + PatientInquiry with source \"Website (Widget)\".
         * @summary Widget book appointment
         * @param {WidgetAppointment} widgetAppointment 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bookWidgetAppointment(widgetAppointment: WidgetAppointment, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bookWidgetAppointment(widgetAppointment, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AppointmentControllerApi.bookWidgetAppointment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Book a appointment of patient with particular provider at particular location. When appointmentRequest is true (patient portal), returns APPOINTMENT_REQUESTEDD.
         * @summary Book appointment
         * @param {Appointment} appointment 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createAppointment(appointment: Appointment, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createAppointment(appointment, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AppointmentControllerApi.createAppointment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create instant appointment.
         * @summary Create Instant appointment
         * @param {InstantAppointment} instantAppointment 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createInstantAppointment(instantAppointment: InstantAppointment, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createInstantAppointment(instantAppointment, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AppointmentControllerApi.createInstantAppointment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Export selected appointments as CSV file.
         * @summary Export appointments to CSV
         * @param {Array<string>} requestBody 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exportAppointmentsCsv(requestBody: Array<string>, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.exportAppointmentsCsv(requestBody, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AppointmentControllerApi.exportAppointmentsCsv']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get future appointment.
         * @summary Get future Appointment
         * @param {string} providerId 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async futureAppointment(providerId: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.futureAppointment(providerId, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AppointmentControllerApi.futureAppointment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get all appointments with filter options on patient, provider, location.
         * @summary Get all appointments.
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {string} [patientUuid] 
         * @param {Array<string>} [providerUuid] 
         * @param {Array<string>} [locationUuid] 
         * @param {GetAllAppointmentsFilterEnum} [filter] 
         * @param {string} [appointmentType] 
         * @param {string} [appointmentMode] 
         * @param {string} [appointmentStatus] 
         * @param {string} [appStatusForPatient] 
         * @param {string} [startDate] 
         * @param {boolean} [notForBilling] 
         * @param {boolean} [superBillGenerated] 
         * @param {boolean} [archive] 
         * @param {string} [endDate] 
         * @param {string} [searchString] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllAppointments(page?: number, size?: number, sortBy?: string, sortDirection?: string, patientUuid?: string, providerUuid?: Array<string>, locationUuid?: Array<string>, filter?: GetAllAppointmentsFilterEnum, appointmentType?: string, appointmentMode?: string, appointmentStatus?: string, appStatusForPatient?: string, startDate?: string, notForBilling?: boolean, superBillGenerated?: boolean, archive?: boolean, endDate?: string, searchString?: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllAppointments(page, size, sortBy, sortDirection, patientUuid, providerUuid, locationUuid, filter, appointmentType, appointmentMode, appointmentStatus, appStatusForPatient, startDate, notForBilling, superBillGenerated, archive, endDate, searchString, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AppointmentControllerApi.getAllAppointments']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get all encounter with filter options on patient, provider, location
         * @summary Get all encounter.
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {Array<string>} [patientUuid] 
         * @param {Array<string>} [providerUuid] 
         * @param {string} [appointmentType] 
         * @param {string} [encounterDate] 
         * @param {string} [searchString] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllAppointments1(page?: number, size?: number, sortBy?: string, sortDirection?: string, patientUuid?: Array<string>, providerUuid?: Array<string>, appointmentType?: string, encounterDate?: string, searchString?: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllAppointments1(page, size, sortBy, sortDirection, patientUuid, providerUuid, appointmentType, encounterDate, searchString, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AppointmentControllerApi.getAllAppointments1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get all appointments with filter options on patient, provider, location
         * @summary Get all appointments For Billing Encounter.
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {string} [patientUuid] 
         * @param {Array<string>} [providerUuid] 
         * @param {Array<string>} [locationUuid] 
         * @param {string} [appointmentType] 
         * @param {string} [startDate] 
         * @param {boolean} [archive] 
         * @param {string} [invoiceType] 
         * @param {string} [endDate] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllAppointmentsForBillingEncounter(page?: number, size?: number, sortBy?: string, sortDirection?: string, patientUuid?: string, providerUuid?: Array<string>, locationUuid?: Array<string>, appointmentType?: string, startDate?: string, archive?: boolean, invoiceType?: string, endDate?: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllAppointmentsForBillingEncounter(page, size, sortBy, sortDirection, patientUuid, providerUuid, locationUuid, appointmentType, startDate, archive, invoiceType, endDate, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AppointmentControllerApi.getAllAppointmentsForBillingEncounter']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Gat appointment by UUID.
         * @summary Get appointment by ID
         * @param {string} appointmentId 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAppointmentById(appointmentId: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAppointmentById(appointmentId, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AppointmentControllerApi.getAppointmentById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Gat appointment by UUID lightweight.
         * @summary Get appointment by ID lightweight
         * @param {string} appointmentId 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAppointmentByIdLightWeight(appointmentId: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAppointmentByIdLightWeight(appointmentId, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AppointmentControllerApi.getAppointmentByIdLightWeight']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Total appointments, completion rate, no show rate, cancellation rate with % change vs previous period.
         * @summary Appointment dashboard stats
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {Array<string>} [providerUuid] 
         * @param {Array<string>} [statuses] 
         * @param {Array<string>} [modes] 
         * @param {Array<string>} [scheduledSources] 
         * @param {Array<string>} [locationUuid] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAppointmentDashboardStats(startDate?: string, endDate?: string, providerUuid?: Array<string>, statuses?: Array<string>, modes?: Array<string>, scheduledSources?: Array<string>, locationUuid?: Array<string>, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAppointmentDashboardStats(startDate, endDate, providerUuid, statuses, modes, scheduledSources, locationUuid, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AppointmentControllerApi.getAppointmentDashboardStats']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get appointment by UUID with limited fields.
         * @summary Get appointment detail light
         * @param {string} appointmentId 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAppointmentDetailLight(appointmentId: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAppointmentDetailLight(appointmentId, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AppointmentControllerApi.getAppointmentDetailLight']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns only uuid, appointment type, status, appointment time, patient name. Filters: pageable, startDate, endDate, appointmentStatus (multiple), appointmentMode (multiple), appStatusForPatient (multiple), appointmentType (multiple), providerUuid (multiple), patientUuid (multiple), locationUuid (multiple).
         * @summary Get lightweight appointment list
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {string} [searchKey] 
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {Array<string>} [appointmentStatus] 
         * @param {Array<string>} [appointmentMode] 
         * @param {Array<string>} [appStatusForPatient] 
         * @param {Array<string>} [appointmentType] 
         * @param {Array<string>} [providerUuid] 
         * @param {Array<string>} [patientUuid] 
         * @param {Array<string>} [locationUuid] 
         * @param {Array<string>} [paymentMode] 
         * @param {Array<string>} [billedStatus] 
         * @param {GetAppointmentLightListDateRangeTypeEnum} [dateRangeType] 
         * @param {string} [invoiceType] 
         * @param {boolean} [claimEligible] 
         * @param {boolean} [isAddendumSigned] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAppointmentLightList(page?: number, size?: number, sortBy?: string, sortDirection?: string, searchKey?: string, startDate?: string, endDate?: string, appointmentStatus?: Array<string>, appointmentMode?: Array<string>, appStatusForPatient?: Array<string>, appointmentType?: Array<string>, providerUuid?: Array<string>, patientUuid?: Array<string>, locationUuid?: Array<string>, paymentMode?: Array<string>, billedStatus?: Array<string>, dateRangeType?: GetAppointmentLightListDateRangeTypeEnum, invoiceType?: string, claimEligible?: boolean, isAddendumSigned?: boolean, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAppointmentLightList(page, size, sortBy, sortDirection, searchKey, startDate, endDate, appointmentStatus, appointmentMode, appStatusForPatient, appointmentType, providerUuid, patientUuid, locationUuid, paymentMode, billedStatus, dateRangeType, invoiceType, claimEligible, isAddendumSigned, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AppointmentControllerApi.getAppointmentLightList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Pageable appointment list with sort, filter support. Columns: uuid, startTime, patientName, patientId, provider, mode, location, scheduledOn, status, insurance.
         * @summary Get appointment list view
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {string} [searchKey] 
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {Array<string>} [statuses] 
         * @param {Array<string>} [modes] 
         * @param {Array<string>} [providerUuid] 
         * @param {Array<string>} [patientUuid] 
         * @param {Array<string>} [locationUuid] 
         * @param {Array<string>} [scheduledSources] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAppointmentList(page?: number, size?: number, sortBy?: string, sortDirection?: string, searchKey?: string, startDate?: string, endDate?: string, statuses?: Array<string>, modes?: Array<string>, providerUuid?: Array<string>, patientUuid?: Array<string>, locationUuid?: Array<string>, scheduledSources?: Array<string>, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAppointmentList(page, size, sortBy, sortDirection, searchKey, startDate, endDate, statuses, modes, providerUuid, patientUuid, locationUuid, scheduledSources, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AppointmentControllerApi.getAppointmentList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get appointment counts grouped by status
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAppointmentStatusCount(xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAppointmentStatusCount(xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AppointmentControllerApi.getAppointmentStatusCount']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns formatted short names of assessments sent to the patient for this appointment.
         * @summary Get assessments sent to patient
         * @param {string} appointmentId 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAssessmentsSentToPatient(appointmentId: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAssessmentsSentToPatient(appointmentId, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AppointmentControllerApi.getAssessmentsSentToPatient']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get today’s appointments and count
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTodayAppointments(xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTodayAppointments(xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AppointmentControllerApi.getTodayAppointments']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Lean appointment list (uuid, time, provider, mode, status, location). Same filters as the full list endpoint. Used by Patient Portal Visit History card.
         * @summary Get visit history.
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {string} [patientUuid] 
         * @param {Array<string>} [providerUuid] 
         * @param {Array<string>} [locationUuid] 
         * @param {GetVisitHistoryFilterEnum} [filter] 
         * @param {string} [appointmentType] 
         * @param {string} [appointmentMode] 
         * @param {string} [appointmentStatus] 
         * @param {string} [appStatusForPatient] 
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {boolean} [archive] 
         * @param {boolean} [notForBilling] 
         * @param {boolean} [superBillGenerated] 
         * @param {string} [searchString] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getVisitHistory(page?: number, size?: number, sortBy?: string, sortDirection?: string, patientUuid?: string, providerUuid?: Array<string>, locationUuid?: Array<string>, filter?: GetVisitHistoryFilterEnum, appointmentType?: string, appointmentMode?: string, appointmentStatus?: string, appStatusForPatient?: string, startDate?: string, endDate?: string, archive?: boolean, notForBilling?: boolean, superBillGenerated?: boolean, searchString?: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getVisitHistory(page, size, sortBy, sortDirection, patientUuid, providerUuid, locationUuid, filter, appointmentType, appointmentMode, appointmentStatus, appStatusForPatient, startDate, endDate, archive, notForBilling, superBillGenerated, searchString, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AppointmentControllerApi.getVisitHistory']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Invite patient for instant appointment.
         * @summary Invite patient for instant appointment
         * @param {InvitePatient} invitePatient 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async invitePatientForInstantAppointment(invitePatient: InvitePatient, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.invitePatientForInstantAppointment(invitePatient, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AppointmentControllerApi.invitePatientForInstantAppointment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Reschedule the a appointment of patient with particular provider at particular location.
         * @summary Reschedule the  appointment
         * @param {RescheduleAppointment} rescheduleAppointment 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reschduleAppointment(rescheduleAppointment: RescheduleAppointment, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reschduleAppointment(rescheduleAppointment, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AppointmentControllerApi.reschduleAppointment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Resend intake forms for an appointment
         * @summary Resend intake forms
         * @param {string} appointmentId 
         * @param {string} [customForms] 
         * @param {string} [assessments] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resendIntakeForms(appointmentId: string, customForms?: string, assessments?: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resendIntakeForms(appointmentId, customForms, assessments, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AppointmentControllerApi.resendIntakeForms']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Generate payment link for appointment
         * @summary Create payment link
         * @param {string} appointmentId 
         * @param {number} amount 
         * @param {string} [currency] 
         * @param {SendPaymentLinkPaymentCategoryEnum} [paymentCategory] 
         * @param {boolean} [resend] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendPaymentLink(appointmentId: string, amount: number, currency?: string, paymentCategory?: SendPaymentLinkPaymentCategoryEnum, resend?: boolean, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendPaymentLink(appointmentId, amount, currency, paymentCategory, resend, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AppointmentControllerApi.sendPaymentLink']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Change Appointment archive status to either archived or unarchived.
         * @summary Archive/Unarchive Appointment
         * @param {string} appointmentId 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateAppointmentArchiveStatus(appointmentId: string, status: boolean, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateAppointmentArchiveStatus(appointmentId, status, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AppointmentControllerApi.updateAppointmentArchiveStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update Appointment status for billing.
         * @summary Update Appointment status for billing
         * @param {string} appointmentId 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateAppointmentBillingStatus(appointmentId: string, status: boolean, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateAppointmentBillingStatus(appointmentId, status, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AppointmentControllerApi.updateAppointmentBillingStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update appointment status for reschedule or cancel.
         * @summary Update appointment status.
         * @param {AppointmentStatusChange} appointmentStatusChange 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateAppointmentStatus(appointmentStatusChange: AppointmentStatusChange, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateAppointmentStatus(appointmentStatusChange, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AppointmentControllerApi.updateAppointmentStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AppointmentControllerApi - factory interface
 * @export
 */
export const AppointmentControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AppointmentControllerApiFp(configuration)
    return {
        /**
         * Public website-widget endpoint to book an appointment as a request. Records a PENDING appointment + PatientInquiry with source \"Website (Widget)\".
         * @summary Widget book appointment
         * @param {WidgetAppointment} widgetAppointment 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bookWidgetAppointment(widgetAppointment: WidgetAppointment, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.bookWidgetAppointment(widgetAppointment, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Book a appointment of patient with particular provider at particular location. When appointmentRequest is true (patient portal), returns APPOINTMENT_REQUESTEDD.
         * @summary Book appointment
         * @param {Appointment} appointment 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAppointment(appointment: Appointment, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.createAppointment(appointment, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Create instant appointment.
         * @summary Create Instant appointment
         * @param {InstantAppointment} instantAppointment 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createInstantAppointment(instantAppointment: InstantAppointment, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.createInstantAppointment(instantAppointment, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Export selected appointments as CSV file.
         * @summary Export appointments to CSV
         * @param {Array<string>} requestBody 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportAppointmentsCsv(requestBody: Array<string>, xTENANTID?: string, options?: any): AxiosPromise<string> {
            return localVarFp.exportAppointmentsCsv(requestBody, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Get future appointment.
         * @summary Get future Appointment
         * @param {string} providerId 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        futureAppointment(providerId: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.futureAppointment(providerId, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all appointments with filter options on patient, provider, location.
         * @summary Get all appointments.
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {string} [patientUuid] 
         * @param {Array<string>} [providerUuid] 
         * @param {Array<string>} [locationUuid] 
         * @param {GetAllAppointmentsFilterEnum} [filter] 
         * @param {string} [appointmentType] 
         * @param {string} [appointmentMode] 
         * @param {string} [appointmentStatus] 
         * @param {string} [appStatusForPatient] 
         * @param {string} [startDate] 
         * @param {boolean} [notForBilling] 
         * @param {boolean} [superBillGenerated] 
         * @param {boolean} [archive] 
         * @param {string} [endDate] 
         * @param {string} [searchString] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllAppointments(page?: number, size?: number, sortBy?: string, sortDirection?: string, patientUuid?: string, providerUuid?: Array<string>, locationUuid?: Array<string>, filter?: GetAllAppointmentsFilterEnum, appointmentType?: string, appointmentMode?: string, appointmentStatus?: string, appStatusForPatient?: string, startDate?: string, notForBilling?: boolean, superBillGenerated?: boolean, archive?: boolean, endDate?: string, searchString?: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getAllAppointments(page, size, sortBy, sortDirection, patientUuid, providerUuid, locationUuid, filter, appointmentType, appointmentMode, appointmentStatus, appStatusForPatient, startDate, notForBilling, superBillGenerated, archive, endDate, searchString, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all encounter with filter options on patient, provider, location
         * @summary Get all encounter.
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {Array<string>} [patientUuid] 
         * @param {Array<string>} [providerUuid] 
         * @param {string} [appointmentType] 
         * @param {string} [encounterDate] 
         * @param {string} [searchString] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllAppointments1(page?: number, size?: number, sortBy?: string, sortDirection?: string, patientUuid?: Array<string>, providerUuid?: Array<string>, appointmentType?: string, encounterDate?: string, searchString?: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getAllAppointments1(page, size, sortBy, sortDirection, patientUuid, providerUuid, appointmentType, encounterDate, searchString, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all appointments with filter options on patient, provider, location
         * @summary Get all appointments For Billing Encounter.
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {string} [patientUuid] 
         * @param {Array<string>} [providerUuid] 
         * @param {Array<string>} [locationUuid] 
         * @param {string} [appointmentType] 
         * @param {string} [startDate] 
         * @param {boolean} [archive] 
         * @param {string} [invoiceType] 
         * @param {string} [endDate] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllAppointmentsForBillingEncounter(page?: number, size?: number, sortBy?: string, sortDirection?: string, patientUuid?: string, providerUuid?: Array<string>, locationUuid?: Array<string>, appointmentType?: string, startDate?: string, archive?: boolean, invoiceType?: string, endDate?: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getAllAppointmentsForBillingEncounter(page, size, sortBy, sortDirection, patientUuid, providerUuid, locationUuid, appointmentType, startDate, archive, invoiceType, endDate, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Gat appointment by UUID.
         * @summary Get appointment by ID
         * @param {string} appointmentId 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAppointmentById(appointmentId: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getAppointmentById(appointmentId, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Gat appointment by UUID lightweight.
         * @summary Get appointment by ID lightweight
         * @param {string} appointmentId 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAppointmentByIdLightWeight(appointmentId: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getAppointmentByIdLightWeight(appointmentId, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Total appointments, completion rate, no show rate, cancellation rate with % change vs previous period.
         * @summary Appointment dashboard stats
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {Array<string>} [providerUuid] 
         * @param {Array<string>} [statuses] 
         * @param {Array<string>} [modes] 
         * @param {Array<string>} [scheduledSources] 
         * @param {Array<string>} [locationUuid] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAppointmentDashboardStats(startDate?: string, endDate?: string, providerUuid?: Array<string>, statuses?: Array<string>, modes?: Array<string>, scheduledSources?: Array<string>, locationUuid?: Array<string>, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getAppointmentDashboardStats(startDate, endDate, providerUuid, statuses, modes, scheduledSources, locationUuid, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Get appointment by UUID with limited fields.
         * @summary Get appointment detail light
         * @param {string} appointmentId 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAppointmentDetailLight(appointmentId: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getAppointmentDetailLight(appointmentId, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns only uuid, appointment type, status, appointment time, patient name. Filters: pageable, startDate, endDate, appointmentStatus (multiple), appointmentMode (multiple), appStatusForPatient (multiple), appointmentType (multiple), providerUuid (multiple), patientUuid (multiple), locationUuid (multiple).
         * @summary Get lightweight appointment list
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {string} [searchKey] 
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {Array<string>} [appointmentStatus] 
         * @param {Array<string>} [appointmentMode] 
         * @param {Array<string>} [appStatusForPatient] 
         * @param {Array<string>} [appointmentType] 
         * @param {Array<string>} [providerUuid] 
         * @param {Array<string>} [patientUuid] 
         * @param {Array<string>} [locationUuid] 
         * @param {Array<string>} [paymentMode] 
         * @param {Array<string>} [billedStatus] 
         * @param {GetAppointmentLightListDateRangeTypeEnum} [dateRangeType] 
         * @param {string} [invoiceType] 
         * @param {boolean} [claimEligible] 
         * @param {boolean} [isAddendumSigned] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAppointmentLightList(page?: number, size?: number, sortBy?: string, sortDirection?: string, searchKey?: string, startDate?: string, endDate?: string, appointmentStatus?: Array<string>, appointmentMode?: Array<string>, appStatusForPatient?: Array<string>, appointmentType?: Array<string>, providerUuid?: Array<string>, patientUuid?: Array<string>, locationUuid?: Array<string>, paymentMode?: Array<string>, billedStatus?: Array<string>, dateRangeType?: GetAppointmentLightListDateRangeTypeEnum, invoiceType?: string, claimEligible?: boolean, isAddendumSigned?: boolean, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getAppointmentLightList(page, size, sortBy, sortDirection, searchKey, startDate, endDate, appointmentStatus, appointmentMode, appStatusForPatient, appointmentType, providerUuid, patientUuid, locationUuid, paymentMode, billedStatus, dateRangeType, invoiceType, claimEligible, isAddendumSigned, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Pageable appointment list with sort, filter support. Columns: uuid, startTime, patientName, patientId, provider, mode, location, scheduledOn, status, insurance.
         * @summary Get appointment list view
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {string} [searchKey] 
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {Array<string>} [statuses] 
         * @param {Array<string>} [modes] 
         * @param {Array<string>} [providerUuid] 
         * @param {Array<string>} [patientUuid] 
         * @param {Array<string>} [locationUuid] 
         * @param {Array<string>} [scheduledSources] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAppointmentList(page?: number, size?: number, sortBy?: string, sortDirection?: string, searchKey?: string, startDate?: string, endDate?: string, statuses?: Array<string>, modes?: Array<string>, providerUuid?: Array<string>, patientUuid?: Array<string>, locationUuid?: Array<string>, scheduledSources?: Array<string>, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getAppointmentList(page, size, sortBy, sortDirection, searchKey, startDate, endDate, statuses, modes, providerUuid, patientUuid, locationUuid, scheduledSources, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get appointment counts grouped by status
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAppointmentStatusCount(xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getAppointmentStatusCount(xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns formatted short names of assessments sent to the patient for this appointment.
         * @summary Get assessments sent to patient
         * @param {string} appointmentId 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAssessmentsSentToPatient(appointmentId: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getAssessmentsSentToPatient(appointmentId, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get today’s appointments and count
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTodayAppointments(xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getTodayAppointments(xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Lean appointment list (uuid, time, provider, mode, status, location). Same filters as the full list endpoint. Used by Patient Portal Visit History card.
         * @summary Get visit history.
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {string} [patientUuid] 
         * @param {Array<string>} [providerUuid] 
         * @param {Array<string>} [locationUuid] 
         * @param {GetVisitHistoryFilterEnum} [filter] 
         * @param {string} [appointmentType] 
         * @param {string} [appointmentMode] 
         * @param {string} [appointmentStatus] 
         * @param {string} [appStatusForPatient] 
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {boolean} [archive] 
         * @param {boolean} [notForBilling] 
         * @param {boolean} [superBillGenerated] 
         * @param {string} [searchString] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVisitHistory(page?: number, size?: number, sortBy?: string, sortDirection?: string, patientUuid?: string, providerUuid?: Array<string>, locationUuid?: Array<string>, filter?: GetVisitHistoryFilterEnum, appointmentType?: string, appointmentMode?: string, appointmentStatus?: string, appStatusForPatient?: string, startDate?: string, endDate?: string, archive?: boolean, notForBilling?: boolean, superBillGenerated?: boolean, searchString?: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getVisitHistory(page, size, sortBy, sortDirection, patientUuid, providerUuid, locationUuid, filter, appointmentType, appointmentMode, appointmentStatus, appStatusForPatient, startDate, endDate, archive, notForBilling, superBillGenerated, searchString, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Invite patient for instant appointment.
         * @summary Invite patient for instant appointment
         * @param {InvitePatient} invitePatient 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invitePatientForInstantAppointment(invitePatient: InvitePatient, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.invitePatientForInstantAppointment(invitePatient, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Reschedule the a appointment of patient with particular provider at particular location.
         * @summary Reschedule the  appointment
         * @param {RescheduleAppointment} rescheduleAppointment 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reschduleAppointment(rescheduleAppointment: RescheduleAppointment, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.reschduleAppointment(rescheduleAppointment, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Resend intake forms for an appointment
         * @summary Resend intake forms
         * @param {string} appointmentId 
         * @param {string} [customForms] 
         * @param {string} [assessments] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resendIntakeForms(appointmentId: string, customForms?: string, assessments?: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.resendIntakeForms(appointmentId, customForms, assessments, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Generate payment link for appointment
         * @summary Create payment link
         * @param {string} appointmentId 
         * @param {number} amount 
         * @param {string} [currency] 
         * @param {SendPaymentLinkPaymentCategoryEnum} [paymentCategory] 
         * @param {boolean} [resend] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendPaymentLink(appointmentId: string, amount: number, currency?: string, paymentCategory?: SendPaymentLinkPaymentCategoryEnum, resend?: boolean, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.sendPaymentLink(appointmentId, amount, currency, paymentCategory, resend, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Change Appointment archive status to either archived or unarchived.
         * @summary Archive/Unarchive Appointment
         * @param {string} appointmentId 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAppointmentArchiveStatus(appointmentId: string, status: boolean, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.updateAppointmentArchiveStatus(appointmentId, status, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Update Appointment status for billing.
         * @summary Update Appointment status for billing
         * @param {string} appointmentId 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAppointmentBillingStatus(appointmentId: string, status: boolean, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.updateAppointmentBillingStatus(appointmentId, status, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Update appointment status for reschedule or cancel.
         * @summary Update appointment status.
         * @param {AppointmentStatusChange} appointmentStatusChange 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAppointmentStatus(appointmentStatusChange: AppointmentStatusChange, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.updateAppointmentStatus(appointmentStatusChange, xTENANTID, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AppointmentControllerApi - object-oriented interface
 * @export
 * @class AppointmentControllerApi
 * @extends {BaseAPI}
 */
export class AppointmentControllerApi extends BaseAPI {
    /**
     * Public website-widget endpoint to book an appointment as a request. Records a PENDING appointment + PatientInquiry with source \"Website (Widget)\".
     * @summary Widget book appointment
     * @param {WidgetAppointment} widgetAppointment 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppointmentControllerApi
     */
    public bookWidgetAppointment(widgetAppointment: WidgetAppointment, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return AppointmentControllerApiFp(this.configuration).bookWidgetAppointment(widgetAppointment, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Book a appointment of patient with particular provider at particular location. When appointmentRequest is true (patient portal), returns APPOINTMENT_REQUESTEDD.
     * @summary Book appointment
     * @param {Appointment} appointment 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppointmentControllerApi
     */
    public createAppointment(appointment: Appointment, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return AppointmentControllerApiFp(this.configuration).createAppointment(appointment, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create instant appointment.
     * @summary Create Instant appointment
     * @param {InstantAppointment} instantAppointment 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppointmentControllerApi
     */
    public createInstantAppointment(instantAppointment: InstantAppointment, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return AppointmentControllerApiFp(this.configuration).createInstantAppointment(instantAppointment, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Export selected appointments as CSV file.
     * @summary Export appointments to CSV
     * @param {Array<string>} requestBody 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppointmentControllerApi
     */
    public exportAppointmentsCsv(requestBody: Array<string>, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return AppointmentControllerApiFp(this.configuration).exportAppointmentsCsv(requestBody, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get future appointment.
     * @summary Get future Appointment
     * @param {string} providerId 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppointmentControllerApi
     */
    public futureAppointment(providerId: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return AppointmentControllerApiFp(this.configuration).futureAppointment(providerId, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all appointments with filter options on patient, provider, location.
     * @summary Get all appointments.
     * @param {number} [page] 
     * @param {number} [size] 
     * @param {string} [sortBy] 
     * @param {string} [sortDirection] 
     * @param {string} [patientUuid] 
     * @param {Array<string>} [providerUuid] 
     * @param {Array<string>} [locationUuid] 
     * @param {GetAllAppointmentsFilterEnum} [filter] 
     * @param {string} [appointmentType] 
     * @param {string} [appointmentMode] 
     * @param {string} [appointmentStatus] 
     * @param {string} [appStatusForPatient] 
     * @param {string} [startDate] 
     * @param {boolean} [notForBilling] 
     * @param {boolean} [superBillGenerated] 
     * @param {boolean} [archive] 
     * @param {string} [endDate] 
     * @param {string} [searchString] 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppointmentControllerApi
     */
    public getAllAppointments(page?: number, size?: number, sortBy?: string, sortDirection?: string, patientUuid?: string, providerUuid?: Array<string>, locationUuid?: Array<string>, filter?: GetAllAppointmentsFilterEnum, appointmentType?: string, appointmentMode?: string, appointmentStatus?: string, appStatusForPatient?: string, startDate?: string, notForBilling?: boolean, superBillGenerated?: boolean, archive?: boolean, endDate?: string, searchString?: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return AppointmentControllerApiFp(this.configuration).getAllAppointments(page, size, sortBy, sortDirection, patientUuid, providerUuid, locationUuid, filter, appointmentType, appointmentMode, appointmentStatus, appStatusForPatient, startDate, notForBilling, superBillGenerated, archive, endDate, searchString, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all encounter with filter options on patient, provider, location
     * @summary Get all encounter.
     * @param {number} [page] 
     * @param {number} [size] 
     * @param {string} [sortBy] 
     * @param {string} [sortDirection] 
     * @param {Array<string>} [patientUuid] 
     * @param {Array<string>} [providerUuid] 
     * @param {string} [appointmentType] 
     * @param {string} [encounterDate] 
     * @param {string} [searchString] 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppointmentControllerApi
     */
    public getAllAppointments1(page?: number, size?: number, sortBy?: string, sortDirection?: string, patientUuid?: Array<string>, providerUuid?: Array<string>, appointmentType?: string, encounterDate?: string, searchString?: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return AppointmentControllerApiFp(this.configuration).getAllAppointments1(page, size, sortBy, sortDirection, patientUuid, providerUuid, appointmentType, encounterDate, searchString, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all appointments with filter options on patient, provider, location
     * @summary Get all appointments For Billing Encounter.
     * @param {number} [page] 
     * @param {number} [size] 
     * @param {string} [sortBy] 
     * @param {string} [sortDirection] 
     * @param {string} [patientUuid] 
     * @param {Array<string>} [providerUuid] 
     * @param {Array<string>} [locationUuid] 
     * @param {string} [appointmentType] 
     * @param {string} [startDate] 
     * @param {boolean} [archive] 
     * @param {string} [invoiceType] 
     * @param {string} [endDate] 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppointmentControllerApi
     */
    public getAllAppointmentsForBillingEncounter(page?: number, size?: number, sortBy?: string, sortDirection?: string, patientUuid?: string, providerUuid?: Array<string>, locationUuid?: Array<string>, appointmentType?: string, startDate?: string, archive?: boolean, invoiceType?: string, endDate?: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return AppointmentControllerApiFp(this.configuration).getAllAppointmentsForBillingEncounter(page, size, sortBy, sortDirection, patientUuid, providerUuid, locationUuid, appointmentType, startDate, archive, invoiceType, endDate, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Gat appointment by UUID.
     * @summary Get appointment by ID
     * @param {string} appointmentId 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppointmentControllerApi
     */
    public getAppointmentById(appointmentId: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return AppointmentControllerApiFp(this.configuration).getAppointmentById(appointmentId, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Gat appointment by UUID lightweight.
     * @summary Get appointment by ID lightweight
     * @param {string} appointmentId 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppointmentControllerApi
     */
    public getAppointmentByIdLightWeight(appointmentId: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return AppointmentControllerApiFp(this.configuration).getAppointmentByIdLightWeight(appointmentId, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Total appointments, completion rate, no show rate, cancellation rate with % change vs previous period.
     * @summary Appointment dashboard stats
     * @param {string} [startDate] 
     * @param {string} [endDate] 
     * @param {Array<string>} [providerUuid] 
     * @param {Array<string>} [statuses] 
     * @param {Array<string>} [modes] 
     * @param {Array<string>} [scheduledSources] 
     * @param {Array<string>} [locationUuid] 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppointmentControllerApi
     */
    public getAppointmentDashboardStats(startDate?: string, endDate?: string, providerUuid?: Array<string>, statuses?: Array<string>, modes?: Array<string>, scheduledSources?: Array<string>, locationUuid?: Array<string>, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return AppointmentControllerApiFp(this.configuration).getAppointmentDashboardStats(startDate, endDate, providerUuid, statuses, modes, scheduledSources, locationUuid, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get appointment by UUID with limited fields.
     * @summary Get appointment detail light
     * @param {string} appointmentId 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppointmentControllerApi
     */
    public getAppointmentDetailLight(appointmentId: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return AppointmentControllerApiFp(this.configuration).getAppointmentDetailLight(appointmentId, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns only uuid, appointment type, status, appointment time, patient name. Filters: pageable, startDate, endDate, appointmentStatus (multiple), appointmentMode (multiple), appStatusForPatient (multiple), appointmentType (multiple), providerUuid (multiple), patientUuid (multiple), locationUuid (multiple).
     * @summary Get lightweight appointment list
     * @param {number} [page] 
     * @param {number} [size] 
     * @param {string} [sortBy] 
     * @param {string} [sortDirection] 
     * @param {string} [searchKey] 
     * @param {string} [startDate] 
     * @param {string} [endDate] 
     * @param {Array<string>} [appointmentStatus] 
     * @param {Array<string>} [appointmentMode] 
     * @param {Array<string>} [appStatusForPatient] 
     * @param {Array<string>} [appointmentType] 
     * @param {Array<string>} [providerUuid] 
     * @param {Array<string>} [patientUuid] 
     * @param {Array<string>} [locationUuid] 
     * @param {Array<string>} [paymentMode] 
     * @param {Array<string>} [billedStatus] 
     * @param {GetAppointmentLightListDateRangeTypeEnum} [dateRangeType] 
     * @param {string} [invoiceType] 
     * @param {boolean} [claimEligible] 
     * @param {boolean} [isAddendumSigned] 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppointmentControllerApi
     */
    public getAppointmentLightList(page?: number, size?: number, sortBy?: string, sortDirection?: string, searchKey?: string, startDate?: string, endDate?: string, appointmentStatus?: Array<string>, appointmentMode?: Array<string>, appStatusForPatient?: Array<string>, appointmentType?: Array<string>, providerUuid?: Array<string>, patientUuid?: Array<string>, locationUuid?: Array<string>, paymentMode?: Array<string>, billedStatus?: Array<string>, dateRangeType?: GetAppointmentLightListDateRangeTypeEnum, invoiceType?: string, claimEligible?: boolean, isAddendumSigned?: boolean, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return AppointmentControllerApiFp(this.configuration).getAppointmentLightList(page, size, sortBy, sortDirection, searchKey, startDate, endDate, appointmentStatus, appointmentMode, appStatusForPatient, appointmentType, providerUuid, patientUuid, locationUuid, paymentMode, billedStatus, dateRangeType, invoiceType, claimEligible, isAddendumSigned, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Pageable appointment list with sort, filter support. Columns: uuid, startTime, patientName, patientId, provider, mode, location, scheduledOn, status, insurance.
     * @summary Get appointment list view
     * @param {number} [page] 
     * @param {number} [size] 
     * @param {string} [sortBy] 
     * @param {string} [sortDirection] 
     * @param {string} [searchKey] 
     * @param {string} [startDate] 
     * @param {string} [endDate] 
     * @param {Array<string>} [statuses] 
     * @param {Array<string>} [modes] 
     * @param {Array<string>} [providerUuid] 
     * @param {Array<string>} [patientUuid] 
     * @param {Array<string>} [locationUuid] 
     * @param {Array<string>} [scheduledSources] 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppointmentControllerApi
     */
    public getAppointmentList(page?: number, size?: number, sortBy?: string, sortDirection?: string, searchKey?: string, startDate?: string, endDate?: string, statuses?: Array<string>, modes?: Array<string>, providerUuid?: Array<string>, patientUuid?: Array<string>, locationUuid?: Array<string>, scheduledSources?: Array<string>, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return AppointmentControllerApiFp(this.configuration).getAppointmentList(page, size, sortBy, sortDirection, searchKey, startDate, endDate, statuses, modes, providerUuid, patientUuid, locationUuid, scheduledSources, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get appointment counts grouped by status
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppointmentControllerApi
     */
    public getAppointmentStatusCount(xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return AppointmentControllerApiFp(this.configuration).getAppointmentStatusCount(xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns formatted short names of assessments sent to the patient for this appointment.
     * @summary Get assessments sent to patient
     * @param {string} appointmentId 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppointmentControllerApi
     */
    public getAssessmentsSentToPatient(appointmentId: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return AppointmentControllerApiFp(this.configuration).getAssessmentsSentToPatient(appointmentId, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get today’s appointments and count
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppointmentControllerApi
     */
    public getTodayAppointments(xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return AppointmentControllerApiFp(this.configuration).getTodayAppointments(xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Lean appointment list (uuid, time, provider, mode, status, location). Same filters as the full list endpoint. Used by Patient Portal Visit History card.
     * @summary Get visit history.
     * @param {number} [page] 
     * @param {number} [size] 
     * @param {string} [sortBy] 
     * @param {string} [sortDirection] 
     * @param {string} [patientUuid] 
     * @param {Array<string>} [providerUuid] 
     * @param {Array<string>} [locationUuid] 
     * @param {GetVisitHistoryFilterEnum} [filter] 
     * @param {string} [appointmentType] 
     * @param {string} [appointmentMode] 
     * @param {string} [appointmentStatus] 
     * @param {string} [appStatusForPatient] 
     * @param {string} [startDate] 
     * @param {string} [endDate] 
     * @param {boolean} [archive] 
     * @param {boolean} [notForBilling] 
     * @param {boolean} [superBillGenerated] 
     * @param {string} [searchString] 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppointmentControllerApi
     */
    public getVisitHistory(page?: number, size?: number, sortBy?: string, sortDirection?: string, patientUuid?: string, providerUuid?: Array<string>, locationUuid?: Array<string>, filter?: GetVisitHistoryFilterEnum, appointmentType?: string, appointmentMode?: string, appointmentStatus?: string, appStatusForPatient?: string, startDate?: string, endDate?: string, archive?: boolean, notForBilling?: boolean, superBillGenerated?: boolean, searchString?: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return AppointmentControllerApiFp(this.configuration).getVisitHistory(page, size, sortBy, sortDirection, patientUuid, providerUuid, locationUuid, filter, appointmentType, appointmentMode, appointmentStatus, appStatusForPatient, startDate, endDate, archive, notForBilling, superBillGenerated, searchString, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Invite patient for instant appointment.
     * @summary Invite patient for instant appointment
     * @param {InvitePatient} invitePatient 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppointmentControllerApi
     */
    public invitePatientForInstantAppointment(invitePatient: InvitePatient, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return AppointmentControllerApiFp(this.configuration).invitePatientForInstantAppointment(invitePatient, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Reschedule the a appointment of patient with particular provider at particular location.
     * @summary Reschedule the  appointment
     * @param {RescheduleAppointment} rescheduleAppointment 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppointmentControllerApi
     */
    public reschduleAppointment(rescheduleAppointment: RescheduleAppointment, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return AppointmentControllerApiFp(this.configuration).reschduleAppointment(rescheduleAppointment, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Resend intake forms for an appointment
     * @summary Resend intake forms
     * @param {string} appointmentId 
     * @param {string} [customForms] 
     * @param {string} [assessments] 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppointmentControllerApi
     */
    public resendIntakeForms(appointmentId: string, customForms?: string, assessments?: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return AppointmentControllerApiFp(this.configuration).resendIntakeForms(appointmentId, customForms, assessments, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Generate payment link for appointment
     * @summary Create payment link
     * @param {string} appointmentId 
     * @param {number} amount 
     * @param {string} [currency] 
     * @param {SendPaymentLinkPaymentCategoryEnum} [paymentCategory] 
     * @param {boolean} [resend] 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppointmentControllerApi
     */
    public sendPaymentLink(appointmentId: string, amount: number, currency?: string, paymentCategory?: SendPaymentLinkPaymentCategoryEnum, resend?: boolean, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return AppointmentControllerApiFp(this.configuration).sendPaymentLink(appointmentId, amount, currency, paymentCategory, resend, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Change Appointment archive status to either archived or unarchived.
     * @summary Archive/Unarchive Appointment
     * @param {string} appointmentId 
     * @param {boolean} status 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppointmentControllerApi
     */
    public updateAppointmentArchiveStatus(appointmentId: string, status: boolean, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return AppointmentControllerApiFp(this.configuration).updateAppointmentArchiveStatus(appointmentId, status, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update Appointment status for billing.
     * @summary Update Appointment status for billing
     * @param {string} appointmentId 
     * @param {boolean} status 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppointmentControllerApi
     */
    public updateAppointmentBillingStatus(appointmentId: string, status: boolean, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return AppointmentControllerApiFp(this.configuration).updateAppointmentBillingStatus(appointmentId, status, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update appointment status for reschedule or cancel.
     * @summary Update appointment status.
     * @param {AppointmentStatusChange} appointmentStatusChange 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppointmentControllerApi
     */
    public updateAppointmentStatus(appointmentStatusChange: AppointmentStatusChange, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return AppointmentControllerApiFp(this.configuration).updateAppointmentStatus(appointmentStatusChange, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const GetAllAppointmentsFilterEnum = {
    All: 'ALL',
    Upcoming: 'UPCOMING',
    Past: 'PAST'
} as const;
export type GetAllAppointmentsFilterEnum = typeof GetAllAppointmentsFilterEnum[keyof typeof GetAllAppointmentsFilterEnum];
/**
 * @export
 */
export const GetAppointmentLightListDateRangeTypeEnum = {
    Today: 'TODAY',
    Yesterday: 'YESTERDAY',
    Last7Days: 'LAST_7_DAYS',
    Last30Days: 'LAST_30_DAYS',
    Last90Days: 'LAST_90_DAYS',
    ThisMonth: 'THIS_MONTH',
    LastMonth: 'LAST_MONTH',
    CustomRange: 'CUSTOM_RANGE'
} as const;
export type GetAppointmentLightListDateRangeTypeEnum = typeof GetAppointmentLightListDateRangeTypeEnum[keyof typeof GetAppointmentLightListDateRangeTypeEnum];
/**
 * @export
 */
export const GetVisitHistoryFilterEnum = {
    All: 'ALL',
    Upcoming: 'UPCOMING',
    Past: 'PAST'
} as const;
export type GetVisitHistoryFilterEnum = typeof GetVisitHistoryFilterEnum[keyof typeof GetVisitHistoryFilterEnum];
/**
 * @export
 */
export const SendPaymentLinkPaymentCategoryEnum = {
    Copay: 'COPAY',
    Deductible: 'DEDUCTIBLE',
    Coinsurance: 'COINSURANCE',
    SelfPay: 'SELF_PAY',
    Advance: 'ADVANCE',
    Pr: 'PR',
    OutOfNetwork: 'OUT_OF_NETWORK',
    Invoice: 'INVOICE'
} as const;
export type SendPaymentLinkPaymentCategoryEnum = typeof SendPaymentLinkPaymentCategoryEnum[keyof typeof SendPaymentLinkPaymentCategoryEnum];


/**
 * AppointmentTypeControllerApi - axios parameter creator
 * @export
 */
export const AppointmentTypeControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Add a new Appointment Type into the system.
         * @summary Add New Appointment Type
         * @param {AppointmentTypeList} appointmentTypeList 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAppointmentType: async (appointmentTypeList: AppointmentTypeList, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'appointmentTypeList' is not null or undefined
            assertParamExists('createAppointmentType', 'appointmentTypeList', appointmentTypeList)
            const localVarPath = `/api/master/appointment-type`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(appointmentTypeList, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all Appointment Type list.
         * @summary Get all Appointment Type.
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {boolean} [status] 
         * @param {boolean} [archive] 
         * @param {string} [searchString] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllAppointmentTypes: async (page?: number, size?: number, sortBy?: string, sortDirection?: string, status?: boolean, archive?: boolean, searchString?: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/master/appointment-type`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (archive !== undefined) {
                localVarQueryParameter['archive'] = archive;
            }

            if (searchString !== undefined) {
                localVarQueryParameter['searchString'] = searchString;
            }

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Public appointment type list for the website widget appointment-type dropdown.
         * @summary Get appointment types for the website widget
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {boolean} [status] 
         * @param {boolean} [archive] 
         * @param {string} [searchString] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWidgetAppointmentTypes: async (page?: number, size?: number, sortBy?: string, sortDirection?: string, status?: boolean, archive?: boolean, searchString?: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/master/appointment-type/widget-appointment-types`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (archive !== undefined) {
                localVarQueryParameter['archive'] = archive;
            }

            if (searchString !== undefined) {
                localVarQueryParameter['searchString'] = searchString;
            }

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Edit Appointment Type
         * @summary Update Appointment Type
         * @param {AppointmentTypeList} appointmentTypeList 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAppointmentType: async (appointmentTypeList: AppointmentTypeList, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'appointmentTypeList' is not null or undefined
            assertParamExists('updateAppointmentType', 'appointmentTypeList', appointmentTypeList)
            const localVarPath = `/api/master/appointment-type`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(appointmentTypeList, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Change Appointment Type  archive status to either archived or unarchived.
         * @summary Archive/Unarchive Appointment Type
         * @param {string} appointmentTypeId 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAppointmentTypeArchiveStatus: async (appointmentTypeId: string, status: boolean, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'appointmentTypeId' is not null or undefined
            assertParamExists('updateAppointmentTypeArchiveStatus', 'appointmentTypeId', appointmentTypeId)
            // verify required parameter 'status' is not null or undefined
            assertParamExists('updateAppointmentTypeArchiveStatus', 'status', status)
            const localVarPath = `/api/master/appointment-type/{appointmentTypeId}/archive-status/{status}`
                .replace(`{${"appointmentTypeId"}}`, encodeURIComponent(String(appointmentTypeId)))
                .replace(`{${"status"}}`, encodeURIComponent(String(status)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AppointmentTypeControllerApi - functional programming interface
 * @export
 */
export const AppointmentTypeControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AppointmentTypeControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * Add a new Appointment Type into the system.
         * @summary Add New Appointment Type
         * @param {AppointmentTypeList} appointmentTypeList 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createAppointmentType(appointmentTypeList: AppointmentTypeList, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createAppointmentType(appointmentTypeList, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AppointmentTypeControllerApi.createAppointmentType']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get all Appointment Type list.
         * @summary Get all Appointment Type.
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {boolean} [status] 
         * @param {boolean} [archive] 
         * @param {string} [searchString] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllAppointmentTypes(page?: number, size?: number, sortBy?: string, sortDirection?: string, status?: boolean, archive?: boolean, searchString?: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllAppointmentTypes(page, size, sortBy, sortDirection, status, archive, searchString, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AppointmentTypeControllerApi.getAllAppointmentTypes']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Public appointment type list for the website widget appointment-type dropdown.
         * @summary Get appointment types for the website widget
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {boolean} [status] 
         * @param {boolean} [archive] 
         * @param {string} [searchString] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWidgetAppointmentTypes(page?: number, size?: number, sortBy?: string, sortDirection?: string, status?: boolean, archive?: boolean, searchString?: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWidgetAppointmentTypes(page, size, sortBy, sortDirection, status, archive, searchString, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AppointmentTypeControllerApi.getWidgetAppointmentTypes']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Edit Appointment Type
         * @summary Update Appointment Type
         * @param {AppointmentTypeList} appointmentTypeList 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateAppointmentType(appointmentTypeList: AppointmentTypeList, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateAppointmentType(appointmentTypeList, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AppointmentTypeControllerApi.updateAppointmentType']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Change Appointment Type  archive status to either archived or unarchived.
         * @summary Archive/Unarchive Appointment Type
         * @param {string} appointmentTypeId 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateAppointmentTypeArchiveStatus(appointmentTypeId: string, status: boolean, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateAppointmentTypeArchiveStatus(appointmentTypeId, status, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AppointmentTypeControllerApi.updateAppointmentTypeArchiveStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AppointmentTypeControllerApi - factory interface
 * @export
 */
export const AppointmentTypeControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AppointmentTypeControllerApiFp(configuration)
    return {
        /**
         * Add a new Appointment Type into the system.
         * @summary Add New Appointment Type
         * @param {AppointmentTypeList} appointmentTypeList 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAppointmentType(appointmentTypeList: AppointmentTypeList, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.createAppointmentType(appointmentTypeList, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all Appointment Type list.
         * @summary Get all Appointment Type.
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {boolean} [status] 
         * @param {boolean} [archive] 
         * @param {string} [searchString] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllAppointmentTypes(page?: number, size?: number, sortBy?: string, sortDirection?: string, status?: boolean, archive?: boolean, searchString?: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getAllAppointmentTypes(page, size, sortBy, sortDirection, status, archive, searchString, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Public appointment type list for the website widget appointment-type dropdown.
         * @summary Get appointment types for the website widget
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {boolean} [status] 
         * @param {boolean} [archive] 
         * @param {string} [searchString] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWidgetAppointmentTypes(page?: number, size?: number, sortBy?: string, sortDirection?: string, status?: boolean, archive?: boolean, searchString?: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getWidgetAppointmentTypes(page, size, sortBy, sortDirection, status, archive, searchString, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Edit Appointment Type
         * @summary Update Appointment Type
         * @param {AppointmentTypeList} appointmentTypeList 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAppointmentType(appointmentTypeList: AppointmentTypeList, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.updateAppointmentType(appointmentTypeList, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Change Appointment Type  archive status to either archived or unarchived.
         * @summary Archive/Unarchive Appointment Type
         * @param {string} appointmentTypeId 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAppointmentTypeArchiveStatus(appointmentTypeId: string, status: boolean, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.updateAppointmentTypeArchiveStatus(appointmentTypeId, status, xTENANTID, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AppointmentTypeControllerApi - object-oriented interface
 * @export
 * @class AppointmentTypeControllerApi
 * @extends {BaseAPI}
 */
export class AppointmentTypeControllerApi extends BaseAPI {
    /**
     * Add a new Appointment Type into the system.
     * @summary Add New Appointment Type
     * @param {AppointmentTypeList} appointmentTypeList 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppointmentTypeControllerApi
     */
    public createAppointmentType(appointmentTypeList: AppointmentTypeList, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return AppointmentTypeControllerApiFp(this.configuration).createAppointmentType(appointmentTypeList, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all Appointment Type list.
     * @summary Get all Appointment Type.
     * @param {number} [page] 
     * @param {number} [size] 
     * @param {string} [sortBy] 
     * @param {string} [sortDirection] 
     * @param {boolean} [status] 
     * @param {boolean} [archive] 
     * @param {string} [searchString] 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppointmentTypeControllerApi
     */
    public getAllAppointmentTypes(page?: number, size?: number, sortBy?: string, sortDirection?: string, status?: boolean, archive?: boolean, searchString?: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return AppointmentTypeControllerApiFp(this.configuration).getAllAppointmentTypes(page, size, sortBy, sortDirection, status, archive, searchString, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Public appointment type list for the website widget appointment-type dropdown.
     * @summary Get appointment types for the website widget
     * @param {number} [page] 
     * @param {number} [size] 
     * @param {string} [sortBy] 
     * @param {string} [sortDirection] 
     * @param {boolean} [status] 
     * @param {boolean} [archive] 
     * @param {string} [searchString] 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppointmentTypeControllerApi
     */
    public getWidgetAppointmentTypes(page?: number, size?: number, sortBy?: string, sortDirection?: string, status?: boolean, archive?: boolean, searchString?: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return AppointmentTypeControllerApiFp(this.configuration).getWidgetAppointmentTypes(page, size, sortBy, sortDirection, status, archive, searchString, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Edit Appointment Type
     * @summary Update Appointment Type
     * @param {AppointmentTypeList} appointmentTypeList 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppointmentTypeControllerApi
     */
    public updateAppointmentType(appointmentTypeList: AppointmentTypeList, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return AppointmentTypeControllerApiFp(this.configuration).updateAppointmentType(appointmentTypeList, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Change Appointment Type  archive status to either archived or unarchived.
     * @summary Archive/Unarchive Appointment Type
     * @param {string} appointmentTypeId 
     * @param {boolean} status 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppointmentTypeControllerApi
     */
    public updateAppointmentTypeArchiveStatus(appointmentTypeId: string, status: boolean, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return AppointmentTypeControllerApiFp(this.configuration).updateAppointmentTypeArchiveStatus(appointmentTypeId, status, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AssessmentPdfControllerApi - axios parameter creator
 * @export
 */
export const AssessmentPdfControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Generate a PDF document from assessment questionnaire data
         * @summary Generate PDF from assessment data
         * @param {AssessmentPDFRequest} assessmentPDFRequest 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateAssessmentPDF: async (assessmentPDFRequest: AssessmentPDFRequest, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'assessmentPDFRequest' is not null or undefined
            assertParamExists('generateAssessmentPDF', 'assessmentPDFRequest', assessmentPDFRequest)
            const localVarPath = `/api/master/assessment-pdf/generate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(assessmentPDFRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AssessmentPdfControllerApi - functional programming interface
 * @export
 */
export const AssessmentPdfControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AssessmentPdfControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * Generate a PDF document from assessment questionnaire data
         * @summary Generate PDF from assessment data
         * @param {AssessmentPDFRequest} assessmentPDFRequest 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generateAssessmentPDF(assessmentPDFRequest: AssessmentPDFRequest, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generateAssessmentPDF(assessmentPDFRequest, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AssessmentPdfControllerApi.generateAssessmentPDF']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AssessmentPdfControllerApi - factory interface
 * @export
 */
export const AssessmentPdfControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AssessmentPdfControllerApiFp(configuration)
    return {
        /**
         * Generate a PDF document from assessment questionnaire data
         * @summary Generate PDF from assessment data
         * @param {AssessmentPDFRequest} assessmentPDFRequest 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateAssessmentPDF(assessmentPDFRequest: AssessmentPDFRequest, xTENANTID?: string, options?: any): AxiosPromise<string> {
            return localVarFp.generateAssessmentPDF(assessmentPDFRequest, xTENANTID, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AssessmentPdfControllerApi - object-oriented interface
 * @export
 * @class AssessmentPdfControllerApi
 * @extends {BaseAPI}
 */
export class AssessmentPdfControllerApi extends BaseAPI {
    /**
     * Generate a PDF document from assessment questionnaire data
     * @summary Generate PDF from assessment data
     * @param {AssessmentPDFRequest} assessmentPDFRequest 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssessmentPdfControllerApi
     */
    public generateAssessmentPDF(assessmentPDFRequest: AssessmentPDFRequest, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return AssessmentPdfControllerApiFp(this.configuration).generateAssessmentPDF(assessmentPDFRequest, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AudioControllerApi - axios parameter creator
 * @export
 */
export const AudioControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} body 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadAudio: async (body: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('uploadAudio', 'body', body)
            const localVarPath = `/api/audio/upload`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AudioControllerApi - functional programming interface
 * @export
 */
export const AudioControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AudioControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} body 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadAudio(body: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadAudio(body, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AudioControllerApi.uploadAudio']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AudioControllerApi - factory interface
 * @export
 */
export const AudioControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AudioControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {string} body 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadAudio(body: string, xTENANTID?: string, options?: any): AxiosPromise<string> {
            return localVarFp.uploadAudio(body, xTENANTID, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AudioControllerApi - object-oriented interface
 * @export
 * @class AudioControllerApi
 * @extends {BaseAPI}
 */
export class AudioControllerApi extends BaseAPI {
    /**
     * 
     * @param {string} body 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AudioControllerApi
     */
    public uploadAudio(body: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return AudioControllerApiFp(this.configuration).uploadAudio(body, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AuditLogControllerApi - axios parameter creator
 * @export
 */
export const AuditLogControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Export filtered audit log records as a downloadable CSV byte stream
         * @summary Export audit log as CSV
         * @param {string} [fromDate] 
         * @param {string} [toDate] 
         * @param {string} [patient] 
         * @param {string} [user] 
         * @param {string} [category] 
         * @param {string} [action] 
         * @param {string} [logType] 
         * @param {string} [ipAddress] 
         * @param {ExportAuditLogCsvDateRangeTypeEnum} [dateRangeType] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportAuditLogCsv: async (fromDate?: string, toDate?: string, patient?: string, user?: string, category?: string, action?: string, logType?: string, ipAddress?: string, dateRangeType?: ExportAuditLogCsvDateRangeTypeEnum, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/master/audit-log/export-csv`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (fromDate !== undefined) {
                localVarQueryParameter['fromDate'] = (fromDate as any instanceof Date) ?
                    (fromDate as any).toISOString() :
                    fromDate;
            }

            if (toDate !== undefined) {
                localVarQueryParameter['toDate'] = (toDate as any instanceof Date) ?
                    (toDate as any).toISOString() :
                    toDate;
            }

            if (patient !== undefined) {
                localVarQueryParameter['patient'] = patient;
            }

            if (user !== undefined) {
                localVarQueryParameter['user'] = user;
            }

            if (category !== undefined) {
                localVarQueryParameter['category'] = category;
            }

            if (action !== undefined) {
                localVarQueryParameter['action'] = action;
            }

            if (logType !== undefined) {
                localVarQueryParameter['logType'] = logType;
            }

            if (ipAddress !== undefined) {
                localVarQueryParameter['ipAddress'] = ipAddress;
            }

            if (dateRangeType !== undefined) {
                localVarQueryParameter['dateRangeType'] = dateRangeType;
            }

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * get all audit log from system. Available sort fields: log_time, patient_name, log_user, action, log_type, category, activity, ip_address
         * @summary get all audit log from system
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {string} [fromDate] 
         * @param {string} [toDate] 
         * @param {string} [patient] 
         * @param {string} [user] 
         * @param {string} [category] 
         * @param {string} [action] 
         * @param {string} [logType] 
         * @param {string} [ipAddress] 
         * @param {GetAllAuditLogDateRangeTypeEnum} [dateRangeType] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllAuditLog: async (page?: number, size?: number, sortBy?: string, sortDirection?: string, fromDate?: string, toDate?: string, patient?: string, user?: string, category?: string, action?: string, logType?: string, ipAddress?: string, dateRangeType?: GetAllAuditLogDateRangeTypeEnum, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/master/audit-log`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }

            if (fromDate !== undefined) {
                localVarQueryParameter['fromDate'] = (fromDate as any instanceof Date) ?
                    (fromDate as any).toISOString() :
                    fromDate;
            }

            if (toDate !== undefined) {
                localVarQueryParameter['toDate'] = (toDate as any instanceof Date) ?
                    (toDate as any).toISOString() :
                    toDate;
            }

            if (patient !== undefined) {
                localVarQueryParameter['patient'] = patient;
            }

            if (user !== undefined) {
                localVarQueryParameter['user'] = user;
            }

            if (category !== undefined) {
                localVarQueryParameter['category'] = category;
            }

            if (action !== undefined) {
                localVarQueryParameter['action'] = action;
            }

            if (logType !== undefined) {
                localVarQueryParameter['logType'] = logType;
            }

            if (ipAddress !== undefined) {
                localVarQueryParameter['ipAddress'] = ipAddress;
            }

            if (dateRangeType !== undefined) {
                localVarQueryParameter['dateRangeType'] = dateRangeType;
            }

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AuditLogControllerApi - functional programming interface
 * @export
 */
export const AuditLogControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AuditLogControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * Export filtered audit log records as a downloadable CSV byte stream
         * @summary Export audit log as CSV
         * @param {string} [fromDate] 
         * @param {string} [toDate] 
         * @param {string} [patient] 
         * @param {string} [user] 
         * @param {string} [category] 
         * @param {string} [action] 
         * @param {string} [logType] 
         * @param {string} [ipAddress] 
         * @param {ExportAuditLogCsvDateRangeTypeEnum} [dateRangeType] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exportAuditLogCsv(fromDate?: string, toDate?: string, patient?: string, user?: string, category?: string, action?: string, logType?: string, ipAddress?: string, dateRangeType?: ExportAuditLogCsvDateRangeTypeEnum, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.exportAuditLogCsv(fromDate, toDate, patient, user, category, action, logType, ipAddress, dateRangeType, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuditLogControllerApi.exportAuditLogCsv']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * get all audit log from system. Available sort fields: log_time, patient_name, log_user, action, log_type, category, activity, ip_address
         * @summary get all audit log from system
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {string} [fromDate] 
         * @param {string} [toDate] 
         * @param {string} [patient] 
         * @param {string} [user] 
         * @param {string} [category] 
         * @param {string} [action] 
         * @param {string} [logType] 
         * @param {string} [ipAddress] 
         * @param {GetAllAuditLogDateRangeTypeEnum} [dateRangeType] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllAuditLog(page?: number, size?: number, sortBy?: string, sortDirection?: string, fromDate?: string, toDate?: string, patient?: string, user?: string, category?: string, action?: string, logType?: string, ipAddress?: string, dateRangeType?: GetAllAuditLogDateRangeTypeEnum, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllAuditLog(page, size, sortBy, sortDirection, fromDate, toDate, patient, user, category, action, logType, ipAddress, dateRangeType, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuditLogControllerApi.getAllAuditLog']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AuditLogControllerApi - factory interface
 * @export
 */
export const AuditLogControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AuditLogControllerApiFp(configuration)
    return {
        /**
         * Export filtered audit log records as a downloadable CSV byte stream
         * @summary Export audit log as CSV
         * @param {string} [fromDate] 
         * @param {string} [toDate] 
         * @param {string} [patient] 
         * @param {string} [user] 
         * @param {string} [category] 
         * @param {string} [action] 
         * @param {string} [logType] 
         * @param {string} [ipAddress] 
         * @param {ExportAuditLogCsvDateRangeTypeEnum} [dateRangeType] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportAuditLogCsv(fromDate?: string, toDate?: string, patient?: string, user?: string, category?: string, action?: string, logType?: string, ipAddress?: string, dateRangeType?: ExportAuditLogCsvDateRangeTypeEnum, xTENANTID?: string, options?: any): AxiosPromise<string> {
            return localVarFp.exportAuditLogCsv(fromDate, toDate, patient, user, category, action, logType, ipAddress, dateRangeType, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * get all audit log from system. Available sort fields: log_time, patient_name, log_user, action, log_type, category, activity, ip_address
         * @summary get all audit log from system
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {string} [fromDate] 
         * @param {string} [toDate] 
         * @param {string} [patient] 
         * @param {string} [user] 
         * @param {string} [category] 
         * @param {string} [action] 
         * @param {string} [logType] 
         * @param {string} [ipAddress] 
         * @param {GetAllAuditLogDateRangeTypeEnum} [dateRangeType] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllAuditLog(page?: number, size?: number, sortBy?: string, sortDirection?: string, fromDate?: string, toDate?: string, patient?: string, user?: string, category?: string, action?: string, logType?: string, ipAddress?: string, dateRangeType?: GetAllAuditLogDateRangeTypeEnum, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getAllAuditLog(page, size, sortBy, sortDirection, fromDate, toDate, patient, user, category, action, logType, ipAddress, dateRangeType, xTENANTID, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AuditLogControllerApi - object-oriented interface
 * @export
 * @class AuditLogControllerApi
 * @extends {BaseAPI}
 */
export class AuditLogControllerApi extends BaseAPI {
    /**
     * Export filtered audit log records as a downloadable CSV byte stream
     * @summary Export audit log as CSV
     * @param {string} [fromDate] 
     * @param {string} [toDate] 
     * @param {string} [patient] 
     * @param {string} [user] 
     * @param {string} [category] 
     * @param {string} [action] 
     * @param {string} [logType] 
     * @param {string} [ipAddress] 
     * @param {ExportAuditLogCsvDateRangeTypeEnum} [dateRangeType] 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuditLogControllerApi
     */
    public exportAuditLogCsv(fromDate?: string, toDate?: string, patient?: string, user?: string, category?: string, action?: string, logType?: string, ipAddress?: string, dateRangeType?: ExportAuditLogCsvDateRangeTypeEnum, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return AuditLogControllerApiFp(this.configuration).exportAuditLogCsv(fromDate, toDate, patient, user, category, action, logType, ipAddress, dateRangeType, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * get all audit log from system. Available sort fields: log_time, patient_name, log_user, action, log_type, category, activity, ip_address
     * @summary get all audit log from system
     * @param {number} [page] 
     * @param {number} [size] 
     * @param {string} [sortBy] 
     * @param {string} [sortDirection] 
     * @param {string} [fromDate] 
     * @param {string} [toDate] 
     * @param {string} [patient] 
     * @param {string} [user] 
     * @param {string} [category] 
     * @param {string} [action] 
     * @param {string} [logType] 
     * @param {string} [ipAddress] 
     * @param {GetAllAuditLogDateRangeTypeEnum} [dateRangeType] 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuditLogControllerApi
     */
    public getAllAuditLog(page?: number, size?: number, sortBy?: string, sortDirection?: string, fromDate?: string, toDate?: string, patient?: string, user?: string, category?: string, action?: string, logType?: string, ipAddress?: string, dateRangeType?: GetAllAuditLogDateRangeTypeEnum, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return AuditLogControllerApiFp(this.configuration).getAllAuditLog(page, size, sortBy, sortDirection, fromDate, toDate, patient, user, category, action, logType, ipAddress, dateRangeType, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const ExportAuditLogCsvDateRangeTypeEnum = {
    Today: 'TODAY',
    Yesterday: 'YESTERDAY',
    Last7Days: 'LAST_7_DAYS',
    Last30Days: 'LAST_30_DAYS',
    Last90Days: 'LAST_90_DAYS',
    ThisMonth: 'THIS_MONTH',
    LastMonth: 'LAST_MONTH',
    CustomRange: 'CUSTOM_RANGE'
} as const;
export type ExportAuditLogCsvDateRangeTypeEnum = typeof ExportAuditLogCsvDateRangeTypeEnum[keyof typeof ExportAuditLogCsvDateRangeTypeEnum];
/**
 * @export
 */
export const GetAllAuditLogDateRangeTypeEnum = {
    Today: 'TODAY',
    Yesterday: 'YESTERDAY',
    Last7Days: 'LAST_7_DAYS',
    Last30Days: 'LAST_30_DAYS',
    Last90Days: 'LAST_90_DAYS',
    ThisMonth: 'THIS_MONTH',
    LastMonth: 'LAST_MONTH',
    CustomRange: 'CUSTOM_RANGE'
} as const;
export type GetAllAuditLogDateRangeTypeEnum = typeof GetAllAuditLogDateRangeTypeEnum[keyof typeof GetAllAuditLogDateRangeTypeEnum];


/**
 * AvailabilityControllerApi - axios parameter creator
 * @export
 */
export const AvailabilityControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} providerUuid 
         * @param {string} startDate 
         * @param {string} endDate 
         * @param {GetProviderAvailabilityTimeZoneEnum} timeZone 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProviderAvailability: async (providerUuid: string, startDate: string, endDate: string, timeZone: GetProviderAvailabilityTimeZoneEnum, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'providerUuid' is not null or undefined
            assertParamExists('getProviderAvailability', 'providerUuid', providerUuid)
            // verify required parameter 'startDate' is not null or undefined
            assertParamExists('getProviderAvailability', 'startDate', startDate)
            // verify required parameter 'endDate' is not null or undefined
            assertParamExists('getProviderAvailability', 'endDate', endDate)
            // verify required parameter 'timeZone' is not null or undefined
            assertParamExists('getProviderAvailability', 'timeZone', timeZone)
            const localVarPath = `/api/master/provider/{providerUuid}/availability`
                .replace(`{${"providerUuid"}}`, encodeURIComponent(String(providerUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString().substring(0,10) :
                    startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString().substring(0,10) :
                    endDate;
            }

            if (timeZone !== undefined) {
                localVarQueryParameter['timeZone'] = timeZone;
            }

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} providerUuid 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProviderAvailabilitySetting: async (providerUuid: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'providerUuid' is not null or undefined
            assertParamExists('getProviderAvailabilitySetting', 'providerUuid', providerUuid)
            const localVarPath = `/api/master/provider/{providerUuid}/availability-setting`
                .replace(`{${"providerUuid"}}`, encodeURIComponent(String(providerUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} providerUuid 
         * @param {string} appointmentTypeUuid 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {GetProviderSlotsAvailabilityModeEnum} [availabilityMode] 
         * @param {string} [locationUuid] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProviderSlots: async (providerUuid: string, appointmentTypeUuid: string, page?: number, size?: number, startDate?: string, endDate?: string, availabilityMode?: GetProviderSlotsAvailabilityModeEnum, locationUuid?: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'providerUuid' is not null or undefined
            assertParamExists('getProviderSlots', 'providerUuid', providerUuid)
            // verify required parameter 'appointmentTypeUuid' is not null or undefined
            assertParamExists('getProviderSlots', 'appointmentTypeUuid', appointmentTypeUuid)
            const localVarPath = `/api/master/provider/{providerUuid}/slots/{appointmentTypeUuid}`
                .replace(`{${"providerUuid"}}`, encodeURIComponent(String(providerUuid)))
                .replace(`{${"appointmentTypeUuid"}}`, encodeURIComponent(String(appointmentTypeUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString() :
                    startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString() :
                    endDate;
            }

            if (availabilityMode !== undefined) {
                localVarQueryParameter['availabilityMode'] = availabilityMode;
            }

            if (locationUuid !== undefined) {
                localVarQueryParameter['locationUuid'] = locationUuid;
            }

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} page 
         * @param {number} size 
         * @param {string} startDate 
         * @param {string} endDate 
         * @param {string} stateCode 
         * @param {string} appointmentTypeUuid 
         * @param {GetProvidersSlotsAvailabilityModeEnum} [availabilityMode] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProvidersSlots: async (page: number, size: number, startDate: string, endDate: string, stateCode: string, appointmentTypeUuid: string, availabilityMode?: GetProvidersSlotsAvailabilityModeEnum, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'page' is not null or undefined
            assertParamExists('getProvidersSlots', 'page', page)
            // verify required parameter 'size' is not null or undefined
            assertParamExists('getProvidersSlots', 'size', size)
            // verify required parameter 'startDate' is not null or undefined
            assertParamExists('getProvidersSlots', 'startDate', startDate)
            // verify required parameter 'endDate' is not null or undefined
            assertParamExists('getProvidersSlots', 'endDate', endDate)
            // verify required parameter 'stateCode' is not null or undefined
            assertParamExists('getProvidersSlots', 'stateCode', stateCode)
            // verify required parameter 'appointmentTypeUuid' is not null or undefined
            assertParamExists('getProvidersSlots', 'appointmentTypeUuid', appointmentTypeUuid)
            const localVarPath = `/api/master/providers/slots`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString() :
                    startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString() :
                    endDate;
            }

            if (stateCode !== undefined) {
                localVarQueryParameter['stateCode'] = stateCode;
            }

            if (appointmentTypeUuid !== undefined) {
                localVarQueryParameter['appointmentTypeUuid'] = appointmentTypeUuid;
            }

            if (availabilityMode !== undefined) {
                localVarQueryParameter['availabilityMode'] = availabilityMode;
            }

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} providerUuid 
         * @param {string} appointmentTypeUuid 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {GetWidgetProviderSlotsAvailabilityModeEnum} [availabilityMode] 
         * @param {string} [locationUuid] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWidgetProviderSlots: async (providerUuid: string, appointmentTypeUuid: string, page?: number, size?: number, startDate?: string, endDate?: string, availabilityMode?: GetWidgetProviderSlotsAvailabilityModeEnum, locationUuid?: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'providerUuid' is not null or undefined
            assertParamExists('getWidgetProviderSlots', 'providerUuid', providerUuid)
            // verify required parameter 'appointmentTypeUuid' is not null or undefined
            assertParamExists('getWidgetProviderSlots', 'appointmentTypeUuid', appointmentTypeUuid)
            const localVarPath = `/api/master/provider/{providerUuid}/widget-slots/{appointmentTypeUuid}`
                .replace(`{${"providerUuid"}}`, encodeURIComponent(String(providerUuid)))
                .replace(`{${"appointmentTypeUuid"}}`, encodeURIComponent(String(appointmentTypeUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString() :
                    startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString() :
                    endDate;
            }

            if (availabilityMode !== undefined) {
                localVarQueryParameter['availabilityMode'] = availabilityMode;
            }

            if (locationUuid !== undefined) {
                localVarQueryParameter['locationUuid'] = locationUuid;
            }

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {AvailabilitySetting} availabilitySetting 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setProviderAvailabilitySetting: async (availabilitySetting: AvailabilitySetting, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'availabilitySetting' is not null or undefined
            assertParamExists('setProviderAvailabilitySetting', 'availabilitySetting', availabilitySetting)
            const localVarPath = `/api/master/provider/availability-setting`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(availabilitySetting, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AvailabilityControllerApi - functional programming interface
 * @export
 */
export const AvailabilityControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AvailabilityControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} providerUuid 
         * @param {string} startDate 
         * @param {string} endDate 
         * @param {GetProviderAvailabilityTimeZoneEnum} timeZone 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProviderAvailability(providerUuid: string, startDate: string, endDate: string, timeZone: GetProviderAvailabilityTimeZoneEnum, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProviderAvailability(providerUuid, startDate, endDate, timeZone, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AvailabilityControllerApi.getProviderAvailability']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} providerUuid 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProviderAvailabilitySetting(providerUuid: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProviderAvailabilitySetting(providerUuid, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AvailabilityControllerApi.getProviderAvailabilitySetting']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} providerUuid 
         * @param {string} appointmentTypeUuid 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {GetProviderSlotsAvailabilityModeEnum} [availabilityMode] 
         * @param {string} [locationUuid] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProviderSlots(providerUuid: string, appointmentTypeUuid: string, page?: number, size?: number, startDate?: string, endDate?: string, availabilityMode?: GetProviderSlotsAvailabilityModeEnum, locationUuid?: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProviderSlots(providerUuid, appointmentTypeUuid, page, size, startDate, endDate, availabilityMode, locationUuid, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AvailabilityControllerApi.getProviderSlots']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} page 
         * @param {number} size 
         * @param {string} startDate 
         * @param {string} endDate 
         * @param {string} stateCode 
         * @param {string} appointmentTypeUuid 
         * @param {GetProvidersSlotsAvailabilityModeEnum} [availabilityMode] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProvidersSlots(page: number, size: number, startDate: string, endDate: string, stateCode: string, appointmentTypeUuid: string, availabilityMode?: GetProvidersSlotsAvailabilityModeEnum, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProvidersSlots(page, size, startDate, endDate, stateCode, appointmentTypeUuid, availabilityMode, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AvailabilityControllerApi.getProvidersSlots']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} providerUuid 
         * @param {string} appointmentTypeUuid 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {GetWidgetProviderSlotsAvailabilityModeEnum} [availabilityMode] 
         * @param {string} [locationUuid] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWidgetProviderSlots(providerUuid: string, appointmentTypeUuid: string, page?: number, size?: number, startDate?: string, endDate?: string, availabilityMode?: GetWidgetProviderSlotsAvailabilityModeEnum, locationUuid?: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWidgetProviderSlots(providerUuid, appointmentTypeUuid, page, size, startDate, endDate, availabilityMode, locationUuid, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AvailabilityControllerApi.getWidgetProviderSlots']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {AvailabilitySetting} availabilitySetting 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setProviderAvailabilitySetting(availabilitySetting: AvailabilitySetting, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setProviderAvailabilitySetting(availabilitySetting, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AvailabilityControllerApi.setProviderAvailabilitySetting']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AvailabilityControllerApi - factory interface
 * @export
 */
export const AvailabilityControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AvailabilityControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {string} providerUuid 
         * @param {string} startDate 
         * @param {string} endDate 
         * @param {GetProviderAvailabilityTimeZoneEnum} timeZone 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProviderAvailability(providerUuid: string, startDate: string, endDate: string, timeZone: GetProviderAvailabilityTimeZoneEnum, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getProviderAvailability(providerUuid, startDate, endDate, timeZone, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} providerUuid 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProviderAvailabilitySetting(providerUuid: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getProviderAvailabilitySetting(providerUuid, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} providerUuid 
         * @param {string} appointmentTypeUuid 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {GetProviderSlotsAvailabilityModeEnum} [availabilityMode] 
         * @param {string} [locationUuid] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProviderSlots(providerUuid: string, appointmentTypeUuid: string, page?: number, size?: number, startDate?: string, endDate?: string, availabilityMode?: GetProviderSlotsAvailabilityModeEnum, locationUuid?: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getProviderSlots(providerUuid, appointmentTypeUuid, page, size, startDate, endDate, availabilityMode, locationUuid, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} page 
         * @param {number} size 
         * @param {string} startDate 
         * @param {string} endDate 
         * @param {string} stateCode 
         * @param {string} appointmentTypeUuid 
         * @param {GetProvidersSlotsAvailabilityModeEnum} [availabilityMode] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProvidersSlots(page: number, size: number, startDate: string, endDate: string, stateCode: string, appointmentTypeUuid: string, availabilityMode?: GetProvidersSlotsAvailabilityModeEnum, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getProvidersSlots(page, size, startDate, endDate, stateCode, appointmentTypeUuid, availabilityMode, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} providerUuid 
         * @param {string} appointmentTypeUuid 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {GetWidgetProviderSlotsAvailabilityModeEnum} [availabilityMode] 
         * @param {string} [locationUuid] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWidgetProviderSlots(providerUuid: string, appointmentTypeUuid: string, page?: number, size?: number, startDate?: string, endDate?: string, availabilityMode?: GetWidgetProviderSlotsAvailabilityModeEnum, locationUuid?: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getWidgetProviderSlots(providerUuid, appointmentTypeUuid, page, size, startDate, endDate, availabilityMode, locationUuid, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AvailabilitySetting} availabilitySetting 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setProviderAvailabilitySetting(availabilitySetting: AvailabilitySetting, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.setProviderAvailabilitySetting(availabilitySetting, xTENANTID, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AvailabilityControllerApi - object-oriented interface
 * @export
 * @class AvailabilityControllerApi
 * @extends {BaseAPI}
 */
export class AvailabilityControllerApi extends BaseAPI {
    /**
     * 
     * @param {string} providerUuid 
     * @param {string} startDate 
     * @param {string} endDate 
     * @param {GetProviderAvailabilityTimeZoneEnum} timeZone 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AvailabilityControllerApi
     */
    public getProviderAvailability(providerUuid: string, startDate: string, endDate: string, timeZone: GetProviderAvailabilityTimeZoneEnum, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return AvailabilityControllerApiFp(this.configuration).getProviderAvailability(providerUuid, startDate, endDate, timeZone, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} providerUuid 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AvailabilityControllerApi
     */
    public getProviderAvailabilitySetting(providerUuid: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return AvailabilityControllerApiFp(this.configuration).getProviderAvailabilitySetting(providerUuid, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} providerUuid 
     * @param {string} appointmentTypeUuid 
     * @param {number} [page] 
     * @param {number} [size] 
     * @param {string} [startDate] 
     * @param {string} [endDate] 
     * @param {GetProviderSlotsAvailabilityModeEnum} [availabilityMode] 
     * @param {string} [locationUuid] 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AvailabilityControllerApi
     */
    public getProviderSlots(providerUuid: string, appointmentTypeUuid: string, page?: number, size?: number, startDate?: string, endDate?: string, availabilityMode?: GetProviderSlotsAvailabilityModeEnum, locationUuid?: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return AvailabilityControllerApiFp(this.configuration).getProviderSlots(providerUuid, appointmentTypeUuid, page, size, startDate, endDate, availabilityMode, locationUuid, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} page 
     * @param {number} size 
     * @param {string} startDate 
     * @param {string} endDate 
     * @param {string} stateCode 
     * @param {string} appointmentTypeUuid 
     * @param {GetProvidersSlotsAvailabilityModeEnum} [availabilityMode] 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AvailabilityControllerApi
     */
    public getProvidersSlots(page: number, size: number, startDate: string, endDate: string, stateCode: string, appointmentTypeUuid: string, availabilityMode?: GetProvidersSlotsAvailabilityModeEnum, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return AvailabilityControllerApiFp(this.configuration).getProvidersSlots(page, size, startDate, endDate, stateCode, appointmentTypeUuid, availabilityMode, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} providerUuid 
     * @param {string} appointmentTypeUuid 
     * @param {number} [page] 
     * @param {number} [size] 
     * @param {string} [startDate] 
     * @param {string} [endDate] 
     * @param {GetWidgetProviderSlotsAvailabilityModeEnum} [availabilityMode] 
     * @param {string} [locationUuid] 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AvailabilityControllerApi
     */
    public getWidgetProviderSlots(providerUuid: string, appointmentTypeUuid: string, page?: number, size?: number, startDate?: string, endDate?: string, availabilityMode?: GetWidgetProviderSlotsAvailabilityModeEnum, locationUuid?: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return AvailabilityControllerApiFp(this.configuration).getWidgetProviderSlots(providerUuid, appointmentTypeUuid, page, size, startDate, endDate, availabilityMode, locationUuid, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AvailabilitySetting} availabilitySetting 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AvailabilityControllerApi
     */
    public setProviderAvailabilitySetting(availabilitySetting: AvailabilitySetting, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return AvailabilityControllerApiFp(this.configuration).setProviderAvailabilitySetting(availabilitySetting, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const GetProviderAvailabilityTimeZoneEnum = {
    Pst: 'PST',
    Est: 'EST',
    Cst: 'CST',
    Mst: 'MST',
    Ast: 'AST',
    Hst: 'HST',
    Edt: 'EDT',
    Pdt: 'PDT',
    Cdt: 'CDT',
    Adt: 'ADT',
    Mdt: 'MDT',
    Ist: 'IST',
    Akdt: 'AKDT',
    Akst: 'AKST',
    Gmt: 'GMT',
    Utc: 'UTC',
    Wet: 'WET',
    West: 'WEST',
    Cet: 'CET',
    Cest: 'CEST',
    Eet: 'EET',
    Eest: 'EEST',
    Msk: 'MSK',
    Msd: 'MSD',
    Aest: 'AEST',
    Aedt: 'AEDT',
    Acst: 'ACST',
    Acdt: 'ACDT',
    Awst: 'AWST',
    Nzst: 'NZST',
    Nzdt: 'NZDT',
    Sgt: 'SGT',
    Hkt: 'HKT',
    Jst: 'JST',
    Kst: 'KST',
    CstChina: 'CST_CHINA',
    Bdt: 'BDT',
    Pkt: 'PKT',
    IstIran: 'IST_IRAN',
    Trt: 'TRT',
    Idt: 'IDT',
    Wat: 'WAT',
    Cat: 'CAT',
    Eat: 'EAT',
    Art: 'ART',
    Bot: 'BOT',
    Clt: 'CLT',
    Clst: 'CLST',
    Srt: 'SRT',
    Gft: 'GFT',
    Uyt: 'UYT',
    Uyst: 'UYST',
    Vet: 'VET',
    Samt: 'SAMT',
    Yekt: 'YEKT',
    Irkt: 'IRKT',
    Krat: 'KRAT',
    Magt: 'MAGT',
    Pett: 'PETT',
    Vlat: 'VLAT',
    Chot: 'CHOT',
    Ulat: 'ULAT',
    Tmt: 'TMT',
    Orat: 'ORAT',
    Almt: 'ALMT',
    Azt: 'AZT',
    Get: 'GET',
    Mut: 'MUT',
    Sct: 'SCT',
    Ret: 'RET',
    Mvt: 'MVT',
    Cct: 'CCT',
    Sast: 'SAST',
    Nst: 'NST',
    Ndt: 'NDT'
} as const;
export type GetProviderAvailabilityTimeZoneEnum = typeof GetProviderAvailabilityTimeZoneEnum[keyof typeof GetProviderAvailabilityTimeZoneEnum];
/**
 * @export
 */
export const GetProviderSlotsAvailabilityModeEnum = {
    InPerson: 'IN_PERSON',
    Virtual: 'VIRTUAL'
} as const;
export type GetProviderSlotsAvailabilityModeEnum = typeof GetProviderSlotsAvailabilityModeEnum[keyof typeof GetProviderSlotsAvailabilityModeEnum];
/**
 * @export
 */
export const GetProvidersSlotsAvailabilityModeEnum = {
    InPerson: 'IN_PERSON',
    Virtual: 'VIRTUAL'
} as const;
export type GetProvidersSlotsAvailabilityModeEnum = typeof GetProvidersSlotsAvailabilityModeEnum[keyof typeof GetProvidersSlotsAvailabilityModeEnum];
/**
 * @export
 */
export const GetWidgetProviderSlotsAvailabilityModeEnum = {
    InPerson: 'IN_PERSON',
    Virtual: 'VIRTUAL'
} as const;
export type GetWidgetProviderSlotsAvailabilityModeEnum = typeof GetWidgetProviderSlotsAvailabilityModeEnum[keyof typeof GetWidgetProviderSlotsAvailabilityModeEnum];


/**
 * CallRecordingControllerApi - axios parameter creator
 * @export
 */
export const CallRecordingControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get all Call Recording list for super admin with search option on name ,active, archive.
         * @summary Get all Call Recording.
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {string} [patientId] 
         * @param {string} [searchString] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllRecording: async (page?: number, size?: number, sortBy?: string, sortDirection?: string, patientId?: string, searchString?: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/master/call-recording`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }

            if (patientId !== undefined) {
                localVarQueryParameter['patientId'] = patientId;
            }

            if (searchString !== undefined) {
                localVarQueryParameter['searchString'] = searchString;
            }

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CallRecordingControllerApi - functional programming interface
 * @export
 */
export const CallRecordingControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CallRecordingControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * Get all Call Recording list for super admin with search option on name ,active, archive.
         * @summary Get all Call Recording.
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {string} [patientId] 
         * @param {string} [searchString] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllRecording(page?: number, size?: number, sortBy?: string, sortDirection?: string, patientId?: string, searchString?: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllRecording(page, size, sortBy, sortDirection, patientId, searchString, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CallRecordingControllerApi.getAllRecording']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CallRecordingControllerApi - factory interface
 * @export
 */
export const CallRecordingControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CallRecordingControllerApiFp(configuration)
    return {
        /**
         * Get all Call Recording list for super admin with search option on name ,active, archive.
         * @summary Get all Call Recording.
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {string} [patientId] 
         * @param {string} [searchString] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllRecording(page?: number, size?: number, sortBy?: string, sortDirection?: string, patientId?: string, searchString?: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getAllRecording(page, size, sortBy, sortDirection, patientId, searchString, xTENANTID, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CallRecordingControllerApi - object-oriented interface
 * @export
 * @class CallRecordingControllerApi
 * @extends {BaseAPI}
 */
export class CallRecordingControllerApi extends BaseAPI {
    /**
     * Get all Call Recording list for super admin with search option on name ,active, archive.
     * @summary Get all Call Recording.
     * @param {number} [page] 
     * @param {number} [size] 
     * @param {string} [sortBy] 
     * @param {string} [sortDirection] 
     * @param {string} [patientId] 
     * @param {string} [searchString] 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CallRecordingControllerApi
     */
    public getAllRecording(page?: number, size?: number, sortBy?: string, sortDirection?: string, patientId?: string, searchString?: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return CallRecordingControllerApiFp(this.configuration).getAllRecording(page, size, sortBy, sortDirection, patientId, searchString, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ChatMessageControllerApi - axios parameter creator
 * @export
 */
export const ChatMessageControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get all Chat Message with search option on current user.
         * @summary Get all Chat Message.
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {boolean} [archive] 
         * @param {string} [conversationId] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllChatMessage: async (page?: number, size?: number, sortBy?: string, sortDirection?: string, archive?: boolean, conversationId?: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/master/chat-message`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }

            if (archive !== undefined) {
                localVarQueryParameter['archive'] = archive;
            }

            if (conversationId !== undefined) {
                localVarQueryParameter['conversationId'] = conversationId;
            }

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Upload a file attachment for chat message. Returns S3 URL that can be used in WebSocket CHAT_MESSAGE.
         * @summary Upload chat attachment
         * @param {File} file 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadChatAttachment: async (file: File, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'file' is not null or undefined
            assertParamExists('uploadChatAttachment', 'file', file)
            const localVarPath = `/api/master/chat-message/upload-attachment`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ChatMessageControllerApi - functional programming interface
 * @export
 */
export const ChatMessageControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ChatMessageControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * Get all Chat Message with search option on current user.
         * @summary Get all Chat Message.
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {boolean} [archive] 
         * @param {string} [conversationId] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllChatMessage(page?: number, size?: number, sortBy?: string, sortDirection?: string, archive?: boolean, conversationId?: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllChatMessage(page, size, sortBy, sortDirection, archive, conversationId, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChatMessageControllerApi.getAllChatMessage']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Upload a file attachment for chat message. Returns S3 URL that can be used in WebSocket CHAT_MESSAGE.
         * @summary Upload chat attachment
         * @param {File} file 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadChatAttachment(file: File, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadChatAttachment(file, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChatMessageControllerApi.uploadChatAttachment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ChatMessageControllerApi - factory interface
 * @export
 */
export const ChatMessageControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ChatMessageControllerApiFp(configuration)
    return {
        /**
         * Get all Chat Message with search option on current user.
         * @summary Get all Chat Message.
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {boolean} [archive] 
         * @param {string} [conversationId] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllChatMessage(page?: number, size?: number, sortBy?: string, sortDirection?: string, archive?: boolean, conversationId?: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getAllChatMessage(page, size, sortBy, sortDirection, archive, conversationId, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Upload a file attachment for chat message. Returns S3 URL that can be used in WebSocket CHAT_MESSAGE.
         * @summary Upload chat attachment
         * @param {File} file 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadChatAttachment(file: File, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.uploadChatAttachment(file, xTENANTID, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ChatMessageControllerApi - object-oriented interface
 * @export
 * @class ChatMessageControllerApi
 * @extends {BaseAPI}
 */
export class ChatMessageControllerApi extends BaseAPI {
    /**
     * Get all Chat Message with search option on current user.
     * @summary Get all Chat Message.
     * @param {number} [page] 
     * @param {number} [size] 
     * @param {string} [sortBy] 
     * @param {string} [sortDirection] 
     * @param {boolean} [archive] 
     * @param {string} [conversationId] 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatMessageControllerApi
     */
    public getAllChatMessage(page?: number, size?: number, sortBy?: string, sortDirection?: string, archive?: boolean, conversationId?: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return ChatMessageControllerApiFp(this.configuration).getAllChatMessage(page, size, sortBy, sortDirection, archive, conversationId, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Upload a file attachment for chat message. Returns S3 URL that can be used in WebSocket CHAT_MESSAGE.
     * @summary Upload chat attachment
     * @param {File} file 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatMessageControllerApi
     */
    public uploadChatAttachment(file: File, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return ChatMessageControllerApiFp(this.configuration).uploadChatAttachment(file, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ClaimControllerApi - axios parameter creator
 * @export
 */
export const ClaimControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Loads each claim by UUID, scrubs it, and updates its scrub_status. Returns a per-claim result plus summary. Failed loads are reported as notFound items but do not abort the batch.
         * @summary Bulk scrub claims by UUIDs
         * @param {BulkScrubRequest} bulkScrubRequest 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkScrubClaims: async (bulkScrubRequest: BulkScrubRequest, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bulkScrubRequest' is not null or undefined
            assertParamExists('bulkScrubClaims', 'bulkScrubRequest', bulkScrubRequest)
            const localVarPath = `/api/master/claim/scrub/bulk`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bulkScrubRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a claim
         * @summary Create Claims
         * @param {Claim} claim 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createClaim1: async (claim: Claim, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'claim' is not null or undefined
            assertParamExists('createClaim1', 'claim', claim)
            const localVarPath = `/api/master/claim`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(claim, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} claimId 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        duplicateClaim: async (claimId: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'claimId' is not null or undefined
            assertParamExists('duplicateClaim', 'claimId', claimId)
            const localVarPath = `/api/master/claim/copy/{claimId}`
                .replace(`{${"claimId"}}`, encodeURIComponent(String(claimId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Export selected claims as CSV file
         * @summary Export claim list to CSV
         * @param {Array<string>} requestBody 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportClaimsCsv: async (requestBody: Array<string>, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'requestBody' is not null or undefined
            assertParamExists('exportClaimsCsv', 'requestBody', requestBody)
            const localVarPath = `/api/master/claim/list/export-csv`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all claim list. 
         * @summary Get all Claim
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {boolean} [status] 
         * @param {boolean} [archive] 
         * @param {Array<string>} [patientUuids] 
         * @param {Array<string>} [providerUuids] 
         * @param {string} [claimStatuses] 
         * @param {GetAllClaim1DateRangeEnum} [dateRange] 
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllClaim1: async (page?: number, size?: number, sortBy?: string, sortDirection?: string, status?: boolean, archive?: boolean, patientUuids?: Array<string>, providerUuids?: Array<string>, claimStatuses?: string, dateRange?: GetAllClaim1DateRangeEnum, startDate?: string, endDate?: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/master/claim`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (archive !== undefined) {
                localVarQueryParameter['archive'] = archive;
            }

            if (patientUuids) {
                localVarQueryParameter['patientUuids'] = patientUuids;
            }

            if (providerUuids) {
                localVarQueryParameter['providerUuids'] = providerUuids;
            }

            if (claimStatuses !== undefined) {
                localVarQueryParameter['claimStatuses'] = claimStatuses;
            }

            if (dateRange !== undefined) {
                localVarQueryParameter['dateRange'] = dateRange;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString() :
                    startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString() :
                    endDate;
            }

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all claim list (fast projection-based API)
         * @summary Get all Claim V2
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {boolean} [status] 
         * @param {boolean} [archive] 
         * @param {Array<string>} [patientUuids] 
         * @param {Array<string>} [providerUuids] 
         * @param {string} [claimStatuses] 
         * @param {string} [postingStatuses] 
         * @param {string} [dateRange] 
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {string} [patientName] 
         * @param {string} [scrubStatus] 
         * @param {Array<string>} [claimType] 
         * @param {string} [claimId] 
         * @param {boolean} [paymentPosted] 
         * @param {string} [payerId] 
         * @param {number} [remainingBalance] 
         * @param {string} [searchString] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllClaimV2: async (page?: number, size?: number, sortBy?: string, sortDirection?: string, status?: boolean, archive?: boolean, patientUuids?: Array<string>, providerUuids?: Array<string>, claimStatuses?: string, postingStatuses?: string, dateRange?: string, startDate?: string, endDate?: string, patientName?: string, scrubStatus?: string, claimType?: Array<string>, claimId?: string, paymentPosted?: boolean, payerId?: string, remainingBalance?: number, searchString?: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/master/claim/v2`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (archive !== undefined) {
                localVarQueryParameter['archive'] = archive;
            }

            if (patientUuids) {
                localVarQueryParameter['patientUuids'] = patientUuids;
            }

            if (providerUuids) {
                localVarQueryParameter['providerUuids'] = providerUuids;
            }

            if (claimStatuses !== undefined) {
                localVarQueryParameter['claimStatuses'] = claimStatuses;
            }

            if (postingStatuses !== undefined) {
                localVarQueryParameter['postingStatuses'] = postingStatuses;
            }

            if (dateRange !== undefined) {
                localVarQueryParameter['dateRange'] = dateRange;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString() :
                    startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString() :
                    endDate;
            }

            if (patientName !== undefined) {
                localVarQueryParameter['patientName'] = patientName;
            }

            if (scrubStatus !== undefined) {
                localVarQueryParameter['scrubStatus'] = scrubStatus;
            }

            if (claimType) {
                localVarQueryParameter['claimType'] = claimType;
            }

            if (claimId !== undefined) {
                localVarQueryParameter['claimId'] = claimId;
            }

            if (paymentPosted !== undefined) {
                localVarQueryParameter['paymentPosted'] = paymentPosted;
            }

            if (payerId !== undefined) {
                localVarQueryParameter['payerId'] = payerId;
            }

            if (remainingBalance !== undefined) {
                localVarQueryParameter['remainingBalance'] = remainingBalance;
            }

            if (searchString !== undefined) {
                localVarQueryParameter['searchString'] = searchString;
            }

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all claim list using EntityGraph for performance testing.
         * @summary Get all Claim (EntityGraph)
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {boolean} [status] 
         * @param {boolean} [archive] 
         * @param {Array<string>} [patientUuids] 
         * @param {Array<string>} [providerUuids] 
         * @param {string} [claimStatuses] 
         * @param {GetAllClaimWithEntityGraphDateRangeEnum} [dateRange] 
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllClaimWithEntityGraph: async (page?: number, size?: number, sortBy?: string, sortDirection?: string, status?: boolean, archive?: boolean, patientUuids?: Array<string>, providerUuids?: Array<string>, claimStatuses?: string, dateRange?: GetAllClaimWithEntityGraphDateRangeEnum, startDate?: string, endDate?: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/master/claim/entity-graph`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (archive !== undefined) {
                localVarQueryParameter['archive'] = archive;
            }

            if (patientUuids) {
                localVarQueryParameter['patientUuids'] = patientUuids;
            }

            if (providerUuids) {
                localVarQueryParameter['providerUuids'] = providerUuids;
            }

            if (claimStatuses !== undefined) {
                localVarQueryParameter['claimStatuses'] = claimStatuses;
            }

            if (dateRange !== undefined) {
                localVarQueryParameter['dateRange'] = dateRange;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString() :
                    startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString() :
                    endDate;
            }

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get claim by claimId
         * @summary Get claim by claimId.
         * @param {string} claimUuid 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClaimById: async (claimUuid: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'claimUuid' is not null or undefined
            assertParamExists('getClaimById', 'claimUuid', claimUuid)
            const localVarPath = `/api/master/claim/{claimUuid}`
                .replace(`{${"claimUuid"}}`, encodeURIComponent(String(claimUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Lightweight claim-by-id: claim-level totals only for the Claim tab
         * @summary Get claim by claimId (lightweight).
         * @param {string} claimUuid 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClaimByIdLite: async (claimUuid: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'claimUuid' is not null or undefined
            assertParamExists('getClaimByIdLite', 'claimUuid', claimUuid)
            const localVarPath = `/api/master/claim/{claimUuid}/liteWeight`
                .replace(`{${"claimUuid"}}`, encodeURIComponent(String(claimUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClaimList: async (xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/master/claim/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Lightweight claim list API
         * @summary Get claim list lite
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {Array<string>} [providerUuids] 
         * @param {Array<string>} [insuranceUuids] 
         * @param {Array<string>} [claimStatuses] 
         * @param {Array<string>} [locationUuids] 
         * @param {Array<string>} [cptCodes] 
         * @param {string} [searchKey] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClaimListLite: async (page?: number, size?: number, sortBy?: string, sortDirection?: string, startDate?: string, endDate?: string, providerUuids?: Array<string>, insuranceUuids?: Array<string>, claimStatuses?: Array<string>, locationUuids?: Array<string>, cptCodes?: Array<string>, searchKey?: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/master/claim/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString() :
                    startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString() :
                    endDate;
            }

            if (providerUuids) {
                localVarQueryParameter['providerUuids'] = providerUuids;
            }

            if (insuranceUuids) {
                localVarQueryParameter['insuranceUuids'] = insuranceUuids;
            }

            if (claimStatuses) {
                localVarQueryParameter['claimStatuses'] = claimStatuses;
            }

            if (locationUuids) {
                localVarQueryParameter['locationUuids'] = locationUuids;
            }

            if (cptCodes) {
                localVarQueryParameter['cptCodes'] = cptCodes;
            }

            if (searchKey !== undefined) {
                localVarQueryParameter['searchKey'] = searchKey;
            }

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Summary: total claims, total billed, total paid
         * @summary Get claim list lite summary
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {Array<string>} [providerUuids] 
         * @param {Array<string>} [insuranceUuids] 
         * @param {Array<string>} [claimStatuses] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClaimListLiteSummary: async (startDate?: string, endDate?: string, providerUuids?: Array<string>, insuranceUuids?: Array<string>, claimStatuses?: Array<string>, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/master/claim/list/summary`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString() :
                    startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString() :
                    endDate;
            }

            if (providerUuids) {
                localVarQueryParameter['providerUuids'] = providerUuids;
            }

            if (insuranceUuids) {
                localVarQueryParameter['insuranceUuids'] = insuranceUuids;
            }

            if (claimStatuses) {
                localVarQueryParameter['claimStatuses'] = claimStatuses;
            }

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get claim counts by status
         * @param {string} [claimType] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClaimStatusCounts: async (claimType?: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/master/claim/status-counts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (claimType !== undefined) {
                localVarQueryParameter['claimType'] = claimType;
            }

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get claim details for a list of claim UUIDs
         * @summary Get claims by UUIDs
         * @param {Array<string>} claimUuids 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClaimsByUuids: async (claimUuids: Array<string>, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'claimUuids' is not null or undefined
            assertParamExists('getClaimsByUuids', 'claimUuids', claimUuids)
            const localVarPath = `/api/master/claim/lists`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (claimUuids) {
                localVarQueryParameter['claimUuids'] = claimUuids;
            }

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Claims of the given patient whose ERA/EOB posting is complete (posting status PAID). Partially posted, unposted and denied claims are excluded.
         * @summary Eligible claims for a PR invoice
         * @param {string} patientUuid 
         * @param {string} [appointmentUuid] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPrEligibleClaims: async (patientUuid: string, appointmentUuid?: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientUuid' is not null or undefined
            assertParamExists('getPrEligibleClaims', 'patientUuid', patientUuid)
            const localVarPath = `/api/master/claim/pr-claims`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (patientUuid !== undefined) {
                localVarQueryParameter['patientUuid'] = patientUuid;
            }

            if (appointmentUuid !== undefined) {
                localVarQueryParameter['appointmentUuid'] = appointmentUuid;
            }

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Validate claim payload against scrubbing rules. Returns list of field errors if any; otherwise success.
         * @summary Scrub claim
         * @param {Claim} claim 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        scrubClaim: async (claim: Claim, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'claim' is not null or undefined
            assertParamExists('scrubClaim', 'claim', claim)
            const localVarPath = `/api/master/claim/scrub`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(claim, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Edit claim. Claim scrubbing is run first; if validation fails, scrub errors are returned and claim is not updated.
         * @summary Update claim
         * @param {Claim} claim 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateClaim: async (claim: Claim, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'claim' is not null or undefined
            assertParamExists('updateClaim', 'claim', claim)
            const localVarPath = `/api/master/claim`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(claim, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update claim with acknowledgment information from 277 response files
         * @summary Update claim acknowledgment
         * @param {UpdateClaimWithAckRequest} updateClaimWithAckRequest 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateClaimAck: async (updateClaimWithAckRequest: UpdateClaimWithAckRequest, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'updateClaimWithAckRequest' is not null or undefined
            assertParamExists('updateClaimAck', 'updateClaimWithAckRequest', updateClaimWithAckRequest)
            const localVarPath = `/api/master/claim/update/ack`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateClaimWithAckRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update claim by its ID
         * @summary update claim type
         * @param {string} claimId 
         * @param {string} claimType 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateClaimArchiveStatus: async (claimId: string, claimType: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'claimId' is not null or undefined
            assertParamExists('updateClaimArchiveStatus', 'claimId', claimId)
            // verify required parameter 'claimType' is not null or undefined
            assertParamExists('updateClaimArchiveStatus', 'claimType', claimType)
            const localVarPath = `/api/master/claim/{claimId}/{claimType}`
                .replace(`{${"claimId"}}`, encodeURIComponent(String(claimId)))
                .replace(`{${"claimType"}}`, encodeURIComponent(String(claimType)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Archive a claim by its ID
         * @summary Archive claim
         * @param {string} claimId 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateClaimArchiveStatus1: async (claimId: string, status: boolean, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'claimId' is not null or undefined
            assertParamExists('updateClaimArchiveStatus1', 'claimId', claimId)
            // verify required parameter 'status' is not null or undefined
            assertParamExists('updateClaimArchiveStatus1', 'status', status)
            const localVarPath = `/api/master/claim/{claimId}/archive-status/{status}`
                .replace(`{${"claimId"}}`, encodeURIComponent(String(claimId)))
                .replace(`{${"status"}}`, encodeURIComponent(String(status)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update claim status by claim ID
         * @summary Update claim status
         * @param {string} claimId 
         * @param {string} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateClaimStatus: async (claimId: string, status: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'claimId' is not null or undefined
            assertParamExists('updateClaimStatus', 'claimId', claimId)
            // verify required parameter 'status' is not null or undefined
            assertParamExists('updateClaimStatus', 'status', status)
            const localVarPath = `/api/master/claim/{claimId}/claim-status/{status}`
                .replace(`{${"claimId"}}`, encodeURIComponent(String(claimId)))
                .replace(`{${"status"}}`, encodeURIComponent(String(status)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ClaimControllerApi - functional programming interface
 * @export
 */
export const ClaimControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ClaimControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * Loads each claim by UUID, scrubs it, and updates its scrub_status. Returns a per-claim result plus summary. Failed loads are reported as notFound items but do not abort the batch.
         * @summary Bulk scrub claims by UUIDs
         * @param {BulkScrubRequest} bulkScrubRequest 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bulkScrubClaims(bulkScrubRequest: BulkScrubRequest, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bulkScrubClaims(bulkScrubRequest, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClaimControllerApi.bulkScrubClaims']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create a claim
         * @summary Create Claims
         * @param {Claim} claim 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createClaim1(claim: Claim, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createClaim1(claim, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClaimControllerApi.createClaim1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} claimId 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async duplicateClaim(claimId: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.duplicateClaim(claimId, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClaimControllerApi.duplicateClaim']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Export selected claims as CSV file
         * @summary Export claim list to CSV
         * @param {Array<string>} requestBody 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exportClaimsCsv(requestBody: Array<string>, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.exportClaimsCsv(requestBody, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClaimControllerApi.exportClaimsCsv']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get all claim list. 
         * @summary Get all Claim
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {boolean} [status] 
         * @param {boolean} [archive] 
         * @param {Array<string>} [patientUuids] 
         * @param {Array<string>} [providerUuids] 
         * @param {string} [claimStatuses] 
         * @param {GetAllClaim1DateRangeEnum} [dateRange] 
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllClaim1(page?: number, size?: number, sortBy?: string, sortDirection?: string, status?: boolean, archive?: boolean, patientUuids?: Array<string>, providerUuids?: Array<string>, claimStatuses?: string, dateRange?: GetAllClaim1DateRangeEnum, startDate?: string, endDate?: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllClaim1(page, size, sortBy, sortDirection, status, archive, patientUuids, providerUuids, claimStatuses, dateRange, startDate, endDate, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClaimControllerApi.getAllClaim1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get all claim list (fast projection-based API)
         * @summary Get all Claim V2
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {boolean} [status] 
         * @param {boolean} [archive] 
         * @param {Array<string>} [patientUuids] 
         * @param {Array<string>} [providerUuids] 
         * @param {string} [claimStatuses] 
         * @param {string} [postingStatuses] 
         * @param {string} [dateRange] 
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {string} [patientName] 
         * @param {string} [scrubStatus] 
         * @param {Array<string>} [claimType] 
         * @param {string} [claimId] 
         * @param {boolean} [paymentPosted] 
         * @param {string} [payerId] 
         * @param {number} [remainingBalance] 
         * @param {string} [searchString] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllClaimV2(page?: number, size?: number, sortBy?: string, sortDirection?: string, status?: boolean, archive?: boolean, patientUuids?: Array<string>, providerUuids?: Array<string>, claimStatuses?: string, postingStatuses?: string, dateRange?: string, startDate?: string, endDate?: string, patientName?: string, scrubStatus?: string, claimType?: Array<string>, claimId?: string, paymentPosted?: boolean, payerId?: string, remainingBalance?: number, searchString?: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllClaimV2(page, size, sortBy, sortDirection, status, archive, patientUuids, providerUuids, claimStatuses, postingStatuses, dateRange, startDate, endDate, patientName, scrubStatus, claimType, claimId, paymentPosted, payerId, remainingBalance, searchString, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClaimControllerApi.getAllClaimV2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get all claim list using EntityGraph for performance testing.
         * @summary Get all Claim (EntityGraph)
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {boolean} [status] 
         * @param {boolean} [archive] 
         * @param {Array<string>} [patientUuids] 
         * @param {Array<string>} [providerUuids] 
         * @param {string} [claimStatuses] 
         * @param {GetAllClaimWithEntityGraphDateRangeEnum} [dateRange] 
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllClaimWithEntityGraph(page?: number, size?: number, sortBy?: string, sortDirection?: string, status?: boolean, archive?: boolean, patientUuids?: Array<string>, providerUuids?: Array<string>, claimStatuses?: string, dateRange?: GetAllClaimWithEntityGraphDateRangeEnum, startDate?: string, endDate?: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllClaimWithEntityGraph(page, size, sortBy, sortDirection, status, archive, patientUuids, providerUuids, claimStatuses, dateRange, startDate, endDate, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClaimControllerApi.getAllClaimWithEntityGraph']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get claim by claimId
         * @summary Get claim by claimId.
         * @param {string} claimUuid 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getClaimById(claimUuid: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getClaimById(claimUuid, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClaimControllerApi.getClaimById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Lightweight claim-by-id: claim-level totals only for the Claim tab
         * @summary Get claim by claimId (lightweight).
         * @param {string} claimUuid 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getClaimByIdLite(claimUuid: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getClaimByIdLite(claimUuid, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClaimControllerApi.getClaimByIdLite']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getClaimList(xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getClaimList(xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClaimControllerApi.getClaimList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Lightweight claim list API
         * @summary Get claim list lite
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {Array<string>} [providerUuids] 
         * @param {Array<string>} [insuranceUuids] 
         * @param {Array<string>} [claimStatuses] 
         * @param {Array<string>} [locationUuids] 
         * @param {Array<string>} [cptCodes] 
         * @param {string} [searchKey] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getClaimListLite(page?: number, size?: number, sortBy?: string, sortDirection?: string, startDate?: string, endDate?: string, providerUuids?: Array<string>, insuranceUuids?: Array<string>, claimStatuses?: Array<string>, locationUuids?: Array<string>, cptCodes?: Array<string>, searchKey?: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getClaimListLite(page, size, sortBy, sortDirection, startDate, endDate, providerUuids, insuranceUuids, claimStatuses, locationUuids, cptCodes, searchKey, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClaimControllerApi.getClaimListLite']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Summary: total claims, total billed, total paid
         * @summary Get claim list lite summary
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {Array<string>} [providerUuids] 
         * @param {Array<string>} [insuranceUuids] 
         * @param {Array<string>} [claimStatuses] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getClaimListLiteSummary(startDate?: string, endDate?: string, providerUuids?: Array<string>, insuranceUuids?: Array<string>, claimStatuses?: Array<string>, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getClaimListLiteSummary(startDate, endDate, providerUuids, insuranceUuids, claimStatuses, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClaimControllerApi.getClaimListLiteSummary']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get claim counts by status
         * @param {string} [claimType] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getClaimStatusCounts(claimType?: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getClaimStatusCounts(claimType, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClaimControllerApi.getClaimStatusCounts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get claim details for a list of claim UUIDs
         * @summary Get claims by UUIDs
         * @param {Array<string>} claimUuids 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getClaimsByUuids(claimUuids: Array<string>, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getClaimsByUuids(claimUuids, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClaimControllerApi.getClaimsByUuids']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Claims of the given patient whose ERA/EOB posting is complete (posting status PAID). Partially posted, unposted and denied claims are excluded.
         * @summary Eligible claims for a PR invoice
         * @param {string} patientUuid 
         * @param {string} [appointmentUuid] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPrEligibleClaims(patientUuid: string, appointmentUuid?: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPrEligibleClaims(patientUuid, appointmentUuid, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClaimControllerApi.getPrEligibleClaims']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Validate claim payload against scrubbing rules. Returns list of field errors if any; otherwise success.
         * @summary Scrub claim
         * @param {Claim} claim 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async scrubClaim(claim: Claim, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.scrubClaim(claim, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClaimControllerApi.scrubClaim']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Edit claim. Claim scrubbing is run first; if validation fails, scrub errors are returned and claim is not updated.
         * @summary Update claim
         * @param {Claim} claim 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateClaim(claim: Claim, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateClaim(claim, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClaimControllerApi.updateClaim']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update claim with acknowledgment information from 277 response files
         * @summary Update claim acknowledgment
         * @param {UpdateClaimWithAckRequest} updateClaimWithAckRequest 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateClaimAck(updateClaimWithAckRequest: UpdateClaimWithAckRequest, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateClaimAck(updateClaimWithAckRequest, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClaimControllerApi.updateClaimAck']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update claim by its ID
         * @summary update claim type
         * @param {string} claimId 
         * @param {string} claimType 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateClaimArchiveStatus(claimId: string, claimType: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateClaimArchiveStatus(claimId, claimType, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClaimControllerApi.updateClaimArchiveStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Archive a claim by its ID
         * @summary Archive claim
         * @param {string} claimId 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateClaimArchiveStatus1(claimId: string, status: boolean, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateClaimArchiveStatus1(claimId, status, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClaimControllerApi.updateClaimArchiveStatus1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update claim status by claim ID
         * @summary Update claim status
         * @param {string} claimId 
         * @param {string} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateClaimStatus(claimId: string, status: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateClaimStatus(claimId, status, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClaimControllerApi.updateClaimStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ClaimControllerApi - factory interface
 * @export
 */
export const ClaimControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ClaimControllerApiFp(configuration)
    return {
        /**
         * Loads each claim by UUID, scrubs it, and updates its scrub_status. Returns a per-claim result plus summary. Failed loads are reported as notFound items but do not abort the batch.
         * @summary Bulk scrub claims by UUIDs
         * @param {BulkScrubRequest} bulkScrubRequest 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkScrubClaims(bulkScrubRequest: BulkScrubRequest, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.bulkScrubClaims(bulkScrubRequest, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a claim
         * @summary Create Claims
         * @param {Claim} claim 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createClaim1(claim: Claim, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.createClaim1(claim, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} claimId 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        duplicateClaim(claimId: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.duplicateClaim(claimId, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Export selected claims as CSV file
         * @summary Export claim list to CSV
         * @param {Array<string>} requestBody 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportClaimsCsv(requestBody: Array<string>, xTENANTID?: string, options?: any): AxiosPromise<string> {
            return localVarFp.exportClaimsCsv(requestBody, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all claim list. 
         * @summary Get all Claim
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {boolean} [status] 
         * @param {boolean} [archive] 
         * @param {Array<string>} [patientUuids] 
         * @param {Array<string>} [providerUuids] 
         * @param {string} [claimStatuses] 
         * @param {GetAllClaim1DateRangeEnum} [dateRange] 
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllClaim1(page?: number, size?: number, sortBy?: string, sortDirection?: string, status?: boolean, archive?: boolean, patientUuids?: Array<string>, providerUuids?: Array<string>, claimStatuses?: string, dateRange?: GetAllClaim1DateRangeEnum, startDate?: string, endDate?: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getAllClaim1(page, size, sortBy, sortDirection, status, archive, patientUuids, providerUuids, claimStatuses, dateRange, startDate, endDate, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all claim list (fast projection-based API)
         * @summary Get all Claim V2
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {boolean} [status] 
         * @param {boolean} [archive] 
         * @param {Array<string>} [patientUuids] 
         * @param {Array<string>} [providerUuids] 
         * @param {string} [claimStatuses] 
         * @param {string} [postingStatuses] 
         * @param {string} [dateRange] 
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {string} [patientName] 
         * @param {string} [scrubStatus] 
         * @param {Array<string>} [claimType] 
         * @param {string} [claimId] 
         * @param {boolean} [paymentPosted] 
         * @param {string} [payerId] 
         * @param {number} [remainingBalance] 
         * @param {string} [searchString] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllClaimV2(page?: number, size?: number, sortBy?: string, sortDirection?: string, status?: boolean, archive?: boolean, patientUuids?: Array<string>, providerUuids?: Array<string>, claimStatuses?: string, postingStatuses?: string, dateRange?: string, startDate?: string, endDate?: string, patientName?: string, scrubStatus?: string, claimType?: Array<string>, claimId?: string, paymentPosted?: boolean, payerId?: string, remainingBalance?: number, searchString?: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getAllClaimV2(page, size, sortBy, sortDirection, status, archive, patientUuids, providerUuids, claimStatuses, postingStatuses, dateRange, startDate, endDate, patientName, scrubStatus, claimType, claimId, paymentPosted, payerId, remainingBalance, searchString, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all claim list using EntityGraph for performance testing.
         * @summary Get all Claim (EntityGraph)
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {boolean} [status] 
         * @param {boolean} [archive] 
         * @param {Array<string>} [patientUuids] 
         * @param {Array<string>} [providerUuids] 
         * @param {string} [claimStatuses] 
         * @param {GetAllClaimWithEntityGraphDateRangeEnum} [dateRange] 
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllClaimWithEntityGraph(page?: number, size?: number, sortBy?: string, sortDirection?: string, status?: boolean, archive?: boolean, patientUuids?: Array<string>, providerUuids?: Array<string>, claimStatuses?: string, dateRange?: GetAllClaimWithEntityGraphDateRangeEnum, startDate?: string, endDate?: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getAllClaimWithEntityGraph(page, size, sortBy, sortDirection, status, archive, patientUuids, providerUuids, claimStatuses, dateRange, startDate, endDate, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Get claim by claimId
         * @summary Get claim by claimId.
         * @param {string} claimUuid 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClaimById(claimUuid: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getClaimById(claimUuid, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Lightweight claim-by-id: claim-level totals only for the Claim tab
         * @summary Get claim by claimId (lightweight).
         * @param {string} claimUuid 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClaimByIdLite(claimUuid: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getClaimByIdLite(claimUuid, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClaimList(xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getClaimList(xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Lightweight claim list API
         * @summary Get claim list lite
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {Array<string>} [providerUuids] 
         * @param {Array<string>} [insuranceUuids] 
         * @param {Array<string>} [claimStatuses] 
         * @param {Array<string>} [locationUuids] 
         * @param {Array<string>} [cptCodes] 
         * @param {string} [searchKey] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClaimListLite(page?: number, size?: number, sortBy?: string, sortDirection?: string, startDate?: string, endDate?: string, providerUuids?: Array<string>, insuranceUuids?: Array<string>, claimStatuses?: Array<string>, locationUuids?: Array<string>, cptCodes?: Array<string>, searchKey?: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getClaimListLite(page, size, sortBy, sortDirection, startDate, endDate, providerUuids, insuranceUuids, claimStatuses, locationUuids, cptCodes, searchKey, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Summary: total claims, total billed, total paid
         * @summary Get claim list lite summary
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {Array<string>} [providerUuids] 
         * @param {Array<string>} [insuranceUuids] 
         * @param {Array<string>} [claimStatuses] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClaimListLiteSummary(startDate?: string, endDate?: string, providerUuids?: Array<string>, insuranceUuids?: Array<string>, claimStatuses?: Array<string>, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getClaimListLiteSummary(startDate, endDate, providerUuids, insuranceUuids, claimStatuses, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get claim counts by status
         * @param {string} [claimType] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClaimStatusCounts(claimType?: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getClaimStatusCounts(claimType, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Get claim details for a list of claim UUIDs
         * @summary Get claims by UUIDs
         * @param {Array<string>} claimUuids 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClaimsByUuids(claimUuids: Array<string>, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getClaimsByUuids(claimUuids, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Claims of the given patient whose ERA/EOB posting is complete (posting status PAID). Partially posted, unposted and denied claims are excluded.
         * @summary Eligible claims for a PR invoice
         * @param {string} patientUuid 
         * @param {string} [appointmentUuid] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPrEligibleClaims(patientUuid: string, appointmentUuid?: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getPrEligibleClaims(patientUuid, appointmentUuid, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Validate claim payload against scrubbing rules. Returns list of field errors if any; otherwise success.
         * @summary Scrub claim
         * @param {Claim} claim 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        scrubClaim(claim: Claim, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.scrubClaim(claim, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Edit claim. Claim scrubbing is run first; if validation fails, scrub errors are returned and claim is not updated.
         * @summary Update claim
         * @param {Claim} claim 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateClaim(claim: Claim, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.updateClaim(claim, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Update claim with acknowledgment information from 277 response files
         * @summary Update claim acknowledgment
         * @param {UpdateClaimWithAckRequest} updateClaimWithAckRequest 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateClaimAck(updateClaimWithAckRequest: UpdateClaimWithAckRequest, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.updateClaimAck(updateClaimWithAckRequest, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Update claim by its ID
         * @summary update claim type
         * @param {string} claimId 
         * @param {string} claimType 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateClaimArchiveStatus(claimId: string, claimType: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.updateClaimArchiveStatus(claimId, claimType, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Archive a claim by its ID
         * @summary Archive claim
         * @param {string} claimId 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateClaimArchiveStatus1(claimId: string, status: boolean, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.updateClaimArchiveStatus1(claimId, status, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Update claim status by claim ID
         * @summary Update claim status
         * @param {string} claimId 
         * @param {string} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateClaimStatus(claimId: string, status: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.updateClaimStatus(claimId, status, xTENANTID, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ClaimControllerApi - object-oriented interface
 * @export
 * @class ClaimControllerApi
 * @extends {BaseAPI}
 */
export class ClaimControllerApi extends BaseAPI {
    /**
     * Loads each claim by UUID, scrubs it, and updates its scrub_status. Returns a per-claim result plus summary. Failed loads are reported as notFound items but do not abort the batch.
     * @summary Bulk scrub claims by UUIDs
     * @param {BulkScrubRequest} bulkScrubRequest 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimControllerApi
     */
    public bulkScrubClaims(bulkScrubRequest: BulkScrubRequest, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return ClaimControllerApiFp(this.configuration).bulkScrubClaims(bulkScrubRequest, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create a claim
     * @summary Create Claims
     * @param {Claim} claim 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimControllerApi
     */
    public createClaim1(claim: Claim, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return ClaimControllerApiFp(this.configuration).createClaim1(claim, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} claimId 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimControllerApi
     */
    public duplicateClaim(claimId: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return ClaimControllerApiFp(this.configuration).duplicateClaim(claimId, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Export selected claims as CSV file
     * @summary Export claim list to CSV
     * @param {Array<string>} requestBody 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimControllerApi
     */
    public exportClaimsCsv(requestBody: Array<string>, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return ClaimControllerApiFp(this.configuration).exportClaimsCsv(requestBody, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all claim list. 
     * @summary Get all Claim
     * @param {number} [page] 
     * @param {number} [size] 
     * @param {string} [sortBy] 
     * @param {string} [sortDirection] 
     * @param {boolean} [status] 
     * @param {boolean} [archive] 
     * @param {Array<string>} [patientUuids] 
     * @param {Array<string>} [providerUuids] 
     * @param {string} [claimStatuses] 
     * @param {GetAllClaim1DateRangeEnum} [dateRange] 
     * @param {string} [startDate] 
     * @param {string} [endDate] 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimControllerApi
     */
    public getAllClaim1(page?: number, size?: number, sortBy?: string, sortDirection?: string, status?: boolean, archive?: boolean, patientUuids?: Array<string>, providerUuids?: Array<string>, claimStatuses?: string, dateRange?: GetAllClaim1DateRangeEnum, startDate?: string, endDate?: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return ClaimControllerApiFp(this.configuration).getAllClaim1(page, size, sortBy, sortDirection, status, archive, patientUuids, providerUuids, claimStatuses, dateRange, startDate, endDate, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all claim list (fast projection-based API)
     * @summary Get all Claim V2
     * @param {number} [page] 
     * @param {number} [size] 
     * @param {string} [sortBy] 
     * @param {string} [sortDirection] 
     * @param {boolean} [status] 
     * @param {boolean} [archive] 
     * @param {Array<string>} [patientUuids] 
     * @param {Array<string>} [providerUuids] 
     * @param {string} [claimStatuses] 
     * @param {string} [postingStatuses] 
     * @param {string} [dateRange] 
     * @param {string} [startDate] 
     * @param {string} [endDate] 
     * @param {string} [patientName] 
     * @param {string} [scrubStatus] 
     * @param {Array<string>} [claimType] 
     * @param {string} [claimId] 
     * @param {boolean} [paymentPosted] 
     * @param {string} [payerId] 
     * @param {number} [remainingBalance] 
     * @param {string} [searchString] 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimControllerApi
     */
    public getAllClaimV2(page?: number, size?: number, sortBy?: string, sortDirection?: string, status?: boolean, archive?: boolean, patientUuids?: Array<string>, providerUuids?: Array<string>, claimStatuses?: string, postingStatuses?: string, dateRange?: string, startDate?: string, endDate?: string, patientName?: string, scrubStatus?: string, claimType?: Array<string>, claimId?: string, paymentPosted?: boolean, payerId?: string, remainingBalance?: number, searchString?: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return ClaimControllerApiFp(this.configuration).getAllClaimV2(page, size, sortBy, sortDirection, status, archive, patientUuids, providerUuids, claimStatuses, postingStatuses, dateRange, startDate, endDate, patientName, scrubStatus, claimType, claimId, paymentPosted, payerId, remainingBalance, searchString, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all claim list using EntityGraph for performance testing.
     * @summary Get all Claim (EntityGraph)
     * @param {number} [page] 
     * @param {number} [size] 
     * @param {string} [sortBy] 
     * @param {string} [sortDirection] 
     * @param {boolean} [status] 
     * @param {boolean} [archive] 
     * @param {Array<string>} [patientUuids] 
     * @param {Array<string>} [providerUuids] 
     * @param {string} [claimStatuses] 
     * @param {GetAllClaimWithEntityGraphDateRangeEnum} [dateRange] 
     * @param {string} [startDate] 
     * @param {string} [endDate] 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimControllerApi
     */
    public getAllClaimWithEntityGraph(page?: number, size?: number, sortBy?: string, sortDirection?: string, status?: boolean, archive?: boolean, patientUuids?: Array<string>, providerUuids?: Array<string>, claimStatuses?: string, dateRange?: GetAllClaimWithEntityGraphDateRangeEnum, startDate?: string, endDate?: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return ClaimControllerApiFp(this.configuration).getAllClaimWithEntityGraph(page, size, sortBy, sortDirection, status, archive, patientUuids, providerUuids, claimStatuses, dateRange, startDate, endDate, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get claim by claimId
     * @summary Get claim by claimId.
     * @param {string} claimUuid 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimControllerApi
     */
    public getClaimById(claimUuid: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return ClaimControllerApiFp(this.configuration).getClaimById(claimUuid, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Lightweight claim-by-id: claim-level totals only for the Claim tab
     * @summary Get claim by claimId (lightweight).
     * @param {string} claimUuid 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimControllerApi
     */
    public getClaimByIdLite(claimUuid: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return ClaimControllerApiFp(this.configuration).getClaimByIdLite(claimUuid, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimControllerApi
     */
    public getClaimList(xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return ClaimControllerApiFp(this.configuration).getClaimList(xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Lightweight claim list API
     * @summary Get claim list lite
     * @param {number} [page] 
     * @param {number} [size] 
     * @param {string} [sortBy] 
     * @param {string} [sortDirection] 
     * @param {string} [startDate] 
     * @param {string} [endDate] 
     * @param {Array<string>} [providerUuids] 
     * @param {Array<string>} [insuranceUuids] 
     * @param {Array<string>} [claimStatuses] 
     * @param {Array<string>} [locationUuids] 
     * @param {Array<string>} [cptCodes] 
     * @param {string} [searchKey] 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimControllerApi
     */
    public getClaimListLite(page?: number, size?: number, sortBy?: string, sortDirection?: string, startDate?: string, endDate?: string, providerUuids?: Array<string>, insuranceUuids?: Array<string>, claimStatuses?: Array<string>, locationUuids?: Array<string>, cptCodes?: Array<string>, searchKey?: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return ClaimControllerApiFp(this.configuration).getClaimListLite(page, size, sortBy, sortDirection, startDate, endDate, providerUuids, insuranceUuids, claimStatuses, locationUuids, cptCodes, searchKey, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Summary: total claims, total billed, total paid
     * @summary Get claim list lite summary
     * @param {string} [startDate] 
     * @param {string} [endDate] 
     * @param {Array<string>} [providerUuids] 
     * @param {Array<string>} [insuranceUuids] 
     * @param {Array<string>} [claimStatuses] 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimControllerApi
     */
    public getClaimListLiteSummary(startDate?: string, endDate?: string, providerUuids?: Array<string>, insuranceUuids?: Array<string>, claimStatuses?: Array<string>, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return ClaimControllerApiFp(this.configuration).getClaimListLiteSummary(startDate, endDate, providerUuids, insuranceUuids, claimStatuses, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get claim counts by status
     * @param {string} [claimType] 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimControllerApi
     */
    public getClaimStatusCounts(claimType?: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return ClaimControllerApiFp(this.configuration).getClaimStatusCounts(claimType, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get claim details for a list of claim UUIDs
     * @summary Get claims by UUIDs
     * @param {Array<string>} claimUuids 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimControllerApi
     */
    public getClaimsByUuids(claimUuids: Array<string>, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return ClaimControllerApiFp(this.configuration).getClaimsByUuids(claimUuids, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Claims of the given patient whose ERA/EOB posting is complete (posting status PAID). Partially posted, unposted and denied claims are excluded.
     * @summary Eligible claims for a PR invoice
     * @param {string} patientUuid 
     * @param {string} [appointmentUuid] 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimControllerApi
     */
    public getPrEligibleClaims(patientUuid: string, appointmentUuid?: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return ClaimControllerApiFp(this.configuration).getPrEligibleClaims(patientUuid, appointmentUuid, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Validate claim payload against scrubbing rules. Returns list of field errors if any; otherwise success.
     * @summary Scrub claim
     * @param {Claim} claim 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimControllerApi
     */
    public scrubClaim(claim: Claim, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return ClaimControllerApiFp(this.configuration).scrubClaim(claim, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Edit claim. Claim scrubbing is run first; if validation fails, scrub errors are returned and claim is not updated.
     * @summary Update claim
     * @param {Claim} claim 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimControllerApi
     */
    public updateClaim(claim: Claim, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return ClaimControllerApiFp(this.configuration).updateClaim(claim, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update claim with acknowledgment information from 277 response files
     * @summary Update claim acknowledgment
     * @param {UpdateClaimWithAckRequest} updateClaimWithAckRequest 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimControllerApi
     */
    public updateClaimAck(updateClaimWithAckRequest: UpdateClaimWithAckRequest, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return ClaimControllerApiFp(this.configuration).updateClaimAck(updateClaimWithAckRequest, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update claim by its ID
     * @summary update claim type
     * @param {string} claimId 
     * @param {string} claimType 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimControllerApi
     */
    public updateClaimArchiveStatus(claimId: string, claimType: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return ClaimControllerApiFp(this.configuration).updateClaimArchiveStatus(claimId, claimType, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Archive a claim by its ID
     * @summary Archive claim
     * @param {string} claimId 
     * @param {boolean} status 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimControllerApi
     */
    public updateClaimArchiveStatus1(claimId: string, status: boolean, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return ClaimControllerApiFp(this.configuration).updateClaimArchiveStatus1(claimId, status, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update claim status by claim ID
     * @summary Update claim status
     * @param {string} claimId 
     * @param {string} status 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimControllerApi
     */
    public updateClaimStatus(claimId: string, status: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return ClaimControllerApiFp(this.configuration).updateClaimStatus(claimId, status, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const GetAllClaim1DateRangeEnum = {
    Today: 'TODAY',
    Yesterday: 'YESTERDAY',
    Last7Days: 'LAST_7_DAYS',
    Last30Days: 'LAST_30_DAYS',
    Last90Days: 'LAST_90_DAYS',
    ThisMonth: 'THIS_MONTH',
    LastMonth: 'LAST_MONTH',
    CustomRange: 'CUSTOM_RANGE'
} as const;
export type GetAllClaim1DateRangeEnum = typeof GetAllClaim1DateRangeEnum[keyof typeof GetAllClaim1DateRangeEnum];
/**
 * @export
 */
export const GetAllClaimWithEntityGraphDateRangeEnum = {
    Today: 'TODAY',
    Yesterday: 'YESTERDAY',
    Last7Days: 'LAST_7_DAYS',
    Last30Days: 'LAST_30_DAYS',
    Last90Days: 'LAST_90_DAYS',
    ThisMonth: 'THIS_MONTH',
    LastMonth: 'LAST_MONTH',
    CustomRange: 'CUSTOM_RANGE'
} as const;
export type GetAllClaimWithEntityGraphDateRangeEnum = typeof GetAllClaimWithEntityGraphDateRangeEnum[keyof typeof GetAllClaimWithEntityGraphDateRangeEnum];


/**
 * ClaimIntegrationControllerApi - axios parameter creator
 * @export
 */
export const ClaimIntegrationControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Add a new Claim Integration Configuration
         * @summary Add Claim Integration Configuration
         * @param {ClaimIntegrationDto} claimIntegrationDto 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addConfiguration1: async (claimIntegrationDto: ClaimIntegrationDto, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'claimIntegrationDto' is not null or undefined
            assertParamExists('addConfiguration1', 'claimIntegrationDto', claimIntegrationDto)
            const localVarPath = `/api/master/claim-integration`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(claimIntegrationDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve a Claim Integration by its unique ID
         * @summary Get Claim Integration by ID
         * @param {string} claimIntegrationId 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClaimIntegrationById: async (claimIntegrationId: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'claimIntegrationId' is not null or undefined
            assertParamExists('getClaimIntegrationById', 'claimIntegrationId', claimIntegrationId)
            const localVarPath = `/api/master/claim-integration/{claimIntegrationId}`
                .replace(`{${"claimIntegrationId"}}`, encodeURIComponent(String(claimIntegrationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all Claim Integration Configurations for Current Tenant
         * @summary Get All Claim Integration Configurations for Current Tenant
         * @param {boolean} [archive] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConfigurations1: async (archive?: boolean, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/master/claim-integration`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (archive !== undefined) {
                localVarQueryParameter['archive'] = archive;
            }

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Archive a Claim Integration by its ID
         * @summary Archive Claim Integration
         * @param {string} claimIntegrationId 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateClaimIntegrationArchiveStatus: async (claimIntegrationId: string, status: boolean, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'claimIntegrationId' is not null or undefined
            assertParamExists('updateClaimIntegrationArchiveStatus', 'claimIntegrationId', claimIntegrationId)
            // verify required parameter 'status' is not null or undefined
            assertParamExists('updateClaimIntegrationArchiveStatus', 'status', status)
            const localVarPath = `/api/master/claim-integration/{claimIntegrationId}/archive-status/{status}`
                .replace(`{${"claimIntegrationId"}}`, encodeURIComponent(String(claimIntegrationId)))
                .replace(`{${"status"}}`, encodeURIComponent(String(status)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update an existing Claim Integration Configuration
         * @summary Update Claim Integration Configuration
         * @param {ClaimIntegrationDto} claimIntegrationDto 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateConfiguration1: async (claimIntegrationDto: ClaimIntegrationDto, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'claimIntegrationDto' is not null or undefined
            assertParamExists('updateConfiguration1', 'claimIntegrationDto', claimIntegrationDto)
            const localVarPath = `/api/master/claim-integration`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(claimIntegrationDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ClaimIntegrationControllerApi - functional programming interface
 * @export
 */
export const ClaimIntegrationControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ClaimIntegrationControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * Add a new Claim Integration Configuration
         * @summary Add Claim Integration Configuration
         * @param {ClaimIntegrationDto} claimIntegrationDto 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addConfiguration1(claimIntegrationDto: ClaimIntegrationDto, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addConfiguration1(claimIntegrationDto, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClaimIntegrationControllerApi.addConfiguration1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve a Claim Integration by its unique ID
         * @summary Get Claim Integration by ID
         * @param {string} claimIntegrationId 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getClaimIntegrationById(claimIntegrationId: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getClaimIntegrationById(claimIntegrationId, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClaimIntegrationControllerApi.getClaimIntegrationById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get all Claim Integration Configurations for Current Tenant
         * @summary Get All Claim Integration Configurations for Current Tenant
         * @param {boolean} [archive] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getConfigurations1(archive?: boolean, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getConfigurations1(archive, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClaimIntegrationControllerApi.getConfigurations1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Archive a Claim Integration by its ID
         * @summary Archive Claim Integration
         * @param {string} claimIntegrationId 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateClaimIntegrationArchiveStatus(claimIntegrationId: string, status: boolean, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateClaimIntegrationArchiveStatus(claimIntegrationId, status, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClaimIntegrationControllerApi.updateClaimIntegrationArchiveStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update an existing Claim Integration Configuration
         * @summary Update Claim Integration Configuration
         * @param {ClaimIntegrationDto} claimIntegrationDto 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateConfiguration1(claimIntegrationDto: ClaimIntegrationDto, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateConfiguration1(claimIntegrationDto, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClaimIntegrationControllerApi.updateConfiguration1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ClaimIntegrationControllerApi - factory interface
 * @export
 */
export const ClaimIntegrationControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ClaimIntegrationControllerApiFp(configuration)
    return {
        /**
         * Add a new Claim Integration Configuration
         * @summary Add Claim Integration Configuration
         * @param {ClaimIntegrationDto} claimIntegrationDto 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addConfiguration1(claimIntegrationDto: ClaimIntegrationDto, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.addConfiguration1(claimIntegrationDto, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve a Claim Integration by its unique ID
         * @summary Get Claim Integration by ID
         * @param {string} claimIntegrationId 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClaimIntegrationById(claimIntegrationId: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getClaimIntegrationById(claimIntegrationId, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all Claim Integration Configurations for Current Tenant
         * @summary Get All Claim Integration Configurations for Current Tenant
         * @param {boolean} [archive] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConfigurations1(archive?: boolean, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getConfigurations1(archive, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Archive a Claim Integration by its ID
         * @summary Archive Claim Integration
         * @param {string} claimIntegrationId 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateClaimIntegrationArchiveStatus(claimIntegrationId: string, status: boolean, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.updateClaimIntegrationArchiveStatus(claimIntegrationId, status, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Update an existing Claim Integration Configuration
         * @summary Update Claim Integration Configuration
         * @param {ClaimIntegrationDto} claimIntegrationDto 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateConfiguration1(claimIntegrationDto: ClaimIntegrationDto, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.updateConfiguration1(claimIntegrationDto, xTENANTID, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ClaimIntegrationControllerApi - object-oriented interface
 * @export
 * @class ClaimIntegrationControllerApi
 * @extends {BaseAPI}
 */
export class ClaimIntegrationControllerApi extends BaseAPI {
    /**
     * Add a new Claim Integration Configuration
     * @summary Add Claim Integration Configuration
     * @param {ClaimIntegrationDto} claimIntegrationDto 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimIntegrationControllerApi
     */
    public addConfiguration1(claimIntegrationDto: ClaimIntegrationDto, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return ClaimIntegrationControllerApiFp(this.configuration).addConfiguration1(claimIntegrationDto, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve a Claim Integration by its unique ID
     * @summary Get Claim Integration by ID
     * @param {string} claimIntegrationId 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimIntegrationControllerApi
     */
    public getClaimIntegrationById(claimIntegrationId: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return ClaimIntegrationControllerApiFp(this.configuration).getClaimIntegrationById(claimIntegrationId, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all Claim Integration Configurations for Current Tenant
     * @summary Get All Claim Integration Configurations for Current Tenant
     * @param {boolean} [archive] 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimIntegrationControllerApi
     */
    public getConfigurations1(archive?: boolean, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return ClaimIntegrationControllerApiFp(this.configuration).getConfigurations1(archive, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Archive a Claim Integration by its ID
     * @summary Archive Claim Integration
     * @param {string} claimIntegrationId 
     * @param {boolean} status 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimIntegrationControllerApi
     */
    public updateClaimIntegrationArchiveStatus(claimIntegrationId: string, status: boolean, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return ClaimIntegrationControllerApiFp(this.configuration).updateClaimIntegrationArchiveStatus(claimIntegrationId, status, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update an existing Claim Integration Configuration
     * @summary Update Claim Integration Configuration
     * @param {ClaimIntegrationDto} claimIntegrationDto 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimIntegrationControllerApi
     */
    public updateConfiguration1(claimIntegrationDto: ClaimIntegrationDto, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return ClaimIntegrationControllerApiFp(this.configuration).updateConfiguration1(claimIntegrationDto, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ClaimsControllerApi - axios parameter creator
 * @export
 */
export const ClaimsControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Submit multiple electronic claims to clearinghouse vendor
         * @summary Submit electronic Claims
         * @param {ClaimRequest} claimRequest 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createClaim: async (claimRequest: ClaimRequest, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'claimRequest' is not null or undefined
            assertParamExists('createClaim', 'claimRequest', claimRequest)
            const localVarPath = `/api/master/electronic-claim`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(claimRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ClaimsControllerApi - functional programming interface
 * @export
 */
export const ClaimsControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ClaimsControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * Submit multiple electronic claims to clearinghouse vendor
         * @summary Submit electronic Claims
         * @param {ClaimRequest} claimRequest 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createClaim(claimRequest: ClaimRequest, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createClaim(claimRequest, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClaimsControllerApi.createClaim']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ClaimsControllerApi - factory interface
 * @export
 */
export const ClaimsControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ClaimsControllerApiFp(configuration)
    return {
        /**
         * Submit multiple electronic claims to clearinghouse vendor
         * @summary Submit electronic Claims
         * @param {ClaimRequest} claimRequest 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createClaim(claimRequest: ClaimRequest, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.createClaim(claimRequest, xTENANTID, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ClaimsControllerApi - object-oriented interface
 * @export
 * @class ClaimsControllerApi
 * @extends {BaseAPI}
 */
export class ClaimsControllerApi extends BaseAPI {
    /**
     * Submit multiple electronic claims to clearinghouse vendor
     * @summary Submit electronic Claims
     * @param {ClaimRequest} claimRequest 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimsControllerApi
     */
    public createClaim(claimRequest: ClaimRequest, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return ClaimsControllerApiFp(this.configuration).createClaim(claimRequest, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ClinicalNotesControllerApi - axios parameter creator
 * @export
 */
export const ClinicalNotesControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Saves clinical notes data to various patient tables (allergy, medication, history, etc.)
         * @summary Save clinical notes to database
         * @param {ClinicalNotesSaveRequest} clinicalNotesSaveRequest 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveClinicalNotes: async (clinicalNotesSaveRequest: ClinicalNotesSaveRequest, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'clinicalNotesSaveRequest' is not null or undefined
            assertParamExists('saveClinicalNotes', 'clinicalNotesSaveRequest', clinicalNotesSaveRequest)
            const localVarPath = `/api/master/clinical-notes/save`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(clinicalNotesSaveRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ClinicalNotesControllerApi - functional programming interface
 * @export
 */
export const ClinicalNotesControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ClinicalNotesControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * Saves clinical notes data to various patient tables (allergy, medication, history, etc.)
         * @summary Save clinical notes to database
         * @param {ClinicalNotesSaveRequest} clinicalNotesSaveRequest 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveClinicalNotes(clinicalNotesSaveRequest: ClinicalNotesSaveRequest, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveClinicalNotes(clinicalNotesSaveRequest, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClinicalNotesControllerApi.saveClinicalNotes']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ClinicalNotesControllerApi - factory interface
 * @export
 */
export const ClinicalNotesControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ClinicalNotesControllerApiFp(configuration)
    return {
        /**
         * Saves clinical notes data to various patient tables (allergy, medication, history, etc.)
         * @summary Save clinical notes to database
         * @param {ClinicalNotesSaveRequest} clinicalNotesSaveRequest 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveClinicalNotes(clinicalNotesSaveRequest: ClinicalNotesSaveRequest, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.saveClinicalNotes(clinicalNotesSaveRequest, xTENANTID, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ClinicalNotesControllerApi - object-oriented interface
 * @export
 * @class ClinicalNotesControllerApi
 * @extends {BaseAPI}
 */
export class ClinicalNotesControllerApi extends BaseAPI {
    /**
     * Saves clinical notes data to various patient tables (allergy, medication, history, etc.)
     * @summary Save clinical notes to database
     * @param {ClinicalNotesSaveRequest} clinicalNotesSaveRequest 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClinicalNotesControllerApi
     */
    public saveClinicalNotes(clinicalNotesSaveRequest: ClinicalNotesSaveRequest, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return ClinicalNotesControllerApiFp(this.configuration).saveClinicalNotes(clinicalNotesSaveRequest, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ClinicalSummaryLinkControllerApi - axios parameter creator
 * @export
 */
export const ClinicalSummaryLinkControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Link clinical data (allergy, medication, vaccine, care plan, vitals, history) to a specific appointment. For HISTORY type, historyType field is required (MEDICAL_HISTORY, SURGICAL_HISTORY, FAMILY_HISTORY). This allows users to search clinical data by appointment ID later.
         * @summary Link Clinical Data to Appointment
         * @param {ClinicalSummaryLinkRequest} clinicalSummaryLinkRequest 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        linkClinicalDataToAppointment: async (clinicalSummaryLinkRequest: ClinicalSummaryLinkRequest, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'clinicalSummaryLinkRequest' is not null or undefined
            assertParamExists('linkClinicalDataToAppointment', 'clinicalSummaryLinkRequest', clinicalSummaryLinkRequest)
            const localVarPath = `/api/master/clinical-summary-link/link`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(clinicalSummaryLinkRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ClinicalSummaryLinkControllerApi - functional programming interface
 * @export
 */
export const ClinicalSummaryLinkControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ClinicalSummaryLinkControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * Link clinical data (allergy, medication, vaccine, care plan, vitals, history) to a specific appointment. For HISTORY type, historyType field is required (MEDICAL_HISTORY, SURGICAL_HISTORY, FAMILY_HISTORY). This allows users to search clinical data by appointment ID later.
         * @summary Link Clinical Data to Appointment
         * @param {ClinicalSummaryLinkRequest} clinicalSummaryLinkRequest 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async linkClinicalDataToAppointment(clinicalSummaryLinkRequest: ClinicalSummaryLinkRequest, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.linkClinicalDataToAppointment(clinicalSummaryLinkRequest, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClinicalSummaryLinkControllerApi.linkClinicalDataToAppointment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ClinicalSummaryLinkControllerApi - factory interface
 * @export
 */
export const ClinicalSummaryLinkControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ClinicalSummaryLinkControllerApiFp(configuration)
    return {
        /**
         * Link clinical data (allergy, medication, vaccine, care plan, vitals, history) to a specific appointment. For HISTORY type, historyType field is required (MEDICAL_HISTORY, SURGICAL_HISTORY, FAMILY_HISTORY). This allows users to search clinical data by appointment ID later.
         * @summary Link Clinical Data to Appointment
         * @param {ClinicalSummaryLinkRequest} clinicalSummaryLinkRequest 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        linkClinicalDataToAppointment(clinicalSummaryLinkRequest: ClinicalSummaryLinkRequest, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.linkClinicalDataToAppointment(clinicalSummaryLinkRequest, xTENANTID, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ClinicalSummaryLinkControllerApi - object-oriented interface
 * @export
 * @class ClinicalSummaryLinkControllerApi
 * @extends {BaseAPI}
 */
export class ClinicalSummaryLinkControllerApi extends BaseAPI {
    /**
     * Link clinical data (allergy, medication, vaccine, care plan, vitals, history) to a specific appointment. For HISTORY type, historyType field is required (MEDICAL_HISTORY, SURGICAL_HISTORY, FAMILY_HISTORY). This allows users to search clinical data by appointment ID later.
     * @summary Link Clinical Data to Appointment
     * @param {ClinicalSummaryLinkRequest} clinicalSummaryLinkRequest 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClinicalSummaryLinkControllerApi
     */
    public linkClinicalDataToAppointment(clinicalSummaryLinkRequest: ClinicalSummaryLinkRequest, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return ClinicalSummaryLinkControllerApiFp(this.configuration).linkClinicalDataToAppointment(clinicalSummaryLinkRequest, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ContactDictionaryControllerApi - axios parameter creator
 * @export
 */
export const ContactDictionaryControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Add a new contact dictionary entry into the system
         * @summary Add Contact Dictionary
         * @param {ContactDictionary} contactDictionary 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createContactDictionary: async (contactDictionary: ContactDictionary, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'contactDictionary' is not null or undefined
            assertParamExists('createContactDictionary', 'contactDictionary', contactDictionary)
            const localVarPath = `/api/master/contact-dictionary`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(contactDictionary, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all contact dictionary entries with filters and search
         * @summary Get all Contact Dictionary entries
         * @param {number} [page] Page number (0-based)
         * @param {number} [size] Page size
         * @param {string} [sortBy] Sort field
         * @param {string} [sort] Sort direction (asc/desc)
         * @param {boolean} [active] Filter by active status
         * @param {boolean} [archive] Filter by archive status
         * @param {string} [searchString] Search string for firstName, lastName, fullName, contactNumber, faxNumber, email
         * @param {GetAllContactDictionariesContactTypeEnum} [contactType] Filter by contact type
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllContactDictionaries: async (page?: number, size?: number, sortBy?: string, sort?: string, active?: boolean, archive?: boolean, searchString?: string, contactType?: GetAllContactDictionariesContactTypeEnum, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/master/contact-dictionary`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (active !== undefined) {
                localVarQueryParameter['active'] = active;
            }

            if (archive !== undefined) {
                localVarQueryParameter['archive'] = archive;
            }

            if (searchString !== undefined) {
                localVarQueryParameter['searchString'] = searchString;
            }

            if (contactType !== undefined) {
                localVarQueryParameter['contactType'] = contactType;
            }

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve a contact dictionary entry by its unique ID
         * @summary Get Contact Dictionary by ID
         * @param {string} contactDictionaryId 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getContactDictionaryById: async (contactDictionaryId: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'contactDictionaryId' is not null or undefined
            assertParamExists('getContactDictionaryById', 'contactDictionaryId', contactDictionaryId)
            const localVarPath = `/api/master/contact-dictionary/{contactDictionaryId}`
                .replace(`{${"contactDictionaryId"}}`, encodeURIComponent(String(contactDictionaryId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update an existing contact dictionary entry
         * @summary Update Contact Dictionary
         * @param {ContactDictionary} contactDictionary 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateContactDictionary: async (contactDictionary: ContactDictionary, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'contactDictionary' is not null or undefined
            assertParamExists('updateContactDictionary', 'contactDictionary', contactDictionary)
            const localVarPath = `/api/master/contact-dictionary`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(contactDictionary, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Archive or unarchive a contact dictionary entry by its ID
         * @summary Update Contact Dictionary Archive Status
         * @param {string} contactDictionaryId 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateContactDictionaryArchiveStatus: async (contactDictionaryId: string, status: boolean, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'contactDictionaryId' is not null or undefined
            assertParamExists('updateContactDictionaryArchiveStatus', 'contactDictionaryId', contactDictionaryId)
            // verify required parameter 'status' is not null or undefined
            assertParamExists('updateContactDictionaryArchiveStatus', 'status', status)
            const localVarPath = `/api/master/contact-dictionary/{contactDictionaryId}/archive-status/{status}`
                .replace(`{${"contactDictionaryId"}}`, encodeURIComponent(String(contactDictionaryId)))
                .replace(`{${"status"}}`, encodeURIComponent(String(status)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Enable or disable a contact dictionary entry by its ID
         * @summary Update Contact Dictionary Status
         * @param {string} contactDictionaryId 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateContactDictionaryStatus: async (contactDictionaryId: string, status: boolean, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'contactDictionaryId' is not null or undefined
            assertParamExists('updateContactDictionaryStatus', 'contactDictionaryId', contactDictionaryId)
            // verify required parameter 'status' is not null or undefined
            assertParamExists('updateContactDictionaryStatus', 'status', status)
            const localVarPath = `/api/master/contact-dictionary/{contactDictionaryId}/status/{status}`
                .replace(`{${"contactDictionaryId"}}`, encodeURIComponent(String(contactDictionaryId)))
                .replace(`{${"status"}}`, encodeURIComponent(String(status)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ContactDictionaryControllerApi - functional programming interface
 * @export
 */
export const ContactDictionaryControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ContactDictionaryControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * Add a new contact dictionary entry into the system
         * @summary Add Contact Dictionary
         * @param {ContactDictionary} contactDictionary 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createContactDictionary(contactDictionary: ContactDictionary, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createContactDictionary(contactDictionary, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContactDictionaryControllerApi.createContactDictionary']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get all contact dictionary entries with filters and search
         * @summary Get all Contact Dictionary entries
         * @param {number} [page] Page number (0-based)
         * @param {number} [size] Page size
         * @param {string} [sortBy] Sort field
         * @param {string} [sort] Sort direction (asc/desc)
         * @param {boolean} [active] Filter by active status
         * @param {boolean} [archive] Filter by archive status
         * @param {string} [searchString] Search string for firstName, lastName, fullName, contactNumber, faxNumber, email
         * @param {GetAllContactDictionariesContactTypeEnum} [contactType] Filter by contact type
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllContactDictionaries(page?: number, size?: number, sortBy?: string, sort?: string, active?: boolean, archive?: boolean, searchString?: string, contactType?: GetAllContactDictionariesContactTypeEnum, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllContactDictionaries(page, size, sortBy, sort, active, archive, searchString, contactType, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContactDictionaryControllerApi.getAllContactDictionaries']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve a contact dictionary entry by its unique ID
         * @summary Get Contact Dictionary by ID
         * @param {string} contactDictionaryId 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getContactDictionaryById(contactDictionaryId: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getContactDictionaryById(contactDictionaryId, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContactDictionaryControllerApi.getContactDictionaryById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update an existing contact dictionary entry
         * @summary Update Contact Dictionary
         * @param {ContactDictionary} contactDictionary 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateContactDictionary(contactDictionary: ContactDictionary, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateContactDictionary(contactDictionary, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContactDictionaryControllerApi.updateContactDictionary']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Archive or unarchive a contact dictionary entry by its ID
         * @summary Update Contact Dictionary Archive Status
         * @param {string} contactDictionaryId 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateContactDictionaryArchiveStatus(contactDictionaryId: string, status: boolean, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateContactDictionaryArchiveStatus(contactDictionaryId, status, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContactDictionaryControllerApi.updateContactDictionaryArchiveStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Enable or disable a contact dictionary entry by its ID
         * @summary Update Contact Dictionary Status
         * @param {string} contactDictionaryId 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateContactDictionaryStatus(contactDictionaryId: string, status: boolean, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateContactDictionaryStatus(contactDictionaryId, status, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContactDictionaryControllerApi.updateContactDictionaryStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ContactDictionaryControllerApi - factory interface
 * @export
 */
export const ContactDictionaryControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ContactDictionaryControllerApiFp(configuration)
    return {
        /**
         * Add a new contact dictionary entry into the system
         * @summary Add Contact Dictionary
         * @param {ContactDictionary} contactDictionary 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createContactDictionary(contactDictionary: ContactDictionary, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.createContactDictionary(contactDictionary, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all contact dictionary entries with filters and search
         * @summary Get all Contact Dictionary entries
         * @param {number} [page] Page number (0-based)
         * @param {number} [size] Page size
         * @param {string} [sortBy] Sort field
         * @param {string} [sort] Sort direction (asc/desc)
         * @param {boolean} [active] Filter by active status
         * @param {boolean} [archive] Filter by archive status
         * @param {string} [searchString] Search string for firstName, lastName, fullName, contactNumber, faxNumber, email
         * @param {GetAllContactDictionariesContactTypeEnum} [contactType] Filter by contact type
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllContactDictionaries(page?: number, size?: number, sortBy?: string, sort?: string, active?: boolean, archive?: boolean, searchString?: string, contactType?: GetAllContactDictionariesContactTypeEnum, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getAllContactDictionaries(page, size, sortBy, sort, active, archive, searchString, contactType, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve a contact dictionary entry by its unique ID
         * @summary Get Contact Dictionary by ID
         * @param {string} contactDictionaryId 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getContactDictionaryById(contactDictionaryId: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getContactDictionaryById(contactDictionaryId, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Update an existing contact dictionary entry
         * @summary Update Contact Dictionary
         * @param {ContactDictionary} contactDictionary 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateContactDictionary(contactDictionary: ContactDictionary, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.updateContactDictionary(contactDictionary, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Archive or unarchive a contact dictionary entry by its ID
         * @summary Update Contact Dictionary Archive Status
         * @param {string} contactDictionaryId 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateContactDictionaryArchiveStatus(contactDictionaryId: string, status: boolean, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.updateContactDictionaryArchiveStatus(contactDictionaryId, status, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Enable or disable a contact dictionary entry by its ID
         * @summary Update Contact Dictionary Status
         * @param {string} contactDictionaryId 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateContactDictionaryStatus(contactDictionaryId: string, status: boolean, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.updateContactDictionaryStatus(contactDictionaryId, status, xTENANTID, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ContactDictionaryControllerApi - object-oriented interface
 * @export
 * @class ContactDictionaryControllerApi
 * @extends {BaseAPI}
 */
export class ContactDictionaryControllerApi extends BaseAPI {
    /**
     * Add a new contact dictionary entry into the system
     * @summary Add Contact Dictionary
     * @param {ContactDictionary} contactDictionary 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContactDictionaryControllerApi
     */
    public createContactDictionary(contactDictionary: ContactDictionary, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return ContactDictionaryControllerApiFp(this.configuration).createContactDictionary(contactDictionary, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all contact dictionary entries with filters and search
     * @summary Get all Contact Dictionary entries
     * @param {number} [page] Page number (0-based)
     * @param {number} [size] Page size
     * @param {string} [sortBy] Sort field
     * @param {string} [sort] Sort direction (asc/desc)
     * @param {boolean} [active] Filter by active status
     * @param {boolean} [archive] Filter by archive status
     * @param {string} [searchString] Search string for firstName, lastName, fullName, contactNumber, faxNumber, email
     * @param {GetAllContactDictionariesContactTypeEnum} [contactType] Filter by contact type
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContactDictionaryControllerApi
     */
    public getAllContactDictionaries(page?: number, size?: number, sortBy?: string, sort?: string, active?: boolean, archive?: boolean, searchString?: string, contactType?: GetAllContactDictionariesContactTypeEnum, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return ContactDictionaryControllerApiFp(this.configuration).getAllContactDictionaries(page, size, sortBy, sort, active, archive, searchString, contactType, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve a contact dictionary entry by its unique ID
     * @summary Get Contact Dictionary by ID
     * @param {string} contactDictionaryId 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContactDictionaryControllerApi
     */
    public getContactDictionaryById(contactDictionaryId: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return ContactDictionaryControllerApiFp(this.configuration).getContactDictionaryById(contactDictionaryId, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update an existing contact dictionary entry
     * @summary Update Contact Dictionary
     * @param {ContactDictionary} contactDictionary 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContactDictionaryControllerApi
     */
    public updateContactDictionary(contactDictionary: ContactDictionary, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return ContactDictionaryControllerApiFp(this.configuration).updateContactDictionary(contactDictionary, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Archive or unarchive a contact dictionary entry by its ID
     * @summary Update Contact Dictionary Archive Status
     * @param {string} contactDictionaryId 
     * @param {boolean} status 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContactDictionaryControllerApi
     */
    public updateContactDictionaryArchiveStatus(contactDictionaryId: string, status: boolean, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return ContactDictionaryControllerApiFp(this.configuration).updateContactDictionaryArchiveStatus(contactDictionaryId, status, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Enable or disable a contact dictionary entry by its ID
     * @summary Update Contact Dictionary Status
     * @param {string} contactDictionaryId 
     * @param {boolean} status 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContactDictionaryControllerApi
     */
    public updateContactDictionaryStatus(contactDictionaryId: string, status: boolean, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return ContactDictionaryControllerApiFp(this.configuration).updateContactDictionaryStatus(contactDictionaryId, status, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const GetAllContactDictionariesContactTypeEnum = {
    Lab: 'LAB',
    Clinic: 'CLINIC',
    Vendor: 'VENDOR',
    Pharmacy: 'PHARMACY',
    Provider: 'PROVIDER',
    Staff: 'STAFF',
    Patient: 'PATIENT',
    Other: 'OTHER',
    InsurancePayer: 'INSURANCE_PAYER'
} as const;
export type GetAllContactDictionariesContactTypeEnum = typeof GetAllContactDictionariesContactTypeEnum[keyof typeof GetAllContactDictionariesContactTypeEnum];


/**
 * ConversationControllerApi - axios parameter creator
 * @export
 */
export const ConversationControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Add a new Conversation into the system.
         * @summary Add Conversation
         * @param {Conversation} conversation 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createConversation: async (conversation: Conversation, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'conversation' is not null or undefined
            assertParamExists('createConversation', 'conversation', conversation)
            const localVarPath = `/api/master/conversation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(conversation, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all Conversations list for the logged-in user (provider or patient). Filter participant2Provider toggles patient vs provider counterparty.
         * @summary Get all Conversation.
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {boolean} [archive] 
         * @param {string} [providerId] 
         * @param {boolean} [participant2Provider] 
         * @param {string} [searchString] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllDepartments3: async (page?: number, size?: number, sortBy?: string, sortDirection?: string, archive?: boolean, providerId?: string, participant2Provider?: boolean, searchString?: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/master/conversation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }

            if (archive !== undefined) {
                localVarQueryParameter['archive'] = archive;
            }

            if (providerId !== undefined) {
                localVarQueryParameter['providerId'] = providerId;
            }

            if (participant2Provider !== undefined) {
                localVarQueryParameter['participant2Provider'] = participant2Provider;
            }

            if (searchString !== undefined) {
                localVarQueryParameter['searchString'] = searchString;
            }

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get the total count of unread messages for a specific provider across all their conversations
         * @summary Get unread message count for provider
         * @param {string} providerId 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUnreadMessageCount: async (providerId: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'providerId' is not null or undefined
            assertParamExists('getUnreadMessageCount', 'providerId', providerId)
            const localVarPath = `/api/master/conversation/unread-count/{providerId}`
                .replace(`{${"providerId"}}`, encodeURIComponent(String(providerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ConversationControllerApi - functional programming interface
 * @export
 */
export const ConversationControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ConversationControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * Add a new Conversation into the system.
         * @summary Add Conversation
         * @param {Conversation} conversation 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createConversation(conversation: Conversation, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createConversation(conversation, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConversationControllerApi.createConversation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get all Conversations list for the logged-in user (provider or patient). Filter participant2Provider toggles patient vs provider counterparty.
         * @summary Get all Conversation.
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {boolean} [archive] 
         * @param {string} [providerId] 
         * @param {boolean} [participant2Provider] 
         * @param {string} [searchString] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllDepartments3(page?: number, size?: number, sortBy?: string, sortDirection?: string, archive?: boolean, providerId?: string, participant2Provider?: boolean, searchString?: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllDepartments3(page, size, sortBy, sortDirection, archive, providerId, participant2Provider, searchString, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConversationControllerApi.getAllDepartments3']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get the total count of unread messages for a specific provider across all their conversations
         * @summary Get unread message count for provider
         * @param {string} providerId 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUnreadMessageCount(providerId: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUnreadMessageCount(providerId, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConversationControllerApi.getUnreadMessageCount']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ConversationControllerApi - factory interface
 * @export
 */
export const ConversationControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ConversationControllerApiFp(configuration)
    return {
        /**
         * Add a new Conversation into the system.
         * @summary Add Conversation
         * @param {Conversation} conversation 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createConversation(conversation: Conversation, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.createConversation(conversation, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all Conversations list for the logged-in user (provider or patient). Filter participant2Provider toggles patient vs provider counterparty.
         * @summary Get all Conversation.
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {boolean} [archive] 
         * @param {string} [providerId] 
         * @param {boolean} [participant2Provider] 
         * @param {string} [searchString] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllDepartments3(page?: number, size?: number, sortBy?: string, sortDirection?: string, archive?: boolean, providerId?: string, participant2Provider?: boolean, searchString?: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getAllDepartments3(page, size, sortBy, sortDirection, archive, providerId, participant2Provider, searchString, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Get the total count of unread messages for a specific provider across all their conversations
         * @summary Get unread message count for provider
         * @param {string} providerId 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUnreadMessageCount(providerId: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getUnreadMessageCount(providerId, xTENANTID, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ConversationControllerApi - object-oriented interface
 * @export
 * @class ConversationControllerApi
 * @extends {BaseAPI}
 */
export class ConversationControllerApi extends BaseAPI {
    /**
     * Add a new Conversation into the system.
     * @summary Add Conversation
     * @param {Conversation} conversation 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConversationControllerApi
     */
    public createConversation(conversation: Conversation, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return ConversationControllerApiFp(this.configuration).createConversation(conversation, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all Conversations list for the logged-in user (provider or patient). Filter participant2Provider toggles patient vs provider counterparty.
     * @summary Get all Conversation.
     * @param {number} [page] 
     * @param {number} [size] 
     * @param {string} [sortBy] 
     * @param {string} [sortDirection] 
     * @param {boolean} [archive] 
     * @param {string} [providerId] 
     * @param {boolean} [participant2Provider] 
     * @param {string} [searchString] 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConversationControllerApi
     */
    public getAllDepartments3(page?: number, size?: number, sortBy?: string, sortDirection?: string, archive?: boolean, providerId?: string, participant2Provider?: boolean, searchString?: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return ConversationControllerApiFp(this.configuration).getAllDepartments3(page, size, sortBy, sortDirection, archive, providerId, participant2Provider, searchString, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get the total count of unread messages for a specific provider across all their conversations
     * @summary Get unread message count for provider
     * @param {string} providerId 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConversationControllerApi
     */
    public getUnreadMessageCount(providerId: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return ConversationControllerApiFp(this.configuration).getUnreadMessageCount(providerId, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * CustomFormControllerApi - axios parameter creator
 * @export
 */
export const CustomFormControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * create custom form into the system
         * @summary create custom form
         * @param {CustomForm} customForm 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCustomForm: async (customForm: CustomForm, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customForm' is not null or undefined
            assertParamExists('createCustomForm', 'customForm', customForm)
            const localVarPath = `/api/master/custom-form`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(customForm, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * get all custom form version from the system
         * @summary get all custom form with version
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {GetAllCustomFormsFormTypeEnum} [formType] 
         * @param {string} [searchString] 
         * @param {boolean} [active] 
         * @param {boolean} [archive] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllCustomForms: async (page?: number, size?: number, sortBy?: string, sortDirection?: string, formType?: GetAllCustomFormsFormTypeEnum, searchString?: string, active?: boolean, archive?: boolean, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/master/custom-form`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }

            if (formType !== undefined) {
                localVarQueryParameter['formType'] = formType;
            }

            if (searchString !== undefined) {
                localVarQueryParameter['searchString'] = searchString;
            }

            if (active !== undefined) {
                localVarQueryParameter['active'] = active;
            }

            if (archive !== undefined) {
                localVarQueryParameter['archive'] = archive;
            }

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * get custom form all version from the system
         * @summary get custom form with all version
         * @param {string} customFormId 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomFormByUuid: async (customFormId: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customFormId' is not null or undefined
            assertParamExists('getCustomFormByUuid', 'customFormId', customFormId)
            const localVarPath = `/api/master/custom-form/{customFormId}`
                .replace(`{${"customFormId"}}`, encodeURIComponent(String(customFormId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * import default custom form
         * @summary import default custom form
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importDefaultCustomForm: async (xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/master/custom-form/import-default-forms`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * update custom form archive status from system
         * @summary update custom form archive status
         * @param {string} customFormId 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateArchiveStatus2: async (customFormId: string, status: boolean, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customFormId' is not null or undefined
            assertParamExists('updateArchiveStatus2', 'customFormId', customFormId)
            // verify required parameter 'status' is not null or undefined
            assertParamExists('updateArchiveStatus2', 'status', status)
            const localVarPath = `/api/master/custom-form/{customFormId}/archive-status/{status}`
                .replace(`{${"customFormId"}}`, encodeURIComponent(String(customFormId)))
                .replace(`{${"status"}}`, encodeURIComponent(String(status)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * update custom form version into the system
         * @summary update custom form version
         * @param {CustomForm} customForm 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCustomForm1: async (customForm: CustomForm, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customForm' is not null or undefined
            assertParamExists('updateCustomForm1', 'customForm', customForm)
            const localVarPath = `/api/master/custom-form`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(customForm, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * update custom form status from system
         * @summary update custom form status
         * @param {string} customFormId 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateStatus2: async (customFormId: string, status: boolean, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customFormId' is not null or undefined
            assertParamExists('updateStatus2', 'customFormId', customFormId)
            // verify required parameter 'status' is not null or undefined
            assertParamExists('updateStatus2', 'status', status)
            const localVarPath = `/api/master/custom-form/{customFormId}/active/{status}`
                .replace(`{${"customFormId"}}`, encodeURIComponent(String(customFormId)))
                .replace(`{${"status"}}`, encodeURIComponent(String(status)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CustomFormControllerApi - functional programming interface
 * @export
 */
export const CustomFormControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CustomFormControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * create custom form into the system
         * @summary create custom form
         * @param {CustomForm} customForm 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createCustomForm(customForm: CustomForm, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createCustomForm(customForm, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomFormControllerApi.createCustomForm']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * get all custom form version from the system
         * @summary get all custom form with version
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {GetAllCustomFormsFormTypeEnum} [formType] 
         * @param {string} [searchString] 
         * @param {boolean} [active] 
         * @param {boolean} [archive] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllCustomForms(page?: number, size?: number, sortBy?: string, sortDirection?: string, formType?: GetAllCustomFormsFormTypeEnum, searchString?: string, active?: boolean, archive?: boolean, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllCustomForms(page, size, sortBy, sortDirection, formType, searchString, active, archive, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomFormControllerApi.getAllCustomForms']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * get custom form all version from the system
         * @summary get custom form with all version
         * @param {string} customFormId 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCustomFormByUuid(customFormId: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCustomFormByUuid(customFormId, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomFormControllerApi.getCustomFormByUuid']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * import default custom form
         * @summary import default custom form
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async importDefaultCustomForm(xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.importDefaultCustomForm(xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomFormControllerApi.importDefaultCustomForm']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * update custom form archive status from system
         * @summary update custom form archive status
         * @param {string} customFormId 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateArchiveStatus2(customFormId: string, status: boolean, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateArchiveStatus2(customFormId, status, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomFormControllerApi.updateArchiveStatus2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * update custom form version into the system
         * @summary update custom form version
         * @param {CustomForm} customForm 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCustomForm1(customForm: CustomForm, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateCustomForm1(customForm, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomFormControllerApi.updateCustomForm1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * update custom form status from system
         * @summary update custom form status
         * @param {string} customFormId 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateStatus2(customFormId: string, status: boolean, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateStatus2(customFormId, status, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomFormControllerApi.updateStatus2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CustomFormControllerApi - factory interface
 * @export
 */
export const CustomFormControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CustomFormControllerApiFp(configuration)
    return {
        /**
         * create custom form into the system
         * @summary create custom form
         * @param {CustomForm} customForm 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCustomForm(customForm: CustomForm, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.createCustomForm(customForm, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * get all custom form version from the system
         * @summary get all custom form with version
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {GetAllCustomFormsFormTypeEnum} [formType] 
         * @param {string} [searchString] 
         * @param {boolean} [active] 
         * @param {boolean} [archive] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllCustomForms(page?: number, size?: number, sortBy?: string, sortDirection?: string, formType?: GetAllCustomFormsFormTypeEnum, searchString?: string, active?: boolean, archive?: boolean, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getAllCustomForms(page, size, sortBy, sortDirection, formType, searchString, active, archive, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * get custom form all version from the system
         * @summary get custom form with all version
         * @param {string} customFormId 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomFormByUuid(customFormId: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getCustomFormByUuid(customFormId, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * import default custom form
         * @summary import default custom form
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importDefaultCustomForm(xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.importDefaultCustomForm(xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * update custom form archive status from system
         * @summary update custom form archive status
         * @param {string} customFormId 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateArchiveStatus2(customFormId: string, status: boolean, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.updateArchiveStatus2(customFormId, status, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * update custom form version into the system
         * @summary update custom form version
         * @param {CustomForm} customForm 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCustomForm1(customForm: CustomForm, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.updateCustomForm1(customForm, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * update custom form status from system
         * @summary update custom form status
         * @param {string} customFormId 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateStatus2(customFormId: string, status: boolean, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.updateStatus2(customFormId, status, xTENANTID, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CustomFormControllerApi - object-oriented interface
 * @export
 * @class CustomFormControllerApi
 * @extends {BaseAPI}
 */
export class CustomFormControllerApi extends BaseAPI {
    /**
     * create custom form into the system
     * @summary create custom form
     * @param {CustomForm} customForm 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomFormControllerApi
     */
    public createCustomForm(customForm: CustomForm, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return CustomFormControllerApiFp(this.configuration).createCustomForm(customForm, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * get all custom form version from the system
     * @summary get all custom form with version
     * @param {number} [page] 
     * @param {number} [size] 
     * @param {string} [sortBy] 
     * @param {string} [sortDirection] 
     * @param {GetAllCustomFormsFormTypeEnum} [formType] 
     * @param {string} [searchString] 
     * @param {boolean} [active] 
     * @param {boolean} [archive] 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomFormControllerApi
     */
    public getAllCustomForms(page?: number, size?: number, sortBy?: string, sortDirection?: string, formType?: GetAllCustomFormsFormTypeEnum, searchString?: string, active?: boolean, archive?: boolean, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return CustomFormControllerApiFp(this.configuration).getAllCustomForms(page, size, sortBy, sortDirection, formType, searchString, active, archive, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * get custom form all version from the system
     * @summary get custom form with all version
     * @param {string} customFormId 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomFormControllerApi
     */
    public getCustomFormByUuid(customFormId: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return CustomFormControllerApiFp(this.configuration).getCustomFormByUuid(customFormId, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * import default custom form
     * @summary import default custom form
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomFormControllerApi
     */
    public importDefaultCustomForm(xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return CustomFormControllerApiFp(this.configuration).importDefaultCustomForm(xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * update custom form archive status from system
     * @summary update custom form archive status
     * @param {string} customFormId 
     * @param {boolean} status 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomFormControllerApi
     */
    public updateArchiveStatus2(customFormId: string, status: boolean, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return CustomFormControllerApiFp(this.configuration).updateArchiveStatus2(customFormId, status, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * update custom form version into the system
     * @summary update custom form version
     * @param {CustomForm} customForm 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomFormControllerApi
     */
    public updateCustomForm1(customForm: CustomForm, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return CustomFormControllerApiFp(this.configuration).updateCustomForm1(customForm, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * update custom form status from system
     * @summary update custom form status
     * @param {string} customFormId 
     * @param {boolean} status 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomFormControllerApi
     */
    public updateStatus2(customFormId: string, status: boolean, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return CustomFormControllerApiFp(this.configuration).updateStatus2(customFormId, status, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const GetAllCustomFormsFormTypeEnum = {
    CustomQuestionnaire: 'CUSTOM_QUESTIONNAIRE',
    VisitNotes: 'VISIT_NOTES',
    ReviewOfSystem: 'REVIEW_OF_SYSTEM',
    PhysicalExam: 'PHYSICAL_EXAM',
    Micros: 'MICROS',
    AnnotableImage: 'ANNOTABLE_IMAGE',
    Email: 'EMAIL',
    Sms: 'SMS',
    OrderSet: 'ORDER_SET',
    IntakeForm: 'INTAKE_FORM',
    ConsentForm: 'CONSENT_FORM'
} as const;
export type GetAllCustomFormsFormTypeEnum = typeof GetAllCustomFormsFormTypeEnum[keyof typeof GetAllCustomFormsFormTypeEnum];


/**
 * CustomFormTemplateControllerApi - axios parameter creator
 * @export
 */
export const CustomFormTemplateControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * create custom form template into the system
         * @summary create custom form template
         * @param {CustomFormTemplate} customFormTemplate 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCustomFormTemplate: async (customFormTemplate: CustomFormTemplate, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customFormTemplate' is not null or undefined
            assertParamExists('createCustomFormTemplate', 'customFormTemplate', customFormTemplate)
            const localVarPath = `/api/master/custom-form-template`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(customFormTemplate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * get all custom form template from the system
         * @summary get all custom form template with version
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {string} [formBuilder] 
         * @param {string} [searchString] 
         * @param {GetAllCustomForms1FormTypeEnum} [formType] 
         * @param {boolean} [active] 
         * @param {boolean} [archive] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllCustomForms1: async (page?: number, size?: number, sortBy?: string, sortDirection?: string, formBuilder?: string, searchString?: string, formType?: GetAllCustomForms1FormTypeEnum, active?: boolean, archive?: boolean, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/master/custom-form-template`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }

            if (formBuilder !== undefined) {
                localVarQueryParameter['formBuilder'] = formBuilder;
            }

            if (searchString !== undefined) {
                localVarQueryParameter['searchString'] = searchString;
            }

            if (formType !== undefined) {
                localVarQueryParameter['formType'] = formType;
            }

            if (active !== undefined) {
                localVarQueryParameter['active'] = active;
            }

            if (archive !== undefined) {
                localVarQueryParameter['archive'] = archive;
            }

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * get custom form template 
         * @summary get custom form template with id
         * @param {string} customFormTemplateId 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomFormTemplateByUuid: async (customFormTemplateId: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customFormTemplateId' is not null or undefined
            assertParamExists('getCustomFormTemplateByUuid', 'customFormTemplateId', customFormTemplateId)
            const localVarPath = `/api/master/custom-form-template/{customFormTemplateId}`
                .replace(`{${"customFormTemplateId"}}`, encodeURIComponent(String(customFormTemplateId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * import default custom form template
         * @summary import default custom form template
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importDefaultCustomFormsTemplates: async (xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/master/custom-form-template/import-default-templates`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * update custom form builder archive status from system
         * @summary update custom form  builder archive status
         * @param {string} customFormBuilderId 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateArchiveStatus3: async (customFormBuilderId: string, status: boolean, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customFormBuilderId' is not null or undefined
            assertParamExists('updateArchiveStatus3', 'customFormBuilderId', customFormBuilderId)
            // verify required parameter 'status' is not null or undefined
            assertParamExists('updateArchiveStatus3', 'status', status)
            const localVarPath = `/api/master/custom-form-template/{customFormBuilderId}/archive-status/{status}`
                .replace(`{${"customFormBuilderId"}}`, encodeURIComponent(String(customFormBuilderId)))
                .replace(`{${"status"}}`, encodeURIComponent(String(status)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * update custom form template version into the system
         * @summary update custom form template version
         * @param {CustomFormTemplate} customFormTemplate 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCustomFormTemplate: async (customFormTemplate: CustomFormTemplate, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customFormTemplate' is not null or undefined
            assertParamExists('updateCustomFormTemplate', 'customFormTemplate', customFormTemplate)
            const localVarPath = `/api/master/custom-form-template`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(customFormTemplate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * update custom form builder status in system
         * @summary update custom form builder status
         * @param {string} customFormTemplateId 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateStatus3: async (customFormTemplateId: string, status: boolean, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customFormTemplateId' is not null or undefined
            assertParamExists('updateStatus3', 'customFormTemplateId', customFormTemplateId)
            // verify required parameter 'status' is not null or undefined
            assertParamExists('updateStatus3', 'status', status)
            const localVarPath = `/api/master/custom-form-template/{customFormTemplateId}/active/{status}`
                .replace(`{${"customFormTemplateId"}}`, encodeURIComponent(String(customFormTemplateId)))
                .replace(`{${"status"}}`, encodeURIComponent(String(status)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CustomFormTemplateControllerApi - functional programming interface
 * @export
 */
export const CustomFormTemplateControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CustomFormTemplateControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * create custom form template into the system
         * @summary create custom form template
         * @param {CustomFormTemplate} customFormTemplate 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createCustomFormTemplate(customFormTemplate: CustomFormTemplate, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createCustomFormTemplate(customFormTemplate, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomFormTemplateControllerApi.createCustomFormTemplate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * get all custom form template from the system
         * @summary get all custom form template with version
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {string} [formBuilder] 
         * @param {string} [searchString] 
         * @param {GetAllCustomForms1FormTypeEnum} [formType] 
         * @param {boolean} [active] 
         * @param {boolean} [archive] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllCustomForms1(page?: number, size?: number, sortBy?: string, sortDirection?: string, formBuilder?: string, searchString?: string, formType?: GetAllCustomForms1FormTypeEnum, active?: boolean, archive?: boolean, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllCustomForms1(page, size, sortBy, sortDirection, formBuilder, searchString, formType, active, archive, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomFormTemplateControllerApi.getAllCustomForms1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * get custom form template 
         * @summary get custom form template with id
         * @param {string} customFormTemplateId 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCustomFormTemplateByUuid(customFormTemplateId: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCustomFormTemplateByUuid(customFormTemplateId, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomFormTemplateControllerApi.getCustomFormTemplateByUuid']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * import default custom form template
         * @summary import default custom form template
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async importDefaultCustomFormsTemplates(xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.importDefaultCustomFormsTemplates(xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomFormTemplateControllerApi.importDefaultCustomFormsTemplates']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * update custom form builder archive status from system
         * @summary update custom form  builder archive status
         * @param {string} customFormBuilderId 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateArchiveStatus3(customFormBuilderId: string, status: boolean, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateArchiveStatus3(customFormBuilderId, status, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomFormTemplateControllerApi.updateArchiveStatus3']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * update custom form template version into the system
         * @summary update custom form template version
         * @param {CustomFormTemplate} customFormTemplate 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCustomFormTemplate(customFormTemplate: CustomFormTemplate, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateCustomFormTemplate(customFormTemplate, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomFormTemplateControllerApi.updateCustomFormTemplate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * update custom form builder status in system
         * @summary update custom form builder status
         * @param {string} customFormTemplateId 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateStatus3(customFormTemplateId: string, status: boolean, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateStatus3(customFormTemplateId, status, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomFormTemplateControllerApi.updateStatus3']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CustomFormTemplateControllerApi - factory interface
 * @export
 */
export const CustomFormTemplateControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CustomFormTemplateControllerApiFp(configuration)
    return {
        /**
         * create custom form template into the system
         * @summary create custom form template
         * @param {CustomFormTemplate} customFormTemplate 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCustomFormTemplate(customFormTemplate: CustomFormTemplate, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.createCustomFormTemplate(customFormTemplate, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * get all custom form template from the system
         * @summary get all custom form template with version
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {string} [formBuilder] 
         * @param {string} [searchString] 
         * @param {GetAllCustomForms1FormTypeEnum} [formType] 
         * @param {boolean} [active] 
         * @param {boolean} [archive] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllCustomForms1(page?: number, size?: number, sortBy?: string, sortDirection?: string, formBuilder?: string, searchString?: string, formType?: GetAllCustomForms1FormTypeEnum, active?: boolean, archive?: boolean, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getAllCustomForms1(page, size, sortBy, sortDirection, formBuilder, searchString, formType, active, archive, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * get custom form template 
         * @summary get custom form template with id
         * @param {string} customFormTemplateId 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomFormTemplateByUuid(customFormTemplateId: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getCustomFormTemplateByUuid(customFormTemplateId, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * import default custom form template
         * @summary import default custom form template
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importDefaultCustomFormsTemplates(xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.importDefaultCustomFormsTemplates(xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * update custom form builder archive status from system
         * @summary update custom form  builder archive status
         * @param {string} customFormBuilderId 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateArchiveStatus3(customFormBuilderId: string, status: boolean, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.updateArchiveStatus3(customFormBuilderId, status, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * update custom form template version into the system
         * @summary update custom form template version
         * @param {CustomFormTemplate} customFormTemplate 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCustomFormTemplate(customFormTemplate: CustomFormTemplate, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.updateCustomFormTemplate(customFormTemplate, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * update custom form builder status in system
         * @summary update custom form builder status
         * @param {string} customFormTemplateId 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateStatus3(customFormTemplateId: string, status: boolean, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.updateStatus3(customFormTemplateId, status, xTENANTID, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CustomFormTemplateControllerApi - object-oriented interface
 * @export
 * @class CustomFormTemplateControllerApi
 * @extends {BaseAPI}
 */
export class CustomFormTemplateControllerApi extends BaseAPI {
    /**
     * create custom form template into the system
     * @summary create custom form template
     * @param {CustomFormTemplate} customFormTemplate 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomFormTemplateControllerApi
     */
    public createCustomFormTemplate(customFormTemplate: CustomFormTemplate, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return CustomFormTemplateControllerApiFp(this.configuration).createCustomFormTemplate(customFormTemplate, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * get all custom form template from the system
     * @summary get all custom form template with version
     * @param {number} [page] 
     * @param {number} [size] 
     * @param {string} [sortBy] 
     * @param {string} [sortDirection] 
     * @param {string} [formBuilder] 
     * @param {string} [searchString] 
     * @param {GetAllCustomForms1FormTypeEnum} [formType] 
     * @param {boolean} [active] 
     * @param {boolean} [archive] 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomFormTemplateControllerApi
     */
    public getAllCustomForms1(page?: number, size?: number, sortBy?: string, sortDirection?: string, formBuilder?: string, searchString?: string, formType?: GetAllCustomForms1FormTypeEnum, active?: boolean, archive?: boolean, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return CustomFormTemplateControllerApiFp(this.configuration).getAllCustomForms1(page, size, sortBy, sortDirection, formBuilder, searchString, formType, active, archive, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * get custom form template 
     * @summary get custom form template with id
     * @param {string} customFormTemplateId 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomFormTemplateControllerApi
     */
    public getCustomFormTemplateByUuid(customFormTemplateId: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return CustomFormTemplateControllerApiFp(this.configuration).getCustomFormTemplateByUuid(customFormTemplateId, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * import default custom form template
     * @summary import default custom form template
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomFormTemplateControllerApi
     */
    public importDefaultCustomFormsTemplates(xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return CustomFormTemplateControllerApiFp(this.configuration).importDefaultCustomFormsTemplates(xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * update custom form builder archive status from system
     * @summary update custom form  builder archive status
     * @param {string} customFormBuilderId 
     * @param {boolean} status 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomFormTemplateControllerApi
     */
    public updateArchiveStatus3(customFormBuilderId: string, status: boolean, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return CustomFormTemplateControllerApiFp(this.configuration).updateArchiveStatus3(customFormBuilderId, status, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * update custom form template version into the system
     * @summary update custom form template version
     * @param {CustomFormTemplate} customFormTemplate 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomFormTemplateControllerApi
     */
    public updateCustomFormTemplate(customFormTemplate: CustomFormTemplate, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return CustomFormTemplateControllerApiFp(this.configuration).updateCustomFormTemplate(customFormTemplate, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * update custom form builder status in system
     * @summary update custom form builder status
     * @param {string} customFormTemplateId 
     * @param {boolean} status 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomFormTemplateControllerApi
     */
    public updateStatus3(customFormTemplateId: string, status: boolean, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return CustomFormTemplateControllerApiFp(this.configuration).updateStatus3(customFormTemplateId, status, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const GetAllCustomForms1FormTypeEnum = {
    CustomQuestionnaire: 'CUSTOM_QUESTIONNAIRE',
    VisitNotes: 'VISIT_NOTES',
    ReviewOfSystem: 'REVIEW_OF_SYSTEM',
    PhysicalExam: 'PHYSICAL_EXAM',
    Micros: 'MICROS',
    AnnotableImage: 'ANNOTABLE_IMAGE',
    Email: 'EMAIL',
    Sms: 'SMS',
    OrderSet: 'ORDER_SET',
    IntakeForm: 'INTAKE_FORM',
    ConsentForm: 'CONSENT_FORM'
} as const;
export type GetAllCustomForms1FormTypeEnum = typeof GetAllCustomForms1FormTypeEnum[keyof typeof GetAllCustomForms1FormTypeEnum];


/**
 * DashboardControllerApi - axios parameter creator
 * @export
 */
export const DashboardControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Returns counts for dashboard cards
         * @summary Get dashboard counts
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDashboardCounts: async (xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/master/dashboard/counts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DashboardControllerApi - functional programming interface
 * @export
 */
export const DashboardControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DashboardControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * Returns counts for dashboard cards
         * @summary Get dashboard counts
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDashboardCounts(xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDashboardCounts(xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DashboardControllerApi.getDashboardCounts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DashboardControllerApi - factory interface
 * @export
 */
export const DashboardControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DashboardControllerApiFp(configuration)
    return {
        /**
         * Returns counts for dashboard cards
         * @summary Get dashboard counts
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDashboardCounts(xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getDashboardCounts(xTENANTID, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DashboardControllerApi - object-oriented interface
 * @export
 * @class DashboardControllerApi
 * @extends {BaseAPI}
 */
export class DashboardControllerApi extends BaseAPI {
    /**
     * Returns counts for dashboard cards
     * @summary Get dashboard counts
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DashboardControllerApi
     */
    public getDashboardCounts(xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return DashboardControllerApiFp(this.configuration).getDashboardCounts(xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * DefaultAssessmentControllerApi - axios parameter creator
 * @export
 */
export const DefaultAssessmentControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Add a new Default Assessments into the system.
         * @summary Add Default Assessments
         * @param {DefaultAssessment} defaultAssessment 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDefaultAssessments: async (defaultAssessment: DefaultAssessment, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'defaultAssessment' is not null or undefined
            assertParamExists('createDefaultAssessments', 'defaultAssessment', defaultAssessment)
            const localVarPath = `/api/master/default-assessments`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(defaultAssessment, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get Default Assessments.
         * @summary Get Default Assessments.
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDefaultAssessments1: async (xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/master/default-assessments/default-assessments`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DefaultAssessmentControllerApi - functional programming interface
 * @export
 */
export const DefaultAssessmentControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DefaultAssessmentControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * Add a new Default Assessments into the system.
         * @summary Add Default Assessments
         * @param {DefaultAssessment} defaultAssessment 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createDefaultAssessments(defaultAssessment: DefaultAssessment, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createDefaultAssessments(defaultAssessment, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultAssessmentControllerApi.createDefaultAssessments']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get Default Assessments.
         * @summary Get Default Assessments.
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDefaultAssessments1(xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDefaultAssessments1(xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultAssessmentControllerApi.getDefaultAssessments1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DefaultAssessmentControllerApi - factory interface
 * @export
 */
export const DefaultAssessmentControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DefaultAssessmentControllerApiFp(configuration)
    return {
        /**
         * Add a new Default Assessments into the system.
         * @summary Add Default Assessments
         * @param {DefaultAssessment} defaultAssessment 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDefaultAssessments(defaultAssessment: DefaultAssessment, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.createDefaultAssessments(defaultAssessment, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Get Default Assessments.
         * @summary Get Default Assessments.
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDefaultAssessments1(xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getDefaultAssessments1(xTENANTID, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DefaultAssessmentControllerApi - object-oriented interface
 * @export
 * @class DefaultAssessmentControllerApi
 * @extends {BaseAPI}
 */
export class DefaultAssessmentControllerApi extends BaseAPI {
    /**
     * Add a new Default Assessments into the system.
     * @summary Add Default Assessments
     * @param {DefaultAssessment} defaultAssessment 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultAssessmentControllerApi
     */
    public createDefaultAssessments(defaultAssessment: DefaultAssessment, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return DefaultAssessmentControllerApiFp(this.configuration).createDefaultAssessments(defaultAssessment, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get Default Assessments.
     * @summary Get Default Assessments.
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultAssessmentControllerApi
     */
    public getDefaultAssessments1(xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return DefaultAssessmentControllerApiFp(this.configuration).getDefaultAssessments1(xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * DepartmentControllerApi - axios parameter creator
 * @export
 */
export const DepartmentControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * To assign department to the particular location
         * @summary Assign department to Location
         * @param {string} departmentId 
         * @param {string} locationId 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignDepartmentToLocation: async (departmentId: string, locationId: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'departmentId' is not null or undefined
            assertParamExists('assignDepartmentToLocation', 'departmentId', departmentId)
            // verify required parameter 'locationId' is not null or undefined
            assertParamExists('assignDepartmentToLocation', 'locationId', locationId)
            const localVarPath = `/api/master/department/{departmentId}/location/{locationId}`
                .replace(`{${"departmentId"}}`, encodeURIComponent(String(departmentId)))
                .replace(`{${"locationId"}}`, encodeURIComponent(String(locationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Add a new Department into the system.
         * @summary Add Department
         * @param {Department} department 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDepartment1: async (department: Department, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'department' is not null or undefined
            assertParamExists('createDepartment1', 'department', department)
            const localVarPath = `/api/master/department`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(department, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all Departments list for super admin with search option on name, deptId and filter options on active, archive.
         * @summary Get all Departments.
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {boolean} [status] 
         * @param {boolean} [archive] 
         * @param {string} [locationUuid] 
         * @param {string} [searchString] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllDepartments2: async (page?: number, size?: number, sortBy?: string, sortDirection?: string, status?: boolean, archive?: boolean, locationUuid?: string, searchString?: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/master/department`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (archive !== undefined) {
                localVarQueryParameter['archive'] = archive;
            }

            if (locationUuid !== undefined) {
                localVarQueryParameter['locationUuid'] = locationUuid;
            }

            if (searchString !== undefined) {
                localVarQueryParameter['searchString'] = searchString;
            }

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get Department by departmentUuid.
         * @summary Get Department by departmentUuid.
         * @param {string} departmentId 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDepartmentById: async (departmentId: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'departmentId' is not null or undefined
            assertParamExists('getDepartmentById', 'departmentId', departmentId)
            const localVarPath = `/api/master/department/{departmentId}`
                .replace(`{${"departmentId"}}`, encodeURIComponent(String(departmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Edit Department with editable fields as phone, npi, email, website, fax, description, physical address, billing address
         * @summary Update Department
         * @param {Department} department 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDepartment: async (department: Department, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'department' is not null or undefined
            assertParamExists('updateDepartment', 'department', department)
            const localVarPath = `/api/master/department`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(department, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Change Department  archive status to either archived or unarchived.
         * @summary Archive/Unarchive Department
         * @param {string} departmentId 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDepartmentArchiveStatus: async (departmentId: string, status: boolean, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'departmentId' is not null or undefined
            assertParamExists('updateDepartmentArchiveStatus', 'departmentId', departmentId)
            // verify required parameter 'status' is not null or undefined
            assertParamExists('updateDepartmentArchiveStatus', 'status', status)
            const localVarPath = `/api/master/department/{departmentId}/archive-status/{status}`
                .replace(`{${"departmentId"}}`, encodeURIComponent(String(departmentId)))
                .replace(`{${"status"}}`, encodeURIComponent(String(status)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Change Department status to either active or inactive.
         * @summary Enable/Disable Department
         * @param {string} departmentId 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDepartmentStatus: async (departmentId: string, status: boolean, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'departmentId' is not null or undefined
            assertParamExists('updateDepartmentStatus', 'departmentId', departmentId)
            // verify required parameter 'status' is not null or undefined
            assertParamExists('updateDepartmentStatus', 'status', status)
            const localVarPath = `/api/master/department/{departmentId}/status/{status}`
                .replace(`{${"departmentId"}}`, encodeURIComponent(String(departmentId)))
                .replace(`{${"status"}}`, encodeURIComponent(String(status)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DepartmentControllerApi - functional programming interface
 * @export
 */
export const DepartmentControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DepartmentControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * To assign department to the particular location
         * @summary Assign department to Location
         * @param {string} departmentId 
         * @param {string} locationId 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assignDepartmentToLocation(departmentId: string, locationId: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assignDepartmentToLocation(departmentId, locationId, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DepartmentControllerApi.assignDepartmentToLocation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Add a new Department into the system.
         * @summary Add Department
         * @param {Department} department 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createDepartment1(department: Department, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createDepartment1(department, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DepartmentControllerApi.createDepartment1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get all Departments list for super admin with search option on name, deptId and filter options on active, archive.
         * @summary Get all Departments.
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {boolean} [status] 
         * @param {boolean} [archive] 
         * @param {string} [locationUuid] 
         * @param {string} [searchString] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllDepartments2(page?: number, size?: number, sortBy?: string, sortDirection?: string, status?: boolean, archive?: boolean, locationUuid?: string, searchString?: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllDepartments2(page, size, sortBy, sortDirection, status, archive, locationUuid, searchString, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DepartmentControllerApi.getAllDepartments2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get Department by departmentUuid.
         * @summary Get Department by departmentUuid.
         * @param {string} departmentId 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDepartmentById(departmentId: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDepartmentById(departmentId, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DepartmentControllerApi.getDepartmentById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Edit Department with editable fields as phone, npi, email, website, fax, description, physical address, billing address
         * @summary Update Department
         * @param {Department} department 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateDepartment(department: Department, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateDepartment(department, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DepartmentControllerApi.updateDepartment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Change Department  archive status to either archived or unarchived.
         * @summary Archive/Unarchive Department
         * @param {string} departmentId 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateDepartmentArchiveStatus(departmentId: string, status: boolean, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateDepartmentArchiveStatus(departmentId, status, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DepartmentControllerApi.updateDepartmentArchiveStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Change Department status to either active or inactive.
         * @summary Enable/Disable Department
         * @param {string} departmentId 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateDepartmentStatus(departmentId: string, status: boolean, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateDepartmentStatus(departmentId, status, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DepartmentControllerApi.updateDepartmentStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DepartmentControllerApi - factory interface
 * @export
 */
export const DepartmentControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DepartmentControllerApiFp(configuration)
    return {
        /**
         * To assign department to the particular location
         * @summary Assign department to Location
         * @param {string} departmentId 
         * @param {string} locationId 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignDepartmentToLocation(departmentId: string, locationId: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.assignDepartmentToLocation(departmentId, locationId, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Add a new Department into the system.
         * @summary Add Department
         * @param {Department} department 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDepartment1(department: Department, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.createDepartment1(department, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all Departments list for super admin with search option on name, deptId and filter options on active, archive.
         * @summary Get all Departments.
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {boolean} [status] 
         * @param {boolean} [archive] 
         * @param {string} [locationUuid] 
         * @param {string} [searchString] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllDepartments2(page?: number, size?: number, sortBy?: string, sortDirection?: string, status?: boolean, archive?: boolean, locationUuid?: string, searchString?: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getAllDepartments2(page, size, sortBy, sortDirection, status, archive, locationUuid, searchString, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Get Department by departmentUuid.
         * @summary Get Department by departmentUuid.
         * @param {string} departmentId 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDepartmentById(departmentId: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getDepartmentById(departmentId, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Edit Department with editable fields as phone, npi, email, website, fax, description, physical address, billing address
         * @summary Update Department
         * @param {Department} department 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDepartment(department: Department, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.updateDepartment(department, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Change Department  archive status to either archived or unarchived.
         * @summary Archive/Unarchive Department
         * @param {string} departmentId 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDepartmentArchiveStatus(departmentId: string, status: boolean, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.updateDepartmentArchiveStatus(departmentId, status, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Change Department status to either active or inactive.
         * @summary Enable/Disable Department
         * @param {string} departmentId 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDepartmentStatus(departmentId: string, status: boolean, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.updateDepartmentStatus(departmentId, status, xTENANTID, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DepartmentControllerApi - object-oriented interface
 * @export
 * @class DepartmentControllerApi
 * @extends {BaseAPI}
 */
export class DepartmentControllerApi extends BaseAPI {
    /**
     * To assign department to the particular location
     * @summary Assign department to Location
     * @param {string} departmentId 
     * @param {string} locationId 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DepartmentControllerApi
     */
    public assignDepartmentToLocation(departmentId: string, locationId: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return DepartmentControllerApiFp(this.configuration).assignDepartmentToLocation(departmentId, locationId, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Add a new Department into the system.
     * @summary Add Department
     * @param {Department} department 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DepartmentControllerApi
     */
    public createDepartment1(department: Department, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return DepartmentControllerApiFp(this.configuration).createDepartment1(department, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all Departments list for super admin with search option on name, deptId and filter options on active, archive.
     * @summary Get all Departments.
     * @param {number} [page] 
     * @param {number} [size] 
     * @param {string} [sortBy] 
     * @param {string} [sortDirection] 
     * @param {boolean} [status] 
     * @param {boolean} [archive] 
     * @param {string} [locationUuid] 
     * @param {string} [searchString] 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DepartmentControllerApi
     */
    public getAllDepartments2(page?: number, size?: number, sortBy?: string, sortDirection?: string, status?: boolean, archive?: boolean, locationUuid?: string, searchString?: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return DepartmentControllerApiFp(this.configuration).getAllDepartments2(page, size, sortBy, sortDirection, status, archive, locationUuid, searchString, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get Department by departmentUuid.
     * @summary Get Department by departmentUuid.
     * @param {string} departmentId 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DepartmentControllerApi
     */
    public getDepartmentById(departmentId: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return DepartmentControllerApiFp(this.configuration).getDepartmentById(departmentId, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Edit Department with editable fields as phone, npi, email, website, fax, description, physical address, billing address
     * @summary Update Department
     * @param {Department} department 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DepartmentControllerApi
     */
    public updateDepartment(department: Department, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return DepartmentControllerApiFp(this.configuration).updateDepartment(department, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Change Department  archive status to either archived or unarchived.
     * @summary Archive/Unarchive Department
     * @param {string} departmentId 
     * @param {boolean} status 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DepartmentControllerApi
     */
    public updateDepartmentArchiveStatus(departmentId: string, status: boolean, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return DepartmentControllerApiFp(this.configuration).updateDepartmentArchiveStatus(departmentId, status, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Change Department status to either active or inactive.
     * @summary Enable/Disable Department
     * @param {string} departmentId 
     * @param {boolean} status 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DepartmentControllerApi
     */
    public updateDepartmentStatus(departmentId: string, status: boolean, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return DepartmentControllerApiFp(this.configuration).updateDepartmentStatus(departmentId, status, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * DocumentTagControllerApi - axios parameter creator
 * @export
 */
export const DocumentTagControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Add a new document tag into the system
         * @summary Add Document Tag
         * @param {DocumentTag} documentTag 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDocumentTag: async (documentTag: DocumentTag, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'documentTag' is not null or undefined
            assertParamExists('createDocumentTag', 'documentTag', documentTag)
            const localVarPath = `/api/master/document-tag`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(documentTag, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all document tags based on their status
         * @summary Get Document Tags by Status
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sort] 
         * @param {boolean} [status] 
         * @param {boolean} [archive] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllDocumentTags: async (page?: number, size?: number, sortBy?: string, sort?: string, status?: boolean, archive?: boolean, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/master/document-tag`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (archive !== undefined) {
                localVarQueryParameter['archive'] = archive;
            }

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve a document tag by its unique ID
         * @summary Get Document Tag by ID
         * @param {string} documentTagId 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDocumentTagById: async (documentTagId: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'documentTagId' is not null or undefined
            assertParamExists('getDocumentTagById', 'documentTagId', documentTagId)
            const localVarPath = `/api/master/document-tag/{documentTagId}`
                .replace(`{${"documentTagId"}}`, encodeURIComponent(String(documentTagId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update an existing document tag
         * @summary Update Document Tag
         * @param {DocumentTag} documentTag 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDocumentTag: async (documentTag: DocumentTag, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'documentTag' is not null or undefined
            assertParamExists('updateDocumentTag', 'documentTag', documentTag)
            const localVarPath = `/api/master/document-tag`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(documentTag, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Archive a document tag by its ID
         * @summary Archive Document Tag
         * @param {string} documentTagId 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDocumentTagArchiveStatus: async (documentTagId: string, status: boolean, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'documentTagId' is not null or undefined
            assertParamExists('updateDocumentTagArchiveStatus', 'documentTagId', documentTagId)
            // verify required parameter 'status' is not null or undefined
            assertParamExists('updateDocumentTagArchiveStatus', 'status', status)
            const localVarPath = `/api/master/document-tag/{documentTagId}/archive-status/{status}`
                .replace(`{${"documentTagId"}}`, encodeURIComponent(String(documentTagId)))
                .replace(`{${"status"}}`, encodeURIComponent(String(status)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update the status of a document tag by its ID
         * @summary Update Document Tag Status
         * @param {string} documentTagId 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDocumentTagStatus: async (documentTagId: string, status: boolean, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'documentTagId' is not null or undefined
            assertParamExists('updateDocumentTagStatus', 'documentTagId', documentTagId)
            // verify required parameter 'status' is not null or undefined
            assertParamExists('updateDocumentTagStatus', 'status', status)
            const localVarPath = `/api/master/document-tag/{documentTagId}/status/{status}`
                .replace(`{${"documentTagId"}}`, encodeURIComponent(String(documentTagId)))
                .replace(`{${"status"}}`, encodeURIComponent(String(status)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DocumentTagControllerApi - functional programming interface
 * @export
 */
export const DocumentTagControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DocumentTagControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * Add a new document tag into the system
         * @summary Add Document Tag
         * @param {DocumentTag} documentTag 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createDocumentTag(documentTag: DocumentTag, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createDocumentTag(documentTag, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentTagControllerApi.createDocumentTag']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get all document tags based on their status
         * @summary Get Document Tags by Status
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sort] 
         * @param {boolean} [status] 
         * @param {boolean} [archive] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllDocumentTags(page?: number, size?: number, sortBy?: string, sort?: string, status?: boolean, archive?: boolean, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllDocumentTags(page, size, sortBy, sort, status, archive, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentTagControllerApi.getAllDocumentTags']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve a document tag by its unique ID
         * @summary Get Document Tag by ID
         * @param {string} documentTagId 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDocumentTagById(documentTagId: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDocumentTagById(documentTagId, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentTagControllerApi.getDocumentTagById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update an existing document tag
         * @summary Update Document Tag
         * @param {DocumentTag} documentTag 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateDocumentTag(documentTag: DocumentTag, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateDocumentTag(documentTag, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentTagControllerApi.updateDocumentTag']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Archive a document tag by its ID
         * @summary Archive Document Tag
         * @param {string} documentTagId 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateDocumentTagArchiveStatus(documentTagId: string, status: boolean, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateDocumentTagArchiveStatus(documentTagId, status, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentTagControllerApi.updateDocumentTagArchiveStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update the status of a document tag by its ID
         * @summary Update Document Tag Status
         * @param {string} documentTagId 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateDocumentTagStatus(documentTagId: string, status: boolean, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateDocumentTagStatus(documentTagId, status, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentTagControllerApi.updateDocumentTagStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DocumentTagControllerApi - factory interface
 * @export
 */
export const DocumentTagControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DocumentTagControllerApiFp(configuration)
    return {
        /**
         * Add a new document tag into the system
         * @summary Add Document Tag
         * @param {DocumentTag} documentTag 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDocumentTag(documentTag: DocumentTag, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.createDocumentTag(documentTag, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all document tags based on their status
         * @summary Get Document Tags by Status
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sort] 
         * @param {boolean} [status] 
         * @param {boolean} [archive] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllDocumentTags(page?: number, size?: number, sortBy?: string, sort?: string, status?: boolean, archive?: boolean, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getAllDocumentTags(page, size, sortBy, sort, status, archive, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve a document tag by its unique ID
         * @summary Get Document Tag by ID
         * @param {string} documentTagId 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDocumentTagById(documentTagId: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getDocumentTagById(documentTagId, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Update an existing document tag
         * @summary Update Document Tag
         * @param {DocumentTag} documentTag 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDocumentTag(documentTag: DocumentTag, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.updateDocumentTag(documentTag, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Archive a document tag by its ID
         * @summary Archive Document Tag
         * @param {string} documentTagId 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDocumentTagArchiveStatus(documentTagId: string, status: boolean, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.updateDocumentTagArchiveStatus(documentTagId, status, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Update the status of a document tag by its ID
         * @summary Update Document Tag Status
         * @param {string} documentTagId 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDocumentTagStatus(documentTagId: string, status: boolean, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.updateDocumentTagStatus(documentTagId, status, xTENANTID, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DocumentTagControllerApi - object-oriented interface
 * @export
 * @class DocumentTagControllerApi
 * @extends {BaseAPI}
 */
export class DocumentTagControllerApi extends BaseAPI {
    /**
     * Add a new document tag into the system
     * @summary Add Document Tag
     * @param {DocumentTag} documentTag 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentTagControllerApi
     */
    public createDocumentTag(documentTag: DocumentTag, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return DocumentTagControllerApiFp(this.configuration).createDocumentTag(documentTag, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all document tags based on their status
     * @summary Get Document Tags by Status
     * @param {number} [page] 
     * @param {number} [size] 
     * @param {string} [sortBy] 
     * @param {string} [sort] 
     * @param {boolean} [status] 
     * @param {boolean} [archive] 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentTagControllerApi
     */
    public getAllDocumentTags(page?: number, size?: number, sortBy?: string, sort?: string, status?: boolean, archive?: boolean, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return DocumentTagControllerApiFp(this.configuration).getAllDocumentTags(page, size, sortBy, sort, status, archive, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve a document tag by its unique ID
     * @summary Get Document Tag by ID
     * @param {string} documentTagId 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentTagControllerApi
     */
    public getDocumentTagById(documentTagId: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return DocumentTagControllerApiFp(this.configuration).getDocumentTagById(documentTagId, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update an existing document tag
     * @summary Update Document Tag
     * @param {DocumentTag} documentTag 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentTagControllerApi
     */
    public updateDocumentTag(documentTag: DocumentTag, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return DocumentTagControllerApiFp(this.configuration).updateDocumentTag(documentTag, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Archive a document tag by its ID
     * @summary Archive Document Tag
     * @param {string} documentTagId 
     * @param {boolean} status 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentTagControllerApi
     */
    public updateDocumentTagArchiveStatus(documentTagId: string, status: boolean, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return DocumentTagControllerApiFp(this.configuration).updateDocumentTagArchiveStatus(documentTagId, status, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update the status of a document tag by its ID
     * @summary Update Document Tag Status
     * @param {string} documentTagId 
     * @param {boolean} status 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentTagControllerApi
     */
    public updateDocumentTagStatus(documentTagId: string, status: boolean, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return DocumentTagControllerApiFp(this.configuration).updateDocumentTagStatus(documentTagId, status, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * EducationMaterialControllerApi - axios parameter creator
 * @export
 */
export const EducationMaterialControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {boolean} [status] 
         * @param {boolean} [archive] 
         * @param {string} [providerId] 
         * @param {string} [specialityId] 
         * @param {string} [searchString] 
         * @param {string} [patientId] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEducationMaterials: async (page?: number, size?: number, sortBy?: string, sortDirection?: string, status?: boolean, archive?: boolean, providerId?: string, specialityId?: string, searchString?: string, patientId?: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/master/education-material/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (archive !== undefined) {
                localVarQueryParameter['archive'] = archive;
            }

            if (providerId !== undefined) {
                localVarQueryParameter['providerId'] = providerId;
            }

            if (specialityId !== undefined) {
                localVarQueryParameter['specialityId'] = specialityId;
            }

            if (searchString !== undefined) {
                localVarQueryParameter['searchString'] = searchString;
            }

            if (patientId !== undefined) {
                localVarQueryParameter['patientId'] = patientId;
            }

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve an Education Material by its ID
         * @summary Get Education Material by ID
         * @param {string} educationMaterialId 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEducationMaterialById: async (educationMaterialId: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'educationMaterialId' is not null or undefined
            assertParamExists('getEducationMaterialById', 'educationMaterialId', educationMaterialId)
            const localVarPath = `/api/master/education-material/{educationMaterialId}`
                .replace(`{${"educationMaterialId"}}`, encodeURIComponent(String(educationMaterialId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Share Education Material with Patient
         * @summary Share Education Material with Patient
         * @param {PatientEducationMaterial} patientEducationMaterial 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shareEducationMaterialWithPatient: async (patientEducationMaterial: PatientEducationMaterial, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientEducationMaterial' is not null or undefined
            assertParamExists('shareEducationMaterialWithPatient', 'patientEducationMaterial', patientEducationMaterial)
            const localVarPath = `/api/master/education-material/share`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patientEducationMaterial, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update an existing Education Material
         * @summary Update Education Material
         * @param {string} educationMaterialId 
         * @param {string} providerId 
         * @param {string} name 
         * @param {string} description 
         * @param {string} condition 
         * @param {UpdateEducationMaterialDocumentFormatEnum} documentFormat 
         * @param {string} [specialityId] 
         * @param {string} [documentDate] 
         * @param {string} [fileName] 
         * @param {string} [xTENANTID] 
         * @param {File} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEducationMaterial: async (educationMaterialId: string, providerId: string, name: string, description: string, condition: string, documentFormat: UpdateEducationMaterialDocumentFormatEnum, specialityId?: string, documentDate?: string, fileName?: string, xTENANTID?: string, file?: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'educationMaterialId' is not null or undefined
            assertParamExists('updateEducationMaterial', 'educationMaterialId', educationMaterialId)
            // verify required parameter 'providerId' is not null or undefined
            assertParamExists('updateEducationMaterial', 'providerId', providerId)
            // verify required parameter 'name' is not null or undefined
            assertParamExists('updateEducationMaterial', 'name', name)
            // verify required parameter 'description' is not null or undefined
            assertParamExists('updateEducationMaterial', 'description', description)
            // verify required parameter 'condition' is not null or undefined
            assertParamExists('updateEducationMaterial', 'condition', condition)
            // verify required parameter 'documentFormat' is not null or undefined
            assertParamExists('updateEducationMaterial', 'documentFormat', documentFormat)
            const localVarPath = `/api/master/education-material`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (educationMaterialId !== undefined) {
                localVarQueryParameter['educationMaterialId'] = educationMaterialId;
            }

            if (providerId !== undefined) {
                localVarQueryParameter['providerId'] = providerId;
            }

            if (specialityId !== undefined) {
                localVarQueryParameter['specialityId'] = specialityId;
            }

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            if (description !== undefined) {
                localVarQueryParameter['description'] = description;
            }

            if (documentDate !== undefined) {
                localVarQueryParameter['documentDate'] = (documentDate as any instanceof Date) ?
                    (documentDate as any).toISOString() :
                    documentDate;
            }

            if (fileName !== undefined) {
                localVarQueryParameter['fileName'] = fileName;
            }

            if (condition !== undefined) {
                localVarQueryParameter['condition'] = condition;
            }

            if (documentFormat !== undefined) {
                localVarQueryParameter['documentFormat'] = documentFormat;
            }

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Archive an Education Material by its ID
         * @summary Archive Education Material
         * @param {string} educationMaterialId 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEducationMaterialArchiveStatus: async (educationMaterialId: string, status: boolean, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'educationMaterialId' is not null or undefined
            assertParamExists('updateEducationMaterialArchiveStatus', 'educationMaterialId', educationMaterialId)
            // verify required parameter 'status' is not null or undefined
            assertParamExists('updateEducationMaterialArchiveStatus', 'status', status)
            const localVarPath = `/api/master/education-material/{educationMaterialId}/archive-status/{status}`
                .replace(`{${"educationMaterialId"}}`, encodeURIComponent(String(educationMaterialId)))
                .replace(`{${"status"}}`, encodeURIComponent(String(status)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update the status of an Education Material by its ID
         * @summary Update Education Material Status
         * @param {string} educationMaterialId 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEducationMaterialStatus: async (educationMaterialId: string, status: boolean, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'educationMaterialId' is not null or undefined
            assertParamExists('updateEducationMaterialStatus', 'educationMaterialId', educationMaterialId)
            // verify required parameter 'status' is not null or undefined
            assertParamExists('updateEducationMaterialStatus', 'status', status)
            const localVarPath = `/api/master/education-material/{educationMaterialId}/status/{status}`
                .replace(`{${"educationMaterialId"}}`, encodeURIComponent(String(educationMaterialId)))
                .replace(`{${"status"}}`, encodeURIComponent(String(status)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} providerId 
         * @param {string} name 
         * @param {string} description 
         * @param {string} fileName 
         * @param {string} condition 
         * @param {UploadEducationMaterialDocumentFormatEnum} documentFormat 
         * @param {File} file 
         * @param {string} [specialityId] 
         * @param {string} [documentDate] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadEducationMaterial: async (providerId: string, name: string, description: string, fileName: string, condition: string, documentFormat: UploadEducationMaterialDocumentFormatEnum, file: File, specialityId?: string, documentDate?: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'providerId' is not null or undefined
            assertParamExists('uploadEducationMaterial', 'providerId', providerId)
            // verify required parameter 'name' is not null or undefined
            assertParamExists('uploadEducationMaterial', 'name', name)
            // verify required parameter 'description' is not null or undefined
            assertParamExists('uploadEducationMaterial', 'description', description)
            // verify required parameter 'fileName' is not null or undefined
            assertParamExists('uploadEducationMaterial', 'fileName', fileName)
            // verify required parameter 'condition' is not null or undefined
            assertParamExists('uploadEducationMaterial', 'condition', condition)
            // verify required parameter 'documentFormat' is not null or undefined
            assertParamExists('uploadEducationMaterial', 'documentFormat', documentFormat)
            // verify required parameter 'file' is not null or undefined
            assertParamExists('uploadEducationMaterial', 'file', file)
            const localVarPath = `/api/master/education-material/upload`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (providerId !== undefined) {
                localVarQueryParameter['providerId'] = providerId;
            }

            if (specialityId !== undefined) {
                localVarQueryParameter['specialityId'] = specialityId;
            }

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            if (description !== undefined) {
                localVarQueryParameter['description'] = description;
            }

            if (documentDate !== undefined) {
                localVarQueryParameter['documentDate'] = (documentDate as any instanceof Date) ?
                    (documentDate as any).toISOString() :
                    documentDate;
            }

            if (fileName !== undefined) {
                localVarQueryParameter['fileName'] = fileName;
            }

            if (condition !== undefined) {
                localVarQueryParameter['condition'] = condition;
            }

            if (documentFormat !== undefined) {
                localVarQueryParameter['documentFormat'] = documentFormat;
            }

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EducationMaterialControllerApi - functional programming interface
 * @export
 */
export const EducationMaterialControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = EducationMaterialControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {boolean} [status] 
         * @param {boolean} [archive] 
         * @param {string} [providerId] 
         * @param {string} [specialityId] 
         * @param {string} [searchString] 
         * @param {string} [patientId] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllEducationMaterials(page?: number, size?: number, sortBy?: string, sortDirection?: string, status?: boolean, archive?: boolean, providerId?: string, specialityId?: string, searchString?: string, patientId?: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllEducationMaterials(page, size, sortBy, sortDirection, status, archive, providerId, specialityId, searchString, patientId, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EducationMaterialControllerApi.getAllEducationMaterials']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve an Education Material by its ID
         * @summary Get Education Material by ID
         * @param {string} educationMaterialId 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEducationMaterialById(educationMaterialId: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEducationMaterialById(educationMaterialId, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EducationMaterialControllerApi.getEducationMaterialById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Share Education Material with Patient
         * @summary Share Education Material with Patient
         * @param {PatientEducationMaterial} patientEducationMaterial 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async shareEducationMaterialWithPatient(patientEducationMaterial: PatientEducationMaterial, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.shareEducationMaterialWithPatient(patientEducationMaterial, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EducationMaterialControllerApi.shareEducationMaterialWithPatient']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update an existing Education Material
         * @summary Update Education Material
         * @param {string} educationMaterialId 
         * @param {string} providerId 
         * @param {string} name 
         * @param {string} description 
         * @param {string} condition 
         * @param {UpdateEducationMaterialDocumentFormatEnum} documentFormat 
         * @param {string} [specialityId] 
         * @param {string} [documentDate] 
         * @param {string} [fileName] 
         * @param {string} [xTENANTID] 
         * @param {File} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateEducationMaterial(educationMaterialId: string, providerId: string, name: string, description: string, condition: string, documentFormat: UpdateEducationMaterialDocumentFormatEnum, specialityId?: string, documentDate?: string, fileName?: string, xTENANTID?: string, file?: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateEducationMaterial(educationMaterialId, providerId, name, description, condition, documentFormat, specialityId, documentDate, fileName, xTENANTID, file, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EducationMaterialControllerApi.updateEducationMaterial']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Archive an Education Material by its ID
         * @summary Archive Education Material
         * @param {string} educationMaterialId 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateEducationMaterialArchiveStatus(educationMaterialId: string, status: boolean, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateEducationMaterialArchiveStatus(educationMaterialId, status, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EducationMaterialControllerApi.updateEducationMaterialArchiveStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update the status of an Education Material by its ID
         * @summary Update Education Material Status
         * @param {string} educationMaterialId 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateEducationMaterialStatus(educationMaterialId: string, status: boolean, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateEducationMaterialStatus(educationMaterialId, status, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EducationMaterialControllerApi.updateEducationMaterialStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} providerId 
         * @param {string} name 
         * @param {string} description 
         * @param {string} fileName 
         * @param {string} condition 
         * @param {UploadEducationMaterialDocumentFormatEnum} documentFormat 
         * @param {File} file 
         * @param {string} [specialityId] 
         * @param {string} [documentDate] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadEducationMaterial(providerId: string, name: string, description: string, fileName: string, condition: string, documentFormat: UploadEducationMaterialDocumentFormatEnum, file: File, specialityId?: string, documentDate?: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadEducationMaterial(providerId, name, description, fileName, condition, documentFormat, file, specialityId, documentDate, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EducationMaterialControllerApi.uploadEducationMaterial']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * EducationMaterialControllerApi - factory interface
 * @export
 */
export const EducationMaterialControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = EducationMaterialControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {boolean} [status] 
         * @param {boolean} [archive] 
         * @param {string} [providerId] 
         * @param {string} [specialityId] 
         * @param {string} [searchString] 
         * @param {string} [patientId] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEducationMaterials(page?: number, size?: number, sortBy?: string, sortDirection?: string, status?: boolean, archive?: boolean, providerId?: string, specialityId?: string, searchString?: string, patientId?: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getAllEducationMaterials(page, size, sortBy, sortDirection, status, archive, providerId, specialityId, searchString, patientId, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve an Education Material by its ID
         * @summary Get Education Material by ID
         * @param {string} educationMaterialId 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEducationMaterialById(educationMaterialId: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getEducationMaterialById(educationMaterialId, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Share Education Material with Patient
         * @summary Share Education Material with Patient
         * @param {PatientEducationMaterial} patientEducationMaterial 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shareEducationMaterialWithPatient(patientEducationMaterial: PatientEducationMaterial, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.shareEducationMaterialWithPatient(patientEducationMaterial, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Update an existing Education Material
         * @summary Update Education Material
         * @param {string} educationMaterialId 
         * @param {string} providerId 
         * @param {string} name 
         * @param {string} description 
         * @param {string} condition 
         * @param {UpdateEducationMaterialDocumentFormatEnum} documentFormat 
         * @param {string} [specialityId] 
         * @param {string} [documentDate] 
         * @param {string} [fileName] 
         * @param {string} [xTENANTID] 
         * @param {File} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEducationMaterial(educationMaterialId: string, providerId: string, name: string, description: string, condition: string, documentFormat: UpdateEducationMaterialDocumentFormatEnum, specialityId?: string, documentDate?: string, fileName?: string, xTENANTID?: string, file?: File, options?: any): AxiosPromise<Response> {
            return localVarFp.updateEducationMaterial(educationMaterialId, providerId, name, description, condition, documentFormat, specialityId, documentDate, fileName, xTENANTID, file, options).then((request) => request(axios, basePath));
        },
        /**
         * Archive an Education Material by its ID
         * @summary Archive Education Material
         * @param {string} educationMaterialId 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEducationMaterialArchiveStatus(educationMaterialId: string, status: boolean, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.updateEducationMaterialArchiveStatus(educationMaterialId, status, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Update the status of an Education Material by its ID
         * @summary Update Education Material Status
         * @param {string} educationMaterialId 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEducationMaterialStatus(educationMaterialId: string, status: boolean, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.updateEducationMaterialStatus(educationMaterialId, status, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} providerId 
         * @param {string} name 
         * @param {string} description 
         * @param {string} fileName 
         * @param {string} condition 
         * @param {UploadEducationMaterialDocumentFormatEnum} documentFormat 
         * @param {File} file 
         * @param {string} [specialityId] 
         * @param {string} [documentDate] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadEducationMaterial(providerId: string, name: string, description: string, fileName: string, condition: string, documentFormat: UploadEducationMaterialDocumentFormatEnum, file: File, specialityId?: string, documentDate?: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.uploadEducationMaterial(providerId, name, description, fileName, condition, documentFormat, file, specialityId, documentDate, xTENANTID, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * EducationMaterialControllerApi - object-oriented interface
 * @export
 * @class EducationMaterialControllerApi
 * @extends {BaseAPI}
 */
export class EducationMaterialControllerApi extends BaseAPI {
    /**
     * 
     * @param {number} [page] 
     * @param {number} [size] 
     * @param {string} [sortBy] 
     * @param {string} [sortDirection] 
     * @param {boolean} [status] 
     * @param {boolean} [archive] 
     * @param {string} [providerId] 
     * @param {string} [specialityId] 
     * @param {string} [searchString] 
     * @param {string} [patientId] 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EducationMaterialControllerApi
     */
    public getAllEducationMaterials(page?: number, size?: number, sortBy?: string, sortDirection?: string, status?: boolean, archive?: boolean, providerId?: string, specialityId?: string, searchString?: string, patientId?: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return EducationMaterialControllerApiFp(this.configuration).getAllEducationMaterials(page, size, sortBy, sortDirection, status, archive, providerId, specialityId, searchString, patientId, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve an Education Material by its ID
     * @summary Get Education Material by ID
     * @param {string} educationMaterialId 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EducationMaterialControllerApi
     */
    public getEducationMaterialById(educationMaterialId: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return EducationMaterialControllerApiFp(this.configuration).getEducationMaterialById(educationMaterialId, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Share Education Material with Patient
     * @summary Share Education Material with Patient
     * @param {PatientEducationMaterial} patientEducationMaterial 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EducationMaterialControllerApi
     */
    public shareEducationMaterialWithPatient(patientEducationMaterial: PatientEducationMaterial, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return EducationMaterialControllerApiFp(this.configuration).shareEducationMaterialWithPatient(patientEducationMaterial, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update an existing Education Material
     * @summary Update Education Material
     * @param {string} educationMaterialId 
     * @param {string} providerId 
     * @param {string} name 
     * @param {string} description 
     * @param {string} condition 
     * @param {UpdateEducationMaterialDocumentFormatEnum} documentFormat 
     * @param {string} [specialityId] 
     * @param {string} [documentDate] 
     * @param {string} [fileName] 
     * @param {string} [xTENANTID] 
     * @param {File} [file] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EducationMaterialControllerApi
     */
    public updateEducationMaterial(educationMaterialId: string, providerId: string, name: string, description: string, condition: string, documentFormat: UpdateEducationMaterialDocumentFormatEnum, specialityId?: string, documentDate?: string, fileName?: string, xTENANTID?: string, file?: File, options?: RawAxiosRequestConfig) {
        return EducationMaterialControllerApiFp(this.configuration).updateEducationMaterial(educationMaterialId, providerId, name, description, condition, documentFormat, specialityId, documentDate, fileName, xTENANTID, file, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Archive an Education Material by its ID
     * @summary Archive Education Material
     * @param {string} educationMaterialId 
     * @param {boolean} status 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EducationMaterialControllerApi
     */
    public updateEducationMaterialArchiveStatus(educationMaterialId: string, status: boolean, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return EducationMaterialControllerApiFp(this.configuration).updateEducationMaterialArchiveStatus(educationMaterialId, status, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update the status of an Education Material by its ID
     * @summary Update Education Material Status
     * @param {string} educationMaterialId 
     * @param {boolean} status 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EducationMaterialControllerApi
     */
    public updateEducationMaterialStatus(educationMaterialId: string, status: boolean, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return EducationMaterialControllerApiFp(this.configuration).updateEducationMaterialStatus(educationMaterialId, status, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} providerId 
     * @param {string} name 
     * @param {string} description 
     * @param {string} fileName 
     * @param {string} condition 
     * @param {UploadEducationMaterialDocumentFormatEnum} documentFormat 
     * @param {File} file 
     * @param {string} [specialityId] 
     * @param {string} [documentDate] 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EducationMaterialControllerApi
     */
    public uploadEducationMaterial(providerId: string, name: string, description: string, fileName: string, condition: string, documentFormat: UploadEducationMaterialDocumentFormatEnum, file: File, specialityId?: string, documentDate?: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return EducationMaterialControllerApiFp(this.configuration).uploadEducationMaterial(providerId, name, description, fileName, condition, documentFormat, file, specialityId, documentDate, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const UpdateEducationMaterialDocumentFormatEnum = {
    Pdf: 'PDF',
    MsWord: 'MS_WORD',
    Zip: 'ZIP',
    XGzip: 'X_GZIP',
    XCompressed: 'X_COMPRESSED',
    Docx: 'DOCX',
    Rtf: 'RTF',
    Plain: 'PLAIN',
    Xlsx: 'XLSX',
    JpegImage: 'JPEG_IMAGE',
    Mp4: 'MP4',
    PngImage: 'PNG_IMAGE',
    GifImage: 'GIF_IMAGE',
    BmpImage: 'BMP_IMAGE',
    WebpImage: 'WEBP_IMAGE',
    SvgImage: 'SVG_IMAGE',
    MpegAudio: 'MPEG_AUDIO',
    Other: 'OTHER',
    Csv: 'CSV'
} as const;
export type UpdateEducationMaterialDocumentFormatEnum = typeof UpdateEducationMaterialDocumentFormatEnum[keyof typeof UpdateEducationMaterialDocumentFormatEnum];
/**
 * @export
 */
export const UploadEducationMaterialDocumentFormatEnum = {
    Pdf: 'PDF',
    MsWord: 'MS_WORD',
    Zip: 'ZIP',
    XGzip: 'X_GZIP',
    XCompressed: 'X_COMPRESSED',
    Docx: 'DOCX',
    Rtf: 'RTF',
    Plain: 'PLAIN',
    Xlsx: 'XLSX',
    JpegImage: 'JPEG_IMAGE',
    Mp4: 'MP4',
    PngImage: 'PNG_IMAGE',
    GifImage: 'GIF_IMAGE',
    BmpImage: 'BMP_IMAGE',
    WebpImage: 'WEBP_IMAGE',
    SvgImage: 'SVG_IMAGE',
    MpegAudio: 'MPEG_AUDIO',
    Other: 'OTHER',
    Csv: 'CSV'
} as const;
export type UploadEducationMaterialDocumentFormatEnum = typeof UploadEducationMaterialDocumentFormatEnum[keyof typeof UploadEducationMaterialDocumentFormatEnum];


/**
 * EligibilityControllerApi - axios parameter creator
 * @export
 */
export const EligibilityControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} patientUuid 
         * @param {string} insuranceId 
         * @param {CheckEligibilityVendorEnum} vendor 
         * @param {string} [providerId] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkEligibility: async (patientUuid: string, insuranceId: string, vendor: CheckEligibilityVendorEnum, providerId?: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientUuid' is not null or undefined
            assertParamExists('checkEligibility', 'patientUuid', patientUuid)
            // verify required parameter 'insuranceId' is not null or undefined
            assertParamExists('checkEligibility', 'insuranceId', insuranceId)
            // verify required parameter 'vendor' is not null or undefined
            assertParamExists('checkEligibility', 'vendor', vendor)
            const localVarPath = `/api/master/eligibility/{patientUuid}/{insuranceId}/{vendor}`
                .replace(`{${"patientUuid"}}`, encodeURIComponent(String(patientUuid)))
                .replace(`{${"insuranceId"}}`, encodeURIComponent(String(insuranceId)))
                .replace(`{${"vendor"}}`, encodeURIComponent(String(vendor)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (providerId !== undefined) {
                localVarQueryParameter['providerId'] = providerId;
            }

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} patientUuid 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEligibilities: async (patientUuid: string, page?: number, size?: number, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientUuid' is not null or undefined
            assertParamExists('getAllEligibilities', 'patientUuid', patientUuid)
            const localVarPath = `/api/master/eligibility/all/{patientUuid}`
                .replace(`{${"patientUuid"}}`, encodeURIComponent(String(patientUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} eligibilityUuid 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEligibility: async (eligibilityUuid: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'eligibilityUuid' is not null or undefined
            assertParamExists('getEligibility', 'eligibilityUuid', eligibilityUuid)
            const localVarPath = `/api/master/eligibility/eligibility/{eligibilityUuid}`
                .replace(`{${"eligibilityUuid"}}`, encodeURIComponent(String(eligibilityUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} patientUuid 
         * @param {string} insuranceId 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLatestEligibilityByInsurance: async (patientUuid: string, insuranceId: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientUuid' is not null or undefined
            assertParamExists('getLatestEligibilityByInsurance', 'patientUuid', patientUuid)
            // verify required parameter 'insuranceId' is not null or undefined
            assertParamExists('getLatestEligibilityByInsurance', 'insuranceId', insuranceId)
            const localVarPath = `/api/master/eligibility/all/{patientUuid}/{insuranceId}`
                .replace(`{${"patientUuid"}}`, encodeURIComponent(String(patientUuid)))
                .replace(`{${"insuranceId"}}`, encodeURIComponent(String(insuranceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EligibilityControllerApi - functional programming interface
 * @export
 */
export const EligibilityControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = EligibilityControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} patientUuid 
         * @param {string} insuranceId 
         * @param {CheckEligibilityVendorEnum} vendor 
         * @param {string} [providerId] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async checkEligibility(patientUuid: string, insuranceId: string, vendor: CheckEligibilityVendorEnum, providerId?: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.checkEligibility(patientUuid, insuranceId, vendor, providerId, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EligibilityControllerApi.checkEligibility']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} patientUuid 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllEligibilities(patientUuid: string, page?: number, size?: number, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllEligibilities(patientUuid, page, size, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EligibilityControllerApi.getAllEligibilities']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} eligibilityUuid 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEligibility(eligibilityUuid: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEligibility(eligibilityUuid, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EligibilityControllerApi.getEligibility']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} patientUuid 
         * @param {string} insuranceId 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLatestEligibilityByInsurance(patientUuid: string, insuranceId: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLatestEligibilityByInsurance(patientUuid, insuranceId, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EligibilityControllerApi.getLatestEligibilityByInsurance']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * EligibilityControllerApi - factory interface
 * @export
 */
export const EligibilityControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = EligibilityControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {string} patientUuid 
         * @param {string} insuranceId 
         * @param {CheckEligibilityVendorEnum} vendor 
         * @param {string} [providerId] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkEligibility(patientUuid: string, insuranceId: string, vendor: CheckEligibilityVendorEnum, providerId?: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.checkEligibility(patientUuid, insuranceId, vendor, providerId, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} patientUuid 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEligibilities(patientUuid: string, page?: number, size?: number, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getAllEligibilities(patientUuid, page, size, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} eligibilityUuid 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEligibility(eligibilityUuid: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getEligibility(eligibilityUuid, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} patientUuid 
         * @param {string} insuranceId 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLatestEligibilityByInsurance(patientUuid: string, insuranceId: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getLatestEligibilityByInsurance(patientUuid, insuranceId, xTENANTID, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * EligibilityControllerApi - object-oriented interface
 * @export
 * @class EligibilityControllerApi
 * @extends {BaseAPI}
 */
export class EligibilityControllerApi extends BaseAPI {
    /**
     * 
     * @param {string} patientUuid 
     * @param {string} insuranceId 
     * @param {CheckEligibilityVendorEnum} vendor 
     * @param {string} [providerId] 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EligibilityControllerApi
     */
    public checkEligibility(patientUuid: string, insuranceId: string, vendor: CheckEligibilityVendorEnum, providerId?: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return EligibilityControllerApiFp(this.configuration).checkEligibility(patientUuid, insuranceId, vendor, providerId, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} patientUuid 
     * @param {number} [page] 
     * @param {number} [size] 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EligibilityControllerApi
     */
    public getAllEligibilities(patientUuid: string, page?: number, size?: number, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return EligibilityControllerApiFp(this.configuration).getAllEligibilities(patientUuid, page, size, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} eligibilityUuid 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EligibilityControllerApi
     */
    public getEligibility(eligibilityUuid: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return EligibilityControllerApiFp(this.configuration).getEligibility(eligibilityUuid, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} patientUuid 
     * @param {string} insuranceId 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EligibilityControllerApi
     */
    public getLatestEligibilityByInsurance(patientUuid: string, insuranceId: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return EligibilityControllerApiFp(this.configuration).getLatestEligibilityByInsurance(patientUuid, insuranceId, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const CheckEligibilityVendorEnum = {
    Waystar: 'WAYSTAR',
    ClaimMd: 'CLAIM_MD',
    Stedi: 'STEDI'
} as const;
export type CheckEligibilityVendorEnum = typeof CheckEligibilityVendorEnum[keyof typeof CheckEligibilityVendorEnum];


/**
 * EmailHistoryControllerApi - axios parameter creator
 * @export
 */
export const EmailHistoryControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Archive an email history record by its ID
         * @summary Archive Email History
         * @param {string} emailHistoryId 
         * @param {boolean} archiveStatus 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        archiveEmailHistory: async (emailHistoryId: string, archiveStatus: boolean, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'emailHistoryId' is not null or undefined
            assertParamExists('archiveEmailHistory', 'emailHistoryId', emailHistoryId)
            // verify required parameter 'archiveStatus' is not null or undefined
            assertParamExists('archiveEmailHistory', 'archiveStatus', archiveStatus)
            const localVarPath = `/api/master/email-history/{emailHistoryId}/archive/{archiveStatus}`
                .replace(`{${"emailHistoryId"}}`, encodeURIComponent(String(emailHistoryId)))
                .replace(`{${"archiveStatus"}}`, encodeURIComponent(String(archiveStatus)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all email history list.
         * @summary Get all email history.
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sort] 
         * @param {string} [searchString] 
         * @param {string} [patientId] 
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {GetAllEmailHistoryTemplateTypesEnum} [templateTypes] 
         * @param {boolean} [archive] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEmailHistory: async (page?: number, size?: number, sortBy?: string, sort?: string, searchString?: string, patientId?: string, startDate?: string, endDate?: string, templateTypes?: GetAllEmailHistoryTemplateTypesEnum, archive?: boolean, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/master/email-history`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (searchString !== undefined) {
                localVarQueryParameter['searchString'] = searchString;
            }

            if (patientId !== undefined) {
                localVarQueryParameter['patientId'] = patientId;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString() :
                    startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString() :
                    endDate;
            }

            if (templateTypes !== undefined) {
                localVarQueryParameter['templateTypes'] = templateTypes;
            }

            if (archive !== undefined) {
                localVarQueryParameter['archive'] = archive;
            }

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EmailHistoryControllerApi - functional programming interface
 * @export
 */
export const EmailHistoryControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = EmailHistoryControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * Archive an email history record by its ID
         * @summary Archive Email History
         * @param {string} emailHistoryId 
         * @param {boolean} archiveStatus 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async archiveEmailHistory(emailHistoryId: string, archiveStatus: boolean, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.archiveEmailHistory(emailHistoryId, archiveStatus, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EmailHistoryControllerApi.archiveEmailHistory']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get all email history list.
         * @summary Get all email history.
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sort] 
         * @param {string} [searchString] 
         * @param {string} [patientId] 
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {GetAllEmailHistoryTemplateTypesEnum} [templateTypes] 
         * @param {boolean} [archive] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllEmailHistory(page?: number, size?: number, sortBy?: string, sort?: string, searchString?: string, patientId?: string, startDate?: string, endDate?: string, templateTypes?: GetAllEmailHistoryTemplateTypesEnum, archive?: boolean, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllEmailHistory(page, size, sortBy, sort, searchString, patientId, startDate, endDate, templateTypes, archive, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EmailHistoryControllerApi.getAllEmailHistory']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * EmailHistoryControllerApi - factory interface
 * @export
 */
export const EmailHistoryControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = EmailHistoryControllerApiFp(configuration)
    return {
        /**
         * Archive an email history record by its ID
         * @summary Archive Email History
         * @param {string} emailHistoryId 
         * @param {boolean} archiveStatus 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        archiveEmailHistory(emailHistoryId: string, archiveStatus: boolean, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.archiveEmailHistory(emailHistoryId, archiveStatus, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all email history list.
         * @summary Get all email history.
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sort] 
         * @param {string} [searchString] 
         * @param {string} [patientId] 
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {GetAllEmailHistoryTemplateTypesEnum} [templateTypes] 
         * @param {boolean} [archive] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEmailHistory(page?: number, size?: number, sortBy?: string, sort?: string, searchString?: string, patientId?: string, startDate?: string, endDate?: string, templateTypes?: GetAllEmailHistoryTemplateTypesEnum, archive?: boolean, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getAllEmailHistory(page, size, sortBy, sort, searchString, patientId, startDate, endDate, templateTypes, archive, xTENANTID, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * EmailHistoryControllerApi - object-oriented interface
 * @export
 * @class EmailHistoryControllerApi
 * @extends {BaseAPI}
 */
export class EmailHistoryControllerApi extends BaseAPI {
    /**
     * Archive an email history record by its ID
     * @summary Archive Email History
     * @param {string} emailHistoryId 
     * @param {boolean} archiveStatus 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmailHistoryControllerApi
     */
    public archiveEmailHistory(emailHistoryId: string, archiveStatus: boolean, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return EmailHistoryControllerApiFp(this.configuration).archiveEmailHistory(emailHistoryId, archiveStatus, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all email history list.
     * @summary Get all email history.
     * @param {number} [page] 
     * @param {number} [size] 
     * @param {string} [sortBy] 
     * @param {string} [sort] 
     * @param {string} [searchString] 
     * @param {string} [patientId] 
     * @param {string} [startDate] 
     * @param {string} [endDate] 
     * @param {GetAllEmailHistoryTemplateTypesEnum} [templateTypes] 
     * @param {boolean} [archive] 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmailHistoryControllerApi
     */
    public getAllEmailHistory(page?: number, size?: number, sortBy?: string, sort?: string, searchString?: string, patientId?: string, startDate?: string, endDate?: string, templateTypes?: GetAllEmailHistoryTemplateTypesEnum, archive?: boolean, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return EmailHistoryControllerApiFp(this.configuration).getAllEmailHistory(page, size, sortBy, sort, searchString, patientId, startDate, endDate, templateTypes, archive, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const GetAllEmailHistoryTemplateTypesEnum = {
    Email: 'EMAIL',
    Sms: 'SMS',
    Ros: 'ROS',
    Physical: 'PHYSICAL',
    Macros: 'MACROS',
    CarePlan: 'CARE_PLAN',
    HomeCareRos: 'HOME_CARE_ROS',
    HomeCarePe: 'HOME_CARE_PE'
} as const;
export type GetAllEmailHistoryTemplateTypesEnum = typeof GetAllEmailHistoryTemplateTypesEnum[keyof typeof GetAllEmailHistoryTemplateTypesEnum];


/**
 * EmailSmsTemplateControllerApi - axios parameter creator
 * @export
 */
export const EmailSmsTemplateControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Add a new EmailSmsTemplate into the system
         * @summary Add EmailSmsTemplate 
         * @param {EmailSmsTemplate} emailSmsTemplate 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEmailSmsTemplate: async (emailSmsTemplate: EmailSmsTemplate, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'emailSmsTemplate' is not null or undefined
            assertParamExists('createEmailSmsTemplate', 'emailSmsTemplate', emailSmsTemplate)
            const localVarPath = `/api/master/email-sms-template`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(emailSmsTemplate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all template list with search option on template_type options on status, archive. 
         * @summary Get all template
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {boolean} [status] 
         * @param {boolean} [archive] 
         * @param {GetAllProviders1TemplateTypesEnum} [templateTypes] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllProviders1: async (page?: number, size?: number, sortBy?: string, sortDirection?: string, status?: boolean, archive?: boolean, templateTypes?: GetAllProviders1TemplateTypesEnum, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/master/email-sms-template`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (archive !== undefined) {
                localVarQueryParameter['archive'] = archive;
            }

            if (templateTypes !== undefined) {
                localVarQueryParameter['templateTypes'] = templateTypes;
            }

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get template by templateUuid
         * @summary Get template by templateUuid.
         * @param {string} templateUuid 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTemplateById: async (templateUuid: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'templateUuid' is not null or undefined
            assertParamExists('getTemplateById', 'templateUuid', templateUuid)
            const localVarPath = `/api/master/email-sms-template/{templateUuid}`
                .replace(`{${"templateUuid"}}`, encodeURIComponent(String(templateUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Edit EmailSmsTemplate with editable fields as subject,decription.
         * @summary Update emailSmsTemplate
         * @param {EmailSmsTemplate} emailSmsTemplate 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEmailSmsTemplate: async (emailSmsTemplate: EmailSmsTemplate, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'emailSmsTemplate' is not null or undefined
            assertParamExists('updateEmailSmsTemplate', 'emailSmsTemplate', emailSmsTemplate)
            const localVarPath = `/api/master/email-sms-template`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(emailSmsTemplate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Change EmailSmsTemplate archive status to either archived or unarchived.
         * @summary Archive/Unarchive EmailSmsTemplate
         * @param {string} emailSmsTemplateId 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEmailSmsTemplateArchiveStatus: async (emailSmsTemplateId: string, status: boolean, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'emailSmsTemplateId' is not null or undefined
            assertParamExists('updateEmailSmsTemplateArchiveStatus', 'emailSmsTemplateId', emailSmsTemplateId)
            // verify required parameter 'status' is not null or undefined
            assertParamExists('updateEmailSmsTemplateArchiveStatus', 'status', status)
            const localVarPath = `/api/master/email-sms-template/{emailSmsTemplateId}/archive-status/{status}`
                .replace(`{${"emailSmsTemplateId"}}`, encodeURIComponent(String(emailSmsTemplateId)))
                .replace(`{${"status"}}`, encodeURIComponent(String(status)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Change EmailSmsTemplate status to either active or inactive.
         * @summary Enable/Disable emailSmsTemplate
         * @param {string} emailSmsTemplateId 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProviderStatus1: async (emailSmsTemplateId: string, status: boolean, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'emailSmsTemplateId' is not null or undefined
            assertParamExists('updateProviderStatus1', 'emailSmsTemplateId', emailSmsTemplateId)
            // verify required parameter 'status' is not null or undefined
            assertParamExists('updateProviderStatus1', 'status', status)
            const localVarPath = `/api/master/email-sms-template/{emailSmsTemplateId}/status/{status}`
                .replace(`{${"emailSmsTemplateId"}}`, encodeURIComponent(String(emailSmsTemplateId)))
                .replace(`{${"status"}}`, encodeURIComponent(String(status)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EmailSmsTemplateControllerApi - functional programming interface
 * @export
 */
export const EmailSmsTemplateControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = EmailSmsTemplateControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * Add a new EmailSmsTemplate into the system
         * @summary Add EmailSmsTemplate 
         * @param {EmailSmsTemplate} emailSmsTemplate 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createEmailSmsTemplate(emailSmsTemplate: EmailSmsTemplate, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createEmailSmsTemplate(emailSmsTemplate, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EmailSmsTemplateControllerApi.createEmailSmsTemplate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get all template list with search option on template_type options on status, archive. 
         * @summary Get all template
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {boolean} [status] 
         * @param {boolean} [archive] 
         * @param {GetAllProviders1TemplateTypesEnum} [templateTypes] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllProviders1(page?: number, size?: number, sortBy?: string, sortDirection?: string, status?: boolean, archive?: boolean, templateTypes?: GetAllProviders1TemplateTypesEnum, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllProviders1(page, size, sortBy, sortDirection, status, archive, templateTypes, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EmailSmsTemplateControllerApi.getAllProviders1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get template by templateUuid
         * @summary Get template by templateUuid.
         * @param {string} templateUuid 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTemplateById(templateUuid: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTemplateById(templateUuid, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EmailSmsTemplateControllerApi.getTemplateById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Edit EmailSmsTemplate with editable fields as subject,decription.
         * @summary Update emailSmsTemplate
         * @param {EmailSmsTemplate} emailSmsTemplate 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateEmailSmsTemplate(emailSmsTemplate: EmailSmsTemplate, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateEmailSmsTemplate(emailSmsTemplate, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EmailSmsTemplateControllerApi.updateEmailSmsTemplate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Change EmailSmsTemplate archive status to either archived or unarchived.
         * @summary Archive/Unarchive EmailSmsTemplate
         * @param {string} emailSmsTemplateId 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateEmailSmsTemplateArchiveStatus(emailSmsTemplateId: string, status: boolean, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateEmailSmsTemplateArchiveStatus(emailSmsTemplateId, status, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EmailSmsTemplateControllerApi.updateEmailSmsTemplateArchiveStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Change EmailSmsTemplate status to either active or inactive.
         * @summary Enable/Disable emailSmsTemplate
         * @param {string} emailSmsTemplateId 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateProviderStatus1(emailSmsTemplateId: string, status: boolean, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateProviderStatus1(emailSmsTemplateId, status, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EmailSmsTemplateControllerApi.updateProviderStatus1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * EmailSmsTemplateControllerApi - factory interface
 * @export
 */
export const EmailSmsTemplateControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = EmailSmsTemplateControllerApiFp(configuration)
    return {
        /**
         * Add a new EmailSmsTemplate into the system
         * @summary Add EmailSmsTemplate 
         * @param {EmailSmsTemplate} emailSmsTemplate 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEmailSmsTemplate(emailSmsTemplate: EmailSmsTemplate, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.createEmailSmsTemplate(emailSmsTemplate, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all template list with search option on template_type options on status, archive. 
         * @summary Get all template
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {boolean} [status] 
         * @param {boolean} [archive] 
         * @param {GetAllProviders1TemplateTypesEnum} [templateTypes] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllProviders1(page?: number, size?: number, sortBy?: string, sortDirection?: string, status?: boolean, archive?: boolean, templateTypes?: GetAllProviders1TemplateTypesEnum, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getAllProviders1(page, size, sortBy, sortDirection, status, archive, templateTypes, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Get template by templateUuid
         * @summary Get template by templateUuid.
         * @param {string} templateUuid 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTemplateById(templateUuid: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getTemplateById(templateUuid, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Edit EmailSmsTemplate with editable fields as subject,decription.
         * @summary Update emailSmsTemplate
         * @param {EmailSmsTemplate} emailSmsTemplate 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEmailSmsTemplate(emailSmsTemplate: EmailSmsTemplate, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.updateEmailSmsTemplate(emailSmsTemplate, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Change EmailSmsTemplate archive status to either archived or unarchived.
         * @summary Archive/Unarchive EmailSmsTemplate
         * @param {string} emailSmsTemplateId 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEmailSmsTemplateArchiveStatus(emailSmsTemplateId: string, status: boolean, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.updateEmailSmsTemplateArchiveStatus(emailSmsTemplateId, status, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Change EmailSmsTemplate status to either active or inactive.
         * @summary Enable/Disable emailSmsTemplate
         * @param {string} emailSmsTemplateId 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProviderStatus1(emailSmsTemplateId: string, status: boolean, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.updateProviderStatus1(emailSmsTemplateId, status, xTENANTID, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * EmailSmsTemplateControllerApi - object-oriented interface
 * @export
 * @class EmailSmsTemplateControllerApi
 * @extends {BaseAPI}
 */
export class EmailSmsTemplateControllerApi extends BaseAPI {
    /**
     * Add a new EmailSmsTemplate into the system
     * @summary Add EmailSmsTemplate 
     * @param {EmailSmsTemplate} emailSmsTemplate 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmailSmsTemplateControllerApi
     */
    public createEmailSmsTemplate(emailSmsTemplate: EmailSmsTemplate, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return EmailSmsTemplateControllerApiFp(this.configuration).createEmailSmsTemplate(emailSmsTemplate, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all template list with search option on template_type options on status, archive. 
     * @summary Get all template
     * @param {number} [page] 
     * @param {number} [size] 
     * @param {string} [sortBy] 
     * @param {string} [sortDirection] 
     * @param {boolean} [status] 
     * @param {boolean} [archive] 
     * @param {GetAllProviders1TemplateTypesEnum} [templateTypes] 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmailSmsTemplateControllerApi
     */
    public getAllProviders1(page?: number, size?: number, sortBy?: string, sortDirection?: string, status?: boolean, archive?: boolean, templateTypes?: GetAllProviders1TemplateTypesEnum, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return EmailSmsTemplateControllerApiFp(this.configuration).getAllProviders1(page, size, sortBy, sortDirection, status, archive, templateTypes, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get template by templateUuid
     * @summary Get template by templateUuid.
     * @param {string} templateUuid 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmailSmsTemplateControllerApi
     */
    public getTemplateById(templateUuid: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return EmailSmsTemplateControllerApiFp(this.configuration).getTemplateById(templateUuid, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Edit EmailSmsTemplate with editable fields as subject,decription.
     * @summary Update emailSmsTemplate
     * @param {EmailSmsTemplate} emailSmsTemplate 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmailSmsTemplateControllerApi
     */
    public updateEmailSmsTemplate(emailSmsTemplate: EmailSmsTemplate, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return EmailSmsTemplateControllerApiFp(this.configuration).updateEmailSmsTemplate(emailSmsTemplate, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Change EmailSmsTemplate archive status to either archived or unarchived.
     * @summary Archive/Unarchive EmailSmsTemplate
     * @param {string} emailSmsTemplateId 
     * @param {boolean} status 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmailSmsTemplateControllerApi
     */
    public updateEmailSmsTemplateArchiveStatus(emailSmsTemplateId: string, status: boolean, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return EmailSmsTemplateControllerApiFp(this.configuration).updateEmailSmsTemplateArchiveStatus(emailSmsTemplateId, status, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Change EmailSmsTemplate status to either active or inactive.
     * @summary Enable/Disable emailSmsTemplate
     * @param {string} emailSmsTemplateId 
     * @param {boolean} status 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmailSmsTemplateControllerApi
     */
    public updateProviderStatus1(emailSmsTemplateId: string, status: boolean, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return EmailSmsTemplateControllerApiFp(this.configuration).updateProviderStatus1(emailSmsTemplateId, status, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const GetAllProviders1TemplateTypesEnum = {
    Email: 'EMAIL',
    Sms: 'SMS',
    Ros: 'ROS',
    Physical: 'PHYSICAL',
    Macros: 'MACROS',
    CarePlan: 'CARE_PLAN',
    HomeCareRos: 'HOME_CARE_ROS',
    HomeCarePe: 'HOME_CARE_PE'
} as const;
export type GetAllProviders1TemplateTypesEnum = typeof GetAllProviders1TemplateTypesEnum[keyof typeof GetAllProviders1TemplateTypesEnum];


/**
 * EncounterReportControllerApi - axios parameter creator
 * @export
 */
export const EncounterReportControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Exports selected encounters as CSV file. Pass encounter UUIDs in request body.
         * @summary Export patient encounters report as CSV
         * @param {string} [xTENANTID] 
         * @param {Array<string>} [requestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportEncounterReport: async (xTENANTID?: string, requestBody?: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/master/patient-encounter-reports/export-csv`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns paginated encounter listing. Supports filters for date range, provider, location, visit type, status, patient search, and diagnosis search.
         * @summary Get patient encounters report listing
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {Array<string>} [providerUuids] 
         * @param {Array<string>} [locationUuids] 
         * @param {Array<string>} [visitTypes] 
         * @param {Array<string>} [statuses] 
         * @param {string} [patientSearch] 
         * @param {string} [diagnosisSearch] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEncounterReport: async (page?: number, size?: number, sortBy?: string, sortDirection?: string, startDate?: string, endDate?: string, providerUuids?: Array<string>, locationUuids?: Array<string>, visitTypes?: Array<string>, statuses?: Array<string>, patientSearch?: string, diagnosisSearch?: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/master/patient-encounter-reports`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString() :
                    startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString() :
                    endDate;
            }

            if (providerUuids) {
                localVarQueryParameter['providerUuids'] = providerUuids;
            }

            if (locationUuids) {
                localVarQueryParameter['locationUuids'] = locationUuids;
            }

            if (visitTypes) {
                localVarQueryParameter['visitTypes'] = visitTypes;
            }

            if (statuses) {
                localVarQueryParameter['statuses'] = statuses;
            }

            if (patientSearch !== undefined) {
                localVarQueryParameter['patientSearch'] = patientSearch;
            }

            if (diagnosisSearch !== undefined) {
                localVarQueryParameter['diagnosisSearch'] = diagnosisSearch;
            }

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Total encounters, no-show rate, unsigned notes with % change vs previous period.
         * @summary Get patient encounters report dashboard-stats
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {Array<string>} [providerUuids] 
         * @param {Array<string>} [locationUuids] 
         * @param {Array<string>} [modes] 
         * @param {Array<string>} [statuses] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEncounterReportDashboard: async (startDate?: string, endDate?: string, providerUuids?: Array<string>, locationUuids?: Array<string>, modes?: Array<string>, statuses?: Array<string>, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/master/patient-encounter-reports/encounter-dashboard-stats`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString() :
                    startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString() :
                    endDate;
            }

            if (providerUuids) {
                localVarQueryParameter['providerUuids'] = providerUuids;
            }

            if (locationUuids) {
                localVarQueryParameter['locationUuids'] = locationUuids;
            }

            if (modes) {
                localVarQueryParameter['modes'] = modes;
            }

            if (statuses) {
                localVarQueryParameter['statuses'] = statuses;
            }

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EncounterReportControllerApi - functional programming interface
 * @export
 */
export const EncounterReportControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = EncounterReportControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * Exports selected encounters as CSV file. Pass encounter UUIDs in request body.
         * @summary Export patient encounters report as CSV
         * @param {string} [xTENANTID] 
         * @param {Array<string>} [requestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exportEncounterReport(xTENANTID?: string, requestBody?: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.exportEncounterReport(xTENANTID, requestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EncounterReportControllerApi.exportEncounterReport']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns paginated encounter listing. Supports filters for date range, provider, location, visit type, status, patient search, and diagnosis search.
         * @summary Get patient encounters report listing
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {Array<string>} [providerUuids] 
         * @param {Array<string>} [locationUuids] 
         * @param {Array<string>} [visitTypes] 
         * @param {Array<string>} [statuses] 
         * @param {string} [patientSearch] 
         * @param {string} [diagnosisSearch] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEncounterReport(page?: number, size?: number, sortBy?: string, sortDirection?: string, startDate?: string, endDate?: string, providerUuids?: Array<string>, locationUuids?: Array<string>, visitTypes?: Array<string>, statuses?: Array<string>, patientSearch?: string, diagnosisSearch?: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEncounterReport(page, size, sortBy, sortDirection, startDate, endDate, providerUuids, locationUuids, visitTypes, statuses, patientSearch, diagnosisSearch, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EncounterReportControllerApi.getEncounterReport']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Total encounters, no-show rate, unsigned notes with % change vs previous period.
         * @summary Get patient encounters report dashboard-stats
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {Array<string>} [providerUuids] 
         * @param {Array<string>} [locationUuids] 
         * @param {Array<string>} [modes] 
         * @param {Array<string>} [statuses] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEncounterReportDashboard(startDate?: string, endDate?: string, providerUuids?: Array<string>, locationUuids?: Array<string>, modes?: Array<string>, statuses?: Array<string>, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEncounterReportDashboard(startDate, endDate, providerUuids, locationUuids, modes, statuses, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EncounterReportControllerApi.getEncounterReportDashboard']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * EncounterReportControllerApi - factory interface
 * @export
 */
export const EncounterReportControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = EncounterReportControllerApiFp(configuration)
    return {
        /**
         * Exports selected encounters as CSV file. Pass encounter UUIDs in request body.
         * @summary Export patient encounters report as CSV
         * @param {string} [xTENANTID] 
         * @param {Array<string>} [requestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportEncounterReport(xTENANTID?: string, requestBody?: Array<string>, options?: any): AxiosPromise<string> {
            return localVarFp.exportEncounterReport(xTENANTID, requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns paginated encounter listing. Supports filters for date range, provider, location, visit type, status, patient search, and diagnosis search.
         * @summary Get patient encounters report listing
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {Array<string>} [providerUuids] 
         * @param {Array<string>} [locationUuids] 
         * @param {Array<string>} [visitTypes] 
         * @param {Array<string>} [statuses] 
         * @param {string} [patientSearch] 
         * @param {string} [diagnosisSearch] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEncounterReport(page?: number, size?: number, sortBy?: string, sortDirection?: string, startDate?: string, endDate?: string, providerUuids?: Array<string>, locationUuids?: Array<string>, visitTypes?: Array<string>, statuses?: Array<string>, patientSearch?: string, diagnosisSearch?: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getEncounterReport(page, size, sortBy, sortDirection, startDate, endDate, providerUuids, locationUuids, visitTypes, statuses, patientSearch, diagnosisSearch, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Total encounters, no-show rate, unsigned notes with % change vs previous period.
         * @summary Get patient encounters report dashboard-stats
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {Array<string>} [providerUuids] 
         * @param {Array<string>} [locationUuids] 
         * @param {Array<string>} [modes] 
         * @param {Array<string>} [statuses] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEncounterReportDashboard(startDate?: string, endDate?: string, providerUuids?: Array<string>, locationUuids?: Array<string>, modes?: Array<string>, statuses?: Array<string>, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getEncounterReportDashboard(startDate, endDate, providerUuids, locationUuids, modes, statuses, xTENANTID, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * EncounterReportControllerApi - object-oriented interface
 * @export
 * @class EncounterReportControllerApi
 * @extends {BaseAPI}
 */
export class EncounterReportControllerApi extends BaseAPI {
    /**
     * Exports selected encounters as CSV file. Pass encounter UUIDs in request body.
     * @summary Export patient encounters report as CSV
     * @param {string} [xTENANTID] 
     * @param {Array<string>} [requestBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EncounterReportControllerApi
     */
    public exportEncounterReport(xTENANTID?: string, requestBody?: Array<string>, options?: RawAxiosRequestConfig) {
        return EncounterReportControllerApiFp(this.configuration).exportEncounterReport(xTENANTID, requestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns paginated encounter listing. Supports filters for date range, provider, location, visit type, status, patient search, and diagnosis search.
     * @summary Get patient encounters report listing
     * @param {number} [page] 
     * @param {number} [size] 
     * @param {string} [sortBy] 
     * @param {string} [sortDirection] 
     * @param {string} [startDate] 
     * @param {string} [endDate] 
     * @param {Array<string>} [providerUuids] 
     * @param {Array<string>} [locationUuids] 
     * @param {Array<string>} [visitTypes] 
     * @param {Array<string>} [statuses] 
     * @param {string} [patientSearch] 
     * @param {string} [diagnosisSearch] 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EncounterReportControllerApi
     */
    public getEncounterReport(page?: number, size?: number, sortBy?: string, sortDirection?: string, startDate?: string, endDate?: string, providerUuids?: Array<string>, locationUuids?: Array<string>, visitTypes?: Array<string>, statuses?: Array<string>, patientSearch?: string, diagnosisSearch?: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return EncounterReportControllerApiFp(this.configuration).getEncounterReport(page, size, sortBy, sortDirection, startDate, endDate, providerUuids, locationUuids, visitTypes, statuses, patientSearch, diagnosisSearch, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Total encounters, no-show rate, unsigned notes with % change vs previous period.
     * @summary Get patient encounters report dashboard-stats
     * @param {string} [startDate] 
     * @param {string} [endDate] 
     * @param {Array<string>} [providerUuids] 
     * @param {Array<string>} [locationUuids] 
     * @param {Array<string>} [modes] 
     * @param {Array<string>} [statuses] 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EncounterReportControllerApi
     */
    public getEncounterReportDashboard(startDate?: string, endDate?: string, providerUuids?: Array<string>, locationUuids?: Array<string>, modes?: Array<string>, statuses?: Array<string>, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return EncounterReportControllerApiFp(this.configuration).getEncounterReportDashboard(startDate, endDate, providerUuids, locationUuids, modes, statuses, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * EncounterSummaryControllerApi - axios parameter creator
 * @export
 */
export const EncounterSummaryControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Add clinical notes to a specific encounter using appointment and patient IDs
         * @summary Add Clinical Notes to Encounter
         * @param {ClinicalNotesDTO} clinicalNotesDTO 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addClinicalNotesToEncounter: async (clinicalNotesDTO: ClinicalNotesDTO, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'clinicalNotesDTO' is not null or undefined
            assertParamExists('addClinicalNotesToEncounter', 'clinicalNotesDTO', clinicalNotesDTO)
            const localVarPath = `/api/master/encounter-summary/add-clinical-notes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(clinicalNotesDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * archive a single therapy link for an appointment; the archived therapy stops appearing in the appointment\'s therapy list.
         * @summary Archive a therapy for an appointment
         * @param {string} appointmentUuid 
         * @param {string} therapyNoteUuid 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        archiveAppointmentTherapy: async (appointmentUuid: string, therapyNoteUuid: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'appointmentUuid' is not null or undefined
            assertParamExists('archiveAppointmentTherapy', 'appointmentUuid', appointmentUuid)
            // verify required parameter 'therapyNoteUuid' is not null or undefined
            assertParamExists('archiveAppointmentTherapy', 'therapyNoteUuid', therapyNoteUuid)
            const localVarPath = `/api/master/encounter-summary/therapy/{appointmentUuid}/archive/{therapyNoteUuid}`
                .replace(`{${"appointmentUuid"}}`, encodeURIComponent(String(appointmentUuid)))
                .replace(`{${"therapyNoteUuid"}}`, encodeURIComponent(String(therapyNoteUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Add a encounter summary
         * @summary Add encounter summary
         * @param {EncounterSumary} encounterSumary 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEncounterSummary: async (encounterSumary: EncounterSumary, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'encounterSumary' is not null or undefined
            assertParamExists('createEncounterSummary', 'encounterSumary', encounterSumary)
            const localVarPath = `/api/master/encounter-summary`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(encounterSumary, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Links the selected allergies (by allergy uuid in the request body) to an appointment via the join table. Idempotent and non-overriding: the same allergy can be exported to multiple appointments/encounters.
         * @summary Export selected patient allergies to encounter
         * @param {string} appointmentUuid 
         * @param {Set<string>} requestBody 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportAllergyToEncounter: async (appointmentUuid: string, requestBody: Set<string>, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'appointmentUuid' is not null or undefined
            assertParamExists('exportAllergyToEncounter', 'appointmentUuid', appointmentUuid)
            // verify required parameter 'requestBody' is not null or undefined
            assertParamExists('exportAllergyToEncounter', 'requestBody', requestBody)
            const localVarPath = `/api/master/encounter-summary/export-allergy/{appointmentUuid}`
                .replace(`{${"appointmentUuid"}}`, encodeURIComponent(String(appointmentUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Unified import. Links the selected records (by uuid in the request body) of the given type (ALLERGY, MEDICAL_HISTORY, SURGICAL_HISTORY, FAMILY_HISTORY, MEDICATION) to an appointment via the relevant join table. Idempotent and non-overriding: the same record can be exported to multiple appointments/encounters.
         * @summary Export selected clinical records to encounter
         * @param {ExportClinicalDataToEncounterTypeEnum} type 
         * @param {string} appointmentUuid 
         * @param {Set<string>} requestBody 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportClinicalDataToEncounter: async (type: ExportClinicalDataToEncounterTypeEnum, appointmentUuid: string, requestBody: Set<string>, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'type' is not null or undefined
            assertParamExists('exportClinicalDataToEncounter', 'type', type)
            // verify required parameter 'appointmentUuid' is not null or undefined
            assertParamExists('exportClinicalDataToEncounter', 'appointmentUuid', appointmentUuid)
            // verify required parameter 'requestBody' is not null or undefined
            assertParamExists('exportClinicalDataToEncounter', 'requestBody', requestBody)
            const localVarPath = `/api/master/encounter-summary/export-clinical/{type}/{appointmentUuid}`
                .replace(`{${"type"}}`, encodeURIComponent(String(type)))
                .replace(`{${"appointmentUuid"}}`, encodeURIComponent(String(appointmentUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Bulk links unlinked medical, family, and surgical history records to an appointment/encounter.
         * @summary Export patient history to encounter
         * @param {string} patientUuid 
         * @param {string} appointmentUuid 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportHistoryToEncounter: async (patientUuid: string, appointmentUuid: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientUuid' is not null or undefined
            assertParamExists('exportHistoryToEncounter', 'patientUuid', patientUuid)
            // verify required parameter 'appointmentUuid' is not null or undefined
            assertParamExists('exportHistoryToEncounter', 'appointmentUuid', appointmentUuid)
            const localVarPath = `/api/master/encounter-summary/export-history/{patientUuid}/{appointmentUuid}`
                .replace(`{${"patientUuid"}}`, encodeURIComponent(String(patientUuid)))
                .replace(`{${"appointmentUuid"}}`, encodeURIComponent(String(appointmentUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Bulk links unlinked social history records to an appointment/encounter.
         * @summary Export patient social history to encounter
         * @param {string} patientUuid 
         * @param {string} appointmentUuid 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportSocialHistoryToEncounter: async (patientUuid: string, appointmentUuid: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientUuid' is not null or undefined
            assertParamExists('exportSocialHistoryToEncounter', 'patientUuid', patientUuid)
            // verify required parameter 'appointmentUuid' is not null or undefined
            assertParamExists('exportSocialHistoryToEncounter', 'appointmentUuid', appointmentUuid)
            const localVarPath = `/api/master/encounter-summary/export-social-history/{patientUuid}/{appointmentUuid}`
                .replace(`{${"patientUuid"}}`, encodeURIComponent(String(patientUuid)))
                .replace(`{${"appointmentUuid"}}`, encodeURIComponent(String(appointmentUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns the signed addendum of a visit, or no data if the visit has none.
         * @summary Get addendum
         * @param {string} appointmentUuid 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAddendum: async (appointmentUuid: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'appointmentUuid' is not null or undefined
            assertParamExists('getAddendum', 'appointmentUuid', appointmentUuid)
            const localVarPath = `/api/master/encounter-summary/addendum/{appointmentUuid}`
                .replace(`{${"appointmentUuid"}}`, encodeURIComponent(String(appointmentUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Return the paginated therapy note catalog; when appointmentId is supplied, only therapies linked to that appointment.
         * @summary Get all therapies
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [appointmentId] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllTherapyNotes: async (page?: number, size?: number, appointmentId?: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/master/encounter-summary/therapy`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (appointmentId !== undefined) {
                localVarQueryParameter['appointmentId'] = appointmentId;
            }

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve an Codes For Super Bills  by appointment unique ID
         * @summary Get Codes For Super Bills by appointment ID
         * @param {string} appointmentUuid 
         * @param {boolean} [cptBilled] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCodesForSuperBills: async (appointmentUuid: string, cptBilled?: boolean, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'appointmentUuid' is not null or undefined
            assertParamExists('getCodesForSuperBills', 'appointmentUuid', appointmentUuid)
            const localVarPath = `/api/master/encounter-summary/super-bill-code/{appointmentUuid}`
                .replace(`{${"appointmentUuid"}}`, encodeURIComponent(String(appointmentUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (cptBilled !== undefined) {
                localVarQueryParameter['cptBilled'] = cptBilled;
            }

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Uses list implementation (minimal relations + ICD/CPT/RX/ROS/PE). Frontend uses this URL unchanged.
         * @summary Get latest encounter summary.
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [appointmentUuid] 
         * @param {GetEncounterSumaryEncounterStatusEnum} [encounterStatus] 
         * @param {boolean} [status] 
         * @param {string} [sortDirection] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEncounterSumary: async (page?: number, size?: number, sortBy?: string, appointmentUuid?: string, encounterStatus?: GetEncounterSumaryEncounterStatusEnum, status?: boolean, sortDirection?: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/master/encounter-summary`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (appointmentUuid !== undefined) {
                localVarQueryParameter['appointmentUuid'] = appointmentUuid;
            }

            if (encounterStatus !== undefined) {
                localVarQueryParameter['encounterStatus'] = encounterStatus;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Original full response. Use when full relation payload is needed.
         * @summary Get encounter summary (full implementation)
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [appointmentUuid] 
         * @param {GetEncounterSummaryListEncounterStatusEnum} [encounterStatus] 
         * @param {boolean} [status] 
         * @param {string} [sortDirection] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEncounterSummaryList: async (page?: number, size?: number, sortBy?: string, appointmentUuid?: string, encounterStatus?: GetEncounterSummaryListEncounterStatusEnum, status?: boolean, sortDirection?: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/master/encounter-summary/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (appointmentUuid !== undefined) {
                localVarQueryParameter['appointmentUuid'] = appointmentUuid;
            }

            if (encounterStatus !== undefined) {
                localVarQueryParameter['encounterStatus'] = encounterStatus;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Snapshot plus the sign-off summary report: patient avatar, email and phone, signed-by name and signed-at time, and the note\'s answered sections as report lines. Pass section keys to include only those sections.
         * @summary Get encounter summary report
         * @param {string} appointmentUuid 
         * @param {Array<string>} [section] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEncounterSummaryReport: async (appointmentUuid: string, section?: Array<string>, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'appointmentUuid' is not null or undefined
            assertParamExists('getEncounterSummaryReport', 'appointmentUuid', appointmentUuid)
            const localVarPath = `/api/master/encounter-summary/snapshot/{appointmentUuid}/report`
                .replace(`{${"appointmentUuid"}}`, encodeURIComponent(String(appointmentUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (section) {
                localVarQueryParameter['section'] = section;
            }

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Lightweight API - returns encounter summary with pre-computed related data from snapshot
         * @summary Get encounter summary snapshot
         * @param {string} appointmentUuid 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEncounterSummarySnapshot: async (appointmentUuid: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'appointmentUuid' is not null or undefined
            assertParamExists('getEncounterSummarySnapshot', 'appointmentUuid', appointmentUuid)
            const localVarPath = `/api/master/encounter-summary/snapshot/{appointmentUuid}`
                .replace(`{${"appointmentUuid"}}`, encodeURIComponent(String(appointmentUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Uses Slice (no COUNT query) + batch appointment loading. Same data as GET /. For testing before replacing original.
         * @summary Get encounter summary optimized (v2-list)
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [appointmentUuid] 
         * @param {GetEncounterSummaryV2ListEncounterStatusEnum} [encounterStatus] 
         * @param {boolean} [status] 
         * @param {string} [sortDirection] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEncounterSummaryV2List: async (page?: number, size?: number, sortBy?: string, appointmentUuid?: string, encounterStatus?: GetEncounterSummaryV2ListEncounterStatusEnum, status?: boolean, sortDirection?: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/master/encounter-summary/v2-list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (appointmentUuid !== undefined) {
                localVarQueryParameter['appointmentUuid'] = appointmentUuid;
            }

            if (encounterStatus !== undefined) {
                localVarQueryParameter['encounterStatus'] = encounterStatus;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} appointmentUuid 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLatestEncounterSummaryV2: async (appointmentUuid: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'appointmentUuid' is not null or undefined
            assertParamExists('getLatestEncounterSummaryV2', 'appointmentUuid', appointmentUuid)
            const localVarPath = `/api/master/encounter-summary/latest/{appointmentUuid}`
                .replace(`{${"appointmentUuid"}}`, encodeURIComponent(String(appointmentUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Link therapy to particular appointment
         * @summary Store therapies for an appointment
         * @param {string} appointmentUuid 
         * @param {Set<string>} requestBody 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        linkTherapiesToAppointment: async (appointmentUuid: string, requestBody: Set<string>, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'appointmentUuid' is not null or undefined
            assertParamExists('linkTherapiesToAppointment', 'appointmentUuid', appointmentUuid)
            // verify required parameter 'requestBody' is not null or undefined
            assertParamExists('linkTherapiesToAppointment', 'requestBody', requestBody)
            const localVarPath = `/api/master/encounter-summary/therapy/{appointmentUuid}`
                .replace(`{${"appointmentUuid"}}`, encodeURIComponent(String(appointmentUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} appointmentUuid 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        printEncounterDetails: async (appointmentUuid: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'appointmentUuid' is not null or undefined
            assertParamExists('printEncounterDetails', 'appointmentUuid', appointmentUuid)
            const localVarPath = `/api/master/encounter-summary/print/{appointmentUuid}`
                .replace(`{${"appointmentUuid"}}`, encodeURIComponent(String(appointmentUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Detaches a single record (by uuid) of the given type ALLERGY, MEDICAL_HISTORY, SURGICAL_HISTORY, FAMILY_HISTORY, MEDICATION
         * @summary Remove a clinical record from the visit note
         * @param {RemoveClinicalDataFromEncounterTypeEnum} type 
         * @param {string} appointmentUuid 
         * @param {string} recordUuid 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeClinicalDataFromEncounter: async (type: RemoveClinicalDataFromEncounterTypeEnum, appointmentUuid: string, recordUuid: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'type' is not null or undefined
            assertParamExists('removeClinicalDataFromEncounter', 'type', type)
            // verify required parameter 'appointmentUuid' is not null or undefined
            assertParamExists('removeClinicalDataFromEncounter', 'appointmentUuid', appointmentUuid)
            // verify required parameter 'recordUuid' is not null or undefined
            assertParamExists('removeClinicalDataFromEncounter', 'recordUuid', recordUuid)
            const localVarPath = `/api/master/encounter-summary/remove-clinical/{type}/{appointmentUuid}/{recordUuid}`
                .replace(`{${"type"}}`, encodeURIComponent(String(type)))
                .replace(`{${"appointmentUuid"}}`, encodeURIComponent(String(appointmentUuid)))
                .replace(`{${"recordUuid"}}`, encodeURIComponent(String(recordUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Adds the one signed addendum to a signed-off visit. Only the rendering provider can sign it; the original note is not changed and the addendum can\'t be edited or deleted afterwards.
         * @summary Sign addendum
         * @param {string} appointmentUuid 
         * @param {EncounterAddendum} encounterAddendum 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        signAddendum: async (appointmentUuid: string, encounterAddendum: EncounterAddendum, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'appointmentUuid' is not null or undefined
            assertParamExists('signAddendum', 'appointmentUuid', appointmentUuid)
            // verify required parameter 'encounterAddendum' is not null or undefined
            assertParamExists('signAddendum', 'encounterAddendum', encounterAddendum)
            const localVarPath = `/api/master/encounter-summary/addendum/{appointmentUuid}`
                .replace(`{${"appointmentUuid"}}`, encodeURIComponent(String(appointmentUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(encounterAddendum, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * sign off encounter
         * @summary Sign off encounter
         * @param {string} encounterSummaryId 
         * @param {EncounterSignOff} encounterSignOff 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        signOffEncounterSummary: async (encounterSummaryId: string, encounterSignOff: EncounterSignOff, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'encounterSummaryId' is not null or undefined
            assertParamExists('signOffEncounterSummary', 'encounterSummaryId', encounterSummaryId)
            // verify required parameter 'encounterSignOff' is not null or undefined
            assertParamExists('signOffEncounterSummary', 'encounterSignOff', encounterSignOff)
            const localVarPath = `/api/master/encounter-summary/{encounterSummaryId}/encounter-sign-off`
                .replace(`{${"encounterSummaryId"}}`, encodeURIComponent(String(encounterSummaryId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(encounterSignOff, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update a encounter summary
         * @summary Update encounter summary
         * @param {EncounterSumary} encounterSumary 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEncounterSummary: async (encounterSumary: EncounterSumary, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'encounterSumary' is not null or undefined
            assertParamExists('updateEncounterSummary', 'encounterSumary', encounterSumary)
            const localVarPath = `/api/master/encounter-summary`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(encounterSumary, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Archive a Encounter summary record by its ID
         * @summary Archive encounter summary
         * @param {string} encounterSummaryId 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEncounterSummaryArchiveStatus: async (encounterSummaryId: string, status: boolean, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'encounterSummaryId' is not null or undefined
            assertParamExists('updateEncounterSummaryArchiveStatus', 'encounterSummaryId', encounterSummaryId)
            // verify required parameter 'status' is not null or undefined
            assertParamExists('updateEncounterSummaryArchiveStatus', 'status', status)
            const localVarPath = `/api/master/encounter-summary/{encounterSummaryId}/archive-status/{status}`
                .replace(`{${"encounterSummaryId"}}`, encodeURIComponent(String(encounterSummaryId)))
                .replace(`{${"status"}}`, encodeURIComponent(String(status)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Uploads the clock drawing image (PNG or JPEG) of a visit\'s Mini Cognitive Test and returns its key, to save in the note, and a preview URL
         * @summary Upload Mini-Cog clock drawing
         * @param {string} appointmentUuid 
         * @param {File} file 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadClockDrawing: async (appointmentUuid: string, file: File, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'appointmentUuid' is not null or undefined
            assertParamExists('uploadClockDrawing', 'appointmentUuid', appointmentUuid)
            // verify required parameter 'file' is not null or undefined
            assertParamExists('uploadClockDrawing', 'file', file)
            const localVarPath = `/api/master/encounter-summary/clock-drawing`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (appointmentUuid !== undefined) {
                localVarQueryParameter['appointmentUuid'] = appointmentUuid;
            }

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EncounterSummaryControllerApi - functional programming interface
 * @export
 */
export const EncounterSummaryControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = EncounterSummaryControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * Add clinical notes to a specific encounter using appointment and patient IDs
         * @summary Add Clinical Notes to Encounter
         * @param {ClinicalNotesDTO} clinicalNotesDTO 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addClinicalNotesToEncounter(clinicalNotesDTO: ClinicalNotesDTO, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addClinicalNotesToEncounter(clinicalNotesDTO, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EncounterSummaryControllerApi.addClinicalNotesToEncounter']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * archive a single therapy link for an appointment; the archived therapy stops appearing in the appointment\'s therapy list.
         * @summary Archive a therapy for an appointment
         * @param {string} appointmentUuid 
         * @param {string} therapyNoteUuid 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async archiveAppointmentTherapy(appointmentUuid: string, therapyNoteUuid: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.archiveAppointmentTherapy(appointmentUuid, therapyNoteUuid, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EncounterSummaryControllerApi.archiveAppointmentTherapy']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Add a encounter summary
         * @summary Add encounter summary
         * @param {EncounterSumary} encounterSumary 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createEncounterSummary(encounterSumary: EncounterSumary, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createEncounterSummary(encounterSumary, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EncounterSummaryControllerApi.createEncounterSummary']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Links the selected allergies (by allergy uuid in the request body) to an appointment via the join table. Idempotent and non-overriding: the same allergy can be exported to multiple appointments/encounters.
         * @summary Export selected patient allergies to encounter
         * @param {string} appointmentUuid 
         * @param {Set<string>} requestBody 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exportAllergyToEncounter(appointmentUuid: string, requestBody: Set<string>, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.exportAllergyToEncounter(appointmentUuid, requestBody, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EncounterSummaryControllerApi.exportAllergyToEncounter']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Unified import. Links the selected records (by uuid in the request body) of the given type (ALLERGY, MEDICAL_HISTORY, SURGICAL_HISTORY, FAMILY_HISTORY, MEDICATION) to an appointment via the relevant join table. Idempotent and non-overriding: the same record can be exported to multiple appointments/encounters.
         * @summary Export selected clinical records to encounter
         * @param {ExportClinicalDataToEncounterTypeEnum} type 
         * @param {string} appointmentUuid 
         * @param {Set<string>} requestBody 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exportClinicalDataToEncounter(type: ExportClinicalDataToEncounterTypeEnum, appointmentUuid: string, requestBody: Set<string>, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.exportClinicalDataToEncounter(type, appointmentUuid, requestBody, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EncounterSummaryControllerApi.exportClinicalDataToEncounter']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Bulk links unlinked medical, family, and surgical history records to an appointment/encounter.
         * @summary Export patient history to encounter
         * @param {string} patientUuid 
         * @param {string} appointmentUuid 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exportHistoryToEncounter(patientUuid: string, appointmentUuid: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.exportHistoryToEncounter(patientUuid, appointmentUuid, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EncounterSummaryControllerApi.exportHistoryToEncounter']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Bulk links unlinked social history records to an appointment/encounter.
         * @summary Export patient social history to encounter
         * @param {string} patientUuid 
         * @param {string} appointmentUuid 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exportSocialHistoryToEncounter(patientUuid: string, appointmentUuid: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.exportSocialHistoryToEncounter(patientUuid, appointmentUuid, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EncounterSummaryControllerApi.exportSocialHistoryToEncounter']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns the signed addendum of a visit, or no data if the visit has none.
         * @summary Get addendum
         * @param {string} appointmentUuid 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAddendum(appointmentUuid: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAddendum(appointmentUuid, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EncounterSummaryControllerApi.getAddendum']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Return the paginated therapy note catalog; when appointmentId is supplied, only therapies linked to that appointment.
         * @summary Get all therapies
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [appointmentId] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllTherapyNotes(page?: number, size?: number, appointmentId?: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllTherapyNotes(page, size, appointmentId, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EncounterSummaryControllerApi.getAllTherapyNotes']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve an Codes For Super Bills  by appointment unique ID
         * @summary Get Codes For Super Bills by appointment ID
         * @param {string} appointmentUuid 
         * @param {boolean} [cptBilled] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCodesForSuperBills(appointmentUuid: string, cptBilled?: boolean, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCodesForSuperBills(appointmentUuid, cptBilled, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EncounterSummaryControllerApi.getCodesForSuperBills']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Uses list implementation (minimal relations + ICD/CPT/RX/ROS/PE). Frontend uses this URL unchanged.
         * @summary Get latest encounter summary.
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [appointmentUuid] 
         * @param {GetEncounterSumaryEncounterStatusEnum} [encounterStatus] 
         * @param {boolean} [status] 
         * @param {string} [sortDirection] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEncounterSumary(page?: number, size?: number, sortBy?: string, appointmentUuid?: string, encounterStatus?: GetEncounterSumaryEncounterStatusEnum, status?: boolean, sortDirection?: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEncounterSumary(page, size, sortBy, appointmentUuid, encounterStatus, status, sortDirection, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EncounterSummaryControllerApi.getEncounterSumary']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Original full response. Use when full relation payload is needed.
         * @summary Get encounter summary (full implementation)
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [appointmentUuid] 
         * @param {GetEncounterSummaryListEncounterStatusEnum} [encounterStatus] 
         * @param {boolean} [status] 
         * @param {string} [sortDirection] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEncounterSummaryList(page?: number, size?: number, sortBy?: string, appointmentUuid?: string, encounterStatus?: GetEncounterSummaryListEncounterStatusEnum, status?: boolean, sortDirection?: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEncounterSummaryList(page, size, sortBy, appointmentUuid, encounterStatus, status, sortDirection, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EncounterSummaryControllerApi.getEncounterSummaryList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Snapshot plus the sign-off summary report: patient avatar, email and phone, signed-by name and signed-at time, and the note\'s answered sections as report lines. Pass section keys to include only those sections.
         * @summary Get encounter summary report
         * @param {string} appointmentUuid 
         * @param {Array<string>} [section] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEncounterSummaryReport(appointmentUuid: string, section?: Array<string>, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEncounterSummaryReport(appointmentUuid, section, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EncounterSummaryControllerApi.getEncounterSummaryReport']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Lightweight API - returns encounter summary with pre-computed related data from snapshot
         * @summary Get encounter summary snapshot
         * @param {string} appointmentUuid 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEncounterSummarySnapshot(appointmentUuid: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEncounterSummarySnapshot(appointmentUuid, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EncounterSummaryControllerApi.getEncounterSummarySnapshot']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Uses Slice (no COUNT query) + batch appointment loading. Same data as GET /. For testing before replacing original.
         * @summary Get encounter summary optimized (v2-list)
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [appointmentUuid] 
         * @param {GetEncounterSummaryV2ListEncounterStatusEnum} [encounterStatus] 
         * @param {boolean} [status] 
         * @param {string} [sortDirection] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEncounterSummaryV2List(page?: number, size?: number, sortBy?: string, appointmentUuid?: string, encounterStatus?: GetEncounterSummaryV2ListEncounterStatusEnum, status?: boolean, sortDirection?: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEncounterSummaryV2List(page, size, sortBy, appointmentUuid, encounterStatus, status, sortDirection, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EncounterSummaryControllerApi.getEncounterSummaryV2List']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} appointmentUuid 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLatestEncounterSummaryV2(appointmentUuid: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLatestEncounterSummaryV2(appointmentUuid, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EncounterSummaryControllerApi.getLatestEncounterSummaryV2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Link therapy to particular appointment
         * @summary Store therapies for an appointment
         * @param {string} appointmentUuid 
         * @param {Set<string>} requestBody 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async linkTherapiesToAppointment(appointmentUuid: string, requestBody: Set<string>, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.linkTherapiesToAppointment(appointmentUuid, requestBody, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EncounterSummaryControllerApi.linkTherapiesToAppointment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} appointmentUuid 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async printEncounterDetails(appointmentUuid: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.printEncounterDetails(appointmentUuid, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EncounterSummaryControllerApi.printEncounterDetails']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Detaches a single record (by uuid) of the given type ALLERGY, MEDICAL_HISTORY, SURGICAL_HISTORY, FAMILY_HISTORY, MEDICATION
         * @summary Remove a clinical record from the visit note
         * @param {RemoveClinicalDataFromEncounterTypeEnum} type 
         * @param {string} appointmentUuid 
         * @param {string} recordUuid 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeClinicalDataFromEncounter(type: RemoveClinicalDataFromEncounterTypeEnum, appointmentUuid: string, recordUuid: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removeClinicalDataFromEncounter(type, appointmentUuid, recordUuid, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EncounterSummaryControllerApi.removeClinicalDataFromEncounter']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Adds the one signed addendum to a signed-off visit. Only the rendering provider can sign it; the original note is not changed and the addendum can\'t be edited or deleted afterwards.
         * @summary Sign addendum
         * @param {string} appointmentUuid 
         * @param {EncounterAddendum} encounterAddendum 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async signAddendum(appointmentUuid: string, encounterAddendum: EncounterAddendum, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.signAddendum(appointmentUuid, encounterAddendum, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EncounterSummaryControllerApi.signAddendum']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * sign off encounter
         * @summary Sign off encounter
         * @param {string} encounterSummaryId 
         * @param {EncounterSignOff} encounterSignOff 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async signOffEncounterSummary(encounterSummaryId: string, encounterSignOff: EncounterSignOff, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.signOffEncounterSummary(encounterSummaryId, encounterSignOff, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EncounterSummaryControllerApi.signOffEncounterSummary']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update a encounter summary
         * @summary Update encounter summary
         * @param {EncounterSumary} encounterSumary 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateEncounterSummary(encounterSumary: EncounterSumary, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateEncounterSummary(encounterSumary, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EncounterSummaryControllerApi.updateEncounterSummary']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Archive a Encounter summary record by its ID
         * @summary Archive encounter summary
         * @param {string} encounterSummaryId 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateEncounterSummaryArchiveStatus(encounterSummaryId: string, status: boolean, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateEncounterSummaryArchiveStatus(encounterSummaryId, status, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EncounterSummaryControllerApi.updateEncounterSummaryArchiveStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Uploads the clock drawing image (PNG or JPEG) of a visit\'s Mini Cognitive Test and returns its key, to save in the note, and a preview URL
         * @summary Upload Mini-Cog clock drawing
         * @param {string} appointmentUuid 
         * @param {File} file 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadClockDrawing(appointmentUuid: string, file: File, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadClockDrawing(appointmentUuid, file, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EncounterSummaryControllerApi.uploadClockDrawing']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * EncounterSummaryControllerApi - factory interface
 * @export
 */
export const EncounterSummaryControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = EncounterSummaryControllerApiFp(configuration)
    return {
        /**
         * Add clinical notes to a specific encounter using appointment and patient IDs
         * @summary Add Clinical Notes to Encounter
         * @param {ClinicalNotesDTO} clinicalNotesDTO 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addClinicalNotesToEncounter(clinicalNotesDTO: ClinicalNotesDTO, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.addClinicalNotesToEncounter(clinicalNotesDTO, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * archive a single therapy link for an appointment; the archived therapy stops appearing in the appointment\'s therapy list.
         * @summary Archive a therapy for an appointment
         * @param {string} appointmentUuid 
         * @param {string} therapyNoteUuid 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        archiveAppointmentTherapy(appointmentUuid: string, therapyNoteUuid: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.archiveAppointmentTherapy(appointmentUuid, therapyNoteUuid, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Add a encounter summary
         * @summary Add encounter summary
         * @param {EncounterSumary} encounterSumary 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEncounterSummary(encounterSumary: EncounterSumary, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.createEncounterSummary(encounterSumary, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Links the selected allergies (by allergy uuid in the request body) to an appointment via the join table. Idempotent and non-overriding: the same allergy can be exported to multiple appointments/encounters.
         * @summary Export selected patient allergies to encounter
         * @param {string} appointmentUuid 
         * @param {Set<string>} requestBody 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportAllergyToEncounter(appointmentUuid: string, requestBody: Set<string>, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.exportAllergyToEncounter(appointmentUuid, requestBody, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Unified import. Links the selected records (by uuid in the request body) of the given type (ALLERGY, MEDICAL_HISTORY, SURGICAL_HISTORY, FAMILY_HISTORY, MEDICATION) to an appointment via the relevant join table. Idempotent and non-overriding: the same record can be exported to multiple appointments/encounters.
         * @summary Export selected clinical records to encounter
         * @param {ExportClinicalDataToEncounterTypeEnum} type 
         * @param {string} appointmentUuid 
         * @param {Set<string>} requestBody 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportClinicalDataToEncounter(type: ExportClinicalDataToEncounterTypeEnum, appointmentUuid: string, requestBody: Set<string>, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.exportClinicalDataToEncounter(type, appointmentUuid, requestBody, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Bulk links unlinked medical, family, and surgical history records to an appointment/encounter.
         * @summary Export patient history to encounter
         * @param {string} patientUuid 
         * @param {string} appointmentUuid 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportHistoryToEncounter(patientUuid: string, appointmentUuid: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.exportHistoryToEncounter(patientUuid, appointmentUuid, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Bulk links unlinked social history records to an appointment/encounter.
         * @summary Export patient social history to encounter
         * @param {string} patientUuid 
         * @param {string} appointmentUuid 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportSocialHistoryToEncounter(patientUuid: string, appointmentUuid: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.exportSocialHistoryToEncounter(patientUuid, appointmentUuid, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns the signed addendum of a visit, or no data if the visit has none.
         * @summary Get addendum
         * @param {string} appointmentUuid 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAddendum(appointmentUuid: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getAddendum(appointmentUuid, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Return the paginated therapy note catalog; when appointmentId is supplied, only therapies linked to that appointment.
         * @summary Get all therapies
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [appointmentId] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllTherapyNotes(page?: number, size?: number, appointmentId?: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getAllTherapyNotes(page, size, appointmentId, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve an Codes For Super Bills  by appointment unique ID
         * @summary Get Codes For Super Bills by appointment ID
         * @param {string} appointmentUuid 
         * @param {boolean} [cptBilled] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCodesForSuperBills(appointmentUuid: string, cptBilled?: boolean, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getCodesForSuperBills(appointmentUuid, cptBilled, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Uses list implementation (minimal relations + ICD/CPT/RX/ROS/PE). Frontend uses this URL unchanged.
         * @summary Get latest encounter summary.
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [appointmentUuid] 
         * @param {GetEncounterSumaryEncounterStatusEnum} [encounterStatus] 
         * @param {boolean} [status] 
         * @param {string} [sortDirection] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEncounterSumary(page?: number, size?: number, sortBy?: string, appointmentUuid?: string, encounterStatus?: GetEncounterSumaryEncounterStatusEnum, status?: boolean, sortDirection?: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getEncounterSumary(page, size, sortBy, appointmentUuid, encounterStatus, status, sortDirection, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Original full response. Use when full relation payload is needed.
         * @summary Get encounter summary (full implementation)
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [appointmentUuid] 
         * @param {GetEncounterSummaryListEncounterStatusEnum} [encounterStatus] 
         * @param {boolean} [status] 
         * @param {string} [sortDirection] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEncounterSummaryList(page?: number, size?: number, sortBy?: string, appointmentUuid?: string, encounterStatus?: GetEncounterSummaryListEncounterStatusEnum, status?: boolean, sortDirection?: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getEncounterSummaryList(page, size, sortBy, appointmentUuid, encounterStatus, status, sortDirection, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Snapshot plus the sign-off summary report: patient avatar, email and phone, signed-by name and signed-at time, and the note\'s answered sections as report lines. Pass section keys to include only those sections.
         * @summary Get encounter summary report
         * @param {string} appointmentUuid 
         * @param {Array<string>} [section] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEncounterSummaryReport(appointmentUuid: string, section?: Array<string>, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getEncounterSummaryReport(appointmentUuid, section, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Lightweight API - returns encounter summary with pre-computed related data from snapshot
         * @summary Get encounter summary snapshot
         * @param {string} appointmentUuid 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEncounterSummarySnapshot(appointmentUuid: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getEncounterSummarySnapshot(appointmentUuid, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Uses Slice (no COUNT query) + batch appointment loading. Same data as GET /. For testing before replacing original.
         * @summary Get encounter summary optimized (v2-list)
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [appointmentUuid] 
         * @param {GetEncounterSummaryV2ListEncounterStatusEnum} [encounterStatus] 
         * @param {boolean} [status] 
         * @param {string} [sortDirection] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEncounterSummaryV2List(page?: number, size?: number, sortBy?: string, appointmentUuid?: string, encounterStatus?: GetEncounterSummaryV2ListEncounterStatusEnum, status?: boolean, sortDirection?: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getEncounterSummaryV2List(page, size, sortBy, appointmentUuid, encounterStatus, status, sortDirection, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} appointmentUuid 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLatestEncounterSummaryV2(appointmentUuid: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getLatestEncounterSummaryV2(appointmentUuid, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Link therapy to particular appointment
         * @summary Store therapies for an appointment
         * @param {string} appointmentUuid 
         * @param {Set<string>} requestBody 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        linkTherapiesToAppointment(appointmentUuid: string, requestBody: Set<string>, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.linkTherapiesToAppointment(appointmentUuid, requestBody, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} appointmentUuid 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        printEncounterDetails(appointmentUuid: string, xTENANTID?: string, options?: any): AxiosPromise<string> {
            return localVarFp.printEncounterDetails(appointmentUuid, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Detaches a single record (by uuid) of the given type ALLERGY, MEDICAL_HISTORY, SURGICAL_HISTORY, FAMILY_HISTORY, MEDICATION
         * @summary Remove a clinical record from the visit note
         * @param {RemoveClinicalDataFromEncounterTypeEnum} type 
         * @param {string} appointmentUuid 
         * @param {string} recordUuid 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeClinicalDataFromEncounter(type: RemoveClinicalDataFromEncounterTypeEnum, appointmentUuid: string, recordUuid: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.removeClinicalDataFromEncounter(type, appointmentUuid, recordUuid, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Adds the one signed addendum to a signed-off visit. Only the rendering provider can sign it; the original note is not changed and the addendum can\'t be edited or deleted afterwards.
         * @summary Sign addendum
         * @param {string} appointmentUuid 
         * @param {EncounterAddendum} encounterAddendum 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        signAddendum(appointmentUuid: string, encounterAddendum: EncounterAddendum, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.signAddendum(appointmentUuid, encounterAddendum, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * sign off encounter
         * @summary Sign off encounter
         * @param {string} encounterSummaryId 
         * @param {EncounterSignOff} encounterSignOff 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        signOffEncounterSummary(encounterSummaryId: string, encounterSignOff: EncounterSignOff, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.signOffEncounterSummary(encounterSummaryId, encounterSignOff, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Update a encounter summary
         * @summary Update encounter summary
         * @param {EncounterSumary} encounterSumary 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEncounterSummary(encounterSumary: EncounterSumary, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.updateEncounterSummary(encounterSumary, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Archive a Encounter summary record by its ID
         * @summary Archive encounter summary
         * @param {string} encounterSummaryId 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEncounterSummaryArchiveStatus(encounterSummaryId: string, status: boolean, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.updateEncounterSummaryArchiveStatus(encounterSummaryId, status, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Uploads the clock drawing image (PNG or JPEG) of a visit\'s Mini Cognitive Test and returns its key, to save in the note, and a preview URL
         * @summary Upload Mini-Cog clock drawing
         * @param {string} appointmentUuid 
         * @param {File} file 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadClockDrawing(appointmentUuid: string, file: File, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.uploadClockDrawing(appointmentUuid, file, xTENANTID, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * EncounterSummaryControllerApi - object-oriented interface
 * @export
 * @class EncounterSummaryControllerApi
 * @extends {BaseAPI}
 */
export class EncounterSummaryControllerApi extends BaseAPI {
    /**
     * Add clinical notes to a specific encounter using appointment and patient IDs
     * @summary Add Clinical Notes to Encounter
     * @param {ClinicalNotesDTO} clinicalNotesDTO 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EncounterSummaryControllerApi
     */
    public addClinicalNotesToEncounter(clinicalNotesDTO: ClinicalNotesDTO, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return EncounterSummaryControllerApiFp(this.configuration).addClinicalNotesToEncounter(clinicalNotesDTO, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * archive a single therapy link for an appointment; the archived therapy stops appearing in the appointment\'s therapy list.
     * @summary Archive a therapy for an appointment
     * @param {string} appointmentUuid 
     * @param {string} therapyNoteUuid 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EncounterSummaryControllerApi
     */
    public archiveAppointmentTherapy(appointmentUuid: string, therapyNoteUuid: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return EncounterSummaryControllerApiFp(this.configuration).archiveAppointmentTherapy(appointmentUuid, therapyNoteUuid, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Add a encounter summary
     * @summary Add encounter summary
     * @param {EncounterSumary} encounterSumary 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EncounterSummaryControllerApi
     */
    public createEncounterSummary(encounterSumary: EncounterSumary, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return EncounterSummaryControllerApiFp(this.configuration).createEncounterSummary(encounterSumary, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Links the selected allergies (by allergy uuid in the request body) to an appointment via the join table. Idempotent and non-overriding: the same allergy can be exported to multiple appointments/encounters.
     * @summary Export selected patient allergies to encounter
     * @param {string} appointmentUuid 
     * @param {Set<string>} requestBody 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EncounterSummaryControllerApi
     */
    public exportAllergyToEncounter(appointmentUuid: string, requestBody: Set<string>, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return EncounterSummaryControllerApiFp(this.configuration).exportAllergyToEncounter(appointmentUuid, requestBody, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Unified import. Links the selected records (by uuid in the request body) of the given type (ALLERGY, MEDICAL_HISTORY, SURGICAL_HISTORY, FAMILY_HISTORY, MEDICATION) to an appointment via the relevant join table. Idempotent and non-overriding: the same record can be exported to multiple appointments/encounters.
     * @summary Export selected clinical records to encounter
     * @param {ExportClinicalDataToEncounterTypeEnum} type 
     * @param {string} appointmentUuid 
     * @param {Set<string>} requestBody 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EncounterSummaryControllerApi
     */
    public exportClinicalDataToEncounter(type: ExportClinicalDataToEncounterTypeEnum, appointmentUuid: string, requestBody: Set<string>, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return EncounterSummaryControllerApiFp(this.configuration).exportClinicalDataToEncounter(type, appointmentUuid, requestBody, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Bulk links unlinked medical, family, and surgical history records to an appointment/encounter.
     * @summary Export patient history to encounter
     * @param {string} patientUuid 
     * @param {string} appointmentUuid 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EncounterSummaryControllerApi
     */
    public exportHistoryToEncounter(patientUuid: string, appointmentUuid: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return EncounterSummaryControllerApiFp(this.configuration).exportHistoryToEncounter(patientUuid, appointmentUuid, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Bulk links unlinked social history records to an appointment/encounter.
     * @summary Export patient social history to encounter
     * @param {string} patientUuid 
     * @param {string} appointmentUuid 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EncounterSummaryControllerApi
     */
    public exportSocialHistoryToEncounter(patientUuid: string, appointmentUuid: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return EncounterSummaryControllerApiFp(this.configuration).exportSocialHistoryToEncounter(patientUuid, appointmentUuid, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns the signed addendum of a visit, or no data if the visit has none.
     * @summary Get addendum
     * @param {string} appointmentUuid 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EncounterSummaryControllerApi
     */
    public getAddendum(appointmentUuid: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return EncounterSummaryControllerApiFp(this.configuration).getAddendum(appointmentUuid, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Return the paginated therapy note catalog; when appointmentId is supplied, only therapies linked to that appointment.
     * @summary Get all therapies
     * @param {number} [page] 
     * @param {number} [size] 
     * @param {string} [appointmentId] 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EncounterSummaryControllerApi
     */
    public getAllTherapyNotes(page?: number, size?: number, appointmentId?: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return EncounterSummaryControllerApiFp(this.configuration).getAllTherapyNotes(page, size, appointmentId, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve an Codes For Super Bills  by appointment unique ID
     * @summary Get Codes For Super Bills by appointment ID
     * @param {string} appointmentUuid 
     * @param {boolean} [cptBilled] 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EncounterSummaryControllerApi
     */
    public getCodesForSuperBills(appointmentUuid: string, cptBilled?: boolean, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return EncounterSummaryControllerApiFp(this.configuration).getCodesForSuperBills(appointmentUuid, cptBilled, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Uses list implementation (minimal relations + ICD/CPT/RX/ROS/PE). Frontend uses this URL unchanged.
     * @summary Get latest encounter summary.
     * @param {number} [page] 
     * @param {number} [size] 
     * @param {string} [sortBy] 
     * @param {string} [appointmentUuid] 
     * @param {GetEncounterSumaryEncounterStatusEnum} [encounterStatus] 
     * @param {boolean} [status] 
     * @param {string} [sortDirection] 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EncounterSummaryControllerApi
     */
    public getEncounterSumary(page?: number, size?: number, sortBy?: string, appointmentUuid?: string, encounterStatus?: GetEncounterSumaryEncounterStatusEnum, status?: boolean, sortDirection?: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return EncounterSummaryControllerApiFp(this.configuration).getEncounterSumary(page, size, sortBy, appointmentUuid, encounterStatus, status, sortDirection, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Original full response. Use when full relation payload is needed.
     * @summary Get encounter summary (full implementation)
     * @param {number} [page] 
     * @param {number} [size] 
     * @param {string} [sortBy] 
     * @param {string} [appointmentUuid] 
     * @param {GetEncounterSummaryListEncounterStatusEnum} [encounterStatus] 
     * @param {boolean} [status] 
     * @param {string} [sortDirection] 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EncounterSummaryControllerApi
     */
    public getEncounterSummaryList(page?: number, size?: number, sortBy?: string, appointmentUuid?: string, encounterStatus?: GetEncounterSummaryListEncounterStatusEnum, status?: boolean, sortDirection?: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return EncounterSummaryControllerApiFp(this.configuration).getEncounterSummaryList(page, size, sortBy, appointmentUuid, encounterStatus, status, sortDirection, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Snapshot plus the sign-off summary report: patient avatar, email and phone, signed-by name and signed-at time, and the note\'s answered sections as report lines. Pass section keys to include only those sections.
     * @summary Get encounter summary report
     * @param {string} appointmentUuid 
     * @param {Array<string>} [section] 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EncounterSummaryControllerApi
     */
    public getEncounterSummaryReport(appointmentUuid: string, section?: Array<string>, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return EncounterSummaryControllerApiFp(this.configuration).getEncounterSummaryReport(appointmentUuid, section, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Lightweight API - returns encounter summary with pre-computed related data from snapshot
     * @summary Get encounter summary snapshot
     * @param {string} appointmentUuid 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EncounterSummaryControllerApi
     */
    public getEncounterSummarySnapshot(appointmentUuid: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return EncounterSummaryControllerApiFp(this.configuration).getEncounterSummarySnapshot(appointmentUuid, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Uses Slice (no COUNT query) + batch appointment loading. Same data as GET /. For testing before replacing original.
     * @summary Get encounter summary optimized (v2-list)
     * @param {number} [page] 
     * @param {number} [size] 
     * @param {string} [sortBy] 
     * @param {string} [appointmentUuid] 
     * @param {GetEncounterSummaryV2ListEncounterStatusEnum} [encounterStatus] 
     * @param {boolean} [status] 
     * @param {string} [sortDirection] 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EncounterSummaryControllerApi
     */
    public getEncounterSummaryV2List(page?: number, size?: number, sortBy?: string, appointmentUuid?: string, encounterStatus?: GetEncounterSummaryV2ListEncounterStatusEnum, status?: boolean, sortDirection?: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return EncounterSummaryControllerApiFp(this.configuration).getEncounterSummaryV2List(page, size, sortBy, appointmentUuid, encounterStatus, status, sortDirection, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} appointmentUuid 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EncounterSummaryControllerApi
     */
    public getLatestEncounterSummaryV2(appointmentUuid: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return EncounterSummaryControllerApiFp(this.configuration).getLatestEncounterSummaryV2(appointmentUuid, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Link therapy to particular appointment
     * @summary Store therapies for an appointment
     * @param {string} appointmentUuid 
     * @param {Set<string>} requestBody 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EncounterSummaryControllerApi
     */
    public linkTherapiesToAppointment(appointmentUuid: string, requestBody: Set<string>, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return EncounterSummaryControllerApiFp(this.configuration).linkTherapiesToAppointment(appointmentUuid, requestBody, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} appointmentUuid 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EncounterSummaryControllerApi
     */
    public printEncounterDetails(appointmentUuid: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return EncounterSummaryControllerApiFp(this.configuration).printEncounterDetails(appointmentUuid, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Detaches a single record (by uuid) of the given type ALLERGY, MEDICAL_HISTORY, SURGICAL_HISTORY, FAMILY_HISTORY, MEDICATION
     * @summary Remove a clinical record from the visit note
     * @param {RemoveClinicalDataFromEncounterTypeEnum} type 
     * @param {string} appointmentUuid 
     * @param {string} recordUuid 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EncounterSummaryControllerApi
     */
    public removeClinicalDataFromEncounter(type: RemoveClinicalDataFromEncounterTypeEnum, appointmentUuid: string, recordUuid: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return EncounterSummaryControllerApiFp(this.configuration).removeClinicalDataFromEncounter(type, appointmentUuid, recordUuid, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Adds the one signed addendum to a signed-off visit. Only the rendering provider can sign it; the original note is not changed and the addendum can\'t be edited or deleted afterwards.
     * @summary Sign addendum
     * @param {string} appointmentUuid 
     * @param {EncounterAddendum} encounterAddendum 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EncounterSummaryControllerApi
     */
    public signAddendum(appointmentUuid: string, encounterAddendum: EncounterAddendum, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return EncounterSummaryControllerApiFp(this.configuration).signAddendum(appointmentUuid, encounterAddendum, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * sign off encounter
     * @summary Sign off encounter
     * @param {string} encounterSummaryId 
     * @param {EncounterSignOff} encounterSignOff 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EncounterSummaryControllerApi
     */
    public signOffEncounterSummary(encounterSummaryId: string, encounterSignOff: EncounterSignOff, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return EncounterSummaryControllerApiFp(this.configuration).signOffEncounterSummary(encounterSummaryId, encounterSignOff, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update a encounter summary
     * @summary Update encounter summary
     * @param {EncounterSumary} encounterSumary 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EncounterSummaryControllerApi
     */
    public updateEncounterSummary(encounterSumary: EncounterSumary, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return EncounterSummaryControllerApiFp(this.configuration).updateEncounterSummary(encounterSumary, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Archive a Encounter summary record by its ID
     * @summary Archive encounter summary
     * @param {string} encounterSummaryId 
     * @param {boolean} status 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EncounterSummaryControllerApi
     */
    public updateEncounterSummaryArchiveStatus(encounterSummaryId: string, status: boolean, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return EncounterSummaryControllerApiFp(this.configuration).updateEncounterSummaryArchiveStatus(encounterSummaryId, status, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Uploads the clock drawing image (PNG or JPEG) of a visit\'s Mini Cognitive Test and returns its key, to save in the note, and a preview URL
     * @summary Upload Mini-Cog clock drawing
     * @param {string} appointmentUuid 
     * @param {File} file 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EncounterSummaryControllerApi
     */
    public uploadClockDrawing(appointmentUuid: string, file: File, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return EncounterSummaryControllerApiFp(this.configuration).uploadClockDrawing(appointmentUuid, file, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const ExportClinicalDataToEncounterTypeEnum = {
    Allergy: 'ALLERGY',
    MedicalHistory: 'MEDICAL_HISTORY',
    SurgicalHistory: 'SURGICAL_HISTORY',
    FamilyHistory: 'FAMILY_HISTORY',
    Medication: 'MEDICATION'
} as const;
export type ExportClinicalDataToEncounterTypeEnum = typeof ExportClinicalDataToEncounterTypeEnum[keyof typeof ExportClinicalDataToEncounterTypeEnum];
/**
 * @export
 */
export const GetEncounterSumaryEncounterStatusEnum = {
    Intake: 'INTAKE',
    Exam: 'EXAM',
    Checkout: 'CHECKOUT',
    Completed: 'COMPLETED'
} as const;
export type GetEncounterSumaryEncounterStatusEnum = typeof GetEncounterSumaryEncounterStatusEnum[keyof typeof GetEncounterSumaryEncounterStatusEnum];
/**
 * @export
 */
export const GetEncounterSummaryListEncounterStatusEnum = {
    Intake: 'INTAKE',
    Exam: 'EXAM',
    Checkout: 'CHECKOUT',
    Completed: 'COMPLETED'
} as const;
export type GetEncounterSummaryListEncounterStatusEnum = typeof GetEncounterSummaryListEncounterStatusEnum[keyof typeof GetEncounterSummaryListEncounterStatusEnum];
/**
 * @export
 */
export const GetEncounterSummaryV2ListEncounterStatusEnum = {
    Intake: 'INTAKE',
    Exam: 'EXAM',
    Checkout: 'CHECKOUT',
    Completed: 'COMPLETED'
} as const;
export type GetEncounterSummaryV2ListEncounterStatusEnum = typeof GetEncounterSummaryV2ListEncounterStatusEnum[keyof typeof GetEncounterSummaryV2ListEncounterStatusEnum];
/**
 * @export
 */
export const RemoveClinicalDataFromEncounterTypeEnum = {
    Allergy: 'ALLERGY',
    MedicalHistory: 'MEDICAL_HISTORY',
    SurgicalHistory: 'SURGICAL_HISTORY',
    FamilyHistory: 'FAMILY_HISTORY',
    Medication: 'MEDICATION'
} as const;
export type RemoveClinicalDataFromEncounterTypeEnum = typeof RemoveClinicalDataFromEncounterTypeEnum[keyof typeof RemoveClinicalDataFromEncounterTypeEnum];


/**
 * EncounterTemplateControllerApi - axios parameter creator
 * @export
 */
export const EncounterTemplateControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Add a new encounter template into the system
         * @summary Add Encounter Template
         * @param {PhysicalROSTemplateRequest} physicalROSTemplateRequest 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEncounterTemplate: async (physicalROSTemplateRequest: PhysicalROSTemplateRequest, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'physicalROSTemplateRequest' is not null or undefined
            assertParamExists('createEncounterTemplate', 'physicalROSTemplateRequest', physicalROSTemplateRequest)
            const localVarPath = `/api/master/encounter-template`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(physicalROSTemplateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all encounter template
         * @summary Get Encounter Template
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {boolean} [status] 
         * @param {boolean} [archive] 
         * @param {GetEncounterTemplateTemplateTypeEnum} [templateType] 
         * @param {string} [appointmentUuid] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEncounterTemplate: async (page?: number, size?: number, sortBy?: string, sortDirection?: string, status?: boolean, archive?: boolean, templateType?: GetEncounterTemplateTemplateTypeEnum, appointmentUuid?: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/master/encounter-template`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (archive !== undefined) {
                localVarQueryParameter['archive'] = archive;
            }

            if (templateType !== undefined) {
                localVarQueryParameter['templateType'] = templateType;
            }

            if (appointmentUuid !== undefined) {
                localVarQueryParameter['appointmentUuid'] = appointmentUuid;
            }

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update encounter template
         * @summary Update encounter template
         * @param {PhysicalROSTemplateRequest} physicalROSTemplateRequest 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEncounterTemplate: async (physicalROSTemplateRequest: PhysicalROSTemplateRequest, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'physicalROSTemplateRequest' is not null or undefined
            assertParamExists('updateEncounterTemplate', 'physicalROSTemplateRequest', physicalROSTemplateRequest)
            const localVarPath = `/api/master/encounter-template`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(physicalROSTemplateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Archive or unarchive a Encounter Template by its ID
         * @summary Archive Encounter Template
         * @param {string} encounterTemplateId 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePatientOrderArchiveStatus1: async (encounterTemplateId: string, status: boolean, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'encounterTemplateId' is not null or undefined
            assertParamExists('updatePatientOrderArchiveStatus1', 'encounterTemplateId', encounterTemplateId)
            // verify required parameter 'status' is not null or undefined
            assertParamExists('updatePatientOrderArchiveStatus1', 'status', status)
            const localVarPath = `/api/master/encounter-template/{encounterTemplateId}/archive-status/{status}`
                .replace(`{${"encounterTemplateId"}}`, encodeURIComponent(String(encounterTemplateId)))
                .replace(`{${"status"}}`, encodeURIComponent(String(status)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EncounterTemplateControllerApi - functional programming interface
 * @export
 */
export const EncounterTemplateControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = EncounterTemplateControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * Add a new encounter template into the system
         * @summary Add Encounter Template
         * @param {PhysicalROSTemplateRequest} physicalROSTemplateRequest 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createEncounterTemplate(physicalROSTemplateRequest: PhysicalROSTemplateRequest, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createEncounterTemplate(physicalROSTemplateRequest, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EncounterTemplateControllerApi.createEncounterTemplate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get all encounter template
         * @summary Get Encounter Template
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {boolean} [status] 
         * @param {boolean} [archive] 
         * @param {GetEncounterTemplateTemplateTypeEnum} [templateType] 
         * @param {string} [appointmentUuid] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEncounterTemplate(page?: number, size?: number, sortBy?: string, sortDirection?: string, status?: boolean, archive?: boolean, templateType?: GetEncounterTemplateTemplateTypeEnum, appointmentUuid?: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEncounterTemplate(page, size, sortBy, sortDirection, status, archive, templateType, appointmentUuid, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EncounterTemplateControllerApi.getEncounterTemplate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update encounter template
         * @summary Update encounter template
         * @param {PhysicalROSTemplateRequest} physicalROSTemplateRequest 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateEncounterTemplate(physicalROSTemplateRequest: PhysicalROSTemplateRequest, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateEncounterTemplate(physicalROSTemplateRequest, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EncounterTemplateControllerApi.updateEncounterTemplate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Archive or unarchive a Encounter Template by its ID
         * @summary Archive Encounter Template
         * @param {string} encounterTemplateId 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePatientOrderArchiveStatus1(encounterTemplateId: string, status: boolean, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePatientOrderArchiveStatus1(encounterTemplateId, status, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EncounterTemplateControllerApi.updatePatientOrderArchiveStatus1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * EncounterTemplateControllerApi - factory interface
 * @export
 */
export const EncounterTemplateControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = EncounterTemplateControllerApiFp(configuration)
    return {
        /**
         * Add a new encounter template into the system
         * @summary Add Encounter Template
         * @param {PhysicalROSTemplateRequest} physicalROSTemplateRequest 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEncounterTemplate(physicalROSTemplateRequest: PhysicalROSTemplateRequest, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.createEncounterTemplate(physicalROSTemplateRequest, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all encounter template
         * @summary Get Encounter Template
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {boolean} [status] 
         * @param {boolean} [archive] 
         * @param {GetEncounterTemplateTemplateTypeEnum} [templateType] 
         * @param {string} [appointmentUuid] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEncounterTemplate(page?: number, size?: number, sortBy?: string, sortDirection?: string, status?: boolean, archive?: boolean, templateType?: GetEncounterTemplateTemplateTypeEnum, appointmentUuid?: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getEncounterTemplate(page, size, sortBy, sortDirection, status, archive, templateType, appointmentUuid, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Update encounter template
         * @summary Update encounter template
         * @param {PhysicalROSTemplateRequest} physicalROSTemplateRequest 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEncounterTemplate(physicalROSTemplateRequest: PhysicalROSTemplateRequest, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.updateEncounterTemplate(physicalROSTemplateRequest, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Archive or unarchive a Encounter Template by its ID
         * @summary Archive Encounter Template
         * @param {string} encounterTemplateId 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePatientOrderArchiveStatus1(encounterTemplateId: string, status: boolean, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.updatePatientOrderArchiveStatus1(encounterTemplateId, status, xTENANTID, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * EncounterTemplateControllerApi - object-oriented interface
 * @export
 * @class EncounterTemplateControllerApi
 * @extends {BaseAPI}
 */
export class EncounterTemplateControllerApi extends BaseAPI {
    /**
     * Add a new encounter template into the system
     * @summary Add Encounter Template
     * @param {PhysicalROSTemplateRequest} physicalROSTemplateRequest 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EncounterTemplateControllerApi
     */
    public createEncounterTemplate(physicalROSTemplateRequest: PhysicalROSTemplateRequest, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return EncounterTemplateControllerApiFp(this.configuration).createEncounterTemplate(physicalROSTemplateRequest, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all encounter template
     * @summary Get Encounter Template
     * @param {number} [page] 
     * @param {number} [size] 
     * @param {string} [sortBy] 
     * @param {string} [sortDirection] 
     * @param {boolean} [status] 
     * @param {boolean} [archive] 
     * @param {GetEncounterTemplateTemplateTypeEnum} [templateType] 
     * @param {string} [appointmentUuid] 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EncounterTemplateControllerApi
     */
    public getEncounterTemplate(page?: number, size?: number, sortBy?: string, sortDirection?: string, status?: boolean, archive?: boolean, templateType?: GetEncounterTemplateTemplateTypeEnum, appointmentUuid?: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return EncounterTemplateControllerApiFp(this.configuration).getEncounterTemplate(page, size, sortBy, sortDirection, status, archive, templateType, appointmentUuid, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update encounter template
     * @summary Update encounter template
     * @param {PhysicalROSTemplateRequest} physicalROSTemplateRequest 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EncounterTemplateControllerApi
     */
    public updateEncounterTemplate(physicalROSTemplateRequest: PhysicalROSTemplateRequest, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return EncounterTemplateControllerApiFp(this.configuration).updateEncounterTemplate(physicalROSTemplateRequest, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Archive or unarchive a Encounter Template by its ID
     * @summary Archive Encounter Template
     * @param {string} encounterTemplateId 
     * @param {boolean} status 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EncounterTemplateControllerApi
     */
    public updatePatientOrderArchiveStatus1(encounterTemplateId: string, status: boolean, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return EncounterTemplateControllerApiFp(this.configuration).updatePatientOrderArchiveStatus1(encounterTemplateId, status, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const GetEncounterTemplateTemplateTypeEnum = {
    PhysicalExam: 'PHYSICAL_EXAM',
    Ros: 'ROS'
} as const;
export type GetEncounterTemplateTemplateTypeEnum = typeof GetEncounterTemplateTemplateTypeEnum[keyof typeof GetEncounterTemplateTemplateTypeEnum];


/**
 * EobControllerApi - axios parameter creator
 * @export
 */
export const EobControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * List EOBs with pagination, filtering and search
         * @summary List EOBs
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {boolean} [active] 
         * @param {boolean} [archive] 
         * @param {string} [searchString] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEobs: async (page?: number, size?: number, sortBy?: string, sortDirection?: string, active?: boolean, archive?: boolean, searchString?: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/master/eob/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }

            if (active !== undefined) {
                localVarQueryParameter['active'] = active;
            }

            if (archive !== undefined) {
                localVarQueryParameter['archive'] = archive;
            }

            if (searchString !== undefined) {
                localVarQueryParameter['searchString'] = searchString;
            }

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve an EOB by its UUID
         * @summary Get EOB by ID
         * @param {string} eobId 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEobById: async (eobId: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'eobId' is not null or undefined
            assertParamExists('getEobById', 'eobId', eobId)
            const localVarPath = `/api/master/eob/{eobId}`
                .replace(`{${"eobId"}}`, encodeURIComponent(String(eobId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Post payment for EOB claims and procedure codes
         * @summary Post Payment
         * @param {string} eobUuid 
         * @param {EobPaymentPostingRequest} eobPaymentPostingRequest 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postPayment: async (eobUuid: string, eobPaymentPostingRequest: EobPaymentPostingRequest, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'eobUuid' is not null or undefined
            assertParamExists('postPayment', 'eobUuid', eobUuid)
            // verify required parameter 'eobPaymentPostingRequest' is not null or undefined
            assertParamExists('postPayment', 'eobPaymentPostingRequest', eobPaymentPostingRequest)
            const localVarPath = `/api/master/eob/post-payment/{eobUuid}`
                .replace(`{${"eobUuid"}}`, encodeURIComponent(String(eobUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(eobPaymentPostingRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update an existing EOB
         * @summary Update EOB
         * @param {string} eobId 
         * @param {string} payerId 
         * @param {string} eobNumber 
         * @param {string} totalPaymentAmount 
         * @param {string} [paymentMethod] 
         * @param {string} [checkEftNumber] 
         * @param {string} [statementDate] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEob: async (eobId: string, payerId: string, eobNumber: string, totalPaymentAmount: string, paymentMethod?: string, checkEftNumber?: string, statementDate?: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'eobId' is not null or undefined
            assertParamExists('updateEob', 'eobId', eobId)
            // verify required parameter 'payerId' is not null or undefined
            assertParamExists('updateEob', 'payerId', payerId)
            // verify required parameter 'eobNumber' is not null or undefined
            assertParamExists('updateEob', 'eobNumber', eobNumber)
            // verify required parameter 'totalPaymentAmount' is not null or undefined
            assertParamExists('updateEob', 'totalPaymentAmount', totalPaymentAmount)
            const localVarPath = `/api/master/eob`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (eobId !== undefined) {
                localVarQueryParameter['eobId'] = eobId;
            }

            if (payerId !== undefined) {
                localVarQueryParameter['payerId'] = payerId;
            }

            if (eobNumber !== undefined) {
                localVarQueryParameter['eobNumber'] = eobNumber;
            }

            if (paymentMethod !== undefined) {
                localVarQueryParameter['paymentMethod'] = paymentMethod;
            }

            if (checkEftNumber !== undefined) {
                localVarQueryParameter['checkEftNumber'] = checkEftNumber;
            }

            if (totalPaymentAmount !== undefined) {
                localVarQueryParameter['totalPaymentAmount'] = totalPaymentAmount;
            }

            if (statementDate !== undefined) {
                localVarQueryParameter['statementDate'] = (statementDate as any instanceof Date) ?
                    (statementDate as any).toISOString() :
                    statementDate;
            }

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Upload a new EOB with payer and payment details
         * @summary Upload EOB
         * @param {string} payerId 
         * @param {string} eobNumber 
         * @param {string} totalPaymentAmount 
         * @param {string} [paymentMethod] 
         * @param {string} [checkEftNumber] 
         * @param {string} [statementDate] 
         * @param {UploadEobDocumentFormatEnum} [documentFormat] 
         * @param {string} [documentName] 
         * @param {string} [xTENANTID] 
         * @param {File} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadEob: async (payerId: string, eobNumber: string, totalPaymentAmount: string, paymentMethod?: string, checkEftNumber?: string, statementDate?: string, documentFormat?: UploadEobDocumentFormatEnum, documentName?: string, xTENANTID?: string, file?: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'payerId' is not null or undefined
            assertParamExists('uploadEob', 'payerId', payerId)
            // verify required parameter 'eobNumber' is not null or undefined
            assertParamExists('uploadEob', 'eobNumber', eobNumber)
            // verify required parameter 'totalPaymentAmount' is not null or undefined
            assertParamExists('uploadEob', 'totalPaymentAmount', totalPaymentAmount)
            const localVarPath = `/api/master/eob/upload`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (payerId !== undefined) {
                localVarQueryParameter['payerId'] = payerId;
            }

            if (eobNumber !== undefined) {
                localVarQueryParameter['eobNumber'] = eobNumber;
            }

            if (paymentMethod !== undefined) {
                localVarQueryParameter['paymentMethod'] = paymentMethod;
            }

            if (checkEftNumber !== undefined) {
                localVarQueryParameter['checkEftNumber'] = checkEftNumber;
            }

            if (totalPaymentAmount !== undefined) {
                localVarQueryParameter['totalPaymentAmount'] = totalPaymentAmount;
            }

            if (statementDate !== undefined) {
                localVarQueryParameter['statementDate'] = (statementDate as any instanceof Date) ?
                    (statementDate as any).toISOString() :
                    statementDate;
            }

            if (documentFormat !== undefined) {
                localVarQueryParameter['documentFormat'] = documentFormat;
            }

            if (documentName !== undefined) {
                localVarQueryParameter['documentName'] = documentName;
            }

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EobControllerApi - functional programming interface
 * @export
 */
export const EobControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = EobControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * List EOBs with pagination, filtering and search
         * @summary List EOBs
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {boolean} [active] 
         * @param {boolean} [archive] 
         * @param {string} [searchString] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllEobs(page?: number, size?: number, sortBy?: string, sortDirection?: string, active?: boolean, archive?: boolean, searchString?: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllEobs(page, size, sortBy, sortDirection, active, archive, searchString, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EobControllerApi.getAllEobs']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve an EOB by its UUID
         * @summary Get EOB by ID
         * @param {string} eobId 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEobById(eobId: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEobById(eobId, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EobControllerApi.getEobById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Post payment for EOB claims and procedure codes
         * @summary Post Payment
         * @param {string} eobUuid 
         * @param {EobPaymentPostingRequest} eobPaymentPostingRequest 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postPayment(eobUuid: string, eobPaymentPostingRequest: EobPaymentPostingRequest, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postPayment(eobUuid, eobPaymentPostingRequest, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EobControllerApi.postPayment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update an existing EOB
         * @summary Update EOB
         * @param {string} eobId 
         * @param {string} payerId 
         * @param {string} eobNumber 
         * @param {string} totalPaymentAmount 
         * @param {string} [paymentMethod] 
         * @param {string} [checkEftNumber] 
         * @param {string} [statementDate] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateEob(eobId: string, payerId: string, eobNumber: string, totalPaymentAmount: string, paymentMethod?: string, checkEftNumber?: string, statementDate?: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateEob(eobId, payerId, eobNumber, totalPaymentAmount, paymentMethod, checkEftNumber, statementDate, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EobControllerApi.updateEob']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Upload a new EOB with payer and payment details
         * @summary Upload EOB
         * @param {string} payerId 
         * @param {string} eobNumber 
         * @param {string} totalPaymentAmount 
         * @param {string} [paymentMethod] 
         * @param {string} [checkEftNumber] 
         * @param {string} [statementDate] 
         * @param {UploadEobDocumentFormatEnum} [documentFormat] 
         * @param {string} [documentName] 
         * @param {string} [xTENANTID] 
         * @param {File} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadEob(payerId: string, eobNumber: string, totalPaymentAmount: string, paymentMethod?: string, checkEftNumber?: string, statementDate?: string, documentFormat?: UploadEobDocumentFormatEnum, documentName?: string, xTENANTID?: string, file?: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadEob(payerId, eobNumber, totalPaymentAmount, paymentMethod, checkEftNumber, statementDate, documentFormat, documentName, xTENANTID, file, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EobControllerApi.uploadEob']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * EobControllerApi - factory interface
 * @export
 */
export const EobControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = EobControllerApiFp(configuration)
    return {
        /**
         * List EOBs with pagination, filtering and search
         * @summary List EOBs
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {boolean} [active] 
         * @param {boolean} [archive] 
         * @param {string} [searchString] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEobs(page?: number, size?: number, sortBy?: string, sortDirection?: string, active?: boolean, archive?: boolean, searchString?: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getAllEobs(page, size, sortBy, sortDirection, active, archive, searchString, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve an EOB by its UUID
         * @summary Get EOB by ID
         * @param {string} eobId 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEobById(eobId: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getEobById(eobId, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Post payment for EOB claims and procedure codes
         * @summary Post Payment
         * @param {string} eobUuid 
         * @param {EobPaymentPostingRequest} eobPaymentPostingRequest 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postPayment(eobUuid: string, eobPaymentPostingRequest: EobPaymentPostingRequest, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.postPayment(eobUuid, eobPaymentPostingRequest, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Update an existing EOB
         * @summary Update EOB
         * @param {string} eobId 
         * @param {string} payerId 
         * @param {string} eobNumber 
         * @param {string} totalPaymentAmount 
         * @param {string} [paymentMethod] 
         * @param {string} [checkEftNumber] 
         * @param {string} [statementDate] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEob(eobId: string, payerId: string, eobNumber: string, totalPaymentAmount: string, paymentMethod?: string, checkEftNumber?: string, statementDate?: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.updateEob(eobId, payerId, eobNumber, totalPaymentAmount, paymentMethod, checkEftNumber, statementDate, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Upload a new EOB with payer and payment details
         * @summary Upload EOB
         * @param {string} payerId 
         * @param {string} eobNumber 
         * @param {string} totalPaymentAmount 
         * @param {string} [paymentMethod] 
         * @param {string} [checkEftNumber] 
         * @param {string} [statementDate] 
         * @param {UploadEobDocumentFormatEnum} [documentFormat] 
         * @param {string} [documentName] 
         * @param {string} [xTENANTID] 
         * @param {File} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadEob(payerId: string, eobNumber: string, totalPaymentAmount: string, paymentMethod?: string, checkEftNumber?: string, statementDate?: string, documentFormat?: UploadEobDocumentFormatEnum, documentName?: string, xTENANTID?: string, file?: File, options?: any): AxiosPromise<Response> {
            return localVarFp.uploadEob(payerId, eobNumber, totalPaymentAmount, paymentMethod, checkEftNumber, statementDate, documentFormat, documentName, xTENANTID, file, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * EobControllerApi - object-oriented interface
 * @export
 * @class EobControllerApi
 * @extends {BaseAPI}
 */
export class EobControllerApi extends BaseAPI {
    /**
     * List EOBs with pagination, filtering and search
     * @summary List EOBs
     * @param {number} [page] 
     * @param {number} [size] 
     * @param {string} [sortBy] 
     * @param {string} [sortDirection] 
     * @param {boolean} [active] 
     * @param {boolean} [archive] 
     * @param {string} [searchString] 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EobControllerApi
     */
    public getAllEobs(page?: number, size?: number, sortBy?: string, sortDirection?: string, active?: boolean, archive?: boolean, searchString?: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return EobControllerApiFp(this.configuration).getAllEobs(page, size, sortBy, sortDirection, active, archive, searchString, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve an EOB by its UUID
     * @summary Get EOB by ID
     * @param {string} eobId 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EobControllerApi
     */
    public getEobById(eobId: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return EobControllerApiFp(this.configuration).getEobById(eobId, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Post payment for EOB claims and procedure codes
     * @summary Post Payment
     * @param {string} eobUuid 
     * @param {EobPaymentPostingRequest} eobPaymentPostingRequest 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EobControllerApi
     */
    public postPayment(eobUuid: string, eobPaymentPostingRequest: EobPaymentPostingRequest, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return EobControllerApiFp(this.configuration).postPayment(eobUuid, eobPaymentPostingRequest, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update an existing EOB
     * @summary Update EOB
     * @param {string} eobId 
     * @param {string} payerId 
     * @param {string} eobNumber 
     * @param {string} totalPaymentAmount 
     * @param {string} [paymentMethod] 
     * @param {string} [checkEftNumber] 
     * @param {string} [statementDate] 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EobControllerApi
     */
    public updateEob(eobId: string, payerId: string, eobNumber: string, totalPaymentAmount: string, paymentMethod?: string, checkEftNumber?: string, statementDate?: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return EobControllerApiFp(this.configuration).updateEob(eobId, payerId, eobNumber, totalPaymentAmount, paymentMethod, checkEftNumber, statementDate, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Upload a new EOB with payer and payment details
     * @summary Upload EOB
     * @param {string} payerId 
     * @param {string} eobNumber 
     * @param {string} totalPaymentAmount 
     * @param {string} [paymentMethod] 
     * @param {string} [checkEftNumber] 
     * @param {string} [statementDate] 
     * @param {UploadEobDocumentFormatEnum} [documentFormat] 
     * @param {string} [documentName] 
     * @param {string} [xTENANTID] 
     * @param {File} [file] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EobControllerApi
     */
    public uploadEob(payerId: string, eobNumber: string, totalPaymentAmount: string, paymentMethod?: string, checkEftNumber?: string, statementDate?: string, documentFormat?: UploadEobDocumentFormatEnum, documentName?: string, xTENANTID?: string, file?: File, options?: RawAxiosRequestConfig) {
        return EobControllerApiFp(this.configuration).uploadEob(payerId, eobNumber, totalPaymentAmount, paymentMethod, checkEftNumber, statementDate, documentFormat, documentName, xTENANTID, file, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const UploadEobDocumentFormatEnum = {
    Pdf: 'PDF',
    MsWord: 'MS_WORD',
    Zip: 'ZIP',
    XGzip: 'X_GZIP',
    XCompressed: 'X_COMPRESSED',
    Docx: 'DOCX',
    Rtf: 'RTF',
    Plain: 'PLAIN',
    Xlsx: 'XLSX',
    JpegImage: 'JPEG_IMAGE',
    Mp4: 'MP4',
    PngImage: 'PNG_IMAGE',
    GifImage: 'GIF_IMAGE',
    BmpImage: 'BMP_IMAGE',
    WebpImage: 'WEBP_IMAGE',
    SvgImage: 'SVG_IMAGE',
    MpegAudio: 'MPEG_AUDIO',
    Other: 'OTHER',
    Csv: 'CSV'
} as const;
export type UploadEobDocumentFormatEnum = typeof UploadEobDocumentFormatEnum[keyof typeof UploadEobDocumentFormatEnum];


/**
 * EraControllerApi - axios parameter creator
 * @export
 */
export const EraControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Creates a new ERA (Electronic Remittance Advice) with associated claims.
         * @summary Create/Upload ERA
         * @param {EraRequest} eraRequest 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEra: async (eraRequest: EraRequest, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'eraRequest' is not null or undefined
            assertParamExists('createEra', 'eraRequest', eraRequest)
            const localVarPath = `/api/master/era`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(eraRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves all ERAs with pagination and filters.
         * @summary Get all ERAs
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {string} [renderingProviderId] 
         * @param {string} [payerId] 
         * @param {string} [eraDateFrom] 
         * @param {string} [eraDateTo] 
         * @param {boolean} [reconciled] 
         * @param {boolean} [isManualUpload] 
         * @param {string} [searchString] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEras: async (page?: number, size?: number, sortBy?: string, sortDirection?: string, renderingProviderId?: string, payerId?: string, eraDateFrom?: string, eraDateTo?: string, reconciled?: boolean, isManualUpload?: boolean, searchString?: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/master/era`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }

            if (renderingProviderId !== undefined) {
                localVarQueryParameter['renderingProviderId'] = renderingProviderId;
            }

            if (payerId !== undefined) {
                localVarQueryParameter['payerId'] = payerId;
            }

            if (eraDateFrom !== undefined) {
                localVarQueryParameter['eraDateFrom'] = (eraDateFrom as any instanceof Date) ?
                    (eraDateFrom as any).toISOString() :
                    eraDateFrom;
            }

            if (eraDateTo !== undefined) {
                localVarQueryParameter['eraDateTo'] = (eraDateTo as any instanceof Date) ?
                    (eraDateTo as any).toISOString() :
                    eraDateTo;
            }

            if (reconciled !== undefined) {
                localVarQueryParameter['reconciled'] = reconciled;
            }

            if (isManualUpload !== undefined) {
                localVarQueryParameter['isManualUpload'] = isManualUpload;
            }

            if (searchString !== undefined) {
                localVarQueryParameter['searchString'] = searchString;
            }

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves complete ERA details including all associated claims.
         * @summary Get ERA by UUID
         * @param {string} uuid 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEraByUuid: async (uuid: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('getEraByUuid', 'uuid', uuid)
            const localVarPath = `/api/master/era/{uuid}`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves all claims within an ERA.
         * @summary Get ERA claims
         * @param {string} uuid 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEraClaimsByEraUuid: async (uuid: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('getEraClaimsByEraUuid', 'uuid', uuid)
            const localVarPath = `/api/master/era/{uuid}/claims`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetches the ERA PDF from Claim.MD for the given Claim.MD era id and returns the parsed result (PDF as base64) so the frontend can open/download it directly.
         * @summary Get ERA PDF from Claim.MD
         * @param {string} eraId 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEraPdf: async (eraId: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'eraId' is not null or undefined
            assertParamExists('getEraPdf', 'eraId', eraId)
            const localVarPath = `/api/master/era/erapdf/{eraId}`
                .replace(`{${"eraId"}}`, encodeURIComponent(String(eraId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Accepts a raw X12 835 (ERA) EDI file and returns the parsed content as JSON. Does not persist anything.
         * @summary Parse ERA 835 file to JSON
         * @param {File} file 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        parse835: async (file: File, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'file' is not null or undefined
            assertParamExists('parse835', 'file', file)
            const localVarPath = `/api/master/era/parse-835`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Posts one or more pre-filled claims under an ERA. Supports partial post — skipped claims stay pending. Missing claims are reported as warnings.
         * @summary Post ERA claims
         * @param {string} uuid 
         * @param {EraPostRequest} eraPostRequest 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postEraClaims: async (uuid: string, eraPostRequest: EraPostRequest, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('postEraClaims', 'uuid', uuid)
            // verify required parameter 'eraPostRequest' is not null or undefined
            assertParamExists('postEraClaims', 'eraPostRequest', eraPostRequest)
            const localVarPath = `/api/master/era/{uuid}/post`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(eraPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Updates the reconciliation status of an ERA.
         * @summary Update ERA reconciliation status
         * @param {string} uuid 
         * @param {boolean} [reconciled] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEraReconciliationStatus: async (uuid: string, reconciled?: boolean, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('updateEraReconciliationStatus', 'uuid', uuid)
            const localVarPath = `/api/master/era/{uuid}/reconciliation`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (reconciled !== undefined) {
                localVarQueryParameter['reconciled'] = reconciled;
            }

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Parses a raw X12 835 (ERA) EDI file and saves it as a pending ERA (claims pre-filled for review/posting), mirroring the Claim.MD ERA flow.
         * @summary Upload and save ERA 835 file
         * @param {File} file 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadEra835: async (file: File, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'file' is not null or undefined
            assertParamExists('uploadEra835', 'file', file)
            const localVarPath = `/api/master/era/upload-835`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EraControllerApi - functional programming interface
 * @export
 */
export const EraControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = EraControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * Creates a new ERA (Electronic Remittance Advice) with associated claims.
         * @summary Create/Upload ERA
         * @param {EraRequest} eraRequest 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createEra(eraRequest: EraRequest, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createEra(eraRequest, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EraControllerApi.createEra']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves all ERAs with pagination and filters.
         * @summary Get all ERAs
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {string} [renderingProviderId] 
         * @param {string} [payerId] 
         * @param {string} [eraDateFrom] 
         * @param {string} [eraDateTo] 
         * @param {boolean} [reconciled] 
         * @param {boolean} [isManualUpload] 
         * @param {string} [searchString] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllEras(page?: number, size?: number, sortBy?: string, sortDirection?: string, renderingProviderId?: string, payerId?: string, eraDateFrom?: string, eraDateTo?: string, reconciled?: boolean, isManualUpload?: boolean, searchString?: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllEras(page, size, sortBy, sortDirection, renderingProviderId, payerId, eraDateFrom, eraDateTo, reconciled, isManualUpload, searchString, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EraControllerApi.getAllEras']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves complete ERA details including all associated claims.
         * @summary Get ERA by UUID
         * @param {string} uuid 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEraByUuid(uuid: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEraByUuid(uuid, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EraControllerApi.getEraByUuid']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves all claims within an ERA.
         * @summary Get ERA claims
         * @param {string} uuid 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEraClaimsByEraUuid(uuid: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEraClaimsByEraUuid(uuid, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EraControllerApi.getEraClaimsByEraUuid']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Fetches the ERA PDF from Claim.MD for the given Claim.MD era id and returns the parsed result (PDF as base64) so the frontend can open/download it directly.
         * @summary Get ERA PDF from Claim.MD
         * @param {string} eraId 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEraPdf(eraId: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEraPdf(eraId, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EraControllerApi.getEraPdf']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Accepts a raw X12 835 (ERA) EDI file and returns the parsed content as JSON. Does not persist anything.
         * @summary Parse ERA 835 file to JSON
         * @param {File} file 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async parse835(file: File, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.parse835(file, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EraControllerApi.parse835']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Posts one or more pre-filled claims under an ERA. Supports partial post — skipped claims stay pending. Missing claims are reported as warnings.
         * @summary Post ERA claims
         * @param {string} uuid 
         * @param {EraPostRequest} eraPostRequest 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postEraClaims(uuid: string, eraPostRequest: EraPostRequest, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postEraClaims(uuid, eraPostRequest, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EraControllerApi.postEraClaims']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Updates the reconciliation status of an ERA.
         * @summary Update ERA reconciliation status
         * @param {string} uuid 
         * @param {boolean} [reconciled] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateEraReconciliationStatus(uuid: string, reconciled?: boolean, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateEraReconciliationStatus(uuid, reconciled, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EraControllerApi.updateEraReconciliationStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Parses a raw X12 835 (ERA) EDI file and saves it as a pending ERA (claims pre-filled for review/posting), mirroring the Claim.MD ERA flow.
         * @summary Upload and save ERA 835 file
         * @param {File} file 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadEra835(file: File, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadEra835(file, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EraControllerApi.uploadEra835']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * EraControllerApi - factory interface
 * @export
 */
export const EraControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = EraControllerApiFp(configuration)
    return {
        /**
         * Creates a new ERA (Electronic Remittance Advice) with associated claims.
         * @summary Create/Upload ERA
         * @param {EraRequest} eraRequest 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEra(eraRequest: EraRequest, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.createEra(eraRequest, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves all ERAs with pagination and filters.
         * @summary Get all ERAs
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {string} [renderingProviderId] 
         * @param {string} [payerId] 
         * @param {string} [eraDateFrom] 
         * @param {string} [eraDateTo] 
         * @param {boolean} [reconciled] 
         * @param {boolean} [isManualUpload] 
         * @param {string} [searchString] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEras(page?: number, size?: number, sortBy?: string, sortDirection?: string, renderingProviderId?: string, payerId?: string, eraDateFrom?: string, eraDateTo?: string, reconciled?: boolean, isManualUpload?: boolean, searchString?: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getAllEras(page, size, sortBy, sortDirection, renderingProviderId, payerId, eraDateFrom, eraDateTo, reconciled, isManualUpload, searchString, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves complete ERA details including all associated claims.
         * @summary Get ERA by UUID
         * @param {string} uuid 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEraByUuid(uuid: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getEraByUuid(uuid, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves all claims within an ERA.
         * @summary Get ERA claims
         * @param {string} uuid 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEraClaimsByEraUuid(uuid: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getEraClaimsByEraUuid(uuid, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Fetches the ERA PDF from Claim.MD for the given Claim.MD era id and returns the parsed result (PDF as base64) so the frontend can open/download it directly.
         * @summary Get ERA PDF from Claim.MD
         * @param {string} eraId 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEraPdf(eraId: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getEraPdf(eraId, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Accepts a raw X12 835 (ERA) EDI file and returns the parsed content as JSON. Does not persist anything.
         * @summary Parse ERA 835 file to JSON
         * @param {File} file 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        parse835(file: File, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.parse835(file, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Posts one or more pre-filled claims under an ERA. Supports partial post — skipped claims stay pending. Missing claims are reported as warnings.
         * @summary Post ERA claims
         * @param {string} uuid 
         * @param {EraPostRequest} eraPostRequest 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postEraClaims(uuid: string, eraPostRequest: EraPostRequest, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.postEraClaims(uuid, eraPostRequest, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates the reconciliation status of an ERA.
         * @summary Update ERA reconciliation status
         * @param {string} uuid 
         * @param {boolean} [reconciled] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEraReconciliationStatus(uuid: string, reconciled?: boolean, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.updateEraReconciliationStatus(uuid, reconciled, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Parses a raw X12 835 (ERA) EDI file and saves it as a pending ERA (claims pre-filled for review/posting), mirroring the Claim.MD ERA flow.
         * @summary Upload and save ERA 835 file
         * @param {File} file 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadEra835(file: File, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.uploadEra835(file, xTENANTID, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * EraControllerApi - object-oriented interface
 * @export
 * @class EraControllerApi
 * @extends {BaseAPI}
 */
export class EraControllerApi extends BaseAPI {
    /**
     * Creates a new ERA (Electronic Remittance Advice) with associated claims.
     * @summary Create/Upload ERA
     * @param {EraRequest} eraRequest 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EraControllerApi
     */
    public createEra(eraRequest: EraRequest, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return EraControllerApiFp(this.configuration).createEra(eraRequest, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves all ERAs with pagination and filters.
     * @summary Get all ERAs
     * @param {number} [page] 
     * @param {number} [size] 
     * @param {string} [sortBy] 
     * @param {string} [sortDirection] 
     * @param {string} [renderingProviderId] 
     * @param {string} [payerId] 
     * @param {string} [eraDateFrom] 
     * @param {string} [eraDateTo] 
     * @param {boolean} [reconciled] 
     * @param {boolean} [isManualUpload] 
     * @param {string} [searchString] 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EraControllerApi
     */
    public getAllEras(page?: number, size?: number, sortBy?: string, sortDirection?: string, renderingProviderId?: string, payerId?: string, eraDateFrom?: string, eraDateTo?: string, reconciled?: boolean, isManualUpload?: boolean, searchString?: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return EraControllerApiFp(this.configuration).getAllEras(page, size, sortBy, sortDirection, renderingProviderId, payerId, eraDateFrom, eraDateTo, reconciled, isManualUpload, searchString, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves complete ERA details including all associated claims.
     * @summary Get ERA by UUID
     * @param {string} uuid 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EraControllerApi
     */
    public getEraByUuid(uuid: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return EraControllerApiFp(this.configuration).getEraByUuid(uuid, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves all claims within an ERA.
     * @summary Get ERA claims
     * @param {string} uuid 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EraControllerApi
     */
    public getEraClaimsByEraUuid(uuid: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return EraControllerApiFp(this.configuration).getEraClaimsByEraUuid(uuid, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Fetches the ERA PDF from Claim.MD for the given Claim.MD era id and returns the parsed result (PDF as base64) so the frontend can open/download it directly.
     * @summary Get ERA PDF from Claim.MD
     * @param {string} eraId 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EraControllerApi
     */
    public getEraPdf(eraId: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return EraControllerApiFp(this.configuration).getEraPdf(eraId, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Accepts a raw X12 835 (ERA) EDI file and returns the parsed content as JSON. Does not persist anything.
     * @summary Parse ERA 835 file to JSON
     * @param {File} file 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EraControllerApi
     */
    public parse835(file: File, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return EraControllerApiFp(this.configuration).parse835(file, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Posts one or more pre-filled claims under an ERA. Supports partial post — skipped claims stay pending. Missing claims are reported as warnings.
     * @summary Post ERA claims
     * @param {string} uuid 
     * @param {EraPostRequest} eraPostRequest 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EraControllerApi
     */
    public postEraClaims(uuid: string, eraPostRequest: EraPostRequest, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return EraControllerApiFp(this.configuration).postEraClaims(uuid, eraPostRequest, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Updates the reconciliation status of an ERA.
     * @summary Update ERA reconciliation status
     * @param {string} uuid 
     * @param {boolean} [reconciled] 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EraControllerApi
     */
    public updateEraReconciliationStatus(uuid: string, reconciled?: boolean, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return EraControllerApiFp(this.configuration).updateEraReconciliationStatus(uuid, reconciled, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Parses a raw X12 835 (ERA) EDI file and saves it as a pending ERA (claims pre-filled for review/posting), mirroring the Claim.MD ERA flow.
     * @summary Upload and save ERA 835 file
     * @param {File} file 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EraControllerApi
     */
    public uploadEra835(file: File, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return EraControllerApiFp(this.configuration).uploadEra835(file, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * EventBridgeManagementApi - axios parameter creator
 * @export
 */
export const EventBridgeManagementApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {SchedulerCreateRequest} schedulerCreateRequest 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createScheduler: async (schedulerCreateRequest: SchedulerCreateRequest, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'schedulerCreateRequest' is not null or undefined
            assertParamExists('createScheduler', 'schedulerCreateRequest', schedulerCreateRequest)
            const localVarPath = `/api/master/event-bridge/create-scheduler`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(schedulerCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {EventBridgeEvent} eventBridgeEvent 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        subscribeEvent: async (eventBridgeEvent: EventBridgeEvent, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'eventBridgeEvent' is not null or undefined
            assertParamExists('subscribeEvent', 'eventBridgeEvent', eventBridgeEvent)
            const localVarPath = `/api/master/event-bridge/send-event`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(eventBridgeEvent, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EventBridgeManagementApi - functional programming interface
 * @export
 */
export const EventBridgeManagementApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = EventBridgeManagementApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {SchedulerCreateRequest} schedulerCreateRequest 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createScheduler(schedulerCreateRequest: SchedulerCreateRequest, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createScheduler(schedulerCreateRequest, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EventBridgeManagementApi.createScheduler']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {EventBridgeEvent} eventBridgeEvent 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async subscribeEvent(eventBridgeEvent: EventBridgeEvent, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.subscribeEvent(eventBridgeEvent, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EventBridgeManagementApi.subscribeEvent']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * EventBridgeManagementApi - factory interface
 * @export
 */
export const EventBridgeManagementApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = EventBridgeManagementApiFp(configuration)
    return {
        /**
         * 
         * @param {SchedulerCreateRequest} schedulerCreateRequest 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createScheduler(schedulerCreateRequest: SchedulerCreateRequest, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.createScheduler(schedulerCreateRequest, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {EventBridgeEvent} eventBridgeEvent 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        subscribeEvent(eventBridgeEvent: EventBridgeEvent, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.subscribeEvent(eventBridgeEvent, xTENANTID, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * EventBridgeManagementApi - object-oriented interface
 * @export
 * @class EventBridgeManagementApi
 * @extends {BaseAPI}
 */
export class EventBridgeManagementApi extends BaseAPI {
    /**
     * 
     * @param {SchedulerCreateRequest} schedulerCreateRequest 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventBridgeManagementApi
     */
    public createScheduler(schedulerCreateRequest: SchedulerCreateRequest, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return EventBridgeManagementApiFp(this.configuration).createScheduler(schedulerCreateRequest, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {EventBridgeEvent} eventBridgeEvent 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventBridgeManagementApi
     */
    public subscribeEvent(eventBridgeEvent: EventBridgeEvent, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return EventBridgeManagementApiFp(this.configuration).subscribeEvent(eventBridgeEvent, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * FaxConfigurationControllerApi - axios parameter creator
 * @export
 */
export const FaxConfigurationControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Add a new Fax Configuration
         * @summary Add Fax Configuration
         * @param {FaxConfiguration} faxConfiguration 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addConfiguration: async (faxConfiguration: FaxConfiguration, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'faxConfiguration' is not null or undefined
            assertParamExists('addConfiguration', 'faxConfiguration', faxConfiguration)
            const localVarPath = `/api/master/fax-configuration`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(faxConfiguration, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all Fax Configurations for Current Tenant
         * @summary Get All Fax Configurations for Current Tenant
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConfigurations: async (xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/master/fax-configuration`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update an existing Fax Configuration
         * @summary Update Fax Configuration
         * @param {FaxConfiguration} faxConfiguration 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateConfiguration: async (faxConfiguration: FaxConfiguration, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'faxConfiguration' is not null or undefined
            assertParamExists('updateConfiguration', 'faxConfiguration', faxConfiguration)
            const localVarPath = `/api/master/fax-configuration`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(faxConfiguration, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FaxConfigurationControllerApi - functional programming interface
 * @export
 */
export const FaxConfigurationControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = FaxConfigurationControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * Add a new Fax Configuration
         * @summary Add Fax Configuration
         * @param {FaxConfiguration} faxConfiguration 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addConfiguration(faxConfiguration: FaxConfiguration, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addConfiguration(faxConfiguration, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FaxConfigurationControllerApi.addConfiguration']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get all Fax Configurations for Current Tenant
         * @summary Get All Fax Configurations for Current Tenant
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getConfigurations(xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getConfigurations(xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FaxConfigurationControllerApi.getConfigurations']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update an existing Fax Configuration
         * @summary Update Fax Configuration
         * @param {FaxConfiguration} faxConfiguration 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateConfiguration(faxConfiguration: FaxConfiguration, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateConfiguration(faxConfiguration, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FaxConfigurationControllerApi.updateConfiguration']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * FaxConfigurationControllerApi - factory interface
 * @export
 */
export const FaxConfigurationControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = FaxConfigurationControllerApiFp(configuration)
    return {
        /**
         * Add a new Fax Configuration
         * @summary Add Fax Configuration
         * @param {FaxConfiguration} faxConfiguration 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addConfiguration(faxConfiguration: FaxConfiguration, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.addConfiguration(faxConfiguration, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all Fax Configurations for Current Tenant
         * @summary Get All Fax Configurations for Current Tenant
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConfigurations(xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getConfigurations(xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Update an existing Fax Configuration
         * @summary Update Fax Configuration
         * @param {FaxConfiguration} faxConfiguration 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateConfiguration(faxConfiguration: FaxConfiguration, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.updateConfiguration(faxConfiguration, xTENANTID, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * FaxConfigurationControllerApi - object-oriented interface
 * @export
 * @class FaxConfigurationControllerApi
 * @extends {BaseAPI}
 */
export class FaxConfigurationControllerApi extends BaseAPI {
    /**
     * Add a new Fax Configuration
     * @summary Add Fax Configuration
     * @param {FaxConfiguration} faxConfiguration 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FaxConfigurationControllerApi
     */
    public addConfiguration(faxConfiguration: FaxConfiguration, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return FaxConfigurationControllerApiFp(this.configuration).addConfiguration(faxConfiguration, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all Fax Configurations for Current Tenant
     * @summary Get All Fax Configurations for Current Tenant
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FaxConfigurationControllerApi
     */
    public getConfigurations(xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return FaxConfigurationControllerApiFp(this.configuration).getConfigurations(xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update an existing Fax Configuration
     * @summary Update Fax Configuration
     * @param {FaxConfiguration} faxConfiguration 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FaxConfigurationControllerApi
     */
    public updateConfiguration(faxConfiguration: FaxConfiguration, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return FaxConfigurationControllerApiFp(this.configuration).updateConfiguration(faxConfiguration, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * FcmTokenControllerApi - axios parameter creator
 * @export
 */
export const FcmTokenControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Add a new Fcm token into the system.
         * @summary Add Fcm Token
         * @param {FcmToken} fcmToken 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFcmToken: async (fcmToken: FcmToken, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'fcmToken' is not null or undefined
            assertParamExists('createFcmToken', 'fcmToken', fcmToken)
            const localVarPath = `/api/master/fcm-token`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(fcmToken, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FcmTokenControllerApi - functional programming interface
 * @export
 */
export const FcmTokenControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = FcmTokenControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * Add a new Fcm token into the system.
         * @summary Add Fcm Token
         * @param {FcmToken} fcmToken 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createFcmToken(fcmToken: FcmToken, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createFcmToken(fcmToken, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FcmTokenControllerApi.createFcmToken']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * FcmTokenControllerApi - factory interface
 * @export
 */
export const FcmTokenControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = FcmTokenControllerApiFp(configuration)
    return {
        /**
         * Add a new Fcm token into the system.
         * @summary Add Fcm Token
         * @param {FcmToken} fcmToken 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFcmToken(fcmToken: FcmToken, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.createFcmToken(fcmToken, xTENANTID, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * FcmTokenControllerApi - object-oriented interface
 * @export
 * @class FcmTokenControllerApi
 * @extends {BaseAPI}
 */
export class FcmTokenControllerApi extends BaseAPI {
    /**
     * Add a new Fcm token into the system.
     * @summary Add Fcm Token
     * @param {FcmToken} fcmToken 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FcmTokenControllerApi
     */
    public createFcmToken(fcmToken: FcmToken, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return FcmTokenControllerApiFp(this.configuration).createFcmToken(fcmToken, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * FeeScheduleControllerApi - axios parameter creator
 * @export
 */
export const FeeScheduleControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Add a new Fee Schedule into the system
         * @summary Add Fee Schedule
         * @param {FeeSchedule} feeSchedule 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFeeSchedule: async (feeSchedule: FeeSchedule, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'feeSchedule' is not null or undefined
            assertParamExists('createFeeSchedule', 'feeSchedule', feeSchedule)
            const localVarPath = `/api/master/fee-schedule`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(feeSchedule, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve a Fee Schedule amount by Provider UUID and Code ID
         * @summary Get Fee Schedule Amount by Provider and Code
         * @param {string} providerId 
         * @param {string} codeId 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFeeScheduleAmount: async (providerId: string, codeId: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'providerId' is not null or undefined
            assertParamExists('getFeeScheduleAmount', 'providerId', providerId)
            // verify required parameter 'codeId' is not null or undefined
            assertParamExists('getFeeScheduleAmount', 'codeId', codeId)
            const localVarPath = `/api/master/fee-schedule/provider/{providerId}/code/{codeId}`
                .replace(`{${"providerId"}}`, encodeURIComponent(String(providerId)))
                .replace(`{${"codeId"}}`, encodeURIComponent(String(codeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve a Fee Schedule amount filtered by Payer ID, Code UUID, and Fee Schedule Type. Intended for claim auto-populate.
         * @summary Get Fee Schedule Amount by Payer, Code and Type
         * @param {string} payerId 
         * @param {string} codeId 
         * @param {GetFeeScheduleAmountByPayerAndTypeFeeScheduleTypeEnum} feeScheduleType 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFeeScheduleAmountByPayerAndType: async (payerId: string, codeId: string, feeScheduleType: GetFeeScheduleAmountByPayerAndTypeFeeScheduleTypeEnum, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'payerId' is not null or undefined
            assertParamExists('getFeeScheduleAmountByPayerAndType', 'payerId', payerId)
            // verify required parameter 'codeId' is not null or undefined
            assertParamExists('getFeeScheduleAmountByPayerAndType', 'codeId', codeId)
            // verify required parameter 'feeScheduleType' is not null or undefined
            assertParamExists('getFeeScheduleAmountByPayerAndType', 'feeScheduleType', feeScheduleType)
            const localVarPath = `/api/master/fee-schedule/payer/{payerId}/code/{codeId}/by-type`
                .replace(`{${"payerId"}}`, encodeURIComponent(String(payerId)))
                .replace(`{${"codeId"}}`, encodeURIComponent(String(codeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (feeScheduleType !== undefined) {
                localVarQueryParameter['feeScheduleType'] = feeScheduleType;
            }

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve a Fee Schedule amount filtered by Provider UUID, Code UUID, and Fee Schedule Type (PAYER_SPECIFIC or PROVIDER_SPECIFIC)
         * @summary Get Fee Schedule Amount by Provider, Code and Type
         * @param {string} providerId 
         * @param {string} codeId 
         * @param {GetFeeScheduleAmountByTypeFeeScheduleTypeEnum} feeScheduleType 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFeeScheduleAmountByType: async (providerId: string, codeId: string, feeScheduleType: GetFeeScheduleAmountByTypeFeeScheduleTypeEnum, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'providerId' is not null or undefined
            assertParamExists('getFeeScheduleAmountByType', 'providerId', providerId)
            // verify required parameter 'codeId' is not null or undefined
            assertParamExists('getFeeScheduleAmountByType', 'codeId', codeId)
            // verify required parameter 'feeScheduleType' is not null or undefined
            assertParamExists('getFeeScheduleAmountByType', 'feeScheduleType', feeScheduleType)
            const localVarPath = `/api/master/fee-schedule/provider/{providerId}/code/{codeId}/by-type`
                .replace(`{${"providerId"}}`, encodeURIComponent(String(providerId)))
                .replace(`{${"codeId"}}`, encodeURIComponent(String(codeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (feeScheduleType !== undefined) {
                localVarQueryParameter['feeScheduleType'] = feeScheduleType;
            }

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve a Fee Schedule by its unique ID
         * @summary Get Fee Schedule by ID
         * @param {string} feeScheduleId 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFeeScheduleById: async (feeScheduleId: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'feeScheduleId' is not null or undefined
            assertParamExists('getFeeScheduleById', 'feeScheduleId', feeScheduleId)
            const localVarPath = `/api/master/fee-schedule/{feeScheduleId}`
                .replace(`{${"feeScheduleId"}}`, encodeURIComponent(String(feeScheduleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all Fee Schedules with search and filter options
         * @summary Get all Fee Schedules
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sort] 
         * @param {Array<string>} [providerUuid] 
         * @param {string} [medicalCodeUuid] 
         * @param {boolean} [status] 
         * @param {boolean} [archive] 
         * @param {GetFeeSchedulesFeeScheduleTypeEnum} [feeScheduleType] 
         * @param {Array<string>} [payerId] 
         * @param {string} [searchString] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFeeSchedules: async (page?: number, size?: number, sortBy?: string, sort?: string, providerUuid?: Array<string>, medicalCodeUuid?: string, status?: boolean, archive?: boolean, feeScheduleType?: GetFeeSchedulesFeeScheduleTypeEnum, payerId?: Array<string>, searchString?: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/master/fee-schedule`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (providerUuid) {
                localVarQueryParameter['providerUuid'] = providerUuid;
            }

            if (medicalCodeUuid !== undefined) {
                localVarQueryParameter['medicalCodeUuid'] = medicalCodeUuid;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (archive !== undefined) {
                localVarQueryParameter['archive'] = archive;
            }

            if (feeScheduleType !== undefined) {
                localVarQueryParameter['feeScheduleType'] = feeScheduleType;
            }

            if (payerId) {
                localVarQueryParameter['payerId'] = payerId;
            }

            if (searchString !== undefined) {
                localVarQueryParameter['searchString'] = searchString;
            }

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update an existing Fee Schedule
         * @summary Update Fee Schedule
         * @param {FeeSchedule} feeSchedule 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFeeSchedule: async (feeSchedule: FeeSchedule, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'feeSchedule' is not null or undefined
            assertParamExists('updateFeeSchedule', 'feeSchedule', feeSchedule)
            const localVarPath = `/api/master/fee-schedule`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(feeSchedule, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Archive a Fee Schedule by its ID
         * @summary Archive Fee Schedule
         * @param {string} feeScheduleId 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFeeScheduleArchiveStatus: async (feeScheduleId: string, status: boolean, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'feeScheduleId' is not null or undefined
            assertParamExists('updateFeeScheduleArchiveStatus', 'feeScheduleId', feeScheduleId)
            // verify required parameter 'status' is not null or undefined
            assertParamExists('updateFeeScheduleArchiveStatus', 'status', status)
            const localVarPath = `/api/master/fee-schedule/{feeScheduleId}/archive-status/{status}`
                .replace(`{${"feeScheduleId"}}`, encodeURIComponent(String(feeScheduleId)))
                .replace(`{${"status"}}`, encodeURIComponent(String(status)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update the status of a Fee Schedule by its ID
         * @summary Update Fee Schedule Status
         * @param {string} feeScheduleId 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFeeScheduleStatus: async (feeScheduleId: string, status: boolean, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'feeScheduleId' is not null or undefined
            assertParamExists('updateFeeScheduleStatus', 'feeScheduleId', feeScheduleId)
            // verify required parameter 'status' is not null or undefined
            assertParamExists('updateFeeScheduleStatus', 'status', status)
            const localVarPath = `/api/master/fee-schedule/{feeScheduleId}/status/{status}`
                .replace(`{${"feeScheduleId"}}`, encodeURIComponent(String(feeScheduleId)))
                .replace(`{${"status"}}`, encodeURIComponent(String(status)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FeeScheduleControllerApi - functional programming interface
 * @export
 */
export const FeeScheduleControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = FeeScheduleControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * Add a new Fee Schedule into the system
         * @summary Add Fee Schedule
         * @param {FeeSchedule} feeSchedule 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createFeeSchedule(feeSchedule: FeeSchedule, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createFeeSchedule(feeSchedule, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FeeScheduleControllerApi.createFeeSchedule']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve a Fee Schedule amount by Provider UUID and Code ID
         * @summary Get Fee Schedule Amount by Provider and Code
         * @param {string} providerId 
         * @param {string} codeId 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFeeScheduleAmount(providerId: string, codeId: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFeeScheduleAmount(providerId, codeId, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FeeScheduleControllerApi.getFeeScheduleAmount']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve a Fee Schedule amount filtered by Payer ID, Code UUID, and Fee Schedule Type. Intended for claim auto-populate.
         * @summary Get Fee Schedule Amount by Payer, Code and Type
         * @param {string} payerId 
         * @param {string} codeId 
         * @param {GetFeeScheduleAmountByPayerAndTypeFeeScheduleTypeEnum} feeScheduleType 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFeeScheduleAmountByPayerAndType(payerId: string, codeId: string, feeScheduleType: GetFeeScheduleAmountByPayerAndTypeFeeScheduleTypeEnum, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFeeScheduleAmountByPayerAndType(payerId, codeId, feeScheduleType, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FeeScheduleControllerApi.getFeeScheduleAmountByPayerAndType']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve a Fee Schedule amount filtered by Provider UUID, Code UUID, and Fee Schedule Type (PAYER_SPECIFIC or PROVIDER_SPECIFIC)
         * @summary Get Fee Schedule Amount by Provider, Code and Type
         * @param {string} providerId 
         * @param {string} codeId 
         * @param {GetFeeScheduleAmountByTypeFeeScheduleTypeEnum} feeScheduleType 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFeeScheduleAmountByType(providerId: string, codeId: string, feeScheduleType: GetFeeScheduleAmountByTypeFeeScheduleTypeEnum, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFeeScheduleAmountByType(providerId, codeId, feeScheduleType, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FeeScheduleControllerApi.getFeeScheduleAmountByType']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve a Fee Schedule by its unique ID
         * @summary Get Fee Schedule by ID
         * @param {string} feeScheduleId 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFeeScheduleById(feeScheduleId: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFeeScheduleById(feeScheduleId, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FeeScheduleControllerApi.getFeeScheduleById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get all Fee Schedules with search and filter options
         * @summary Get all Fee Schedules
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sort] 
         * @param {Array<string>} [providerUuid] 
         * @param {string} [medicalCodeUuid] 
         * @param {boolean} [status] 
         * @param {boolean} [archive] 
         * @param {GetFeeSchedulesFeeScheduleTypeEnum} [feeScheduleType] 
         * @param {Array<string>} [payerId] 
         * @param {string} [searchString] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFeeSchedules(page?: number, size?: number, sortBy?: string, sort?: string, providerUuid?: Array<string>, medicalCodeUuid?: string, status?: boolean, archive?: boolean, feeScheduleType?: GetFeeSchedulesFeeScheduleTypeEnum, payerId?: Array<string>, searchString?: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFeeSchedules(page, size, sortBy, sort, providerUuid, medicalCodeUuid, status, archive, feeScheduleType, payerId, searchString, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FeeScheduleControllerApi.getFeeSchedules']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update an existing Fee Schedule
         * @summary Update Fee Schedule
         * @param {FeeSchedule} feeSchedule 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateFeeSchedule(feeSchedule: FeeSchedule, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateFeeSchedule(feeSchedule, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FeeScheduleControllerApi.updateFeeSchedule']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Archive a Fee Schedule by its ID
         * @summary Archive Fee Schedule
         * @param {string} feeScheduleId 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateFeeScheduleArchiveStatus(feeScheduleId: string, status: boolean, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateFeeScheduleArchiveStatus(feeScheduleId, status, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FeeScheduleControllerApi.updateFeeScheduleArchiveStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update the status of a Fee Schedule by its ID
         * @summary Update Fee Schedule Status
         * @param {string} feeScheduleId 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateFeeScheduleStatus(feeScheduleId: string, status: boolean, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateFeeScheduleStatus(feeScheduleId, status, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FeeScheduleControllerApi.updateFeeScheduleStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * FeeScheduleControllerApi - factory interface
 * @export
 */
export const FeeScheduleControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = FeeScheduleControllerApiFp(configuration)
    return {
        /**
         * Add a new Fee Schedule into the system
         * @summary Add Fee Schedule
         * @param {FeeSchedule} feeSchedule 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFeeSchedule(feeSchedule: FeeSchedule, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.createFeeSchedule(feeSchedule, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve a Fee Schedule amount by Provider UUID and Code ID
         * @summary Get Fee Schedule Amount by Provider and Code
         * @param {string} providerId 
         * @param {string} codeId 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFeeScheduleAmount(providerId: string, codeId: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getFeeScheduleAmount(providerId, codeId, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve a Fee Schedule amount filtered by Payer ID, Code UUID, and Fee Schedule Type. Intended for claim auto-populate.
         * @summary Get Fee Schedule Amount by Payer, Code and Type
         * @param {string} payerId 
         * @param {string} codeId 
         * @param {GetFeeScheduleAmountByPayerAndTypeFeeScheduleTypeEnum} feeScheduleType 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFeeScheduleAmountByPayerAndType(payerId: string, codeId: string, feeScheduleType: GetFeeScheduleAmountByPayerAndTypeFeeScheduleTypeEnum, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getFeeScheduleAmountByPayerAndType(payerId, codeId, feeScheduleType, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve a Fee Schedule amount filtered by Provider UUID, Code UUID, and Fee Schedule Type (PAYER_SPECIFIC or PROVIDER_SPECIFIC)
         * @summary Get Fee Schedule Amount by Provider, Code and Type
         * @param {string} providerId 
         * @param {string} codeId 
         * @param {GetFeeScheduleAmountByTypeFeeScheduleTypeEnum} feeScheduleType 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFeeScheduleAmountByType(providerId: string, codeId: string, feeScheduleType: GetFeeScheduleAmountByTypeFeeScheduleTypeEnum, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getFeeScheduleAmountByType(providerId, codeId, feeScheduleType, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve a Fee Schedule by its unique ID
         * @summary Get Fee Schedule by ID
         * @param {string} feeScheduleId 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFeeScheduleById(feeScheduleId: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getFeeScheduleById(feeScheduleId, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all Fee Schedules with search and filter options
         * @summary Get all Fee Schedules
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sort] 
         * @param {Array<string>} [providerUuid] 
         * @param {string} [medicalCodeUuid] 
         * @param {boolean} [status] 
         * @param {boolean} [archive] 
         * @param {GetFeeSchedulesFeeScheduleTypeEnum} [feeScheduleType] 
         * @param {Array<string>} [payerId] 
         * @param {string} [searchString] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFeeSchedules(page?: number, size?: number, sortBy?: string, sort?: string, providerUuid?: Array<string>, medicalCodeUuid?: string, status?: boolean, archive?: boolean, feeScheduleType?: GetFeeSchedulesFeeScheduleTypeEnum, payerId?: Array<string>, searchString?: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getFeeSchedules(page, size, sortBy, sort, providerUuid, medicalCodeUuid, status, archive, feeScheduleType, payerId, searchString, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Update an existing Fee Schedule
         * @summary Update Fee Schedule
         * @param {FeeSchedule} feeSchedule 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFeeSchedule(feeSchedule: FeeSchedule, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.updateFeeSchedule(feeSchedule, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Archive a Fee Schedule by its ID
         * @summary Archive Fee Schedule
         * @param {string} feeScheduleId 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFeeScheduleArchiveStatus(feeScheduleId: string, status: boolean, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.updateFeeScheduleArchiveStatus(feeScheduleId, status, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Update the status of a Fee Schedule by its ID
         * @summary Update Fee Schedule Status
         * @param {string} feeScheduleId 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFeeScheduleStatus(feeScheduleId: string, status: boolean, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.updateFeeScheduleStatus(feeScheduleId, status, xTENANTID, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * FeeScheduleControllerApi - object-oriented interface
 * @export
 * @class FeeScheduleControllerApi
 * @extends {BaseAPI}
 */
export class FeeScheduleControllerApi extends BaseAPI {
    /**
     * Add a new Fee Schedule into the system
     * @summary Add Fee Schedule
     * @param {FeeSchedule} feeSchedule 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FeeScheduleControllerApi
     */
    public createFeeSchedule(feeSchedule: FeeSchedule, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return FeeScheduleControllerApiFp(this.configuration).createFeeSchedule(feeSchedule, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve a Fee Schedule amount by Provider UUID and Code ID
     * @summary Get Fee Schedule Amount by Provider and Code
     * @param {string} providerId 
     * @param {string} codeId 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FeeScheduleControllerApi
     */
    public getFeeScheduleAmount(providerId: string, codeId: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return FeeScheduleControllerApiFp(this.configuration).getFeeScheduleAmount(providerId, codeId, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve a Fee Schedule amount filtered by Payer ID, Code UUID, and Fee Schedule Type. Intended for claim auto-populate.
     * @summary Get Fee Schedule Amount by Payer, Code and Type
     * @param {string} payerId 
     * @param {string} codeId 
     * @param {GetFeeScheduleAmountByPayerAndTypeFeeScheduleTypeEnum} feeScheduleType 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FeeScheduleControllerApi
     */
    public getFeeScheduleAmountByPayerAndType(payerId: string, codeId: string, feeScheduleType: GetFeeScheduleAmountByPayerAndTypeFeeScheduleTypeEnum, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return FeeScheduleControllerApiFp(this.configuration).getFeeScheduleAmountByPayerAndType(payerId, codeId, feeScheduleType, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve a Fee Schedule amount filtered by Provider UUID, Code UUID, and Fee Schedule Type (PAYER_SPECIFIC or PROVIDER_SPECIFIC)
     * @summary Get Fee Schedule Amount by Provider, Code and Type
     * @param {string} providerId 
     * @param {string} codeId 
     * @param {GetFeeScheduleAmountByTypeFeeScheduleTypeEnum} feeScheduleType 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FeeScheduleControllerApi
     */
    public getFeeScheduleAmountByType(providerId: string, codeId: string, feeScheduleType: GetFeeScheduleAmountByTypeFeeScheduleTypeEnum, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return FeeScheduleControllerApiFp(this.configuration).getFeeScheduleAmountByType(providerId, codeId, feeScheduleType, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve a Fee Schedule by its unique ID
     * @summary Get Fee Schedule by ID
     * @param {string} feeScheduleId 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FeeScheduleControllerApi
     */
    public getFeeScheduleById(feeScheduleId: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return FeeScheduleControllerApiFp(this.configuration).getFeeScheduleById(feeScheduleId, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all Fee Schedules with search and filter options
     * @summary Get all Fee Schedules
     * @param {number} [page] 
     * @param {number} [size] 
     * @param {string} [sortBy] 
     * @param {string} [sort] 
     * @param {Array<string>} [providerUuid] 
     * @param {string} [medicalCodeUuid] 
     * @param {boolean} [status] 
     * @param {boolean} [archive] 
     * @param {GetFeeSchedulesFeeScheduleTypeEnum} [feeScheduleType] 
     * @param {Array<string>} [payerId] 
     * @param {string} [searchString] 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FeeScheduleControllerApi
     */
    public getFeeSchedules(page?: number, size?: number, sortBy?: string, sort?: string, providerUuid?: Array<string>, medicalCodeUuid?: string, status?: boolean, archive?: boolean, feeScheduleType?: GetFeeSchedulesFeeScheduleTypeEnum, payerId?: Array<string>, searchString?: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return FeeScheduleControllerApiFp(this.configuration).getFeeSchedules(page, size, sortBy, sort, providerUuid, medicalCodeUuid, status, archive, feeScheduleType, payerId, searchString, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update an existing Fee Schedule
     * @summary Update Fee Schedule
     * @param {FeeSchedule} feeSchedule 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FeeScheduleControllerApi
     */
    public updateFeeSchedule(feeSchedule: FeeSchedule, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return FeeScheduleControllerApiFp(this.configuration).updateFeeSchedule(feeSchedule, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Archive a Fee Schedule by its ID
     * @summary Archive Fee Schedule
     * @param {string} feeScheduleId 
     * @param {boolean} status 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FeeScheduleControllerApi
     */
    public updateFeeScheduleArchiveStatus(feeScheduleId: string, status: boolean, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return FeeScheduleControllerApiFp(this.configuration).updateFeeScheduleArchiveStatus(feeScheduleId, status, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update the status of a Fee Schedule by its ID
     * @summary Update Fee Schedule Status
     * @param {string} feeScheduleId 
     * @param {boolean} status 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FeeScheduleControllerApi
     */
    public updateFeeScheduleStatus(feeScheduleId: string, status: boolean, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return FeeScheduleControllerApiFp(this.configuration).updateFeeScheduleStatus(feeScheduleId, status, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const GetFeeScheduleAmountByPayerAndTypeFeeScheduleTypeEnum = {
    PayerSpecific: 'PAYER_SPECIFIC',
    ProviderSpecific: 'PROVIDER_SPECIFIC'
} as const;
export type GetFeeScheduleAmountByPayerAndTypeFeeScheduleTypeEnum = typeof GetFeeScheduleAmountByPayerAndTypeFeeScheduleTypeEnum[keyof typeof GetFeeScheduleAmountByPayerAndTypeFeeScheduleTypeEnum];
/**
 * @export
 */
export const GetFeeScheduleAmountByTypeFeeScheduleTypeEnum = {
    PayerSpecific: 'PAYER_SPECIFIC',
    ProviderSpecific: 'PROVIDER_SPECIFIC'
} as const;
export type GetFeeScheduleAmountByTypeFeeScheduleTypeEnum = typeof GetFeeScheduleAmountByTypeFeeScheduleTypeEnum[keyof typeof GetFeeScheduleAmountByTypeFeeScheduleTypeEnum];
/**
 * @export
 */
export const GetFeeSchedulesFeeScheduleTypeEnum = {
    PayerSpecific: 'PAYER_SPECIFIC',
    ProviderSpecific: 'PROVIDER_SPECIFIC'
} as const;
export type GetFeeSchedulesFeeScheduleTypeEnum = typeof GetFeeSchedulesFeeScheduleTypeEnum[keyof typeof GetFeeSchedulesFeeScheduleTypeEnum];


/**
 * FlagsControllerApi - axios parameter creator
 * @export
 */
export const FlagsControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Add a new flag into the system
         * @summary Add Flag
         * @param {Flags} flags 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFlags: async (flags: Flags, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'flags' is not null or undefined
            assertParamExists('createFlags', 'flags', flags)
            const localVarPath = `/api/master/flags`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(flags, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all flags list with search and filter options.
         * @summary Get all flags.
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sort] 
         * @param {string} [name] 
         * @param {boolean} [active] 
         * @param {boolean} [archive] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllFlags: async (page?: number, size?: number, sortBy?: string, sort?: string, name?: string, active?: boolean, archive?: boolean, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/master/flags`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            if (active !== undefined) {
                localVarQueryParameter['active'] = active;
            }

            if (archive !== undefined) {
                localVarQueryParameter['archive'] = archive;
            }

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update an existing Flags
         * @summary Update Flags
         * @param {Flags} flags 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFlags: async (flags: Flags, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'flags' is not null or undefined
            assertParamExists('updateFlags', 'flags', flags)
            const localVarPath = `/api/master/flags`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(flags, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Archive a Flags by its ID
         * @summary Archive Flags
         * @param {string} patientFlagId 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePatientFlagArchiveStatus1: async (patientFlagId: string, status: boolean, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientFlagId' is not null or undefined
            assertParamExists('updatePatientFlagArchiveStatus1', 'patientFlagId', patientFlagId)
            // verify required parameter 'status' is not null or undefined
            assertParamExists('updatePatientFlagArchiveStatus1', 'status', status)
            const localVarPath = `/api/master/flags/{patientFlagId}/archive-status/{status}`
                .replace(`{${"patientFlagId"}}`, encodeURIComponent(String(patientFlagId)))
                .replace(`{${"status"}}`, encodeURIComponent(String(status)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FlagsControllerApi - functional programming interface
 * @export
 */
export const FlagsControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = FlagsControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * Add a new flag into the system
         * @summary Add Flag
         * @param {Flags} flags 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createFlags(flags: Flags, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createFlags(flags, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FlagsControllerApi.createFlags']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get all flags list with search and filter options.
         * @summary Get all flags.
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sort] 
         * @param {string} [name] 
         * @param {boolean} [active] 
         * @param {boolean} [archive] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllFlags(page?: number, size?: number, sortBy?: string, sort?: string, name?: string, active?: boolean, archive?: boolean, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllFlags(page, size, sortBy, sort, name, active, archive, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FlagsControllerApi.getAllFlags']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update an existing Flags
         * @summary Update Flags
         * @param {Flags} flags 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateFlags(flags: Flags, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateFlags(flags, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FlagsControllerApi.updateFlags']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Archive a Flags by its ID
         * @summary Archive Flags
         * @param {string} patientFlagId 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePatientFlagArchiveStatus1(patientFlagId: string, status: boolean, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePatientFlagArchiveStatus1(patientFlagId, status, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FlagsControllerApi.updatePatientFlagArchiveStatus1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * FlagsControllerApi - factory interface
 * @export
 */
export const FlagsControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = FlagsControllerApiFp(configuration)
    return {
        /**
         * Add a new flag into the system
         * @summary Add Flag
         * @param {Flags} flags 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFlags(flags: Flags, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.createFlags(flags, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all flags list with search and filter options.
         * @summary Get all flags.
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sort] 
         * @param {string} [name] 
         * @param {boolean} [active] 
         * @param {boolean} [archive] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllFlags(page?: number, size?: number, sortBy?: string, sort?: string, name?: string, active?: boolean, archive?: boolean, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getAllFlags(page, size, sortBy, sort, name, active, archive, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Update an existing Flags
         * @summary Update Flags
         * @param {Flags} flags 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFlags(flags: Flags, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.updateFlags(flags, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Archive a Flags by its ID
         * @summary Archive Flags
         * @param {string} patientFlagId 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePatientFlagArchiveStatus1(patientFlagId: string, status: boolean, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.updatePatientFlagArchiveStatus1(patientFlagId, status, xTENANTID, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * FlagsControllerApi - object-oriented interface
 * @export
 * @class FlagsControllerApi
 * @extends {BaseAPI}
 */
export class FlagsControllerApi extends BaseAPI {
    /**
     * Add a new flag into the system
     * @summary Add Flag
     * @param {Flags} flags 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FlagsControllerApi
     */
    public createFlags(flags: Flags, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return FlagsControllerApiFp(this.configuration).createFlags(flags, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all flags list with search and filter options.
     * @summary Get all flags.
     * @param {number} [page] 
     * @param {number} [size] 
     * @param {string} [sortBy] 
     * @param {string} [sort] 
     * @param {string} [name] 
     * @param {boolean} [active] 
     * @param {boolean} [archive] 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FlagsControllerApi
     */
    public getAllFlags(page?: number, size?: number, sortBy?: string, sort?: string, name?: string, active?: boolean, archive?: boolean, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return FlagsControllerApiFp(this.configuration).getAllFlags(page, size, sortBy, sort, name, active, archive, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update an existing Flags
     * @summary Update Flags
     * @param {Flags} flags 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FlagsControllerApi
     */
    public updateFlags(flags: Flags, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return FlagsControllerApiFp(this.configuration).updateFlags(flags, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Archive a Flags by its ID
     * @summary Archive Flags
     * @param {string} patientFlagId 
     * @param {boolean} status 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FlagsControllerApi
     */
    public updatePatientFlagArchiveStatus1(patientFlagId: string, status: boolean, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return FlagsControllerApiFp(this.configuration).updatePatientFlagArchiveStatus1(patientFlagId, status, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * FullscriptApi - axios parameter creator
 * @export
 */
export const FullscriptApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Public endpoint that accepts authorization code from Fullscript OAuth redirect and exchanges it for an access token. Stores tokens in provider table. The \'state\' param carries \'schema|providerUuid\' for tenant and provider identification.
         * @summary OAuth Authorization Callback
         * @param {string} code Authorization code from Fullscript OAuth redirect
         * @param {string} [state] schema|providerUuid (passed as OAuth state param)
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authorize: async (code: string, state?: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'code' is not null or undefined
            assertParamExists('authorize', 'code', code)
            const localVarPath = `/api/master/fullscript/oauth/authorize`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (code !== undefined) {
                localVarQueryParameter['code'] = code;
            }

            if (state !== undefined) {
                localVarQueryParameter['state'] = state;
            }

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Creates a new patient in Fullscript. Uses X-TENANT-ID header.
         * @summary Create Patient in Fullscript
         * @param {CreatePatientDto} createPatientDto 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPatient1: async (createPatientDto: CreatePatientDto, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createPatientDto' is not null or undefined
            assertParamExists('createPatient1', 'createPatientDto', createPatientDto)
            const localVarPath = `/api/master/fullscript/patients`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createPatientDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Creates a session grant for Fullscript embeddable. Requires a valid access token. Uses X-TENANT-ID header.
         * @summary Create Session Grant,
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSessionGrant: async (xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/master/fullscript/session-grant`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves the access token from DB if available and not expired. If not found or expired, returns the OAuth authorization redirect URL. Uses X-TENANT-ID header to identify the provider group.
         * @summary Get Access Token or Redirect URL
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccessTokenOrRedirect: async (xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/master/fullscript/oauth/token`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Updates an existing patient in Fullscript. Uses X-TENANT-ID header.
         * @summary Update Patient in Fullscript
         * @param {string} id Fullscript patient ID
         * @param {UpdatePatientDto} updatePatientDto 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePatient1: async (id: string, updatePatientDto: UpdatePatientDto, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updatePatient1', 'id', id)
            // verify required parameter 'updatePatientDto' is not null or undefined
            assertParamExists('updatePatient1', 'updatePatientDto', updatePatientDto)
            const localVarPath = `/api/master/fullscript/patients/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updatePatientDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FullscriptApi - functional programming interface
 * @export
 */
export const FullscriptApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = FullscriptApiAxiosParamCreator(configuration)
    return {
        /**
         * Public endpoint that accepts authorization code from Fullscript OAuth redirect and exchanges it for an access token. Stores tokens in provider table. The \'state\' param carries \'schema|providerUuid\' for tenant and provider identification.
         * @summary OAuth Authorization Callback
         * @param {string} code Authorization code from Fullscript OAuth redirect
         * @param {string} [state] schema|providerUuid (passed as OAuth state param)
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authorize(code: string, state?: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authorize(code, state, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FullscriptApi.authorize']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Creates a new patient in Fullscript. Uses X-TENANT-ID header.
         * @summary Create Patient in Fullscript
         * @param {CreatePatientDto} createPatientDto 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createPatient1(createPatientDto: CreatePatientDto, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createPatient1(createPatientDto, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FullscriptApi.createPatient1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Creates a session grant for Fullscript embeddable. Requires a valid access token. Uses X-TENANT-ID header.
         * @summary Create Session Grant,
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createSessionGrant(xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createSessionGrant(xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FullscriptApi.createSessionGrant']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves the access token from DB if available and not expired. If not found or expired, returns the OAuth authorization redirect URL. Uses X-TENANT-ID header to identify the provider group.
         * @summary Get Access Token or Redirect URL
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAccessTokenOrRedirect(xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAccessTokenOrRedirect(xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FullscriptApi.getAccessTokenOrRedirect']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Updates an existing patient in Fullscript. Uses X-TENANT-ID header.
         * @summary Update Patient in Fullscript
         * @param {string} id Fullscript patient ID
         * @param {UpdatePatientDto} updatePatientDto 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePatient1(id: string, updatePatientDto: UpdatePatientDto, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePatient1(id, updatePatientDto, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FullscriptApi.updatePatient1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * FullscriptApi - factory interface
 * @export
 */
export const FullscriptApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = FullscriptApiFp(configuration)
    return {
        /**
         * Public endpoint that accepts authorization code from Fullscript OAuth redirect and exchanges it for an access token. Stores tokens in provider table. The \'state\' param carries \'schema|providerUuid\' for tenant and provider identification.
         * @summary OAuth Authorization Callback
         * @param {string} code Authorization code from Fullscript OAuth redirect
         * @param {string} [state] schema|providerUuid (passed as OAuth state param)
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authorize(code: string, state?: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.authorize(code, state, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Creates a new patient in Fullscript. Uses X-TENANT-ID header.
         * @summary Create Patient in Fullscript
         * @param {CreatePatientDto} createPatientDto 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPatient1(createPatientDto: CreatePatientDto, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.createPatient1(createPatientDto, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Creates a session grant for Fullscript embeddable. Requires a valid access token. Uses X-TENANT-ID header.
         * @summary Create Session Grant,
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSessionGrant(xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.createSessionGrant(xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves the access token from DB if available and not expired. If not found or expired, returns the OAuth authorization redirect URL. Uses X-TENANT-ID header to identify the provider group.
         * @summary Get Access Token or Redirect URL
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccessTokenOrRedirect(xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getAccessTokenOrRedirect(xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates an existing patient in Fullscript. Uses X-TENANT-ID header.
         * @summary Update Patient in Fullscript
         * @param {string} id Fullscript patient ID
         * @param {UpdatePatientDto} updatePatientDto 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePatient1(id: string, updatePatientDto: UpdatePatientDto, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.updatePatient1(id, updatePatientDto, xTENANTID, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * FullscriptApi - object-oriented interface
 * @export
 * @class FullscriptApi
 * @extends {BaseAPI}
 */
export class FullscriptApi extends BaseAPI {
    /**
     * Public endpoint that accepts authorization code from Fullscript OAuth redirect and exchanges it for an access token. Stores tokens in provider table. The \'state\' param carries \'schema|providerUuid\' for tenant and provider identification.
     * @summary OAuth Authorization Callback
     * @param {string} code Authorization code from Fullscript OAuth redirect
     * @param {string} [state] schema|providerUuid (passed as OAuth state param)
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FullscriptApi
     */
    public authorize(code: string, state?: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return FullscriptApiFp(this.configuration).authorize(code, state, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Creates a new patient in Fullscript. Uses X-TENANT-ID header.
     * @summary Create Patient in Fullscript
     * @param {CreatePatientDto} createPatientDto 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FullscriptApi
     */
    public createPatient1(createPatientDto: CreatePatientDto, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return FullscriptApiFp(this.configuration).createPatient1(createPatientDto, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Creates a session grant for Fullscript embeddable. Requires a valid access token. Uses X-TENANT-ID header.
     * @summary Create Session Grant,
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FullscriptApi
     */
    public createSessionGrant(xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return FullscriptApiFp(this.configuration).createSessionGrant(xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves the access token from DB if available and not expired. If not found or expired, returns the OAuth authorization redirect URL. Uses X-TENANT-ID header to identify the provider group.
     * @summary Get Access Token or Redirect URL
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FullscriptApi
     */
    public getAccessTokenOrRedirect(xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return FullscriptApiFp(this.configuration).getAccessTokenOrRedirect(xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Updates an existing patient in Fullscript. Uses X-TENANT-ID header.
     * @summary Update Patient in Fullscript
     * @param {string} id Fullscript patient ID
     * @param {UpdatePatientDto} updatePatientDto 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FullscriptApi
     */
    public updatePatient1(id: string, updatePatientDto: UpdatePatientDto, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return FullscriptApiFp(this.configuration).updatePatient1(id, updatePatientDto, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * IamControllerApi - axios parameter creator
 * @export
 */
export const IamControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Deletes a provider group realm using the realm name
         * @summary Delete realm by name
         * @param {string} realmName 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteRealmByName: async (realmName: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'realmName' is not null or undefined
            assertParamExists('deleteRealmByName', 'realmName', realmName)
            const localVarPath = `/api/master/iam/{realmName}`
                .replace(`{${"realmName"}}`, encodeURIComponent(String(realmName)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * IamControllerApi - functional programming interface
 * @export
 */
export const IamControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = IamControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * Deletes a provider group realm using the realm name
         * @summary Delete realm by name
         * @param {string} realmName 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteRealmByName(realmName: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteRealmByName(realmName, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['IamControllerApi.deleteRealmByName']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * IamControllerApi - factory interface
 * @export
 */
export const IamControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = IamControllerApiFp(configuration)
    return {
        /**
         * Deletes a provider group realm using the realm name
         * @summary Delete realm by name
         * @param {string} realmName 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteRealmByName(realmName: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.deleteRealmByName(realmName, xTENANTID, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * IamControllerApi - object-oriented interface
 * @export
 * @class IamControllerApi
 * @extends {BaseAPI}
 */
export class IamControllerApi extends BaseAPI {
    /**
     * Deletes a provider group realm using the realm name
     * @summary Delete realm by name
     * @param {string} realmName 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IamControllerApi
     */
    public deleteRealmByName(realmName: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return IamControllerApiFp(this.configuration).deleteRealmByName(realmName, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * InAppNotificationControllerApi - axios parameter creator
 * @export
 */
export const InAppNotificationControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get all notifications of current user.
         * @summary Get notification 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNotificationsOfCurrentUser: async (page?: number, size?: number, sortBy?: string, sortDirection?: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/master/notification`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get unseen notifications of current user.
         * @summary Get unseen notifications of current user
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUnseenNotificationsCount: async (xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/master/notification/unseen-notifications`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get notification by notificationUuid.
         * @summary Get notification by notificationUuid
         * @param {string} notificationUuid 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markNotificationAsSeen: async (notificationUuid: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'notificationUuid' is not null or undefined
            assertParamExists('markNotificationAsSeen', 'notificationUuid', notificationUuid)
            const localVarPath = `/api/master/notification/{notificationUuid}`
                .replace(`{${"notificationUuid"}}`, encodeURIComponent(String(notificationUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * InAppNotificationControllerApi - functional programming interface
 * @export
 */
export const InAppNotificationControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = InAppNotificationControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * Get all notifications of current user.
         * @summary Get notification 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getNotificationsOfCurrentUser(page?: number, size?: number, sortBy?: string, sortDirection?: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getNotificationsOfCurrentUser(page, size, sortBy, sortDirection, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InAppNotificationControllerApi.getNotificationsOfCurrentUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get unseen notifications of current user.
         * @summary Get unseen notifications of current user
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUnseenNotificationsCount(xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUnseenNotificationsCount(xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InAppNotificationControllerApi.getUnseenNotificationsCount']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get notification by notificationUuid.
         * @summary Get notification by notificationUuid
         * @param {string} notificationUuid 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async markNotificationAsSeen(notificationUuid: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.markNotificationAsSeen(notificationUuid, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InAppNotificationControllerApi.markNotificationAsSeen']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * InAppNotificationControllerApi - factory interface
 * @export
 */
export const InAppNotificationControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = InAppNotificationControllerApiFp(configuration)
    return {
        /**
         * Get all notifications of current user.
         * @summary Get notification 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNotificationsOfCurrentUser(page?: number, size?: number, sortBy?: string, sortDirection?: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getNotificationsOfCurrentUser(page, size, sortBy, sortDirection, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Get unseen notifications of current user.
         * @summary Get unseen notifications of current user
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUnseenNotificationsCount(xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getUnseenNotificationsCount(xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Get notification by notificationUuid.
         * @summary Get notification by notificationUuid
         * @param {string} notificationUuid 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markNotificationAsSeen(notificationUuid: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.markNotificationAsSeen(notificationUuid, xTENANTID, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * InAppNotificationControllerApi - object-oriented interface
 * @export
 * @class InAppNotificationControllerApi
 * @extends {BaseAPI}
 */
export class InAppNotificationControllerApi extends BaseAPI {
    /**
     * Get all notifications of current user.
     * @summary Get notification 
     * @param {number} [page] 
     * @param {number} [size] 
     * @param {string} [sortBy] 
     * @param {string} [sortDirection] 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InAppNotificationControllerApi
     */
    public getNotificationsOfCurrentUser(page?: number, size?: number, sortBy?: string, sortDirection?: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return InAppNotificationControllerApiFp(this.configuration).getNotificationsOfCurrentUser(page, size, sortBy, sortDirection, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get unseen notifications of current user.
     * @summary Get unseen notifications of current user
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InAppNotificationControllerApi
     */
    public getUnseenNotificationsCount(xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return InAppNotificationControllerApiFp(this.configuration).getUnseenNotificationsCount(xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get notification by notificationUuid.
     * @summary Get notification by notificationUuid
     * @param {string} notificationUuid 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InAppNotificationControllerApi
     */
    public markNotificationAsSeen(notificationUuid: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return InAppNotificationControllerApiFp(this.configuration).markNotificationAsSeen(notificationUuid, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * InsurancePayerControllerApi - axios parameter creator
 * @export
 */
export const InsurancePayerControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Add a new Insurance payer. New payers are active and not archived.
         * @summary Add Insurance Payer
         * @param {InsurancePayer} insurancePayer 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addInsurancePayer: async (insurancePayer: InsurancePayer, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'insurancePayer' is not null or undefined
            assertParamExists('addInsurancePayer', 'insurancePayer', insurancePayer)
            const localVarPath = `/api/master/insurance-payers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(insurancePayer, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all Insurance payers list.
         * @summary Get all Insurance Payer.
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {string} [searchString] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllInsurancePayer: async (page?: number, size?: number, sortBy?: string, sortDirection?: string, searchString?: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/master/insurance-payers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }

            if (searchString !== undefined) {
                localVarQueryParameter['searchString'] = searchString;
            }

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Number of patients and open claims linked to an Insurance payer, shown before marking it inactive.
         * @summary Get Insurance Payer Usage
         * @param {string} payerId 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInsurancePayerUsage: async (payerId: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'payerId' is not null or undefined
            assertParamExists('getInsurancePayerUsage', 'payerId', payerId)
            const localVarPath = `/api/master/insurance-payers/{payerId}/usage`
                .replace(`{${"payerId"}}`, encodeURIComponent(String(payerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get Insurance payers list with search option on payer id and payer name and filter options on active, archive, payerType. Supports sorting by: payer_id, payer_name, payer_type, active.
         * @summary Get Insurance Payers by status.
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {string} [searchString] 
         * @param {boolean} [active] 
         * @param {boolean} [archive] 
         * @param {GetInsurancePayersByStatusPayerTypeEnum} [payerType] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInsurancePayersByStatus: async (page?: number, size?: number, sortBy?: string, sortDirection?: string, searchString?: string, active?: boolean, archive?: boolean, payerType?: GetInsurancePayersByStatusPayerTypeEnum, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/master/insurance-payers/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }

            if (searchString !== undefined) {
                localVarQueryParameter['searchString'] = searchString;
            }

            if (active !== undefined) {
                localVarQueryParameter['active'] = active;
            }

            if (archive !== undefined) {
                localVarQueryParameter['archive'] = archive;
            }

            if (payerType !== undefined) {
                localVarQueryParameter['payerType'] = payerType;
            }

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update an Insurance payer by its current payer id.
         * @summary Update Insurance Payer
         * @param {string} payerId 
         * @param {InsurancePayer} insurancePayer 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateInsurancePayer: async (payerId: string, insurancePayer: InsurancePayer, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'payerId' is not null or undefined
            assertParamExists('updateInsurancePayer', 'payerId', payerId)
            // verify required parameter 'insurancePayer' is not null or undefined
            assertParamExists('updateInsurancePayer', 'insurancePayer', insurancePayer)
            const localVarPath = `/api/master/insurance-payers/{payerId}`
                .replace(`{${"payerId"}}`, encodeURIComponent(String(payerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(insurancePayer, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Archive or unarchive an Insurance payer by its payer id
         * @summary Archive Insurance Payer
         * @param {string} payerId 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateInsurancePayerArchiveStatus: async (payerId: string, status: boolean, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'payerId' is not null or undefined
            assertParamExists('updateInsurancePayerArchiveStatus', 'payerId', payerId)
            // verify required parameter 'status' is not null or undefined
            assertParamExists('updateInsurancePayerArchiveStatus', 'status', status)
            const localVarPath = `/api/master/insurance-payers/{payerId}/archive-status/{status}`
                .replace(`{${"payerId"}}`, encodeURIComponent(String(payerId)))
                .replace(`{${"status"}}`, encodeURIComponent(String(status)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Activate or deactivate an Insurance payer by its payer id
         * @summary Update Insurance Payer Status
         * @param {string} payerId 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateInsurancePayerStatus: async (payerId: string, status: boolean, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'payerId' is not null or undefined
            assertParamExists('updateInsurancePayerStatus', 'payerId', payerId)
            // verify required parameter 'status' is not null or undefined
            assertParamExists('updateInsurancePayerStatus', 'status', status)
            const localVarPath = `/api/master/insurance-payers/{payerId}/status/{status}`
                .replace(`{${"payerId"}}`, encodeURIComponent(String(payerId)))
                .replace(`{${"status"}}`, encodeURIComponent(String(status)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * InsurancePayerControllerApi - functional programming interface
 * @export
 */
export const InsurancePayerControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = InsurancePayerControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * Add a new Insurance payer. New payers are active and not archived.
         * @summary Add Insurance Payer
         * @param {InsurancePayer} insurancePayer 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addInsurancePayer(insurancePayer: InsurancePayer, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addInsurancePayer(insurancePayer, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InsurancePayerControllerApi.addInsurancePayer']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get all Insurance payers list.
         * @summary Get all Insurance Payer.
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {string} [searchString] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllInsurancePayer(page?: number, size?: number, sortBy?: string, sortDirection?: string, searchString?: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllInsurancePayer(page, size, sortBy, sortDirection, searchString, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InsurancePayerControllerApi.getAllInsurancePayer']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Number of patients and open claims linked to an Insurance payer, shown before marking it inactive.
         * @summary Get Insurance Payer Usage
         * @param {string} payerId 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getInsurancePayerUsage(payerId: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getInsurancePayerUsage(payerId, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InsurancePayerControllerApi.getInsurancePayerUsage']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get Insurance payers list with search option on payer id and payer name and filter options on active, archive, payerType. Supports sorting by: payer_id, payer_name, payer_type, active.
         * @summary Get Insurance Payers by status.
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {string} [searchString] 
         * @param {boolean} [active] 
         * @param {boolean} [archive] 
         * @param {GetInsurancePayersByStatusPayerTypeEnum} [payerType] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getInsurancePayersByStatus(page?: number, size?: number, sortBy?: string, sortDirection?: string, searchString?: string, active?: boolean, archive?: boolean, payerType?: GetInsurancePayersByStatusPayerTypeEnum, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getInsurancePayersByStatus(page, size, sortBy, sortDirection, searchString, active, archive, payerType, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InsurancePayerControllerApi.getInsurancePayersByStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update an Insurance payer by its current payer id.
         * @summary Update Insurance Payer
         * @param {string} payerId 
         * @param {InsurancePayer} insurancePayer 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateInsurancePayer(payerId: string, insurancePayer: InsurancePayer, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateInsurancePayer(payerId, insurancePayer, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InsurancePayerControllerApi.updateInsurancePayer']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Archive or unarchive an Insurance payer by its payer id
         * @summary Archive Insurance Payer
         * @param {string} payerId 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateInsurancePayerArchiveStatus(payerId: string, status: boolean, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateInsurancePayerArchiveStatus(payerId, status, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InsurancePayerControllerApi.updateInsurancePayerArchiveStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Activate or deactivate an Insurance payer by its payer id
         * @summary Update Insurance Payer Status
         * @param {string} payerId 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateInsurancePayerStatus(payerId: string, status: boolean, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateInsurancePayerStatus(payerId, status, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InsurancePayerControllerApi.updateInsurancePayerStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * InsurancePayerControllerApi - factory interface
 * @export
 */
export const InsurancePayerControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = InsurancePayerControllerApiFp(configuration)
    return {
        /**
         * Add a new Insurance payer. New payers are active and not archived.
         * @summary Add Insurance Payer
         * @param {InsurancePayer} insurancePayer 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addInsurancePayer(insurancePayer: InsurancePayer, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.addInsurancePayer(insurancePayer, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all Insurance payers list.
         * @summary Get all Insurance Payer.
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {string} [searchString] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllInsurancePayer(page?: number, size?: number, sortBy?: string, sortDirection?: string, searchString?: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getAllInsurancePayer(page, size, sortBy, sortDirection, searchString, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Number of patients and open claims linked to an Insurance payer, shown before marking it inactive.
         * @summary Get Insurance Payer Usage
         * @param {string} payerId 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInsurancePayerUsage(payerId: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getInsurancePayerUsage(payerId, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Get Insurance payers list with search option on payer id and payer name and filter options on active, archive, payerType. Supports sorting by: payer_id, payer_name, payer_type, active.
         * @summary Get Insurance Payers by status.
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {string} [searchString] 
         * @param {boolean} [active] 
         * @param {boolean} [archive] 
         * @param {GetInsurancePayersByStatusPayerTypeEnum} [payerType] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInsurancePayersByStatus(page?: number, size?: number, sortBy?: string, sortDirection?: string, searchString?: string, active?: boolean, archive?: boolean, payerType?: GetInsurancePayersByStatusPayerTypeEnum, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getInsurancePayersByStatus(page, size, sortBy, sortDirection, searchString, active, archive, payerType, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Update an Insurance payer by its current payer id.
         * @summary Update Insurance Payer
         * @param {string} payerId 
         * @param {InsurancePayer} insurancePayer 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateInsurancePayer(payerId: string, insurancePayer: InsurancePayer, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.updateInsurancePayer(payerId, insurancePayer, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Archive or unarchive an Insurance payer by its payer id
         * @summary Archive Insurance Payer
         * @param {string} payerId 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateInsurancePayerArchiveStatus(payerId: string, status: boolean, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.updateInsurancePayerArchiveStatus(payerId, status, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Activate or deactivate an Insurance payer by its payer id
         * @summary Update Insurance Payer Status
         * @param {string} payerId 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateInsurancePayerStatus(payerId: string, status: boolean, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.updateInsurancePayerStatus(payerId, status, xTENANTID, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * InsurancePayerControllerApi - object-oriented interface
 * @export
 * @class InsurancePayerControllerApi
 * @extends {BaseAPI}
 */
export class InsurancePayerControllerApi extends BaseAPI {
    /**
     * Add a new Insurance payer. New payers are active and not archived.
     * @summary Add Insurance Payer
     * @param {InsurancePayer} insurancePayer 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InsurancePayerControllerApi
     */
    public addInsurancePayer(insurancePayer: InsurancePayer, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return InsurancePayerControllerApiFp(this.configuration).addInsurancePayer(insurancePayer, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all Insurance payers list.
     * @summary Get all Insurance Payer.
     * @param {number} [page] 
     * @param {number} [size] 
     * @param {string} [sortBy] 
     * @param {string} [sortDirection] 
     * @param {string} [searchString] 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InsurancePayerControllerApi
     */
    public getAllInsurancePayer(page?: number, size?: number, sortBy?: string, sortDirection?: string, searchString?: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return InsurancePayerControllerApiFp(this.configuration).getAllInsurancePayer(page, size, sortBy, sortDirection, searchString, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Number of patients and open claims linked to an Insurance payer, shown before marking it inactive.
     * @summary Get Insurance Payer Usage
     * @param {string} payerId 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InsurancePayerControllerApi
     */
    public getInsurancePayerUsage(payerId: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return InsurancePayerControllerApiFp(this.configuration).getInsurancePayerUsage(payerId, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get Insurance payers list with search option on payer id and payer name and filter options on active, archive, payerType. Supports sorting by: payer_id, payer_name, payer_type, active.
     * @summary Get Insurance Payers by status.
     * @param {number} [page] 
     * @param {number} [size] 
     * @param {string} [sortBy] 
     * @param {string} [sortDirection] 
     * @param {string} [searchString] 
     * @param {boolean} [active] 
     * @param {boolean} [archive] 
     * @param {GetInsurancePayersByStatusPayerTypeEnum} [payerType] 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InsurancePayerControllerApi
     */
    public getInsurancePayersByStatus(page?: number, size?: number, sortBy?: string, sortDirection?: string, searchString?: string, active?: boolean, archive?: boolean, payerType?: GetInsurancePayersByStatusPayerTypeEnum, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return InsurancePayerControllerApiFp(this.configuration).getInsurancePayersByStatus(page, size, sortBy, sortDirection, searchString, active, archive, payerType, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update an Insurance payer by its current payer id.
     * @summary Update Insurance Payer
     * @param {string} payerId 
     * @param {InsurancePayer} insurancePayer 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InsurancePayerControllerApi
     */
    public updateInsurancePayer(payerId: string, insurancePayer: InsurancePayer, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return InsurancePayerControllerApiFp(this.configuration).updateInsurancePayer(payerId, insurancePayer, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Archive or unarchive an Insurance payer by its payer id
     * @summary Archive Insurance Payer
     * @param {string} payerId 
     * @param {boolean} status 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InsurancePayerControllerApi
     */
    public updateInsurancePayerArchiveStatus(payerId: string, status: boolean, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return InsurancePayerControllerApiFp(this.configuration).updateInsurancePayerArchiveStatus(payerId, status, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Activate or deactivate an Insurance payer by its payer id
     * @summary Update Insurance Payer Status
     * @param {string} payerId 
     * @param {boolean} status 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InsurancePayerControllerApi
     */
    public updateInsurancePayerStatus(payerId: string, status: boolean, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return InsurancePayerControllerApiFp(this.configuration).updateInsurancePayerStatus(payerId, status, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const GetInsurancePayersByStatusPayerTypeEnum = {
    Commercial: 'COMMERCIAL',
    Medicare: 'MEDICARE',
    Medicaid: 'MEDICAID',
    MedicaidManagedCare: 'MEDICAID_MANAGED_CARE',
    MedicareAdvantage: 'MEDICARE_ADVANTAGE',
    WorkersComp: 'WORKERS_COMP',
    AutoPip: 'AUTO_PIP',
    TricareVa: 'TRICARE_VA',
    SelfPay: 'SELF_PAY',
    Other: 'OTHER'
} as const;
export type GetInsurancePayersByStatusPayerTypeEnum = typeof GetInsurancePayersByStatusPayerTypeEnum[keyof typeof GetInsurancePayersByStatusPayerTypeEnum];


/**
 * InsurancePlanControllerApi - axios parameter creator
 * @export
 */
export const InsurancePlanControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Add a new patient insurance lan into the system
         * @summary Add Patient Insurance Plan 
         * @param {InsurancePlan} insurancePlan 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPatientInsurancePlan: async (insurancePlan: InsurancePlan, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'insurancePlan' is not null or undefined
            assertParamExists('createPatientInsurancePlan', 'insurancePlan', insurancePlan)
            const localVarPath = `/api/master/insurance-plan`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(insurancePlan, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all Patient Insurance list with search option on name, patientId and filter options on active, archive.
         * @summary Get all Patient Insurance Plan
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sort] 
         * @param {string} [payerId] 
         * @param {boolean} [status] 
         * @param {boolean} [archive] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatientInsurancePlan: async (page?: number, size?: number, sortBy?: string, sort?: string, payerId?: string, status?: boolean, archive?: boolean, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/master/insurance-plan`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (payerId !== undefined) {
                localVarQueryParameter['payerId'] = payerId;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (archive !== undefined) {
                localVarQueryParameter['archive'] = archive;
            }

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve a Patient Insurance plan by its unique ID
         * @summary Get Patient Insurance plan by ID
         * @param {string} patientInsurancePlanId 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatientInsurancePlanById: async (patientInsurancePlanId: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientInsurancePlanId' is not null or undefined
            assertParamExists('getPatientInsurancePlanById', 'patientInsurancePlanId', patientInsurancePlanId)
            const localVarPath = `/api/master/insurance-plan/{patientInsurancePlanId}`
                .replace(`{${"patientInsurancePlanId"}}`, encodeURIComponent(String(patientInsurancePlanId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * InsurancePlanControllerApi - functional programming interface
 * @export
 */
export const InsurancePlanControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = InsurancePlanControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * Add a new patient insurance lan into the system
         * @summary Add Patient Insurance Plan 
         * @param {InsurancePlan} insurancePlan 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createPatientInsurancePlan(insurancePlan: InsurancePlan, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createPatientInsurancePlan(insurancePlan, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InsurancePlanControllerApi.createPatientInsurancePlan']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get all Patient Insurance list with search option on name, patientId and filter options on active, archive.
         * @summary Get all Patient Insurance Plan
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sort] 
         * @param {string} [payerId] 
         * @param {boolean} [status] 
         * @param {boolean} [archive] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPatientInsurancePlan(page?: number, size?: number, sortBy?: string, sort?: string, payerId?: string, status?: boolean, archive?: boolean, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPatientInsurancePlan(page, size, sortBy, sort, payerId, status, archive, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InsurancePlanControllerApi.getPatientInsurancePlan']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve a Patient Insurance plan by its unique ID
         * @summary Get Patient Insurance plan by ID
         * @param {string} patientInsurancePlanId 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPatientInsurancePlanById(patientInsurancePlanId: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPatientInsurancePlanById(patientInsurancePlanId, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InsurancePlanControllerApi.getPatientInsurancePlanById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * InsurancePlanControllerApi - factory interface
 * @export
 */
export const InsurancePlanControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = InsurancePlanControllerApiFp(configuration)
    return {
        /**
         * Add a new patient insurance lan into the system
         * @summary Add Patient Insurance Plan 
         * @param {InsurancePlan} insurancePlan 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPatientInsurancePlan(insurancePlan: InsurancePlan, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.createPatientInsurancePlan(insurancePlan, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all Patient Insurance list with search option on name, patientId and filter options on active, archive.
         * @summary Get all Patient Insurance Plan
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sort] 
         * @param {string} [payerId] 
         * @param {boolean} [status] 
         * @param {boolean} [archive] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatientInsurancePlan(page?: number, size?: number, sortBy?: string, sort?: string, payerId?: string, status?: boolean, archive?: boolean, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getPatientInsurancePlan(page, size, sortBy, sort, payerId, status, archive, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve a Patient Insurance plan by its unique ID
         * @summary Get Patient Insurance plan by ID
         * @param {string} patientInsurancePlanId 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatientInsurancePlanById(patientInsurancePlanId: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getPatientInsurancePlanById(patientInsurancePlanId, xTENANTID, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * InsurancePlanControllerApi - object-oriented interface
 * @export
 * @class InsurancePlanControllerApi
 * @extends {BaseAPI}
 */
export class InsurancePlanControllerApi extends BaseAPI {
    /**
     * Add a new patient insurance lan into the system
     * @summary Add Patient Insurance Plan 
     * @param {InsurancePlan} insurancePlan 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InsurancePlanControllerApi
     */
    public createPatientInsurancePlan(insurancePlan: InsurancePlan, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return InsurancePlanControllerApiFp(this.configuration).createPatientInsurancePlan(insurancePlan, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all Patient Insurance list with search option on name, patientId and filter options on active, archive.
     * @summary Get all Patient Insurance Plan
     * @param {number} [page] 
     * @param {number} [size] 
     * @param {string} [sortBy] 
     * @param {string} [sort] 
     * @param {string} [payerId] 
     * @param {boolean} [status] 
     * @param {boolean} [archive] 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InsurancePlanControllerApi
     */
    public getPatientInsurancePlan(page?: number, size?: number, sortBy?: string, sort?: string, payerId?: string, status?: boolean, archive?: boolean, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return InsurancePlanControllerApiFp(this.configuration).getPatientInsurancePlan(page, size, sortBy, sort, payerId, status, archive, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve a Patient Insurance plan by its unique ID
     * @summary Get Patient Insurance plan by ID
     * @param {string} patientInsurancePlanId 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InsurancePlanControllerApi
     */
    public getPatientInsurancePlanById(patientInsurancePlanId: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return InsurancePlanControllerApiFp(this.configuration).getPatientInsurancePlanById(patientInsurancePlanId, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * IntakeFormControllerApi - axios parameter creator
 * @export
 */
export const IntakeFormControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Create a intake form of appointment.
         * @summary Create Intake Form
         * @param {IntakeForm} intakeForm 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createIntakeForm1: async (intakeForm: IntakeForm, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'intakeForm' is not null or undefined
            assertParamExists('createIntakeForm1', 'intakeForm', intakeForm)
            const localVarPath = `/api/master/intake-form`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(intakeForm, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all intake form
         * @summary Get all intake form.
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [appointmentUuid] 
         * @param {string} [patientUuid] 
         * @param {string} [sortDirection] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllIntakeForm: async (page?: number, size?: number, sortBy?: string, appointmentUuid?: string, patientUuid?: string, sortDirection?: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/master/intake-form`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (appointmentUuid !== undefined) {
                localVarQueryParameter['appointmentUuid'] = appointmentUuid;
            }

            if (patientUuid !== undefined) {
                localVarQueryParameter['patientUuid'] = patientUuid;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Gat intake form by UUID.
         * @summary Get intake form by ID
         * @param {string} intakeFormId 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIntakeFormById: async (intakeFormId: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'intakeFormId' is not null or undefined
            assertParamExists('getIntakeFormById', 'intakeFormId', intakeFormId)
            const localVarPath = `/api/master/intake-form/{intakeFormId}`
                .replace(`{${"intakeFormId"}}`, encodeURIComponent(String(intakeFormId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * update the intake form
         * @summary update intake form
         * @param {IntakeForm} intakeForm 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update: async (intakeForm: IntakeForm, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'intakeForm' is not null or undefined
            assertParamExists('update', 'intakeForm', intakeForm)
            const localVarPath = `/api/master/intake-form`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(intakeForm, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * IntakeFormControllerApi - functional programming interface
 * @export
 */
export const IntakeFormControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = IntakeFormControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * Create a intake form of appointment.
         * @summary Create Intake Form
         * @param {IntakeForm} intakeForm 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createIntakeForm1(intakeForm: IntakeForm, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createIntakeForm1(intakeForm, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['IntakeFormControllerApi.createIntakeForm1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get all intake form
         * @summary Get all intake form.
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [appointmentUuid] 
         * @param {string} [patientUuid] 
         * @param {string} [sortDirection] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllIntakeForm(page?: number, size?: number, sortBy?: string, appointmentUuid?: string, patientUuid?: string, sortDirection?: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllIntakeForm(page, size, sortBy, appointmentUuid, patientUuid, sortDirection, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['IntakeFormControllerApi.getAllIntakeForm']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Gat intake form by UUID.
         * @summary Get intake form by ID
         * @param {string} intakeFormId 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getIntakeFormById(intakeFormId: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getIntakeFormById(intakeFormId, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['IntakeFormControllerApi.getIntakeFormById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * update the intake form
         * @summary update intake form
         * @param {IntakeForm} intakeForm 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async update(intakeForm: IntakeForm, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.update(intakeForm, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['IntakeFormControllerApi.update']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * IntakeFormControllerApi - factory interface
 * @export
 */
export const IntakeFormControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = IntakeFormControllerApiFp(configuration)
    return {
        /**
         * Create a intake form of appointment.
         * @summary Create Intake Form
         * @param {IntakeForm} intakeForm 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createIntakeForm1(intakeForm: IntakeForm, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.createIntakeForm1(intakeForm, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all intake form
         * @summary Get all intake form.
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [appointmentUuid] 
         * @param {string} [patientUuid] 
         * @param {string} [sortDirection] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllIntakeForm(page?: number, size?: number, sortBy?: string, appointmentUuid?: string, patientUuid?: string, sortDirection?: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getAllIntakeForm(page, size, sortBy, appointmentUuid, patientUuid, sortDirection, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Gat intake form by UUID.
         * @summary Get intake form by ID
         * @param {string} intakeFormId 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIntakeFormById(intakeFormId: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getIntakeFormById(intakeFormId, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * update the intake form
         * @summary update intake form
         * @param {IntakeForm} intakeForm 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update(intakeForm: IntakeForm, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.update(intakeForm, xTENANTID, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * IntakeFormControllerApi - object-oriented interface
 * @export
 * @class IntakeFormControllerApi
 * @extends {BaseAPI}
 */
export class IntakeFormControllerApi extends BaseAPI {
    /**
     * Create a intake form of appointment.
     * @summary Create Intake Form
     * @param {IntakeForm} intakeForm 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntakeFormControllerApi
     */
    public createIntakeForm1(intakeForm: IntakeForm, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return IntakeFormControllerApiFp(this.configuration).createIntakeForm1(intakeForm, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all intake form
     * @summary Get all intake form.
     * @param {number} [page] 
     * @param {number} [size] 
     * @param {string} [sortBy] 
     * @param {string} [appointmentUuid] 
     * @param {string} [patientUuid] 
     * @param {string} [sortDirection] 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntakeFormControllerApi
     */
    public getAllIntakeForm(page?: number, size?: number, sortBy?: string, appointmentUuid?: string, patientUuid?: string, sortDirection?: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return IntakeFormControllerApiFp(this.configuration).getAllIntakeForm(page, size, sortBy, appointmentUuid, patientUuid, sortDirection, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Gat intake form by UUID.
     * @summary Get intake form by ID
     * @param {string} intakeFormId 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntakeFormControllerApi
     */
    public getIntakeFormById(intakeFormId: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return IntakeFormControllerApiFp(this.configuration).getIntakeFormById(intakeFormId, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * update the intake form
     * @summary update intake form
     * @param {IntakeForm} intakeForm 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntakeFormControllerApi
     */
    public update(intakeForm: IntakeForm, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return IntakeFormControllerApiFp(this.configuration).update(intakeForm, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * LanguagesControllerApi - axios parameter creator
 * @export
 */
export const LanguagesControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get all Languages list with pagination and sorting.
         * @summary Get all Languages.
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllLanguages: async (page?: number, size?: number, sortBy?: string, sortDirection?: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/master/languages`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LanguagesControllerApi - functional programming interface
 * @export
 */
export const LanguagesControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = LanguagesControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * Get all Languages list with pagination and sorting.
         * @summary Get all Languages.
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllLanguages(page?: number, size?: number, sortBy?: string, sortDirection?: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllLanguages(page, size, sortBy, sortDirection, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LanguagesControllerApi.getAllLanguages']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * LanguagesControllerApi - factory interface
 * @export
 */
export const LanguagesControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = LanguagesControllerApiFp(configuration)
    return {
        /**
         * Get all Languages list with pagination and sorting.
         * @summary Get all Languages.
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllLanguages(page?: number, size?: number, sortBy?: string, sortDirection?: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getAllLanguages(page, size, sortBy, sortDirection, xTENANTID, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * LanguagesControllerApi - object-oriented interface
 * @export
 * @class LanguagesControllerApi
 * @extends {BaseAPI}
 */
export class LanguagesControllerApi extends BaseAPI {
    /**
     * Get all Languages list with pagination and sorting.
     * @summary Get all Languages.
     * @param {number} [page] 
     * @param {number} [size] 
     * @param {string} [sortBy] 
     * @param {string} [sortDirection] 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LanguagesControllerApi
     */
    public getAllLanguages(page?: number, size?: number, sortBy?: string, sortDirection?: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return LanguagesControllerApiFp(this.configuration).getAllLanguages(page, size, sortBy, sortDirection, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * LedgerControllerApi - axios parameter creator
 * @export
 */
export const LedgerControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Paginated ledger rows with optional patient, status, date-range (date of service) and provider/payer search filters.
         * @summary Get Ledger
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {string} [patientId] 
         * @param {string} [status] 
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {string} [searchString] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLedgers: async (page?: number, size?: number, sortBy?: string, sortDirection?: string, patientId?: string, status?: string, startDate?: string, endDate?: string, searchString?: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/master/ledger`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }

            if (patientId !== undefined) {
                localVarQueryParameter['patientId'] = patientId;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString() :
                    startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString() :
                    endDate;
            }

            if (searchString !== undefined) {
                localVarQueryParameter['searchString'] = searchString;
            }

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LedgerControllerApi - functional programming interface
 * @export
 */
export const LedgerControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = LedgerControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * Paginated ledger rows with optional patient, status, date-range (date of service) and provider/payer search filters.
         * @summary Get Ledger
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {string} [patientId] 
         * @param {string} [status] 
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {string} [searchString] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLedgers(page?: number, size?: number, sortBy?: string, sortDirection?: string, patientId?: string, status?: string, startDate?: string, endDate?: string, searchString?: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLedgers(page, size, sortBy, sortDirection, patientId, status, startDate, endDate, searchString, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LedgerControllerApi.getLedgers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * LedgerControllerApi - factory interface
 * @export
 */
export const LedgerControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = LedgerControllerApiFp(configuration)
    return {
        /**
         * Paginated ledger rows with optional patient, status, date-range (date of service) and provider/payer search filters.
         * @summary Get Ledger
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {string} [patientId] 
         * @param {string} [status] 
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {string} [searchString] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLedgers(page?: number, size?: number, sortBy?: string, sortDirection?: string, patientId?: string, status?: string, startDate?: string, endDate?: string, searchString?: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getLedgers(page, size, sortBy, sortDirection, patientId, status, startDate, endDate, searchString, xTENANTID, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * LedgerControllerApi - object-oriented interface
 * @export
 * @class LedgerControllerApi
 * @extends {BaseAPI}
 */
export class LedgerControllerApi extends BaseAPI {
    /**
     * Paginated ledger rows with optional patient, status, date-range (date of service) and provider/payer search filters.
     * @summary Get Ledger
     * @param {number} [page] 
     * @param {number} [size] 
     * @param {string} [sortBy] 
     * @param {string} [sortDirection] 
     * @param {string} [patientId] 
     * @param {string} [status] 
     * @param {string} [startDate] 
     * @param {string} [endDate] 
     * @param {string} [searchString] 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LedgerControllerApi
     */
    public getLedgers(page?: number, size?: number, sortBy?: string, sortDirection?: string, patientId?: string, status?: string, startDate?: string, endDate?: string, searchString?: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return LedgerControllerApiFp(this.configuration).getLedgers(page, size, sortBy, sortDirection, patientId, status, startDate, endDate, searchString, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * LocationControllerApi - axios parameter creator
 * @export
 */
export const LocationControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Change location avatar
         * @summary Change Avatar
         * @param {string} locationUuid 
         * @param {ChangeAvatarRequest} changeAvatarRequest 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeAvatar3: async (locationUuid: string, changeAvatarRequest: ChangeAvatarRequest, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'locationUuid' is not null or undefined
            assertParamExists('changeAvatar3', 'locationUuid', locationUuid)
            // verify required parameter 'changeAvatarRequest' is not null or undefined
            assertParamExists('changeAvatar3', 'changeAvatarRequest', changeAvatarRequest)
            const localVarPath = `/api/master/location/change-location-avatar/{locationUuid}`
                .replace(`{${"locationUuid"}}`, encodeURIComponent(String(locationUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(changeAvatarRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Add a new Location into the system.
         * @summary Add Location
         * @param {Location} location 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createLocation: async (location: Location, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'location' is not null or undefined
            assertParamExists('createLocation', 'location', location)
            const localVarPath = `/api/master/location`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(location, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all Locations list for super admin with search option on name, locationId and filter options on active, archive and physical addresses state.
         * @summary Get all Locations.
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {boolean} [status] 
         * @param {boolean} [archive] 
         * @param {string} [state] 
         * @param {string} [searchString] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllLocations: async (page?: number, size?: number, sortBy?: string, sortDirection?: string, status?: boolean, archive?: boolean, state?: string, searchString?: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/master/location`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (archive !== undefined) {
                localVarQueryParameter['archive'] = archive;
            }

            if (state !== undefined) {
                localVarQueryParameter['state'] = state;
            }

            if (searchString !== undefined) {
                localVarQueryParameter['searchString'] = searchString;
            }

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get list of locations with optional search string
         * @summary Get list of locations
         * @param {string} [searchString] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLocation: async (searchString?: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/master/location/v2/get-location`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (searchString !== undefined) {
                localVarQueryParameter['searchString'] = searchString;
            }

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get Location by locationUuid.
         * @summary Get Location by locationUuid.
         * @param {string} locationId 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLocationById: async (locationId: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'locationId' is not null or undefined
            assertParamExists('getLocationById', 'locationId', locationId)
            const localVarPath = `/api/master/location/{locationId}`
                .replace(`{${"locationId"}}`, encodeURIComponent(String(locationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Public list of active locations (uuid and name) for the website widget location filter.
         * @summary Get active locations for the website widget
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWidgetLocations: async (xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/master/location/widget-locations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Edit Location with editable fields as 
         * @summary Update Location
         * @param {Location} location 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateLocation: async (location: Location, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'location' is not null or undefined
            assertParamExists('updateLocation', 'location', location)
            const localVarPath = `/api/master/location`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(location, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Change Location  archive status to either archived or unarchived.
         * @summary Archive/Unarchive Location
         * @param {string} locationId 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateLocationArchiveStatus: async (locationId: string, status: boolean, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'locationId' is not null or undefined
            assertParamExists('updateLocationArchiveStatus', 'locationId', locationId)
            // verify required parameter 'status' is not null or undefined
            assertParamExists('updateLocationArchiveStatus', 'status', status)
            const localVarPath = `/api/master/location/{locationId}/{status}`
                .replace(`{${"locationId"}}`, encodeURIComponent(String(locationId)))
                .replace(`{${"status"}}`, encodeURIComponent(String(status)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Change Location status to either active or inactive.
         * @summary Enable/Disable Location
         * @param {string} locationId 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateLocationStatus: async (locationId: string, status: boolean, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'locationId' is not null or undefined
            assertParamExists('updateLocationStatus', 'locationId', locationId)
            // verify required parameter 'status' is not null or undefined
            assertParamExists('updateLocationStatus', 'status', status)
            const localVarPath = `/api/master/location/{locationId}/active/{status}`
                .replace(`{${"locationId"}}`, encodeURIComponent(String(locationId)))
                .replace(`{${"status"}}`, encodeURIComponent(String(status)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LocationControllerApi - functional programming interface
 * @export
 */
export const LocationControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = LocationControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * Change location avatar
         * @summary Change Avatar
         * @param {string} locationUuid 
         * @param {ChangeAvatarRequest} changeAvatarRequest 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async changeAvatar3(locationUuid: string, changeAvatarRequest: ChangeAvatarRequest, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.changeAvatar3(locationUuid, changeAvatarRequest, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LocationControllerApi.changeAvatar3']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Add a new Location into the system.
         * @summary Add Location
         * @param {Location} location 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createLocation(location: Location, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createLocation(location, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LocationControllerApi.createLocation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get all Locations list for super admin with search option on name, locationId and filter options on active, archive and physical addresses state.
         * @summary Get all Locations.
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {boolean} [status] 
         * @param {boolean} [archive] 
         * @param {string} [state] 
         * @param {string} [searchString] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllLocations(page?: number, size?: number, sortBy?: string, sortDirection?: string, status?: boolean, archive?: boolean, state?: string, searchString?: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllLocations(page, size, sortBy, sortDirection, status, archive, state, searchString, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LocationControllerApi.getAllLocations']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get list of locations with optional search string
         * @summary Get list of locations
         * @param {string} [searchString] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLocation(searchString?: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLocation(searchString, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LocationControllerApi.getLocation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get Location by locationUuid.
         * @summary Get Location by locationUuid.
         * @param {string} locationId 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLocationById(locationId: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLocationById(locationId, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LocationControllerApi.getLocationById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Public list of active locations (uuid and name) for the website widget location filter.
         * @summary Get active locations for the website widget
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWidgetLocations(xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWidgetLocations(xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LocationControllerApi.getWidgetLocations']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Edit Location with editable fields as 
         * @summary Update Location
         * @param {Location} location 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateLocation(location: Location, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateLocation(location, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LocationControllerApi.updateLocation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Change Location  archive status to either archived or unarchived.
         * @summary Archive/Unarchive Location
         * @param {string} locationId 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateLocationArchiveStatus(locationId: string, status: boolean, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateLocationArchiveStatus(locationId, status, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LocationControllerApi.updateLocationArchiveStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Change Location status to either active or inactive.
         * @summary Enable/Disable Location
         * @param {string} locationId 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateLocationStatus(locationId: string, status: boolean, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateLocationStatus(locationId, status, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LocationControllerApi.updateLocationStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * LocationControllerApi - factory interface
 * @export
 */
export const LocationControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = LocationControllerApiFp(configuration)
    return {
        /**
         * Change location avatar
         * @summary Change Avatar
         * @param {string} locationUuid 
         * @param {ChangeAvatarRequest} changeAvatarRequest 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeAvatar3(locationUuid: string, changeAvatarRequest: ChangeAvatarRequest, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.changeAvatar3(locationUuid, changeAvatarRequest, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Add a new Location into the system.
         * @summary Add Location
         * @param {Location} location 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createLocation(location: Location, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.createLocation(location, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all Locations list for super admin with search option on name, locationId and filter options on active, archive and physical addresses state.
         * @summary Get all Locations.
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {boolean} [status] 
         * @param {boolean} [archive] 
         * @param {string} [state] 
         * @param {string} [searchString] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllLocations(page?: number, size?: number, sortBy?: string, sortDirection?: string, status?: boolean, archive?: boolean, state?: string, searchString?: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getAllLocations(page, size, sortBy, sortDirection, status, archive, state, searchString, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Get list of locations with optional search string
         * @summary Get list of locations
         * @param {string} [searchString] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLocation(searchString?: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getLocation(searchString, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Get Location by locationUuid.
         * @summary Get Location by locationUuid.
         * @param {string} locationId 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLocationById(locationId: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getLocationById(locationId, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Public list of active locations (uuid and name) for the website widget location filter.
         * @summary Get active locations for the website widget
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWidgetLocations(xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getWidgetLocations(xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Edit Location with editable fields as 
         * @summary Update Location
         * @param {Location} location 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateLocation(location: Location, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.updateLocation(location, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Change Location  archive status to either archived or unarchived.
         * @summary Archive/Unarchive Location
         * @param {string} locationId 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateLocationArchiveStatus(locationId: string, status: boolean, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.updateLocationArchiveStatus(locationId, status, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Change Location status to either active or inactive.
         * @summary Enable/Disable Location
         * @param {string} locationId 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateLocationStatus(locationId: string, status: boolean, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.updateLocationStatus(locationId, status, xTENANTID, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * LocationControllerApi - object-oriented interface
 * @export
 * @class LocationControllerApi
 * @extends {BaseAPI}
 */
export class LocationControllerApi extends BaseAPI {
    /**
     * Change location avatar
     * @summary Change Avatar
     * @param {string} locationUuid 
     * @param {ChangeAvatarRequest} changeAvatarRequest 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationControllerApi
     */
    public changeAvatar3(locationUuid: string, changeAvatarRequest: ChangeAvatarRequest, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return LocationControllerApiFp(this.configuration).changeAvatar3(locationUuid, changeAvatarRequest, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Add a new Location into the system.
     * @summary Add Location
     * @param {Location} location 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationControllerApi
     */
    public createLocation(location: Location, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return LocationControllerApiFp(this.configuration).createLocation(location, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all Locations list for super admin with search option on name, locationId and filter options on active, archive and physical addresses state.
     * @summary Get all Locations.
     * @param {number} [page] 
     * @param {number} [size] 
     * @param {string} [sortBy] 
     * @param {string} [sortDirection] 
     * @param {boolean} [status] 
     * @param {boolean} [archive] 
     * @param {string} [state] 
     * @param {string} [searchString] 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationControllerApi
     */
    public getAllLocations(page?: number, size?: number, sortBy?: string, sortDirection?: string, status?: boolean, archive?: boolean, state?: string, searchString?: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return LocationControllerApiFp(this.configuration).getAllLocations(page, size, sortBy, sortDirection, status, archive, state, searchString, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get list of locations with optional search string
     * @summary Get list of locations
     * @param {string} [searchString] 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationControllerApi
     */
    public getLocation(searchString?: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return LocationControllerApiFp(this.configuration).getLocation(searchString, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get Location by locationUuid.
     * @summary Get Location by locationUuid.
     * @param {string} locationId 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationControllerApi
     */
    public getLocationById(locationId: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return LocationControllerApiFp(this.configuration).getLocationById(locationId, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Public list of active locations (uuid and name) for the website widget location filter.
     * @summary Get active locations for the website widget
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationControllerApi
     */
    public getWidgetLocations(xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return LocationControllerApiFp(this.configuration).getWidgetLocations(xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Edit Location with editable fields as 
     * @summary Update Location
     * @param {Location} location 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationControllerApi
     */
    public updateLocation(location: Location, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return LocationControllerApiFp(this.configuration).updateLocation(location, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Change Location  archive status to either archived or unarchived.
     * @summary Archive/Unarchive Location
     * @param {string} locationId 
     * @param {boolean} status 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationControllerApi
     */
    public updateLocationArchiveStatus(locationId: string, status: boolean, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return LocationControllerApiFp(this.configuration).updateLocationArchiveStatus(locationId, status, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Change Location status to either active or inactive.
     * @summary Enable/Disable Location
     * @param {string} locationId 
     * @param {boolean} status 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationControllerApi
     */
    public updateLocationStatus(locationId: string, status: boolean, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return LocationControllerApiFp(this.configuration).updateLocationStatus(locationId, status, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * MacrosTemplateControllerApi - axios parameter creator
 * @export
 */
export const MacrosTemplateControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * create macros template into the system
         * @summary create macros template
         * @param {MacrosTemplate} macrosTemplate 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMacrosTemplate: async (macrosTemplate: MacrosTemplate, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'macrosTemplate' is not null or undefined
            assertParamExists('createMacrosTemplate', 'macrosTemplate', macrosTemplate)
            const localVarPath = `/api/master/macros-template`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(macrosTemplate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * get all macros template from the system
         * @summary get all macros template
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {boolean} [active] 
         * @param {boolean} [archive] 
         * @param {string} [searchString] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllMacrosTemplate: async (page?: number, size?: number, sortBy?: string, sortDirection?: string, active?: boolean, archive?: boolean, searchString?: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/master/macros-template`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }

            if (active !== undefined) {
                localVarQueryParameter['active'] = active;
            }

            if (archive !== undefined) {
                localVarQueryParameter['archive'] = archive;
            }

            if (searchString !== undefined) {
                localVarQueryParameter['searchString'] = searchString;
            }

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * get all macros template from the system
         * @summary get all macros template
         * @param {string} macrosTemplateId 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMacrosTemplateByUuid: async (macrosTemplateId: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'macrosTemplateId' is not null or undefined
            assertParamExists('getMacrosTemplateByUuid', 'macrosTemplateId', macrosTemplateId)
            const localVarPath = `/api/master/macros-template/{macrosTemplateId}`
                .replace(`{${"macrosTemplateId"}}`, encodeURIComponent(String(macrosTemplateId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * update macros template into the system
         * @summary update macros template
         * @param {MacrosTemplate} macrosTemplate 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCustomForm: async (macrosTemplate: MacrosTemplate, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'macrosTemplate' is not null or undefined
            assertParamExists('updateCustomForm', 'macrosTemplate', macrosTemplate)
            const localVarPath = `/api/master/macros-template`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(macrosTemplate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * update macros template archive status from system
         * @summary update macros template archive status
         * @param {string} macrosTemplateId 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMacrosTemplateArchiveStatus: async (macrosTemplateId: string, status: boolean, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'macrosTemplateId' is not null or undefined
            assertParamExists('updateMacrosTemplateArchiveStatus', 'macrosTemplateId', macrosTemplateId)
            // verify required parameter 'status' is not null or undefined
            assertParamExists('updateMacrosTemplateArchiveStatus', 'status', status)
            const localVarPath = `/api/master/macros-template/{macrosTemplateId}/archive-status/{status}`
                .replace(`{${"macrosTemplateId"}}`, encodeURIComponent(String(macrosTemplateId)))
                .replace(`{${"status"}}`, encodeURIComponent(String(status)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MacrosTemplateControllerApi - functional programming interface
 * @export
 */
export const MacrosTemplateControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MacrosTemplateControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * create macros template into the system
         * @summary create macros template
         * @param {MacrosTemplate} macrosTemplate 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createMacrosTemplate(macrosTemplate: MacrosTemplate, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createMacrosTemplate(macrosTemplate, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MacrosTemplateControllerApi.createMacrosTemplate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * get all macros template from the system
         * @summary get all macros template
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {boolean} [active] 
         * @param {boolean} [archive] 
         * @param {string} [searchString] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllMacrosTemplate(page?: number, size?: number, sortBy?: string, sortDirection?: string, active?: boolean, archive?: boolean, searchString?: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllMacrosTemplate(page, size, sortBy, sortDirection, active, archive, searchString, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MacrosTemplateControllerApi.getAllMacrosTemplate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * get all macros template from the system
         * @summary get all macros template
         * @param {string} macrosTemplateId 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMacrosTemplateByUuid(macrosTemplateId: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMacrosTemplateByUuid(macrosTemplateId, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MacrosTemplateControllerApi.getMacrosTemplateByUuid']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * update macros template into the system
         * @summary update macros template
         * @param {MacrosTemplate} macrosTemplate 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCustomForm(macrosTemplate: MacrosTemplate, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateCustomForm(macrosTemplate, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MacrosTemplateControllerApi.updateCustomForm']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * update macros template archive status from system
         * @summary update macros template archive status
         * @param {string} macrosTemplateId 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateMacrosTemplateArchiveStatus(macrosTemplateId: string, status: boolean, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateMacrosTemplateArchiveStatus(macrosTemplateId, status, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MacrosTemplateControllerApi.updateMacrosTemplateArchiveStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * MacrosTemplateControllerApi - factory interface
 * @export
 */
export const MacrosTemplateControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MacrosTemplateControllerApiFp(configuration)
    return {
        /**
         * create macros template into the system
         * @summary create macros template
         * @param {MacrosTemplate} macrosTemplate 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMacrosTemplate(macrosTemplate: MacrosTemplate, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.createMacrosTemplate(macrosTemplate, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * get all macros template from the system
         * @summary get all macros template
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {boolean} [active] 
         * @param {boolean} [archive] 
         * @param {string} [searchString] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllMacrosTemplate(page?: number, size?: number, sortBy?: string, sortDirection?: string, active?: boolean, archive?: boolean, searchString?: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getAllMacrosTemplate(page, size, sortBy, sortDirection, active, archive, searchString, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * get all macros template from the system
         * @summary get all macros template
         * @param {string} macrosTemplateId 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMacrosTemplateByUuid(macrosTemplateId: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getMacrosTemplateByUuid(macrosTemplateId, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * update macros template into the system
         * @summary update macros template
         * @param {MacrosTemplate} macrosTemplate 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCustomForm(macrosTemplate: MacrosTemplate, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.updateCustomForm(macrosTemplate, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * update macros template archive status from system
         * @summary update macros template archive status
         * @param {string} macrosTemplateId 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMacrosTemplateArchiveStatus(macrosTemplateId: string, status: boolean, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.updateMacrosTemplateArchiveStatus(macrosTemplateId, status, xTENANTID, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MacrosTemplateControllerApi - object-oriented interface
 * @export
 * @class MacrosTemplateControllerApi
 * @extends {BaseAPI}
 */
export class MacrosTemplateControllerApi extends BaseAPI {
    /**
     * create macros template into the system
     * @summary create macros template
     * @param {MacrosTemplate} macrosTemplate 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MacrosTemplateControllerApi
     */
    public createMacrosTemplate(macrosTemplate: MacrosTemplate, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return MacrosTemplateControllerApiFp(this.configuration).createMacrosTemplate(macrosTemplate, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * get all macros template from the system
     * @summary get all macros template
     * @param {number} [page] 
     * @param {number} [size] 
     * @param {string} [sortBy] 
     * @param {string} [sortDirection] 
     * @param {boolean} [active] 
     * @param {boolean} [archive] 
     * @param {string} [searchString] 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MacrosTemplateControllerApi
     */
    public getAllMacrosTemplate(page?: number, size?: number, sortBy?: string, sortDirection?: string, active?: boolean, archive?: boolean, searchString?: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return MacrosTemplateControllerApiFp(this.configuration).getAllMacrosTemplate(page, size, sortBy, sortDirection, active, archive, searchString, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * get all macros template from the system
     * @summary get all macros template
     * @param {string} macrosTemplateId 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MacrosTemplateControllerApi
     */
    public getMacrosTemplateByUuid(macrosTemplateId: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return MacrosTemplateControllerApiFp(this.configuration).getMacrosTemplateByUuid(macrosTemplateId, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * update macros template into the system
     * @summary update macros template
     * @param {MacrosTemplate} macrosTemplate 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MacrosTemplateControllerApi
     */
    public updateCustomForm(macrosTemplate: MacrosTemplate, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return MacrosTemplateControllerApiFp(this.configuration).updateCustomForm(macrosTemplate, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * update macros template archive status from system
     * @summary update macros template archive status
     * @param {string} macrosTemplateId 
     * @param {boolean} status 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MacrosTemplateControllerApi
     */
    public updateMacrosTemplateArchiveStatus(macrosTemplateId: string, status: boolean, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return MacrosTemplateControllerApiFp(this.configuration).updateMacrosTemplateArchiveStatus(macrosTemplateId, status, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * MedicalCodeControllerApi - axios parameter creator
 * @export
 */
export const MedicalCodeControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Add a new MedicalCode into the system
         * @summary Add MedicalCode
         * @param {MedicalCode} medicalCode 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMedicalCode: async (medicalCode: MedicalCode, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'medicalCode' is not null or undefined
            assertParamExists('createMedicalCode', 'medicalCode', medicalCode)
            const localVarPath = `/api/master/medical-codes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(medicalCode, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Export medical codes by type as CSV format (max 500 records)
         * @summary Export Medical Codes as CSV
         * @param {ExportMedicalCodesAsCsvTypeEnum} type 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportMedicalCodesAsCsv: async (type: ExportMedicalCodesAsCsvTypeEnum, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'type' is not null or undefined
            assertParamExists('exportMedicalCodesAsCsv', 'type', type)
            const localVarPath = `/api/master/medical-codes/export-csv`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all CPT/HCPCS MedicalCodes list for super admin with search option on name, deptId and filter options on active, archive.
         * @summary Get CPT/HCPCS MedicalCode.
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sort] 
         * @param {boolean} [active] 
         * @param {boolean} [archive] 
         * @param {string} [source] 
         * @param {string} [searchString] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCptHcpcsMedicalCodes: async (page?: number, size?: number, sortBy?: string, sort?: string, active?: boolean, archive?: boolean, source?: string, searchString?: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/master/medical-codes/cpt-hcpcs-code`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (active !== undefined) {
                localVarQueryParameter['active'] = active;
            }

            if (archive !== undefined) {
                localVarQueryParameter['archive'] = archive;
            }

            if (source !== undefined) {
                localVarQueryParameter['source'] = source;
            }

            if (searchString !== undefined) {
                localVarQueryParameter['searchString'] = searchString;
            }

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve a MedicalCode by its unique ID
         * @summary Get MedicalCode by ID
         * @param {string} medicalCodeId 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMedicalCodeById: async (medicalCodeId: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'medicalCodeId' is not null or undefined
            assertParamExists('getMedicalCodeById', 'medicalCodeId', medicalCodeId)
            const localVarPath = `/api/master/medical-codes/{medicalCodeId}`
                .replace(`{${"medicalCodeId"}}`, encodeURIComponent(String(medicalCodeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all MedicalCodes list for super admin with search option on name, deptId and filter options on active, archive.
         * @summary Get all MedicalCode.
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sort] 
         * @param {GetMedicalCodesTypeEnum} [type] 
         * @param {boolean} [active] 
         * @param {boolean} [archive] 
         * @param {string} [source] 
         * @param {string} [searchString] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMedicalCodes: async (page?: number, size?: number, sortBy?: string, sort?: string, type?: GetMedicalCodesTypeEnum, active?: boolean, archive?: boolean, source?: string, searchString?: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/master/medical-codes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }

            if (active !== undefined) {
                localVarQueryParameter['active'] = active;
            }

            if (archive !== undefined) {
                localVarQueryParameter['archive'] = archive;
            }

            if (source !== undefined) {
                localVarQueryParameter['source'] = source;
            }

            if (searchString !== undefined) {
                localVarQueryParameter['searchString'] = searchString;
            }

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Import initial medical code by type (e.g., ICD, HCPCS)
         * @summary Import initial medical code
         * @param {ImportInitialDataTypeEnum} type 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importInitialData: async (type: ImportInitialDataTypeEnum, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'type' is not null or undefined
            assertParamExists('importInitialData', 'type', type)
            const localVarPath = `/api/master/medical-codes/import-initial-data`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update an existing MedicalCode
         * @summary Update MedicalCode
         * @param {MedicalCode} medicalCode 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMedicalCode: async (medicalCode: MedicalCode, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'medicalCode' is not null or undefined
            assertParamExists('updateMedicalCode', 'medicalCode', medicalCode)
            const localVarPath = `/api/master/medical-codes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(medicalCode, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Archive a MedicalCode by its ID
         * @summary Archive MedicalCode
         * @param {string} medicalCodeId 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMedicalCodeArchiveStatus: async (medicalCodeId: string, status: boolean, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'medicalCodeId' is not null or undefined
            assertParamExists('updateMedicalCodeArchiveStatus', 'medicalCodeId', medicalCodeId)
            // verify required parameter 'status' is not null or undefined
            assertParamExists('updateMedicalCodeArchiveStatus', 'status', status)
            const localVarPath = `/api/master/medical-codes/{medicalCodeId}/archive-status/{status}`
                .replace(`{${"medicalCodeId"}}`, encodeURIComponent(String(medicalCodeId)))
                .replace(`{${"status"}}`, encodeURIComponent(String(status)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update the status of a MedicalCode by its ID
         * @summary Update MedicalCode Status
         * @param {string} medicalCodeId 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMedicalCodeStatus: async (medicalCodeId: string, status: boolean, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'medicalCodeId' is not null or undefined
            assertParamExists('updateMedicalCodeStatus', 'medicalCodeId', medicalCodeId)
            // verify required parameter 'status' is not null or undefined
            assertParamExists('updateMedicalCodeStatus', 'status', status)
            const localVarPath = `/api/master/medical-codes/{medicalCodeId}/status/{status}`
                .replace(`{${"medicalCodeId"}}`, encodeURIComponent(String(medicalCodeId)))
                .replace(`{${"status"}}`, encodeURIComponent(String(status)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MedicalCodeControllerApi - functional programming interface
 * @export
 */
export const MedicalCodeControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MedicalCodeControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * Add a new MedicalCode into the system
         * @summary Add MedicalCode
         * @param {MedicalCode} medicalCode 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createMedicalCode(medicalCode: MedicalCode, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createMedicalCode(medicalCode, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MedicalCodeControllerApi.createMedicalCode']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Export medical codes by type as CSV format (max 500 records)
         * @summary Export Medical Codes as CSV
         * @param {ExportMedicalCodesAsCsvTypeEnum} type 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exportMedicalCodesAsCsv(type: ExportMedicalCodesAsCsvTypeEnum, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.exportMedicalCodesAsCsv(type, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MedicalCodeControllerApi.exportMedicalCodesAsCsv']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get all CPT/HCPCS MedicalCodes list for super admin with search option on name, deptId and filter options on active, archive.
         * @summary Get CPT/HCPCS MedicalCode.
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sort] 
         * @param {boolean} [active] 
         * @param {boolean} [archive] 
         * @param {string} [source] 
         * @param {string} [searchString] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCptHcpcsMedicalCodes(page?: number, size?: number, sortBy?: string, sort?: string, active?: boolean, archive?: boolean, source?: string, searchString?: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCptHcpcsMedicalCodes(page, size, sortBy, sort, active, archive, source, searchString, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MedicalCodeControllerApi.getCptHcpcsMedicalCodes']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve a MedicalCode by its unique ID
         * @summary Get MedicalCode by ID
         * @param {string} medicalCodeId 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMedicalCodeById(medicalCodeId: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMedicalCodeById(medicalCodeId, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MedicalCodeControllerApi.getMedicalCodeById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get all MedicalCodes list for super admin with search option on name, deptId and filter options on active, archive.
         * @summary Get all MedicalCode.
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sort] 
         * @param {GetMedicalCodesTypeEnum} [type] 
         * @param {boolean} [active] 
         * @param {boolean} [archive] 
         * @param {string} [source] 
         * @param {string} [searchString] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMedicalCodes(page?: number, size?: number, sortBy?: string, sort?: string, type?: GetMedicalCodesTypeEnum, active?: boolean, archive?: boolean, source?: string, searchString?: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMedicalCodes(page, size, sortBy, sort, type, active, archive, source, searchString, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MedicalCodeControllerApi.getMedicalCodes']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Import initial medical code by type (e.g., ICD, HCPCS)
         * @summary Import initial medical code
         * @param {ImportInitialDataTypeEnum} type 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async importInitialData(type: ImportInitialDataTypeEnum, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.importInitialData(type, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MedicalCodeControllerApi.importInitialData']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update an existing MedicalCode
         * @summary Update MedicalCode
         * @param {MedicalCode} medicalCode 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateMedicalCode(medicalCode: MedicalCode, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateMedicalCode(medicalCode, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MedicalCodeControllerApi.updateMedicalCode']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Archive a MedicalCode by its ID
         * @summary Archive MedicalCode
         * @param {string} medicalCodeId 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateMedicalCodeArchiveStatus(medicalCodeId: string, status: boolean, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateMedicalCodeArchiveStatus(medicalCodeId, status, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MedicalCodeControllerApi.updateMedicalCodeArchiveStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update the status of a MedicalCode by its ID
         * @summary Update MedicalCode Status
         * @param {string} medicalCodeId 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateMedicalCodeStatus(medicalCodeId: string, status: boolean, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateMedicalCodeStatus(medicalCodeId, status, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MedicalCodeControllerApi.updateMedicalCodeStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * MedicalCodeControllerApi - factory interface
 * @export
 */
export const MedicalCodeControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MedicalCodeControllerApiFp(configuration)
    return {
        /**
         * Add a new MedicalCode into the system
         * @summary Add MedicalCode
         * @param {MedicalCode} medicalCode 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMedicalCode(medicalCode: MedicalCode, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.createMedicalCode(medicalCode, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Export medical codes by type as CSV format (max 500 records)
         * @summary Export Medical Codes as CSV
         * @param {ExportMedicalCodesAsCsvTypeEnum} type 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportMedicalCodesAsCsv(type: ExportMedicalCodesAsCsvTypeEnum, xTENANTID?: string, options?: any): AxiosPromise<string> {
            return localVarFp.exportMedicalCodesAsCsv(type, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all CPT/HCPCS MedicalCodes list for super admin with search option on name, deptId and filter options on active, archive.
         * @summary Get CPT/HCPCS MedicalCode.
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sort] 
         * @param {boolean} [active] 
         * @param {boolean} [archive] 
         * @param {string} [source] 
         * @param {string} [searchString] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCptHcpcsMedicalCodes(page?: number, size?: number, sortBy?: string, sort?: string, active?: boolean, archive?: boolean, source?: string, searchString?: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getCptHcpcsMedicalCodes(page, size, sortBy, sort, active, archive, source, searchString, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve a MedicalCode by its unique ID
         * @summary Get MedicalCode by ID
         * @param {string} medicalCodeId 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMedicalCodeById(medicalCodeId: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getMedicalCodeById(medicalCodeId, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all MedicalCodes list for super admin with search option on name, deptId and filter options on active, archive.
         * @summary Get all MedicalCode.
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sort] 
         * @param {GetMedicalCodesTypeEnum} [type] 
         * @param {boolean} [active] 
         * @param {boolean} [archive] 
         * @param {string} [source] 
         * @param {string} [searchString] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMedicalCodes(page?: number, size?: number, sortBy?: string, sort?: string, type?: GetMedicalCodesTypeEnum, active?: boolean, archive?: boolean, source?: string, searchString?: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getMedicalCodes(page, size, sortBy, sort, type, active, archive, source, searchString, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Import initial medical code by type (e.g., ICD, HCPCS)
         * @summary Import initial medical code
         * @param {ImportInitialDataTypeEnum} type 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importInitialData(type: ImportInitialDataTypeEnum, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.importInitialData(type, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Update an existing MedicalCode
         * @summary Update MedicalCode
         * @param {MedicalCode} medicalCode 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMedicalCode(medicalCode: MedicalCode, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.updateMedicalCode(medicalCode, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Archive a MedicalCode by its ID
         * @summary Archive MedicalCode
         * @param {string} medicalCodeId 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMedicalCodeArchiveStatus(medicalCodeId: string, status: boolean, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.updateMedicalCodeArchiveStatus(medicalCodeId, status, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Update the status of a MedicalCode by its ID
         * @summary Update MedicalCode Status
         * @param {string} medicalCodeId 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMedicalCodeStatus(medicalCodeId: string, status: boolean, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.updateMedicalCodeStatus(medicalCodeId, status, xTENANTID, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MedicalCodeControllerApi - object-oriented interface
 * @export
 * @class MedicalCodeControllerApi
 * @extends {BaseAPI}
 */
export class MedicalCodeControllerApi extends BaseAPI {
    /**
     * Add a new MedicalCode into the system
     * @summary Add MedicalCode
     * @param {MedicalCode} medicalCode 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MedicalCodeControllerApi
     */
    public createMedicalCode(medicalCode: MedicalCode, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return MedicalCodeControllerApiFp(this.configuration).createMedicalCode(medicalCode, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Export medical codes by type as CSV format (max 500 records)
     * @summary Export Medical Codes as CSV
     * @param {ExportMedicalCodesAsCsvTypeEnum} type 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MedicalCodeControllerApi
     */
    public exportMedicalCodesAsCsv(type: ExportMedicalCodesAsCsvTypeEnum, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return MedicalCodeControllerApiFp(this.configuration).exportMedicalCodesAsCsv(type, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all CPT/HCPCS MedicalCodes list for super admin with search option on name, deptId and filter options on active, archive.
     * @summary Get CPT/HCPCS MedicalCode.
     * @param {number} [page] 
     * @param {number} [size] 
     * @param {string} [sortBy] 
     * @param {string} [sort] 
     * @param {boolean} [active] 
     * @param {boolean} [archive] 
     * @param {string} [source] 
     * @param {string} [searchString] 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MedicalCodeControllerApi
     */
    public getCptHcpcsMedicalCodes(page?: number, size?: number, sortBy?: string, sort?: string, active?: boolean, archive?: boolean, source?: string, searchString?: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return MedicalCodeControllerApiFp(this.configuration).getCptHcpcsMedicalCodes(page, size, sortBy, sort, active, archive, source, searchString, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve a MedicalCode by its unique ID
     * @summary Get MedicalCode by ID
     * @param {string} medicalCodeId 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MedicalCodeControllerApi
     */
    public getMedicalCodeById(medicalCodeId: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return MedicalCodeControllerApiFp(this.configuration).getMedicalCodeById(medicalCodeId, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all MedicalCodes list for super admin with search option on name, deptId and filter options on active, archive.
     * @summary Get all MedicalCode.
     * @param {number} [page] 
     * @param {number} [size] 
     * @param {string} [sortBy] 
     * @param {string} [sort] 
     * @param {GetMedicalCodesTypeEnum} [type] 
     * @param {boolean} [active] 
     * @param {boolean} [archive] 
     * @param {string} [source] 
     * @param {string} [searchString] 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MedicalCodeControllerApi
     */
    public getMedicalCodes(page?: number, size?: number, sortBy?: string, sort?: string, type?: GetMedicalCodesTypeEnum, active?: boolean, archive?: boolean, source?: string, searchString?: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return MedicalCodeControllerApiFp(this.configuration).getMedicalCodes(page, size, sortBy, sort, type, active, archive, source, searchString, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Import initial medical code by type (e.g., ICD, HCPCS)
     * @summary Import initial medical code
     * @param {ImportInitialDataTypeEnum} type 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MedicalCodeControllerApi
     */
    public importInitialData(type: ImportInitialDataTypeEnum, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return MedicalCodeControllerApiFp(this.configuration).importInitialData(type, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update an existing MedicalCode
     * @summary Update MedicalCode
     * @param {MedicalCode} medicalCode 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MedicalCodeControllerApi
     */
    public updateMedicalCode(medicalCode: MedicalCode, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return MedicalCodeControllerApiFp(this.configuration).updateMedicalCode(medicalCode, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Archive a MedicalCode by its ID
     * @summary Archive MedicalCode
     * @param {string} medicalCodeId 
     * @param {boolean} status 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MedicalCodeControllerApi
     */
    public updateMedicalCodeArchiveStatus(medicalCodeId: string, status: boolean, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return MedicalCodeControllerApiFp(this.configuration).updateMedicalCodeArchiveStatus(medicalCodeId, status, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update the status of a MedicalCode by its ID
     * @summary Update MedicalCode Status
     * @param {string} medicalCodeId 
     * @param {boolean} status 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MedicalCodeControllerApi
     */
    public updateMedicalCodeStatus(medicalCodeId: string, status: boolean, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return MedicalCodeControllerApiFp(this.configuration).updateMedicalCodeStatus(medicalCodeId, status, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const ExportMedicalCodesAsCsvTypeEnum = {
    Cpt: 'CPT',
    Icd: 'ICD',
    Hcpcs: 'HCPCS',
    Loinc: 'LOINC',
    PayerCatalog: 'PAYER_CATALOG',
    Patient: 'PATIENT',
    Provider: 'PROVIDER',
    LabTest: 'LAB_TEST',
    ImagingStudy: 'IMAGING_STUDY',
    DrugCatalog: 'DRUG_CATALOG'
} as const;
export type ExportMedicalCodesAsCsvTypeEnum = typeof ExportMedicalCodesAsCsvTypeEnum[keyof typeof ExportMedicalCodesAsCsvTypeEnum];
/**
 * @export
 */
export const GetMedicalCodesTypeEnum = {
    Cpt: 'CPT',
    Icd: 'ICD',
    Hcpcs: 'HCPCS',
    Loinc: 'LOINC',
    PayerCatalog: 'PAYER_CATALOG',
    Patient: 'PATIENT',
    Provider: 'PROVIDER',
    LabTest: 'LAB_TEST',
    ImagingStudy: 'IMAGING_STUDY',
    DrugCatalog: 'DRUG_CATALOG'
} as const;
export type GetMedicalCodesTypeEnum = typeof GetMedicalCodesTypeEnum[keyof typeof GetMedicalCodesTypeEnum];
/**
 * @export
 */
export const ImportInitialDataTypeEnum = {
    Cpt: 'CPT',
    Icd: 'ICD',
    Hcpcs: 'HCPCS',
    Loinc: 'LOINC',
    PayerCatalog: 'PAYER_CATALOG',
    Patient: 'PATIENT',
    Provider: 'PROVIDER',
    LabTest: 'LAB_TEST',
    ImagingStudy: 'IMAGING_STUDY',
    DrugCatalog: 'DRUG_CATALOG'
} as const;
export type ImportInitialDataTypeEnum = typeof ImportInitialDataTypeEnum[keyof typeof ImportInitialDataTypeEnum];


/**
 * MedicalHistoryControllerApi - axios parameter creator
 * @export
 */
export const MedicalHistoryControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Add a new patient medical history into the system
         * @summary Add patient medical history
         * @param {MedicalHistory} medicalHistory 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPatientMedicalHistory: async (medicalHistory: MedicalHistory, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'medicalHistory' is not null or undefined
            assertParamExists('createPatientMedicalHistory', 'medicalHistory', medicalHistory)
            const localVarPath = `/api/master/patient-medical-history`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(medicalHistory, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all Patient Medical History
         * @summary Get all Patient Medical History.
         * @param {string} [patientUuid] 
         * @param {string} [appointmentUuid] 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sort] 
         * @param {boolean} [status] 
         * @param {boolean} [archive] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatientMedicalHistory: async (patientUuid?: string, appointmentUuid?: string, page?: number, size?: number, sortBy?: string, sort?: string, status?: boolean, archive?: boolean, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/master/patient-medical-history`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (patientUuid !== undefined) {
                localVarQueryParameter['patientUuid'] = patientUuid;
            }

            if (appointmentUuid !== undefined) {
                localVarQueryParameter['appointmentUuid'] = appointmentUuid;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (archive !== undefined) {
                localVarQueryParameter['archive'] = archive;
            }

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve a Patient Medical History by its unique ID
         * @summary Get Patient Medical History by ID
         * @param {string} patientMedicalHistoryId 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatientMedicalHistoryById: async (patientMedicalHistoryId: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientMedicalHistoryId' is not null or undefined
            assertParamExists('getPatientMedicalHistoryById', 'patientMedicalHistoryId', patientMedicalHistoryId)
            const localVarPath = `/api/master/patient-medical-history/{patientMedicalHistoryId}`
                .replace(`{${"patientMedicalHistoryId"}}`, encodeURIComponent(String(patientMedicalHistoryId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update an existing Patient Medical History
         * @summary Update Patient Medical History
         * @param {MedicalHistory} medicalHistory 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePatientMedicalHistory: async (medicalHistory: MedicalHistory, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'medicalHistory' is not null or undefined
            assertParamExists('updatePatientMedicalHistory', 'medicalHistory', medicalHistory)
            const localVarPath = `/api/master/patient-medical-history`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(medicalHistory, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Change the  Patient  medical history archive status to either archived or unarchived.
         * @summary Archive/Unarchive Patient Medical History
         * @param {string} patientMedicalHistoryId 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePatientMedicalHistoryArchiveStatus: async (patientMedicalHistoryId: string, status: boolean, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientMedicalHistoryId' is not null or undefined
            assertParamExists('updatePatientMedicalHistoryArchiveStatus', 'patientMedicalHistoryId', patientMedicalHistoryId)
            // verify required parameter 'status' is not null or undefined
            assertParamExists('updatePatientMedicalHistoryArchiveStatus', 'status', status)
            const localVarPath = `/api/master/patient-medical-history/{patientMedicalHistoryId}/archive-status/{status}`
                .replace(`{${"patientMedicalHistoryId"}}`, encodeURIComponent(String(patientMedicalHistoryId)))
                .replace(`{${"status"}}`, encodeURIComponent(String(status)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Change the  Patient  Medical history status.
         * @summary Update Patient Medical History Status
         * @param {string} patientMedicalHistoryId 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePatientMedicalHistoryStatus: async (patientMedicalHistoryId: string, status: boolean, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientMedicalHistoryId' is not null or undefined
            assertParamExists('updatePatientMedicalHistoryStatus', 'patientMedicalHistoryId', patientMedicalHistoryId)
            // verify required parameter 'status' is not null or undefined
            assertParamExists('updatePatientMedicalHistoryStatus', 'status', status)
            const localVarPath = `/api/master/patient-medical-history/{patientMedicalHistoryId}/status/{status}`
                .replace(`{${"patientMedicalHistoryId"}}`, encodeURIComponent(String(patientMedicalHistoryId)))
                .replace(`{${"status"}}`, encodeURIComponent(String(status)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MedicalHistoryControllerApi - functional programming interface
 * @export
 */
export const MedicalHistoryControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MedicalHistoryControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * Add a new patient medical history into the system
         * @summary Add patient medical history
         * @param {MedicalHistory} medicalHistory 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createPatientMedicalHistory(medicalHistory: MedicalHistory, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createPatientMedicalHistory(medicalHistory, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MedicalHistoryControllerApi.createPatientMedicalHistory']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get all Patient Medical History
         * @summary Get all Patient Medical History.
         * @param {string} [patientUuid] 
         * @param {string} [appointmentUuid] 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sort] 
         * @param {boolean} [status] 
         * @param {boolean} [archive] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPatientMedicalHistory(patientUuid?: string, appointmentUuid?: string, page?: number, size?: number, sortBy?: string, sort?: string, status?: boolean, archive?: boolean, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPatientMedicalHistory(patientUuid, appointmentUuid, page, size, sortBy, sort, status, archive, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MedicalHistoryControllerApi.getPatientMedicalHistory']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve a Patient Medical History by its unique ID
         * @summary Get Patient Medical History by ID
         * @param {string} patientMedicalHistoryId 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPatientMedicalHistoryById(patientMedicalHistoryId: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPatientMedicalHistoryById(patientMedicalHistoryId, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MedicalHistoryControllerApi.getPatientMedicalHistoryById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update an existing Patient Medical History
         * @summary Update Patient Medical History
         * @param {MedicalHistory} medicalHistory 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePatientMedicalHistory(medicalHistory: MedicalHistory, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePatientMedicalHistory(medicalHistory, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MedicalHistoryControllerApi.updatePatientMedicalHistory']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Change the  Patient  medical history archive status to either archived or unarchived.
         * @summary Archive/Unarchive Patient Medical History
         * @param {string} patientMedicalHistoryId 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePatientMedicalHistoryArchiveStatus(patientMedicalHistoryId: string, status: boolean, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePatientMedicalHistoryArchiveStatus(patientMedicalHistoryId, status, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MedicalHistoryControllerApi.updatePatientMedicalHistoryArchiveStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Change the  Patient  Medical history status.
         * @summary Update Patient Medical History Status
         * @param {string} patientMedicalHistoryId 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePatientMedicalHistoryStatus(patientMedicalHistoryId: string, status: boolean, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePatientMedicalHistoryStatus(patientMedicalHistoryId, status, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MedicalHistoryControllerApi.updatePatientMedicalHistoryStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * MedicalHistoryControllerApi - factory interface
 * @export
 */
export const MedicalHistoryControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MedicalHistoryControllerApiFp(configuration)
    return {
        /**
         * Add a new patient medical history into the system
         * @summary Add patient medical history
         * @param {MedicalHistory} medicalHistory 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPatientMedicalHistory(medicalHistory: MedicalHistory, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.createPatientMedicalHistory(medicalHistory, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all Patient Medical History
         * @summary Get all Patient Medical History.
         * @param {string} [patientUuid] 
         * @param {string} [appointmentUuid] 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sort] 
         * @param {boolean} [status] 
         * @param {boolean} [archive] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatientMedicalHistory(patientUuid?: string, appointmentUuid?: string, page?: number, size?: number, sortBy?: string, sort?: string, status?: boolean, archive?: boolean, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getPatientMedicalHistory(patientUuid, appointmentUuid, page, size, sortBy, sort, status, archive, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve a Patient Medical History by its unique ID
         * @summary Get Patient Medical History by ID
         * @param {string} patientMedicalHistoryId 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatientMedicalHistoryById(patientMedicalHistoryId: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getPatientMedicalHistoryById(patientMedicalHistoryId, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Update an existing Patient Medical History
         * @summary Update Patient Medical History
         * @param {MedicalHistory} medicalHistory 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePatientMedicalHistory(medicalHistory: MedicalHistory, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.updatePatientMedicalHistory(medicalHistory, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Change the  Patient  medical history archive status to either archived or unarchived.
         * @summary Archive/Unarchive Patient Medical History
         * @param {string} patientMedicalHistoryId 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePatientMedicalHistoryArchiveStatus(patientMedicalHistoryId: string, status: boolean, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.updatePatientMedicalHistoryArchiveStatus(patientMedicalHistoryId, status, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Change the  Patient  Medical history status.
         * @summary Update Patient Medical History Status
         * @param {string} patientMedicalHistoryId 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePatientMedicalHistoryStatus(patientMedicalHistoryId: string, status: boolean, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.updatePatientMedicalHistoryStatus(patientMedicalHistoryId, status, xTENANTID, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MedicalHistoryControllerApi - object-oriented interface
 * @export
 * @class MedicalHistoryControllerApi
 * @extends {BaseAPI}
 */
export class MedicalHistoryControllerApi extends BaseAPI {
    /**
     * Add a new patient medical history into the system
     * @summary Add patient medical history
     * @param {MedicalHistory} medicalHistory 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MedicalHistoryControllerApi
     */
    public createPatientMedicalHistory(medicalHistory: MedicalHistory, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return MedicalHistoryControllerApiFp(this.configuration).createPatientMedicalHistory(medicalHistory, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all Patient Medical History
     * @summary Get all Patient Medical History.
     * @param {string} [patientUuid] 
     * @param {string} [appointmentUuid] 
     * @param {number} [page] 
     * @param {number} [size] 
     * @param {string} [sortBy] 
     * @param {string} [sort] 
     * @param {boolean} [status] 
     * @param {boolean} [archive] 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MedicalHistoryControllerApi
     */
    public getPatientMedicalHistory(patientUuid?: string, appointmentUuid?: string, page?: number, size?: number, sortBy?: string, sort?: string, status?: boolean, archive?: boolean, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return MedicalHistoryControllerApiFp(this.configuration).getPatientMedicalHistory(patientUuid, appointmentUuid, page, size, sortBy, sort, status, archive, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve a Patient Medical History by its unique ID
     * @summary Get Patient Medical History by ID
     * @param {string} patientMedicalHistoryId 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MedicalHistoryControllerApi
     */
    public getPatientMedicalHistoryById(patientMedicalHistoryId: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return MedicalHistoryControllerApiFp(this.configuration).getPatientMedicalHistoryById(patientMedicalHistoryId, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update an existing Patient Medical History
     * @summary Update Patient Medical History
     * @param {MedicalHistory} medicalHistory 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MedicalHistoryControllerApi
     */
    public updatePatientMedicalHistory(medicalHistory: MedicalHistory, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return MedicalHistoryControllerApiFp(this.configuration).updatePatientMedicalHistory(medicalHistory, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Change the  Patient  medical history archive status to either archived or unarchived.
     * @summary Archive/Unarchive Patient Medical History
     * @param {string} patientMedicalHistoryId 
     * @param {boolean} status 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MedicalHistoryControllerApi
     */
    public updatePatientMedicalHistoryArchiveStatus(patientMedicalHistoryId: string, status: boolean, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return MedicalHistoryControllerApiFp(this.configuration).updatePatientMedicalHistoryArchiveStatus(patientMedicalHistoryId, status, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Change the  Patient  Medical history status.
     * @summary Update Patient Medical History Status
     * @param {string} patientMedicalHistoryId 
     * @param {boolean} status 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MedicalHistoryControllerApi
     */
    public updatePatientMedicalHistoryStatus(patientMedicalHistoryId: string, status: boolean, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return MedicalHistoryControllerApiFp(this.configuration).updatePatientMedicalHistoryStatus(patientMedicalHistoryId, status, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * MedicationsControllerApi - axios parameter creator
 * @export
 */
export const MedicationsControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Add a new medication into the system
         * @summary Add Medication
         * @param {Medication} medication 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMedication: async (medication: Medication, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'medication' is not null or undefined
            assertParamExists('createMedication', 'medication', medication)
            const localVarPath = `/api/master/medications`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(medication, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all Medication list.
         * @summary Get all Medications.
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {string} [searchString] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllMedications: async (page?: number, size?: number, sortBy?: string, sortDirection?: string, searchString?: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/master/medications`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }

            if (searchString !== undefined) {
                localVarQueryParameter['searchString'] = searchString;
            }

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MedicationsControllerApi - functional programming interface
 * @export
 */
export const MedicationsControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MedicationsControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * Add a new medication into the system
         * @summary Add Medication
         * @param {Medication} medication 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createMedication(medication: Medication, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createMedication(medication, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MedicationsControllerApi.createMedication']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get all Medication list.
         * @summary Get all Medications.
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {string} [searchString] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllMedications(page?: number, size?: number, sortBy?: string, sortDirection?: string, searchString?: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllMedications(page, size, sortBy, sortDirection, searchString, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MedicationsControllerApi.getAllMedications']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * MedicationsControllerApi - factory interface
 * @export
 */
export const MedicationsControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MedicationsControllerApiFp(configuration)
    return {
        /**
         * Add a new medication into the system
         * @summary Add Medication
         * @param {Medication} medication 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMedication(medication: Medication, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.createMedication(medication, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all Medication list.
         * @summary Get all Medications.
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {string} [searchString] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllMedications(page?: number, size?: number, sortBy?: string, sortDirection?: string, searchString?: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getAllMedications(page, size, sortBy, sortDirection, searchString, xTENANTID, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MedicationsControllerApi - object-oriented interface
 * @export
 * @class MedicationsControllerApi
 * @extends {BaseAPI}
 */
export class MedicationsControllerApi extends BaseAPI {
    /**
     * Add a new medication into the system
     * @summary Add Medication
     * @param {Medication} medication 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MedicationsControllerApi
     */
    public createMedication(medication: Medication, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return MedicationsControllerApiFp(this.configuration).createMedication(medication, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all Medication list.
     * @summary Get all Medications.
     * @param {number} [page] 
     * @param {number} [size] 
     * @param {string} [sortBy] 
     * @param {string} [sortDirection] 
     * @param {string} [searchString] 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MedicationsControllerApi
     */
    public getAllMedications(page?: number, size?: number, sortBy?: string, sortDirection?: string, searchString?: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return MedicationsControllerApiFp(this.configuration).getAllMedications(page, size, sortBy, sortDirection, searchString, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * MigrationControllerApi - axios parameter creator
 * @export
 */
export const MigrationControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Downloads a template CSV file based on the specified category
         * @summary Download a template CSV file
         * @param {DownloadTemplateCategoryEnum} category 
         * @param {DownloadTemplateTypeEnum} type 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadTemplate: async (category: DownloadTemplateCategoryEnum, type: DownloadTemplateTypeEnum, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'category' is not null or undefined
            assertParamExists('downloadTemplate', 'category', category)
            // verify required parameter 'type' is not null or undefined
            assertParamExists('downloadTemplate', 'type', type)
            const localVarPath = `/api/master/data-import/sample/{category}/{type}`
                .replace(`{${"category"}}`, encodeURIComponent(String(category)))
                .replace(`{${"type"}}`, encodeURIComponent(String(type)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all Data list.
         * @summary Get all Data
         * @param {string} dataImportUuid 
         * @param {ExportPatientListTypeEnum} type 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportPatientList: async (dataImportUuid: string, type: ExportPatientListTypeEnum, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dataImportUuid' is not null or undefined
            assertParamExists('exportPatientList', 'dataImportUuid', dataImportUuid)
            // verify required parameter 'type' is not null or undefined
            assertParamExists('exportPatientList', 'type', type)
            const localVarPath = `/api/master/data-import/data/export`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (dataImportUuid !== undefined) {
                localVarQueryParameter['dataImportUuid'] = dataImportUuid;
            }

            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve a DataImport by its unique ID
         * @summary Get DataImport by ID
         * @param {string} dataImportId 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDataImportById: async (dataImportId: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dataImportId' is not null or undefined
            assertParamExists('getDataImportById', 'dataImportId', dataImportId)
            const localVarPath = `/api/master/data-import/{dataImportId}`
                .replace(`{${"dataImportId"}}`, encodeURIComponent(String(dataImportId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetches paginated data import records with type, provider group UUID, and status filters.
         * @summary Get all DataImport records.
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {GetDataImportRecordsTypeEnum} [type] 
         * @param {string} [providerGroupUuid] 
         * @param {string} [status] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDataImportRecords: async (page?: number, size?: number, sortBy?: string, sortDirection?: string, type?: GetDataImportRecordsTypeEnum, providerGroupUuid?: string, status?: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/master/data-import`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }

            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }

            if (providerGroupUuid !== undefined) {
                localVarQueryParameter['providerGroupUuid'] = providerGroupUuid;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetches paginated data import medical code records with type and provider group UUID.
         * @summary Get all DataImport Medical Code records.
         * @param {string} dataImportUuid 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {string} [searchString] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getImportedMedicalDataData: async (dataImportUuid: string, page?: number, size?: number, sortBy?: string, sortDirection?: string, searchString?: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dataImportUuid' is not null or undefined
            assertParamExists('getImportedMedicalDataData', 'dataImportUuid', dataImportUuid)
            const localVarPath = `/api/master/data-import/medical-code-data`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }

            if (searchString !== undefined) {
                localVarQueryParameter['searchString'] = searchString;
            }

            if (dataImportUuid !== undefined) {
                localVarQueryParameter['dataImportUuid'] = dataImportUuid;
            }

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetches paginated data import patient records with type and provider group UUID.
         * @summary Get all DataImport patient records.
         * @param {string} dataImportUuid 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {string} [searchString] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getImportedPatientData: async (dataImportUuid: string, page?: number, size?: number, sortBy?: string, sortDirection?: string, searchString?: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dataImportUuid' is not null or undefined
            assertParamExists('getImportedPatientData', 'dataImportUuid', dataImportUuid)
            const localVarPath = `/api/master/data-import/patient-data`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }

            if (searchString !== undefined) {
                localVarQueryParameter['searchString'] = searchString;
            }

            if (dataImportUuid !== undefined) {
                localVarQueryParameter['dataImportUuid'] = dataImportUuid;
            }

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetches paginated data import provider records with type and provider group UUID.
         * @summary Get all DataImport provider records.
         * @param {string} dataImportUuid 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {string} [searchString] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getImportedProviderData: async (dataImportUuid: string, page?: number, size?: number, sortBy?: string, sortDirection?: string, searchString?: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dataImportUuid' is not null or undefined
            assertParamExists('getImportedProviderData', 'dataImportUuid', dataImportUuid)
            const localVarPath = `/api/master/data-import/provider-data`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }

            if (searchString !== undefined) {
                localVarQueryParameter['searchString'] = searchString;
            }

            if (dataImportUuid !== undefined) {
                localVarQueryParameter['dataImportUuid'] = dataImportUuid;
            }

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Uploads a CSV file for the specified category and title
         * @summary Upload a CSV file
         * @param {UploadFileCategoryEnum} category 
         * @param {string} title 
         * @param {File} file 
         * @param {string} [providerGroupUuid] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadFile: async (category: UploadFileCategoryEnum, title: string, file: File, providerGroupUuid?: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'category' is not null or undefined
            assertParamExists('uploadFile', 'category', category)
            // verify required parameter 'title' is not null or undefined
            assertParamExists('uploadFile', 'title', title)
            // verify required parameter 'file' is not null or undefined
            assertParamExists('uploadFile', 'file', file)
            const localVarPath = `/api/master/data-import/{category}/upload`
                .replace(`{${"category"}}`, encodeURIComponent(String(category)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (providerGroupUuid !== undefined) {
                localVarQueryParameter['ProviderGroupUuid'] = providerGroupUuid;
            }

            if (title !== undefined) {
                localVarQueryParameter['title'] = title;
            }

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MigrationControllerApi - functional programming interface
 * @export
 */
export const MigrationControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MigrationControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * Downloads a template CSV file based on the specified category
         * @summary Download a template CSV file
         * @param {DownloadTemplateCategoryEnum} category 
         * @param {DownloadTemplateTypeEnum} type 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadTemplate(category: DownloadTemplateCategoryEnum, type: DownloadTemplateTypeEnum, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadTemplate(category, type, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MigrationControllerApi.downloadTemplate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get all Data list.
         * @summary Get all Data
         * @param {string} dataImportUuid 
         * @param {ExportPatientListTypeEnum} type 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exportPatientList(dataImportUuid: string, type: ExportPatientListTypeEnum, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.exportPatientList(dataImportUuid, type, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MigrationControllerApi.exportPatientList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve a DataImport by its unique ID
         * @summary Get DataImport by ID
         * @param {string} dataImportId 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDataImportById(dataImportId: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDataImportById(dataImportId, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MigrationControllerApi.getDataImportById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Fetches paginated data import records with type, provider group UUID, and status filters.
         * @summary Get all DataImport records.
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {GetDataImportRecordsTypeEnum} [type] 
         * @param {string} [providerGroupUuid] 
         * @param {string} [status] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDataImportRecords(page?: number, size?: number, sortBy?: string, sortDirection?: string, type?: GetDataImportRecordsTypeEnum, providerGroupUuid?: string, status?: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDataImportRecords(page, size, sortBy, sortDirection, type, providerGroupUuid, status, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MigrationControllerApi.getDataImportRecords']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Fetches paginated data import medical code records with type and provider group UUID.
         * @summary Get all DataImport Medical Code records.
         * @param {string} dataImportUuid 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {string} [searchString] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getImportedMedicalDataData(dataImportUuid: string, page?: number, size?: number, sortBy?: string, sortDirection?: string, searchString?: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getImportedMedicalDataData(dataImportUuid, page, size, sortBy, sortDirection, searchString, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MigrationControllerApi.getImportedMedicalDataData']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Fetches paginated data import patient records with type and provider group UUID.
         * @summary Get all DataImport patient records.
         * @param {string} dataImportUuid 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {string} [searchString] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getImportedPatientData(dataImportUuid: string, page?: number, size?: number, sortBy?: string, sortDirection?: string, searchString?: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getImportedPatientData(dataImportUuid, page, size, sortBy, sortDirection, searchString, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MigrationControllerApi.getImportedPatientData']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Fetches paginated data import provider records with type and provider group UUID.
         * @summary Get all DataImport provider records.
         * @param {string} dataImportUuid 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {string} [searchString] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getImportedProviderData(dataImportUuid: string, page?: number, size?: number, sortBy?: string, sortDirection?: string, searchString?: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getImportedProviderData(dataImportUuid, page, size, sortBy, sortDirection, searchString, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MigrationControllerApi.getImportedProviderData']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Uploads a CSV file for the specified category and title
         * @summary Upload a CSV file
         * @param {UploadFileCategoryEnum} category 
         * @param {string} title 
         * @param {File} file 
         * @param {string} [providerGroupUuid] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadFile(category: UploadFileCategoryEnum, title: string, file: File, providerGroupUuid?: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadFile(category, title, file, providerGroupUuid, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MigrationControllerApi.uploadFile']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * MigrationControllerApi - factory interface
 * @export
 */
export const MigrationControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MigrationControllerApiFp(configuration)
    return {
        /**
         * Downloads a template CSV file based on the specified category
         * @summary Download a template CSV file
         * @param {DownloadTemplateCategoryEnum} category 
         * @param {DownloadTemplateTypeEnum} type 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadTemplate(category: DownloadTemplateCategoryEnum, type: DownloadTemplateTypeEnum, xTENANTID?: string, options?: any): AxiosPromise<File> {
            return localVarFp.downloadTemplate(category, type, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all Data list.
         * @summary Get all Data
         * @param {string} dataImportUuid 
         * @param {ExportPatientListTypeEnum} type 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportPatientList(dataImportUuid: string, type: ExportPatientListTypeEnum, xTENANTID?: string, options?: any): AxiosPromise<object> {
            return localVarFp.exportPatientList(dataImportUuid, type, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve a DataImport by its unique ID
         * @summary Get DataImport by ID
         * @param {string} dataImportId 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDataImportById(dataImportId: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getDataImportById(dataImportId, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Fetches paginated data import records with type, provider group UUID, and status filters.
         * @summary Get all DataImport records.
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {GetDataImportRecordsTypeEnum} [type] 
         * @param {string} [providerGroupUuid] 
         * @param {string} [status] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDataImportRecords(page?: number, size?: number, sortBy?: string, sortDirection?: string, type?: GetDataImportRecordsTypeEnum, providerGroupUuid?: string, status?: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getDataImportRecords(page, size, sortBy, sortDirection, type, providerGroupUuid, status, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Fetches paginated data import medical code records with type and provider group UUID.
         * @summary Get all DataImport Medical Code records.
         * @param {string} dataImportUuid 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {string} [searchString] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getImportedMedicalDataData(dataImportUuid: string, page?: number, size?: number, sortBy?: string, sortDirection?: string, searchString?: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getImportedMedicalDataData(dataImportUuid, page, size, sortBy, sortDirection, searchString, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Fetches paginated data import patient records with type and provider group UUID.
         * @summary Get all DataImport patient records.
         * @param {string} dataImportUuid 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {string} [searchString] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getImportedPatientData(dataImportUuid: string, page?: number, size?: number, sortBy?: string, sortDirection?: string, searchString?: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getImportedPatientData(dataImportUuid, page, size, sortBy, sortDirection, searchString, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Fetches paginated data import provider records with type and provider group UUID.
         * @summary Get all DataImport provider records.
         * @param {string} dataImportUuid 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {string} [searchString] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getImportedProviderData(dataImportUuid: string, page?: number, size?: number, sortBy?: string, sortDirection?: string, searchString?: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getImportedProviderData(dataImportUuid, page, size, sortBy, sortDirection, searchString, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Uploads a CSV file for the specified category and title
         * @summary Upload a CSV file
         * @param {UploadFileCategoryEnum} category 
         * @param {string} title 
         * @param {File} file 
         * @param {string} [providerGroupUuid] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadFile(category: UploadFileCategoryEnum, title: string, file: File, providerGroupUuid?: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.uploadFile(category, title, file, providerGroupUuid, xTENANTID, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MigrationControllerApi - object-oriented interface
 * @export
 * @class MigrationControllerApi
 * @extends {BaseAPI}
 */
export class MigrationControllerApi extends BaseAPI {
    /**
     * Downloads a template CSV file based on the specified category
     * @summary Download a template CSV file
     * @param {DownloadTemplateCategoryEnum} category 
     * @param {DownloadTemplateTypeEnum} type 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MigrationControllerApi
     */
    public downloadTemplate(category: DownloadTemplateCategoryEnum, type: DownloadTemplateTypeEnum, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return MigrationControllerApiFp(this.configuration).downloadTemplate(category, type, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all Data list.
     * @summary Get all Data
     * @param {string} dataImportUuid 
     * @param {ExportPatientListTypeEnum} type 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MigrationControllerApi
     */
    public exportPatientList(dataImportUuid: string, type: ExportPatientListTypeEnum, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return MigrationControllerApiFp(this.configuration).exportPatientList(dataImportUuid, type, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve a DataImport by its unique ID
     * @summary Get DataImport by ID
     * @param {string} dataImportId 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MigrationControllerApi
     */
    public getDataImportById(dataImportId: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return MigrationControllerApiFp(this.configuration).getDataImportById(dataImportId, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Fetches paginated data import records with type, provider group UUID, and status filters.
     * @summary Get all DataImport records.
     * @param {number} [page] 
     * @param {number} [size] 
     * @param {string} [sortBy] 
     * @param {string} [sortDirection] 
     * @param {GetDataImportRecordsTypeEnum} [type] 
     * @param {string} [providerGroupUuid] 
     * @param {string} [status] 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MigrationControllerApi
     */
    public getDataImportRecords(page?: number, size?: number, sortBy?: string, sortDirection?: string, type?: GetDataImportRecordsTypeEnum, providerGroupUuid?: string, status?: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return MigrationControllerApiFp(this.configuration).getDataImportRecords(page, size, sortBy, sortDirection, type, providerGroupUuid, status, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Fetches paginated data import medical code records with type and provider group UUID.
     * @summary Get all DataImport Medical Code records.
     * @param {string} dataImportUuid 
     * @param {number} [page] 
     * @param {number} [size] 
     * @param {string} [sortBy] 
     * @param {string} [sortDirection] 
     * @param {string} [searchString] 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MigrationControllerApi
     */
    public getImportedMedicalDataData(dataImportUuid: string, page?: number, size?: number, sortBy?: string, sortDirection?: string, searchString?: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return MigrationControllerApiFp(this.configuration).getImportedMedicalDataData(dataImportUuid, page, size, sortBy, sortDirection, searchString, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Fetches paginated data import patient records with type and provider group UUID.
     * @summary Get all DataImport patient records.
     * @param {string} dataImportUuid 
     * @param {number} [page] 
     * @param {number} [size] 
     * @param {string} [sortBy] 
     * @param {string} [sortDirection] 
     * @param {string} [searchString] 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MigrationControllerApi
     */
    public getImportedPatientData(dataImportUuid: string, page?: number, size?: number, sortBy?: string, sortDirection?: string, searchString?: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return MigrationControllerApiFp(this.configuration).getImportedPatientData(dataImportUuid, page, size, sortBy, sortDirection, searchString, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Fetches paginated data import provider records with type and provider group UUID.
     * @summary Get all DataImport provider records.
     * @param {string} dataImportUuid 
     * @param {number} [page] 
     * @param {number} [size] 
     * @param {string} [sortBy] 
     * @param {string} [sortDirection] 
     * @param {string} [searchString] 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MigrationControllerApi
     */
    public getImportedProviderData(dataImportUuid: string, page?: number, size?: number, sortBy?: string, sortDirection?: string, searchString?: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return MigrationControllerApiFp(this.configuration).getImportedProviderData(dataImportUuid, page, size, sortBy, sortDirection, searchString, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Uploads a CSV file for the specified category and title
     * @summary Upload a CSV file
     * @param {UploadFileCategoryEnum} category 
     * @param {string} title 
     * @param {File} file 
     * @param {string} [providerGroupUuid] 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MigrationControllerApi
     */
    public uploadFile(category: UploadFileCategoryEnum, title: string, file: File, providerGroupUuid?: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return MigrationControllerApiFp(this.configuration).uploadFile(category, title, file, providerGroupUuid, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const DownloadTemplateCategoryEnum = {
    Cpt: 'CPT',
    Icd: 'ICD',
    Hcpcs: 'HCPCS',
    Loinc: 'LOINC',
    PayerCatalog: 'PAYER_CATALOG',
    Patient: 'PATIENT',
    Provider: 'PROVIDER',
    LabTest: 'LAB_TEST',
    ImagingStudy: 'IMAGING_STUDY',
    DrugCatalog: 'DRUG_CATALOG'
} as const;
export type DownloadTemplateCategoryEnum = typeof DownloadTemplateCategoryEnum[keyof typeof DownloadTemplateCategoryEnum];
/**
 * @export
 */
export const DownloadTemplateTypeEnum = {
    Xlsx: 'XLSX',
    Csv: 'CSV'
} as const;
export type DownloadTemplateTypeEnum = typeof DownloadTemplateTypeEnum[keyof typeof DownloadTemplateTypeEnum];
/**
 * @export
 */
export const ExportPatientListTypeEnum = {
    Cpt: 'CPT',
    Icd: 'ICD',
    Hcpcs: 'HCPCS',
    Loinc: 'LOINC',
    PayerCatalog: 'PAYER_CATALOG',
    Patient: 'PATIENT',
    Provider: 'PROVIDER',
    LabTest: 'LAB_TEST',
    ImagingStudy: 'IMAGING_STUDY',
    DrugCatalog: 'DRUG_CATALOG'
} as const;
export type ExportPatientListTypeEnum = typeof ExportPatientListTypeEnum[keyof typeof ExportPatientListTypeEnum];
/**
 * @export
 */
export const GetDataImportRecordsTypeEnum = {
    Cpt: 'CPT',
    Icd: 'ICD',
    Hcpcs: 'HCPCS',
    Loinc: 'LOINC',
    PayerCatalog: 'PAYER_CATALOG',
    Patient: 'PATIENT',
    Provider: 'PROVIDER',
    LabTest: 'LAB_TEST',
    ImagingStudy: 'IMAGING_STUDY',
    DrugCatalog: 'DRUG_CATALOG'
} as const;
export type GetDataImportRecordsTypeEnum = typeof GetDataImportRecordsTypeEnum[keyof typeof GetDataImportRecordsTypeEnum];
/**
 * @export
 */
export const UploadFileCategoryEnum = {
    Cpt: 'CPT',
    Icd: 'ICD',
    Hcpcs: 'HCPCS',
    Loinc: 'LOINC',
    PayerCatalog: 'PAYER_CATALOG',
    Patient: 'PATIENT',
    Provider: 'PROVIDER',
    LabTest: 'LAB_TEST',
    ImagingStudy: 'IMAGING_STUDY',
    DrugCatalog: 'DRUG_CATALOG'
} as const;
export type UploadFileCategoryEnum = typeof UploadFileCategoryEnum[keyof typeof UploadFileCategoryEnum];


/**
 * ModifierControllerApi - axios parameter creator
 * @export
 */
export const ModifierControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get all Modifiers list with pagination and sorting.
         * @summary Get all Modifiers.
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [searchString] 
         * @param {string} [sortDirection] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllModifiers: async (page?: number, size?: number, sortBy?: string, searchString?: string, sortDirection?: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/master/modifier`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (searchString !== undefined) {
                localVarQueryParameter['searchString'] = searchString;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ModifierControllerApi - functional programming interface
 * @export
 */
export const ModifierControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ModifierControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * Get all Modifiers list with pagination and sorting.
         * @summary Get all Modifiers.
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [searchString] 
         * @param {string} [sortDirection] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllModifiers(page?: number, size?: number, sortBy?: string, searchString?: string, sortDirection?: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllModifiers(page, size, sortBy, searchString, sortDirection, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ModifierControllerApi.getAllModifiers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ModifierControllerApi - factory interface
 * @export
 */
export const ModifierControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ModifierControllerApiFp(configuration)
    return {
        /**
         * Get all Modifiers list with pagination and sorting.
         * @summary Get all Modifiers.
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [searchString] 
         * @param {string} [sortDirection] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllModifiers(page?: number, size?: number, sortBy?: string, searchString?: string, sortDirection?: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getAllModifiers(page, size, sortBy, searchString, sortDirection, xTENANTID, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ModifierControllerApi - object-oriented interface
 * @export
 * @class ModifierControllerApi
 * @extends {BaseAPI}
 */
export class ModifierControllerApi extends BaseAPI {
    /**
     * Get all Modifiers list with pagination and sorting.
     * @summary Get all Modifiers.
     * @param {number} [page] 
     * @param {number} [size] 
     * @param {string} [sortBy] 
     * @param {string} [searchString] 
     * @param {string} [sortDirection] 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ModifierControllerApi
     */
    public getAllModifiers(page?: number, size?: number, sortBy?: string, searchString?: string, sortDirection?: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return ModifierControllerApiFp(this.configuration).getAllModifiers(page, size, sortBy, searchString, sortDirection, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PatientAllergyControllerApi - axios parameter creator
 * @export
 */
export const PatientAllergyControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Add a new patient allergy into the system
         * @summary Add Patient Allergy
         * @param {Patientallergy} patientallergy 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPatientAllergy: async (patientallergy: Patientallergy, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientallergy' is not null or undefined
            assertParamExists('createPatientAllergy', 'patientallergy', patientallergy)
            const localVarPath = `/api/master/patient-allergy`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patientallergy, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all Patient Allergy list with search option on name, patientId and filter options on active, archive. Supports sorting by: severity (Mild → Moderate → Severe), onsetDate (chronological), updatedDate (chronological), recordedDate (chronological), allergy, reaction, allergyType, active, archive.
         * @summary Get all Patient Allergy.
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sort] 
         * @param {string} [patientUuid] 
         * @param {string} [appointmentUuid] 
         * @param {boolean} [status] 
         * @param {boolean} [archive] 
         * @param {GetPatientAllergyProviderStatusEnum} [providerStatus] 
         * @param {string} [searchString] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatientAllergy: async (page?: number, size?: number, sortBy?: string, sort?: string, patientUuid?: string, appointmentUuid?: string, status?: boolean, archive?: boolean, providerStatus?: GetPatientAllergyProviderStatusEnum, searchString?: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/master/patient-allergy`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (patientUuid !== undefined) {
                localVarQueryParameter['patientUuid'] = patientUuid;
            }

            if (appointmentUuid !== undefined) {
                localVarQueryParameter['appointmentUuid'] = appointmentUuid;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (archive !== undefined) {
                localVarQueryParameter['archive'] = archive;
            }

            if (providerStatus !== undefined) {
                localVarQueryParameter['providerStatus'] = providerStatus;
            }

            if (searchString !== undefined) {
                localVarQueryParameter['searchString'] = searchString;
            }

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve a Patient Allergy by its unique ID
         * @summary Get Patient Allergy by ID
         * @param {string} patientAllergyId 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatientAllergyById: async (patientAllergyId: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientAllergyId' is not null or undefined
            assertParamExists('getPatientAllergyById', 'patientAllergyId', patientAllergyId)
            const localVarPath = `/api/master/patient-allergy/{patientAllergyId}`
                .replace(`{${"patientAllergyId"}}`, encodeURIComponent(String(patientAllergyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get active, non-archived allergies for a patient. Used on patient portal side.
         * @summary Get Patient Allergies for Patient Portal
         * @param {string} patientUuid 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatientPortalAllergies: async (patientUuid: string, page?: number, size?: number, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientUuid' is not null or undefined
            assertParamExists('getPatientPortalAllergies', 'patientUuid', patientUuid)
            const localVarPath = `/api/master/patient-allergy/patient-portal`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (patientUuid !== undefined) {
                localVarQueryParameter['patientUuid'] = patientUuid;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update an existing Patient Allergy
         * @summary Update Patient Allergy
         * @param {Patientallergy} patientallergy 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePatientAllergy: async (patientallergy: Patientallergy, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientallergy' is not null or undefined
            assertParamExists('updatePatientAllergy', 'patientallergy', patientallergy)
            const localVarPath = `/api/master/patient-allergy`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patientallergy, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Archive a Patient Allergy by its ID
         * @summary Archive Patient Allergy
         * @param {string} patientAllergyId 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePatientAllergyArchiveStatus: async (patientAllergyId: string, status: boolean, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientAllergyId' is not null or undefined
            assertParamExists('updatePatientAllergyArchiveStatus', 'patientAllergyId', patientAllergyId)
            // verify required parameter 'status' is not null or undefined
            assertParamExists('updatePatientAllergyArchiveStatus', 'status', status)
            const localVarPath = `/api/master/patient-allergy/{patientAllergyId}/archive-status/{status}`
                .replace(`{${"patientAllergyId"}}`, encodeURIComponent(String(patientAllergyId)))
                .replace(`{${"status"}}`, encodeURIComponent(String(status)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update the status of a Patient Allergy by its ID
         * @summary Update Patient Allergy Status
         * @param {string} patientAllergyId 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePatientAllergyStatus: async (patientAllergyId: string, status: boolean, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientAllergyId' is not null or undefined
            assertParamExists('updatePatientAllergyStatus', 'patientAllergyId', patientAllergyId)
            // verify required parameter 'status' is not null or undefined
            assertParamExists('updatePatientAllergyStatus', 'status', status)
            const localVarPath = `/api/master/patient-allergy/{patientAllergyId}/status/{status}`
                .replace(`{${"patientAllergyId"}}`, encodeURIComponent(String(patientAllergyId)))
                .replace(`{${"status"}}`, encodeURIComponent(String(status)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PatientAllergyControllerApi - functional programming interface
 * @export
 */
export const PatientAllergyControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PatientAllergyControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * Add a new patient allergy into the system
         * @summary Add Patient Allergy
         * @param {Patientallergy} patientallergy 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createPatientAllergy(patientallergy: Patientallergy, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createPatientAllergy(patientallergy, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientAllergyControllerApi.createPatientAllergy']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get all Patient Allergy list with search option on name, patientId and filter options on active, archive. Supports sorting by: severity (Mild → Moderate → Severe), onsetDate (chronological), updatedDate (chronological), recordedDate (chronological), allergy, reaction, allergyType, active, archive.
         * @summary Get all Patient Allergy.
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sort] 
         * @param {string} [patientUuid] 
         * @param {string} [appointmentUuid] 
         * @param {boolean} [status] 
         * @param {boolean} [archive] 
         * @param {GetPatientAllergyProviderStatusEnum} [providerStatus] 
         * @param {string} [searchString] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPatientAllergy(page?: number, size?: number, sortBy?: string, sort?: string, patientUuid?: string, appointmentUuid?: string, status?: boolean, archive?: boolean, providerStatus?: GetPatientAllergyProviderStatusEnum, searchString?: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPatientAllergy(page, size, sortBy, sort, patientUuid, appointmentUuid, status, archive, providerStatus, searchString, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientAllergyControllerApi.getPatientAllergy']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve a Patient Allergy by its unique ID
         * @summary Get Patient Allergy by ID
         * @param {string} patientAllergyId 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPatientAllergyById(patientAllergyId: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPatientAllergyById(patientAllergyId, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientAllergyControllerApi.getPatientAllergyById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get active, non-archived allergies for a patient. Used on patient portal side.
         * @summary Get Patient Allergies for Patient Portal
         * @param {string} patientUuid 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPatientPortalAllergies(patientUuid: string, page?: number, size?: number, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPatientPortalAllergies(patientUuid, page, size, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientAllergyControllerApi.getPatientPortalAllergies']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update an existing Patient Allergy
         * @summary Update Patient Allergy
         * @param {Patientallergy} patientallergy 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePatientAllergy(patientallergy: Patientallergy, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePatientAllergy(patientallergy, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientAllergyControllerApi.updatePatientAllergy']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Archive a Patient Allergy by its ID
         * @summary Archive Patient Allergy
         * @param {string} patientAllergyId 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePatientAllergyArchiveStatus(patientAllergyId: string, status: boolean, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePatientAllergyArchiveStatus(patientAllergyId, status, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientAllergyControllerApi.updatePatientAllergyArchiveStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update the status of a Patient Allergy by its ID
         * @summary Update Patient Allergy Status
         * @param {string} patientAllergyId 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePatientAllergyStatus(patientAllergyId: string, status: boolean, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePatientAllergyStatus(patientAllergyId, status, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientAllergyControllerApi.updatePatientAllergyStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PatientAllergyControllerApi - factory interface
 * @export
 */
export const PatientAllergyControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PatientAllergyControllerApiFp(configuration)
    return {
        /**
         * Add a new patient allergy into the system
         * @summary Add Patient Allergy
         * @param {Patientallergy} patientallergy 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPatientAllergy(patientallergy: Patientallergy, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.createPatientAllergy(patientallergy, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all Patient Allergy list with search option on name, patientId and filter options on active, archive. Supports sorting by: severity (Mild → Moderate → Severe), onsetDate (chronological), updatedDate (chronological), recordedDate (chronological), allergy, reaction, allergyType, active, archive.
         * @summary Get all Patient Allergy.
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sort] 
         * @param {string} [patientUuid] 
         * @param {string} [appointmentUuid] 
         * @param {boolean} [status] 
         * @param {boolean} [archive] 
         * @param {GetPatientAllergyProviderStatusEnum} [providerStatus] 
         * @param {string} [searchString] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatientAllergy(page?: number, size?: number, sortBy?: string, sort?: string, patientUuid?: string, appointmentUuid?: string, status?: boolean, archive?: boolean, providerStatus?: GetPatientAllergyProviderStatusEnum, searchString?: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getPatientAllergy(page, size, sortBy, sort, patientUuid, appointmentUuid, status, archive, providerStatus, searchString, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve a Patient Allergy by its unique ID
         * @summary Get Patient Allergy by ID
         * @param {string} patientAllergyId 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatientAllergyById(patientAllergyId: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getPatientAllergyById(patientAllergyId, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Get active, non-archived allergies for a patient. Used on patient portal side.
         * @summary Get Patient Allergies for Patient Portal
         * @param {string} patientUuid 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatientPortalAllergies(patientUuid: string, page?: number, size?: number, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getPatientPortalAllergies(patientUuid, page, size, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Update an existing Patient Allergy
         * @summary Update Patient Allergy
         * @param {Patientallergy} patientallergy 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePatientAllergy(patientallergy: Patientallergy, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.updatePatientAllergy(patientallergy, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Archive a Patient Allergy by its ID
         * @summary Archive Patient Allergy
         * @param {string} patientAllergyId 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePatientAllergyArchiveStatus(patientAllergyId: string, status: boolean, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.updatePatientAllergyArchiveStatus(patientAllergyId, status, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Update the status of a Patient Allergy by its ID
         * @summary Update Patient Allergy Status
         * @param {string} patientAllergyId 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePatientAllergyStatus(patientAllergyId: string, status: boolean, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.updatePatientAllergyStatus(patientAllergyId, status, xTENANTID, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PatientAllergyControllerApi - object-oriented interface
 * @export
 * @class PatientAllergyControllerApi
 * @extends {BaseAPI}
 */
export class PatientAllergyControllerApi extends BaseAPI {
    /**
     * Add a new patient allergy into the system
     * @summary Add Patient Allergy
     * @param {Patientallergy} patientallergy 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientAllergyControllerApi
     */
    public createPatientAllergy(patientallergy: Patientallergy, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return PatientAllergyControllerApiFp(this.configuration).createPatientAllergy(patientallergy, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all Patient Allergy list with search option on name, patientId and filter options on active, archive. Supports sorting by: severity (Mild → Moderate → Severe), onsetDate (chronological), updatedDate (chronological), recordedDate (chronological), allergy, reaction, allergyType, active, archive.
     * @summary Get all Patient Allergy.
     * @param {number} [page] 
     * @param {number} [size] 
     * @param {string} [sortBy] 
     * @param {string} [sort] 
     * @param {string} [patientUuid] 
     * @param {string} [appointmentUuid] 
     * @param {boolean} [status] 
     * @param {boolean} [archive] 
     * @param {GetPatientAllergyProviderStatusEnum} [providerStatus] 
     * @param {string} [searchString] 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientAllergyControllerApi
     */
    public getPatientAllergy(page?: number, size?: number, sortBy?: string, sort?: string, patientUuid?: string, appointmentUuid?: string, status?: boolean, archive?: boolean, providerStatus?: GetPatientAllergyProviderStatusEnum, searchString?: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return PatientAllergyControllerApiFp(this.configuration).getPatientAllergy(page, size, sortBy, sort, patientUuid, appointmentUuid, status, archive, providerStatus, searchString, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve a Patient Allergy by its unique ID
     * @summary Get Patient Allergy by ID
     * @param {string} patientAllergyId 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientAllergyControllerApi
     */
    public getPatientAllergyById(patientAllergyId: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return PatientAllergyControllerApiFp(this.configuration).getPatientAllergyById(patientAllergyId, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get active, non-archived allergies for a patient. Used on patient portal side.
     * @summary Get Patient Allergies for Patient Portal
     * @param {string} patientUuid 
     * @param {number} [page] 
     * @param {number} [size] 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientAllergyControllerApi
     */
    public getPatientPortalAllergies(patientUuid: string, page?: number, size?: number, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return PatientAllergyControllerApiFp(this.configuration).getPatientPortalAllergies(patientUuid, page, size, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update an existing Patient Allergy
     * @summary Update Patient Allergy
     * @param {Patientallergy} patientallergy 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientAllergyControllerApi
     */
    public updatePatientAllergy(patientallergy: Patientallergy, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return PatientAllergyControllerApiFp(this.configuration).updatePatientAllergy(patientallergy, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Archive a Patient Allergy by its ID
     * @summary Archive Patient Allergy
     * @param {string} patientAllergyId 
     * @param {boolean} status 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientAllergyControllerApi
     */
    public updatePatientAllergyArchiveStatus(patientAllergyId: string, status: boolean, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return PatientAllergyControllerApiFp(this.configuration).updatePatientAllergyArchiveStatus(patientAllergyId, status, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update the status of a Patient Allergy by its ID
     * @summary Update Patient Allergy Status
     * @param {string} patientAllergyId 
     * @param {boolean} status 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientAllergyControllerApi
     */
    public updatePatientAllergyStatus(patientAllergyId: string, status: boolean, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return PatientAllergyControllerApiFp(this.configuration).updatePatientAllergyStatus(patientAllergyId, status, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const GetPatientAllergyProviderStatusEnum = {
    Pending: 'PENDING',
    Confirmed: 'CONFIRMED'
} as const;
export type GetPatientAllergyProviderStatusEnum = typeof GetPatientAllergyProviderStatusEnum[keyof typeof GetPatientAllergyProviderStatusEnum];


/**
 * PatientAssessmentControllerApi - axios parameter creator
 * @export
 */
export const PatientAssessmentControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Add a patient assessment.
         * @summary create patient assessment
         * @param {PatientAssessment} patientAssessment 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDepartment: async (patientAssessment: PatientAssessment, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientAssessment' is not null or undefined
            assertParamExists('createDepartment', 'patientAssessment', patientAssessment)
            const localVarPath = `/api/master/patient-assessment`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patientAssessment, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all Patient Assessments list.
         * @summary Get all Patient Assessments.
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {string} [patientId] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllPatientAssessments: async (page?: number, size?: number, sortBy?: string, sortDirection?: string, patientId?: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/master/patient-assessment`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }

            if (patientId !== undefined) {
                localVarQueryParameter['patientId'] = patientId;
            }

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get Default Assessments.
         * @summary Get Default Assessments.
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDefaultAssessments: async (xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/master/patient-assessment/default-assessments`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PatientAssessmentControllerApi - functional programming interface
 * @export
 */
export const PatientAssessmentControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PatientAssessmentControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * Add a patient assessment.
         * @summary create patient assessment
         * @param {PatientAssessment} patientAssessment 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createDepartment(patientAssessment: PatientAssessment, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createDepartment(patientAssessment, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientAssessmentControllerApi.createDepartment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get all Patient Assessments list.
         * @summary Get all Patient Assessments.
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {string} [patientId] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllPatientAssessments(page?: number, size?: number, sortBy?: string, sortDirection?: string, patientId?: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllPatientAssessments(page, size, sortBy, sortDirection, patientId, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientAssessmentControllerApi.getAllPatientAssessments']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get Default Assessments.
         * @summary Get Default Assessments.
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDefaultAssessments(xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDefaultAssessments(xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientAssessmentControllerApi.getDefaultAssessments']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PatientAssessmentControllerApi - factory interface
 * @export
 */
export const PatientAssessmentControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PatientAssessmentControllerApiFp(configuration)
    return {
        /**
         * Add a patient assessment.
         * @summary create patient assessment
         * @param {PatientAssessment} patientAssessment 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDepartment(patientAssessment: PatientAssessment, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.createDepartment(patientAssessment, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all Patient Assessments list.
         * @summary Get all Patient Assessments.
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {string} [patientId] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllPatientAssessments(page?: number, size?: number, sortBy?: string, sortDirection?: string, patientId?: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getAllPatientAssessments(page, size, sortBy, sortDirection, patientId, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Get Default Assessments.
         * @summary Get Default Assessments.
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDefaultAssessments(xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getDefaultAssessments(xTENANTID, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PatientAssessmentControllerApi - object-oriented interface
 * @export
 * @class PatientAssessmentControllerApi
 * @extends {BaseAPI}
 */
export class PatientAssessmentControllerApi extends BaseAPI {
    /**
     * Add a patient assessment.
     * @summary create patient assessment
     * @param {PatientAssessment} patientAssessment 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientAssessmentControllerApi
     */
    public createDepartment(patientAssessment: PatientAssessment, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return PatientAssessmentControllerApiFp(this.configuration).createDepartment(patientAssessment, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all Patient Assessments list.
     * @summary Get all Patient Assessments.
     * @param {number} [page] 
     * @param {number} [size] 
     * @param {string} [sortBy] 
     * @param {string} [sortDirection] 
     * @param {string} [patientId] 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientAssessmentControllerApi
     */
    public getAllPatientAssessments(page?: number, size?: number, sortBy?: string, sortDirection?: string, patientId?: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return PatientAssessmentControllerApiFp(this.configuration).getAllPatientAssessments(page, size, sortBy, sortDirection, patientId, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get Default Assessments.
     * @summary Get Default Assessments.
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientAssessmentControllerApi
     */
    public getDefaultAssessments(xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return PatientAssessmentControllerApiFp(this.configuration).getDefaultAssessments(xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PatientAssessmentControllerXApi - axios parameter creator
 * @export
 */
export const PatientAssessmentControllerXApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Assigns the assessment to a reviewer provider and auto-generates a task with SMS/Email/Push notification to the assignee.
         * @summary Assign Assessment for Review
         * @param {string} assessmentId 
         * @param {string} providerId 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignForReview: async (assessmentId: string, providerId: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'assessmentId' is not null or undefined
            assertParamExists('assignForReview', 'assessmentId', assessmentId)
            // verify required parameter 'providerId' is not null or undefined
            assertParamExists('assignForReview', 'providerId', providerId)
            const localVarPath = `/api/master/patient-assessment/{assessmentId}/assign-for-review/{providerId}`
                .replace(`{${"assessmentId"}}`, encodeURIComponent(String(assessmentId)))
                .replace(`{${"providerId"}}`, encodeURIComponent(String(providerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all patient assessments. Patient ID is optional - if not provided, returns all assessments. Supports search by patient name or MRN.
         * @summary get-all-patientId-assessments
         * @param {string} [patientId] 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {boolean} [scheduled] 
         * @param {boolean} [archive] 
         * @param {string} [sendDate] 
         * @param {string} [submittedDate] 
         * @param {string} [searchString] 
         * @param {string} [screenerType] 
         * @param {string} [sendBy] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllPatientAssessments1: async (patientId?: string, page?: number, size?: number, sortBy?: string, sortDirection?: string, scheduled?: boolean, archive?: boolean, sendDate?: string, submittedDate?: string, searchString?: string, screenerType?: string, sendBy?: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/master/patient-assessment/get-all-assessments`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (patientId !== undefined) {
                localVarQueryParameter['patientId'] = patientId;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }

            if (scheduled !== undefined) {
                localVarQueryParameter['scheduled'] = scheduled;
            }

            if (archive !== undefined) {
                localVarQueryParameter['archive'] = archive;
            }

            if (sendDate !== undefined) {
                localVarQueryParameter['sendDate'] = (sendDate as any instanceof Date) ?
                    (sendDate as any).toISOString() :
                    sendDate;
            }

            if (submittedDate !== undefined) {
                localVarQueryParameter['submittedDate'] = (submittedDate as any instanceof Date) ?
                    (submittedDate as any).toISOString() :
                    submittedDate;
            }

            if (searchString !== undefined) {
                localVarQueryParameter['searchString'] = searchString;
            }

            if (screenerType !== undefined) {
                localVarQueryParameter['screenerType'] = screenerType;
            }

            if (sendBy !== undefined) {
                localVarQueryParameter['sendBy'] = sendBy;
            }

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Edit the schedule time (and optionally screener type / appointment) of a SCHEDULED assessment. Deletes the existing AWS schedule and creates a new one.
         * @summary Reschedule a scheduled assessment
         * @param {string} assessmentUuid 
         * @param {RescheduleAssessmentRequest} rescheduleAssessmentRequest 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rescheduleAssessment: async (assessmentUuid: string, rescheduleAssessmentRequest: RescheduleAssessmentRequest, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'assessmentUuid' is not null or undefined
            assertParamExists('rescheduleAssessment', 'assessmentUuid', assessmentUuid)
            // verify required parameter 'rescheduleAssessmentRequest' is not null or undefined
            assertParamExists('rescheduleAssessment', 'rescheduleAssessmentRequest', rescheduleAssessmentRequest)
            const localVarPath = `/api/master/patient-assessment/schedule/{assessmentUuid}`
                .replace(`{${"assessmentUuid"}}`, encodeURIComponent(String(assessmentUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(rescheduleAssessmentRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Marks the assessment as reviewed and resolves the associated review task.
         * @summary Review Assessment
         * @param {string} assessmentId 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reviewAssessment: async (assessmentId: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'assessmentId' is not null or undefined
            assertParamExists('reviewAssessment', 'assessmentId', assessmentId)
            const localVarPath = `/api/master/patient-assessment/{assessmentId}/review`
                .replace(`{${"assessmentId"}}`, encodeURIComponent(String(assessmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Send assessments to one or multiple patients. Supports multi-select for both patients and assessments.
         * @summary Send Patient Assessments
         * @param {PatientAssessments} patientAssessments 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendAssessment: async (patientAssessments: PatientAssessments, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientAssessments' is not null or undefined
            assertParamExists('sendAssessment', 'patientAssessments', patientAssessments)
            const localVarPath = `/api/master/patient-assessment/sendAssessment`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patientAssessments, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Legacy endpoint: Send assessments to a single patient. Use /sendAssessment for multi-patient support.
         * @summary Send Patient Assessments (Legacy)
         * @param {string} patientId 
         * @param {PatientAssessments} patientAssessments 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendAssessmentLegacy: async (patientId: string, patientAssessments: PatientAssessments, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientId' is not null or undefined
            assertParamExists('sendAssessmentLegacy', 'patientId', patientId)
            // verify required parameter 'patientAssessments' is not null or undefined
            assertParamExists('sendAssessmentLegacy', 'patientAssessments', patientAssessments)
            const localVarPath = `/api/master/patient-assessment/sendAssessment/{patientId}`
                .replace(`{${"patientId"}}`, encodeURIComponent(String(patientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patientAssessments, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Change Patient Assessment archive status to either archived or unarchived.
         * @summary Archive/Unarchive Patient Assessment
         * @param {string} patientAssessmentId 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePatientAssessmentArchiveStatus: async (patientAssessmentId: string, status: boolean, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientAssessmentId' is not null or undefined
            assertParamExists('updatePatientAssessmentArchiveStatus', 'patientAssessmentId', patientAssessmentId)
            // verify required parameter 'status' is not null or undefined
            assertParamExists('updatePatientAssessmentArchiveStatus', 'status', status)
            const localVarPath = `/api/master/patient-assessment/{patientAssessmentId}/archive-status/{status}`
                .replace(`{${"patientAssessmentId"}}`, encodeURIComponent(String(patientAssessmentId)))
                .replace(`{${"status"}}`, encodeURIComponent(String(status)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PatientAssessmentControllerXApi - functional programming interface
 * @export
 */
export const PatientAssessmentControllerXApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PatientAssessmentControllerXApiAxiosParamCreator(configuration)
    return {
        /**
         * Assigns the assessment to a reviewer provider and auto-generates a task with SMS/Email/Push notification to the assignee.
         * @summary Assign Assessment for Review
         * @param {string} assessmentId 
         * @param {string} providerId 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assignForReview(assessmentId: string, providerId: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assignForReview(assessmentId, providerId, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientAssessmentControllerXApi.assignForReview']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get all patient assessments. Patient ID is optional - if not provided, returns all assessments. Supports search by patient name or MRN.
         * @summary get-all-patientId-assessments
         * @param {string} [patientId] 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {boolean} [scheduled] 
         * @param {boolean} [archive] 
         * @param {string} [sendDate] 
         * @param {string} [submittedDate] 
         * @param {string} [searchString] 
         * @param {string} [screenerType] 
         * @param {string} [sendBy] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllPatientAssessments1(patientId?: string, page?: number, size?: number, sortBy?: string, sortDirection?: string, scheduled?: boolean, archive?: boolean, sendDate?: string, submittedDate?: string, searchString?: string, screenerType?: string, sendBy?: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagedModelAssessmentsEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllPatientAssessments1(patientId, page, size, sortBy, sortDirection, scheduled, archive, sendDate, submittedDate, searchString, screenerType, sendBy, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientAssessmentControllerXApi.getAllPatientAssessments1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Edit the schedule time (and optionally screener type / appointment) of a SCHEDULED assessment. Deletes the existing AWS schedule and creates a new one.
         * @summary Reschedule a scheduled assessment
         * @param {string} assessmentUuid 
         * @param {RescheduleAssessmentRequest} rescheduleAssessmentRequest 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async rescheduleAssessment(assessmentUuid: string, rescheduleAssessmentRequest: RescheduleAssessmentRequest, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.rescheduleAssessment(assessmentUuid, rescheduleAssessmentRequest, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientAssessmentControllerXApi.rescheduleAssessment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Marks the assessment as reviewed and resolves the associated review task.
         * @summary Review Assessment
         * @param {string} assessmentId 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reviewAssessment(assessmentId: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reviewAssessment(assessmentId, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientAssessmentControllerXApi.reviewAssessment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Send assessments to one or multiple patients. Supports multi-select for both patients and assessments.
         * @summary Send Patient Assessments
         * @param {PatientAssessments} patientAssessments 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendAssessment(patientAssessments: PatientAssessments, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendAssessment(patientAssessments, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientAssessmentControllerXApi.sendAssessment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Legacy endpoint: Send assessments to a single patient. Use /sendAssessment for multi-patient support.
         * @summary Send Patient Assessments (Legacy)
         * @param {string} patientId 
         * @param {PatientAssessments} patientAssessments 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendAssessmentLegacy(patientId: string, patientAssessments: PatientAssessments, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendAssessmentLegacy(patientId, patientAssessments, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientAssessmentControllerXApi.sendAssessmentLegacy']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Change Patient Assessment archive status to either archived or unarchived.
         * @summary Archive/Unarchive Patient Assessment
         * @param {string} patientAssessmentId 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePatientAssessmentArchiveStatus(patientAssessmentId: string, status: boolean, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePatientAssessmentArchiveStatus(patientAssessmentId, status, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientAssessmentControllerXApi.updatePatientAssessmentArchiveStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PatientAssessmentControllerXApi - factory interface
 * @export
 */
export const PatientAssessmentControllerXApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PatientAssessmentControllerXApiFp(configuration)
    return {
        /**
         * Assigns the assessment to a reviewer provider and auto-generates a task with SMS/Email/Push notification to the assignee.
         * @summary Assign Assessment for Review
         * @param {string} assessmentId 
         * @param {string} providerId 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignForReview(assessmentId: string, providerId: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.assignForReview(assessmentId, providerId, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all patient assessments. Patient ID is optional - if not provided, returns all assessments. Supports search by patient name or MRN.
         * @summary get-all-patientId-assessments
         * @param {string} [patientId] 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {boolean} [scheduled] 
         * @param {boolean} [archive] 
         * @param {string} [sendDate] 
         * @param {string} [submittedDate] 
         * @param {string} [searchString] 
         * @param {string} [screenerType] 
         * @param {string} [sendBy] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllPatientAssessments1(patientId?: string, page?: number, size?: number, sortBy?: string, sortDirection?: string, scheduled?: boolean, archive?: boolean, sendDate?: string, submittedDate?: string, searchString?: string, screenerType?: string, sendBy?: string, xTENANTID?: string, options?: any): AxiosPromise<PagedModelAssessmentsEntity> {
            return localVarFp.getAllPatientAssessments1(patientId, page, size, sortBy, sortDirection, scheduled, archive, sendDate, submittedDate, searchString, screenerType, sendBy, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Edit the schedule time (and optionally screener type / appointment) of a SCHEDULED assessment. Deletes the existing AWS schedule and creates a new one.
         * @summary Reschedule a scheduled assessment
         * @param {string} assessmentUuid 
         * @param {RescheduleAssessmentRequest} rescheduleAssessmentRequest 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rescheduleAssessment(assessmentUuid: string, rescheduleAssessmentRequest: RescheduleAssessmentRequest, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.rescheduleAssessment(assessmentUuid, rescheduleAssessmentRequest, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Marks the assessment as reviewed and resolves the associated review task.
         * @summary Review Assessment
         * @param {string} assessmentId 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reviewAssessment(assessmentId: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.reviewAssessment(assessmentId, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Send assessments to one or multiple patients. Supports multi-select for both patients and assessments.
         * @summary Send Patient Assessments
         * @param {PatientAssessments} patientAssessments 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendAssessment(patientAssessments: PatientAssessments, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.sendAssessment(patientAssessments, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Legacy endpoint: Send assessments to a single patient. Use /sendAssessment for multi-patient support.
         * @summary Send Patient Assessments (Legacy)
         * @param {string} patientId 
         * @param {PatientAssessments} patientAssessments 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendAssessmentLegacy(patientId: string, patientAssessments: PatientAssessments, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.sendAssessmentLegacy(patientId, patientAssessments, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Change Patient Assessment archive status to either archived or unarchived.
         * @summary Archive/Unarchive Patient Assessment
         * @param {string} patientAssessmentId 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePatientAssessmentArchiveStatus(patientAssessmentId: string, status: boolean, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.updatePatientAssessmentArchiveStatus(patientAssessmentId, status, xTENANTID, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PatientAssessmentControllerXApi - object-oriented interface
 * @export
 * @class PatientAssessmentControllerXApi
 * @extends {BaseAPI}
 */
export class PatientAssessmentControllerXApi extends BaseAPI {
    /**
     * Assigns the assessment to a reviewer provider and auto-generates a task with SMS/Email/Push notification to the assignee.
     * @summary Assign Assessment for Review
     * @param {string} assessmentId 
     * @param {string} providerId 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientAssessmentControllerXApi
     */
    public assignForReview(assessmentId: string, providerId: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return PatientAssessmentControllerXApiFp(this.configuration).assignForReview(assessmentId, providerId, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all patient assessments. Patient ID is optional - if not provided, returns all assessments. Supports search by patient name or MRN.
     * @summary get-all-patientId-assessments
     * @param {string} [patientId] 
     * @param {number} [page] 
     * @param {number} [size] 
     * @param {string} [sortBy] 
     * @param {string} [sortDirection] 
     * @param {boolean} [scheduled] 
     * @param {boolean} [archive] 
     * @param {string} [sendDate] 
     * @param {string} [submittedDate] 
     * @param {string} [searchString] 
     * @param {string} [screenerType] 
     * @param {string} [sendBy] 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientAssessmentControllerXApi
     */
    public getAllPatientAssessments1(patientId?: string, page?: number, size?: number, sortBy?: string, sortDirection?: string, scheduled?: boolean, archive?: boolean, sendDate?: string, submittedDate?: string, searchString?: string, screenerType?: string, sendBy?: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return PatientAssessmentControllerXApiFp(this.configuration).getAllPatientAssessments1(patientId, page, size, sortBy, sortDirection, scheduled, archive, sendDate, submittedDate, searchString, screenerType, sendBy, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Edit the schedule time (and optionally screener type / appointment) of a SCHEDULED assessment. Deletes the existing AWS schedule and creates a new one.
     * @summary Reschedule a scheduled assessment
     * @param {string} assessmentUuid 
     * @param {RescheduleAssessmentRequest} rescheduleAssessmentRequest 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientAssessmentControllerXApi
     */
    public rescheduleAssessment(assessmentUuid: string, rescheduleAssessmentRequest: RescheduleAssessmentRequest, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return PatientAssessmentControllerXApiFp(this.configuration).rescheduleAssessment(assessmentUuid, rescheduleAssessmentRequest, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Marks the assessment as reviewed and resolves the associated review task.
     * @summary Review Assessment
     * @param {string} assessmentId 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientAssessmentControllerXApi
     */
    public reviewAssessment(assessmentId: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return PatientAssessmentControllerXApiFp(this.configuration).reviewAssessment(assessmentId, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Send assessments to one or multiple patients. Supports multi-select for both patients and assessments.
     * @summary Send Patient Assessments
     * @param {PatientAssessments} patientAssessments 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientAssessmentControllerXApi
     */
    public sendAssessment(patientAssessments: PatientAssessments, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return PatientAssessmentControllerXApiFp(this.configuration).sendAssessment(patientAssessments, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Legacy endpoint: Send assessments to a single patient. Use /sendAssessment for multi-patient support.
     * @summary Send Patient Assessments (Legacy)
     * @param {string} patientId 
     * @param {PatientAssessments} patientAssessments 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientAssessmentControllerXApi
     */
    public sendAssessmentLegacy(patientId: string, patientAssessments: PatientAssessments, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return PatientAssessmentControllerXApiFp(this.configuration).sendAssessmentLegacy(patientId, patientAssessments, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Change Patient Assessment archive status to either archived or unarchived.
     * @summary Archive/Unarchive Patient Assessment
     * @param {string} patientAssessmentId 
     * @param {boolean} status 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientAssessmentControllerXApi
     */
    public updatePatientAssessmentArchiveStatus(patientAssessmentId: string, status: boolean, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return PatientAssessmentControllerXApiFp(this.configuration).updatePatientAssessmentArchiveStatus(patientAssessmentId, status, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PatientCarePlanControllerApi - axios parameter creator
 * @export
 */
export const PatientCarePlanControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Add a new care plan record into the system
         * @summary Add Patient Care Plan
         * @param {CarePlan} carePlan 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCarePlan: async (carePlan: CarePlan, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'carePlan' is not null or undefined
            assertParamExists('createCarePlan', 'carePlan', carePlan)
            const localVarPath = `/api/master/patient-care-plan`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(carePlan, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve a Care Plan record by its unique ID
         * @summary Get Patient Care Plan by ID
         * @param {string} carePlanId 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCarePlanById: async (carePlanId: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'carePlanId' is not null or undefined
            assertParamExists('getCarePlanById', 'carePlanId', carePlanId)
            const localVarPath = `/api/master/patient-care-plan/{carePlanId}`
                .replace(`{${"carePlanId"}}`, encodeURIComponent(String(carePlanId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all Patient Care Plan records with search and filter options. Supports sorting by: startDate (chronological), endDate (chronological), assignDate (chronological), updatedDate (chronological), createdDate (chronological), title, condition, active, archive.
         * @summary Get Patient Care Plans
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {boolean} [status] 
         * @param {boolean} [archive] 
         * @param {boolean} [current] 
         * @param {string} [patientUuid] 
         * @param {string} [appointmentUuid] 
         * @param {string} [searchString] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCarePlans: async (page?: number, size?: number, sortBy?: string, sortDirection?: string, status?: boolean, archive?: boolean, current?: boolean, patientUuid?: string, appointmentUuid?: string, searchString?: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/master/patient-care-plan`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (archive !== undefined) {
                localVarQueryParameter['archive'] = archive;
            }

            if (current !== undefined) {
                localVarQueryParameter['current'] = current;
            }

            if (patientUuid !== undefined) {
                localVarQueryParameter['patientUuid'] = patientUuid;
            }

            if (appointmentUuid !== undefined) {
                localVarQueryParameter['appointmentUuid'] = appointmentUuid;
            }

            if (searchString !== undefined) {
                localVarQueryParameter['searchString'] = searchString;
            }

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get care plans for patient portal with active=true and archive=false
         * @summary Get Patient Portal Care Plans
         * @param {string} patientUuid 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatientPortalCarePlans: async (patientUuid: string, page?: number, size?: number, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientUuid' is not null or undefined
            assertParamExists('getPatientPortalCarePlans', 'patientUuid', patientUuid)
            const localVarPath = `/api/master/patient-care-plan/patient-portal`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (patientUuid !== undefined) {
                localVarQueryParameter['patientUuid'] = patientUuid;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update an existing Patient Care Plan record
         * @summary Update Patient Care Plan
         * @param {CarePlan} carePlan 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCarePlan: async (carePlan: CarePlan, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'carePlan' is not null or undefined
            assertParamExists('updateCarePlan', 'carePlan', carePlan)
            const localVarPath = `/api/master/patient-care-plan`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(carePlan, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Archive a Patient Care Plan record by its ID
         * @summary Archive Patient Care Plan
         * @param {string} carePlanId 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCarePlanArchiveStatus: async (carePlanId: string, status: boolean, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'carePlanId' is not null or undefined
            assertParamExists('updateCarePlanArchiveStatus', 'carePlanId', carePlanId)
            // verify required parameter 'status' is not null or undefined
            assertParamExists('updateCarePlanArchiveStatus', 'status', status)
            const localVarPath = `/api/master/patient-care-plan/{carePlanId}/archive-status/{status}`
                .replace(`{${"carePlanId"}}`, encodeURIComponent(String(carePlanId)))
                .replace(`{${"status"}}`, encodeURIComponent(String(status)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update the status of a Patient Care Plan record by its ID
         * @summary Update Patient Care Plan Status
         * @param {string} carePlanId 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCarePlanStatus: async (carePlanId: string, status: boolean, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'carePlanId' is not null or undefined
            assertParamExists('updateCarePlanStatus', 'carePlanId', carePlanId)
            // verify required parameter 'status' is not null or undefined
            assertParamExists('updateCarePlanStatus', 'status', status)
            const localVarPath = `/api/master/patient-care-plan/{carePlanId}/status/{status}`
                .replace(`{${"carePlanId"}}`, encodeURIComponent(String(carePlanId)))
                .replace(`{${"status"}}`, encodeURIComponent(String(status)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PatientCarePlanControllerApi - functional programming interface
 * @export
 */
export const PatientCarePlanControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PatientCarePlanControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * Add a new care plan record into the system
         * @summary Add Patient Care Plan
         * @param {CarePlan} carePlan 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createCarePlan(carePlan: CarePlan, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createCarePlan(carePlan, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientCarePlanControllerApi.createCarePlan']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve a Care Plan record by its unique ID
         * @summary Get Patient Care Plan by ID
         * @param {string} carePlanId 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCarePlanById(carePlanId: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCarePlanById(carePlanId, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientCarePlanControllerApi.getCarePlanById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get all Patient Care Plan records with search and filter options. Supports sorting by: startDate (chronological), endDate (chronological), assignDate (chronological), updatedDate (chronological), createdDate (chronological), title, condition, active, archive.
         * @summary Get Patient Care Plans
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {boolean} [status] 
         * @param {boolean} [archive] 
         * @param {boolean} [current] 
         * @param {string} [patientUuid] 
         * @param {string} [appointmentUuid] 
         * @param {string} [searchString] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCarePlans(page?: number, size?: number, sortBy?: string, sortDirection?: string, status?: boolean, archive?: boolean, current?: boolean, patientUuid?: string, appointmentUuid?: string, searchString?: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCarePlans(page, size, sortBy, sortDirection, status, archive, current, patientUuid, appointmentUuid, searchString, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientCarePlanControllerApi.getCarePlans']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get care plans for patient portal with active=true and archive=false
         * @summary Get Patient Portal Care Plans
         * @param {string} patientUuid 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPatientPortalCarePlans(patientUuid: string, page?: number, size?: number, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPatientPortalCarePlans(patientUuid, page, size, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientCarePlanControllerApi.getPatientPortalCarePlans']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update an existing Patient Care Plan record
         * @summary Update Patient Care Plan
         * @param {CarePlan} carePlan 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCarePlan(carePlan: CarePlan, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateCarePlan(carePlan, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientCarePlanControllerApi.updateCarePlan']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Archive a Patient Care Plan record by its ID
         * @summary Archive Patient Care Plan
         * @param {string} carePlanId 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCarePlanArchiveStatus(carePlanId: string, status: boolean, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateCarePlanArchiveStatus(carePlanId, status, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientCarePlanControllerApi.updateCarePlanArchiveStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update the status of a Patient Care Plan record by its ID
         * @summary Update Patient Care Plan Status
         * @param {string} carePlanId 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCarePlanStatus(carePlanId: string, status: boolean, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateCarePlanStatus(carePlanId, status, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientCarePlanControllerApi.updateCarePlanStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PatientCarePlanControllerApi - factory interface
 * @export
 */
export const PatientCarePlanControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PatientCarePlanControllerApiFp(configuration)
    return {
        /**
         * Add a new care plan record into the system
         * @summary Add Patient Care Plan
         * @param {CarePlan} carePlan 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCarePlan(carePlan: CarePlan, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.createCarePlan(carePlan, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve a Care Plan record by its unique ID
         * @summary Get Patient Care Plan by ID
         * @param {string} carePlanId 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCarePlanById(carePlanId: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getCarePlanById(carePlanId, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all Patient Care Plan records with search and filter options. Supports sorting by: startDate (chronological), endDate (chronological), assignDate (chronological), updatedDate (chronological), createdDate (chronological), title, condition, active, archive.
         * @summary Get Patient Care Plans
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {boolean} [status] 
         * @param {boolean} [archive] 
         * @param {boolean} [current] 
         * @param {string} [patientUuid] 
         * @param {string} [appointmentUuid] 
         * @param {string} [searchString] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCarePlans(page?: number, size?: number, sortBy?: string, sortDirection?: string, status?: boolean, archive?: boolean, current?: boolean, patientUuid?: string, appointmentUuid?: string, searchString?: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getCarePlans(page, size, sortBy, sortDirection, status, archive, current, patientUuid, appointmentUuid, searchString, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Get care plans for patient portal with active=true and archive=false
         * @summary Get Patient Portal Care Plans
         * @param {string} patientUuid 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatientPortalCarePlans(patientUuid: string, page?: number, size?: number, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getPatientPortalCarePlans(patientUuid, page, size, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Update an existing Patient Care Plan record
         * @summary Update Patient Care Plan
         * @param {CarePlan} carePlan 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCarePlan(carePlan: CarePlan, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.updateCarePlan(carePlan, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Archive a Patient Care Plan record by its ID
         * @summary Archive Patient Care Plan
         * @param {string} carePlanId 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCarePlanArchiveStatus(carePlanId: string, status: boolean, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.updateCarePlanArchiveStatus(carePlanId, status, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Update the status of a Patient Care Plan record by its ID
         * @summary Update Patient Care Plan Status
         * @param {string} carePlanId 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCarePlanStatus(carePlanId: string, status: boolean, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.updateCarePlanStatus(carePlanId, status, xTENANTID, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PatientCarePlanControllerApi - object-oriented interface
 * @export
 * @class PatientCarePlanControllerApi
 * @extends {BaseAPI}
 */
export class PatientCarePlanControllerApi extends BaseAPI {
    /**
     * Add a new care plan record into the system
     * @summary Add Patient Care Plan
     * @param {CarePlan} carePlan 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientCarePlanControllerApi
     */
    public createCarePlan(carePlan: CarePlan, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return PatientCarePlanControllerApiFp(this.configuration).createCarePlan(carePlan, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve a Care Plan record by its unique ID
     * @summary Get Patient Care Plan by ID
     * @param {string} carePlanId 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientCarePlanControllerApi
     */
    public getCarePlanById(carePlanId: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return PatientCarePlanControllerApiFp(this.configuration).getCarePlanById(carePlanId, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all Patient Care Plan records with search and filter options. Supports sorting by: startDate (chronological), endDate (chronological), assignDate (chronological), updatedDate (chronological), createdDate (chronological), title, condition, active, archive.
     * @summary Get Patient Care Plans
     * @param {number} [page] 
     * @param {number} [size] 
     * @param {string} [sortBy] 
     * @param {string} [sortDirection] 
     * @param {boolean} [status] 
     * @param {boolean} [archive] 
     * @param {boolean} [current] 
     * @param {string} [patientUuid] 
     * @param {string} [appointmentUuid] 
     * @param {string} [searchString] 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientCarePlanControllerApi
     */
    public getCarePlans(page?: number, size?: number, sortBy?: string, sortDirection?: string, status?: boolean, archive?: boolean, current?: boolean, patientUuid?: string, appointmentUuid?: string, searchString?: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return PatientCarePlanControllerApiFp(this.configuration).getCarePlans(page, size, sortBy, sortDirection, status, archive, current, patientUuid, appointmentUuid, searchString, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get care plans for patient portal with active=true and archive=false
     * @summary Get Patient Portal Care Plans
     * @param {string} patientUuid 
     * @param {number} [page] 
     * @param {number} [size] 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientCarePlanControllerApi
     */
    public getPatientPortalCarePlans(patientUuid: string, page?: number, size?: number, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return PatientCarePlanControllerApiFp(this.configuration).getPatientPortalCarePlans(patientUuid, page, size, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update an existing Patient Care Plan record
     * @summary Update Patient Care Plan
     * @param {CarePlan} carePlan 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientCarePlanControllerApi
     */
    public updateCarePlan(carePlan: CarePlan, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return PatientCarePlanControllerApiFp(this.configuration).updateCarePlan(carePlan, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Archive a Patient Care Plan record by its ID
     * @summary Archive Patient Care Plan
     * @param {string} carePlanId 
     * @param {boolean} status 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientCarePlanControllerApi
     */
    public updateCarePlanArchiveStatus(carePlanId: string, status: boolean, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return PatientCarePlanControllerApiFp(this.configuration).updateCarePlanArchiveStatus(carePlanId, status, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update the status of a Patient Care Plan record by its ID
     * @summary Update Patient Care Plan Status
     * @param {string} carePlanId 
     * @param {boolean} status 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientCarePlanControllerApi
     */
    public updateCarePlanStatus(carePlanId: string, status: boolean, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return PatientCarePlanControllerApiFp(this.configuration).updateCarePlanStatus(carePlanId, status, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PatientControllerApi - axios parameter creator
 * @export
 */
export const PatientControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Accept or reject a referral patient
         * @summary Accept or Reject Referral
         * @param {string} patientId 
         * @param {string} referralUuid 
         * @param {AcceptReferralReferralStatusEnum} referralStatus 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        acceptReferral: async (patientId: string, referralUuid: string, referralStatus: AcceptReferralReferralStatusEnum, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientId' is not null or undefined
            assertParamExists('acceptReferral', 'patientId', patientId)
            // verify required parameter 'referralUuid' is not null or undefined
            assertParamExists('acceptReferral', 'referralUuid', referralUuid)
            // verify required parameter 'referralStatus' is not null or undefined
            assertParamExists('acceptReferral', 'referralStatus', referralStatus)
            const localVarPath = `/api/master/patient/accept-referral/{patientId}`
                .replace(`{${"patientId"}}`, encodeURIComponent(String(patientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (referralUuid !== undefined) {
                localVarQueryParameter['referralUuid'] = referralUuid;
            }

            if (referralStatus !== undefined) {
                localVarQueryParameter['referralStatus'] = referralStatus;
            }

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Change patient avatar
         * @summary Change Avatar
         * @param {ChangeAvatarRequest} changeAvatarRequest 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeAvatar2: async (changeAvatarRequest: ChangeAvatarRequest, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'changeAvatarRequest' is not null or undefined
            assertParamExists('changeAvatar2', 'changeAvatarRequest', changeAvatarRequest)
            const localVarPath = `/api/master/patient/change-patient-avatar`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(changeAvatarRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Public endpoint for a new patient to widget-register via the registration.
         * @summary widget Patient Registration
         * @param {WidgetPatient} widgetPatient 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createNewPatientRegistration: async (widgetPatient: WidgetPatient, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'widgetPatient' is not null or undefined
            assertParamExists('createNewPatientRegistration', 'widgetPatient', widgetPatient)
            const localVarPath = `/api/master/patient/widget-patient`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(widgetPatient, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Add a new Patient User into the system
         * @summary Add Patient User
         * @param {Patient} patient 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPatient: async (patient: Patient, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patient' is not null or undefined
            assertParamExists('createPatient', 'patient', patient)
            const localVarPath = `/api/master/patient`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patient, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Export all patient data.
         * @summary Export all patient data
         * @param {ExportPatientExportTypeEnum} exportType 
         * @param {Array<string>} requestBody 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportPatient: async (exportType: ExportPatientExportTypeEnum, requestBody: Array<string>, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'exportType' is not null or undefined
            assertParamExists('exportPatient', 'exportType', exportType)
            // verify required parameter 'requestBody' is not null or undefined
            assertParamExists('exportPatient', 'requestBody', requestBody)
            const localVarPath = `/api/master/patient/export/{exportType}`
                .replace(`{${"exportType"}}`, encodeURIComponent(String(exportType)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all patient list with search option on firstName, lastName. 
         * @summary Get all patient
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {boolean} [status] 
         * @param {boolean} [archive] 
         * @param {string} [locationUuid] 
         * @param {string} [providerUuid] 
         * @param {Array<string>} [referringAgencyUuid] 
         * @param {string} [ssn] 
         * @param {string} [phone] 
         * @param {string} [ageFilterCategory] 
         * @param {number} [ageFilterValue] 
         * @param {string} [dateOfBirth] 
         * @param {boolean} [isReferral] 
         * @param {string} [searchString] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllPatient: async (page?: number, size?: number, sortBy?: string, sortDirection?: string, status?: boolean, archive?: boolean, locationUuid?: string, providerUuid?: string, referringAgencyUuid?: Array<string>, ssn?: string, phone?: string, ageFilterCategory?: string, ageFilterValue?: number, dateOfBirth?: string, isReferral?: boolean, searchString?: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/master/patient`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (archive !== undefined) {
                localVarQueryParameter['archive'] = archive;
            }

            if (locationUuid !== undefined) {
                localVarQueryParameter['locationUuid'] = locationUuid;
            }

            if (providerUuid !== undefined) {
                localVarQueryParameter['providerUuid'] = providerUuid;
            }

            if (referringAgencyUuid) {
                localVarQueryParameter['referringAgencyUuid'] = referringAgencyUuid;
            }

            if (ssn !== undefined) {
                localVarQueryParameter['ssn'] = ssn;
            }

            if (phone !== undefined) {
                localVarQueryParameter['phone'] = phone;
            }

            if (ageFilterCategory !== undefined) {
                localVarQueryParameter['ageFilterCategory'] = ageFilterCategory;
            }

            if (ageFilterValue !== undefined) {
                localVarQueryParameter['ageFilterValue'] = ageFilterValue;
            }

            if (dateOfBirth !== undefined) {
                localVarQueryParameter['dateOfBirth'] = (dateOfBirth as any instanceof Date) ?
                    (dateOfBirth as any).toISOString() :
                    dateOfBirth;
            }

            if (isReferral !== undefined) {
                localVarQueryParameter['isReferral'] = isReferral;
            }

            if (searchString !== undefined) {
                localVarQueryParameter['searchString'] = searchString;
            }

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all patient record. 
         * @summary Get all patient record
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {string} [searchString] 
         * @param {boolean} [unreadOnly] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllPatientForSmsRecord: async (page?: number, size?: number, sortBy?: string, sortDirection?: string, searchString?: string, unreadOnly?: boolean, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/master/patient/patient-sms-record`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }

            if (searchString !== undefined) {
                localVarQueryParameter['searchString'] = searchString;
            }

            if (unreadOnly !== undefined) {
                localVarQueryParameter['unreadOnly'] = unreadOnly;
            }

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all patient list with search option on firstName, lastName 
         * @summary Get all patient list
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {boolean} [isReferral] 
         * @param {string} [searchString] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllPatients: async (page?: number, size?: number, sortBy?: string, sortDirection?: string, isReferral?: boolean, searchString?: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/master/patient/patient-search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }

            if (isReferral !== undefined) {
                localVarQueryParameter['isReferral'] = isReferral;
            }

            if (searchString !== undefined) {
                localVarQueryParameter['searchString'] = searchString;
            }

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Lightweight patient list returning only uuid, name and eCareHealth patient id.
         * @summary Get all patients lightweight
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [searchString] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllPatientsLight: async (page?: number, size?: number, searchString?: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/master/patient/patient-list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (searchString !== undefined) {
                localVarQueryParameter['searchString'] = searchString;
            }

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns insurance verification fields for a patient
         * @summary Get patient insurance detail
         * @param {string} patientUuid 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInsuranceDetail: async (patientUuid: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientUuid' is not null or undefined
            assertParamExists('getInsuranceDetail', 'patientUuid', patientUuid)
            const localVarPath = `/api/master/patient/insurance-detail/{patientUuid}`
                .replace(`{${"patientUuid"}}`, encodeURIComponent(String(patientUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get patient by patientUuid
         * @summary Get patient by patientUuid.
         * @param {string} patientUuid 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatientById1: async (patientUuid: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientUuid' is not null or undefined
            assertParamExists('getPatientById1', 'patientUuid', patientUuid)
            const localVarPath = `/api/master/patient/{patientUuid}`
                .replace(`{${"patientUuid"}}`, encodeURIComponent(String(patientUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get patient by card detail by patient id
         * @summary Get patient by card details.
         * @param {string} patientUuid 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatientDetailForCardView: async (patientUuid: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientUuid' is not null or undefined
            assertParamExists('getPatientDetailForCardView', 'patientUuid', patientUuid)
            const localVarPath = `/api/master/patient/card-view/{patientUuid}`
                .replace(`{${"patientUuid"}}`, encodeURIComponent(String(patientUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get lightweight patient list with essential fields only.
         * @summary Get patient list (lightweight)
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {boolean} [status] 
         * @param {boolean} [archive] 
         * @param {boolean} [isReferral] 
         * @param {string} [searchString] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatientList: async (page?: number, size?: number, sortBy?: string, sortDirection?: string, status?: boolean, archive?: boolean, isReferral?: boolean, searchString?: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/master/patient/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (archive !== undefined) {
                localVarQueryParameter['archive'] = archive;
            }

            if (isReferral !== undefined) {
                localVarQueryParameter['isReferral'] = isReferral;
            }

            if (searchString !== undefined) {
                localVarQueryParameter['searchString'] = searchString;
            }

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get patient unread sms count.
         * @summary Get patient unread sms count
         * @param {string} patientId 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatientUnreadSmsCount: async (patientId: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientId' is not null or undefined
            assertParamExists('getPatientUnreadSmsCount', 'patientId', patientId)
            const localVarPath = `/api/master/patient/unread-sms/{patientId}`
                .replace(`{${"patientId"}}`, encodeURIComponent(String(patientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get patient profile
         * @summary Get patient profile
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProfile2: async (xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/master/patient/profile`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Generate Twilio access token for patient voice calls
         * @summary Get Twilio token for voice calls
         * @param {string} patientId 
         * @param {string} [scheduleId] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTwilioToken: async (patientId: string, scheduleId?: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientId' is not null or undefined
            assertParamExists('getTwilioToken', 'patientId', patientId)
            const localVarPath = `/api/master/patient/get-token`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (patientId !== undefined) {
                localVarQueryParameter['patient_id'] = patientId;
            }

            if (scheduleId !== undefined) {
                localVarQueryParameter['schedule_id'] = scheduleId;
            }

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Receive the sms from Twilio webhook
         * @summary Receive Sms
         * @param {string} xTenantId 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {string} [body] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        receiveSMS: async (xTenantId: string, from?: string, to?: string, body?: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'xTenantId' is not null or undefined
            assertParamExists('receiveSMS', 'xTenantId', xTenantId)
            const localVarPath = `/api/master/patient/twilio-incoming-sms`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTenantId !== undefined) {
                localVarQueryParameter['x_tenant_id'] = xTenantId;
            }

            if (from !== undefined) {
                localVarQueryParameter['From'] = from;
            }

            if (to !== undefined) {
                localVarQueryParameter['To'] = to;
            }

            if (body !== undefined) {
                localVarQueryParameter['Body'] = body;
            }

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Send email to patients.
         * @summary Send email to patients
         * @param {EmailToPatient} emailToPatient 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendEmailToPatientId: async (emailToPatient: EmailToPatient, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'emailToPatient' is not null or undefined
            assertParamExists('sendEmailToPatientId', 'emailToPatient', emailToPatient)
            const localVarPath = `/api/master/patient/send-email`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(emailToPatient, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Send email with optional attachment to a given email address.
         * @summary Send email with attachment
         * @param {string} toEmail 
         * @param {string} fromEmail 
         * @param {string} subject 
         * @param {string} description 
         * @param {string} [xTENANTID] 
         * @param {File} [attachment] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendEmailWithAttachment: async (toEmail: string, fromEmail: string, subject: string, description: string, xTENANTID?: string, attachment?: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'toEmail' is not null or undefined
            assertParamExists('sendEmailWithAttachment', 'toEmail', toEmail)
            // verify required parameter 'fromEmail' is not null or undefined
            assertParamExists('sendEmailWithAttachment', 'fromEmail', fromEmail)
            // verify required parameter 'subject' is not null or undefined
            assertParamExists('sendEmailWithAttachment', 'subject', subject)
            // verify required parameter 'description' is not null or undefined
            assertParamExists('sendEmailWithAttachment', 'description', description)
            const localVarPath = `/api/master/patient/send-email-with-attachment`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (toEmail !== undefined) {
                localVarQueryParameter['toEmail'] = toEmail;
            }

            if (fromEmail !== undefined) {
                localVarQueryParameter['fromEmail'] = fromEmail;
            }

            if (subject !== undefined) {
                localVarQueryParameter['subject'] = subject;
            }

            if (description !== undefined) {
                localVarQueryParameter['description'] = description;
            }

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


            if (attachment !== undefined) { 
                localVarFormParams.append('attachment', attachment as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Send sms to patients.
         * @summary Send Sms to patients
         * @param {EmailToPatient} emailToPatient 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendSMSToPatientId: async (emailToPatient: EmailToPatient, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'emailToPatient' is not null or undefined
            assertParamExists('sendSMSToPatientId', 'emailToPatient', emailToPatient)
            const localVarPath = `/api/master/patient/send-sms`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(emailToPatient, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Edit Patient with editable fields as firstName, lastName, phone.
         * @summary Update patient
         * @param {Patient} patient 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePatient: async (patient: Patient, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patient' is not null or undefined
            assertParamExists('updatePatient', 'patient', patient)
            const localVarPath = `/api/master/patient`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patient, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Change Patient archive status to either archived or unarchived.
         * @summary Archive/Unarchive Patient
         * @param {string} patientId 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePatientArchiveStatus: async (patientId: string, status: boolean, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientId' is not null or undefined
            assertParamExists('updatePatientArchiveStatus', 'patientId', patientId)
            // verify required parameter 'status' is not null or undefined
            assertParamExists('updatePatientArchiveStatus', 'status', status)
            const localVarPath = `/api/master/patient/{patientId}/archive-status/{status}`
                .replace(`{${"patientId"}}`, encodeURIComponent(String(patientId)))
                .replace(`{${"status"}}`, encodeURIComponent(String(status)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Enable or disable patient portal access for a patient
         * @summary Update patient portal access
         * @param {string} patientUuid 
         * @param {boolean} access 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePatientPortalAccess: async (patientUuid: string, access: boolean, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientUuid' is not null or undefined
            assertParamExists('updatePatientPortalAccess', 'patientUuid', patientUuid)
            // verify required parameter 'access' is not null or undefined
            assertParamExists('updatePatientPortalAccess', 'access', access)
            const localVarPath = `/api/master/patient/{patientUuid}/portal-access`
                .replace(`{${"patientUuid"}}`, encodeURIComponent(String(patientUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (access !== undefined) {
                localVarQueryParameter['access'] = access;
            }

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Change Patient status to either active or inactive.
         * @summary Enable/Disable patient
         * @param {string} patientId 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePatientStatus: async (patientId: string, status: boolean, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientId' is not null or undefined
            assertParamExists('updatePatientStatus', 'patientId', patientId)
            // verify required parameter 'status' is not null or undefined
            assertParamExists('updatePatientStatus', 'status', status)
            const localVarPath = `/api/master/patient/{patientId}/status/{status}`
                .replace(`{${"patientId"}}`, encodeURIComponent(String(patientId)))
                .replace(`{${"status"}}`, encodeURIComponent(String(status)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Return true if patient UUID and DOB match
         * @summary Validate patient\'s DOB
         * @param {string} patientId 
         * @param {string} dob 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validatePatientDob: async (patientId: string, dob: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientId' is not null or undefined
            assertParamExists('validatePatientDob', 'patientId', patientId)
            // verify required parameter 'dob' is not null or undefined
            assertParamExists('validatePatientDob', 'dob', dob)
            const localVarPath = `/api/master/patient/{patientId}/validate-dob`
                .replace(`{${"patientId"}}`, encodeURIComponent(String(patientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (dob !== undefined) {
                localVarQueryParameter['dob'] = (dob as any instanceof Date) ?
                    (dob as any).toISOString().substring(0,10) :
                    dob;
            }

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PatientControllerApi - functional programming interface
 * @export
 */
export const PatientControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PatientControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * Accept or reject a referral patient
         * @summary Accept or Reject Referral
         * @param {string} patientId 
         * @param {string} referralUuid 
         * @param {AcceptReferralReferralStatusEnum} referralStatus 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async acceptReferral(patientId: string, referralUuid: string, referralStatus: AcceptReferralReferralStatusEnum, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.acceptReferral(patientId, referralUuid, referralStatus, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientControllerApi.acceptReferral']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Change patient avatar
         * @summary Change Avatar
         * @param {ChangeAvatarRequest} changeAvatarRequest 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async changeAvatar2(changeAvatarRequest: ChangeAvatarRequest, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.changeAvatar2(changeAvatarRequest, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientControllerApi.changeAvatar2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Public endpoint for a new patient to widget-register via the registration.
         * @summary widget Patient Registration
         * @param {WidgetPatient} widgetPatient 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createNewPatientRegistration(widgetPatient: WidgetPatient, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createNewPatientRegistration(widgetPatient, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientControllerApi.createNewPatientRegistration']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Add a new Patient User into the system
         * @summary Add Patient User
         * @param {Patient} patient 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createPatient(patient: Patient, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createPatient(patient, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientControllerApi.createPatient']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Export all patient data.
         * @summary Export all patient data
         * @param {ExportPatientExportTypeEnum} exportType 
         * @param {Array<string>} requestBody 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exportPatient(exportType: ExportPatientExportTypeEnum, requestBody: Array<string>, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.exportPatient(exportType, requestBody, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientControllerApi.exportPatient']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get all patient list with search option on firstName, lastName. 
         * @summary Get all patient
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {boolean} [status] 
         * @param {boolean} [archive] 
         * @param {string} [locationUuid] 
         * @param {string} [providerUuid] 
         * @param {Array<string>} [referringAgencyUuid] 
         * @param {string} [ssn] 
         * @param {string} [phone] 
         * @param {string} [ageFilterCategory] 
         * @param {number} [ageFilterValue] 
         * @param {string} [dateOfBirth] 
         * @param {boolean} [isReferral] 
         * @param {string} [searchString] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllPatient(page?: number, size?: number, sortBy?: string, sortDirection?: string, status?: boolean, archive?: boolean, locationUuid?: string, providerUuid?: string, referringAgencyUuid?: Array<string>, ssn?: string, phone?: string, ageFilterCategory?: string, ageFilterValue?: number, dateOfBirth?: string, isReferral?: boolean, searchString?: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllPatient(page, size, sortBy, sortDirection, status, archive, locationUuid, providerUuid, referringAgencyUuid, ssn, phone, ageFilterCategory, ageFilterValue, dateOfBirth, isReferral, searchString, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientControllerApi.getAllPatient']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get all patient record. 
         * @summary Get all patient record
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {string} [searchString] 
         * @param {boolean} [unreadOnly] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllPatientForSmsRecord(page?: number, size?: number, sortBy?: string, sortDirection?: string, searchString?: string, unreadOnly?: boolean, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllPatientForSmsRecord(page, size, sortBy, sortDirection, searchString, unreadOnly, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientControllerApi.getAllPatientForSmsRecord']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get all patient list with search option on firstName, lastName 
         * @summary Get all patient list
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {boolean} [isReferral] 
         * @param {string} [searchString] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllPatients(page?: number, size?: number, sortBy?: string, sortDirection?: string, isReferral?: boolean, searchString?: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllPatients(page, size, sortBy, sortDirection, isReferral, searchString, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientControllerApi.getAllPatients']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Lightweight patient list returning only uuid, name and eCareHealth patient id.
         * @summary Get all patients lightweight
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [searchString] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllPatientsLight(page?: number, size?: number, searchString?: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllPatientsLight(page, size, searchString, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientControllerApi.getAllPatientsLight']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns insurance verification fields for a patient
         * @summary Get patient insurance detail
         * @param {string} patientUuid 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getInsuranceDetail(patientUuid: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getInsuranceDetail(patientUuid, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientControllerApi.getInsuranceDetail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get patient by patientUuid
         * @summary Get patient by patientUuid.
         * @param {string} patientUuid 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPatientById1(patientUuid: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPatientById1(patientUuid, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientControllerApi.getPatientById1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get patient by card detail by patient id
         * @summary Get patient by card details.
         * @param {string} patientUuid 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPatientDetailForCardView(patientUuid: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPatientDetailForCardView(patientUuid, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientControllerApi.getPatientDetailForCardView']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get lightweight patient list with essential fields only.
         * @summary Get patient list (lightweight)
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {boolean} [status] 
         * @param {boolean} [archive] 
         * @param {boolean} [isReferral] 
         * @param {string} [searchString] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPatientList(page?: number, size?: number, sortBy?: string, sortDirection?: string, status?: boolean, archive?: boolean, isReferral?: boolean, searchString?: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPatientList(page, size, sortBy, sortDirection, status, archive, isReferral, searchString, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientControllerApi.getPatientList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get patient unread sms count.
         * @summary Get patient unread sms count
         * @param {string} patientId 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPatientUnreadSmsCount(patientId: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPatientUnreadSmsCount(patientId, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientControllerApi.getPatientUnreadSmsCount']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get patient profile
         * @summary Get patient profile
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProfile2(xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProfile2(xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientControllerApi.getProfile2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Generate Twilio access token for patient voice calls
         * @summary Get Twilio token for voice calls
         * @param {string} patientId 
         * @param {string} [scheduleId] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTwilioToken(patientId: string, scheduleId?: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTwilioToken(patientId, scheduleId, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientControllerApi.getTwilioToken']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Receive the sms from Twilio webhook
         * @summary Receive Sms
         * @param {string} xTenantId 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {string} [body] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async receiveSMS(xTenantId: string, from?: string, to?: string, body?: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.receiveSMS(xTenantId, from, to, body, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientControllerApi.receiveSMS']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Send email to patients.
         * @summary Send email to patients
         * @param {EmailToPatient} emailToPatient 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendEmailToPatientId(emailToPatient: EmailToPatient, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendEmailToPatientId(emailToPatient, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientControllerApi.sendEmailToPatientId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Send email with optional attachment to a given email address.
         * @summary Send email with attachment
         * @param {string} toEmail 
         * @param {string} fromEmail 
         * @param {string} subject 
         * @param {string} description 
         * @param {string} [xTENANTID] 
         * @param {File} [attachment] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendEmailWithAttachment(toEmail: string, fromEmail: string, subject: string, description: string, xTENANTID?: string, attachment?: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendEmailWithAttachment(toEmail, fromEmail, subject, description, xTENANTID, attachment, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientControllerApi.sendEmailWithAttachment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Send sms to patients.
         * @summary Send Sms to patients
         * @param {EmailToPatient} emailToPatient 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendSMSToPatientId(emailToPatient: EmailToPatient, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendSMSToPatientId(emailToPatient, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientControllerApi.sendSMSToPatientId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Edit Patient with editable fields as firstName, lastName, phone.
         * @summary Update patient
         * @param {Patient} patient 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePatient(patient: Patient, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePatient(patient, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientControllerApi.updatePatient']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Change Patient archive status to either archived or unarchived.
         * @summary Archive/Unarchive Patient
         * @param {string} patientId 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePatientArchiveStatus(patientId: string, status: boolean, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePatientArchiveStatus(patientId, status, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientControllerApi.updatePatientArchiveStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Enable or disable patient portal access for a patient
         * @summary Update patient portal access
         * @param {string} patientUuid 
         * @param {boolean} access 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePatientPortalAccess(patientUuid: string, access: boolean, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePatientPortalAccess(patientUuid, access, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientControllerApi.updatePatientPortalAccess']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Change Patient status to either active or inactive.
         * @summary Enable/Disable patient
         * @param {string} patientId 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePatientStatus(patientId: string, status: boolean, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePatientStatus(patientId, status, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientControllerApi.updatePatientStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Return true if patient UUID and DOB match
         * @summary Validate patient\'s DOB
         * @param {string} patientId 
         * @param {string} dob 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async validatePatientDob(patientId: string, dob: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.validatePatientDob(patientId, dob, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientControllerApi.validatePatientDob']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PatientControllerApi - factory interface
 * @export
 */
export const PatientControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PatientControllerApiFp(configuration)
    return {
        /**
         * Accept or reject a referral patient
         * @summary Accept or Reject Referral
         * @param {string} patientId 
         * @param {string} referralUuid 
         * @param {AcceptReferralReferralStatusEnum} referralStatus 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        acceptReferral(patientId: string, referralUuid: string, referralStatus: AcceptReferralReferralStatusEnum, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.acceptReferral(patientId, referralUuid, referralStatus, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Change patient avatar
         * @summary Change Avatar
         * @param {ChangeAvatarRequest} changeAvatarRequest 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeAvatar2(changeAvatarRequest: ChangeAvatarRequest, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.changeAvatar2(changeAvatarRequest, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Public endpoint for a new patient to widget-register via the registration.
         * @summary widget Patient Registration
         * @param {WidgetPatient} widgetPatient 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createNewPatientRegistration(widgetPatient: WidgetPatient, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.createNewPatientRegistration(widgetPatient, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Add a new Patient User into the system
         * @summary Add Patient User
         * @param {Patient} patient 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPatient(patient: Patient, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.createPatient(patient, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Export all patient data.
         * @summary Export all patient data
         * @param {ExportPatientExportTypeEnum} exportType 
         * @param {Array<string>} requestBody 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportPatient(exportType: ExportPatientExportTypeEnum, requestBody: Array<string>, xTENANTID?: string, options?: any): AxiosPromise<object> {
            return localVarFp.exportPatient(exportType, requestBody, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all patient list with search option on firstName, lastName. 
         * @summary Get all patient
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {boolean} [status] 
         * @param {boolean} [archive] 
         * @param {string} [locationUuid] 
         * @param {string} [providerUuid] 
         * @param {Array<string>} [referringAgencyUuid] 
         * @param {string} [ssn] 
         * @param {string} [phone] 
         * @param {string} [ageFilterCategory] 
         * @param {number} [ageFilterValue] 
         * @param {string} [dateOfBirth] 
         * @param {boolean} [isReferral] 
         * @param {string} [searchString] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllPatient(page?: number, size?: number, sortBy?: string, sortDirection?: string, status?: boolean, archive?: boolean, locationUuid?: string, providerUuid?: string, referringAgencyUuid?: Array<string>, ssn?: string, phone?: string, ageFilterCategory?: string, ageFilterValue?: number, dateOfBirth?: string, isReferral?: boolean, searchString?: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getAllPatient(page, size, sortBy, sortDirection, status, archive, locationUuid, providerUuid, referringAgencyUuid, ssn, phone, ageFilterCategory, ageFilterValue, dateOfBirth, isReferral, searchString, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all patient record. 
         * @summary Get all patient record
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {string} [searchString] 
         * @param {boolean} [unreadOnly] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllPatientForSmsRecord(page?: number, size?: number, sortBy?: string, sortDirection?: string, searchString?: string, unreadOnly?: boolean, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getAllPatientForSmsRecord(page, size, sortBy, sortDirection, searchString, unreadOnly, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all patient list with search option on firstName, lastName 
         * @summary Get all patient list
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {boolean} [isReferral] 
         * @param {string} [searchString] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllPatients(page?: number, size?: number, sortBy?: string, sortDirection?: string, isReferral?: boolean, searchString?: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getAllPatients(page, size, sortBy, sortDirection, isReferral, searchString, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Lightweight patient list returning only uuid, name and eCareHealth patient id.
         * @summary Get all patients lightweight
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [searchString] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllPatientsLight(page?: number, size?: number, searchString?: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getAllPatientsLight(page, size, searchString, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns insurance verification fields for a patient
         * @summary Get patient insurance detail
         * @param {string} patientUuid 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInsuranceDetail(patientUuid: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getInsuranceDetail(patientUuid, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Get patient by patientUuid
         * @summary Get patient by patientUuid.
         * @param {string} patientUuid 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatientById1(patientUuid: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getPatientById1(patientUuid, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Get patient by card detail by patient id
         * @summary Get patient by card details.
         * @param {string} patientUuid 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatientDetailForCardView(patientUuid: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getPatientDetailForCardView(patientUuid, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Get lightweight patient list with essential fields only.
         * @summary Get patient list (lightweight)
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {boolean} [status] 
         * @param {boolean} [archive] 
         * @param {boolean} [isReferral] 
         * @param {string} [searchString] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatientList(page?: number, size?: number, sortBy?: string, sortDirection?: string, status?: boolean, archive?: boolean, isReferral?: boolean, searchString?: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getPatientList(page, size, sortBy, sortDirection, status, archive, isReferral, searchString, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Get patient unread sms count.
         * @summary Get patient unread sms count
         * @param {string} patientId 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatientUnreadSmsCount(patientId: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getPatientUnreadSmsCount(patientId, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Get patient profile
         * @summary Get patient profile
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProfile2(xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getProfile2(xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Generate Twilio access token for patient voice calls
         * @summary Get Twilio token for voice calls
         * @param {string} patientId 
         * @param {string} [scheduleId] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTwilioToken(patientId: string, scheduleId?: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getTwilioToken(patientId, scheduleId, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Receive the sms from Twilio webhook
         * @summary Receive Sms
         * @param {string} xTenantId 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {string} [body] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        receiveSMS(xTenantId: string, from?: string, to?: string, body?: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.receiveSMS(xTenantId, from, to, body, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Send email to patients.
         * @summary Send email to patients
         * @param {EmailToPatient} emailToPatient 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendEmailToPatientId(emailToPatient: EmailToPatient, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.sendEmailToPatientId(emailToPatient, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Send email with optional attachment to a given email address.
         * @summary Send email with attachment
         * @param {string} toEmail 
         * @param {string} fromEmail 
         * @param {string} subject 
         * @param {string} description 
         * @param {string} [xTENANTID] 
         * @param {File} [attachment] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendEmailWithAttachment(toEmail: string, fromEmail: string, subject: string, description: string, xTENANTID?: string, attachment?: File, options?: any): AxiosPromise<Response> {
            return localVarFp.sendEmailWithAttachment(toEmail, fromEmail, subject, description, xTENANTID, attachment, options).then((request) => request(axios, basePath));
        },
        /**
         * Send sms to patients.
         * @summary Send Sms to patients
         * @param {EmailToPatient} emailToPatient 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendSMSToPatientId(emailToPatient: EmailToPatient, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.sendSMSToPatientId(emailToPatient, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Edit Patient with editable fields as firstName, lastName, phone.
         * @summary Update patient
         * @param {Patient} patient 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePatient(patient: Patient, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.updatePatient(patient, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Change Patient archive status to either archived or unarchived.
         * @summary Archive/Unarchive Patient
         * @param {string} patientId 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePatientArchiveStatus(patientId: string, status: boolean, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.updatePatientArchiveStatus(patientId, status, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Enable or disable patient portal access for a patient
         * @summary Update patient portal access
         * @param {string} patientUuid 
         * @param {boolean} access 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePatientPortalAccess(patientUuid: string, access: boolean, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.updatePatientPortalAccess(patientUuid, access, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Change Patient status to either active or inactive.
         * @summary Enable/Disable patient
         * @param {string} patientId 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePatientStatus(patientId: string, status: boolean, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.updatePatientStatus(patientId, status, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Return true if patient UUID and DOB match
         * @summary Validate patient\'s DOB
         * @param {string} patientId 
         * @param {string} dob 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validatePatientDob(patientId: string, dob: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.validatePatientDob(patientId, dob, xTENANTID, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PatientControllerApi - object-oriented interface
 * @export
 * @class PatientControllerApi
 * @extends {BaseAPI}
 */
export class PatientControllerApi extends BaseAPI {
    /**
     * Accept or reject a referral patient
     * @summary Accept or Reject Referral
     * @param {string} patientId 
     * @param {string} referralUuid 
     * @param {AcceptReferralReferralStatusEnum} referralStatus 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientControllerApi
     */
    public acceptReferral(patientId: string, referralUuid: string, referralStatus: AcceptReferralReferralStatusEnum, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return PatientControllerApiFp(this.configuration).acceptReferral(patientId, referralUuid, referralStatus, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Change patient avatar
     * @summary Change Avatar
     * @param {ChangeAvatarRequest} changeAvatarRequest 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientControllerApi
     */
    public changeAvatar2(changeAvatarRequest: ChangeAvatarRequest, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return PatientControllerApiFp(this.configuration).changeAvatar2(changeAvatarRequest, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Public endpoint for a new patient to widget-register via the registration.
     * @summary widget Patient Registration
     * @param {WidgetPatient} widgetPatient 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientControllerApi
     */
    public createNewPatientRegistration(widgetPatient: WidgetPatient, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return PatientControllerApiFp(this.configuration).createNewPatientRegistration(widgetPatient, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Add a new Patient User into the system
     * @summary Add Patient User
     * @param {Patient} patient 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientControllerApi
     */
    public createPatient(patient: Patient, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return PatientControllerApiFp(this.configuration).createPatient(patient, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Export all patient data.
     * @summary Export all patient data
     * @param {ExportPatientExportTypeEnum} exportType 
     * @param {Array<string>} requestBody 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientControllerApi
     */
    public exportPatient(exportType: ExportPatientExportTypeEnum, requestBody: Array<string>, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return PatientControllerApiFp(this.configuration).exportPatient(exportType, requestBody, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all patient list with search option on firstName, lastName. 
     * @summary Get all patient
     * @param {number} [page] 
     * @param {number} [size] 
     * @param {string} [sortBy] 
     * @param {string} [sortDirection] 
     * @param {boolean} [status] 
     * @param {boolean} [archive] 
     * @param {string} [locationUuid] 
     * @param {string} [providerUuid] 
     * @param {Array<string>} [referringAgencyUuid] 
     * @param {string} [ssn] 
     * @param {string} [phone] 
     * @param {string} [ageFilterCategory] 
     * @param {number} [ageFilterValue] 
     * @param {string} [dateOfBirth] 
     * @param {boolean} [isReferral] 
     * @param {string} [searchString] 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientControllerApi
     */
    public getAllPatient(page?: number, size?: number, sortBy?: string, sortDirection?: string, status?: boolean, archive?: boolean, locationUuid?: string, providerUuid?: string, referringAgencyUuid?: Array<string>, ssn?: string, phone?: string, ageFilterCategory?: string, ageFilterValue?: number, dateOfBirth?: string, isReferral?: boolean, searchString?: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return PatientControllerApiFp(this.configuration).getAllPatient(page, size, sortBy, sortDirection, status, archive, locationUuid, providerUuid, referringAgencyUuid, ssn, phone, ageFilterCategory, ageFilterValue, dateOfBirth, isReferral, searchString, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all patient record. 
     * @summary Get all patient record
     * @param {number} [page] 
     * @param {number} [size] 
     * @param {string} [sortBy] 
     * @param {string} [sortDirection] 
     * @param {string} [searchString] 
     * @param {boolean} [unreadOnly] 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientControllerApi
     */
    public getAllPatientForSmsRecord(page?: number, size?: number, sortBy?: string, sortDirection?: string, searchString?: string, unreadOnly?: boolean, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return PatientControllerApiFp(this.configuration).getAllPatientForSmsRecord(page, size, sortBy, sortDirection, searchString, unreadOnly, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all patient list with search option on firstName, lastName 
     * @summary Get all patient list
     * @param {number} [page] 
     * @param {number} [size] 
     * @param {string} [sortBy] 
     * @param {string} [sortDirection] 
     * @param {boolean} [isReferral] 
     * @param {string} [searchString] 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientControllerApi
     */
    public getAllPatients(page?: number, size?: number, sortBy?: string, sortDirection?: string, isReferral?: boolean, searchString?: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return PatientControllerApiFp(this.configuration).getAllPatients(page, size, sortBy, sortDirection, isReferral, searchString, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Lightweight patient list returning only uuid, name and eCareHealth patient id.
     * @summary Get all patients lightweight
     * @param {number} [page] 
     * @param {number} [size] 
     * @param {string} [searchString] 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientControllerApi
     */
    public getAllPatientsLight(page?: number, size?: number, searchString?: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return PatientControllerApiFp(this.configuration).getAllPatientsLight(page, size, searchString, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns insurance verification fields for a patient
     * @summary Get patient insurance detail
     * @param {string} patientUuid 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientControllerApi
     */
    public getInsuranceDetail(patientUuid: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return PatientControllerApiFp(this.configuration).getInsuranceDetail(patientUuid, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get patient by patientUuid
     * @summary Get patient by patientUuid.
     * @param {string} patientUuid 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientControllerApi
     */
    public getPatientById1(patientUuid: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return PatientControllerApiFp(this.configuration).getPatientById1(patientUuid, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get patient by card detail by patient id
     * @summary Get patient by card details.
     * @param {string} patientUuid 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientControllerApi
     */
    public getPatientDetailForCardView(patientUuid: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return PatientControllerApiFp(this.configuration).getPatientDetailForCardView(patientUuid, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get lightweight patient list with essential fields only.
     * @summary Get patient list (lightweight)
     * @param {number} [page] 
     * @param {number} [size] 
     * @param {string} [sortBy] 
     * @param {string} [sortDirection] 
     * @param {boolean} [status] 
     * @param {boolean} [archive] 
     * @param {boolean} [isReferral] 
     * @param {string} [searchString] 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientControllerApi
     */
    public getPatientList(page?: number, size?: number, sortBy?: string, sortDirection?: string, status?: boolean, archive?: boolean, isReferral?: boolean, searchString?: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return PatientControllerApiFp(this.configuration).getPatientList(page, size, sortBy, sortDirection, status, archive, isReferral, searchString, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get patient unread sms count.
     * @summary Get patient unread sms count
     * @param {string} patientId 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientControllerApi
     */
    public getPatientUnreadSmsCount(patientId: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return PatientControllerApiFp(this.configuration).getPatientUnreadSmsCount(patientId, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get patient profile
     * @summary Get patient profile
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientControllerApi
     */
    public getProfile2(xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return PatientControllerApiFp(this.configuration).getProfile2(xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Generate Twilio access token for patient voice calls
     * @summary Get Twilio token for voice calls
     * @param {string} patientId 
     * @param {string} [scheduleId] 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientControllerApi
     */
    public getTwilioToken(patientId: string, scheduleId?: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return PatientControllerApiFp(this.configuration).getTwilioToken(patientId, scheduleId, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Receive the sms from Twilio webhook
     * @summary Receive Sms
     * @param {string} xTenantId 
     * @param {string} [from] 
     * @param {string} [to] 
     * @param {string} [body] 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientControllerApi
     */
    public receiveSMS(xTenantId: string, from?: string, to?: string, body?: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return PatientControllerApiFp(this.configuration).receiveSMS(xTenantId, from, to, body, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Send email to patients.
     * @summary Send email to patients
     * @param {EmailToPatient} emailToPatient 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientControllerApi
     */
    public sendEmailToPatientId(emailToPatient: EmailToPatient, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return PatientControllerApiFp(this.configuration).sendEmailToPatientId(emailToPatient, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Send email with optional attachment to a given email address.
     * @summary Send email with attachment
     * @param {string} toEmail 
     * @param {string} fromEmail 
     * @param {string} subject 
     * @param {string} description 
     * @param {string} [xTENANTID] 
     * @param {File} [attachment] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientControllerApi
     */
    public sendEmailWithAttachment(toEmail: string, fromEmail: string, subject: string, description: string, xTENANTID?: string, attachment?: File, options?: RawAxiosRequestConfig) {
        return PatientControllerApiFp(this.configuration).sendEmailWithAttachment(toEmail, fromEmail, subject, description, xTENANTID, attachment, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Send sms to patients.
     * @summary Send Sms to patients
     * @param {EmailToPatient} emailToPatient 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientControllerApi
     */
    public sendSMSToPatientId(emailToPatient: EmailToPatient, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return PatientControllerApiFp(this.configuration).sendSMSToPatientId(emailToPatient, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Edit Patient with editable fields as firstName, lastName, phone.
     * @summary Update patient
     * @param {Patient} patient 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientControllerApi
     */
    public updatePatient(patient: Patient, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return PatientControllerApiFp(this.configuration).updatePatient(patient, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Change Patient archive status to either archived or unarchived.
     * @summary Archive/Unarchive Patient
     * @param {string} patientId 
     * @param {boolean} status 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientControllerApi
     */
    public updatePatientArchiveStatus(patientId: string, status: boolean, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return PatientControllerApiFp(this.configuration).updatePatientArchiveStatus(patientId, status, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Enable or disable patient portal access for a patient
     * @summary Update patient portal access
     * @param {string} patientUuid 
     * @param {boolean} access 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientControllerApi
     */
    public updatePatientPortalAccess(patientUuid: string, access: boolean, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return PatientControllerApiFp(this.configuration).updatePatientPortalAccess(patientUuid, access, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Change Patient status to either active or inactive.
     * @summary Enable/Disable patient
     * @param {string} patientId 
     * @param {boolean} status 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientControllerApi
     */
    public updatePatientStatus(patientId: string, status: boolean, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return PatientControllerApiFp(this.configuration).updatePatientStatus(patientId, status, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Return true if patient UUID and DOB match
     * @summary Validate patient\'s DOB
     * @param {string} patientId 
     * @param {string} dob 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientControllerApi
     */
    public validatePatientDob(patientId: string, dob: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return PatientControllerApiFp(this.configuration).validatePatientDob(patientId, dob, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const AcceptReferralReferralStatusEnum = {
    Pending: 'PENDING',
    Closed: 'CLOSED',
    Sent: 'SENT',
    Accepted: 'ACCEPTED',
    Completed: 'COMPLETED',
    Scheduled: 'SCHEDULED',
    Rejected: 'REJECTED'
} as const;
export type AcceptReferralReferralStatusEnum = typeof AcceptReferralReferralStatusEnum[keyof typeof AcceptReferralReferralStatusEnum];
/**
 * @export
 */
export const ExportPatientExportTypeEnum = {
    Csv: 'CSV',
    Pdf: 'PDF',
    Xls: 'XLS',
    Ccda: 'CCDA'
} as const;
export type ExportPatientExportTypeEnum = typeof ExportPatientExportTypeEnum[keyof typeof ExportPatientExportTypeEnum];


/**
 * PatientCredentialControllerApi - axios parameter creator
 * @export
 */
export const PatientCredentialControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Generate unique username and password for patient, save to Keycloak for direct login
         * @summary Generate patient login credentials
         * @param {string} patientUuid 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateCredential: async (patientUuid: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientUuid' is not null or undefined
            assertParamExists('generateCredential', 'patientUuid', patientUuid)
            const localVarPath = `/api/master/patient-credential/{patientUuid}/generate`
                .replace(`{${"patientUuid"}}`, encodeURIComponent(String(patientUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve existing credentials for a patient
         * @summary Get patient credentials
         * @param {string} patientUuid 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCredential: async (patientUuid: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientUuid' is not null or undefined
            assertParamExists('getCredential', 'patientUuid', patientUuid)
            const localVarPath = `/api/master/patient-credential/{patientUuid}`
                .replace(`{${"patientUuid"}}`, encodeURIComponent(String(patientUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Send the patient\'s login credentials to their email address
         * @summary Send credentials via email
         * @param {string} patientUuid 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendCredentialEmail: async (patientUuid: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientUuid' is not null or undefined
            assertParamExists('sendCredentialEmail', 'patientUuid', patientUuid)
            const localVarPath = `/api/master/patient-credential/{patientUuid}/send-email`
                .replace(`{${"patientUuid"}}`, encodeURIComponent(String(patientUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PatientCredentialControllerApi - functional programming interface
 * @export
 */
export const PatientCredentialControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PatientCredentialControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * Generate unique username and password for patient, save to Keycloak for direct login
         * @summary Generate patient login credentials
         * @param {string} patientUuid 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generateCredential(patientUuid: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generateCredential(patientUuid, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientCredentialControllerApi.generateCredential']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve existing credentials for a patient
         * @summary Get patient credentials
         * @param {string} patientUuid 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCredential(patientUuid: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCredential(patientUuid, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientCredentialControllerApi.getCredential']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Send the patient\'s login credentials to their email address
         * @summary Send credentials via email
         * @param {string} patientUuid 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendCredentialEmail(patientUuid: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendCredentialEmail(patientUuid, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientCredentialControllerApi.sendCredentialEmail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PatientCredentialControllerApi - factory interface
 * @export
 */
export const PatientCredentialControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PatientCredentialControllerApiFp(configuration)
    return {
        /**
         * Generate unique username and password for patient, save to Keycloak for direct login
         * @summary Generate patient login credentials
         * @param {string} patientUuid 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateCredential(patientUuid: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.generateCredential(patientUuid, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve existing credentials for a patient
         * @summary Get patient credentials
         * @param {string} patientUuid 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCredential(patientUuid: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getCredential(patientUuid, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Send the patient\'s login credentials to their email address
         * @summary Send credentials via email
         * @param {string} patientUuid 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendCredentialEmail(patientUuid: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.sendCredentialEmail(patientUuid, xTENANTID, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PatientCredentialControllerApi - object-oriented interface
 * @export
 * @class PatientCredentialControllerApi
 * @extends {BaseAPI}
 */
export class PatientCredentialControllerApi extends BaseAPI {
    /**
     * Generate unique username and password for patient, save to Keycloak for direct login
     * @summary Generate patient login credentials
     * @param {string} patientUuid 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientCredentialControllerApi
     */
    public generateCredential(patientUuid: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return PatientCredentialControllerApiFp(this.configuration).generateCredential(patientUuid, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve existing credentials for a patient
     * @summary Get patient credentials
     * @param {string} patientUuid 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientCredentialControllerApi
     */
    public getCredential(patientUuid: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return PatientCredentialControllerApiFp(this.configuration).getCredential(patientUuid, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Send the patient\'s login credentials to their email address
     * @summary Send credentials via email
     * @param {string} patientUuid 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientCredentialControllerApi
     */
    public sendCredentialEmail(patientUuid: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return PatientCredentialControllerApiFp(this.configuration).sendCredentialEmail(patientUuid, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PatientDiagnosisControllerApi - axios parameter creator
 * @export
 */
export const PatientDiagnosisControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Add a new patient diagnosis into the system
         * @summary Add Patient Diagnosis
         * @param {PatientDiagnosis} patientDiagnosis 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPatientDiagnosis: async (patientDiagnosis: PatientDiagnosis, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientDiagnosis' is not null or undefined
            assertParamExists('createPatientDiagnosis', 'patientDiagnosis', patientDiagnosis)
            const localVarPath = `/api/master/patient-diagnosis`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patientDiagnosis, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all Patient Diagnosis list with search option on name, patientId and filter options on active, archive. Supports sorting by: diagnosedDate (chronological), updatedDate (chronological), recordedDate (chronological), name, active, archive, diagnosisStatus, type.
         * @summary Get all Patient Diagnosis.
         * @param {string} patientUuid 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {boolean} [status] 
         * @param {boolean} [archive] 
         * @param {string} [searchString] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatientDiagnosis: async (patientUuid: string, page?: number, size?: number, sortBy?: string, sortDirection?: string, status?: boolean, archive?: boolean, searchString?: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientUuid' is not null or undefined
            assertParamExists('getPatientDiagnosis', 'patientUuid', patientUuid)
            const localVarPath = `/api/master/patient-diagnosis`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (archive !== undefined) {
                localVarQueryParameter['archive'] = archive;
            }

            if (patientUuid !== undefined) {
                localVarQueryParameter['patientUuid'] = patientUuid;
            }

            if (searchString !== undefined) {
                localVarQueryParameter['searchString'] = searchString;
            }

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve a Patient Diagnosis by its unique ID
         * @summary Get Patient Diagnosis by ID
         * @param {string} patientDiagnosisId 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatientDiagnosisById: async (patientDiagnosisId: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientDiagnosisId' is not null or undefined
            assertParamExists('getPatientDiagnosisById', 'patientDiagnosisId', patientDiagnosisId)
            const localVarPath = `/api/master/patient-diagnosis/{patientDiagnosisId}`
                .replace(`{${"patientDiagnosisId"}}`, encodeURIComponent(String(patientDiagnosisId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update an existing Patient Diagnosis
         * @summary Update Patient Diagnosis
         * @param {PatientDiagnosis} patientDiagnosis 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePatientDiagnosis: async (patientDiagnosis: PatientDiagnosis, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientDiagnosis' is not null or undefined
            assertParamExists('updatePatientDiagnosis', 'patientDiagnosis', patientDiagnosis)
            const localVarPath = `/api/master/patient-diagnosis`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patientDiagnosis, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Archive a Patient Diagnosis by its ID
         * @summary Archive Patient Diagnosis
         * @param {string} patientDiagnosisId 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePatientDiagnosisArchiveStatus: async (patientDiagnosisId: string, status: boolean, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientDiagnosisId' is not null or undefined
            assertParamExists('updatePatientDiagnosisArchiveStatus', 'patientDiagnosisId', patientDiagnosisId)
            // verify required parameter 'status' is not null or undefined
            assertParamExists('updatePatientDiagnosisArchiveStatus', 'status', status)
            const localVarPath = `/api/master/patient-diagnosis/{patientDiagnosisId}/archive-status/{status}`
                .replace(`{${"patientDiagnosisId"}}`, encodeURIComponent(String(patientDiagnosisId)))
                .replace(`{${"status"}}`, encodeURIComponent(String(status)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update the status of a Patient Diagnosis by its ID
         * @summary Update Patient Diagnosis Status
         * @param {string} patientDiagnosisId 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePatientDiagnosisStatus: async (patientDiagnosisId: string, status: boolean, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientDiagnosisId' is not null or undefined
            assertParamExists('updatePatientDiagnosisStatus', 'patientDiagnosisId', patientDiagnosisId)
            // verify required parameter 'status' is not null or undefined
            assertParamExists('updatePatientDiagnosisStatus', 'status', status)
            const localVarPath = `/api/master/patient-diagnosis/{patientDiagnosisId}/status/{status}`
                .replace(`{${"patientDiagnosisId"}}`, encodeURIComponent(String(patientDiagnosisId)))
                .replace(`{${"status"}}`, encodeURIComponent(String(status)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PatientDiagnosisControllerApi - functional programming interface
 * @export
 */
export const PatientDiagnosisControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PatientDiagnosisControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * Add a new patient diagnosis into the system
         * @summary Add Patient Diagnosis
         * @param {PatientDiagnosis} patientDiagnosis 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createPatientDiagnosis(patientDiagnosis: PatientDiagnosis, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createPatientDiagnosis(patientDiagnosis, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientDiagnosisControllerApi.createPatientDiagnosis']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get all Patient Diagnosis list with search option on name, patientId and filter options on active, archive. Supports sorting by: diagnosedDate (chronological), updatedDate (chronological), recordedDate (chronological), name, active, archive, diagnosisStatus, type.
         * @summary Get all Patient Diagnosis.
         * @param {string} patientUuid 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {boolean} [status] 
         * @param {boolean} [archive] 
         * @param {string} [searchString] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPatientDiagnosis(patientUuid: string, page?: number, size?: number, sortBy?: string, sortDirection?: string, status?: boolean, archive?: boolean, searchString?: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPatientDiagnosis(patientUuid, page, size, sortBy, sortDirection, status, archive, searchString, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientDiagnosisControllerApi.getPatientDiagnosis']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve a Patient Diagnosis by its unique ID
         * @summary Get Patient Diagnosis by ID
         * @param {string} patientDiagnosisId 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPatientDiagnosisById(patientDiagnosisId: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPatientDiagnosisById(patientDiagnosisId, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientDiagnosisControllerApi.getPatientDiagnosisById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update an existing Patient Diagnosis
         * @summary Update Patient Diagnosis
         * @param {PatientDiagnosis} patientDiagnosis 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePatientDiagnosis(patientDiagnosis: PatientDiagnosis, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePatientDiagnosis(patientDiagnosis, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientDiagnosisControllerApi.updatePatientDiagnosis']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Archive a Patient Diagnosis by its ID
         * @summary Archive Patient Diagnosis
         * @param {string} patientDiagnosisId 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePatientDiagnosisArchiveStatus(patientDiagnosisId: string, status: boolean, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePatientDiagnosisArchiveStatus(patientDiagnosisId, status, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientDiagnosisControllerApi.updatePatientDiagnosisArchiveStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update the status of a Patient Diagnosis by its ID
         * @summary Update Patient Diagnosis Status
         * @param {string} patientDiagnosisId 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePatientDiagnosisStatus(patientDiagnosisId: string, status: boolean, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePatientDiagnosisStatus(patientDiagnosisId, status, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientDiagnosisControllerApi.updatePatientDiagnosisStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PatientDiagnosisControllerApi - factory interface
 * @export
 */
export const PatientDiagnosisControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PatientDiagnosisControllerApiFp(configuration)
    return {
        /**
         * Add a new patient diagnosis into the system
         * @summary Add Patient Diagnosis
         * @param {PatientDiagnosis} patientDiagnosis 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPatientDiagnosis(patientDiagnosis: PatientDiagnosis, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.createPatientDiagnosis(patientDiagnosis, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all Patient Diagnosis list with search option on name, patientId and filter options on active, archive. Supports sorting by: diagnosedDate (chronological), updatedDate (chronological), recordedDate (chronological), name, active, archive, diagnosisStatus, type.
         * @summary Get all Patient Diagnosis.
         * @param {string} patientUuid 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {boolean} [status] 
         * @param {boolean} [archive] 
         * @param {string} [searchString] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatientDiagnosis(patientUuid: string, page?: number, size?: number, sortBy?: string, sortDirection?: string, status?: boolean, archive?: boolean, searchString?: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getPatientDiagnosis(patientUuid, page, size, sortBy, sortDirection, status, archive, searchString, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve a Patient Diagnosis by its unique ID
         * @summary Get Patient Diagnosis by ID
         * @param {string} patientDiagnosisId 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatientDiagnosisById(patientDiagnosisId: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getPatientDiagnosisById(patientDiagnosisId, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Update an existing Patient Diagnosis
         * @summary Update Patient Diagnosis
         * @param {PatientDiagnosis} patientDiagnosis 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePatientDiagnosis(patientDiagnosis: PatientDiagnosis, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.updatePatientDiagnosis(patientDiagnosis, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Archive a Patient Diagnosis by its ID
         * @summary Archive Patient Diagnosis
         * @param {string} patientDiagnosisId 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePatientDiagnosisArchiveStatus(patientDiagnosisId: string, status: boolean, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.updatePatientDiagnosisArchiveStatus(patientDiagnosisId, status, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Update the status of a Patient Diagnosis by its ID
         * @summary Update Patient Diagnosis Status
         * @param {string} patientDiagnosisId 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePatientDiagnosisStatus(patientDiagnosisId: string, status: boolean, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.updatePatientDiagnosisStatus(patientDiagnosisId, status, xTENANTID, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PatientDiagnosisControllerApi - object-oriented interface
 * @export
 * @class PatientDiagnosisControllerApi
 * @extends {BaseAPI}
 */
export class PatientDiagnosisControllerApi extends BaseAPI {
    /**
     * Add a new patient diagnosis into the system
     * @summary Add Patient Diagnosis
     * @param {PatientDiagnosis} patientDiagnosis 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientDiagnosisControllerApi
     */
    public createPatientDiagnosis(patientDiagnosis: PatientDiagnosis, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return PatientDiagnosisControllerApiFp(this.configuration).createPatientDiagnosis(patientDiagnosis, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all Patient Diagnosis list with search option on name, patientId and filter options on active, archive. Supports sorting by: diagnosedDate (chronological), updatedDate (chronological), recordedDate (chronological), name, active, archive, diagnosisStatus, type.
     * @summary Get all Patient Diagnosis.
     * @param {string} patientUuid 
     * @param {number} [page] 
     * @param {number} [size] 
     * @param {string} [sortBy] 
     * @param {string} [sortDirection] 
     * @param {boolean} [status] 
     * @param {boolean} [archive] 
     * @param {string} [searchString] 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientDiagnosisControllerApi
     */
    public getPatientDiagnosis(patientUuid: string, page?: number, size?: number, sortBy?: string, sortDirection?: string, status?: boolean, archive?: boolean, searchString?: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return PatientDiagnosisControllerApiFp(this.configuration).getPatientDiagnosis(patientUuid, page, size, sortBy, sortDirection, status, archive, searchString, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve a Patient Diagnosis by its unique ID
     * @summary Get Patient Diagnosis by ID
     * @param {string} patientDiagnosisId 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientDiagnosisControllerApi
     */
    public getPatientDiagnosisById(patientDiagnosisId: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return PatientDiagnosisControllerApiFp(this.configuration).getPatientDiagnosisById(patientDiagnosisId, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update an existing Patient Diagnosis
     * @summary Update Patient Diagnosis
     * @param {PatientDiagnosis} patientDiagnosis 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientDiagnosisControllerApi
     */
    public updatePatientDiagnosis(patientDiagnosis: PatientDiagnosis, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return PatientDiagnosisControllerApiFp(this.configuration).updatePatientDiagnosis(patientDiagnosis, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Archive a Patient Diagnosis by its ID
     * @summary Archive Patient Diagnosis
     * @param {string} patientDiagnosisId 
     * @param {boolean} status 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientDiagnosisControllerApi
     */
    public updatePatientDiagnosisArchiveStatus(patientDiagnosisId: string, status: boolean, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return PatientDiagnosisControllerApiFp(this.configuration).updatePatientDiagnosisArchiveStatus(patientDiagnosisId, status, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update the status of a Patient Diagnosis by its ID
     * @summary Update Patient Diagnosis Status
     * @param {string} patientDiagnosisId 
     * @param {boolean} status 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientDiagnosisControllerApi
     */
    public updatePatientDiagnosisStatus(patientDiagnosisId: string, status: boolean, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return PatientDiagnosisControllerApiFp(this.configuration).updatePatientDiagnosisStatus(patientDiagnosisId, status, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PatientDocumentControllerApi - axios parameter creator
 * @export
 */
export const PatientDocumentControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Assign Patient To Document by its ID
         * @summary Assign Patient To Document
         * @param {string} patientDocumentId 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignDocumentToPatient: async (patientDocumentId: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientDocumentId' is not null or undefined
            assertParamExists('assignDocumentToPatient', 'patientDocumentId', patientDocumentId)
            const localVarPath = `/api/master/patient-document/{patientDocumentId}/assigned`
                .replace(`{${"patientDocumentId"}}`, encodeURIComponent(String(patientDocumentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {boolean} [status] 
         * @param {boolean} [assigned] 
         * @param {boolean} [archive] 
         * @param {GetAllDocumentsDocumentTagEnum} [documentTag] 
         * @param {string} [appointmentId] 
         * @param {string} [patientId] 
         * @param {string} [searchString] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllDocuments: async (page?: number, size?: number, sortBy?: string, sortDirection?: string, status?: boolean, assigned?: boolean, archive?: boolean, documentTag?: GetAllDocumentsDocumentTagEnum, appointmentId?: string, patientId?: string, searchString?: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/master/patient-document/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (assigned !== undefined) {
                localVarQueryParameter['assigned'] = assigned;
            }

            if (archive !== undefined) {
                localVarQueryParameter['archive'] = archive;
            }

            if (documentTag !== undefined) {
                localVarQueryParameter['documentTag'] = documentTag;
            }

            if (appointmentId !== undefined) {
                localVarQueryParameter['appointmentId'] = appointmentId;
            }

            if (patientId !== undefined) {
                localVarQueryParameter['patientId'] = patientId;
            }

            if (searchString !== undefined) {
                localVarQueryParameter['searchString'] = searchString;
            }

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve a Patient Document by  ID
         * @summary Get Patient Document by ID
         * @param {string} patientDocumentId 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatientDocumentById: async (patientDocumentId: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientDocumentId' is not null or undefined
            assertParamExists('getPatientDocumentById', 'patientDocumentId', patientDocumentId)
            const localVarPath = `/api/master/patient-document/{patientDocumentId}`
                .replace(`{${"patientDocumentId"}}`, encodeURIComponent(String(patientDocumentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update an existing Patient Document
         * @summary Update Patient Document
         * @param {string} patientDocumentId 
         * @param {string} name 
         * @param {UpdatePatientDocumentDocumentTagEnum} documentTag 
         * @param {string} [documentDate] 
         * @param {string} [documentDescription] 
         * @param {UpdatePatientDocumentDocumentFormatEnum} [documentFormat] 
         * @param {string} [xTENANTID] 
         * @param {File} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePatientDocument: async (patientDocumentId: string, name: string, documentTag: UpdatePatientDocumentDocumentTagEnum, documentDate?: string, documentDescription?: string, documentFormat?: UpdatePatientDocumentDocumentFormatEnum, xTENANTID?: string, file?: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientDocumentId' is not null or undefined
            assertParamExists('updatePatientDocument', 'patientDocumentId', patientDocumentId)
            // verify required parameter 'name' is not null or undefined
            assertParamExists('updatePatientDocument', 'name', name)
            // verify required parameter 'documentTag' is not null or undefined
            assertParamExists('updatePatientDocument', 'documentTag', documentTag)
            const localVarPath = `/api/master/patient-document`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (patientDocumentId !== undefined) {
                localVarQueryParameter['patientDocumentId'] = patientDocumentId;
            }

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            if (documentTag !== undefined) {
                localVarQueryParameter['documentTag'] = documentTag;
            }

            if (documentDate !== undefined) {
                localVarQueryParameter['documentDate'] = (documentDate as any instanceof Date) ?
                    (documentDate as any).toISOString() :
                    documentDate;
            }

            if (documentDescription !== undefined) {
                localVarQueryParameter['documentDescription'] = documentDescription;
            }

            if (documentFormat !== undefined) {
                localVarQueryParameter['documentFormat'] = documentFormat;
            }

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Archive a Patient Document by its ID
         * @summary Archive Patient Document
         * @param {string} patientDocumentId 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePatientDocumentArchiveStatus: async (patientDocumentId: string, status: boolean, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientDocumentId' is not null or undefined
            assertParamExists('updatePatientDocumentArchiveStatus', 'patientDocumentId', patientDocumentId)
            // verify required parameter 'status' is not null or undefined
            assertParamExists('updatePatientDocumentArchiveStatus', 'status', status)
            const localVarPath = `/api/master/patient-document/{patientDocumentId}/archive-status/{status}`
                .replace(`{${"patientDocumentId"}}`, encodeURIComponent(String(patientDocumentId)))
                .replace(`{${"status"}}`, encodeURIComponent(String(status)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update the status of a Patient Document by its ID
         * @summary Update Patient Document Status
         * @param {string} patientDocumentId 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePatientDocumentStatus: async (patientDocumentId: string, status: boolean, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientDocumentId' is not null or undefined
            assertParamExists('updatePatientDocumentStatus', 'patientDocumentId', patientDocumentId)
            // verify required parameter 'status' is not null or undefined
            assertParamExists('updatePatientDocumentStatus', 'status', status)
            const localVarPath = `/api/master/patient-document/{patientDocumentId}/status/{status}`
                .replace(`{${"patientDocumentId"}}`, encodeURIComponent(String(patientDocumentId)))
                .replace(`{${"status"}}`, encodeURIComponent(String(status)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} patientId 
         * @param {string} name 
         * @param {boolean} assigned 
         * @param {UploadDocumentDocumentTagEnum} documentTag 
         * @param {UploadDocumentDocumentFormatEnum} documentFormat 
         * @param {File} file 
         * @param {string} [documentDate] 
         * @param {string} [documentDescription] 
         * @param {string} [appointmentUuid] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadDocument: async (patientId: string, name: string, assigned: boolean, documentTag: UploadDocumentDocumentTagEnum, documentFormat: UploadDocumentDocumentFormatEnum, file: File, documentDate?: string, documentDescription?: string, appointmentUuid?: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientId' is not null or undefined
            assertParamExists('uploadDocument', 'patientId', patientId)
            // verify required parameter 'name' is not null or undefined
            assertParamExists('uploadDocument', 'name', name)
            // verify required parameter 'assigned' is not null or undefined
            assertParamExists('uploadDocument', 'assigned', assigned)
            // verify required parameter 'documentTag' is not null or undefined
            assertParamExists('uploadDocument', 'documentTag', documentTag)
            // verify required parameter 'documentFormat' is not null or undefined
            assertParamExists('uploadDocument', 'documentFormat', documentFormat)
            // verify required parameter 'file' is not null or undefined
            assertParamExists('uploadDocument', 'file', file)
            const localVarPath = `/api/master/patient-document/upload`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (patientId !== undefined) {
                localVarQueryParameter['patientId'] = patientId;
            }

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            if (assigned !== undefined) {
                localVarQueryParameter['assigned'] = assigned;
            }

            if (documentDate !== undefined) {
                localVarQueryParameter['documentDate'] = (documentDate as any instanceof Date) ?
                    (documentDate as any).toISOString() :
                    documentDate;
            }

            if (documentDescription !== undefined) {
                localVarQueryParameter['documentDescription'] = documentDescription;
            }

            if (documentTag !== undefined) {
                localVarQueryParameter['documentTag'] = documentTag;
            }

            if (appointmentUuid !== undefined) {
                localVarQueryParameter['appointmentUuid'] = appointmentUuid;
            }

            if (documentFormat !== undefined) {
                localVarQueryParameter['documentFormat'] = documentFormat;
            }

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PatientDocumentControllerApi - functional programming interface
 * @export
 */
export const PatientDocumentControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PatientDocumentControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * Assign Patient To Document by its ID
         * @summary Assign Patient To Document
         * @param {string} patientDocumentId 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assignDocumentToPatient(patientDocumentId: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assignDocumentToPatient(patientDocumentId, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientDocumentControllerApi.assignDocumentToPatient']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {boolean} [status] 
         * @param {boolean} [assigned] 
         * @param {boolean} [archive] 
         * @param {GetAllDocumentsDocumentTagEnum} [documentTag] 
         * @param {string} [appointmentId] 
         * @param {string} [patientId] 
         * @param {string} [searchString] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllDocuments(page?: number, size?: number, sortBy?: string, sortDirection?: string, status?: boolean, assigned?: boolean, archive?: boolean, documentTag?: GetAllDocumentsDocumentTagEnum, appointmentId?: string, patientId?: string, searchString?: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllDocuments(page, size, sortBy, sortDirection, status, assigned, archive, documentTag, appointmentId, patientId, searchString, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientDocumentControllerApi.getAllDocuments']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve a Patient Document by  ID
         * @summary Get Patient Document by ID
         * @param {string} patientDocumentId 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPatientDocumentById(patientDocumentId: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPatientDocumentById(patientDocumentId, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientDocumentControllerApi.getPatientDocumentById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update an existing Patient Document
         * @summary Update Patient Document
         * @param {string} patientDocumentId 
         * @param {string} name 
         * @param {UpdatePatientDocumentDocumentTagEnum} documentTag 
         * @param {string} [documentDate] 
         * @param {string} [documentDescription] 
         * @param {UpdatePatientDocumentDocumentFormatEnum} [documentFormat] 
         * @param {string} [xTENANTID] 
         * @param {File} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePatientDocument(patientDocumentId: string, name: string, documentTag: UpdatePatientDocumentDocumentTagEnum, documentDate?: string, documentDescription?: string, documentFormat?: UpdatePatientDocumentDocumentFormatEnum, xTENANTID?: string, file?: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePatientDocument(patientDocumentId, name, documentTag, documentDate, documentDescription, documentFormat, xTENANTID, file, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientDocumentControllerApi.updatePatientDocument']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Archive a Patient Document by its ID
         * @summary Archive Patient Document
         * @param {string} patientDocumentId 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePatientDocumentArchiveStatus(patientDocumentId: string, status: boolean, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePatientDocumentArchiveStatus(patientDocumentId, status, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientDocumentControllerApi.updatePatientDocumentArchiveStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update the status of a Patient Document by its ID
         * @summary Update Patient Document Status
         * @param {string} patientDocumentId 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePatientDocumentStatus(patientDocumentId: string, status: boolean, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePatientDocumentStatus(patientDocumentId, status, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientDocumentControllerApi.updatePatientDocumentStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} patientId 
         * @param {string} name 
         * @param {boolean} assigned 
         * @param {UploadDocumentDocumentTagEnum} documentTag 
         * @param {UploadDocumentDocumentFormatEnum} documentFormat 
         * @param {File} file 
         * @param {string} [documentDate] 
         * @param {string} [documentDescription] 
         * @param {string} [appointmentUuid] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadDocument(patientId: string, name: string, assigned: boolean, documentTag: UploadDocumentDocumentTagEnum, documentFormat: UploadDocumentDocumentFormatEnum, file: File, documentDate?: string, documentDescription?: string, appointmentUuid?: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadDocument(patientId, name, assigned, documentTag, documentFormat, file, documentDate, documentDescription, appointmentUuid, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientDocumentControllerApi.uploadDocument']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PatientDocumentControllerApi - factory interface
 * @export
 */
export const PatientDocumentControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PatientDocumentControllerApiFp(configuration)
    return {
        /**
         * Assign Patient To Document by its ID
         * @summary Assign Patient To Document
         * @param {string} patientDocumentId 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignDocumentToPatient(patientDocumentId: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.assignDocumentToPatient(patientDocumentId, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {boolean} [status] 
         * @param {boolean} [assigned] 
         * @param {boolean} [archive] 
         * @param {GetAllDocumentsDocumentTagEnum} [documentTag] 
         * @param {string} [appointmentId] 
         * @param {string} [patientId] 
         * @param {string} [searchString] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllDocuments(page?: number, size?: number, sortBy?: string, sortDirection?: string, status?: boolean, assigned?: boolean, archive?: boolean, documentTag?: GetAllDocumentsDocumentTagEnum, appointmentId?: string, patientId?: string, searchString?: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getAllDocuments(page, size, sortBy, sortDirection, status, assigned, archive, documentTag, appointmentId, patientId, searchString, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve a Patient Document by  ID
         * @summary Get Patient Document by ID
         * @param {string} patientDocumentId 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatientDocumentById(patientDocumentId: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getPatientDocumentById(patientDocumentId, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Update an existing Patient Document
         * @summary Update Patient Document
         * @param {string} patientDocumentId 
         * @param {string} name 
         * @param {UpdatePatientDocumentDocumentTagEnum} documentTag 
         * @param {string} [documentDate] 
         * @param {string} [documentDescription] 
         * @param {UpdatePatientDocumentDocumentFormatEnum} [documentFormat] 
         * @param {string} [xTENANTID] 
         * @param {File} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePatientDocument(patientDocumentId: string, name: string, documentTag: UpdatePatientDocumentDocumentTagEnum, documentDate?: string, documentDescription?: string, documentFormat?: UpdatePatientDocumentDocumentFormatEnum, xTENANTID?: string, file?: File, options?: any): AxiosPromise<Response> {
            return localVarFp.updatePatientDocument(patientDocumentId, name, documentTag, documentDate, documentDescription, documentFormat, xTENANTID, file, options).then((request) => request(axios, basePath));
        },
        /**
         * Archive a Patient Document by its ID
         * @summary Archive Patient Document
         * @param {string} patientDocumentId 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePatientDocumentArchiveStatus(patientDocumentId: string, status: boolean, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.updatePatientDocumentArchiveStatus(patientDocumentId, status, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Update the status of a Patient Document by its ID
         * @summary Update Patient Document Status
         * @param {string} patientDocumentId 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePatientDocumentStatus(patientDocumentId: string, status: boolean, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.updatePatientDocumentStatus(patientDocumentId, status, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} patientId 
         * @param {string} name 
         * @param {boolean} assigned 
         * @param {UploadDocumentDocumentTagEnum} documentTag 
         * @param {UploadDocumentDocumentFormatEnum} documentFormat 
         * @param {File} file 
         * @param {string} [documentDate] 
         * @param {string} [documentDescription] 
         * @param {string} [appointmentUuid] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadDocument(patientId: string, name: string, assigned: boolean, documentTag: UploadDocumentDocumentTagEnum, documentFormat: UploadDocumentDocumentFormatEnum, file: File, documentDate?: string, documentDescription?: string, appointmentUuid?: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.uploadDocument(patientId, name, assigned, documentTag, documentFormat, file, documentDate, documentDescription, appointmentUuid, xTENANTID, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PatientDocumentControllerApi - object-oriented interface
 * @export
 * @class PatientDocumentControllerApi
 * @extends {BaseAPI}
 */
export class PatientDocumentControllerApi extends BaseAPI {
    /**
     * Assign Patient To Document by its ID
     * @summary Assign Patient To Document
     * @param {string} patientDocumentId 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientDocumentControllerApi
     */
    public assignDocumentToPatient(patientDocumentId: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return PatientDocumentControllerApiFp(this.configuration).assignDocumentToPatient(patientDocumentId, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [page] 
     * @param {number} [size] 
     * @param {string} [sortBy] 
     * @param {string} [sortDirection] 
     * @param {boolean} [status] 
     * @param {boolean} [assigned] 
     * @param {boolean} [archive] 
     * @param {GetAllDocumentsDocumentTagEnum} [documentTag] 
     * @param {string} [appointmentId] 
     * @param {string} [patientId] 
     * @param {string} [searchString] 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientDocumentControllerApi
     */
    public getAllDocuments(page?: number, size?: number, sortBy?: string, sortDirection?: string, status?: boolean, assigned?: boolean, archive?: boolean, documentTag?: GetAllDocumentsDocumentTagEnum, appointmentId?: string, patientId?: string, searchString?: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return PatientDocumentControllerApiFp(this.configuration).getAllDocuments(page, size, sortBy, sortDirection, status, assigned, archive, documentTag, appointmentId, patientId, searchString, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve a Patient Document by  ID
     * @summary Get Patient Document by ID
     * @param {string} patientDocumentId 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientDocumentControllerApi
     */
    public getPatientDocumentById(patientDocumentId: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return PatientDocumentControllerApiFp(this.configuration).getPatientDocumentById(patientDocumentId, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update an existing Patient Document
     * @summary Update Patient Document
     * @param {string} patientDocumentId 
     * @param {string} name 
     * @param {UpdatePatientDocumentDocumentTagEnum} documentTag 
     * @param {string} [documentDate] 
     * @param {string} [documentDescription] 
     * @param {UpdatePatientDocumentDocumentFormatEnum} [documentFormat] 
     * @param {string} [xTENANTID] 
     * @param {File} [file] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientDocumentControllerApi
     */
    public updatePatientDocument(patientDocumentId: string, name: string, documentTag: UpdatePatientDocumentDocumentTagEnum, documentDate?: string, documentDescription?: string, documentFormat?: UpdatePatientDocumentDocumentFormatEnum, xTENANTID?: string, file?: File, options?: RawAxiosRequestConfig) {
        return PatientDocumentControllerApiFp(this.configuration).updatePatientDocument(patientDocumentId, name, documentTag, documentDate, documentDescription, documentFormat, xTENANTID, file, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Archive a Patient Document by its ID
     * @summary Archive Patient Document
     * @param {string} patientDocumentId 
     * @param {boolean} status 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientDocumentControllerApi
     */
    public updatePatientDocumentArchiveStatus(patientDocumentId: string, status: boolean, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return PatientDocumentControllerApiFp(this.configuration).updatePatientDocumentArchiveStatus(patientDocumentId, status, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update the status of a Patient Document by its ID
     * @summary Update Patient Document Status
     * @param {string} patientDocumentId 
     * @param {boolean} status 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientDocumentControllerApi
     */
    public updatePatientDocumentStatus(patientDocumentId: string, status: boolean, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return PatientDocumentControllerApiFp(this.configuration).updatePatientDocumentStatus(patientDocumentId, status, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} patientId 
     * @param {string} name 
     * @param {boolean} assigned 
     * @param {UploadDocumentDocumentTagEnum} documentTag 
     * @param {UploadDocumentDocumentFormatEnum} documentFormat 
     * @param {File} file 
     * @param {string} [documentDate] 
     * @param {string} [documentDescription] 
     * @param {string} [appointmentUuid] 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientDocumentControllerApi
     */
    public uploadDocument(patientId: string, name: string, assigned: boolean, documentTag: UploadDocumentDocumentTagEnum, documentFormat: UploadDocumentDocumentFormatEnum, file: File, documentDate?: string, documentDescription?: string, appointmentUuid?: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return PatientDocumentControllerApiFp(this.configuration).uploadDocument(patientId, name, assigned, documentTag, documentFormat, file, documentDate, documentDescription, appointmentUuid, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const GetAllDocumentsDocumentTagEnum = {
    PatientRegistrationForm: 'PATIENT_REGISTRATION_FORM',
    InsuranceInformation: 'INSURANCE_INFORMATION',
    ConsentForm: 'CONSENT_FORM',
    IdAndProofOfAddress: 'ID_AND_PROOF_OF_ADDRESS',
    ProgressNote: 'PROGRESS_NOTE',
    LabReport: 'LAB_REPORT',
    ImagingReport: 'IMAGING_REPORT',
    ConsultationNote: 'CONSULTATION_NOTE',
    SurgeryReport: 'SURGERY_REPORT',
    DischargeSummaries: 'DISCHARGE_SUMMARIES',
    MedicationList: 'MEDICATION_LIST',
    ReferralLetter: 'REFERRAL_LETTER',
    AuthorizationLetter: 'AUTHORIZATION_LETTER',
    Fax: 'FAX',
    EncounterSummary: 'ENCOUNTER_SUMMARY'
} as const;
export type GetAllDocumentsDocumentTagEnum = typeof GetAllDocumentsDocumentTagEnum[keyof typeof GetAllDocumentsDocumentTagEnum];
/**
 * @export
 */
export const UpdatePatientDocumentDocumentTagEnum = {
    PatientRegistrationForm: 'PATIENT_REGISTRATION_FORM',
    InsuranceInformation: 'INSURANCE_INFORMATION',
    ConsentForm: 'CONSENT_FORM',
    IdAndProofOfAddress: 'ID_AND_PROOF_OF_ADDRESS',
    ProgressNote: 'PROGRESS_NOTE',
    LabReport: 'LAB_REPORT',
    ImagingReport: 'IMAGING_REPORT',
    ConsultationNote: 'CONSULTATION_NOTE',
    SurgeryReport: 'SURGERY_REPORT',
    DischargeSummaries: 'DISCHARGE_SUMMARIES',
    MedicationList: 'MEDICATION_LIST',
    ReferralLetter: 'REFERRAL_LETTER',
    AuthorizationLetter: 'AUTHORIZATION_LETTER',
    Fax: 'FAX',
    EncounterSummary: 'ENCOUNTER_SUMMARY'
} as const;
export type UpdatePatientDocumentDocumentTagEnum = typeof UpdatePatientDocumentDocumentTagEnum[keyof typeof UpdatePatientDocumentDocumentTagEnum];
/**
 * @export
 */
export const UpdatePatientDocumentDocumentFormatEnum = {
    Pdf: 'PDF',
    MsWord: 'MS_WORD',
    Zip: 'ZIP',
    XGzip: 'X_GZIP',
    XCompressed: 'X_COMPRESSED',
    Docx: 'DOCX',
    Rtf: 'RTF',
    Plain: 'PLAIN',
    Xlsx: 'XLSX',
    JpegImage: 'JPEG_IMAGE',
    Mp4: 'MP4',
    PngImage: 'PNG_IMAGE',
    GifImage: 'GIF_IMAGE',
    BmpImage: 'BMP_IMAGE',
    WebpImage: 'WEBP_IMAGE',
    SvgImage: 'SVG_IMAGE',
    MpegAudio: 'MPEG_AUDIO',
    Other: 'OTHER',
    Csv: 'CSV'
} as const;
export type UpdatePatientDocumentDocumentFormatEnum = typeof UpdatePatientDocumentDocumentFormatEnum[keyof typeof UpdatePatientDocumentDocumentFormatEnum];
/**
 * @export
 */
export const UploadDocumentDocumentTagEnum = {
    PatientRegistrationForm: 'PATIENT_REGISTRATION_FORM',
    InsuranceInformation: 'INSURANCE_INFORMATION',
    ConsentForm: 'CONSENT_FORM',
    IdAndProofOfAddress: 'ID_AND_PROOF_OF_ADDRESS',
    ProgressNote: 'PROGRESS_NOTE',
    LabReport: 'LAB_REPORT',
    ImagingReport: 'IMAGING_REPORT',
    ConsultationNote: 'CONSULTATION_NOTE',
    SurgeryReport: 'SURGERY_REPORT',
    DischargeSummaries: 'DISCHARGE_SUMMARIES',
    MedicationList: 'MEDICATION_LIST',
    ReferralLetter: 'REFERRAL_LETTER',
    AuthorizationLetter: 'AUTHORIZATION_LETTER',
    Fax: 'FAX',
    EncounterSummary: 'ENCOUNTER_SUMMARY'
} as const;
export type UploadDocumentDocumentTagEnum = typeof UploadDocumentDocumentTagEnum[keyof typeof UploadDocumentDocumentTagEnum];
/**
 * @export
 */
export const UploadDocumentDocumentFormatEnum = {
    Pdf: 'PDF',
    MsWord: 'MS_WORD',
    Zip: 'ZIP',
    XGzip: 'X_GZIP',
    XCompressed: 'X_COMPRESSED',
    Docx: 'DOCX',
    Rtf: 'RTF',
    Plain: 'PLAIN',
    Xlsx: 'XLSX',
    JpegImage: 'JPEG_IMAGE',
    Mp4: 'MP4',
    PngImage: 'PNG_IMAGE',
    GifImage: 'GIF_IMAGE',
    BmpImage: 'BMP_IMAGE',
    WebpImage: 'WEBP_IMAGE',
    SvgImage: 'SVG_IMAGE',
    MpegAudio: 'MPEG_AUDIO',
    Other: 'OTHER',
    Csv: 'CSV'
} as const;
export type UploadDocumentDocumentFormatEnum = typeof UploadDocumentDocumentFormatEnum[keyof typeof UploadDocumentDocumentFormatEnum];


/**
 * PatientFamilyHistoryControllerApi - axios parameter creator
 * @export
 */
export const PatientFamilyHistoryControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Add a new patient family history into the system
         * @summary Add patient family history
         * @param {FamilyHistory} familyHistory 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPatientFamilyHistory: async (familyHistory: FamilyHistory, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'familyHistory' is not null or undefined
            assertParamExists('createPatientFamilyHistory', 'familyHistory', familyHistory)
            const localVarPath = `/api/master/patient-family-history`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(familyHistory, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Archive a Patient Family History by its ID
         * @summary Archive Patient Family History
         * @param {string} patientFamilyHistoryId 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePatientFamilyHistoryId: async (patientFamilyHistoryId: string, status: boolean, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientFamilyHistoryId' is not null or undefined
            assertParamExists('deletePatientFamilyHistoryId', 'patientFamilyHistoryId', patientFamilyHistoryId)
            // verify required parameter 'status' is not null or undefined
            assertParamExists('deletePatientFamilyHistoryId', 'status', status)
            const localVarPath = `/api/master/patient-family-history/{patientFamilyHistoryId}/archive-status/{status}`
                .replace(`{${"patientFamilyHistoryId"}}`, encodeURIComponent(String(patientFamilyHistoryId)))
                .replace(`{${"status"}}`, encodeURIComponent(String(status)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all Patient Family History list
         * @summary Get all Patient\'s Family History.
         * @param {string} [patientUuid] 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sort] 
         * @param {boolean} [status] 
         * @param {string} [appointmentUuid] 
         * @param {GetPatientFamilyHistoryProviderStatusEnum} [providerStatus] 
         * @param {boolean} [archive] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatientFamilyHistory: async (patientUuid?: string, page?: number, size?: number, sortBy?: string, sort?: string, status?: boolean, appointmentUuid?: string, providerStatus?: GetPatientFamilyHistoryProviderStatusEnum, archive?: boolean, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/master/patient-family-history`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (patientUuid !== undefined) {
                localVarQueryParameter['patientUuid'] = patientUuid;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (appointmentUuid !== undefined) {
                localVarQueryParameter['appointmentUuid'] = appointmentUuid;
            }

            if (providerStatus !== undefined) {
                localVarQueryParameter['providerStatus'] = providerStatus;
            }

            if (archive !== undefined) {
                localVarQueryParameter['archive'] = archive;
            }

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve a Patient Family History by its unique ID
         * @summary Get Patient Family History by ID
         * @param {string} patientFamilyHistoryId 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatientFamilyHistoryById: async (patientFamilyHistoryId: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientFamilyHistoryId' is not null or undefined
            assertParamExists('getPatientFamilyHistoryById', 'patientFamilyHistoryId', patientFamilyHistoryId)
            const localVarPath = `/api/master/patient-family-history/{patientFamilyHistoryId}`
                .replace(`{${"patientFamilyHistoryId"}}`, encodeURIComponent(String(patientFamilyHistoryId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update an existing Patient Family History
         * @summary Update Patient Family History
         * @param {FamilyHistory} familyHistory 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePatientFamilyHistory: async (familyHistory: FamilyHistory, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'familyHistory' is not null or undefined
            assertParamExists('updatePatientFamilyHistory', 'familyHistory', familyHistory)
            const localVarPath = `/api/master/patient-family-history`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(familyHistory, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Change the  Patient  Family history status.
         * @summary Update Patient Family History Status
         * @param {string} patientFamilyHistoryId 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePatientFamilyHistoryStatus: async (patientFamilyHistoryId: string, status: boolean, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientFamilyHistoryId' is not null or undefined
            assertParamExists('updatePatientFamilyHistoryStatus', 'patientFamilyHistoryId', patientFamilyHistoryId)
            // verify required parameter 'status' is not null or undefined
            assertParamExists('updatePatientFamilyHistoryStatus', 'status', status)
            const localVarPath = `/api/master/patient-family-history/{patientFamilyHistoryId}/status/{status}`
                .replace(`{${"patientFamilyHistoryId"}}`, encodeURIComponent(String(patientFamilyHistoryId)))
                .replace(`{${"status"}}`, encodeURIComponent(String(status)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PatientFamilyHistoryControllerApi - functional programming interface
 * @export
 */
export const PatientFamilyHistoryControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PatientFamilyHistoryControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * Add a new patient family history into the system
         * @summary Add patient family history
         * @param {FamilyHistory} familyHistory 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createPatientFamilyHistory(familyHistory: FamilyHistory, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createPatientFamilyHistory(familyHistory, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientFamilyHistoryControllerApi.createPatientFamilyHistory']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Archive a Patient Family History by its ID
         * @summary Archive Patient Family History
         * @param {string} patientFamilyHistoryId 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deletePatientFamilyHistoryId(patientFamilyHistoryId: string, status: boolean, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deletePatientFamilyHistoryId(patientFamilyHistoryId, status, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientFamilyHistoryControllerApi.deletePatientFamilyHistoryId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get all Patient Family History list
         * @summary Get all Patient\'s Family History.
         * @param {string} [patientUuid] 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sort] 
         * @param {boolean} [status] 
         * @param {string} [appointmentUuid] 
         * @param {GetPatientFamilyHistoryProviderStatusEnum} [providerStatus] 
         * @param {boolean} [archive] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPatientFamilyHistory(patientUuid?: string, page?: number, size?: number, sortBy?: string, sort?: string, status?: boolean, appointmentUuid?: string, providerStatus?: GetPatientFamilyHistoryProviderStatusEnum, archive?: boolean, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPatientFamilyHistory(patientUuid, page, size, sortBy, sort, status, appointmentUuid, providerStatus, archive, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientFamilyHistoryControllerApi.getPatientFamilyHistory']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve a Patient Family History by its unique ID
         * @summary Get Patient Family History by ID
         * @param {string} patientFamilyHistoryId 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPatientFamilyHistoryById(patientFamilyHistoryId: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPatientFamilyHistoryById(patientFamilyHistoryId, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientFamilyHistoryControllerApi.getPatientFamilyHistoryById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update an existing Patient Family History
         * @summary Update Patient Family History
         * @param {FamilyHistory} familyHistory 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePatientFamilyHistory(familyHistory: FamilyHistory, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePatientFamilyHistory(familyHistory, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientFamilyHistoryControllerApi.updatePatientFamilyHistory']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Change the  Patient  Family history status.
         * @summary Update Patient Family History Status
         * @param {string} patientFamilyHistoryId 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePatientFamilyHistoryStatus(patientFamilyHistoryId: string, status: boolean, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePatientFamilyHistoryStatus(patientFamilyHistoryId, status, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientFamilyHistoryControllerApi.updatePatientFamilyHistoryStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PatientFamilyHistoryControllerApi - factory interface
 * @export
 */
export const PatientFamilyHistoryControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PatientFamilyHistoryControllerApiFp(configuration)
    return {
        /**
         * Add a new patient family history into the system
         * @summary Add patient family history
         * @param {FamilyHistory} familyHistory 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPatientFamilyHistory(familyHistory: FamilyHistory, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.createPatientFamilyHistory(familyHistory, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Archive a Patient Family History by its ID
         * @summary Archive Patient Family History
         * @param {string} patientFamilyHistoryId 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePatientFamilyHistoryId(patientFamilyHistoryId: string, status: boolean, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.deletePatientFamilyHistoryId(patientFamilyHistoryId, status, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all Patient Family History list
         * @summary Get all Patient\'s Family History.
         * @param {string} [patientUuid] 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sort] 
         * @param {boolean} [status] 
         * @param {string} [appointmentUuid] 
         * @param {GetPatientFamilyHistoryProviderStatusEnum} [providerStatus] 
         * @param {boolean} [archive] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatientFamilyHistory(patientUuid?: string, page?: number, size?: number, sortBy?: string, sort?: string, status?: boolean, appointmentUuid?: string, providerStatus?: GetPatientFamilyHistoryProviderStatusEnum, archive?: boolean, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getPatientFamilyHistory(patientUuid, page, size, sortBy, sort, status, appointmentUuid, providerStatus, archive, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve a Patient Family History by its unique ID
         * @summary Get Patient Family History by ID
         * @param {string} patientFamilyHistoryId 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatientFamilyHistoryById(patientFamilyHistoryId: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getPatientFamilyHistoryById(patientFamilyHistoryId, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Update an existing Patient Family History
         * @summary Update Patient Family History
         * @param {FamilyHistory} familyHistory 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePatientFamilyHistory(familyHistory: FamilyHistory, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.updatePatientFamilyHistory(familyHistory, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Change the  Patient  Family history status.
         * @summary Update Patient Family History Status
         * @param {string} patientFamilyHistoryId 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePatientFamilyHistoryStatus(patientFamilyHistoryId: string, status: boolean, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.updatePatientFamilyHistoryStatus(patientFamilyHistoryId, status, xTENANTID, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PatientFamilyHistoryControllerApi - object-oriented interface
 * @export
 * @class PatientFamilyHistoryControllerApi
 * @extends {BaseAPI}
 */
export class PatientFamilyHistoryControllerApi extends BaseAPI {
    /**
     * Add a new patient family history into the system
     * @summary Add patient family history
     * @param {FamilyHistory} familyHistory 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientFamilyHistoryControllerApi
     */
    public createPatientFamilyHistory(familyHistory: FamilyHistory, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return PatientFamilyHistoryControllerApiFp(this.configuration).createPatientFamilyHistory(familyHistory, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Archive a Patient Family History by its ID
     * @summary Archive Patient Family History
     * @param {string} patientFamilyHistoryId 
     * @param {boolean} status 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientFamilyHistoryControllerApi
     */
    public deletePatientFamilyHistoryId(patientFamilyHistoryId: string, status: boolean, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return PatientFamilyHistoryControllerApiFp(this.configuration).deletePatientFamilyHistoryId(patientFamilyHistoryId, status, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all Patient Family History list
     * @summary Get all Patient\'s Family History.
     * @param {string} [patientUuid] 
     * @param {number} [page] 
     * @param {number} [size] 
     * @param {string} [sortBy] 
     * @param {string} [sort] 
     * @param {boolean} [status] 
     * @param {string} [appointmentUuid] 
     * @param {GetPatientFamilyHistoryProviderStatusEnum} [providerStatus] 
     * @param {boolean} [archive] 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientFamilyHistoryControllerApi
     */
    public getPatientFamilyHistory(patientUuid?: string, page?: number, size?: number, sortBy?: string, sort?: string, status?: boolean, appointmentUuid?: string, providerStatus?: GetPatientFamilyHistoryProviderStatusEnum, archive?: boolean, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return PatientFamilyHistoryControllerApiFp(this.configuration).getPatientFamilyHistory(patientUuid, page, size, sortBy, sort, status, appointmentUuid, providerStatus, archive, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve a Patient Family History by its unique ID
     * @summary Get Patient Family History by ID
     * @param {string} patientFamilyHistoryId 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientFamilyHistoryControllerApi
     */
    public getPatientFamilyHistoryById(patientFamilyHistoryId: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return PatientFamilyHistoryControllerApiFp(this.configuration).getPatientFamilyHistoryById(patientFamilyHistoryId, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update an existing Patient Family History
     * @summary Update Patient Family History
     * @param {FamilyHistory} familyHistory 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientFamilyHistoryControllerApi
     */
    public updatePatientFamilyHistory(familyHistory: FamilyHistory, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return PatientFamilyHistoryControllerApiFp(this.configuration).updatePatientFamilyHistory(familyHistory, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Change the  Patient  Family history status.
     * @summary Update Patient Family History Status
     * @param {string} patientFamilyHistoryId 
     * @param {boolean} status 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientFamilyHistoryControllerApi
     */
    public updatePatientFamilyHistoryStatus(patientFamilyHistoryId: string, status: boolean, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return PatientFamilyHistoryControllerApiFp(this.configuration).updatePatientFamilyHistoryStatus(patientFamilyHistoryId, status, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const GetPatientFamilyHistoryProviderStatusEnum = {
    Pending: 'PENDING',
    Confirmed: 'CONFIRMED'
} as const;
export type GetPatientFamilyHistoryProviderStatusEnum = typeof GetPatientFamilyHistoryProviderStatusEnum[keyof typeof GetPatientFamilyHistoryProviderStatusEnum];


/**
 * PatientFlagsControllerApi - axios parameter creator
 * @export
 */
export const PatientFlagsControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Assign multiple flags to a patient. Skips already assigned flags.
         * @summary Assign Multiple Flags to a Patient
         * @param {PatientMultipleFlagsRequest} patientMultipleFlagsRequest 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignMultipleFlagsToPatient: async (patientMultipleFlagsRequest: PatientMultipleFlagsRequest, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientMultipleFlagsRequest' is not null or undefined
            assertParamExists('assignMultipleFlagsToPatient', 'patientMultipleFlagsRequest', patientMultipleFlagsRequest)
            const localVarPath = `/api/master/patient-flags/assign-multiple-flags`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patientMultipleFlagsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Add a new patient flags into the system
         * @summary Add Patient Flags
         * @param {PatientFlags} patientFlags 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPatientFlags: async (patientFlags: PatientFlags, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientFlags' is not null or undefined
            assertParamExists('createPatientFlags', 'patientFlags', patientFlags)
            const localVarPath = `/api/master/patient-flags`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patientFlags, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve a Patient Flag by its unique ID
         * @summary Get Patient Flag by ID
         * @param {string} patientFlagId 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatientFlagById: async (patientFlagId: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientFlagId' is not null or undefined
            assertParamExists('getPatientFlagById', 'patientFlagId', patientFlagId)
            const localVarPath = `/api/master/patient-flags/{patientFlagId}`
                .replace(`{${"patientFlagId"}}`, encodeURIComponent(String(patientFlagId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all Patient Flags list with search option on flagUuid, patientId and filter options on active, archive.
         * @summary Get all Patient Flags.
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sort] 
         * @param {string} [patientUuid] 
         * @param {boolean} [status] 
         * @param {boolean} [archive] 
         * @param {string} [flagUuid] 
         * @param {string} [searchString] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatientFlags: async (page?: number, size?: number, sortBy?: string, sort?: string, patientUuid?: string, status?: boolean, archive?: boolean, flagUuid?: string, searchString?: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/master/patient-flags`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (patientUuid !== undefined) {
                localVarQueryParameter['patientUuid'] = patientUuid;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (archive !== undefined) {
                localVarQueryParameter['archive'] = archive;
            }

            if (flagUuid !== undefined) {
                localVarQueryParameter['flagUuid'] = flagUuid;
            }

            if (searchString !== undefined) {
                localVarQueryParameter['searchString'] = searchString;
            }

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Remove a patient from a patient flag by flag UUID and patient UUID
         * @summary Remove Patient from Flag
         * @param {string} patientFlagId 
         * @param {string} patientUuid 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removePatientFromFlag: async (patientFlagId: string, patientUuid: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientFlagId' is not null or undefined
            assertParamExists('removePatientFromFlag', 'patientFlagId', patientFlagId)
            // verify required parameter 'patientUuid' is not null or undefined
            assertParamExists('removePatientFromFlag', 'patientUuid', patientUuid)
            const localVarPath = `/api/master/patient-flags/{patientFlagId}/remove-patient/{patientUuid}`
                .replace(`{${"patientFlagId"}}`, encodeURIComponent(String(patientFlagId)))
                .replace(`{${"patientUuid"}}`, encodeURIComponent(String(patientUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Archive a Patient Flags by its ID
         * @summary Archive Patient Flags
         * @param {string} patientFlagId 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePatientFlagArchiveStatus: async (patientFlagId: string, status: boolean, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientFlagId' is not null or undefined
            assertParamExists('updatePatientFlagArchiveStatus', 'patientFlagId', patientFlagId)
            // verify required parameter 'status' is not null or undefined
            assertParamExists('updatePatientFlagArchiveStatus', 'status', status)
            const localVarPath = `/api/master/patient-flags/{patientFlagId}/archive-status/{status}`
                .replace(`{${"patientFlagId"}}`, encodeURIComponent(String(patientFlagId)))
                .replace(`{${"status"}}`, encodeURIComponent(String(status)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update an existing Patient Flags
         * @summary Update Patient Flags
         * @param {PatientFlags} patientFlags 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePatientFlags: async (patientFlags: PatientFlags, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientFlags' is not null or undefined
            assertParamExists('updatePatientFlags', 'patientFlags', patientFlags)
            const localVarPath = `/api/master/patient-flags`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patientFlags, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PatientFlagsControllerApi - functional programming interface
 * @export
 */
export const PatientFlagsControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PatientFlagsControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * Assign multiple flags to a patient. Skips already assigned flags.
         * @summary Assign Multiple Flags to a Patient
         * @param {PatientMultipleFlagsRequest} patientMultipleFlagsRequest 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assignMultipleFlagsToPatient(patientMultipleFlagsRequest: PatientMultipleFlagsRequest, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assignMultipleFlagsToPatient(patientMultipleFlagsRequest, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientFlagsControllerApi.assignMultipleFlagsToPatient']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Add a new patient flags into the system
         * @summary Add Patient Flags
         * @param {PatientFlags} patientFlags 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createPatientFlags(patientFlags: PatientFlags, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createPatientFlags(patientFlags, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientFlagsControllerApi.createPatientFlags']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve a Patient Flag by its unique ID
         * @summary Get Patient Flag by ID
         * @param {string} patientFlagId 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPatientFlagById(patientFlagId: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPatientFlagById(patientFlagId, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientFlagsControllerApi.getPatientFlagById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get all Patient Flags list with search option on flagUuid, patientId and filter options on active, archive.
         * @summary Get all Patient Flags.
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sort] 
         * @param {string} [patientUuid] 
         * @param {boolean} [status] 
         * @param {boolean} [archive] 
         * @param {string} [flagUuid] 
         * @param {string} [searchString] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPatientFlags(page?: number, size?: number, sortBy?: string, sort?: string, patientUuid?: string, status?: boolean, archive?: boolean, flagUuid?: string, searchString?: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPatientFlags(page, size, sortBy, sort, patientUuid, status, archive, flagUuid, searchString, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientFlagsControllerApi.getPatientFlags']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Remove a patient from a patient flag by flag UUID and patient UUID
         * @summary Remove Patient from Flag
         * @param {string} patientFlagId 
         * @param {string} patientUuid 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removePatientFromFlag(patientFlagId: string, patientUuid: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removePatientFromFlag(patientFlagId, patientUuid, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientFlagsControllerApi.removePatientFromFlag']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Archive a Patient Flags by its ID
         * @summary Archive Patient Flags
         * @param {string} patientFlagId 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePatientFlagArchiveStatus(patientFlagId: string, status: boolean, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePatientFlagArchiveStatus(patientFlagId, status, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientFlagsControllerApi.updatePatientFlagArchiveStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update an existing Patient Flags
         * @summary Update Patient Flags
         * @param {PatientFlags} patientFlags 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePatientFlags(patientFlags: PatientFlags, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePatientFlags(patientFlags, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientFlagsControllerApi.updatePatientFlags']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PatientFlagsControllerApi - factory interface
 * @export
 */
export const PatientFlagsControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PatientFlagsControllerApiFp(configuration)
    return {
        /**
         * Assign multiple flags to a patient. Skips already assigned flags.
         * @summary Assign Multiple Flags to a Patient
         * @param {PatientMultipleFlagsRequest} patientMultipleFlagsRequest 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignMultipleFlagsToPatient(patientMultipleFlagsRequest: PatientMultipleFlagsRequest, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.assignMultipleFlagsToPatient(patientMultipleFlagsRequest, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Add a new patient flags into the system
         * @summary Add Patient Flags
         * @param {PatientFlags} patientFlags 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPatientFlags(patientFlags: PatientFlags, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.createPatientFlags(patientFlags, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve a Patient Flag by its unique ID
         * @summary Get Patient Flag by ID
         * @param {string} patientFlagId 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatientFlagById(patientFlagId: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getPatientFlagById(patientFlagId, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all Patient Flags list with search option on flagUuid, patientId and filter options on active, archive.
         * @summary Get all Patient Flags.
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sort] 
         * @param {string} [patientUuid] 
         * @param {boolean} [status] 
         * @param {boolean} [archive] 
         * @param {string} [flagUuid] 
         * @param {string} [searchString] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatientFlags(page?: number, size?: number, sortBy?: string, sort?: string, patientUuid?: string, status?: boolean, archive?: boolean, flagUuid?: string, searchString?: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getPatientFlags(page, size, sortBy, sort, patientUuid, status, archive, flagUuid, searchString, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Remove a patient from a patient flag by flag UUID and patient UUID
         * @summary Remove Patient from Flag
         * @param {string} patientFlagId 
         * @param {string} patientUuid 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removePatientFromFlag(patientFlagId: string, patientUuid: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.removePatientFromFlag(patientFlagId, patientUuid, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Archive a Patient Flags by its ID
         * @summary Archive Patient Flags
         * @param {string} patientFlagId 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePatientFlagArchiveStatus(patientFlagId: string, status: boolean, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.updatePatientFlagArchiveStatus(patientFlagId, status, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Update an existing Patient Flags
         * @summary Update Patient Flags
         * @param {PatientFlags} patientFlags 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePatientFlags(patientFlags: PatientFlags, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.updatePatientFlags(patientFlags, xTENANTID, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PatientFlagsControllerApi - object-oriented interface
 * @export
 * @class PatientFlagsControllerApi
 * @extends {BaseAPI}
 */
export class PatientFlagsControllerApi extends BaseAPI {
    /**
     * Assign multiple flags to a patient. Skips already assigned flags.
     * @summary Assign Multiple Flags to a Patient
     * @param {PatientMultipleFlagsRequest} patientMultipleFlagsRequest 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientFlagsControllerApi
     */
    public assignMultipleFlagsToPatient(patientMultipleFlagsRequest: PatientMultipleFlagsRequest, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return PatientFlagsControllerApiFp(this.configuration).assignMultipleFlagsToPatient(patientMultipleFlagsRequest, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Add a new patient flags into the system
     * @summary Add Patient Flags
     * @param {PatientFlags} patientFlags 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientFlagsControllerApi
     */
    public createPatientFlags(patientFlags: PatientFlags, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return PatientFlagsControllerApiFp(this.configuration).createPatientFlags(patientFlags, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve a Patient Flag by its unique ID
     * @summary Get Patient Flag by ID
     * @param {string} patientFlagId 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientFlagsControllerApi
     */
    public getPatientFlagById(patientFlagId: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return PatientFlagsControllerApiFp(this.configuration).getPatientFlagById(patientFlagId, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all Patient Flags list with search option on flagUuid, patientId and filter options on active, archive.
     * @summary Get all Patient Flags.
     * @param {number} [page] 
     * @param {number} [size] 
     * @param {string} [sortBy] 
     * @param {string} [sort] 
     * @param {string} [patientUuid] 
     * @param {boolean} [status] 
     * @param {boolean} [archive] 
     * @param {string} [flagUuid] 
     * @param {string} [searchString] 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientFlagsControllerApi
     */
    public getPatientFlags(page?: number, size?: number, sortBy?: string, sort?: string, patientUuid?: string, status?: boolean, archive?: boolean, flagUuid?: string, searchString?: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return PatientFlagsControllerApiFp(this.configuration).getPatientFlags(page, size, sortBy, sort, patientUuid, status, archive, flagUuid, searchString, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Remove a patient from a patient flag by flag UUID and patient UUID
     * @summary Remove Patient from Flag
     * @param {string} patientFlagId 
     * @param {string} patientUuid 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientFlagsControllerApi
     */
    public removePatientFromFlag(patientFlagId: string, patientUuid: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return PatientFlagsControllerApiFp(this.configuration).removePatientFromFlag(patientFlagId, patientUuid, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Archive a Patient Flags by its ID
     * @summary Archive Patient Flags
     * @param {string} patientFlagId 
     * @param {boolean} status 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientFlagsControllerApi
     */
    public updatePatientFlagArchiveStatus(patientFlagId: string, status: boolean, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return PatientFlagsControllerApiFp(this.configuration).updatePatientFlagArchiveStatus(patientFlagId, status, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update an existing Patient Flags
     * @summary Update Patient Flags
     * @param {PatientFlags} patientFlags 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientFlagsControllerApi
     */
    public updatePatientFlags(patientFlags: PatientFlags, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return PatientFlagsControllerApiFp(this.configuration).updatePatientFlags(patientFlags, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PatientFormControllerApi - axios parameter creator
 * @export
 */
export const PatientFormControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get all patient forms by the patient Id. Optionally filter by status (e.g. PENDING, COMPLETED).
         * @summary get-all-patientId-forms
         * @param {string} patientId 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {Array<string>} [status] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllPatientForms: async (patientId: string, page?: number, size?: number, sortBy?: string, sortDirection?: string, status?: Array<string>, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientId' is not null or undefined
            assertParamExists('getAllPatientForms', 'patientId', patientId)
            const localVarPath = `/api/master/patient-form/get-all-forms/{patientId}`
                .replace(`{${"patientId"}}`, encodeURIComponent(String(patientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }

            if (status) {
                localVarQueryParameter['status'] = status;
            }

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Resend intake forms for an appointment
         * @summary Send Patient Forms
         * @param {Array<string>} patientForms 
         * @param {string} patientId 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendForm: async (patientForms: Array<string>, patientId: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientForms' is not null or undefined
            assertParamExists('sendForm', 'patientForms', patientForms)
            // verify required parameter 'patientId' is not null or undefined
            assertParamExists('sendForm', 'patientId', patientId)
            const localVarPath = `/api/master/patient-form/sendForm`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (patientForms) {
                localVarQueryParameter['patientForms'] = patientForms;
            }

            if (patientId !== undefined) {
                localVarQueryParameter['patientId'] = patientId;
            }

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PatientFormControllerApi - functional programming interface
 * @export
 */
export const PatientFormControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PatientFormControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * Get all patient forms by the patient Id. Optionally filter by status (e.g. PENDING, COMPLETED).
         * @summary get-all-patientId-forms
         * @param {string} patientId 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {Array<string>} [status] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllPatientForms(patientId: string, page?: number, size?: number, sortBy?: string, sortDirection?: string, status?: Array<string>, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagedModelPatientFormEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllPatientForms(patientId, page, size, sortBy, sortDirection, status, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientFormControllerApi.getAllPatientForms']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Resend intake forms for an appointment
         * @summary Send Patient Forms
         * @param {Array<string>} patientForms 
         * @param {string} patientId 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendForm(patientForms: Array<string>, patientId: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendForm(patientForms, patientId, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientFormControllerApi.sendForm']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PatientFormControllerApi - factory interface
 * @export
 */
export const PatientFormControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PatientFormControllerApiFp(configuration)
    return {
        /**
         * Get all patient forms by the patient Id. Optionally filter by status (e.g. PENDING, COMPLETED).
         * @summary get-all-patientId-forms
         * @param {string} patientId 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {Array<string>} [status] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllPatientForms(patientId: string, page?: number, size?: number, sortBy?: string, sortDirection?: string, status?: Array<string>, xTENANTID?: string, options?: any): AxiosPromise<PagedModelPatientFormEntity> {
            return localVarFp.getAllPatientForms(patientId, page, size, sortBy, sortDirection, status, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Resend intake forms for an appointment
         * @summary Send Patient Forms
         * @param {Array<string>} patientForms 
         * @param {string} patientId 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendForm(patientForms: Array<string>, patientId: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.sendForm(patientForms, patientId, xTENANTID, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PatientFormControllerApi - object-oriented interface
 * @export
 * @class PatientFormControllerApi
 * @extends {BaseAPI}
 */
export class PatientFormControllerApi extends BaseAPI {
    /**
     * Get all patient forms by the patient Id. Optionally filter by status (e.g. PENDING, COMPLETED).
     * @summary get-all-patientId-forms
     * @param {string} patientId 
     * @param {number} [page] 
     * @param {number} [size] 
     * @param {string} [sortBy] 
     * @param {string} [sortDirection] 
     * @param {Array<string>} [status] 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientFormControllerApi
     */
    public getAllPatientForms(patientId: string, page?: number, size?: number, sortBy?: string, sortDirection?: string, status?: Array<string>, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return PatientFormControllerApiFp(this.configuration).getAllPatientForms(patientId, page, size, sortBy, sortDirection, status, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Resend intake forms for an appointment
     * @summary Send Patient Forms
     * @param {Array<string>} patientForms 
     * @param {string} patientId 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientFormControllerApi
     */
    public sendForm(patientForms: Array<string>, patientId: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return PatientFormControllerApiFp(this.configuration).sendForm(patientForms, patientId, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PatientInquiryControllerApi - axios parameter creator
 * @export
 */
export const PatientInquiryControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get a single patient inquiry with full detail: list fields plus patient phone, email, address (decrypted), timezone, appointment chief complaint, app type, payment mode, patient note.
         * @summary Get patient inquiry by ID
         * @param {string} uuid 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatientInquiryById: async (uuid: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('getPatientInquiryById', 'uuid', uuid)
            const localVarPath = `/api/master/patient-inquiry/{uuid}`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get paginated patient inquiries. Filters: providerId, status (multi-select). Search by patient name.
         * @summary Get patient inquiry list
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {string} [providerId] 
         * @param {Array<GetPatientInquiryListStatusEnum>} [status] 
         * @param {string} [searchString] 
         * @param {string} [source] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatientInquiryList: async (page?: number, size?: number, sortBy?: string, sortDirection?: string, providerId?: string, status?: Array<GetPatientInquiryListStatusEnum>, searchString?: string, source?: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/master/patient-inquiry`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }

            if (providerId !== undefined) {
                localVarQueryParameter['providerId'] = providerId;
            }

            if (status) {
                localVarQueryParameter['status'] = status;
            }

            if (searchString !== undefined) {
                localVarQueryParameter['searchString'] = searchString;
            }

            if (source !== undefined) {
                localVarQueryParameter['source'] = source;
            }

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get patient inquiry counts by status
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatientInquiryStatusCounts: async (xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/master/patient-inquiry/status-counts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Confirm or reject a patient appointment request. Payload: status (CONFIRMED/REJECTED), optional rejectReason when status is REJECTED. Updates enquiry and asynchronously updates appointment appStatusForPatient (and appointment status to CONFIRMED when confirmed).
         * @summary Update patient inquiry status
         * @param {string} uuid 
         * @param {PatientInquiryStatusUpdate} patientInquiryStatusUpdate 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateStatus1: async (uuid: string, patientInquiryStatusUpdate: PatientInquiryStatusUpdate, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('updateStatus1', 'uuid', uuid)
            // verify required parameter 'patientInquiryStatusUpdate' is not null or undefined
            assertParamExists('updateStatus1', 'patientInquiryStatusUpdate', patientInquiryStatusUpdate)
            const localVarPath = `/api/master/patient-inquiry/{uuid}`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patientInquiryStatusUpdate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PatientInquiryControllerApi - functional programming interface
 * @export
 */
export const PatientInquiryControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PatientInquiryControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * Get a single patient inquiry with full detail: list fields plus patient phone, email, address (decrypted), timezone, appointment chief complaint, app type, payment mode, patient note.
         * @summary Get patient inquiry by ID
         * @param {string} uuid 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPatientInquiryById(uuid: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPatientInquiryById(uuid, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientInquiryControllerApi.getPatientInquiryById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get paginated patient inquiries. Filters: providerId, status (multi-select). Search by patient name.
         * @summary Get patient inquiry list
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {string} [providerId] 
         * @param {Array<GetPatientInquiryListStatusEnum>} [status] 
         * @param {string} [searchString] 
         * @param {string} [source] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPatientInquiryList(page?: number, size?: number, sortBy?: string, sortDirection?: string, providerId?: string, status?: Array<GetPatientInquiryListStatusEnum>, searchString?: string, source?: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPatientInquiryList(page, size, sortBy, sortDirection, providerId, status, searchString, source, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientInquiryControllerApi.getPatientInquiryList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get patient inquiry counts by status
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPatientInquiryStatusCounts(xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPatientInquiryStatusCounts(xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientInquiryControllerApi.getPatientInquiryStatusCounts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Confirm or reject a patient appointment request. Payload: status (CONFIRMED/REJECTED), optional rejectReason when status is REJECTED. Updates enquiry and asynchronously updates appointment appStatusForPatient (and appointment status to CONFIRMED when confirmed).
         * @summary Update patient inquiry status
         * @param {string} uuid 
         * @param {PatientInquiryStatusUpdate} patientInquiryStatusUpdate 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateStatus1(uuid: string, patientInquiryStatusUpdate: PatientInquiryStatusUpdate, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateStatus1(uuid, patientInquiryStatusUpdate, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientInquiryControllerApi.updateStatus1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PatientInquiryControllerApi - factory interface
 * @export
 */
export const PatientInquiryControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PatientInquiryControllerApiFp(configuration)
    return {
        /**
         * Get a single patient inquiry with full detail: list fields plus patient phone, email, address (decrypted), timezone, appointment chief complaint, app type, payment mode, patient note.
         * @summary Get patient inquiry by ID
         * @param {string} uuid 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatientInquiryById(uuid: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getPatientInquiryById(uuid, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Get paginated patient inquiries. Filters: providerId, status (multi-select). Search by patient name.
         * @summary Get patient inquiry list
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {string} [providerId] 
         * @param {Array<GetPatientInquiryListStatusEnum>} [status] 
         * @param {string} [searchString] 
         * @param {string} [source] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatientInquiryList(page?: number, size?: number, sortBy?: string, sortDirection?: string, providerId?: string, status?: Array<GetPatientInquiryListStatusEnum>, searchString?: string, source?: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getPatientInquiryList(page, size, sortBy, sortDirection, providerId, status, searchString, source, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get patient inquiry counts by status
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatientInquiryStatusCounts(xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getPatientInquiryStatusCounts(xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Confirm or reject a patient appointment request. Payload: status (CONFIRMED/REJECTED), optional rejectReason when status is REJECTED. Updates enquiry and asynchronously updates appointment appStatusForPatient (and appointment status to CONFIRMED when confirmed).
         * @summary Update patient inquiry status
         * @param {string} uuid 
         * @param {PatientInquiryStatusUpdate} patientInquiryStatusUpdate 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateStatus1(uuid: string, patientInquiryStatusUpdate: PatientInquiryStatusUpdate, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.updateStatus1(uuid, patientInquiryStatusUpdate, xTENANTID, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PatientInquiryControllerApi - object-oriented interface
 * @export
 * @class PatientInquiryControllerApi
 * @extends {BaseAPI}
 */
export class PatientInquiryControllerApi extends BaseAPI {
    /**
     * Get a single patient inquiry with full detail: list fields plus patient phone, email, address (decrypted), timezone, appointment chief complaint, app type, payment mode, patient note.
     * @summary Get patient inquiry by ID
     * @param {string} uuid 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientInquiryControllerApi
     */
    public getPatientInquiryById(uuid: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return PatientInquiryControllerApiFp(this.configuration).getPatientInquiryById(uuid, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get paginated patient inquiries. Filters: providerId, status (multi-select). Search by patient name.
     * @summary Get patient inquiry list
     * @param {number} [page] 
     * @param {number} [size] 
     * @param {string} [sortBy] 
     * @param {string} [sortDirection] 
     * @param {string} [providerId] 
     * @param {Array<GetPatientInquiryListStatusEnum>} [status] 
     * @param {string} [searchString] 
     * @param {string} [source] 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientInquiryControllerApi
     */
    public getPatientInquiryList(page?: number, size?: number, sortBy?: string, sortDirection?: string, providerId?: string, status?: Array<GetPatientInquiryListStatusEnum>, searchString?: string, source?: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return PatientInquiryControllerApiFp(this.configuration).getPatientInquiryList(page, size, sortBy, sortDirection, providerId, status, searchString, source, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get patient inquiry counts by status
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientInquiryControllerApi
     */
    public getPatientInquiryStatusCounts(xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return PatientInquiryControllerApiFp(this.configuration).getPatientInquiryStatusCounts(xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Confirm or reject a patient appointment request. Payload: status (CONFIRMED/REJECTED), optional rejectReason when status is REJECTED. Updates enquiry and asynchronously updates appointment appStatusForPatient (and appointment status to CONFIRMED when confirmed).
     * @summary Update patient inquiry status
     * @param {string} uuid 
     * @param {PatientInquiryStatusUpdate} patientInquiryStatusUpdate 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientInquiryControllerApi
     */
    public updateStatus1(uuid: string, patientInquiryStatusUpdate: PatientInquiryStatusUpdate, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return PatientInquiryControllerApiFp(this.configuration).updateStatus1(uuid, patientInquiryStatusUpdate, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const GetPatientInquiryListStatusEnum = {
    Pending: 'PENDING',
    Confirmed: 'CONFIRMED',
    Rejected: 'REJECTED'
} as const;
export type GetPatientInquiryListStatusEnum = typeof GetPatientInquiryListStatusEnum[keyof typeof GetPatientInquiryListStatusEnum];


/**
 * PatientInsuranceControllerApi - axios parameter creator
 * @export
 */
export const PatientInsuranceControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Add a new patient insurance into the system
         * @summary Add Patient Insurance
         * @param {Array<PatientInsurance>} patientInsurance 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPatientInsurance: async (patientInsurance: Array<PatientInsurance>, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientInsurance' is not null or undefined
            assertParamExists('createPatientInsurance', 'patientInsurance', patientInsurance)
            const localVarPath = `/api/master/patient-insurance`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patientInsurance, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all Patient Insurance list with search option on name, patientId and filter options on active, archive.
         * @summary Get all Patient Insurance.
         * @param {string} patientUuid 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sort] 
         * @param {GetPatientInsuranceInsuranceTypeEnum} [insuranceType] 
         * @param {boolean} [status] 
         * @param {boolean} [archive] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatientInsurance: async (patientUuid: string, page?: number, size?: number, sortBy?: string, sort?: string, insuranceType?: GetPatientInsuranceInsuranceTypeEnum, status?: boolean, archive?: boolean, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientUuid' is not null or undefined
            assertParamExists('getPatientInsurance', 'patientUuid', patientUuid)
            const localVarPath = `/api/master/patient-insurance`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (patientUuid !== undefined) {
                localVarQueryParameter['patientUuid'] = patientUuid;
            }

            if (insuranceType !== undefined) {
                localVarQueryParameter['insurance_type'] = insuranceType;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (archive !== undefined) {
                localVarQueryParameter['archive'] = archive;
            }

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve a Patient Insurance by its unique ID
         * @summary Get Patient Insurance by ID
         * @param {string} patientInsuranceId 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatientInsuranceById: async (patientInsuranceId: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientInsuranceId' is not null or undefined
            assertParamExists('getPatientInsuranceById', 'patientInsuranceId', patientInsuranceId)
            const localVarPath = `/api/master/patient-insurance/{patientInsuranceId}`
                .replace(`{${"patientInsuranceId"}}`, encodeURIComponent(String(patientInsuranceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update an existing Patient Insurance
         * @summary Update Patient Insurance
         * @param {PatientInsurance} patientInsurance 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePatientInsurance: async (patientInsurance: PatientInsurance, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientInsurance' is not null or undefined
            assertParamExists('updatePatientInsurance', 'patientInsurance', patientInsurance)
            const localVarPath = `/api/master/patient-insurance`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patientInsurance, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Archive a Patient Insurance by its ID
         * @summary Archive Patient Insurance
         * @param {string} patientInsuranceId 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePatientInsuranceArchiveStatus: async (patientInsuranceId: string, status: boolean, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientInsuranceId' is not null or undefined
            assertParamExists('updatePatientInsuranceArchiveStatus', 'patientInsuranceId', patientInsuranceId)
            // verify required parameter 'status' is not null or undefined
            assertParamExists('updatePatientInsuranceArchiveStatus', 'status', status)
            const localVarPath = `/api/master/patient-insurance/{patientInsuranceId}/archive-status/{status}`
                .replace(`{${"patientInsuranceId"}}`, encodeURIComponent(String(patientInsuranceId)))
                .replace(`{${"status"}}`, encodeURIComponent(String(status)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Set Primary Patient Insurance
         * @summary Set Primary Patient Insurance
         * @param {string} patientUuid 
         * @param {string} patientInsuranceId 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePatientInsurancePrimary: async (patientUuid: string, patientInsuranceId: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientUuid' is not null or undefined
            assertParamExists('updatePatientInsurancePrimary', 'patientUuid', patientUuid)
            // verify required parameter 'patientInsuranceId' is not null or undefined
            assertParamExists('updatePatientInsurancePrimary', 'patientInsuranceId', patientInsuranceId)
            const localVarPath = `/api/master/patient-insurance/{patientInsuranceId}/{patientUuid}`
                .replace(`{${"patientUuid"}}`, encodeURIComponent(String(patientUuid)))
                .replace(`{${"patientInsuranceId"}}`, encodeURIComponent(String(patientInsuranceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update the status of a Patient Insurance by its ID
         * @summary Update Patient Insurance Status
         * @param {string} patientInsuranceId 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePatientInsuranceStatus: async (patientInsuranceId: string, status: boolean, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientInsuranceId' is not null or undefined
            assertParamExists('updatePatientInsuranceStatus', 'patientInsuranceId', patientInsuranceId)
            // verify required parameter 'status' is not null or undefined
            assertParamExists('updatePatientInsuranceStatus', 'status', status)
            const localVarPath = `/api/master/patient-insurance/{patientInsuranceId}/status/{status}`
                .replace(`{${"patientInsuranceId"}}`, encodeURIComponent(String(patientInsuranceId)))
                .replace(`{${"status"}}`, encodeURIComponent(String(status)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PatientInsuranceControllerApi - functional programming interface
 * @export
 */
export const PatientInsuranceControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PatientInsuranceControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * Add a new patient insurance into the system
         * @summary Add Patient Insurance
         * @param {Array<PatientInsurance>} patientInsurance 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createPatientInsurance(patientInsurance: Array<PatientInsurance>, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createPatientInsurance(patientInsurance, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientInsuranceControllerApi.createPatientInsurance']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get all Patient Insurance list with search option on name, patientId and filter options on active, archive.
         * @summary Get all Patient Insurance.
         * @param {string} patientUuid 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sort] 
         * @param {GetPatientInsuranceInsuranceTypeEnum} [insuranceType] 
         * @param {boolean} [status] 
         * @param {boolean} [archive] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPatientInsurance(patientUuid: string, page?: number, size?: number, sortBy?: string, sort?: string, insuranceType?: GetPatientInsuranceInsuranceTypeEnum, status?: boolean, archive?: boolean, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPatientInsurance(patientUuid, page, size, sortBy, sort, insuranceType, status, archive, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientInsuranceControllerApi.getPatientInsurance']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve a Patient Insurance by its unique ID
         * @summary Get Patient Insurance by ID
         * @param {string} patientInsuranceId 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPatientInsuranceById(patientInsuranceId: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPatientInsuranceById(patientInsuranceId, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientInsuranceControllerApi.getPatientInsuranceById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update an existing Patient Insurance
         * @summary Update Patient Insurance
         * @param {PatientInsurance} patientInsurance 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePatientInsurance(patientInsurance: PatientInsurance, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePatientInsurance(patientInsurance, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientInsuranceControllerApi.updatePatientInsurance']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Archive a Patient Insurance by its ID
         * @summary Archive Patient Insurance
         * @param {string} patientInsuranceId 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePatientInsuranceArchiveStatus(patientInsuranceId: string, status: boolean, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePatientInsuranceArchiveStatus(patientInsuranceId, status, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientInsuranceControllerApi.updatePatientInsuranceArchiveStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Set Primary Patient Insurance
         * @summary Set Primary Patient Insurance
         * @param {string} patientUuid 
         * @param {string} patientInsuranceId 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePatientInsurancePrimary(patientUuid: string, patientInsuranceId: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePatientInsurancePrimary(patientUuid, patientInsuranceId, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientInsuranceControllerApi.updatePatientInsurancePrimary']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update the status of a Patient Insurance by its ID
         * @summary Update Patient Insurance Status
         * @param {string} patientInsuranceId 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePatientInsuranceStatus(patientInsuranceId: string, status: boolean, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePatientInsuranceStatus(patientInsuranceId, status, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientInsuranceControllerApi.updatePatientInsuranceStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PatientInsuranceControllerApi - factory interface
 * @export
 */
export const PatientInsuranceControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PatientInsuranceControllerApiFp(configuration)
    return {
        /**
         * Add a new patient insurance into the system
         * @summary Add Patient Insurance
         * @param {Array<PatientInsurance>} patientInsurance 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPatientInsurance(patientInsurance: Array<PatientInsurance>, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.createPatientInsurance(patientInsurance, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all Patient Insurance list with search option on name, patientId and filter options on active, archive.
         * @summary Get all Patient Insurance.
         * @param {string} patientUuid 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sort] 
         * @param {GetPatientInsuranceInsuranceTypeEnum} [insuranceType] 
         * @param {boolean} [status] 
         * @param {boolean} [archive] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatientInsurance(patientUuid: string, page?: number, size?: number, sortBy?: string, sort?: string, insuranceType?: GetPatientInsuranceInsuranceTypeEnum, status?: boolean, archive?: boolean, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getPatientInsurance(patientUuid, page, size, sortBy, sort, insuranceType, status, archive, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve a Patient Insurance by its unique ID
         * @summary Get Patient Insurance by ID
         * @param {string} patientInsuranceId 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatientInsuranceById(patientInsuranceId: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getPatientInsuranceById(patientInsuranceId, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Update an existing Patient Insurance
         * @summary Update Patient Insurance
         * @param {PatientInsurance} patientInsurance 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePatientInsurance(patientInsurance: PatientInsurance, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.updatePatientInsurance(patientInsurance, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Archive a Patient Insurance by its ID
         * @summary Archive Patient Insurance
         * @param {string} patientInsuranceId 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePatientInsuranceArchiveStatus(patientInsuranceId: string, status: boolean, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.updatePatientInsuranceArchiveStatus(patientInsuranceId, status, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Set Primary Patient Insurance
         * @summary Set Primary Patient Insurance
         * @param {string} patientUuid 
         * @param {string} patientInsuranceId 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePatientInsurancePrimary(patientUuid: string, patientInsuranceId: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.updatePatientInsurancePrimary(patientUuid, patientInsuranceId, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Update the status of a Patient Insurance by its ID
         * @summary Update Patient Insurance Status
         * @param {string} patientInsuranceId 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePatientInsuranceStatus(patientInsuranceId: string, status: boolean, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.updatePatientInsuranceStatus(patientInsuranceId, status, xTENANTID, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PatientInsuranceControllerApi - object-oriented interface
 * @export
 * @class PatientInsuranceControllerApi
 * @extends {BaseAPI}
 */
export class PatientInsuranceControllerApi extends BaseAPI {
    /**
     * Add a new patient insurance into the system
     * @summary Add Patient Insurance
     * @param {Array<PatientInsurance>} patientInsurance 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientInsuranceControllerApi
     */
    public createPatientInsurance(patientInsurance: Array<PatientInsurance>, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return PatientInsuranceControllerApiFp(this.configuration).createPatientInsurance(patientInsurance, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all Patient Insurance list with search option on name, patientId and filter options on active, archive.
     * @summary Get all Patient Insurance.
     * @param {string} patientUuid 
     * @param {number} [page] 
     * @param {number} [size] 
     * @param {string} [sortBy] 
     * @param {string} [sort] 
     * @param {GetPatientInsuranceInsuranceTypeEnum} [insuranceType] 
     * @param {boolean} [status] 
     * @param {boolean} [archive] 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientInsuranceControllerApi
     */
    public getPatientInsurance(patientUuid: string, page?: number, size?: number, sortBy?: string, sort?: string, insuranceType?: GetPatientInsuranceInsuranceTypeEnum, status?: boolean, archive?: boolean, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return PatientInsuranceControllerApiFp(this.configuration).getPatientInsurance(patientUuid, page, size, sortBy, sort, insuranceType, status, archive, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve a Patient Insurance by its unique ID
     * @summary Get Patient Insurance by ID
     * @param {string} patientInsuranceId 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientInsuranceControllerApi
     */
    public getPatientInsuranceById(patientInsuranceId: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return PatientInsuranceControllerApiFp(this.configuration).getPatientInsuranceById(patientInsuranceId, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update an existing Patient Insurance
     * @summary Update Patient Insurance
     * @param {PatientInsurance} patientInsurance 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientInsuranceControllerApi
     */
    public updatePatientInsurance(patientInsurance: PatientInsurance, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return PatientInsuranceControllerApiFp(this.configuration).updatePatientInsurance(patientInsurance, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Archive a Patient Insurance by its ID
     * @summary Archive Patient Insurance
     * @param {string} patientInsuranceId 
     * @param {boolean} status 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientInsuranceControllerApi
     */
    public updatePatientInsuranceArchiveStatus(patientInsuranceId: string, status: boolean, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return PatientInsuranceControllerApiFp(this.configuration).updatePatientInsuranceArchiveStatus(patientInsuranceId, status, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Set Primary Patient Insurance
     * @summary Set Primary Patient Insurance
     * @param {string} patientUuid 
     * @param {string} patientInsuranceId 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientInsuranceControllerApi
     */
    public updatePatientInsurancePrimary(patientUuid: string, patientInsuranceId: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return PatientInsuranceControllerApiFp(this.configuration).updatePatientInsurancePrimary(patientUuid, patientInsuranceId, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update the status of a Patient Insurance by its ID
     * @summary Update Patient Insurance Status
     * @param {string} patientInsuranceId 
     * @param {boolean} status 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientInsuranceControllerApi
     */
    public updatePatientInsuranceStatus(patientInsuranceId: string, status: boolean, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return PatientInsuranceControllerApiFp(this.configuration).updatePatientInsuranceStatus(patientInsuranceId, status, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const GetPatientInsuranceInsuranceTypeEnum = {
    Primary: 'PRIMARY',
    Secondary: 'SECONDARY',
    Tertiary: 'TERTIARY',
    Other: 'OTHER'
} as const;
export type GetPatientInsuranceInsuranceTypeEnum = typeof GetPatientInsuranceInsuranceTypeEnum[keyof typeof GetPatientInsuranceInsuranceTypeEnum];


/**
 * PatientIntakeFormControllerApi - axios parameter creator
 * @export
 */
export const PatientIntakeFormControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Create a intake form of appointment.
         * @summary Create Intake Form
         * @param {string} formEntries 
         * @param {PatientIntakeForm} patientIntakeForm 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createIntakeForm: async (formEntries: string, patientIntakeForm: PatientIntakeForm, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'formEntries' is not null or undefined
            assertParamExists('createIntakeForm', 'formEntries', formEntries)
            // verify required parameter 'patientIntakeForm' is not null or undefined
            assertParamExists('createIntakeForm', 'patientIntakeForm', patientIntakeForm)
            const localVarPath = `/api/master/patient-intake-form`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (formEntries !== undefined) {
                localVarQueryParameter['formEntries'] = formEntries;
            }

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patientIntakeForm, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get patient\'s all intake form
         * @summary Get patient intake form.
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [patientUuid] 
         * @param {string} [appointmentUuid] 
         * @param {string} [sortDirection] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatientAllIntakeForm: async (page?: number, size?: number, sortBy?: string, patientUuid?: string, appointmentUuid?: string, sortDirection?: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/master/patient-intake-form`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (patientUuid !== undefined) {
                localVarQueryParameter['patientUuid'] = patientUuid;
            }

            if (appointmentUuid !== undefined) {
                localVarQueryParameter['appointmentUuid'] = appointmentUuid;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * import previous encounter notes
         * @summary import previous encounter notes
         * @param {string} appointmentId 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importEncounterNote: async (appointmentId: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'appointmentId' is not null or undefined
            assertParamExists('importEncounterNote', 'appointmentId', appointmentId)
            const localVarPath = `/api/master/patient-intake-form/{appointmentId}/import-encounter-note`
                .replace(`{${"appointmentId"}}`, encodeURIComponent(String(appointmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {PatientIntakeFormRequest} patientIntakeFormRequest 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        printIntakeForm: async (patientIntakeFormRequest: PatientIntakeFormRequest, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientIntakeFormRequest' is not null or undefined
            assertParamExists('printIntakeForm', 'patientIntakeFormRequest', patientIntakeFormRequest)
            const localVarPath = `/api/master/patient-intake-form/print/intake-form`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patientIntakeFormRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * reset the intake form
         * @summary reset patient intake form
         * @param {string} patientIntakeFormId 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetPatientIntakeForm: async (patientIntakeFormId: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientIntakeFormId' is not null or undefined
            assertParamExists('resetPatientIntakeForm', 'patientIntakeFormId', patientIntakeFormId)
            const localVarPath = `/api/master/patient-intake-form/{patientIntakeFormId}/reset-form`
                .replace(`{${"patientIntakeFormId"}}`, encodeURIComponent(String(patientIntakeFormId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * update the intake form
         * @summary update patient intake form
         * @param {string} formEntries 
         * @param {PatientIntakeForm} patientIntakeForm 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePatientIntakeForm: async (formEntries: string, patientIntakeForm: PatientIntakeForm, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'formEntries' is not null or undefined
            assertParamExists('updatePatientIntakeForm', 'formEntries', formEntries)
            // verify required parameter 'patientIntakeForm' is not null or undefined
            assertParamExists('updatePatientIntakeForm', 'patientIntakeForm', patientIntakeForm)
            const localVarPath = `/api/master/patient-intake-form`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (formEntries !== undefined) {
                localVarQueryParameter['formEntries'] = formEntries;
            }

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patientIntakeForm, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PatientIntakeFormControllerApi - functional programming interface
 * @export
 */
export const PatientIntakeFormControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PatientIntakeFormControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * Create a intake form of appointment.
         * @summary Create Intake Form
         * @param {string} formEntries 
         * @param {PatientIntakeForm} patientIntakeForm 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createIntakeForm(formEntries: string, patientIntakeForm: PatientIntakeForm, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createIntakeForm(formEntries, patientIntakeForm, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientIntakeFormControllerApi.createIntakeForm']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get patient\'s all intake form
         * @summary Get patient intake form.
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [patientUuid] 
         * @param {string} [appointmentUuid] 
         * @param {string} [sortDirection] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPatientAllIntakeForm(page?: number, size?: number, sortBy?: string, patientUuid?: string, appointmentUuid?: string, sortDirection?: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPatientAllIntakeForm(page, size, sortBy, patientUuid, appointmentUuid, sortDirection, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientIntakeFormControllerApi.getPatientAllIntakeForm']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * import previous encounter notes
         * @summary import previous encounter notes
         * @param {string} appointmentId 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async importEncounterNote(appointmentId: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.importEncounterNote(appointmentId, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientIntakeFormControllerApi.importEncounterNote']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {PatientIntakeFormRequest} patientIntakeFormRequest 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async printIntakeForm(patientIntakeFormRequest: PatientIntakeFormRequest, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.printIntakeForm(patientIntakeFormRequest, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientIntakeFormControllerApi.printIntakeForm']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * reset the intake form
         * @summary reset patient intake form
         * @param {string} patientIntakeFormId 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resetPatientIntakeForm(patientIntakeFormId: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resetPatientIntakeForm(patientIntakeFormId, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientIntakeFormControllerApi.resetPatientIntakeForm']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * update the intake form
         * @summary update patient intake form
         * @param {string} formEntries 
         * @param {PatientIntakeForm} patientIntakeForm 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePatientIntakeForm(formEntries: string, patientIntakeForm: PatientIntakeForm, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePatientIntakeForm(formEntries, patientIntakeForm, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientIntakeFormControllerApi.updatePatientIntakeForm']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PatientIntakeFormControllerApi - factory interface
 * @export
 */
export const PatientIntakeFormControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PatientIntakeFormControllerApiFp(configuration)
    return {
        /**
         * Create a intake form of appointment.
         * @summary Create Intake Form
         * @param {string} formEntries 
         * @param {PatientIntakeForm} patientIntakeForm 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createIntakeForm(formEntries: string, patientIntakeForm: PatientIntakeForm, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.createIntakeForm(formEntries, patientIntakeForm, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Get patient\'s all intake form
         * @summary Get patient intake form.
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [patientUuid] 
         * @param {string} [appointmentUuid] 
         * @param {string} [sortDirection] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatientAllIntakeForm(page?: number, size?: number, sortBy?: string, patientUuid?: string, appointmentUuid?: string, sortDirection?: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getPatientAllIntakeForm(page, size, sortBy, patientUuid, appointmentUuid, sortDirection, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * import previous encounter notes
         * @summary import previous encounter notes
         * @param {string} appointmentId 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importEncounterNote(appointmentId: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.importEncounterNote(appointmentId, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PatientIntakeFormRequest} patientIntakeFormRequest 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        printIntakeForm(patientIntakeFormRequest: PatientIntakeFormRequest, xTENANTID?: string, options?: any): AxiosPromise<string> {
            return localVarFp.printIntakeForm(patientIntakeFormRequest, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * reset the intake form
         * @summary reset patient intake form
         * @param {string} patientIntakeFormId 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetPatientIntakeForm(patientIntakeFormId: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.resetPatientIntakeForm(patientIntakeFormId, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * update the intake form
         * @summary update patient intake form
         * @param {string} formEntries 
         * @param {PatientIntakeForm} patientIntakeForm 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePatientIntakeForm(formEntries: string, patientIntakeForm: PatientIntakeForm, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.updatePatientIntakeForm(formEntries, patientIntakeForm, xTENANTID, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PatientIntakeFormControllerApi - object-oriented interface
 * @export
 * @class PatientIntakeFormControllerApi
 * @extends {BaseAPI}
 */
export class PatientIntakeFormControllerApi extends BaseAPI {
    /**
     * Create a intake form of appointment.
     * @summary Create Intake Form
     * @param {string} formEntries 
     * @param {PatientIntakeForm} patientIntakeForm 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientIntakeFormControllerApi
     */
    public createIntakeForm(formEntries: string, patientIntakeForm: PatientIntakeForm, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return PatientIntakeFormControllerApiFp(this.configuration).createIntakeForm(formEntries, patientIntakeForm, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get patient\'s all intake form
     * @summary Get patient intake form.
     * @param {number} [page] 
     * @param {number} [size] 
     * @param {string} [sortBy] 
     * @param {string} [patientUuid] 
     * @param {string} [appointmentUuid] 
     * @param {string} [sortDirection] 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientIntakeFormControllerApi
     */
    public getPatientAllIntakeForm(page?: number, size?: number, sortBy?: string, patientUuid?: string, appointmentUuid?: string, sortDirection?: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return PatientIntakeFormControllerApiFp(this.configuration).getPatientAllIntakeForm(page, size, sortBy, patientUuid, appointmentUuid, sortDirection, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * import previous encounter notes
     * @summary import previous encounter notes
     * @param {string} appointmentId 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientIntakeFormControllerApi
     */
    public importEncounterNote(appointmentId: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return PatientIntakeFormControllerApiFp(this.configuration).importEncounterNote(appointmentId, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PatientIntakeFormRequest} patientIntakeFormRequest 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientIntakeFormControllerApi
     */
    public printIntakeForm(patientIntakeFormRequest: PatientIntakeFormRequest, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return PatientIntakeFormControllerApiFp(this.configuration).printIntakeForm(patientIntakeFormRequest, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * reset the intake form
     * @summary reset patient intake form
     * @param {string} patientIntakeFormId 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientIntakeFormControllerApi
     */
    public resetPatientIntakeForm(patientIntakeFormId: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return PatientIntakeFormControllerApiFp(this.configuration).resetPatientIntakeForm(patientIntakeFormId, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * update the intake form
     * @summary update patient intake form
     * @param {string} formEntries 
     * @param {PatientIntakeForm} patientIntakeForm 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientIntakeFormControllerApi
     */
    public updatePatientIntakeForm(formEntries: string, patientIntakeForm: PatientIntakeForm, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return PatientIntakeFormControllerApiFp(this.configuration).updatePatientIntakeForm(formEntries, patientIntakeForm, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PatientLabResultControllerApi - axios parameter creator
 * @export
 */
export const PatientLabResultControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} patientId 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {boolean} [status] 
         * @param {boolean} [archive] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllLabResults: async (patientId: string, page?: number, size?: number, sortBy?: string, sortDirection?: string, status?: boolean, archive?: boolean, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientId' is not null or undefined
            assertParamExists('getAllLabResults', 'patientId', patientId)
            const localVarPath = `/api/master/patient-lab-result/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (archive !== undefined) {
                localVarQueryParameter['archive'] = archive;
            }

            if (patientId !== undefined) {
                localVarQueryParameter['patientId'] = patientId;
            }

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Paginated latest reports for the patient portal dashboard Latest Reports card.
         * @summary Get Latest Reports for Patient Dashboard
         * @param {string} patientUuid 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLatestReports: async (patientUuid: string, page?: number, size?: number, sortBy?: string, sortDirection?: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientUuid' is not null or undefined
            assertParamExists('getLatestReports', 'patientUuid', patientUuid)
            const localVarPath = `/api/master/patient-lab-result/latest`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (patientUuid !== undefined) {
                localVarQueryParameter['patientUuid'] = patientUuid;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve a Patient Lab Result by ID
         * @summary Get Patient Lab Result by ID
         * @param {string} patientLabResultId 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatientLabResultById: async (patientLabResultId: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientLabResultId' is not null or undefined
            assertParamExists('getPatientLabResultById', 'patientLabResultId', patientLabResultId)
            const localVarPath = `/api/master/patient-lab-result/{patientLabResultId}`
                .replace(`{${"patientLabResultId"}}`, encodeURIComponent(String(patientLabResultId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get lab results for patient portal with active=true and archive=false
         * @summary Get Patient Portal Lab Results
         * @param {string} patientUuid 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatientPortalLabResults: async (patientUuid: string, page?: number, size?: number, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientUuid' is not null or undefined
            assertParamExists('getPatientPortalLabResults', 'patientUuid', patientUuid)
            const localVarPath = `/api/master/patient-lab-result/patient-portal`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (patientUuid !== undefined) {
                localVarQueryParameter['patientUuid'] = patientUuid;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update an existing Patient Lab Result
         * @summary Update Patient Lab Result
         * @param {string} patientLabResultId 
         * @param {UpdatePatientLabResultDocumentFormatEnum} [documentFormat] 
         * @param {UpdatePatientLabResultAbnormalFlagEnum} [abnormalFlag] 
         * @param {string} [recordedDate] 
         * @param {string} [labDescription] 
         * @param {string} [note] 
         * @param {string} [resultValue] 
         * @param {string} [fileName] 
         * @param {string} [xTENANTID] 
         * @param {File} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePatientLabResult: async (patientLabResultId: string, documentFormat?: UpdatePatientLabResultDocumentFormatEnum, abnormalFlag?: UpdatePatientLabResultAbnormalFlagEnum, recordedDate?: string, labDescription?: string, note?: string, resultValue?: string, fileName?: string, xTENANTID?: string, file?: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientLabResultId' is not null or undefined
            assertParamExists('updatePatientLabResult', 'patientLabResultId', patientLabResultId)
            const localVarPath = `/api/master/patient-lab-result`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (patientLabResultId !== undefined) {
                localVarQueryParameter['patientLabResultId'] = patientLabResultId;
            }

            if (documentFormat !== undefined) {
                localVarQueryParameter['documentFormat'] = documentFormat;
            }

            if (abnormalFlag !== undefined) {
                localVarQueryParameter['abnormalFlag'] = abnormalFlag;
            }

            if (recordedDate !== undefined) {
                localVarQueryParameter['recordedDate'] = (recordedDate as any instanceof Date) ?
                    (recordedDate as any).toISOString() :
                    recordedDate;
            }

            if (labDescription !== undefined) {
                localVarQueryParameter['labDescription'] = labDescription;
            }

            if (note !== undefined) {
                localVarQueryParameter['note'] = note;
            }

            if (resultValue !== undefined) {
                localVarQueryParameter['resultValue'] = resultValue;
            }

            if (fileName !== undefined) {
                localVarQueryParameter['fileName'] = fileName;
            }

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Archive a Patient Lab Result by its ID
         * @summary Archive Patient Lab Result
         * @param {string} patientLabResultId 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePatientLabResultArchiveStatus: async (patientLabResultId: string, status: boolean, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientLabResultId' is not null or undefined
            assertParamExists('updatePatientLabResultArchiveStatus', 'patientLabResultId', patientLabResultId)
            // verify required parameter 'status' is not null or undefined
            assertParamExists('updatePatientLabResultArchiveStatus', 'status', status)
            const localVarPath = `/api/master/patient-lab-result/{patientLabResultId}/archive-status/{status}`
                .replace(`{${"patientLabResultId"}}`, encodeURIComponent(String(patientLabResultId)))
                .replace(`{${"status"}}`, encodeURIComponent(String(status)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update the status of a Patient Lab Result by its ID
         * @summary Update Patient Lab Result Status
         * @param {string} patientLabResultId 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePatientLabResultStatus: async (patientLabResultId: string, status: boolean, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientLabResultId' is not null or undefined
            assertParamExists('updatePatientLabResultStatus', 'patientLabResultId', patientLabResultId)
            // verify required parameter 'status' is not null or undefined
            assertParamExists('updatePatientLabResultStatus', 'status', status)
            const localVarPath = `/api/master/patient-lab-result/{patientLabResultId}/status/{status}`
                .replace(`{${"patientLabResultId"}}`, encodeURIComponent(String(patientLabResultId)))
                .replace(`{${"status"}}`, encodeURIComponent(String(status)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} patientId 
         * @param {string} labDescription 
         * @param {string} [patientOrderId] 
         * @param {UploadLabResultDocumentFormatEnum} [documentFormat] 
         * @param {UploadLabResultAbnormalFlagEnum} [abnormalFlag] 
         * @param {string} [recordedDate] 
         * @param {string} [note] 
         * @param {string} [resultValue] 
         * @param {string} [fileName] 
         * @param {string} [xTENANTID] 
         * @param {File} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadLabResult: async (patientId: string, labDescription: string, patientOrderId?: string, documentFormat?: UploadLabResultDocumentFormatEnum, abnormalFlag?: UploadLabResultAbnormalFlagEnum, recordedDate?: string, note?: string, resultValue?: string, fileName?: string, xTENANTID?: string, file?: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientId' is not null or undefined
            assertParamExists('uploadLabResult', 'patientId', patientId)
            // verify required parameter 'labDescription' is not null or undefined
            assertParamExists('uploadLabResult', 'labDescription', labDescription)
            const localVarPath = `/api/master/patient-lab-result/upload`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (patientId !== undefined) {
                localVarQueryParameter['patientId'] = patientId;
            }

            if (labDescription !== undefined) {
                localVarQueryParameter['labDescription'] = labDescription;
            }

            if (patientOrderId !== undefined) {
                localVarQueryParameter['patientOrderId'] = patientOrderId;
            }

            if (documentFormat !== undefined) {
                localVarQueryParameter['documentFormat'] = documentFormat;
            }

            if (abnormalFlag !== undefined) {
                localVarQueryParameter['abnormalFlag'] = abnormalFlag;
            }

            if (recordedDate !== undefined) {
                localVarQueryParameter['recordedDate'] = (recordedDate as any instanceof Date) ?
                    (recordedDate as any).toISOString() :
                    recordedDate;
            }

            if (note !== undefined) {
                localVarQueryParameter['note'] = note;
            }

            if (resultValue !== undefined) {
                localVarQueryParameter['resultValue'] = resultValue;
            }

            if (fileName !== undefined) {
                localVarQueryParameter['fileName'] = fileName;
            }

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PatientLabResultControllerApi - functional programming interface
 * @export
 */
export const PatientLabResultControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PatientLabResultControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} patientId 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {boolean} [status] 
         * @param {boolean} [archive] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllLabResults(patientId: string, page?: number, size?: number, sortBy?: string, sortDirection?: string, status?: boolean, archive?: boolean, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllLabResults(patientId, page, size, sortBy, sortDirection, status, archive, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientLabResultControllerApi.getAllLabResults']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Paginated latest reports for the patient portal dashboard Latest Reports card.
         * @summary Get Latest Reports for Patient Dashboard
         * @param {string} patientUuid 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLatestReports(patientUuid: string, page?: number, size?: number, sortBy?: string, sortDirection?: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLatestReports(patientUuid, page, size, sortBy, sortDirection, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientLabResultControllerApi.getLatestReports']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve a Patient Lab Result by ID
         * @summary Get Patient Lab Result by ID
         * @param {string} patientLabResultId 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPatientLabResultById(patientLabResultId: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPatientLabResultById(patientLabResultId, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientLabResultControllerApi.getPatientLabResultById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get lab results for patient portal with active=true and archive=false
         * @summary Get Patient Portal Lab Results
         * @param {string} patientUuid 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPatientPortalLabResults(patientUuid: string, page?: number, size?: number, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPatientPortalLabResults(patientUuid, page, size, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientLabResultControllerApi.getPatientPortalLabResults']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update an existing Patient Lab Result
         * @summary Update Patient Lab Result
         * @param {string} patientLabResultId 
         * @param {UpdatePatientLabResultDocumentFormatEnum} [documentFormat] 
         * @param {UpdatePatientLabResultAbnormalFlagEnum} [abnormalFlag] 
         * @param {string} [recordedDate] 
         * @param {string} [labDescription] 
         * @param {string} [note] 
         * @param {string} [resultValue] 
         * @param {string} [fileName] 
         * @param {string} [xTENANTID] 
         * @param {File} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePatientLabResult(patientLabResultId: string, documentFormat?: UpdatePatientLabResultDocumentFormatEnum, abnormalFlag?: UpdatePatientLabResultAbnormalFlagEnum, recordedDate?: string, labDescription?: string, note?: string, resultValue?: string, fileName?: string, xTENANTID?: string, file?: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePatientLabResult(patientLabResultId, documentFormat, abnormalFlag, recordedDate, labDescription, note, resultValue, fileName, xTENANTID, file, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientLabResultControllerApi.updatePatientLabResult']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Archive a Patient Lab Result by its ID
         * @summary Archive Patient Lab Result
         * @param {string} patientLabResultId 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePatientLabResultArchiveStatus(patientLabResultId: string, status: boolean, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePatientLabResultArchiveStatus(patientLabResultId, status, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientLabResultControllerApi.updatePatientLabResultArchiveStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update the status of a Patient Lab Result by its ID
         * @summary Update Patient Lab Result Status
         * @param {string} patientLabResultId 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePatientLabResultStatus(patientLabResultId: string, status: boolean, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePatientLabResultStatus(patientLabResultId, status, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientLabResultControllerApi.updatePatientLabResultStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} patientId 
         * @param {string} labDescription 
         * @param {string} [patientOrderId] 
         * @param {UploadLabResultDocumentFormatEnum} [documentFormat] 
         * @param {UploadLabResultAbnormalFlagEnum} [abnormalFlag] 
         * @param {string} [recordedDate] 
         * @param {string} [note] 
         * @param {string} [resultValue] 
         * @param {string} [fileName] 
         * @param {string} [xTENANTID] 
         * @param {File} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadLabResult(patientId: string, labDescription: string, patientOrderId?: string, documentFormat?: UploadLabResultDocumentFormatEnum, abnormalFlag?: UploadLabResultAbnormalFlagEnum, recordedDate?: string, note?: string, resultValue?: string, fileName?: string, xTENANTID?: string, file?: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadLabResult(patientId, labDescription, patientOrderId, documentFormat, abnormalFlag, recordedDate, note, resultValue, fileName, xTENANTID, file, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientLabResultControllerApi.uploadLabResult']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PatientLabResultControllerApi - factory interface
 * @export
 */
export const PatientLabResultControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PatientLabResultControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {string} patientId 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {boolean} [status] 
         * @param {boolean} [archive] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllLabResults(patientId: string, page?: number, size?: number, sortBy?: string, sortDirection?: string, status?: boolean, archive?: boolean, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getAllLabResults(patientId, page, size, sortBy, sortDirection, status, archive, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Paginated latest reports for the patient portal dashboard Latest Reports card.
         * @summary Get Latest Reports for Patient Dashboard
         * @param {string} patientUuid 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLatestReports(patientUuid: string, page?: number, size?: number, sortBy?: string, sortDirection?: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getLatestReports(patientUuid, page, size, sortBy, sortDirection, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve a Patient Lab Result by ID
         * @summary Get Patient Lab Result by ID
         * @param {string} patientLabResultId 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatientLabResultById(patientLabResultId: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getPatientLabResultById(patientLabResultId, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Get lab results for patient portal with active=true and archive=false
         * @summary Get Patient Portal Lab Results
         * @param {string} patientUuid 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatientPortalLabResults(patientUuid: string, page?: number, size?: number, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getPatientPortalLabResults(patientUuid, page, size, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Update an existing Patient Lab Result
         * @summary Update Patient Lab Result
         * @param {string} patientLabResultId 
         * @param {UpdatePatientLabResultDocumentFormatEnum} [documentFormat] 
         * @param {UpdatePatientLabResultAbnormalFlagEnum} [abnormalFlag] 
         * @param {string} [recordedDate] 
         * @param {string} [labDescription] 
         * @param {string} [note] 
         * @param {string} [resultValue] 
         * @param {string} [fileName] 
         * @param {string} [xTENANTID] 
         * @param {File} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePatientLabResult(patientLabResultId: string, documentFormat?: UpdatePatientLabResultDocumentFormatEnum, abnormalFlag?: UpdatePatientLabResultAbnormalFlagEnum, recordedDate?: string, labDescription?: string, note?: string, resultValue?: string, fileName?: string, xTENANTID?: string, file?: File, options?: any): AxiosPromise<Response> {
            return localVarFp.updatePatientLabResult(patientLabResultId, documentFormat, abnormalFlag, recordedDate, labDescription, note, resultValue, fileName, xTENANTID, file, options).then((request) => request(axios, basePath));
        },
        /**
         * Archive a Patient Lab Result by its ID
         * @summary Archive Patient Lab Result
         * @param {string} patientLabResultId 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePatientLabResultArchiveStatus(patientLabResultId: string, status: boolean, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.updatePatientLabResultArchiveStatus(patientLabResultId, status, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Update the status of a Patient Lab Result by its ID
         * @summary Update Patient Lab Result Status
         * @param {string} patientLabResultId 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePatientLabResultStatus(patientLabResultId: string, status: boolean, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.updatePatientLabResultStatus(patientLabResultId, status, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} patientId 
         * @param {string} labDescription 
         * @param {string} [patientOrderId] 
         * @param {UploadLabResultDocumentFormatEnum} [documentFormat] 
         * @param {UploadLabResultAbnormalFlagEnum} [abnormalFlag] 
         * @param {string} [recordedDate] 
         * @param {string} [note] 
         * @param {string} [resultValue] 
         * @param {string} [fileName] 
         * @param {string} [xTENANTID] 
         * @param {File} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadLabResult(patientId: string, labDescription: string, patientOrderId?: string, documentFormat?: UploadLabResultDocumentFormatEnum, abnormalFlag?: UploadLabResultAbnormalFlagEnum, recordedDate?: string, note?: string, resultValue?: string, fileName?: string, xTENANTID?: string, file?: File, options?: any): AxiosPromise<Response> {
            return localVarFp.uploadLabResult(patientId, labDescription, patientOrderId, documentFormat, abnormalFlag, recordedDate, note, resultValue, fileName, xTENANTID, file, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PatientLabResultControllerApi - object-oriented interface
 * @export
 * @class PatientLabResultControllerApi
 * @extends {BaseAPI}
 */
export class PatientLabResultControllerApi extends BaseAPI {
    /**
     * 
     * @param {string} patientId 
     * @param {number} [page] 
     * @param {number} [size] 
     * @param {string} [sortBy] 
     * @param {string} [sortDirection] 
     * @param {boolean} [status] 
     * @param {boolean} [archive] 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientLabResultControllerApi
     */
    public getAllLabResults(patientId: string, page?: number, size?: number, sortBy?: string, sortDirection?: string, status?: boolean, archive?: boolean, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return PatientLabResultControllerApiFp(this.configuration).getAllLabResults(patientId, page, size, sortBy, sortDirection, status, archive, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Paginated latest reports for the patient portal dashboard Latest Reports card.
     * @summary Get Latest Reports for Patient Dashboard
     * @param {string} patientUuid 
     * @param {number} [page] 
     * @param {number} [size] 
     * @param {string} [sortBy] 
     * @param {string} [sortDirection] 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientLabResultControllerApi
     */
    public getLatestReports(patientUuid: string, page?: number, size?: number, sortBy?: string, sortDirection?: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return PatientLabResultControllerApiFp(this.configuration).getLatestReports(patientUuid, page, size, sortBy, sortDirection, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve a Patient Lab Result by ID
     * @summary Get Patient Lab Result by ID
     * @param {string} patientLabResultId 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientLabResultControllerApi
     */
    public getPatientLabResultById(patientLabResultId: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return PatientLabResultControllerApiFp(this.configuration).getPatientLabResultById(patientLabResultId, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get lab results for patient portal with active=true and archive=false
     * @summary Get Patient Portal Lab Results
     * @param {string} patientUuid 
     * @param {number} [page] 
     * @param {number} [size] 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientLabResultControllerApi
     */
    public getPatientPortalLabResults(patientUuid: string, page?: number, size?: number, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return PatientLabResultControllerApiFp(this.configuration).getPatientPortalLabResults(patientUuid, page, size, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update an existing Patient Lab Result
     * @summary Update Patient Lab Result
     * @param {string} patientLabResultId 
     * @param {UpdatePatientLabResultDocumentFormatEnum} [documentFormat] 
     * @param {UpdatePatientLabResultAbnormalFlagEnum} [abnormalFlag] 
     * @param {string} [recordedDate] 
     * @param {string} [labDescription] 
     * @param {string} [note] 
     * @param {string} [resultValue] 
     * @param {string} [fileName] 
     * @param {string} [xTENANTID] 
     * @param {File} [file] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientLabResultControllerApi
     */
    public updatePatientLabResult(patientLabResultId: string, documentFormat?: UpdatePatientLabResultDocumentFormatEnum, abnormalFlag?: UpdatePatientLabResultAbnormalFlagEnum, recordedDate?: string, labDescription?: string, note?: string, resultValue?: string, fileName?: string, xTENANTID?: string, file?: File, options?: RawAxiosRequestConfig) {
        return PatientLabResultControllerApiFp(this.configuration).updatePatientLabResult(patientLabResultId, documentFormat, abnormalFlag, recordedDate, labDescription, note, resultValue, fileName, xTENANTID, file, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Archive a Patient Lab Result by its ID
     * @summary Archive Patient Lab Result
     * @param {string} patientLabResultId 
     * @param {boolean} status 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientLabResultControllerApi
     */
    public updatePatientLabResultArchiveStatus(patientLabResultId: string, status: boolean, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return PatientLabResultControllerApiFp(this.configuration).updatePatientLabResultArchiveStatus(patientLabResultId, status, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update the status of a Patient Lab Result by its ID
     * @summary Update Patient Lab Result Status
     * @param {string} patientLabResultId 
     * @param {boolean} status 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientLabResultControllerApi
     */
    public updatePatientLabResultStatus(patientLabResultId: string, status: boolean, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return PatientLabResultControllerApiFp(this.configuration).updatePatientLabResultStatus(patientLabResultId, status, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} patientId 
     * @param {string} labDescription 
     * @param {string} [patientOrderId] 
     * @param {UploadLabResultDocumentFormatEnum} [documentFormat] 
     * @param {UploadLabResultAbnormalFlagEnum} [abnormalFlag] 
     * @param {string} [recordedDate] 
     * @param {string} [note] 
     * @param {string} [resultValue] 
     * @param {string} [fileName] 
     * @param {string} [xTENANTID] 
     * @param {File} [file] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientLabResultControllerApi
     */
    public uploadLabResult(patientId: string, labDescription: string, patientOrderId?: string, documentFormat?: UploadLabResultDocumentFormatEnum, abnormalFlag?: UploadLabResultAbnormalFlagEnum, recordedDate?: string, note?: string, resultValue?: string, fileName?: string, xTENANTID?: string, file?: File, options?: RawAxiosRequestConfig) {
        return PatientLabResultControllerApiFp(this.configuration).uploadLabResult(patientId, labDescription, patientOrderId, documentFormat, abnormalFlag, recordedDate, note, resultValue, fileName, xTENANTID, file, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const UpdatePatientLabResultDocumentFormatEnum = {
    Pdf: 'PDF',
    MsWord: 'MS_WORD',
    Zip: 'ZIP',
    XGzip: 'X_GZIP',
    XCompressed: 'X_COMPRESSED',
    Docx: 'DOCX',
    Rtf: 'RTF',
    Plain: 'PLAIN',
    Xlsx: 'XLSX',
    JpegImage: 'JPEG_IMAGE',
    Mp4: 'MP4',
    PngImage: 'PNG_IMAGE',
    GifImage: 'GIF_IMAGE',
    BmpImage: 'BMP_IMAGE',
    WebpImage: 'WEBP_IMAGE',
    SvgImage: 'SVG_IMAGE',
    MpegAudio: 'MPEG_AUDIO',
    Other: 'OTHER',
    Csv: 'CSV'
} as const;
export type UpdatePatientLabResultDocumentFormatEnum = typeof UpdatePatientLabResultDocumentFormatEnum[keyof typeof UpdatePatientLabResultDocumentFormatEnum];
/**
 * @export
 */
export const UpdatePatientLabResultAbnormalFlagEnum = {
    BelowLowNormal: 'BELOW_LOW_NORMAL',
    BelowLowerPanicLimits: 'BELOW_LOWER_PANIC_LIMITS',
    AboveUpperPanicLimits: 'ABOVE_UPPER_PANIC_LIMITS'
} as const;
export type UpdatePatientLabResultAbnormalFlagEnum = typeof UpdatePatientLabResultAbnormalFlagEnum[keyof typeof UpdatePatientLabResultAbnormalFlagEnum];
/**
 * @export
 */
export const UploadLabResultDocumentFormatEnum = {
    Pdf: 'PDF',
    MsWord: 'MS_WORD',
    Zip: 'ZIP',
    XGzip: 'X_GZIP',
    XCompressed: 'X_COMPRESSED',
    Docx: 'DOCX',
    Rtf: 'RTF',
    Plain: 'PLAIN',
    Xlsx: 'XLSX',
    JpegImage: 'JPEG_IMAGE',
    Mp4: 'MP4',
    PngImage: 'PNG_IMAGE',
    GifImage: 'GIF_IMAGE',
    BmpImage: 'BMP_IMAGE',
    WebpImage: 'WEBP_IMAGE',
    SvgImage: 'SVG_IMAGE',
    MpegAudio: 'MPEG_AUDIO',
    Other: 'OTHER',
    Csv: 'CSV'
} as const;
export type UploadLabResultDocumentFormatEnum = typeof UploadLabResultDocumentFormatEnum[keyof typeof UploadLabResultDocumentFormatEnum];
/**
 * @export
 */
export const UploadLabResultAbnormalFlagEnum = {
    BelowLowNormal: 'BELOW_LOW_NORMAL',
    BelowLowerPanicLimits: 'BELOW_LOWER_PANIC_LIMITS',
    AboveUpperPanicLimits: 'ABOVE_UPPER_PANIC_LIMITS'
} as const;
export type UploadLabResultAbnormalFlagEnum = typeof UploadLabResultAbnormalFlagEnum[keyof typeof UploadLabResultAbnormalFlagEnum];


/**
 * PatientMedicationControllerApi - axios parameter creator
 * @export
 */
export const PatientMedicationControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Add a new patient medication into the system
         * @summary Add Patient Medication
         * @param {PatientMedication} patientMedication 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPatientMedication: async (patientMedication: PatientMedication, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientMedication' is not null or undefined
            assertParamExists('createPatientMedication', 'patientMedication', patientMedication)
            const localVarPath = `/api/master/patient-medication`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patientMedication, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Archive a Patient Medication by its ID
         * @summary Archive Patient Medication
         * @param {string} patientMedicationId 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePatientMedicationId: async (patientMedicationId: string, status: boolean, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientMedicationId' is not null or undefined
            assertParamExists('deletePatientMedicationId', 'patientMedicationId', patientMedicationId)
            // verify required parameter 'status' is not null or undefined
            assertParamExists('deletePatientMedicationId', 'status', status)
            const localVarPath = `/api/master/patient-medication/{patientMedicationId}/archive-status/{status}`
                .replace(`{${"patientMedicationId"}}`, encodeURIComponent(String(patientMedicationId)))
                .replace(`{${"status"}}`, encodeURIComponent(String(status)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all Patient Medication list with search and filter options. Supports sorting by: startDate (chronological), endDate (chronological), updatedDate (chronological), recordedDate (chronological), medication, dosage, frequency, active, archive.
         * @summary Get all Patient Medication.
         * @param {string} [patientUuid] 
         * @param {string} [appointmentUuid] 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sort] 
         * @param {boolean} [status] 
         * @param {boolean} [archive] 
         * @param {boolean} [current] 
         * @param {string} [searchString] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatientMedication: async (patientUuid?: string, appointmentUuid?: string, page?: number, size?: number, sortBy?: string, sort?: string, status?: boolean, archive?: boolean, current?: boolean, searchString?: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/master/patient-medication`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (patientUuid !== undefined) {
                localVarQueryParameter['patientUuid'] = patientUuid;
            }

            if (appointmentUuid !== undefined) {
                localVarQueryParameter['appointmentUuid'] = appointmentUuid;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (archive !== undefined) {
                localVarQueryParameter['archive'] = archive;
            }

            if (current !== undefined) {
                localVarQueryParameter['current'] = current;
            }

            if (searchString !== undefined) {
                localVarQueryParameter['searchString'] = searchString;
            }

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve a Patient Medication by its unique ID
         * @summary Get Patient Medication by ID
         * @param {string} patientMedicationId 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatientMedicationById: async (patientMedicationId: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientMedicationId' is not null or undefined
            assertParamExists('getPatientMedicationById', 'patientMedicationId', patientMedicationId)
            const localVarPath = `/api/master/patient-medication/{patientMedicationId}`
                .replace(`{${"patientMedicationId"}}`, encodeURIComponent(String(patientMedicationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update an existing Patient Medication
         * @summary Update Patient Medication
         * @param {PatientMedication} patientMedication 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePatientMedication: async (patientMedication: PatientMedication, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientMedication' is not null or undefined
            assertParamExists('updatePatientMedication', 'patientMedication', patientMedication)
            const localVarPath = `/api/master/patient-medication`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patientMedication, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} patientMedicationId 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePatientMedicationStatus: async (patientMedicationId: string, status: boolean, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientMedicationId' is not null or undefined
            assertParamExists('updatePatientMedicationStatus', 'patientMedicationId', patientMedicationId)
            // verify required parameter 'status' is not null or undefined
            assertParamExists('updatePatientMedicationStatus', 'status', status)
            const localVarPath = `/api/master/patient-medication/{patientMedicationId}/status/{status}`
                .replace(`{${"patientMedicationId"}}`, encodeURIComponent(String(patientMedicationId)))
                .replace(`{${"status"}}`, encodeURIComponent(String(status)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PatientMedicationControllerApi - functional programming interface
 * @export
 */
export const PatientMedicationControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PatientMedicationControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * Add a new patient medication into the system
         * @summary Add Patient Medication
         * @param {PatientMedication} patientMedication 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createPatientMedication(patientMedication: PatientMedication, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createPatientMedication(patientMedication, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientMedicationControllerApi.createPatientMedication']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Archive a Patient Medication by its ID
         * @summary Archive Patient Medication
         * @param {string} patientMedicationId 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deletePatientMedicationId(patientMedicationId: string, status: boolean, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deletePatientMedicationId(patientMedicationId, status, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientMedicationControllerApi.deletePatientMedicationId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get all Patient Medication list with search and filter options. Supports sorting by: startDate (chronological), endDate (chronological), updatedDate (chronological), recordedDate (chronological), medication, dosage, frequency, active, archive.
         * @summary Get all Patient Medication.
         * @param {string} [patientUuid] 
         * @param {string} [appointmentUuid] 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sort] 
         * @param {boolean} [status] 
         * @param {boolean} [archive] 
         * @param {boolean} [current] 
         * @param {string} [searchString] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPatientMedication(patientUuid?: string, appointmentUuid?: string, page?: number, size?: number, sortBy?: string, sort?: string, status?: boolean, archive?: boolean, current?: boolean, searchString?: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPatientMedication(patientUuid, appointmentUuid, page, size, sortBy, sort, status, archive, current, searchString, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientMedicationControllerApi.getPatientMedication']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve a Patient Medication by its unique ID
         * @summary Get Patient Medication by ID
         * @param {string} patientMedicationId 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPatientMedicationById(patientMedicationId: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPatientMedicationById(patientMedicationId, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientMedicationControllerApi.getPatientMedicationById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update an existing Patient Medication
         * @summary Update Patient Medication
         * @param {PatientMedication} patientMedication 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePatientMedication(patientMedication: PatientMedication, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePatientMedication(patientMedication, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientMedicationControllerApi.updatePatientMedication']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} patientMedicationId 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePatientMedicationStatus(patientMedicationId: string, status: boolean, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePatientMedicationStatus(patientMedicationId, status, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientMedicationControllerApi.updatePatientMedicationStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PatientMedicationControllerApi - factory interface
 * @export
 */
export const PatientMedicationControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PatientMedicationControllerApiFp(configuration)
    return {
        /**
         * Add a new patient medication into the system
         * @summary Add Patient Medication
         * @param {PatientMedication} patientMedication 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPatientMedication(patientMedication: PatientMedication, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.createPatientMedication(patientMedication, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Archive a Patient Medication by its ID
         * @summary Archive Patient Medication
         * @param {string} patientMedicationId 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePatientMedicationId(patientMedicationId: string, status: boolean, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.deletePatientMedicationId(patientMedicationId, status, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all Patient Medication list with search and filter options. Supports sorting by: startDate (chronological), endDate (chronological), updatedDate (chronological), recordedDate (chronological), medication, dosage, frequency, active, archive.
         * @summary Get all Patient Medication.
         * @param {string} [patientUuid] 
         * @param {string} [appointmentUuid] 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sort] 
         * @param {boolean} [status] 
         * @param {boolean} [archive] 
         * @param {boolean} [current] 
         * @param {string} [searchString] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatientMedication(patientUuid?: string, appointmentUuid?: string, page?: number, size?: number, sortBy?: string, sort?: string, status?: boolean, archive?: boolean, current?: boolean, searchString?: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getPatientMedication(patientUuid, appointmentUuid, page, size, sortBy, sort, status, archive, current, searchString, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve a Patient Medication by its unique ID
         * @summary Get Patient Medication by ID
         * @param {string} patientMedicationId 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatientMedicationById(patientMedicationId: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getPatientMedicationById(patientMedicationId, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Update an existing Patient Medication
         * @summary Update Patient Medication
         * @param {PatientMedication} patientMedication 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePatientMedication(patientMedication: PatientMedication, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.updatePatientMedication(patientMedication, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} patientMedicationId 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePatientMedicationStatus(patientMedicationId: string, status: boolean, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.updatePatientMedicationStatus(patientMedicationId, status, xTENANTID, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PatientMedicationControllerApi - object-oriented interface
 * @export
 * @class PatientMedicationControllerApi
 * @extends {BaseAPI}
 */
export class PatientMedicationControllerApi extends BaseAPI {
    /**
     * Add a new patient medication into the system
     * @summary Add Patient Medication
     * @param {PatientMedication} patientMedication 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientMedicationControllerApi
     */
    public createPatientMedication(patientMedication: PatientMedication, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return PatientMedicationControllerApiFp(this.configuration).createPatientMedication(patientMedication, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Archive a Patient Medication by its ID
     * @summary Archive Patient Medication
     * @param {string} patientMedicationId 
     * @param {boolean} status 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientMedicationControllerApi
     */
    public deletePatientMedicationId(patientMedicationId: string, status: boolean, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return PatientMedicationControllerApiFp(this.configuration).deletePatientMedicationId(patientMedicationId, status, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all Patient Medication list with search and filter options. Supports sorting by: startDate (chronological), endDate (chronological), updatedDate (chronological), recordedDate (chronological), medication, dosage, frequency, active, archive.
     * @summary Get all Patient Medication.
     * @param {string} [patientUuid] 
     * @param {string} [appointmentUuid] 
     * @param {number} [page] 
     * @param {number} [size] 
     * @param {string} [sortBy] 
     * @param {string} [sort] 
     * @param {boolean} [status] 
     * @param {boolean} [archive] 
     * @param {boolean} [current] 
     * @param {string} [searchString] 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientMedicationControllerApi
     */
    public getPatientMedication(patientUuid?: string, appointmentUuid?: string, page?: number, size?: number, sortBy?: string, sort?: string, status?: boolean, archive?: boolean, current?: boolean, searchString?: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return PatientMedicationControllerApiFp(this.configuration).getPatientMedication(patientUuid, appointmentUuid, page, size, sortBy, sort, status, archive, current, searchString, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve a Patient Medication by its unique ID
     * @summary Get Patient Medication by ID
     * @param {string} patientMedicationId 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientMedicationControllerApi
     */
    public getPatientMedicationById(patientMedicationId: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return PatientMedicationControllerApiFp(this.configuration).getPatientMedicationById(patientMedicationId, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update an existing Patient Medication
     * @summary Update Patient Medication
     * @param {PatientMedication} patientMedication 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientMedicationControllerApi
     */
    public updatePatientMedication(patientMedication: PatientMedication, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return PatientMedicationControllerApiFp(this.configuration).updatePatientMedication(patientMedication, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} patientMedicationId 
     * @param {boolean} status 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientMedicationControllerApi
     */
    public updatePatientMedicationStatus(patientMedicationId: string, status: boolean, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return PatientMedicationControllerApiFp(this.configuration).updatePatientMedicationStatus(patientMedicationId, status, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PatientNotificationPreferenceControllerApi - axios parameter creator
 * @export
 */
export const PatientNotificationPreferenceControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get all notification preferences for a patient. Initializes defaults if none exist.
         * @summary Get patient notification preferences
         * @param {string} patientUuid 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPreferences: async (patientUuid: string, page?: number, size?: number, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientUuid' is not null or undefined
            assertParamExists('getPreferences', 'patientUuid', patientUuid)
            const localVarPath = `/api/master/patient-notification-preference/{patientUuid}`
                .replace(`{${"patientUuid"}}`, encodeURIComponent(String(patientUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update push/text/email preferences for notification types
         * @summary Update patient notification preferences
         * @param {string} patientUuid 
         * @param {Array<PatientNotificationPreference>} patientNotificationPreference 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePreferences: async (patientUuid: string, patientNotificationPreference: Array<PatientNotificationPreference>, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientUuid' is not null or undefined
            assertParamExists('updatePreferences', 'patientUuid', patientUuid)
            // verify required parameter 'patientNotificationPreference' is not null or undefined
            assertParamExists('updatePreferences', 'patientNotificationPreference', patientNotificationPreference)
            const localVarPath = `/api/master/patient-notification-preference/{patientUuid}`
                .replace(`{${"patientUuid"}}`, encodeURIComponent(String(patientUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patientNotificationPreference, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PatientNotificationPreferenceControllerApi - functional programming interface
 * @export
 */
export const PatientNotificationPreferenceControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PatientNotificationPreferenceControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * Get all notification preferences for a patient. Initializes defaults if none exist.
         * @summary Get patient notification preferences
         * @param {string} patientUuid 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPreferences(patientUuid: string, page?: number, size?: number, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPreferences(patientUuid, page, size, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientNotificationPreferenceControllerApi.getPreferences']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update push/text/email preferences for notification types
         * @summary Update patient notification preferences
         * @param {string} patientUuid 
         * @param {Array<PatientNotificationPreference>} patientNotificationPreference 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePreferences(patientUuid: string, patientNotificationPreference: Array<PatientNotificationPreference>, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePreferences(patientUuid, patientNotificationPreference, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientNotificationPreferenceControllerApi.updatePreferences']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PatientNotificationPreferenceControllerApi - factory interface
 * @export
 */
export const PatientNotificationPreferenceControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PatientNotificationPreferenceControllerApiFp(configuration)
    return {
        /**
         * Get all notification preferences for a patient. Initializes defaults if none exist.
         * @summary Get patient notification preferences
         * @param {string} patientUuid 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPreferences(patientUuid: string, page?: number, size?: number, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getPreferences(patientUuid, page, size, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Update push/text/email preferences for notification types
         * @summary Update patient notification preferences
         * @param {string} patientUuid 
         * @param {Array<PatientNotificationPreference>} patientNotificationPreference 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePreferences(patientUuid: string, patientNotificationPreference: Array<PatientNotificationPreference>, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.updatePreferences(patientUuid, patientNotificationPreference, xTENANTID, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PatientNotificationPreferenceControllerApi - object-oriented interface
 * @export
 * @class PatientNotificationPreferenceControllerApi
 * @extends {BaseAPI}
 */
export class PatientNotificationPreferenceControllerApi extends BaseAPI {
    /**
     * Get all notification preferences for a patient. Initializes defaults if none exist.
     * @summary Get patient notification preferences
     * @param {string} patientUuid 
     * @param {number} [page] 
     * @param {number} [size] 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientNotificationPreferenceControllerApi
     */
    public getPreferences(patientUuid: string, page?: number, size?: number, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return PatientNotificationPreferenceControllerApiFp(this.configuration).getPreferences(patientUuid, page, size, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update push/text/email preferences for notification types
     * @summary Update patient notification preferences
     * @param {string} patientUuid 
     * @param {Array<PatientNotificationPreference>} patientNotificationPreference 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientNotificationPreferenceControllerApi
     */
    public updatePreferences(patientUuid: string, patientNotificationPreference: Array<PatientNotificationPreference>, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return PatientNotificationPreferenceControllerApiFp(this.configuration).updatePreferences(patientUuid, patientNotificationPreference, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PatientOrderControllerApi - axios parameter creator
 * @export
 */
export const PatientOrderControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Add a new patient order into the system
         * @summary Add Patient Order
         * @param {PatientOrder} patientOrder 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPatientOrder: async (patientOrder: PatientOrder, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientOrder' is not null or undefined
            assertParamExists('createPatientOrder', 'patientOrder', patientOrder)
            const localVarPath = `/api/master/patient-order`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patientOrder, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Generate a PDF report for a lab order by its ID
         * @summary Generate Lab Order Report PDF
         * @param {string} patientOrderId 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateLabOrderPDF: async (patientOrderId: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientOrderId' is not null or undefined
            assertParamExists('generateLabOrderPDF', 'patientOrderId', patientOrderId)
            const localVarPath = `/api/master/patient-order/{patientOrderId}/pdf`
                .replace(`{${"patientOrderId"}}`, encodeURIComponent(String(patientOrderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve a Patient Order record by its unique ID
         * @summary Get Patient Order by ID
         * @param {string} patientOrderId 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatientOrderById: async (patientOrderId: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientOrderId' is not null or undefined
            assertParamExists('getPatientOrderById', 'patientOrderId', patientOrderId)
            const localVarPath = `/api/master/patient-order/{patientOrderId}`
                .replace(`{${"patientOrderId"}}`, encodeURIComponent(String(patientOrderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve all Patient Orders with search and filter options
         * @summary Get Patient Orders
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {string} [patientUuid] 
         * @param {string} [labUuid] 
         * @param {string} [appointmentUuid] 
         * @param {boolean} [active] 
         * @param {GetPatientOrdersOrderTypeEnum} [orderType] 
         * @param {boolean} [archive] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatientOrders: async (page?: number, size?: number, sortBy?: string, sortDirection?: string, patientUuid?: string, labUuid?: string, appointmentUuid?: string, active?: boolean, orderType?: GetPatientOrdersOrderTypeEnum, archive?: boolean, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/master/patient-order`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }

            if (patientUuid !== undefined) {
                localVarQueryParameter['patientUuid'] = patientUuid;
            }

            if (labUuid !== undefined) {
                localVarQueryParameter['labUuid'] = labUuid;
            }

            if (appointmentUuid !== undefined) {
                localVarQueryParameter['appointmentUuid'] = appointmentUuid;
            }

            if (active !== undefined) {
                localVarQueryParameter['active'] = active;
            }

            if (orderType !== undefined) {
                localVarQueryParameter['orderType'] = orderType;
            }

            if (archive !== undefined) {
                localVarQueryParameter['archive'] = archive;
            }

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get orders for patient portal with active=true and archive=false
         * @summary Get Patient Portal Orders
         * @param {string} patientUuid 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatientPortalOrders: async (patientUuid: string, page?: number, size?: number, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientUuid' is not null or undefined
            assertParamExists('getPatientPortalOrders', 'patientUuid', patientUuid)
            const localVarPath = `/api/master/patient-order/patient-portal`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (patientUuid !== undefined) {
                localVarQueryParameter['patientUuid'] = patientUuid;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update an existing Patient Order record
         * @summary Update Patient Order
         * @param {PatientOrder} patientOrder 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePatientOrder: async (patientOrder: PatientOrder, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientOrder' is not null or undefined
            assertParamExists('updatePatientOrder', 'patientOrder', patientOrder)
            const localVarPath = `/api/master/patient-order`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patientOrder, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Archive or unarchive a Patient Order by its ID
         * @summary Archive Patient Order
         * @param {string} patientOrderId 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePatientOrderArchiveStatus: async (patientOrderId: string, status: boolean, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientOrderId' is not null or undefined
            assertParamExists('updatePatientOrderArchiveStatus', 'patientOrderId', patientOrderId)
            // verify required parameter 'status' is not null or undefined
            assertParamExists('updatePatientOrderArchiveStatus', 'status', status)
            const localVarPath = `/api/master/patient-order/{patientOrderId}/archive-status/{status}`
                .replace(`{${"patientOrderId"}}`, encodeURIComponent(String(patientOrderId)))
                .replace(`{${"status"}}`, encodeURIComponent(String(status)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Enable or disable a Patient Order by its ID
         * @summary Update Patient Order Status
         * @param {string} patientOrderId 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePatientOrderStatus: async (patientOrderId: string, status: boolean, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientOrderId' is not null or undefined
            assertParamExists('updatePatientOrderStatus', 'patientOrderId', patientOrderId)
            // verify required parameter 'status' is not null or undefined
            assertParamExists('updatePatientOrderStatus', 'status', status)
            const localVarPath = `/api/master/patient-order/{patientOrderId}/status/{status}`
                .replace(`{${"patientOrderId"}}`, encodeURIComponent(String(patientOrderId)))
                .replace(`{${"status"}}`, encodeURIComponent(String(status)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Enable or disable a Patient Order by its ID
         * @summary Update Patient Order Status
         * @param {string} patientOrderId 
         * @param {string} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePatientOrderStatus1: async (patientOrderId: string, status: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientOrderId' is not null or undefined
            assertParamExists('updatePatientOrderStatus1', 'patientOrderId', patientOrderId)
            // verify required parameter 'status' is not null or undefined
            assertParamExists('updatePatientOrderStatus1', 'status', status)
            const localVarPath = `/api/master/patient-order/{patientOrderId}/order-status/{status}`
                .replace(`{${"patientOrderId"}}`, encodeURIComponent(String(patientOrderId)))
                .replace(`{${"status"}}`, encodeURIComponent(String(status)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PatientOrderControllerApi - functional programming interface
 * @export
 */
export const PatientOrderControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PatientOrderControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * Add a new patient order into the system
         * @summary Add Patient Order
         * @param {PatientOrder} patientOrder 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createPatientOrder(patientOrder: PatientOrder, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createPatientOrder(patientOrder, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientOrderControllerApi.createPatientOrder']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Generate a PDF report for a lab order by its ID
         * @summary Generate Lab Order Report PDF
         * @param {string} patientOrderId 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generateLabOrderPDF(patientOrderId: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generateLabOrderPDF(patientOrderId, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientOrderControllerApi.generateLabOrderPDF']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve a Patient Order record by its unique ID
         * @summary Get Patient Order by ID
         * @param {string} patientOrderId 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPatientOrderById(patientOrderId: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPatientOrderById(patientOrderId, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientOrderControllerApi.getPatientOrderById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve all Patient Orders with search and filter options
         * @summary Get Patient Orders
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {string} [patientUuid] 
         * @param {string} [labUuid] 
         * @param {string} [appointmentUuid] 
         * @param {boolean} [active] 
         * @param {GetPatientOrdersOrderTypeEnum} [orderType] 
         * @param {boolean} [archive] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPatientOrders(page?: number, size?: number, sortBy?: string, sortDirection?: string, patientUuid?: string, labUuid?: string, appointmentUuid?: string, active?: boolean, orderType?: GetPatientOrdersOrderTypeEnum, archive?: boolean, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPatientOrders(page, size, sortBy, sortDirection, patientUuid, labUuid, appointmentUuid, active, orderType, archive, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientOrderControllerApi.getPatientOrders']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get orders for patient portal with active=true and archive=false
         * @summary Get Patient Portal Orders
         * @param {string} patientUuid 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPatientPortalOrders(patientUuid: string, page?: number, size?: number, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPatientPortalOrders(patientUuid, page, size, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientOrderControllerApi.getPatientPortalOrders']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update an existing Patient Order record
         * @summary Update Patient Order
         * @param {PatientOrder} patientOrder 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePatientOrder(patientOrder: PatientOrder, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePatientOrder(patientOrder, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientOrderControllerApi.updatePatientOrder']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Archive or unarchive a Patient Order by its ID
         * @summary Archive Patient Order
         * @param {string} patientOrderId 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePatientOrderArchiveStatus(patientOrderId: string, status: boolean, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePatientOrderArchiveStatus(patientOrderId, status, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientOrderControllerApi.updatePatientOrderArchiveStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Enable or disable a Patient Order by its ID
         * @summary Update Patient Order Status
         * @param {string} patientOrderId 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePatientOrderStatus(patientOrderId: string, status: boolean, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePatientOrderStatus(patientOrderId, status, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientOrderControllerApi.updatePatientOrderStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Enable or disable a Patient Order by its ID
         * @summary Update Patient Order Status
         * @param {string} patientOrderId 
         * @param {string} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePatientOrderStatus1(patientOrderId: string, status: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePatientOrderStatus1(patientOrderId, status, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientOrderControllerApi.updatePatientOrderStatus1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PatientOrderControllerApi - factory interface
 * @export
 */
export const PatientOrderControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PatientOrderControllerApiFp(configuration)
    return {
        /**
         * Add a new patient order into the system
         * @summary Add Patient Order
         * @param {PatientOrder} patientOrder 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPatientOrder(patientOrder: PatientOrder, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.createPatientOrder(patientOrder, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Generate a PDF report for a lab order by its ID
         * @summary Generate Lab Order Report PDF
         * @param {string} patientOrderId 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateLabOrderPDF(patientOrderId: string, xTENANTID?: string, options?: any): AxiosPromise<string> {
            return localVarFp.generateLabOrderPDF(patientOrderId, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve a Patient Order record by its unique ID
         * @summary Get Patient Order by ID
         * @param {string} patientOrderId 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatientOrderById(patientOrderId: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getPatientOrderById(patientOrderId, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve all Patient Orders with search and filter options
         * @summary Get Patient Orders
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {string} [patientUuid] 
         * @param {string} [labUuid] 
         * @param {string} [appointmentUuid] 
         * @param {boolean} [active] 
         * @param {GetPatientOrdersOrderTypeEnum} [orderType] 
         * @param {boolean} [archive] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatientOrders(page?: number, size?: number, sortBy?: string, sortDirection?: string, patientUuid?: string, labUuid?: string, appointmentUuid?: string, active?: boolean, orderType?: GetPatientOrdersOrderTypeEnum, archive?: boolean, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getPatientOrders(page, size, sortBy, sortDirection, patientUuid, labUuid, appointmentUuid, active, orderType, archive, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Get orders for patient portal with active=true and archive=false
         * @summary Get Patient Portal Orders
         * @param {string} patientUuid 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatientPortalOrders(patientUuid: string, page?: number, size?: number, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getPatientPortalOrders(patientUuid, page, size, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Update an existing Patient Order record
         * @summary Update Patient Order
         * @param {PatientOrder} patientOrder 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePatientOrder(patientOrder: PatientOrder, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.updatePatientOrder(patientOrder, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Archive or unarchive a Patient Order by its ID
         * @summary Archive Patient Order
         * @param {string} patientOrderId 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePatientOrderArchiveStatus(patientOrderId: string, status: boolean, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.updatePatientOrderArchiveStatus(patientOrderId, status, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Enable or disable a Patient Order by its ID
         * @summary Update Patient Order Status
         * @param {string} patientOrderId 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePatientOrderStatus(patientOrderId: string, status: boolean, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.updatePatientOrderStatus(patientOrderId, status, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Enable or disable a Patient Order by its ID
         * @summary Update Patient Order Status
         * @param {string} patientOrderId 
         * @param {string} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePatientOrderStatus1(patientOrderId: string, status: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.updatePatientOrderStatus1(patientOrderId, status, xTENANTID, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PatientOrderControllerApi - object-oriented interface
 * @export
 * @class PatientOrderControllerApi
 * @extends {BaseAPI}
 */
export class PatientOrderControllerApi extends BaseAPI {
    /**
     * Add a new patient order into the system
     * @summary Add Patient Order
     * @param {PatientOrder} patientOrder 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientOrderControllerApi
     */
    public createPatientOrder(patientOrder: PatientOrder, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return PatientOrderControllerApiFp(this.configuration).createPatientOrder(patientOrder, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Generate a PDF report for a lab order by its ID
     * @summary Generate Lab Order Report PDF
     * @param {string} patientOrderId 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientOrderControllerApi
     */
    public generateLabOrderPDF(patientOrderId: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return PatientOrderControllerApiFp(this.configuration).generateLabOrderPDF(patientOrderId, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve a Patient Order record by its unique ID
     * @summary Get Patient Order by ID
     * @param {string} patientOrderId 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientOrderControllerApi
     */
    public getPatientOrderById(patientOrderId: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return PatientOrderControllerApiFp(this.configuration).getPatientOrderById(patientOrderId, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve all Patient Orders with search and filter options
     * @summary Get Patient Orders
     * @param {number} [page] 
     * @param {number} [size] 
     * @param {string} [sortBy] 
     * @param {string} [sortDirection] 
     * @param {string} [patientUuid] 
     * @param {string} [labUuid] 
     * @param {string} [appointmentUuid] 
     * @param {boolean} [active] 
     * @param {GetPatientOrdersOrderTypeEnum} [orderType] 
     * @param {boolean} [archive] 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientOrderControllerApi
     */
    public getPatientOrders(page?: number, size?: number, sortBy?: string, sortDirection?: string, patientUuid?: string, labUuid?: string, appointmentUuid?: string, active?: boolean, orderType?: GetPatientOrdersOrderTypeEnum, archive?: boolean, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return PatientOrderControllerApiFp(this.configuration).getPatientOrders(page, size, sortBy, sortDirection, patientUuid, labUuid, appointmentUuid, active, orderType, archive, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get orders for patient portal with active=true and archive=false
     * @summary Get Patient Portal Orders
     * @param {string} patientUuid 
     * @param {number} [page] 
     * @param {number} [size] 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientOrderControllerApi
     */
    public getPatientPortalOrders(patientUuid: string, page?: number, size?: number, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return PatientOrderControllerApiFp(this.configuration).getPatientPortalOrders(patientUuid, page, size, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update an existing Patient Order record
     * @summary Update Patient Order
     * @param {PatientOrder} patientOrder 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientOrderControllerApi
     */
    public updatePatientOrder(patientOrder: PatientOrder, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return PatientOrderControllerApiFp(this.configuration).updatePatientOrder(patientOrder, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Archive or unarchive a Patient Order by its ID
     * @summary Archive Patient Order
     * @param {string} patientOrderId 
     * @param {boolean} status 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientOrderControllerApi
     */
    public updatePatientOrderArchiveStatus(patientOrderId: string, status: boolean, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return PatientOrderControllerApiFp(this.configuration).updatePatientOrderArchiveStatus(patientOrderId, status, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Enable or disable a Patient Order by its ID
     * @summary Update Patient Order Status
     * @param {string} patientOrderId 
     * @param {boolean} status 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientOrderControllerApi
     */
    public updatePatientOrderStatus(patientOrderId: string, status: boolean, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return PatientOrderControllerApiFp(this.configuration).updatePatientOrderStatus(patientOrderId, status, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Enable or disable a Patient Order by its ID
     * @summary Update Patient Order Status
     * @param {string} patientOrderId 
     * @param {string} status 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientOrderControllerApi
     */
    public updatePatientOrderStatus1(patientOrderId: string, status: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return PatientOrderControllerApiFp(this.configuration).updatePatientOrderStatus1(patientOrderId, status, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const GetPatientOrdersOrderTypeEnum = {
    Lab: 'LAB',
    Imaging: 'IMAGING',
    Prescription: 'PRESCRIPTION'
} as const;
export type GetPatientOrdersOrderTypeEnum = typeof GetPatientOrdersOrderTypeEnum[keyof typeof GetPatientOrdersOrderTypeEnum];


/**
 * PatientPaymentControllerApi - axios parameter creator
 * @export
 */
export const PatientPaymentControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Add a new patient payment into the system
         * @summary Add Patient Payment
         * @param {PatientCard} patientCard 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPatientPayment: async (patientCard: PatientCard, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientCard' is not null or undefined
            assertParamExists('createPatientPayment', 'patientCard', patientCard)
            const localVarPath = `/api/master/patient-payment`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patientCard, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all Patient payment list with search on patientId.
         * @summary Get all Patient payment.
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {GetPatientAllPaymentPaymentModeEnum} [paymentMode] 
         * @param {GetPatientAllPaymentTypeOfPaymentEnum} [typeOfPayment] 
         * @param {string} [sort] 
         * @param {string} [transactionId] 
         * @param {string} [transactionDate] 
         * @param {string} [patientUuid] 
         * @param {string} [searchString] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatientAllPayment: async (page?: number, size?: number, sortBy?: string, paymentMode?: GetPatientAllPaymentPaymentModeEnum, typeOfPayment?: GetPatientAllPaymentTypeOfPaymentEnum, sort?: string, transactionId?: string, transactionDate?: string, patientUuid?: string, searchString?: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/master/patient-payment`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (paymentMode !== undefined) {
                localVarQueryParameter['paymentMode'] = paymentMode;
            }

            if (typeOfPayment !== undefined) {
                localVarQueryParameter['typeOfPayment'] = typeOfPayment;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (transactionId !== undefined) {
                localVarQueryParameter['transactionId'] = transactionId;
            }

            if (transactionDate !== undefined) {
                localVarQueryParameter['transactionDate'] = (transactionDate as any instanceof Date) ?
                    (transactionDate as any).toISOString() :
                    transactionDate;
            }

            if (patientUuid !== undefined) {
                localVarQueryParameter['patientUuid'] = patientUuid;
            }

            if (searchString !== undefined) {
                localVarQueryParameter['searchString'] = searchString;
            }

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * One row per saved card: uuid, patient, paymentMethodId, paymentMode, last4, displayBrand, primary, active and archive.
         * @summary Get all Patient payment (slim)
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {GetPatientAllPaymentProjectionPaymentModeEnum} [paymentMode] 
         * @param {GetPatientAllPaymentProjectionTypeOfPaymentEnum} [typeOfPayment] 
         * @param {string} [patientUuid] 
         * @param {boolean} [archive] 
         * @param {GetPatientAllPaymentProjectionCardStatusEnum} [cardStatus] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatientAllPaymentProjection: async (page?: number, size?: number, paymentMode?: GetPatientAllPaymentProjectionPaymentModeEnum, typeOfPayment?: GetPatientAllPaymentProjectionTypeOfPaymentEnum, patientUuid?: string, archive?: boolean, cardStatus?: GetPatientAllPaymentProjectionCardStatusEnum, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/master/patient-payment/v2/slim`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (paymentMode !== undefined) {
                localVarQueryParameter['paymentMode'] = paymentMode;
            }

            if (typeOfPayment !== undefined) {
                localVarQueryParameter['typeOfPayment'] = typeOfPayment;
            }

            if (patientUuid !== undefined) {
                localVarQueryParameter['patientUuid'] = patientUuid;
            }

            if (archive !== undefined) {
                localVarQueryParameter['archive'] = archive;
            }

            if (cardStatus !== undefined) {
                localVarQueryParameter['cardStatus'] = cardStatus;
            }

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all Patient payment list with search and all fields, using a fast projection-based API.
         * @summary Get all Patient payment (lightweight)
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {GetPatientAllPaymentV2PaymentModeEnum} [paymentMode] 
         * @param {GetPatientAllPaymentV2PaymentCategoryEnum} [paymentCategory] 
         * @param {GetPatientAllPaymentV2TypeOfPaymentEnum} [typeOfPayment] 
         * @param {string} [sort] 
         * @param {string} [transactionId] 
         * @param {string} [transactionDate] 
         * @param {string} [patientUuid] 
         * @param {string} [visitId] 
         * @param {string} [superbillId] 
         * @param {string} [claimId] 
         * @param {string} [status] 
         * @param {boolean} [archive] 
         * @param {string} [searchString] 
         * @param {boolean} [creditBalance] 
         * @param {boolean} [outstandingBalance] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatientAllPaymentV2: async (page?: number, size?: number, sortBy?: string, paymentMode?: GetPatientAllPaymentV2PaymentModeEnum, paymentCategory?: GetPatientAllPaymentV2PaymentCategoryEnum, typeOfPayment?: GetPatientAllPaymentV2TypeOfPaymentEnum, sort?: string, transactionId?: string, transactionDate?: string, patientUuid?: string, visitId?: string, superbillId?: string, claimId?: string, status?: string, archive?: boolean, searchString?: string, creditBalance?: boolean, outstandingBalance?: boolean, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/master/patient-payment/v2`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (paymentMode !== undefined) {
                localVarQueryParameter['paymentMode'] = paymentMode;
            }

            if (paymentCategory !== undefined) {
                localVarQueryParameter['paymentCategory'] = paymentCategory;
            }

            if (typeOfPayment !== undefined) {
                localVarQueryParameter['typeOfPayment'] = typeOfPayment;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (transactionId !== undefined) {
                localVarQueryParameter['transactionId'] = transactionId;
            }

            if (transactionDate !== undefined) {
                localVarQueryParameter['transactionDate'] = (transactionDate as any instanceof Date) ?
                    (transactionDate as any).toISOString() :
                    transactionDate;
            }

            if (patientUuid !== undefined) {
                localVarQueryParameter['patientUuid'] = patientUuid;
            }

            if (visitId !== undefined) {
                localVarQueryParameter['visitId'] = visitId;
            }

            if (superbillId !== undefined) {
                localVarQueryParameter['superbillId'] = superbillId;
            }

            if (claimId !== undefined) {
                localVarQueryParameter['claimId'] = claimId;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (archive !== undefined) {
                localVarQueryParameter['archive'] = archive;
            }

            if (searchString !== undefined) {
                localVarQueryParameter['searchString'] = searchString;
            }

            if (creditBalance !== undefined) {
                localVarQueryParameter['creditBalance'] = creditBalance;
            }

            if (outstandingBalance !== undefined) {
                localVarQueryParameter['outstandingBalance'] = outstandingBalance;
            }

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve a Patient Payment by its unique ID
         * @summary Get Patient Payment by ID
         * @param {string} patientPaymentId 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatientPaymentById: async (patientPaymentId: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientPaymentId' is not null or undefined
            assertParamExists('getPatientPaymentById', 'patientPaymentId', patientPaymentId)
            const localVarPath = `/api/master/patient-payment/{patientPaymentId}`
                .replace(`{${"patientPaymentId"}}`, encodeURIComponent(String(patientPaymentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns the patient\'s total outstanding invoice balance along with the payments made for a specific visit
         * @summary Get Patient payments by patient and visit
         * @param {string} patientUuid 
         * @param {string} [visitId] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatientPaymentsByVisit: async (patientUuid: string, visitId?: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientUuid' is not null or undefined
            assertParamExists('getPatientPaymentsByVisit', 'patientUuid', patientUuid)
            const localVarPath = `/api/master/patient-payment/v2/by-visit`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (patientUuid !== undefined) {
                localVarQueryParameter['patientUuid'] = patientUuid;
            }

            if (visitId !== undefined) {
                localVarQueryParameter['visitId'] = visitId;
            }

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns paginated transaction records linked to one or more invoices (super bills).
         * @summary Get transactions by invoice (super bill) UUIDs
         * @param {Array<string>} superBillUuids 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTransactionsByInvoice: async (superBillUuids: Array<string>, page?: number, size?: number, sortBy?: string, sortDirection?: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'superBillUuids' is not null or undefined
            assertParamExists('getTransactionsByInvoice', 'superBillUuids', superBillUuids)
            const localVarPath = `/api/master/patient-payment/by-invoice`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (superBillUuids) {
                localVarQueryParameter['superBillUuids'] = superBillUuids;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Set a card as primary for a patient
         * @summary Set Primary Card
         * @param {string} cardUuid 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setPrimaryCard: async (cardUuid: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'cardUuid' is not null or undefined
            assertParamExists('setPrimaryCard', 'cardUuid', cardUuid)
            const localVarPath = `/api/master/patient-payment/{cardUuid}/primary`
                .replace(`{${"cardUuid"}}`, encodeURIComponent(String(cardUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update card holder name, expiry, and billing details on a saved card
         * @summary Update Patient Card
         * @param {string} cardId 
         * @param {PatientCard} patientCard 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCard: async (cardId: string, patientCard: PatientCard, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'cardId' is not null or undefined
            assertParamExists('updateCard', 'cardId', cardId)
            // verify required parameter 'patientCard' is not null or undefined
            assertParamExists('updateCard', 'patientCard', patientCard)
            const localVarPath = `/api/master/patient-payment/{cardId}`
                .replace(`{${"cardId"}}`, encodeURIComponent(String(cardId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patientCard, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Archive or Unarchive a Patient Card by its ID
         * @summary Archive Patient Card
         * @param {string} patientCardId 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePatientCardArchiveStatus: async (patientCardId: string, status: boolean, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientCardId' is not null or undefined
            assertParamExists('updatePatientCardArchiveStatus', 'patientCardId', patientCardId)
            // verify required parameter 'status' is not null or undefined
            assertParamExists('updatePatientCardArchiveStatus', 'status', status)
            const localVarPath = `/api/master/patient-payment/{patientCardId}/archive-status/{status}`
                .replace(`{${"patientCardId"}}`, encodeURIComponent(String(patientCardId)))
                .replace(`{${"status"}}`, encodeURIComponent(String(status)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update the status of a Patient Card by its ID
         * @summary Update Patient Card Status
         * @param {string} patientCardId 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePatientCardStatus: async (patientCardId: string, status: boolean, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientCardId' is not null or undefined
            assertParamExists('updatePatientCardStatus', 'patientCardId', patientCardId)
            // verify required parameter 'status' is not null or undefined
            assertParamExists('updatePatientCardStatus', 'status', status)
            const localVarPath = `/api/master/patient-payment/{patientCardId}/status/{status}`
                .replace(`{${"patientCardId"}}`, encodeURIComponent(String(patientCardId)))
                .replace(`{${"status"}}`, encodeURIComponent(String(status)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PatientPaymentControllerApi - functional programming interface
 * @export
 */
export const PatientPaymentControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PatientPaymentControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * Add a new patient payment into the system
         * @summary Add Patient Payment
         * @param {PatientCard} patientCard 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createPatientPayment(patientCard: PatientCard, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createPatientPayment(patientCard, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientPaymentControllerApi.createPatientPayment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get all Patient payment list with search on patientId.
         * @summary Get all Patient payment.
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {GetPatientAllPaymentPaymentModeEnum} [paymentMode] 
         * @param {GetPatientAllPaymentTypeOfPaymentEnum} [typeOfPayment] 
         * @param {string} [sort] 
         * @param {string} [transactionId] 
         * @param {string} [transactionDate] 
         * @param {string} [patientUuid] 
         * @param {string} [searchString] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPatientAllPayment(page?: number, size?: number, sortBy?: string, paymentMode?: GetPatientAllPaymentPaymentModeEnum, typeOfPayment?: GetPatientAllPaymentTypeOfPaymentEnum, sort?: string, transactionId?: string, transactionDate?: string, patientUuid?: string, searchString?: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPatientAllPayment(page, size, sortBy, paymentMode, typeOfPayment, sort, transactionId, transactionDate, patientUuid, searchString, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientPaymentControllerApi.getPatientAllPayment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * One row per saved card: uuid, patient, paymentMethodId, paymentMode, last4, displayBrand, primary, active and archive.
         * @summary Get all Patient payment (slim)
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {GetPatientAllPaymentProjectionPaymentModeEnum} [paymentMode] 
         * @param {GetPatientAllPaymentProjectionTypeOfPaymentEnum} [typeOfPayment] 
         * @param {string} [patientUuid] 
         * @param {boolean} [archive] 
         * @param {GetPatientAllPaymentProjectionCardStatusEnum} [cardStatus] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPatientAllPaymentProjection(page?: number, size?: number, paymentMode?: GetPatientAllPaymentProjectionPaymentModeEnum, typeOfPayment?: GetPatientAllPaymentProjectionTypeOfPaymentEnum, patientUuid?: string, archive?: boolean, cardStatus?: GetPatientAllPaymentProjectionCardStatusEnum, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPatientAllPaymentProjection(page, size, paymentMode, typeOfPayment, patientUuid, archive, cardStatus, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientPaymentControllerApi.getPatientAllPaymentProjection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get all Patient payment list with search and all fields, using a fast projection-based API.
         * @summary Get all Patient payment (lightweight)
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {GetPatientAllPaymentV2PaymentModeEnum} [paymentMode] 
         * @param {GetPatientAllPaymentV2PaymentCategoryEnum} [paymentCategory] 
         * @param {GetPatientAllPaymentV2TypeOfPaymentEnum} [typeOfPayment] 
         * @param {string} [sort] 
         * @param {string} [transactionId] 
         * @param {string} [transactionDate] 
         * @param {string} [patientUuid] 
         * @param {string} [visitId] 
         * @param {string} [superbillId] 
         * @param {string} [claimId] 
         * @param {string} [status] 
         * @param {boolean} [archive] 
         * @param {string} [searchString] 
         * @param {boolean} [creditBalance] 
         * @param {boolean} [outstandingBalance] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPatientAllPaymentV2(page?: number, size?: number, sortBy?: string, paymentMode?: GetPatientAllPaymentV2PaymentModeEnum, paymentCategory?: GetPatientAllPaymentV2PaymentCategoryEnum, typeOfPayment?: GetPatientAllPaymentV2TypeOfPaymentEnum, sort?: string, transactionId?: string, transactionDate?: string, patientUuid?: string, visitId?: string, superbillId?: string, claimId?: string, status?: string, archive?: boolean, searchString?: string, creditBalance?: boolean, outstandingBalance?: boolean, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPatientAllPaymentV2(page, size, sortBy, paymentMode, paymentCategory, typeOfPayment, sort, transactionId, transactionDate, patientUuid, visitId, superbillId, claimId, status, archive, searchString, creditBalance, outstandingBalance, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientPaymentControllerApi.getPatientAllPaymentV2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve a Patient Payment by its unique ID
         * @summary Get Patient Payment by ID
         * @param {string} patientPaymentId 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPatientPaymentById(patientPaymentId: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPatientPaymentById(patientPaymentId, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientPaymentControllerApi.getPatientPaymentById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns the patient\'s total outstanding invoice balance along with the payments made for a specific visit
         * @summary Get Patient payments by patient and visit
         * @param {string} patientUuid 
         * @param {string} [visitId] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPatientPaymentsByVisit(patientUuid: string, visitId?: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPatientPaymentsByVisit(patientUuid, visitId, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientPaymentControllerApi.getPatientPaymentsByVisit']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns paginated transaction records linked to one or more invoices (super bills).
         * @summary Get transactions by invoice (super bill) UUIDs
         * @param {Array<string>} superBillUuids 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTransactionsByInvoice(superBillUuids: Array<string>, page?: number, size?: number, sortBy?: string, sortDirection?: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTransactionsByInvoice(superBillUuids, page, size, sortBy, sortDirection, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientPaymentControllerApi.getTransactionsByInvoice']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Set a card as primary for a patient
         * @summary Set Primary Card
         * @param {string} cardUuid 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setPrimaryCard(cardUuid: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setPrimaryCard(cardUuid, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientPaymentControllerApi.setPrimaryCard']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update card holder name, expiry, and billing details on a saved card
         * @summary Update Patient Card
         * @param {string} cardId 
         * @param {PatientCard} patientCard 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCard(cardId: string, patientCard: PatientCard, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateCard(cardId, patientCard, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientPaymentControllerApi.updateCard']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Archive or Unarchive a Patient Card by its ID
         * @summary Archive Patient Card
         * @param {string} patientCardId 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePatientCardArchiveStatus(patientCardId: string, status: boolean, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePatientCardArchiveStatus(patientCardId, status, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientPaymentControllerApi.updatePatientCardArchiveStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update the status of a Patient Card by its ID
         * @summary Update Patient Card Status
         * @param {string} patientCardId 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePatientCardStatus(patientCardId: string, status: boolean, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePatientCardStatus(patientCardId, status, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientPaymentControllerApi.updatePatientCardStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PatientPaymentControllerApi - factory interface
 * @export
 */
export const PatientPaymentControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PatientPaymentControllerApiFp(configuration)
    return {
        /**
         * Add a new patient payment into the system
         * @summary Add Patient Payment
         * @param {PatientCard} patientCard 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPatientPayment(patientCard: PatientCard, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.createPatientPayment(patientCard, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all Patient payment list with search on patientId.
         * @summary Get all Patient payment.
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {GetPatientAllPaymentPaymentModeEnum} [paymentMode] 
         * @param {GetPatientAllPaymentTypeOfPaymentEnum} [typeOfPayment] 
         * @param {string} [sort] 
         * @param {string} [transactionId] 
         * @param {string} [transactionDate] 
         * @param {string} [patientUuid] 
         * @param {string} [searchString] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatientAllPayment(page?: number, size?: number, sortBy?: string, paymentMode?: GetPatientAllPaymentPaymentModeEnum, typeOfPayment?: GetPatientAllPaymentTypeOfPaymentEnum, sort?: string, transactionId?: string, transactionDate?: string, patientUuid?: string, searchString?: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getPatientAllPayment(page, size, sortBy, paymentMode, typeOfPayment, sort, transactionId, transactionDate, patientUuid, searchString, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * One row per saved card: uuid, patient, paymentMethodId, paymentMode, last4, displayBrand, primary, active and archive.
         * @summary Get all Patient payment (slim)
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {GetPatientAllPaymentProjectionPaymentModeEnum} [paymentMode] 
         * @param {GetPatientAllPaymentProjectionTypeOfPaymentEnum} [typeOfPayment] 
         * @param {string} [patientUuid] 
         * @param {boolean} [archive] 
         * @param {GetPatientAllPaymentProjectionCardStatusEnum} [cardStatus] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatientAllPaymentProjection(page?: number, size?: number, paymentMode?: GetPatientAllPaymentProjectionPaymentModeEnum, typeOfPayment?: GetPatientAllPaymentProjectionTypeOfPaymentEnum, patientUuid?: string, archive?: boolean, cardStatus?: GetPatientAllPaymentProjectionCardStatusEnum, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getPatientAllPaymentProjection(page, size, paymentMode, typeOfPayment, patientUuid, archive, cardStatus, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all Patient payment list with search and all fields, using a fast projection-based API.
         * @summary Get all Patient payment (lightweight)
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {GetPatientAllPaymentV2PaymentModeEnum} [paymentMode] 
         * @param {GetPatientAllPaymentV2PaymentCategoryEnum} [paymentCategory] 
         * @param {GetPatientAllPaymentV2TypeOfPaymentEnum} [typeOfPayment] 
         * @param {string} [sort] 
         * @param {string} [transactionId] 
         * @param {string} [transactionDate] 
         * @param {string} [patientUuid] 
         * @param {string} [visitId] 
         * @param {string} [superbillId] 
         * @param {string} [claimId] 
         * @param {string} [status] 
         * @param {boolean} [archive] 
         * @param {string} [searchString] 
         * @param {boolean} [creditBalance] 
         * @param {boolean} [outstandingBalance] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatientAllPaymentV2(page?: number, size?: number, sortBy?: string, paymentMode?: GetPatientAllPaymentV2PaymentModeEnum, paymentCategory?: GetPatientAllPaymentV2PaymentCategoryEnum, typeOfPayment?: GetPatientAllPaymentV2TypeOfPaymentEnum, sort?: string, transactionId?: string, transactionDate?: string, patientUuid?: string, visitId?: string, superbillId?: string, claimId?: string, status?: string, archive?: boolean, searchString?: string, creditBalance?: boolean, outstandingBalance?: boolean, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getPatientAllPaymentV2(page, size, sortBy, paymentMode, paymentCategory, typeOfPayment, sort, transactionId, transactionDate, patientUuid, visitId, superbillId, claimId, status, archive, searchString, creditBalance, outstandingBalance, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve a Patient Payment by its unique ID
         * @summary Get Patient Payment by ID
         * @param {string} patientPaymentId 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatientPaymentById(patientPaymentId: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getPatientPaymentById(patientPaymentId, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns the patient\'s total outstanding invoice balance along with the payments made for a specific visit
         * @summary Get Patient payments by patient and visit
         * @param {string} patientUuid 
         * @param {string} [visitId] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatientPaymentsByVisit(patientUuid: string, visitId?: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getPatientPaymentsByVisit(patientUuid, visitId, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns paginated transaction records linked to one or more invoices (super bills).
         * @summary Get transactions by invoice (super bill) UUIDs
         * @param {Array<string>} superBillUuids 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTransactionsByInvoice(superBillUuids: Array<string>, page?: number, size?: number, sortBy?: string, sortDirection?: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getTransactionsByInvoice(superBillUuids, page, size, sortBy, sortDirection, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Set a card as primary for a patient
         * @summary Set Primary Card
         * @param {string} cardUuid 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setPrimaryCard(cardUuid: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.setPrimaryCard(cardUuid, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Update card holder name, expiry, and billing details on a saved card
         * @summary Update Patient Card
         * @param {string} cardId 
         * @param {PatientCard} patientCard 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCard(cardId: string, patientCard: PatientCard, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.updateCard(cardId, patientCard, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Archive or Unarchive a Patient Card by its ID
         * @summary Archive Patient Card
         * @param {string} patientCardId 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePatientCardArchiveStatus(patientCardId: string, status: boolean, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.updatePatientCardArchiveStatus(patientCardId, status, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Update the status of a Patient Card by its ID
         * @summary Update Patient Card Status
         * @param {string} patientCardId 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePatientCardStatus(patientCardId: string, status: boolean, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.updatePatientCardStatus(patientCardId, status, xTENANTID, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PatientPaymentControllerApi - object-oriented interface
 * @export
 * @class PatientPaymentControllerApi
 * @extends {BaseAPI}
 */
export class PatientPaymentControllerApi extends BaseAPI {
    /**
     * Add a new patient payment into the system
     * @summary Add Patient Payment
     * @param {PatientCard} patientCard 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientPaymentControllerApi
     */
    public createPatientPayment(patientCard: PatientCard, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return PatientPaymentControllerApiFp(this.configuration).createPatientPayment(patientCard, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all Patient payment list with search on patientId.
     * @summary Get all Patient payment.
     * @param {number} [page] 
     * @param {number} [size] 
     * @param {string} [sortBy] 
     * @param {GetPatientAllPaymentPaymentModeEnum} [paymentMode] 
     * @param {GetPatientAllPaymentTypeOfPaymentEnum} [typeOfPayment] 
     * @param {string} [sort] 
     * @param {string} [transactionId] 
     * @param {string} [transactionDate] 
     * @param {string} [patientUuid] 
     * @param {string} [searchString] 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientPaymentControllerApi
     */
    public getPatientAllPayment(page?: number, size?: number, sortBy?: string, paymentMode?: GetPatientAllPaymentPaymentModeEnum, typeOfPayment?: GetPatientAllPaymentTypeOfPaymentEnum, sort?: string, transactionId?: string, transactionDate?: string, patientUuid?: string, searchString?: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return PatientPaymentControllerApiFp(this.configuration).getPatientAllPayment(page, size, sortBy, paymentMode, typeOfPayment, sort, transactionId, transactionDate, patientUuid, searchString, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * One row per saved card: uuid, patient, paymentMethodId, paymentMode, last4, displayBrand, primary, active and archive.
     * @summary Get all Patient payment (slim)
     * @param {number} [page] 
     * @param {number} [size] 
     * @param {GetPatientAllPaymentProjectionPaymentModeEnum} [paymentMode] 
     * @param {GetPatientAllPaymentProjectionTypeOfPaymentEnum} [typeOfPayment] 
     * @param {string} [patientUuid] 
     * @param {boolean} [archive] 
     * @param {GetPatientAllPaymentProjectionCardStatusEnum} [cardStatus] 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientPaymentControllerApi
     */
    public getPatientAllPaymentProjection(page?: number, size?: number, paymentMode?: GetPatientAllPaymentProjectionPaymentModeEnum, typeOfPayment?: GetPatientAllPaymentProjectionTypeOfPaymentEnum, patientUuid?: string, archive?: boolean, cardStatus?: GetPatientAllPaymentProjectionCardStatusEnum, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return PatientPaymentControllerApiFp(this.configuration).getPatientAllPaymentProjection(page, size, paymentMode, typeOfPayment, patientUuid, archive, cardStatus, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all Patient payment list with search and all fields, using a fast projection-based API.
     * @summary Get all Patient payment (lightweight)
     * @param {number} [page] 
     * @param {number} [size] 
     * @param {string} [sortBy] 
     * @param {GetPatientAllPaymentV2PaymentModeEnum} [paymentMode] 
     * @param {GetPatientAllPaymentV2PaymentCategoryEnum} [paymentCategory] 
     * @param {GetPatientAllPaymentV2TypeOfPaymentEnum} [typeOfPayment] 
     * @param {string} [sort] 
     * @param {string} [transactionId] 
     * @param {string} [transactionDate] 
     * @param {string} [patientUuid] 
     * @param {string} [visitId] 
     * @param {string} [superbillId] 
     * @param {string} [claimId] 
     * @param {string} [status] 
     * @param {boolean} [archive] 
     * @param {string} [searchString] 
     * @param {boolean} [creditBalance] 
     * @param {boolean} [outstandingBalance] 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientPaymentControllerApi
     */
    public getPatientAllPaymentV2(page?: number, size?: number, sortBy?: string, paymentMode?: GetPatientAllPaymentV2PaymentModeEnum, paymentCategory?: GetPatientAllPaymentV2PaymentCategoryEnum, typeOfPayment?: GetPatientAllPaymentV2TypeOfPaymentEnum, sort?: string, transactionId?: string, transactionDate?: string, patientUuid?: string, visitId?: string, superbillId?: string, claimId?: string, status?: string, archive?: boolean, searchString?: string, creditBalance?: boolean, outstandingBalance?: boolean, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return PatientPaymentControllerApiFp(this.configuration).getPatientAllPaymentV2(page, size, sortBy, paymentMode, paymentCategory, typeOfPayment, sort, transactionId, transactionDate, patientUuid, visitId, superbillId, claimId, status, archive, searchString, creditBalance, outstandingBalance, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve a Patient Payment by its unique ID
     * @summary Get Patient Payment by ID
     * @param {string} patientPaymentId 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientPaymentControllerApi
     */
    public getPatientPaymentById(patientPaymentId: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return PatientPaymentControllerApiFp(this.configuration).getPatientPaymentById(patientPaymentId, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns the patient\'s total outstanding invoice balance along with the payments made for a specific visit
     * @summary Get Patient payments by patient and visit
     * @param {string} patientUuid 
     * @param {string} [visitId] 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientPaymentControllerApi
     */
    public getPatientPaymentsByVisit(patientUuid: string, visitId?: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return PatientPaymentControllerApiFp(this.configuration).getPatientPaymentsByVisit(patientUuid, visitId, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns paginated transaction records linked to one or more invoices (super bills).
     * @summary Get transactions by invoice (super bill) UUIDs
     * @param {Array<string>} superBillUuids 
     * @param {number} [page] 
     * @param {number} [size] 
     * @param {string} [sortBy] 
     * @param {string} [sortDirection] 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientPaymentControllerApi
     */
    public getTransactionsByInvoice(superBillUuids: Array<string>, page?: number, size?: number, sortBy?: string, sortDirection?: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return PatientPaymentControllerApiFp(this.configuration).getTransactionsByInvoice(superBillUuids, page, size, sortBy, sortDirection, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Set a card as primary for a patient
     * @summary Set Primary Card
     * @param {string} cardUuid 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientPaymentControllerApi
     */
    public setPrimaryCard(cardUuid: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return PatientPaymentControllerApiFp(this.configuration).setPrimaryCard(cardUuid, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update card holder name, expiry, and billing details on a saved card
     * @summary Update Patient Card
     * @param {string} cardId 
     * @param {PatientCard} patientCard 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientPaymentControllerApi
     */
    public updateCard(cardId: string, patientCard: PatientCard, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return PatientPaymentControllerApiFp(this.configuration).updateCard(cardId, patientCard, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Archive or Unarchive a Patient Card by its ID
     * @summary Archive Patient Card
     * @param {string} patientCardId 
     * @param {boolean} status 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientPaymentControllerApi
     */
    public updatePatientCardArchiveStatus(patientCardId: string, status: boolean, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return PatientPaymentControllerApiFp(this.configuration).updatePatientCardArchiveStatus(patientCardId, status, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update the status of a Patient Card by its ID
     * @summary Update Patient Card Status
     * @param {string} patientCardId 
     * @param {boolean} status 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientPaymentControllerApi
     */
    public updatePatientCardStatus(patientCardId: string, status: boolean, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return PatientPaymentControllerApiFp(this.configuration).updatePatientCardStatus(patientCardId, status, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const GetPatientAllPaymentPaymentModeEnum = {
    Cash: 'CASH',
    Online: 'ONLINE',
    Bank: 'BANK',
    Check: 'CHECK',
    ApplyCreditBalance: 'APPLY_CREDIT_BALANCE',
    Ach: 'ACH'
} as const;
export type GetPatientAllPaymentPaymentModeEnum = typeof GetPatientAllPaymentPaymentModeEnum[keyof typeof GetPatientAllPaymentPaymentModeEnum];
/**
 * @export
 */
export const GetPatientAllPaymentTypeOfPaymentEnum = {
    Patient: 'PATIENT',
    Insurance: 'INSURANCE'
} as const;
export type GetPatientAllPaymentTypeOfPaymentEnum = typeof GetPatientAllPaymentTypeOfPaymentEnum[keyof typeof GetPatientAllPaymentTypeOfPaymentEnum];
/**
 * @export
 */
export const GetPatientAllPaymentProjectionPaymentModeEnum = {
    Cash: 'CASH',
    Online: 'ONLINE',
    Bank: 'BANK',
    Check: 'CHECK',
    ApplyCreditBalance: 'APPLY_CREDIT_BALANCE',
    Ach: 'ACH'
} as const;
export type GetPatientAllPaymentProjectionPaymentModeEnum = typeof GetPatientAllPaymentProjectionPaymentModeEnum[keyof typeof GetPatientAllPaymentProjectionPaymentModeEnum];
/**
 * @export
 */
export const GetPatientAllPaymentProjectionTypeOfPaymentEnum = {
    Patient: 'PATIENT',
    Insurance: 'INSURANCE'
} as const;
export type GetPatientAllPaymentProjectionTypeOfPaymentEnum = typeof GetPatientAllPaymentProjectionTypeOfPaymentEnum[keyof typeof GetPatientAllPaymentProjectionTypeOfPaymentEnum];
/**
 * @export
 */
export const GetPatientAllPaymentProjectionCardStatusEnum = {
    Active: 'ACTIVE',
    Expired: 'EXPIRED',
    Inactive: 'INACTIVE'
} as const;
export type GetPatientAllPaymentProjectionCardStatusEnum = typeof GetPatientAllPaymentProjectionCardStatusEnum[keyof typeof GetPatientAllPaymentProjectionCardStatusEnum];
/**
 * @export
 */
export const GetPatientAllPaymentV2PaymentModeEnum = {
    Cash: 'CASH',
    Online: 'ONLINE',
    Bank: 'BANK',
    Check: 'CHECK',
    ApplyCreditBalance: 'APPLY_CREDIT_BALANCE',
    Ach: 'ACH'
} as const;
export type GetPatientAllPaymentV2PaymentModeEnum = typeof GetPatientAllPaymentV2PaymentModeEnum[keyof typeof GetPatientAllPaymentV2PaymentModeEnum];
/**
 * @export
 */
export const GetPatientAllPaymentV2PaymentCategoryEnum = {
    Copay: 'COPAY',
    Deductible: 'DEDUCTIBLE',
    Coinsurance: 'COINSURANCE',
    SelfPay: 'SELF_PAY',
    Advance: 'ADVANCE',
    Pr: 'PR',
    OutOfNetwork: 'OUT_OF_NETWORK',
    Invoice: 'INVOICE'
} as const;
export type GetPatientAllPaymentV2PaymentCategoryEnum = typeof GetPatientAllPaymentV2PaymentCategoryEnum[keyof typeof GetPatientAllPaymentV2PaymentCategoryEnum];
/**
 * @export
 */
export const GetPatientAllPaymentV2TypeOfPaymentEnum = {
    Patient: 'PATIENT',
    Insurance: 'INSURANCE'
} as const;
export type GetPatientAllPaymentV2TypeOfPaymentEnum = typeof GetPatientAllPaymentV2TypeOfPaymentEnum[keyof typeof GetPatientAllPaymentV2TypeOfPaymentEnum];


/**
 * PatientPortalControllerApi - axios parameter creator
 * @export
 */
export const PatientPortalControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Returns a paginated list of active providers (same provider group as patient). Optional searchString filters by first name and last name. Excludes bank and signature details.
         * @summary Get active providers for patient portal
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sort] 
         * @param {string} [searchString] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProviders: async (page?: number, size?: number, sortBy?: string, sort?: string, searchString?: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/master/patient-portal/providers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (searchString !== undefined) {
                localVarQueryParameter['searchString'] = searchString;
            }

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PatientPortalControllerApi - functional programming interface
 * @export
 */
export const PatientPortalControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PatientPortalControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * Returns a paginated list of active providers (same provider group as patient). Optional searchString filters by first name and last name. Excludes bank and signature details.
         * @summary Get active providers for patient portal
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sort] 
         * @param {string} [searchString] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProviders(page?: number, size?: number, sortBy?: string, sort?: string, searchString?: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProviders(page, size, sortBy, sort, searchString, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientPortalControllerApi.getProviders']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PatientPortalControllerApi - factory interface
 * @export
 */
export const PatientPortalControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PatientPortalControllerApiFp(configuration)
    return {
        /**
         * Returns a paginated list of active providers (same provider group as patient). Optional searchString filters by first name and last name. Excludes bank and signature details.
         * @summary Get active providers for patient portal
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sort] 
         * @param {string} [searchString] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProviders(page?: number, size?: number, sortBy?: string, sort?: string, searchString?: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getProviders(page, size, sortBy, sort, searchString, xTENANTID, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PatientPortalControllerApi - object-oriented interface
 * @export
 * @class PatientPortalControllerApi
 * @extends {BaseAPI}
 */
export class PatientPortalControllerApi extends BaseAPI {
    /**
     * Returns a paginated list of active providers (same provider group as patient). Optional searchString filters by first name and last name. Excludes bank and signature details.
     * @summary Get active providers for patient portal
     * @param {number} [page] 
     * @param {number} [size] 
     * @param {string} [sortBy] 
     * @param {string} [sort] 
     * @param {string} [searchString] 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientPortalControllerApi
     */
    public getProviders(page?: number, size?: number, sortBy?: string, sort?: string, searchString?: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return PatientPortalControllerApiFp(this.configuration).getProviders(page, size, sortBy, sort, searchString, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PatientPortalEmailControllerApi - axios parameter creator
 * @export
 */
export const PatientPortalEmailControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Archive multiple patient portal emails by their IDs
         * @summary Archive Patient Portal Emails
         * @param {boolean} archiveStatus 
         * @param {Array<string>} requestBody 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        archivePatientPortalEmail: async (archiveStatus: boolean, requestBody: Array<string>, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'archiveStatus' is not null or undefined
            assertParamExists('archivePatientPortalEmail', 'archiveStatus', archiveStatus)
            // verify required parameter 'requestBody' is not null or undefined
            assertParamExists('archivePatientPortalEmail', 'requestBody', requestBody)
            const localVarPath = `/api/master/patient-portal-email/archive/{archiveStatus}`
                .replace(`{${"archiveStatus"}}`, encodeURIComponent(String(archiveStatus)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all emails sent to the logged-in patient.
         * @summary Get all patient portal emails.
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sort] 
         * @param {string} [searchString] 
         * @param {string} [patientId] 
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {GetAllPatientPortalEmailsTemplateTypesEnum} [templateTypes] 
         * @param {boolean} [archive] 
         * @param {string} [sender] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllPatientPortalEmails: async (page?: number, size?: number, sortBy?: string, sort?: string, searchString?: string, patientId?: string, startDate?: string, endDate?: string, templateTypes?: GetAllPatientPortalEmailsTemplateTypesEnum, archive?: boolean, sender?: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/master/patient-portal-email`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (searchString !== undefined) {
                localVarQueryParameter['searchString'] = searchString;
            }

            if (patientId !== undefined) {
                localVarQueryParameter['patientId'] = patientId;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString() :
                    startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString() :
                    endDate;
            }

            if (templateTypes !== undefined) {
                localVarQueryParameter['templateTypes'] = templateTypes;
            }

            if (archive !== undefined) {
                localVarQueryParameter['archive'] = archive;
            }

            if (sender !== undefined) {
                localVarQueryParameter['sender'] = sender;
            }

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get count of unread emails for a patient
         * @summary Get unread email count
         * @param {string} patientId 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUnreadCount: async (patientId: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientId' is not null or undefined
            assertParamExists('getUnreadCount', 'patientId', patientId)
            const localVarPath = `/api/master/patient-portal-email/unread-count`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (patientId !== undefined) {
                localVarQueryParameter['patientId'] = patientId;
            }

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Mark a patient portal email as read when opened
         * @summary Mark Email as Read
         * @param {string} emailId 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markEmailAsRead: async (emailId: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'emailId' is not null or undefined
            assertParamExists('markEmailAsRead', 'emailId', emailId)
            const localVarPath = `/api/master/patient-portal-email/{emailId}/read`
                .replace(`{${"emailId"}}`, encodeURIComponent(String(emailId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PatientPortalEmailControllerApi - functional programming interface
 * @export
 */
export const PatientPortalEmailControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PatientPortalEmailControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * Archive multiple patient portal emails by their IDs
         * @summary Archive Patient Portal Emails
         * @param {boolean} archiveStatus 
         * @param {Array<string>} requestBody 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async archivePatientPortalEmail(archiveStatus: boolean, requestBody: Array<string>, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.archivePatientPortalEmail(archiveStatus, requestBody, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientPortalEmailControllerApi.archivePatientPortalEmail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get all emails sent to the logged-in patient.
         * @summary Get all patient portal emails.
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sort] 
         * @param {string} [searchString] 
         * @param {string} [patientId] 
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {GetAllPatientPortalEmailsTemplateTypesEnum} [templateTypes] 
         * @param {boolean} [archive] 
         * @param {string} [sender] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllPatientPortalEmails(page?: number, size?: number, sortBy?: string, sort?: string, searchString?: string, patientId?: string, startDate?: string, endDate?: string, templateTypes?: GetAllPatientPortalEmailsTemplateTypesEnum, archive?: boolean, sender?: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllPatientPortalEmails(page, size, sortBy, sort, searchString, patientId, startDate, endDate, templateTypes, archive, sender, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientPortalEmailControllerApi.getAllPatientPortalEmails']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get count of unread emails for a patient
         * @summary Get unread email count
         * @param {string} patientId 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUnreadCount(patientId: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUnreadCount(patientId, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientPortalEmailControllerApi.getUnreadCount']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Mark a patient portal email as read when opened
         * @summary Mark Email as Read
         * @param {string} emailId 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async markEmailAsRead(emailId: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.markEmailAsRead(emailId, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientPortalEmailControllerApi.markEmailAsRead']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PatientPortalEmailControllerApi - factory interface
 * @export
 */
export const PatientPortalEmailControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PatientPortalEmailControllerApiFp(configuration)
    return {
        /**
         * Archive multiple patient portal emails by their IDs
         * @summary Archive Patient Portal Emails
         * @param {boolean} archiveStatus 
         * @param {Array<string>} requestBody 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        archivePatientPortalEmail(archiveStatus: boolean, requestBody: Array<string>, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.archivePatientPortalEmail(archiveStatus, requestBody, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all emails sent to the logged-in patient.
         * @summary Get all patient portal emails.
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sort] 
         * @param {string} [searchString] 
         * @param {string} [patientId] 
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {GetAllPatientPortalEmailsTemplateTypesEnum} [templateTypes] 
         * @param {boolean} [archive] 
         * @param {string} [sender] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllPatientPortalEmails(page?: number, size?: number, sortBy?: string, sort?: string, searchString?: string, patientId?: string, startDate?: string, endDate?: string, templateTypes?: GetAllPatientPortalEmailsTemplateTypesEnum, archive?: boolean, sender?: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getAllPatientPortalEmails(page, size, sortBy, sort, searchString, patientId, startDate, endDate, templateTypes, archive, sender, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Get count of unread emails for a patient
         * @summary Get unread email count
         * @param {string} patientId 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUnreadCount(patientId: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getUnreadCount(patientId, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Mark a patient portal email as read when opened
         * @summary Mark Email as Read
         * @param {string} emailId 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markEmailAsRead(emailId: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.markEmailAsRead(emailId, xTENANTID, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PatientPortalEmailControllerApi - object-oriented interface
 * @export
 * @class PatientPortalEmailControllerApi
 * @extends {BaseAPI}
 */
export class PatientPortalEmailControllerApi extends BaseAPI {
    /**
     * Archive multiple patient portal emails by their IDs
     * @summary Archive Patient Portal Emails
     * @param {boolean} archiveStatus 
     * @param {Array<string>} requestBody 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientPortalEmailControllerApi
     */
    public archivePatientPortalEmail(archiveStatus: boolean, requestBody: Array<string>, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return PatientPortalEmailControllerApiFp(this.configuration).archivePatientPortalEmail(archiveStatus, requestBody, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all emails sent to the logged-in patient.
     * @summary Get all patient portal emails.
     * @param {number} [page] 
     * @param {number} [size] 
     * @param {string} [sortBy] 
     * @param {string} [sort] 
     * @param {string} [searchString] 
     * @param {string} [patientId] 
     * @param {string} [startDate] 
     * @param {string} [endDate] 
     * @param {GetAllPatientPortalEmailsTemplateTypesEnum} [templateTypes] 
     * @param {boolean} [archive] 
     * @param {string} [sender] 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientPortalEmailControllerApi
     */
    public getAllPatientPortalEmails(page?: number, size?: number, sortBy?: string, sort?: string, searchString?: string, patientId?: string, startDate?: string, endDate?: string, templateTypes?: GetAllPatientPortalEmailsTemplateTypesEnum, archive?: boolean, sender?: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return PatientPortalEmailControllerApiFp(this.configuration).getAllPatientPortalEmails(page, size, sortBy, sort, searchString, patientId, startDate, endDate, templateTypes, archive, sender, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get count of unread emails for a patient
     * @summary Get unread email count
     * @param {string} patientId 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientPortalEmailControllerApi
     */
    public getUnreadCount(patientId: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return PatientPortalEmailControllerApiFp(this.configuration).getUnreadCount(patientId, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Mark a patient portal email as read when opened
     * @summary Mark Email as Read
     * @param {string} emailId 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientPortalEmailControllerApi
     */
    public markEmailAsRead(emailId: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return PatientPortalEmailControllerApiFp(this.configuration).markEmailAsRead(emailId, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const GetAllPatientPortalEmailsTemplateTypesEnum = {
    Email: 'EMAIL',
    Sms: 'SMS',
    Ros: 'ROS',
    Physical: 'PHYSICAL',
    Macros: 'MACROS',
    CarePlan: 'CARE_PLAN',
    HomeCareRos: 'HOME_CARE_ROS',
    HomeCarePe: 'HOME_CARE_PE'
} as const;
export type GetAllPatientPortalEmailsTemplateTypesEnum = typeof GetAllPatientPortalEmailsTemplateTypesEnum[keyof typeof GetAllPatientPortalEmailsTemplateTypesEnum];


/**
 * PatientPortalNotificationControllerApi - axios parameter creator
 * @export
 */
export const PatientPortalNotificationControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get paginated notifications for a patient, optionally filtered by category
         * @summary Get patient portal notifications
         * @param {string} patientUuid 
         * @param {GetNotificationsCategoryEnum} [category] 
         * @param {boolean} [isRead] 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNotifications: async (patientUuid: string, category?: GetNotificationsCategoryEnum, isRead?: boolean, page?: number, size?: number, sortBy?: string, sortDirection?: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientUuid' is not null or undefined
            assertParamExists('getNotifications', 'patientUuid', patientUuid)
            const localVarPath = `/api/master/patient-portal-notification/{patientUuid}`
                .replace(`{${"patientUuid"}}`, encodeURIComponent(String(patientUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (category !== undefined) {
                localVarQueryParameter['category'] = category;
            }

            if (isRead !== undefined) {
                localVarQueryParameter['isRead'] = isRead;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get unread counts per category for a patient
         * @summary Get unread notification counts
         * @param {string} patientUuid 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUnreadCounts: async (patientUuid: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientUuid' is not null or undefined
            assertParamExists('getUnreadCounts', 'patientUuid', patientUuid)
            const localVarPath = `/api/master/patient-portal-notification/{patientUuid}/unread-counts`
                .replace(`{${"patientUuid"}}`, encodeURIComponent(String(patientUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Mark all unread notifications as read for a patient
         * @summary Mark all notifications as read
         * @param {string} patientUuid 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markAllAsRead: async (patientUuid: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientUuid' is not null or undefined
            assertParamExists('markAllAsRead', 'patientUuid', patientUuid)
            const localVarPath = `/api/master/patient-portal-notification/{patientUuid}/read-all`
                .replace(`{${"patientUuid"}}`, encodeURIComponent(String(patientUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Mark a single notification as read
         * @summary Mark notification as read
         * @param {string} notificationUuid 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markAsRead: async (notificationUuid: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'notificationUuid' is not null or undefined
            assertParamExists('markAsRead', 'notificationUuid', notificationUuid)
            const localVarPath = `/api/master/patient-portal-notification/{notificationUuid}/read`
                .replace(`{${"notificationUuid"}}`, encodeURIComponent(String(notificationUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Mark a batch of notifications as read
         * @summary Mark multiple notifications as read
         * @param {Array<string>} requestBody 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markAsReadBatch: async (requestBody: Array<string>, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'requestBody' is not null or undefined
            assertParamExists('markAsReadBatch', 'requestBody', requestBody)
            const localVarPath = `/api/master/patient-portal-notification/read-batch`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PatientPortalNotificationControllerApi - functional programming interface
 * @export
 */
export const PatientPortalNotificationControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PatientPortalNotificationControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * Get paginated notifications for a patient, optionally filtered by category
         * @summary Get patient portal notifications
         * @param {string} patientUuid 
         * @param {GetNotificationsCategoryEnum} [category] 
         * @param {boolean} [isRead] 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getNotifications(patientUuid: string, category?: GetNotificationsCategoryEnum, isRead?: boolean, page?: number, size?: number, sortBy?: string, sortDirection?: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getNotifications(patientUuid, category, isRead, page, size, sortBy, sortDirection, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientPortalNotificationControllerApi.getNotifications']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get unread counts per category for a patient
         * @summary Get unread notification counts
         * @param {string} patientUuid 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUnreadCounts(patientUuid: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUnreadCounts(patientUuid, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientPortalNotificationControllerApi.getUnreadCounts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Mark all unread notifications as read for a patient
         * @summary Mark all notifications as read
         * @param {string} patientUuid 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async markAllAsRead(patientUuid: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.markAllAsRead(patientUuid, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientPortalNotificationControllerApi.markAllAsRead']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Mark a single notification as read
         * @summary Mark notification as read
         * @param {string} notificationUuid 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async markAsRead(notificationUuid: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.markAsRead(notificationUuid, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientPortalNotificationControllerApi.markAsRead']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Mark a batch of notifications as read
         * @summary Mark multiple notifications as read
         * @param {Array<string>} requestBody 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async markAsReadBatch(requestBody: Array<string>, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.markAsReadBatch(requestBody, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientPortalNotificationControllerApi.markAsReadBatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PatientPortalNotificationControllerApi - factory interface
 * @export
 */
export const PatientPortalNotificationControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PatientPortalNotificationControllerApiFp(configuration)
    return {
        /**
         * Get paginated notifications for a patient, optionally filtered by category
         * @summary Get patient portal notifications
         * @param {string} patientUuid 
         * @param {GetNotificationsCategoryEnum} [category] 
         * @param {boolean} [isRead] 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNotifications(patientUuid: string, category?: GetNotificationsCategoryEnum, isRead?: boolean, page?: number, size?: number, sortBy?: string, sortDirection?: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getNotifications(patientUuid, category, isRead, page, size, sortBy, sortDirection, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Get unread counts per category for a patient
         * @summary Get unread notification counts
         * @param {string} patientUuid 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUnreadCounts(patientUuid: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getUnreadCounts(patientUuid, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Mark all unread notifications as read for a patient
         * @summary Mark all notifications as read
         * @param {string} patientUuid 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markAllAsRead(patientUuid: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.markAllAsRead(patientUuid, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Mark a single notification as read
         * @summary Mark notification as read
         * @param {string} notificationUuid 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markAsRead(notificationUuid: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.markAsRead(notificationUuid, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Mark a batch of notifications as read
         * @summary Mark multiple notifications as read
         * @param {Array<string>} requestBody 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markAsReadBatch(requestBody: Array<string>, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.markAsReadBatch(requestBody, xTENANTID, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PatientPortalNotificationControllerApi - object-oriented interface
 * @export
 * @class PatientPortalNotificationControllerApi
 * @extends {BaseAPI}
 */
export class PatientPortalNotificationControllerApi extends BaseAPI {
    /**
     * Get paginated notifications for a patient, optionally filtered by category
     * @summary Get patient portal notifications
     * @param {string} patientUuid 
     * @param {GetNotificationsCategoryEnum} [category] 
     * @param {boolean} [isRead] 
     * @param {number} [page] 
     * @param {number} [size] 
     * @param {string} [sortBy] 
     * @param {string} [sortDirection] 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientPortalNotificationControllerApi
     */
    public getNotifications(patientUuid: string, category?: GetNotificationsCategoryEnum, isRead?: boolean, page?: number, size?: number, sortBy?: string, sortDirection?: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return PatientPortalNotificationControllerApiFp(this.configuration).getNotifications(patientUuid, category, isRead, page, size, sortBy, sortDirection, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get unread counts per category for a patient
     * @summary Get unread notification counts
     * @param {string} patientUuid 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientPortalNotificationControllerApi
     */
    public getUnreadCounts(patientUuid: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return PatientPortalNotificationControllerApiFp(this.configuration).getUnreadCounts(patientUuid, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Mark all unread notifications as read for a patient
     * @summary Mark all notifications as read
     * @param {string} patientUuid 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientPortalNotificationControllerApi
     */
    public markAllAsRead(patientUuid: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return PatientPortalNotificationControllerApiFp(this.configuration).markAllAsRead(patientUuid, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Mark a single notification as read
     * @summary Mark notification as read
     * @param {string} notificationUuid 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientPortalNotificationControllerApi
     */
    public markAsRead(notificationUuid: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return PatientPortalNotificationControllerApiFp(this.configuration).markAsRead(notificationUuid, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Mark a batch of notifications as read
     * @summary Mark multiple notifications as read
     * @param {Array<string>} requestBody 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientPortalNotificationControllerApi
     */
    public markAsReadBatch(requestBody: Array<string>, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return PatientPortalNotificationControllerApiFp(this.configuration).markAsReadBatch(requestBody, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const GetNotificationsCategoryEnum = {
    Appointment: 'APPOINTMENT',
    Clinical: 'CLINICAL',
    Communication: 'COMMUNICATION',
    Critical: 'CRITICAL',
    Messaging: 'MESSAGING',
    Results: 'RESULTS'
} as const;
export type GetNotificationsCategoryEnum = typeof GetNotificationsCategoryEnum[keyof typeof GetNotificationsCategoryEnum];


/**
 * PatientProcedureCodeControllerApi - axios parameter creator
 * @export
 */
export const PatientProcedureCodeControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Sub Total using rendering provider\'s fee schedule if UUID provided; otherwise uses SuperBill charges
         * @summary Get Sub Total For Patient ProcedureCode
         * @param {PatientProcedureCode} patientProcedureCode 
         * @param {string} [renderingProviderUuid] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSubTotalForPatientProcedureCode: async (patientProcedureCode: PatientProcedureCode, renderingProviderUuid?: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientProcedureCode' is not null or undefined
            assertParamExists('getSubTotalForPatientProcedureCode', 'patientProcedureCode', patientProcedureCode)
            const localVarPath = `/api/master/patient-procedure-code`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (renderingProviderUuid !== undefined) {
                localVarQueryParameter['renderingProviderUuid'] = renderingProviderUuid;
            }

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patientProcedureCode, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PatientProcedureCodeControllerApi - functional programming interface
 * @export
 */
export const PatientProcedureCodeControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PatientProcedureCodeControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * Sub Total using rendering provider\'s fee schedule if UUID provided; otherwise uses SuperBill charges
         * @summary Get Sub Total For Patient ProcedureCode
         * @param {PatientProcedureCode} patientProcedureCode 
         * @param {string} [renderingProviderUuid] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSubTotalForPatientProcedureCode(patientProcedureCode: PatientProcedureCode, renderingProviderUuid?: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSubTotalForPatientProcedureCode(patientProcedureCode, renderingProviderUuid, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientProcedureCodeControllerApi.getSubTotalForPatientProcedureCode']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PatientProcedureCodeControllerApi - factory interface
 * @export
 */
export const PatientProcedureCodeControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PatientProcedureCodeControllerApiFp(configuration)
    return {
        /**
         * Sub Total using rendering provider\'s fee schedule if UUID provided; otherwise uses SuperBill charges
         * @summary Get Sub Total For Patient ProcedureCode
         * @param {PatientProcedureCode} patientProcedureCode 
         * @param {string} [renderingProviderUuid] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSubTotalForPatientProcedureCode(patientProcedureCode: PatientProcedureCode, renderingProviderUuid?: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getSubTotalForPatientProcedureCode(patientProcedureCode, renderingProviderUuid, xTENANTID, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PatientProcedureCodeControllerApi - object-oriented interface
 * @export
 * @class PatientProcedureCodeControllerApi
 * @extends {BaseAPI}
 */
export class PatientProcedureCodeControllerApi extends BaseAPI {
    /**
     * Sub Total using rendering provider\'s fee schedule if UUID provided; otherwise uses SuperBill charges
     * @summary Get Sub Total For Patient ProcedureCode
     * @param {PatientProcedureCode} patientProcedureCode 
     * @param {string} [renderingProviderUuid] 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientProcedureCodeControllerApi
     */
    public getSubTotalForPatientProcedureCode(patientProcedureCode: PatientProcedureCode, renderingProviderUuid?: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return PatientProcedureCodeControllerApiFp(this.configuration).getSubTotalForPatientProcedureCode(patientProcedureCode, renderingProviderUuid, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PatientQuestionnaireControllerApi - axios parameter creator
 * @export
 */
export const PatientQuestionnaireControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Export patient questionnaire as PDF or CSV by questionnaire IDs
         * @summary Export Patient Questionnaire
         * @param {string} exportType 
         * @param {PatientQuestionnaireExportRequest} patientQuestionnaireExportRequest 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportPatientQuestionnaire: async (exportType: string, patientQuestionnaireExportRequest: PatientQuestionnaireExportRequest, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'exportType' is not null or undefined
            assertParamExists('exportPatientQuestionnaire', 'exportType', exportType)
            // verify required parameter 'patientQuestionnaireExportRequest' is not null or undefined
            assertParamExists('exportPatientQuestionnaire', 'patientQuestionnaireExportRequest', patientQuestionnaireExportRequest)
            const localVarPath = `/api/master/patient-questionnaire/export`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (exportType !== undefined) {
                localVarQueryParameter['exportType'] = exportType;
            }

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patientQuestionnaireExportRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all patient questionnaire list for super admin with search option on patient name and patient MRN (case-insensitive partial match), filter by submitted date (date match only), and filter options on active, archive.
         * @summary Get all Patient Questionnaire.
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {boolean} [status] 
         * @param {boolean} [archive] 
         * @param {boolean} [review] 
         * @param {string} [searchString] 
         * @param {string} [submittedDate] 
         * @param {GetAllPatientQuestionnaireMonthFilterEnum} [monthFilter] 
         * @param {string} [submittedBy] 
         * @param {string} [severityRange] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllPatientQuestionnaire: async (page?: number, size?: number, sortBy?: string, sortDirection?: string, status?: boolean, archive?: boolean, review?: boolean, searchString?: string, submittedDate?: string, monthFilter?: GetAllPatientQuestionnaireMonthFilterEnum, submittedBy?: string, severityRange?: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/master/patient-questionnaire`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (archive !== undefined) {
                localVarQueryParameter['archive'] = archive;
            }

            if (review !== undefined) {
                localVarQueryParameter['review'] = review;
            }

            if (searchString !== undefined) {
                localVarQueryParameter['searchString'] = searchString;
            }

            if (submittedDate !== undefined) {
                localVarQueryParameter['submittedDate'] = (submittedDate as any instanceof Date) ?
                    (submittedDate as any).toISOString() :
                    submittedDate;
            }

            if (monthFilter !== undefined) {
                localVarQueryParameter['monthFilter'] = monthFilter;
            }

            if (submittedBy !== undefined) {
                localVarQueryParameter['submittedBy'] = submittedBy;
            }

            if (severityRange !== undefined) {
                localVarQueryParameter['severityRange'] = severityRange;
            }

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get Patient Questionnaire
         * @summary Get  Patient Questionnaires
         * @param {string} patientId 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatientQuestionnaire: async (patientId: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientId' is not null or undefined
            assertParamExists('getPatientQuestionnaire', 'patientId', patientId)
            const localVarPath = `/api/master/patient-questionnaire/{patientId}`
                .replace(`{${"patientId"}}`, encodeURIComponent(String(patientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get patient questionnaires filtered by screener types and date range, grouped by date
         * @summary Get Patient Questionnaires by Screener Types
         * @param {string} patientId 
         * @param {string} fromDate 
         * @param {string} toDate 
         * @param {Array<string>} [screenerTypes] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatientQuestionnaireByScreenerTypes: async (patientId: string, fromDate: string, toDate: string, screenerTypes?: Array<string>, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientId' is not null or undefined
            assertParamExists('getPatientQuestionnaireByScreenerTypes', 'patientId', patientId)
            // verify required parameter 'fromDate' is not null or undefined
            assertParamExists('getPatientQuestionnaireByScreenerTypes', 'fromDate', fromDate)
            // verify required parameter 'toDate' is not null or undefined
            assertParamExists('getPatientQuestionnaireByScreenerTypes', 'toDate', toDate)
            const localVarPath = `/api/master/patient-questionnaire/{patientId}/screener-types`
                .replace(`{${"patientId"}}`, encodeURIComponent(String(patientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (screenerTypes) {
                localVarQueryParameter['screenerTypes'] = screenerTypes;
            }

            if (fromDate !== undefined) {
                localVarQueryParameter['fromDate'] = (fromDate as any instanceof Date) ?
                    (fromDate as any).toISOString() :
                    fromDate;
            }

            if (toDate !== undefined) {
                localVarQueryParameter['toDate'] = (toDate as any instanceof Date) ?
                    (toDate as any).toISOString() :
                    toDate;
            }

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Edit Patient Questionnaire
         * @summary Update Patient Questionnaire
         * @param {string} patientQuestionnaireId 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePatientQuestionnaire: async (patientQuestionnaireId: string, status: boolean, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientQuestionnaireId' is not null or undefined
            assertParamExists('updatePatientQuestionnaire', 'patientQuestionnaireId', patientQuestionnaireId)
            // verify required parameter 'status' is not null or undefined
            assertParamExists('updatePatientQuestionnaire', 'status', status)
            const localVarPath = `/api/master/patient-questionnaire/{patientQuestionnaireId}/status/{status}`
                .replace(`{${"patientQuestionnaireId"}}`, encodeURIComponent(String(patientQuestionnaireId)))
                .replace(`{${"status"}}`, encodeURIComponent(String(status)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PatientQuestionnaireControllerApi - functional programming interface
 * @export
 */
export const PatientQuestionnaireControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PatientQuestionnaireControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * Export patient questionnaire as PDF or CSV by questionnaire IDs
         * @summary Export Patient Questionnaire
         * @param {string} exportType 
         * @param {PatientQuestionnaireExportRequest} patientQuestionnaireExportRequest 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exportPatientQuestionnaire(exportType: string, patientQuestionnaireExportRequest: PatientQuestionnaireExportRequest, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.exportPatientQuestionnaire(exportType, patientQuestionnaireExportRequest, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientQuestionnaireControllerApi.exportPatientQuestionnaire']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get all patient questionnaire list for super admin with search option on patient name and patient MRN (case-insensitive partial match), filter by submitted date (date match only), and filter options on active, archive.
         * @summary Get all Patient Questionnaire.
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {boolean} [status] 
         * @param {boolean} [archive] 
         * @param {boolean} [review] 
         * @param {string} [searchString] 
         * @param {string} [submittedDate] 
         * @param {GetAllPatientQuestionnaireMonthFilterEnum} [monthFilter] 
         * @param {string} [submittedBy] 
         * @param {string} [severityRange] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllPatientQuestionnaire(page?: number, size?: number, sortBy?: string, sortDirection?: string, status?: boolean, archive?: boolean, review?: boolean, searchString?: string, submittedDate?: string, monthFilter?: GetAllPatientQuestionnaireMonthFilterEnum, submittedBy?: string, severityRange?: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllPatientQuestionnaire(page, size, sortBy, sortDirection, status, archive, review, searchString, submittedDate, monthFilter, submittedBy, severityRange, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientQuestionnaireControllerApi.getAllPatientQuestionnaire']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get Patient Questionnaire
         * @summary Get  Patient Questionnaires
         * @param {string} patientId 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPatientQuestionnaire(patientId: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPatientQuestionnaire(patientId, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientQuestionnaireControllerApi.getPatientQuestionnaire']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get patient questionnaires filtered by screener types and date range, grouped by date
         * @summary Get Patient Questionnaires by Screener Types
         * @param {string} patientId 
         * @param {string} fromDate 
         * @param {string} toDate 
         * @param {Array<string>} [screenerTypes] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPatientQuestionnaireByScreenerTypes(patientId: string, fromDate: string, toDate: string, screenerTypes?: Array<string>, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPatientQuestionnaireByScreenerTypes(patientId, fromDate, toDate, screenerTypes, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientQuestionnaireControllerApi.getPatientQuestionnaireByScreenerTypes']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Edit Patient Questionnaire
         * @summary Update Patient Questionnaire
         * @param {string} patientQuestionnaireId 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePatientQuestionnaire(patientQuestionnaireId: string, status: boolean, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePatientQuestionnaire(patientQuestionnaireId, status, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientQuestionnaireControllerApi.updatePatientQuestionnaire']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PatientQuestionnaireControllerApi - factory interface
 * @export
 */
export const PatientQuestionnaireControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PatientQuestionnaireControllerApiFp(configuration)
    return {
        /**
         * Export patient questionnaire as PDF or CSV by questionnaire IDs
         * @summary Export Patient Questionnaire
         * @param {string} exportType 
         * @param {PatientQuestionnaireExportRequest} patientQuestionnaireExportRequest 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportPatientQuestionnaire(exportType: string, patientQuestionnaireExportRequest: PatientQuestionnaireExportRequest, xTENANTID?: string, options?: any): AxiosPromise<File> {
            return localVarFp.exportPatientQuestionnaire(exportType, patientQuestionnaireExportRequest, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all patient questionnaire list for super admin with search option on patient name and patient MRN (case-insensitive partial match), filter by submitted date (date match only), and filter options on active, archive.
         * @summary Get all Patient Questionnaire.
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {boolean} [status] 
         * @param {boolean} [archive] 
         * @param {boolean} [review] 
         * @param {string} [searchString] 
         * @param {string} [submittedDate] 
         * @param {GetAllPatientQuestionnaireMonthFilterEnum} [monthFilter] 
         * @param {string} [submittedBy] 
         * @param {string} [severityRange] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllPatientQuestionnaire(page?: number, size?: number, sortBy?: string, sortDirection?: string, status?: boolean, archive?: boolean, review?: boolean, searchString?: string, submittedDate?: string, monthFilter?: GetAllPatientQuestionnaireMonthFilterEnum, submittedBy?: string, severityRange?: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getAllPatientQuestionnaire(page, size, sortBy, sortDirection, status, archive, review, searchString, submittedDate, monthFilter, submittedBy, severityRange, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Get Patient Questionnaire
         * @summary Get  Patient Questionnaires
         * @param {string} patientId 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatientQuestionnaire(patientId: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getPatientQuestionnaire(patientId, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Get patient questionnaires filtered by screener types and date range, grouped by date
         * @summary Get Patient Questionnaires by Screener Types
         * @param {string} patientId 
         * @param {string} fromDate 
         * @param {string} toDate 
         * @param {Array<string>} [screenerTypes] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatientQuestionnaireByScreenerTypes(patientId: string, fromDate: string, toDate: string, screenerTypes?: Array<string>, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getPatientQuestionnaireByScreenerTypes(patientId, fromDate, toDate, screenerTypes, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Edit Patient Questionnaire
         * @summary Update Patient Questionnaire
         * @param {string} patientQuestionnaireId 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePatientQuestionnaire(patientQuestionnaireId: string, status: boolean, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.updatePatientQuestionnaire(patientQuestionnaireId, status, xTENANTID, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PatientQuestionnaireControllerApi - object-oriented interface
 * @export
 * @class PatientQuestionnaireControllerApi
 * @extends {BaseAPI}
 */
export class PatientQuestionnaireControllerApi extends BaseAPI {
    /**
     * Export patient questionnaire as PDF or CSV by questionnaire IDs
     * @summary Export Patient Questionnaire
     * @param {string} exportType 
     * @param {PatientQuestionnaireExportRequest} patientQuestionnaireExportRequest 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientQuestionnaireControllerApi
     */
    public exportPatientQuestionnaire(exportType: string, patientQuestionnaireExportRequest: PatientQuestionnaireExportRequest, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return PatientQuestionnaireControllerApiFp(this.configuration).exportPatientQuestionnaire(exportType, patientQuestionnaireExportRequest, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all patient questionnaire list for super admin with search option on patient name and patient MRN (case-insensitive partial match), filter by submitted date (date match only), and filter options on active, archive.
     * @summary Get all Patient Questionnaire.
     * @param {number} [page] 
     * @param {number} [size] 
     * @param {string} [sortBy] 
     * @param {string} [sortDirection] 
     * @param {boolean} [status] 
     * @param {boolean} [archive] 
     * @param {boolean} [review] 
     * @param {string} [searchString] 
     * @param {string} [submittedDate] 
     * @param {GetAllPatientQuestionnaireMonthFilterEnum} [monthFilter] 
     * @param {string} [submittedBy] 
     * @param {string} [severityRange] 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientQuestionnaireControllerApi
     */
    public getAllPatientQuestionnaire(page?: number, size?: number, sortBy?: string, sortDirection?: string, status?: boolean, archive?: boolean, review?: boolean, searchString?: string, submittedDate?: string, monthFilter?: GetAllPatientQuestionnaireMonthFilterEnum, submittedBy?: string, severityRange?: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return PatientQuestionnaireControllerApiFp(this.configuration).getAllPatientQuestionnaire(page, size, sortBy, sortDirection, status, archive, review, searchString, submittedDate, monthFilter, submittedBy, severityRange, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get Patient Questionnaire
     * @summary Get  Patient Questionnaires
     * @param {string} patientId 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientQuestionnaireControllerApi
     */
    public getPatientQuestionnaire(patientId: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return PatientQuestionnaireControllerApiFp(this.configuration).getPatientQuestionnaire(patientId, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get patient questionnaires filtered by screener types and date range, grouped by date
     * @summary Get Patient Questionnaires by Screener Types
     * @param {string} patientId 
     * @param {string} fromDate 
     * @param {string} toDate 
     * @param {Array<string>} [screenerTypes] 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientQuestionnaireControllerApi
     */
    public getPatientQuestionnaireByScreenerTypes(patientId: string, fromDate: string, toDate: string, screenerTypes?: Array<string>, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return PatientQuestionnaireControllerApiFp(this.configuration).getPatientQuestionnaireByScreenerTypes(patientId, fromDate, toDate, screenerTypes, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Edit Patient Questionnaire
     * @summary Update Patient Questionnaire
     * @param {string} patientQuestionnaireId 
     * @param {boolean} status 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientQuestionnaireControllerApi
     */
    public updatePatientQuestionnaire(patientQuestionnaireId: string, status: boolean, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return PatientQuestionnaireControllerApiFp(this.configuration).updatePatientQuestionnaire(patientQuestionnaireId, status, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const GetAllPatientQuestionnaireMonthFilterEnum = {
    OneMonth: 'ONE_MONTH',
    TwoMonth: 'TWO_MONTH',
    ThreeMonth: 'THREE_MONTH',
    SixMonth: 'SIX_MONTH',
    OneYear: 'ONE_YEAR',
    AllTime: 'ALL_TIME'
} as const;
export type GetAllPatientQuestionnaireMonthFilterEnum = typeof GetAllPatientQuestionnaireMonthFilterEnum[keyof typeof GetAllPatientQuestionnaireMonthFilterEnum];


/**
 * PatientRequiringActionControllerApi - axios parameter creator
 * @export
 */
export const PatientRequiringActionControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Mark a patient requiring action as completed.
         * @summary Complete patient requiring action
         * @param {string} patientRequiringActionId 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        complete: async (patientRequiringActionId: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientRequiringActionId' is not null or undefined
            assertParamExists('complete', 'patientRequiringActionId', patientRequiringActionId)
            const localVarPath = `/api/master/patient-requiring-action/{patientRequiringActionId}/complete`
                .replace(`{${"patientRequiringActionId"}}`, encodeURIComponent(String(patientRequiringActionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get requiring actions for a patient (patient portal). Patient UUID is required.
         * @summary Get patient requiring actions
         * @param {string} patient 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {GetByPatientActionStatusEnum} [actionStatus] 
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getByPatient: async (patient: string, page?: number, size?: number, sortBy?: string, sortDirection?: string, actionStatus?: GetByPatientActionStatusEnum, startDate?: string, endDate?: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patient' is not null or undefined
            assertParamExists('getByPatient', 'patient', patient)
            const localVarPath = `/api/master/patient-requiring-action`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (patient !== undefined) {
                localVarQueryParameter['patient'] = patient;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }

            if (actionStatus !== undefined) {
                localVarQueryParameter['actionStatus'] = actionStatus;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString() :
                    startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString() :
                    endDate;
            }

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PatientRequiringActionControllerApi - functional programming interface
 * @export
 */
export const PatientRequiringActionControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PatientRequiringActionControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * Mark a patient requiring action as completed.
         * @summary Complete patient requiring action
         * @param {string} patientRequiringActionId 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async complete(patientRequiringActionId: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.complete(patientRequiringActionId, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientRequiringActionControllerApi.complete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get requiring actions for a patient (patient portal). Patient UUID is required.
         * @summary Get patient requiring actions
         * @param {string} patient 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {GetByPatientActionStatusEnum} [actionStatus] 
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getByPatient(patient: string, page?: number, size?: number, sortBy?: string, sortDirection?: string, actionStatus?: GetByPatientActionStatusEnum, startDate?: string, endDate?: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getByPatient(patient, page, size, sortBy, sortDirection, actionStatus, startDate, endDate, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientRequiringActionControllerApi.getByPatient']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PatientRequiringActionControllerApi - factory interface
 * @export
 */
export const PatientRequiringActionControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PatientRequiringActionControllerApiFp(configuration)
    return {
        /**
         * Mark a patient requiring action as completed.
         * @summary Complete patient requiring action
         * @param {string} patientRequiringActionId 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        complete(patientRequiringActionId: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.complete(patientRequiringActionId, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Get requiring actions for a patient (patient portal). Patient UUID is required.
         * @summary Get patient requiring actions
         * @param {string} patient 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {GetByPatientActionStatusEnum} [actionStatus] 
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getByPatient(patient: string, page?: number, size?: number, sortBy?: string, sortDirection?: string, actionStatus?: GetByPatientActionStatusEnum, startDate?: string, endDate?: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getByPatient(patient, page, size, sortBy, sortDirection, actionStatus, startDate, endDate, xTENANTID, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PatientRequiringActionControllerApi - object-oriented interface
 * @export
 * @class PatientRequiringActionControllerApi
 * @extends {BaseAPI}
 */
export class PatientRequiringActionControllerApi extends BaseAPI {
    /**
     * Mark a patient requiring action as completed.
     * @summary Complete patient requiring action
     * @param {string} patientRequiringActionId 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientRequiringActionControllerApi
     */
    public complete(patientRequiringActionId: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return PatientRequiringActionControllerApiFp(this.configuration).complete(patientRequiringActionId, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get requiring actions for a patient (patient portal). Patient UUID is required.
     * @summary Get patient requiring actions
     * @param {string} patient 
     * @param {number} [page] 
     * @param {number} [size] 
     * @param {string} [sortBy] 
     * @param {string} [sortDirection] 
     * @param {GetByPatientActionStatusEnum} [actionStatus] 
     * @param {string} [startDate] 
     * @param {string} [endDate] 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientRequiringActionControllerApi
     */
    public getByPatient(patient: string, page?: number, size?: number, sortBy?: string, sortDirection?: string, actionStatus?: GetByPatientActionStatusEnum, startDate?: string, endDate?: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return PatientRequiringActionControllerApiFp(this.configuration).getByPatient(patient, page, size, sortBy, sortDirection, actionStatus, startDate, endDate, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const GetByPatientActionStatusEnum = {
    Pending: 'PENDING',
    Completed: 'COMPLETED',
    Scheduled: 'SCHEDULED'
} as const;
export type GetByPatientActionStatusEnum = typeof GetByPatientActionStatusEnum[keyof typeof GetByPatientActionStatusEnum];


/**
 * PatientRunningNoteControllerApi - axios parameter creator
 * @export
 */
export const PatientRunningNoteControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * create running note 
         * @summary create patient running note
         * @param {PatientRunningNote} patientRunningNote 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRunningNote: async (patientRunningNote: PatientRunningNote, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientRunningNote' is not null or undefined
            assertParamExists('createRunningNote', 'patientRunningNote', patientRunningNote)
            const localVarPath = `/api/master/patient-running-note`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patientRunningNote, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * get running note by patient id
         * @summary get running note by patient id
         * @param {string} patientId 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRunningNoteByUuid: async (patientId: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientId' is not null or undefined
            assertParamExists('getRunningNoteByUuid', 'patientId', patientId)
            const localVarPath = `/api/master/patient-running-note/{patientId}`
                .replace(`{${"patientId"}}`, encodeURIComponent(String(patientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PatientRunningNoteControllerApi - functional programming interface
 * @export
 */
export const PatientRunningNoteControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PatientRunningNoteControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * create running note 
         * @summary create patient running note
         * @param {PatientRunningNote} patientRunningNote 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createRunningNote(patientRunningNote: PatientRunningNote, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createRunningNote(patientRunningNote, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientRunningNoteControllerApi.createRunningNote']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * get running note by patient id
         * @summary get running note by patient id
         * @param {string} patientId 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRunningNoteByUuid(patientId: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRunningNoteByUuid(patientId, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientRunningNoteControllerApi.getRunningNoteByUuid']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PatientRunningNoteControllerApi - factory interface
 * @export
 */
export const PatientRunningNoteControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PatientRunningNoteControllerApiFp(configuration)
    return {
        /**
         * create running note 
         * @summary create patient running note
         * @param {PatientRunningNote} patientRunningNote 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRunningNote(patientRunningNote: PatientRunningNote, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.createRunningNote(patientRunningNote, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * get running note by patient id
         * @summary get running note by patient id
         * @param {string} patientId 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRunningNoteByUuid(patientId: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getRunningNoteByUuid(patientId, xTENANTID, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PatientRunningNoteControllerApi - object-oriented interface
 * @export
 * @class PatientRunningNoteControllerApi
 * @extends {BaseAPI}
 */
export class PatientRunningNoteControllerApi extends BaseAPI {
    /**
     * create running note 
     * @summary create patient running note
     * @param {PatientRunningNote} patientRunningNote 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientRunningNoteControllerApi
     */
    public createRunningNote(patientRunningNote: PatientRunningNote, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return PatientRunningNoteControllerApiFp(this.configuration).createRunningNote(patientRunningNote, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * get running note by patient id
     * @summary get running note by patient id
     * @param {string} patientId 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientRunningNoteControllerApi
     */
    public getRunningNoteByUuid(patientId: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return PatientRunningNoteControllerApiFp(this.configuration).getRunningNoteByUuid(patientId, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PatientScreenerAnswerControllerApi - axios parameter creator
 * @export
 */
export const PatientScreenerAnswerControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Add patient screener question answer
         * @summary Add answer
         * @param {string} patientUuid 
         * @param {PatientScreener} patientScreener 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addPatientScreener: async (patientUuid: string, patientScreener: PatientScreener, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientUuid' is not null or undefined
            assertParamExists('addPatientScreener', 'patientUuid', patientUuid)
            // verify required parameter 'patientScreener' is not null or undefined
            assertParamExists('addPatientScreener', 'patientScreener', patientScreener)
            const localVarPath = `/api/master/patient-screener/{patientUuid}`
                .replace(`{${"patientUuid"}}`, encodeURIComponent(String(patientUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patientScreener, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} appointmentUuid 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllScreenersAnswerForAppointment: async (appointmentUuid: string, page?: number, size?: number, sortBy?: string, sortDirection?: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'appointmentUuid' is not null or undefined
            assertParamExists('getAllScreenersAnswerForAppointment', 'appointmentUuid', appointmentUuid)
            const localVarPath = `/api/master/patient-screener/appointment/{appointmentUuid}`
                .replace(`{${"appointmentUuid"}}`, encodeURIComponent(String(appointmentUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves all patient forms, intake forms, and assessments sent to the patient for a specific appointment
         * @summary Get all forms and assessments for appointment
         * @param {string} appointmentUuid 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFormsAndAssessmentsByAppointment: async (appointmentUuid: string, page?: number, size?: number, sortBy?: string, sortDirection?: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'appointmentUuid' is not null or undefined
            assertParamExists('getFormsAndAssessmentsByAppointment', 'appointmentUuid', appointmentUuid)
            const localVarPath = `/api/master/patient-screener/forms-and-assessments/appointment/{appointmentUuid}`
                .replace(`{${"appointmentUuid"}}`, encodeURIComponent(String(appointmentUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all patient screener answers by patient by screener type and appointment
         * @summary Get all patient screener answers preview
         * @param {string} appointmentUuid 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatientScreeners: async (appointmentUuid: string, page?: number, size?: number, sortBy?: string, sortDirection?: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'appointmentUuid' is not null or undefined
            assertParamExists('getPatientScreeners', 'appointmentUuid', appointmentUuid)
            const localVarPath = `/api/master/patient-screener/screener-type/appointment/{appointmentUuid}`
                .replace(`{${"appointmentUuid"}}`, encodeURIComponent(String(appointmentUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all patient screener answers by patient by screener type and appointment
         * @summary Get all patient screener answers
         * @param {string} type 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {string} [patientId] 
         * @param {string} [appointmentId] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatientScreenersByType: async (type: string, page?: number, size?: number, sortBy?: string, sortDirection?: string, patientId?: string, appointmentId?: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'type' is not null or undefined
            assertParamExists('getPatientScreenersByType', 'type', type)
            const localVarPath = `/api/master/patient-screener/screener-type/{type}`
                .replace(`{${"type"}}`, encodeURIComponent(String(type)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }

            if (patientId !== undefined) {
                localVarQueryParameter['patientId'] = patientId;
            }

            if (appointmentId !== undefined) {
                localVarQueryParameter['appointmentId'] = appointmentId;
            }

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} appointmentUuid 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatientScreenersScoreByAppointment: async (appointmentUuid: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'appointmentUuid' is not null or undefined
            assertParamExists('getPatientScreenersScoreByAppointment', 'appointmentUuid', appointmentUuid)
            const localVarPath = `/api/master/patient-screener/score/{appointmentUuid}`
                .replace(`{${"appointmentUuid"}}`, encodeURIComponent(String(appointmentUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} appointmentUuid 
         * @param {GetPatientScreenersScoreByAppointmentAndTypeScreenersTypeEnum} screenersType 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatientScreenersScoreByAppointmentAndType: async (appointmentUuid: string, screenersType: GetPatientScreenersScoreByAppointmentAndTypeScreenersTypeEnum, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'appointmentUuid' is not null or undefined
            assertParamExists('getPatientScreenersScoreByAppointmentAndType', 'appointmentUuid', appointmentUuid)
            // verify required parameter 'screenersType' is not null or undefined
            assertParamExists('getPatientScreenersScoreByAppointmentAndType', 'screenersType', screenersType)
            const localVarPath = `/api/master/patient-screener/score/{appointmentUuid}/{screenersType}`
                .replace(`{${"appointmentUuid"}}`, encodeURIComponent(String(appointmentUuid)))
                .replace(`{${"screenersType"}}`, encodeURIComponent(String(screenersType)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all patient screener answers by screener type and appointment with question answer details
         * @summary Get all patient screener answers with assessment
         * @param {string} appointmentUuid 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {string} [screenerType] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatientScreenersWithAssessment: async (appointmentUuid: string, page?: number, size?: number, sortBy?: string, sortDirection?: string, screenerType?: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'appointmentUuid' is not null or undefined
            assertParamExists('getPatientScreenersWithAssessment', 'appointmentUuid', appointmentUuid)
            const localVarPath = `/api/master/patient-screener/screener-type/appointment-answer/{appointmentUuid}`
                .replace(`{${"appointmentUuid"}}`, encodeURIComponent(String(appointmentUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }

            if (screenerType !== undefined) {
                localVarQueryParameter['screenerType'] = screenerType;
            }

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all patient screener answers for specific appointment and screener type
         * @summary Get screener answers for appointment and type
         * @param {string} type 
         * @param {string} appointmentUuid 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getScreenersByTypeAndAppointment: async (type: string, appointmentUuid: string, page?: number, size?: number, sortBy?: string, sortDirection?: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'type' is not null or undefined
            assertParamExists('getScreenersByTypeAndAppointment', 'type', type)
            // verify required parameter 'appointmentUuid' is not null or undefined
            assertParamExists('getScreenersByTypeAndAppointment', 'appointmentUuid', appointmentUuid)
            const localVarPath = `/api/master/patient-screener/screener-type/{type}/appointment/{appointmentUuid}`
                .replace(`{${"type"}}`, encodeURIComponent(String(type)))
                .replace(`{${"appointmentUuid"}}`, encodeURIComponent(String(appointmentUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update patient screener question answer
         * @summary update answer
         * @param {string} patientUuid 
         * @param {PatientScreener} patientScreener 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePatientScreenerAnswer: async (patientUuid: string, patientScreener: PatientScreener, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientUuid' is not null or undefined
            assertParamExists('updatePatientScreenerAnswer', 'patientUuid', patientUuid)
            // verify required parameter 'patientScreener' is not null or undefined
            assertParamExists('updatePatientScreenerAnswer', 'patientScreener', patientScreener)
            const localVarPath = `/api/master/patient-screener/{patientUuid}`
                .replace(`{${"patientUuid"}}`, encodeURIComponent(String(patientUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patientScreener, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PatientScreenerAnswerControllerApi - functional programming interface
 * @export
 */
export const PatientScreenerAnswerControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PatientScreenerAnswerControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * Add patient screener question answer
         * @summary Add answer
         * @param {string} patientUuid 
         * @param {PatientScreener} patientScreener 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addPatientScreener(patientUuid: string, patientScreener: PatientScreener, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addPatientScreener(patientUuid, patientScreener, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientScreenerAnswerControllerApi.addPatientScreener']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} appointmentUuid 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllScreenersAnswerForAppointment(appointmentUuid: string, page?: number, size?: number, sortBy?: string, sortDirection?: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllScreenersAnswerForAppointment(appointmentUuid, page, size, sortBy, sortDirection, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientScreenerAnswerControllerApi.getAllScreenersAnswerForAppointment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves all patient forms, intake forms, and assessments sent to the patient for a specific appointment
         * @summary Get all forms and assessments for appointment
         * @param {string} appointmentUuid 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFormsAndAssessmentsByAppointment(appointmentUuid: string, page?: number, size?: number, sortBy?: string, sortDirection?: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFormsAndAssessmentsByAppointment(appointmentUuid, page, size, sortBy, sortDirection, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientScreenerAnswerControllerApi.getFormsAndAssessmentsByAppointment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get all patient screener answers by patient by screener type and appointment
         * @summary Get all patient screener answers preview
         * @param {string} appointmentUuid 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPatientScreeners(appointmentUuid: string, page?: number, size?: number, sortBy?: string, sortDirection?: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPatientScreeners(appointmentUuid, page, size, sortBy, sortDirection, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientScreenerAnswerControllerApi.getPatientScreeners']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get all patient screener answers by patient by screener type and appointment
         * @summary Get all patient screener answers
         * @param {string} type 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {string} [patientId] 
         * @param {string} [appointmentId] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPatientScreenersByType(type: string, page?: number, size?: number, sortBy?: string, sortDirection?: string, patientId?: string, appointmentId?: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPatientScreenersByType(type, page, size, sortBy, sortDirection, patientId, appointmentId, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientScreenerAnswerControllerApi.getPatientScreenersByType']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} appointmentUuid 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPatientScreenersScoreByAppointment(appointmentUuid: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPatientScreenersScoreByAppointment(appointmentUuid, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientScreenerAnswerControllerApi.getPatientScreenersScoreByAppointment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} appointmentUuid 
         * @param {GetPatientScreenersScoreByAppointmentAndTypeScreenersTypeEnum} screenersType 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPatientScreenersScoreByAppointmentAndType(appointmentUuid: string, screenersType: GetPatientScreenersScoreByAppointmentAndTypeScreenersTypeEnum, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPatientScreenersScoreByAppointmentAndType(appointmentUuid, screenersType, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientScreenerAnswerControllerApi.getPatientScreenersScoreByAppointmentAndType']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get all patient screener answers by screener type and appointment with question answer details
         * @summary Get all patient screener answers with assessment
         * @param {string} appointmentUuid 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {string} [screenerType] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPatientScreenersWithAssessment(appointmentUuid: string, page?: number, size?: number, sortBy?: string, sortDirection?: string, screenerType?: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPatientScreenersWithAssessment(appointmentUuid, page, size, sortBy, sortDirection, screenerType, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientScreenerAnswerControllerApi.getPatientScreenersWithAssessment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get all patient screener answers for specific appointment and screener type
         * @summary Get screener answers for appointment and type
         * @param {string} type 
         * @param {string} appointmentUuid 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getScreenersByTypeAndAppointment(type: string, appointmentUuid: string, page?: number, size?: number, sortBy?: string, sortDirection?: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getScreenersByTypeAndAppointment(type, appointmentUuid, page, size, sortBy, sortDirection, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientScreenerAnswerControllerApi.getScreenersByTypeAndAppointment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update patient screener question answer
         * @summary update answer
         * @param {string} patientUuid 
         * @param {PatientScreener} patientScreener 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePatientScreenerAnswer(patientUuid: string, patientScreener: PatientScreener, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePatientScreenerAnswer(patientUuid, patientScreener, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientScreenerAnswerControllerApi.updatePatientScreenerAnswer']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PatientScreenerAnswerControllerApi - factory interface
 * @export
 */
export const PatientScreenerAnswerControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PatientScreenerAnswerControllerApiFp(configuration)
    return {
        /**
         * Add patient screener question answer
         * @summary Add answer
         * @param {string} patientUuid 
         * @param {PatientScreener} patientScreener 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addPatientScreener(patientUuid: string, patientScreener: PatientScreener, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.addPatientScreener(patientUuid, patientScreener, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} appointmentUuid 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllScreenersAnswerForAppointment(appointmentUuid: string, page?: number, size?: number, sortBy?: string, sortDirection?: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getAllScreenersAnswerForAppointment(appointmentUuid, page, size, sortBy, sortDirection, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves all patient forms, intake forms, and assessments sent to the patient for a specific appointment
         * @summary Get all forms and assessments for appointment
         * @param {string} appointmentUuid 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFormsAndAssessmentsByAppointment(appointmentUuid: string, page?: number, size?: number, sortBy?: string, sortDirection?: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getFormsAndAssessmentsByAppointment(appointmentUuid, page, size, sortBy, sortDirection, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all patient screener answers by patient by screener type and appointment
         * @summary Get all patient screener answers preview
         * @param {string} appointmentUuid 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatientScreeners(appointmentUuid: string, page?: number, size?: number, sortBy?: string, sortDirection?: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getPatientScreeners(appointmentUuid, page, size, sortBy, sortDirection, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all patient screener answers by patient by screener type and appointment
         * @summary Get all patient screener answers
         * @param {string} type 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {string} [patientId] 
         * @param {string} [appointmentId] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatientScreenersByType(type: string, page?: number, size?: number, sortBy?: string, sortDirection?: string, patientId?: string, appointmentId?: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getPatientScreenersByType(type, page, size, sortBy, sortDirection, patientId, appointmentId, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} appointmentUuid 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatientScreenersScoreByAppointment(appointmentUuid: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getPatientScreenersScoreByAppointment(appointmentUuid, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} appointmentUuid 
         * @param {GetPatientScreenersScoreByAppointmentAndTypeScreenersTypeEnum} screenersType 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatientScreenersScoreByAppointmentAndType(appointmentUuid: string, screenersType: GetPatientScreenersScoreByAppointmentAndTypeScreenersTypeEnum, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getPatientScreenersScoreByAppointmentAndType(appointmentUuid, screenersType, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all patient screener answers by screener type and appointment with question answer details
         * @summary Get all patient screener answers with assessment
         * @param {string} appointmentUuid 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {string} [screenerType] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatientScreenersWithAssessment(appointmentUuid: string, page?: number, size?: number, sortBy?: string, sortDirection?: string, screenerType?: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getPatientScreenersWithAssessment(appointmentUuid, page, size, sortBy, sortDirection, screenerType, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all patient screener answers for specific appointment and screener type
         * @summary Get screener answers for appointment and type
         * @param {string} type 
         * @param {string} appointmentUuid 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getScreenersByTypeAndAppointment(type: string, appointmentUuid: string, page?: number, size?: number, sortBy?: string, sortDirection?: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getScreenersByTypeAndAppointment(type, appointmentUuid, page, size, sortBy, sortDirection, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Update patient screener question answer
         * @summary update answer
         * @param {string} patientUuid 
         * @param {PatientScreener} patientScreener 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePatientScreenerAnswer(patientUuid: string, patientScreener: PatientScreener, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.updatePatientScreenerAnswer(patientUuid, patientScreener, xTENANTID, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PatientScreenerAnswerControllerApi - object-oriented interface
 * @export
 * @class PatientScreenerAnswerControllerApi
 * @extends {BaseAPI}
 */
export class PatientScreenerAnswerControllerApi extends BaseAPI {
    /**
     * Add patient screener question answer
     * @summary Add answer
     * @param {string} patientUuid 
     * @param {PatientScreener} patientScreener 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientScreenerAnswerControllerApi
     */
    public addPatientScreener(patientUuid: string, patientScreener: PatientScreener, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return PatientScreenerAnswerControllerApiFp(this.configuration).addPatientScreener(patientUuid, patientScreener, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} appointmentUuid 
     * @param {number} [page] 
     * @param {number} [size] 
     * @param {string} [sortBy] 
     * @param {string} [sortDirection] 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientScreenerAnswerControllerApi
     */
    public getAllScreenersAnswerForAppointment(appointmentUuid: string, page?: number, size?: number, sortBy?: string, sortDirection?: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return PatientScreenerAnswerControllerApiFp(this.configuration).getAllScreenersAnswerForAppointment(appointmentUuid, page, size, sortBy, sortDirection, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves all patient forms, intake forms, and assessments sent to the patient for a specific appointment
     * @summary Get all forms and assessments for appointment
     * @param {string} appointmentUuid 
     * @param {number} [page] 
     * @param {number} [size] 
     * @param {string} [sortBy] 
     * @param {string} [sortDirection] 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientScreenerAnswerControllerApi
     */
    public getFormsAndAssessmentsByAppointment(appointmentUuid: string, page?: number, size?: number, sortBy?: string, sortDirection?: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return PatientScreenerAnswerControllerApiFp(this.configuration).getFormsAndAssessmentsByAppointment(appointmentUuid, page, size, sortBy, sortDirection, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all patient screener answers by patient by screener type and appointment
     * @summary Get all patient screener answers preview
     * @param {string} appointmentUuid 
     * @param {number} [page] 
     * @param {number} [size] 
     * @param {string} [sortBy] 
     * @param {string} [sortDirection] 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientScreenerAnswerControllerApi
     */
    public getPatientScreeners(appointmentUuid: string, page?: number, size?: number, sortBy?: string, sortDirection?: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return PatientScreenerAnswerControllerApiFp(this.configuration).getPatientScreeners(appointmentUuid, page, size, sortBy, sortDirection, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all patient screener answers by patient by screener type and appointment
     * @summary Get all patient screener answers
     * @param {string} type 
     * @param {number} [page] 
     * @param {number} [size] 
     * @param {string} [sortBy] 
     * @param {string} [sortDirection] 
     * @param {string} [patientId] 
     * @param {string} [appointmentId] 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientScreenerAnswerControllerApi
     */
    public getPatientScreenersByType(type: string, page?: number, size?: number, sortBy?: string, sortDirection?: string, patientId?: string, appointmentId?: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return PatientScreenerAnswerControllerApiFp(this.configuration).getPatientScreenersByType(type, page, size, sortBy, sortDirection, patientId, appointmentId, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} appointmentUuid 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientScreenerAnswerControllerApi
     */
    public getPatientScreenersScoreByAppointment(appointmentUuid: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return PatientScreenerAnswerControllerApiFp(this.configuration).getPatientScreenersScoreByAppointment(appointmentUuid, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} appointmentUuid 
     * @param {GetPatientScreenersScoreByAppointmentAndTypeScreenersTypeEnum} screenersType 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientScreenerAnswerControllerApi
     */
    public getPatientScreenersScoreByAppointmentAndType(appointmentUuid: string, screenersType: GetPatientScreenersScoreByAppointmentAndTypeScreenersTypeEnum, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return PatientScreenerAnswerControllerApiFp(this.configuration).getPatientScreenersScoreByAppointmentAndType(appointmentUuid, screenersType, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all patient screener answers by screener type and appointment with question answer details
     * @summary Get all patient screener answers with assessment
     * @param {string} appointmentUuid 
     * @param {number} [page] 
     * @param {number} [size] 
     * @param {string} [sortBy] 
     * @param {string} [sortDirection] 
     * @param {string} [screenerType] 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientScreenerAnswerControllerApi
     */
    public getPatientScreenersWithAssessment(appointmentUuid: string, page?: number, size?: number, sortBy?: string, sortDirection?: string, screenerType?: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return PatientScreenerAnswerControllerApiFp(this.configuration).getPatientScreenersWithAssessment(appointmentUuid, page, size, sortBy, sortDirection, screenerType, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all patient screener answers for specific appointment and screener type
     * @summary Get screener answers for appointment and type
     * @param {string} type 
     * @param {string} appointmentUuid 
     * @param {number} [page] 
     * @param {number} [size] 
     * @param {string} [sortBy] 
     * @param {string} [sortDirection] 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientScreenerAnswerControllerApi
     */
    public getScreenersByTypeAndAppointment(type: string, appointmentUuid: string, page?: number, size?: number, sortBy?: string, sortDirection?: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return PatientScreenerAnswerControllerApiFp(this.configuration).getScreenersByTypeAndAppointment(type, appointmentUuid, page, size, sortBy, sortDirection, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update patient screener question answer
     * @summary update answer
     * @param {string} patientUuid 
     * @param {PatientScreener} patientScreener 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientScreenerAnswerControllerApi
     */
    public updatePatientScreenerAnswer(patientUuid: string, patientScreener: PatientScreener, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return PatientScreenerAnswerControllerApiFp(this.configuration).updatePatientScreenerAnswer(patientUuid, patientScreener, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const GetPatientScreenersScoreByAppointmentAndTypeScreenersTypeEnum = {
    Aai: 'AAI',
    AaqIi: 'AAQ_II',
    Aas: 'AAS',
    Aces: 'ACES',
    Acsi: 'ACSI',
    ActAdv: 'ACT_ADV',
    AcOk: 'AC_OK',
    AdhdSs: 'ADHD_SS',
    AdlFa: 'ADL_FA',
    Adnm8: 'ADNM_8',
    Adnm8Stressors: 'ADNM_8_STRESSORS',
    AhcHealthRelatedSocialNeedsScreenerAdults: 'AHC_HEALTH_RELATED_SOCIAL_NEEDS_SCREENER_ADULTS',
    Ahs: 'AHS',
    Alss: 'ALSS',
    Amps: 'AMPS',
    Ansa: 'ANSA',
    Apq: 'APQ',
    Aq: 'AQ',
    Ari: 'ARI',
    Arm5New: 'ARM_5_NEW',
    Arm5T: 'ARM_5_T',
    AsbiP: 'ASBI_P',
    Aseq: 'ASEQ',
    Asq: 'ASQ',
    AsqAr: 'ASQ_AR',
    Asrm: 'ASRM',
    Asrs11: 'ASRS_1_1',
    AsrsV11PartA: 'ASRS_V1_1_PART_A',
    Assist: 'ASSIST',
    Audit: 'AUDIT',
    AuditC: 'AUDIT_C',
    Aware30: 'AWARE_3_0',
    Aws: 'AWS',
    Ayr: 'AYR',
    ADes: 'A_DES',
    BamNew: 'BAM_NEW',
    Barc10: 'BARC_10',
    BatNew: 'BAT_NEW',
    Bbq: 'BBQ',
    Bdrs: 'BDRS',
    Bdss: 'BDSS',
    Bes: 'BES',
    Best: 'BEST',
    BfneIi: 'BFNE_II',
    BmsEvaluationOfSession: 'BMS_EVALUATION_OF_SESSION',
    Bpds: 'BPDS',
    Bql: 'BQL',
    Brcs: 'BRCS',
    BrcsSpanish: 'BRCS_SPANISH',
    BriefmoodAfter: 'BRIEFMOOD_AFTER',
    BriefmoodBefore: 'BRIEFMOOD_BEFORE',
    Bsl23: 'BSL_23',
    Bsl23Full: 'BSL_23_FULL',
    Bsps: 'BSPS',
    Bsps4: 'BSPS_4',
    Bts: 'BTS',
    BvsNew: 'BVS_NEW',
    Cage: 'CAGE',
    CalpasPatientSf: 'CALPAS_PATIENT_SF',
    CansEi: 'CANS_EI',
    Care: 'CARE',
    CareF: 'CARE_F',
    Cast: 'CAST',
    CatsChildSpanish: 'CATS_CHILD_SPANISH',
    CatsParent: 'CATS_PARENT',
    CatsParent36: 'CATS_PARENT_3_6',
    CatsParent36Spanish: 'CATS_PARENT_3_6_SPANISH',
    CatsParent717Spanish: 'CATS_PARENT_7_17_SPANISH',
    CatsProgressYouth: 'CATS_PROGRESS_YOUTH',
    CatsSelfReport717: 'CATS_SELF_REPORT_7_17',
    CatsYouth: 'CATS_YOUTH',
    Cdc: 'CDC',
    CesD: 'CES_D',
    CesDc: 'CES_DC',
    Cfars: 'CFARS',
    Cfq: 'CFQ',
    Cga: 'CGA',
    ChildBehaviorRatingScaleCbrs: 'CHILD_BEHAVIOR_RATING_SCALE_CBRS',
    Chs: 'CHS',
    Cias: 'CIAS',
    Cia30: 'CIA_3_0',
    Ciraa: 'CIRAA',
    Compact: 'COMPACT',
    CompactMod: 'COMPACT_MOD',
    Covid19Screener: 'COVID_19_SCREENER',
    CpaqR: 'CPAQ_R',
    Cppss: 'CPPSS',
    CpssVNew: 'CPSS_V_NEW',
    Cries13: 'CRIES_13',
    Cries131: 'CRIES_13_1',
    Cries132: 'CRIES_13_2',
    Cs: 'CS',
    Csaq: 'CSAQ',
    CsasSpanish: 'CSAS_SPANISH',
    Csi: 'CSI',
    Csi16: 'CSI_16',
    Csi4: 'CSI_4',
    CFoci: 'C_FOCI',
    CSsrs: 'C_SSRS',
    CSsrsB: 'C_SSRS_B',
    CSsrsNew: 'C_SSRS_NEW',
    CSsrsSl: 'C_SSRS_SL',
    Das: 'DAS',
    Dass: 'DASS',
    Dass10: 'DASS_10',
    Dass21: 'DASS_21',
    DassY: 'DASS_Y',
    Dbas16Neww: 'DBAS_16_NEWW',
    DbtWccl: 'DBT_WCCL',
    Ders: 'DERS',
    Ders18: 'DERS_18',
    Des: 'DES',
    DesBNew: 'DES_B_NEW',
    Dgsr: 'DGSR',
    Dla20SelfReport: 'DLA_20_SELF_REPORT',
    DpdQ: 'DPD_Q',
    DpssClinicianRated: 'DPSS_CLINICIAN_RATED',
    Drs: 'DRS',
    DrsCa: 'DRS_CA',
    Dsm5Ccsm: 'DSM5_CCSM',
    Dsm5SuChild: 'DSM5_SU_CHILD',
    Dsm5Agoraphobia: 'DSM_5_AGORAPHOBIA',
    Dsm5AnxC: 'DSM_5_ANX_C',
    Dsm5GadC: 'DSM_5_GAD_C',
    Dsm5IiAngP: 'DSM_5_II_ANG_P',
    Dsm5IiAnxP: 'DSM_5_II_ANX_P',
    Dsm5IiAnxPGn: 'DSM_5_II_ANX_P_GN',
    Dsm5IiDepP: 'DSM_5_II_DEP_P',
    Dsm5IiIrrP: 'DSM_5_II_IRR_P',
    Dsm5IiSomPNew: 'DSM_5_II_SOM_P_NEW',
    Dsm5IiSubUse: 'DSM_5_II_SUB_USE',
    Dsm5Level1Child: 'DSM_5_LEVEL_1_CHILD',
    Dsm5Level1Parent: 'DSM_5_LEVEL_1_PARENT',
    Dsm5SadChild: 'DSM_5_SAD_CHILD',
    Dsm5SadNew: 'DSM_5_SAD_NEW',
    Dsm5SmasC: 'DSM_5_SMAS_C',
    Dsm5SmdC: 'DSM_5_SMD_C',
    Dsm5SmptsdC: 'DSM_5_SMPTSD_C',
    Dsrs: 'DSRS',
    Dss: 'DSS',
    DssB: 'DSS_B',
    Dts: 'DTS',
    Eat26PartB: 'EAT_26_PART_B',
    EcrR: 'ECR_R',
    EdeQs: 'EDE_QS',
    EdeQ60Modified: 'EDE_Q_6_0_MODIFIED',
    Edqol: 'EDQOL',
    Epds: 'EPDS',
    Eq: 'EQ',
    Erq: 'ERQ',
    EssNew: 'ESS_NEW',
    Expass: 'EXPASS',
    FaasNew: 'FAAS_NEW',
    Fad: 'FAD',
    Fasa: 'FASA',
    FasN: 'FAS_N',
    FasP: 'FAS_P',
    FasS: 'FAS_S',
    Fbs: 'FBS',
    FbsN: 'FBS_N',
    FbsP: 'FBS_P',
    Ffmq: 'FFMQ',
    FibserScaleNew: 'FIBSER_SCALE_NEW',
    Flbs: 'FLBS',
    Fm5: 'FM5',
    FreiburgMindfulnessInventoryFmi: 'FREIBURG_MINDFULNESS_INVENTORY_FMI',
    Fsas: 'FSAS',
    Fsfi: 'FSFI',
    Fwbs: 'FWBS',
    Gad7: 'GAD7',
    Gad2: 'GAD_2',
    Gad7Spanish: 'GAD_7_SPANISH',
    Gad7Impairment: 'GAD_7___IMPAIRMENT',
    GasNew: 'GAS_NEW',
    GclsPsy: 'GCLS_PSY',
    Giq: 'GIQ',
    Gis: 'GIS',
    GqiNew: 'GQI_NEW',
    Gs: 'GS',
    Gse: 'GSE',
    Hai: 'HAI',
    HamA: 'HAM_A',
    Icg: 'ICG',
    IcuaFi: 'ICUA_FI',
    IcuaFiC: 'ICUA_FI_C',
    IcuaFiF: 'ICUA_FI_F',
    IcuaFiI: 'ICUA_FI_I',
    Ies1: 'IES_1',
    Ies2: 'IES_2',
    Ies3: 'IES_3',
    IesR: 'IES_R',
    Iief: 'IIEF',
    Is: 'IS',
    Isel12: 'ISEL_12',
    Isi: 'ISI',
    Itq: 'ITQ',
    ItrCs: 'ITR_CS',
    Kims: 'KIMS',
    Lasa: 'LASA',
    LdqNew: 'LDQ_NEW',
    Lec5: 'LEC_5',
    Locus: 'LOCUS',
    Lovemap: 'LOVEMAP',
    LscR: 'LSC_R',
    MadrsS: 'MADRS_S',
    Maia2: 'MAIA_2',
    Mast: 'MAST',
    Maysi: 'MAYSI',
    Mcsi: 'MCSI',
    Mdq: 'MDQ',
    MeasuringAdverseEvents: 'MEASURING_ADVERSE_EVENTS',
    Mfpi: 'MFPI',
    MfpiS: 'MFPI_S',
    MfqParentLong: 'MFQ_PARENT_LONG',
    MfqParentShort: 'MFQ_PARENT_SHORT',
    MghHairPulling: 'MGH_HAIR_PULLING',
    Mgma: 'MGMA',
    MhcSf: 'MHC_SF',
    MhlcC: 'MHLC_C',
    MindfuliWaiSr: 'MINDFULI_WAI_SR',
    MoasNew: 'MOAS_NEW',
    MqgChildLong: 'MQG_CHILD_LONG',
    Mshq: 'MSHQ',
    MshqEjd: 'MSHQ_EJD',
    Msi: 'MSI',
    MsiBpd: 'MSI_BPD',
    NihHeals: 'NIH_HEALS',
    NmrqA: 'NMRQ_A',
    Npi13: 'NPI_13',
    Npi16: 'NPI_16',
    Nq: 'NQ',
    Nssi: 'NSSI',
    Oa: 'OA',
    Oasis: 'OASIS',
    ObesityScreening: 'OBESITY_SCREENING',
    TobaccoScreening: 'TOBACCO_SCREENING',
    DiabetesAssessment: 'DIABETES_ASSESSMENT',
    AnnualWellness: 'ANNUAL_WELLNESS',
    Obq44: 'OBQ_44',
    Oci: 'OCI',
    Oci12: 'OCI_12',
    Oci4: 'OCI_4',
    OciCvR: 'OCI_CV_R',
    OciR: 'OCI_R',
    OcTrs: 'OC_TRS',
    Odsis: 'ODSIS',
    OhqNew: 'OHQ_NEW',
    Olbi: 'OLBI',
    PanasSf: 'PANAS_SF',
    PanasX: 'PANAS_X',
    Paqr: 'PAQR',
    Pass: 'PASS',
    PasP: 'PAS_P',
    Pcl5: 'PCL_5',
    Pcl5Lec: 'PCL_5_LEC',
    Pcl5Spanish: 'PCL_5_SPANISH',
    PcPtsd5: 'PC_PTSD_5',
    Phq9: 'PHQ9',
    Phq15Child: 'PHQ_15_CHILD',
    Phq2: 'PHQ_2',
    Phq4: 'PHQ_4',
    Phq8: 'PHQ_8',
    Phq9Spanish: 'PHQ_9_SPANISH',
    Phq9Impairment: 'PHQ_9___IMPAIRMENT',
    PhqA: 'PHQ_A',
    Pnrs: 'PNRS',
    Pnss: 'PNSS',
    Pops: 'POPS',
    PpcsS: 'PPCS_S',
    PqB: 'PQ_B',
    PqLesQ: 'PQ_LES_Q',
    Prea: 'PREA',
    PromisAng: 'PROMIS_ANG',
    PromisAngChild: 'PROMIS_ANG_CHILD',
    PromisDepressiveSymptomsParentReport: 'PROMIS_DEPRESSIVE_SYMPTOMS_PARENT_REPORT',
    PromisPediatricAnxietySf: 'PROMIS_PEDIATRIC_ANXIETY_SF',
    PromisSle: 'PROMIS_SLE',
    PromisSleepChild: 'PROMIS_SLEEP_CHILD',
    PromisSom: 'PROMIS_SOM',
    Proqol: 'PROQOL',
    PsccPS: 'PSCC_P_S',
    Psc17: 'PSC_17',
    Psc17ParentNew: 'PSC_17_PARENT_NEW',
    Psc17Spanish: 'PSC_17_SPANISH',
    Psc35: 'PSC_35',
    PscPA: 'PSC_P_A',
    PscYA: 'PSC_Y_A',
    Psi: 'PSI',
    Pss: 'PSS',
    Pstq: 'PSTQ',
    PstqA: 'PSTQ_A',
    Pswq: 'PSWQ',
    PswqC: 'PSWQ_C',
    PtgiNew: 'PTGI_NEW',
    Ptsst: 'PTSST',
    PtsstP: 'PTSST_P',
    PwiA: 'PWI_A',
    PwiSc: 'PWI_SC',
    PAces: 'P_ACES',
    QewpR: 'QEWP_R',
    QLesQ: 'Q_LES_Q',
    QLesQS: 'Q_LES_Q_S',
    QLesQSf: 'Q_LES_Q_SF',
    Raads14: 'RAADS_14',
    Ras: 'RAS',
    Rcads: 'RCADS',
    RcadsP: 'RCADS_P',
    Rfls: 'RFLS',
    Riasec: 'RIASEC',
    Rses: 'RSES',
    Saam: 'SAAM',
    SaiPatient: 'SAI_PATIENT',
    Sapas: 'SAPAS',
    Sast: 'SAST',
    SatisfactionWithCare: 'SATISFACTION_WITH_CARE',
    Sbc: 'SBC',
    ScaredChild: 'SCARED_CHILD',
    ScaredChildSpanish: 'SCARED_CHILD_SPANISH',
    ScaredParent: 'SCARED_PARENT',
    ScaredParentSpanish: 'SCARED_PARENT_SPANISH',
    ScasChildSpanish: 'SCAS_CHILD_SPANISH',
    ScasParentSpanish: 'SCAS_PARENT_SPANISH',
    ScasPreschoolSpanish: 'SCAS_PRESCHOOL_SPANISH',
    Scd: 'SCD',
    Scoff: 'SCOFF',
    Score15: 'SCORE_15',
    Score15Kids: 'SCORE_15_KIDS',
    ScsSfNew: 'SCS_SF_NEW',
    ScsY: 'SCS_Y',
    Sdoh: 'SDOH',
    Sdq: 'SDQ',
    SdsCl25New: 'SDS_CL_25_NEW',
    SfCds: 'SF_CDS',
    Sias: 'SIAS',
    Sir: 'SIR',
    Smfq: 'SMFQ',
    Smhat1: 'SMHAT_1',
    Smhat2: 'SMHAT_2',
    Smhat3: 'SMHAT_3',
    Smpd: 'SMPD',
    Smsp: 'SMSP',
    Sogs: 'SOGS',
    Sps: 'SPS',
    SpsNew: 'SPS_NEW',
    Srs2: 'SRS_2',
    SscsL: 'SSCS_L',
    SscsSNew: 'SSCS_S_NEW',
    Ssps: 'SSPS',
    Sss8: 'SSS_8',
    Stai: 'STAI',
    SticChildRel: 'STIC_CHILD_REL',
    SticCouples: 'STIC_COUPLES',
    SticFamily: 'STIC_FAMILY',
    SticInd: 'STIC_IND',
    Stim: 'STIM',
    SubstanceAbuse: 'SUBSTANCE_ABUSE',
    Taps1: 'TAPS_1',
    Taps2New: 'TAPS_2_NEW',
    Tas: 'TAS',
    TcsNew: 'TCS_NEW',
    TgiSr: 'TGI_SR_',
    ThePainCatastrophizingScale: 'THE_PAIN_CATASTROPHIZING_SCALE',
    Thq: 'THQ',
    Ths: 'THS',
    TlcPtsdCaq: 'TLC_PTSD_CAQ',
    Trs: 'TRS',
    TrsCa: 'TRS_CA',
    Ucla3New: 'UCLA_3_NEW',
    Uus: 'UUS',
    VasParent: 'VAS_PARENT',
    VasParentFollowUp: 'VAS_PARENT_FOLLOW_UP',
    VasParentFollowUpSpanish: 'VAS_PARENT_FOLLOW_UP_SPANISH',
    VasTeacher: 'VAS_TEACHER',
    VqNew: 'VQ_NEW',
    Wai: 'WAI',
    WaiBest: 'WAI_BEST',
    WaA: 'WA_A',
    WaY: 'WA_Y',
    WeeklyParticipationSurvey: 'WEEKLY_PARTICIPATION_SURVEY',
    Wemwbs: 'WEMWBS',
    Whodas20New: 'WHODAS_2_0_NEW',
    Who5: 'WHO_5',
    Whympi: 'WHYMPI',
    Wss: 'WSS',
    Wurs25: 'WURS_25',
    YalePrime: 'YALE_PRIME',
    Ycpc: 'YCPC',
    Yfas: 'YFAS',
    Yfas20: 'YFAS_2_0'
} as const;
export type GetPatientScreenersScoreByAppointmentAndTypeScreenersTypeEnum = typeof GetPatientScreenersScoreByAppointmentAndTypeScreenersTypeEnum[keyof typeof GetPatientScreenersScoreByAppointmentAndTypeScreenersTypeEnum];


/**
 * PatientSocialHistoryControllerApi - axios parameter creator
 * @export
 */
export const PatientSocialHistoryControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Add a new patient social history into the system
         * @summary Add patient social history
         * @param {PatientQuestionAnswerRequest} patientQuestionAnswerRequest 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPatientSocialHistory: async (patientQuestionAnswerRequest: PatientQuestionAnswerRequest, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientQuestionAnswerRequest' is not null or undefined
            assertParamExists('createPatientSocialHistory', 'patientQuestionAnswerRequest', patientQuestionAnswerRequest)
            const localVarPath = `/api/master/patient-social-history`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patientQuestionAnswerRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Archive a Patient Social History by its ID
         * @summary Archive Patient Social History
         * @param {string} patientSocialHistoryId 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePatientSocialHistoryId: async (patientSocialHistoryId: string, status: boolean, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientSocialHistoryId' is not null or undefined
            assertParamExists('deletePatientSocialHistoryId', 'patientSocialHistoryId', patientSocialHistoryId)
            // verify required parameter 'status' is not null or undefined
            assertParamExists('deletePatientSocialHistoryId', 'status', status)
            const localVarPath = `/api/master/patient-social-history/{patientSocialHistoryId}/archive-status/{status}`
                .replace(`{${"patientSocialHistoryId"}}`, encodeURIComponent(String(patientSocialHistoryId)))
                .replace(`{${"status"}}`, encodeURIComponent(String(status)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all Patient Social History list
         * @summary Get all Patient\'s Social History.
         * @param {GetPatientSocialHistorySocialHistoryTypeEnum} socialHistoryType 
         * @param {string} [patientUuid] 
         * @param {boolean} [status] 
         * @param {boolean} [archive] 
         * @param {string} [appointmentId] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatientSocialHistory: async (socialHistoryType: GetPatientSocialHistorySocialHistoryTypeEnum, patientUuid?: string, status?: boolean, archive?: boolean, appointmentId?: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'socialHistoryType' is not null or undefined
            assertParamExists('getPatientSocialHistory', 'socialHistoryType', socialHistoryType)
            const localVarPath = `/api/master/patient-social-history`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (patientUuid !== undefined) {
                localVarQueryParameter['patientUuid'] = patientUuid;
            }

            if (socialHistoryType !== undefined) {
                localVarQueryParameter['socialHistoryType'] = socialHistoryType;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (archive !== undefined) {
                localVarQueryParameter['archive'] = archive;
            }

            if (appointmentId !== undefined) {
                localVarQueryParameter['appointmentId'] = appointmentId;
            }

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve a Patient Social History by its unique ID
         * @summary Get Patient Social History by ID
         * @param {string} patientSocialHistoryId 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatientSocialHistoryById: async (patientSocialHistoryId: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientSocialHistoryId' is not null or undefined
            assertParamExists('getPatientSocialHistoryById', 'patientSocialHistoryId', patientSocialHistoryId)
            const localVarPath = `/api/master/patient-social-history/{patientSocialHistoryId}`
                .replace(`{${"patientSocialHistoryId"}}`, encodeURIComponent(String(patientSocialHistoryId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all Patient Social History Status list
         * @summary Get all Patient\'s Social History Status.
         * @param {string} patientUuid 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatientSocialHistoryStatus: async (patientUuid: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientUuid' is not null or undefined
            assertParamExists('getPatientSocialHistoryStatus', 'patientUuid', patientUuid)
            const localVarPath = `/api/master/patient-social-history/status`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (patientUuid !== undefined) {
                localVarQueryParameter['patientUuid'] = patientUuid;
            }

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get list of Social History Types for a specific appointment
         * @summary Get Social History Types by Appointment ID
         * @param {string} appointmentId 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSocialHistoryTypesByAppointmentId: async (appointmentId: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'appointmentId' is not null or undefined
            assertParamExists('getSocialHistoryTypesByAppointmentId', 'appointmentId', appointmentId)
            const localVarPath = `/api/master/patient-social-history/types`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (appointmentId !== undefined) {
                localVarQueryParameter['appointmentId'] = appointmentId;
            }

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update an existing Patient Social History
         * @summary Update Patient Social History
         * @param {PatientQuestionAnswerRequest} patientQuestionAnswerRequest 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePatientSocialHistory: async (patientQuestionAnswerRequest: PatientQuestionAnswerRequest, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientQuestionAnswerRequest' is not null or undefined
            assertParamExists('updatePatientSocialHistory', 'patientQuestionAnswerRequest', patientQuestionAnswerRequest)
            const localVarPath = `/api/master/patient-social-history`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patientQuestionAnswerRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Change the  Patient  Social history status.
         * @summary Update Patient Social History Status
         * @param {string} patientSocialHistoryId 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePatientSocialHistoryStatus: async (patientSocialHistoryId: string, status: boolean, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientSocialHistoryId' is not null or undefined
            assertParamExists('updatePatientSocialHistoryStatus', 'patientSocialHistoryId', patientSocialHistoryId)
            // verify required parameter 'status' is not null or undefined
            assertParamExists('updatePatientSocialHistoryStatus', 'status', status)
            const localVarPath = `/api/master/patient-social-history/{patientSocialHistoryId}/status/{status}`
                .replace(`{${"patientSocialHistoryId"}}`, encodeURIComponent(String(patientSocialHistoryId)))
                .replace(`{${"status"}}`, encodeURIComponent(String(status)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PatientSocialHistoryControllerApi - functional programming interface
 * @export
 */
export const PatientSocialHistoryControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PatientSocialHistoryControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * Add a new patient social history into the system
         * @summary Add patient social history
         * @param {PatientQuestionAnswerRequest} patientQuestionAnswerRequest 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createPatientSocialHistory(patientQuestionAnswerRequest: PatientQuestionAnswerRequest, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createPatientSocialHistory(patientQuestionAnswerRequest, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientSocialHistoryControllerApi.createPatientSocialHistory']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Archive a Patient Social History by its ID
         * @summary Archive Patient Social History
         * @param {string} patientSocialHistoryId 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deletePatientSocialHistoryId(patientSocialHistoryId: string, status: boolean, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deletePatientSocialHistoryId(patientSocialHistoryId, status, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientSocialHistoryControllerApi.deletePatientSocialHistoryId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get all Patient Social History list
         * @summary Get all Patient\'s Social History.
         * @param {GetPatientSocialHistorySocialHistoryTypeEnum} socialHistoryType 
         * @param {string} [patientUuid] 
         * @param {boolean} [status] 
         * @param {boolean} [archive] 
         * @param {string} [appointmentId] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPatientSocialHistory(socialHistoryType: GetPatientSocialHistorySocialHistoryTypeEnum, patientUuid?: string, status?: boolean, archive?: boolean, appointmentId?: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPatientSocialHistory(socialHistoryType, patientUuid, status, archive, appointmentId, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientSocialHistoryControllerApi.getPatientSocialHistory']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve a Patient Social History by its unique ID
         * @summary Get Patient Social History by ID
         * @param {string} patientSocialHistoryId 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPatientSocialHistoryById(patientSocialHistoryId: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPatientSocialHistoryById(patientSocialHistoryId, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientSocialHistoryControllerApi.getPatientSocialHistoryById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get all Patient Social History Status list
         * @summary Get all Patient\'s Social History Status.
         * @param {string} patientUuid 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPatientSocialHistoryStatus(patientUuid: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPatientSocialHistoryStatus(patientUuid, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientSocialHistoryControllerApi.getPatientSocialHistoryStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get list of Social History Types for a specific appointment
         * @summary Get Social History Types by Appointment ID
         * @param {string} appointmentId 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSocialHistoryTypesByAppointmentId(appointmentId: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSocialHistoryTypesByAppointmentId(appointmentId, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientSocialHistoryControllerApi.getSocialHistoryTypesByAppointmentId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update an existing Patient Social History
         * @summary Update Patient Social History
         * @param {PatientQuestionAnswerRequest} patientQuestionAnswerRequest 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePatientSocialHistory(patientQuestionAnswerRequest: PatientQuestionAnswerRequest, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePatientSocialHistory(patientQuestionAnswerRequest, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientSocialHistoryControllerApi.updatePatientSocialHistory']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Change the  Patient  Social history status.
         * @summary Update Patient Social History Status
         * @param {string} patientSocialHistoryId 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePatientSocialHistoryStatus(patientSocialHistoryId: string, status: boolean, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePatientSocialHistoryStatus(patientSocialHistoryId, status, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientSocialHistoryControllerApi.updatePatientSocialHistoryStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PatientSocialHistoryControllerApi - factory interface
 * @export
 */
export const PatientSocialHistoryControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PatientSocialHistoryControllerApiFp(configuration)
    return {
        /**
         * Add a new patient social history into the system
         * @summary Add patient social history
         * @param {PatientQuestionAnswerRequest} patientQuestionAnswerRequest 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPatientSocialHistory(patientQuestionAnswerRequest: PatientQuestionAnswerRequest, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.createPatientSocialHistory(patientQuestionAnswerRequest, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Archive a Patient Social History by its ID
         * @summary Archive Patient Social History
         * @param {string} patientSocialHistoryId 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePatientSocialHistoryId(patientSocialHistoryId: string, status: boolean, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.deletePatientSocialHistoryId(patientSocialHistoryId, status, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all Patient Social History list
         * @summary Get all Patient\'s Social History.
         * @param {GetPatientSocialHistorySocialHistoryTypeEnum} socialHistoryType 
         * @param {string} [patientUuid] 
         * @param {boolean} [status] 
         * @param {boolean} [archive] 
         * @param {string} [appointmentId] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatientSocialHistory(socialHistoryType: GetPatientSocialHistorySocialHistoryTypeEnum, patientUuid?: string, status?: boolean, archive?: boolean, appointmentId?: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getPatientSocialHistory(socialHistoryType, patientUuid, status, archive, appointmentId, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve a Patient Social History by its unique ID
         * @summary Get Patient Social History by ID
         * @param {string} patientSocialHistoryId 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatientSocialHistoryById(patientSocialHistoryId: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getPatientSocialHistoryById(patientSocialHistoryId, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all Patient Social History Status list
         * @summary Get all Patient\'s Social History Status.
         * @param {string} patientUuid 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatientSocialHistoryStatus(patientUuid: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getPatientSocialHistoryStatus(patientUuid, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Get list of Social History Types for a specific appointment
         * @summary Get Social History Types by Appointment ID
         * @param {string} appointmentId 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSocialHistoryTypesByAppointmentId(appointmentId: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getSocialHistoryTypesByAppointmentId(appointmentId, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Update an existing Patient Social History
         * @summary Update Patient Social History
         * @param {PatientQuestionAnswerRequest} patientQuestionAnswerRequest 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePatientSocialHistory(patientQuestionAnswerRequest: PatientQuestionAnswerRequest, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.updatePatientSocialHistory(patientQuestionAnswerRequest, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Change the  Patient  Social history status.
         * @summary Update Patient Social History Status
         * @param {string} patientSocialHistoryId 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePatientSocialHistoryStatus(patientSocialHistoryId: string, status: boolean, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.updatePatientSocialHistoryStatus(patientSocialHistoryId, status, xTENANTID, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PatientSocialHistoryControllerApi - object-oriented interface
 * @export
 * @class PatientSocialHistoryControllerApi
 * @extends {BaseAPI}
 */
export class PatientSocialHistoryControllerApi extends BaseAPI {
    /**
     * Add a new patient social history into the system
     * @summary Add patient social history
     * @param {PatientQuestionAnswerRequest} patientQuestionAnswerRequest 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientSocialHistoryControllerApi
     */
    public createPatientSocialHistory(patientQuestionAnswerRequest: PatientQuestionAnswerRequest, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return PatientSocialHistoryControllerApiFp(this.configuration).createPatientSocialHistory(patientQuestionAnswerRequest, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Archive a Patient Social History by its ID
     * @summary Archive Patient Social History
     * @param {string} patientSocialHistoryId 
     * @param {boolean} status 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientSocialHistoryControllerApi
     */
    public deletePatientSocialHistoryId(patientSocialHistoryId: string, status: boolean, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return PatientSocialHistoryControllerApiFp(this.configuration).deletePatientSocialHistoryId(patientSocialHistoryId, status, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all Patient Social History list
     * @summary Get all Patient\'s Social History.
     * @param {GetPatientSocialHistorySocialHistoryTypeEnum} socialHistoryType 
     * @param {string} [patientUuid] 
     * @param {boolean} [status] 
     * @param {boolean} [archive] 
     * @param {string} [appointmentId] 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientSocialHistoryControllerApi
     */
    public getPatientSocialHistory(socialHistoryType: GetPatientSocialHistorySocialHistoryTypeEnum, patientUuid?: string, status?: boolean, archive?: boolean, appointmentId?: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return PatientSocialHistoryControllerApiFp(this.configuration).getPatientSocialHistory(socialHistoryType, patientUuid, status, archive, appointmentId, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve a Patient Social History by its unique ID
     * @summary Get Patient Social History by ID
     * @param {string} patientSocialHistoryId 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientSocialHistoryControllerApi
     */
    public getPatientSocialHistoryById(patientSocialHistoryId: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return PatientSocialHistoryControllerApiFp(this.configuration).getPatientSocialHistoryById(patientSocialHistoryId, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all Patient Social History Status list
     * @summary Get all Patient\'s Social History Status.
     * @param {string} patientUuid 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientSocialHistoryControllerApi
     */
    public getPatientSocialHistoryStatus(patientUuid: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return PatientSocialHistoryControllerApiFp(this.configuration).getPatientSocialHistoryStatus(patientUuid, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get list of Social History Types for a specific appointment
     * @summary Get Social History Types by Appointment ID
     * @param {string} appointmentId 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientSocialHistoryControllerApi
     */
    public getSocialHistoryTypesByAppointmentId(appointmentId: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return PatientSocialHistoryControllerApiFp(this.configuration).getSocialHistoryTypesByAppointmentId(appointmentId, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update an existing Patient Social History
     * @summary Update Patient Social History
     * @param {PatientQuestionAnswerRequest} patientQuestionAnswerRequest 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientSocialHistoryControllerApi
     */
    public updatePatientSocialHistory(patientQuestionAnswerRequest: PatientQuestionAnswerRequest, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return PatientSocialHistoryControllerApiFp(this.configuration).updatePatientSocialHistory(patientQuestionAnswerRequest, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Change the  Patient  Social history status.
     * @summary Update Patient Social History Status
     * @param {string} patientSocialHistoryId 
     * @param {boolean} status 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientSocialHistoryControllerApi
     */
    public updatePatientSocialHistoryStatus(patientSocialHistoryId: string, status: boolean, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return PatientSocialHistoryControllerApiFp(this.configuration).updatePatientSocialHistoryStatus(patientSocialHistoryId, status, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const GetPatientSocialHistorySocialHistoryTypeEnum = {
    HomeAndEnvironment: 'HOME_AND_ENVIRONMENT',
    SubstanceUse: 'SUBSTANCE_USE',
    EducationAndOccupation: 'EDUCATION_AND_OCCUPATION',
    Lifestyle: 'LIFESTYLE',
    MarriageAndSexuality: 'MARRIAGE_AND_SEXUALITY',
    AdvanceDirective: 'ADVANCE_DIRECTIVE',
    DietAndExercise: 'DIET_AND_EXERCISE',
    PublicHealthAndTravel: 'PUBLIC_HEALTH_AND_TRAVEL',
    ActivitiesOfDailyLiving: 'ACTIVITIES_OF_DAILY_LIVING',
    Covid19VaccineScreening: 'COVID_19_VACCINE_SCREENING',
    MigrationFrom123121: 'MIGRATION_FROM_123121',
    Psychiatry: 'PSYCHIATRY',
    HomeCareSubstanceUse: 'HOME_CARE_SUBSTANCE_USE'
} as const;
export type GetPatientSocialHistorySocialHistoryTypeEnum = typeof GetPatientSocialHistorySocialHistoryTypeEnum[keyof typeof GetPatientSocialHistorySocialHistoryTypeEnum];


/**
 * PatientTimelineEventControllerApi - axios parameter creator
 * @export
 */
export const PatientTimelineEventControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {string} [patientUuid] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllPatientTimelineEvents: async (startDate?: string, endDate?: string, patientUuid?: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/master/patient-timeline-event`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString() :
                    startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString() :
                    endDate;
            }

            if (patientUuid !== undefined) {
                localVarQueryParameter['patientUuid'] = patientUuid;
            }

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {string} [patientUuid] 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllPatientTimelineEventsv2: async (startDate?: string, endDate?: string, patientUuid?: string, page?: number, size?: number, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/master/patient-timeline-event/paginated`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString() :
                    startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString() :
                    endDate;
            }

            if (patientUuid !== undefined) {
                localVarQueryParameter['patientUuid'] = patientUuid;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PatientTimelineEventControllerApi - functional programming interface
 * @export
 */
export const PatientTimelineEventControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PatientTimelineEventControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {string} [patientUuid] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllPatientTimelineEvents(startDate?: string, endDate?: string, patientUuid?: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllPatientTimelineEvents(startDate, endDate, patientUuid, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientTimelineEventControllerApi.getAllPatientTimelineEvents']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {string} [patientUuid] 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllPatientTimelineEventsv2(startDate?: string, endDate?: string, patientUuid?: string, page?: number, size?: number, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllPatientTimelineEventsv2(startDate, endDate, patientUuid, page, size, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientTimelineEventControllerApi.getAllPatientTimelineEventsv2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PatientTimelineEventControllerApi - factory interface
 * @export
 */
export const PatientTimelineEventControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PatientTimelineEventControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {string} [patientUuid] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllPatientTimelineEvents(startDate?: string, endDate?: string, patientUuid?: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getAllPatientTimelineEvents(startDate, endDate, patientUuid, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {string} [patientUuid] 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllPatientTimelineEventsv2(startDate?: string, endDate?: string, patientUuid?: string, page?: number, size?: number, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getAllPatientTimelineEventsv2(startDate, endDate, patientUuid, page, size, xTENANTID, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PatientTimelineEventControllerApi - object-oriented interface
 * @export
 * @class PatientTimelineEventControllerApi
 * @extends {BaseAPI}
 */
export class PatientTimelineEventControllerApi extends BaseAPI {
    /**
     * 
     * @param {string} [startDate] 
     * @param {string} [endDate] 
     * @param {string} [patientUuid] 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientTimelineEventControllerApi
     */
    public getAllPatientTimelineEvents(startDate?: string, endDate?: string, patientUuid?: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return PatientTimelineEventControllerApiFp(this.configuration).getAllPatientTimelineEvents(startDate, endDate, patientUuid, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [startDate] 
     * @param {string} [endDate] 
     * @param {string} [patientUuid] 
     * @param {number} [page] 
     * @param {number} [size] 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientTimelineEventControllerApi
     */
    public getAllPatientTimelineEventsv2(startDate?: string, endDate?: string, patientUuid?: string, page?: number, size?: number, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return PatientTimelineEventControllerApiFp(this.configuration).getAllPatientTimelineEventsv2(startDate, endDate, patientUuid, page, size, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PatientVaccineControllerApi - axios parameter creator
 * @export
 */
export const PatientVaccineControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Add a new patient vaccine record into the system
         * @summary Add Patient Vaccine
         * @param {PatientVaccine} patientVaccine 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPatientVaccine: async (patientVaccine: PatientVaccine, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientVaccine' is not null or undefined
            assertParamExists('createPatientVaccine', 'patientVaccine', patientVaccine)
            const localVarPath = `/api/master/patient-vaccine`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patientVaccine, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get vaccines for patient portal with active=true and archive=false
         * @summary Get Patient Portal Vaccines
         * @param {string} patientUuid 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatientPortalVaccines: async (patientUuid: string, page?: number, size?: number, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientUuid' is not null or undefined
            assertParamExists('getPatientPortalVaccines', 'patientUuid', patientUuid)
            const localVarPath = `/api/master/patient-vaccine/patient-portal`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (patientUuid !== undefined) {
                localVarQueryParameter['patientUuid'] = patientUuid;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve a Patient Vaccine record by its unique ID
         * @summary Get Patient Vaccine by ID
         * @param {string} patientVaccineId 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatientVaccineById: async (patientVaccineId: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientVaccineId' is not null or undefined
            assertParamExists('getPatientVaccineById', 'patientVaccineId', patientVaccineId)
            const localVarPath = `/api/master/patient-vaccine/{patientVaccineId}`
                .replace(`{${"patientVaccineId"}}`, encodeURIComponent(String(patientVaccineId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all Patient Vaccine records with search and filter options
         * @summary Get Patient Vaccines
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {boolean} [status] 
         * @param {boolean} [archive] 
         * @param {string} [patientUuid] 
         * @param {string} [appointmentUuid] 
         * @param {string} [searchString] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatientVaccines: async (page?: number, size?: number, sortBy?: string, sortDirection?: string, status?: boolean, archive?: boolean, patientUuid?: string, appointmentUuid?: string, searchString?: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/master/patient-vaccine`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (archive !== undefined) {
                localVarQueryParameter['archive'] = archive;
            }

            if (patientUuid !== undefined) {
                localVarQueryParameter['patientUuid'] = patientUuid;
            }

            if (appointmentUuid !== undefined) {
                localVarQueryParameter['appointmentUuid'] = appointmentUuid;
            }

            if (searchString !== undefined) {
                localVarQueryParameter['searchString'] = searchString;
            }

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update an existing Patient Vaccine record
         * @summary Update Patient Vaccine
         * @param {PatientVaccine} patientVaccine 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePatientVaccine: async (patientVaccine: PatientVaccine, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientVaccine' is not null or undefined
            assertParamExists('updatePatientVaccine', 'patientVaccine', patientVaccine)
            const localVarPath = `/api/master/patient-vaccine`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patientVaccine, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Archive a Patient Vaccine record by its ID
         * @summary Archive Patient Vaccine
         * @param {string} patientVaccineId 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePatientVaccineArchiveStatus: async (patientVaccineId: string, status: boolean, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientVaccineId' is not null or undefined
            assertParamExists('updatePatientVaccineArchiveStatus', 'patientVaccineId', patientVaccineId)
            // verify required parameter 'status' is not null or undefined
            assertParamExists('updatePatientVaccineArchiveStatus', 'status', status)
            const localVarPath = `/api/master/patient-vaccine/{patientVaccineId}/archive-status/{status}`
                .replace(`{${"patientVaccineId"}}`, encodeURIComponent(String(patientVaccineId)))
                .replace(`{${"status"}}`, encodeURIComponent(String(status)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update the status of a Patient Vaccine record by its ID
         * @summary Update Patient Vaccine Status
         * @param {string} patientVaccineId 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePatientVaccineStatus: async (patientVaccineId: string, status: boolean, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientVaccineId' is not null or undefined
            assertParamExists('updatePatientVaccineStatus', 'patientVaccineId', patientVaccineId)
            // verify required parameter 'status' is not null or undefined
            assertParamExists('updatePatientVaccineStatus', 'status', status)
            const localVarPath = `/api/master/patient-vaccine/{patientVaccineId}/status/{status}`
                .replace(`{${"patientVaccineId"}}`, encodeURIComponent(String(patientVaccineId)))
                .replace(`{${"status"}}`, encodeURIComponent(String(status)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PatientVaccineControllerApi - functional programming interface
 * @export
 */
export const PatientVaccineControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PatientVaccineControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * Add a new patient vaccine record into the system
         * @summary Add Patient Vaccine
         * @param {PatientVaccine} patientVaccine 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createPatientVaccine(patientVaccine: PatientVaccine, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createPatientVaccine(patientVaccine, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientVaccineControllerApi.createPatientVaccine']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get vaccines for patient portal with active=true and archive=false
         * @summary Get Patient Portal Vaccines
         * @param {string} patientUuid 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPatientPortalVaccines(patientUuid: string, page?: number, size?: number, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPatientPortalVaccines(patientUuid, page, size, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientVaccineControllerApi.getPatientPortalVaccines']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve a Patient Vaccine record by its unique ID
         * @summary Get Patient Vaccine by ID
         * @param {string} patientVaccineId 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPatientVaccineById(patientVaccineId: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPatientVaccineById(patientVaccineId, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientVaccineControllerApi.getPatientVaccineById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get all Patient Vaccine records with search and filter options
         * @summary Get Patient Vaccines
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {boolean} [status] 
         * @param {boolean} [archive] 
         * @param {string} [patientUuid] 
         * @param {string} [appointmentUuid] 
         * @param {string} [searchString] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPatientVaccines(page?: number, size?: number, sortBy?: string, sortDirection?: string, status?: boolean, archive?: boolean, patientUuid?: string, appointmentUuid?: string, searchString?: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPatientVaccines(page, size, sortBy, sortDirection, status, archive, patientUuid, appointmentUuid, searchString, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientVaccineControllerApi.getPatientVaccines']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update an existing Patient Vaccine record
         * @summary Update Patient Vaccine
         * @param {PatientVaccine} patientVaccine 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePatientVaccine(patientVaccine: PatientVaccine, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePatientVaccine(patientVaccine, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientVaccineControllerApi.updatePatientVaccine']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Archive a Patient Vaccine record by its ID
         * @summary Archive Patient Vaccine
         * @param {string} patientVaccineId 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePatientVaccineArchiveStatus(patientVaccineId: string, status: boolean, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePatientVaccineArchiveStatus(patientVaccineId, status, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientVaccineControllerApi.updatePatientVaccineArchiveStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update the status of a Patient Vaccine record by its ID
         * @summary Update Patient Vaccine Status
         * @param {string} patientVaccineId 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePatientVaccineStatus(patientVaccineId: string, status: boolean, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePatientVaccineStatus(patientVaccineId, status, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientVaccineControllerApi.updatePatientVaccineStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PatientVaccineControllerApi - factory interface
 * @export
 */
export const PatientVaccineControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PatientVaccineControllerApiFp(configuration)
    return {
        /**
         * Add a new patient vaccine record into the system
         * @summary Add Patient Vaccine
         * @param {PatientVaccine} patientVaccine 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPatientVaccine(patientVaccine: PatientVaccine, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.createPatientVaccine(patientVaccine, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Get vaccines for patient portal with active=true and archive=false
         * @summary Get Patient Portal Vaccines
         * @param {string} patientUuid 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatientPortalVaccines(patientUuid: string, page?: number, size?: number, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getPatientPortalVaccines(patientUuid, page, size, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve a Patient Vaccine record by its unique ID
         * @summary Get Patient Vaccine by ID
         * @param {string} patientVaccineId 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatientVaccineById(patientVaccineId: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getPatientVaccineById(patientVaccineId, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all Patient Vaccine records with search and filter options
         * @summary Get Patient Vaccines
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {boolean} [status] 
         * @param {boolean} [archive] 
         * @param {string} [patientUuid] 
         * @param {string} [appointmentUuid] 
         * @param {string} [searchString] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatientVaccines(page?: number, size?: number, sortBy?: string, sortDirection?: string, status?: boolean, archive?: boolean, patientUuid?: string, appointmentUuid?: string, searchString?: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getPatientVaccines(page, size, sortBy, sortDirection, status, archive, patientUuid, appointmentUuid, searchString, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Update an existing Patient Vaccine record
         * @summary Update Patient Vaccine
         * @param {PatientVaccine} patientVaccine 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePatientVaccine(patientVaccine: PatientVaccine, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.updatePatientVaccine(patientVaccine, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Archive a Patient Vaccine record by its ID
         * @summary Archive Patient Vaccine
         * @param {string} patientVaccineId 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePatientVaccineArchiveStatus(patientVaccineId: string, status: boolean, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.updatePatientVaccineArchiveStatus(patientVaccineId, status, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Update the status of a Patient Vaccine record by its ID
         * @summary Update Patient Vaccine Status
         * @param {string} patientVaccineId 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePatientVaccineStatus(patientVaccineId: string, status: boolean, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.updatePatientVaccineStatus(patientVaccineId, status, xTENANTID, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PatientVaccineControllerApi - object-oriented interface
 * @export
 * @class PatientVaccineControllerApi
 * @extends {BaseAPI}
 */
export class PatientVaccineControllerApi extends BaseAPI {
    /**
     * Add a new patient vaccine record into the system
     * @summary Add Patient Vaccine
     * @param {PatientVaccine} patientVaccine 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientVaccineControllerApi
     */
    public createPatientVaccine(patientVaccine: PatientVaccine, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return PatientVaccineControllerApiFp(this.configuration).createPatientVaccine(patientVaccine, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get vaccines for patient portal with active=true and archive=false
     * @summary Get Patient Portal Vaccines
     * @param {string} patientUuid 
     * @param {number} [page] 
     * @param {number} [size] 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientVaccineControllerApi
     */
    public getPatientPortalVaccines(patientUuid: string, page?: number, size?: number, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return PatientVaccineControllerApiFp(this.configuration).getPatientPortalVaccines(patientUuid, page, size, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve a Patient Vaccine record by its unique ID
     * @summary Get Patient Vaccine by ID
     * @param {string} patientVaccineId 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientVaccineControllerApi
     */
    public getPatientVaccineById(patientVaccineId: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return PatientVaccineControllerApiFp(this.configuration).getPatientVaccineById(patientVaccineId, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all Patient Vaccine records with search and filter options
     * @summary Get Patient Vaccines
     * @param {number} [page] 
     * @param {number} [size] 
     * @param {string} [sortBy] 
     * @param {string} [sortDirection] 
     * @param {boolean} [status] 
     * @param {boolean} [archive] 
     * @param {string} [patientUuid] 
     * @param {string} [appointmentUuid] 
     * @param {string} [searchString] 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientVaccineControllerApi
     */
    public getPatientVaccines(page?: number, size?: number, sortBy?: string, sortDirection?: string, status?: boolean, archive?: boolean, patientUuid?: string, appointmentUuid?: string, searchString?: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return PatientVaccineControllerApiFp(this.configuration).getPatientVaccines(page, size, sortBy, sortDirection, status, archive, patientUuid, appointmentUuid, searchString, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update an existing Patient Vaccine record
     * @summary Update Patient Vaccine
     * @param {PatientVaccine} patientVaccine 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientVaccineControllerApi
     */
    public updatePatientVaccine(patientVaccine: PatientVaccine, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return PatientVaccineControllerApiFp(this.configuration).updatePatientVaccine(patientVaccine, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Archive a Patient Vaccine record by its ID
     * @summary Archive Patient Vaccine
     * @param {string} patientVaccineId 
     * @param {boolean} status 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientVaccineControllerApi
     */
    public updatePatientVaccineArchiveStatus(patientVaccineId: string, status: boolean, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return PatientVaccineControllerApiFp(this.configuration).updatePatientVaccineArchiveStatus(patientVaccineId, status, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update the status of a Patient Vaccine record by its ID
     * @summary Update Patient Vaccine Status
     * @param {string} patientVaccineId 
     * @param {boolean} status 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientVaccineControllerApi
     */
    public updatePatientVaccineStatus(patientVaccineId: string, status: boolean, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return PatientVaccineControllerApiFp(this.configuration).updatePatientVaccineStatus(patientVaccineId, status, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PatientVitalControllerApi - axios parameter creator
 * @export
 */
export const PatientVitalControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Add a new patient vital record into the system
         * @summary Add Patient Vital
         * @param {PatientVitalRequest} patientVitalRequest 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPatientVital: async (patientVitalRequest: PatientVitalRequest, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientVitalRequest' is not null or undefined
            assertParamExists('createPatientVital', 'patientVitalRequest', patientVitalRequest)
            const localVarPath = `/api/master/patient-vital`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patientVitalRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get the latest values for all vital types for a specific patient
         * @summary Get Latest Vitals by Patient ID
         * @param {string} patientId 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLatestVitalsByPatientId: async (patientId: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientId' is not null or undefined
            assertParamExists('getLatestVitalsByPatientId', 'patientId', patientId)
            const localVarPath = `/api/master/patient-vital/latest/{patientId}`
                .replace(`{${"patientId"}}`, encodeURIComponent(String(patientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve a Patient Vital record by its unique ID
         * @summary Get Patient Vital by ID
         * @param {string} patientVitalId 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatientVitalById: async (patientVitalId: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientVitalId' is not null or undefined
            assertParamExists('getPatientVitalById', 'patientVitalId', patientVitalId)
            const localVarPath = `/api/master/patient-vital/{patientVitalId}`
                .replace(`{${"patientVitalId"}}`, encodeURIComponent(String(patientVitalId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all Patient Vitals with search and filter options. Supports sorting by: recordedAt (chronological), updatedDate (chronological), recordedDate (chronological), name, value, unit, active, archive.
         * @summary Get Patient Vitals
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sort] 
         * @param {boolean} [active] 
         * @param {boolean} [archive] 
         * @param {string} [patientUuid] 
         * @param {string} [appointmentUuid] 
         * @param {string} [searchString] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatientVitals: async (page?: number, size?: number, sortBy?: string, sort?: string, active?: boolean, archive?: boolean, patientUuid?: string, appointmentUuid?: string, searchString?: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/master/patient-vital`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (active !== undefined) {
                localVarQueryParameter['active'] = active;
            }

            if (archive !== undefined) {
                localVarQueryParameter['archive'] = archive;
            }

            if (patientUuid !== undefined) {
                localVarQueryParameter['patientUuid'] = patientUuid;
            }

            if (appointmentUuid !== undefined) {
                localVarQueryParameter['appointmentUuid'] = appointmentUuid;
            }

            if (searchString !== undefined) {
                localVarQueryParameter['searchString'] = searchString;
            }

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Change patient vital archive status to either archived or unarchived.
         * @summary Archive/Unarchive Patient Vital
         * @param {string} patientVitalId 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateArchiveStatus1: async (patientVitalId: string, status: boolean, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientVitalId' is not null or undefined
            assertParamExists('updateArchiveStatus1', 'patientVitalId', patientVitalId)
            // verify required parameter 'status' is not null or undefined
            assertParamExists('updateArchiveStatus1', 'status', status)
            const localVarPath = `/api/master/patient-vital/{patientVitalId}/archive-status/{status}`
                .replace(`{${"patientVitalId"}}`, encodeURIComponent(String(patientVitalId)))
                .replace(`{${"status"}}`, encodeURIComponent(String(status)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update an existing Patient Vital record
         * @summary Update Patient Vital
         * @param {PatientVital} patientVital 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePatientVital: async (patientVital: PatientVital, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientVital' is not null or undefined
            assertParamExists('updatePatientVital', 'patientVital', patientVital)
            const localVarPath = `/api/master/patient-vital`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patientVital, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PatientVitalControllerApi - functional programming interface
 * @export
 */
export const PatientVitalControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PatientVitalControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * Add a new patient vital record into the system
         * @summary Add Patient Vital
         * @param {PatientVitalRequest} patientVitalRequest 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createPatientVital(patientVitalRequest: PatientVitalRequest, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createPatientVital(patientVitalRequest, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientVitalControllerApi.createPatientVital']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get the latest values for all vital types for a specific patient
         * @summary Get Latest Vitals by Patient ID
         * @param {string} patientId 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLatestVitalsByPatientId(patientId: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLatestVitalsByPatientId(patientId, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientVitalControllerApi.getLatestVitalsByPatientId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve a Patient Vital record by its unique ID
         * @summary Get Patient Vital by ID
         * @param {string} patientVitalId 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPatientVitalById(patientVitalId: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPatientVitalById(patientVitalId, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientVitalControllerApi.getPatientVitalById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get all Patient Vitals with search and filter options. Supports sorting by: recordedAt (chronological), updatedDate (chronological), recordedDate (chronological), name, value, unit, active, archive.
         * @summary Get Patient Vitals
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sort] 
         * @param {boolean} [active] 
         * @param {boolean} [archive] 
         * @param {string} [patientUuid] 
         * @param {string} [appointmentUuid] 
         * @param {string} [searchString] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPatientVitals(page?: number, size?: number, sortBy?: string, sort?: string, active?: boolean, archive?: boolean, patientUuid?: string, appointmentUuid?: string, searchString?: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPatientVitals(page, size, sortBy, sort, active, archive, patientUuid, appointmentUuid, searchString, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientVitalControllerApi.getPatientVitals']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Change patient vital archive status to either archived or unarchived.
         * @summary Archive/Unarchive Patient Vital
         * @param {string} patientVitalId 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateArchiveStatus1(patientVitalId: string, status: boolean, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateArchiveStatus1(patientVitalId, status, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientVitalControllerApi.updateArchiveStatus1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update an existing Patient Vital record
         * @summary Update Patient Vital
         * @param {PatientVital} patientVital 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePatientVital(patientVital: PatientVital, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePatientVital(patientVital, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientVitalControllerApi.updatePatientVital']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PatientVitalControllerApi - factory interface
 * @export
 */
export const PatientVitalControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PatientVitalControllerApiFp(configuration)
    return {
        /**
         * Add a new patient vital record into the system
         * @summary Add Patient Vital
         * @param {PatientVitalRequest} patientVitalRequest 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPatientVital(patientVitalRequest: PatientVitalRequest, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.createPatientVital(patientVitalRequest, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Get the latest values for all vital types for a specific patient
         * @summary Get Latest Vitals by Patient ID
         * @param {string} patientId 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLatestVitalsByPatientId(patientId: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getLatestVitalsByPatientId(patientId, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve a Patient Vital record by its unique ID
         * @summary Get Patient Vital by ID
         * @param {string} patientVitalId 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatientVitalById(patientVitalId: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getPatientVitalById(patientVitalId, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all Patient Vitals with search and filter options. Supports sorting by: recordedAt (chronological), updatedDate (chronological), recordedDate (chronological), name, value, unit, active, archive.
         * @summary Get Patient Vitals
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sort] 
         * @param {boolean} [active] 
         * @param {boolean} [archive] 
         * @param {string} [patientUuid] 
         * @param {string} [appointmentUuid] 
         * @param {string} [searchString] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatientVitals(page?: number, size?: number, sortBy?: string, sort?: string, active?: boolean, archive?: boolean, patientUuid?: string, appointmentUuid?: string, searchString?: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getPatientVitals(page, size, sortBy, sort, active, archive, patientUuid, appointmentUuid, searchString, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Change patient vital archive status to either archived or unarchived.
         * @summary Archive/Unarchive Patient Vital
         * @param {string} patientVitalId 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateArchiveStatus1(patientVitalId: string, status: boolean, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.updateArchiveStatus1(patientVitalId, status, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Update an existing Patient Vital record
         * @summary Update Patient Vital
         * @param {PatientVital} patientVital 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePatientVital(patientVital: PatientVital, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.updatePatientVital(patientVital, xTENANTID, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PatientVitalControllerApi - object-oriented interface
 * @export
 * @class PatientVitalControllerApi
 * @extends {BaseAPI}
 */
export class PatientVitalControllerApi extends BaseAPI {
    /**
     * Add a new patient vital record into the system
     * @summary Add Patient Vital
     * @param {PatientVitalRequest} patientVitalRequest 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientVitalControllerApi
     */
    public createPatientVital(patientVitalRequest: PatientVitalRequest, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return PatientVitalControllerApiFp(this.configuration).createPatientVital(patientVitalRequest, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get the latest values for all vital types for a specific patient
     * @summary Get Latest Vitals by Patient ID
     * @param {string} patientId 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientVitalControllerApi
     */
    public getLatestVitalsByPatientId(patientId: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return PatientVitalControllerApiFp(this.configuration).getLatestVitalsByPatientId(patientId, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve a Patient Vital record by its unique ID
     * @summary Get Patient Vital by ID
     * @param {string} patientVitalId 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientVitalControllerApi
     */
    public getPatientVitalById(patientVitalId: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return PatientVitalControllerApiFp(this.configuration).getPatientVitalById(patientVitalId, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all Patient Vitals with search and filter options. Supports sorting by: recordedAt (chronological), updatedDate (chronological), recordedDate (chronological), name, value, unit, active, archive.
     * @summary Get Patient Vitals
     * @param {number} [page] 
     * @param {number} [size] 
     * @param {string} [sortBy] 
     * @param {string} [sort] 
     * @param {boolean} [active] 
     * @param {boolean} [archive] 
     * @param {string} [patientUuid] 
     * @param {string} [appointmentUuid] 
     * @param {string} [searchString] 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientVitalControllerApi
     */
    public getPatientVitals(page?: number, size?: number, sortBy?: string, sort?: string, active?: boolean, archive?: boolean, patientUuid?: string, appointmentUuid?: string, searchString?: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return PatientVitalControllerApiFp(this.configuration).getPatientVitals(page, size, sortBy, sort, active, archive, patientUuid, appointmentUuid, searchString, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Change patient vital archive status to either archived or unarchived.
     * @summary Archive/Unarchive Patient Vital
     * @param {string} patientVitalId 
     * @param {boolean} status 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientVitalControllerApi
     */
    public updateArchiveStatus1(patientVitalId: string, status: boolean, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return PatientVitalControllerApiFp(this.configuration).updateArchiveStatus1(patientVitalId, status, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update an existing Patient Vital record
     * @summary Update Patient Vital
     * @param {PatientVital} patientVital 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientVitalControllerApi
     */
    public updatePatientVital(patientVital: PatientVital, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return PatientVitalControllerApiFp(this.configuration).updatePatientVital(patientVital, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PharmacyLabRadiologyControllerApi - axios parameter creator
 * @export
 */
export const PharmacyLabRadiologyControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Create a Pharmacy Lab Radiology
         * @summary Create Pharmacy Lab Radiology
         * @param {PharmacyLabRadiology} pharmacyLabRadiology 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPharmacyLabRadiology: async (pharmacyLabRadiology: PharmacyLabRadiology, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pharmacyLabRadiology' is not null or undefined
            assertParamExists('createPharmacyLabRadiology', 'pharmacyLabRadiology', pharmacyLabRadiology)
            const localVarPath = `/api/master/pharmacy-lab-radiology`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(pharmacyLabRadiology, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all pharmacy lab radiology. 
         * @summary Get all pharmacy lab radiology
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {GetAllPharmacyLabRadiologyTypeEnum} [type] 
         * @param {string} [searchString] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllPharmacyLabRadiology: async (page?: number, size?: number, sortBy?: string, sortDirection?: string, type?: GetAllPharmacyLabRadiologyTypeEnum, searchString?: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/master/pharmacy-lab-radiology`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }

            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }

            if (searchString !== undefined) {
                localVarQueryParameter['searchString'] = searchString;
            }

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get preference by id
         * @summary Get preference by id.
         * @param {string} preferenceUuid 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPreferencesById: async (preferenceUuid: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'preferenceUuid' is not null or undefined
            assertParamExists('getPreferencesById', 'preferenceUuid', preferenceUuid)
            const localVarPath = `/api/master/pharmacy-lab-radiology/{preferenceUuid}`
                .replace(`{${"preferenceUuid"}}`, encodeURIComponent(String(preferenceUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update a Pharmacy Lab Radiology
         * @summary Update Pharmacy Lab Radiology
         * @param {string} preferenceUuid 
         * @param {PharmacyLabRadiology} pharmacyLabRadiology 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePharmacyLabRadiology: async (preferenceUuid: string, pharmacyLabRadiology: PharmacyLabRadiology, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'preferenceUuid' is not null or undefined
            assertParamExists('updatePharmacyLabRadiology', 'preferenceUuid', preferenceUuid)
            // verify required parameter 'pharmacyLabRadiology' is not null or undefined
            assertParamExists('updatePharmacyLabRadiology', 'pharmacyLabRadiology', pharmacyLabRadiology)
            const localVarPath = `/api/master/pharmacy-lab-radiology/{preferenceUuid}`
                .replace(`{${"preferenceUuid"}}`, encodeURIComponent(String(preferenceUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(pharmacyLabRadiology, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PharmacyLabRadiologyControllerApi - functional programming interface
 * @export
 */
export const PharmacyLabRadiologyControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PharmacyLabRadiologyControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * Create a Pharmacy Lab Radiology
         * @summary Create Pharmacy Lab Radiology
         * @param {PharmacyLabRadiology} pharmacyLabRadiology 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createPharmacyLabRadiology(pharmacyLabRadiology: PharmacyLabRadiology, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createPharmacyLabRadiology(pharmacyLabRadiology, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PharmacyLabRadiologyControllerApi.createPharmacyLabRadiology']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get all pharmacy lab radiology. 
         * @summary Get all pharmacy lab radiology
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {GetAllPharmacyLabRadiologyTypeEnum} [type] 
         * @param {string} [searchString] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllPharmacyLabRadiology(page?: number, size?: number, sortBy?: string, sortDirection?: string, type?: GetAllPharmacyLabRadiologyTypeEnum, searchString?: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllPharmacyLabRadiology(page, size, sortBy, sortDirection, type, searchString, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PharmacyLabRadiologyControllerApi.getAllPharmacyLabRadiology']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get preference by id
         * @summary Get preference by id.
         * @param {string} preferenceUuid 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPreferencesById(preferenceUuid: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPreferencesById(preferenceUuid, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PharmacyLabRadiologyControllerApi.getPreferencesById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update a Pharmacy Lab Radiology
         * @summary Update Pharmacy Lab Radiology
         * @param {string} preferenceUuid 
         * @param {PharmacyLabRadiology} pharmacyLabRadiology 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePharmacyLabRadiology(preferenceUuid: string, pharmacyLabRadiology: PharmacyLabRadiology, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePharmacyLabRadiology(preferenceUuid, pharmacyLabRadiology, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PharmacyLabRadiologyControllerApi.updatePharmacyLabRadiology']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PharmacyLabRadiologyControllerApi - factory interface
 * @export
 */
export const PharmacyLabRadiologyControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PharmacyLabRadiologyControllerApiFp(configuration)
    return {
        /**
         * Create a Pharmacy Lab Radiology
         * @summary Create Pharmacy Lab Radiology
         * @param {PharmacyLabRadiology} pharmacyLabRadiology 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPharmacyLabRadiology(pharmacyLabRadiology: PharmacyLabRadiology, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.createPharmacyLabRadiology(pharmacyLabRadiology, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all pharmacy lab radiology. 
         * @summary Get all pharmacy lab radiology
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {GetAllPharmacyLabRadiologyTypeEnum} [type] 
         * @param {string} [searchString] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllPharmacyLabRadiology(page?: number, size?: number, sortBy?: string, sortDirection?: string, type?: GetAllPharmacyLabRadiologyTypeEnum, searchString?: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getAllPharmacyLabRadiology(page, size, sortBy, sortDirection, type, searchString, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Get preference by id
         * @summary Get preference by id.
         * @param {string} preferenceUuid 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPreferencesById(preferenceUuid: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getPreferencesById(preferenceUuid, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Update a Pharmacy Lab Radiology
         * @summary Update Pharmacy Lab Radiology
         * @param {string} preferenceUuid 
         * @param {PharmacyLabRadiology} pharmacyLabRadiology 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePharmacyLabRadiology(preferenceUuid: string, pharmacyLabRadiology: PharmacyLabRadiology, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.updatePharmacyLabRadiology(preferenceUuid, pharmacyLabRadiology, xTENANTID, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PharmacyLabRadiologyControllerApi - object-oriented interface
 * @export
 * @class PharmacyLabRadiologyControllerApi
 * @extends {BaseAPI}
 */
export class PharmacyLabRadiologyControllerApi extends BaseAPI {
    /**
     * Create a Pharmacy Lab Radiology
     * @summary Create Pharmacy Lab Radiology
     * @param {PharmacyLabRadiology} pharmacyLabRadiology 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PharmacyLabRadiologyControllerApi
     */
    public createPharmacyLabRadiology(pharmacyLabRadiology: PharmacyLabRadiology, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return PharmacyLabRadiologyControllerApiFp(this.configuration).createPharmacyLabRadiology(pharmacyLabRadiology, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all pharmacy lab radiology. 
     * @summary Get all pharmacy lab radiology
     * @param {number} [page] 
     * @param {number} [size] 
     * @param {string} [sortBy] 
     * @param {string} [sortDirection] 
     * @param {GetAllPharmacyLabRadiologyTypeEnum} [type] 
     * @param {string} [searchString] 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PharmacyLabRadiologyControllerApi
     */
    public getAllPharmacyLabRadiology(page?: number, size?: number, sortBy?: string, sortDirection?: string, type?: GetAllPharmacyLabRadiologyTypeEnum, searchString?: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return PharmacyLabRadiologyControllerApiFp(this.configuration).getAllPharmacyLabRadiology(page, size, sortBy, sortDirection, type, searchString, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get preference by id
     * @summary Get preference by id.
     * @param {string} preferenceUuid 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PharmacyLabRadiologyControllerApi
     */
    public getPreferencesById(preferenceUuid: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return PharmacyLabRadiologyControllerApiFp(this.configuration).getPreferencesById(preferenceUuid, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update a Pharmacy Lab Radiology
     * @summary Update Pharmacy Lab Radiology
     * @param {string} preferenceUuid 
     * @param {PharmacyLabRadiology} pharmacyLabRadiology 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PharmacyLabRadiologyControllerApi
     */
    public updatePharmacyLabRadiology(preferenceUuid: string, pharmacyLabRadiology: PharmacyLabRadiology, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return PharmacyLabRadiologyControllerApiFp(this.configuration).updatePharmacyLabRadiology(preferenceUuid, pharmacyLabRadiology, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const GetAllPharmacyLabRadiologyTypeEnum = {
    Lab: 'LAB',
    Pharmacy: 'PHARMACY',
    Radiology: 'RADIOLOGY'
} as const;
export type GetAllPharmacyLabRadiologyTypeEnum = typeof GetAllPharmacyLabRadiologyTypeEnum[keyof typeof GetAllPharmacyLabRadiologyTypeEnum];


/**
 * PhysicalTemplateControllerApi - axios parameter creator
 * @export
 */
export const PhysicalTemplateControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Create a Physical Template
         * @summary Create Physical Template
         * @param {PhysicalTemplate} physicalTemplate 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPhysicalTemplate: async (physicalTemplate: PhysicalTemplate, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'physicalTemplate' is not null or undefined
            assertParamExists('createPhysicalTemplate', 'physicalTemplate', physicalTemplate)
            const localVarPath = `/api/master/physical-template`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(physicalTemplate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all Physical Templates
         * @summary Get all Physical Templates
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {string} [speciality] 
         * @param {boolean} [status] 
         * @param {boolean} [archive] 
         * @param {string} [searchString] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllPhysicalTemplates: async (page?: number, size?: number, sortBy?: string, sortDirection?: string, speciality?: string, status?: boolean, archive?: boolean, searchString?: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/master/physical-template`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }

            if (speciality !== undefined) {
                localVarQueryParameter['speciality'] = speciality;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (archive !== undefined) {
                localVarQueryParameter['archive'] = archive;
            }

            if (searchString !== undefined) {
                localVarQueryParameter['searchString'] = searchString;
            }

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get Physical Template by Id
         * @summary Get Physical Template by Id
         * @param {string} physicalTemplateUuid 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPhysicalTemplateById: async (physicalTemplateUuid: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'physicalTemplateUuid' is not null or undefined
            assertParamExists('getPhysicalTemplateById', 'physicalTemplateUuid', physicalTemplateUuid)
            const localVarPath = `/api/master/physical-template/{physicalTemplateUuid}`
                .replace(`{${"physicalTemplateUuid"}}`, encodeURIComponent(String(physicalTemplateUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Archive a physical template by its ID
         * @summary Archive Physical Template Status
         * @param {string} physicalTemplateUuid 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePhysicalArchiveStatus: async (physicalTemplateUuid: string, status: boolean, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'physicalTemplateUuid' is not null or undefined
            assertParamExists('updatePhysicalArchiveStatus', 'physicalTemplateUuid', physicalTemplateUuid)
            // verify required parameter 'status' is not null or undefined
            assertParamExists('updatePhysicalArchiveStatus', 'status', status)
            const localVarPath = `/api/master/physical-template/{physicalTemplateUuid}/archive-status/{status}`
                .replace(`{${"physicalTemplateUuid"}}`, encodeURIComponent(String(physicalTemplateUuid)))
                .replace(`{${"status"}}`, encodeURIComponent(String(status)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Edit Physical Template
         * @summary Update Physical Template
         * @param {PhysicalTemplate} physicalTemplate 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePhysicalTemplate: async (physicalTemplate: PhysicalTemplate, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'physicalTemplate' is not null or undefined
            assertParamExists('updatePhysicalTemplate', 'physicalTemplate', physicalTemplate)
            const localVarPath = `/api/master/physical-template`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(physicalTemplate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update the status of a Physical template by its ID
         * @summary Update Physical Template Status
         * @param {string} physicalTemplateUuid 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePhysicalTemplateStatus: async (physicalTemplateUuid: string, status: boolean, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'physicalTemplateUuid' is not null or undefined
            assertParamExists('updatePhysicalTemplateStatus', 'physicalTemplateUuid', physicalTemplateUuid)
            // verify required parameter 'status' is not null or undefined
            assertParamExists('updatePhysicalTemplateStatus', 'status', status)
            const localVarPath = `/api/master/physical-template/{physicalTemplateUuid}/status/{status}`
                .replace(`{${"physicalTemplateUuid"}}`, encodeURIComponent(String(physicalTemplateUuid)))
                .replace(`{${"status"}}`, encodeURIComponent(String(status)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PhysicalTemplateControllerApi - functional programming interface
 * @export
 */
export const PhysicalTemplateControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PhysicalTemplateControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * Create a Physical Template
         * @summary Create Physical Template
         * @param {PhysicalTemplate} physicalTemplate 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createPhysicalTemplate(physicalTemplate: PhysicalTemplate, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createPhysicalTemplate(physicalTemplate, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PhysicalTemplateControllerApi.createPhysicalTemplate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get all Physical Templates
         * @summary Get all Physical Templates
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {string} [speciality] 
         * @param {boolean} [status] 
         * @param {boolean} [archive] 
         * @param {string} [searchString] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllPhysicalTemplates(page?: number, size?: number, sortBy?: string, sortDirection?: string, speciality?: string, status?: boolean, archive?: boolean, searchString?: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllPhysicalTemplates(page, size, sortBy, sortDirection, speciality, status, archive, searchString, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PhysicalTemplateControllerApi.getAllPhysicalTemplates']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get Physical Template by Id
         * @summary Get Physical Template by Id
         * @param {string} physicalTemplateUuid 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPhysicalTemplateById(physicalTemplateUuid: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPhysicalTemplateById(physicalTemplateUuid, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PhysicalTemplateControllerApi.getPhysicalTemplateById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Archive a physical template by its ID
         * @summary Archive Physical Template Status
         * @param {string} physicalTemplateUuid 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePhysicalArchiveStatus(physicalTemplateUuid: string, status: boolean, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePhysicalArchiveStatus(physicalTemplateUuid, status, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PhysicalTemplateControllerApi.updatePhysicalArchiveStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Edit Physical Template
         * @summary Update Physical Template
         * @param {PhysicalTemplate} physicalTemplate 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePhysicalTemplate(physicalTemplate: PhysicalTemplate, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePhysicalTemplate(physicalTemplate, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PhysicalTemplateControllerApi.updatePhysicalTemplate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update the status of a Physical template by its ID
         * @summary Update Physical Template Status
         * @param {string} physicalTemplateUuid 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePhysicalTemplateStatus(physicalTemplateUuid: string, status: boolean, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePhysicalTemplateStatus(physicalTemplateUuid, status, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PhysicalTemplateControllerApi.updatePhysicalTemplateStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PhysicalTemplateControllerApi - factory interface
 * @export
 */
export const PhysicalTemplateControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PhysicalTemplateControllerApiFp(configuration)
    return {
        /**
         * Create a Physical Template
         * @summary Create Physical Template
         * @param {PhysicalTemplate} physicalTemplate 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPhysicalTemplate(physicalTemplate: PhysicalTemplate, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.createPhysicalTemplate(physicalTemplate, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all Physical Templates
         * @summary Get all Physical Templates
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {string} [speciality] 
         * @param {boolean} [status] 
         * @param {boolean} [archive] 
         * @param {string} [searchString] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllPhysicalTemplates(page?: number, size?: number, sortBy?: string, sortDirection?: string, speciality?: string, status?: boolean, archive?: boolean, searchString?: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getAllPhysicalTemplates(page, size, sortBy, sortDirection, speciality, status, archive, searchString, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Get Physical Template by Id
         * @summary Get Physical Template by Id
         * @param {string} physicalTemplateUuid 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPhysicalTemplateById(physicalTemplateUuid: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getPhysicalTemplateById(physicalTemplateUuid, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Archive a physical template by its ID
         * @summary Archive Physical Template Status
         * @param {string} physicalTemplateUuid 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePhysicalArchiveStatus(physicalTemplateUuid: string, status: boolean, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.updatePhysicalArchiveStatus(physicalTemplateUuid, status, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Edit Physical Template
         * @summary Update Physical Template
         * @param {PhysicalTemplate} physicalTemplate 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePhysicalTemplate(physicalTemplate: PhysicalTemplate, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.updatePhysicalTemplate(physicalTemplate, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Update the status of a Physical template by its ID
         * @summary Update Physical Template Status
         * @param {string} physicalTemplateUuid 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePhysicalTemplateStatus(physicalTemplateUuid: string, status: boolean, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.updatePhysicalTemplateStatus(physicalTemplateUuid, status, xTENANTID, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PhysicalTemplateControllerApi - object-oriented interface
 * @export
 * @class PhysicalTemplateControllerApi
 * @extends {BaseAPI}
 */
export class PhysicalTemplateControllerApi extends BaseAPI {
    /**
     * Create a Physical Template
     * @summary Create Physical Template
     * @param {PhysicalTemplate} physicalTemplate 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PhysicalTemplateControllerApi
     */
    public createPhysicalTemplate(physicalTemplate: PhysicalTemplate, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return PhysicalTemplateControllerApiFp(this.configuration).createPhysicalTemplate(physicalTemplate, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all Physical Templates
     * @summary Get all Physical Templates
     * @param {number} [page] 
     * @param {number} [size] 
     * @param {string} [sortBy] 
     * @param {string} [sortDirection] 
     * @param {string} [speciality] 
     * @param {boolean} [status] 
     * @param {boolean} [archive] 
     * @param {string} [searchString] 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PhysicalTemplateControllerApi
     */
    public getAllPhysicalTemplates(page?: number, size?: number, sortBy?: string, sortDirection?: string, speciality?: string, status?: boolean, archive?: boolean, searchString?: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return PhysicalTemplateControllerApiFp(this.configuration).getAllPhysicalTemplates(page, size, sortBy, sortDirection, speciality, status, archive, searchString, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get Physical Template by Id
     * @summary Get Physical Template by Id
     * @param {string} physicalTemplateUuid 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PhysicalTemplateControllerApi
     */
    public getPhysicalTemplateById(physicalTemplateUuid: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return PhysicalTemplateControllerApiFp(this.configuration).getPhysicalTemplateById(physicalTemplateUuid, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Archive a physical template by its ID
     * @summary Archive Physical Template Status
     * @param {string} physicalTemplateUuid 
     * @param {boolean} status 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PhysicalTemplateControllerApi
     */
    public updatePhysicalArchiveStatus(physicalTemplateUuid: string, status: boolean, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return PhysicalTemplateControllerApiFp(this.configuration).updatePhysicalArchiveStatus(physicalTemplateUuid, status, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Edit Physical Template
     * @summary Update Physical Template
     * @param {PhysicalTemplate} physicalTemplate 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PhysicalTemplateControllerApi
     */
    public updatePhysicalTemplate(physicalTemplate: PhysicalTemplate, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return PhysicalTemplateControllerApiFp(this.configuration).updatePhysicalTemplate(physicalTemplate, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update the status of a Physical template by its ID
     * @summary Update Physical Template Status
     * @param {string} physicalTemplateUuid 
     * @param {boolean} status 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PhysicalTemplateControllerApi
     */
    public updatePhysicalTemplateStatus(physicalTemplateUuid: string, status: boolean, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return PhysicalTemplateControllerApiFp(this.configuration).updatePhysicalTemplateStatus(physicalTemplateUuid, status, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PhysicalTemplateTypeControllerApi - axios parameter creator
 * @export
 */
export const PhysicalTemplateTypeControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Add a new Physical Template type into the system.
         * @summary Add Physical Template Type
         * @param {PhysicalTemplateType} physicalTemplateType 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPhysicalTemplateType: async (physicalTemplateType: PhysicalTemplateType, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'physicalTemplateType' is not null or undefined
            assertParamExists('createPhysicalTemplateType', 'physicalTemplateType', physicalTemplateType)
            const localVarPath = `/api/master/physical-template-type`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(physicalTemplateType, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all Physical Template types
         * @summary Get all Physical Template Types
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {boolean} [isBaseType] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllPhysicalTemplateTypes: async (page?: number, size?: number, sortBy?: string, sortDirection?: string, isBaseType?: boolean, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/master/physical-template-type`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }

            if (isBaseType !== undefined) {
                localVarQueryParameter['isBaseType'] = isBaseType;
            }

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PhysicalTemplateTypeControllerApi - functional programming interface
 * @export
 */
export const PhysicalTemplateTypeControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PhysicalTemplateTypeControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * Add a new Physical Template type into the system.
         * @summary Add Physical Template Type
         * @param {PhysicalTemplateType} physicalTemplateType 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createPhysicalTemplateType(physicalTemplateType: PhysicalTemplateType, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createPhysicalTemplateType(physicalTemplateType, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PhysicalTemplateTypeControllerApi.createPhysicalTemplateType']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get all Physical Template types
         * @summary Get all Physical Template Types
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {boolean} [isBaseType] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllPhysicalTemplateTypes(page?: number, size?: number, sortBy?: string, sortDirection?: string, isBaseType?: boolean, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllPhysicalTemplateTypes(page, size, sortBy, sortDirection, isBaseType, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PhysicalTemplateTypeControllerApi.getAllPhysicalTemplateTypes']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PhysicalTemplateTypeControllerApi - factory interface
 * @export
 */
export const PhysicalTemplateTypeControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PhysicalTemplateTypeControllerApiFp(configuration)
    return {
        /**
         * Add a new Physical Template type into the system.
         * @summary Add Physical Template Type
         * @param {PhysicalTemplateType} physicalTemplateType 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPhysicalTemplateType(physicalTemplateType: PhysicalTemplateType, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.createPhysicalTemplateType(physicalTemplateType, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all Physical Template types
         * @summary Get all Physical Template Types
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {boolean} [isBaseType] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllPhysicalTemplateTypes(page?: number, size?: number, sortBy?: string, sortDirection?: string, isBaseType?: boolean, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getAllPhysicalTemplateTypes(page, size, sortBy, sortDirection, isBaseType, xTENANTID, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PhysicalTemplateTypeControllerApi - object-oriented interface
 * @export
 * @class PhysicalTemplateTypeControllerApi
 * @extends {BaseAPI}
 */
export class PhysicalTemplateTypeControllerApi extends BaseAPI {
    /**
     * Add a new Physical Template type into the system.
     * @summary Add Physical Template Type
     * @param {PhysicalTemplateType} physicalTemplateType 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PhysicalTemplateTypeControllerApi
     */
    public createPhysicalTemplateType(physicalTemplateType: PhysicalTemplateType, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return PhysicalTemplateTypeControllerApiFp(this.configuration).createPhysicalTemplateType(physicalTemplateType, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all Physical Template types
     * @summary Get all Physical Template Types
     * @param {number} [page] 
     * @param {number} [size] 
     * @param {string} [sortBy] 
     * @param {string} [sortDirection] 
     * @param {boolean} [isBaseType] 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PhysicalTemplateTypeControllerApi
     */
    public getAllPhysicalTemplateTypes(page?: number, size?: number, sortBy?: string, sortDirection?: string, isBaseType?: boolean, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return PhysicalTemplateTypeControllerApiFp(this.configuration).getAllPhysicalTemplateTypes(page, size, sortBy, sortDirection, isBaseType, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PrescriptionFormControllerApi - axios parameter creator
 * @export
 */
export const PrescriptionFormControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Add a new prescription form into the system
         * @summary Add Prescription Form
         * @param {PrescriptionForm} prescriptionForm 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPrescriptionForm: async (prescriptionForm: PrescriptionForm, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'prescriptionForm' is not null or undefined
            assertParamExists('createPrescriptionForm', 'prescriptionForm', prescriptionForm)
            const localVarPath = `/api/master/prescription-form`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(prescriptionForm, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Generate a PDF report for a prescription form by its ID
         * @summary Generate Prescription Form PDF
         * @param {string} prescriptionFormId 
         * @param {boolean} [hasStatusChange] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generatePrescriptionFormPDF: async (prescriptionFormId: string, hasStatusChange?: boolean, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'prescriptionFormId' is not null or undefined
            assertParamExists('generatePrescriptionFormPDF', 'prescriptionFormId', prescriptionFormId)
            const localVarPath = `/api/master/prescription-form/{prescriptionFormId}/pdf`
                .replace(`{${"prescriptionFormId"}}`, encodeURIComponent(String(prescriptionFormId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (hasStatusChange !== undefined) {
                localVarQueryParameter['hasStatusChange'] = hasStatusChange;
            }

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve a prescription form by its unique ID
         * @summary Get Prescription Form by ID
         * @param {string} prescriptionFormId 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPrescriptionFormById: async (prescriptionFormId: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'prescriptionFormId' is not null or undefined
            assertParamExists('getPrescriptionFormById', 'prescriptionFormId', prescriptionFormId)
            const localVarPath = `/api/master/prescription-form/{prescriptionFormId}`
                .replace(`{${"prescriptionFormId"}}`, encodeURIComponent(String(prescriptionFormId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve a prescription form by its unique ID for printing
         * @summary Get Prescription Form for Print
         * @param {string} prescriptionFormId 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPrescriptionFormForPrint: async (prescriptionFormId: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'prescriptionFormId' is not null or undefined
            assertParamExists('getPrescriptionFormForPrint', 'prescriptionFormId', prescriptionFormId)
            const localVarPath = `/api/master/prescription-form/print/{prescriptionFormId}`
                .replace(`{${"prescriptionFormId"}}`, encodeURIComponent(String(prescriptionFormId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve all prescription forms with search and filter options
         * @summary Get Prescription Forms
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {string} [patientUuid] 
         * @param {string} [appointmentUuid] 
         * @param {boolean} [active] 
         * @param {boolean} [archive] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPrescriptionForms: async (page?: number, size?: number, sortBy?: string, sortDirection?: string, patientUuid?: string, appointmentUuid?: string, active?: boolean, archive?: boolean, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/master/prescription-form`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }

            if (patientUuid !== undefined) {
                localVarQueryParameter['patientUuid'] = patientUuid;
            }

            if (appointmentUuid !== undefined) {
                localVarQueryParameter['appointmentUuid'] = appointmentUuid;
            }

            if (active !== undefined) {
                localVarQueryParameter['active'] = active;
            }

            if (archive !== undefined) {
                localVarQueryParameter['archive'] = archive;
            }

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get the status change history for a prescription
         * @summary Get Prescription Status History
         * @param {string} prescriptionFormId 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPrescriptionStatusHistory: async (prescriptionFormId: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'prescriptionFormId' is not null or undefined
            assertParamExists('getPrescriptionStatusHistory', 'prescriptionFormId', prescriptionFormId)
            const localVarPath = `/api/master/prescription-form/{prescriptionFormId}/status-history`
                .replace(`{${"prescriptionFormId"}}`, encodeURIComponent(String(prescriptionFormId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Webhook endpoint to accept prescription status updates from pharmacy systems
         * @summary Pharmacy Status Webhook
         * @param {{ [key: string]: object; }} requestBody 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pharmacyStatusWebhook: async (requestBody: { [key: string]: object; }, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'requestBody' is not null or undefined
            assertParamExists('pharmacyStatusWebhook', 'requestBody', requestBody)
            const localVarPath = `/api/master/prescription-form/webhook/pharmacy-status`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update an existing prescription form
         * @summary Update Prescription Form
         * @param {PrescriptionForm} prescriptionForm 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePrescriptionForm: async (prescriptionForm: PrescriptionForm, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'prescriptionForm' is not null or undefined
            assertParamExists('updatePrescriptionForm', 'prescriptionForm', prescriptionForm)
            const localVarPath = `/api/master/prescription-form`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(prescriptionForm, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Archive or unarchive a prescription form by its ID
         * @summary Archive Prescription Form
         * @param {string} prescriptionFormId 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePrescriptionFormArchiveStatus: async (prescriptionFormId: string, status: boolean, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'prescriptionFormId' is not null or undefined
            assertParamExists('updatePrescriptionFormArchiveStatus', 'prescriptionFormId', prescriptionFormId)
            // verify required parameter 'status' is not null or undefined
            assertParamExists('updatePrescriptionFormArchiveStatus', 'status', status)
            const localVarPath = `/api/master/prescription-form/{prescriptionFormId}/archive-status/{status}`
                .replace(`{${"prescriptionFormId"}}`, encodeURIComponent(String(prescriptionFormId)))
                .replace(`{${"status"}}`, encodeURIComponent(String(status)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * EPRESCRIPTION_FORM_DISABLEDnable or disable a prescription form by its ID
         * @summary Update Prescription Form Status
         * @param {string} prescriptionFormId 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePrescriptionFormStatus: async (prescriptionFormId: string, status: boolean, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'prescriptionFormId' is not null or undefined
            assertParamExists('updatePrescriptionFormStatus', 'prescriptionFormId', prescriptionFormId)
            // verify required parameter 'status' is not null or undefined
            assertParamExists('updatePrescriptionFormStatus', 'status', status)
            const localVarPath = `/api/master/prescription-form/{prescriptionFormId}/status/{status}`
                .replace(`{${"prescriptionFormId"}}`, encodeURIComponent(String(prescriptionFormId)))
                .replace(`{${"status"}}`, encodeURIComponent(String(status)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update prescription status with reason and pharmacy response
         * @summary Update Prescription Status
         * @param {string} prescriptionFormId 
         * @param {UpdatePrescriptionStatusStatusEnum} status 
         * @param {string} [reason] 
         * @param {string} [pharmacyResponse] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePrescriptionStatus: async (prescriptionFormId: string, status: UpdatePrescriptionStatusStatusEnum, reason?: string, pharmacyResponse?: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'prescriptionFormId' is not null or undefined
            assertParamExists('updatePrescriptionStatus', 'prescriptionFormId', prescriptionFormId)
            // verify required parameter 'status' is not null or undefined
            assertParamExists('updatePrescriptionStatus', 'status', status)
            const localVarPath = `/api/master/prescription-form/{prescriptionFormId}/prescription-status`
                .replace(`{${"prescriptionFormId"}}`, encodeURIComponent(String(prescriptionFormId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (reason !== undefined) {
                localVarQueryParameter['reason'] = reason;
            }

            if (pharmacyResponse !== undefined) {
                localVarQueryParameter['pharmacyResponse'] = pharmacyResponse;
            }

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PrescriptionFormControllerApi - functional programming interface
 * @export
 */
export const PrescriptionFormControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PrescriptionFormControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * Add a new prescription form into the system
         * @summary Add Prescription Form
         * @param {PrescriptionForm} prescriptionForm 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createPrescriptionForm(prescriptionForm: PrescriptionForm, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createPrescriptionForm(prescriptionForm, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PrescriptionFormControllerApi.createPrescriptionForm']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Generate a PDF report for a prescription form by its ID
         * @summary Generate Prescription Form PDF
         * @param {string} prescriptionFormId 
         * @param {boolean} [hasStatusChange] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generatePrescriptionFormPDF(prescriptionFormId: string, hasStatusChange?: boolean, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generatePrescriptionFormPDF(prescriptionFormId, hasStatusChange, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PrescriptionFormControllerApi.generatePrescriptionFormPDF']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve a prescription form by its unique ID
         * @summary Get Prescription Form by ID
         * @param {string} prescriptionFormId 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPrescriptionFormById(prescriptionFormId: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPrescriptionFormById(prescriptionFormId, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PrescriptionFormControllerApi.getPrescriptionFormById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve a prescription form by its unique ID for printing
         * @summary Get Prescription Form for Print
         * @param {string} prescriptionFormId 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPrescriptionFormForPrint(prescriptionFormId: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPrescriptionFormForPrint(prescriptionFormId, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PrescriptionFormControllerApi.getPrescriptionFormForPrint']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve all prescription forms with search and filter options
         * @summary Get Prescription Forms
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {string} [patientUuid] 
         * @param {string} [appointmentUuid] 
         * @param {boolean} [active] 
         * @param {boolean} [archive] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPrescriptionForms(page?: number, size?: number, sortBy?: string, sortDirection?: string, patientUuid?: string, appointmentUuid?: string, active?: boolean, archive?: boolean, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPrescriptionForms(page, size, sortBy, sortDirection, patientUuid, appointmentUuid, active, archive, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PrescriptionFormControllerApi.getPrescriptionForms']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get the status change history for a prescription
         * @summary Get Prescription Status History
         * @param {string} prescriptionFormId 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPrescriptionStatusHistory(prescriptionFormId: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPrescriptionStatusHistory(prescriptionFormId, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PrescriptionFormControllerApi.getPrescriptionStatusHistory']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Webhook endpoint to accept prescription status updates from pharmacy systems
         * @summary Pharmacy Status Webhook
         * @param {{ [key: string]: object; }} requestBody 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pharmacyStatusWebhook(requestBody: { [key: string]: object; }, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pharmacyStatusWebhook(requestBody, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PrescriptionFormControllerApi.pharmacyStatusWebhook']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update an existing prescription form
         * @summary Update Prescription Form
         * @param {PrescriptionForm} prescriptionForm 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePrescriptionForm(prescriptionForm: PrescriptionForm, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePrescriptionForm(prescriptionForm, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PrescriptionFormControllerApi.updatePrescriptionForm']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Archive or unarchive a prescription form by its ID
         * @summary Archive Prescription Form
         * @param {string} prescriptionFormId 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePrescriptionFormArchiveStatus(prescriptionFormId: string, status: boolean, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePrescriptionFormArchiveStatus(prescriptionFormId, status, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PrescriptionFormControllerApi.updatePrescriptionFormArchiveStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * EPRESCRIPTION_FORM_DISABLEDnable or disable a prescription form by its ID
         * @summary Update Prescription Form Status
         * @param {string} prescriptionFormId 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePrescriptionFormStatus(prescriptionFormId: string, status: boolean, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePrescriptionFormStatus(prescriptionFormId, status, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PrescriptionFormControllerApi.updatePrescriptionFormStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update prescription status with reason and pharmacy response
         * @summary Update Prescription Status
         * @param {string} prescriptionFormId 
         * @param {UpdatePrescriptionStatusStatusEnum} status 
         * @param {string} [reason] 
         * @param {string} [pharmacyResponse] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePrescriptionStatus(prescriptionFormId: string, status: UpdatePrescriptionStatusStatusEnum, reason?: string, pharmacyResponse?: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePrescriptionStatus(prescriptionFormId, status, reason, pharmacyResponse, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PrescriptionFormControllerApi.updatePrescriptionStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PrescriptionFormControllerApi - factory interface
 * @export
 */
export const PrescriptionFormControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PrescriptionFormControllerApiFp(configuration)
    return {
        /**
         * Add a new prescription form into the system
         * @summary Add Prescription Form
         * @param {PrescriptionForm} prescriptionForm 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPrescriptionForm(prescriptionForm: PrescriptionForm, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.createPrescriptionForm(prescriptionForm, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Generate a PDF report for a prescription form by its ID
         * @summary Generate Prescription Form PDF
         * @param {string} prescriptionFormId 
         * @param {boolean} [hasStatusChange] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generatePrescriptionFormPDF(prescriptionFormId: string, hasStatusChange?: boolean, xTENANTID?: string, options?: any): AxiosPromise<string> {
            return localVarFp.generatePrescriptionFormPDF(prescriptionFormId, hasStatusChange, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve a prescription form by its unique ID
         * @summary Get Prescription Form by ID
         * @param {string} prescriptionFormId 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPrescriptionFormById(prescriptionFormId: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getPrescriptionFormById(prescriptionFormId, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve a prescription form by its unique ID for printing
         * @summary Get Prescription Form for Print
         * @param {string} prescriptionFormId 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPrescriptionFormForPrint(prescriptionFormId: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getPrescriptionFormForPrint(prescriptionFormId, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve all prescription forms with search and filter options
         * @summary Get Prescription Forms
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {string} [patientUuid] 
         * @param {string} [appointmentUuid] 
         * @param {boolean} [active] 
         * @param {boolean} [archive] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPrescriptionForms(page?: number, size?: number, sortBy?: string, sortDirection?: string, patientUuid?: string, appointmentUuid?: string, active?: boolean, archive?: boolean, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getPrescriptionForms(page, size, sortBy, sortDirection, patientUuid, appointmentUuid, active, archive, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Get the status change history for a prescription
         * @summary Get Prescription Status History
         * @param {string} prescriptionFormId 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPrescriptionStatusHistory(prescriptionFormId: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getPrescriptionStatusHistory(prescriptionFormId, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Webhook endpoint to accept prescription status updates from pharmacy systems
         * @summary Pharmacy Status Webhook
         * @param {{ [key: string]: object; }} requestBody 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pharmacyStatusWebhook(requestBody: { [key: string]: object; }, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.pharmacyStatusWebhook(requestBody, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Update an existing prescription form
         * @summary Update Prescription Form
         * @param {PrescriptionForm} prescriptionForm 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePrescriptionForm(prescriptionForm: PrescriptionForm, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.updatePrescriptionForm(prescriptionForm, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Archive or unarchive a prescription form by its ID
         * @summary Archive Prescription Form
         * @param {string} prescriptionFormId 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePrescriptionFormArchiveStatus(prescriptionFormId: string, status: boolean, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.updatePrescriptionFormArchiveStatus(prescriptionFormId, status, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * EPRESCRIPTION_FORM_DISABLEDnable or disable a prescription form by its ID
         * @summary Update Prescription Form Status
         * @param {string} prescriptionFormId 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePrescriptionFormStatus(prescriptionFormId: string, status: boolean, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.updatePrescriptionFormStatus(prescriptionFormId, status, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Update prescription status with reason and pharmacy response
         * @summary Update Prescription Status
         * @param {string} prescriptionFormId 
         * @param {UpdatePrescriptionStatusStatusEnum} status 
         * @param {string} [reason] 
         * @param {string} [pharmacyResponse] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePrescriptionStatus(prescriptionFormId: string, status: UpdatePrescriptionStatusStatusEnum, reason?: string, pharmacyResponse?: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.updatePrescriptionStatus(prescriptionFormId, status, reason, pharmacyResponse, xTENANTID, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PrescriptionFormControllerApi - object-oriented interface
 * @export
 * @class PrescriptionFormControllerApi
 * @extends {BaseAPI}
 */
export class PrescriptionFormControllerApi extends BaseAPI {
    /**
     * Add a new prescription form into the system
     * @summary Add Prescription Form
     * @param {PrescriptionForm} prescriptionForm 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrescriptionFormControllerApi
     */
    public createPrescriptionForm(prescriptionForm: PrescriptionForm, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return PrescriptionFormControllerApiFp(this.configuration).createPrescriptionForm(prescriptionForm, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Generate a PDF report for a prescription form by its ID
     * @summary Generate Prescription Form PDF
     * @param {string} prescriptionFormId 
     * @param {boolean} [hasStatusChange] 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrescriptionFormControllerApi
     */
    public generatePrescriptionFormPDF(prescriptionFormId: string, hasStatusChange?: boolean, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return PrescriptionFormControllerApiFp(this.configuration).generatePrescriptionFormPDF(prescriptionFormId, hasStatusChange, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve a prescription form by its unique ID
     * @summary Get Prescription Form by ID
     * @param {string} prescriptionFormId 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrescriptionFormControllerApi
     */
    public getPrescriptionFormById(prescriptionFormId: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return PrescriptionFormControllerApiFp(this.configuration).getPrescriptionFormById(prescriptionFormId, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve a prescription form by its unique ID for printing
     * @summary Get Prescription Form for Print
     * @param {string} prescriptionFormId 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrescriptionFormControllerApi
     */
    public getPrescriptionFormForPrint(prescriptionFormId: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return PrescriptionFormControllerApiFp(this.configuration).getPrescriptionFormForPrint(prescriptionFormId, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve all prescription forms with search and filter options
     * @summary Get Prescription Forms
     * @param {number} [page] 
     * @param {number} [size] 
     * @param {string} [sortBy] 
     * @param {string} [sortDirection] 
     * @param {string} [patientUuid] 
     * @param {string} [appointmentUuid] 
     * @param {boolean} [active] 
     * @param {boolean} [archive] 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrescriptionFormControllerApi
     */
    public getPrescriptionForms(page?: number, size?: number, sortBy?: string, sortDirection?: string, patientUuid?: string, appointmentUuid?: string, active?: boolean, archive?: boolean, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return PrescriptionFormControllerApiFp(this.configuration).getPrescriptionForms(page, size, sortBy, sortDirection, patientUuid, appointmentUuid, active, archive, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get the status change history for a prescription
     * @summary Get Prescription Status History
     * @param {string} prescriptionFormId 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrescriptionFormControllerApi
     */
    public getPrescriptionStatusHistory(prescriptionFormId: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return PrescriptionFormControllerApiFp(this.configuration).getPrescriptionStatusHistory(prescriptionFormId, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Webhook endpoint to accept prescription status updates from pharmacy systems
     * @summary Pharmacy Status Webhook
     * @param {{ [key: string]: object; }} requestBody 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrescriptionFormControllerApi
     */
    public pharmacyStatusWebhook(requestBody: { [key: string]: object; }, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return PrescriptionFormControllerApiFp(this.configuration).pharmacyStatusWebhook(requestBody, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update an existing prescription form
     * @summary Update Prescription Form
     * @param {PrescriptionForm} prescriptionForm 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrescriptionFormControllerApi
     */
    public updatePrescriptionForm(prescriptionForm: PrescriptionForm, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return PrescriptionFormControllerApiFp(this.configuration).updatePrescriptionForm(prescriptionForm, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Archive or unarchive a prescription form by its ID
     * @summary Archive Prescription Form
     * @param {string} prescriptionFormId 
     * @param {boolean} status 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrescriptionFormControllerApi
     */
    public updatePrescriptionFormArchiveStatus(prescriptionFormId: string, status: boolean, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return PrescriptionFormControllerApiFp(this.configuration).updatePrescriptionFormArchiveStatus(prescriptionFormId, status, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * EPRESCRIPTION_FORM_DISABLEDnable or disable a prescription form by its ID
     * @summary Update Prescription Form Status
     * @param {string} prescriptionFormId 
     * @param {boolean} status 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrescriptionFormControllerApi
     */
    public updatePrescriptionFormStatus(prescriptionFormId: string, status: boolean, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return PrescriptionFormControllerApiFp(this.configuration).updatePrescriptionFormStatus(prescriptionFormId, status, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update prescription status with reason and pharmacy response
     * @summary Update Prescription Status
     * @param {string} prescriptionFormId 
     * @param {UpdatePrescriptionStatusStatusEnum} status 
     * @param {string} [reason] 
     * @param {string} [pharmacyResponse] 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrescriptionFormControllerApi
     */
    public updatePrescriptionStatus(prescriptionFormId: string, status: UpdatePrescriptionStatusStatusEnum, reason?: string, pharmacyResponse?: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return PrescriptionFormControllerApiFp(this.configuration).updatePrescriptionStatus(prescriptionFormId, status, reason, pharmacyResponse, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const UpdatePrescriptionStatusStatusEnum = {
    Draft: 'DRAFT',
    Sent: 'SENT',
    Ordered: 'ORDERED',
    Canceled: 'CANCELED',
    Dispensed: 'DISPENSED',
    Delivered: 'DELIVERED',
    Received: 'RECEIVED',
    InProgress: 'IN_PROGRESS',
    ReadyForPickup: 'READY_FOR_PICKUP',
    PartiallyFilled: 'PARTIALLY_FILLED',
    Filled: 'FILLED',
    PickedUp: 'PICKED_UP',
    Rejected: 'REJECTED',
    Cancelled: 'CANCELLED',
    Expired: 'EXPIRED',
    OnHold: 'ON_HOLD',
    Returned: 'RETURNED',
    PriorAuthRequired: 'PRIOR_AUTH_REQUIRED',
    InsuranceRejected: 'INSURANCE_REJECTED',
    Transferred: 'TRANSFERRED',
    Discontinued: 'DISCONTINUED'
} as const;
export type UpdatePrescriptionStatusStatusEnum = typeof UpdatePrescriptionStatusStatusEnum[keyof typeof UpdatePrescriptionStatusStatusEnum];


/**
 * PrintConfigurationControllerApi - axios parameter creator
 * @export
 */
export const PrintConfigurationControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Create a print configuration for provider.
         * @summary Create Print Configuration for Provider
         * @param {PrintConfiguration} printConfiguration 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPrintConfiguration: async (printConfiguration: PrintConfiguration, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'printConfiguration' is not null or undefined
            assertParamExists('createPrintConfiguration', 'printConfiguration', printConfiguration)
            const localVarPath = `/api/master/print-configuration`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(printConfiguration, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all print configuration. 
         * @summary Get all print configuration
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {boolean} [status] 
         * @param {boolean} [isDefault] 
         * @param {boolean} [archive] 
         * @param {string} [searchString] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllPrintConfiguration: async (page?: number, size?: number, sortBy?: string, sortDirection?: string, status?: boolean, isDefault?: boolean, archive?: boolean, searchString?: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/master/print-configuration`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (isDefault !== undefined) {
                localVarQueryParameter['isDefault'] = isDefault;
            }

            if (archive !== undefined) {
                localVarQueryParameter['archive'] = archive;
            }

            if (searchString !== undefined) {
                localVarQueryParameter['searchString'] = searchString;
            }

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Set the default print configuration
         * @summary Set the default print configuration
         * @param {string} printConfigurationId 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setDefaultPrintConfiguration: async (printConfigurationId: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'printConfigurationId' is not null or undefined
            assertParamExists('setDefaultPrintConfiguration', 'printConfigurationId', printConfigurationId)
            const localVarPath = `/api/master/print-configuration/{printConfigurationId}/set-default`
                .replace(`{${"printConfigurationId"}}`, encodeURIComponent(String(printConfigurationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * update print configuration archive status from system
         * @summary update print configuration archive status
         * @param {string} printConfigurationId 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateArchiveStatus: async (printConfigurationId: string, status: boolean, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'printConfigurationId' is not null or undefined
            assertParamExists('updateArchiveStatus', 'printConfigurationId', printConfigurationId)
            // verify required parameter 'status' is not null or undefined
            assertParamExists('updateArchiveStatus', 'status', status)
            const localVarPath = `/api/master/print-configuration/{printConfigurationId}/archive-status/{status}`
                .replace(`{${"printConfigurationId"}}`, encodeURIComponent(String(printConfigurationId)))
                .replace(`{${"status"}}`, encodeURIComponent(String(status)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * update print configuration into the system
         * @summary update print configuration
         * @param {PrintConfiguration} printConfiguration 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePrintConfiguration: async (printConfiguration: PrintConfiguration, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'printConfiguration' is not null or undefined
            assertParamExists('updatePrintConfiguration', 'printConfiguration', printConfiguration)
            const localVarPath = `/api/master/print-configuration`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(printConfiguration, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * update print configuration status from system
         * @summary update print configuration status
         * @param {string} printConfigurationId 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateStatus: async (printConfigurationId: string, status: boolean, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'printConfigurationId' is not null or undefined
            assertParamExists('updateStatus', 'printConfigurationId', printConfigurationId)
            // verify required parameter 'status' is not null or undefined
            assertParamExists('updateStatus', 'status', status)
            const localVarPath = `/api/master/print-configuration/{printConfigurationId}/active/{status}`
                .replace(`{${"printConfigurationId"}}`, encodeURIComponent(String(printConfigurationId)))
                .replace(`{${"status"}}`, encodeURIComponent(String(status)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PrintConfigurationControllerApi - functional programming interface
 * @export
 */
export const PrintConfigurationControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PrintConfigurationControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * Create a print configuration for provider.
         * @summary Create Print Configuration for Provider
         * @param {PrintConfiguration} printConfiguration 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createPrintConfiguration(printConfiguration: PrintConfiguration, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createPrintConfiguration(printConfiguration, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PrintConfigurationControllerApi.createPrintConfiguration']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get all print configuration. 
         * @summary Get all print configuration
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {boolean} [status] 
         * @param {boolean} [isDefault] 
         * @param {boolean} [archive] 
         * @param {string} [searchString] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllPrintConfiguration(page?: number, size?: number, sortBy?: string, sortDirection?: string, status?: boolean, isDefault?: boolean, archive?: boolean, searchString?: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllPrintConfiguration(page, size, sortBy, sortDirection, status, isDefault, archive, searchString, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PrintConfigurationControllerApi.getAllPrintConfiguration']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Set the default print configuration
         * @summary Set the default print configuration
         * @param {string} printConfigurationId 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setDefaultPrintConfiguration(printConfigurationId: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setDefaultPrintConfiguration(printConfigurationId, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PrintConfigurationControllerApi.setDefaultPrintConfiguration']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * update print configuration archive status from system
         * @summary update print configuration archive status
         * @param {string} printConfigurationId 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateArchiveStatus(printConfigurationId: string, status: boolean, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateArchiveStatus(printConfigurationId, status, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PrintConfigurationControllerApi.updateArchiveStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * update print configuration into the system
         * @summary update print configuration
         * @param {PrintConfiguration} printConfiguration 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePrintConfiguration(printConfiguration: PrintConfiguration, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePrintConfiguration(printConfiguration, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PrintConfigurationControllerApi.updatePrintConfiguration']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * update print configuration status from system
         * @summary update print configuration status
         * @param {string} printConfigurationId 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateStatus(printConfigurationId: string, status: boolean, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateStatus(printConfigurationId, status, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PrintConfigurationControllerApi.updateStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PrintConfigurationControllerApi - factory interface
 * @export
 */
export const PrintConfigurationControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PrintConfigurationControllerApiFp(configuration)
    return {
        /**
         * Create a print configuration for provider.
         * @summary Create Print Configuration for Provider
         * @param {PrintConfiguration} printConfiguration 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPrintConfiguration(printConfiguration: PrintConfiguration, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.createPrintConfiguration(printConfiguration, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all print configuration. 
         * @summary Get all print configuration
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {boolean} [status] 
         * @param {boolean} [isDefault] 
         * @param {boolean} [archive] 
         * @param {string} [searchString] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllPrintConfiguration(page?: number, size?: number, sortBy?: string, sortDirection?: string, status?: boolean, isDefault?: boolean, archive?: boolean, searchString?: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getAllPrintConfiguration(page, size, sortBy, sortDirection, status, isDefault, archive, searchString, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Set the default print configuration
         * @summary Set the default print configuration
         * @param {string} printConfigurationId 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setDefaultPrintConfiguration(printConfigurationId: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.setDefaultPrintConfiguration(printConfigurationId, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * update print configuration archive status from system
         * @summary update print configuration archive status
         * @param {string} printConfigurationId 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateArchiveStatus(printConfigurationId: string, status: boolean, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.updateArchiveStatus(printConfigurationId, status, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * update print configuration into the system
         * @summary update print configuration
         * @param {PrintConfiguration} printConfiguration 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePrintConfiguration(printConfiguration: PrintConfiguration, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.updatePrintConfiguration(printConfiguration, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * update print configuration status from system
         * @summary update print configuration status
         * @param {string} printConfigurationId 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateStatus(printConfigurationId: string, status: boolean, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.updateStatus(printConfigurationId, status, xTENANTID, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PrintConfigurationControllerApi - object-oriented interface
 * @export
 * @class PrintConfigurationControllerApi
 * @extends {BaseAPI}
 */
export class PrintConfigurationControllerApi extends BaseAPI {
    /**
     * Create a print configuration for provider.
     * @summary Create Print Configuration for Provider
     * @param {PrintConfiguration} printConfiguration 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrintConfigurationControllerApi
     */
    public createPrintConfiguration(printConfiguration: PrintConfiguration, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return PrintConfigurationControllerApiFp(this.configuration).createPrintConfiguration(printConfiguration, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all print configuration. 
     * @summary Get all print configuration
     * @param {number} [page] 
     * @param {number} [size] 
     * @param {string} [sortBy] 
     * @param {string} [sortDirection] 
     * @param {boolean} [status] 
     * @param {boolean} [isDefault] 
     * @param {boolean} [archive] 
     * @param {string} [searchString] 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrintConfigurationControllerApi
     */
    public getAllPrintConfiguration(page?: number, size?: number, sortBy?: string, sortDirection?: string, status?: boolean, isDefault?: boolean, archive?: boolean, searchString?: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return PrintConfigurationControllerApiFp(this.configuration).getAllPrintConfiguration(page, size, sortBy, sortDirection, status, isDefault, archive, searchString, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Set the default print configuration
     * @summary Set the default print configuration
     * @param {string} printConfigurationId 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrintConfigurationControllerApi
     */
    public setDefaultPrintConfiguration(printConfigurationId: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return PrintConfigurationControllerApiFp(this.configuration).setDefaultPrintConfiguration(printConfigurationId, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * update print configuration archive status from system
     * @summary update print configuration archive status
     * @param {string} printConfigurationId 
     * @param {boolean} status 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrintConfigurationControllerApi
     */
    public updateArchiveStatus(printConfigurationId: string, status: boolean, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return PrintConfigurationControllerApiFp(this.configuration).updateArchiveStatus(printConfigurationId, status, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * update print configuration into the system
     * @summary update print configuration
     * @param {PrintConfiguration} printConfiguration 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrintConfigurationControllerApi
     */
    public updatePrintConfiguration(printConfiguration: PrintConfiguration, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return PrintConfigurationControllerApiFp(this.configuration).updatePrintConfiguration(printConfiguration, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * update print configuration status from system
     * @summary update print configuration status
     * @param {string} printConfigurationId 
     * @param {boolean} status 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrintConfigurationControllerApi
     */
    public updateStatus(printConfigurationId: string, status: boolean, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return PrintConfigurationControllerApiFp(this.configuration).updateStatus(printConfigurationId, status, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PriorAuthorizationControllerApi - axios parameter creator
 * @export
 */
export const PriorAuthorizationControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Create a new Prior Authorization with optional document upload.
         * @summary Create Prior Authorization
         * @param {string} authorizationNumber 
         * @param {Array<string>} payers 
         * @param {string} patientId 
         * @param {string} startDate 
         * @param {string} endDate 
         * @param {number} allowedVisit 
         * @param {number} warningCount 
         * @param {number} remainingVisit 
         * @param {string} [dateOfRequest] 
         * @param {string} [dateOfApproval] 
         * @param {string} [dateOfExpiration] 
         * @param {CreatePriorAuthorizationServiceTypeEnum} [serviceType] 
         * @param {CreatePriorAuthorizationAuthorizationStatusEnum} [authorizationStatus] 
         * @param {string} [notes] 
         * @param {CreatePriorAuthorizationDocumentFormatEnum} [documentFormat] 
         * @param {Array<string>} [icdCodes] 
         * @param {Array<string>} [cptCodes] 
         * @param {string} [providerId] 
         * @param {string} [encounterId] 
         * @param {string} [fileName] 
         * @param {string} [noOfUnit] 
         * @param {CreatePriorAuthorizationPlaceOfServiceEnum} [placeOfService] 
         * @param {string} [requestingProviderId] 
         * @param {string} [xTENANTID] 
         * @param {File} [attachments] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPriorAuthorization: async (authorizationNumber: string, payers: Array<string>, patientId: string, startDate: string, endDate: string, allowedVisit: number, warningCount: number, remainingVisit: number, dateOfRequest?: string, dateOfApproval?: string, dateOfExpiration?: string, serviceType?: CreatePriorAuthorizationServiceTypeEnum, authorizationStatus?: CreatePriorAuthorizationAuthorizationStatusEnum, notes?: string, documentFormat?: CreatePriorAuthorizationDocumentFormatEnum, icdCodes?: Array<string>, cptCodes?: Array<string>, providerId?: string, encounterId?: string, fileName?: string, noOfUnit?: string, placeOfService?: CreatePriorAuthorizationPlaceOfServiceEnum, requestingProviderId?: string, xTENANTID?: string, attachments?: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorizationNumber' is not null or undefined
            assertParamExists('createPriorAuthorization', 'authorizationNumber', authorizationNumber)
            // verify required parameter 'payers' is not null or undefined
            assertParamExists('createPriorAuthorization', 'payers', payers)
            // verify required parameter 'patientId' is not null or undefined
            assertParamExists('createPriorAuthorization', 'patientId', patientId)
            // verify required parameter 'startDate' is not null or undefined
            assertParamExists('createPriorAuthorization', 'startDate', startDate)
            // verify required parameter 'endDate' is not null or undefined
            assertParamExists('createPriorAuthorization', 'endDate', endDate)
            // verify required parameter 'allowedVisit' is not null or undefined
            assertParamExists('createPriorAuthorization', 'allowedVisit', allowedVisit)
            // verify required parameter 'warningCount' is not null or undefined
            assertParamExists('createPriorAuthorization', 'warningCount', warningCount)
            // verify required parameter 'remainingVisit' is not null or undefined
            assertParamExists('createPriorAuthorization', 'remainingVisit', remainingVisit)
            const localVarPath = `/api/master/prior-authorization`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (authorizationNumber !== undefined) {
                localVarQueryParameter['authorizationNumber'] = authorizationNumber;
            }

            if (dateOfRequest !== undefined) {
                localVarQueryParameter['dateOfRequest'] = (dateOfRequest as any instanceof Date) ?
                    (dateOfRequest as any).toISOString() :
                    dateOfRequest;
            }

            if (dateOfApproval !== undefined) {
                localVarQueryParameter['dateOfApproval'] = (dateOfApproval as any instanceof Date) ?
                    (dateOfApproval as any).toISOString() :
                    dateOfApproval;
            }

            if (dateOfExpiration !== undefined) {
                localVarQueryParameter['dateOfExpiration'] = (dateOfExpiration as any instanceof Date) ?
                    (dateOfExpiration as any).toISOString() :
                    dateOfExpiration;
            }

            if (serviceType !== undefined) {
                localVarQueryParameter['serviceType'] = serviceType;
            }

            if (authorizationStatus !== undefined) {
                localVarQueryParameter['authorizationStatus'] = authorizationStatus;
            }

            if (notes !== undefined) {
                localVarQueryParameter['notes'] = notes;
            }

            if (documentFormat !== undefined) {
                localVarQueryParameter['documentFormat'] = documentFormat;
            }

            if (icdCodes) {
                localVarQueryParameter['icdCodes'] = icdCodes;
            }

            if (cptCodes) {
                localVarQueryParameter['cptCodes'] = cptCodes;
            }

            if (payers) {
                localVarQueryParameter['payers'] = payers;
            }

            if (patientId !== undefined) {
                localVarQueryParameter['patientId'] = patientId;
            }

            if (providerId !== undefined) {
                localVarQueryParameter['providerId'] = providerId;
            }

            if (encounterId !== undefined) {
                localVarQueryParameter['encounterId'] = encounterId;
            }

            if (fileName !== undefined) {
                localVarQueryParameter['fileName'] = fileName;
            }

            if (noOfUnit !== undefined) {
                localVarQueryParameter['noOfUnit'] = noOfUnit;
            }

            if (placeOfService !== undefined) {
                localVarQueryParameter['placeOfService'] = placeOfService;
            }

            if (requestingProviderId !== undefined) {
                localVarQueryParameter['requestingProviderId'] = requestingProviderId;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString() :
                    startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString() :
                    endDate;
            }

            if (allowedVisit !== undefined) {
                localVarQueryParameter['allowedVisit'] = allowedVisit;
            }

            if (warningCount !== undefined) {
                localVarQueryParameter['warningCount'] = warningCount;
            }

            if (remainingVisit !== undefined) {
                localVarQueryParameter['remainingVisit'] = remainingVisit;
            }

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


            if (attachments !== undefined) { 
                localVarFormParams.append('attachments', attachments as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Generate a printable PDF form for Prior Authorization submission to clearing house.
         * @summary Generate Prior Authorization PDF
         * @param {string} priorAuthorizationId 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generatePriorAuthorizationPdf: async (priorAuthorizationId: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'priorAuthorizationId' is not null or undefined
            assertParamExists('generatePriorAuthorizationPdf', 'priorAuthorizationId', priorAuthorizationId)
            const localVarPath = `/api/master/prior-authorization/{priorAuthorizationId}/pdf`
                .replace(`{${"priorAuthorizationId"}}`, encodeURIComponent(String(priorAuthorizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all Prior Authorization list .
         * @summary Get all Prior Authorization.
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {GetAllPriorAuthorizationAuthorizationStatusEnum} [authorizationStatus] 
         * @param {boolean} [archive] 
         * @param {string} [patientId] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllPriorAuthorization: async (page?: number, size?: number, sortBy?: string, sortDirection?: string, authorizationStatus?: GetAllPriorAuthorizationAuthorizationStatusEnum, archive?: boolean, patientId?: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/master/prior-authorization`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }

            if (authorizationStatus !== undefined) {
                localVarQueryParameter['authorizationStatus'] = authorizationStatus;
            }

            if (archive !== undefined) {
                localVarQueryParameter['archive'] = archive;
            }

            if (patientId !== undefined) {
                localVarQueryParameter['patientId'] = patientId;
            }

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get Prior Authorization details by UUID with pre-signed URL for attachments.
         * @summary Get Prior Authorization by UUID
         * @param {string} priorAuthorizationId 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPriorAuthorizationById: async (priorAuthorizationId: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'priorAuthorizationId' is not null or undefined
            assertParamExists('getPriorAuthorizationById', 'priorAuthorizationId', priorAuthorizationId)
            const localVarPath = `/api/master/prior-authorization/{priorAuthorizationId}`
                .replace(`{${"priorAuthorizationId"}}`, encodeURIComponent(String(priorAuthorizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update existing Prior Authorization with optional new document upload and all fields.
         * @summary Update Prior Authorization
         * @param {string} priorAuthorizationId 
         * @param {string} [authorizationNumber] 
         * @param {string} [dateOfRequest] 
         * @param {string} [dateOfApproval] 
         * @param {string} [dateOfExpiration] 
         * @param {UpdatePriorAuthorizationServiceTypeEnum} [serviceType] 
         * @param {UpdatePriorAuthorizationAuthorizationStatusEnum} [authorizationStatus] 
         * @param {string} [notes] 
         * @param {UpdatePriorAuthorizationDocumentFormatEnum} [documentFormat] 
         * @param {Array<string>} [icdCodes] 
         * @param {Array<string>} [cptCodes] 
         * @param {Array<string>} [payers] 
         * @param {string} [patientId] 
         * @param {string} [providerId] 
         * @param {string} [encounterId] 
         * @param {string} [fileName] 
         * @param {string} [noOfUnit] 
         * @param {UpdatePriorAuthorizationPlaceOfServiceEnum} [placeOfService] 
         * @param {string} [requestingProviderId] 
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {number} [allowedVisit] 
         * @param {number} [warningCount] 
         * @param {number} [remainingVisit] 
         * @param {string} [xTENANTID] 
         * @param {File} [attachments] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePriorAuthorization: async (priorAuthorizationId: string, authorizationNumber?: string, dateOfRequest?: string, dateOfApproval?: string, dateOfExpiration?: string, serviceType?: UpdatePriorAuthorizationServiceTypeEnum, authorizationStatus?: UpdatePriorAuthorizationAuthorizationStatusEnum, notes?: string, documentFormat?: UpdatePriorAuthorizationDocumentFormatEnum, icdCodes?: Array<string>, cptCodes?: Array<string>, payers?: Array<string>, patientId?: string, providerId?: string, encounterId?: string, fileName?: string, noOfUnit?: string, placeOfService?: UpdatePriorAuthorizationPlaceOfServiceEnum, requestingProviderId?: string, startDate?: string, endDate?: string, allowedVisit?: number, warningCount?: number, remainingVisit?: number, xTENANTID?: string, attachments?: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'priorAuthorizationId' is not null or undefined
            assertParamExists('updatePriorAuthorization', 'priorAuthorizationId', priorAuthorizationId)
            const localVarPath = `/api/master/prior-authorization/{priorAuthorizationId}`
                .replace(`{${"priorAuthorizationId"}}`, encodeURIComponent(String(priorAuthorizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (authorizationNumber !== undefined) {
                localVarQueryParameter['authorizationNumber'] = authorizationNumber;
            }

            if (dateOfRequest !== undefined) {
                localVarQueryParameter['dateOfRequest'] = (dateOfRequest as any instanceof Date) ?
                    (dateOfRequest as any).toISOString() :
                    dateOfRequest;
            }

            if (dateOfApproval !== undefined) {
                localVarQueryParameter['dateOfApproval'] = (dateOfApproval as any instanceof Date) ?
                    (dateOfApproval as any).toISOString() :
                    dateOfApproval;
            }

            if (dateOfExpiration !== undefined) {
                localVarQueryParameter['dateOfExpiration'] = (dateOfExpiration as any instanceof Date) ?
                    (dateOfExpiration as any).toISOString() :
                    dateOfExpiration;
            }

            if (serviceType !== undefined) {
                localVarQueryParameter['serviceType'] = serviceType;
            }

            if (authorizationStatus !== undefined) {
                localVarQueryParameter['authorizationStatus'] = authorizationStatus;
            }

            if (notes !== undefined) {
                localVarQueryParameter['notes'] = notes;
            }

            if (documentFormat !== undefined) {
                localVarQueryParameter['documentFormat'] = documentFormat;
            }

            if (icdCodes) {
                localVarQueryParameter['icdCodes'] = icdCodes;
            }

            if (cptCodes) {
                localVarQueryParameter['cptCodes'] = cptCodes;
            }

            if (payers) {
                localVarQueryParameter['payers'] = payers;
            }

            if (patientId !== undefined) {
                localVarQueryParameter['patientId'] = patientId;
            }

            if (providerId !== undefined) {
                localVarQueryParameter['providerId'] = providerId;
            }

            if (encounterId !== undefined) {
                localVarQueryParameter['encounterId'] = encounterId;
            }

            if (fileName !== undefined) {
                localVarQueryParameter['fileName'] = fileName;
            }

            if (noOfUnit !== undefined) {
                localVarQueryParameter['noOfUnit'] = noOfUnit;
            }

            if (placeOfService !== undefined) {
                localVarQueryParameter['placeOfService'] = placeOfService;
            }

            if (requestingProviderId !== undefined) {
                localVarQueryParameter['requestingProviderId'] = requestingProviderId;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString() :
                    startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString() :
                    endDate;
            }

            if (allowedVisit !== undefined) {
                localVarQueryParameter['allowedVisit'] = allowedVisit;
            }

            if (warningCount !== undefined) {
                localVarQueryParameter['warningCount'] = warningCount;
            }

            if (remainingVisit !== undefined) {
                localVarQueryParameter['remainingVisit'] = remainingVisit;
            }

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


            if (attachments !== undefined) { 
                localVarFormParams.append('attachments', attachments as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Change Prior Authorization archive status to either archived or unarchived.
         * @summary Archive/Unarchive Prior Authorization
         * @param {string} priorAuthorizationId 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePriorAuthorizationArchiveStatus: async (priorAuthorizationId: string, status: boolean, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'priorAuthorizationId' is not null or undefined
            assertParamExists('updatePriorAuthorizationArchiveStatus', 'priorAuthorizationId', priorAuthorizationId)
            // verify required parameter 'status' is not null or undefined
            assertParamExists('updatePriorAuthorizationArchiveStatus', 'status', status)
            const localVarPath = `/api/master/prior-authorization/{priorAuthorizationId}/archive-status/{status}`
                .replace(`{${"priorAuthorizationId"}}`, encodeURIComponent(String(priorAuthorizationId)))
                .replace(`{${"status"}}`, encodeURIComponent(String(status)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Change Prior Authorization archive status to either archived or unarchived.
         * @summary Update status of Prior Authorization
         * @param {string} priorAuthorizationId 
         * @param {UpdatePriorAuthorizationStatusStatusEnum} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePriorAuthorizationStatus: async (priorAuthorizationId: string, status: UpdatePriorAuthorizationStatusStatusEnum, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'priorAuthorizationId' is not null or undefined
            assertParamExists('updatePriorAuthorizationStatus', 'priorAuthorizationId', priorAuthorizationId)
            // verify required parameter 'status' is not null or undefined
            assertParamExists('updatePriorAuthorizationStatus', 'status', status)
            const localVarPath = `/api/master/prior-authorization/{priorAuthorizationId}/{status}`
                .replace(`{${"priorAuthorizationId"}}`, encodeURIComponent(String(priorAuthorizationId)))
                .replace(`{${"status"}}`, encodeURIComponent(String(status)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PriorAuthorizationControllerApi - functional programming interface
 * @export
 */
export const PriorAuthorizationControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PriorAuthorizationControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * Create a new Prior Authorization with optional document upload.
         * @summary Create Prior Authorization
         * @param {string} authorizationNumber 
         * @param {Array<string>} payers 
         * @param {string} patientId 
         * @param {string} startDate 
         * @param {string} endDate 
         * @param {number} allowedVisit 
         * @param {number} warningCount 
         * @param {number} remainingVisit 
         * @param {string} [dateOfRequest] 
         * @param {string} [dateOfApproval] 
         * @param {string} [dateOfExpiration] 
         * @param {CreatePriorAuthorizationServiceTypeEnum} [serviceType] 
         * @param {CreatePriorAuthorizationAuthorizationStatusEnum} [authorizationStatus] 
         * @param {string} [notes] 
         * @param {CreatePriorAuthorizationDocumentFormatEnum} [documentFormat] 
         * @param {Array<string>} [icdCodes] 
         * @param {Array<string>} [cptCodes] 
         * @param {string} [providerId] 
         * @param {string} [encounterId] 
         * @param {string} [fileName] 
         * @param {string} [noOfUnit] 
         * @param {CreatePriorAuthorizationPlaceOfServiceEnum} [placeOfService] 
         * @param {string} [requestingProviderId] 
         * @param {string} [xTENANTID] 
         * @param {File} [attachments] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createPriorAuthorization(authorizationNumber: string, payers: Array<string>, patientId: string, startDate: string, endDate: string, allowedVisit: number, warningCount: number, remainingVisit: number, dateOfRequest?: string, dateOfApproval?: string, dateOfExpiration?: string, serviceType?: CreatePriorAuthorizationServiceTypeEnum, authorizationStatus?: CreatePriorAuthorizationAuthorizationStatusEnum, notes?: string, documentFormat?: CreatePriorAuthorizationDocumentFormatEnum, icdCodes?: Array<string>, cptCodes?: Array<string>, providerId?: string, encounterId?: string, fileName?: string, noOfUnit?: string, placeOfService?: CreatePriorAuthorizationPlaceOfServiceEnum, requestingProviderId?: string, xTENANTID?: string, attachments?: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createPriorAuthorization(authorizationNumber, payers, patientId, startDate, endDate, allowedVisit, warningCount, remainingVisit, dateOfRequest, dateOfApproval, dateOfExpiration, serviceType, authorizationStatus, notes, documentFormat, icdCodes, cptCodes, providerId, encounterId, fileName, noOfUnit, placeOfService, requestingProviderId, xTENANTID, attachments, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PriorAuthorizationControllerApi.createPriorAuthorization']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Generate a printable PDF form for Prior Authorization submission to clearing house.
         * @summary Generate Prior Authorization PDF
         * @param {string} priorAuthorizationId 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generatePriorAuthorizationPdf(priorAuthorizationId: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generatePriorAuthorizationPdf(priorAuthorizationId, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PriorAuthorizationControllerApi.generatePriorAuthorizationPdf']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get all Prior Authorization list .
         * @summary Get all Prior Authorization.
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {GetAllPriorAuthorizationAuthorizationStatusEnum} [authorizationStatus] 
         * @param {boolean} [archive] 
         * @param {string} [patientId] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllPriorAuthorization(page?: number, size?: number, sortBy?: string, sortDirection?: string, authorizationStatus?: GetAllPriorAuthorizationAuthorizationStatusEnum, archive?: boolean, patientId?: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllPriorAuthorization(page, size, sortBy, sortDirection, authorizationStatus, archive, patientId, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PriorAuthorizationControllerApi.getAllPriorAuthorization']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get Prior Authorization details by UUID with pre-signed URL for attachments.
         * @summary Get Prior Authorization by UUID
         * @param {string} priorAuthorizationId 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPriorAuthorizationById(priorAuthorizationId: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPriorAuthorizationById(priorAuthorizationId, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PriorAuthorizationControllerApi.getPriorAuthorizationById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update existing Prior Authorization with optional new document upload and all fields.
         * @summary Update Prior Authorization
         * @param {string} priorAuthorizationId 
         * @param {string} [authorizationNumber] 
         * @param {string} [dateOfRequest] 
         * @param {string} [dateOfApproval] 
         * @param {string} [dateOfExpiration] 
         * @param {UpdatePriorAuthorizationServiceTypeEnum} [serviceType] 
         * @param {UpdatePriorAuthorizationAuthorizationStatusEnum} [authorizationStatus] 
         * @param {string} [notes] 
         * @param {UpdatePriorAuthorizationDocumentFormatEnum} [documentFormat] 
         * @param {Array<string>} [icdCodes] 
         * @param {Array<string>} [cptCodes] 
         * @param {Array<string>} [payers] 
         * @param {string} [patientId] 
         * @param {string} [providerId] 
         * @param {string} [encounterId] 
         * @param {string} [fileName] 
         * @param {string} [noOfUnit] 
         * @param {UpdatePriorAuthorizationPlaceOfServiceEnum} [placeOfService] 
         * @param {string} [requestingProviderId] 
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {number} [allowedVisit] 
         * @param {number} [warningCount] 
         * @param {number} [remainingVisit] 
         * @param {string} [xTENANTID] 
         * @param {File} [attachments] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePriorAuthorization(priorAuthorizationId: string, authorizationNumber?: string, dateOfRequest?: string, dateOfApproval?: string, dateOfExpiration?: string, serviceType?: UpdatePriorAuthorizationServiceTypeEnum, authorizationStatus?: UpdatePriorAuthorizationAuthorizationStatusEnum, notes?: string, documentFormat?: UpdatePriorAuthorizationDocumentFormatEnum, icdCodes?: Array<string>, cptCodes?: Array<string>, payers?: Array<string>, patientId?: string, providerId?: string, encounterId?: string, fileName?: string, noOfUnit?: string, placeOfService?: UpdatePriorAuthorizationPlaceOfServiceEnum, requestingProviderId?: string, startDate?: string, endDate?: string, allowedVisit?: number, warningCount?: number, remainingVisit?: number, xTENANTID?: string, attachments?: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePriorAuthorization(priorAuthorizationId, authorizationNumber, dateOfRequest, dateOfApproval, dateOfExpiration, serviceType, authorizationStatus, notes, documentFormat, icdCodes, cptCodes, payers, patientId, providerId, encounterId, fileName, noOfUnit, placeOfService, requestingProviderId, startDate, endDate, allowedVisit, warningCount, remainingVisit, xTENANTID, attachments, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PriorAuthorizationControllerApi.updatePriorAuthorization']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Change Prior Authorization archive status to either archived or unarchived.
         * @summary Archive/Unarchive Prior Authorization
         * @param {string} priorAuthorizationId 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePriorAuthorizationArchiveStatus(priorAuthorizationId: string, status: boolean, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePriorAuthorizationArchiveStatus(priorAuthorizationId, status, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PriorAuthorizationControllerApi.updatePriorAuthorizationArchiveStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Change Prior Authorization archive status to either archived or unarchived.
         * @summary Update status of Prior Authorization
         * @param {string} priorAuthorizationId 
         * @param {UpdatePriorAuthorizationStatusStatusEnum} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePriorAuthorizationStatus(priorAuthorizationId: string, status: UpdatePriorAuthorizationStatusStatusEnum, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePriorAuthorizationStatus(priorAuthorizationId, status, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PriorAuthorizationControllerApi.updatePriorAuthorizationStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PriorAuthorizationControllerApi - factory interface
 * @export
 */
export const PriorAuthorizationControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PriorAuthorizationControllerApiFp(configuration)
    return {
        /**
         * Create a new Prior Authorization with optional document upload.
         * @summary Create Prior Authorization
         * @param {string} authorizationNumber 
         * @param {Array<string>} payers 
         * @param {string} patientId 
         * @param {string} startDate 
         * @param {string} endDate 
         * @param {number} allowedVisit 
         * @param {number} warningCount 
         * @param {number} remainingVisit 
         * @param {string} [dateOfRequest] 
         * @param {string} [dateOfApproval] 
         * @param {string} [dateOfExpiration] 
         * @param {CreatePriorAuthorizationServiceTypeEnum} [serviceType] 
         * @param {CreatePriorAuthorizationAuthorizationStatusEnum} [authorizationStatus] 
         * @param {string} [notes] 
         * @param {CreatePriorAuthorizationDocumentFormatEnum} [documentFormat] 
         * @param {Array<string>} [icdCodes] 
         * @param {Array<string>} [cptCodes] 
         * @param {string} [providerId] 
         * @param {string} [encounterId] 
         * @param {string} [fileName] 
         * @param {string} [noOfUnit] 
         * @param {CreatePriorAuthorizationPlaceOfServiceEnum} [placeOfService] 
         * @param {string} [requestingProviderId] 
         * @param {string} [xTENANTID] 
         * @param {File} [attachments] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPriorAuthorization(authorizationNumber: string, payers: Array<string>, patientId: string, startDate: string, endDate: string, allowedVisit: number, warningCount: number, remainingVisit: number, dateOfRequest?: string, dateOfApproval?: string, dateOfExpiration?: string, serviceType?: CreatePriorAuthorizationServiceTypeEnum, authorizationStatus?: CreatePriorAuthorizationAuthorizationStatusEnum, notes?: string, documentFormat?: CreatePriorAuthorizationDocumentFormatEnum, icdCodes?: Array<string>, cptCodes?: Array<string>, providerId?: string, encounterId?: string, fileName?: string, noOfUnit?: string, placeOfService?: CreatePriorAuthorizationPlaceOfServiceEnum, requestingProviderId?: string, xTENANTID?: string, attachments?: File, options?: any): AxiosPromise<Response> {
            return localVarFp.createPriorAuthorization(authorizationNumber, payers, patientId, startDate, endDate, allowedVisit, warningCount, remainingVisit, dateOfRequest, dateOfApproval, dateOfExpiration, serviceType, authorizationStatus, notes, documentFormat, icdCodes, cptCodes, providerId, encounterId, fileName, noOfUnit, placeOfService, requestingProviderId, xTENANTID, attachments, options).then((request) => request(axios, basePath));
        },
        /**
         * Generate a printable PDF form for Prior Authorization submission to clearing house.
         * @summary Generate Prior Authorization PDF
         * @param {string} priorAuthorizationId 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generatePriorAuthorizationPdf(priorAuthorizationId: string, xTENANTID?: string, options?: any): AxiosPromise<string> {
            return localVarFp.generatePriorAuthorizationPdf(priorAuthorizationId, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all Prior Authorization list .
         * @summary Get all Prior Authorization.
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {GetAllPriorAuthorizationAuthorizationStatusEnum} [authorizationStatus] 
         * @param {boolean} [archive] 
         * @param {string} [patientId] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllPriorAuthorization(page?: number, size?: number, sortBy?: string, sortDirection?: string, authorizationStatus?: GetAllPriorAuthorizationAuthorizationStatusEnum, archive?: boolean, patientId?: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getAllPriorAuthorization(page, size, sortBy, sortDirection, authorizationStatus, archive, patientId, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Get Prior Authorization details by UUID with pre-signed URL for attachments.
         * @summary Get Prior Authorization by UUID
         * @param {string} priorAuthorizationId 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPriorAuthorizationById(priorAuthorizationId: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getPriorAuthorizationById(priorAuthorizationId, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Update existing Prior Authorization with optional new document upload and all fields.
         * @summary Update Prior Authorization
         * @param {string} priorAuthorizationId 
         * @param {string} [authorizationNumber] 
         * @param {string} [dateOfRequest] 
         * @param {string} [dateOfApproval] 
         * @param {string} [dateOfExpiration] 
         * @param {UpdatePriorAuthorizationServiceTypeEnum} [serviceType] 
         * @param {UpdatePriorAuthorizationAuthorizationStatusEnum} [authorizationStatus] 
         * @param {string} [notes] 
         * @param {UpdatePriorAuthorizationDocumentFormatEnum} [documentFormat] 
         * @param {Array<string>} [icdCodes] 
         * @param {Array<string>} [cptCodes] 
         * @param {Array<string>} [payers] 
         * @param {string} [patientId] 
         * @param {string} [providerId] 
         * @param {string} [encounterId] 
         * @param {string} [fileName] 
         * @param {string} [noOfUnit] 
         * @param {UpdatePriorAuthorizationPlaceOfServiceEnum} [placeOfService] 
         * @param {string} [requestingProviderId] 
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {number} [allowedVisit] 
         * @param {number} [warningCount] 
         * @param {number} [remainingVisit] 
         * @param {string} [xTENANTID] 
         * @param {File} [attachments] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePriorAuthorization(priorAuthorizationId: string, authorizationNumber?: string, dateOfRequest?: string, dateOfApproval?: string, dateOfExpiration?: string, serviceType?: UpdatePriorAuthorizationServiceTypeEnum, authorizationStatus?: UpdatePriorAuthorizationAuthorizationStatusEnum, notes?: string, documentFormat?: UpdatePriorAuthorizationDocumentFormatEnum, icdCodes?: Array<string>, cptCodes?: Array<string>, payers?: Array<string>, patientId?: string, providerId?: string, encounterId?: string, fileName?: string, noOfUnit?: string, placeOfService?: UpdatePriorAuthorizationPlaceOfServiceEnum, requestingProviderId?: string, startDate?: string, endDate?: string, allowedVisit?: number, warningCount?: number, remainingVisit?: number, xTENANTID?: string, attachments?: File, options?: any): AxiosPromise<Response> {
            return localVarFp.updatePriorAuthorization(priorAuthorizationId, authorizationNumber, dateOfRequest, dateOfApproval, dateOfExpiration, serviceType, authorizationStatus, notes, documentFormat, icdCodes, cptCodes, payers, patientId, providerId, encounterId, fileName, noOfUnit, placeOfService, requestingProviderId, startDate, endDate, allowedVisit, warningCount, remainingVisit, xTENANTID, attachments, options).then((request) => request(axios, basePath));
        },
        /**
         * Change Prior Authorization archive status to either archived or unarchived.
         * @summary Archive/Unarchive Prior Authorization
         * @param {string} priorAuthorizationId 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePriorAuthorizationArchiveStatus(priorAuthorizationId: string, status: boolean, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.updatePriorAuthorizationArchiveStatus(priorAuthorizationId, status, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Change Prior Authorization archive status to either archived or unarchived.
         * @summary Update status of Prior Authorization
         * @param {string} priorAuthorizationId 
         * @param {UpdatePriorAuthorizationStatusStatusEnum} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePriorAuthorizationStatus(priorAuthorizationId: string, status: UpdatePriorAuthorizationStatusStatusEnum, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.updatePriorAuthorizationStatus(priorAuthorizationId, status, xTENANTID, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PriorAuthorizationControllerApi - object-oriented interface
 * @export
 * @class PriorAuthorizationControllerApi
 * @extends {BaseAPI}
 */
export class PriorAuthorizationControllerApi extends BaseAPI {
    /**
     * Create a new Prior Authorization with optional document upload.
     * @summary Create Prior Authorization
     * @param {string} authorizationNumber 
     * @param {Array<string>} payers 
     * @param {string} patientId 
     * @param {string} startDate 
     * @param {string} endDate 
     * @param {number} allowedVisit 
     * @param {number} warningCount 
     * @param {number} remainingVisit 
     * @param {string} [dateOfRequest] 
     * @param {string} [dateOfApproval] 
     * @param {string} [dateOfExpiration] 
     * @param {CreatePriorAuthorizationServiceTypeEnum} [serviceType] 
     * @param {CreatePriorAuthorizationAuthorizationStatusEnum} [authorizationStatus] 
     * @param {string} [notes] 
     * @param {CreatePriorAuthorizationDocumentFormatEnum} [documentFormat] 
     * @param {Array<string>} [icdCodes] 
     * @param {Array<string>} [cptCodes] 
     * @param {string} [providerId] 
     * @param {string} [encounterId] 
     * @param {string} [fileName] 
     * @param {string} [noOfUnit] 
     * @param {CreatePriorAuthorizationPlaceOfServiceEnum} [placeOfService] 
     * @param {string} [requestingProviderId] 
     * @param {string} [xTENANTID] 
     * @param {File} [attachments] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PriorAuthorizationControllerApi
     */
    public createPriorAuthorization(authorizationNumber: string, payers: Array<string>, patientId: string, startDate: string, endDate: string, allowedVisit: number, warningCount: number, remainingVisit: number, dateOfRequest?: string, dateOfApproval?: string, dateOfExpiration?: string, serviceType?: CreatePriorAuthorizationServiceTypeEnum, authorizationStatus?: CreatePriorAuthorizationAuthorizationStatusEnum, notes?: string, documentFormat?: CreatePriorAuthorizationDocumentFormatEnum, icdCodes?: Array<string>, cptCodes?: Array<string>, providerId?: string, encounterId?: string, fileName?: string, noOfUnit?: string, placeOfService?: CreatePriorAuthorizationPlaceOfServiceEnum, requestingProviderId?: string, xTENANTID?: string, attachments?: File, options?: RawAxiosRequestConfig) {
        return PriorAuthorizationControllerApiFp(this.configuration).createPriorAuthorization(authorizationNumber, payers, patientId, startDate, endDate, allowedVisit, warningCount, remainingVisit, dateOfRequest, dateOfApproval, dateOfExpiration, serviceType, authorizationStatus, notes, documentFormat, icdCodes, cptCodes, providerId, encounterId, fileName, noOfUnit, placeOfService, requestingProviderId, xTENANTID, attachments, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Generate a printable PDF form for Prior Authorization submission to clearing house.
     * @summary Generate Prior Authorization PDF
     * @param {string} priorAuthorizationId 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PriorAuthorizationControllerApi
     */
    public generatePriorAuthorizationPdf(priorAuthorizationId: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return PriorAuthorizationControllerApiFp(this.configuration).generatePriorAuthorizationPdf(priorAuthorizationId, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all Prior Authorization list .
     * @summary Get all Prior Authorization.
     * @param {number} [page] 
     * @param {number} [size] 
     * @param {string} [sortBy] 
     * @param {string} [sortDirection] 
     * @param {GetAllPriorAuthorizationAuthorizationStatusEnum} [authorizationStatus] 
     * @param {boolean} [archive] 
     * @param {string} [patientId] 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PriorAuthorizationControllerApi
     */
    public getAllPriorAuthorization(page?: number, size?: number, sortBy?: string, sortDirection?: string, authorizationStatus?: GetAllPriorAuthorizationAuthorizationStatusEnum, archive?: boolean, patientId?: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return PriorAuthorizationControllerApiFp(this.configuration).getAllPriorAuthorization(page, size, sortBy, sortDirection, authorizationStatus, archive, patientId, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get Prior Authorization details by UUID with pre-signed URL for attachments.
     * @summary Get Prior Authorization by UUID
     * @param {string} priorAuthorizationId 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PriorAuthorizationControllerApi
     */
    public getPriorAuthorizationById(priorAuthorizationId: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return PriorAuthorizationControllerApiFp(this.configuration).getPriorAuthorizationById(priorAuthorizationId, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update existing Prior Authorization with optional new document upload and all fields.
     * @summary Update Prior Authorization
     * @param {string} priorAuthorizationId 
     * @param {string} [authorizationNumber] 
     * @param {string} [dateOfRequest] 
     * @param {string} [dateOfApproval] 
     * @param {string} [dateOfExpiration] 
     * @param {UpdatePriorAuthorizationServiceTypeEnum} [serviceType] 
     * @param {UpdatePriorAuthorizationAuthorizationStatusEnum} [authorizationStatus] 
     * @param {string} [notes] 
     * @param {UpdatePriorAuthorizationDocumentFormatEnum} [documentFormat] 
     * @param {Array<string>} [icdCodes] 
     * @param {Array<string>} [cptCodes] 
     * @param {Array<string>} [payers] 
     * @param {string} [patientId] 
     * @param {string} [providerId] 
     * @param {string} [encounterId] 
     * @param {string} [fileName] 
     * @param {string} [noOfUnit] 
     * @param {UpdatePriorAuthorizationPlaceOfServiceEnum} [placeOfService] 
     * @param {string} [requestingProviderId] 
     * @param {string} [startDate] 
     * @param {string} [endDate] 
     * @param {number} [allowedVisit] 
     * @param {number} [warningCount] 
     * @param {number} [remainingVisit] 
     * @param {string} [xTENANTID] 
     * @param {File} [attachments] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PriorAuthorizationControllerApi
     */
    public updatePriorAuthorization(priorAuthorizationId: string, authorizationNumber?: string, dateOfRequest?: string, dateOfApproval?: string, dateOfExpiration?: string, serviceType?: UpdatePriorAuthorizationServiceTypeEnum, authorizationStatus?: UpdatePriorAuthorizationAuthorizationStatusEnum, notes?: string, documentFormat?: UpdatePriorAuthorizationDocumentFormatEnum, icdCodes?: Array<string>, cptCodes?: Array<string>, payers?: Array<string>, patientId?: string, providerId?: string, encounterId?: string, fileName?: string, noOfUnit?: string, placeOfService?: UpdatePriorAuthorizationPlaceOfServiceEnum, requestingProviderId?: string, startDate?: string, endDate?: string, allowedVisit?: number, warningCount?: number, remainingVisit?: number, xTENANTID?: string, attachments?: File, options?: RawAxiosRequestConfig) {
        return PriorAuthorizationControllerApiFp(this.configuration).updatePriorAuthorization(priorAuthorizationId, authorizationNumber, dateOfRequest, dateOfApproval, dateOfExpiration, serviceType, authorizationStatus, notes, documentFormat, icdCodes, cptCodes, payers, patientId, providerId, encounterId, fileName, noOfUnit, placeOfService, requestingProviderId, startDate, endDate, allowedVisit, warningCount, remainingVisit, xTENANTID, attachments, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Change Prior Authorization archive status to either archived or unarchived.
     * @summary Archive/Unarchive Prior Authorization
     * @param {string} priorAuthorizationId 
     * @param {boolean} status 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PriorAuthorizationControllerApi
     */
    public updatePriorAuthorizationArchiveStatus(priorAuthorizationId: string, status: boolean, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return PriorAuthorizationControllerApiFp(this.configuration).updatePriorAuthorizationArchiveStatus(priorAuthorizationId, status, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Change Prior Authorization archive status to either archived or unarchived.
     * @summary Update status of Prior Authorization
     * @param {string} priorAuthorizationId 
     * @param {UpdatePriorAuthorizationStatusStatusEnum} status 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PriorAuthorizationControllerApi
     */
    public updatePriorAuthorizationStatus(priorAuthorizationId: string, status: UpdatePriorAuthorizationStatusStatusEnum, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return PriorAuthorizationControllerApiFp(this.configuration).updatePriorAuthorizationStatus(priorAuthorizationId, status, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const CreatePriorAuthorizationServiceTypeEnum = {
    Lab: 'LAB',
    Imaging: 'IMAGING',
    Procedure: 'PROCEDURE',
    Consultation: 'CONSULTATION',
    Other: 'OTHER',
    Inpatient: 'INPATIENT',
    Outpatient: 'OUTPATIENT',
    SpecialistReferral: 'SPECIALIST_REFERRAL',
    Dme: 'DME',
    BehavioralHealth: 'BEHAVIORAL_HEALTH',
    Surgery: 'SURGERY',
    HomeHealth: 'HOME_HEALTH'
} as const;
export type CreatePriorAuthorizationServiceTypeEnum = typeof CreatePriorAuthorizationServiceTypeEnum[keyof typeof CreatePriorAuthorizationServiceTypeEnum];
/**
 * @export
 */
export const CreatePriorAuthorizationAuthorizationStatusEnum = {
    Pending: 'PENDING',
    Approved: 'APPROVED',
    PartiallyApproved: 'PARTIALLY_APPROVED',
    Denied: 'DENIED',
    Expired: 'EXPIRED',
    Cancelled: 'CANCELLED',
    Submitted: 'SUBMITTED',
    UnderReview: 'UNDER_REVIEW',
    AppealPending: 'APPEAL_PENDING',
    Active: 'ACTIVE',
    Inactive: 'INACTIVE'
} as const;
export type CreatePriorAuthorizationAuthorizationStatusEnum = typeof CreatePriorAuthorizationAuthorizationStatusEnum[keyof typeof CreatePriorAuthorizationAuthorizationStatusEnum];
/**
 * @export
 */
export const CreatePriorAuthorizationDocumentFormatEnum = {
    Pdf: 'PDF',
    MsWord: 'MS_WORD',
    Zip: 'ZIP',
    XGzip: 'X_GZIP',
    XCompressed: 'X_COMPRESSED',
    Docx: 'DOCX',
    Rtf: 'RTF',
    Plain: 'PLAIN',
    Xlsx: 'XLSX',
    JpegImage: 'JPEG_IMAGE',
    Mp4: 'MP4',
    PngImage: 'PNG_IMAGE',
    GifImage: 'GIF_IMAGE',
    BmpImage: 'BMP_IMAGE',
    WebpImage: 'WEBP_IMAGE',
    SvgImage: 'SVG_IMAGE',
    MpegAudio: 'MPEG_AUDIO',
    Other: 'OTHER',
    Csv: 'CSV'
} as const;
export type CreatePriorAuthorizationDocumentFormatEnum = typeof CreatePriorAuthorizationDocumentFormatEnum[keyof typeof CreatePriorAuthorizationDocumentFormatEnum];
/**
 * @export
 */
export const CreatePriorAuthorizationPlaceOfServiceEnum = {
    Pharmacy: 'PHARMACY',
    TelehealthOutsidePatientHome: 'TELEHEALTH_OUTSIDE_PATIENT_HOME',
    School: 'SCHOOL',
    HomelessShelter: 'HOMELESS_SHELTER',
    IndianHealthServiceFreeStandingFacility: 'INDIAN_HEALTH_SERVICE_FREE_STANDING_FACILITY',
    IndianHealthServiceProviderBasedFacility: 'INDIAN_HEALTH_SERVICE_PROVIDER_BASED_FACILITY',
    Tribal638FreeStandingFacility: 'TRIBAL_638_FREE_STANDING_FACILITY',
    Tribal638ProviderBasedFacility: 'TRIBAL_638_PROVIDER_BASED_FACILITY',
    PrisonCorrectionalFacility: 'PRISON_CORRECTIONAL_FACILITY',
    TelehealthInsidePatientHome: 'TELEHEALTH_INSIDE_PATIENT_HOME',
    Office: 'OFFICE',
    Home: 'HOME',
    AssistedLivingFacility: 'ASSISTED_LIVING_FACILITY',
    GroupHome: 'GROUP_HOME',
    MobileUnit: 'MOBILE_UNIT',
    TemporaryLodging: 'TEMPORARY_LODGING',
    WalkInRetailHealthClinic: 'WALK_IN_RETAIL_HEALTH_CLINIC',
    PlaceOfEmploymentWorksite: 'PLACE_OF_EMPLOYMENT_WORKSITE',
    OffCampusOutpatientHospital: 'OFF_CAMPUS_OUTPATIENT_HOSPITAL',
    UrgentCareFacility: 'URGENT_CARE_FACILITY',
    InpatientHospital: 'INPATIENT_HOSPITAL',
    OutpatientHospital: 'OUTPATIENT_HOSPITAL',
    EmergencyRoomHospital: 'EMERGENCY_ROOM_HOSPITAL',
    AmbulatorySurgicalCenter: 'AMBULATORY_SURGICAL_CENTER',
    BirthingCenter: 'BIRTHING_CENTER',
    MilitaryTreatmentFacility: 'MILITARY_TREATMENT_FACILITY',
    SkilledNursingFacility: 'SKILLED_NURSING_FACILITY',
    NursingFacility: 'NURSING_FACILITY',
    CustodialCareFacility: 'CUSTODIAL_CARE_FACILITY',
    Hospice: 'HOSPICE',
    AmbulanceLand: 'AMBULANCE_LAND',
    AmbulanceAirOrWater: 'AMBULANCE_AIR_OR_WATER',
    IndependentClinic: 'INDEPENDENT_CLINIC',
    FederallyQualifiedHealthCenter: 'FEDERALLY_QUALIFIED_HEALTH_CENTER',
    InpatientPsychiatricFacility: 'INPATIENT_PSYCHIATRIC_FACILITY',
    PsychiatricFacilityPartialHospitalization: 'PSYCHIATRIC_FACILITY_PARTIAL_HOSPITALIZATION',
    CommunityMentalHealthCenter: 'COMMUNITY_MENTAL_HEALTH_CENTER',
    IntermediateCareFacilityIntellectualDisabilities: 'INTERMEDIATE_CARE_FACILITY_INTELLECTUAL_DISABILITIES',
    ResidentialSubstanceAbuseTreatmentFacility: 'RESIDENTIAL_SUBSTANCE_ABUSE_TREATMENT_FACILITY',
    PsychiatricResidentialTreatmentCenter: 'PSYCHIATRIC_RESIDENTIAL_TREATMENT_CENTER',
    NonResidentialSubstanceAbuseTreatmentFacility: 'NON_RESIDENTIAL_SUBSTANCE_ABUSE_TREATMENT_FACILITY',
    NonResidentialOpioidTreatmentFacility: 'NON_RESIDENTIAL_OPIOID_TREATMENT_FACILITY',
    MassImmunizationCenter: 'MASS_IMMUNIZATION_CENTER',
    ComprehensiveInpatientRehabilitationFacility: 'COMPREHENSIVE_INPATIENT_REHABILITATION_FACILITY',
    ComprehensiveOutpatientRehabilitationFacility: 'COMPREHENSIVE_OUTPATIENT_REHABILITATION_FACILITY',
    EndStageRenalDiseaseTreatmentFacility: 'END_STAGE_RENAL_DISEASE_TREATMENT_FACILITY',
    PublicHealthClinic: 'PUBLIC_HEALTH_CLINIC',
    RuralHealthClinic: 'RURAL_HEALTH_CLINIC',
    IndependentLaboratory: 'INDEPENDENT_LABORATORY',
    OtherPlaceOfService: 'OTHER_PLACE_OF_SERVICE'
} as const;
export type CreatePriorAuthorizationPlaceOfServiceEnum = typeof CreatePriorAuthorizationPlaceOfServiceEnum[keyof typeof CreatePriorAuthorizationPlaceOfServiceEnum];
/**
 * @export
 */
export const GetAllPriorAuthorizationAuthorizationStatusEnum = {
    Pending: 'PENDING',
    Approved: 'APPROVED',
    PartiallyApproved: 'PARTIALLY_APPROVED',
    Denied: 'DENIED',
    Expired: 'EXPIRED',
    Cancelled: 'CANCELLED',
    Submitted: 'SUBMITTED',
    UnderReview: 'UNDER_REVIEW',
    AppealPending: 'APPEAL_PENDING',
    Active: 'ACTIVE',
    Inactive: 'INACTIVE'
} as const;
export type GetAllPriorAuthorizationAuthorizationStatusEnum = typeof GetAllPriorAuthorizationAuthorizationStatusEnum[keyof typeof GetAllPriorAuthorizationAuthorizationStatusEnum];
/**
 * @export
 */
export const UpdatePriorAuthorizationServiceTypeEnum = {
    Lab: 'LAB',
    Imaging: 'IMAGING',
    Procedure: 'PROCEDURE',
    Consultation: 'CONSULTATION',
    Other: 'OTHER',
    Inpatient: 'INPATIENT',
    Outpatient: 'OUTPATIENT',
    SpecialistReferral: 'SPECIALIST_REFERRAL',
    Dme: 'DME',
    BehavioralHealth: 'BEHAVIORAL_HEALTH',
    Surgery: 'SURGERY',
    HomeHealth: 'HOME_HEALTH'
} as const;
export type UpdatePriorAuthorizationServiceTypeEnum = typeof UpdatePriorAuthorizationServiceTypeEnum[keyof typeof UpdatePriorAuthorizationServiceTypeEnum];
/**
 * @export
 */
export const UpdatePriorAuthorizationAuthorizationStatusEnum = {
    Pending: 'PENDING',
    Approved: 'APPROVED',
    PartiallyApproved: 'PARTIALLY_APPROVED',
    Denied: 'DENIED',
    Expired: 'EXPIRED',
    Cancelled: 'CANCELLED',
    Submitted: 'SUBMITTED',
    UnderReview: 'UNDER_REVIEW',
    AppealPending: 'APPEAL_PENDING',
    Active: 'ACTIVE',
    Inactive: 'INACTIVE'
} as const;
export type UpdatePriorAuthorizationAuthorizationStatusEnum = typeof UpdatePriorAuthorizationAuthorizationStatusEnum[keyof typeof UpdatePriorAuthorizationAuthorizationStatusEnum];
/**
 * @export
 */
export const UpdatePriorAuthorizationDocumentFormatEnum = {
    Pdf: 'PDF',
    MsWord: 'MS_WORD',
    Zip: 'ZIP',
    XGzip: 'X_GZIP',
    XCompressed: 'X_COMPRESSED',
    Docx: 'DOCX',
    Rtf: 'RTF',
    Plain: 'PLAIN',
    Xlsx: 'XLSX',
    JpegImage: 'JPEG_IMAGE',
    Mp4: 'MP4',
    PngImage: 'PNG_IMAGE',
    GifImage: 'GIF_IMAGE',
    BmpImage: 'BMP_IMAGE',
    WebpImage: 'WEBP_IMAGE',
    SvgImage: 'SVG_IMAGE',
    MpegAudio: 'MPEG_AUDIO',
    Other: 'OTHER',
    Csv: 'CSV'
} as const;
export type UpdatePriorAuthorizationDocumentFormatEnum = typeof UpdatePriorAuthorizationDocumentFormatEnum[keyof typeof UpdatePriorAuthorizationDocumentFormatEnum];
/**
 * @export
 */
export const UpdatePriorAuthorizationPlaceOfServiceEnum = {
    Pharmacy: 'PHARMACY',
    TelehealthOutsidePatientHome: 'TELEHEALTH_OUTSIDE_PATIENT_HOME',
    School: 'SCHOOL',
    HomelessShelter: 'HOMELESS_SHELTER',
    IndianHealthServiceFreeStandingFacility: 'INDIAN_HEALTH_SERVICE_FREE_STANDING_FACILITY',
    IndianHealthServiceProviderBasedFacility: 'INDIAN_HEALTH_SERVICE_PROVIDER_BASED_FACILITY',
    Tribal638FreeStandingFacility: 'TRIBAL_638_FREE_STANDING_FACILITY',
    Tribal638ProviderBasedFacility: 'TRIBAL_638_PROVIDER_BASED_FACILITY',
    PrisonCorrectionalFacility: 'PRISON_CORRECTIONAL_FACILITY',
    TelehealthInsidePatientHome: 'TELEHEALTH_INSIDE_PATIENT_HOME',
    Office: 'OFFICE',
    Home: 'HOME',
    AssistedLivingFacility: 'ASSISTED_LIVING_FACILITY',
    GroupHome: 'GROUP_HOME',
    MobileUnit: 'MOBILE_UNIT',
    TemporaryLodging: 'TEMPORARY_LODGING',
    WalkInRetailHealthClinic: 'WALK_IN_RETAIL_HEALTH_CLINIC',
    PlaceOfEmploymentWorksite: 'PLACE_OF_EMPLOYMENT_WORKSITE',
    OffCampusOutpatientHospital: 'OFF_CAMPUS_OUTPATIENT_HOSPITAL',
    UrgentCareFacility: 'URGENT_CARE_FACILITY',
    InpatientHospital: 'INPATIENT_HOSPITAL',
    OutpatientHospital: 'OUTPATIENT_HOSPITAL',
    EmergencyRoomHospital: 'EMERGENCY_ROOM_HOSPITAL',
    AmbulatorySurgicalCenter: 'AMBULATORY_SURGICAL_CENTER',
    BirthingCenter: 'BIRTHING_CENTER',
    MilitaryTreatmentFacility: 'MILITARY_TREATMENT_FACILITY',
    SkilledNursingFacility: 'SKILLED_NURSING_FACILITY',
    NursingFacility: 'NURSING_FACILITY',
    CustodialCareFacility: 'CUSTODIAL_CARE_FACILITY',
    Hospice: 'HOSPICE',
    AmbulanceLand: 'AMBULANCE_LAND',
    AmbulanceAirOrWater: 'AMBULANCE_AIR_OR_WATER',
    IndependentClinic: 'INDEPENDENT_CLINIC',
    FederallyQualifiedHealthCenter: 'FEDERALLY_QUALIFIED_HEALTH_CENTER',
    InpatientPsychiatricFacility: 'INPATIENT_PSYCHIATRIC_FACILITY',
    PsychiatricFacilityPartialHospitalization: 'PSYCHIATRIC_FACILITY_PARTIAL_HOSPITALIZATION',
    CommunityMentalHealthCenter: 'COMMUNITY_MENTAL_HEALTH_CENTER',
    IntermediateCareFacilityIntellectualDisabilities: 'INTERMEDIATE_CARE_FACILITY_INTELLECTUAL_DISABILITIES',
    ResidentialSubstanceAbuseTreatmentFacility: 'RESIDENTIAL_SUBSTANCE_ABUSE_TREATMENT_FACILITY',
    PsychiatricResidentialTreatmentCenter: 'PSYCHIATRIC_RESIDENTIAL_TREATMENT_CENTER',
    NonResidentialSubstanceAbuseTreatmentFacility: 'NON_RESIDENTIAL_SUBSTANCE_ABUSE_TREATMENT_FACILITY',
    NonResidentialOpioidTreatmentFacility: 'NON_RESIDENTIAL_OPIOID_TREATMENT_FACILITY',
    MassImmunizationCenter: 'MASS_IMMUNIZATION_CENTER',
    ComprehensiveInpatientRehabilitationFacility: 'COMPREHENSIVE_INPATIENT_REHABILITATION_FACILITY',
    ComprehensiveOutpatientRehabilitationFacility: 'COMPREHENSIVE_OUTPATIENT_REHABILITATION_FACILITY',
    EndStageRenalDiseaseTreatmentFacility: 'END_STAGE_RENAL_DISEASE_TREATMENT_FACILITY',
    PublicHealthClinic: 'PUBLIC_HEALTH_CLINIC',
    RuralHealthClinic: 'RURAL_HEALTH_CLINIC',
    IndependentLaboratory: 'INDEPENDENT_LABORATORY',
    OtherPlaceOfService: 'OTHER_PLACE_OF_SERVICE'
} as const;
export type UpdatePriorAuthorizationPlaceOfServiceEnum = typeof UpdatePriorAuthorizationPlaceOfServiceEnum[keyof typeof UpdatePriorAuthorizationPlaceOfServiceEnum];
/**
 * @export
 */
export const UpdatePriorAuthorizationStatusStatusEnum = {
    Pending: 'PENDING',
    Approved: 'APPROVED',
    PartiallyApproved: 'PARTIALLY_APPROVED',
    Denied: 'DENIED',
    Expired: 'EXPIRED',
    Cancelled: 'CANCELLED',
    Submitted: 'SUBMITTED',
    UnderReview: 'UNDER_REVIEW',
    AppealPending: 'APPEAL_PENDING',
    Active: 'ACTIVE',
    Inactive: 'INACTIVE'
} as const;
export type UpdatePriorAuthorizationStatusStatusEnum = typeof UpdatePriorAuthorizationStatusStatusEnum[keyof typeof UpdatePriorAuthorizationStatusStatusEnum];


/**
 * ProblemsControllerApi - axios parameter creator
 * @export
 */
export const ProblemsControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get all Problems list.
         * @summary Get all Problems.
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {string} [searchString] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllSpecialities1: async (page?: number, size?: number, sortBy?: string, sortDirection?: string, searchString?: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/master/problems`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }

            if (searchString !== undefined) {
                localVarQueryParameter['searchString'] = searchString;
            }

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProblemsControllerApi - functional programming interface
 * @export
 */
export const ProblemsControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ProblemsControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * Get all Problems list.
         * @summary Get all Problems.
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {string} [searchString] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllSpecialities1(page?: number, size?: number, sortBy?: string, sortDirection?: string, searchString?: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllSpecialities1(page, size, sortBy, sortDirection, searchString, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProblemsControllerApi.getAllSpecialities1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ProblemsControllerApi - factory interface
 * @export
 */
export const ProblemsControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ProblemsControllerApiFp(configuration)
    return {
        /**
         * Get all Problems list.
         * @summary Get all Problems.
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {string} [searchString] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllSpecialities1(page?: number, size?: number, sortBy?: string, sortDirection?: string, searchString?: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getAllSpecialities1(page, size, sortBy, sortDirection, searchString, xTENANTID, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ProblemsControllerApi - object-oriented interface
 * @export
 * @class ProblemsControllerApi
 * @extends {BaseAPI}
 */
export class ProblemsControllerApi extends BaseAPI {
    /**
     * Get all Problems list.
     * @summary Get all Problems.
     * @param {number} [page] 
     * @param {number} [size] 
     * @param {string} [sortBy] 
     * @param {string} [sortDirection] 
     * @param {string} [searchString] 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProblemsControllerApi
     */
    public getAllSpecialities1(page?: number, size?: number, sortBy?: string, sortDirection?: string, searchString?: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return ProblemsControllerApiFp(this.configuration).getAllSpecialities1(page, size, sortBy, sortDirection, searchString, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ProviderAccountDetailControllerApi - axios parameter creator
 * @export
 */
export const ProviderAccountDetailControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get all provider account detail
         * @summary Get all provider account detail.
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {string} [providerId] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllProviderAccountDetail: async (page?: number, size?: number, sortBy?: string, sortDirection?: string, providerId?: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/master/provider-account-detail`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }

            if (providerId !== undefined) {
                localVarQueryParameter['providerId'] = providerId;
            }

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProviderAccountDetailControllerApi - functional programming interface
 * @export
 */
export const ProviderAccountDetailControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ProviderAccountDetailControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * Get all provider account detail
         * @summary Get all provider account detail.
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {string} [providerId] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllProviderAccountDetail(page?: number, size?: number, sortBy?: string, sortDirection?: string, providerId?: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllProviderAccountDetail(page, size, sortBy, sortDirection, providerId, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProviderAccountDetailControllerApi.getAllProviderAccountDetail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ProviderAccountDetailControllerApi - factory interface
 * @export
 */
export const ProviderAccountDetailControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ProviderAccountDetailControllerApiFp(configuration)
    return {
        /**
         * Get all provider account detail
         * @summary Get all provider account detail.
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {string} [providerId] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllProviderAccountDetail(page?: number, size?: number, sortBy?: string, sortDirection?: string, providerId?: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getAllProviderAccountDetail(page, size, sortBy, sortDirection, providerId, xTENANTID, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ProviderAccountDetailControllerApi - object-oriented interface
 * @export
 * @class ProviderAccountDetailControllerApi
 * @extends {BaseAPI}
 */
export class ProviderAccountDetailControllerApi extends BaseAPI {
    /**
     * Get all provider account detail
     * @summary Get all provider account detail.
     * @param {number} [page] 
     * @param {number} [size] 
     * @param {string} [sortBy] 
     * @param {string} [sortDirection] 
     * @param {string} [providerId] 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProviderAccountDetailControllerApi
     */
    public getAllProviderAccountDetail(page?: number, size?: number, sortBy?: string, sortDirection?: string, providerId?: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return ProviderAccountDetailControllerApiFp(this.configuration).getAllProviderAccountDetail(page, size, sortBy, sortDirection, providerId, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ProviderControllerApi - axios parameter creator
 * @export
 */
export const ProviderControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * To assign provider to the particular location
         * @summary Assign provider to Location
         * @param {string} providerId 
         * @param {string} locationId 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignDProviderToLocation: async (providerId: string, locationId: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'providerId' is not null or undefined
            assertParamExists('assignDProviderToLocation', 'providerId', providerId)
            // verify required parameter 'locationId' is not null or undefined
            assertParamExists('assignDProviderToLocation', 'locationId', locationId)
            const localVarPath = `/api/master/provider/{providerId}/location/{locationId}`
                .replace(`{${"providerId"}}`, encodeURIComponent(String(providerId)))
                .replace(`{${"locationId"}}`, encodeURIComponent(String(locationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Change provider avatar
         * @summary Change Avatar
         * @param {ChangeAvatarRequest} changeAvatarRequest 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeAvatar: async (changeAvatarRequest: ChangeAvatarRequest, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'changeAvatarRequest' is not null or undefined
            assertParamExists('changeAvatar', 'changeAvatarRequest', changeAvatarRequest)
            const localVarPath = `/api/master/provider/change-provider-avatar`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(changeAvatarRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Add a new Provider User into the system
         * @summary Add Provider User
         * @param {Provider} provider 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createProvider: async (provider: Provider, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'provider' is not null or undefined
            assertParamExists('createProvider', 'provider', provider)
            const localVarPath = `/api/master/provider`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(provider, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all providers list with search option on firstName, lastName, npi and filter options on status, archive and state. 
         * @summary Get all providers
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {boolean} [status] 
         * @param {boolean} [archive] 
         * @param {boolean} [isReferral] 
         * @param {string} [state] 
         * @param {GetAllProvidersRoleEnum} [role] 
         * @param {string} [speciality] 
         * @param {string} [locationUuid] 
         * @param {string} [searchString] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllProviders: async (page?: number, size?: number, sortBy?: string, sortDirection?: string, status?: boolean, archive?: boolean, isReferral?: boolean, state?: string, role?: GetAllProvidersRoleEnum, speciality?: string, locationUuid?: string, searchString?: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/master/provider`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (archive !== undefined) {
                localVarQueryParameter['archive'] = archive;
            }

            if (isReferral !== undefined) {
                localVarQueryParameter['isReferral'] = isReferral;
            }

            if (state !== undefined) {
                localVarQueryParameter['state'] = state;
            }

            if (role !== undefined) {
                localVarQueryParameter['role'] = role;
            }

            if (speciality !== undefined) {
                localVarQueryParameter['speciality'] = speciality;
            }

            if (locationUuid !== undefined) {
                localVarQueryParameter['locationUuid'] = locationUuid;
            }

            if (searchString !== undefined) {
                localVarQueryParameter['searchString'] = searchString;
            }

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all providers list. Optional filters: isReferral, active, archive.
         * @summary Get all providers name and id
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {string} [searchString] 
         * @param {boolean} [isReferral] 
         * @param {boolean} [status] 
         * @param {boolean} [archive] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllProvidersNameAndId: async (page?: number, size?: number, sortBy?: string, sortDirection?: string, searchString?: string, isReferral?: boolean, status?: boolean, archive?: boolean, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/master/provider/get-providers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }

            if (searchString !== undefined) {
                localVarQueryParameter['searchString'] = searchString;
            }

            if (isReferral !== undefined) {
                localVarQueryParameter['isReferral'] = isReferral;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (archive !== undefined) {
                localVarQueryParameter['archive'] = archive;
            }

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all roles that can be assigned to providers
         * @summary Get Available Provider Roles
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAvailableProviderRoles: async (xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/master/provider/available-roles`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get provider profile
         * @summary Get provider profile
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProfile: async (xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/master/provider/profile`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fast provider profile with only essential fields — no eager loading
         * @summary Get lightweight provider profile
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProfileLight: async (xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/master/provider/profile-light`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get provider by providerUuid
         * @summary Get provider by providerUuid.
         * @param {string} providerUuid 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProviderById: async (providerUuid: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'providerUuid' is not null or undefined
            assertParamExists('getProviderById', 'providerUuid', providerUuid)
            const localVarPath = `/api/master/provider/{providerUuid}`
                .replace(`{${"providerUuid"}}`, encodeURIComponent(String(providerUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {string} [searchString] 
         * @param {boolean} [archive] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProviderList: async (page?: number, size?: number, sortBy?: string, sortDirection?: string, searchString?: string, archive?: boolean, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/master/provider/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }

            if (searchString !== undefined) {
                localVarQueryParameter['searchString'] = searchString;
            }

            if (archive !== undefined) {
                localVarQueryParameter['archive'] = archive;
            }

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get list of providers with UUID as key and IAM ID as value
         * @summary Get Provider UUID and IAM ID List
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProviderUuidAndIamIdList: async (xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/master/provider/provider-list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns active providers excluding the logged-in user. Lightweight response: uuid, email, firstName, lastName.
         * @summary Get providers for task reassignment
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [searchString] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProvidersForReassign: async (page?: number, size?: number, searchString?: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/master/provider/reassign-list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (searchString !== undefined) {
                localVarQueryParameter['searchString'] = searchString;
            }

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Public provider profile for the website widget: name, avatar, gender, dob, specialities, bio and accepted insurances.
         * @summary Get provider profile for the website widget
         * @param {string} providerUuid 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWidgetProviderById: async (providerUuid: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'providerUuid' is not null or undefined
            assertParamExists('getWidgetProviderById', 'providerUuid', providerUuid)
            const localVarPath = `/api/master/provider/widget-profile/{providerUuid}`
                .replace(`{${"providerUuid"}}`, encodeURIComponent(String(providerUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Public uuid-and-name map of active providers for the website widget provider filter dropdown.
         * @summary Get provider options for the website widget
         * @param {Array<string>} [speciality] 
         * @param {string} [locationUuid] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWidgetProviderOptions: async (speciality?: Array<string>, locationUuid?: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/master/provider/widget-provider-lite`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (speciality) {
                localVarQueryParameter['speciality'] = speciality;
            }

            if (locationUuid !== undefined) {
                localVarQueryParameter['locationUuid'] = locationUuid;
            }

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Public lightweight provider list for the website widget, filterable by location (single), specialities and providers (multi). Returns active providers only with uuid, name, avatar, dob, specialities and locations.
         * @summary Get providers for the website widget
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {Array<string>} [speciality] 
         * @param {Array<string>} [providerUuid] 
         * @param {string} [locationUuid] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWidgetProviders: async (page?: number, size?: number, speciality?: Array<string>, providerUuid?: Array<string>, locationUuid?: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/master/provider/widget-providers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (speciality) {
                localVarQueryParameter['speciality'] = speciality;
            }

            if (providerUuid) {
                localVarQueryParameter['providerUuid'] = providerUuid;
            }

            if (locationUuid !== undefined) {
                localVarQueryParameter['locationUuid'] = locationUuid;
            }

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Edit Provider with editable fields as firstName, lastName, phone, providerType, gender, npi, federalTaxIdNumber, deaNumber, officeFaxNumber, licenseNumber, groupNpiNumber, taxonomyNumber, workLocations, acceptedInsurances, specialities, hospitalAffiliation, experience, acceptCash, providerEmployment, workExperience, bio.
         * @summary Update provider
         * @param {Provider} provider 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProvider: async (provider: Provider, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'provider' is not null or undefined
            assertParamExists('updateProvider', 'provider', provider)
            const localVarPath = `/api/master/provider`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(provider, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Change Provider archive status to either archived or unarchived.
         * @summary Archive/Unarchive Provider
         * @param {string} providerId 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProviderArchiveStatus: async (providerId: string, status: boolean, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'providerId' is not null or undefined
            assertParamExists('updateProviderArchiveStatus', 'providerId', providerId)
            // verify required parameter 'status' is not null or undefined
            assertParamExists('updateProviderArchiveStatus', 'status', status)
            const localVarPath = `/api/master/provider/{providerId}/archive-status/{status}`
                .replace(`{${"providerId"}}`, encodeURIComponent(String(providerId)))
                .replace(`{${"status"}}`, encodeURIComponent(String(status)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Change Provider status to either active or inactive.
         * @summary Enable/Disable provider
         * @param {string} providerId 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProviderStatus: async (providerId: string, status: boolean, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'providerId' is not null or undefined
            assertParamExists('updateProviderStatus', 'providerId', providerId)
            // verify required parameter 'status' is not null or undefined
            assertParamExists('updateProviderStatus', 'status', status)
            const localVarPath = `/api/master/provider/{providerId}/status/{status}`
                .replace(`{${"providerId"}}`, encodeURIComponent(String(providerId)))
                .replace(`{${"status"}}`, encodeURIComponent(String(status)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProviderControllerApi - functional programming interface
 * @export
 */
export const ProviderControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ProviderControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * To assign provider to the particular location
         * @summary Assign provider to Location
         * @param {string} providerId 
         * @param {string} locationId 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assignDProviderToLocation(providerId: string, locationId: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assignDProviderToLocation(providerId, locationId, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProviderControllerApi.assignDProviderToLocation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Change provider avatar
         * @summary Change Avatar
         * @param {ChangeAvatarRequest} changeAvatarRequest 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async changeAvatar(changeAvatarRequest: ChangeAvatarRequest, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.changeAvatar(changeAvatarRequest, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProviderControllerApi.changeAvatar']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Add a new Provider User into the system
         * @summary Add Provider User
         * @param {Provider} provider 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createProvider(provider: Provider, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createProvider(provider, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProviderControllerApi.createProvider']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get all providers list with search option on firstName, lastName, npi and filter options on status, archive and state. 
         * @summary Get all providers
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {boolean} [status] 
         * @param {boolean} [archive] 
         * @param {boolean} [isReferral] 
         * @param {string} [state] 
         * @param {GetAllProvidersRoleEnum} [role] 
         * @param {string} [speciality] 
         * @param {string} [locationUuid] 
         * @param {string} [searchString] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllProviders(page?: number, size?: number, sortBy?: string, sortDirection?: string, status?: boolean, archive?: boolean, isReferral?: boolean, state?: string, role?: GetAllProvidersRoleEnum, speciality?: string, locationUuid?: string, searchString?: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllProviders(page, size, sortBy, sortDirection, status, archive, isReferral, state, role, speciality, locationUuid, searchString, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProviderControllerApi.getAllProviders']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get all providers list. Optional filters: isReferral, active, archive.
         * @summary Get all providers name and id
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {string} [searchString] 
         * @param {boolean} [isReferral] 
         * @param {boolean} [status] 
         * @param {boolean} [archive] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllProvidersNameAndId(page?: number, size?: number, sortBy?: string, sortDirection?: string, searchString?: string, isReferral?: boolean, status?: boolean, archive?: boolean, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllProvidersNameAndId(page, size, sortBy, sortDirection, searchString, isReferral, status, archive, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProviderControllerApi.getAllProvidersNameAndId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get all roles that can be assigned to providers
         * @summary Get Available Provider Roles
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAvailableProviderRoles(xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAvailableProviderRoles(xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProviderControllerApi.getAvailableProviderRoles']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get provider profile
         * @summary Get provider profile
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProfile(xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProfile(xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProviderControllerApi.getProfile']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Fast provider profile with only essential fields — no eager loading
         * @summary Get lightweight provider profile
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProfileLight(xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProfileLight(xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProviderControllerApi.getProfileLight']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get provider by providerUuid
         * @summary Get provider by providerUuid.
         * @param {string} providerUuid 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProviderById(providerUuid: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProviderById(providerUuid, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProviderControllerApi.getProviderById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {string} [searchString] 
         * @param {boolean} [archive] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProviderList(page?: number, size?: number, sortBy?: string, sortDirection?: string, searchString?: string, archive?: boolean, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProviderList(page, size, sortBy, sortDirection, searchString, archive, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProviderControllerApi.getProviderList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get list of providers with UUID as key and IAM ID as value
         * @summary Get Provider UUID and IAM ID List
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProviderUuidAndIamIdList(xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProviderUuidAndIamIdList(xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProviderControllerApi.getProviderUuidAndIamIdList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns active providers excluding the logged-in user. Lightweight response: uuid, email, firstName, lastName.
         * @summary Get providers for task reassignment
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [searchString] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProvidersForReassign(page?: number, size?: number, searchString?: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProvidersForReassign(page, size, searchString, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProviderControllerApi.getProvidersForReassign']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Public provider profile for the website widget: name, avatar, gender, dob, specialities, bio and accepted insurances.
         * @summary Get provider profile for the website widget
         * @param {string} providerUuid 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWidgetProviderById(providerUuid: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWidgetProviderById(providerUuid, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProviderControllerApi.getWidgetProviderById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Public uuid-and-name map of active providers for the website widget provider filter dropdown.
         * @summary Get provider options for the website widget
         * @param {Array<string>} [speciality] 
         * @param {string} [locationUuid] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWidgetProviderOptions(speciality?: Array<string>, locationUuid?: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWidgetProviderOptions(speciality, locationUuid, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProviderControllerApi.getWidgetProviderOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Public lightweight provider list for the website widget, filterable by location (single), specialities and providers (multi). Returns active providers only with uuid, name, avatar, dob, specialities and locations.
         * @summary Get providers for the website widget
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {Array<string>} [speciality] 
         * @param {Array<string>} [providerUuid] 
         * @param {string} [locationUuid] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWidgetProviders(page?: number, size?: number, speciality?: Array<string>, providerUuid?: Array<string>, locationUuid?: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWidgetProviders(page, size, speciality, providerUuid, locationUuid, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProviderControllerApi.getWidgetProviders']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Edit Provider with editable fields as firstName, lastName, phone, providerType, gender, npi, federalTaxIdNumber, deaNumber, officeFaxNumber, licenseNumber, groupNpiNumber, taxonomyNumber, workLocations, acceptedInsurances, specialities, hospitalAffiliation, experience, acceptCash, providerEmployment, workExperience, bio.
         * @summary Update provider
         * @param {Provider} provider 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateProvider(provider: Provider, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateProvider(provider, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProviderControllerApi.updateProvider']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Change Provider archive status to either archived or unarchived.
         * @summary Archive/Unarchive Provider
         * @param {string} providerId 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateProviderArchiveStatus(providerId: string, status: boolean, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateProviderArchiveStatus(providerId, status, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProviderControllerApi.updateProviderArchiveStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Change Provider status to either active or inactive.
         * @summary Enable/Disable provider
         * @param {string} providerId 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateProviderStatus(providerId: string, status: boolean, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateProviderStatus(providerId, status, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProviderControllerApi.updateProviderStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ProviderControllerApi - factory interface
 * @export
 */
export const ProviderControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ProviderControllerApiFp(configuration)
    return {
        /**
         * To assign provider to the particular location
         * @summary Assign provider to Location
         * @param {string} providerId 
         * @param {string} locationId 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignDProviderToLocation(providerId: string, locationId: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.assignDProviderToLocation(providerId, locationId, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Change provider avatar
         * @summary Change Avatar
         * @param {ChangeAvatarRequest} changeAvatarRequest 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeAvatar(changeAvatarRequest: ChangeAvatarRequest, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.changeAvatar(changeAvatarRequest, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Add a new Provider User into the system
         * @summary Add Provider User
         * @param {Provider} provider 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createProvider(provider: Provider, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.createProvider(provider, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all providers list with search option on firstName, lastName, npi and filter options on status, archive and state. 
         * @summary Get all providers
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {boolean} [status] 
         * @param {boolean} [archive] 
         * @param {boolean} [isReferral] 
         * @param {string} [state] 
         * @param {GetAllProvidersRoleEnum} [role] 
         * @param {string} [speciality] 
         * @param {string} [locationUuid] 
         * @param {string} [searchString] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllProviders(page?: number, size?: number, sortBy?: string, sortDirection?: string, status?: boolean, archive?: boolean, isReferral?: boolean, state?: string, role?: GetAllProvidersRoleEnum, speciality?: string, locationUuid?: string, searchString?: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getAllProviders(page, size, sortBy, sortDirection, status, archive, isReferral, state, role, speciality, locationUuid, searchString, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all providers list. Optional filters: isReferral, active, archive.
         * @summary Get all providers name and id
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {string} [searchString] 
         * @param {boolean} [isReferral] 
         * @param {boolean} [status] 
         * @param {boolean} [archive] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllProvidersNameAndId(page?: number, size?: number, sortBy?: string, sortDirection?: string, searchString?: string, isReferral?: boolean, status?: boolean, archive?: boolean, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getAllProvidersNameAndId(page, size, sortBy, sortDirection, searchString, isReferral, status, archive, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all roles that can be assigned to providers
         * @summary Get Available Provider Roles
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAvailableProviderRoles(xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getAvailableProviderRoles(xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Get provider profile
         * @summary Get provider profile
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProfile(xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getProfile(xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Fast provider profile with only essential fields — no eager loading
         * @summary Get lightweight provider profile
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProfileLight(xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getProfileLight(xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Get provider by providerUuid
         * @summary Get provider by providerUuid.
         * @param {string} providerUuid 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProviderById(providerUuid: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getProviderById(providerUuid, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {string} [searchString] 
         * @param {boolean} [archive] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProviderList(page?: number, size?: number, sortBy?: string, sortDirection?: string, searchString?: string, archive?: boolean, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getProviderList(page, size, sortBy, sortDirection, searchString, archive, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Get list of providers with UUID as key and IAM ID as value
         * @summary Get Provider UUID and IAM ID List
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProviderUuidAndIamIdList(xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getProviderUuidAndIamIdList(xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns active providers excluding the logged-in user. Lightweight response: uuid, email, firstName, lastName.
         * @summary Get providers for task reassignment
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [searchString] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProvidersForReassign(page?: number, size?: number, searchString?: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getProvidersForReassign(page, size, searchString, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Public provider profile for the website widget: name, avatar, gender, dob, specialities, bio and accepted insurances.
         * @summary Get provider profile for the website widget
         * @param {string} providerUuid 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWidgetProviderById(providerUuid: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getWidgetProviderById(providerUuid, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Public uuid-and-name map of active providers for the website widget provider filter dropdown.
         * @summary Get provider options for the website widget
         * @param {Array<string>} [speciality] 
         * @param {string} [locationUuid] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWidgetProviderOptions(speciality?: Array<string>, locationUuid?: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getWidgetProviderOptions(speciality, locationUuid, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Public lightweight provider list for the website widget, filterable by location (single), specialities and providers (multi). Returns active providers only with uuid, name, avatar, dob, specialities and locations.
         * @summary Get providers for the website widget
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {Array<string>} [speciality] 
         * @param {Array<string>} [providerUuid] 
         * @param {string} [locationUuid] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWidgetProviders(page?: number, size?: number, speciality?: Array<string>, providerUuid?: Array<string>, locationUuid?: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getWidgetProviders(page, size, speciality, providerUuid, locationUuid, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Edit Provider with editable fields as firstName, lastName, phone, providerType, gender, npi, federalTaxIdNumber, deaNumber, officeFaxNumber, licenseNumber, groupNpiNumber, taxonomyNumber, workLocations, acceptedInsurances, specialities, hospitalAffiliation, experience, acceptCash, providerEmployment, workExperience, bio.
         * @summary Update provider
         * @param {Provider} provider 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProvider(provider: Provider, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.updateProvider(provider, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Change Provider archive status to either archived or unarchived.
         * @summary Archive/Unarchive Provider
         * @param {string} providerId 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProviderArchiveStatus(providerId: string, status: boolean, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.updateProviderArchiveStatus(providerId, status, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Change Provider status to either active or inactive.
         * @summary Enable/Disable provider
         * @param {string} providerId 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProviderStatus(providerId: string, status: boolean, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.updateProviderStatus(providerId, status, xTENANTID, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ProviderControllerApi - object-oriented interface
 * @export
 * @class ProviderControllerApi
 * @extends {BaseAPI}
 */
export class ProviderControllerApi extends BaseAPI {
    /**
     * To assign provider to the particular location
     * @summary Assign provider to Location
     * @param {string} providerId 
     * @param {string} locationId 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProviderControllerApi
     */
    public assignDProviderToLocation(providerId: string, locationId: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return ProviderControllerApiFp(this.configuration).assignDProviderToLocation(providerId, locationId, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Change provider avatar
     * @summary Change Avatar
     * @param {ChangeAvatarRequest} changeAvatarRequest 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProviderControllerApi
     */
    public changeAvatar(changeAvatarRequest: ChangeAvatarRequest, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return ProviderControllerApiFp(this.configuration).changeAvatar(changeAvatarRequest, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Add a new Provider User into the system
     * @summary Add Provider User
     * @param {Provider} provider 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProviderControllerApi
     */
    public createProvider(provider: Provider, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return ProviderControllerApiFp(this.configuration).createProvider(provider, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all providers list with search option on firstName, lastName, npi and filter options on status, archive and state. 
     * @summary Get all providers
     * @param {number} [page] 
     * @param {number} [size] 
     * @param {string} [sortBy] 
     * @param {string} [sortDirection] 
     * @param {boolean} [status] 
     * @param {boolean} [archive] 
     * @param {boolean} [isReferral] 
     * @param {string} [state] 
     * @param {GetAllProvidersRoleEnum} [role] 
     * @param {string} [speciality] 
     * @param {string} [locationUuid] 
     * @param {string} [searchString] 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProviderControllerApi
     */
    public getAllProviders(page?: number, size?: number, sortBy?: string, sortDirection?: string, status?: boolean, archive?: boolean, isReferral?: boolean, state?: string, role?: GetAllProvidersRoleEnum, speciality?: string, locationUuid?: string, searchString?: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return ProviderControllerApiFp(this.configuration).getAllProviders(page, size, sortBy, sortDirection, status, archive, isReferral, state, role, speciality, locationUuid, searchString, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all providers list. Optional filters: isReferral, active, archive.
     * @summary Get all providers name and id
     * @param {number} [page] 
     * @param {number} [size] 
     * @param {string} [sortBy] 
     * @param {string} [sortDirection] 
     * @param {string} [searchString] 
     * @param {boolean} [isReferral] 
     * @param {boolean} [status] 
     * @param {boolean} [archive] 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProviderControllerApi
     */
    public getAllProvidersNameAndId(page?: number, size?: number, sortBy?: string, sortDirection?: string, searchString?: string, isReferral?: boolean, status?: boolean, archive?: boolean, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return ProviderControllerApiFp(this.configuration).getAllProvidersNameAndId(page, size, sortBy, sortDirection, searchString, isReferral, status, archive, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all roles that can be assigned to providers
     * @summary Get Available Provider Roles
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProviderControllerApi
     */
    public getAvailableProviderRoles(xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return ProviderControllerApiFp(this.configuration).getAvailableProviderRoles(xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get provider profile
     * @summary Get provider profile
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProviderControllerApi
     */
    public getProfile(xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return ProviderControllerApiFp(this.configuration).getProfile(xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Fast provider profile with only essential fields — no eager loading
     * @summary Get lightweight provider profile
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProviderControllerApi
     */
    public getProfileLight(xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return ProviderControllerApiFp(this.configuration).getProfileLight(xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get provider by providerUuid
     * @summary Get provider by providerUuid.
     * @param {string} providerUuid 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProviderControllerApi
     */
    public getProviderById(providerUuid: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return ProviderControllerApiFp(this.configuration).getProviderById(providerUuid, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [page] 
     * @param {number} [size] 
     * @param {string} [sortBy] 
     * @param {string} [sortDirection] 
     * @param {string} [searchString] 
     * @param {boolean} [archive] 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProviderControllerApi
     */
    public getProviderList(page?: number, size?: number, sortBy?: string, sortDirection?: string, searchString?: string, archive?: boolean, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return ProviderControllerApiFp(this.configuration).getProviderList(page, size, sortBy, sortDirection, searchString, archive, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get list of providers with UUID as key and IAM ID as value
     * @summary Get Provider UUID and IAM ID List
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProviderControllerApi
     */
    public getProviderUuidAndIamIdList(xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return ProviderControllerApiFp(this.configuration).getProviderUuidAndIamIdList(xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns active providers excluding the logged-in user. Lightweight response: uuid, email, firstName, lastName.
     * @summary Get providers for task reassignment
     * @param {number} [page] 
     * @param {number} [size] 
     * @param {string} [searchString] 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProviderControllerApi
     */
    public getProvidersForReassign(page?: number, size?: number, searchString?: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return ProviderControllerApiFp(this.configuration).getProvidersForReassign(page, size, searchString, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Public provider profile for the website widget: name, avatar, gender, dob, specialities, bio and accepted insurances.
     * @summary Get provider profile for the website widget
     * @param {string} providerUuid 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProviderControllerApi
     */
    public getWidgetProviderById(providerUuid: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return ProviderControllerApiFp(this.configuration).getWidgetProviderById(providerUuid, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Public uuid-and-name map of active providers for the website widget provider filter dropdown.
     * @summary Get provider options for the website widget
     * @param {Array<string>} [speciality] 
     * @param {string} [locationUuid] 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProviderControllerApi
     */
    public getWidgetProviderOptions(speciality?: Array<string>, locationUuid?: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return ProviderControllerApiFp(this.configuration).getWidgetProviderOptions(speciality, locationUuid, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Public lightweight provider list for the website widget, filterable by location (single), specialities and providers (multi). Returns active providers only with uuid, name, avatar, dob, specialities and locations.
     * @summary Get providers for the website widget
     * @param {number} [page] 
     * @param {number} [size] 
     * @param {Array<string>} [speciality] 
     * @param {Array<string>} [providerUuid] 
     * @param {string} [locationUuid] 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProviderControllerApi
     */
    public getWidgetProviders(page?: number, size?: number, speciality?: Array<string>, providerUuid?: Array<string>, locationUuid?: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return ProviderControllerApiFp(this.configuration).getWidgetProviders(page, size, speciality, providerUuid, locationUuid, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Edit Provider with editable fields as firstName, lastName, phone, providerType, gender, npi, federalTaxIdNumber, deaNumber, officeFaxNumber, licenseNumber, groupNpiNumber, taxonomyNumber, workLocations, acceptedInsurances, specialities, hospitalAffiliation, experience, acceptCash, providerEmployment, workExperience, bio.
     * @summary Update provider
     * @param {Provider} provider 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProviderControllerApi
     */
    public updateProvider(provider: Provider, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return ProviderControllerApiFp(this.configuration).updateProvider(provider, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Change Provider archive status to either archived or unarchived.
     * @summary Archive/Unarchive Provider
     * @param {string} providerId 
     * @param {boolean} status 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProviderControllerApi
     */
    public updateProviderArchiveStatus(providerId: string, status: boolean, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return ProviderControllerApiFp(this.configuration).updateProviderArchiveStatus(providerId, status, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Change Provider status to either active or inactive.
     * @summary Enable/Disable provider
     * @param {string} providerId 
     * @param {boolean} status 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProviderControllerApi
     */
    public updateProviderStatus(providerId: string, status: boolean, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return ProviderControllerApiFp(this.configuration).updateProviderStatus(providerId, status, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const GetAllProvidersRoleEnum = {
    SuperAdmin: 'SUPER_ADMIN',
    Provider: 'PROVIDER',
    Frontdesk: 'FRONTDESK',
    Biller: 'BILLER',
    Enb: 'ENB',
    Psychiatrist: 'PSYCHIATRIST',
    Therapist: 'THERAPIST',
    Nurse: 'NURSE',
    Patient: 'PATIENT',
    Anonymous: 'ANONYMOUS',
    ResolutionSpecialist: 'RESOLUTION_SPECIALIST',
    ProviderGroupAdmin: 'PROVIDER_GROUP_ADMIN',
    Admin: 'ADMIN'
} as const;
export type GetAllProvidersRoleEnum = typeof GetAllProvidersRoleEnum[keyof typeof GetAllProvidersRoleEnum];


/**
 * ProviderGroupControllerApi - axios parameter creator
 * @export
 */
export const ProviderGroupControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Add ecarehealth patient id configuration
         * @summary Add ecarehealth patient id configuration
         * @param {string} ecarehealthPatientId 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addEcareHealthPatientId: async (ecarehealthPatientId: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ecarehealthPatientId' is not null or undefined
            assertParamExists('addEcareHealthPatientId', 'ecarehealthPatientId', ecarehealthPatientId)
            const localVarPath = `/api/master/provider-group/patient-id-configuration/{ecarehealth_patient_id}`
                .replace(`{${"ecarehealth_patient_id"}}`, encodeURIComponent(String(ecarehealthPatientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Add provider group email for sending email
         * @summary Provider Group Email Verification
         * @param {EmailVerificationRequest} emailVerificationRequest 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addProviderGroupEmail: async (emailVerificationRequest: EmailVerificationRequest, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'emailVerificationRequest' is not null or undefined
            assertParamExists('addProviderGroupEmail', 'emailVerificationRequest', emailVerificationRequest)
            const localVarPath = `/api/master/provider-group/email-verification`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(emailVerificationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Change Provider Group avatar
         * @summary Change Avatar
         * @param {string} providerGroupId 
         * @param {ChangeAvatarRequest} changeAvatarRequest 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeAvatar1: async (providerGroupId: string, changeAvatarRequest: ChangeAvatarRequest, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'providerGroupId' is not null or undefined
            assertParamExists('changeAvatar1', 'providerGroupId', providerGroupId)
            // verify required parameter 'changeAvatarRequest' is not null or undefined
            assertParamExists('changeAvatar1', 'changeAvatarRequest', changeAvatarRequest)
            const localVarPath = `/api/master/provider-group/change-avatar/{providerGroupId}`
                .replace(`{${"providerGroupId"}}`, encodeURIComponent(String(providerGroupId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(changeAvatarRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Add a new provider group into the system
         * @summary Add provider group
         * @param {ProviderGroup} providerGroup 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createProviderGroup: async (providerGroup: ProviderGroup, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'providerGroup' is not null or undefined
            assertParamExists('createProviderGroup', 'providerGroup', providerGroup)
            const localVarPath = `/api/master/provider-group`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(providerGroup, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all provider groups list for super admin
         * @summary Get all provider groups.
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {boolean} [status] 
         * @param {boolean} [archive] 
         * @param {string} [state] 
         * @param {string} [speciality] 
         * @param {string} [searchString] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllProviderGroups: async (page?: number, size?: number, sortBy?: string, sortDirection?: string, status?: boolean, archive?: boolean, state?: string, speciality?: string, searchString?: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/master/provider-group`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (archive !== undefined) {
                localVarQueryParameter['archive'] = archive;
            }

            if (state !== undefined) {
                localVarQueryParameter['state'] = state;
            }

            if (speciality !== undefined) {
                localVarQueryParameter['speciality'] = speciality;
            }

            if (searchString !== undefined) {
                localVarQueryParameter['searchString'] = searchString;
            }

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fast provider group list with only uuid, name, schema, subdomain, phone
         * @summary Get all provider groups (lightweight)
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {boolean} [status] 
         * @param {boolean} [archive] 
         * @param {string} [searchString] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllProviderGroupsLight: async (page?: number, size?: number, status?: boolean, archive?: boolean, searchString?: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/master/provider-group/light`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (archive !== undefined) {
                localVarQueryParameter['archive'] = archive;
            }

            if (searchString !== undefined) {
                localVarQueryParameter['searchString'] = searchString;
            }

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns provider group name, NPI and billing address for the current tenant
         * @summary Get provider group billing info
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProviderGroupBillingInfo: async (xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/master/provider-group/billing-info`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get provider group by providerGroupUuid
         * @summary Get provider group by providerGroupUuid.
         * @param {string} providerGroupId 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProviderGroupById: async (providerGroupId: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'providerGroupId' is not null or undefined
            assertParamExists('getProviderGroupById', 'providerGroupId', providerGroupId)
            const localVarPath = `/api/master/provider-group/{providerGroupId}`
                .replace(`{${"providerGroupId"}}`, encodeURIComponent(String(providerGroupId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get provider group configuration data with specific fields: id, uuid, timezone, caller_id, subdomain, schema, email, ecarehealth_patient_id, emailId
         * @summary Get provider group configuration data.
         * @param {string} schemaName 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProviderGroupConfig: async (schemaName: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'schemaName' is not null or undefined
            assertParamExists('getProviderGroupConfig', 'schemaName', schemaName)
            const localVarPath = `/api/master/provider-group/config/{schemaName}`
                .replace(`{${"schemaName"}}`, encodeURIComponent(String(schemaName)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get provider group detail
         * @summary Get provider group Detail.
         * @param {string} schemaName 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProviderGroupDetail: async (schemaName: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'schemaName' is not null or undefined
            assertParamExists('getProviderGroupDetail', 'schemaName', schemaName)
            const localVarPath = `/api/master/provider-group/detail/{schemaName}`
                .replace(`{${"schemaName"}}`, encodeURIComponent(String(schemaName)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns provider group name for the current tenant. Used on login screen.
         * @summary Get provider group name
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProviderGroupName: async (xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/master/provider-group/name`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns provider group name, NPI, phone and physical address for the current tenant
         * @summary Get provider group practice info
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProviderGroupPracticeInfo: async (xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/master/provider-group/provider-group-intake-info`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get provider group profile
         * @summary Get provider group profile.
         * @param {string} schemaName 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProviderGroupProfile: async (schemaName: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'schemaName' is not null or undefined
            assertParamExists('getProviderGroupProfile', 'schemaName', schemaName)
            const localVarPath = `/api/master/provider-group/profile/{schemaName}`
                .replace(`{${"schemaName"}}`, encodeURIComponent(String(schemaName)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get provider group timezone
         * @summary Get provider group timezone.
         * @param {string} schemaName 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProviderGroupTimezone: async (schemaName: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'schemaName' is not null or undefined
            assertParamExists('getProviderGroupTimezone', 'schemaName', schemaName)
            const localVarPath = `/api/master/provider-group/v2/timezone/{schemaName}`
                .replace(`{${"schemaName"}}`, encodeURIComponent(String(schemaName)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Sends the ScriptSure organization registration invite to the provider group\'s email
         * @summary Send ScriptSure organization invite
         * @param {string} providerGroupId 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendScriptsureInvite: async (providerGroupId: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'providerGroupId' is not null or undefined
            assertParamExists('sendScriptsureInvite', 'providerGroupId', providerGroupId)
            const localVarPath = `/api/master/provider-group/{providerGroupId}/scriptsure/invite`
                .replace(`{${"providerGroupId"}}`, encodeURIComponent(String(providerGroupId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Set provider group caller od
         * @summary Set provider group Caller Id
         * @param {string} providerGroupId 
         * @param {TwilioCallerId} twilioCallerId 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setProviderGroupCallerId: async (providerGroupId: string, twilioCallerId: TwilioCallerId, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'providerGroupId' is not null or undefined
            assertParamExists('setProviderGroupCallerId', 'providerGroupId', providerGroupId)
            // verify required parameter 'twilioCallerId' is not null or undefined
            assertParamExists('setProviderGroupCallerId', 'twilioCallerId', twilioCallerId)
            const localVarPath = `/api/master/provider-group/{providerGroupId}/create-twilio-number`
                .replace(`{${"providerGroupId"}}`, encodeURIComponent(String(providerGroupId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(twilioCallerId, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} uuid 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncDatabaseSchema: async (uuid: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('syncDatabaseSchema', 'uuid', uuid)
            const localVarPath = `/api/master/provider-group/{uuid}/sync`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Edit Provider Group with editable fields as phone, npi, email, website, fax, description, physical address, billing address
         * @summary Update Provider Group
         * @param {ProviderGroup} providerGroup 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProviderGroup: async (providerGroup: ProviderGroup, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'providerGroup' is not null or undefined
            assertParamExists('updateProviderGroup', 'providerGroup', providerGroup)
            const localVarPath = `/api/master/provider-group`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(providerGroup, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Change Provider Group  archive status to either archived or unarchived.
         * @summary Archive/Un-archive Provider Group
         * @param {string} providerGroupId 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProviderGroupArchiveStatus: async (providerGroupId: string, status: boolean, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'providerGroupId' is not null or undefined
            assertParamExists('updateProviderGroupArchiveStatus', 'providerGroupId', providerGroupId)
            // verify required parameter 'status' is not null or undefined
            assertParamExists('updateProviderGroupArchiveStatus', 'status', status)
            const localVarPath = `/api/master/provider-group/{providerGroupId}/archive-status/{status}`
                .replace(`{${"providerGroupId"}}`, encodeURIComponent(String(providerGroupId)))
                .replace(`{${"status"}}`, encodeURIComponent(String(status)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Change Provider Group status to either active or inactive.
         * @summary Enable/Disable Provider Group
         * @param {string} providerGroupId 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProviderGroupStatus: async (providerGroupId: string, status: boolean, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'providerGroupId' is not null or undefined
            assertParamExists('updateProviderGroupStatus', 'providerGroupId', providerGroupId)
            // verify required parameter 'status' is not null or undefined
            assertParamExists('updateProviderGroupStatus', 'status', status)
            const localVarPath = `/api/master/provider-group/{providerGroupId}/status/{status}`
                .replace(`{${"providerGroupId"}}`, encodeURIComponent(String(providerGroupId)))
                .replace(`{${"status"}}`, encodeURIComponent(String(status)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProviderGroupControllerApi - functional programming interface
 * @export
 */
export const ProviderGroupControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ProviderGroupControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * Add ecarehealth patient id configuration
         * @summary Add ecarehealth patient id configuration
         * @param {string} ecarehealthPatientId 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addEcareHealthPatientId(ecarehealthPatientId: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addEcareHealthPatientId(ecarehealthPatientId, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProviderGroupControllerApi.addEcareHealthPatientId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Add provider group email for sending email
         * @summary Provider Group Email Verification
         * @param {EmailVerificationRequest} emailVerificationRequest 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addProviderGroupEmail(emailVerificationRequest: EmailVerificationRequest, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addProviderGroupEmail(emailVerificationRequest, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProviderGroupControllerApi.addProviderGroupEmail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Change Provider Group avatar
         * @summary Change Avatar
         * @param {string} providerGroupId 
         * @param {ChangeAvatarRequest} changeAvatarRequest 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async changeAvatar1(providerGroupId: string, changeAvatarRequest: ChangeAvatarRequest, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.changeAvatar1(providerGroupId, changeAvatarRequest, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProviderGroupControllerApi.changeAvatar1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Add a new provider group into the system
         * @summary Add provider group
         * @param {ProviderGroup} providerGroup 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createProviderGroup(providerGroup: ProviderGroup, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createProviderGroup(providerGroup, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProviderGroupControllerApi.createProviderGroup']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get all provider groups list for super admin
         * @summary Get all provider groups.
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {boolean} [status] 
         * @param {boolean} [archive] 
         * @param {string} [state] 
         * @param {string} [speciality] 
         * @param {string} [searchString] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllProviderGroups(page?: number, size?: number, sortBy?: string, sortDirection?: string, status?: boolean, archive?: boolean, state?: string, speciality?: string, searchString?: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllProviderGroups(page, size, sortBy, sortDirection, status, archive, state, speciality, searchString, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProviderGroupControllerApi.getAllProviderGroups']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Fast provider group list with only uuid, name, schema, subdomain, phone
         * @summary Get all provider groups (lightweight)
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {boolean} [status] 
         * @param {boolean} [archive] 
         * @param {string} [searchString] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllProviderGroupsLight(page?: number, size?: number, status?: boolean, archive?: boolean, searchString?: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllProviderGroupsLight(page, size, status, archive, searchString, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProviderGroupControllerApi.getAllProviderGroupsLight']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns provider group name, NPI and billing address for the current tenant
         * @summary Get provider group billing info
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProviderGroupBillingInfo(xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProviderGroupBillingInfo(xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProviderGroupControllerApi.getProviderGroupBillingInfo']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get provider group by providerGroupUuid
         * @summary Get provider group by providerGroupUuid.
         * @param {string} providerGroupId 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProviderGroupById(providerGroupId: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProviderGroupById(providerGroupId, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProviderGroupControllerApi.getProviderGroupById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get provider group configuration data with specific fields: id, uuid, timezone, caller_id, subdomain, schema, email, ecarehealth_patient_id, emailId
         * @summary Get provider group configuration data.
         * @param {string} schemaName 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProviderGroupConfig(schemaName: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProviderGroupConfig(schemaName, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProviderGroupControllerApi.getProviderGroupConfig']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get provider group detail
         * @summary Get provider group Detail.
         * @param {string} schemaName 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProviderGroupDetail(schemaName: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProviderGroupDetail(schemaName, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProviderGroupControllerApi.getProviderGroupDetail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns provider group name for the current tenant. Used on login screen.
         * @summary Get provider group name
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProviderGroupName(xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProviderGroupName(xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProviderGroupControllerApi.getProviderGroupName']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns provider group name, NPI, phone and physical address for the current tenant
         * @summary Get provider group practice info
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProviderGroupPracticeInfo(xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProviderGroupPracticeInfo(xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProviderGroupControllerApi.getProviderGroupPracticeInfo']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get provider group profile
         * @summary Get provider group profile.
         * @param {string} schemaName 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProviderGroupProfile(schemaName: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProviderGroupProfile(schemaName, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProviderGroupControllerApi.getProviderGroupProfile']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get provider group timezone
         * @summary Get provider group timezone.
         * @param {string} schemaName 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProviderGroupTimezone(schemaName: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProviderGroupTimezone(schemaName, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProviderGroupControllerApi.getProviderGroupTimezone']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Sends the ScriptSure organization registration invite to the provider group\'s email
         * @summary Send ScriptSure organization invite
         * @param {string} providerGroupId 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendScriptsureInvite(providerGroupId: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendScriptsureInvite(providerGroupId, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProviderGroupControllerApi.sendScriptsureInvite']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Set provider group caller od
         * @summary Set provider group Caller Id
         * @param {string} providerGroupId 
         * @param {TwilioCallerId} twilioCallerId 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setProviderGroupCallerId(providerGroupId: string, twilioCallerId: TwilioCallerId, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setProviderGroupCallerId(providerGroupId, twilioCallerId, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProviderGroupControllerApi.setProviderGroupCallerId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} uuid 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async syncDatabaseSchema(uuid: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.syncDatabaseSchema(uuid, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProviderGroupControllerApi.syncDatabaseSchema']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Edit Provider Group with editable fields as phone, npi, email, website, fax, description, physical address, billing address
         * @summary Update Provider Group
         * @param {ProviderGroup} providerGroup 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateProviderGroup(providerGroup: ProviderGroup, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateProviderGroup(providerGroup, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProviderGroupControllerApi.updateProviderGroup']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Change Provider Group  archive status to either archived or unarchived.
         * @summary Archive/Un-archive Provider Group
         * @param {string} providerGroupId 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateProviderGroupArchiveStatus(providerGroupId: string, status: boolean, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateProviderGroupArchiveStatus(providerGroupId, status, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProviderGroupControllerApi.updateProviderGroupArchiveStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Change Provider Group status to either active or inactive.
         * @summary Enable/Disable Provider Group
         * @param {string} providerGroupId 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateProviderGroupStatus(providerGroupId: string, status: boolean, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateProviderGroupStatus(providerGroupId, status, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProviderGroupControllerApi.updateProviderGroupStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ProviderGroupControllerApi - factory interface
 * @export
 */
export const ProviderGroupControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ProviderGroupControllerApiFp(configuration)
    return {
        /**
         * Add ecarehealth patient id configuration
         * @summary Add ecarehealth patient id configuration
         * @param {string} ecarehealthPatientId 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addEcareHealthPatientId(ecarehealthPatientId: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.addEcareHealthPatientId(ecarehealthPatientId, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Add provider group email for sending email
         * @summary Provider Group Email Verification
         * @param {EmailVerificationRequest} emailVerificationRequest 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addProviderGroupEmail(emailVerificationRequest: EmailVerificationRequest, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.addProviderGroupEmail(emailVerificationRequest, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Change Provider Group avatar
         * @summary Change Avatar
         * @param {string} providerGroupId 
         * @param {ChangeAvatarRequest} changeAvatarRequest 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeAvatar1(providerGroupId: string, changeAvatarRequest: ChangeAvatarRequest, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.changeAvatar1(providerGroupId, changeAvatarRequest, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Add a new provider group into the system
         * @summary Add provider group
         * @param {ProviderGroup} providerGroup 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createProviderGroup(providerGroup: ProviderGroup, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.createProviderGroup(providerGroup, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all provider groups list for super admin
         * @summary Get all provider groups.
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {boolean} [status] 
         * @param {boolean} [archive] 
         * @param {string} [state] 
         * @param {string} [speciality] 
         * @param {string} [searchString] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllProviderGroups(page?: number, size?: number, sortBy?: string, sortDirection?: string, status?: boolean, archive?: boolean, state?: string, speciality?: string, searchString?: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getAllProviderGroups(page, size, sortBy, sortDirection, status, archive, state, speciality, searchString, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Fast provider group list with only uuid, name, schema, subdomain, phone
         * @summary Get all provider groups (lightweight)
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {boolean} [status] 
         * @param {boolean} [archive] 
         * @param {string} [searchString] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllProviderGroupsLight(page?: number, size?: number, status?: boolean, archive?: boolean, searchString?: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getAllProviderGroupsLight(page, size, status, archive, searchString, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns provider group name, NPI and billing address for the current tenant
         * @summary Get provider group billing info
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProviderGroupBillingInfo(xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getProviderGroupBillingInfo(xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Get provider group by providerGroupUuid
         * @summary Get provider group by providerGroupUuid.
         * @param {string} providerGroupId 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProviderGroupById(providerGroupId: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getProviderGroupById(providerGroupId, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Get provider group configuration data with specific fields: id, uuid, timezone, caller_id, subdomain, schema, email, ecarehealth_patient_id, emailId
         * @summary Get provider group configuration data.
         * @param {string} schemaName 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProviderGroupConfig(schemaName: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getProviderGroupConfig(schemaName, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Get provider group detail
         * @summary Get provider group Detail.
         * @param {string} schemaName 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProviderGroupDetail(schemaName: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getProviderGroupDetail(schemaName, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns provider group name for the current tenant. Used on login screen.
         * @summary Get provider group name
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProviderGroupName(xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getProviderGroupName(xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns provider group name, NPI, phone and physical address for the current tenant
         * @summary Get provider group practice info
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProviderGroupPracticeInfo(xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getProviderGroupPracticeInfo(xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Get provider group profile
         * @summary Get provider group profile.
         * @param {string} schemaName 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProviderGroupProfile(schemaName: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getProviderGroupProfile(schemaName, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Get provider group timezone
         * @summary Get provider group timezone.
         * @param {string} schemaName 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProviderGroupTimezone(schemaName: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getProviderGroupTimezone(schemaName, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Sends the ScriptSure organization registration invite to the provider group\'s email
         * @summary Send ScriptSure organization invite
         * @param {string} providerGroupId 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendScriptsureInvite(providerGroupId: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.sendScriptsureInvite(providerGroupId, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Set provider group caller od
         * @summary Set provider group Caller Id
         * @param {string} providerGroupId 
         * @param {TwilioCallerId} twilioCallerId 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setProviderGroupCallerId(providerGroupId: string, twilioCallerId: TwilioCallerId, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.setProviderGroupCallerId(providerGroupId, twilioCallerId, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} uuid 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncDatabaseSchema(uuid: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.syncDatabaseSchema(uuid, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Edit Provider Group with editable fields as phone, npi, email, website, fax, description, physical address, billing address
         * @summary Update Provider Group
         * @param {ProviderGroup} providerGroup 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProviderGroup(providerGroup: ProviderGroup, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.updateProviderGroup(providerGroup, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Change Provider Group  archive status to either archived or unarchived.
         * @summary Archive/Un-archive Provider Group
         * @param {string} providerGroupId 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProviderGroupArchiveStatus(providerGroupId: string, status: boolean, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.updateProviderGroupArchiveStatus(providerGroupId, status, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Change Provider Group status to either active or inactive.
         * @summary Enable/Disable Provider Group
         * @param {string} providerGroupId 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProviderGroupStatus(providerGroupId: string, status: boolean, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.updateProviderGroupStatus(providerGroupId, status, xTENANTID, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ProviderGroupControllerApi - object-oriented interface
 * @export
 * @class ProviderGroupControllerApi
 * @extends {BaseAPI}
 */
export class ProviderGroupControllerApi extends BaseAPI {
    /**
     * Add ecarehealth patient id configuration
     * @summary Add ecarehealth patient id configuration
     * @param {string} ecarehealthPatientId 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProviderGroupControllerApi
     */
    public addEcareHealthPatientId(ecarehealthPatientId: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return ProviderGroupControllerApiFp(this.configuration).addEcareHealthPatientId(ecarehealthPatientId, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Add provider group email for sending email
     * @summary Provider Group Email Verification
     * @param {EmailVerificationRequest} emailVerificationRequest 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProviderGroupControllerApi
     */
    public addProviderGroupEmail(emailVerificationRequest: EmailVerificationRequest, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return ProviderGroupControllerApiFp(this.configuration).addProviderGroupEmail(emailVerificationRequest, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Change Provider Group avatar
     * @summary Change Avatar
     * @param {string} providerGroupId 
     * @param {ChangeAvatarRequest} changeAvatarRequest 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProviderGroupControllerApi
     */
    public changeAvatar1(providerGroupId: string, changeAvatarRequest: ChangeAvatarRequest, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return ProviderGroupControllerApiFp(this.configuration).changeAvatar1(providerGroupId, changeAvatarRequest, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Add a new provider group into the system
     * @summary Add provider group
     * @param {ProviderGroup} providerGroup 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProviderGroupControllerApi
     */
    public createProviderGroup(providerGroup: ProviderGroup, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return ProviderGroupControllerApiFp(this.configuration).createProviderGroup(providerGroup, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all provider groups list for super admin
     * @summary Get all provider groups.
     * @param {number} [page] 
     * @param {number} [size] 
     * @param {string} [sortBy] 
     * @param {string} [sortDirection] 
     * @param {boolean} [status] 
     * @param {boolean} [archive] 
     * @param {string} [state] 
     * @param {string} [speciality] 
     * @param {string} [searchString] 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProviderGroupControllerApi
     */
    public getAllProviderGroups(page?: number, size?: number, sortBy?: string, sortDirection?: string, status?: boolean, archive?: boolean, state?: string, speciality?: string, searchString?: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return ProviderGroupControllerApiFp(this.configuration).getAllProviderGroups(page, size, sortBy, sortDirection, status, archive, state, speciality, searchString, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Fast provider group list with only uuid, name, schema, subdomain, phone
     * @summary Get all provider groups (lightweight)
     * @param {number} [page] 
     * @param {number} [size] 
     * @param {boolean} [status] 
     * @param {boolean} [archive] 
     * @param {string} [searchString] 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProviderGroupControllerApi
     */
    public getAllProviderGroupsLight(page?: number, size?: number, status?: boolean, archive?: boolean, searchString?: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return ProviderGroupControllerApiFp(this.configuration).getAllProviderGroupsLight(page, size, status, archive, searchString, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns provider group name, NPI and billing address for the current tenant
     * @summary Get provider group billing info
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProviderGroupControllerApi
     */
    public getProviderGroupBillingInfo(xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return ProviderGroupControllerApiFp(this.configuration).getProviderGroupBillingInfo(xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get provider group by providerGroupUuid
     * @summary Get provider group by providerGroupUuid.
     * @param {string} providerGroupId 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProviderGroupControllerApi
     */
    public getProviderGroupById(providerGroupId: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return ProviderGroupControllerApiFp(this.configuration).getProviderGroupById(providerGroupId, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get provider group configuration data with specific fields: id, uuid, timezone, caller_id, subdomain, schema, email, ecarehealth_patient_id, emailId
     * @summary Get provider group configuration data.
     * @param {string} schemaName 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProviderGroupControllerApi
     */
    public getProviderGroupConfig(schemaName: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return ProviderGroupControllerApiFp(this.configuration).getProviderGroupConfig(schemaName, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get provider group detail
     * @summary Get provider group Detail.
     * @param {string} schemaName 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProviderGroupControllerApi
     */
    public getProviderGroupDetail(schemaName: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return ProviderGroupControllerApiFp(this.configuration).getProviderGroupDetail(schemaName, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns provider group name for the current tenant. Used on login screen.
     * @summary Get provider group name
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProviderGroupControllerApi
     */
    public getProviderGroupName(xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return ProviderGroupControllerApiFp(this.configuration).getProviderGroupName(xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns provider group name, NPI, phone and physical address for the current tenant
     * @summary Get provider group practice info
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProviderGroupControllerApi
     */
    public getProviderGroupPracticeInfo(xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return ProviderGroupControllerApiFp(this.configuration).getProviderGroupPracticeInfo(xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get provider group profile
     * @summary Get provider group profile.
     * @param {string} schemaName 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProviderGroupControllerApi
     */
    public getProviderGroupProfile(schemaName: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return ProviderGroupControllerApiFp(this.configuration).getProviderGroupProfile(schemaName, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get provider group timezone
     * @summary Get provider group timezone.
     * @param {string} schemaName 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProviderGroupControllerApi
     */
    public getProviderGroupTimezone(schemaName: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return ProviderGroupControllerApiFp(this.configuration).getProviderGroupTimezone(schemaName, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Sends the ScriptSure organization registration invite to the provider group\'s email
     * @summary Send ScriptSure organization invite
     * @param {string} providerGroupId 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProviderGroupControllerApi
     */
    public sendScriptsureInvite(providerGroupId: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return ProviderGroupControllerApiFp(this.configuration).sendScriptsureInvite(providerGroupId, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Set provider group caller od
     * @summary Set provider group Caller Id
     * @param {string} providerGroupId 
     * @param {TwilioCallerId} twilioCallerId 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProviderGroupControllerApi
     */
    public setProviderGroupCallerId(providerGroupId: string, twilioCallerId: TwilioCallerId, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return ProviderGroupControllerApiFp(this.configuration).setProviderGroupCallerId(providerGroupId, twilioCallerId, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} uuid 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProviderGroupControllerApi
     */
    public syncDatabaseSchema(uuid: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return ProviderGroupControllerApiFp(this.configuration).syncDatabaseSchema(uuid, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Edit Provider Group with editable fields as phone, npi, email, website, fax, description, physical address, billing address
     * @summary Update Provider Group
     * @param {ProviderGroup} providerGroup 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProviderGroupControllerApi
     */
    public updateProviderGroup(providerGroup: ProviderGroup, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return ProviderGroupControllerApiFp(this.configuration).updateProviderGroup(providerGroup, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Change Provider Group  archive status to either archived or unarchived.
     * @summary Archive/Un-archive Provider Group
     * @param {string} providerGroupId 
     * @param {boolean} status 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProviderGroupControllerApi
     */
    public updateProviderGroupArchiveStatus(providerGroupId: string, status: boolean, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return ProviderGroupControllerApiFp(this.configuration).updateProviderGroupArchiveStatus(providerGroupId, status, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Change Provider Group status to either active or inactive.
     * @summary Enable/Disable Provider Group
     * @param {string} providerGroupId 
     * @param {boolean} status 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProviderGroupControllerApi
     */
    public updateProviderGroupStatus(providerGroupId: string, status: boolean, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return ProviderGroupControllerApiFp(this.configuration).updateProviderGroupStatus(providerGroupId, status, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ProviderSignatureControllerApi - axios parameter creator
 * @export
 */
export const ProviderSignatureControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Add a provider signature into the system.
         * @summary Add Provider Signature 
         * @param {ProviderSignature} providerSignature 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createProviderSignature: async (providerSignature: ProviderSignature, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'providerSignature' is not null or undefined
            assertParamExists('createProviderSignature', 'providerSignature', providerSignature)
            const localVarPath = `/api/master/provider-signature`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(providerSignature, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetch a provider\'s signature using the provider\'s UUID.
         * @summary Get Provider Signature by Provider UUID
         * @param {string} providerUuid 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProviderSignatureByProviderUuid: async (providerUuid: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'providerUuid' is not null or undefined
            assertParamExists('getProviderSignatureByProviderUuid', 'providerUuid', providerUuid)
            const localVarPath = `/api/master/provider-signature/{providerUuid}`
                .replace(`{${"providerUuid"}}`, encodeURIComponent(String(providerUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProviderSignatureControllerApi - functional programming interface
 * @export
 */
export const ProviderSignatureControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ProviderSignatureControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * Add a provider signature into the system.
         * @summary Add Provider Signature 
         * @param {ProviderSignature} providerSignature 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createProviderSignature(providerSignature: ProviderSignature, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createProviderSignature(providerSignature, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProviderSignatureControllerApi.createProviderSignature']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Fetch a provider\'s signature using the provider\'s UUID.
         * @summary Get Provider Signature by Provider UUID
         * @param {string} providerUuid 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProviderSignatureByProviderUuid(providerUuid: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProviderSignatureByProviderUuid(providerUuid, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProviderSignatureControllerApi.getProviderSignatureByProviderUuid']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ProviderSignatureControllerApi - factory interface
 * @export
 */
export const ProviderSignatureControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ProviderSignatureControllerApiFp(configuration)
    return {
        /**
         * Add a provider signature into the system.
         * @summary Add Provider Signature 
         * @param {ProviderSignature} providerSignature 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createProviderSignature(providerSignature: ProviderSignature, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.createProviderSignature(providerSignature, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Fetch a provider\'s signature using the provider\'s UUID.
         * @summary Get Provider Signature by Provider UUID
         * @param {string} providerUuid 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProviderSignatureByProviderUuid(providerUuid: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getProviderSignatureByProviderUuid(providerUuid, xTENANTID, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ProviderSignatureControllerApi - object-oriented interface
 * @export
 * @class ProviderSignatureControllerApi
 * @extends {BaseAPI}
 */
export class ProviderSignatureControllerApi extends BaseAPI {
    /**
     * Add a provider signature into the system.
     * @summary Add Provider Signature 
     * @param {ProviderSignature} providerSignature 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProviderSignatureControllerApi
     */
    public createProviderSignature(providerSignature: ProviderSignature, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return ProviderSignatureControllerApiFp(this.configuration).createProviderSignature(providerSignature, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Fetch a provider\'s signature using the provider\'s UUID.
     * @summary Get Provider Signature by Provider UUID
     * @param {string} providerUuid 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProviderSignatureControllerApi
     */
    public getProviderSignatureByProviderUuid(providerUuid: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return ProviderSignatureControllerApiFp(this.configuration).getProviderSignatureByProviderUuid(providerUuid, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PushNotificationControllerApi - axios parameter creator
 * @export
 */
export const PushNotificationControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get all push-notification
         * @summary Get all push-notification.
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {boolean} [isViewed] 
         * @param {string} [patientId] 
         * @param {string} [sortDirection] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllPushNotification: async (page?: number, size?: number, sortBy?: string, isViewed?: boolean, patientId?: string, sortDirection?: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/master/push-notification`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (isViewed !== undefined) {
                localVarQueryParameter['isViewed'] = isViewed;
            }

            if (patientId !== undefined) {
                localVarQueryParameter['patientId'] = patientId;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Mark notification
         * @summary Read the notification
         * @param {string} pushNotificationId 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        maskAsReadNotification: async (pushNotificationId: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pushNotificationId' is not null or undefined
            assertParamExists('maskAsReadNotification', 'pushNotificationId', pushNotificationId)
            const localVarPath = `/api/master/push-notification/{pushNotificationId}/mark-as-read`
                .replace(`{${"pushNotificationId"}}`, encodeURIComponent(String(pushNotificationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Mark all notification
         * @summary Mark all as read
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        maskAsReadNotification1: async (xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/master/push-notification/mark-all-read`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PushNotificationControllerApi - functional programming interface
 * @export
 */
export const PushNotificationControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PushNotificationControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * Get all push-notification
         * @summary Get all push-notification.
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {boolean} [isViewed] 
         * @param {string} [patientId] 
         * @param {string} [sortDirection] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllPushNotification(page?: number, size?: number, sortBy?: string, isViewed?: boolean, patientId?: string, sortDirection?: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllPushNotification(page, size, sortBy, isViewed, patientId, sortDirection, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PushNotificationControllerApi.getAllPushNotification']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Mark notification
         * @summary Read the notification
         * @param {string} pushNotificationId 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async maskAsReadNotification(pushNotificationId: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.maskAsReadNotification(pushNotificationId, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PushNotificationControllerApi.maskAsReadNotification']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Mark all notification
         * @summary Mark all as read
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async maskAsReadNotification1(xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.maskAsReadNotification1(xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PushNotificationControllerApi.maskAsReadNotification1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PushNotificationControllerApi - factory interface
 * @export
 */
export const PushNotificationControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PushNotificationControllerApiFp(configuration)
    return {
        /**
         * Get all push-notification
         * @summary Get all push-notification.
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {boolean} [isViewed] 
         * @param {string} [patientId] 
         * @param {string} [sortDirection] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllPushNotification(page?: number, size?: number, sortBy?: string, isViewed?: boolean, patientId?: string, sortDirection?: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getAllPushNotification(page, size, sortBy, isViewed, patientId, sortDirection, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Mark notification
         * @summary Read the notification
         * @param {string} pushNotificationId 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        maskAsReadNotification(pushNotificationId: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.maskAsReadNotification(pushNotificationId, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Mark all notification
         * @summary Mark all as read
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        maskAsReadNotification1(xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.maskAsReadNotification1(xTENANTID, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PushNotificationControllerApi - object-oriented interface
 * @export
 * @class PushNotificationControllerApi
 * @extends {BaseAPI}
 */
export class PushNotificationControllerApi extends BaseAPI {
    /**
     * Get all push-notification
     * @summary Get all push-notification.
     * @param {number} [page] 
     * @param {number} [size] 
     * @param {string} [sortBy] 
     * @param {boolean} [isViewed] 
     * @param {string} [patientId] 
     * @param {string} [sortDirection] 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PushNotificationControllerApi
     */
    public getAllPushNotification(page?: number, size?: number, sortBy?: string, isViewed?: boolean, patientId?: string, sortDirection?: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return PushNotificationControllerApiFp(this.configuration).getAllPushNotification(page, size, sortBy, isViewed, patientId, sortDirection, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Mark notification
     * @summary Read the notification
     * @param {string} pushNotificationId 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PushNotificationControllerApi
     */
    public maskAsReadNotification(pushNotificationId: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return PushNotificationControllerApiFp(this.configuration).maskAsReadNotification(pushNotificationId, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Mark all notification
     * @summary Mark all as read
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PushNotificationControllerApi
     */
    public maskAsReadNotification1(xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return PushNotificationControllerApiFp(this.configuration).maskAsReadNotification1(xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ReferralControllerApi - axios parameter creator
 * @export
 */
export const ReferralControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Create a referral in system.
         * @summary Create a referral
         * @param {Referral} referral 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createReferral: async (referral: Referral, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'referral' is not null or undefined
            assertParamExists('createReferral', 'referral', referral)
            const localVarPath = `/api/master/referral`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(referral, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all referral with filter options on patient, provider. Supports sorting by: patientName (alphabetical), referralDate (chronological), priority (High → Medium → Low), updatedDate (chronological), createdDate (chronological), referralStatus, active, archive.
         * @summary Get all referral.
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {boolean} [archive] 
         * @param {boolean} [active] 
         * @param {boolean} [referralIn] 
         * @param {string} [referralFrom] 
         * @param {string} [referralTo] 
         * @param {string} [referralSpeciality] 
         * @param {string} [referralDate] 
         * @param {GetAllReferralReferralStatusEnum} [referralStatus] 
         * @param {string} [searchString] 
         * @param {string} [patientName] 
         * @param {string} [patientId] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllReferral: async (page?: number, size?: number, sortBy?: string, sortDirection?: string, archive?: boolean, active?: boolean, referralIn?: boolean, referralFrom?: string, referralTo?: string, referralSpeciality?: string, referralDate?: string, referralStatus?: GetAllReferralReferralStatusEnum, searchString?: string, patientName?: string, patientId?: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/master/referral`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }

            if (archive !== undefined) {
                localVarQueryParameter['archive'] = archive;
            }

            if (active !== undefined) {
                localVarQueryParameter['active'] = active;
            }

            if (referralIn !== undefined) {
                localVarQueryParameter['referralIn'] = referralIn;
            }

            if (referralFrom !== undefined) {
                localVarQueryParameter['referralFrom'] = referralFrom;
            }

            if (referralTo !== undefined) {
                localVarQueryParameter['referralTo'] = referralTo;
            }

            if (referralSpeciality !== undefined) {
                localVarQueryParameter['referralSpeciality'] = referralSpeciality;
            }

            if (referralDate !== undefined) {
                localVarQueryParameter['referralDate'] = (referralDate as any instanceof Date) ?
                    (referralDate as any).toISOString() :
                    referralDate;
            }

            if (referralStatus !== undefined) {
                localVarQueryParameter['referralStatus'] = referralStatus;
            }

            if (searchString !== undefined) {
                localVarQueryParameter['searchString'] = searchString;
            }

            if (patientName !== undefined) {
                localVarQueryParameter['patientName'] = patientName;
            }

            if (patientId !== undefined) {
                localVarQueryParameter['patientId'] = patientId;
            }

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Gat referral by UUID.
         * @summary Get referral by ID
         * @param {string} referralId 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReferralById: async (referralId: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'referralId' is not null or undefined
            assertParamExists('getReferralById', 'referralId', referralId)
            const localVarPath = `/api/master/referral/{referralId}`
                .replace(`{${"referralId"}}`, encodeURIComponent(String(referralId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Generate a printable PDF for a referral by its ID
         * @summary Print Referral
         * @param {string} referralId 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        printReferral: async (referralId: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'referralId' is not null or undefined
            assertParamExists('printReferral', 'referralId', referralId)
            const localVarPath = `/api/master/referral/{referralId}/print`
                .replace(`{${"referralId"}}`, encodeURIComponent(String(referralId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Edit Referral with editable fields as patient,referralFrom,referralTo
         * @summary Update Referral
         * @param {Referral} referral 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateReferral: async (referral: Referral, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'referral' is not null or undefined
            assertParamExists('updateReferral', 'referral', referral)
            const localVarPath = `/api/master/referral`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(referral, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Archive a Referral record by its ID
         * @summary Archive Referral
         * @param {string} referralId 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateReferralArchiveStatus: async (referralId: string, status: boolean, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'referralId' is not null or undefined
            assertParamExists('updateReferralArchiveStatus', 'referralId', referralId)
            // verify required parameter 'status' is not null or undefined
            assertParamExists('updateReferralArchiveStatus', 'status', status)
            const localVarPath = `/api/master/referral/{referralId}/archive-status/{status}`
                .replace(`{${"referralId"}}`, encodeURIComponent(String(referralId)))
                .replace(`{${"status"}}`, encodeURIComponent(String(status)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Change a Referral record by its ID
         * @summary Changes Referral status
         * @param {UpdateReferral} updateReferral 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateReferralStatus: async (updateReferral: UpdateReferral, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'updateReferral' is not null or undefined
            assertParamExists('updateReferralStatus', 'updateReferral', updateReferral)
            const localVarPath = `/api/master/referral/update-status`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateReferral, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ReferralControllerApi - functional programming interface
 * @export
 */
export const ReferralControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ReferralControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * Create a referral in system.
         * @summary Create a referral
         * @param {Referral} referral 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createReferral(referral: Referral, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createReferral(referral, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReferralControllerApi.createReferral']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get all referral with filter options on patient, provider. Supports sorting by: patientName (alphabetical), referralDate (chronological), priority (High → Medium → Low), updatedDate (chronological), createdDate (chronological), referralStatus, active, archive.
         * @summary Get all referral.
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {boolean} [archive] 
         * @param {boolean} [active] 
         * @param {boolean} [referralIn] 
         * @param {string} [referralFrom] 
         * @param {string} [referralTo] 
         * @param {string} [referralSpeciality] 
         * @param {string} [referralDate] 
         * @param {GetAllReferralReferralStatusEnum} [referralStatus] 
         * @param {string} [searchString] 
         * @param {string} [patientName] 
         * @param {string} [patientId] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllReferral(page?: number, size?: number, sortBy?: string, sortDirection?: string, archive?: boolean, active?: boolean, referralIn?: boolean, referralFrom?: string, referralTo?: string, referralSpeciality?: string, referralDate?: string, referralStatus?: GetAllReferralReferralStatusEnum, searchString?: string, patientName?: string, patientId?: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllReferral(page, size, sortBy, sortDirection, archive, active, referralIn, referralFrom, referralTo, referralSpeciality, referralDate, referralStatus, searchString, patientName, patientId, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReferralControllerApi.getAllReferral']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Gat referral by UUID.
         * @summary Get referral by ID
         * @param {string} referralId 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getReferralById(referralId: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getReferralById(referralId, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReferralControllerApi.getReferralById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Generate a printable PDF for a referral by its ID
         * @summary Print Referral
         * @param {string} referralId 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async printReferral(referralId: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.printReferral(referralId, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReferralControllerApi.printReferral']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Edit Referral with editable fields as patient,referralFrom,referralTo
         * @summary Update Referral
         * @param {Referral} referral 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateReferral(referral: Referral, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateReferral(referral, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReferralControllerApi.updateReferral']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Archive a Referral record by its ID
         * @summary Archive Referral
         * @param {string} referralId 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateReferralArchiveStatus(referralId: string, status: boolean, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateReferralArchiveStatus(referralId, status, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReferralControllerApi.updateReferralArchiveStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Change a Referral record by its ID
         * @summary Changes Referral status
         * @param {UpdateReferral} updateReferral 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateReferralStatus(updateReferral: UpdateReferral, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateReferralStatus(updateReferral, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReferralControllerApi.updateReferralStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ReferralControllerApi - factory interface
 * @export
 */
export const ReferralControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ReferralControllerApiFp(configuration)
    return {
        /**
         * Create a referral in system.
         * @summary Create a referral
         * @param {Referral} referral 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createReferral(referral: Referral, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.createReferral(referral, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all referral with filter options on patient, provider. Supports sorting by: patientName (alphabetical), referralDate (chronological), priority (High → Medium → Low), updatedDate (chronological), createdDate (chronological), referralStatus, active, archive.
         * @summary Get all referral.
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {boolean} [archive] 
         * @param {boolean} [active] 
         * @param {boolean} [referralIn] 
         * @param {string} [referralFrom] 
         * @param {string} [referralTo] 
         * @param {string} [referralSpeciality] 
         * @param {string} [referralDate] 
         * @param {GetAllReferralReferralStatusEnum} [referralStatus] 
         * @param {string} [searchString] 
         * @param {string} [patientName] 
         * @param {string} [patientId] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllReferral(page?: number, size?: number, sortBy?: string, sortDirection?: string, archive?: boolean, active?: boolean, referralIn?: boolean, referralFrom?: string, referralTo?: string, referralSpeciality?: string, referralDate?: string, referralStatus?: GetAllReferralReferralStatusEnum, searchString?: string, patientName?: string, patientId?: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getAllReferral(page, size, sortBy, sortDirection, archive, active, referralIn, referralFrom, referralTo, referralSpeciality, referralDate, referralStatus, searchString, patientName, patientId, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Gat referral by UUID.
         * @summary Get referral by ID
         * @param {string} referralId 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReferralById(referralId: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getReferralById(referralId, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Generate a printable PDF for a referral by its ID
         * @summary Print Referral
         * @param {string} referralId 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        printReferral(referralId: string, xTENANTID?: string, options?: any): AxiosPromise<string> {
            return localVarFp.printReferral(referralId, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Edit Referral with editable fields as patient,referralFrom,referralTo
         * @summary Update Referral
         * @param {Referral} referral 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateReferral(referral: Referral, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.updateReferral(referral, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Archive a Referral record by its ID
         * @summary Archive Referral
         * @param {string} referralId 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateReferralArchiveStatus(referralId: string, status: boolean, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.updateReferralArchiveStatus(referralId, status, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Change a Referral record by its ID
         * @summary Changes Referral status
         * @param {UpdateReferral} updateReferral 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateReferralStatus(updateReferral: UpdateReferral, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.updateReferralStatus(updateReferral, xTENANTID, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ReferralControllerApi - object-oriented interface
 * @export
 * @class ReferralControllerApi
 * @extends {BaseAPI}
 */
export class ReferralControllerApi extends BaseAPI {
    /**
     * Create a referral in system.
     * @summary Create a referral
     * @param {Referral} referral 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReferralControllerApi
     */
    public createReferral(referral: Referral, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return ReferralControllerApiFp(this.configuration).createReferral(referral, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all referral with filter options on patient, provider. Supports sorting by: patientName (alphabetical), referralDate (chronological), priority (High → Medium → Low), updatedDate (chronological), createdDate (chronological), referralStatus, active, archive.
     * @summary Get all referral.
     * @param {number} [page] 
     * @param {number} [size] 
     * @param {string} [sortBy] 
     * @param {string} [sortDirection] 
     * @param {boolean} [archive] 
     * @param {boolean} [active] 
     * @param {boolean} [referralIn] 
     * @param {string} [referralFrom] 
     * @param {string} [referralTo] 
     * @param {string} [referralSpeciality] 
     * @param {string} [referralDate] 
     * @param {GetAllReferralReferralStatusEnum} [referralStatus] 
     * @param {string} [searchString] 
     * @param {string} [patientName] 
     * @param {string} [patientId] 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReferralControllerApi
     */
    public getAllReferral(page?: number, size?: number, sortBy?: string, sortDirection?: string, archive?: boolean, active?: boolean, referralIn?: boolean, referralFrom?: string, referralTo?: string, referralSpeciality?: string, referralDate?: string, referralStatus?: GetAllReferralReferralStatusEnum, searchString?: string, patientName?: string, patientId?: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return ReferralControllerApiFp(this.configuration).getAllReferral(page, size, sortBy, sortDirection, archive, active, referralIn, referralFrom, referralTo, referralSpeciality, referralDate, referralStatus, searchString, patientName, patientId, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Gat referral by UUID.
     * @summary Get referral by ID
     * @param {string} referralId 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReferralControllerApi
     */
    public getReferralById(referralId: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return ReferralControllerApiFp(this.configuration).getReferralById(referralId, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Generate a printable PDF for a referral by its ID
     * @summary Print Referral
     * @param {string} referralId 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReferralControllerApi
     */
    public printReferral(referralId: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return ReferralControllerApiFp(this.configuration).printReferral(referralId, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Edit Referral with editable fields as patient,referralFrom,referralTo
     * @summary Update Referral
     * @param {Referral} referral 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReferralControllerApi
     */
    public updateReferral(referral: Referral, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return ReferralControllerApiFp(this.configuration).updateReferral(referral, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Archive a Referral record by its ID
     * @summary Archive Referral
     * @param {string} referralId 
     * @param {boolean} status 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReferralControllerApi
     */
    public updateReferralArchiveStatus(referralId: string, status: boolean, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return ReferralControllerApiFp(this.configuration).updateReferralArchiveStatus(referralId, status, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Change a Referral record by its ID
     * @summary Changes Referral status
     * @param {UpdateReferral} updateReferral 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReferralControllerApi
     */
    public updateReferralStatus(updateReferral: UpdateReferral, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return ReferralControllerApiFp(this.configuration).updateReferralStatus(updateReferral, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const GetAllReferralReferralStatusEnum = {
    Pending: 'PENDING',
    Closed: 'CLOSED',
    Sent: 'SENT',
    Accepted: 'ACCEPTED',
    Completed: 'COMPLETED',
    Scheduled: 'SCHEDULED',
    Rejected: 'REJECTED'
} as const;
export type GetAllReferralReferralStatusEnum = typeof GetAllReferralReferralStatusEnum[keyof typeof GetAllReferralReferralStatusEnum];


/**
 * ReferringAgencyControllerApi - axios parameter creator
 * @export
 */
export const ReferringAgencyControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Add a new Referring Agency and return it with its generated Agency ID.
         * @summary Add Referring Agency
         * @param {ReferringAgency} referringAgency 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createReferringAgency: async (referringAgency: ReferringAgency, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'referringAgency' is not null or undefined
            assertParamExists('createReferringAgency', 'referringAgency', referringAgency)
            const localVarPath = `/api/master/referring-agency`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(referringAgency, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all Referring Agencies with search option on name, agency type and filter option on archive.
         * @summary Get all Referring Agencies.
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {boolean} [archive] 
         * @param {boolean} [active] 
         * @param {string} [searchString] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllReferringAgencies: async (page?: number, size?: number, sortBy?: string, sortDirection?: string, archive?: boolean, active?: boolean, searchString?: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/master/referring-agency`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }

            if (archive !== undefined) {
                localVarQueryParameter['archive'] = archive;
            }

            if (active !== undefined) {
                localVarQueryParameter['active'] = active;
            }

            if (searchString !== undefined) {
                localVarQueryParameter['searchString'] = searchString;
            }

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get Referring Agency by referringAgencyUuid.
         * @summary Get Referring Agency by referringAgencyUuid.
         * @param {string} referringAgencyId 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReferringAgencyById: async (referringAgencyId: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'referringAgencyId' is not null or undefined
            assertParamExists('getReferringAgencyById', 'referringAgencyId', referringAgencyId)
            const localVarPath = `/api/master/referring-agency/{referringAgencyId}`
                .replace(`{${"referringAgencyId"}}`, encodeURIComponent(String(referringAgencyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns false if the referring agency is attached to any patient, otherwise true.
         * @summary Get Referring Agency patient link status
         * @param {string} referringAgencyId 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReferringAgencyPatientLinkStatus: async (referringAgencyId: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'referringAgencyId' is not null or undefined
            assertParamExists('getReferringAgencyPatientLinkStatus', 'referringAgencyId', referringAgencyId)
            const localVarPath = `/api/master/referring-agency/{referringAgencyId}/patient-link-status`
                .replace(`{${"referringAgencyId"}}`, encodeURIComponent(String(referringAgencyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Edit an active Referring Agency. Agency ID is not editable.
         * @summary Update Referring Agency
         * @param {ReferringAgency} referringAgency 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateReferringAgency: async (referringAgency: ReferringAgency, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'referringAgency' is not null or undefined
            assertParamExists('updateReferringAgency', 'referringAgency', referringAgency)
            const localVarPath = `/api/master/referring-agency`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(referringAgency, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Change Referring Agency archive status to either archived or restored.
         * @summary Archive/Restore Referring Agency
         * @param {string} referringAgencyId 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateReferringAgencyArchiveStatus: async (referringAgencyId: string, status: boolean, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'referringAgencyId' is not null or undefined
            assertParamExists('updateReferringAgencyArchiveStatus', 'referringAgencyId', referringAgencyId)
            // verify required parameter 'status' is not null or undefined
            assertParamExists('updateReferringAgencyArchiveStatus', 'status', status)
            const localVarPath = `/api/master/referring-agency/{referringAgencyId}/archive-status/{status}`
                .replace(`{${"referringAgencyId"}}`, encodeURIComponent(String(referringAgencyId)))
                .replace(`{${"status"}}`, encodeURIComponent(String(status)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ReferringAgencyControllerApi - functional programming interface
 * @export
 */
export const ReferringAgencyControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ReferringAgencyControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * Add a new Referring Agency and return it with its generated Agency ID.
         * @summary Add Referring Agency
         * @param {ReferringAgency} referringAgency 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createReferringAgency(referringAgency: ReferringAgency, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createReferringAgency(referringAgency, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReferringAgencyControllerApi.createReferringAgency']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get all Referring Agencies with search option on name, agency type and filter option on archive.
         * @summary Get all Referring Agencies.
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {boolean} [archive] 
         * @param {boolean} [active] 
         * @param {string} [searchString] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllReferringAgencies(page?: number, size?: number, sortBy?: string, sortDirection?: string, archive?: boolean, active?: boolean, searchString?: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllReferringAgencies(page, size, sortBy, sortDirection, archive, active, searchString, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReferringAgencyControllerApi.getAllReferringAgencies']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get Referring Agency by referringAgencyUuid.
         * @summary Get Referring Agency by referringAgencyUuid.
         * @param {string} referringAgencyId 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getReferringAgencyById(referringAgencyId: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getReferringAgencyById(referringAgencyId, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReferringAgencyControllerApi.getReferringAgencyById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns false if the referring agency is attached to any patient, otherwise true.
         * @summary Get Referring Agency patient link status
         * @param {string} referringAgencyId 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getReferringAgencyPatientLinkStatus(referringAgencyId: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getReferringAgencyPatientLinkStatus(referringAgencyId, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReferringAgencyControllerApi.getReferringAgencyPatientLinkStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Edit an active Referring Agency. Agency ID is not editable.
         * @summary Update Referring Agency
         * @param {ReferringAgency} referringAgency 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateReferringAgency(referringAgency: ReferringAgency, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateReferringAgency(referringAgency, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReferringAgencyControllerApi.updateReferringAgency']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Change Referring Agency archive status to either archived or restored.
         * @summary Archive/Restore Referring Agency
         * @param {string} referringAgencyId 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateReferringAgencyArchiveStatus(referringAgencyId: string, status: boolean, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateReferringAgencyArchiveStatus(referringAgencyId, status, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReferringAgencyControllerApi.updateReferringAgencyArchiveStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ReferringAgencyControllerApi - factory interface
 * @export
 */
export const ReferringAgencyControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ReferringAgencyControllerApiFp(configuration)
    return {
        /**
         * Add a new Referring Agency and return it with its generated Agency ID.
         * @summary Add Referring Agency
         * @param {ReferringAgency} referringAgency 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createReferringAgency(referringAgency: ReferringAgency, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.createReferringAgency(referringAgency, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all Referring Agencies with search option on name, agency type and filter option on archive.
         * @summary Get all Referring Agencies.
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {boolean} [archive] 
         * @param {boolean} [active] 
         * @param {string} [searchString] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllReferringAgencies(page?: number, size?: number, sortBy?: string, sortDirection?: string, archive?: boolean, active?: boolean, searchString?: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getAllReferringAgencies(page, size, sortBy, sortDirection, archive, active, searchString, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Get Referring Agency by referringAgencyUuid.
         * @summary Get Referring Agency by referringAgencyUuid.
         * @param {string} referringAgencyId 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReferringAgencyById(referringAgencyId: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getReferringAgencyById(referringAgencyId, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns false if the referring agency is attached to any patient, otherwise true.
         * @summary Get Referring Agency patient link status
         * @param {string} referringAgencyId 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReferringAgencyPatientLinkStatus(referringAgencyId: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getReferringAgencyPatientLinkStatus(referringAgencyId, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Edit an active Referring Agency. Agency ID is not editable.
         * @summary Update Referring Agency
         * @param {ReferringAgency} referringAgency 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateReferringAgency(referringAgency: ReferringAgency, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.updateReferringAgency(referringAgency, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Change Referring Agency archive status to either archived or restored.
         * @summary Archive/Restore Referring Agency
         * @param {string} referringAgencyId 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateReferringAgencyArchiveStatus(referringAgencyId: string, status: boolean, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.updateReferringAgencyArchiveStatus(referringAgencyId, status, xTENANTID, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ReferringAgencyControllerApi - object-oriented interface
 * @export
 * @class ReferringAgencyControllerApi
 * @extends {BaseAPI}
 */
export class ReferringAgencyControllerApi extends BaseAPI {
    /**
     * Add a new Referring Agency and return it with its generated Agency ID.
     * @summary Add Referring Agency
     * @param {ReferringAgency} referringAgency 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReferringAgencyControllerApi
     */
    public createReferringAgency(referringAgency: ReferringAgency, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return ReferringAgencyControllerApiFp(this.configuration).createReferringAgency(referringAgency, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all Referring Agencies with search option on name, agency type and filter option on archive.
     * @summary Get all Referring Agencies.
     * @param {number} [page] 
     * @param {number} [size] 
     * @param {string} [sortBy] 
     * @param {string} [sortDirection] 
     * @param {boolean} [archive] 
     * @param {boolean} [active] 
     * @param {string} [searchString] 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReferringAgencyControllerApi
     */
    public getAllReferringAgencies(page?: number, size?: number, sortBy?: string, sortDirection?: string, archive?: boolean, active?: boolean, searchString?: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return ReferringAgencyControllerApiFp(this.configuration).getAllReferringAgencies(page, size, sortBy, sortDirection, archive, active, searchString, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get Referring Agency by referringAgencyUuid.
     * @summary Get Referring Agency by referringAgencyUuid.
     * @param {string} referringAgencyId 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReferringAgencyControllerApi
     */
    public getReferringAgencyById(referringAgencyId: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return ReferringAgencyControllerApiFp(this.configuration).getReferringAgencyById(referringAgencyId, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns false if the referring agency is attached to any patient, otherwise true.
     * @summary Get Referring Agency patient link status
     * @param {string} referringAgencyId 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReferringAgencyControllerApi
     */
    public getReferringAgencyPatientLinkStatus(referringAgencyId: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return ReferringAgencyControllerApiFp(this.configuration).getReferringAgencyPatientLinkStatus(referringAgencyId, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Edit an active Referring Agency. Agency ID is not editable.
     * @summary Update Referring Agency
     * @param {ReferringAgency} referringAgency 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReferringAgencyControllerApi
     */
    public updateReferringAgency(referringAgency: ReferringAgency, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return ReferringAgencyControllerApiFp(this.configuration).updateReferringAgency(referringAgency, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Change Referring Agency archive status to either archived or restored.
     * @summary Archive/Restore Referring Agency
     * @param {string} referringAgencyId 
     * @param {boolean} status 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReferringAgencyControllerApi
     */
    public updateReferringAgencyArchiveStatus(referringAgencyId: string, status: boolean, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return ReferringAgencyControllerApiFp(this.configuration).updateReferringAgencyArchiveStatus(referringAgencyId, status, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * RequiringActionControllerApi - axios parameter creator
 * @export
 */
export const RequiringActionControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * get all requiring action from system with optional date filtering
         * @summary get all requiring action from system
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {string} [patient] 
         * @param {GetAllRequiringActionActionStatusEnum} [actionStatus] 
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllRequiringAction: async (page?: number, size?: number, sortBy?: string, sortDirection?: string, patient?: string, actionStatus?: GetAllRequiringActionActionStatusEnum, startDate?: string, endDate?: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/master/requiring-action`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }

            if (patient !== undefined) {
                localVarQueryParameter['patient'] = patient;
            }

            if (actionStatus !== undefined) {
                localVarQueryParameter['actionStatus'] = actionStatus;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString() :
                    startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString() :
                    endDate;
            }

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get provider\'s requiring actions for specific patient with emoji functionality and date-wise filtering
         * @summary Get provider\'s requiring actions for specific patient
         * @param {string} patientUuid 
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProviderRequiringActionsForPatient: async (patientUuid: string, startDate?: string, endDate?: string, page?: number, size?: number, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientUuid' is not null or undefined
            assertParamExists('getProviderRequiringActionsForPatient', 'patientUuid', patientUuid)
            const localVarPath = `/api/master/requiring-action/provider-requiring-action/paginated`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (patientUuid !== undefined) {
                localVarQueryParameter['patientUuid'] = patientUuid;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString() :
                    startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString() :
                    endDate;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get provider\'s requiring actions for specific patient with emoji functionality and date-wise filtering
         * @summary Get provider\'s requiring actions for specific patient
         * @param {string} patientUuid 
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProviderRequiringActionsForPatientV2: async (patientUuid: string, startDate?: string, endDate?: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientUuid' is not null or undefined
            assertParamExists('getProviderRequiringActionsForPatientV2', 'patientUuid', patientUuid)
            const localVarPath = `/api/master/requiring-action/provider-requiring-action`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (patientUuid !== undefined) {
                localVarQueryParameter['patientUuid'] = patientUuid;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString() :
                    startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString() :
                    endDate;
            }

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Change Department status to either active or inactive.
         * @summary Enable/Disable Department
         * @param {string} requiringActionId 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRequiringAction: async (requiringActionId: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'requiringActionId' is not null or undefined
            assertParamExists('updateRequiringAction', 'requiringActionId', requiringActionId)
            const localVarPath = `/api/master/requiring-action/{requiringActionId}/complete`
                .replace(`{${"requiringActionId"}}`, encodeURIComponent(String(requiringActionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RequiringActionControllerApi - functional programming interface
 * @export
 */
export const RequiringActionControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RequiringActionControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * get all requiring action from system with optional date filtering
         * @summary get all requiring action from system
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {string} [patient] 
         * @param {GetAllRequiringActionActionStatusEnum} [actionStatus] 
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllRequiringAction(page?: number, size?: number, sortBy?: string, sortDirection?: string, patient?: string, actionStatus?: GetAllRequiringActionActionStatusEnum, startDate?: string, endDate?: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllRequiringAction(page, size, sortBy, sortDirection, patient, actionStatus, startDate, endDate, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RequiringActionControllerApi.getAllRequiringAction']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get provider\'s requiring actions for specific patient with emoji functionality and date-wise filtering
         * @summary Get provider\'s requiring actions for specific patient
         * @param {string} patientUuid 
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProviderRequiringActionsForPatient(patientUuid: string, startDate?: string, endDate?: string, page?: number, size?: number, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProviderRequiringActionsForPatient(patientUuid, startDate, endDate, page, size, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RequiringActionControllerApi.getProviderRequiringActionsForPatient']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get provider\'s requiring actions for specific patient with emoji functionality and date-wise filtering
         * @summary Get provider\'s requiring actions for specific patient
         * @param {string} patientUuid 
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProviderRequiringActionsForPatientV2(patientUuid: string, startDate?: string, endDate?: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProviderRequiringActionsForPatientV2(patientUuid, startDate, endDate, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RequiringActionControllerApi.getProviderRequiringActionsForPatientV2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Change Department status to either active or inactive.
         * @summary Enable/Disable Department
         * @param {string} requiringActionId 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateRequiringAction(requiringActionId: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateRequiringAction(requiringActionId, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RequiringActionControllerApi.updateRequiringAction']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * RequiringActionControllerApi - factory interface
 * @export
 */
export const RequiringActionControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RequiringActionControllerApiFp(configuration)
    return {
        /**
         * get all requiring action from system with optional date filtering
         * @summary get all requiring action from system
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {string} [patient] 
         * @param {GetAllRequiringActionActionStatusEnum} [actionStatus] 
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllRequiringAction(page?: number, size?: number, sortBy?: string, sortDirection?: string, patient?: string, actionStatus?: GetAllRequiringActionActionStatusEnum, startDate?: string, endDate?: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getAllRequiringAction(page, size, sortBy, sortDirection, patient, actionStatus, startDate, endDate, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Get provider\'s requiring actions for specific patient with emoji functionality and date-wise filtering
         * @summary Get provider\'s requiring actions for specific patient
         * @param {string} patientUuid 
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProviderRequiringActionsForPatient(patientUuid: string, startDate?: string, endDate?: string, page?: number, size?: number, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getProviderRequiringActionsForPatient(patientUuid, startDate, endDate, page, size, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Get provider\'s requiring actions for specific patient with emoji functionality and date-wise filtering
         * @summary Get provider\'s requiring actions for specific patient
         * @param {string} patientUuid 
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProviderRequiringActionsForPatientV2(patientUuid: string, startDate?: string, endDate?: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getProviderRequiringActionsForPatientV2(patientUuid, startDate, endDate, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Change Department status to either active or inactive.
         * @summary Enable/Disable Department
         * @param {string} requiringActionId 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRequiringAction(requiringActionId: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.updateRequiringAction(requiringActionId, xTENANTID, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RequiringActionControllerApi - object-oriented interface
 * @export
 * @class RequiringActionControllerApi
 * @extends {BaseAPI}
 */
export class RequiringActionControllerApi extends BaseAPI {
    /**
     * get all requiring action from system with optional date filtering
     * @summary get all requiring action from system
     * @param {number} [page] 
     * @param {number} [size] 
     * @param {string} [sortBy] 
     * @param {string} [sortDirection] 
     * @param {string} [patient] 
     * @param {GetAllRequiringActionActionStatusEnum} [actionStatus] 
     * @param {string} [startDate] 
     * @param {string} [endDate] 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RequiringActionControllerApi
     */
    public getAllRequiringAction(page?: number, size?: number, sortBy?: string, sortDirection?: string, patient?: string, actionStatus?: GetAllRequiringActionActionStatusEnum, startDate?: string, endDate?: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return RequiringActionControllerApiFp(this.configuration).getAllRequiringAction(page, size, sortBy, sortDirection, patient, actionStatus, startDate, endDate, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get provider\'s requiring actions for specific patient with emoji functionality and date-wise filtering
     * @summary Get provider\'s requiring actions for specific patient
     * @param {string} patientUuid 
     * @param {string} [startDate] 
     * @param {string} [endDate] 
     * @param {number} [page] 
     * @param {number} [size] 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RequiringActionControllerApi
     */
    public getProviderRequiringActionsForPatient(patientUuid: string, startDate?: string, endDate?: string, page?: number, size?: number, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return RequiringActionControllerApiFp(this.configuration).getProviderRequiringActionsForPatient(patientUuid, startDate, endDate, page, size, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get provider\'s requiring actions for specific patient with emoji functionality and date-wise filtering
     * @summary Get provider\'s requiring actions for specific patient
     * @param {string} patientUuid 
     * @param {string} [startDate] 
     * @param {string} [endDate] 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RequiringActionControllerApi
     */
    public getProviderRequiringActionsForPatientV2(patientUuid: string, startDate?: string, endDate?: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return RequiringActionControllerApiFp(this.configuration).getProviderRequiringActionsForPatientV2(patientUuid, startDate, endDate, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Change Department status to either active or inactive.
     * @summary Enable/Disable Department
     * @param {string} requiringActionId 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RequiringActionControllerApi
     */
    public updateRequiringAction(requiringActionId: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return RequiringActionControllerApiFp(this.configuration).updateRequiringAction(requiringActionId, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const GetAllRequiringActionActionStatusEnum = {
    Pending: 'PENDING',
    Completed: 'COMPLETED',
    Scheduled: 'SCHEDULED'
} as const;
export type GetAllRequiringActionActionStatusEnum = typeof GetAllRequiringActionActionStatusEnum[keyof typeof GetAllRequiringActionActionStatusEnum];


/**
 * RolesAndPrivilegesControllerApi - axios parameter creator
 * @export
 */
export const RolesAndPrivilegesControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Add a new Role
         * @summary Add New Role
         * @param {Role} role 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addNewRole: async (role: Role, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'role' is not null or undefined
            assertParamExists('addNewRole', 'role', role)
            const localVarPath = `/api/master/role/add-new-role`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(role, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Add a new Role and Privileges
         * @summary Add Role And Privileges
         * @param {Array<RolePrivilegeMapping>} rolePrivilegeMapping 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addRoleAndPrivilege: async (rolePrivilegeMapping: Array<RolePrivilegeMapping>, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'rolePrivilegeMapping' is not null or undefined
            assertParamExists('addRoleAndPrivilege', 'rolePrivilegeMapping', rolePrivilegeMapping)
            const localVarPath = `/api/master/role/roles-privileges`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(rolePrivilegeMapping, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all Privileges
         * @summary Get all Privileges.
         * @param {string} [module] 
         * @param {number} [roleId] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllPrivileges: async (module?: string, roleId?: number, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/master/role/privileges`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (module !== undefined) {
                localVarQueryParameter['module'] = module;
            }

            if (roleId !== undefined) {
                localVarQueryParameter['roleId'] = roleId;
            }

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all roles with pagination and filters
         * @summary Get all.
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {boolean} [status] 
         * @param {boolean} [archive] 
         * @param {Array<GetAllRoleRoleTypeEnum>} [roleType] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllRole: async (page?: number, size?: number, sortBy?: string, sortDirection?: string, status?: boolean, archive?: boolean, roleType?: Array<GetAllRoleRoleTypeEnum>, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/master/role/all-roles`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (archive !== undefined) {
                localVarQueryParameter['archive'] = archive;
            }

            if (roleType) {
                localVarQueryParameter['roleType'] = roleType;
            }

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all Roles list with their Privileges
         * @summary Get all Roles with Privileges.
         * @param {string} [roleName] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllRoles: async (roleName?: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/master/role`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (roleName !== undefined) {
                localVarQueryParameter['roleName'] = roleName;
            }

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get roles with only name and type using interface projection and search functionality.
         * @summary Get roles with name and type.
         * @param {string} [search] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRolesWithNameAndType: async (search?: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/master/role/roles-name-type`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Import initial roles and their privilege mappings from public schema
         * @summary Import initial roles
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importInitialRoles: async (xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/master/role/import-initial-roles`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Synchronize all database roles to Keycloak realm for current tenant
         * @summary Sync roles to Keycloak
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncRolesToKeycloak: async (xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/master/role/sync-to-keycloak`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Convert underscores to spaces in all existing role names
         * @summary Update existing role names
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateExistingRoleNames: async (xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/master/role/update-existing-role-names`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update an existing Role
         * @summary Update Role
         * @param {Role} role 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRole: async (role: Role, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'role' is not null or undefined
            assertParamExists('updateRole', 'role', role)
            const localVarPath = `/api/master/role`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(role, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Change Role archive status to either archived or unarchived.
         * @summary Archive/Un-archive Role
         * @param {number} roleId 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRoleArchiveStatus: async (roleId: number, status: boolean, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'roleId' is not null or undefined
            assertParamExists('updateRoleArchiveStatus', 'roleId', roleId)
            // verify required parameter 'status' is not null or undefined
            assertParamExists('updateRoleArchiveStatus', 'status', status)
            const localVarPath = `/api/master/role/{roleId}/archive-status/{status}`
                .replace(`{${"roleId"}}`, encodeURIComponent(String(roleId)))
                .replace(`{${"status"}}`, encodeURIComponent(String(status)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Change the role status.
         * @summary Enable/Disable Role
         * @param {number} roleId 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRoleStatus: async (roleId: number, status: boolean, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'roleId' is not null or undefined
            assertParamExists('updateRoleStatus', 'roleId', roleId)
            // verify required parameter 'status' is not null or undefined
            assertParamExists('updateRoleStatus', 'status', status)
            const localVarPath = `/api/master/role/{roleId}/status/{status}`
                .replace(`{${"roleId"}}`, encodeURIComponent(String(roleId)))
                .replace(`{${"status"}}`, encodeURIComponent(String(status)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RolesAndPrivilegesControllerApi - functional programming interface
 * @export
 */
export const RolesAndPrivilegesControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RolesAndPrivilegesControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * Add a new Role
         * @summary Add New Role
         * @param {Role} role 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addNewRole(role: Role, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addNewRole(role, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RolesAndPrivilegesControllerApi.addNewRole']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Add a new Role and Privileges
         * @summary Add Role And Privileges
         * @param {Array<RolePrivilegeMapping>} rolePrivilegeMapping 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addRoleAndPrivilege(rolePrivilegeMapping: Array<RolePrivilegeMapping>, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addRoleAndPrivilege(rolePrivilegeMapping, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RolesAndPrivilegesControllerApi.addRoleAndPrivilege']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get all Privileges
         * @summary Get all Privileges.
         * @param {string} [module] 
         * @param {number} [roleId] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllPrivileges(module?: string, roleId?: number, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllPrivileges(module, roleId, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RolesAndPrivilegesControllerApi.getAllPrivileges']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get all roles with pagination and filters
         * @summary Get all.
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {boolean} [status] 
         * @param {boolean} [archive] 
         * @param {Array<GetAllRoleRoleTypeEnum>} [roleType] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllRole(page?: number, size?: number, sortBy?: string, sortDirection?: string, status?: boolean, archive?: boolean, roleType?: Array<GetAllRoleRoleTypeEnum>, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllRole(page, size, sortBy, sortDirection, status, archive, roleType, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RolesAndPrivilegesControllerApi.getAllRole']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get all Roles list with their Privileges
         * @summary Get all Roles with Privileges.
         * @param {string} [roleName] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllRoles(roleName?: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllRoles(roleName, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RolesAndPrivilegesControllerApi.getAllRoles']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get roles with only name and type using interface projection and search functionality.
         * @summary Get roles with name and type.
         * @param {string} [search] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRolesWithNameAndType(search?: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRolesWithNameAndType(search, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RolesAndPrivilegesControllerApi.getRolesWithNameAndType']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Import initial roles and their privilege mappings from public schema
         * @summary Import initial roles
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async importInitialRoles(xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.importInitialRoles(xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RolesAndPrivilegesControllerApi.importInitialRoles']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Synchronize all database roles to Keycloak realm for current tenant
         * @summary Sync roles to Keycloak
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async syncRolesToKeycloak(xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.syncRolesToKeycloak(xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RolesAndPrivilegesControllerApi.syncRolesToKeycloak']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Convert underscores to spaces in all existing role names
         * @summary Update existing role names
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateExistingRoleNames(xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateExistingRoleNames(xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RolesAndPrivilegesControllerApi.updateExistingRoleNames']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update an existing Role
         * @summary Update Role
         * @param {Role} role 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateRole(role: Role, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateRole(role, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RolesAndPrivilegesControllerApi.updateRole']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Change Role archive status to either archived or unarchived.
         * @summary Archive/Un-archive Role
         * @param {number} roleId 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateRoleArchiveStatus(roleId: number, status: boolean, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateRoleArchiveStatus(roleId, status, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RolesAndPrivilegesControllerApi.updateRoleArchiveStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Change the role status.
         * @summary Enable/Disable Role
         * @param {number} roleId 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateRoleStatus(roleId: number, status: boolean, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateRoleStatus(roleId, status, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RolesAndPrivilegesControllerApi.updateRoleStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * RolesAndPrivilegesControllerApi - factory interface
 * @export
 */
export const RolesAndPrivilegesControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RolesAndPrivilegesControllerApiFp(configuration)
    return {
        /**
         * Add a new Role
         * @summary Add New Role
         * @param {Role} role 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addNewRole(role: Role, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.addNewRole(role, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Add a new Role and Privileges
         * @summary Add Role And Privileges
         * @param {Array<RolePrivilegeMapping>} rolePrivilegeMapping 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addRoleAndPrivilege(rolePrivilegeMapping: Array<RolePrivilegeMapping>, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.addRoleAndPrivilege(rolePrivilegeMapping, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all Privileges
         * @summary Get all Privileges.
         * @param {string} [module] 
         * @param {number} [roleId] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllPrivileges(module?: string, roleId?: number, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getAllPrivileges(module, roleId, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all roles with pagination and filters
         * @summary Get all.
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {boolean} [status] 
         * @param {boolean} [archive] 
         * @param {Array<GetAllRoleRoleTypeEnum>} [roleType] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllRole(page?: number, size?: number, sortBy?: string, sortDirection?: string, status?: boolean, archive?: boolean, roleType?: Array<GetAllRoleRoleTypeEnum>, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getAllRole(page, size, sortBy, sortDirection, status, archive, roleType, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all Roles list with their Privileges
         * @summary Get all Roles with Privileges.
         * @param {string} [roleName] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllRoles(roleName?: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getAllRoles(roleName, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Get roles with only name and type using interface projection and search functionality.
         * @summary Get roles with name and type.
         * @param {string} [search] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRolesWithNameAndType(search?: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getRolesWithNameAndType(search, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Import initial roles and their privilege mappings from public schema
         * @summary Import initial roles
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importInitialRoles(xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.importInitialRoles(xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Synchronize all database roles to Keycloak realm for current tenant
         * @summary Sync roles to Keycloak
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncRolesToKeycloak(xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.syncRolesToKeycloak(xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Convert underscores to spaces in all existing role names
         * @summary Update existing role names
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateExistingRoleNames(xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.updateExistingRoleNames(xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Update an existing Role
         * @summary Update Role
         * @param {Role} role 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRole(role: Role, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.updateRole(role, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Change Role archive status to either archived or unarchived.
         * @summary Archive/Un-archive Role
         * @param {number} roleId 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRoleArchiveStatus(roleId: number, status: boolean, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.updateRoleArchiveStatus(roleId, status, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Change the role status.
         * @summary Enable/Disable Role
         * @param {number} roleId 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRoleStatus(roleId: number, status: boolean, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.updateRoleStatus(roleId, status, xTENANTID, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RolesAndPrivilegesControllerApi - object-oriented interface
 * @export
 * @class RolesAndPrivilegesControllerApi
 * @extends {BaseAPI}
 */
export class RolesAndPrivilegesControllerApi extends BaseAPI {
    /**
     * Add a new Role
     * @summary Add New Role
     * @param {Role} role 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RolesAndPrivilegesControllerApi
     */
    public addNewRole(role: Role, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return RolesAndPrivilegesControllerApiFp(this.configuration).addNewRole(role, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Add a new Role and Privileges
     * @summary Add Role And Privileges
     * @param {Array<RolePrivilegeMapping>} rolePrivilegeMapping 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RolesAndPrivilegesControllerApi
     */
    public addRoleAndPrivilege(rolePrivilegeMapping: Array<RolePrivilegeMapping>, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return RolesAndPrivilegesControllerApiFp(this.configuration).addRoleAndPrivilege(rolePrivilegeMapping, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all Privileges
     * @summary Get all Privileges.
     * @param {string} [module] 
     * @param {number} [roleId] 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RolesAndPrivilegesControllerApi
     */
    public getAllPrivileges(module?: string, roleId?: number, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return RolesAndPrivilegesControllerApiFp(this.configuration).getAllPrivileges(module, roleId, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all roles with pagination and filters
     * @summary Get all.
     * @param {number} [page] 
     * @param {number} [size] 
     * @param {string} [sortBy] 
     * @param {string} [sortDirection] 
     * @param {boolean} [status] 
     * @param {boolean} [archive] 
     * @param {Array<GetAllRoleRoleTypeEnum>} [roleType] 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RolesAndPrivilegesControllerApi
     */
    public getAllRole(page?: number, size?: number, sortBy?: string, sortDirection?: string, status?: boolean, archive?: boolean, roleType?: Array<GetAllRoleRoleTypeEnum>, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return RolesAndPrivilegesControllerApiFp(this.configuration).getAllRole(page, size, sortBy, sortDirection, status, archive, roleType, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all Roles list with their Privileges
     * @summary Get all Roles with Privileges.
     * @param {string} [roleName] 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RolesAndPrivilegesControllerApi
     */
    public getAllRoles(roleName?: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return RolesAndPrivilegesControllerApiFp(this.configuration).getAllRoles(roleName, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get roles with only name and type using interface projection and search functionality.
     * @summary Get roles with name and type.
     * @param {string} [search] 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RolesAndPrivilegesControllerApi
     */
    public getRolesWithNameAndType(search?: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return RolesAndPrivilegesControllerApiFp(this.configuration).getRolesWithNameAndType(search, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Import initial roles and their privilege mappings from public schema
     * @summary Import initial roles
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RolesAndPrivilegesControllerApi
     */
    public importInitialRoles(xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return RolesAndPrivilegesControllerApiFp(this.configuration).importInitialRoles(xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Synchronize all database roles to Keycloak realm for current tenant
     * @summary Sync roles to Keycloak
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RolesAndPrivilegesControllerApi
     */
    public syncRolesToKeycloak(xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return RolesAndPrivilegesControllerApiFp(this.configuration).syncRolesToKeycloak(xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Convert underscores to spaces in all existing role names
     * @summary Update existing role names
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RolesAndPrivilegesControllerApi
     */
    public updateExistingRoleNames(xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return RolesAndPrivilegesControllerApiFp(this.configuration).updateExistingRoleNames(xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update an existing Role
     * @summary Update Role
     * @param {Role} role 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RolesAndPrivilegesControllerApi
     */
    public updateRole(role: Role, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return RolesAndPrivilegesControllerApiFp(this.configuration).updateRole(role, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Change Role archive status to either archived or unarchived.
     * @summary Archive/Un-archive Role
     * @param {number} roleId 
     * @param {boolean} status 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RolesAndPrivilegesControllerApi
     */
    public updateRoleArchiveStatus(roleId: number, status: boolean, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return RolesAndPrivilegesControllerApiFp(this.configuration).updateRoleArchiveStatus(roleId, status, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Change the role status.
     * @summary Enable/Disable Role
     * @param {number} roleId 
     * @param {boolean} status 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RolesAndPrivilegesControllerApi
     */
    public updateRoleStatus(roleId: number, status: boolean, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return RolesAndPrivilegesControllerApiFp(this.configuration).updateRoleStatus(roleId, status, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const GetAllRoleRoleTypeEnum = {
    Provider: 'PROVIDER',
    Staff: 'STAFF',
    Patient: 'PATIENT',
    Admin: 'ADMIN',
    Physician: 'PHYSICIAN',
    BillingAdmin: 'BILLING_ADMIN',
    Biller: 'BILLER',
    FrontDeskStaff: 'FRONT_DESK_STAFF',
    SalesCoordinator: 'SALES_COORDINATOR',
    Support: 'SUPPORT',
    PracticeAdmin: 'PRACTICE_ADMIN',
    CareManager: 'CARE_MANAGER'
} as const;
export type GetAllRoleRoleTypeEnum = typeof GetAllRoleRoleTypeEnum[keyof typeof GetAllRoleRoleTypeEnum];


/**
 * RosTemplateControllerApi - axios parameter creator
 * @export
 */
export const RosTemplateControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Create a Ros Template
         * @summary Create Ros Template
         * @param {RosTemplate} rosTemplate 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRosTemplate: async (rosTemplate: RosTemplate, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'rosTemplate' is not null or undefined
            assertParamExists('createRosTemplate', 'rosTemplate', rosTemplate)
            const localVarPath = `/api/master/ros-template`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(rosTemplate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all ROS Template. 
         * @summary Get all ROS Template
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {Array<string>} [specialityUuids] 
         * @param {boolean} [status] 
         * @param {boolean} [archive] 
         * @param {Array<GetAllClaimTemplateTypesEnum>} [templateTypes] 
         * @param {string} [searchString] 
         * @param {string} [appointmentId] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllClaim: async (page?: number, size?: number, sortBy?: string, sortDirection?: string, specialityUuids?: Array<string>, status?: boolean, archive?: boolean, templateTypes?: Array<GetAllClaimTemplateTypesEnum>, searchString?: string, appointmentId?: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/master/ros-template`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }

            if (specialityUuids) {
                localVarQueryParameter['specialityUuids'] = specialityUuids;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (archive !== undefined) {
                localVarQueryParameter['archive'] = archive;
            }

            if (templateTypes) {
                localVarQueryParameter['templateTypes'] = templateTypes;
            }

            if (searchString !== undefined) {
                localVarQueryParameter['searchString'] = searchString;
            }

            if (appointmentId !== undefined) {
                localVarQueryParameter['appointmentId'] = appointmentId;
            }

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get ros template by Id
         * @summary Get ros template by Id.
         * @param {string} rosTemplateUuid 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRosTemplateById: async (rosTemplateUuid: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'rosTemplateUuid' is not null or undefined
            assertParamExists('getRosTemplateById', 'rosTemplateUuid', rosTemplateUuid)
            const localVarPath = `/api/master/ros-template/{rosTemplateUuid}`
                .replace(`{${"rosTemplateUuid"}}`, encodeURIComponent(String(rosTemplateUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Archive a ros template by its ID
         * @summary Archive Ros Template Archive Status
         * @param {string} rosTemplateUuid 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRosArchiveStatus: async (rosTemplateUuid: string, status: boolean, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'rosTemplateUuid' is not null or undefined
            assertParamExists('updateRosArchiveStatus', 'rosTemplateUuid', rosTemplateUuid)
            // verify required parameter 'status' is not null or undefined
            assertParamExists('updateRosArchiveStatus', 'status', status)
            const localVarPath = `/api/master/ros-template/{rosTemplateUuid}/archive-status/{status}`
                .replace(`{${"rosTemplateUuid"}}`, encodeURIComponent(String(rosTemplateUuid)))
                .replace(`{${"status"}}`, encodeURIComponent(String(status)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Edit Ros Template
         * @summary Update Ros Template
         * @param {RosTemplate} rosTemplate 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRosTemplate: async (rosTemplate: RosTemplate, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'rosTemplate' is not null or undefined
            assertParamExists('updateRosTemplate', 'rosTemplate', rosTemplate)
            const localVarPath = `/api/master/ros-template`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(rosTemplate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update the status of a ROS template by its ID
         * @summary Update Ros Template Status
         * @param {string} rosTemplateUuid 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRosTemplateStatus: async (rosTemplateUuid: string, status: boolean, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'rosTemplateUuid' is not null or undefined
            assertParamExists('updateRosTemplateStatus', 'rosTemplateUuid', rosTemplateUuid)
            // verify required parameter 'status' is not null or undefined
            assertParamExists('updateRosTemplateStatus', 'status', status)
            const localVarPath = `/api/master/ros-template/{rosTemplateUuid}/status/{status}`
                .replace(`{${"rosTemplateUuid"}}`, encodeURIComponent(String(rosTemplateUuid)))
                .replace(`{${"status"}}`, encodeURIComponent(String(status)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RosTemplateControllerApi - functional programming interface
 * @export
 */
export const RosTemplateControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RosTemplateControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * Create a Ros Template
         * @summary Create Ros Template
         * @param {RosTemplate} rosTemplate 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createRosTemplate(rosTemplate: RosTemplate, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createRosTemplate(rosTemplate, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RosTemplateControllerApi.createRosTemplate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get all ROS Template. 
         * @summary Get all ROS Template
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {Array<string>} [specialityUuids] 
         * @param {boolean} [status] 
         * @param {boolean} [archive] 
         * @param {Array<GetAllClaimTemplateTypesEnum>} [templateTypes] 
         * @param {string} [searchString] 
         * @param {string} [appointmentId] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllClaim(page?: number, size?: number, sortBy?: string, sortDirection?: string, specialityUuids?: Array<string>, status?: boolean, archive?: boolean, templateTypes?: Array<GetAllClaimTemplateTypesEnum>, searchString?: string, appointmentId?: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllClaim(page, size, sortBy, sortDirection, specialityUuids, status, archive, templateTypes, searchString, appointmentId, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RosTemplateControllerApi.getAllClaim']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get ros template by Id
         * @summary Get ros template by Id.
         * @param {string} rosTemplateUuid 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRosTemplateById(rosTemplateUuid: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRosTemplateById(rosTemplateUuid, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RosTemplateControllerApi.getRosTemplateById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Archive a ros template by its ID
         * @summary Archive Ros Template Archive Status
         * @param {string} rosTemplateUuid 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateRosArchiveStatus(rosTemplateUuid: string, status: boolean, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateRosArchiveStatus(rosTemplateUuid, status, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RosTemplateControllerApi.updateRosArchiveStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Edit Ros Template
         * @summary Update Ros Template
         * @param {RosTemplate} rosTemplate 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateRosTemplate(rosTemplate: RosTemplate, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateRosTemplate(rosTemplate, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RosTemplateControllerApi.updateRosTemplate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update the status of a ROS template by its ID
         * @summary Update Ros Template Status
         * @param {string} rosTemplateUuid 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateRosTemplateStatus(rosTemplateUuid: string, status: boolean, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateRosTemplateStatus(rosTemplateUuid, status, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RosTemplateControllerApi.updateRosTemplateStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * RosTemplateControllerApi - factory interface
 * @export
 */
export const RosTemplateControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RosTemplateControllerApiFp(configuration)
    return {
        /**
         * Create a Ros Template
         * @summary Create Ros Template
         * @param {RosTemplate} rosTemplate 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRosTemplate(rosTemplate: RosTemplate, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.createRosTemplate(rosTemplate, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all ROS Template. 
         * @summary Get all ROS Template
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {Array<string>} [specialityUuids] 
         * @param {boolean} [status] 
         * @param {boolean} [archive] 
         * @param {Array<GetAllClaimTemplateTypesEnum>} [templateTypes] 
         * @param {string} [searchString] 
         * @param {string} [appointmentId] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllClaim(page?: number, size?: number, sortBy?: string, sortDirection?: string, specialityUuids?: Array<string>, status?: boolean, archive?: boolean, templateTypes?: Array<GetAllClaimTemplateTypesEnum>, searchString?: string, appointmentId?: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getAllClaim(page, size, sortBy, sortDirection, specialityUuids, status, archive, templateTypes, searchString, appointmentId, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Get ros template by Id
         * @summary Get ros template by Id.
         * @param {string} rosTemplateUuid 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRosTemplateById(rosTemplateUuid: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getRosTemplateById(rosTemplateUuid, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Archive a ros template by its ID
         * @summary Archive Ros Template Archive Status
         * @param {string} rosTemplateUuid 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRosArchiveStatus(rosTemplateUuid: string, status: boolean, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.updateRosArchiveStatus(rosTemplateUuid, status, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Edit Ros Template
         * @summary Update Ros Template
         * @param {RosTemplate} rosTemplate 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRosTemplate(rosTemplate: RosTemplate, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.updateRosTemplate(rosTemplate, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Update the status of a ROS template by its ID
         * @summary Update Ros Template Status
         * @param {string} rosTemplateUuid 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRosTemplateStatus(rosTemplateUuid: string, status: boolean, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.updateRosTemplateStatus(rosTemplateUuid, status, xTENANTID, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RosTemplateControllerApi - object-oriented interface
 * @export
 * @class RosTemplateControllerApi
 * @extends {BaseAPI}
 */
export class RosTemplateControllerApi extends BaseAPI {
    /**
     * Create a Ros Template
     * @summary Create Ros Template
     * @param {RosTemplate} rosTemplate 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RosTemplateControllerApi
     */
    public createRosTemplate(rosTemplate: RosTemplate, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return RosTemplateControllerApiFp(this.configuration).createRosTemplate(rosTemplate, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all ROS Template. 
     * @summary Get all ROS Template
     * @param {number} [page] 
     * @param {number} [size] 
     * @param {string} [sortBy] 
     * @param {string} [sortDirection] 
     * @param {Array<string>} [specialityUuids] 
     * @param {boolean} [status] 
     * @param {boolean} [archive] 
     * @param {Array<GetAllClaimTemplateTypesEnum>} [templateTypes] 
     * @param {string} [searchString] 
     * @param {string} [appointmentId] 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RosTemplateControllerApi
     */
    public getAllClaim(page?: number, size?: number, sortBy?: string, sortDirection?: string, specialityUuids?: Array<string>, status?: boolean, archive?: boolean, templateTypes?: Array<GetAllClaimTemplateTypesEnum>, searchString?: string, appointmentId?: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return RosTemplateControllerApiFp(this.configuration).getAllClaim(page, size, sortBy, sortDirection, specialityUuids, status, archive, templateTypes, searchString, appointmentId, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get ros template by Id
     * @summary Get ros template by Id.
     * @param {string} rosTemplateUuid 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RosTemplateControllerApi
     */
    public getRosTemplateById(rosTemplateUuid: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return RosTemplateControllerApiFp(this.configuration).getRosTemplateById(rosTemplateUuid, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Archive a ros template by its ID
     * @summary Archive Ros Template Archive Status
     * @param {string} rosTemplateUuid 
     * @param {boolean} status 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RosTemplateControllerApi
     */
    public updateRosArchiveStatus(rosTemplateUuid: string, status: boolean, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return RosTemplateControllerApiFp(this.configuration).updateRosArchiveStatus(rosTemplateUuid, status, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Edit Ros Template
     * @summary Update Ros Template
     * @param {RosTemplate} rosTemplate 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RosTemplateControllerApi
     */
    public updateRosTemplate(rosTemplate: RosTemplate, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return RosTemplateControllerApiFp(this.configuration).updateRosTemplate(rosTemplate, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update the status of a ROS template by its ID
     * @summary Update Ros Template Status
     * @param {string} rosTemplateUuid 
     * @param {boolean} status 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RosTemplateControllerApi
     */
    public updateRosTemplateStatus(rosTemplateUuid: string, status: boolean, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return RosTemplateControllerApiFp(this.configuration).updateRosTemplateStatus(rosTemplateUuid, status, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const GetAllClaimTemplateTypesEnum = {
    Email: 'EMAIL',
    Sms: 'SMS',
    Ros: 'ROS',
    Physical: 'PHYSICAL',
    Macros: 'MACROS',
    CarePlan: 'CARE_PLAN',
    HomeCareRos: 'HOME_CARE_ROS',
    HomeCarePe: 'HOME_CARE_PE'
} as const;
export type GetAllClaimTemplateTypesEnum = typeof GetAllClaimTemplateTypesEnum[keyof typeof GetAllClaimTemplateTypesEnum];


/**
 * RosTemplateTypeControllerApi - axios parameter creator
 * @export
 */
export const RosTemplateTypeControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Add a new Ros Template type into the system.
         * @summary Add Ros Template Type
         * @param {RosTemplateType} rosTemplateType 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRosTemplateType: async (rosTemplateType: RosTemplateType, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'rosTemplateType' is not null or undefined
            assertParamExists('createRosTemplateType', 'rosTemplateType', rosTemplateType)
            const localVarPath = `/api/master/ros-template-type`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(rosTemplateType, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all Ros template type
         * @summary Get all Ros template Type.
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {boolean} [isBaseType] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllDepartments1: async (page?: number, size?: number, sortBy?: string, sortDirection?: string, isBaseType?: boolean, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/master/ros-template-type`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }

            if (isBaseType !== undefined) {
                localVarQueryParameter['isBaseType'] = isBaseType;
            }

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RosTemplateTypeControllerApi - functional programming interface
 * @export
 */
export const RosTemplateTypeControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RosTemplateTypeControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * Add a new Ros Template type into the system.
         * @summary Add Ros Template Type
         * @param {RosTemplateType} rosTemplateType 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createRosTemplateType(rosTemplateType: RosTemplateType, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createRosTemplateType(rosTemplateType, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RosTemplateTypeControllerApi.createRosTemplateType']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get all Ros template type
         * @summary Get all Ros template Type.
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {boolean} [isBaseType] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllDepartments1(page?: number, size?: number, sortBy?: string, sortDirection?: string, isBaseType?: boolean, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllDepartments1(page, size, sortBy, sortDirection, isBaseType, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RosTemplateTypeControllerApi.getAllDepartments1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * RosTemplateTypeControllerApi - factory interface
 * @export
 */
export const RosTemplateTypeControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RosTemplateTypeControllerApiFp(configuration)
    return {
        /**
         * Add a new Ros Template type into the system.
         * @summary Add Ros Template Type
         * @param {RosTemplateType} rosTemplateType 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRosTemplateType(rosTemplateType: RosTemplateType, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.createRosTemplateType(rosTemplateType, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all Ros template type
         * @summary Get all Ros template Type.
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {boolean} [isBaseType] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllDepartments1(page?: number, size?: number, sortBy?: string, sortDirection?: string, isBaseType?: boolean, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getAllDepartments1(page, size, sortBy, sortDirection, isBaseType, xTENANTID, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RosTemplateTypeControllerApi - object-oriented interface
 * @export
 * @class RosTemplateTypeControllerApi
 * @extends {BaseAPI}
 */
export class RosTemplateTypeControllerApi extends BaseAPI {
    /**
     * Add a new Ros Template type into the system.
     * @summary Add Ros Template Type
     * @param {RosTemplateType} rosTemplateType 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RosTemplateTypeControllerApi
     */
    public createRosTemplateType(rosTemplateType: RosTemplateType, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return RosTemplateTypeControllerApiFp(this.configuration).createRosTemplateType(rosTemplateType, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all Ros template type
     * @summary Get all Ros template Type.
     * @param {number} [page] 
     * @param {number} [size] 
     * @param {string} [sortBy] 
     * @param {string} [sortDirection] 
     * @param {boolean} [isBaseType] 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RosTemplateTypeControllerApi
     */
    public getAllDepartments1(page?: number, size?: number, sortBy?: string, sortDirection?: string, isBaseType?: boolean, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return RosTemplateTypeControllerApiFp(this.configuration).getAllDepartments1(page, size, sortBy, sortDirection, isBaseType, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ScreenerControllerApi - axios parameter creator
 * @export
 */
export const ScreenerControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get all distinct screener types (e.g., GAD7, PHQ9) with pagination. Search by screener type name.
         * @summary Get all screener types with pagination and search
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {string} [searchString] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllScreenerTypes: async (page?: number, size?: number, sortBy?: string, sortDirection?: string, searchString?: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/master/screener/types`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }

            if (searchString !== undefined) {
                localVarQueryParameter['searchString'] = searchString;
            }

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get screener questions by specific type
         * @summary Get screener by type
         * @param {string} type 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getScreenerByType: async (type: string, page?: number, size?: number, sortBy?: string, sortDirection?: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'type' is not null or undefined
            assertParamExists('getScreenerByType', 'type', type)
            const localVarPath = `/api/master/screener`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }

            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ScreenerControllerApi - functional programming interface
 * @export
 */
export const ScreenerControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ScreenerControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * Get all distinct screener types (e.g., GAD7, PHQ9) with pagination. Search by screener type name.
         * @summary Get all screener types with pagination and search
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {string} [searchString] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllScreenerTypes(page?: number, size?: number, sortBy?: string, sortDirection?: string, searchString?: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllScreenerTypes(page, size, sortBy, sortDirection, searchString, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ScreenerControllerApi.getAllScreenerTypes']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get screener questions by specific type
         * @summary Get screener by type
         * @param {string} type 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getScreenerByType(type: string, page?: number, size?: number, sortBy?: string, sortDirection?: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getScreenerByType(type, page, size, sortBy, sortDirection, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ScreenerControllerApi.getScreenerByType']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ScreenerControllerApi - factory interface
 * @export
 */
export const ScreenerControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ScreenerControllerApiFp(configuration)
    return {
        /**
         * Get all distinct screener types (e.g., GAD7, PHQ9) with pagination. Search by screener type name.
         * @summary Get all screener types with pagination and search
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {string} [searchString] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllScreenerTypes(page?: number, size?: number, sortBy?: string, sortDirection?: string, searchString?: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getAllScreenerTypes(page, size, sortBy, sortDirection, searchString, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Get screener questions by specific type
         * @summary Get screener by type
         * @param {string} type 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getScreenerByType(type: string, page?: number, size?: number, sortBy?: string, sortDirection?: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getScreenerByType(type, page, size, sortBy, sortDirection, xTENANTID, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ScreenerControllerApi - object-oriented interface
 * @export
 * @class ScreenerControllerApi
 * @extends {BaseAPI}
 */
export class ScreenerControllerApi extends BaseAPI {
    /**
     * Get all distinct screener types (e.g., GAD7, PHQ9) with pagination. Search by screener type name.
     * @summary Get all screener types with pagination and search
     * @param {number} [page] 
     * @param {number} [size] 
     * @param {string} [sortBy] 
     * @param {string} [sortDirection] 
     * @param {string} [searchString] 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ScreenerControllerApi
     */
    public getAllScreenerTypes(page?: number, size?: number, sortBy?: string, sortDirection?: string, searchString?: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return ScreenerControllerApiFp(this.configuration).getAllScreenerTypes(page, size, sortBy, sortDirection, searchString, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get screener questions by specific type
     * @summary Get screener by type
     * @param {string} type 
     * @param {number} [page] 
     * @param {number} [size] 
     * @param {string} [sortBy] 
     * @param {string} [sortDirection] 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ScreenerControllerApi
     */
    public getScreenerByType(type: string, page?: number, size?: number, sortBy?: string, sortDirection?: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return ScreenerControllerApiFp(this.configuration).getScreenerByType(type, page, size, sortBy, sortDirection, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ScriptSureControllerApi - axios parameter creator
 * @export
 */
export const ScriptSureControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Accepts allergy payload from ScriptSure and processes it
         * @summary Allergy webhook
         * @param {{ [key: string]: object; }} requestBody 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        allergyWebhook: async (requestBody: { [key: string]: object; }, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'requestBody' is not null or undefined
            assertParamExists('allergyWebhook', 'requestBody', requestBody)
            const localVarPath = `/api/master/scriptsure/webhook/allergy`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get patient allergy by patientUuid
         * @summary Get patient allergy by patient id.
         * @param {string} patientUuid 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatientById: async (patientUuid: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientUuid' is not null or undefined
            assertParamExists('getPatientById', 'patientUuid', patientUuid)
            const localVarPath = `/api/master/scriptsure/sync-allergy/{patientUuid}`
                .replace(`{${"patientUuid"}}`, encodeURIComponent(String(patientUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Builds the ScriptSure profile URL using patient\'s ScriptSure ID and a session token generated for the provider\'s email. Dark mode is hardcoded off. Type parameter can be \'Allergy\' or \'prescription\'.
         * @summary Get ScriptSure profile URL for patient
         * @param {string} patientId 
         * @param {string} providerId 
         * @param {GetScriptsureProfileUrlTypeEnum} [type] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getScriptsureProfileUrl: async (patientId: string, providerId: string, type?: GetScriptsureProfileUrlTypeEnum, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientId' is not null or undefined
            assertParamExists('getScriptsureProfileUrl', 'patientId', patientId)
            // verify required parameter 'providerId' is not null or undefined
            assertParamExists('getScriptsureProfileUrl', 'providerId', providerId)
            const localVarPath = `/api/master/scriptsure/profile-url`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (patientId !== undefined) {
                localVarQueryParameter['patientId'] = patientId;
            }

            if (providerId !== undefined) {
                localVarQueryParameter['providerId'] = providerId;
            }

            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns a ScriptSure session token for the given email.
         * @summary Get ScriptSure session token by email
         * @param {string} email 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSessionTokenByEmail: async (email: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'email' is not null or undefined
            assertParamExists('getSessionTokenByEmail', 'email', email)
            const localVarPath = `/api/master/scriptsure/session-token`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Accepts prescription payload from ScriptSure and processes it
         * @summary Prescription webhook
         * @param {{ [key: string]: object; }} requestBody 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        prescriptionWebhook: async (requestBody: { [key: string]: object; }, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'requestBody' is not null or undefined
            assertParamExists('prescriptionWebhook', 'requestBody', requestBody)
            const localVarPath = `/api/master/scriptsure/webhook/prescription`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Webhook endpoint to accept ScriptSure organization invite data.
         * @summary ScriptSure Invite Webhook
         * @param {{ [key: string]: object; }} requestBody 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        scriptSureInviteWebhook: async (requestBody: { [key: string]: object; }, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'requestBody' is not null or undefined
            assertParamExists('scriptSureInviteWebhook', 'requestBody', requestBody)
            const localVarPath = `/api/master/scriptsure/webhook/scriptsure-invite`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Creates an already-existing patient in ScriptSure when they were not synced at creation time.
         * @summary Sync an existing patient to ScriptSure
         * @param {string} patientUuid 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncPatient: async (patientUuid: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientUuid' is not null or undefined
            assertParamExists('syncPatient', 'patientUuid', patientUuid)
            const localVarPath = `/api/master/scriptsure/sync-patient/{patientUuid}`
                .replace(`{${"patientUuid"}}`, encodeURIComponent(String(patientUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ScriptSureControllerApi - functional programming interface
 * @export
 */
export const ScriptSureControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ScriptSureControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * Accepts allergy payload from ScriptSure and processes it
         * @summary Allergy webhook
         * @param {{ [key: string]: object; }} requestBody 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async allergyWebhook(requestBody: { [key: string]: object; }, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.allergyWebhook(requestBody, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ScriptSureControllerApi.allergyWebhook']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get patient allergy by patientUuid
         * @summary Get patient allergy by patient id.
         * @param {string} patientUuid 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPatientById(patientUuid: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPatientById(patientUuid, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ScriptSureControllerApi.getPatientById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Builds the ScriptSure profile URL using patient\'s ScriptSure ID and a session token generated for the provider\'s email. Dark mode is hardcoded off. Type parameter can be \'Allergy\' or \'prescription\'.
         * @summary Get ScriptSure profile URL for patient
         * @param {string} patientId 
         * @param {string} providerId 
         * @param {GetScriptsureProfileUrlTypeEnum} [type] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getScriptsureProfileUrl(patientId: string, providerId: string, type?: GetScriptsureProfileUrlTypeEnum, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getScriptsureProfileUrl(patientId, providerId, type, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ScriptSureControllerApi.getScriptsureProfileUrl']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns a ScriptSure session token for the given email.
         * @summary Get ScriptSure session token by email
         * @param {string} email 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSessionTokenByEmail(email: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSessionTokenByEmail(email, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ScriptSureControllerApi.getSessionTokenByEmail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Accepts prescription payload from ScriptSure and processes it
         * @summary Prescription webhook
         * @param {{ [key: string]: object; }} requestBody 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async prescriptionWebhook(requestBody: { [key: string]: object; }, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.prescriptionWebhook(requestBody, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ScriptSureControllerApi.prescriptionWebhook']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Webhook endpoint to accept ScriptSure organization invite data.
         * @summary ScriptSure Invite Webhook
         * @param {{ [key: string]: object; }} requestBody 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async scriptSureInviteWebhook(requestBody: { [key: string]: object; }, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.scriptSureInviteWebhook(requestBody, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ScriptSureControllerApi.scriptSureInviteWebhook']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Creates an already-existing patient in ScriptSure when they were not synced at creation time.
         * @summary Sync an existing patient to ScriptSure
         * @param {string} patientUuid 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async syncPatient(patientUuid: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.syncPatient(patientUuid, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ScriptSureControllerApi.syncPatient']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ScriptSureControllerApi - factory interface
 * @export
 */
export const ScriptSureControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ScriptSureControllerApiFp(configuration)
    return {
        /**
         * Accepts allergy payload from ScriptSure and processes it
         * @summary Allergy webhook
         * @param {{ [key: string]: object; }} requestBody 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        allergyWebhook(requestBody: { [key: string]: object; }, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.allergyWebhook(requestBody, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Get patient allergy by patientUuid
         * @summary Get patient allergy by patient id.
         * @param {string} patientUuid 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatientById(patientUuid: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getPatientById(patientUuid, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Builds the ScriptSure profile URL using patient\'s ScriptSure ID and a session token generated for the provider\'s email. Dark mode is hardcoded off. Type parameter can be \'Allergy\' or \'prescription\'.
         * @summary Get ScriptSure profile URL for patient
         * @param {string} patientId 
         * @param {string} providerId 
         * @param {GetScriptsureProfileUrlTypeEnum} [type] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getScriptsureProfileUrl(patientId: string, providerId: string, type?: GetScriptsureProfileUrlTypeEnum, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getScriptsureProfileUrl(patientId, providerId, type, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns a ScriptSure session token for the given email.
         * @summary Get ScriptSure session token by email
         * @param {string} email 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSessionTokenByEmail(email: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getSessionTokenByEmail(email, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Accepts prescription payload from ScriptSure and processes it
         * @summary Prescription webhook
         * @param {{ [key: string]: object; }} requestBody 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        prescriptionWebhook(requestBody: { [key: string]: object; }, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.prescriptionWebhook(requestBody, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Webhook endpoint to accept ScriptSure organization invite data.
         * @summary ScriptSure Invite Webhook
         * @param {{ [key: string]: object; }} requestBody 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        scriptSureInviteWebhook(requestBody: { [key: string]: object; }, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.scriptSureInviteWebhook(requestBody, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Creates an already-existing patient in ScriptSure when they were not synced at creation time.
         * @summary Sync an existing patient to ScriptSure
         * @param {string} patientUuid 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncPatient(patientUuid: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.syncPatient(patientUuid, xTENANTID, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ScriptSureControllerApi - object-oriented interface
 * @export
 * @class ScriptSureControllerApi
 * @extends {BaseAPI}
 */
export class ScriptSureControllerApi extends BaseAPI {
    /**
     * Accepts allergy payload from ScriptSure and processes it
     * @summary Allergy webhook
     * @param {{ [key: string]: object; }} requestBody 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ScriptSureControllerApi
     */
    public allergyWebhook(requestBody: { [key: string]: object; }, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return ScriptSureControllerApiFp(this.configuration).allergyWebhook(requestBody, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get patient allergy by patientUuid
     * @summary Get patient allergy by patient id.
     * @param {string} patientUuid 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ScriptSureControllerApi
     */
    public getPatientById(patientUuid: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return ScriptSureControllerApiFp(this.configuration).getPatientById(patientUuid, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Builds the ScriptSure profile URL using patient\'s ScriptSure ID and a session token generated for the provider\'s email. Dark mode is hardcoded off. Type parameter can be \'Allergy\' or \'prescription\'.
     * @summary Get ScriptSure profile URL for patient
     * @param {string} patientId 
     * @param {string} providerId 
     * @param {GetScriptsureProfileUrlTypeEnum} [type] 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ScriptSureControllerApi
     */
    public getScriptsureProfileUrl(patientId: string, providerId: string, type?: GetScriptsureProfileUrlTypeEnum, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return ScriptSureControllerApiFp(this.configuration).getScriptsureProfileUrl(patientId, providerId, type, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns a ScriptSure session token for the given email.
     * @summary Get ScriptSure session token by email
     * @param {string} email 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ScriptSureControllerApi
     */
    public getSessionTokenByEmail(email: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return ScriptSureControllerApiFp(this.configuration).getSessionTokenByEmail(email, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Accepts prescription payload from ScriptSure and processes it
     * @summary Prescription webhook
     * @param {{ [key: string]: object; }} requestBody 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ScriptSureControllerApi
     */
    public prescriptionWebhook(requestBody: { [key: string]: object; }, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return ScriptSureControllerApiFp(this.configuration).prescriptionWebhook(requestBody, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Webhook endpoint to accept ScriptSure organization invite data.
     * @summary ScriptSure Invite Webhook
     * @param {{ [key: string]: object; }} requestBody 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ScriptSureControllerApi
     */
    public scriptSureInviteWebhook(requestBody: { [key: string]: object; }, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return ScriptSureControllerApiFp(this.configuration).scriptSureInviteWebhook(requestBody, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Creates an already-existing patient in ScriptSure when they were not synced at creation time.
     * @summary Sync an existing patient to ScriptSure
     * @param {string} patientUuid 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ScriptSureControllerApi
     */
    public syncPatient(patientUuid: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return ScriptSureControllerApiFp(this.configuration).syncPatient(patientUuid, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const GetScriptsureProfileUrlTypeEnum = {
    Allergy: 'ALLERGY',
    Prescription: 'PRESCRIPTION'
} as const;
export type GetScriptsureProfileUrlTypeEnum = typeof GetScriptsureProfileUrlTypeEnum[keyof typeof GetScriptsureProfileUrlTypeEnum];


/**
 * SmsRecordControllerApi - axios parameter creator
 * @export
 */
export const SmsRecordControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get all sms record list.
         * @summary Get all sms record.
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {string} [patientUuid] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllSmsRecord: async (page?: number, size?: number, sortBy?: string, sortDirection?: string, patientUuid?: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/master/sms-record`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }

            if (patientUuid !== undefined) {
                localVarQueryParameter['patientUuid'] = patientUuid;
            }

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SmsRecordControllerApi - functional programming interface
 * @export
 */
export const SmsRecordControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SmsRecordControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * Get all sms record list.
         * @summary Get all sms record.
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {string} [patientUuid] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllSmsRecord(page?: number, size?: number, sortBy?: string, sortDirection?: string, patientUuid?: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllSmsRecord(page, size, sortBy, sortDirection, patientUuid, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SmsRecordControllerApi.getAllSmsRecord']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SmsRecordControllerApi - factory interface
 * @export
 */
export const SmsRecordControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SmsRecordControllerApiFp(configuration)
    return {
        /**
         * Get all sms record list.
         * @summary Get all sms record.
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {string} [patientUuid] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllSmsRecord(page?: number, size?: number, sortBy?: string, sortDirection?: string, patientUuid?: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getAllSmsRecord(page, size, sortBy, sortDirection, patientUuid, xTENANTID, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SmsRecordControllerApi - object-oriented interface
 * @export
 * @class SmsRecordControllerApi
 * @extends {BaseAPI}
 */
export class SmsRecordControllerApi extends BaseAPI {
    /**
     * Get all sms record list.
     * @summary Get all sms record.
     * @param {number} [page] 
     * @param {number} [size] 
     * @param {string} [sortBy] 
     * @param {string} [sortDirection] 
     * @param {string} [patientUuid] 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SmsRecordControllerApi
     */
    public getAllSmsRecord(page?: number, size?: number, sortBy?: string, sortDirection?: string, patientUuid?: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return SmsRecordControllerApiFp(this.configuration).getAllSmsRecord(page, size, sortBy, sortDirection, patientUuid, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * SmtpConfigurationControllerApi - axios parameter creator
 * @export
 */
export const SmtpConfigurationControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Add a new Smtp Configuration into the system.
         * @summary Add Smtp Configuration
         * @param {SmtpConfiguration} smtpConfiguration 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSmtpConfiguration: async (smtpConfiguration: SmtpConfiguration, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'smtpConfiguration' is not null or undefined
            assertParamExists('createSmtpConfiguration', 'smtpConfiguration', smtpConfiguration)
            const localVarPath = `/api/master/smtp-configuration`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(smtpConfiguration, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get Smtp Configuration by providerGroupId.
         * @summary Get Smtp Configuration by providerGroupId.
         * @param {string} providerGroupId 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSmtpConfigurationByProviderGroupId: async (providerGroupId: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'providerGroupId' is not null or undefined
            assertParamExists('getSmtpConfigurationByProviderGroupId', 'providerGroupId', providerGroupId)
            const localVarPath = `/api/master/smtp-configuration/provider-group/{providerGroupId}`
                .replace(`{${"providerGroupId"}}`, encodeURIComponent(String(providerGroupId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Edit Smtp Configuration
         * @summary Update Smtp Configuration
         * @param {SmtpConfiguration} smtpConfiguration 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSmtpConfiguration: async (smtpConfiguration: SmtpConfiguration, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'smtpConfiguration' is not null or undefined
            assertParamExists('updateSmtpConfiguration', 'smtpConfiguration', smtpConfiguration)
            const localVarPath = `/api/master/smtp-configuration`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(smtpConfiguration, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SmtpConfigurationControllerApi - functional programming interface
 * @export
 */
export const SmtpConfigurationControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SmtpConfigurationControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * Add a new Smtp Configuration into the system.
         * @summary Add Smtp Configuration
         * @param {SmtpConfiguration} smtpConfiguration 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createSmtpConfiguration(smtpConfiguration: SmtpConfiguration, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createSmtpConfiguration(smtpConfiguration, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SmtpConfigurationControllerApi.createSmtpConfiguration']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get Smtp Configuration by providerGroupId.
         * @summary Get Smtp Configuration by providerGroupId.
         * @param {string} providerGroupId 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSmtpConfigurationByProviderGroupId(providerGroupId: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSmtpConfigurationByProviderGroupId(providerGroupId, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SmtpConfigurationControllerApi.getSmtpConfigurationByProviderGroupId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Edit Smtp Configuration
         * @summary Update Smtp Configuration
         * @param {SmtpConfiguration} smtpConfiguration 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateSmtpConfiguration(smtpConfiguration: SmtpConfiguration, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateSmtpConfiguration(smtpConfiguration, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SmtpConfigurationControllerApi.updateSmtpConfiguration']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SmtpConfigurationControllerApi - factory interface
 * @export
 */
export const SmtpConfigurationControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SmtpConfigurationControllerApiFp(configuration)
    return {
        /**
         * Add a new Smtp Configuration into the system.
         * @summary Add Smtp Configuration
         * @param {SmtpConfiguration} smtpConfiguration 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSmtpConfiguration(smtpConfiguration: SmtpConfiguration, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.createSmtpConfiguration(smtpConfiguration, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Get Smtp Configuration by providerGroupId.
         * @summary Get Smtp Configuration by providerGroupId.
         * @param {string} providerGroupId 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSmtpConfigurationByProviderGroupId(providerGroupId: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getSmtpConfigurationByProviderGroupId(providerGroupId, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Edit Smtp Configuration
         * @summary Update Smtp Configuration
         * @param {SmtpConfiguration} smtpConfiguration 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSmtpConfiguration(smtpConfiguration: SmtpConfiguration, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.updateSmtpConfiguration(smtpConfiguration, xTENANTID, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SmtpConfigurationControllerApi - object-oriented interface
 * @export
 * @class SmtpConfigurationControllerApi
 * @extends {BaseAPI}
 */
export class SmtpConfigurationControllerApi extends BaseAPI {
    /**
     * Add a new Smtp Configuration into the system.
     * @summary Add Smtp Configuration
     * @param {SmtpConfiguration} smtpConfiguration 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SmtpConfigurationControllerApi
     */
    public createSmtpConfiguration(smtpConfiguration: SmtpConfiguration, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return SmtpConfigurationControllerApiFp(this.configuration).createSmtpConfiguration(smtpConfiguration, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get Smtp Configuration by providerGroupId.
     * @summary Get Smtp Configuration by providerGroupId.
     * @param {string} providerGroupId 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SmtpConfigurationControllerApi
     */
    public getSmtpConfigurationByProviderGroupId(providerGroupId: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return SmtpConfigurationControllerApiFp(this.configuration).getSmtpConfigurationByProviderGroupId(providerGroupId, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Edit Smtp Configuration
     * @summary Update Smtp Configuration
     * @param {SmtpConfiguration} smtpConfiguration 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SmtpConfigurationControllerApi
     */
    public updateSmtpConfiguration(smtpConfiguration: SmtpConfiguration, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return SmtpConfigurationControllerApiFp(this.configuration).updateSmtpConfiguration(smtpConfiguration, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * SocialHistoryQuestionsControllerApi - axios parameter creator
 * @export
 */
export const SocialHistoryQuestionsControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get all Questions list.
         * @summary Get all Questions.
         * @param {GetAllSocialHistoryQuestionsSocialHistoryTypeEnum} socialHistoryType 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllSocialHistoryQuestions: async (socialHistoryType: GetAllSocialHistoryQuestionsSocialHistoryTypeEnum, page?: number, size?: number, sortBy?: string, sortDirection?: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'socialHistoryType' is not null or undefined
            assertParamExists('getAllSocialHistoryQuestions', 'socialHistoryType', socialHistoryType)
            const localVarPath = `/api/master/history-questions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }

            if (socialHistoryType !== undefined) {
                localVarQueryParameter['socialHistoryType'] = socialHistoryType;
            }

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all Questions Patient list.
         * @summary Get all Questions Patient.
         * @param {GetAllSocialHistoryQuestionsForPatientSocialHistoryTypeEnum} socialHistoryType 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllSocialHistoryQuestionsForPatient: async (socialHistoryType: GetAllSocialHistoryQuestionsForPatientSocialHistoryTypeEnum, page?: number, size?: number, sortBy?: string, sortDirection?: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'socialHistoryType' is not null or undefined
            assertParamExists('getAllSocialHistoryQuestionsForPatient', 'socialHistoryType', socialHistoryType)
            const localVarPath = `/api/master/history-questions/patient`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }

            if (socialHistoryType !== undefined) {
                localVarQueryParameter['socialHistoryType'] = socialHistoryType;
            }

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SocialHistoryQuestionsControllerApi - functional programming interface
 * @export
 */
export const SocialHistoryQuestionsControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SocialHistoryQuestionsControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * Get all Questions list.
         * @summary Get all Questions.
         * @param {GetAllSocialHistoryQuestionsSocialHistoryTypeEnum} socialHistoryType 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllSocialHistoryQuestions(socialHistoryType: GetAllSocialHistoryQuestionsSocialHistoryTypeEnum, page?: number, size?: number, sortBy?: string, sortDirection?: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllSocialHistoryQuestions(socialHistoryType, page, size, sortBy, sortDirection, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SocialHistoryQuestionsControllerApi.getAllSocialHistoryQuestions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get all Questions Patient list.
         * @summary Get all Questions Patient.
         * @param {GetAllSocialHistoryQuestionsForPatientSocialHistoryTypeEnum} socialHistoryType 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllSocialHistoryQuestionsForPatient(socialHistoryType: GetAllSocialHistoryQuestionsForPatientSocialHistoryTypeEnum, page?: number, size?: number, sortBy?: string, sortDirection?: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllSocialHistoryQuestionsForPatient(socialHistoryType, page, size, sortBy, sortDirection, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SocialHistoryQuestionsControllerApi.getAllSocialHistoryQuestionsForPatient']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SocialHistoryQuestionsControllerApi - factory interface
 * @export
 */
export const SocialHistoryQuestionsControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SocialHistoryQuestionsControllerApiFp(configuration)
    return {
        /**
         * Get all Questions list.
         * @summary Get all Questions.
         * @param {GetAllSocialHistoryQuestionsSocialHistoryTypeEnum} socialHistoryType 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllSocialHistoryQuestions(socialHistoryType: GetAllSocialHistoryQuestionsSocialHistoryTypeEnum, page?: number, size?: number, sortBy?: string, sortDirection?: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getAllSocialHistoryQuestions(socialHistoryType, page, size, sortBy, sortDirection, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all Questions Patient list.
         * @summary Get all Questions Patient.
         * @param {GetAllSocialHistoryQuestionsForPatientSocialHistoryTypeEnum} socialHistoryType 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllSocialHistoryQuestionsForPatient(socialHistoryType: GetAllSocialHistoryQuestionsForPatientSocialHistoryTypeEnum, page?: number, size?: number, sortBy?: string, sortDirection?: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getAllSocialHistoryQuestionsForPatient(socialHistoryType, page, size, sortBy, sortDirection, xTENANTID, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SocialHistoryQuestionsControllerApi - object-oriented interface
 * @export
 * @class SocialHistoryQuestionsControllerApi
 * @extends {BaseAPI}
 */
export class SocialHistoryQuestionsControllerApi extends BaseAPI {
    /**
     * Get all Questions list.
     * @summary Get all Questions.
     * @param {GetAllSocialHistoryQuestionsSocialHistoryTypeEnum} socialHistoryType 
     * @param {number} [page] 
     * @param {number} [size] 
     * @param {string} [sortBy] 
     * @param {string} [sortDirection] 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SocialHistoryQuestionsControllerApi
     */
    public getAllSocialHistoryQuestions(socialHistoryType: GetAllSocialHistoryQuestionsSocialHistoryTypeEnum, page?: number, size?: number, sortBy?: string, sortDirection?: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return SocialHistoryQuestionsControllerApiFp(this.configuration).getAllSocialHistoryQuestions(socialHistoryType, page, size, sortBy, sortDirection, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all Questions Patient list.
     * @summary Get all Questions Patient.
     * @param {GetAllSocialHistoryQuestionsForPatientSocialHistoryTypeEnum} socialHistoryType 
     * @param {number} [page] 
     * @param {number} [size] 
     * @param {string} [sortBy] 
     * @param {string} [sortDirection] 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SocialHistoryQuestionsControllerApi
     */
    public getAllSocialHistoryQuestionsForPatient(socialHistoryType: GetAllSocialHistoryQuestionsForPatientSocialHistoryTypeEnum, page?: number, size?: number, sortBy?: string, sortDirection?: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return SocialHistoryQuestionsControllerApiFp(this.configuration).getAllSocialHistoryQuestionsForPatient(socialHistoryType, page, size, sortBy, sortDirection, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const GetAllSocialHistoryQuestionsSocialHistoryTypeEnum = {
    HomeAndEnvironment: 'HOME_AND_ENVIRONMENT',
    SubstanceUse: 'SUBSTANCE_USE',
    EducationAndOccupation: 'EDUCATION_AND_OCCUPATION',
    Lifestyle: 'LIFESTYLE',
    MarriageAndSexuality: 'MARRIAGE_AND_SEXUALITY',
    AdvanceDirective: 'ADVANCE_DIRECTIVE',
    DietAndExercise: 'DIET_AND_EXERCISE',
    PublicHealthAndTravel: 'PUBLIC_HEALTH_AND_TRAVEL',
    ActivitiesOfDailyLiving: 'ACTIVITIES_OF_DAILY_LIVING',
    Covid19VaccineScreening: 'COVID_19_VACCINE_SCREENING',
    MigrationFrom123121: 'MIGRATION_FROM_123121',
    Psychiatry: 'PSYCHIATRY',
    HomeCareSubstanceUse: 'HOME_CARE_SUBSTANCE_USE'
} as const;
export type GetAllSocialHistoryQuestionsSocialHistoryTypeEnum = typeof GetAllSocialHistoryQuestionsSocialHistoryTypeEnum[keyof typeof GetAllSocialHistoryQuestionsSocialHistoryTypeEnum];
/**
 * @export
 */
export const GetAllSocialHistoryQuestionsForPatientSocialHistoryTypeEnum = {
    HomeAndEnvironment: 'HOME_AND_ENVIRONMENT',
    SubstanceUse: 'SUBSTANCE_USE',
    EducationAndOccupation: 'EDUCATION_AND_OCCUPATION',
    Lifestyle: 'LIFESTYLE',
    MarriageAndSexuality: 'MARRIAGE_AND_SEXUALITY',
    AdvanceDirective: 'ADVANCE_DIRECTIVE',
    DietAndExercise: 'DIET_AND_EXERCISE',
    PublicHealthAndTravel: 'PUBLIC_HEALTH_AND_TRAVEL',
    ActivitiesOfDailyLiving: 'ACTIVITIES_OF_DAILY_LIVING',
    Covid19VaccineScreening: 'COVID_19_VACCINE_SCREENING',
    MigrationFrom123121: 'MIGRATION_FROM_123121',
    Psychiatry: 'PSYCHIATRY',
    HomeCareSubstanceUse: 'HOME_CARE_SUBSTANCE_USE'
} as const;
export type GetAllSocialHistoryQuestionsForPatientSocialHistoryTypeEnum = typeof GetAllSocialHistoryQuestionsForPatientSocialHistoryTypeEnum[keyof typeof GetAllSocialHistoryQuestionsForPatientSocialHistoryTypeEnum];


/**
 * SpecialityControllerApi - axios parameter creator
 * @export
 */
export const SpecialityControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get all Specialities list with pagination and sorting.
         * @summary Get all Specialities.
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [searchString] 
         * @param {string} [sortDirection] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllSpecialities: async (page?: number, size?: number, sortBy?: string, searchString?: string, sortDirection?: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/master/speciality`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (searchString !== undefined) {
                localVarQueryParameter['searchString'] = searchString;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Public list of active specialities (uuid and name) for the website widget speciality filter.
         * @summary Get active specialities for the website widget
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWidgetSpecialities: async (xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/master/speciality/widget-specialities`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SpecialityControllerApi - functional programming interface
 * @export
 */
export const SpecialityControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SpecialityControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * Get all Specialities list with pagination and sorting.
         * @summary Get all Specialities.
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [searchString] 
         * @param {string} [sortDirection] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllSpecialities(page?: number, size?: number, sortBy?: string, searchString?: string, sortDirection?: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllSpecialities(page, size, sortBy, searchString, sortDirection, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SpecialityControllerApi.getAllSpecialities']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Public list of active specialities (uuid and name) for the website widget speciality filter.
         * @summary Get active specialities for the website widget
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWidgetSpecialities(xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWidgetSpecialities(xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SpecialityControllerApi.getWidgetSpecialities']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SpecialityControllerApi - factory interface
 * @export
 */
export const SpecialityControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SpecialityControllerApiFp(configuration)
    return {
        /**
         * Get all Specialities list with pagination and sorting.
         * @summary Get all Specialities.
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [searchString] 
         * @param {string} [sortDirection] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllSpecialities(page?: number, size?: number, sortBy?: string, searchString?: string, sortDirection?: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getAllSpecialities(page, size, sortBy, searchString, sortDirection, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Public list of active specialities (uuid and name) for the website widget speciality filter.
         * @summary Get active specialities for the website widget
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWidgetSpecialities(xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getWidgetSpecialities(xTENANTID, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SpecialityControllerApi - object-oriented interface
 * @export
 * @class SpecialityControllerApi
 * @extends {BaseAPI}
 */
export class SpecialityControllerApi extends BaseAPI {
    /**
     * Get all Specialities list with pagination and sorting.
     * @summary Get all Specialities.
     * @param {number} [page] 
     * @param {number} [size] 
     * @param {string} [sortBy] 
     * @param {string} [searchString] 
     * @param {string} [sortDirection] 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SpecialityControllerApi
     */
    public getAllSpecialities(page?: number, size?: number, sortBy?: string, searchString?: string, sortDirection?: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return SpecialityControllerApiFp(this.configuration).getAllSpecialities(page, size, sortBy, searchString, sortDirection, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Public list of active specialities (uuid and name) for the website widget speciality filter.
     * @summary Get active specialities for the website widget
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SpecialityControllerApi
     */
    public getWidgetSpecialities(xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return SpecialityControllerApiFp(this.configuration).getWidgetSpecialities(xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * SrFaxManagementApi - axios parameter creator
 * @export
 */
export const SrFaxManagementApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get all faxes with search options on file name, to fax number, remote ID and filter options on fax type, fax flag, fax line, archive status and to fax number
         * @summary Get all faxes
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {boolean} [archive] 
         * @param {string} [toFaxNumber] 
         * @param {string} [searchString] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllFaxes: async (page?: number, size?: number, sortBy?: string, sortDirection?: string, archive?: boolean, toFaxNumber?: string, searchString?: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/master/fax-outbox`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }

            if (archive !== undefined) {
                localVarQueryParameter['archive'] = archive;
            }

            if (toFaxNumber !== undefined) {
                localVarQueryParameter['toFaxNumber'] = toFaxNumber;
            }

            if (searchString !== undefined) {
                localVarQueryParameter['searchString'] = searchString;
            }

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all faxes with search options on file name, caller ID, remote ID, user fax number and filter options on fax type, fax flag, fax line, archive and read status
         * @summary Get all faxes
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {boolean} [archive] 
         * @param {boolean} [read] 
         * @param {string} [faxNumber] 
         * @param {string} [searchString] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllFaxes1: async (page?: number, size?: number, sortBy?: string, sortDirection?: string, archive?: boolean, read?: boolean, faxNumber?: string, searchString?: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/master/fax-inbox`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }

            if (archive !== undefined) {
                localVarQueryParameter['archive'] = archive;
            }

            if (read !== undefined) {
                localVarQueryParameter['read'] = read;
            }

            if (faxNumber !== undefined) {
                localVarQueryParameter['faxNumber'] = faxNumber;
            }

            if (searchString !== undefined) {
                localVarQueryParameter['searchString'] = searchString;
            }

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This endpoint will be helpful for getting the document in Base64 format by fax uuid.
         * @summary View fax document by id
         * @param {string} faxId 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFaxDocumentById: async (faxId: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'faxId' is not null or undefined
            assertParamExists('getFaxDocumentById', 'faxId', faxId)
            const localVarPath = `/api/master/fax-outbox/{faxId}`
                .replace(`{${"faxId"}}`, encodeURIComponent(String(faxId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This endpoint will be helpful for getting the document in Base64 format by fax uuid.
         * @summary View fax document by id
         * @param {string} faxId 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFaxDocumentById1: async (faxId: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'faxId' is not null or undefined
            assertParamExists('getFaxDocumentById1', 'faxId', faxId)
            const localVarPath = `/api/master/fax-inbox/{faxId}`
                .replace(`{${"faxId"}}`, encodeURIComponent(String(faxId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFaxInbox: async (xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/master/srfax/inbox`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFaxOutbox: async (xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/master/srfax/outbox`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFaxQueued: async (xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/master/srfax/queued`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get incoming fax count by status (e.g. - unread)
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIncomingFaxStatusCount: async (xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/master/srfax/status-count`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Mark fax as read
         * @summary Mark fax as read
         * @param {string} faxId 
         * @param {boolean} read 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markAsRead1: async (faxId: string, read: boolean, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'faxId' is not null or undefined
            assertParamExists('markAsRead1', 'faxId', faxId)
            // verify required parameter 'read' is not null or undefined
            assertParamExists('markAsRead1', 'read', read)
            const localVarPath = `/api/master/fax-inbox/{faxId}/{read}`
                .replace(`{${"faxId"}}`, encodeURIComponent(String(faxId)))
                .replace(`{${"read"}}`, encodeURIComponent(String(read)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Use to send the  fax; sFaxType(SINGLE, BROADCAST), sToFaxNumber,sFileName_1(mention file type), sFileContent_1(mention  base64) 
         * @summary Add to queue
         * @param {SrfaxQueueFaxRequest} srfaxQueueFaxRequest 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        queueFax: async (srfaxQueueFaxRequest: SrfaxQueueFaxRequest, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'srfaxQueueFaxRequest' is not null or undefined
            assertParamExists('queueFax', 'srfaxQueueFaxRequest', srfaxQueueFaxRequest)
            const localVarPath = `/api/master/srfax/queue`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(srfaxQueueFaxRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SrFaxManagementApi - functional programming interface
 * @export
 */
export const SrFaxManagementApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SrFaxManagementApiAxiosParamCreator(configuration)
    return {
        /**
         * Get all faxes with search options on file name, to fax number, remote ID and filter options on fax type, fax flag, fax line, archive status and to fax number
         * @summary Get all faxes
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {boolean} [archive] 
         * @param {string} [toFaxNumber] 
         * @param {string} [searchString] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllFaxes(page?: number, size?: number, sortBy?: string, sortDirection?: string, archive?: boolean, toFaxNumber?: string, searchString?: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllFaxes(page, size, sortBy, sortDirection, archive, toFaxNumber, searchString, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SrFaxManagementApi.getAllFaxes']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get all faxes with search options on file name, caller ID, remote ID, user fax number and filter options on fax type, fax flag, fax line, archive and read status
         * @summary Get all faxes
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {boolean} [archive] 
         * @param {boolean} [read] 
         * @param {string} [faxNumber] 
         * @param {string} [searchString] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllFaxes1(page?: number, size?: number, sortBy?: string, sortDirection?: string, archive?: boolean, read?: boolean, faxNumber?: string, searchString?: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllFaxes1(page, size, sortBy, sortDirection, archive, read, faxNumber, searchString, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SrFaxManagementApi.getAllFaxes1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * This endpoint will be helpful for getting the document in Base64 format by fax uuid.
         * @summary View fax document by id
         * @param {string} faxId 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFaxDocumentById(faxId: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFaxDocumentById(faxId, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SrFaxManagementApi.getFaxDocumentById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * This endpoint will be helpful for getting the document in Base64 format by fax uuid.
         * @summary View fax document by id
         * @param {string} faxId 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFaxDocumentById1(faxId: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFaxDocumentById1(faxId, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SrFaxManagementApi.getFaxDocumentById1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFaxInbox(xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFaxInbox(xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SrFaxManagementApi.getFaxInbox']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFaxOutbox(xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFaxOutbox(xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SrFaxManagementApi.getFaxOutbox']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFaxQueued(xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFaxQueued(xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SrFaxManagementApi.getFaxQueued']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get incoming fax count by status (e.g. - unread)
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getIncomingFaxStatusCount(xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getIncomingFaxStatusCount(xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SrFaxManagementApi.getIncomingFaxStatusCount']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Mark fax as read
         * @summary Mark fax as read
         * @param {string} faxId 
         * @param {boolean} read 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async markAsRead1(faxId: string, read: boolean, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.markAsRead1(faxId, read, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SrFaxManagementApi.markAsRead1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Use to send the  fax; sFaxType(SINGLE, BROADCAST), sToFaxNumber,sFileName_1(mention file type), sFileContent_1(mention  base64) 
         * @summary Add to queue
         * @param {SrfaxQueueFaxRequest} srfaxQueueFaxRequest 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async queueFax(srfaxQueueFaxRequest: SrfaxQueueFaxRequest, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.queueFax(srfaxQueueFaxRequest, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SrFaxManagementApi.queueFax']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SrFaxManagementApi - factory interface
 * @export
 */
export const SrFaxManagementApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SrFaxManagementApiFp(configuration)
    return {
        /**
         * Get all faxes with search options on file name, to fax number, remote ID and filter options on fax type, fax flag, fax line, archive status and to fax number
         * @summary Get all faxes
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {boolean} [archive] 
         * @param {string} [toFaxNumber] 
         * @param {string} [searchString] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllFaxes(page?: number, size?: number, sortBy?: string, sortDirection?: string, archive?: boolean, toFaxNumber?: string, searchString?: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getAllFaxes(page, size, sortBy, sortDirection, archive, toFaxNumber, searchString, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all faxes with search options on file name, caller ID, remote ID, user fax number and filter options on fax type, fax flag, fax line, archive and read status
         * @summary Get all faxes
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {boolean} [archive] 
         * @param {boolean} [read] 
         * @param {string} [faxNumber] 
         * @param {string} [searchString] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllFaxes1(page?: number, size?: number, sortBy?: string, sortDirection?: string, archive?: boolean, read?: boolean, faxNumber?: string, searchString?: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getAllFaxes1(page, size, sortBy, sortDirection, archive, read, faxNumber, searchString, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * This endpoint will be helpful for getting the document in Base64 format by fax uuid.
         * @summary View fax document by id
         * @param {string} faxId 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFaxDocumentById(faxId: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getFaxDocumentById(faxId, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * This endpoint will be helpful for getting the document in Base64 format by fax uuid.
         * @summary View fax document by id
         * @param {string} faxId 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFaxDocumentById1(faxId: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getFaxDocumentById1(faxId, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFaxInbox(xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getFaxInbox(xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFaxOutbox(xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getFaxOutbox(xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFaxQueued(xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getFaxQueued(xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get incoming fax count by status (e.g. - unread)
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIncomingFaxStatusCount(xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getIncomingFaxStatusCount(xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Mark fax as read
         * @summary Mark fax as read
         * @param {string} faxId 
         * @param {boolean} read 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markAsRead1(faxId: string, read: boolean, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.markAsRead1(faxId, read, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Use to send the  fax; sFaxType(SINGLE, BROADCAST), sToFaxNumber,sFileName_1(mention file type), sFileContent_1(mention  base64) 
         * @summary Add to queue
         * @param {SrfaxQueueFaxRequest} srfaxQueueFaxRequest 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        queueFax(srfaxQueueFaxRequest: SrfaxQueueFaxRequest, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.queueFax(srfaxQueueFaxRequest, xTENANTID, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SrFaxManagementApi - object-oriented interface
 * @export
 * @class SrFaxManagementApi
 * @extends {BaseAPI}
 */
export class SrFaxManagementApi extends BaseAPI {
    /**
     * Get all faxes with search options on file name, to fax number, remote ID and filter options on fax type, fax flag, fax line, archive status and to fax number
     * @summary Get all faxes
     * @param {number} [page] 
     * @param {number} [size] 
     * @param {string} [sortBy] 
     * @param {string} [sortDirection] 
     * @param {boolean} [archive] 
     * @param {string} [toFaxNumber] 
     * @param {string} [searchString] 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SrFaxManagementApi
     */
    public getAllFaxes(page?: number, size?: number, sortBy?: string, sortDirection?: string, archive?: boolean, toFaxNumber?: string, searchString?: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return SrFaxManagementApiFp(this.configuration).getAllFaxes(page, size, sortBy, sortDirection, archive, toFaxNumber, searchString, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all faxes with search options on file name, caller ID, remote ID, user fax number and filter options on fax type, fax flag, fax line, archive and read status
     * @summary Get all faxes
     * @param {number} [page] 
     * @param {number} [size] 
     * @param {string} [sortBy] 
     * @param {string} [sortDirection] 
     * @param {boolean} [archive] 
     * @param {boolean} [read] 
     * @param {string} [faxNumber] 
     * @param {string} [searchString] 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SrFaxManagementApi
     */
    public getAllFaxes1(page?: number, size?: number, sortBy?: string, sortDirection?: string, archive?: boolean, read?: boolean, faxNumber?: string, searchString?: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return SrFaxManagementApiFp(this.configuration).getAllFaxes1(page, size, sortBy, sortDirection, archive, read, faxNumber, searchString, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This endpoint will be helpful for getting the document in Base64 format by fax uuid.
     * @summary View fax document by id
     * @param {string} faxId 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SrFaxManagementApi
     */
    public getFaxDocumentById(faxId: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return SrFaxManagementApiFp(this.configuration).getFaxDocumentById(faxId, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This endpoint will be helpful for getting the document in Base64 format by fax uuid.
     * @summary View fax document by id
     * @param {string} faxId 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SrFaxManagementApi
     */
    public getFaxDocumentById1(faxId: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return SrFaxManagementApiFp(this.configuration).getFaxDocumentById1(faxId, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SrFaxManagementApi
     */
    public getFaxInbox(xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return SrFaxManagementApiFp(this.configuration).getFaxInbox(xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SrFaxManagementApi
     */
    public getFaxOutbox(xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return SrFaxManagementApiFp(this.configuration).getFaxOutbox(xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SrFaxManagementApi
     */
    public getFaxQueued(xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return SrFaxManagementApiFp(this.configuration).getFaxQueued(xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get incoming fax count by status (e.g. - unread)
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SrFaxManagementApi
     */
    public getIncomingFaxStatusCount(xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return SrFaxManagementApiFp(this.configuration).getIncomingFaxStatusCount(xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Mark fax as read
     * @summary Mark fax as read
     * @param {string} faxId 
     * @param {boolean} read 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SrFaxManagementApi
     */
    public markAsRead1(faxId: string, read: boolean, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return SrFaxManagementApiFp(this.configuration).markAsRead1(faxId, read, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Use to send the  fax; sFaxType(SINGLE, BROADCAST), sToFaxNumber,sFileName_1(mention file type), sFileContent_1(mention  base64) 
     * @summary Add to queue
     * @param {SrfaxQueueFaxRequest} srfaxQueueFaxRequest 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SrFaxManagementApi
     */
    public queueFax(srfaxQueueFaxRequest: SrfaxQueueFaxRequest, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return SrFaxManagementApiFp(this.configuration).queueFax(srfaxQueueFaxRequest, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * StickyNoteControllerApi - axios parameter creator
 * @export
 */
export const StickyNoteControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Add a new sticky note into the system
         * @summary Add Sticky Note
         * @param {StickyNotes} stickyNotes 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createStickyNote: async (stickyNotes: StickyNotes, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'stickyNotes' is not null or undefined
            assertParamExists('createStickyNote', 'stickyNotes', stickyNotes)
            const localVarPath = `/api/master/sticky-notes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(stickyNotes, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve a Sticky Note by its unique ID
         * @summary Get Sticky Note by ID
         * @param {string} stickyNoteId 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStickyNoteById: async (stickyNoteId: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'stickyNoteId' is not null or undefined
            assertParamExists('getStickyNoteById', 'stickyNoteId', stickyNoteId)
            const localVarPath = `/api/master/sticky-notes/{stickyNoteId}`
                .replace(`{${"stickyNoteId"}}`, encodeURIComponent(String(stickyNoteId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all Sticky Notes for a specific patient
         * @summary Get Sticky Notes by Patient ID
         * @param {string} patientUuid 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sort] 
         * @param {boolean} [status] 
         * @param {boolean} [archive] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStickyNotesByPatient: async (patientUuid: string, page?: number, size?: number, sortBy?: string, sort?: string, status?: boolean, archive?: boolean, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientUuid' is not null or undefined
            assertParamExists('getStickyNotesByPatient', 'patientUuid', patientUuid)
            const localVarPath = `/api/master/sticky-notes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (archive !== undefined) {
                localVarQueryParameter['archive'] = archive;
            }

            if (patientUuid !== undefined) {
                localVarQueryParameter['patientUuid'] = patientUuid;
            }

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update an existing Sticky Note
         * @summary Update Sticky Note
         * @param {StickyNotes} stickyNotes 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateStickyNote: async (stickyNotes: StickyNotes, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'stickyNotes' is not null or undefined
            assertParamExists('updateStickyNote', 'stickyNotes', stickyNotes)
            const localVarPath = `/api/master/sticky-notes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(stickyNotes, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Archive a Sticky Note by its ID
         * @summary Archive Sticky Note
         * @param {string} stickyNoteId 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateStickyNoteArchiveStatus: async (stickyNoteId: string, status: boolean, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'stickyNoteId' is not null or undefined
            assertParamExists('updateStickyNoteArchiveStatus', 'stickyNoteId', stickyNoteId)
            // verify required parameter 'status' is not null or undefined
            assertParamExists('updateStickyNoteArchiveStatus', 'status', status)
            const localVarPath = `/api/master/sticky-notes/{stickyNoteId}/archive-status/{status}`
                .replace(`{${"stickyNoteId"}}`, encodeURIComponent(String(stickyNoteId)))
                .replace(`{${"status"}}`, encodeURIComponent(String(status)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update the status of a Sticky Note by its ID
         * @summary Update Sticky Note Status
         * @param {string} stickyNoteId 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateStickyNoteStatus: async (stickyNoteId: string, status: boolean, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'stickyNoteId' is not null or undefined
            assertParamExists('updateStickyNoteStatus', 'stickyNoteId', stickyNoteId)
            // verify required parameter 'status' is not null or undefined
            assertParamExists('updateStickyNoteStatus', 'status', status)
            const localVarPath = `/api/master/sticky-notes/{stickyNoteId}/status/{status}`
                .replace(`{${"stickyNoteId"}}`, encodeURIComponent(String(stickyNoteId)))
                .replace(`{${"status"}}`, encodeURIComponent(String(status)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * StickyNoteControllerApi - functional programming interface
 * @export
 */
export const StickyNoteControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = StickyNoteControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * Add a new sticky note into the system
         * @summary Add Sticky Note
         * @param {StickyNotes} stickyNotes 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createStickyNote(stickyNotes: StickyNotes, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createStickyNote(stickyNotes, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StickyNoteControllerApi.createStickyNote']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve a Sticky Note by its unique ID
         * @summary Get Sticky Note by ID
         * @param {string} stickyNoteId 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getStickyNoteById(stickyNoteId: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getStickyNoteById(stickyNoteId, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StickyNoteControllerApi.getStickyNoteById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get all Sticky Notes for a specific patient
         * @summary Get Sticky Notes by Patient ID
         * @param {string} patientUuid 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sort] 
         * @param {boolean} [status] 
         * @param {boolean} [archive] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getStickyNotesByPatient(patientUuid: string, page?: number, size?: number, sortBy?: string, sort?: string, status?: boolean, archive?: boolean, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getStickyNotesByPatient(patientUuid, page, size, sortBy, sort, status, archive, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StickyNoteControllerApi.getStickyNotesByPatient']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update an existing Sticky Note
         * @summary Update Sticky Note
         * @param {StickyNotes} stickyNotes 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateStickyNote(stickyNotes: StickyNotes, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateStickyNote(stickyNotes, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StickyNoteControllerApi.updateStickyNote']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Archive a Sticky Note by its ID
         * @summary Archive Sticky Note
         * @param {string} stickyNoteId 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateStickyNoteArchiveStatus(stickyNoteId: string, status: boolean, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateStickyNoteArchiveStatus(stickyNoteId, status, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StickyNoteControllerApi.updateStickyNoteArchiveStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update the status of a Sticky Note by its ID
         * @summary Update Sticky Note Status
         * @param {string} stickyNoteId 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateStickyNoteStatus(stickyNoteId: string, status: boolean, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateStickyNoteStatus(stickyNoteId, status, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StickyNoteControllerApi.updateStickyNoteStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * StickyNoteControllerApi - factory interface
 * @export
 */
export const StickyNoteControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = StickyNoteControllerApiFp(configuration)
    return {
        /**
         * Add a new sticky note into the system
         * @summary Add Sticky Note
         * @param {StickyNotes} stickyNotes 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createStickyNote(stickyNotes: StickyNotes, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.createStickyNote(stickyNotes, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve a Sticky Note by its unique ID
         * @summary Get Sticky Note by ID
         * @param {string} stickyNoteId 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStickyNoteById(stickyNoteId: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getStickyNoteById(stickyNoteId, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all Sticky Notes for a specific patient
         * @summary Get Sticky Notes by Patient ID
         * @param {string} patientUuid 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sort] 
         * @param {boolean} [status] 
         * @param {boolean} [archive] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStickyNotesByPatient(patientUuid: string, page?: number, size?: number, sortBy?: string, sort?: string, status?: boolean, archive?: boolean, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getStickyNotesByPatient(patientUuid, page, size, sortBy, sort, status, archive, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Update an existing Sticky Note
         * @summary Update Sticky Note
         * @param {StickyNotes} stickyNotes 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateStickyNote(stickyNotes: StickyNotes, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.updateStickyNote(stickyNotes, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Archive a Sticky Note by its ID
         * @summary Archive Sticky Note
         * @param {string} stickyNoteId 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateStickyNoteArchiveStatus(stickyNoteId: string, status: boolean, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.updateStickyNoteArchiveStatus(stickyNoteId, status, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Update the status of a Sticky Note by its ID
         * @summary Update Sticky Note Status
         * @param {string} stickyNoteId 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateStickyNoteStatus(stickyNoteId: string, status: boolean, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.updateStickyNoteStatus(stickyNoteId, status, xTENANTID, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * StickyNoteControllerApi - object-oriented interface
 * @export
 * @class StickyNoteControllerApi
 * @extends {BaseAPI}
 */
export class StickyNoteControllerApi extends BaseAPI {
    /**
     * Add a new sticky note into the system
     * @summary Add Sticky Note
     * @param {StickyNotes} stickyNotes 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StickyNoteControllerApi
     */
    public createStickyNote(stickyNotes: StickyNotes, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return StickyNoteControllerApiFp(this.configuration).createStickyNote(stickyNotes, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve a Sticky Note by its unique ID
     * @summary Get Sticky Note by ID
     * @param {string} stickyNoteId 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StickyNoteControllerApi
     */
    public getStickyNoteById(stickyNoteId: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return StickyNoteControllerApiFp(this.configuration).getStickyNoteById(stickyNoteId, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all Sticky Notes for a specific patient
     * @summary Get Sticky Notes by Patient ID
     * @param {string} patientUuid 
     * @param {number} [page] 
     * @param {number} [size] 
     * @param {string} [sortBy] 
     * @param {string} [sort] 
     * @param {boolean} [status] 
     * @param {boolean} [archive] 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StickyNoteControllerApi
     */
    public getStickyNotesByPatient(patientUuid: string, page?: number, size?: number, sortBy?: string, sort?: string, status?: boolean, archive?: boolean, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return StickyNoteControllerApiFp(this.configuration).getStickyNotesByPatient(patientUuid, page, size, sortBy, sort, status, archive, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update an existing Sticky Note
     * @summary Update Sticky Note
     * @param {StickyNotes} stickyNotes 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StickyNoteControllerApi
     */
    public updateStickyNote(stickyNotes: StickyNotes, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return StickyNoteControllerApiFp(this.configuration).updateStickyNote(stickyNotes, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Archive a Sticky Note by its ID
     * @summary Archive Sticky Note
     * @param {string} stickyNoteId 
     * @param {boolean} status 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StickyNoteControllerApi
     */
    public updateStickyNoteArchiveStatus(stickyNoteId: string, status: boolean, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return StickyNoteControllerApiFp(this.configuration).updateStickyNoteArchiveStatus(stickyNoteId, status, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update the status of a Sticky Note by its ID
     * @summary Update Sticky Note Status
     * @param {string} stickyNoteId 
     * @param {boolean} status 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StickyNoteControllerApi
     */
    public updateStickyNoteStatus(stickyNoteId: string, status: boolean, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return StickyNoteControllerApiFp(this.configuration).updateStickyNoteStatus(stickyNoteId, status, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * StripePaymentControllerApi - axios parameter creator
 * @export
 */
export const StripePaymentControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} patientUuid 
         * @param {string} paymentMethodId 
         * @param {boolean} [isPrimary] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        attachPaymentMethodToCustomer: async (patientUuid: string, paymentMethodId: string, isPrimary?: boolean, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientUuid' is not null or undefined
            assertParamExists('attachPaymentMethodToCustomer', 'patientUuid', patientUuid)
            // verify required parameter 'paymentMethodId' is not null or undefined
            assertParamExists('attachPaymentMethodToCustomer', 'paymentMethodId', paymentMethodId)
            const localVarPath = `/api/master/stripe-payment/attach-payment-method/{patientUuid}/{paymentMethodId}`
                .replace(`{${"patientUuid"}}`, encodeURIComponent(String(patientUuid)))
                .replace(`{${"paymentMethodId"}}`, encodeURIComponent(String(paymentMethodId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (isPrimary !== undefined) {
                localVarQueryParameter['isPrimary'] = isPrimary;
            }

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} body 
         * @param {string} [stripeSignature] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        handleStripeWebhook: async (body: string, stripeSignature?: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('handleStripeWebhook', 'body', body)
            const localVarPath = `/api/master/stripe-payment/webhook`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (stripeSignature != null) {
                localVarHeaderParameter['Stripe-Signature'] = String(stripeSignature);
            }

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        handleStripeWebhookGet: async (xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/master/stripe-payment/webhook`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {PaymentRequest} paymentRequest 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        makeChargeStripe: async (paymentRequest: PaymentRequest, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'paymentRequest' is not null or undefined
            assertParamExists('makeChargeStripe', 'paymentRequest', paymentRequest)
            const localVarPath = `/api/master/stripe-payment/make-charge`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(paymentRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        testWebhookEndpoint: async (xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/master/stripe-payment/webhook/test`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * StripePaymentControllerApi - functional programming interface
 * @export
 */
export const StripePaymentControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = StripePaymentControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} patientUuid 
         * @param {string} paymentMethodId 
         * @param {boolean} [isPrimary] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async attachPaymentMethodToCustomer(patientUuid: string, paymentMethodId: string, isPrimary?: boolean, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.attachPaymentMethodToCustomer(patientUuid, paymentMethodId, isPrimary, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StripePaymentControllerApi.attachPaymentMethodToCustomer']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} body 
         * @param {string} [stripeSignature] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async handleStripeWebhook(body: string, stripeSignature?: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.handleStripeWebhook(body, stripeSignature, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StripePaymentControllerApi.handleStripeWebhook']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async handleStripeWebhookGet(xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: string; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.handleStripeWebhookGet(xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StripePaymentControllerApi.handleStripeWebhookGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {PaymentRequest} paymentRequest 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async makeChargeStripe(paymentRequest: PaymentRequest, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.makeChargeStripe(paymentRequest, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StripePaymentControllerApi.makeChargeStripe']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async testWebhookEndpoint(xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: string; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.testWebhookEndpoint(xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StripePaymentControllerApi.testWebhookEndpoint']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * StripePaymentControllerApi - factory interface
 * @export
 */
export const StripePaymentControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = StripePaymentControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {string} patientUuid 
         * @param {string} paymentMethodId 
         * @param {boolean} [isPrimary] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        attachPaymentMethodToCustomer(patientUuid: string, paymentMethodId: string, isPrimary?: boolean, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.attachPaymentMethodToCustomer(patientUuid, paymentMethodId, isPrimary, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} body 
         * @param {string} [stripeSignature] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        handleStripeWebhook(body: string, stripeSignature?: string, xTENANTID?: string, options?: any): AxiosPromise<string> {
            return localVarFp.handleStripeWebhook(body, stripeSignature, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        handleStripeWebhookGet(xTENANTID?: string, options?: any): AxiosPromise<{ [key: string]: string; }> {
            return localVarFp.handleStripeWebhookGet(xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PaymentRequest} paymentRequest 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        makeChargeStripe(paymentRequest: PaymentRequest, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.makeChargeStripe(paymentRequest, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        testWebhookEndpoint(xTENANTID?: string, options?: any): AxiosPromise<{ [key: string]: string; }> {
            return localVarFp.testWebhookEndpoint(xTENANTID, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * StripePaymentControllerApi - object-oriented interface
 * @export
 * @class StripePaymentControllerApi
 * @extends {BaseAPI}
 */
export class StripePaymentControllerApi extends BaseAPI {
    /**
     * 
     * @param {string} patientUuid 
     * @param {string} paymentMethodId 
     * @param {boolean} [isPrimary] 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StripePaymentControllerApi
     */
    public attachPaymentMethodToCustomer(patientUuid: string, paymentMethodId: string, isPrimary?: boolean, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return StripePaymentControllerApiFp(this.configuration).attachPaymentMethodToCustomer(patientUuid, paymentMethodId, isPrimary, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} body 
     * @param {string} [stripeSignature] 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StripePaymentControllerApi
     */
    public handleStripeWebhook(body: string, stripeSignature?: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return StripePaymentControllerApiFp(this.configuration).handleStripeWebhook(body, stripeSignature, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StripePaymentControllerApi
     */
    public handleStripeWebhookGet(xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return StripePaymentControllerApiFp(this.configuration).handleStripeWebhookGet(xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PaymentRequest} paymentRequest 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StripePaymentControllerApi
     */
    public makeChargeStripe(paymentRequest: PaymentRequest, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return StripePaymentControllerApiFp(this.configuration).makeChargeStripe(paymentRequest, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StripePaymentControllerApi
     */
    public testWebhookEndpoint(xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return StripePaymentControllerApiFp(this.configuration).testWebhookEndpoint(xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * SuperBillControllerApi - axios parameter creator
 * @export
 */
export const SuperBillControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Generate PDF for each selected invoice and return as a ZIP file download
         * @summary Batch print invoices
         * @param {Array<string>} requestBody 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        batchPrintInvoices: async (requestBody: Array<string>, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'requestBody' is not null or undefined
            assertParamExists('batchPrintInvoices', 'requestBody', requestBody)
            const localVarPath = `/api/master/super-bill/batch-print`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Calculate the patient balance
         * @param {PatientBalanceCalculation} patientBalanceCalculation 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        calculatePatientBalance: async (patientBalanceCalculation: PatientBalanceCalculation, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientBalanceCalculation' is not null or undefined
            assertParamExists('calculatePatientBalance', 'patientBalanceCalculation', patientBalanceCalculation)
            const localVarPath = `/api/master/super-bill/patient-balance-calculate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patientBalanceCalculation, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Canceled a Super Bill by its ID
         * @summary Canceled Super Bill
         * @param {string} superBillId 
         * @param {CancelledStatusStatusEnum} status 
         * @param {string} [cancelReason] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelledStatus: async (superBillId: string, status: CancelledStatusStatusEnum, cancelReason?: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'superBillId' is not null or undefined
            assertParamExists('cancelledStatus', 'superBillId', superBillId)
            // verify required parameter 'status' is not null or undefined
            assertParamExists('cancelledStatus', 'status', status)
            const localVarPath = `/api/master/super-bill/{superBillId}/cancel-status/{status}`
                .replace(`{${"superBillId"}}`, encodeURIComponent(String(superBillId)))
                .replace(`{${"status"}}`, encodeURIComponent(String(status)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (cancelReason !== undefined) {
                localVarQueryParameter['cancelReason'] = cancelReason;
            }

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Schedule a one-time reminder notification for an invoice via the patient\'s preferred communication channel
         * @summary Configure invoice reminder
         * @param {string} superBillId 
         * @param {InvoiceReminderRequest} invoiceReminderRequest 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        configureInvoiceReminder: async (superBillId: string, invoiceReminderRequest: InvoiceReminderRequest, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'superBillId' is not null or undefined
            assertParamExists('configureInvoiceReminder', 'superBillId', superBillId)
            // verify required parameter 'invoiceReminderRequest' is not null or undefined
            assertParamExists('configureInvoiceReminder', 'invoiceReminderRequest', invoiceReminderRequest)
            const localVarPath = `/api/master/super-bill/{superBillId}/configure-reminder`
                .replace(`{${"superBillId"}}`, encodeURIComponent(String(superBillId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(invoiceReminderRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a super bill
         * @summary Create Super Bill
         * @param {SuperBill} superBill 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSuperBill: async (superBill: SuperBill, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'superBill' is not null or undefined
            assertParamExists('createSuperBill', 'superBill', superBill)
            const localVarPath = `/api/master/super-bill`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(superBill, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all super bill list. 
         * @summary Get all superBill
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {boolean} [status] 
         * @param {boolean} [archive] 
         * @param {string} [patientId] 
         * @param {string} [locationId] 
         * @param {string} [encounterId] 
         * @param {string} [providerId] 
         * @param {string} [searchString] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllSuperBill: async (page?: number, size?: number, sortBy?: string, sortDirection?: string, status?: boolean, archive?: boolean, patientId?: string, locationId?: string, encounterId?: string, providerId?: string, searchString?: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/master/super-bill`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (archive !== undefined) {
                localVarQueryParameter['archive'] = archive;
            }

            if (patientId !== undefined) {
                localVarQueryParameter['patientId'] = patientId;
            }

            if (locationId !== undefined) {
                localVarQueryParameter['locationId'] = locationId;
            }

            if (encounterId !== undefined) {
                localVarQueryParameter['encounterId'] = encounterId;
            }

            if (providerId !== undefined) {
                localVarQueryParameter['providerId'] = providerId;
            }

            if (searchString !== undefined) {
                localVarQueryParameter['searchString'] = searchString;
            }

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all super bill list (fast projection-based API)
         * @summary Get all superBill V2
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {boolean} [status] 
         * @param {boolean} [archive] 
         * @param {string} [patientId] 
         * @param {string} [locationId] 
         * @param {string} [encounterId] 
         * @param {string} [providerId] 
         * @param {string} [searchString] 
         * @param {GetAllSuperBillV2BillStatusEnum} [billStatus] 
         * @param {boolean} [outstandingBalance] 
         * @param {string} [dateRangeType] 
         * @param {string} [customStartDate] 
         * @param {string} [customEndDate] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllSuperBillV2: async (page?: number, size?: number, sortBy?: string, sortDirection?: string, status?: boolean, archive?: boolean, patientId?: string, locationId?: string, encounterId?: string, providerId?: string, searchString?: string, billStatus?: GetAllSuperBillV2BillStatusEnum, outstandingBalance?: boolean, dateRangeType?: string, customStartDate?: string, customEndDate?: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/master/super-bill/v2`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (archive !== undefined) {
                localVarQueryParameter['archive'] = archive;
            }

            if (patientId !== undefined) {
                localVarQueryParameter['patientId'] = patientId;
            }

            if (locationId !== undefined) {
                localVarQueryParameter['locationId'] = locationId;
            }

            if (encounterId !== undefined) {
                localVarQueryParameter['encounterId'] = encounterId;
            }

            if (providerId !== undefined) {
                localVarQueryParameter['providerId'] = providerId;
            }

            if (searchString !== undefined) {
                localVarQueryParameter['searchString'] = searchString;
            }

            if (billStatus !== undefined) {
                localVarQueryParameter['billStatus'] = billStatus;
            }

            if (outstandingBalance !== undefined) {
                localVarQueryParameter['outstandingBalance'] = outstandingBalance;
            }

            if (dateRangeType !== undefined) {
                localVarQueryParameter['dateRangeType'] = dateRangeType;
            }

            if (customStartDate !== undefined) {
                localVarQueryParameter['customStartDate'] = (customStartDate as any instanceof Date) ?
                    (customStartDate as any).toISOString() :
                    customStartDate;
            }

            if (customEndDate !== undefined) {
                localVarQueryParameter['customEndDate'] = (customEndDate as any instanceof Date) ?
                    (customEndDate as any).toISOString() :
                    customEndDate;
            }

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Paginated list of unpaid and partially-paid invoices for the patient. Used by Patient Portal Dashboard Payments Due card.
         * @summary Get Payments Due for patient dashboard
         * @param {string} patientUuid 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPaymentsDue: async (patientUuid: string, page?: number, size?: number, sortBy?: string, sortDirection?: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientUuid' is not null or undefined
            assertParamExists('getPaymentsDue', 'patientUuid', patientUuid)
            const localVarPath = `/api/master/super-bill/payments-due`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (patientUuid !== undefined) {
                localVarQueryParameter['patientUuid'] = patientUuid;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get superbill by superUuid
         * @summary Get super bill by superBillUuid.
         * @param {string} superBillUuid 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSuperBillById: async (superBillUuid: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'superBillUuid' is not null or undefined
            assertParamExists('getSuperBillById', 'superBillUuid', superBillUuid)
            const localVarPath = `/api/master/super-bill/{superBillUuid}`
                .replace(`{${"superBillUuid"}}`, encodeURIComponent(String(superBillUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns minimal projection-based data for CMS 1500 form print
         * @summary Get super bill by id for CMS 1500 print
         * @param {string} superBillUuid 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSuperBillCms1500Print: async (superBillUuid: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'superBillUuid' is not null or undefined
            assertParamExists('getSuperBillCms1500Print', 'superBillUuid', superBillUuid)
            const localVarPath = `/api/master/super-bill/{superBillUuid}/print/cms1500`
                .replace(`{${"superBillUuid"}}`, encodeURIComponent(String(superBillUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get list of superbills by IDs
         * @summary Get list of super bills
         * @param {Array<string>} requestBody 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSuperBills: async (requestBody: Array<string>, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'requestBody' is not null or undefined
            assertParamExists('getSuperBills', 'requestBody', requestBody)
            const localVarPath = `/api/master/super-bill/super-bills/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} superBillId 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        printSuperBillDetails: async (superBillId: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'superBillId' is not null or undefined
            assertParamExists('printSuperBillDetails', 'superBillId', superBillId)
            const localVarPath = `/api/master/super-bill/print/{superBillId}`
                .replace(`{${"superBillId"}}`, encodeURIComponent(String(superBillId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Process a patient payment and update the super bill balance
         * @summary Process patient payment
         * @param {string} superBillId 
         * @param {number} paymentAmount 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        processPatientPayment: async (superBillId: string, paymentAmount: number, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'superBillId' is not null or undefined
            assertParamExists('processPatientPayment', 'superBillId', superBillId)
            // verify required parameter 'paymentAmount' is not null or undefined
            assertParamExists('processPatientPayment', 'paymentAmount', paymentAmount)
            const localVarPath = `/api/master/super-bill/{superBillId}/process-payment`
                .replace(`{${"superBillId"}}`, encodeURIComponent(String(superBillId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (paymentAmount !== undefined) {
                localVarQueryParameter['paymentAmount'] = paymentAmount;
            }

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Generate invoice payment link from super bill and send invoice email to patient with and without the payment link
         * @summary Send invoice email from super bill
         * @param {string} superBillId 
         * @param {boolean} [invoiceSentToPatient] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendInvoiceEmail: async (superBillId: string, invoiceSentToPatient?: boolean, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'superBillId' is not null or undefined
            assertParamExists('sendInvoiceEmail', 'superBillId', superBillId)
            const localVarPath = `/api/master/super-bill/{superBillId}/send-invoice-email`
                .replace(`{${"superBillId"}}`, encodeURIComponent(String(superBillId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (invoiceSentToPatient !== undefined) {
                localVarQueryParameter['invoiceSentToPatient'] = invoiceSentToPatient;
            }

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Send invoice email to patient without payment link
         * @summary Send invoice email from super bill without payment link
         * @param {string} superBillId 
         * @param {boolean} [invoiceSentToPatient] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendInvoiceWithoutPaymentLink: async (superBillId: string, invoiceSentToPatient?: boolean, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'superBillId' is not null or undefined
            assertParamExists('sendInvoiceWithoutPaymentLink', 'superBillId', superBillId)
            const localVarPath = `/api/master/super-bill/{superBillId}/send-invoice-email-without-payment-link`
                .replace(`{${"superBillId"}}`, encodeURIComponent(String(superBillId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (invoiceSentToPatient !== undefined) {
                localVarQueryParameter['invoiceSentToPatient'] = invoiceSentToPatient;
            }

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Bulk update 
         * @summary Bulk update super bill
         * @param {Array<SuperBillBulk>} superBillBulk 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateBulkSuperBills: async (superBillBulk: Array<SuperBillBulk>, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'superBillBulk' is not null or undefined
            assertParamExists('updateBulkSuperBills', 'superBillBulk', superBillBulk)
            const localVarPath = `/api/master/super-bill/superbill-bulk-update`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(superBillBulk, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Edit Super Bill.
         * @summary Update super bill
         * @param {SuperBill} superBill 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSuperBill: async (superBill: SuperBill, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'superBill' is not null or undefined
            assertParamExists('updateSuperBill', 'superBill', superBill)
            const localVarPath = `/api/master/super-bill`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(superBill, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Archive a Super Bill by its ID
         * @summary Archive Super Bill
         * @param {string} superBillId 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSuperBillArchiveStatus: async (superBillId: string, status: boolean, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'superBillId' is not null or undefined
            assertParamExists('updateSuperBillArchiveStatus', 'superBillId', superBillId)
            // verify required parameter 'status' is not null or undefined
            assertParamExists('updateSuperBillArchiveStatus', 'status', status)
            const localVarPath = `/api/master/super-bill/{superBillId}/archive-status/{status}`
                .replace(`{${"superBillId"}}`, encodeURIComponent(String(superBillId)))
                .replace(`{${"status"}}`, encodeURIComponent(String(status)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SuperBillControllerApi - functional programming interface
 * @export
 */
export const SuperBillControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SuperBillControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * Generate PDF for each selected invoice and return as a ZIP file download
         * @summary Batch print invoices
         * @param {Array<string>} requestBody 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async batchPrintInvoices(requestBody: Array<string>, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.batchPrintInvoices(requestBody, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SuperBillControllerApi.batchPrintInvoices']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Calculate the patient balance
         * @param {PatientBalanceCalculation} patientBalanceCalculation 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async calculatePatientBalance(patientBalanceCalculation: PatientBalanceCalculation, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.calculatePatientBalance(patientBalanceCalculation, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SuperBillControllerApi.calculatePatientBalance']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Canceled a Super Bill by its ID
         * @summary Canceled Super Bill
         * @param {string} superBillId 
         * @param {CancelledStatusStatusEnum} status 
         * @param {string} [cancelReason] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cancelledStatus(superBillId: string, status: CancelledStatusStatusEnum, cancelReason?: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cancelledStatus(superBillId, status, cancelReason, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SuperBillControllerApi.cancelledStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Schedule a one-time reminder notification for an invoice via the patient\'s preferred communication channel
         * @summary Configure invoice reminder
         * @param {string} superBillId 
         * @param {InvoiceReminderRequest} invoiceReminderRequest 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async configureInvoiceReminder(superBillId: string, invoiceReminderRequest: InvoiceReminderRequest, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.configureInvoiceReminder(superBillId, invoiceReminderRequest, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SuperBillControllerApi.configureInvoiceReminder']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create a super bill
         * @summary Create Super Bill
         * @param {SuperBill} superBill 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createSuperBill(superBill: SuperBill, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createSuperBill(superBill, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SuperBillControllerApi.createSuperBill']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get all super bill list. 
         * @summary Get all superBill
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {boolean} [status] 
         * @param {boolean} [archive] 
         * @param {string} [patientId] 
         * @param {string} [locationId] 
         * @param {string} [encounterId] 
         * @param {string} [providerId] 
         * @param {string} [searchString] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllSuperBill(page?: number, size?: number, sortBy?: string, sortDirection?: string, status?: boolean, archive?: boolean, patientId?: string, locationId?: string, encounterId?: string, providerId?: string, searchString?: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllSuperBill(page, size, sortBy, sortDirection, status, archive, patientId, locationId, encounterId, providerId, searchString, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SuperBillControllerApi.getAllSuperBill']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get all super bill list (fast projection-based API)
         * @summary Get all superBill V2
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {boolean} [status] 
         * @param {boolean} [archive] 
         * @param {string} [patientId] 
         * @param {string} [locationId] 
         * @param {string} [encounterId] 
         * @param {string} [providerId] 
         * @param {string} [searchString] 
         * @param {GetAllSuperBillV2BillStatusEnum} [billStatus] 
         * @param {boolean} [outstandingBalance] 
         * @param {string} [dateRangeType] 
         * @param {string} [customStartDate] 
         * @param {string} [customEndDate] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllSuperBillV2(page?: number, size?: number, sortBy?: string, sortDirection?: string, status?: boolean, archive?: boolean, patientId?: string, locationId?: string, encounterId?: string, providerId?: string, searchString?: string, billStatus?: GetAllSuperBillV2BillStatusEnum, outstandingBalance?: boolean, dateRangeType?: string, customStartDate?: string, customEndDate?: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllSuperBillV2(page, size, sortBy, sortDirection, status, archive, patientId, locationId, encounterId, providerId, searchString, billStatus, outstandingBalance, dateRangeType, customStartDate, customEndDate, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SuperBillControllerApi.getAllSuperBillV2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Paginated list of unpaid and partially-paid invoices for the patient. Used by Patient Portal Dashboard Payments Due card.
         * @summary Get Payments Due for patient dashboard
         * @param {string} patientUuid 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPaymentsDue(patientUuid: string, page?: number, size?: number, sortBy?: string, sortDirection?: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPaymentsDue(patientUuid, page, size, sortBy, sortDirection, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SuperBillControllerApi.getPaymentsDue']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get superbill by superUuid
         * @summary Get super bill by superBillUuid.
         * @param {string} superBillUuid 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSuperBillById(superBillUuid: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSuperBillById(superBillUuid, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SuperBillControllerApi.getSuperBillById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns minimal projection-based data for CMS 1500 form print
         * @summary Get super bill by id for CMS 1500 print
         * @param {string} superBillUuid 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSuperBillCms1500Print(superBillUuid: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSuperBillCms1500Print(superBillUuid, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SuperBillControllerApi.getSuperBillCms1500Print']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get list of superbills by IDs
         * @summary Get list of super bills
         * @param {Array<string>} requestBody 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSuperBills(requestBody: Array<string>, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSuperBills(requestBody, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SuperBillControllerApi.getSuperBills']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} superBillId 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async printSuperBillDetails(superBillId: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.printSuperBillDetails(superBillId, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SuperBillControllerApi.printSuperBillDetails']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Process a patient payment and update the super bill balance
         * @summary Process patient payment
         * @param {string} superBillId 
         * @param {number} paymentAmount 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async processPatientPayment(superBillId: string, paymentAmount: number, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.processPatientPayment(superBillId, paymentAmount, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SuperBillControllerApi.processPatientPayment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Generate invoice payment link from super bill and send invoice email to patient with and without the payment link
         * @summary Send invoice email from super bill
         * @param {string} superBillId 
         * @param {boolean} [invoiceSentToPatient] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendInvoiceEmail(superBillId: string, invoiceSentToPatient?: boolean, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendInvoiceEmail(superBillId, invoiceSentToPatient, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SuperBillControllerApi.sendInvoiceEmail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Send invoice email to patient without payment link
         * @summary Send invoice email from super bill without payment link
         * @param {string} superBillId 
         * @param {boolean} [invoiceSentToPatient] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendInvoiceWithoutPaymentLink(superBillId: string, invoiceSentToPatient?: boolean, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendInvoiceWithoutPaymentLink(superBillId, invoiceSentToPatient, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SuperBillControllerApi.sendInvoiceWithoutPaymentLink']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Bulk update 
         * @summary Bulk update super bill
         * @param {Array<SuperBillBulk>} superBillBulk 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateBulkSuperBills(superBillBulk: Array<SuperBillBulk>, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateBulkSuperBills(superBillBulk, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SuperBillControllerApi.updateBulkSuperBills']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Edit Super Bill.
         * @summary Update super bill
         * @param {SuperBill} superBill 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateSuperBill(superBill: SuperBill, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateSuperBill(superBill, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SuperBillControllerApi.updateSuperBill']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Archive a Super Bill by its ID
         * @summary Archive Super Bill
         * @param {string} superBillId 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateSuperBillArchiveStatus(superBillId: string, status: boolean, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateSuperBillArchiveStatus(superBillId, status, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SuperBillControllerApi.updateSuperBillArchiveStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SuperBillControllerApi - factory interface
 * @export
 */
export const SuperBillControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SuperBillControllerApiFp(configuration)
    return {
        /**
         * Generate PDF for each selected invoice and return as a ZIP file download
         * @summary Batch print invoices
         * @param {Array<string>} requestBody 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        batchPrintInvoices(requestBody: Array<string>, xTENANTID?: string, options?: any): AxiosPromise<string> {
            return localVarFp.batchPrintInvoices(requestBody, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Calculate the patient balance
         * @param {PatientBalanceCalculation} patientBalanceCalculation 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        calculatePatientBalance(patientBalanceCalculation: PatientBalanceCalculation, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.calculatePatientBalance(patientBalanceCalculation, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Canceled a Super Bill by its ID
         * @summary Canceled Super Bill
         * @param {string} superBillId 
         * @param {CancelledStatusStatusEnum} status 
         * @param {string} [cancelReason] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelledStatus(superBillId: string, status: CancelledStatusStatusEnum, cancelReason?: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.cancelledStatus(superBillId, status, cancelReason, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Schedule a one-time reminder notification for an invoice via the patient\'s preferred communication channel
         * @summary Configure invoice reminder
         * @param {string} superBillId 
         * @param {InvoiceReminderRequest} invoiceReminderRequest 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        configureInvoiceReminder(superBillId: string, invoiceReminderRequest: InvoiceReminderRequest, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.configureInvoiceReminder(superBillId, invoiceReminderRequest, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a super bill
         * @summary Create Super Bill
         * @param {SuperBill} superBill 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSuperBill(superBill: SuperBill, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.createSuperBill(superBill, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all super bill list. 
         * @summary Get all superBill
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {boolean} [status] 
         * @param {boolean} [archive] 
         * @param {string} [patientId] 
         * @param {string} [locationId] 
         * @param {string} [encounterId] 
         * @param {string} [providerId] 
         * @param {string} [searchString] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllSuperBill(page?: number, size?: number, sortBy?: string, sortDirection?: string, status?: boolean, archive?: boolean, patientId?: string, locationId?: string, encounterId?: string, providerId?: string, searchString?: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getAllSuperBill(page, size, sortBy, sortDirection, status, archive, patientId, locationId, encounterId, providerId, searchString, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all super bill list (fast projection-based API)
         * @summary Get all superBill V2
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {boolean} [status] 
         * @param {boolean} [archive] 
         * @param {string} [patientId] 
         * @param {string} [locationId] 
         * @param {string} [encounterId] 
         * @param {string} [providerId] 
         * @param {string} [searchString] 
         * @param {GetAllSuperBillV2BillStatusEnum} [billStatus] 
         * @param {boolean} [outstandingBalance] 
         * @param {string} [dateRangeType] 
         * @param {string} [customStartDate] 
         * @param {string} [customEndDate] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllSuperBillV2(page?: number, size?: number, sortBy?: string, sortDirection?: string, status?: boolean, archive?: boolean, patientId?: string, locationId?: string, encounterId?: string, providerId?: string, searchString?: string, billStatus?: GetAllSuperBillV2BillStatusEnum, outstandingBalance?: boolean, dateRangeType?: string, customStartDate?: string, customEndDate?: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getAllSuperBillV2(page, size, sortBy, sortDirection, status, archive, patientId, locationId, encounterId, providerId, searchString, billStatus, outstandingBalance, dateRangeType, customStartDate, customEndDate, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Paginated list of unpaid and partially-paid invoices for the patient. Used by Patient Portal Dashboard Payments Due card.
         * @summary Get Payments Due for patient dashboard
         * @param {string} patientUuid 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPaymentsDue(patientUuid: string, page?: number, size?: number, sortBy?: string, sortDirection?: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getPaymentsDue(patientUuid, page, size, sortBy, sortDirection, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Get superbill by superUuid
         * @summary Get super bill by superBillUuid.
         * @param {string} superBillUuid 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSuperBillById(superBillUuid: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getSuperBillById(superBillUuid, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns minimal projection-based data for CMS 1500 form print
         * @summary Get super bill by id for CMS 1500 print
         * @param {string} superBillUuid 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSuperBillCms1500Print(superBillUuid: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getSuperBillCms1500Print(superBillUuid, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Get list of superbills by IDs
         * @summary Get list of super bills
         * @param {Array<string>} requestBody 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSuperBills(requestBody: Array<string>, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getSuperBills(requestBody, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} superBillId 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        printSuperBillDetails(superBillId: string, xTENANTID?: string, options?: any): AxiosPromise<string> {
            return localVarFp.printSuperBillDetails(superBillId, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Process a patient payment and update the super bill balance
         * @summary Process patient payment
         * @param {string} superBillId 
         * @param {number} paymentAmount 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        processPatientPayment(superBillId: string, paymentAmount: number, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.processPatientPayment(superBillId, paymentAmount, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Generate invoice payment link from super bill and send invoice email to patient with and without the payment link
         * @summary Send invoice email from super bill
         * @param {string} superBillId 
         * @param {boolean} [invoiceSentToPatient] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendInvoiceEmail(superBillId: string, invoiceSentToPatient?: boolean, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.sendInvoiceEmail(superBillId, invoiceSentToPatient, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Send invoice email to patient without payment link
         * @summary Send invoice email from super bill without payment link
         * @param {string} superBillId 
         * @param {boolean} [invoiceSentToPatient] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendInvoiceWithoutPaymentLink(superBillId: string, invoiceSentToPatient?: boolean, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.sendInvoiceWithoutPaymentLink(superBillId, invoiceSentToPatient, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Bulk update 
         * @summary Bulk update super bill
         * @param {Array<SuperBillBulk>} superBillBulk 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateBulkSuperBills(superBillBulk: Array<SuperBillBulk>, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.updateBulkSuperBills(superBillBulk, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Edit Super Bill.
         * @summary Update super bill
         * @param {SuperBill} superBill 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSuperBill(superBill: SuperBill, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.updateSuperBill(superBill, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Archive a Super Bill by its ID
         * @summary Archive Super Bill
         * @param {string} superBillId 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSuperBillArchiveStatus(superBillId: string, status: boolean, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.updateSuperBillArchiveStatus(superBillId, status, xTENANTID, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SuperBillControllerApi - object-oriented interface
 * @export
 * @class SuperBillControllerApi
 * @extends {BaseAPI}
 */
export class SuperBillControllerApi extends BaseAPI {
    /**
     * Generate PDF for each selected invoice and return as a ZIP file download
     * @summary Batch print invoices
     * @param {Array<string>} requestBody 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SuperBillControllerApi
     */
    public batchPrintInvoices(requestBody: Array<string>, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return SuperBillControllerApiFp(this.configuration).batchPrintInvoices(requestBody, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Calculate the patient balance
     * @param {PatientBalanceCalculation} patientBalanceCalculation 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SuperBillControllerApi
     */
    public calculatePatientBalance(patientBalanceCalculation: PatientBalanceCalculation, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return SuperBillControllerApiFp(this.configuration).calculatePatientBalance(patientBalanceCalculation, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Canceled a Super Bill by its ID
     * @summary Canceled Super Bill
     * @param {string} superBillId 
     * @param {CancelledStatusStatusEnum} status 
     * @param {string} [cancelReason] 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SuperBillControllerApi
     */
    public cancelledStatus(superBillId: string, status: CancelledStatusStatusEnum, cancelReason?: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return SuperBillControllerApiFp(this.configuration).cancelledStatus(superBillId, status, cancelReason, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Schedule a one-time reminder notification for an invoice via the patient\'s preferred communication channel
     * @summary Configure invoice reminder
     * @param {string} superBillId 
     * @param {InvoiceReminderRequest} invoiceReminderRequest 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SuperBillControllerApi
     */
    public configureInvoiceReminder(superBillId: string, invoiceReminderRequest: InvoiceReminderRequest, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return SuperBillControllerApiFp(this.configuration).configureInvoiceReminder(superBillId, invoiceReminderRequest, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create a super bill
     * @summary Create Super Bill
     * @param {SuperBill} superBill 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SuperBillControllerApi
     */
    public createSuperBill(superBill: SuperBill, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return SuperBillControllerApiFp(this.configuration).createSuperBill(superBill, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all super bill list. 
     * @summary Get all superBill
     * @param {number} [page] 
     * @param {number} [size] 
     * @param {string} [sortBy] 
     * @param {string} [sortDirection] 
     * @param {boolean} [status] 
     * @param {boolean} [archive] 
     * @param {string} [patientId] 
     * @param {string} [locationId] 
     * @param {string} [encounterId] 
     * @param {string} [providerId] 
     * @param {string} [searchString] 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SuperBillControllerApi
     */
    public getAllSuperBill(page?: number, size?: number, sortBy?: string, sortDirection?: string, status?: boolean, archive?: boolean, patientId?: string, locationId?: string, encounterId?: string, providerId?: string, searchString?: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return SuperBillControllerApiFp(this.configuration).getAllSuperBill(page, size, sortBy, sortDirection, status, archive, patientId, locationId, encounterId, providerId, searchString, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all super bill list (fast projection-based API)
     * @summary Get all superBill V2
     * @param {number} [page] 
     * @param {number} [size] 
     * @param {string} [sortBy] 
     * @param {string} [sortDirection] 
     * @param {boolean} [status] 
     * @param {boolean} [archive] 
     * @param {string} [patientId] 
     * @param {string} [locationId] 
     * @param {string} [encounterId] 
     * @param {string} [providerId] 
     * @param {string} [searchString] 
     * @param {GetAllSuperBillV2BillStatusEnum} [billStatus] 
     * @param {boolean} [outstandingBalance] 
     * @param {string} [dateRangeType] 
     * @param {string} [customStartDate] 
     * @param {string} [customEndDate] 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SuperBillControllerApi
     */
    public getAllSuperBillV2(page?: number, size?: number, sortBy?: string, sortDirection?: string, status?: boolean, archive?: boolean, patientId?: string, locationId?: string, encounterId?: string, providerId?: string, searchString?: string, billStatus?: GetAllSuperBillV2BillStatusEnum, outstandingBalance?: boolean, dateRangeType?: string, customStartDate?: string, customEndDate?: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return SuperBillControllerApiFp(this.configuration).getAllSuperBillV2(page, size, sortBy, sortDirection, status, archive, patientId, locationId, encounterId, providerId, searchString, billStatus, outstandingBalance, dateRangeType, customStartDate, customEndDate, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Paginated list of unpaid and partially-paid invoices for the patient. Used by Patient Portal Dashboard Payments Due card.
     * @summary Get Payments Due for patient dashboard
     * @param {string} patientUuid 
     * @param {number} [page] 
     * @param {number} [size] 
     * @param {string} [sortBy] 
     * @param {string} [sortDirection] 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SuperBillControllerApi
     */
    public getPaymentsDue(patientUuid: string, page?: number, size?: number, sortBy?: string, sortDirection?: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return SuperBillControllerApiFp(this.configuration).getPaymentsDue(patientUuid, page, size, sortBy, sortDirection, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get superbill by superUuid
     * @summary Get super bill by superBillUuid.
     * @param {string} superBillUuid 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SuperBillControllerApi
     */
    public getSuperBillById(superBillUuid: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return SuperBillControllerApiFp(this.configuration).getSuperBillById(superBillUuid, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns minimal projection-based data for CMS 1500 form print
     * @summary Get super bill by id for CMS 1500 print
     * @param {string} superBillUuid 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SuperBillControllerApi
     */
    public getSuperBillCms1500Print(superBillUuid: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return SuperBillControllerApiFp(this.configuration).getSuperBillCms1500Print(superBillUuid, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get list of superbills by IDs
     * @summary Get list of super bills
     * @param {Array<string>} requestBody 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SuperBillControllerApi
     */
    public getSuperBills(requestBody: Array<string>, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return SuperBillControllerApiFp(this.configuration).getSuperBills(requestBody, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} superBillId 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SuperBillControllerApi
     */
    public printSuperBillDetails(superBillId: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return SuperBillControllerApiFp(this.configuration).printSuperBillDetails(superBillId, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Process a patient payment and update the super bill balance
     * @summary Process patient payment
     * @param {string} superBillId 
     * @param {number} paymentAmount 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SuperBillControllerApi
     */
    public processPatientPayment(superBillId: string, paymentAmount: number, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return SuperBillControllerApiFp(this.configuration).processPatientPayment(superBillId, paymentAmount, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Generate invoice payment link from super bill and send invoice email to patient with and without the payment link
     * @summary Send invoice email from super bill
     * @param {string} superBillId 
     * @param {boolean} [invoiceSentToPatient] 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SuperBillControllerApi
     */
    public sendInvoiceEmail(superBillId: string, invoiceSentToPatient?: boolean, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return SuperBillControllerApiFp(this.configuration).sendInvoiceEmail(superBillId, invoiceSentToPatient, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Send invoice email to patient without payment link
     * @summary Send invoice email from super bill without payment link
     * @param {string} superBillId 
     * @param {boolean} [invoiceSentToPatient] 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SuperBillControllerApi
     */
    public sendInvoiceWithoutPaymentLink(superBillId: string, invoiceSentToPatient?: boolean, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return SuperBillControllerApiFp(this.configuration).sendInvoiceWithoutPaymentLink(superBillId, invoiceSentToPatient, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Bulk update 
     * @summary Bulk update super bill
     * @param {Array<SuperBillBulk>} superBillBulk 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SuperBillControllerApi
     */
    public updateBulkSuperBills(superBillBulk: Array<SuperBillBulk>, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return SuperBillControllerApiFp(this.configuration).updateBulkSuperBills(superBillBulk, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Edit Super Bill.
     * @summary Update super bill
     * @param {SuperBill} superBill 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SuperBillControllerApi
     */
    public updateSuperBill(superBill: SuperBill, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return SuperBillControllerApiFp(this.configuration).updateSuperBill(superBill, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Archive a Super Bill by its ID
     * @summary Archive Super Bill
     * @param {string} superBillId 
     * @param {boolean} status 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SuperBillControllerApi
     */
    public updateSuperBillArchiveStatus(superBillId: string, status: boolean, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return SuperBillControllerApiFp(this.configuration).updateSuperBillArchiveStatus(superBillId, status, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const CancelledStatusStatusEnum = {
    ReadyForClaim: 'READY_FOR_CLAIM',
    Draft: 'DRAFT',
    Pending: 'PENDING',
    PartiallyPaid: 'PARTIALLY_PAID',
    Paid: 'PAID',
    Cancelled: 'CANCELLED',
    Overdue: 'OVERDUE'
} as const;
export type CancelledStatusStatusEnum = typeof CancelledStatusStatusEnum[keyof typeof CancelledStatusStatusEnum];
/**
 * @export
 */
export const GetAllSuperBillV2BillStatusEnum = {
    ReadyForClaim: 'READY_FOR_CLAIM',
    Draft: 'DRAFT',
    Pending: 'PENDING',
    PartiallyPaid: 'PARTIALLY_PAID',
    Paid: 'PAID',
    Cancelled: 'CANCELLED',
    Overdue: 'OVERDUE'
} as const;
export type GetAllSuperBillV2BillStatusEnum = typeof GetAllSuperBillV2BillStatusEnum[keyof typeof GetAllSuperBillV2BillStatusEnum];


/**
 * SurgicalHistoryControllerApi - axios parameter creator
 * @export
 */
export const SurgicalHistoryControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Add a new patient surgical history into the system
         * @summary Add patient surgical history
         * @param {SurgicalHistory} surgicalHistory 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPatientSurgicalHistory: async (surgicalHistory: SurgicalHistory, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'surgicalHistory' is not null or undefined
            assertParamExists('createPatientSurgicalHistory', 'surgicalHistory', surgicalHistory)
            const localVarPath = `/api/master/patient-surgical-history`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(surgicalHistory, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all Patient Surgical History
         * @summary Get all Patient Surgical History.
         * @param {string} [patientUuid] 
         * @param {string} [appointmentUuid] 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sort] 
         * @param {boolean} [status] 
         * @param {boolean} [archive] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatientSurgicalHistory: async (patientUuid?: string, appointmentUuid?: string, page?: number, size?: number, sortBy?: string, sort?: string, status?: boolean, archive?: boolean, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/master/patient-surgical-history`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (patientUuid !== undefined) {
                localVarQueryParameter['patientUuid'] = patientUuid;
            }

            if (appointmentUuid !== undefined) {
                localVarQueryParameter['appointmentUuid'] = appointmentUuid;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (archive !== undefined) {
                localVarQueryParameter['archive'] = archive;
            }

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve a Patient Surgical History by its unique ID
         * @summary Get Patient Surgical History by ID
         * @param {string} patientSurgicalHistoryId 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatientSurgicalHistoryById: async (patientSurgicalHistoryId: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientSurgicalHistoryId' is not null or undefined
            assertParamExists('getPatientSurgicalHistoryById', 'patientSurgicalHistoryId', patientSurgicalHistoryId)
            const localVarPath = `/api/master/patient-surgical-history/{patientSurgicalHistoryId}`
                .replace(`{${"patientSurgicalHistoryId"}}`, encodeURIComponent(String(patientSurgicalHistoryId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update an existing Patient Surgical History
         * @summary Update Patient Surgical History
         * @param {SurgicalHistory} surgicalHistory 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePatientSurgicalHistory: async (surgicalHistory: SurgicalHistory, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'surgicalHistory' is not null or undefined
            assertParamExists('updatePatientSurgicalHistory', 'surgicalHistory', surgicalHistory)
            const localVarPath = `/api/master/patient-surgical-history`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(surgicalHistory, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Change the  Patient  Surgical history archive status to either archived or unarchived.
         * @summary Archive/Unarchive Patient Surgical History
         * @param {string} patientSurgicalHistoryId 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePatientSurgicalHistoryArchiveStatus: async (patientSurgicalHistoryId: string, status: boolean, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientSurgicalHistoryId' is not null or undefined
            assertParamExists('updatePatientSurgicalHistoryArchiveStatus', 'patientSurgicalHistoryId', patientSurgicalHistoryId)
            // verify required parameter 'status' is not null or undefined
            assertParamExists('updatePatientSurgicalHistoryArchiveStatus', 'status', status)
            const localVarPath = `/api/master/patient-surgical-history/{patientSurgicalHistoryId}/archive-status/{status}`
                .replace(`{${"patientSurgicalHistoryId"}}`, encodeURIComponent(String(patientSurgicalHistoryId)))
                .replace(`{${"status"}}`, encodeURIComponent(String(status)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Change the  Patient  Surgical history status.
         * @summary Update Patient Surgical History Status
         * @param {string} patientSurgicalHistoryId 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePatientSurgicalHistoryStatus: async (patientSurgicalHistoryId: string, status: boolean, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientSurgicalHistoryId' is not null or undefined
            assertParamExists('updatePatientSurgicalHistoryStatus', 'patientSurgicalHistoryId', patientSurgicalHistoryId)
            // verify required parameter 'status' is not null or undefined
            assertParamExists('updatePatientSurgicalHistoryStatus', 'status', status)
            const localVarPath = `/api/master/patient-surgical-history/{patientSurgicalHistoryId}/status/{status}`
                .replace(`{${"patientSurgicalHistoryId"}}`, encodeURIComponent(String(patientSurgicalHistoryId)))
                .replace(`{${"status"}}`, encodeURIComponent(String(status)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SurgicalHistoryControllerApi - functional programming interface
 * @export
 */
export const SurgicalHistoryControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SurgicalHistoryControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * Add a new patient surgical history into the system
         * @summary Add patient surgical history
         * @param {SurgicalHistory} surgicalHistory 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createPatientSurgicalHistory(surgicalHistory: SurgicalHistory, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createPatientSurgicalHistory(surgicalHistory, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SurgicalHistoryControllerApi.createPatientSurgicalHistory']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get all Patient Surgical History
         * @summary Get all Patient Surgical History.
         * @param {string} [patientUuid] 
         * @param {string} [appointmentUuid] 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sort] 
         * @param {boolean} [status] 
         * @param {boolean} [archive] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPatientSurgicalHistory(patientUuid?: string, appointmentUuid?: string, page?: number, size?: number, sortBy?: string, sort?: string, status?: boolean, archive?: boolean, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPatientSurgicalHistory(patientUuid, appointmentUuid, page, size, sortBy, sort, status, archive, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SurgicalHistoryControllerApi.getPatientSurgicalHistory']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve a Patient Surgical History by its unique ID
         * @summary Get Patient Surgical History by ID
         * @param {string} patientSurgicalHistoryId 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPatientSurgicalHistoryById(patientSurgicalHistoryId: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPatientSurgicalHistoryById(patientSurgicalHistoryId, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SurgicalHistoryControllerApi.getPatientSurgicalHistoryById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update an existing Patient Surgical History
         * @summary Update Patient Surgical History
         * @param {SurgicalHistory} surgicalHistory 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePatientSurgicalHistory(surgicalHistory: SurgicalHistory, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePatientSurgicalHistory(surgicalHistory, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SurgicalHistoryControllerApi.updatePatientSurgicalHistory']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Change the  Patient  Surgical history archive status to either archived or unarchived.
         * @summary Archive/Unarchive Patient Surgical History
         * @param {string} patientSurgicalHistoryId 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePatientSurgicalHistoryArchiveStatus(patientSurgicalHistoryId: string, status: boolean, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePatientSurgicalHistoryArchiveStatus(patientSurgicalHistoryId, status, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SurgicalHistoryControllerApi.updatePatientSurgicalHistoryArchiveStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Change the  Patient  Surgical history status.
         * @summary Update Patient Surgical History Status
         * @param {string} patientSurgicalHistoryId 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePatientSurgicalHistoryStatus(patientSurgicalHistoryId: string, status: boolean, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePatientSurgicalHistoryStatus(patientSurgicalHistoryId, status, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SurgicalHistoryControllerApi.updatePatientSurgicalHistoryStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SurgicalHistoryControllerApi - factory interface
 * @export
 */
export const SurgicalHistoryControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SurgicalHistoryControllerApiFp(configuration)
    return {
        /**
         * Add a new patient surgical history into the system
         * @summary Add patient surgical history
         * @param {SurgicalHistory} surgicalHistory 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPatientSurgicalHistory(surgicalHistory: SurgicalHistory, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.createPatientSurgicalHistory(surgicalHistory, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all Patient Surgical History
         * @summary Get all Patient Surgical History.
         * @param {string} [patientUuid] 
         * @param {string} [appointmentUuid] 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sort] 
         * @param {boolean} [status] 
         * @param {boolean} [archive] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatientSurgicalHistory(patientUuid?: string, appointmentUuid?: string, page?: number, size?: number, sortBy?: string, sort?: string, status?: boolean, archive?: boolean, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getPatientSurgicalHistory(patientUuid, appointmentUuid, page, size, sortBy, sort, status, archive, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve a Patient Surgical History by its unique ID
         * @summary Get Patient Surgical History by ID
         * @param {string} patientSurgicalHistoryId 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatientSurgicalHistoryById(patientSurgicalHistoryId: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getPatientSurgicalHistoryById(patientSurgicalHistoryId, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Update an existing Patient Surgical History
         * @summary Update Patient Surgical History
         * @param {SurgicalHistory} surgicalHistory 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePatientSurgicalHistory(surgicalHistory: SurgicalHistory, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.updatePatientSurgicalHistory(surgicalHistory, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Change the  Patient  Surgical history archive status to either archived or unarchived.
         * @summary Archive/Unarchive Patient Surgical History
         * @param {string} patientSurgicalHistoryId 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePatientSurgicalHistoryArchiveStatus(patientSurgicalHistoryId: string, status: boolean, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.updatePatientSurgicalHistoryArchiveStatus(patientSurgicalHistoryId, status, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Change the  Patient  Surgical history status.
         * @summary Update Patient Surgical History Status
         * @param {string} patientSurgicalHistoryId 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePatientSurgicalHistoryStatus(patientSurgicalHistoryId: string, status: boolean, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.updatePatientSurgicalHistoryStatus(patientSurgicalHistoryId, status, xTENANTID, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SurgicalHistoryControllerApi - object-oriented interface
 * @export
 * @class SurgicalHistoryControllerApi
 * @extends {BaseAPI}
 */
export class SurgicalHistoryControllerApi extends BaseAPI {
    /**
     * Add a new patient surgical history into the system
     * @summary Add patient surgical history
     * @param {SurgicalHistory} surgicalHistory 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SurgicalHistoryControllerApi
     */
    public createPatientSurgicalHistory(surgicalHistory: SurgicalHistory, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return SurgicalHistoryControllerApiFp(this.configuration).createPatientSurgicalHistory(surgicalHistory, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all Patient Surgical History
     * @summary Get all Patient Surgical History.
     * @param {string} [patientUuid] 
     * @param {string} [appointmentUuid] 
     * @param {number} [page] 
     * @param {number} [size] 
     * @param {string} [sortBy] 
     * @param {string} [sort] 
     * @param {boolean} [status] 
     * @param {boolean} [archive] 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SurgicalHistoryControllerApi
     */
    public getPatientSurgicalHistory(patientUuid?: string, appointmentUuid?: string, page?: number, size?: number, sortBy?: string, sort?: string, status?: boolean, archive?: boolean, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return SurgicalHistoryControllerApiFp(this.configuration).getPatientSurgicalHistory(patientUuid, appointmentUuid, page, size, sortBy, sort, status, archive, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve a Patient Surgical History by its unique ID
     * @summary Get Patient Surgical History by ID
     * @param {string} patientSurgicalHistoryId 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SurgicalHistoryControllerApi
     */
    public getPatientSurgicalHistoryById(patientSurgicalHistoryId: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return SurgicalHistoryControllerApiFp(this.configuration).getPatientSurgicalHistoryById(patientSurgicalHistoryId, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update an existing Patient Surgical History
     * @summary Update Patient Surgical History
     * @param {SurgicalHistory} surgicalHistory 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SurgicalHistoryControllerApi
     */
    public updatePatientSurgicalHistory(surgicalHistory: SurgicalHistory, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return SurgicalHistoryControllerApiFp(this.configuration).updatePatientSurgicalHistory(surgicalHistory, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Change the  Patient  Surgical history archive status to either archived or unarchived.
     * @summary Archive/Unarchive Patient Surgical History
     * @param {string} patientSurgicalHistoryId 
     * @param {boolean} status 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SurgicalHistoryControllerApi
     */
    public updatePatientSurgicalHistoryArchiveStatus(patientSurgicalHistoryId: string, status: boolean, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return SurgicalHistoryControllerApiFp(this.configuration).updatePatientSurgicalHistoryArchiveStatus(patientSurgicalHistoryId, status, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Change the  Patient  Surgical history status.
     * @summary Update Patient Surgical History Status
     * @param {string} patientSurgicalHistoryId 
     * @param {boolean} status 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SurgicalHistoryControllerApi
     */
    public updatePatientSurgicalHistoryStatus(patientSurgicalHistoryId: string, status: boolean, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return SurgicalHistoryControllerApiFp(this.configuration).updatePatientSurgicalHistoryStatus(patientSurgicalHistoryId, status, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * TaskControllerApi - axios parameter creator
 * @export
 */
export const TaskControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Acknowledged a Task by its ID
         * @summary Acknowledged Task
         * @param {string} taskId 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        acknowledgedTasks: async (taskId: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'taskId' is not null or undefined
            assertParamExists('acknowledgedTasks', 'taskId', taskId)
            const localVarPath = `/api/master/task/{taskId}/Acknowledged`
                .replace(`{${"taskId"}}`, encodeURIComponent(String(taskId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Canceled a Task by its ID
         * @summary Canceled Task
         * @param {BulkCancel} bulkCancel 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelTasks: async (bulkCancel: BulkCancel, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bulkCancel' is not null or undefined
            assertParamExists('cancelTasks', 'bulkCancel', bulkCancel)
            const localVarPath = `/api/master/task/task-cancel`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bulkCancel, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Add a new Task record into the system
         * @summary Add Task
         * @param {Task} task 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTask: async (task: Task, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'task' is not null or undefined
            assertParamExists('createTask', 'task', task)
            const localVarPath = `/api/master/task`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(task, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all Task records with search and filter options. Supports sorting by: patientName (alphabetical), dueDate (chronological), priority (High → Medium → Low), createdDate (chronological), updatedDate (chronological), title, description, active, archive, taskStatus.
         * @summary Get Tasks
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sort] 
         * @param {boolean} [active] 
         * @param {GetAllTasksFlagEnum} [flag] 
         * @param {GetAllTasksTaskPriorityEnum} [taskPriority] 
         * @param {boolean} [providerTask] 
         * @param {string} [patient] 
         * @param {string} [assignTo] 
         * @param {string} [assignBy] 
         * @param {boolean} [myTask] 
         * @param {boolean} [toDoTask] 
         * @param {boolean} [archive] 
         * @param {string} [dueDate] 
         * @param {GetAllTasksTaskStatusEnum} [taskStatus] 
         * @param {string} [searchString] 
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {string} [appointmentId] 
         * @param {string} [actionType] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllTasks: async (page?: number, size?: number, sortBy?: string, sort?: string, active?: boolean, flag?: GetAllTasksFlagEnum, taskPriority?: GetAllTasksTaskPriorityEnum, providerTask?: boolean, patient?: string, assignTo?: string, assignBy?: string, myTask?: boolean, toDoTask?: boolean, archive?: boolean, dueDate?: string, taskStatus?: GetAllTasksTaskStatusEnum, searchString?: string, startDate?: string, endDate?: string, appointmentId?: string, actionType?: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/master/task`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (active !== undefined) {
                localVarQueryParameter['active'] = active;
            }

            if (flag !== undefined) {
                localVarQueryParameter['flag'] = flag;
            }

            if (taskPriority !== undefined) {
                localVarQueryParameter['taskPriority'] = taskPriority;
            }

            if (providerTask !== undefined) {
                localVarQueryParameter['providerTask'] = providerTask;
            }

            if (patient !== undefined) {
                localVarQueryParameter['patient'] = patient;
            }

            if (assignTo !== undefined) {
                localVarQueryParameter['assignTo'] = assignTo;
            }

            if (assignBy !== undefined) {
                localVarQueryParameter['assignBy'] = assignBy;
            }

            if (myTask !== undefined) {
                localVarQueryParameter['myTask'] = myTask;
            }

            if (toDoTask !== undefined) {
                localVarQueryParameter['toDoTask'] = toDoTask;
            }

            if (archive !== undefined) {
                localVarQueryParameter['archive'] = archive;
            }

            if (dueDate !== undefined) {
                localVarQueryParameter['dueDate'] = (dueDate as any instanceof Date) ?
                    (dueDate as any).toISOString() :
                    dueDate;
            }

            if (taskStatus !== undefined) {
                localVarQueryParameter['taskStatus'] = taskStatus;
            }

            if (searchString !== undefined) {
                localVarQueryParameter['searchString'] = searchString;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString() :
                    startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString() :
                    endDate;
            }

            if (appointmentId !== undefined) {
                localVarQueryParameter['appointmentId'] = appointmentId;
            }

            if (actionType !== undefined) {
                localVarQueryParameter['actionType'] = actionType;
            }

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all Task records with patient UUID filter and search (excludes patient name from search). Supports sorting by: due_date, task_priority, task_title, created_date, etc.
         * @summary Get Filtered Tasks
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sort] 
         * @param {boolean} [active] 
         * @param {GetFilteredTasksFlagEnum} [flag] 
         * @param {GetFilteredTasksTaskPriorityEnum} [taskPriority] 
         * @param {boolean} [providerTask] 
         * @param {string} [patient] 
         * @param {string} [assignTo] 
         * @param {string} [assignBy] 
         * @param {boolean} [myTask] 
         * @param {boolean} [toDoTask] 
         * @param {boolean} [archive] 
         * @param {string} [dueDate] 
         * @param {GetFilteredTasksTaskStatusEnum} [taskStatus] 
         * @param {string} [searchString] 
         * @param {string} [appointmentId] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFilteredTasks: async (page?: number, size?: number, sortBy?: string, sort?: string, active?: boolean, flag?: GetFilteredTasksFlagEnum, taskPriority?: GetFilteredTasksTaskPriorityEnum, providerTask?: boolean, patient?: string, assignTo?: string, assignBy?: string, myTask?: boolean, toDoTask?: boolean, archive?: boolean, dueDate?: string, taskStatus?: GetFilteredTasksTaskStatusEnum, searchString?: string, appointmentId?: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/master/task/filtered`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (active !== undefined) {
                localVarQueryParameter['active'] = active;
            }

            if (flag !== undefined) {
                localVarQueryParameter['flag'] = flag;
            }

            if (taskPriority !== undefined) {
                localVarQueryParameter['taskPriority'] = taskPriority;
            }

            if (providerTask !== undefined) {
                localVarQueryParameter['providerTask'] = providerTask;
            }

            if (patient !== undefined) {
                localVarQueryParameter['patient'] = patient;
            }

            if (assignTo !== undefined) {
                localVarQueryParameter['assignTo'] = assignTo;
            }

            if (assignBy !== undefined) {
                localVarQueryParameter['assignBy'] = assignBy;
            }

            if (myTask !== undefined) {
                localVarQueryParameter['myTask'] = myTask;
            }

            if (toDoTask !== undefined) {
                localVarQueryParameter['toDoTask'] = toDoTask;
            }

            if (archive !== undefined) {
                localVarQueryParameter['archive'] = archive;
            }

            if (dueDate !== undefined) {
                localVarQueryParameter['dueDate'] = (dueDate as any instanceof Date) ?
                    (dueDate as any).toISOString() :
                    dueDate;
            }

            if (taskStatus !== undefined) {
                localVarQueryParameter['taskStatus'] = taskStatus;
            }

            if (searchString !== undefined) {
                localVarQueryParameter['searchString'] = searchString;
            }

            if (appointmentId !== undefined) {
                localVarQueryParameter['appointmentId'] = appointmentId;
            }

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Lightweight, patient-centric task list for patient portal. Requires patient UUID. Returns: uuid, taskTitle, dueDate, priority, description, assignedBy, taskStatus. toDoTask=true filters by status TO_DO/OVERDUE.
         * @summary Get Patient Portal Tasks
         * @param {string} patient 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sort] 
         * @param {boolean} [toDoTask] 
         * @param {boolean} [archive] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatientPortalTasks: async (patient: string, page?: number, size?: number, sortBy?: string, sort?: string, toDoTask?: boolean, archive?: boolean, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patient' is not null or undefined
            assertParamExists('getPatientPortalTasks', 'patient', patient)
            const localVarPath = `/api/master/task/patient-portal`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (patient !== undefined) {
                localVarQueryParameter['patient'] = patient;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (toDoTask !== undefined) {
                localVarQueryParameter['toDoTask'] = toDoTask;
            }

            if (archive !== undefined) {
                localVarQueryParameter['archive'] = archive;
            }

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve a Task record by its unique ID
         * @summary Get Task by ID
         * @param {string} taskUuid 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTaskById: async (taskUuid: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'taskUuid' is not null or undefined
            assertParamExists('getTaskById', 'taskUuid', taskUuid)
            const localVarPath = `/api/master/task/{taskUuid}`
                .replace(`{${"taskUuid"}}`, encodeURIComponent(String(taskUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTodayTasks: async (xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/master/task/today-task`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Resolve a task by task ID without requiring the caller to be the assignee. Use for patient portal or system-initiated resolution.
         * @summary Resolve Task by ID
         * @param {BulkReassigned} bulkReassigned 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resolveTaskByTaskId: async (bulkReassigned: BulkReassigned, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bulkReassigned' is not null or undefined
            assertParamExists('resolveTaskByTaskId', 'bulkReassigned', bulkReassigned)
            const localVarPath = `/api/master/task/task-resolve`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bulkReassigned, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Resolved a Task by its ID. Caller must be the assigned provider.
         * @summary Resolved Task
         * @param {BulkReassigned} bulkReassigned 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resolvedTasks: async (bulkReassigned: BulkReassigned, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bulkReassigned' is not null or undefined
            assertParamExists('resolvedTasks', 'bulkReassigned', bulkReassigned)
            const localVarPath = `/api/master/task/task-resolved`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bulkReassigned, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Reviewed a Task by its ID
         * @summary Reviewed Task
         * @param {TaskReviewed} taskReviewed 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reviewTask: async (taskReviewed: TaskReviewed, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'taskReviewed' is not null or undefined
            assertParamExists('reviewTask', 'taskReviewed', taskReviewed)
            const localVarPath = `/api/master/task/task-reviewed`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(taskReviewed, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Re-assigned a Task by its ID
         * @summary ReAssigned  Task
         * @param {BulkReassigned} bulkReassigned 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        taskReassignTasks: async (bulkReassigned: BulkReassigned, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bulkReassigned' is not null or undefined
            assertParamExists('taskReassignTasks', 'bulkReassigned', bulkReassigned)
            const localVarPath = `/api/master/task/task-reassigned`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bulkReassigned, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update an existing Task record
         * @summary Update Task
         * @param {Task} task 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTask: async (task: Task, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'task' is not null or undefined
            assertParamExists('updateTask', 'task', task)
            const localVarPath = `/api/master/task`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(task, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Archive a Task record by its ID
         * @summary Archive Task
         * @param {string} taskId 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTaskArchiveStatus: async (taskId: string, status: boolean, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'taskId' is not null or undefined
            assertParamExists('updateTaskArchiveStatus', 'taskId', taskId)
            // verify required parameter 'status' is not null or undefined
            assertParamExists('updateTaskArchiveStatus', 'status', status)
            const localVarPath = `/api/master/task/{taskId}/archive-status/{status}`
                .replace(`{${"taskId"}}`, encodeURIComponent(String(taskId)))
                .replace(`{${"status"}}`, encodeURIComponent(String(status)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update the status of a Task record by its ID
         * @summary Update Task Status
         * @param {string} taskId 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTaskStatus: async (taskId: string, status: boolean, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'taskId' is not null or undefined
            assertParamExists('updateTaskStatus', 'taskId', taskId)
            // verify required parameter 'status' is not null or undefined
            assertParamExists('updateTaskStatus', 'status', status)
            const localVarPath = `/api/master/task/{taskId}/status/{status}`
                .replace(`{${"taskId"}}`, encodeURIComponent(String(taskId)))
                .replace(`{${"status"}}`, encodeURIComponent(String(status)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TaskControllerApi - functional programming interface
 * @export
 */
export const TaskControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TaskControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * Acknowledged a Task by its ID
         * @summary Acknowledged Task
         * @param {string} taskId 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async acknowledgedTasks(taskId: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.acknowledgedTasks(taskId, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TaskControllerApi.acknowledgedTasks']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Canceled a Task by its ID
         * @summary Canceled Task
         * @param {BulkCancel} bulkCancel 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cancelTasks(bulkCancel: BulkCancel, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cancelTasks(bulkCancel, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TaskControllerApi.cancelTasks']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Add a new Task record into the system
         * @summary Add Task
         * @param {Task} task 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createTask(task: Task, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createTask(task, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TaskControllerApi.createTask']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get all Task records with search and filter options. Supports sorting by: patientName (alphabetical), dueDate (chronological), priority (High → Medium → Low), createdDate (chronological), updatedDate (chronological), title, description, active, archive, taskStatus.
         * @summary Get Tasks
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sort] 
         * @param {boolean} [active] 
         * @param {GetAllTasksFlagEnum} [flag] 
         * @param {GetAllTasksTaskPriorityEnum} [taskPriority] 
         * @param {boolean} [providerTask] 
         * @param {string} [patient] 
         * @param {string} [assignTo] 
         * @param {string} [assignBy] 
         * @param {boolean} [myTask] 
         * @param {boolean} [toDoTask] 
         * @param {boolean} [archive] 
         * @param {string} [dueDate] 
         * @param {GetAllTasksTaskStatusEnum} [taskStatus] 
         * @param {string} [searchString] 
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {string} [appointmentId] 
         * @param {string} [actionType] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllTasks(page?: number, size?: number, sortBy?: string, sort?: string, active?: boolean, flag?: GetAllTasksFlagEnum, taskPriority?: GetAllTasksTaskPriorityEnum, providerTask?: boolean, patient?: string, assignTo?: string, assignBy?: string, myTask?: boolean, toDoTask?: boolean, archive?: boolean, dueDate?: string, taskStatus?: GetAllTasksTaskStatusEnum, searchString?: string, startDate?: string, endDate?: string, appointmentId?: string, actionType?: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllTasks(page, size, sortBy, sort, active, flag, taskPriority, providerTask, patient, assignTo, assignBy, myTask, toDoTask, archive, dueDate, taskStatus, searchString, startDate, endDate, appointmentId, actionType, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TaskControllerApi.getAllTasks']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get all Task records with patient UUID filter and search (excludes patient name from search). Supports sorting by: due_date, task_priority, task_title, created_date, etc.
         * @summary Get Filtered Tasks
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sort] 
         * @param {boolean} [active] 
         * @param {GetFilteredTasksFlagEnum} [flag] 
         * @param {GetFilteredTasksTaskPriorityEnum} [taskPriority] 
         * @param {boolean} [providerTask] 
         * @param {string} [patient] 
         * @param {string} [assignTo] 
         * @param {string} [assignBy] 
         * @param {boolean} [myTask] 
         * @param {boolean} [toDoTask] 
         * @param {boolean} [archive] 
         * @param {string} [dueDate] 
         * @param {GetFilteredTasksTaskStatusEnum} [taskStatus] 
         * @param {string} [searchString] 
         * @param {string} [appointmentId] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFilteredTasks(page?: number, size?: number, sortBy?: string, sort?: string, active?: boolean, flag?: GetFilteredTasksFlagEnum, taskPriority?: GetFilteredTasksTaskPriorityEnum, providerTask?: boolean, patient?: string, assignTo?: string, assignBy?: string, myTask?: boolean, toDoTask?: boolean, archive?: boolean, dueDate?: string, taskStatus?: GetFilteredTasksTaskStatusEnum, searchString?: string, appointmentId?: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFilteredTasks(page, size, sortBy, sort, active, flag, taskPriority, providerTask, patient, assignTo, assignBy, myTask, toDoTask, archive, dueDate, taskStatus, searchString, appointmentId, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TaskControllerApi.getFilteredTasks']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Lightweight, patient-centric task list for patient portal. Requires patient UUID. Returns: uuid, taskTitle, dueDate, priority, description, assignedBy, taskStatus. toDoTask=true filters by status TO_DO/OVERDUE.
         * @summary Get Patient Portal Tasks
         * @param {string} patient 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sort] 
         * @param {boolean} [toDoTask] 
         * @param {boolean} [archive] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPatientPortalTasks(patient: string, page?: number, size?: number, sortBy?: string, sort?: string, toDoTask?: boolean, archive?: boolean, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPatientPortalTasks(patient, page, size, sortBy, sort, toDoTask, archive, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TaskControllerApi.getPatientPortalTasks']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve a Task record by its unique ID
         * @summary Get Task by ID
         * @param {string} taskUuid 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTaskById(taskUuid: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTaskById(taskUuid, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TaskControllerApi.getTaskById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTodayTasks(xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTodayTasks(xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TaskControllerApi.getTodayTasks']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Resolve a task by task ID without requiring the caller to be the assignee. Use for patient portal or system-initiated resolution.
         * @summary Resolve Task by ID
         * @param {BulkReassigned} bulkReassigned 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resolveTaskByTaskId(bulkReassigned: BulkReassigned, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resolveTaskByTaskId(bulkReassigned, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TaskControllerApi.resolveTaskByTaskId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Resolved a Task by its ID. Caller must be the assigned provider.
         * @summary Resolved Task
         * @param {BulkReassigned} bulkReassigned 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resolvedTasks(bulkReassigned: BulkReassigned, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resolvedTasks(bulkReassigned, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TaskControllerApi.resolvedTasks']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Reviewed a Task by its ID
         * @summary Reviewed Task
         * @param {TaskReviewed} taskReviewed 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reviewTask(taskReviewed: TaskReviewed, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reviewTask(taskReviewed, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TaskControllerApi.reviewTask']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Re-assigned a Task by its ID
         * @summary ReAssigned  Task
         * @param {BulkReassigned} bulkReassigned 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async taskReassignTasks(bulkReassigned: BulkReassigned, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.taskReassignTasks(bulkReassigned, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TaskControllerApi.taskReassignTasks']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update an existing Task record
         * @summary Update Task
         * @param {Task} task 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateTask(task: Task, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateTask(task, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TaskControllerApi.updateTask']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Archive a Task record by its ID
         * @summary Archive Task
         * @param {string} taskId 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateTaskArchiveStatus(taskId: string, status: boolean, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateTaskArchiveStatus(taskId, status, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TaskControllerApi.updateTaskArchiveStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update the status of a Task record by its ID
         * @summary Update Task Status
         * @param {string} taskId 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateTaskStatus(taskId: string, status: boolean, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateTaskStatus(taskId, status, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TaskControllerApi.updateTaskStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * TaskControllerApi - factory interface
 * @export
 */
export const TaskControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TaskControllerApiFp(configuration)
    return {
        /**
         * Acknowledged a Task by its ID
         * @summary Acknowledged Task
         * @param {string} taskId 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        acknowledgedTasks(taskId: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.acknowledgedTasks(taskId, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Canceled a Task by its ID
         * @summary Canceled Task
         * @param {BulkCancel} bulkCancel 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelTasks(bulkCancel: BulkCancel, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.cancelTasks(bulkCancel, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Add a new Task record into the system
         * @summary Add Task
         * @param {Task} task 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTask(task: Task, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.createTask(task, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all Task records with search and filter options. Supports sorting by: patientName (alphabetical), dueDate (chronological), priority (High → Medium → Low), createdDate (chronological), updatedDate (chronological), title, description, active, archive, taskStatus.
         * @summary Get Tasks
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sort] 
         * @param {boolean} [active] 
         * @param {GetAllTasksFlagEnum} [flag] 
         * @param {GetAllTasksTaskPriorityEnum} [taskPriority] 
         * @param {boolean} [providerTask] 
         * @param {string} [patient] 
         * @param {string} [assignTo] 
         * @param {string} [assignBy] 
         * @param {boolean} [myTask] 
         * @param {boolean} [toDoTask] 
         * @param {boolean} [archive] 
         * @param {string} [dueDate] 
         * @param {GetAllTasksTaskStatusEnum} [taskStatus] 
         * @param {string} [searchString] 
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {string} [appointmentId] 
         * @param {string} [actionType] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllTasks(page?: number, size?: number, sortBy?: string, sort?: string, active?: boolean, flag?: GetAllTasksFlagEnum, taskPriority?: GetAllTasksTaskPriorityEnum, providerTask?: boolean, patient?: string, assignTo?: string, assignBy?: string, myTask?: boolean, toDoTask?: boolean, archive?: boolean, dueDate?: string, taskStatus?: GetAllTasksTaskStatusEnum, searchString?: string, startDate?: string, endDate?: string, appointmentId?: string, actionType?: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getAllTasks(page, size, sortBy, sort, active, flag, taskPriority, providerTask, patient, assignTo, assignBy, myTask, toDoTask, archive, dueDate, taskStatus, searchString, startDate, endDate, appointmentId, actionType, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all Task records with patient UUID filter and search (excludes patient name from search). Supports sorting by: due_date, task_priority, task_title, created_date, etc.
         * @summary Get Filtered Tasks
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sort] 
         * @param {boolean} [active] 
         * @param {GetFilteredTasksFlagEnum} [flag] 
         * @param {GetFilteredTasksTaskPriorityEnum} [taskPriority] 
         * @param {boolean} [providerTask] 
         * @param {string} [patient] 
         * @param {string} [assignTo] 
         * @param {string} [assignBy] 
         * @param {boolean} [myTask] 
         * @param {boolean} [toDoTask] 
         * @param {boolean} [archive] 
         * @param {string} [dueDate] 
         * @param {GetFilteredTasksTaskStatusEnum} [taskStatus] 
         * @param {string} [searchString] 
         * @param {string} [appointmentId] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFilteredTasks(page?: number, size?: number, sortBy?: string, sort?: string, active?: boolean, flag?: GetFilteredTasksFlagEnum, taskPriority?: GetFilteredTasksTaskPriorityEnum, providerTask?: boolean, patient?: string, assignTo?: string, assignBy?: string, myTask?: boolean, toDoTask?: boolean, archive?: boolean, dueDate?: string, taskStatus?: GetFilteredTasksTaskStatusEnum, searchString?: string, appointmentId?: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getFilteredTasks(page, size, sortBy, sort, active, flag, taskPriority, providerTask, patient, assignTo, assignBy, myTask, toDoTask, archive, dueDate, taskStatus, searchString, appointmentId, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Lightweight, patient-centric task list for patient portal. Requires patient UUID. Returns: uuid, taskTitle, dueDate, priority, description, assignedBy, taskStatus. toDoTask=true filters by status TO_DO/OVERDUE.
         * @summary Get Patient Portal Tasks
         * @param {string} patient 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sort] 
         * @param {boolean} [toDoTask] 
         * @param {boolean} [archive] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatientPortalTasks(patient: string, page?: number, size?: number, sortBy?: string, sort?: string, toDoTask?: boolean, archive?: boolean, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getPatientPortalTasks(patient, page, size, sortBy, sort, toDoTask, archive, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve a Task record by its unique ID
         * @summary Get Task by ID
         * @param {string} taskUuid 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTaskById(taskUuid: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getTaskById(taskUuid, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTodayTasks(xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getTodayTasks(xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Resolve a task by task ID without requiring the caller to be the assignee. Use for patient portal or system-initiated resolution.
         * @summary Resolve Task by ID
         * @param {BulkReassigned} bulkReassigned 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resolveTaskByTaskId(bulkReassigned: BulkReassigned, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.resolveTaskByTaskId(bulkReassigned, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Resolved a Task by its ID. Caller must be the assigned provider.
         * @summary Resolved Task
         * @param {BulkReassigned} bulkReassigned 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resolvedTasks(bulkReassigned: BulkReassigned, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.resolvedTasks(bulkReassigned, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Reviewed a Task by its ID
         * @summary Reviewed Task
         * @param {TaskReviewed} taskReviewed 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reviewTask(taskReviewed: TaskReviewed, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.reviewTask(taskReviewed, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Re-assigned a Task by its ID
         * @summary ReAssigned  Task
         * @param {BulkReassigned} bulkReassigned 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        taskReassignTasks(bulkReassigned: BulkReassigned, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.taskReassignTasks(bulkReassigned, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Update an existing Task record
         * @summary Update Task
         * @param {Task} task 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTask(task: Task, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.updateTask(task, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Archive a Task record by its ID
         * @summary Archive Task
         * @param {string} taskId 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTaskArchiveStatus(taskId: string, status: boolean, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.updateTaskArchiveStatus(taskId, status, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Update the status of a Task record by its ID
         * @summary Update Task Status
         * @param {string} taskId 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTaskStatus(taskId: string, status: boolean, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.updateTaskStatus(taskId, status, xTENANTID, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TaskControllerApi - object-oriented interface
 * @export
 * @class TaskControllerApi
 * @extends {BaseAPI}
 */
export class TaskControllerApi extends BaseAPI {
    /**
     * Acknowledged a Task by its ID
     * @summary Acknowledged Task
     * @param {string} taskId 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TaskControllerApi
     */
    public acknowledgedTasks(taskId: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return TaskControllerApiFp(this.configuration).acknowledgedTasks(taskId, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Canceled a Task by its ID
     * @summary Canceled Task
     * @param {BulkCancel} bulkCancel 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TaskControllerApi
     */
    public cancelTasks(bulkCancel: BulkCancel, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return TaskControllerApiFp(this.configuration).cancelTasks(bulkCancel, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Add a new Task record into the system
     * @summary Add Task
     * @param {Task} task 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TaskControllerApi
     */
    public createTask(task: Task, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return TaskControllerApiFp(this.configuration).createTask(task, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all Task records with search and filter options. Supports sorting by: patientName (alphabetical), dueDate (chronological), priority (High → Medium → Low), createdDate (chronological), updatedDate (chronological), title, description, active, archive, taskStatus.
     * @summary Get Tasks
     * @param {number} [page] 
     * @param {number} [size] 
     * @param {string} [sortBy] 
     * @param {string} [sort] 
     * @param {boolean} [active] 
     * @param {GetAllTasksFlagEnum} [flag] 
     * @param {GetAllTasksTaskPriorityEnum} [taskPriority] 
     * @param {boolean} [providerTask] 
     * @param {string} [patient] 
     * @param {string} [assignTo] 
     * @param {string} [assignBy] 
     * @param {boolean} [myTask] 
     * @param {boolean} [toDoTask] 
     * @param {boolean} [archive] 
     * @param {string} [dueDate] 
     * @param {GetAllTasksTaskStatusEnum} [taskStatus] 
     * @param {string} [searchString] 
     * @param {string} [startDate] 
     * @param {string} [endDate] 
     * @param {string} [appointmentId] 
     * @param {string} [actionType] 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TaskControllerApi
     */
    public getAllTasks(page?: number, size?: number, sortBy?: string, sort?: string, active?: boolean, flag?: GetAllTasksFlagEnum, taskPriority?: GetAllTasksTaskPriorityEnum, providerTask?: boolean, patient?: string, assignTo?: string, assignBy?: string, myTask?: boolean, toDoTask?: boolean, archive?: boolean, dueDate?: string, taskStatus?: GetAllTasksTaskStatusEnum, searchString?: string, startDate?: string, endDate?: string, appointmentId?: string, actionType?: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return TaskControllerApiFp(this.configuration).getAllTasks(page, size, sortBy, sort, active, flag, taskPriority, providerTask, patient, assignTo, assignBy, myTask, toDoTask, archive, dueDate, taskStatus, searchString, startDate, endDate, appointmentId, actionType, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all Task records with patient UUID filter and search (excludes patient name from search). Supports sorting by: due_date, task_priority, task_title, created_date, etc.
     * @summary Get Filtered Tasks
     * @param {number} [page] 
     * @param {number} [size] 
     * @param {string} [sortBy] 
     * @param {string} [sort] 
     * @param {boolean} [active] 
     * @param {GetFilteredTasksFlagEnum} [flag] 
     * @param {GetFilteredTasksTaskPriorityEnum} [taskPriority] 
     * @param {boolean} [providerTask] 
     * @param {string} [patient] 
     * @param {string} [assignTo] 
     * @param {string} [assignBy] 
     * @param {boolean} [myTask] 
     * @param {boolean} [toDoTask] 
     * @param {boolean} [archive] 
     * @param {string} [dueDate] 
     * @param {GetFilteredTasksTaskStatusEnum} [taskStatus] 
     * @param {string} [searchString] 
     * @param {string} [appointmentId] 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TaskControllerApi
     */
    public getFilteredTasks(page?: number, size?: number, sortBy?: string, sort?: string, active?: boolean, flag?: GetFilteredTasksFlagEnum, taskPriority?: GetFilteredTasksTaskPriorityEnum, providerTask?: boolean, patient?: string, assignTo?: string, assignBy?: string, myTask?: boolean, toDoTask?: boolean, archive?: boolean, dueDate?: string, taskStatus?: GetFilteredTasksTaskStatusEnum, searchString?: string, appointmentId?: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return TaskControllerApiFp(this.configuration).getFilteredTasks(page, size, sortBy, sort, active, flag, taskPriority, providerTask, patient, assignTo, assignBy, myTask, toDoTask, archive, dueDate, taskStatus, searchString, appointmentId, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Lightweight, patient-centric task list for patient portal. Requires patient UUID. Returns: uuid, taskTitle, dueDate, priority, description, assignedBy, taskStatus. toDoTask=true filters by status TO_DO/OVERDUE.
     * @summary Get Patient Portal Tasks
     * @param {string} patient 
     * @param {number} [page] 
     * @param {number} [size] 
     * @param {string} [sortBy] 
     * @param {string} [sort] 
     * @param {boolean} [toDoTask] 
     * @param {boolean} [archive] 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TaskControllerApi
     */
    public getPatientPortalTasks(patient: string, page?: number, size?: number, sortBy?: string, sort?: string, toDoTask?: boolean, archive?: boolean, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return TaskControllerApiFp(this.configuration).getPatientPortalTasks(patient, page, size, sortBy, sort, toDoTask, archive, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve a Task record by its unique ID
     * @summary Get Task by ID
     * @param {string} taskUuid 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TaskControllerApi
     */
    public getTaskById(taskUuid: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return TaskControllerApiFp(this.configuration).getTaskById(taskUuid, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TaskControllerApi
     */
    public getTodayTasks(xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return TaskControllerApiFp(this.configuration).getTodayTasks(xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Resolve a task by task ID without requiring the caller to be the assignee. Use for patient portal or system-initiated resolution.
     * @summary Resolve Task by ID
     * @param {BulkReassigned} bulkReassigned 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TaskControllerApi
     */
    public resolveTaskByTaskId(bulkReassigned: BulkReassigned, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return TaskControllerApiFp(this.configuration).resolveTaskByTaskId(bulkReassigned, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Resolved a Task by its ID. Caller must be the assigned provider.
     * @summary Resolved Task
     * @param {BulkReassigned} bulkReassigned 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TaskControllerApi
     */
    public resolvedTasks(bulkReassigned: BulkReassigned, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return TaskControllerApiFp(this.configuration).resolvedTasks(bulkReassigned, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Reviewed a Task by its ID
     * @summary Reviewed Task
     * @param {TaskReviewed} taskReviewed 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TaskControllerApi
     */
    public reviewTask(taskReviewed: TaskReviewed, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return TaskControllerApiFp(this.configuration).reviewTask(taskReviewed, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Re-assigned a Task by its ID
     * @summary ReAssigned  Task
     * @param {BulkReassigned} bulkReassigned 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TaskControllerApi
     */
    public taskReassignTasks(bulkReassigned: BulkReassigned, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return TaskControllerApiFp(this.configuration).taskReassignTasks(bulkReassigned, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update an existing Task record
     * @summary Update Task
     * @param {Task} task 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TaskControllerApi
     */
    public updateTask(task: Task, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return TaskControllerApiFp(this.configuration).updateTask(task, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Archive a Task record by its ID
     * @summary Archive Task
     * @param {string} taskId 
     * @param {boolean} status 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TaskControllerApi
     */
    public updateTaskArchiveStatus(taskId: string, status: boolean, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return TaskControllerApiFp(this.configuration).updateTaskArchiveStatus(taskId, status, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update the status of a Task record by its ID
     * @summary Update Task Status
     * @param {string} taskId 
     * @param {boolean} status 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TaskControllerApi
     */
    public updateTaskStatus(taskId: string, status: boolean, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return TaskControllerApiFp(this.configuration).updateTaskStatus(taskId, status, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const GetAllTasksFlagEnum = {
    Pending: 'PENDING',
    Completed: 'COMPLETED',
    Overdue: 'OVERDUE',
    Acknowledged: 'ACKNOWLEDGED'
} as const;
export type GetAllTasksFlagEnum = typeof GetAllTasksFlagEnum[keyof typeof GetAllTasksFlagEnum];
/**
 * @export
 */
export const GetAllTasksTaskPriorityEnum = {
    High: 'HIGH',
    Low: 'LOW',
    Medium: 'MEDIUM'
} as const;
export type GetAllTasksTaskPriorityEnum = typeof GetAllTasksTaskPriorityEnum[keyof typeof GetAllTasksTaskPriorityEnum];
/**
 * @export
 */
export const GetAllTasksTaskStatusEnum = {
    Resolved: 'RESOLVED',
    ToDo: 'TO_DO',
    Overdue: 'OVERDUE'
} as const;
export type GetAllTasksTaskStatusEnum = typeof GetAllTasksTaskStatusEnum[keyof typeof GetAllTasksTaskStatusEnum];
/**
 * @export
 */
export const GetFilteredTasksFlagEnum = {
    Pending: 'PENDING',
    Completed: 'COMPLETED',
    Overdue: 'OVERDUE',
    Acknowledged: 'ACKNOWLEDGED'
} as const;
export type GetFilteredTasksFlagEnum = typeof GetFilteredTasksFlagEnum[keyof typeof GetFilteredTasksFlagEnum];
/**
 * @export
 */
export const GetFilteredTasksTaskPriorityEnum = {
    High: 'HIGH',
    Low: 'LOW',
    Medium: 'MEDIUM'
} as const;
export type GetFilteredTasksTaskPriorityEnum = typeof GetFilteredTasksTaskPriorityEnum[keyof typeof GetFilteredTasksTaskPriorityEnum];
/**
 * @export
 */
export const GetFilteredTasksTaskStatusEnum = {
    Resolved: 'RESOLVED',
    ToDo: 'TO_DO',
    Overdue: 'OVERDUE'
} as const;
export type GetFilteredTasksTaskStatusEnum = typeof GetFilteredTasksTaskStatusEnum[keyof typeof GetFilteredTasksTaskStatusEnum];


/**
 * TaskTitleControllerApi - axios parameter creator
 * @export
 */
export const TaskTitleControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Add a new Task Title into the system.
         * @summary Add Task Title
         * @param {TaskTitle} taskTitle 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTaskTitle: async (taskTitle: TaskTitle, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'taskTitle' is not null or undefined
            assertParamExists('createTaskTitle', 'taskTitle', taskTitle)
            const localVarPath = `/api/master/task-title`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(taskTitle, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all Task Title list for super admin with search option on name, deptId and filter options on active, archive.
         * @summary Get all Task Title.
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {boolean} [status] 
         * @param {boolean} [archive] 
         * @param {string} [searchString] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllDepartments: async (page?: number, size?: number, sortBy?: string, sortDirection?: string, status?: boolean, archive?: boolean, searchString?: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/master/task-title`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (archive !== undefined) {
                localVarQueryParameter['archive'] = archive;
            }

            if (searchString !== undefined) {
                localVarQueryParameter['searchString'] = searchString;
            }

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TaskTitleControllerApi - functional programming interface
 * @export
 */
export const TaskTitleControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TaskTitleControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * Add a new Task Title into the system.
         * @summary Add Task Title
         * @param {TaskTitle} taskTitle 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createTaskTitle(taskTitle: TaskTitle, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createTaskTitle(taskTitle, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TaskTitleControllerApi.createTaskTitle']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get all Task Title list for super admin with search option on name, deptId and filter options on active, archive.
         * @summary Get all Task Title.
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {boolean} [status] 
         * @param {boolean} [archive] 
         * @param {string} [searchString] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllDepartments(page?: number, size?: number, sortBy?: string, sortDirection?: string, status?: boolean, archive?: boolean, searchString?: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllDepartments(page, size, sortBy, sortDirection, status, archive, searchString, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TaskTitleControllerApi.getAllDepartments']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * TaskTitleControllerApi - factory interface
 * @export
 */
export const TaskTitleControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TaskTitleControllerApiFp(configuration)
    return {
        /**
         * Add a new Task Title into the system.
         * @summary Add Task Title
         * @param {TaskTitle} taskTitle 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTaskTitle(taskTitle: TaskTitle, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.createTaskTitle(taskTitle, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all Task Title list for super admin with search option on name, deptId and filter options on active, archive.
         * @summary Get all Task Title.
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {boolean} [status] 
         * @param {boolean} [archive] 
         * @param {string} [searchString] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllDepartments(page?: number, size?: number, sortBy?: string, sortDirection?: string, status?: boolean, archive?: boolean, searchString?: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getAllDepartments(page, size, sortBy, sortDirection, status, archive, searchString, xTENANTID, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TaskTitleControllerApi - object-oriented interface
 * @export
 * @class TaskTitleControllerApi
 * @extends {BaseAPI}
 */
export class TaskTitleControllerApi extends BaseAPI {
    /**
     * Add a new Task Title into the system.
     * @summary Add Task Title
     * @param {TaskTitle} taskTitle 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TaskTitleControllerApi
     */
    public createTaskTitle(taskTitle: TaskTitle, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return TaskTitleControllerApiFp(this.configuration).createTaskTitle(taskTitle, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all Task Title list for super admin with search option on name, deptId and filter options on active, archive.
     * @summary Get all Task Title.
     * @param {number} [page] 
     * @param {number} [size] 
     * @param {string} [sortBy] 
     * @param {string} [sortDirection] 
     * @param {boolean} [status] 
     * @param {boolean} [archive] 
     * @param {string} [searchString] 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TaskTitleControllerApi
     */
    public getAllDepartments(page?: number, size?: number, sortBy?: string, sortDirection?: string, status?: boolean, archive?: boolean, searchString?: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return TaskTitleControllerApiFp(this.configuration).getAllDepartments(page, size, sortBy, sortDirection, status, archive, searchString, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * TaskTypeControllerApi - axios parameter creator
 * @export
 */
export const TaskTypeControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Add a new Task Type into the system
         * @summary Add New Task Type
         * @param {TaskType} taskType 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addNewTaskType: async (taskType: TaskType, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'taskType' is not null or undefined
            assertParamExists('addNewTaskType', 'taskType', taskType)
            const localVarPath = `/api/master/task-type/user`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(taskType, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all Task Type list
         * @summary Get all  Task Type
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sort] 
         * @param {string} [searchString] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllTaskType: async (page?: number, size?: number, sortBy?: string, sort?: string, searchString?: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/master/task-type`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (searchString !== undefined) {
                localVarQueryParameter['searchString'] = searchString;
            }

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TaskTypeControllerApi - functional programming interface
 * @export
 */
export const TaskTypeControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TaskTypeControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * Add a new Task Type into the system
         * @summary Add New Task Type
         * @param {TaskType} taskType 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addNewTaskType(taskType: TaskType, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addNewTaskType(taskType, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TaskTypeControllerApi.addNewTaskType']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get all Task Type list
         * @summary Get all  Task Type
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sort] 
         * @param {string} [searchString] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllTaskType(page?: number, size?: number, sortBy?: string, sort?: string, searchString?: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllTaskType(page, size, sortBy, sort, searchString, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TaskTypeControllerApi.getAllTaskType']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * TaskTypeControllerApi - factory interface
 * @export
 */
export const TaskTypeControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TaskTypeControllerApiFp(configuration)
    return {
        /**
         * Add a new Task Type into the system
         * @summary Add New Task Type
         * @param {TaskType} taskType 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addNewTaskType(taskType: TaskType, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.addNewTaskType(taskType, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all Task Type list
         * @summary Get all  Task Type
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sort] 
         * @param {string} [searchString] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllTaskType(page?: number, size?: number, sortBy?: string, sort?: string, searchString?: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getAllTaskType(page, size, sortBy, sort, searchString, xTENANTID, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TaskTypeControllerApi - object-oriented interface
 * @export
 * @class TaskTypeControllerApi
 * @extends {BaseAPI}
 */
export class TaskTypeControllerApi extends BaseAPI {
    /**
     * Add a new Task Type into the system
     * @summary Add New Task Type
     * @param {TaskType} taskType 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TaskTypeControllerApi
     */
    public addNewTaskType(taskType: TaskType, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return TaskTypeControllerApiFp(this.configuration).addNewTaskType(taskType, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all Task Type list
     * @summary Get all  Task Type
     * @param {number} [page] 
     * @param {number} [size] 
     * @param {string} [sortBy] 
     * @param {string} [sort] 
     * @param {string} [searchString] 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TaskTypeControllerApi
     */
    public getAllTaskType(page?: number, size?: number, sortBy?: string, sort?: string, searchString?: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return TaskTypeControllerApiFp(this.configuration).getAllTaskType(page, size, sortBy, sort, searchString, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * TenantConfigurationControllerApi - axios parameter creator
 * @export
 */
export const TenantConfigurationControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Creates a new tenant configuration and returns the created entity.
         * @summary Create a new tenant configuration
         * @param {TenantConfiguration} tenantConfiguration 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTenantConfiguration: async (tenantConfiguration: TenantConfiguration, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantConfiguration' is not null or undefined
            assertParamExists('createTenantConfiguration', 'tenantConfiguration', tenantConfiguration)
            const localVarPath = `/api/master/tenant-configuration`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(tenantConfiguration, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves a tenant configuration by its tenantConfigurationId.
         * @summary Get tenant configuration by tenantConfigurationId
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTenantConfiguration: async (xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/master/tenant-configuration`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Updates the entire tenant configuration based on provided data.
         * @summary Update tenant configuration
         * @param {TenantConfiguration} tenantConfiguration 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTenantConfiguration: async (tenantConfiguration: TenantConfiguration, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantConfiguration' is not null or undefined
            assertParamExists('updateTenantConfiguration', 'tenantConfiguration', tenantConfiguration)
            const localVarPath = `/api/master/tenant-configuration`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(tenantConfiguration, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TenantConfigurationControllerApi - functional programming interface
 * @export
 */
export const TenantConfigurationControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TenantConfigurationControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * Creates a new tenant configuration and returns the created entity.
         * @summary Create a new tenant configuration
         * @param {TenantConfiguration} tenantConfiguration 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createTenantConfiguration(tenantConfiguration: TenantConfiguration, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createTenantConfiguration(tenantConfiguration, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TenantConfigurationControllerApi.createTenantConfiguration']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves a tenant configuration by its tenantConfigurationId.
         * @summary Get tenant configuration by tenantConfigurationId
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTenantConfiguration(xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTenantConfiguration(xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TenantConfigurationControllerApi.getTenantConfiguration']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Updates the entire tenant configuration based on provided data.
         * @summary Update tenant configuration
         * @param {TenantConfiguration} tenantConfiguration 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateTenantConfiguration(tenantConfiguration: TenantConfiguration, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateTenantConfiguration(tenantConfiguration, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TenantConfigurationControllerApi.updateTenantConfiguration']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * TenantConfigurationControllerApi - factory interface
 * @export
 */
export const TenantConfigurationControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TenantConfigurationControllerApiFp(configuration)
    return {
        /**
         * Creates a new tenant configuration and returns the created entity.
         * @summary Create a new tenant configuration
         * @param {TenantConfiguration} tenantConfiguration 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTenantConfiguration(tenantConfiguration: TenantConfiguration, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.createTenantConfiguration(tenantConfiguration, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves a tenant configuration by its tenantConfigurationId.
         * @summary Get tenant configuration by tenantConfigurationId
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTenantConfiguration(xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getTenantConfiguration(xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates the entire tenant configuration based on provided data.
         * @summary Update tenant configuration
         * @param {TenantConfiguration} tenantConfiguration 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTenantConfiguration(tenantConfiguration: TenantConfiguration, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.updateTenantConfiguration(tenantConfiguration, xTENANTID, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TenantConfigurationControllerApi - object-oriented interface
 * @export
 * @class TenantConfigurationControllerApi
 * @extends {BaseAPI}
 */
export class TenantConfigurationControllerApi extends BaseAPI {
    /**
     * Creates a new tenant configuration and returns the created entity.
     * @summary Create a new tenant configuration
     * @param {TenantConfiguration} tenantConfiguration 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantConfigurationControllerApi
     */
    public createTenantConfiguration(tenantConfiguration: TenantConfiguration, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return TenantConfigurationControllerApiFp(this.configuration).createTenantConfiguration(tenantConfiguration, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves a tenant configuration by its tenantConfigurationId.
     * @summary Get tenant configuration by tenantConfigurationId
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantConfigurationControllerApi
     */
    public getTenantConfiguration(xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return TenantConfigurationControllerApiFp(this.configuration).getTenantConfiguration(xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Updates the entire tenant configuration based on provided data.
     * @summary Update tenant configuration
     * @param {TenantConfiguration} tenantConfiguration 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantConfigurationControllerApi
     */
    public updateTenantConfiguration(tenantConfiguration: TenantConfiguration, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return TenantConfigurationControllerApiFp(this.configuration).updateTenantConfiguration(tenantConfiguration, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * TicketControllerApi - axios parameter creator
 * @export
 */
export const TicketControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Create a new support ticket with optional attachments
         * @summary Raise a support ticket
         * @param {TicketCreateRequest} ticketCreateRequest 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        raiseTicket: async (ticketCreateRequest: TicketCreateRequest, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ticketCreateRequest' is not null or undefined
            assertParamExists('raiseTicket', 'ticketCreateRequest', ticketCreateRequest)
            const localVarPath = `/api/master/help-support/raise-ticket`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(ticketCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TicketControllerApi - functional programming interface
 * @export
 */
export const TicketControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TicketControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * Create a new support ticket with optional attachments
         * @summary Raise a support ticket
         * @param {TicketCreateRequest} ticketCreateRequest 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async raiseTicket(ticketCreateRequest: TicketCreateRequest, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.raiseTicket(ticketCreateRequest, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TicketControllerApi.raiseTicket']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * TicketControllerApi - factory interface
 * @export
 */
export const TicketControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TicketControllerApiFp(configuration)
    return {
        /**
         * Create a new support ticket with optional attachments
         * @summary Raise a support ticket
         * @param {TicketCreateRequest} ticketCreateRequest 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        raiseTicket(ticketCreateRequest: TicketCreateRequest, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.raiseTicket(ticketCreateRequest, xTENANTID, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TicketControllerApi - object-oriented interface
 * @export
 * @class TicketControllerApi
 * @extends {BaseAPI}
 */
export class TicketControllerApi extends BaseAPI {
    /**
     * Create a new support ticket with optional attachments
     * @summary Raise a support ticket
     * @param {TicketCreateRequest} ticketCreateRequest 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TicketControllerApi
     */
    public raiseTicket(ticketCreateRequest: TicketCreateRequest, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return TicketControllerApiFp(this.configuration).raiseTicket(ticketCreateRequest, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * TranscriptionControllerApi - axios parameter creator
 * @export
 */
export const TranscriptionControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {LanguageConversionRequest} languageConversionRequest 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        convertLanguage: async (languageConversionRequest: LanguageConversionRequest, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'languageConversionRequest' is not null or undefined
            assertParamExists('convertLanguage', 'languageConversionRequest', languageConversionRequest)
            const localVarPath = `/api/master/transcription/convert-language`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(languageConversionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Submit an electronic claim
         * @summary Submit electronic Claims
         * @param {CreateTranscriptionNoteTypeEnum} noteType 
         * @param {string} [xTENANTID] 
         * @param {CreateTranscriptionRequest} [createTranscriptionRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTranscription: async (noteType: CreateTranscriptionNoteTypeEnum, xTENANTID?: string, createTranscriptionRequest?: CreateTranscriptionRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'noteType' is not null or undefined
            assertParamExists('createTranscription', 'noteType', noteType)
            const localVarPath = `/api/master/transcription`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (noteType !== undefined) {
                localVarQueryParameter['noteType'] = noteType;
            }

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createTranscriptionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Generate a clinical note from transcription segments
         * @summary Generate note from transcription segments
         * @param {NoteGenerationRequest} noteGenerationRequest 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateNoteFromSegments: async (noteGenerationRequest: NoteGenerationRequest, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'noteGenerationRequest' is not null or undefined
            assertParamExists('generateNoteFromSegments', 'noteGenerationRequest', noteGenerationRequest)
            const localVarPath = `/api/master/transcription/generate-note-from-segments`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(noteGenerationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns the patient\'s existing chart data, plus the verbatim promptText handed to the model, so the clinician can see exactly what context is in use
         * @summary Get the patient context used by the scribe
         * @param {string} patientUuid 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatientScribeContext: async (patientUuid: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientUuid' is not null or undefined
            assertParamExists('getPatientScribeContext', 'patientUuid', patientUuid)
            const localVarPath = `/api/master/transcription/patient-context/{patientUuid}`
                .replace(`{${"patientUuid"}}`, encodeURIComponent(String(patientUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Splits the transcript into turns attributed to Speaker 1 (clinician) and Speaker 2 (patient)
         * @summary Label speakers in a transcript
         * @param {SpeakerLabelRequest} speakerLabelRequest 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        labelSpeakers: async (speakerLabelRequest: SpeakerLabelRequest, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'speakerLabelRequest' is not null or undefined
            assertParamExists('labelSpeakers', 'speakerLabelRequest', speakerLabelRequest)
            const localVarPath = `/api/master/transcription/label-speakers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(speakerLabelRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TranscriptionControllerApi - functional programming interface
 * @export
 */
export const TranscriptionControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TranscriptionControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {LanguageConversionRequest} languageConversionRequest 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async convertLanguage(languageConversionRequest: LanguageConversionRequest, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TranscriptionSegmentDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.convertLanguage(languageConversionRequest, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TranscriptionControllerApi.convertLanguage']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Submit an electronic claim
         * @summary Submit electronic Claims
         * @param {CreateTranscriptionNoteTypeEnum} noteType 
         * @param {string} [xTENANTID] 
         * @param {CreateTranscriptionRequest} [createTranscriptionRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createTranscription(noteType: CreateTranscriptionNoteTypeEnum, xTENANTID?: string, createTranscriptionRequest?: CreateTranscriptionRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createTranscription(noteType, xTENANTID, createTranscriptionRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TranscriptionControllerApi.createTranscription']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Generate a clinical note from transcription segments
         * @summary Generate note from transcription segments
         * @param {NoteGenerationRequest} noteGenerationRequest 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generateNoteFromSegments(noteGenerationRequest: NoteGenerationRequest, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generateNoteFromSegments(noteGenerationRequest, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TranscriptionControllerApi.generateNoteFromSegments']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns the patient\'s existing chart data, plus the verbatim promptText handed to the model, so the clinician can see exactly what context is in use
         * @summary Get the patient context used by the scribe
         * @param {string} patientUuid 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPatientScribeContext(patientUuid: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPatientScribeContext(patientUuid, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TranscriptionControllerApi.getPatientScribeContext']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Splits the transcript into turns attributed to Speaker 1 (clinician) and Speaker 2 (patient)
         * @summary Label speakers in a transcript
         * @param {SpeakerLabelRequest} speakerLabelRequest 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async labelSpeakers(speakerLabelRequest: SpeakerLabelRequest, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.labelSpeakers(speakerLabelRequest, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TranscriptionControllerApi.labelSpeakers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * TranscriptionControllerApi - factory interface
 * @export
 */
export const TranscriptionControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TranscriptionControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {LanguageConversionRequest} languageConversionRequest 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        convertLanguage(languageConversionRequest: LanguageConversionRequest, xTENANTID?: string, options?: any): AxiosPromise<Array<TranscriptionSegmentDTO>> {
            return localVarFp.convertLanguage(languageConversionRequest, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Submit an electronic claim
         * @summary Submit electronic Claims
         * @param {CreateTranscriptionNoteTypeEnum} noteType 
         * @param {string} [xTENANTID] 
         * @param {CreateTranscriptionRequest} [createTranscriptionRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTranscription(noteType: CreateTranscriptionNoteTypeEnum, xTENANTID?: string, createTranscriptionRequest?: CreateTranscriptionRequest, options?: any): AxiosPromise<Response> {
            return localVarFp.createTranscription(noteType, xTENANTID, createTranscriptionRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Generate a clinical note from transcription segments
         * @summary Generate note from transcription segments
         * @param {NoteGenerationRequest} noteGenerationRequest 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateNoteFromSegments(noteGenerationRequest: NoteGenerationRequest, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.generateNoteFromSegments(noteGenerationRequest, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns the patient\'s existing chart data, plus the verbatim promptText handed to the model, so the clinician can see exactly what context is in use
         * @summary Get the patient context used by the scribe
         * @param {string} patientUuid 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatientScribeContext(patientUuid: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getPatientScribeContext(patientUuid, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Splits the transcript into turns attributed to Speaker 1 (clinician) and Speaker 2 (patient)
         * @summary Label speakers in a transcript
         * @param {SpeakerLabelRequest} speakerLabelRequest 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        labelSpeakers(speakerLabelRequest: SpeakerLabelRequest, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.labelSpeakers(speakerLabelRequest, xTENANTID, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TranscriptionControllerApi - object-oriented interface
 * @export
 * @class TranscriptionControllerApi
 * @extends {BaseAPI}
 */
export class TranscriptionControllerApi extends BaseAPI {
    /**
     * 
     * @param {LanguageConversionRequest} languageConversionRequest 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TranscriptionControllerApi
     */
    public convertLanguage(languageConversionRequest: LanguageConversionRequest, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return TranscriptionControllerApiFp(this.configuration).convertLanguage(languageConversionRequest, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Submit an electronic claim
     * @summary Submit electronic Claims
     * @param {CreateTranscriptionNoteTypeEnum} noteType 
     * @param {string} [xTENANTID] 
     * @param {CreateTranscriptionRequest} [createTranscriptionRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TranscriptionControllerApi
     */
    public createTranscription(noteType: CreateTranscriptionNoteTypeEnum, xTENANTID?: string, createTranscriptionRequest?: CreateTranscriptionRequest, options?: RawAxiosRequestConfig) {
        return TranscriptionControllerApiFp(this.configuration).createTranscription(noteType, xTENANTID, createTranscriptionRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Generate a clinical note from transcription segments
     * @summary Generate note from transcription segments
     * @param {NoteGenerationRequest} noteGenerationRequest 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TranscriptionControllerApi
     */
    public generateNoteFromSegments(noteGenerationRequest: NoteGenerationRequest, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return TranscriptionControllerApiFp(this.configuration).generateNoteFromSegments(noteGenerationRequest, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns the patient\'s existing chart data, plus the verbatim promptText handed to the model, so the clinician can see exactly what context is in use
     * @summary Get the patient context used by the scribe
     * @param {string} patientUuid 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TranscriptionControllerApi
     */
    public getPatientScribeContext(patientUuid: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return TranscriptionControllerApiFp(this.configuration).getPatientScribeContext(patientUuid, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Splits the transcript into turns attributed to Speaker 1 (clinician) and Speaker 2 (patient)
     * @summary Label speakers in a transcript
     * @param {SpeakerLabelRequest} speakerLabelRequest 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TranscriptionControllerApi
     */
    public labelSpeakers(speakerLabelRequest: SpeakerLabelRequest, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return TranscriptionControllerApiFp(this.configuration).labelSpeakers(speakerLabelRequest, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const CreateTranscriptionNoteTypeEnum = {
    SimpleSoapNote: 'SIMPLE_SOAP_NOTE',
    PsychiatricNote: 'PSYCHIATRIC_NOTE',
    PrimaryCareSoapNote: 'PRIMARY_CARE_SOAP_NOTE',
    FreeSoapNote: 'FREE_SOAP_NOTE',
    TreatmentPlan: 'TREATMENT_PLAN',
    PsychiatricProgress: 'PSYCHIATRIC_PROGRESS',
    InitialPsychotherapy: 'INITIAL_PSYCHOTHERAPY',
    PsychiatricInitialVisitNote: 'PSYCHIATRIC_INITIAL_VISIT_NOTE',
    PreoperativeNote: 'PREOPERATIVE_NOTE',
    PsychodynamicTherapyNote: 'PSYCHODYNAMIC_THERAPY_NOTE',
    PsychotherapyNote: 'PSYCHOTHERAPY_NOTE',
    CollaborativeCareModel: 'COLLABORATIVE_CARE_MODEL',
    PsychoeducationTherapy: 'PSYCHOEDUCATION_THERAPY',
    DapNote: 'DAP_NOTE',
    BirpNote: 'BIRP_NOTE',
    ProgressNote: 'PROGRESS_NOTE',
    PremierMdInitialF2F: 'PREMIER_MD_INITIAL_F2F',
    PremierMdReadmissionF2F: 'PREMIER_MD_READMISSION_F2F',
    PremierMdRecertificationF2F: 'PREMIER_MD_RECERTIFICATION_F2F',
    PremierMdRocF2F: 'PREMIER_MD_ROC_F2F',
    PremierMdFollowUpF2F: 'PREMIER_MD_FOLLOW_UP_F2F',
    PremierMd30DayF2F: 'PREMIER_MD_30_DAY_F2F',
    PremierMdInitialTelehealth: 'PREMIER_MD_INITIAL_TELEHEALTH',
    PremierMdReadmissionTelehealth: 'PREMIER_MD_READMISSION_TELEHEALTH',
    PremierMdRecertificationTelehealth: 'PREMIER_MD_RECERTIFICATION_TELEHEALTH',
    PremierMdRocTelehealth: 'PREMIER_MD_ROC_TELEHEALTH',
    PremierMd30DayTelehealth: 'PREMIER_MD_30_DAY_TELEHEALTH',
    PremierMdCognitiveVisit: 'PREMIER_MD_COGNITIVE_VISIT',
    PremierMdLabsCommNote: 'PREMIER_MD_LABS_COMM_NOTE'
} as const;
export type CreateTranscriptionNoteTypeEnum = typeof CreateTranscriptionNoteTypeEnum[keyof typeof CreateTranscriptionNoteTypeEnum];


/**
 * TwilioVoiceControllerApi - axios parameter creator
 * @export
 */
export const TwilioVoiceControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Handle Twilio recording callbacks
         * @summary Twilio Recording Callback
         * @param {string} [userId] 
         * @param {string} [patientId] 
         * @param {string} [tenantName] 
         * @param {string} [scheduleId] 
         * @param {string} [callType] 
         * @param {string} [callTimeKey] 
         * @param {string} [calledBy] 
         * @param {string} [recordingUrl] 
         * @param {string} [recordingSid] 
         * @param {string} [recordingDuration] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        recordingCallback: async (userId?: string, patientId?: string, tenantName?: string, scheduleId?: string, callType?: string, callTimeKey?: string, calledBy?: string, recordingUrl?: string, recordingSid?: string, recordingDuration?: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/master/twilio/recording-callback`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (userId !== undefined) {
                localVarQueryParameter['user_id'] = userId;
            }

            if (patientId !== undefined) {
                localVarQueryParameter['patient_id'] = patientId;
            }

            if (tenantName !== undefined) {
                localVarQueryParameter['tenant_name'] = tenantName;
            }

            if (scheduleId !== undefined) {
                localVarQueryParameter['schedule_id'] = scheduleId;
            }

            if (callType !== undefined) {
                localVarQueryParameter['call_type'] = callType;
            }

            if (callTimeKey !== undefined) {
                localVarQueryParameter['call_time_key'] = callTimeKey;
            }

            if (calledBy !== undefined) {
                localVarQueryParameter['called_by'] = calledBy;
            }

            if (recordingUrl !== undefined) {
                localVarQueryParameter['RecordingUrl'] = recordingUrl;
            }

            if (recordingSid !== undefined) {
                localVarQueryParameter['RecordingSid'] = recordingSid;
            }

            if (recordingDuration !== undefined) {
                localVarQueryParameter['RecordingDuration'] = recordingDuration;
            }

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Handle Twilio voice callbacks and generate TwiML response
         * @summary Twilio Voice Callback
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {string} [callSid] 
         * @param {string} [callStatus] 
         * @param {string} [direction] 
         * @param {string} [accountSid] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        twilioVoice: async (from?: string, to?: string, callSid?: string, callStatus?: string, direction?: string, accountSid?: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/master/twilio/twilio-voice`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (from !== undefined) {
                localVarQueryParameter['From'] = from;
            }

            if (to !== undefined) {
                localVarQueryParameter['To'] = to;
            }

            if (callSid !== undefined) {
                localVarQueryParameter['CallSid'] = callSid;
            }

            if (callStatus !== undefined) {
                localVarQueryParameter['CallStatus'] = callStatus;
            }

            if (direction !== undefined) {
                localVarQueryParameter['Direction'] = direction;
            }

            if (accountSid !== undefined) {
                localVarQueryParameter['AccountSid'] = accountSid;
            }

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TwilioVoiceControllerApi - functional programming interface
 * @export
 */
export const TwilioVoiceControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TwilioVoiceControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * Handle Twilio recording callbacks
         * @summary Twilio Recording Callback
         * @param {string} [userId] 
         * @param {string} [patientId] 
         * @param {string} [tenantName] 
         * @param {string} [scheduleId] 
         * @param {string} [callType] 
         * @param {string} [callTimeKey] 
         * @param {string} [calledBy] 
         * @param {string} [recordingUrl] 
         * @param {string} [recordingSid] 
         * @param {string} [recordingDuration] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async recordingCallback(userId?: string, patientId?: string, tenantName?: string, scheduleId?: string, callType?: string, callTimeKey?: string, calledBy?: string, recordingUrl?: string, recordingSid?: string, recordingDuration?: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.recordingCallback(userId, patientId, tenantName, scheduleId, callType, callTimeKey, calledBy, recordingUrl, recordingSid, recordingDuration, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TwilioVoiceControllerApi.recordingCallback']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Handle Twilio voice callbacks and generate TwiML response
         * @summary Twilio Voice Callback
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {string} [callSid] 
         * @param {string} [callStatus] 
         * @param {string} [direction] 
         * @param {string} [accountSid] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async twilioVoice(from?: string, to?: string, callSid?: string, callStatus?: string, direction?: string, accountSid?: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.twilioVoice(from, to, callSid, callStatus, direction, accountSid, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TwilioVoiceControllerApi.twilioVoice']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * TwilioVoiceControllerApi - factory interface
 * @export
 */
export const TwilioVoiceControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TwilioVoiceControllerApiFp(configuration)
    return {
        /**
         * Handle Twilio recording callbacks
         * @summary Twilio Recording Callback
         * @param {string} [userId] 
         * @param {string} [patientId] 
         * @param {string} [tenantName] 
         * @param {string} [scheduleId] 
         * @param {string} [callType] 
         * @param {string} [callTimeKey] 
         * @param {string} [calledBy] 
         * @param {string} [recordingUrl] 
         * @param {string} [recordingSid] 
         * @param {string} [recordingDuration] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        recordingCallback(userId?: string, patientId?: string, tenantName?: string, scheduleId?: string, callType?: string, callTimeKey?: string, calledBy?: string, recordingUrl?: string, recordingSid?: string, recordingDuration?: string, xTENANTID?: string, options?: any): AxiosPromise<string> {
            return localVarFp.recordingCallback(userId, patientId, tenantName, scheduleId, callType, callTimeKey, calledBy, recordingUrl, recordingSid, recordingDuration, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Handle Twilio voice callbacks and generate TwiML response
         * @summary Twilio Voice Callback
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {string} [callSid] 
         * @param {string} [callStatus] 
         * @param {string} [direction] 
         * @param {string} [accountSid] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        twilioVoice(from?: string, to?: string, callSid?: string, callStatus?: string, direction?: string, accountSid?: string, xTENANTID?: string, options?: any): AxiosPromise<string> {
            return localVarFp.twilioVoice(from, to, callSid, callStatus, direction, accountSid, xTENANTID, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TwilioVoiceControllerApi - object-oriented interface
 * @export
 * @class TwilioVoiceControllerApi
 * @extends {BaseAPI}
 */
export class TwilioVoiceControllerApi extends BaseAPI {
    /**
     * Handle Twilio recording callbacks
     * @summary Twilio Recording Callback
     * @param {string} [userId] 
     * @param {string} [patientId] 
     * @param {string} [tenantName] 
     * @param {string} [scheduleId] 
     * @param {string} [callType] 
     * @param {string} [callTimeKey] 
     * @param {string} [calledBy] 
     * @param {string} [recordingUrl] 
     * @param {string} [recordingSid] 
     * @param {string} [recordingDuration] 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TwilioVoiceControllerApi
     */
    public recordingCallback(userId?: string, patientId?: string, tenantName?: string, scheduleId?: string, callType?: string, callTimeKey?: string, calledBy?: string, recordingUrl?: string, recordingSid?: string, recordingDuration?: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return TwilioVoiceControllerApiFp(this.configuration).recordingCallback(userId, patientId, tenantName, scheduleId, callType, callTimeKey, calledBy, recordingUrl, recordingSid, recordingDuration, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Handle Twilio voice callbacks and generate TwiML response
     * @summary Twilio Voice Callback
     * @param {string} [from] 
     * @param {string} [to] 
     * @param {string} [callSid] 
     * @param {string} [callStatus] 
     * @param {string} [direction] 
     * @param {string} [accountSid] 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TwilioVoiceControllerApi
     */
    public twilioVoice(from?: string, to?: string, callSid?: string, callStatus?: string, direction?: string, accountSid?: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return TwilioVoiceControllerApiFp(this.configuration).twilioVoice(from, to, callSid, callStatus, direction, accountSid, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * TwoFactorAuthenticationApi - axios parameter creator
 * @export
 */
export const TwoFactorAuthenticationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Disable 2FA (both Google Authenticator and Email OTP) using provider email and password. Clears all 2FA data.
         * @summary Disable 2FA for provider
         * @param {string} email Provider email
         * @param {string} password Provider password for confirmation
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        disable2FA: async (email: string, password: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'email' is not null or undefined
            assertParamExists('disable2FA', 'email', email)
            // verify required parameter 'password' is not null or undefined
            assertParamExists('disable2FA', 'password', password)
            const localVarPath = `/api/master/2fa/disable`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }

            if (password !== undefined) {
                localVarQueryParameter['password'] = password;
            }

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Send verification code via email for providers using email-based 2FA during login flow. Only works if provider has email OTP enabled.
         * @summary Send Email OTP for login
         * @param {SendEmailOtpRequest} sendEmailOtpRequest 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendEmailOtp: async (sendEmailOtpRequest: SendEmailOtpRequest, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sendEmailOtpRequest' is not null or undefined
            assertParamExists('sendEmailOtp', 'sendEmailOtpRequest', sendEmailOtpRequest)
            const localVarPath = `/api/master/2fa/send-otp`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(sendEmailOtpRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Setup 2FA for a provider. Choose between Google Authenticator (returns QR code) or Email OTP (confirmation message). Provider can only have one authentication method at a time.
         * @summary Setup 2FA for provider
         * @param {Setup2FARequest} setup2FARequest 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setup2FA: async (setup2FARequest: Setup2FARequest, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'setup2FARequest' is not null or undefined
            assertParamExists('setup2FA', 'setup2FARequest', setup2FARequest)
            const localVarPath = `/api/master/2fa/setup`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(setup2FARequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Verify a code from Google Authenticator or Email OTP using provider email. During setup (isLogin=false), automatically enables 2FA if code is valid. During login (isLogin=true), just verifies the code.
         * @summary Verify 2FA code and enable if setup
         * @param {Verify2FARequest} verify2FARequest 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verify2FA: async (verify2FARequest: Verify2FARequest, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'verify2FARequest' is not null or undefined
            assertParamExists('verify2FA', 'verify2FARequest', verify2FARequest)
            const localVarPath = `/api/master/2fa/verify`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(verify2FARequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TwoFactorAuthenticationApi - functional programming interface
 * @export
 */
export const TwoFactorAuthenticationApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TwoFactorAuthenticationApiAxiosParamCreator(configuration)
    return {
        /**
         * Disable 2FA (both Google Authenticator and Email OTP) using provider email and password. Clears all 2FA data.
         * @summary Disable 2FA for provider
         * @param {string} email Provider email
         * @param {string} password Provider password for confirmation
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async disable2FA(email: string, password: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.disable2FA(email, password, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TwoFactorAuthenticationApi.disable2FA']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Send verification code via email for providers using email-based 2FA during login flow. Only works if provider has email OTP enabled.
         * @summary Send Email OTP for login
         * @param {SendEmailOtpRequest} sendEmailOtpRequest 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendEmailOtp(sendEmailOtpRequest: SendEmailOtpRequest, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendEmailOtp(sendEmailOtpRequest, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TwoFactorAuthenticationApi.sendEmailOtp']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Setup 2FA for a provider. Choose between Google Authenticator (returns QR code) or Email OTP (confirmation message). Provider can only have one authentication method at a time.
         * @summary Setup 2FA for provider
         * @param {Setup2FARequest} setup2FARequest 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setup2FA(setup2FARequest: Setup2FARequest, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setup2FA(setup2FARequest, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TwoFactorAuthenticationApi.setup2FA']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Verify a code from Google Authenticator or Email OTP using provider email. During setup (isLogin=false), automatically enables 2FA if code is valid. During login (isLogin=true), just verifies the code.
         * @summary Verify 2FA code and enable if setup
         * @param {Verify2FARequest} verify2FARequest 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async verify2FA(verify2FARequest: Verify2FARequest, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.verify2FA(verify2FARequest, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TwoFactorAuthenticationApi.verify2FA']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * TwoFactorAuthenticationApi - factory interface
 * @export
 */
export const TwoFactorAuthenticationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TwoFactorAuthenticationApiFp(configuration)
    return {
        /**
         * Disable 2FA (both Google Authenticator and Email OTP) using provider email and password. Clears all 2FA data.
         * @summary Disable 2FA for provider
         * @param {string} email Provider email
         * @param {string} password Provider password for confirmation
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        disable2FA(email: string, password: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.disable2FA(email, password, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Send verification code via email for providers using email-based 2FA during login flow. Only works if provider has email OTP enabled.
         * @summary Send Email OTP for login
         * @param {SendEmailOtpRequest} sendEmailOtpRequest 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendEmailOtp(sendEmailOtpRequest: SendEmailOtpRequest, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.sendEmailOtp(sendEmailOtpRequest, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Setup 2FA for a provider. Choose between Google Authenticator (returns QR code) or Email OTP (confirmation message). Provider can only have one authentication method at a time.
         * @summary Setup 2FA for provider
         * @param {Setup2FARequest} setup2FARequest 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setup2FA(setup2FARequest: Setup2FARequest, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.setup2FA(setup2FARequest, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Verify a code from Google Authenticator or Email OTP using provider email. During setup (isLogin=false), automatically enables 2FA if code is valid. During login (isLogin=true), just verifies the code.
         * @summary Verify 2FA code and enable if setup
         * @param {Verify2FARequest} verify2FARequest 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verify2FA(verify2FARequest: Verify2FARequest, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.verify2FA(verify2FARequest, xTENANTID, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TwoFactorAuthenticationApi - object-oriented interface
 * @export
 * @class TwoFactorAuthenticationApi
 * @extends {BaseAPI}
 */
export class TwoFactorAuthenticationApi extends BaseAPI {
    /**
     * Disable 2FA (both Google Authenticator and Email OTP) using provider email and password. Clears all 2FA data.
     * @summary Disable 2FA for provider
     * @param {string} email Provider email
     * @param {string} password Provider password for confirmation
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TwoFactorAuthenticationApi
     */
    public disable2FA(email: string, password: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return TwoFactorAuthenticationApiFp(this.configuration).disable2FA(email, password, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Send verification code via email for providers using email-based 2FA during login flow. Only works if provider has email OTP enabled.
     * @summary Send Email OTP for login
     * @param {SendEmailOtpRequest} sendEmailOtpRequest 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TwoFactorAuthenticationApi
     */
    public sendEmailOtp(sendEmailOtpRequest: SendEmailOtpRequest, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return TwoFactorAuthenticationApiFp(this.configuration).sendEmailOtp(sendEmailOtpRequest, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Setup 2FA for a provider. Choose between Google Authenticator (returns QR code) or Email OTP (confirmation message). Provider can only have one authentication method at a time.
     * @summary Setup 2FA for provider
     * @param {Setup2FARequest} setup2FARequest 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TwoFactorAuthenticationApi
     */
    public setup2FA(setup2FARequest: Setup2FARequest, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return TwoFactorAuthenticationApiFp(this.configuration).setup2FA(setup2FARequest, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Verify a code from Google Authenticator or Email OTP using provider email. During setup (isLogin=false), automatically enables 2FA if code is valid. During login (isLogin=true), just verifies the code.
     * @summary Verify 2FA code and enable if setup
     * @param {Verify2FARequest} verify2FARequest 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TwoFactorAuthenticationApi
     */
    public verify2FA(verify2FARequest: Verify2FARequest, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return TwoFactorAuthenticationApiFp(this.configuration).verify2FA(verify2FARequest, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * UserControllerApi - axios parameter creator
 * @export
 */
export const UserControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Add a new Staff User into the system
         * @summary Add Staff User
         * @param {User} user 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addUser: async (user: User, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'user' is not null or undefined
            assertParamExists('addUser', 'user', user)
            const localVarPath = `/api/master/user`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(user, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * To assign user to the particular location
         * @summary Assign user to Location
         * @param {string} userId 
         * @param {string} locationId 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignLocationToUser: async (userId: string, locationId: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('assignLocationToUser', 'userId', userId)
            // verify required parameter 'locationId' is not null or undefined
            assertParamExists('assignLocationToUser', 'locationId', locationId)
            const localVarPath = `/api/master/user/{userId}/location/{locationId}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)))
                .replace(`{${"locationId"}}`, encodeURIComponent(String(locationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Change user avatar
         * @summary Change Avatar
         * @param {ChangeAvatarRequest} changeAvatarRequest 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeAvatar4: async (changeAvatarRequest: ChangeAvatarRequest, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'changeAvatarRequest' is not null or undefined
            assertParamExists('changeAvatar4', 'changeAvatarRequest', changeAvatarRequest)
            const localVarPath = `/api/master/change-avatar`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(changeAvatarRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Change Password for Logged-in User
         * @summary Change Password
         * @param {ChangePasswordRequest} changePasswordRequest 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changePassword: async (changePasswordRequest: ChangePasswordRequest, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'changePasswordRequest' is not null or undefined
            assertParamExists('changePassword', 'changePasswordRequest', changePasswordRequest)
            const localVarPath = `/api/master/change-password`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(changePasswordRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get access token using Username and Password
         * @summary Renew Token
         * @param {AccessToken} accessToken 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccessToken: async (accessToken: AccessToken, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'accessToken' is not null or undefined
            assertParamExists('getAccessToken', 'accessToken', accessToken)
            const localVarPath = `/api/master/renew-token`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(accessToken, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get access token using Username and Password
         * @summary Login
         * @param {LoginRequest} loginRequest 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccessToken1: async (loginRequest: LoginRequest, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'loginRequest' is not null or undefined
            assertParamExists('getAccessToken1', 'loginRequest', loginRequest)
            const localVarPath = `/api/master/login`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(loginRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List staff users using Filter with Pagination and Sorting with filter options on status, archive and role and search functionality on firstName, lastName and email,
         * @summary List Staff Users
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {boolean} [status] 
         * @param {boolean} [archive] 
         * @param {string} [role] 
         * @param {GetAllUsersRoleTypeEnum} [roleType] 
         * @param {string} [locationUuid] 
         * @param {string} [searchString] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllUsers: async (page?: number, size?: number, sortBy?: string, sortDirection?: string, status?: boolean, archive?: boolean, role?: string, roleType?: GetAllUsersRoleTypeEnum, locationUuid?: string, searchString?: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/master/users`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (archive !== undefined) {
                localVarQueryParameter['archive'] = archive;
            }

            if (role !== undefined) {
                localVarQueryParameter['role'] = role;
            }

            if (roleType !== undefined) {
                localVarQueryParameter['roleType'] = roleType;
            }

            if (locationUuid !== undefined) {
                localVarQueryParameter['locationUuid'] = locationUuid;
            }

            if (searchString !== undefined) {
                localVarQueryParameter['searchString'] = searchString;
            }

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get Logged-in User Profile
         * @summary User Profile
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProfile1: async (xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/master/profile`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get Staff User by userUuid
         * @summary Staff User
         * @param {string} userId 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUser: async (userId: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getUser', 'userId', userId)
            const localVarPath = `/api/master/user/{userId}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Invalidate active access tokens
         * @summary Logout
         * @param {AccessToken} accessToken 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logout: async (accessToken: AccessToken, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'accessToken' is not null or undefined
            assertParamExists('logout', 'accessToken', accessToken)
            const localVarPath = `/api/master/logout`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(accessToken, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Remove user avatar
         * @summary Remove Avatar
         * @param {ChangeAvatarRequest} changeAvatarRequest 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeAvatar: async (changeAvatarRequest: ChangeAvatarRequest, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'changeAvatarRequest' is not null or undefined
            assertParamExists('removeAvatar', 'changeAvatarRequest', changeAvatarRequest)
            const localVarPath = `/api/master/remove-user-avatar`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(changeAvatarRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Send Set/Reset Password Link
         * @summary Set/Reset Password
         * @param {string} linkType 
         * @param {SetPasswordRequest} setPasswordRequest 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendEmailForForgotPassword: async (linkType: string, setPasswordRequest: SetPasswordRequest, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'linkType' is not null or undefined
            assertParamExists('sendEmailForForgotPassword', 'linkType', linkType)
            // verify required parameter 'setPasswordRequest' is not null or undefined
            assertParamExists('sendEmailForForgotPassword', 'setPasswordRequest', setPasswordRequest)
            const localVarPath = `/api/master/set-reset-password/{linkType}`
                .replace(`{${"linkType"}}`, encodeURIComponent(String(linkType)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(setPasswordRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Verify Password Link and Set/Reset Password for User
         * @summary Set/Reset Password
         * @param {string} linkType 
         * @param {ResetPasswordRequest} resetPasswordRequest 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setPassword: async (linkType: string, resetPasswordRequest: ResetPasswordRequest, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'linkType' is not null or undefined
            assertParamExists('setPassword', 'linkType', linkType)
            // verify required parameter 'resetPasswordRequest' is not null or undefined
            assertParamExists('setPassword', 'resetPasswordRequest', resetPasswordRequest)
            const localVarPath = `/api/master/set-password/{linkType}`
                .replace(`{${"linkType"}}`, encodeURIComponent(String(linkType)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(resetPasswordRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Edit Staff User with editable fields as firstName, lastName, phone, roleType, role.
         * @summary Update Staff Users
         * @param {User} user 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUser: async (user: User, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'user' is not null or undefined
            assertParamExists('updateUser', 'user', user)
            const localVarPath = `/api/master/user`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(user, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Change User archive status to either archived or unarchived.
         * @summary Archive/Unarchive User
         * @param {string} userId 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserArchiveStatus: async (userId: string, status: boolean, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('updateUserArchiveStatus', 'userId', userId)
            // verify required parameter 'status' is not null or undefined
            assertParamExists('updateUserArchiveStatus', 'status', status)
            const localVarPath = `/api/master/{userId}/archive-status/{status}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)))
                .replace(`{${"status"}}`, encodeURIComponent(String(status)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Change user status to either active or inactive to restrict user from login
         * @summary Enable/Disable User
         * @param {string} userId 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserStatus: async (userId: string, status: boolean, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('updateUserStatus', 'userId', userId)
            // verify required parameter 'status' is not null or undefined
            assertParamExists('updateUserStatus', 'status', status)
            const localVarPath = `/api/master/user/{userId}/status/{status}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)))
                .replace(`{${"status"}}`, encodeURIComponent(String(status)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UserControllerApi - functional programming interface
 * @export
 */
export const UserControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UserControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * Add a new Staff User into the system
         * @summary Add Staff User
         * @param {User} user 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addUser(user: User, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addUser(user, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserControllerApi.addUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * To assign user to the particular location
         * @summary Assign user to Location
         * @param {string} userId 
         * @param {string} locationId 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assignLocationToUser(userId: string, locationId: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assignLocationToUser(userId, locationId, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserControllerApi.assignLocationToUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Change user avatar
         * @summary Change Avatar
         * @param {ChangeAvatarRequest} changeAvatarRequest 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async changeAvatar4(changeAvatarRequest: ChangeAvatarRequest, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.changeAvatar4(changeAvatarRequest, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserControllerApi.changeAvatar4']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Change Password for Logged-in User
         * @summary Change Password
         * @param {ChangePasswordRequest} changePasswordRequest 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async changePassword(changePasswordRequest: ChangePasswordRequest, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.changePassword(changePasswordRequest, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserControllerApi.changePassword']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get access token using Username and Password
         * @summary Renew Token
         * @param {AccessToken} accessToken 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAccessToken(accessToken: AccessToken, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAccessToken(accessToken, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserControllerApi.getAccessToken']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get access token using Username and Password
         * @summary Login
         * @param {LoginRequest} loginRequest 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAccessToken1(loginRequest: LoginRequest, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAccessToken1(loginRequest, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserControllerApi.getAccessToken1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List staff users using Filter with Pagination and Sorting with filter options on status, archive and role and search functionality on firstName, lastName and email,
         * @summary List Staff Users
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {boolean} [status] 
         * @param {boolean} [archive] 
         * @param {string} [role] 
         * @param {GetAllUsersRoleTypeEnum} [roleType] 
         * @param {string} [locationUuid] 
         * @param {string} [searchString] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllUsers(page?: number, size?: number, sortBy?: string, sortDirection?: string, status?: boolean, archive?: boolean, role?: string, roleType?: GetAllUsersRoleTypeEnum, locationUuid?: string, searchString?: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllUsers(page, size, sortBy, sortDirection, status, archive, role, roleType, locationUuid, searchString, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserControllerApi.getAllUsers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get Logged-in User Profile
         * @summary User Profile
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProfile1(xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProfile1(xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserControllerApi.getProfile1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get Staff User by userUuid
         * @summary Staff User
         * @param {string} userId 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUser(userId: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUser(userId, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserControllerApi.getUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Invalidate active access tokens
         * @summary Logout
         * @param {AccessToken} accessToken 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async logout(accessToken: AccessToken, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.logout(accessToken, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserControllerApi.logout']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Remove user avatar
         * @summary Remove Avatar
         * @param {ChangeAvatarRequest} changeAvatarRequest 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeAvatar(changeAvatarRequest: ChangeAvatarRequest, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removeAvatar(changeAvatarRequest, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserControllerApi.removeAvatar']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Send Set/Reset Password Link
         * @summary Set/Reset Password
         * @param {string} linkType 
         * @param {SetPasswordRequest} setPasswordRequest 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendEmailForForgotPassword(linkType: string, setPasswordRequest: SetPasswordRequest, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendEmailForForgotPassword(linkType, setPasswordRequest, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserControllerApi.sendEmailForForgotPassword']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Verify Password Link and Set/Reset Password for User
         * @summary Set/Reset Password
         * @param {string} linkType 
         * @param {ResetPasswordRequest} resetPasswordRequest 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setPassword(linkType: string, resetPasswordRequest: ResetPasswordRequest, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setPassword(linkType, resetPasswordRequest, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserControllerApi.setPassword']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Edit Staff User with editable fields as firstName, lastName, phone, roleType, role.
         * @summary Update Staff Users
         * @param {User} user 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateUser(user: User, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateUser(user, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserControllerApi.updateUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Change User archive status to either archived or unarchived.
         * @summary Archive/Unarchive User
         * @param {string} userId 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateUserArchiveStatus(userId: string, status: boolean, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateUserArchiveStatus(userId, status, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserControllerApi.updateUserArchiveStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Change user status to either active or inactive to restrict user from login
         * @summary Enable/Disable User
         * @param {string} userId 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateUserStatus(userId: string, status: boolean, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateUserStatus(userId, status, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserControllerApi.updateUserStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * UserControllerApi - factory interface
 * @export
 */
export const UserControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UserControllerApiFp(configuration)
    return {
        /**
         * Add a new Staff User into the system
         * @summary Add Staff User
         * @param {User} user 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addUser(user: User, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.addUser(user, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * To assign user to the particular location
         * @summary Assign user to Location
         * @param {string} userId 
         * @param {string} locationId 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignLocationToUser(userId: string, locationId: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.assignLocationToUser(userId, locationId, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Change user avatar
         * @summary Change Avatar
         * @param {ChangeAvatarRequest} changeAvatarRequest 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeAvatar4(changeAvatarRequest: ChangeAvatarRequest, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.changeAvatar4(changeAvatarRequest, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Change Password for Logged-in User
         * @summary Change Password
         * @param {ChangePasswordRequest} changePasswordRequest 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changePassword(changePasswordRequest: ChangePasswordRequest, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.changePassword(changePasswordRequest, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Get access token using Username and Password
         * @summary Renew Token
         * @param {AccessToken} accessToken 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccessToken(accessToken: AccessToken, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getAccessToken(accessToken, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Get access token using Username and Password
         * @summary Login
         * @param {LoginRequest} loginRequest 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccessToken1(loginRequest: LoginRequest, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getAccessToken1(loginRequest, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * List staff users using Filter with Pagination and Sorting with filter options on status, archive and role and search functionality on firstName, lastName and email,
         * @summary List Staff Users
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {boolean} [status] 
         * @param {boolean} [archive] 
         * @param {string} [role] 
         * @param {GetAllUsersRoleTypeEnum} [roleType] 
         * @param {string} [locationUuid] 
         * @param {string} [searchString] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllUsers(page?: number, size?: number, sortBy?: string, sortDirection?: string, status?: boolean, archive?: boolean, role?: string, roleType?: GetAllUsersRoleTypeEnum, locationUuid?: string, searchString?: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getAllUsers(page, size, sortBy, sortDirection, status, archive, role, roleType, locationUuid, searchString, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Get Logged-in User Profile
         * @summary User Profile
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProfile1(xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getProfile1(xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Get Staff User by userUuid
         * @summary Staff User
         * @param {string} userId 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUser(userId: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getUser(userId, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Invalidate active access tokens
         * @summary Logout
         * @param {AccessToken} accessToken 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logout(accessToken: AccessToken, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.logout(accessToken, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Remove user avatar
         * @summary Remove Avatar
         * @param {ChangeAvatarRequest} changeAvatarRequest 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeAvatar(changeAvatarRequest: ChangeAvatarRequest, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.removeAvatar(changeAvatarRequest, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Send Set/Reset Password Link
         * @summary Set/Reset Password
         * @param {string} linkType 
         * @param {SetPasswordRequest} setPasswordRequest 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendEmailForForgotPassword(linkType: string, setPasswordRequest: SetPasswordRequest, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.sendEmailForForgotPassword(linkType, setPasswordRequest, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Verify Password Link and Set/Reset Password for User
         * @summary Set/Reset Password
         * @param {string} linkType 
         * @param {ResetPasswordRequest} resetPasswordRequest 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setPassword(linkType: string, resetPasswordRequest: ResetPasswordRequest, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.setPassword(linkType, resetPasswordRequest, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Edit Staff User with editable fields as firstName, lastName, phone, roleType, role.
         * @summary Update Staff Users
         * @param {User} user 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUser(user: User, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.updateUser(user, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Change User archive status to either archived or unarchived.
         * @summary Archive/Unarchive User
         * @param {string} userId 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserArchiveStatus(userId: string, status: boolean, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.updateUserArchiveStatus(userId, status, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Change user status to either active or inactive to restrict user from login
         * @summary Enable/Disable User
         * @param {string} userId 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserStatus(userId: string, status: boolean, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.updateUserStatus(userId, status, xTENANTID, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UserControllerApi - object-oriented interface
 * @export
 * @class UserControllerApi
 * @extends {BaseAPI}
 */
export class UserControllerApi extends BaseAPI {
    /**
     * Add a new Staff User into the system
     * @summary Add Staff User
     * @param {User} user 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserControllerApi
     */
    public addUser(user: User, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return UserControllerApiFp(this.configuration).addUser(user, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * To assign user to the particular location
     * @summary Assign user to Location
     * @param {string} userId 
     * @param {string} locationId 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserControllerApi
     */
    public assignLocationToUser(userId: string, locationId: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return UserControllerApiFp(this.configuration).assignLocationToUser(userId, locationId, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Change user avatar
     * @summary Change Avatar
     * @param {ChangeAvatarRequest} changeAvatarRequest 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserControllerApi
     */
    public changeAvatar4(changeAvatarRequest: ChangeAvatarRequest, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return UserControllerApiFp(this.configuration).changeAvatar4(changeAvatarRequest, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Change Password for Logged-in User
     * @summary Change Password
     * @param {ChangePasswordRequest} changePasswordRequest 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserControllerApi
     */
    public changePassword(changePasswordRequest: ChangePasswordRequest, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return UserControllerApiFp(this.configuration).changePassword(changePasswordRequest, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get access token using Username and Password
     * @summary Renew Token
     * @param {AccessToken} accessToken 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserControllerApi
     */
    public getAccessToken(accessToken: AccessToken, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return UserControllerApiFp(this.configuration).getAccessToken(accessToken, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get access token using Username and Password
     * @summary Login
     * @param {LoginRequest} loginRequest 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserControllerApi
     */
    public getAccessToken1(loginRequest: LoginRequest, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return UserControllerApiFp(this.configuration).getAccessToken1(loginRequest, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List staff users using Filter with Pagination and Sorting with filter options on status, archive and role and search functionality on firstName, lastName and email,
     * @summary List Staff Users
     * @param {number} [page] 
     * @param {number} [size] 
     * @param {string} [sortBy] 
     * @param {string} [sortDirection] 
     * @param {boolean} [status] 
     * @param {boolean} [archive] 
     * @param {string} [role] 
     * @param {GetAllUsersRoleTypeEnum} [roleType] 
     * @param {string} [locationUuid] 
     * @param {string} [searchString] 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserControllerApi
     */
    public getAllUsers(page?: number, size?: number, sortBy?: string, sortDirection?: string, status?: boolean, archive?: boolean, role?: string, roleType?: GetAllUsersRoleTypeEnum, locationUuid?: string, searchString?: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return UserControllerApiFp(this.configuration).getAllUsers(page, size, sortBy, sortDirection, status, archive, role, roleType, locationUuid, searchString, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get Logged-in User Profile
     * @summary User Profile
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserControllerApi
     */
    public getProfile1(xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return UserControllerApiFp(this.configuration).getProfile1(xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get Staff User by userUuid
     * @summary Staff User
     * @param {string} userId 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserControllerApi
     */
    public getUser(userId: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return UserControllerApiFp(this.configuration).getUser(userId, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Invalidate active access tokens
     * @summary Logout
     * @param {AccessToken} accessToken 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserControllerApi
     */
    public logout(accessToken: AccessToken, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return UserControllerApiFp(this.configuration).logout(accessToken, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Remove user avatar
     * @summary Remove Avatar
     * @param {ChangeAvatarRequest} changeAvatarRequest 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserControllerApi
     */
    public removeAvatar(changeAvatarRequest: ChangeAvatarRequest, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return UserControllerApiFp(this.configuration).removeAvatar(changeAvatarRequest, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Send Set/Reset Password Link
     * @summary Set/Reset Password
     * @param {string} linkType 
     * @param {SetPasswordRequest} setPasswordRequest 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserControllerApi
     */
    public sendEmailForForgotPassword(linkType: string, setPasswordRequest: SetPasswordRequest, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return UserControllerApiFp(this.configuration).sendEmailForForgotPassword(linkType, setPasswordRequest, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Verify Password Link and Set/Reset Password for User
     * @summary Set/Reset Password
     * @param {string} linkType 
     * @param {ResetPasswordRequest} resetPasswordRequest 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserControllerApi
     */
    public setPassword(linkType: string, resetPasswordRequest: ResetPasswordRequest, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return UserControllerApiFp(this.configuration).setPassword(linkType, resetPasswordRequest, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Edit Staff User with editable fields as firstName, lastName, phone, roleType, role.
     * @summary Update Staff Users
     * @param {User} user 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserControllerApi
     */
    public updateUser(user: User, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return UserControllerApiFp(this.configuration).updateUser(user, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Change User archive status to either archived or unarchived.
     * @summary Archive/Unarchive User
     * @param {string} userId 
     * @param {boolean} status 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserControllerApi
     */
    public updateUserArchiveStatus(userId: string, status: boolean, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return UserControllerApiFp(this.configuration).updateUserArchiveStatus(userId, status, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Change user status to either active or inactive to restrict user from login
     * @summary Enable/Disable User
     * @param {string} userId 
     * @param {boolean} status 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserControllerApi
     */
    public updateUserStatus(userId: string, status: boolean, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return UserControllerApiFp(this.configuration).updateUserStatus(userId, status, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const GetAllUsersRoleTypeEnum = {
    Provider: 'PROVIDER',
    Staff: 'STAFF',
    Patient: 'PATIENT',
    Admin: 'ADMIN',
    Physician: 'PHYSICIAN',
    BillingAdmin: 'BILLING_ADMIN',
    Biller: 'BILLER',
    FrontDeskStaff: 'FRONT_DESK_STAFF',
    SalesCoordinator: 'SALES_COORDINATOR',
    Support: 'SUPPORT',
    PracticeAdmin: 'PRACTICE_ADMIN',
    CareManager: 'CARE_MANAGER'
} as const;
export type GetAllUsersRoleTypeEnum = typeof GetAllUsersRoleTypeEnum[keyof typeof GetAllUsersRoleTypeEnum];


/**
 * UserDocumentControllerApi - axios parameter creator
 * @export
 */
export const UserDocumentControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} patientId 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {boolean} [status] 
         * @param {boolean} [archive] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllDocumentOfPatient: async (patientId: string, page?: number, size?: number, sortBy?: string, sortDirection?: string, status?: boolean, archive?: boolean, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientId' is not null or undefined
            assertParamExists('getAllDocumentOfPatient', 'patientId', patientId)
            const localVarPath = `/api/master/user-document/patient`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (archive !== undefined) {
                localVarQueryParameter['archive'] = archive;
            }

            if (patientId !== undefined) {
                localVarQueryParameter['patientId'] = patientId;
            }

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} providerId 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {boolean} [status] 
         * @param {boolean} [archive] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllDocumentOfProvider: async (providerId: string, page?: number, size?: number, sortBy?: string, sortDirection?: string, status?: boolean, archive?: boolean, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'providerId' is not null or undefined
            assertParamExists('getAllDocumentOfProvider', 'providerId', providerId)
            const localVarPath = `/api/master/user-document/provider`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (archive !== undefined) {
                localVarQueryParameter['archive'] = archive;
            }

            if (providerId !== undefined) {
                localVarQueryParameter['providerId'] = providerId;
            }

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} patientId 
         * @param {string} name 
         * @param {UploadDocumentPatientDocumentTypeEnum} documentType 
         * @param {string} documentTypes 
         * @param {UploadDocumentPatientDocumentFormatEnum} documentFormat 
         * @param {string} [xTENANTID] 
         * @param {UploadDocumentPatientRequest} [uploadDocumentPatientRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadDocumentPatient: async (patientId: string, name: string, documentType: UploadDocumentPatientDocumentTypeEnum, documentTypes: string, documentFormat: UploadDocumentPatientDocumentFormatEnum, xTENANTID?: string, uploadDocumentPatientRequest?: UploadDocumentPatientRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientId' is not null or undefined
            assertParamExists('uploadDocumentPatient', 'patientId', patientId)
            // verify required parameter 'name' is not null or undefined
            assertParamExists('uploadDocumentPatient', 'name', name)
            // verify required parameter 'documentType' is not null or undefined
            assertParamExists('uploadDocumentPatient', 'documentType', documentType)
            // verify required parameter 'documentTypes' is not null or undefined
            assertParamExists('uploadDocumentPatient', 'documentTypes', documentTypes)
            // verify required parameter 'documentFormat' is not null or undefined
            assertParamExists('uploadDocumentPatient', 'documentFormat', documentFormat)
            const localVarPath = `/api/master/user-document/patient`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (patientId !== undefined) {
                localVarQueryParameter['patientId'] = patientId;
            }

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            if (documentType !== undefined) {
                localVarQueryParameter['documentType'] = documentType;
            }

            if (documentTypes !== undefined) {
                localVarQueryParameter['documentTypes'] = documentTypes;
            }

            if (documentFormat !== undefined) {
                localVarQueryParameter['documentFormat'] = documentFormat;
            }

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(uploadDocumentPatientRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} providerId 
         * @param {string} name 
         * @param {UploadDocumentProviderDocumentTypeEnum} [documentType] 
         * @param {string} [documentTag] 
         * @param {UploadDocumentProviderDocumentFormatEnum} [documentFormat] 
         * @param {string} [xTENANTID] 
         * @param {UploadDocumentProviderRequest} [uploadDocumentProviderRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadDocumentProvider: async (providerId: string, name: string, documentType?: UploadDocumentProviderDocumentTypeEnum, documentTag?: string, documentFormat?: UploadDocumentProviderDocumentFormatEnum, xTENANTID?: string, uploadDocumentProviderRequest?: UploadDocumentProviderRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'providerId' is not null or undefined
            assertParamExists('uploadDocumentProvider', 'providerId', providerId)
            // verify required parameter 'name' is not null or undefined
            assertParamExists('uploadDocumentProvider', 'name', name)
            const localVarPath = `/api/master/user-document/provider`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (providerId !== undefined) {
                localVarQueryParameter['providerId'] = providerId;
            }

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            if (documentType !== undefined) {
                localVarQueryParameter['documentType'] = documentType;
            }

            if (documentTag !== undefined) {
                localVarQueryParameter['documentTag'] = documentTag;
            }

            if (documentFormat !== undefined) {
                localVarQueryParameter['documentFormat'] = documentFormat;
            }

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(uploadDocumentProviderRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UserDocumentControllerApi - functional programming interface
 * @export
 */
export const UserDocumentControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UserDocumentControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} patientId 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {boolean} [status] 
         * @param {boolean} [archive] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllDocumentOfPatient(patientId: string, page?: number, size?: number, sortBy?: string, sortDirection?: string, status?: boolean, archive?: boolean, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllDocumentOfPatient(patientId, page, size, sortBy, sortDirection, status, archive, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserDocumentControllerApi.getAllDocumentOfPatient']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} providerId 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {boolean} [status] 
         * @param {boolean} [archive] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllDocumentOfProvider(providerId: string, page?: number, size?: number, sortBy?: string, sortDirection?: string, status?: boolean, archive?: boolean, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllDocumentOfProvider(providerId, page, size, sortBy, sortDirection, status, archive, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserDocumentControllerApi.getAllDocumentOfProvider']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} patientId 
         * @param {string} name 
         * @param {UploadDocumentPatientDocumentTypeEnum} documentType 
         * @param {string} documentTypes 
         * @param {UploadDocumentPatientDocumentFormatEnum} documentFormat 
         * @param {string} [xTENANTID] 
         * @param {UploadDocumentPatientRequest} [uploadDocumentPatientRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadDocumentPatient(patientId: string, name: string, documentType: UploadDocumentPatientDocumentTypeEnum, documentTypes: string, documentFormat: UploadDocumentPatientDocumentFormatEnum, xTENANTID?: string, uploadDocumentPatientRequest?: UploadDocumentPatientRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadDocumentPatient(patientId, name, documentType, documentTypes, documentFormat, xTENANTID, uploadDocumentPatientRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserDocumentControllerApi.uploadDocumentPatient']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} providerId 
         * @param {string} name 
         * @param {UploadDocumentProviderDocumentTypeEnum} [documentType] 
         * @param {string} [documentTag] 
         * @param {UploadDocumentProviderDocumentFormatEnum} [documentFormat] 
         * @param {string} [xTENANTID] 
         * @param {UploadDocumentProviderRequest} [uploadDocumentProviderRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadDocumentProvider(providerId: string, name: string, documentType?: UploadDocumentProviderDocumentTypeEnum, documentTag?: string, documentFormat?: UploadDocumentProviderDocumentFormatEnum, xTENANTID?: string, uploadDocumentProviderRequest?: UploadDocumentProviderRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadDocumentProvider(providerId, name, documentType, documentTag, documentFormat, xTENANTID, uploadDocumentProviderRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserDocumentControllerApi.uploadDocumentProvider']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * UserDocumentControllerApi - factory interface
 * @export
 */
export const UserDocumentControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UserDocumentControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {string} patientId 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {boolean} [status] 
         * @param {boolean} [archive] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllDocumentOfPatient(patientId: string, page?: number, size?: number, sortBy?: string, sortDirection?: string, status?: boolean, archive?: boolean, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getAllDocumentOfPatient(patientId, page, size, sortBy, sortDirection, status, archive, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} providerId 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {boolean} [status] 
         * @param {boolean} [archive] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllDocumentOfProvider(providerId: string, page?: number, size?: number, sortBy?: string, sortDirection?: string, status?: boolean, archive?: boolean, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getAllDocumentOfProvider(providerId, page, size, sortBy, sortDirection, status, archive, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} patientId 
         * @param {string} name 
         * @param {UploadDocumentPatientDocumentTypeEnum} documentType 
         * @param {string} documentTypes 
         * @param {UploadDocumentPatientDocumentFormatEnum} documentFormat 
         * @param {string} [xTENANTID] 
         * @param {UploadDocumentPatientRequest} [uploadDocumentPatientRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadDocumentPatient(patientId: string, name: string, documentType: UploadDocumentPatientDocumentTypeEnum, documentTypes: string, documentFormat: UploadDocumentPatientDocumentFormatEnum, xTENANTID?: string, uploadDocumentPatientRequest?: UploadDocumentPatientRequest, options?: any): AxiosPromise<Response> {
            return localVarFp.uploadDocumentPatient(patientId, name, documentType, documentTypes, documentFormat, xTENANTID, uploadDocumentPatientRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} providerId 
         * @param {string} name 
         * @param {UploadDocumentProviderDocumentTypeEnum} [documentType] 
         * @param {string} [documentTag] 
         * @param {UploadDocumentProviderDocumentFormatEnum} [documentFormat] 
         * @param {string} [xTENANTID] 
         * @param {UploadDocumentProviderRequest} [uploadDocumentProviderRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadDocumentProvider(providerId: string, name: string, documentType?: UploadDocumentProviderDocumentTypeEnum, documentTag?: string, documentFormat?: UploadDocumentProviderDocumentFormatEnum, xTENANTID?: string, uploadDocumentProviderRequest?: UploadDocumentProviderRequest, options?: any): AxiosPromise<Response> {
            return localVarFp.uploadDocumentProvider(providerId, name, documentType, documentTag, documentFormat, xTENANTID, uploadDocumentProviderRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UserDocumentControllerApi - object-oriented interface
 * @export
 * @class UserDocumentControllerApi
 * @extends {BaseAPI}
 */
export class UserDocumentControllerApi extends BaseAPI {
    /**
     * 
     * @param {string} patientId 
     * @param {number} [page] 
     * @param {number} [size] 
     * @param {string} [sortBy] 
     * @param {string} [sortDirection] 
     * @param {boolean} [status] 
     * @param {boolean} [archive] 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserDocumentControllerApi
     */
    public getAllDocumentOfPatient(patientId: string, page?: number, size?: number, sortBy?: string, sortDirection?: string, status?: boolean, archive?: boolean, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return UserDocumentControllerApiFp(this.configuration).getAllDocumentOfPatient(patientId, page, size, sortBy, sortDirection, status, archive, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} providerId 
     * @param {number} [page] 
     * @param {number} [size] 
     * @param {string} [sortBy] 
     * @param {string} [sortDirection] 
     * @param {boolean} [status] 
     * @param {boolean} [archive] 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserDocumentControllerApi
     */
    public getAllDocumentOfProvider(providerId: string, page?: number, size?: number, sortBy?: string, sortDirection?: string, status?: boolean, archive?: boolean, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return UserDocumentControllerApiFp(this.configuration).getAllDocumentOfProvider(providerId, page, size, sortBy, sortDirection, status, archive, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} patientId 
     * @param {string} name 
     * @param {UploadDocumentPatientDocumentTypeEnum} documentType 
     * @param {string} documentTypes 
     * @param {UploadDocumentPatientDocumentFormatEnum} documentFormat 
     * @param {string} [xTENANTID] 
     * @param {UploadDocumentPatientRequest} [uploadDocumentPatientRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserDocumentControllerApi
     */
    public uploadDocumentPatient(patientId: string, name: string, documentType: UploadDocumentPatientDocumentTypeEnum, documentTypes: string, documentFormat: UploadDocumentPatientDocumentFormatEnum, xTENANTID?: string, uploadDocumentPatientRequest?: UploadDocumentPatientRequest, options?: RawAxiosRequestConfig) {
        return UserDocumentControllerApiFp(this.configuration).uploadDocumentPatient(patientId, name, documentType, documentTypes, documentFormat, xTENANTID, uploadDocumentPatientRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} providerId 
     * @param {string} name 
     * @param {UploadDocumentProviderDocumentTypeEnum} [documentType] 
     * @param {string} [documentTag] 
     * @param {UploadDocumentProviderDocumentFormatEnum} [documentFormat] 
     * @param {string} [xTENANTID] 
     * @param {UploadDocumentProviderRequest} [uploadDocumentProviderRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserDocumentControllerApi
     */
    public uploadDocumentProvider(providerId: string, name: string, documentType?: UploadDocumentProviderDocumentTypeEnum, documentTag?: string, documentFormat?: UploadDocumentProviderDocumentFormatEnum, xTENANTID?: string, uploadDocumentProviderRequest?: UploadDocumentProviderRequest, options?: RawAxiosRequestConfig) {
        return UserDocumentControllerApiFp(this.configuration).uploadDocumentProvider(providerId, name, documentType, documentTag, documentFormat, xTENANTID, uploadDocumentProviderRequest, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const UploadDocumentPatientDocumentTypeEnum = {
    Avatar: 'AVATAR',
    CustomForm: 'CUSTOM_FORM',
    Insurance: 'INSURANCE',
    IdProof: 'ID_PROOF',
    DrivingLicense: 'DRIVING_LICENSE',
    StateId: 'STATE_ID',
    Passport: 'PASSPORT',
    GreenCardPhoto: 'GREEN_CARD_PHOTO',
    Documents: 'DOCUMENTS',
    LabReport: 'LAB_REPORT',
    LabOrder: 'LAB_ORDER',
    InsuranceCardFront: 'INSURANCE_CARD_FRONT',
    InsuranceCardBack: 'INSURANCE_CARD_BACK',
    InsuranceEligibility: 'INSURANCE_ELIGIBILITY',
    ConsentForm: 'CONSENT_FORM',
    EducationMaterial: 'EDUCATION_MATERIAL',
    LicenseInformation: 'LICENSE_INFORMATION',
    FailDataImportDocuments: 'FAIL_DATA_IMPORT_DOCUMENTS',
    Roi: 'ROI',
    ReferralDocuments: 'REFERRAL_DOCUMENTS',
    PatientConsent: 'PATIENT_CONSENT',
    PriorAuthorization: 'PRIOR_AUTHORIZATION',
    ChatAttachment: 'CHAT_ATTACHMENT',
    MiniCogClock: 'MINI_COG_CLOCK',
    Eob: 'EOB'
} as const;
export type UploadDocumentPatientDocumentTypeEnum = typeof UploadDocumentPatientDocumentTypeEnum[keyof typeof UploadDocumentPatientDocumentTypeEnum];
/**
 * @export
 */
export const UploadDocumentPatientDocumentFormatEnum = {
    Pdf: 'PDF',
    MsWord: 'MS_WORD',
    Zip: 'ZIP',
    XGzip: 'X_GZIP',
    XCompressed: 'X_COMPRESSED',
    Docx: 'DOCX',
    Rtf: 'RTF',
    Plain: 'PLAIN',
    Xlsx: 'XLSX',
    JpegImage: 'JPEG_IMAGE',
    Mp4: 'MP4',
    PngImage: 'PNG_IMAGE',
    GifImage: 'GIF_IMAGE',
    BmpImage: 'BMP_IMAGE',
    WebpImage: 'WEBP_IMAGE',
    SvgImage: 'SVG_IMAGE',
    MpegAudio: 'MPEG_AUDIO',
    Other: 'OTHER',
    Csv: 'CSV'
} as const;
export type UploadDocumentPatientDocumentFormatEnum = typeof UploadDocumentPatientDocumentFormatEnum[keyof typeof UploadDocumentPatientDocumentFormatEnum];
/**
 * @export
 */
export const UploadDocumentProviderDocumentTypeEnum = {
    Avatar: 'AVATAR',
    CustomForm: 'CUSTOM_FORM',
    Insurance: 'INSURANCE',
    IdProof: 'ID_PROOF',
    DrivingLicense: 'DRIVING_LICENSE',
    StateId: 'STATE_ID',
    Passport: 'PASSPORT',
    GreenCardPhoto: 'GREEN_CARD_PHOTO',
    Documents: 'DOCUMENTS',
    LabReport: 'LAB_REPORT',
    LabOrder: 'LAB_ORDER',
    InsuranceCardFront: 'INSURANCE_CARD_FRONT',
    InsuranceCardBack: 'INSURANCE_CARD_BACK',
    InsuranceEligibility: 'INSURANCE_ELIGIBILITY',
    ConsentForm: 'CONSENT_FORM',
    EducationMaterial: 'EDUCATION_MATERIAL',
    LicenseInformation: 'LICENSE_INFORMATION',
    FailDataImportDocuments: 'FAIL_DATA_IMPORT_DOCUMENTS',
    Roi: 'ROI',
    ReferralDocuments: 'REFERRAL_DOCUMENTS',
    PatientConsent: 'PATIENT_CONSENT',
    PriorAuthorization: 'PRIOR_AUTHORIZATION',
    ChatAttachment: 'CHAT_ATTACHMENT',
    MiniCogClock: 'MINI_COG_CLOCK',
    Eob: 'EOB'
} as const;
export type UploadDocumentProviderDocumentTypeEnum = typeof UploadDocumentProviderDocumentTypeEnum[keyof typeof UploadDocumentProviderDocumentTypeEnum];
/**
 * @export
 */
export const UploadDocumentProviderDocumentFormatEnum = {
    Pdf: 'PDF',
    MsWord: 'MS_WORD',
    Zip: 'ZIP',
    XGzip: 'X_GZIP',
    XCompressed: 'X_COMPRESSED',
    Docx: 'DOCX',
    Rtf: 'RTF',
    Plain: 'PLAIN',
    Xlsx: 'XLSX',
    JpegImage: 'JPEG_IMAGE',
    Mp4: 'MP4',
    PngImage: 'PNG_IMAGE',
    GifImage: 'GIF_IMAGE',
    BmpImage: 'BMP_IMAGE',
    WebpImage: 'WEBP_IMAGE',
    SvgImage: 'SVG_IMAGE',
    MpegAudio: 'MPEG_AUDIO',
    Other: 'OTHER',
    Csv: 'CSV'
} as const;
export type UploadDocumentProviderDocumentFormatEnum = typeof UploadDocumentProviderDocumentFormatEnum[keyof typeof UploadDocumentProviderDocumentFormatEnum];


/**
 * VaccinesControllerApi - axios parameter creator
 * @export
 */
export const VaccinesControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get all vaccine records
         * @summary Get all Vaccines
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {string} [searchString] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllVaccines: async (page?: number, size?: number, sortBy?: string, sortDirection?: string, searchString?: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/master/vaccine`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }

            if (searchString !== undefined) {
                localVarQueryParameter['searchString'] = searchString;
            }

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * VaccinesControllerApi - functional programming interface
 * @export
 */
export const VaccinesControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = VaccinesControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * Get all vaccine records
         * @summary Get all Vaccines
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {string} [searchString] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllVaccines(page?: number, size?: number, sortBy?: string, sortDirection?: string, searchString?: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllVaccines(page, size, sortBy, sortDirection, searchString, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VaccinesControllerApi.getAllVaccines']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * VaccinesControllerApi - factory interface
 * @export
 */
export const VaccinesControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = VaccinesControllerApiFp(configuration)
    return {
        /**
         * Get all vaccine records
         * @summary Get all Vaccines
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {string} [searchString] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllVaccines(page?: number, size?: number, sortBy?: string, sortDirection?: string, searchString?: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getAllVaccines(page, size, sortBy, sortDirection, searchString, xTENANTID, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * VaccinesControllerApi - object-oriented interface
 * @export
 * @class VaccinesControllerApi
 * @extends {BaseAPI}
 */
export class VaccinesControllerApi extends BaseAPI {
    /**
     * Get all vaccine records
     * @summary Get all Vaccines
     * @param {number} [page] 
     * @param {number} [size] 
     * @param {string} [sortBy] 
     * @param {string} [sortDirection] 
     * @param {string} [searchString] 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VaccinesControllerApi
     */
    public getAllVaccines(page?: number, size?: number, sortBy?: string, sortDirection?: string, searchString?: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return VaccinesControllerApiFp(this.configuration).getAllVaccines(page, size, sortBy, sortDirection, searchString, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * VideoControllerApi - axios parameter creator
 * @export
 */
export const VideoControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * To emit event for provider to accept or deny
         * @summary to emit event
         * @param {PatientEmitEventDTO} patientEmitEventDTO 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        emit: async (patientEmitEventDTO: PatientEmitEventDTO, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientEmitEventDTO' is not null or undefined
            assertParamExists('emit', 'patientEmitEventDTO', patientEmitEventDTO)
            const localVarPath = `/api/master/event/emit`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patientEmitEventDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * To register an event for notification
         * @summary event registerer
         * @param {string} room 
         * @param {string} [authorization] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAuthToken: async (room: string, authorization?: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'room' is not null or undefined
            assertParamExists('getAuthToken', 'room', room)
            const localVarPath = `/api/master/token/{room}`
                .replace(`{${"room"}}`, encodeURIComponent(String(room)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * To register an event for notification
         * @summary event registerer
         * @param {string} eventKey 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        subscribe: async (eventKey: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'eventKey' is not null or undefined
            assertParamExists('subscribe', 'eventKey', eventKey)
            const localVarPath = `/api/master/event/subscribe/{eventKey}`
                .replace(`{${"eventKey"}}`, encodeURIComponent(String(eventKey)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * VideoControllerApi - functional programming interface
 * @export
 */
export const VideoControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = VideoControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * To emit event for provider to accept or deny
         * @summary to emit event
         * @param {PatientEmitEventDTO} patientEmitEventDTO 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async emit(patientEmitEventDTO: PatientEmitEventDTO, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.emit(patientEmitEventDTO, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VideoControllerApi.emit']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * To register an event for notification
         * @summary event registerer
         * @param {string} room 
         * @param {string} [authorization] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAuthToken(room: string, authorization?: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAuthToken(room, authorization, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VideoControllerApi.getAuthToken']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * To register an event for notification
         * @summary event registerer
         * @param {string} eventKey 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async subscribe(eventKey: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SseEmitter>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.subscribe(eventKey, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VideoControllerApi.subscribe']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * VideoControllerApi - factory interface
 * @export
 */
export const VideoControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = VideoControllerApiFp(configuration)
    return {
        /**
         * To emit event for provider to accept or deny
         * @summary to emit event
         * @param {PatientEmitEventDTO} patientEmitEventDTO 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        emit(patientEmitEventDTO: PatientEmitEventDTO, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.emit(patientEmitEventDTO, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * To register an event for notification
         * @summary event registerer
         * @param {string} room 
         * @param {string} [authorization] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAuthToken(room: string, authorization?: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getAuthToken(room, authorization, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * To register an event for notification
         * @summary event registerer
         * @param {string} eventKey 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        subscribe(eventKey: string, xTENANTID?: string, options?: any): AxiosPromise<SseEmitter> {
            return localVarFp.subscribe(eventKey, xTENANTID, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * VideoControllerApi - object-oriented interface
 * @export
 * @class VideoControllerApi
 * @extends {BaseAPI}
 */
export class VideoControllerApi extends BaseAPI {
    /**
     * To emit event for provider to accept or deny
     * @summary to emit event
     * @param {PatientEmitEventDTO} patientEmitEventDTO 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VideoControllerApi
     */
    public emit(patientEmitEventDTO: PatientEmitEventDTO, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return VideoControllerApiFp(this.configuration).emit(patientEmitEventDTO, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * To register an event for notification
     * @summary event registerer
     * @param {string} room 
     * @param {string} [authorization] 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VideoControllerApi
     */
    public getAuthToken(room: string, authorization?: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return VideoControllerApiFp(this.configuration).getAuthToken(room, authorization, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * To register an event for notification
     * @summary event registerer
     * @param {string} eventKey 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VideoControllerApi
     */
    public subscribe(eventKey: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return VideoControllerApiFp(this.configuration).subscribe(eventKey, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * VisitNoteTemplateControllerApi - axios parameter creator
 * @export
 */
export const VisitNoteTemplateControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Add a new Visit note template into the system.
         * @summary Add new visit note template
         * @param {VisitNoteTemplate} visitNoteTemplate 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createVisitNoteTemplate: async (visitNoteTemplate: VisitNoteTemplate, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'visitNoteTemplate' is not null or undefined
            assertParamExists('createVisitNoteTemplate', 'visitNoteTemplate', visitNoteTemplate)
            const localVarPath = `/api/master/visit-note-template`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(visitNoteTemplate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all Visit Note Template list for super admin with search option on name, deptId and filter options on active, archive.
         * @summary Get all Visit Note Template.
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {boolean} [archive] 
         * @param {string} [searchString] 
         * @param {GetAllVisitNoteTemplateTemplateTypeEnum} [templateType] 
         * @param {string} [username] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllVisitNoteTemplate: async (page?: number, size?: number, sortBy?: string, sortDirection?: string, archive?: boolean, searchString?: string, templateType?: GetAllVisitNoteTemplateTemplateTypeEnum, username?: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/master/visit-note-template`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }

            if (archive !== undefined) {
                localVarQueryParameter['archive'] = archive;
            }

            if (searchString !== undefined) {
                localVarQueryParameter['searchString'] = searchString;
            }

            if (templateType !== undefined) {
                localVarQueryParameter['templateType'] = templateType;
            }

            if (username !== undefined) {
                localVarQueryParameter['username'] = username;
            }

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get Visit Note Template by template id.
         * @summary Get Visit Note Template by template id.
         * @param {string} visitNoteTemplateId 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVisitNoteTemplateById: async (visitNoteTemplateId: string, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'visitNoteTemplateId' is not null or undefined
            assertParamExists('getVisitNoteTemplateById', 'visitNoteTemplateId', visitNoteTemplateId)
            const localVarPath = `/api/master/visit-note-template/{visitNoteTemplateId}`
                .replace(`{${"visitNoteTemplateId"}}`, encodeURIComponent(String(visitNoteTemplateId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Edit Visit Note Template
         * @summary Update Visit Note Template
         * @param {VisitNoteTemplate} visitNoteTemplate 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateVisitNoteTemplate: async (visitNoteTemplate: VisitNoteTemplate, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'visitNoteTemplate' is not null or undefined
            assertParamExists('updateVisitNoteTemplate', 'visitNoteTemplate', visitNoteTemplate)
            const localVarPath = `/api/master/visit-note-template`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(visitNoteTemplate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Change Visit Note Template archive status to either archived or unarchived.
         * @summary Archive/Unarchive Visit Note
         * @param {string} visitNoteTemplateId 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateVisitNoteTemplateArchiveStatus: async (visitNoteTemplateId: string, status: boolean, xTENANTID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'visitNoteTemplateId' is not null or undefined
            assertParamExists('updateVisitNoteTemplateArchiveStatus', 'visitNoteTemplateId', visitNoteTemplateId)
            // verify required parameter 'status' is not null or undefined
            assertParamExists('updateVisitNoteTemplateArchiveStatus', 'status', status)
            const localVarPath = `/api/master/visit-note-template/{visitNoteTemplateId}/archive-status/{status}`
                .replace(`{${"visitNoteTemplateId"}}`, encodeURIComponent(String(visitNoteTemplateId)))
                .replace(`{${"status"}}`, encodeURIComponent(String(status)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication KeycloakAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "KeycloakAuth", [], configuration)

            if (xTENANTID != null) {
                localVarHeaderParameter['X-TENANT-ID'] = String(xTENANTID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * VisitNoteTemplateControllerApi - functional programming interface
 * @export
 */
export const VisitNoteTemplateControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = VisitNoteTemplateControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * Add a new Visit note template into the system.
         * @summary Add new visit note template
         * @param {VisitNoteTemplate} visitNoteTemplate 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createVisitNoteTemplate(visitNoteTemplate: VisitNoteTemplate, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createVisitNoteTemplate(visitNoteTemplate, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VisitNoteTemplateControllerApi.createVisitNoteTemplate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get all Visit Note Template list for super admin with search option on name, deptId and filter options on active, archive.
         * @summary Get all Visit Note Template.
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {boolean} [archive] 
         * @param {string} [searchString] 
         * @param {GetAllVisitNoteTemplateTemplateTypeEnum} [templateType] 
         * @param {string} [username] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllVisitNoteTemplate(page?: number, size?: number, sortBy?: string, sortDirection?: string, archive?: boolean, searchString?: string, templateType?: GetAllVisitNoteTemplateTemplateTypeEnum, username?: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllVisitNoteTemplate(page, size, sortBy, sortDirection, archive, searchString, templateType, username, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VisitNoteTemplateControllerApi.getAllVisitNoteTemplate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get Visit Note Template by template id.
         * @summary Get Visit Note Template by template id.
         * @param {string} visitNoteTemplateId 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getVisitNoteTemplateById(visitNoteTemplateId: string, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getVisitNoteTemplateById(visitNoteTemplateId, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VisitNoteTemplateControllerApi.getVisitNoteTemplateById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Edit Visit Note Template
         * @summary Update Visit Note Template
         * @param {VisitNoteTemplate} visitNoteTemplate 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateVisitNoteTemplate(visitNoteTemplate: VisitNoteTemplate, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateVisitNoteTemplate(visitNoteTemplate, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VisitNoteTemplateControllerApi.updateVisitNoteTemplate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Change Visit Note Template archive status to either archived or unarchived.
         * @summary Archive/Unarchive Visit Note
         * @param {string} visitNoteTemplateId 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateVisitNoteTemplateArchiveStatus(visitNoteTemplateId: string, status: boolean, xTENANTID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateVisitNoteTemplateArchiveStatus(visitNoteTemplateId, status, xTENANTID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VisitNoteTemplateControllerApi.updateVisitNoteTemplateArchiveStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * VisitNoteTemplateControllerApi - factory interface
 * @export
 */
export const VisitNoteTemplateControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = VisitNoteTemplateControllerApiFp(configuration)
    return {
        /**
         * Add a new Visit note template into the system.
         * @summary Add new visit note template
         * @param {VisitNoteTemplate} visitNoteTemplate 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createVisitNoteTemplate(visitNoteTemplate: VisitNoteTemplate, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.createVisitNoteTemplate(visitNoteTemplate, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all Visit Note Template list for super admin with search option on name, deptId and filter options on active, archive.
         * @summary Get all Visit Note Template.
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {boolean} [archive] 
         * @param {string} [searchString] 
         * @param {GetAllVisitNoteTemplateTemplateTypeEnum} [templateType] 
         * @param {string} [username] 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllVisitNoteTemplate(page?: number, size?: number, sortBy?: string, sortDirection?: string, archive?: boolean, searchString?: string, templateType?: GetAllVisitNoteTemplateTemplateTypeEnum, username?: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getAllVisitNoteTemplate(page, size, sortBy, sortDirection, archive, searchString, templateType, username, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Get Visit Note Template by template id.
         * @summary Get Visit Note Template by template id.
         * @param {string} visitNoteTemplateId 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVisitNoteTemplateById(visitNoteTemplateId: string, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.getVisitNoteTemplateById(visitNoteTemplateId, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Edit Visit Note Template
         * @summary Update Visit Note Template
         * @param {VisitNoteTemplate} visitNoteTemplate 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateVisitNoteTemplate(visitNoteTemplate: VisitNoteTemplate, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.updateVisitNoteTemplate(visitNoteTemplate, xTENANTID, options).then((request) => request(axios, basePath));
        },
        /**
         * Change Visit Note Template archive status to either archived or unarchived.
         * @summary Archive/Unarchive Visit Note
         * @param {string} visitNoteTemplateId 
         * @param {boolean} status 
         * @param {string} [xTENANTID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateVisitNoteTemplateArchiveStatus(visitNoteTemplateId: string, status: boolean, xTENANTID?: string, options?: any): AxiosPromise<Response> {
            return localVarFp.updateVisitNoteTemplateArchiveStatus(visitNoteTemplateId, status, xTENANTID, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * VisitNoteTemplateControllerApi - object-oriented interface
 * @export
 * @class VisitNoteTemplateControllerApi
 * @extends {BaseAPI}
 */
export class VisitNoteTemplateControllerApi extends BaseAPI {
    /**
     * Add a new Visit note template into the system.
     * @summary Add new visit note template
     * @param {VisitNoteTemplate} visitNoteTemplate 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VisitNoteTemplateControllerApi
     */
    public createVisitNoteTemplate(visitNoteTemplate: VisitNoteTemplate, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return VisitNoteTemplateControllerApiFp(this.configuration).createVisitNoteTemplate(visitNoteTemplate, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all Visit Note Template list for super admin with search option on name, deptId and filter options on active, archive.
     * @summary Get all Visit Note Template.
     * @param {number} [page] 
     * @param {number} [size] 
     * @param {string} [sortBy] 
     * @param {string} [sortDirection] 
     * @param {boolean} [archive] 
     * @param {string} [searchString] 
     * @param {GetAllVisitNoteTemplateTemplateTypeEnum} [templateType] 
     * @param {string} [username] 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VisitNoteTemplateControllerApi
     */
    public getAllVisitNoteTemplate(page?: number, size?: number, sortBy?: string, sortDirection?: string, archive?: boolean, searchString?: string, templateType?: GetAllVisitNoteTemplateTemplateTypeEnum, username?: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return VisitNoteTemplateControllerApiFp(this.configuration).getAllVisitNoteTemplate(page, size, sortBy, sortDirection, archive, searchString, templateType, username, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get Visit Note Template by template id.
     * @summary Get Visit Note Template by template id.
     * @param {string} visitNoteTemplateId 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VisitNoteTemplateControllerApi
     */
    public getVisitNoteTemplateById(visitNoteTemplateId: string, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return VisitNoteTemplateControllerApiFp(this.configuration).getVisitNoteTemplateById(visitNoteTemplateId, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Edit Visit Note Template
     * @summary Update Visit Note Template
     * @param {VisitNoteTemplate} visitNoteTemplate 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VisitNoteTemplateControllerApi
     */
    public updateVisitNoteTemplate(visitNoteTemplate: VisitNoteTemplate, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return VisitNoteTemplateControllerApiFp(this.configuration).updateVisitNoteTemplate(visitNoteTemplate, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Change Visit Note Template archive status to either archived or unarchived.
     * @summary Archive/Unarchive Visit Note
     * @param {string} visitNoteTemplateId 
     * @param {boolean} status 
     * @param {string} [xTENANTID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VisitNoteTemplateControllerApi
     */
    public updateVisitNoteTemplateArchiveStatus(visitNoteTemplateId: string, status: boolean, xTENANTID?: string, options?: RawAxiosRequestConfig) {
        return VisitNoteTemplateControllerApiFp(this.configuration).updateVisitNoteTemplateArchiveStatus(visitNoteTemplateId, status, xTENANTID, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const GetAllVisitNoteTemplateTemplateTypeEnum = {
    SimpleSoapNote: 'SIMPLE_SOAP_NOTE',
    PsychiatricNote: 'PSYCHIATRIC_NOTE',
    PrimaryCareSoapNote: 'PRIMARY_CARE_SOAP_NOTE',
    FreeSoapNote: 'FREE_SOAP_NOTE',
    TreatmentPlan: 'TREATMENT_PLAN',
    PsychiatricProgress: 'PSYCHIATRIC_PROGRESS',
    InitialPsychotherapy: 'INITIAL_PSYCHOTHERAPY',
    PsychiatricInitialVisitNote: 'PSYCHIATRIC_INITIAL_VISIT_NOTE',
    PreoperativeNote: 'PREOPERATIVE_NOTE',
    CollaborativeCareModel: 'COLLABORATIVE_CARE_MODEL'
} as const;
export type GetAllVisitNoteTemplateTemplateTypeEnum = typeof GetAllVisitNoteTemplateTemplateTypeEnum[keyof typeof GetAllVisitNoteTemplateTemplateTypeEnum];


